export default{
  "CSNK1A1P3": [
    "CSNK1A1P3 CNV",
    "CSNK1A1P3 RNA"
  ],
  "GPR89B": [
    "GPR89B CNV",
    "GPR89B RNA"
  ],
  "AQP7P1": [
    "AQP7P1 CNV",
    "AQP7P1 RNA"
  ],
  "TRMT112P7": [
    "TRMT112P7 CNV",
    "TRMT112P7 RNA"
  ],
  "RBM11P1": [
    "RBM11P1 CNV",
    "RBM11P1 RNA"
  ],
  "CDRT15P4": [
    "CDRT15P4 CNV",
    "CDRT15P4 RNA"
  ],
  "ZNF322": [
    "ZNF322 CNV",
    "ZNF322 RNA"
  ],
  "LINC00265-2P": [
    "LINC00265-2P CNV",
    "LINC00265-2P RNA"
  ],
  "SMIM30": [
    "SMIM30 CNV",
    "SMIM30 RNA"
  ],
  "KRIT1": [
    "KRIT1 CNV",
    "KRIT1 RNA",
    "KRIT1 Proteo"
  ],
  "MEGF10": [
    "MEGF10 CNV",
    "MEGF10 RNA",
    "MEGF10 Proteo"
  ],
  "ZNF354B": [
    "ZNF354B CNV",
    "ZNF354B RNA"
  ],
  "ZNF69": [
    "ZNF69 CNV",
    "ZNF69 RNA"
  ],
  "IGHV3-33-2": [
    "IGHV3-33-2 CNV",
    "IGHV3-33-2 RNA"
  ],
  "RPL39P15": [
    "RPL39P15 CNV",
    "RPL39P15 RNA"
  ],
  "NDUFAF4P3": [
    "NDUFAF4P3 CNV",
    "NDUFAF4P3 RNA"
  ],
  "LRIG3": [
    "LRIG3 CNV",
    "LRIG3 RNA",
    "LRIG3 Proteo"
  ],
  "COX7CP1": [
    "COX7CP1 CNV",
    "COX7CP1 RNA"
  ],
  "GJA5": [
    "GJA5 CNV",
    "GJA5 RNA"
  ],
  "ZNF431": [
    "ZNF431 CNV",
    "ZNF431 RNA"
  ],
  "PABPC1P2": [
    "PABPC1P2 CNV",
    "PABPC1P2 RNA"
  ],
  "EFCAB10": [
    "EFCAB10 CNV",
    "EFCAB10 RNA"
  ],
  "FTH1P2": [
    "FTH1P2 CNV",
    "FTH1P2 RNA"
  ],
  "LMNA": [
    "LMNA CNV",
    "LMNA RNA",
    "LMNA Proteo"
  ],
  "YWHAE": [
    "YWHAE CNV",
    "YWHAE RNA",
    "YWHAE Proteo"
  ],
  "MT1JP": [
    "MT1JP CNV",
    "MT1JP RNA"
  ],
  "JSRP1": [
    "JSRP1 CNV",
    "JSRP1 RNA",
    "JSRP1 Proteo"
  ],
  "PNMA8A": [
    "PNMA8A CNV",
    "PNMA8A RNA",
    "PNMA8A Proteo"
  ],
  "NFE2L1": [
    "NFE2L1 CNV",
    "NFE2L1 RNA",
    "NFE2L1 Proteo"
  ],
  "IGKV2OR2-8": [
    "IGKV2OR2-8 CNV",
    "IGKV2OR2-8 RNA"
  ],
  "ABHD10": [
    "ABHD10 CNV",
    "ABHD10 RNA",
    "ABHD10 Proteo"
  ],
  "MAFF": [
    "MAFF CNV",
    "MAFF RNA",
    "MAFF Proteo"
  ],
  "FAUP2": [
    "FAUP2 CNV",
    "FAUP2 RNA"
  ],
  "UNC119B": [
    "UNC119B CNV",
    "UNC119B RNA",
    "UNC119B Proteo"
  ],
  "RNF207": [
    "RNF207 CNV",
    "RNF207 RNA"
  ],
  "FAM172A": [
    "FAM172A CNV",
    "FAM172A RNA",
    "FAM172A Proteo"
  ],
  "TMEM248P1": [
    "TMEM248P1 CNV",
    "TMEM248P1 RNA"
  ],
  "SLC13A1": [
    "SLC13A1 CNV",
    "SLC13A1 RNA"
  ],
  "SLC13A2": [
    "SLC13A2 CNV",
    "SLC13A2 RNA"
  ],
  "MRC2": [
    "MRC2 CNV",
    "MRC2 RNA",
    "MRC2 Proteo"
  ],
  "TSPY15P": [
    "TSPY15P CNV",
    "TSPY15P RNA"
  ],
  "GLS2": [
    "GLS2 CNV",
    "GLS2 RNA",
    "GLS2 Proteo"
  ],
  "MTND5P25": [
    "MTND5P25 CNV",
    "MTND5P25 RNA"
  ],
  "PPEF2": [
    "PPEF2 CNV",
    "PPEF2 RNA"
  ],
  "RPL36P13": [
    "RPL36P13 CNV",
    "RPL36P13 RNA"
  ],
  "ITGAD": [
    "ITGAD CNV",
    "ITGAD RNA"
  ],
  "ATP2A3": [
    "ATP2A3 CNV",
    "ATP2A3 RNA",
    "ATP2A3 Proteo"
  ],
  "CES5A": [
    "CES5A CNV",
    "CES5A RNA"
  ],
  "HIGD1AP17": [
    "HIGD1AP17 CNV",
    "HIGD1AP17 RNA"
  ],
  "ARSF": [
    "ARSF CNV",
    "ARSF RNA"
  ],
  "SCTR": [
    "SCTR CNV",
    "SCTR RNA"
  ],
  "BIVM": [
    "BIVM CNV",
    "BIVM RNA"
  ],
  "TAB1": [
    "TAB1 CNV",
    "TAB1 RNA",
    "TAB1 Proteo"
  ],
  "CORT": [
    "CORT CNV",
    "CORT RNA"
  ],
  "PHB1": [
    "PHB1 CNV",
    "PHB1 RNA",
    "PHB1 Proteo"
  ],
  "PSORS1C2": [
    "PSORS1C2 CNV",
    "PSORS1C2 RNA"
  ],
  "MPTX1": [
    "MPTX1 CNV",
    "MPTX1 RNA"
  ],
  "KRTAP8-1": [
    "KRTAP8-1 CNV",
    "KRTAP8-1 RNA"
  ],
  "RAET1K": [
    "RAET1K CNV",
    "RAET1K RNA"
  ],
  "BRAP": [
    "BRAP CNV",
    "BRAP RNA",
    "BRAP Proteo"
  ],
  "CKAP2LP1": [
    "CKAP2LP1 CNV",
    "CKAP2LP1 RNA"
  ],
  "PRR13": [
    "PRR13 CNV",
    "PRR13 RNA"
  ],
  "STIM1": [
    "STIM1 CNV",
    "STIM1 RNA",
    "STIM1 Proteo"
  ],
  "OR10G7": [
    "OR10G7 CNV",
    "OR10G7 RNA"
  ],
  "UHRF1": [
    "UHRF1 CNV",
    "UHRF1 RNA",
    "UHRF1 Proteo"
  ],
  "ANP32A": [
    "ANP32A CNV",
    "ANP32A RNA",
    "ANP32A Proteo"
  ],
  "LY6G6C": [
    "LY6G6C CNV",
    "LY6G6C RNA",
    "LY6G6C Proteo"
  ],
  "PRRC2C": [
    "PRRC2C CNV",
    "PRRC2C RNA",
    "PRRC2C Proteo"
  ],
  "HLA-DMA": [
    "HLA-DMA CNV",
    "HLA-DMA RNA",
    "HLA-DMA Proteo"
  ],
  "DNAJB7": [
    "DNAJB7 CNV",
    "DNAJB7 RNA"
  ],
  "GTF2A1L": [
    "GTF2A1L CNV",
    "GTF2A1L RNA"
  ],
  "PABPC4": [
    "PABPC4 CNV",
    "PABPC4 RNA",
    "PABPC4 Proteo"
  ],
  "SLC9B1": [
    "SLC9B1 CNV",
    "SLC9B1 RNA"
  ],
  "GON7": [
    "GON7 CNV",
    "GON7 RNA",
    "GON7 Proteo"
  ],
  "OR7E15P": [
    "OR7E15P CNV",
    "OR7E15P RNA"
  ],
  "ARF6": [
    "ARF6 CNV",
    "ARF6 RNA",
    "ARF6 Proteo"
  ],
  "IGHV1-69": [
    "IGHV1-69 Proteo"
  ],
  "USP17L28": [
    "USP17L28 CNV",
    "USP17L28 RNA"
  ],
  "GCSHP2": [
    "GCSHP2 CNV",
    "GCSHP2 RNA"
  ],
  "RPL4P3": [
    "RPL4P3 CNV",
    "RPL4P3 RNA"
  ],
  "MARVELD3": [
    "MARVELD3 CNV",
    "MARVELD3 RNA"
  ],
  "RNF39": [
    "RNF39 CNV",
    "RNF39 RNA"
  ],
  "MARK2": [
    "MARK2 CNV",
    "MARK2 RNA",
    "MARK2 Proteo"
  ],
  "PDE4DIPP6": [
    "PDE4DIPP6 CNV",
    "PDE4DIPP6 RNA"
  ],
  "FGF8": [
    "FGF8 CNV",
    "FGF8 RNA"
  ],
  "TMEM64": [
    "TMEM64 CNV",
    "TMEM64 RNA",
    "TMEM64 Proteo"
  ],
  "RPS2P2": [
    "RPS2P2 CNV",
    "RPS2P2 RNA"
  ],
  "LRRC8B": [
    "LRRC8B CNV",
    "LRRC8B RNA",
    "LRRC8B Proteo"
  ],
  "HERC6": [
    "HERC6 CNV",
    "HERC6 RNA",
    "HERC6 Proteo"
  ],
  "OR4D9": [
    "OR4D9 CNV",
    "OR4D9 RNA"
  ],
  "KLHL3": [
    "KLHL3 CNV",
    "KLHL3 RNA"
  ],
  "IDO2": [
    "IDO2 CNV",
    "IDO2 RNA"
  ],
  "LPAR6": [
    "LPAR6 CNV",
    "LPAR6 RNA"
  ],
  "DNAJC8P1": [
    "DNAJC8P1 CNV",
    "DNAJC8P1 RNA"
  ],
  "DIP2A": [
    "DIP2A CNV",
    "DIP2A RNA",
    "DIP2A Proteo"
  ],
  "SEPTIN7P7": [
    "SEPTIN7P7 CNV",
    "SEPTIN7P7 RNA"
  ],
  "TRIM60P3Y": [
    "TRIM60P3Y CNV",
    "TRIM60P3Y RNA"
  ],
  "C2CD2": [
    "C2CD2 CNV",
    "C2CD2 RNA",
    "C2CD2 Proteo"
  ],
  "SCML2": [
    "SCML2 CNV",
    "SCML2 RNA",
    "SCML2 Proteo"
  ],
  "DHRS7B": [
    "DHRS7B CNV",
    "DHRS7B RNA",
    "DHRS7B Proteo"
  ],
  "TMEM141": [
    "TMEM141 CNV",
    "TMEM141 RNA",
    "TMEM141 Proteo"
  ],
  "LIPA": [
    "LIPA CNV",
    "LIPA RNA",
    "LIPA Proteo"
  ],
  "KMT2CP4": [
    "KMT2CP4 CNV",
    "KMT2CP4 RNA"
  ],
  "STN1": [
    "STN1 CNV",
    "STN1 RNA",
    "STN1 Proteo"
  ],
  "C1orf54": [
    "C1orf54 CNV",
    "C1orf54 RNA"
  ],
  "ADAM11": [
    "ADAM11 CNV",
    "ADAM11 RNA",
    "ADAM11 Proteo"
  ],
  "FBXL8": [
    "FBXL8 CNV",
    "FBXL8 RNA",
    "FBXL8 Proteo"
  ],
  "ESD": [
    "ESD CNV",
    "ESD RNA",
    "ESD Proteo"
  ],
  "C11orf91": [
    "C11orf91 CNV",
    "C11orf91 RNA"
  ],
  "PAICS": [
    "PAICS CNV",
    "PAICS RNA",
    "PAICS Proteo"
  ],
  "RPS17P7": [
    "RPS17P7 CNV",
    "RPS17P7 RNA"
  ],
  "RNA5SP467": [
    "RNA5SP467 CNV",
    "RNA5SP467 RNA"
  ],
  "HAUS8P1": [
    "HAUS8P1 CNV",
    "HAUS8P1 RNA"
  ],
  "BARD1": [
    "BARD1 CNV",
    "BARD1 RNA",
    "BARD1 Proteo"
  ],
  "OLFM2": [
    "OLFM2 CNV",
    "OLFM2 RNA"
  ],
  "HOXB9": [
    "HOXB9 CNV",
    "HOXB9 RNA",
    "HOXB9 Proteo"
  ],
  "CHRD": [
    "CHRD CNV",
    "CHRD RNA",
    "CHRD Proteo"
  ],
  "ZC3H6": [
    "ZC3H6 CNV",
    "ZC3H6 RNA",
    "ZC3H6 Proteo"
  ],
  "TNNI3K": [
    "TNNI3K CNV",
    "TNNI3K RNA"
  ],
  "HNRNPA1P20": [
    "HNRNPA1P20 CNV",
    "HNRNPA1P20 RNA"
  ],
  "HTR3C": [
    "HTR3C CNV",
    "HTR3C RNA"
  ],
  "FMN1": [
    "FMN1 CNV",
    "FMN1 RNA",
    "FMN1 Proteo"
  ],
  "IFNWP19": [
    "IFNWP19 CNV",
    "IFNWP19 RNA"
  ],
  "ZNF34": [
    "ZNF34 CNV",
    "ZNF34 RNA"
  ],
  "PTMAP5": [
    "PTMAP5 CNV",
    "PTMAP5 RNA"
  ],
  "RNASEH1": [
    "RNASEH1 CNV",
    "RNASEH1 RNA",
    "RNASEH1 Proteo"
  ],
  "HID1": [
    "HID1 CNV",
    "HID1 RNA",
    "HID1 Proteo"
  ],
  "CLEC14A": [
    "CLEC14A CNV",
    "CLEC14A RNA",
    "CLEC14A Proteo"
  ],
  "ELP2": [
    "ELP2 CNV",
    "ELP2 RNA",
    "ELP2 Proteo"
  ],
  "MGAM2": [
    "MGAM2 CNV",
    "MGAM2 RNA"
  ],
  "OR7E46P": [
    "OR7E46P CNV",
    "OR7E46P RNA"
  ],
  "RNF138P2": [
    "RNF138P2 CNV",
    "RNF138P2 RNA"
  ],
  "NDUFA13": [
    "NDUFA13 CNV",
    "NDUFA13 RNA",
    "NDUFA13 Proteo"
  ],
  "CBX3P8": [
    "CBX3P8 CNV",
    "CBX3P8 RNA"
  ],
  "MMP12": [
    "MMP12 CNV",
    "MMP12 RNA",
    "MMP12 Proteo"
  ],
  "TMEM165": [
    "TMEM165 CNV",
    "TMEM165 RNA",
    "TMEM165 Proteo"
  ],
  "PIN4": [
    "PIN4 CNV",
    "PIN4 RNA",
    "PIN4 Proteo"
  ],
  "SSX6P": [
    "SSX6P CNV",
    "SSX6P RNA"
  ],
  "P2RY13": [
    "P2RY13 CNV",
    "P2RY13 RNA",
    "P2RY13 Proteo"
  ],
  "CFHR2": [
    "CFHR2 CNV",
    "CFHR2 RNA",
    "CFHR2 Proteo"
  ],
  "MYBPC3": [
    "MYBPC3 CNV",
    "MYBPC3 RNA"
  ],
  "OR7G2": [
    "OR7G2 CNV",
    "OR7G2 RNA"
  ],
  "IMPDH1P8": [
    "IMPDH1P8 CNV",
    "IMPDH1P8 RNA"
  ],
  "GGA1": [
    "GGA1 CNV",
    "GGA1 RNA",
    "GGA1 Proteo"
  ],
  "TRIM54": [
    "TRIM54 CNV",
    "TRIM54 RNA"
  ],
  "NXF5": [
    "NXF5 CNV",
    "NXF5 RNA"
  ],
  "TMEM68": [
    "TMEM68 CNV",
    "TMEM68 RNA",
    "TMEM68 Proteo"
  ],
  "OR8Q1P": [
    "OR8Q1P CNV",
    "OR8Q1P RNA"
  ],
  "IGLV3-10": [
    "IGLV3-10 Proteo"
  ],
  "CFAP54": [
    "CFAP54 CNV",
    "CFAP54 RNA"
  ],
  "IQCF6": [
    "IQCF6 CNV",
    "IQCF6 RNA"
  ],
  "SLC29A4P1": [
    "SLC29A4P1 CNV",
    "SLC29A4P1 RNA"
  ],
  "GLT1D1": [
    "GLT1D1 CNV",
    "GLT1D1 RNA"
  ],
  "VN1R107P": [
    "VN1R107P CNV",
    "VN1R107P RNA"
  ],
  "THEMIS3P": [
    "THEMIS3P CNV",
    "THEMIS3P RNA"
  ],
  "YWHAZP5": [
    "YWHAZP5 CNV",
    "YWHAZP5 RNA"
  ],
  "DLGAP1": [
    "DLGAP1 CNV",
    "DLGAP1 RNA",
    "DLGAP1 Proteo"
  ],
  "SLC9A7P1": [
    "SLC9A7P1 CNV",
    "SLC9A7P1 RNA"
  ],
  "IDUA": [
    "IDUA CNV",
    "IDUA RNA",
    "IDUA Proteo"
  ],
  "ETF1P3": [
    "ETF1P3 CNV",
    "ETF1P3 RNA"
  ],
  "FAHD2CP": [
    "FAHD2CP CNV",
    "FAHD2CP RNA"
  ],
  "ITGA2B": [
    "ITGA2B CNV",
    "ITGA2B RNA",
    "ITGA2B Proteo"
  ],
  "NDUFB3P5": [
    "NDUFB3P5 CNV",
    "NDUFB3P5 RNA"
  ],
  "RPL22L1": [
    "RPL22L1 CNV",
    "RPL22L1 RNA",
    "RPL22L1 Proteo"
  ],
  "PDE4DIPP4": [
    "PDE4DIPP4 CNV",
    "PDE4DIPP4 RNA"
  ],
  "SSX1": [
    "SSX1 CNV",
    "SSX1 RNA",
    "SSX1 Proteo"
  ],
  "CHEK2P2": [
    "CHEK2P2 CNV",
    "CHEK2P2 RNA"
  ],
  "HSPE1P4": [
    "HSPE1P4 CNV",
    "HSPE1P4 RNA"
  ],
  "DYNAP": [
    "DYNAP CNV",
    "DYNAP RNA",
    "DYNAP Proteo"
  ],
  "WDR88": [
    "WDR88 CNV",
    "WDR88 RNA"
  ],
  "MT3": [
    "MT3 CNV",
    "MT3 RNA"
  ],
  "DIPK2B": [
    "DIPK2B CNV",
    "DIPK2B RNA"
  ],
  "CYP2F1": [
    "CYP2F1 CNV",
    "CYP2F1 RNA"
  ],
  "PPIAP11": [
    "PPIAP11 CNV",
    "PPIAP11 RNA"
  ],
  "LGALS16": [
    "LGALS16 CNV",
    "LGALS16 RNA"
  ],
  "GABRA5": [
    "GABRA5 CNV",
    "GABRA5 RNA"
  ],
  "CIBAR2": [
    "CIBAR2 CNV",
    "CIBAR2 RNA"
  ],
  "BLACAT1": [
    "BLACAT1 CNV",
    "BLACAT1 RNA"
  ],
  "CFAP74": [
    "CFAP74 CNV",
    "CFAP74 RNA"
  ],
  "GIMD1": [
    "GIMD1 CNV",
    "GIMD1 RNA"
  ],
  "DLAT": [
    "DLAT CNV",
    "DLAT RNA",
    "DLAT Proteo"
  ],
  "KCNB1": [
    "KCNB1 CNV",
    "KCNB1 RNA"
  ],
  "DSTNP5": [
    "DSTNP5 CNV",
    "DSTNP5 RNA"
  ],
  "METTL23": [
    "METTL23 CNV",
    "METTL23 RNA"
  ],
  "CEP126": [
    "CEP126 CNV",
    "CEP126 RNA"
  ],
  "ITPRID2": [
    "ITPRID2 CNV",
    "ITPRID2 RNA",
    "ITPRID2 Proteo"
  ],
  "FCN1": [
    "FCN1 CNV",
    "FCN1 RNA",
    "FCN1 Proteo"
  ],
  "TTC13": [
    "TTC13 CNV",
    "TTC13 RNA",
    "TTC13 Proteo"
  ],
  "RPS3AP47": [
    "RPS3AP47 CNV",
    "RPS3AP47 RNA"
  ],
  "PDLIM1": [
    "PDLIM1 CNV",
    "PDLIM1 RNA",
    "PDLIM1 Proteo"
  ],
  "CRIP3": [
    "CRIP3 CNV",
    "CRIP3 RNA"
  ],
  "RPSAP22": [
    "RPSAP22 CNV",
    "RPSAP22 RNA"
  ],
  "AFF2": [
    "AFF2 CNV",
    "AFF2 RNA"
  ],
  "NIN": [
    "NIN CNV",
    "NIN RNA",
    "NIN Proteo"
  ],
  "RPL22P5": [
    "RPL22P5 CNV",
    "RPL22P5 RNA"
  ],
  "NDUFB4P1": [
    "NDUFB4P1 CNV",
    "NDUFB4P1 RNA"
  ],
  "RILP": [
    "RILP CNV",
    "RILP RNA",
    "RILP Proteo"
  ],
  "CPS1": [
    "CPS1 CNV",
    "CPS1 RNA",
    "CPS1 Proteo"
  ],
  "CICP25": [
    "CICP25 CNV",
    "CICP25 RNA"
  ],
  "OR5L2": [
    "OR5L2 CNV",
    "OR5L2 RNA"
  ],
  "ARFGEF2": [
    "ARFGEF2 CNV",
    "ARFGEF2 RNA",
    "ARFGEF2 Proteo"
  ],
  "IRX6": [
    "IRX6 CNV",
    "IRX6 RNA"
  ],
  "B3GALNT1P1": [
    "B3GALNT1P1 CNV",
    "B3GALNT1P1 RNA"
  ],
  "PIGV": [
    "PIGV CNV",
    "PIGV RNA"
  ],
  "NBPF2P": [
    "NBPF2P CNV",
    "NBPF2P RNA"
  ],
  "DUSP22": [
    "DUSP22 CNV",
    "DUSP22 RNA",
    "DUSP22 Proteo"
  ],
  "CCNT1": [
    "CCNT1 CNV",
    "CCNT1 RNA",
    "CCNT1 Proteo"
  ],
  "DNAJA1P3": [
    "DNAJA1P3 CNV",
    "DNAJA1P3 RNA"
  ],
  "LCT": [
    "LCT CNV",
    "LCT RNA"
  ],
  "RPS27AP2": [
    "RPS27AP2 CNV",
    "RPS27AP2 RNA"
  ],
  "ZSWIM7": [
    "ZSWIM7 CNV",
    "ZSWIM7 RNA",
    "ZSWIM7 Proteo"
  ],
  "RAVER2": [
    "RAVER2 CNV",
    "RAVER2 RNA",
    "RAVER2 Proteo"
  ],
  "MDN1": [
    "MDN1 CNV",
    "MDN1 RNA",
    "MDN1 Proteo"
  ],
  "KLF17": [
    "KLF17 CNV",
    "KLF17 RNA"
  ],
  "MT2A": [
    "MT2A CNV",
    "MT2A RNA",
    "MT2A Proteo"
  ],
  "PCMTD1P1": [
    "PCMTD1P1 CNV",
    "PCMTD1P1 RNA"
  ],
  "GRPEL2P1": [
    "GRPEL2P1 CNV",
    "GRPEL2P1 RNA"
  ],
  "SSR4": [
    "SSR4 CNV",
    "SSR4 RNA",
    "SSR4 Proteo"
  ],
  "YME1L1": [
    "YME1L1 CNV",
    "YME1L1 RNA",
    "YME1L1 Proteo"
  ],
  "MAGEB3": [
    "MAGEB3 CNV",
    "MAGEB3 RNA"
  ],
  "CDK2AP2P3": [
    "CDK2AP2P3 CNV",
    "CDK2AP2P3 RNA"
  ],
  "CHIC1": [
    "CHIC1 CNV",
    "CHIC1 RNA"
  ],
  "MTND5P19": [
    "MTND5P19 CNV",
    "MTND5P19 RNA"
  ],
  "EYS": [
    "EYS CNV",
    "EYS RNA"
  ],
  "HLA-DOB": [
    "HLA-DOB CNV",
    "HLA-DOB RNA",
    "HLA-DOB Proteo"
  ],
  "BTBD3": [
    "BTBD3 CNV",
    "BTBD3 RNA"
  ],
  "SRGN": [
    "SRGN CNV",
    "SRGN RNA",
    "SRGN Proteo"
  ],
  "HOXA6": [
    "HOXA6 CNV",
    "HOXA6 RNA"
  ],
  "TMEM74": [
    "TMEM74 CNV",
    "TMEM74 RNA"
  ],
  "H4P1": [
    "H4P1 CNV",
    "H4P1 RNA"
  ],
  "FEM1AP3": [
    "FEM1AP3 CNV",
    "FEM1AP3 RNA"
  ],
  "GGTLC2": [
    "GGTLC2 CNV",
    "GGTLC2 RNA"
  ],
  "FAM90A1": [
    "FAM90A1 CNV",
    "FAM90A1 RNA"
  ],
  "EPS8L2": [
    "EPS8L2 CNV",
    "EPS8L2 RNA",
    "EPS8L2 Proteo"
  ],
  "MASTL": [
    "MASTL CNV",
    "MASTL RNA",
    "MASTL Proteo"
  ],
  "LEKR1": [
    "LEKR1 CNV",
    "LEKR1 RNA"
  ],
  "RPL7AP64": [
    "RPL7AP64 CNV",
    "RPL7AP64 RNA"
  ],
  "CLUHP10": [
    "CLUHP10 CNV",
    "CLUHP10 RNA"
  ],
  "RNA5SP299": [
    "RNA5SP299 CNV",
    "RNA5SP299 RNA"
  ],
  "SUPT20HL1": [
    "SUPT20HL1 CNV",
    "SUPT20HL1 RNA"
  ],
  "CDK18": [
    "CDK18 CNV",
    "CDK18 RNA",
    "CDK18 Proteo"
  ],
  "PAFAH2": [
    "PAFAH2 CNV",
    "PAFAH2 RNA",
    "PAFAH2 Proteo"
  ],
  "TRAJ51": [
    "TRAJ51 CNV",
    "TRAJ51 RNA"
  ],
  "CRLF3": [
    "CRLF3 CNV",
    "CRLF3 RNA",
    "CRLF3 Proteo"
  ],
  "LNPK": [
    "LNPK CNV",
    "LNPK RNA",
    "LNPK Proteo"
  ],
  "SAAL1": [
    "SAAL1 CNV",
    "SAAL1 RNA",
    "SAAL1 Proteo"
  ],
  "OR4A7P": [
    "OR4A7P CNV",
    "OR4A7P RNA"
  ],
  "RPL21P36": [
    "RPL21P36 CNV",
    "RPL21P36 RNA"
  ],
  "ALDH1L2": [
    "ALDH1L2 CNV",
    "ALDH1L2 RNA",
    "ALDH1L2 Proteo"
  ],
  "PYY": [
    "PYY CNV",
    "PYY RNA"
  ],
  "FAIM2": [
    "FAIM2 CNV",
    "FAIM2 RNA"
  ],
  "CCDC50": [
    "CCDC50 CNV",
    "CCDC50 RNA",
    "CCDC50 Proteo"
  ],
  "E2F3P1": [
    "E2F3P1 CNV",
    "E2F3P1 RNA"
  ],
  "ADNP": [
    "ADNP CNV",
    "ADNP RNA",
    "ADNP Proteo"
  ],
  "H2BC21": [
    "H2BC21 CNV",
    "H2BC21 RNA"
  ],
  "CT47A2": [
    "CT47A2 CNV",
    "CT47A2 RNA"
  ],
  "BCL2L12P1": [
    "BCL2L12P1 CNV",
    "BCL2L12P1 RNA"
  ],
  "HIP1": [
    "HIP1 CNV",
    "HIP1 RNA",
    "HIP1 Proteo"
  ],
  "RPP14": [
    "RPP14 CNV",
    "RPP14 RNA",
    "RPP14 Proteo"
  ],
  "NEK4P3": [
    "NEK4P3 CNV",
    "NEK4P3 RNA"
  ],
  "CDK13": [
    "CDK13 CNV",
    "CDK13 RNA",
    "CDK13 Proteo"
  ],
  "COX6CP11": [
    "COX6CP11 CNV",
    "COX6CP11 RNA"
  ],
  "FBXO15": [
    "FBXO15 CNV",
    "FBXO15 RNA"
  ],
  "STON1-GTF2A1L": [
    "STON1-GTF2A1L Proteo"
  ],
  "OR7K1P": [
    "OR7K1P CNV",
    "OR7K1P RNA"
  ],
  "CNTNAP3": [
    "CNTNAP3 CNV",
    "CNTNAP3 RNA",
    "CNTNAP3 Proteo"
  ],
  "SLC24A4": [
    "SLC24A4 CNV",
    "SLC24A4 RNA",
    "SLC24A4 Proteo"
  ],
  "RPLP0P9": [
    "RPLP0P9 CNV",
    "RPLP0P9 RNA"
  ],
  "PCSK1N": [
    "PCSK1N CNV",
    "PCSK1N RNA"
  ],
  "GPBAR1": [
    "GPBAR1 CNV",
    "GPBAR1 RNA"
  ],
  "HHIPL1": [
    "HHIPL1 CNV",
    "HHIPL1 RNA"
  ],
  "TEDC1": [
    "TEDC1 CNV",
    "TEDC1 RNA",
    "TEDC1 Proteo"
  ],
  "PPIAP69": [
    "PPIAP69 CNV",
    "PPIAP69 RNA"
  ],
  "C17orf98": [
    "C17orf98 CNV",
    "C17orf98 RNA"
  ],
  "LRRC73": [
    "LRRC73 CNV",
    "LRRC73 RNA"
  ],
  "OTUB2": [
    "OTUB2 CNV",
    "OTUB2 RNA",
    "OTUB2 Proteo"
  ],
  "PRELID1P7": [
    "PRELID1P7 CNV",
    "PRELID1P7 RNA"
  ],
  "RPL23AP45": [
    "RPL23AP45 CNV",
    "RPL23AP45 RNA"
  ],
  "RPL36AL": [
    "RPL36AL CNV",
    "RPL36AL RNA",
    "RPL36AL Proteo"
  ],
  "TRMT1L": [
    "TRMT1L CNV",
    "TRMT1L RNA",
    "TRMT1L Proteo"
  ],
  "PRAMEF10": [
    "PRAMEF10 CNV",
    "PRAMEF10 RNA"
  ],
  "ADAM28": [
    "ADAM28 CNV",
    "ADAM28 RNA",
    "ADAM28 Proteo"
  ],
  "NRXN3": [
    "NRXN3 CNV",
    "NRXN3 RNA"
  ],
  "HJURP": [
    "HJURP CNV",
    "HJURP RNA",
    "HJURP Proteo"
  ],
  "GALC": [
    "GALC CNV",
    "GALC RNA",
    "GALC Proteo"
  ],
  "CRACD": [
    "CRACD CNV",
    "CRACD RNA",
    "CRACD Proteo"
  ],
  "FAM117A": [
    "FAM117A CNV",
    "FAM117A RNA",
    "FAM117A Proteo"
  ],
  "TAAR2": [
    "TAAR2 CNV",
    "TAAR2 RNA"
  ],
  "NRBF2P3": [
    "NRBF2P3 CNV",
    "NRBF2P3 RNA"
  ],
  "AVPI1": [
    "AVPI1 CNV",
    "AVPI1 RNA"
  ],
  "ENPP7": [
    "ENPP7 CNV",
    "ENPP7 RNA"
  ],
  "ERCC6": [
    "ERCC6 CNV",
    "ERCC6 RNA",
    "ERCC6 Proteo"
  ],
  "RPS6KL1": [
    "RPS6KL1 CNV",
    "RPS6KL1 RNA"
  ],
  "SPRR2C": [
    "SPRR2C CNV",
    "SPRR2C RNA"
  ],
  "ZNF157": [
    "ZNF157 CNV",
    "ZNF157 RNA"
  ],
  "RPL32P18": [
    "RPL32P18 CNV",
    "RPL32P18 RNA"
  ],
  "LAMA2": [
    "LAMA2 CNV",
    "LAMA2 RNA",
    "LAMA2 Proteo"
  ],
  "PPARGC1A": [
    "PPARGC1A CNV",
    "PPARGC1A RNA"
  ],
  "RPL39P18": [
    "RPL39P18 CNV",
    "RPL39P18 RNA"
  ],
  "H2AC15": [
    "H2AC15 CNV",
    "H2AC15 RNA"
  ],
  "GNAI2": [
    "GNAI2 CNV",
    "GNAI2 RNA",
    "GNAI2 Proteo"
  ],
  "TMEM163": [
    "TMEM163 CNV",
    "TMEM163 RNA",
    "TMEM163 Proteo"
  ],
  "ZNF391": [
    "ZNF391 CNV",
    "ZNF391 RNA"
  ],
  "SIRPAP1": [
    "SIRPAP1 CNV",
    "SIRPAP1 RNA"
  ],
  "SVEP1": [
    "SVEP1 CNV",
    "SVEP1 RNA",
    "SVEP1 Proteo"
  ],
  "TM6SF1": [
    "TM6SF1 CNV",
    "TM6SF1 RNA",
    "TM6SF1 Proteo"
  ],
  "LZTR1": [
    "LZTR1 CNV",
    "LZTR1 RNA",
    "LZTR1 Proteo"
  ],
  "CUEDC2": [
    "CUEDC2 CNV",
    "CUEDC2 RNA",
    "CUEDC2 Proteo"
  ],
  "SPTY2D1OS": [
    "SPTY2D1OS CNV",
    "SPTY2D1OS RNA"
  ],
  "ALDH1A1": [
    "ALDH1A1 CNV",
    "ALDH1A1 RNA",
    "ALDH1A1 Proteo"
  ],
  "DRC1": [
    "DRC1 CNV",
    "DRC1 RNA"
  ],
  "ADCY1": [
    "ADCY1 CNV",
    "ADCY1 RNA"
  ],
  "GK3P": [
    "GK3P CNV",
    "GK3P RNA"
  ],
  "YES1": [
    "YES1 CNV",
    "YES1 RNA",
    "YES1 Proteo"
  ],
  "RB1CC1": [
    "RB1CC1 CNV",
    "RB1CC1 RNA",
    "RB1CC1 Proteo"
  ],
  "TAB3": [
    "TAB3 CNV",
    "TAB3 RNA",
    "TAB3 Proteo"
  ],
  "RPL22P12": [
    "RPL22P12 CNV",
    "RPL22P12 RNA"
  ],
  "VDAC1P4": [
    "VDAC1P4 CNV",
    "VDAC1P4 RNA"
  ],
  "RNA5SP117": [
    "RNA5SP117 CNV",
    "RNA5SP117 RNA"
  ],
  "MRI1": [
    "MRI1 CNV",
    "MRI1 RNA",
    "MRI1 Proteo"
  ],
  "DUX4L29": [
    "DUX4L29 CNV",
    "DUX4L29 RNA"
  ],
  "HAP1": [
    "HAP1 CNV",
    "HAP1 RNA"
  ],
  "KRT18P39": [
    "KRT18P39 CNV",
    "KRT18P39 RNA"
  ],
  "LBP": [
    "LBP CNV",
    "LBP RNA",
    "LBP Proteo"
  ],
  "GLULP4": [
    "GLULP4 CNV",
    "GLULP4 RNA"
  ],
  "NEDD8": [
    "NEDD8 CNV",
    "NEDD8 RNA",
    "NEDD8 Proteo"
  ],
  "TMEM215": [
    "TMEM215 CNV",
    "TMEM215 RNA"
  ],
  "TEAD4": [
    "TEAD4 CNV",
    "TEAD4 RNA",
    "TEAD4 Proteo"
  ],
  "TRUB2": [
    "TRUB2 CNV",
    "TRUB2 RNA",
    "TRUB2 Proteo"
  ],
  "WWC1": [
    "WWC1 CNV",
    "WWC1 RNA",
    "WWC1 Proteo"
  ],
  "GLRA1": [
    "GLRA1 CNV",
    "GLRA1 RNA"
  ],
  "FABP5P3": [
    "FABP5P3 CNV",
    "FABP5P3 RNA"
  ],
  "P2RX4": [
    "P2RX4 CNV",
    "P2RX4 RNA",
    "P2RX4 Proteo"
  ],
  "PRR4": [
    "PRR4 CNV",
    "PRR4 RNA",
    "PRR4 Proteo"
  ],
  "UBE3D": [
    "UBE3D CNV",
    "UBE3D RNA",
    "UBE3D Proteo"
  ],
  "ZNF788P": [
    "ZNF788P CNV",
    "ZNF788P RNA"
  ],
  "IGKV1D-16": [
    "IGKV1D-16 Proteo"
  ],
  "OTX2P1": [
    "OTX2P1 CNV",
    "OTX2P1 RNA"
  ],
  "MOXD1": [
    "MOXD1 CNV",
    "MOXD1 RNA",
    "MOXD1 Proteo"
  ],
  "CYTH3": [
    "CYTH3 CNV",
    "CYTH3 RNA",
    "CYTH3 Proteo"
  ],
  "PIP": [
    "PIP CNV",
    "PIP RNA",
    "PIP Proteo"
  ],
  "ANO6": [
    "ANO6 CNV",
    "ANO6 RNA",
    "ANO6 Proteo"
  ],
  "COQ9": [
    "COQ9 CNV",
    "COQ9 RNA",
    "COQ9 Proteo"
  ],
  "MRPS14": [
    "MRPS14 CNV",
    "MRPS14 RNA",
    "MRPS14 Proteo"
  ],
  "UHRF2": [
    "UHRF2 CNV",
    "UHRF2 RNA",
    "UHRF2 Proteo"
  ],
  "SAFB": [
    "SAFB CNV",
    "SAFB RNA",
    "SAFB Proteo"
  ],
  "SF3A3": [
    "SF3A3 CNV",
    "SF3A3 RNA",
    "SF3A3 Proteo"
  ],
  "UNC93B4": [
    "UNC93B4 CNV",
    "UNC93B4 RNA"
  ],
  "MRPL54": [
    "MRPL54 CNV",
    "MRPL54 RNA",
    "MRPL54 Proteo"
  ],
  "DNASE2": [
    "DNASE2 CNV",
    "DNASE2 RNA",
    "DNASE2 Proteo"
  ],
  "GUCA2B": [
    "GUCA2B CNV",
    "GUCA2B RNA"
  ],
  "DCLK3": [
    "DCLK3 CNV",
    "DCLK3 RNA"
  ],
  "SLC36A1": [
    "SLC36A1 CNV",
    "SLC36A1 RNA",
    "SLC36A1 Proteo"
  ],
  "TAF5LP1": [
    "TAF5LP1 CNV",
    "TAF5LP1 RNA"
  ],
  "BSG": [
    "BSG CNV",
    "BSG RNA",
    "BSG Proteo"
  ],
  "FAM90A22": [
    "FAM90A22 CNV",
    "FAM90A22 RNA"
  ],
  "RPL7AP51": [
    "RPL7AP51 CNV",
    "RPL7AP51 RNA"
  ],
  "CYP11B2": [
    "CYP11B2 CNV",
    "CYP11B2 RNA"
  ],
  "MLH1": [
    "MLH1 CNV",
    "MLH1 RNA",
    "MLH1 Proteo"
  ],
  "DSC2": [
    "DSC2 CNV",
    "DSC2 RNA",
    "DSC2 Proteo"
  ],
  "PDIK1L": [
    "PDIK1L CNV",
    "PDIK1L RNA",
    "PDIK1L Proteo"
  ],
  "TSPY7P": [
    "TSPY7P CNV",
    "TSPY7P RNA"
  ],
  "RPL3P11": [
    "RPL3P11 CNV",
    "RPL3P11 RNA"
  ],
  "TUBB8P7": [
    "TUBB8P7 CNV",
    "TUBB8P7 RNA"
  ],
  "TNRC6B": [
    "TNRC6B CNV",
    "TNRC6B RNA",
    "TNRC6B Proteo"
  ],
  "WNT2": [
    "WNT2 CNV",
    "WNT2 RNA",
    "WNT2 Proteo"
  ],
  "COP1": [
    "COP1 CNV",
    "COP1 RNA",
    "COP1 Proteo"
  ],
  "MTND4P17": [
    "MTND4P17 CNV",
    "MTND4P17 RNA"
  ],
  "RNA5SP436": [
    "RNA5SP436 CNV",
    "RNA5SP436 RNA"
  ],
  "TNP2": [
    "TNP2 CNV",
    "TNP2 RNA"
  ],
  "TCEA1P1": [
    "TCEA1P1 CNV",
    "TCEA1P1 RNA"
  ],
  "HMGN2P26": [
    "HMGN2P26 CNV",
    "HMGN2P26 RNA"
  ],
  "CD37": [
    "CD37 CNV",
    "CD37 RNA",
    "CD37 Proteo"
  ],
  "CHMP1B": [
    "CHMP1B CNV",
    "CHMP1B RNA",
    "CHMP1B Proteo"
  ],
  "RPS3AP13": [
    "RPS3AP13 CNV",
    "RPS3AP13 RNA"
  ],
  "SPDYE8": [
    "SPDYE8 CNV",
    "SPDYE8 RNA"
  ],
  "C1orf162": [
    "C1orf162 CNV",
    "C1orf162 RNA"
  ],
  "BRD8": [
    "BRD8 CNV",
    "BRD8 RNA",
    "BRD8 Proteo"
  ],
  "RFC4": [
    "RFC4 CNV",
    "RFC4 RNA",
    "RFC4 Proteo"
  ],
  "MAGEB5": [
    "MAGEB5 CNV",
    "MAGEB5 RNA"
  ],
  "C1QTNF2": [
    "C1QTNF2 CNV",
    "C1QTNF2 RNA"
  ],
  "TMEM161BP1": [
    "TMEM161BP1 CNV",
    "TMEM161BP1 RNA"
  ],
  "RPAP3": [
    "RPAP3 CNV",
    "RPAP3 RNA",
    "RPAP3 Proteo"
  ],
  "RNF14P3": [
    "RNF14P3 CNV",
    "RNF14P3 RNA"
  ],
  "MTND1P15": [
    "MTND1P15 CNV",
    "MTND1P15 RNA"
  ],
  "ZNF737": [
    "ZNF737 CNV",
    "ZNF737 RNA"
  ],
  "SERPINB1": [
    "SERPINB1 CNV",
    "SERPINB1 RNA",
    "SERPINB1 Proteo"
  ],
  "GUSBP18": [
    "GUSBP18 CNV",
    "GUSBP18 RNA"
  ],
  "PF4V1": [
    "PF4V1 CNV",
    "PF4V1 RNA"
  ],
  "PSMC6": [
    "PSMC6 CNV",
    "PSMC6 RNA",
    "PSMC6 Proteo"
  ],
  "MED9": [
    "MED9 CNV",
    "MED9 RNA",
    "MED9 Proteo"
  ],
  "NRSN1": [
    "NRSN1 CNV",
    "NRSN1 RNA"
  ],
  "ELK3": [
    "ELK3 CNV",
    "ELK3 RNA",
    "ELK3 Proteo"
  ],
  "RPS11": [
    "RPS11 CNV",
    "RPS11 RNA",
    "RPS11 Proteo"
  ],
  "POM121L3P": [
    "POM121L3P CNV",
    "POM121L3P RNA"
  ],
  "UGT3A1": [
    "UGT3A1 CNV",
    "UGT3A1 RNA"
  ],
  "NTPCR": [
    "NTPCR CNV",
    "NTPCR RNA",
    "NTPCR Proteo"
  ],
  "TDP1": [
    "TDP1 CNV",
    "TDP1 RNA",
    "TDP1 Proteo"
  ],
  "ABRA": [
    "ABRA CNV",
    "ABRA RNA"
  ],
  "H2BU1": [
    "H2BU1 CNV",
    "H2BU1 RNA"
  ],
  "ZNF587P1": [
    "ZNF587P1 CNV",
    "ZNF587P1 RNA"
  ],
  "SMR3B": [
    "SMR3B CNV",
    "SMR3B RNA",
    "SMR3B Proteo"
  ],
  "CFC1": [
    "CFC1 CNV",
    "CFC1 RNA"
  ],
  "FBXL12": [
    "FBXL12 CNV",
    "FBXL12 RNA",
    "FBXL12 Proteo"
  ],
  "TPTE2P5": [
    "TPTE2P5 CNV",
    "TPTE2P5 RNA"
  ],
  "OR52K3P": [
    "OR52K3P CNV",
    "OR52K3P RNA"
  ],
  "FAM170B": [
    "FAM170B CNV",
    "FAM170B RNA"
  ],
  "RO60": [
    "RO60 CNV",
    "RO60 RNA",
    "RO60 Proteo"
  ],
  "SNX21": [
    "SNX21 CNV",
    "SNX21 RNA",
    "SNX21 Proteo"
  ],
  "CD24P2": [
    "CD24P2 CNV",
    "CD24P2 RNA"
  ],
  "AKT1": [
    "AKT1 CNV",
    "AKT1 RNA",
    "AKT1 Proteo"
  ],
  "RPS3AP8": [
    "RPS3AP8 CNV",
    "RPS3AP8 RNA"
  ],
  "HIC1": [
    "HIC1 CNV",
    "HIC1 RNA",
    "HIC1 Proteo"
  ],
  "GPR52": [
    "GPR52 CNV",
    "GPR52 RNA"
  ],
  "AP4E1": [
    "AP4E1 CNV",
    "AP4E1 RNA",
    "AP4E1 Proteo"
  ],
  "CTXN1": [
    "CTXN1 CNV",
    "CTXN1 RNA"
  ],
  "ERP27": [
    "ERP27 CNV",
    "ERP27 RNA"
  ],
  "RAD51AP1P1": [
    "RAD51AP1P1 CNV",
    "RAD51AP1P1 RNA"
  ],
  "MT-CYB": [
    "MT-CYB RNA",
    "MT-CYB Proteo"
  ],
  "CFAP141": [
    "CFAP141 CNV",
    "CFAP141 RNA"
  ],
  "RPS3AP27": [
    "RPS3AP27 CNV",
    "RPS3AP27 RNA"
  ],
  "NUTM2E": [
    "NUTM2E CNV",
    "NUTM2E RNA"
  ],
  "ACSM4": [
    "ACSM4 CNV",
    "ACSM4 RNA"
  ],
  "NFRKB": [
    "NFRKB CNV",
    "NFRKB RNA",
    "NFRKB Proteo"
  ],
  "ANKRD34B": [
    "ANKRD34B CNV",
    "ANKRD34B RNA"
  ],
  "MTND4LP32": [
    "MTND4LP32 CNV",
    "MTND4LP32 RNA"
  ],
  "SUPT4H1P1": [
    "SUPT4H1P1 CNV",
    "SUPT4H1P1 RNA"
  ],
  "C2CD5": [
    "C2CD5 CNV",
    "C2CD5 RNA",
    "C2CD5 Proteo"
  ],
  "GRAP": [
    "GRAP CNV",
    "GRAP RNA",
    "GRAP Proteo"
  ],
  "AMIGO3": [
    "AMIGO3 CNV",
    "AMIGO3 RNA"
  ],
  "BRICD5": [
    "BRICD5 CNV",
    "BRICD5 RNA"
  ],
  "RIPPLY3": [
    "RIPPLY3 CNV",
    "RIPPLY3 RNA"
  ],
  "CENPB": [
    "CENPB CNV",
    "CENPB RNA",
    "CENPB Proteo"
  ],
  "OR4A5": [
    "OR4A5 CNV",
    "OR4A5 RNA"
  ],
  "FCF1P10": [
    "FCF1P10 CNV",
    "FCF1P10 RNA"
  ],
  "RPS27P20": [
    "RPS27P20 CNV",
    "RPS27P20 RNA"
  ],
  "RNA5SP72": [
    "RNA5SP72 CNV",
    "RNA5SP72 RNA"
  ],
  "DEUP1": [
    "DEUP1 CNV",
    "DEUP1 RNA"
  ],
  "TATDN2P1": [
    "TATDN2P1 CNV",
    "TATDN2P1 RNA"
  ],
  "MRPS17": [
    "MRPS17 CNV",
    "MRPS17 RNA",
    "MRPS17 Proteo"
  ],
  "RNASE10": [
    "RNASE10 CNV",
    "RNASE10 RNA"
  ],
  "HMGN1P34": [
    "HMGN1P34 CNV",
    "HMGN1P34 RNA"
  ],
  "ZNF181": [
    "ZNF181 CNV",
    "ZNF181 RNA"
  ],
  "ADI1P3": [
    "ADI1P3 CNV",
    "ADI1P3 RNA"
  ],
  "PTMAP10": [
    "PTMAP10 CNV",
    "PTMAP10 RNA"
  ],
  "AMPD3": [
    "AMPD3 CNV",
    "AMPD3 RNA",
    "AMPD3 Proteo"
  ],
  "CALHM5": [
    "CALHM5 CNV",
    "CALHM5 RNA",
    "CALHM5 Proteo"
  ],
  "KCNK6": [
    "KCNK6 CNV",
    "KCNK6 RNA"
  ],
  "SLAMF9": [
    "SLAMF9 CNV",
    "SLAMF9 RNA"
  ],
  "AKAP5": [
    "AKAP5 CNV",
    "AKAP5 RNA",
    "AKAP5 Proteo"
  ],
  "CLUHP8": [
    "CLUHP8 CNV",
    "CLUHP8 RNA"
  ],
  "RNA5SP478": [
    "RNA5SP478 CNV",
    "RNA5SP478 RNA"
  ],
  "ABHD11": [
    "ABHD11 CNV",
    "ABHD11 RNA",
    "ABHD11 Proteo"
  ],
  "RNA5SP103": [
    "RNA5SP103 CNV",
    "RNA5SP103 RNA"
  ],
  "ABR": [
    "ABR CNV",
    "ABR RNA",
    "ABR Proteo"
  ],
  "ZNF551": [
    "ZNF551 CNV",
    "ZNF551 RNA"
  ],
  "SLC25A39": [
    "SLC25A39 CNV",
    "SLC25A39 RNA"
  ],
  "PSMC3IP": [
    "PSMC3IP CNV",
    "PSMC3IP RNA",
    "PSMC3IP Proteo"
  ],
  "SMIM12": [
    "SMIM12 CNV",
    "SMIM12 RNA",
    "SMIM12 Proteo"
  ],
  "LRRC43": [
    "LRRC43 CNV",
    "LRRC43 RNA"
  ],
  "KRT18P13": [
    "KRT18P13 CNV",
    "KRT18P13 RNA"
  ],
  "FRG1FP": [
    "FRG1FP CNV",
    "FRG1FP RNA"
  ],
  "HMHB1": [
    "HMHB1 CNV",
    "HMHB1 RNA"
  ],
  "CENPCP1": [
    "CENPCP1 CNV",
    "CENPCP1 RNA"
  ],
  "NPM1P46": [
    "NPM1P46 CNV",
    "NPM1P46 RNA"
  ],
  "ZIM2": [
    "ZIM2 CNV",
    "ZIM2 RNA"
  ],
  "ZNF536": [
    "ZNF536 CNV",
    "ZNF536 RNA"
  ],
  "PIGA": [
    "PIGA CNV",
    "PIGA RNA",
    "PIGA Proteo"
  ],
  "TAF11L9": [
    "TAF11L9 CNV",
    "TAF11L9 RNA"
  ],
  "CTAGE9": [
    "CTAGE9 CNV",
    "CTAGE9 RNA"
  ],
  "PPP1R2P2": [
    "PPP1R2P2 CNV",
    "PPP1R2P2 RNA"
  ],
  "TPRG1LP1": [
    "TPRG1LP1 CNV",
    "TPRG1LP1 RNA"
  ],
  "KDM4F": [
    "KDM4F CNV",
    "KDM4F RNA"
  ],
  "NAV2": [
    "NAV2 CNV",
    "NAV2 RNA",
    "NAV2 Proteo"
  ],
  "RPL7AP63": [
    "RPL7AP63 CNV",
    "RPL7AP63 RNA"
  ],
  "ALDH7A1": [
    "ALDH7A1 CNV",
    "ALDH7A1 RNA",
    "ALDH7A1 Proteo"
  ],
  "OR4H6P": [
    "OR4H6P CNV",
    "OR4H6P RNA"
  ],
  "CENPQ": [
    "CENPQ CNV",
    "CENPQ RNA",
    "CENPQ Proteo"
  ],
  "CYB561": [
    "CYB561 CNV",
    "CYB561 RNA",
    "CYB561 Proteo"
  ],
  "DHDDS": [
    "DHDDS CNV",
    "DHDDS RNA",
    "DHDDS Proteo"
  ],
  "CDY8P": [
    "CDY8P CNV",
    "CDY8P RNA"
  ],
  "RPL23AP6": [
    "RPL23AP6 CNV",
    "RPL23AP6 RNA"
  ],
  "PRYP1": [
    "PRYP1 CNV",
    "PRYP1 RNA"
  ],
  "UFM1": [
    "UFM1 CNV",
    "UFM1 RNA",
    "UFM1 Proteo"
  ],
  "HSPA8P5": [
    "HSPA8P5 CNV",
    "HSPA8P5 RNA"
  ],
  "ABCA3P1": [
    "ABCA3P1 CNV",
    "ABCA3P1 RNA"
  ],
  "DNM2": [
    "DNM2 CNV",
    "DNM2 RNA",
    "DNM2 Proteo"
  ],
  "TRAPPC13": [
    "TRAPPC13 CNV",
    "TRAPPC13 RNA",
    "TRAPPC13 Proteo"
  ],
  "HYPK": [
    "HYPK CNV",
    "HYPK RNA",
    "HYPK Proteo"
  ],
  "PDAP1": [
    "PDAP1 CNV",
    "PDAP1 RNA",
    "PDAP1 Proteo"
  ],
  "NPEPPS": [
    "NPEPPS CNV",
    "NPEPPS RNA",
    "NPEPPS Proteo"
  ],
  "PPIAP31": [
    "PPIAP31 CNV",
    "PPIAP31 RNA"
  ],
  "IRF5": [
    "IRF5 CNV",
    "IRF5 RNA",
    "IRF5 Proteo"
  ],
  "KCNMB2": [
    "KCNMB2 CNV",
    "KCNMB2 RNA"
  ],
  "SVBP": [
    "SVBP CNV",
    "SVBP RNA",
    "SVBP Proteo"
  ],
  "GTF3AP6": [
    "GTF3AP6 CNV",
    "GTF3AP6 RNA"
  ],
  "PSMB3": [
    "PSMB3 CNV",
    "PSMB3 RNA",
    "PSMB3 Proteo"
  ],
  "SURF6P1": [
    "SURF6P1 CNV",
    "SURF6P1 RNA"
  ],
  "VWDE": [
    "VWDE CNV",
    "VWDE RNA"
  ],
  "CCDC175": [
    "CCDC175 CNV",
    "CCDC175 RNA"
  ],
  "ERHP2": [
    "ERHP2 CNV",
    "ERHP2 RNA"
  ],
  "PRSS22": [
    "PRSS22 CNV",
    "PRSS22 RNA"
  ],
  "TRMO": [
    "TRMO CNV",
    "TRMO RNA"
  ],
  "ZNF266": [
    "ZNF266 CNV",
    "ZNF266 RNA"
  ],
  "IRGC": [
    "IRGC CNV",
    "IRGC RNA"
  ],
  "RPL26P19": [
    "RPL26P19 CNV",
    "RPL26P19 RNA"
  ],
  "CHRNA5": [
    "CHRNA5 CNV",
    "CHRNA5 RNA"
  ],
  "RPL12P23": [
    "RPL12P23 CNV",
    "RPL12P23 RNA"
  ],
  "CYP2C58P": [
    "CYP2C58P CNV",
    "CYP2C58P RNA"
  ],
  "SHOX": [
    "SHOX CNV",
    "SHOX RNA"
  ],
  "NDUFB6": [
    "NDUFB6 CNV",
    "NDUFB6 RNA",
    "NDUFB6 Proteo"
  ],
  "SSBL3P": [
    "SSBL3P CNV",
    "SSBL3P RNA"
  ],
  "GSTA9P": [
    "GSTA9P CNV",
    "GSTA9P RNA"
  ],
  "FARSBP1": [
    "FARSBP1 CNV",
    "FARSBP1 RNA"
  ],
  "TBCC": [
    "TBCC CNV",
    "TBCC RNA",
    "TBCC Proteo"
  ],
  "ZNF273": [
    "ZNF273 CNV",
    "ZNF273 RNA",
    "ZNF273 Proteo"
  ],
  "RPS12P31": [
    "RPS12P31 CNV",
    "RPS12P31 RNA"
  ],
  "L1TD1": [
    "L1TD1 CNV",
    "L1TD1 RNA"
  ],
  "PLEKHO1": [
    "PLEKHO1 CNV",
    "PLEKHO1 RNA",
    "PLEKHO1 Proteo"
  ],
  "CCDC196": [
    "CCDC196 CNV",
    "CCDC196 RNA"
  ],
  "NMI": [
    "NMI CNV",
    "NMI RNA",
    "NMI Proteo"
  ],
  "PAX2": [
    "PAX2 CNV",
    "PAX2 RNA"
  ],
  "ATM": [
    "ATM CNV",
    "ATM RNA",
    "ATM Proteo"
  ],
  "SIRPA": [
    "SIRPA CNV",
    "SIRPA RNA",
    "SIRPA Proteo"
  ],
  "PI4K2A": [
    "PI4K2A CNV",
    "PI4K2A RNA",
    "PI4K2A Proteo"
  ],
  "LAMC3": [
    "LAMC3 CNV",
    "LAMC3 RNA",
    "LAMC3 Proteo"
  ],
  "ANKRD40CL": [
    "ANKRD40CL CNV",
    "ANKRD40CL RNA"
  ],
  "RRP15": [
    "RRP15 CNV",
    "RRP15 RNA",
    "RRP15 Proteo"
  ],
  "SEPTIN7P9": [
    "SEPTIN7P9 CNV",
    "SEPTIN7P9 RNA"
  ],
  "TFB2M": [
    "TFB2M CNV",
    "TFB2M RNA",
    "TFB2M Proteo"
  ],
  "IRF9": [
    "IRF9 CNV",
    "IRF9 RNA",
    "IRF9 Proteo"
  ],
  "RPS3AP40": [
    "RPS3AP40 CNV",
    "RPS3AP40 RNA"
  ],
  "H2BC8": [
    "H2BC8 CNV",
    "H2BC8 RNA"
  ],
  "SULT1B1": [
    "SULT1B1 CNV",
    "SULT1B1 RNA",
    "SULT1B1 Proteo"
  ],
  "H3Y1": [
    "H3Y1 CNV",
    "H3Y1 RNA"
  ],
  "RBMX2P2": [
    "RBMX2P2 CNV",
    "RBMX2P2 RNA"
  ],
  "EXOSC5": [
    "EXOSC5 CNV",
    "EXOSC5 RNA",
    "EXOSC5 Proteo"
  ],
  "PPP6R3": [
    "PPP6R3 CNV",
    "PPP6R3 RNA",
    "PPP6R3 Proteo"
  ],
  "USP7": [
    "USP7 CNV",
    "USP7 RNA",
    "USP7 Proteo"
  ],
  "BMS1P11": [
    "BMS1P11 CNV",
    "BMS1P11 RNA"
  ],
  "MPHOSPH10P1": [
    "MPHOSPH10P1 CNV",
    "MPHOSPH10P1 RNA"
  ],
  "KNOP1P5": [
    "KNOP1P5 CNV",
    "KNOP1P5 RNA"
  ],
  "SEC14L5": [
    "SEC14L5 CNV",
    "SEC14L5 RNA"
  ],
  "SFTPC": [
    "SFTPC CNV",
    "SFTPC RNA",
    "SFTPC Proteo"
  ],
  "RPS23P8": [
    "RPS23P8 CNV",
    "RPS23P8 RNA"
  ],
  "TMEM238": [
    "TMEM238 CNV",
    "TMEM238 RNA",
    "TMEM238 Proteo"
  ],
  "OCIAD1": [
    "OCIAD1 CNV",
    "OCIAD1 RNA",
    "OCIAD1 Proteo"
  ],
  "SAFB2": [
    "SAFB2 CNV",
    "SAFB2 RNA",
    "SAFB2 Proteo"
  ],
  "SMN1": [
    "SMN1 CNV",
    "SMN1 RNA",
    "SMN1 Proteo"
  ],
  "RAB33A": [
    "RAB33A CNV",
    "RAB33A RNA",
    "RAB33A Proteo"
  ],
  "PPA2": [
    "PPA2 CNV",
    "PPA2 RNA",
    "PPA2 Proteo"
  ],
  "LAS1L": [
    "LAS1L CNV",
    "LAS1L RNA",
    "LAS1L Proteo"
  ],
  "RAC1P4": [
    "RAC1P4 CNV",
    "RAC1P4 RNA"
  ],
  "CPSF1P1": [
    "CPSF1P1 CNV",
    "CPSF1P1 RNA"
  ],
  "ARL6IP6": [
    "ARL6IP6 CNV",
    "ARL6IP6 RNA",
    "ARL6IP6 Proteo"
  ],
  "ARHGEF9": [
    "ARHGEF9 CNV",
    "ARHGEF9 RNA"
  ],
  "MICA": [
    "MICA CNV",
    "MICA RNA",
    "MICA Proteo"
  ],
  "PJA2": [
    "PJA2 CNV",
    "PJA2 RNA",
    "PJA2 Proteo"
  ],
  "RPL12P2": [
    "RPL12P2 CNV",
    "RPL12P2 RNA"
  ],
  "SIGLEC5": [
    "SIGLEC5 CNV",
    "SIGLEC5 RNA",
    "SIGLEC5 Proteo"
  ],
  "ZNF384": [
    "ZNF384 CNV",
    "ZNF384 RNA",
    "ZNF384 Proteo"
  ],
  "PRICKLE2": [
    "PRICKLE2 CNV",
    "PRICKLE2 RNA",
    "PRICKLE2 Proteo"
  ],
  "NETO2": [
    "NETO2 CNV",
    "NETO2 RNA"
  ],
  "RPSAP74": [
    "RPSAP74 CNV",
    "RPSAP74 RNA"
  ],
  "CCNF": [
    "CCNF CNV",
    "CCNF RNA"
  ],
  "C3orf20": [
    "C3orf20 CNV",
    "C3orf20 RNA"
  ],
  "VXN": [
    "VXN CNV",
    "VXN RNA"
  ],
  "MAN2A2": [
    "MAN2A2 CNV",
    "MAN2A2 RNA",
    "MAN2A2 Proteo"
  ],
  "RNA5SP335": [
    "RNA5SP335 CNV",
    "RNA5SP335 RNA"
  ],
  "AK1": [
    "AK1 CNV",
    "AK1 RNA",
    "AK1 Proteo"
  ],
  "POLR3D": [
    "POLR3D CNV",
    "POLR3D RNA",
    "POLR3D Proteo"
  ],
  "YWHAH": [
    "YWHAH CNV",
    "YWHAH RNA",
    "YWHAH Proteo"
  ],
  "ZNF550": [
    "ZNF550 CNV",
    "ZNF550 RNA"
  ],
  "RAB33B": [
    "RAB33B CNV",
    "RAB33B RNA",
    "RAB33B Proteo"
  ],
  "POLR2C": [
    "POLR2C CNV",
    "POLR2C RNA",
    "POLR2C Proteo"
  ],
  "NDUFA5P5": [
    "NDUFA5P5 CNV",
    "NDUFA5P5 RNA"
  ],
  "RPL6P29": [
    "RPL6P29 CNV",
    "RPL6P29 RNA"
  ],
  "ITPKC": [
    "ITPKC CNV",
    "ITPKC RNA",
    "ITPKC Proteo"
  ],
  "MSLNL": [
    "MSLNL CNV",
    "MSLNL RNA"
  ],
  "MRGPRX7P": [
    "MRGPRX7P CNV",
    "MRGPRX7P RNA"
  ],
  "TMEM255A": [
    "TMEM255A CNV",
    "TMEM255A RNA"
  ],
  "ZNF3": [
    "ZNF3 CNV",
    "ZNF3 RNA",
    "ZNF3 Proteo"
  ],
  "H2BC2P": [
    "H2BC2P CNV",
    "H2BC2P RNA"
  ],
  "RPL7AP28": [
    "RPL7AP28 CNV",
    "RPL7AP28 RNA"
  ],
  "NOC2LP2": [
    "NOC2LP2 CNV",
    "NOC2LP2 RNA"
  ],
  "C10orf143": [
    "C10orf143 CNV",
    "C10orf143 RNA"
  ],
  "MOBP": [
    "MOBP CNV",
    "MOBP RNA"
  ],
  "CDH12P1": [
    "CDH12P1 CNV",
    "CDH12P1 RNA"
  ],
  "FAM204DP": [
    "FAM204DP CNV",
    "FAM204DP RNA"
  ],
  "TRAV11": [
    "TRAV11 CNV",
    "TRAV11 RNA"
  ],
  "SETX": [
    "SETX CNV",
    "SETX RNA",
    "SETX Proteo"
  ],
  "CX3CL1": [
    "CX3CL1 CNV",
    "CX3CL1 RNA"
  ],
  "RNPC3": [
    "RNPC3 CNV",
    "RNPC3 RNA",
    "RNPC3 Proteo"
  ],
  "CSP1": [
    "CSP1 CNV",
    "CSP1 RNA"
  ],
  "RPS29P9": [
    "RPS29P9 CNV",
    "RPS29P9 RNA"
  ],
  "OR8U3": [
    "OR8U3 CNV",
    "OR8U3 RNA"
  ],
  "RNA5SP272": [
    "RNA5SP272 CNV",
    "RNA5SP272 RNA"
  ],
  "CFAP57": [
    "CFAP57 CNV",
    "CFAP57 RNA"
  ],
  "SHROOM4": [
    "SHROOM4 CNV",
    "SHROOM4 RNA",
    "SHROOM4 Proteo"
  ],
  "NDUFB5": [
    "NDUFB5 CNV",
    "NDUFB5 RNA",
    "NDUFB5 Proteo"
  ],
  "CCDC125": [
    "CCDC125 CNV",
    "CCDC125 RNA"
  ],
  "ADAMTS7P3": [
    "ADAMTS7P3 CNV",
    "ADAMTS7P3 RNA"
  ],
  "CD74": [
    "CD74 CNV",
    "CD74 RNA",
    "CD74 Proteo"
  ],
  "RNA5SP181": [
    "RNA5SP181 CNV",
    "RNA5SP181 RNA"
  ],
  "ZC3H15": [
    "ZC3H15 CNV",
    "ZC3H15 RNA",
    "ZC3H15 Proteo"
  ],
  "RBPJ": [
    "RBPJ CNV",
    "RBPJ RNA",
    "RBPJ Proteo"
  ],
  "CDY15P": [
    "CDY15P CNV",
    "CDY15P RNA"
  ],
  "DUS3L": [
    "DUS3L CNV",
    "DUS3L RNA",
    "DUS3L Proteo"
  ],
  "PGGT1B": [
    "PGGT1B CNV",
    "PGGT1B RNA",
    "PGGT1B Proteo"
  ],
  "RNA5SP188": [
    "RNA5SP188 CNV",
    "RNA5SP188 RNA"
  ],
  "ZNF438": [
    "ZNF438 CNV",
    "ZNF438 RNA",
    "ZNF438 Proteo"
  ],
  "GSG1L": [
    "GSG1L CNV",
    "GSG1L RNA"
  ],
  "FIS1": [
    "FIS1 CNV",
    "FIS1 RNA",
    "FIS1 Proteo"
  ],
  "GNAO1": [
    "GNAO1 CNV",
    "GNAO1 RNA",
    "GNAO1 Proteo"
  ],
  "U2SURP": [
    "U2SURP CNV",
    "U2SURP RNA",
    "U2SURP Proteo"
  ],
  "EDAR": [
    "EDAR CNV",
    "EDAR RNA"
  ],
  "VAMP2": [
    "VAMP2 CNV",
    "VAMP2 RNA",
    "VAMP2 Proteo"
  ],
  "IFIT3": [
    "IFIT3 CNV",
    "IFIT3 RNA",
    "IFIT3 Proteo"
  ],
  "FAM169A": [
    "FAM169A CNV",
    "FAM169A RNA",
    "FAM169A Proteo"
  ],
  "SIPA1": [
    "SIPA1 CNV",
    "SIPA1 RNA",
    "SIPA1 Proteo"
  ],
  "MRPL57P1": [
    "MRPL57P1 CNV",
    "MRPL57P1 RNA"
  ],
  "CHIT1": [
    "CHIT1 CNV",
    "CHIT1 RNA",
    "CHIT1 Proteo"
  ],
  "PIH1D2": [
    "PIH1D2 CNV",
    "PIH1D2 RNA"
  ],
  "RNA5SP126": [
    "RNA5SP126 CNV",
    "RNA5SP126 RNA"
  ],
  "ZNF552": [
    "ZNF552 CNV",
    "ZNF552 RNA"
  ],
  "GDPD5": [
    "GDPD5 CNV",
    "GDPD5 RNA",
    "GDPD5 Proteo"
  ],
  "C7orf33": [
    "C7orf33 CNV",
    "C7orf33 RNA"
  ],
  "C2CD6": [
    "C2CD6 CNV",
    "C2CD6 RNA"
  ],
  "EIF1": [
    "EIF1 CNV",
    "EIF1 RNA",
    "EIF1 Proteo"
  ],
  "SS18L2P2": [
    "SS18L2P2 CNV",
    "SS18L2P2 RNA"
  ],
  "MOB2": [
    "MOB2 CNV",
    "MOB2 RNA",
    "MOB2 Proteo"
  ],
  "TSPAN12": [
    "TSPAN12 CNV",
    "TSPAN12 RNA"
  ],
  "GOLGA7": [
    "GOLGA7 CNV",
    "GOLGA7 RNA",
    "GOLGA7 Proteo"
  ],
  "RGS14": [
    "RGS14 CNV",
    "RGS14 RNA",
    "RGS14 Proteo"
  ],
  "SPDYC": [
    "SPDYC CNV",
    "SPDYC RNA"
  ],
  "CHTF8P1": [
    "CHTF8P1 CNV",
    "CHTF8P1 RNA"
  ],
  "ADORA2B": [
    "ADORA2B CNV",
    "ADORA2B RNA"
  ],
  "ZNF385D": [
    "ZNF385D CNV",
    "ZNF385D RNA"
  ],
  "FAM21EP": [
    "FAM21EP CNV",
    "FAM21EP RNA"
  ],
  "DPYD": [
    "DPYD CNV",
    "DPYD RNA",
    "DPYD Proteo"
  ],
  "TLR1": [
    "TLR1 CNV",
    "TLR1 RNA",
    "TLR1 Proteo"
  ],
  "ANO10": [
    "ANO10 CNV",
    "ANO10 RNA",
    "ANO10 Proteo"
  ],
  "LCE4A": [
    "LCE4A CNV",
    "LCE4A RNA"
  ],
  "SSTR1": [
    "SSTR1 CNV",
    "SSTR1 RNA"
  ],
  "ATP6V1G1": [
    "ATP6V1G1 CNV",
    "ATP6V1G1 RNA",
    "ATP6V1G1 Proteo"
  ],
  "UBE2V1P10": [
    "UBE2V1P10 CNV",
    "UBE2V1P10 RNA"
  ],
  "SNX7": [
    "SNX7 CNV",
    "SNX7 RNA",
    "SNX7 Proteo"
  ],
  "PELI2": [
    "PELI2 CNV",
    "PELI2 RNA",
    "PELI2 Proteo"
  ],
  "GAPDHP46": [
    "GAPDHP46 CNV",
    "GAPDHP46 RNA"
  ],
  "RPL21P119": [
    "RPL21P119 CNV",
    "RPL21P119 RNA"
  ],
  "BRSK1": [
    "BRSK1 CNV",
    "BRSK1 RNA"
  ],
  "GUSB": [
    "GUSB CNV",
    "GUSB RNA",
    "GUSB Proteo"
  ],
  "CDX4": [
    "CDX4 CNV",
    "CDX4 RNA"
  ],
  "SFT2D3": [
    "SFT2D3 CNV",
    "SFT2D3 RNA",
    "SFT2D3 Proteo"
  ],
  "GABRB2": [
    "GABRB2 CNV",
    "GABRB2 RNA"
  ],
  "IL32": [
    "IL32 CNV",
    "IL32 RNA",
    "IL32 Proteo"
  ],
  "DDX43P1": [
    "DDX43P1 CNV",
    "DDX43P1 RNA"
  ],
  "INTS2": [
    "INTS2 CNV",
    "INTS2 RNA",
    "INTS2 Proteo"
  ],
  "TPR": [
    "TPR CNV",
    "TPR RNA",
    "TPR Proteo"
  ],
  "HNRNPA1P29": [
    "HNRNPA1P29 CNV",
    "HNRNPA1P29 RNA"
  ],
  "SYCE1": [
    "SYCE1 CNV",
    "SYCE1 RNA"
  ],
  "EVA1CP4": [
    "EVA1CP4 CNV",
    "EVA1CP4 RNA"
  ],
  "FBXW7": [
    "FBXW7 CNV",
    "FBXW7 RNA",
    "FBXW7 Proteo"
  ],
  "DFFB": [
    "DFFB CNV",
    "DFFB RNA",
    "DFFB Proteo"
  ],
  "MRFAP1P1": [
    "MRFAP1P1 CNV",
    "MRFAP1P1 RNA"
  ],
  "IRS1": [
    "IRS1 CNV",
    "IRS1 RNA",
    "IRS1 Proteo"
  ],
  "RANGRF": [
    "RANGRF CNV",
    "RANGRF RNA",
    "RANGRF Proteo"
  ],
  "PREX2": [
    "PREX2 CNV",
    "PREX2 RNA"
  ],
  "TSEN34": [
    "TSEN34 CNV",
    "TSEN34 RNA",
    "TSEN34 Proteo"
  ],
  "FAM74A4": [
    "FAM74A4 CNV",
    "FAM74A4 RNA"
  ],
  "COA5": [
    "COA5 CNV",
    "COA5 RNA",
    "COA5 Proteo"
  ],
  "RAPGEF2": [
    "RAPGEF2 CNV",
    "RAPGEF2 RNA",
    "RAPGEF2 Proteo"
  ],
  "RHOG2P": [
    "RHOG2P CNV",
    "RHOG2P RNA"
  ],
  "RPL23AP47": [
    "RPL23AP47 CNV",
    "RPL23AP47 RNA"
  ],
  "HSPG2": [
    "HSPG2 CNV",
    "HSPG2 RNA",
    "HSPG2 Proteo"
  ],
  "LGALS9": [
    "LGALS9 CNV",
    "LGALS9 RNA",
    "LGALS9 Proteo"
  ],
  "BBS1": [
    "BBS1 CNV",
    "BBS1 RNA",
    "BBS1 Proteo"
  ],
  "ITLN2": [
    "ITLN2 CNV",
    "ITLN2 RNA"
  ],
  "SLC25A51": [
    "SLC25A51 CNV",
    "SLC25A51 RNA",
    "SLC25A51 Proteo"
  ],
  "RPS9P1": [
    "RPS9P1 CNV",
    "RPS9P1 RNA"
  ],
  "S100A9": [
    "S100A9 CNV",
    "S100A9 RNA",
    "S100A9 Proteo"
  ],
  "H4C13": [
    "H4C13 CNV",
    "H4C13 RNA"
  ],
  "FREM2": [
    "FREM2 CNV",
    "FREM2 RNA",
    "FREM2 Proteo"
  ],
  "ZNF836": [
    "ZNF836 CNV",
    "ZNF836 RNA"
  ],
  "CDKL1": [
    "CDKL1 CNV",
    "CDKL1 RNA"
  ],
  "CDK16": [
    "CDK16 CNV",
    "CDK16 RNA",
    "CDK16 Proteo"
  ],
  "TINAG": [
    "TINAG CNV",
    "TINAG RNA"
  ],
  "PCDHA9": [
    "PCDHA9 CNV",
    "PCDHA9 RNA"
  ],
  "DDX18P5": [
    "DDX18P5 CNV",
    "DDX18P5 RNA"
  ],
  "PIK3R3": [
    "PIK3R3 CNV",
    "PIK3R3 RNA"
  ],
  "PRSS50": [
    "PRSS50 CNV",
    "PRSS50 RNA"
  ],
  "MTND3P19": [
    "MTND3P19 CNV",
    "MTND3P19 RNA"
  ],
  "TTC23": [
    "TTC23 CNV",
    "TTC23 RNA"
  ],
  "OR5AP1P": [
    "OR5AP1P CNV",
    "OR5AP1P RNA"
  ],
  "PPIL1P1": [
    "PPIL1P1 CNV",
    "PPIL1P1 RNA"
  ],
  "QPCTL": [
    "QPCTL CNV",
    "QPCTL RNA",
    "QPCTL Proteo"
  ],
  "RPL19P1": [
    "RPL19P1 CNV",
    "RPL19P1 RNA"
  ],
  "CEP41": [
    "CEP41 CNV",
    "CEP41 RNA",
    "CEP41 Proteo"
  ],
  "RAB6D": [
    "RAB6D CNV",
    "RAB6D RNA",
    "RAB6D Proteo"
  ],
  "NFE2L3P1": [
    "NFE2L3P1 CNV",
    "NFE2L3P1 RNA"
  ],
  "LSM3P2": [
    "LSM3P2 CNV",
    "LSM3P2 RNA"
  ],
  "PSG3": [
    "PSG3 CNV",
    "PSG3 RNA"
  ],
  "PCDHA10": [
    "PCDHA10 CNV",
    "PCDHA10 RNA"
  ],
  "EEF1B2P1": [
    "EEF1B2P1 CNV",
    "EEF1B2P1 RNA"
  ],
  "VPS53": [
    "VPS53 CNV",
    "VPS53 RNA",
    "VPS53 Proteo"
  ],
  "DNAAF2": [
    "DNAAF2 CNV",
    "DNAAF2 RNA",
    "DNAAF2 Proteo"
  ],
  "OR4A43P": [
    "OR4A43P CNV",
    "OR4A43P RNA"
  ],
  "RPP40P1": [
    "RPP40P1 CNV",
    "RPP40P1 RNA"
  ],
  "UBQLN1": [
    "UBQLN1 CNV",
    "UBQLN1 RNA",
    "UBQLN1 Proteo"
  ],
  "GLUD1P3": [
    "GLUD1P3 CNV",
    "GLUD1P3 RNA"
  ],
  "ZNF212": [
    "ZNF212 CNV",
    "ZNF212 RNA"
  ],
  "FZD4": [
    "FZD4 CNV",
    "FZD4 RNA"
  ],
  "SLC25A11": [
    "SLC25A11 CNV",
    "SLC25A11 RNA",
    "SLC25A11 Proteo"
  ],
  "NLE1": [
    "NLE1 CNV",
    "NLE1 RNA",
    "NLE1 Proteo"
  ],
  "ADARB2": [
    "ADARB2 CNV",
    "ADARB2 RNA",
    "ADARB2 Proteo"
  ],
  "CABP1": [
    "CABP1 CNV",
    "CABP1 RNA"
  ],
  "ARHGEF10": [
    "ARHGEF10 CNV",
    "ARHGEF10 RNA",
    "ARHGEF10 Proteo"
  ],
  "TAS2R5": [
    "TAS2R5 CNV",
    "TAS2R5 RNA"
  ],
  "GOLGA6L11P": [
    "GOLGA6L11P CNV",
    "GOLGA6L11P RNA"
  ],
  "HMGA1P5": [
    "HMGA1P5 CNV",
    "HMGA1P5 RNA"
  ],
  "C4B": [
    "C4B CNV",
    "C4B RNA",
    "C4B Proteo"
  ],
  "FTH1P12": [
    "FTH1P12 CNV",
    "FTH1P12 RNA"
  ],
  "PANX3": [
    "PANX3 CNV",
    "PANX3 RNA"
  ],
  "FAM192BP": [
    "FAM192BP CNV",
    "FAM192BP RNA"
  ],
  "CHCHD6": [
    "CHCHD6 CNV",
    "CHCHD6 RNA",
    "CHCHD6 Proteo"
  ],
  "SELENOT": [
    "SELENOT CNV",
    "SELENOT RNA",
    "SELENOT Proteo"
  ],
  "KCNJ1": [
    "KCNJ1 CNV",
    "KCNJ1 RNA"
  ],
  "GRK3": [
    "GRK3 CNV",
    "GRK3 RNA",
    "GRK3 Proteo"
  ],
  "IQSEC1": [
    "IQSEC1 CNV",
    "IQSEC1 RNA",
    "IQSEC1 Proteo"
  ],
  "ACSM3": [
    "ACSM3 CNV",
    "ACSM3 RNA",
    "ACSM3 Proteo"
  ],
  "PKMP1": [
    "PKMP1 CNV",
    "PKMP1 RNA"
  ],
  "RARRES2": [
    "RARRES2 CNV",
    "RARRES2 RNA",
    "RARRES2 Proteo"
  ],
  "NPIPB5": [
    "NPIPB5 CNV",
    "NPIPB5 RNA"
  ],
  "IDNK": [
    "IDNK CNV",
    "IDNK RNA",
    "IDNK Proteo"
  ],
  "ELOCP12": [
    "ELOCP12 CNV",
    "ELOCP12 RNA"
  ],
  "MAST2": [
    "MAST2 CNV",
    "MAST2 RNA",
    "MAST2 Proteo"
  ],
  "SLC8A3": [
    "SLC8A3 CNV",
    "SLC8A3 RNA"
  ],
  "ZDHHC3": [
    "ZDHHC3 CNV",
    "ZDHHC3 RNA",
    "ZDHHC3 Proteo"
  ],
  "CLMN": [
    "CLMN CNV",
    "CLMN RNA",
    "CLMN Proteo"
  ],
  "SMTN": [
    "SMTN CNV",
    "SMTN RNA",
    "SMTN Proteo"
  ],
  "ZNF763": [
    "ZNF763 CNV",
    "ZNF763 RNA"
  ],
  "SIRPB2": [
    "SIRPB2 CNV",
    "SIRPB2 RNA"
  ],
  "KRT18P40": [
    "KRT18P40 CNV",
    "KRT18P40 RNA"
  ],
  "ARMC1": [
    "ARMC1 CNV",
    "ARMC1 RNA",
    "ARMC1 Proteo"
  ],
  "SELENBP1": [
    "SELENBP1 CNV",
    "SELENBP1 RNA",
    "SELENBP1 Proteo"
  ],
  "HMBS": [
    "HMBS CNV",
    "HMBS RNA",
    "HMBS Proteo"
  ],
  "GIMAP4": [
    "GIMAP4 CNV",
    "GIMAP4 RNA",
    "GIMAP4 Proteo"
  ],
  "SUGT1": [
    "SUGT1 CNV",
    "SUGT1 RNA",
    "SUGT1 Proteo"
  ],
  "LCE1F": [
    "LCE1F CNV",
    "LCE1F RNA"
  ],
  "PRXL2AP1": [
    "PRXL2AP1 CNV",
    "PRXL2AP1 RNA"
  ],
  "ZNF486": [
    "ZNF486 CNV",
    "ZNF486 RNA"
  ],
  "RPS7P9": [
    "RPS7P9 CNV",
    "RPS7P9 RNA"
  ],
  "SMARCC2": [
    "SMARCC2 CNV",
    "SMARCC2 RNA",
    "SMARCC2 Proteo"
  ],
  "NPHS2": [
    "NPHS2 CNV",
    "NPHS2 RNA"
  ],
  "KRT84": [
    "KRT84 CNV",
    "KRT84 RNA",
    "KRT84 Proteo"
  ],
  "KRT28": [
    "KRT28 CNV",
    "KRT28 RNA",
    "KRT28 Proteo"
  ],
  "AKR1B10": [
    "AKR1B10 CNV",
    "AKR1B10 RNA",
    "AKR1B10 Proteo"
  ],
  "NUP58": [
    "NUP58 CNV",
    "NUP58 RNA",
    "NUP58 Proteo"
  ],
  "RPL9P14": [
    "RPL9P14 CNV",
    "RPL9P14 RNA"
  ],
  "DYNLT2B": [
    "DYNLT2B CNV",
    "DYNLT2B RNA"
  ],
  "HNRNPA1P68": [
    "HNRNPA1P68 CNV",
    "HNRNPA1P68 RNA"
  ],
  "PDHX": [
    "PDHX CNV",
    "PDHX RNA",
    "PDHX Proteo"
  ],
  "IL17A": [
    "IL17A CNV",
    "IL17A RNA"
  ],
  "UBAP1L": [
    "UBAP1L CNV",
    "UBAP1L RNA"
  ],
  "HNRNPCL4": [
    "HNRNPCL4 CNV",
    "HNRNPCL4 RNA"
  ],
  "CNOT10": [
    "CNOT10 CNV",
    "CNOT10 RNA",
    "CNOT10 Proteo"
  ],
  "CEACAMP7": [
    "CEACAMP7 CNV",
    "CEACAMP7 RNA"
  ],
  "RPL19P14": [
    "RPL19P14 CNV",
    "RPL19P14 RNA"
  ],
  "SPINK5": [
    "SPINK5 CNV",
    "SPINK5 RNA",
    "SPINK5 Proteo"
  ],
  "OR10H2": [
    "OR10H2 CNV",
    "OR10H2 RNA"
  ],
  "ALG1L3P": [
    "ALG1L3P CNV",
    "ALG1L3P RNA"
  ],
  "TOMM70": [
    "TOMM70 CNV",
    "TOMM70 RNA",
    "TOMM70 Proteo"
  ],
  "MTND5P30": [
    "MTND5P30 CNV",
    "MTND5P30 RNA"
  ],
  "CDC42EP5": [
    "CDC42EP5 CNV",
    "CDC42EP5 RNA",
    "CDC42EP5 Proteo"
  ],
  "PIP5K1P1": [
    "PIP5K1P1 CNV",
    "PIP5K1P1 RNA"
  ],
  "ABCC8": [
    "ABCC8 CNV",
    "ABCC8 RNA"
  ],
  "FHL2": [
    "FHL2 CNV",
    "FHL2 RNA",
    "FHL2 Proteo"
  ],
  "FTLP5": [
    "FTLP5 CNV",
    "FTLP5 RNA"
  ],
  "BPGM": [
    "BPGM CNV",
    "BPGM RNA",
    "BPGM Proteo"
  ],
  "ZNF789": [
    "ZNF789 CNV",
    "ZNF789 RNA"
  ],
  "SLAMF6": [
    "SLAMF6 CNV",
    "SLAMF6 RNA",
    "SLAMF6 Proteo"
  ],
  "PLEKHS1": [
    "PLEKHS1 CNV",
    "PLEKHS1 RNA"
  ],
  "RPL12P5": [
    "RPL12P5 CNV",
    "RPL12P5 RNA"
  ],
  "PTENP1": [
    "PTENP1 CNV",
    "PTENP1 RNA"
  ],
  "NFATC2": [
    "NFATC2 CNV",
    "NFATC2 RNA",
    "NFATC2 Proteo"
  ],
  "HTR3D": [
    "HTR3D CNV",
    "HTR3D RNA"
  ],
  "ITLN1": [
    "ITLN1 CNV",
    "ITLN1 RNA",
    "ITLN1 Proteo"
  ],
  "BCDIN3D": [
    "BCDIN3D CNV",
    "BCDIN3D RNA"
  ],
  "OR6C65": [
    "OR6C65 CNV",
    "OR6C65 RNA"
  ],
  "RPL23AP86": [
    "RPL23AP86 CNV",
    "RPL23AP86 RNA"
  ],
  "ASH2LP2": [
    "ASH2LP2 CNV",
    "ASH2LP2 RNA"
  ],
  "CETN4P": [
    "CETN4P CNV",
    "CETN4P RNA"
  ],
  "VN1R3": [
    "VN1R3 CNV",
    "VN1R3 RNA"
  ],
  "TNFRSF11A": [
    "TNFRSF11A CNV",
    "TNFRSF11A RNA"
  ],
  "FNDC5": [
    "FNDC5 CNV",
    "FNDC5 RNA"
  ],
  "ABCF1": [
    "ABCF1 CNV",
    "ABCF1 RNA",
    "ABCF1 Proteo"
  ],
  "EPB41L2": [
    "EPB41L2 CNV",
    "EPB41L2 RNA",
    "EPB41L2 Proteo"
  ],
  "TIGD1": [
    "TIGD1 CNV",
    "TIGD1 RNA"
  ],
  "IGLV7-43": [
    "IGLV7-43 Proteo"
  ],
  "DRAM1": [
    "DRAM1 CNV",
    "DRAM1 RNA"
  ],
  "HNRNPC": [
    "HNRNPC CNV",
    "HNRNPC RNA",
    "HNRNPC Proteo"
  ],
  "APOOP3": [
    "APOOP3 CNV",
    "APOOP3 RNA"
  ],
  "CCDC187": [
    "CCDC187 CNV",
    "CCDC187 RNA"
  ],
  "VIM": [
    "VIM CNV",
    "VIM RNA",
    "VIM Proteo"
  ],
  "KCNAB2": [
    "KCNAB2 CNV",
    "KCNAB2 RNA",
    "KCNAB2 Proteo"
  ],
  "RPS2P5": [
    "RPS2P5 CNV",
    "RPS2P5 RNA"
  ],
  "PARL": [
    "PARL CNV",
    "PARL RNA",
    "PARL Proteo"
  ],
  "REXO1L9P": [
    "REXO1L9P CNV",
    "REXO1L9P RNA"
  ],
  "TRIM51DP": [
    "TRIM51DP CNV",
    "TRIM51DP RNA"
  ],
  "RPS29P26": [
    "RPS29P26 CNV",
    "RPS29P26 RNA"
  ],
  "VN1R79P": [
    "VN1R79P CNV",
    "VN1R79P RNA"
  ],
  "RPL21P37": [
    "RPL21P37 CNV",
    "RPL21P37 RNA"
  ],
  "MYO5BP3": [
    "MYO5BP3 CNV",
    "MYO5BP3 RNA"
  ],
  "GNG2": [
    "GNG2 CNV",
    "GNG2 RNA",
    "GNG2 Proteo"
  ],
  "CCDC34": [
    "CCDC34 CNV",
    "CCDC34 RNA",
    "CCDC34 Proteo"
  ],
  "BCRP6": [
    "BCRP6 CNV",
    "BCRP6 RNA"
  ],
  "TUBB4BP7": [
    "TUBB4BP7 CNV",
    "TUBB4BP7 RNA"
  ],
  "STK16P1": [
    "STK16P1 CNV",
    "STK16P1 RNA"
  ],
  "CBX3P4": [
    "CBX3P4 CNV",
    "CBX3P4 RNA"
  ],
  "IGKV1OR2-3": [
    "IGKV1OR2-3 CNV",
    "IGKV1OR2-3 RNA"
  ],
  "EIF4BP5": [
    "EIF4BP5 CNV",
    "EIF4BP5 RNA"
  ],
  "DHX38": [
    "DHX38 CNV",
    "DHX38 RNA",
    "DHX38 Proteo"
  ],
  "C5orf34": [
    "C5orf34 CNV",
    "C5orf34 RNA"
  ],
  "ELMOD1": [
    "ELMOD1 CNV",
    "ELMOD1 RNA"
  ],
  "RNA5SP315": [
    "RNA5SP315 CNV",
    "RNA5SP315 RNA"
  ],
  "POR": [
    "POR CNV",
    "POR RNA",
    "POR Proteo"
  ],
  "RPL12P36": [
    "RPL12P36 CNV",
    "RPL12P36 RNA"
  ],
  "TBC1D3B": [
    "TBC1D3B CNV",
    "TBC1D3B RNA"
  ],
  "CLIP3": [
    "CLIP3 CNV",
    "CLIP3 RNA"
  ],
  "SNX25": [
    "SNX25 CNV",
    "SNX25 RNA",
    "SNX25 Proteo"
  ],
  "EPN1": [
    "EPN1 CNV",
    "EPN1 RNA",
    "EPN1 Proteo"
  ],
  "TRIM51EP": [
    "TRIM51EP CNV",
    "TRIM51EP RNA"
  ],
  "OR1F1": [
    "OR1F1 CNV",
    "OR1F1 RNA"
  ],
  "IGFL2": [
    "IGFL2 CNV",
    "IGFL2 RNA"
  ],
  "NUP62": [
    "NUP62 CNV",
    "NUP62 RNA",
    "NUP62 Proteo"
  ],
  "ATL2": [
    "ATL2 CNV",
    "ATL2 RNA",
    "ATL2 Proteo"
  ],
  "SUMO3": [
    "SUMO3 CNV",
    "SUMO3 RNA",
    "SUMO3 Proteo"
  ],
  "MACROD2": [
    "MACROD2 CNV",
    "MACROD2 RNA",
    "MACROD2 Proteo"
  ],
  "RP2": [
    "RP2 CNV",
    "RP2 RNA",
    "RP2 Proteo"
  ],
  "ZFYVE27": [
    "ZFYVE27 CNV",
    "ZFYVE27 RNA",
    "ZFYVE27 Proteo"
  ],
  "OR6T1": [
    "OR6T1 CNV",
    "OR6T1 RNA"
  ],
  "OCA2": [
    "OCA2 CNV",
    "OCA2 RNA",
    "OCA2 Proteo"
  ],
  "RPS6KB2": [
    "RPS6KB2 CNV",
    "RPS6KB2 RNA",
    "RPS6KB2 Proteo"
  ],
  "NOSIP": [
    "NOSIP CNV",
    "NOSIP RNA",
    "NOSIP Proteo"
  ],
  "ROPN1B": [
    "ROPN1B CNV",
    "ROPN1B RNA"
  ],
  "TCEAL9": [
    "TCEAL9 CNV",
    "TCEAL9 RNA",
    "TCEAL9 Proteo"
  ],
  "RPS26P49": [
    "RPS26P49 CNV",
    "RPS26P49 RNA"
  ],
  "DNM1P47": [
    "DNM1P47 CNV",
    "DNM1P47 RNA"
  ],
  "MTCYBP6": [
    "MTCYBP6 CNV",
    "MTCYBP6 RNA"
  ],
  "TMEM53": [
    "TMEM53 CNV",
    "TMEM53 RNA",
    "TMEM53 Proteo"
  ],
  "RBM46": [
    "RBM46 CNV",
    "RBM46 RNA"
  ],
  "OR10G4": [
    "OR10G4 CNV",
    "OR10G4 RNA"
  ],
  "BOD1L1": [
    "BOD1L1 CNV",
    "BOD1L1 RNA",
    "BOD1L1 Proteo"
  ],
  "GUCA1C": [
    "GUCA1C CNV",
    "GUCA1C RNA"
  ],
  "CD38": [
    "CD38 CNV",
    "CD38 RNA",
    "CD38 Proteo"
  ],
  "SNU13": [
    "SNU13 CNV",
    "SNU13 RNA",
    "SNU13 Proteo"
  ],
  "ZFHX2": [
    "ZFHX2 CNV",
    "ZFHX2 RNA"
  ],
  "MGAT2P2": [
    "MGAT2P2 CNV",
    "MGAT2P2 RNA"
  ],
  "DICER1": [
    "DICER1 CNV",
    "DICER1 RNA",
    "DICER1 Proteo"
  ],
  "PLSCR3": [
    "PLSCR3 CNV",
    "PLSCR3 RNA",
    "PLSCR3 Proteo"
  ],
  "OS9": [
    "OS9 CNV",
    "OS9 RNA",
    "OS9 Proteo"
  ],
  "YY1P2": [
    "YY1P2 CNV",
    "YY1P2 RNA"
  ],
  "RPS26P34": [
    "RPS26P34 CNV",
    "RPS26P34 RNA"
  ],
  "GMEB1": [
    "GMEB1 CNV",
    "GMEB1 RNA",
    "GMEB1 Proteo"
  ],
  "USP17L3": [
    "USP17L3 CNV",
    "USP17L3 RNA"
  ],
  "PLCE1P1": [
    "PLCE1P1 CNV",
    "PLCE1P1 RNA"
  ],
  "ADGRE4P": [
    "ADGRE4P CNV",
    "ADGRE4P RNA"
  ],
  "LY6H": [
    "LY6H CNV",
    "LY6H RNA"
  ],
  "MROH6": [
    "MROH6 CNV",
    "MROH6 RNA"
  ],
  "SNRPEP7": [
    "SNRPEP7 CNV",
    "SNRPEP7 RNA"
  ],
  "IGIP": [
    "IGIP CNV",
    "IGIP RNA"
  ],
  "NDUFAF4P4": [
    "NDUFAF4P4 CNV",
    "NDUFAF4P4 RNA"
  ],
  "SAXO2": [
    "SAXO2 CNV",
    "SAXO2 RNA"
  ],
  "SNX18P2": [
    "SNX18P2 CNV",
    "SNX18P2 RNA"
  ],
  "TLCD5": [
    "TLCD5 CNV",
    "TLCD5 RNA"
  ],
  "ATP5F1E": [
    "ATP5F1E CNV",
    "ATP5F1E RNA",
    "ATP5F1E Proteo"
  ],
  "NCBP2L": [
    "NCBP2L CNV",
    "NCBP2L RNA"
  ],
  "LGALS9B": [
    "LGALS9B CNV",
    "LGALS9B RNA"
  ],
  "IRX3": [
    "IRX3 CNV",
    "IRX3 RNA"
  ],
  "RDXP1": [
    "RDXP1 CNV",
    "RDXP1 RNA"
  ],
  "SEPTIN7P14": [
    "SEPTIN7P14 CNV",
    "SEPTIN7P14 RNA"
  ],
  "OR2B6": [
    "OR2B6 CNV",
    "OR2B6 RNA"
  ],
  "H4C7": [
    "H4C7 CNV",
    "H4C7 RNA",
    "H4C7 Proteo"
  ],
  "SMC3": [
    "SMC3 CNV",
    "SMC3 RNA",
    "SMC3 Proteo"
  ],
  "MTFR1P1": [
    "MTFR1P1 CNV",
    "MTFR1P1 RNA"
  ],
  "BNIP3P17": [
    "BNIP3P17 CNV",
    "BNIP3P17 RNA"
  ],
  "ZNF660": [
    "ZNF660 CNV",
    "ZNF660 RNA"
  ],
  "PMEL": [
    "PMEL CNV",
    "PMEL RNA",
    "PMEL Proteo"
  ],
  "RS1": [
    "RS1 CNV",
    "RS1 RNA"
  ],
  "WASF1P1": [
    "WASF1P1 CNV",
    "WASF1P1 RNA"
  ],
  "TRIM17": [
    "TRIM17 CNV",
    "TRIM17 RNA"
  ],
  "PPRC1": [
    "PPRC1 CNV",
    "PPRC1 RNA",
    "PPRC1 Proteo"
  ],
  "OTULIN": [
    "OTULIN CNV",
    "OTULIN RNA",
    "OTULIN Proteo"
  ],
  "VIPR1": [
    "VIPR1 CNV",
    "VIPR1 RNA"
  ],
  "NALCN": [
    "NALCN CNV",
    "NALCN RNA"
  ],
  "CTNS": [
    "CTNS CNV",
    "CTNS RNA"
  ],
  "STK17A": [
    "STK17A CNV",
    "STK17A RNA",
    "STK17A Proteo"
  ],
  "DLGAP5": [
    "DLGAP5 CNV",
    "DLGAP5 RNA",
    "DLGAP5 Proteo"
  ],
  "SPAG11A": [
    "SPAG11A CNV",
    "SPAG11A RNA"
  ],
  "SH2D1B": [
    "SH2D1B CNV",
    "SH2D1B RNA"
  ],
  "DLG2": [
    "DLG2 CNV",
    "DLG2 RNA",
    "DLG2 Proteo"
  ],
  "FRMPD2B": [
    "FRMPD2B CNV",
    "FRMPD2B RNA"
  ],
  "SHROOM3": [
    "SHROOM3 CNV",
    "SHROOM3 RNA",
    "SHROOM3 Proteo"
  ],
  "RPL15P20": [
    "RPL15P20 CNV",
    "RPL15P20 RNA"
  ],
  "COX17P1": [
    "COX17P1 CNV",
    "COX17P1 RNA"
  ],
  "RPL23P4": [
    "RPL23P4 CNV",
    "RPL23P4 RNA"
  ],
  "C2orf72": [
    "C2orf72 CNV",
    "C2orf72 RNA",
    "C2orf72 Proteo"
  ],
  "RPL3P12": [
    "RPL3P12 CNV",
    "RPL3P12 RNA"
  ],
  "UAP1L1": [
    "UAP1L1 CNV",
    "UAP1L1 RNA",
    "UAP1L1 Proteo"
  ],
  "KRT8P43": [
    "KRT8P43 CNV",
    "KRT8P43 RNA"
  ],
  "SEC61GP1": [
    "SEC61GP1 CNV",
    "SEC61GP1 RNA"
  ],
  "MT-ND4": [
    "MT-ND4 RNA",
    "MT-ND4 Proteo"
  ],
  "ZNF184": [
    "ZNF184 CNV",
    "ZNF184 RNA",
    "ZNF184 Proteo"
  ],
  "RNF123": [
    "RNF123 CNV",
    "RNF123 RNA",
    "RNF123 Proteo"
  ],
  "IFIT5": [
    "IFIT5 CNV",
    "IFIT5 RNA",
    "IFIT5 Proteo"
  ],
  "RASSF9": [
    "RASSF9 CNV",
    "RASSF9 RNA"
  ],
  "NDUFA5P3": [
    "NDUFA5P3 CNV",
    "NDUFA5P3 RNA"
  ],
  "KIR3DP1": [
    "KIR3DP1 CNV",
    "KIR3DP1 RNA"
  ],
  "KRT4": [
    "KRT4 CNV",
    "KRT4 RNA",
    "KRT4 Proteo"
  ],
  "INTS15": [
    "INTS15 CNV",
    "INTS15 RNA",
    "INTS15 Proteo"
  ],
  "H4C6": [
    "H4C6 CNV",
    "H4C6 RNA",
    "H4C6 Proteo"
  ],
  "STX16": [
    "STX16 CNV",
    "STX16 RNA",
    "STX16 Proteo"
  ],
  "SLC5A11": [
    "SLC5A11 CNV",
    "SLC5A11 RNA"
  ],
  "LCA5": [
    "LCA5 CNV",
    "LCA5 RNA",
    "LCA5 Proteo"
  ],
  "SCRT1": [
    "SCRT1 CNV",
    "SCRT1 RNA"
  ],
  "ISG20": [
    "ISG20 CNV",
    "ISG20 RNA",
    "ISG20 Proteo"
  ],
  "ZNF32": [
    "ZNF32 CNV",
    "ZNF32 RNA",
    "ZNF32 Proteo"
  ],
  "PPP4R3B": [
    "PPP4R3B CNV",
    "PPP4R3B RNA",
    "PPP4R3B Proteo"
  ],
  "VGF": [
    "VGF CNV",
    "VGF RNA",
    "VGF Proteo"
  ],
  "PAX7": [
    "PAX7 CNV",
    "PAX7 RNA"
  ],
  "RPL7AP46": [
    "RPL7AP46 CNV",
    "RPL7AP46 RNA"
  ],
  "ZZZ3": [
    "ZZZ3 CNV",
    "ZZZ3 RNA",
    "ZZZ3 Proteo"
  ],
  "RNA5SP219": [
    "RNA5SP219 CNV",
    "RNA5SP219 RNA"
  ],
  "WFIKKN1": [
    "WFIKKN1 CNV",
    "WFIKKN1 RNA"
  ],
  "ZNF772": [
    "ZNF772 CNV",
    "ZNF772 RNA"
  ],
  "OTUD4P1": [
    "OTUD4P1 CNV",
    "OTUD4P1 RNA"
  ],
  "FNIP1": [
    "FNIP1 CNV",
    "FNIP1 RNA",
    "FNIP1 Proteo"
  ],
  "WDR93": [
    "WDR93 CNV",
    "WDR93 RNA"
  ],
  "SYT15": [
    "SYT15 CNV",
    "SYT15 RNA"
  ],
  "DNAH11": [
    "DNAH11 CNV",
    "DNAH11 RNA"
  ],
  "EFCAB5": [
    "EFCAB5 CNV",
    "EFCAB5 RNA"
  ],
  "AGPAT3": [
    "AGPAT3 CNV",
    "AGPAT3 RNA",
    "AGPAT3 Proteo"
  ],
  "RHCG": [
    "RHCG CNV",
    "RHCG RNA",
    "RHCG Proteo"
  ],
  "LRRC56": [
    "LRRC56 CNV",
    "LRRC56 RNA"
  ],
  "RPS29P10": [
    "RPS29P10 CNV",
    "RPS29P10 RNA"
  ],
  "IRAK1BP1": [
    "IRAK1BP1 CNV",
    "IRAK1BP1 RNA"
  ],
  "RPL7P41": [
    "RPL7P41 CNV",
    "RPL7P41 RNA"
  ],
  "RPL23AP84": [
    "RPL23AP84 CNV",
    "RPL23AP84 RNA"
  ],
  "TSPY23P": [
    "TSPY23P CNV",
    "TSPY23P RNA"
  ],
  "ATP5MF": [
    "ATP5MF CNV",
    "ATP5MF RNA",
    "ATP5MF Proteo"
  ],
  "SAP130": [
    "SAP130 CNV",
    "SAP130 RNA",
    "SAP130 Proteo"
  ],
  "RNA5SP518": [
    "RNA5SP518 CNV",
    "RNA5SP518 RNA"
  ],
  "H2BC15": [
    "H2BC15 CNV",
    "H2BC15 RNA"
  ],
  "ZBTB34": [
    "ZBTB34 CNV",
    "ZBTB34 RNA",
    "ZBTB34 Proteo"
  ],
  "NABP1": [
    "NABP1 CNV",
    "NABP1 RNA",
    "NABP1 Proteo"
  ],
  "BRAFP1": [
    "BRAFP1 CNV",
    "BRAFP1 RNA"
  ],
  "MTCO1P1": [
    "MTCO1P1 CNV",
    "MTCO1P1 RNA"
  ],
  "C11orf97": [
    "C11orf97 CNV",
    "C11orf97 RNA"
  ],
  "FAT1P1": [
    "FAT1P1 CNV",
    "FAT1P1 RNA"
  ],
  "CCDC60": [
    "CCDC60 CNV",
    "CCDC60 RNA"
  ],
  "EFNA4": [
    "EFNA4 CNV",
    "EFNA4 RNA"
  ],
  "SPO11": [
    "SPO11 CNV",
    "SPO11 RNA"
  ],
  "KLF2P3": [
    "KLF2P3 CNV",
    "KLF2P3 RNA"
  ],
  "SMU1": [
    "SMU1 CNV",
    "SMU1 RNA",
    "SMU1 Proteo"
  ],
  "NEFM": [
    "NEFM CNV",
    "NEFM RNA",
    "NEFM Proteo"
  ],
  "TEX48": [
    "TEX48 CNV",
    "TEX48 RNA"
  ],
  "DPPA3P2": [
    "DPPA3P2 CNV",
    "DPPA3P2 RNA"
  ],
  "TOP3A": [
    "TOP3A CNV",
    "TOP3A RNA",
    "TOP3A Proteo"
  ],
  "PLD6": [
    "PLD6 CNV",
    "PLD6 RNA",
    "PLD6 Proteo"
  ],
  "CST8": [
    "CST8 CNV",
    "CST8 RNA"
  ],
  "RNA5SP399": [
    "RNA5SP399 CNV",
    "RNA5SP399 RNA"
  ],
  "H4C11": [
    "H4C11 CNV",
    "H4C11 RNA"
  ],
  "BLOC1S6": [
    "BLOC1S6 CNV",
    "BLOC1S6 RNA",
    "BLOC1S6 Proteo"
  ],
  "RPL23AP94": [
    "RPL23AP94 CNV",
    "RPL23AP94 RNA"
  ],
  "CA4": [
    "CA4 CNV",
    "CA4 RNA",
    "CA4 Proteo"
  ],
  "TMPPE": [
    "TMPPE CNV",
    "TMPPE RNA",
    "TMPPE Proteo"
  ],
  "HINT1P2": [
    "HINT1P2 CNV",
    "HINT1P2 RNA"
  ],
  "AQP6": [
    "AQP6 CNV",
    "AQP6 RNA"
  ],
  "RARG": [
    "RARG CNV",
    "RARG RNA"
  ],
  "CTAGE16P": [
    "CTAGE16P CNV",
    "CTAGE16P RNA"
  ],
  "ST13P2": [
    "ST13P2 CNV",
    "ST13P2 RNA"
  ],
  "CDC42P6": [
    "CDC42P6 CNV",
    "CDC42P6 RNA"
  ],
  "FAM8A4P": [
    "FAM8A4P CNV",
    "FAM8A4P RNA"
  ],
  "FMO6P": [
    "FMO6P CNV",
    "FMO6P RNA"
  ],
  "NPIPA5": [
    "NPIPA5 CNV",
    "NPIPA5 RNA"
  ],
  "OGFOD3": [
    "OGFOD3 CNV",
    "OGFOD3 RNA",
    "OGFOD3 Proteo"
  ],
  "BICD1P1": [
    "BICD1P1 CNV",
    "BICD1P1 RNA"
  ],
  "PHC3": [
    "PHC3 CNV",
    "PHC3 RNA",
    "PHC3 Proteo"
  ],
  "RHBDL3": [
    "RHBDL3 CNV",
    "RHBDL3 RNA"
  ],
  "GCHFR": [
    "GCHFR CNV",
    "GCHFR RNA",
    "GCHFR Proteo"
  ],
  "ZNF579": [
    "ZNF579 CNV",
    "ZNF579 RNA",
    "ZNF579 Proteo"
  ],
  "MYB": [
    "MYB CNV",
    "MYB RNA",
    "MYB Proteo"
  ],
  "MTIF2P1": [
    "MTIF2P1 CNV",
    "MTIF2P1 RNA"
  ],
  "KCTD20": [
    "KCTD20 CNV",
    "KCTD20 RNA",
    "KCTD20 Proteo"
  ],
  "SRSF10P1": [
    "SRSF10P1 CNV",
    "SRSF10P1 RNA"
  ],
  "EEF1GP4": [
    "EEF1GP4 CNV",
    "EEF1GP4 RNA"
  ],
  "PTP4A1P5": [
    "PTP4A1P5 CNV",
    "PTP4A1P5 RNA"
  ],
  "CDH20": [
    "CDH20 CNV",
    "CDH20 RNA"
  ],
  "SPATA6L": [
    "SPATA6L CNV",
    "SPATA6L RNA"
  ],
  "CALCOCO2": [
    "CALCOCO2 CNV",
    "CALCOCO2 RNA",
    "CALCOCO2 Proteo"
  ],
  "FATE1": [
    "FATE1 CNV",
    "FATE1 RNA"
  ],
  "IWS1": [
    "IWS1 CNV",
    "IWS1 RNA",
    "IWS1 Proteo"
  ],
  "MAPKAP1": [
    "MAPKAP1 CNV",
    "MAPKAP1 RNA",
    "MAPKAP1 Proteo"
  ],
  "FGGY": [
    "FGGY CNV",
    "FGGY RNA",
    "FGGY Proteo"
  ],
  "SPDYE12": [
    "SPDYE12 CNV",
    "SPDYE12 RNA"
  ],
  "KIF18B": [
    "KIF18B CNV",
    "KIF18B RNA",
    "KIF18B Proteo"
  ],
  "RNA5SP375": [
    "RNA5SP375 CNV",
    "RNA5SP375 RNA"
  ],
  "COX20": [
    "COX20 CNV",
    "COX20 RNA",
    "COX20 Proteo"
  ],
  "HSPA8P1": [
    "HSPA8P1 CNV",
    "HSPA8P1 RNA"
  ],
  "PRR22": [
    "PRR22 CNV",
    "PRR22 RNA"
  ],
  "FPGS": [
    "FPGS CNV",
    "FPGS RNA",
    "FPGS Proteo"
  ],
  "NUP93": [
    "NUP93 CNV",
    "NUP93 RNA",
    "NUP93 Proteo"
  ],
  "LETMD1": [
    "LETMD1 CNV",
    "LETMD1 RNA",
    "LETMD1 Proteo"
  ],
  "THOC3": [
    "THOC3 CNV",
    "THOC3 RNA",
    "THOC3 Proteo"
  ],
  "SNURF": [
    "SNURF CNV",
    "SNURF RNA"
  ],
  "MRPL45P1": [
    "MRPL45P1 CNV",
    "MRPL45P1 RNA"
  ],
  "STXBP5": [
    "STXBP5 CNV",
    "STXBP5 RNA",
    "STXBP5 Proteo"
  ],
  "RPL17P46": [
    "RPL17P46 CNV",
    "RPL17P46 RNA"
  ],
  "ZNF587B": [
    "ZNF587B CNV",
    "ZNF587B RNA"
  ],
  "PRPF3": [
    "PRPF3 CNV",
    "PRPF3 RNA",
    "PRPF3 Proteo"
  ],
  "CSPG4P3Y": [
    "CSPG4P3Y CNV",
    "CSPG4P3Y RNA"
  ],
  "LCEP2": [
    "LCEP2 CNV",
    "LCEP2 RNA"
  ],
  "SMIM38": [
    "SMIM38 CNV",
    "SMIM38 RNA"
  ],
  "NPAP1P6": [
    "NPAP1P6 CNV",
    "NPAP1P6 RNA"
  ],
  "ACBD3": [
    "ACBD3 CNV",
    "ACBD3 RNA",
    "ACBD3 Proteo"
  ],
  "UBE2FP3": [
    "UBE2FP3 CNV",
    "UBE2FP3 RNA"
  ],
  "KRTAP9-12P": [
    "KRTAP9-12P CNV",
    "KRTAP9-12P RNA"
  ],
  "PGAP4": [
    "PGAP4 CNV",
    "PGAP4 RNA"
  ],
  "MAP4K4": [
    "MAP4K4 CNV",
    "MAP4K4 RNA",
    "MAP4K4 Proteo"
  ],
  "RPL23AP48": [
    "RPL23AP48 CNV",
    "RPL23AP48 RNA"
  ],
  "DNAH8": [
    "DNAH8 CNV",
    "DNAH8 RNA"
  ],
  "SHLD2P2": [
    "SHLD2P2 CNV",
    "SHLD2P2 RNA"
  ],
  "HMGN2P24": [
    "HMGN2P24 CNV",
    "HMGN2P24 RNA"
  ],
  "DBIP2": [
    "DBIP2 CNV",
    "DBIP2 RNA"
  ],
  "KRTAP5-6": [
    "KRTAP5-6 CNV",
    "KRTAP5-6 RNA"
  ],
  "ELMO2": [
    "ELMO2 CNV",
    "ELMO2 RNA",
    "ELMO2 Proteo"
  ],
  "EMILIN2": [
    "EMILIN2 CNV",
    "EMILIN2 RNA",
    "EMILIN2 Proteo"
  ],
  "ADCY8": [
    "ADCY8 CNV",
    "ADCY8 RNA"
  ],
  "OR1D2": [
    "OR1D2 CNV",
    "OR1D2 RNA"
  ],
  "CPA2": [
    "CPA2 CNV",
    "CPA2 RNA"
  ],
  "CPA5": [
    "CPA5 CNV",
    "CPA5 RNA"
  ],
  "NFKBID": [
    "NFKBID CNV",
    "NFKBID RNA"
  ],
  "EIF3FP1": [
    "EIF3FP1 CNV",
    "EIF3FP1 RNA"
  ],
  "OR4N4C": [
    "OR4N4C CNV",
    "OR4N4C RNA"
  ],
  "CLRN1": [
    "CLRN1 CNV",
    "CLRN1 RNA"
  ],
  "LRRC14": [
    "LRRC14 CNV",
    "LRRC14 RNA",
    "LRRC14 Proteo"
  ],
  "TUSC3": [
    "TUSC3 CNV",
    "TUSC3 RNA",
    "TUSC3 Proteo"
  ],
  "RPS26P55": [
    "RPS26P55 CNV",
    "RPS26P55 RNA"
  ],
  "RBMY1D": [
    "RBMY1D CNV",
    "RBMY1D RNA"
  ],
  "GNAL": [
    "GNAL CNV",
    "GNAL RNA",
    "GNAL Proteo"
  ],
  "ARR3": [
    "ARR3 CNV",
    "ARR3 RNA"
  ],
  "MAS1L": [
    "MAS1L CNV",
    "MAS1L RNA"
  ],
  "PEBP1": [
    "PEBP1 CNV",
    "PEBP1 RNA",
    "PEBP1 Proteo"
  ],
  "OTOP2": [
    "OTOP2 CNV",
    "OTOP2 RNA"
  ],
  "IFNL3P1": [
    "IFNL3P1 CNV",
    "IFNL3P1 RNA"
  ],
  "ASB12": [
    "ASB12 CNV",
    "ASB12 RNA"
  ],
  "INCENP": [
    "INCENP CNV",
    "INCENP RNA",
    "INCENP Proteo"
  ],
  "RPL34P33": [
    "RPL34P33 CNV",
    "RPL34P33 RNA"
  ],
  "PHLDA1": [
    "PHLDA1 CNV",
    "PHLDA1 RNA",
    "PHLDA1 Proteo"
  ],
  "ESPNL": [
    "ESPNL CNV",
    "ESPNL RNA"
  ],
  "ADIPOR1P2": [
    "ADIPOR1P2 CNV",
    "ADIPOR1P2 RNA"
  ],
  "NPM1P47": [
    "NPM1P47 CNV",
    "NPM1P47 RNA"
  ],
  "ALG5": [
    "ALG5 CNV",
    "ALG5 RNA",
    "ALG5 Proteo"
  ],
  "BDP1": [
    "BDP1 CNV",
    "BDP1 RNA",
    "BDP1 Proteo"
  ],
  "CNTNAP1": [
    "CNTNAP1 CNV",
    "CNTNAP1 RNA",
    "CNTNAP1 Proteo"
  ],
  "YY1": [
    "YY1 CNV",
    "YY1 RNA",
    "YY1 Proteo"
  ],
  "PLP1": [
    "PLP1 CNV",
    "PLP1 RNA",
    "PLP1 Proteo"
  ],
  "ZNF646": [
    "ZNF646 CNV",
    "ZNF646 RNA",
    "ZNF646 Proteo"
  ],
  "APOBEC3G": [
    "APOBEC3G CNV",
    "APOBEC3G RNA",
    "APOBEC3G Proteo"
  ],
  "AMFR": [
    "AMFR CNV",
    "AMFR RNA",
    "AMFR Proteo"
  ],
  "POC1A": [
    "POC1A CNV",
    "POC1A RNA",
    "POC1A Proteo"
  ],
  "IFITM9P": [
    "IFITM9P CNV",
    "IFITM9P RNA"
  ],
  "GXYLT1P4": [
    "GXYLT1P4 CNV",
    "GXYLT1P4 RNA"
  ],
  "SNX12": [
    "SNX12 CNV",
    "SNX12 RNA",
    "SNX12 Proteo"
  ],
  "ABHD13": [
    "ABHD13 CNV",
    "ABHD13 RNA",
    "ABHD13 Proteo"
  ],
  "MMP16": [
    "MMP16 CNV",
    "MMP16 RNA"
  ],
  "CTAGE10P": [
    "CTAGE10P CNV",
    "CTAGE10P RNA"
  ],
  "RPS17P17": [
    "RPS17P17 CNV",
    "RPS17P17 RNA"
  ],
  "HIPK1": [
    "HIPK1 CNV",
    "HIPK1 RNA"
  ],
  "ARL8A": [
    "ARL8A CNV",
    "ARL8A RNA",
    "ARL8A Proteo"
  ],
  "GUCD1": [
    "GUCD1 CNV",
    "GUCD1 RNA",
    "GUCD1 Proteo"
  ],
  "STMN1P2": [
    "STMN1P2 CNV",
    "STMN1P2 RNA"
  ],
  "BICD2": [
    "BICD2 CNV",
    "BICD2 RNA",
    "BICD2 Proteo"
  ],
  "DNAJC6": [
    "DNAJC6 CNV",
    "DNAJC6 RNA",
    "DNAJC6 Proteo"
  ],
  "HSPD1P21": [
    "HSPD1P21 CNV",
    "HSPD1P21 RNA"
  ],
  "SHISAL2B": [
    "SHISAL2B CNV",
    "SHISAL2B RNA"
  ],
  "S100A11P1": [
    "S100A11P1 CNV",
    "S100A11P1 RNA"
  ],
  "ASXL3": [
    "ASXL3 CNV",
    "ASXL3 RNA"
  ],
  "NUS1P4": [
    "NUS1P4 CNV",
    "NUS1P4 RNA"
  ],
  "COG7": [
    "COG7 CNV",
    "COG7 RNA",
    "COG7 Proteo"
  ],
  "ZIK1": [
    "ZIK1 CNV",
    "ZIK1 RNA"
  ],
  "LRRC20": [
    "LRRC20 CNV",
    "LRRC20 RNA",
    "LRRC20 Proteo"
  ],
  "MYO5BP2": [
    "MYO5BP2 CNV",
    "MYO5BP2 RNA"
  ],
  "ACTG1P11": [
    "ACTG1P11 CNV",
    "ACTG1P11 RNA"
  ],
  "DAP3P2": [
    "DAP3P2 CNV",
    "DAP3P2 RNA"
  ],
  "HMGN2P19": [
    "HMGN2P19 CNV",
    "HMGN2P19 RNA"
  ],
  "H2AZP5": [
    "H2AZP5 CNV",
    "H2AZP5 RNA"
  ],
  "DHX37": [
    "DHX37 CNV",
    "DHX37 RNA",
    "DHX37 Proteo"
  ],
  "CIBAR1": [
    "CIBAR1 CNV",
    "CIBAR1 RNA",
    "CIBAR1 Proteo"
  ],
  "KCNE5": [
    "KCNE5 CNV",
    "KCNE5 RNA"
  ],
  "TMEM209": [
    "TMEM209 CNV",
    "TMEM209 RNA",
    "TMEM209 Proteo"
  ],
  "EPN3": [
    "EPN3 CNV",
    "EPN3 RNA"
  ],
  "USP53": [
    "USP53 CNV",
    "USP53 RNA",
    "USP53 Proteo"
  ],
  "SIAH3": [
    "SIAH3 CNV",
    "SIAH3 RNA"
  ],
  "MTCO1P24": [
    "MTCO1P24 CNV",
    "MTCO1P24 RNA"
  ],
  "KCNMB3P1": [
    "KCNMB3P1 CNV",
    "KCNMB3P1 RNA"
  ],
  "SSPN": [
    "SSPN CNV",
    "SSPN RNA"
  ],
  "RPL18A": [
    "RPL18A CNV",
    "RPL18A RNA",
    "RPL18A Proteo"
  ],
  "LCN8": [
    "LCN8 CNV",
    "LCN8 RNA"
  ],
  "EIF1P6": [
    "EIF1P6 CNV",
    "EIF1P6 RNA"
  ],
  "ZNF710": [
    "ZNF710 CNV",
    "ZNF710 RNA",
    "ZNF710 Proteo"
  ],
  "NR2E3": [
    "NR2E3 CNV",
    "NR2E3 RNA"
  ],
  "RCN1P2": [
    "RCN1P2 CNV",
    "RCN1P2 RNA"
  ],
  "BTN2A2": [
    "BTN2A2 CNV",
    "BTN2A2 RNA",
    "BTN2A2 Proteo"
  ],
  "NEUROD1": [
    "NEUROD1 CNV",
    "NEUROD1 RNA"
  ],
  "KMT2D": [
    "KMT2D CNV",
    "KMT2D RNA",
    "KMT2D Proteo"
  ],
  "UPRT": [
    "UPRT CNV",
    "UPRT RNA",
    "UPRT Proteo"
  ],
  "ABCC11": [
    "ABCC11 CNV",
    "ABCC11 RNA"
  ],
  "SHCBP1": [
    "SHCBP1 CNV",
    "SHCBP1 RNA",
    "SHCBP1 Proteo"
  ],
  "DDTL": [
    "DDTL CNV",
    "DDTL RNA"
  ],
  "FANCB": [
    "FANCB CNV",
    "FANCB RNA",
    "FANCB Proteo"
  ],
  "TMEM218": [
    "TMEM218 CNV",
    "TMEM218 RNA"
  ],
  "CENPC": [
    "CENPC CNV",
    "CENPC RNA",
    "CENPC Proteo"
  ],
  "FBP2P1": [
    "FBP2P1 CNV",
    "FBP2P1 RNA"
  ],
  "ARMC10P1": [
    "ARMC10P1 CNV",
    "ARMC10P1 RNA"
  ],
  "MRGPRG": [
    "MRGPRG CNV",
    "MRGPRG RNA"
  ],
  "MYO19": [
    "MYO19 CNV",
    "MYO19 RNA",
    "MYO19 Proteo"
  ],
  "ANTXR2": [
    "ANTXR2 CNV",
    "ANTXR2 RNA",
    "ANTXR2 Proteo"
  ],
  "ZNF502": [
    "ZNF502 CNV",
    "ZNF502 RNA"
  ],
  "ZFP90": [
    "ZFP90 CNV",
    "ZFP90 RNA"
  ],
  "RBMXP1": [
    "RBMXP1 CNV",
    "RBMXP1 RNA"
  ],
  "ATPSCKMT": [
    "ATPSCKMT CNV",
    "ATPSCKMT RNA",
    "ATPSCKMT Proteo"
  ],
  "CNOT7P2": [
    "CNOT7P2 CNV",
    "CNOT7P2 RNA"
  ],
  "RPL21P112": [
    "RPL21P112 CNV",
    "RPL21P112 RNA"
  ],
  "NGFR": [
    "NGFR CNV",
    "NGFR RNA",
    "NGFR Proteo"
  ],
  "PPIAP37": [
    "PPIAP37 CNV",
    "PPIAP37 RNA"
  ],
  "XKR8": [
    "XKR8 CNV",
    "XKR8 RNA"
  ],
  "ASXL2": [
    "ASXL2 CNV",
    "ASXL2 RNA",
    "ASXL2 Proteo"
  ],
  "GBGT1": [
    "GBGT1 CNV",
    "GBGT1 RNA"
  ],
  "ERVV-2": [
    "ERVV-2 CNV",
    "ERVV-2 RNA"
  ],
  "ITGAV": [
    "ITGAV CNV",
    "ITGAV RNA",
    "ITGAV Proteo"
  ],
  "MTCO2P31": [
    "MTCO2P31 CNV",
    "MTCO2P31 RNA"
  ],
  "KRT16P4": [
    "KRT16P4 CNV",
    "KRT16P4 RNA"
  ],
  "ZNF503": [
    "ZNF503 CNV",
    "ZNF503 RNA",
    "ZNF503 Proteo"
  ],
  "RNASEH2C": [
    "RNASEH2C CNV",
    "RNASEH2C RNA",
    "RNASEH2C Proteo"
  ],
  "SLX1A": [
    "SLX1A CNV",
    "SLX1A RNA"
  ],
  "BEND3P3": [
    "BEND3P3 CNV",
    "BEND3P3 RNA"
  ],
  "AKR1C7P": [
    "AKR1C7P CNV",
    "AKR1C7P RNA"
  ],
  "ROBO2": [
    "ROBO2 CNV",
    "ROBO2 RNA",
    "ROBO2 Proteo"
  ],
  "HMGB1P49": [
    "HMGB1P49 CNV",
    "HMGB1P49 RNA"
  ],
  "MTND1P17": [
    "MTND1P17 CNV",
    "MTND1P17 RNA"
  ],
  "ZNF672": [
    "ZNF672 CNV",
    "ZNF672 RNA",
    "ZNF672 Proteo"
  ],
  "IER3": [
    "IER3 CNV",
    "IER3 RNA"
  ],
  "ADAM20P2": [
    "ADAM20P2 CNV",
    "ADAM20P2 RNA"
  ],
  "CSNK1G2": [
    "CSNK1G2 CNV",
    "CSNK1G2 RNA",
    "CSNK1G2 Proteo"
  ],
  "IGHVIII-67-2": [
    "IGHVIII-67-2 CNV",
    "IGHVIII-67-2 RNA"
  ],
  "DCDC1": [
    "DCDC1 CNV",
    "DCDC1 RNA"
  ],
  "THAP1": [
    "THAP1 CNV",
    "THAP1 RNA"
  ],
  "DENND5A": [
    "DENND5A CNV",
    "DENND5A RNA",
    "DENND5A Proteo"
  ],
  "UBE2C": [
    "UBE2C CNV",
    "UBE2C RNA",
    "UBE2C Proteo"
  ],
  "FRMD1": [
    "FRMD1 CNV",
    "FRMD1 RNA"
  ],
  "CAMK4": [
    "CAMK4 CNV",
    "CAMK4 RNA",
    "CAMK4 Proteo"
  ],
  "RPL27P12": [
    "RPL27P12 CNV",
    "RPL27P12 RNA"
  ],
  "SELPLG": [
    "SELPLG CNV",
    "SELPLG RNA",
    "SELPLG Proteo"
  ],
  "CLPX": [
    "CLPX CNV",
    "CLPX RNA",
    "CLPX Proteo"
  ],
  "SMAD3": [
    "SMAD3 CNV",
    "SMAD3 RNA",
    "SMAD3 Proteo"
  ],
  "H2BC14": [
    "H2BC14 CNV",
    "H2BC14 RNA"
  ],
  "LRRC31": [
    "LRRC31 CNV",
    "LRRC31 RNA"
  ],
  "PET117": [
    "PET117 CNV",
    "PET117 RNA",
    "PET117 Proteo"
  ],
  "OR10AG1": [
    "OR10AG1 CNV",
    "OR10AG1 RNA"
  ],
  "CREB3L1": [
    "CREB3L1 CNV",
    "CREB3L1 RNA"
  ],
  "ACO2": [
    "ACO2 CNV",
    "ACO2 RNA",
    "ACO2 Proteo"
  ],
  "YBX2": [
    "YBX2 CNV",
    "YBX2 RNA",
    "YBX2 Proteo"
  ],
  "ATP8B3": [
    "ATP8B3 CNV",
    "ATP8B3 RNA"
  ],
  "KRT16P5": [
    "KRT16P5 CNV",
    "KRT16P5 RNA"
  ],
  "MGAT4A": [
    "MGAT4A CNV",
    "MGAT4A RNA",
    "MGAT4A Proteo"
  ],
  "TIAM1": [
    "TIAM1 CNV",
    "TIAM1 RNA",
    "TIAM1 Proteo"
  ],
  "KCNQ2": [
    "KCNQ2 CNV",
    "KCNQ2 RNA"
  ],
  "LDLRAD1": [
    "LDLRAD1 CNV",
    "LDLRAD1 RNA"
  ],
  "PKP4P1": [
    "PKP4P1 CNV",
    "PKP4P1 RNA"
  ],
  "SLC29A2": [
    "SLC29A2 CNV",
    "SLC29A2 RNA",
    "SLC29A2 Proteo"
  ],
  "POF1B": [
    "POF1B CNV",
    "POF1B RNA",
    "POF1B Proteo"
  ],
  "KRTAP21-4P": [
    "KRTAP21-4P CNV",
    "KRTAP21-4P RNA"
  ],
  "KRT8P51": [
    "KRT8P51 CNV",
    "KRT8P51 RNA"
  ],
  "TREML4": [
    "TREML4 CNV",
    "TREML4 RNA"
  ],
  "RPL7AP27": [
    "RPL7AP27 CNV",
    "RPL7AP27 RNA"
  ],
  "TIMM21": [
    "TIMM21 CNV",
    "TIMM21 RNA",
    "TIMM21 Proteo"
  ],
  "SIRT2": [
    "SIRT2 CNV",
    "SIRT2 RNA",
    "SIRT2 Proteo"
  ],
  "URM1": [
    "URM1 CNV",
    "URM1 RNA",
    "URM1 Proteo"
  ],
  "NECTIN3": [
    "NECTIN3 CNV",
    "NECTIN3 RNA",
    "NECTIN3 Proteo"
  ],
  "BEST3": [
    "BEST3 CNV",
    "BEST3 RNA"
  ],
  "TRAPPC2P4": [
    "TRAPPC2P4 CNV",
    "TRAPPC2P4 RNA"
  ],
  "PDIA2": [
    "PDIA2 CNV",
    "PDIA2 RNA",
    "PDIA2 Proteo"
  ],
  "TLX3": [
    "TLX3 CNV",
    "TLX3 RNA"
  ],
  "ZDHHC16": [
    "ZDHHC16 CNV",
    "ZDHHC16 RNA",
    "ZDHHC16 Proteo"
  ],
  "SGCA": [
    "SGCA CNV",
    "SGCA RNA"
  ],
  "MYPN": [
    "MYPN CNV",
    "MYPN RNA"
  ],
  "PDK4": [
    "PDK4 CNV",
    "PDK4 RNA",
    "PDK4 Proteo"
  ],
  "KIAA0040": [
    "KIAA0040 CNV",
    "KIAA0040 RNA"
  ],
  "ANKS1B": [
    "ANKS1B CNV",
    "ANKS1B RNA"
  ],
  "LRRC53": [
    "LRRC53 CNV",
    "LRRC53 RNA"
  ],
  "RPS27AP17": [
    "RPS27AP17 CNV",
    "RPS27AP17 RNA"
  ],
  "LONRF2P2": [
    "LONRF2P2 CNV",
    "LONRF2P2 RNA"
  ],
  "SPRR2F": [
    "SPRR2F CNV",
    "SPRR2F RNA"
  ],
  "DPPA2P2": [
    "DPPA2P2 CNV",
    "DPPA2P2 RNA"
  ],
  "ABCA3": [
    "ABCA3 CNV",
    "ABCA3 RNA",
    "ABCA3 Proteo"
  ],
  "ABCC5": [
    "ABCC5 CNV",
    "ABCC5 RNA",
    "ABCC5 Proteo"
  ],
  "FIBP": [
    "FIBP CNV",
    "FIBP RNA",
    "FIBP Proteo"
  ],
  "RIOK3": [
    "RIOK3 CNV",
    "RIOK3 RNA",
    "RIOK3 Proteo"
  ],
  "CYP51A1P1": [
    "CYP51A1P1 CNV",
    "CYP51A1P1 RNA"
  ],
  "RPS26P35": [
    "RPS26P35 CNV",
    "RPS26P35 RNA"
  ],
  "ZNF780B": [
    "ZNF780B CNV",
    "ZNF780B RNA"
  ],
  "OR4C46": [
    "OR4C46 CNV",
    "OR4C46 RNA"
  ],
  "INTS6": [
    "INTS6 CNV",
    "INTS6 RNA",
    "INTS6 Proteo"
  ],
  "ALDH2": [
    "ALDH2 CNV",
    "ALDH2 RNA",
    "ALDH2 Proteo"
  ],
  "KDM2B": [
    "KDM2B CNV",
    "KDM2B RNA",
    "KDM2B Proteo"
  ],
  "MYOCD": [
    "MYOCD CNV",
    "MYOCD RNA"
  ],
  "ENPEP": [
    "ENPEP CNV",
    "ENPEP RNA",
    "ENPEP Proteo"
  ],
  "KCNG4": [
    "KCNG4 CNV",
    "KCNG4 RNA"
  ],
  "ACTG1P21": [
    "ACTG1P21 CNV",
    "ACTG1P21 RNA"
  ],
  "ZNF121": [
    "ZNF121 CNV",
    "ZNF121 RNA",
    "ZNF121 Proteo"
  ],
  "SSX7": [
    "SSX7 CNV",
    "SSX7 RNA"
  ],
  "IGHV3-50": [
    "IGHV3-50 CNV",
    "IGHV3-50 RNA"
  ],
  "ANAPC15": [
    "ANAPC15 CNV",
    "ANAPC15 RNA",
    "ANAPC15 Proteo"
  ],
  "RAX": [
    "RAX CNV",
    "RAX RNA"
  ],
  "ELF4": [
    "ELF4 CNV",
    "ELF4 RNA"
  ],
  "GPR137B": [
    "GPR137B CNV",
    "GPR137B RNA",
    "GPR137B Proteo"
  ],
  "TRAIP": [
    "TRAIP CNV",
    "TRAIP RNA",
    "TRAIP Proteo"
  ],
  "CCDC185": [
    "CCDC185 CNV",
    "CCDC185 RNA"
  ],
  "SNAP25": [
    "SNAP25 CNV",
    "SNAP25 RNA"
  ],
  "SMC4P1": [
    "SMC4P1 CNV",
    "SMC4P1 RNA"
  ],
  "CYP2S1": [
    "CYP2S1 CNV",
    "CYP2S1 RNA",
    "CYP2S1 Proteo"
  ],
  "C19orf48": [
    "C19orf48 CNV",
    "C19orf48 RNA"
  ],
  "HAS2": [
    "HAS2 CNV",
    "HAS2 RNA"
  ],
  "NUP43": [
    "NUP43 CNV",
    "NUP43 RNA",
    "NUP43 Proteo"
  ],
  "NCCRP1": [
    "NCCRP1 CNV",
    "NCCRP1 RNA",
    "NCCRP1 Proteo"
  ],
  "RASGRP3": [
    "RASGRP3 CNV",
    "RASGRP3 RNA",
    "RASGRP3 Proteo"
  ],
  "CST9L": [
    "CST9L CNV",
    "CST9L RNA"
  ],
  "RAMAC": [
    "RAMAC CNV",
    "RAMAC RNA",
    "RAMAC Proteo"
  ],
  "ABAT": [
    "ABAT CNV",
    "ABAT RNA",
    "ABAT Proteo"
  ],
  "IGSF5": [
    "IGSF5 CNV",
    "IGSF5 RNA"
  ],
  "TRIM2": [
    "TRIM2 CNV",
    "TRIM2 RNA"
  ],
  "HNRNPCP3": [
    "HNRNPCP3 CNV",
    "HNRNPCP3 RNA"
  ],
  "CTDSPL": [
    "CTDSPL CNV",
    "CTDSPL RNA",
    "CTDSPL Proteo"
  ],
  "NDUFB4P7": [
    "NDUFB4P7 CNV",
    "NDUFB4P7 RNA"
  ],
  "SLC5A8": [
    "SLC5A8 CNV",
    "SLC5A8 RNA"
  ],
  "ACAP3": [
    "ACAP3 CNV",
    "ACAP3 RNA",
    "ACAP3 Proteo"
  ],
  "FOXO1": [
    "FOXO1 CNV",
    "FOXO1 RNA",
    "FOXO1 Proteo"
  ],
  "DRAM2": [
    "DRAM2 CNV",
    "DRAM2 RNA",
    "DRAM2 Proteo"
  ],
  "RPL12P26": [
    "RPL12P26 CNV",
    "RPL12P26 RNA"
  ],
  "VWA5B1": [
    "VWA5B1 CNV",
    "VWA5B1 RNA"
  ],
  "TMEM216": [
    "TMEM216 CNV",
    "TMEM216 RNA"
  ],
  "LCE3E": [
    "LCE3E CNV",
    "LCE3E RNA"
  ],
  "FNDC4": [
    "FNDC4 CNV",
    "FNDC4 RNA"
  ],
  "TRIM60P15": [
    "TRIM60P15 CNV",
    "TRIM60P15 RNA"
  ],
  "COG3": [
    "COG3 CNV",
    "COG3 RNA",
    "COG3 Proteo"
  ],
  "CDK11A": [
    "CDK11A CNV",
    "CDK11A RNA",
    "CDK11A Proteo"
  ],
  "PISD": [
    "PISD CNV",
    "PISD RNA",
    "PISD Proteo"
  ],
  "RNA5SP264": [
    "RNA5SP264 CNV",
    "RNA5SP264 RNA"
  ],
  "IGHMBP2": [
    "IGHMBP2 CNV",
    "IGHMBP2 RNA",
    "IGHMBP2 Proteo"
  ],
  "ASNSD1": [
    "ASNSD1 CNV",
    "ASNSD1 RNA",
    "ASNSD1 Proteo"
  ],
  "NUTF2": [
    "NUTF2 CNV",
    "NUTF2 RNA",
    "NUTF2 Proteo"
  ],
  "SMG1P4": [
    "SMG1P4 CNV",
    "SMG1P4 RNA"
  ],
  "PARP4P2": [
    "PARP4P2 CNV",
    "PARP4P2 RNA"
  ],
  "RPLP0P3": [
    "RPLP0P3 CNV",
    "RPLP0P3 RNA"
  ],
  "PNPLA8": [
    "PNPLA8 CNV",
    "PNPLA8 RNA",
    "PNPLA8 Proteo"
  ],
  "TMEM175": [
    "TMEM175 CNV",
    "TMEM175 RNA",
    "TMEM175 Proteo"
  ],
  "RPL38P1": [
    "RPL38P1 CNV",
    "RPL38P1 RNA"
  ],
  "PNN": [
    "PNN CNV",
    "PNN RNA",
    "PNN Proteo"
  ],
  "ASDURF": [
    "ASDURF CNV",
    "ASDURF RNA",
    "ASDURF Proteo"
  ],
  "PDLIM7": [
    "PDLIM7 CNV",
    "PDLIM7 RNA",
    "PDLIM7 Proteo"
  ],
  "C21orf140": [
    "C21orf140 CNV",
    "C21orf140 RNA"
  ],
  "RLF": [
    "RLF CNV",
    "RLF RNA",
    "RLF Proteo"
  ],
  "MRPL40P1": [
    "MRPL40P1 CNV",
    "MRPL40P1 RNA"
  ],
  "IGFBP1": [
    "IGFBP1 CNV",
    "IGFBP1 RNA"
  ],
  "DENND1C": [
    "DENND1C CNV",
    "DENND1C RNA",
    "DENND1C Proteo"
  ],
  "ZNF638": [
    "ZNF638 CNV",
    "ZNF638 RNA",
    "ZNF638 Proteo"
  ],
  "P3H4": [
    "P3H4 CNV",
    "P3H4 RNA",
    "P3H4 Proteo"
  ],
  "NUTM2B": [
    "NUTM2B CNV",
    "NUTM2B RNA"
  ],
  "KAT6A": [
    "KAT6A CNV",
    "KAT6A RNA",
    "KAT6A Proteo"
  ],
  "ZNF521": [
    "ZNF521 CNV",
    "ZNF521 RNA",
    "ZNF521 Proteo"
  ],
  "MFSD2A": [
    "MFSD2A CNV",
    "MFSD2A RNA"
  ],
  "CDH22": [
    "CDH22 CNV",
    "CDH22 RNA"
  ],
  "IGKV1OR2-2": [
    "IGKV1OR2-2 CNV",
    "IGKV1OR2-2 RNA"
  ],
  "MON2": [
    "MON2 CNV",
    "MON2 RNA",
    "MON2 Proteo"
  ],
  "C10orf53": [
    "C10orf53 CNV",
    "C10orf53 RNA"
  ],
  "ZNF300": [
    "ZNF300 CNV",
    "ZNF300 RNA"
  ],
  "TFIP11": [
    "TFIP11 CNV",
    "TFIP11 RNA",
    "TFIP11 Proteo"
  ],
  "NDUFB4P5": [
    "NDUFB4P5 CNV",
    "NDUFB4P5 RNA"
  ],
  "SEMA6A": [
    "SEMA6A CNV",
    "SEMA6A RNA",
    "SEMA6A Proteo"
  ],
  "OLFM3": [
    "OLFM3 CNV",
    "OLFM3 RNA"
  ],
  "ASB8": [
    "ASB8 CNV",
    "ASB8 RNA",
    "ASB8 Proteo"
  ],
  "COL4A6": [
    "COL4A6 CNV",
    "COL4A6 RNA"
  ],
  "SEPHS1P2": [
    "SEPHS1P2 CNV",
    "SEPHS1P2 RNA"
  ],
  "SMPDL3A": [
    "SMPDL3A CNV",
    "SMPDL3A RNA",
    "SMPDL3A Proteo"
  ],
  "MAPK6P3": [
    "MAPK6P3 CNV",
    "MAPK6P3 RNA"
  ],
  "TAS2R9": [
    "TAS2R9 CNV",
    "TAS2R9 RNA"
  ],
  "VN1R70P": [
    "VN1R70P CNV",
    "VN1R70P RNA"
  ],
  "SMIM10L1": [
    "SMIM10L1 CNV",
    "SMIM10L1 RNA",
    "SMIM10L1 Proteo"
  ],
  "KRTAP9-2": [
    "KRTAP9-2 CNV",
    "KRTAP9-2 RNA"
  ],
  "PIGX": [
    "PIGX CNV",
    "PIGX RNA",
    "PIGX Proteo"
  ],
  "FMO9P": [
    "FMO9P CNV",
    "FMO9P RNA"
  ],
  "EXOC4": [
    "EXOC4 CNV",
    "EXOC4 RNA",
    "EXOC4 Proteo"
  ],
  "CYC1": [
    "CYC1 CNV",
    "CYC1 RNA",
    "CYC1 Proteo"
  ],
  "MIS12": [
    "MIS12 CNV",
    "MIS12 RNA",
    "MIS12 Proteo"
  ],
  "IGKV1D-33": [
    "IGKV1D-33 Proteo"
  ],
  "FAR2": [
    "FAR2 CNV",
    "FAR2 RNA",
    "FAR2 Proteo"
  ],
  "GOLGA8EP": [
    "GOLGA8EP CNV",
    "GOLGA8EP RNA"
  ],
  "MRPS30": [
    "MRPS30 CNV",
    "MRPS30 RNA",
    "MRPS30 Proteo"
  ],
  "VN1R108P": [
    "VN1R108P CNV",
    "VN1R108P RNA"
  ],
  "TMOD4": [
    "TMOD4 CNV",
    "TMOD4 RNA"
  ],
  "ZNF620": [
    "ZNF620 CNV",
    "ZNF620 RNA"
  ],
  "CLCA1": [
    "CLCA1 CNV",
    "CLCA1 RNA",
    "CLCA1 Proteo"
  ],
  "CCNI": [
    "CCNI CNV",
    "CCNI RNA",
    "CCNI Proteo"
  ],
  "DNAJA1P6": [
    "DNAJA1P6 CNV",
    "DNAJA1P6 RNA"
  ],
  "CSRP3": [
    "CSRP3 CNV",
    "CSRP3 RNA",
    "CSRP3 Proteo"
  ],
  "SRP14": [
    "SRP14 CNV",
    "SRP14 RNA",
    "SRP14 Proteo"
  ],
  "H2AZP7": [
    "H2AZP7 CNV",
    "H2AZP7 RNA"
  ],
  "DEFB108B": [
    "DEFB108B CNV",
    "DEFB108B RNA"
  ],
  "RPL21P39": [
    "RPL21P39 CNV",
    "RPL21P39 RNA"
  ],
  "GAGE10": [
    "GAGE10 CNV",
    "GAGE10 RNA"
  ],
  "FBXW5": [
    "FBXW5 CNV",
    "FBXW5 RNA",
    "FBXW5 Proteo"
  ],
  "SERGEF": [
    "SERGEF CNV",
    "SERGEF RNA",
    "SERGEF Proteo"
  ],
  "ZNF133": [
    "ZNF133 CNV",
    "ZNF133 RNA"
  ],
  "COMTD1": [
    "COMTD1 CNV",
    "COMTD1 RNA",
    "COMTD1 Proteo"
  ],
  "FCF1P3": [
    "FCF1P3 CNV",
    "FCF1P3 RNA"
  ],
  "PRLR": [
    "PRLR CNV",
    "PRLR RNA",
    "PRLR Proteo"
  ],
  "TMEM114": [
    "TMEM114 CNV",
    "TMEM114 RNA"
  ],
  "GOLGA2P7": [
    "GOLGA2P7 CNV",
    "GOLGA2P7 RNA"
  ],
  "OR6U2P": [
    "OR6U2P CNV",
    "OR6U2P RNA"
  ],
  "RPL5P1": [
    "RPL5P1 CNV",
    "RPL5P1 RNA"
  ],
  "GID4": [
    "GID4 CNV",
    "GID4 RNA",
    "GID4 Proteo"
  ],
  "HDLBP": [
    "HDLBP CNV",
    "HDLBP RNA",
    "HDLBP Proteo"
  ],
  "RNA5SP322": [
    "RNA5SP322 CNV",
    "RNA5SP322 RNA"
  ],
  "PIP5K1B": [
    "PIP5K1B CNV",
    "PIP5K1B RNA"
  ],
  "GPR82": [
    "GPR82 CNV",
    "GPR82 RNA"
  ],
  "CACNB3": [
    "CACNB3 CNV",
    "CACNB3 RNA",
    "CACNB3 Proteo"
  ],
  "RIMBP3B": [
    "RIMBP3B CNV",
    "RIMBP3B RNA"
  ],
  "CICP28": [
    "CICP28 CNV",
    "CICP28 RNA"
  ],
  "CDAN1": [
    "CDAN1 CNV",
    "CDAN1 RNA",
    "CDAN1 Proteo"
  ],
  "SEPTIN7P12": [
    "SEPTIN7P12 CNV",
    "SEPTIN7P12 RNA"
  ],
  "RPL7AP72": [
    "RPL7AP72 CNV",
    "RPL7AP72 RNA"
  ],
  "DKK3": [
    "DKK3 CNV",
    "DKK3 RNA",
    "DKK3 Proteo"
  ],
  "T_CD8": [
    "T_CD8 Cell_type"
  ],
  "KAZN": [
    "KAZN CNV",
    "KAZN RNA",
    "KAZN Proteo"
  ],
  "ZNRF2P1": [
    "ZNRF2P1 CNV",
    "ZNRF2P1 RNA"
  ],
  "WDR91": [
    "WDR91 CNV",
    "WDR91 RNA",
    "WDR91 Proteo"
  ],
  "A4GNT": [
    "A4GNT CNV",
    "A4GNT RNA"
  ],
  "IVNS1ABP": [
    "IVNS1ABP CNV",
    "IVNS1ABP RNA",
    "IVNS1ABP Proteo"
  ],
  "TIE1": [
    "TIE1 CNV",
    "TIE1 RNA",
    "TIE1 Proteo"
  ],
  "RPSAP41": [
    "RPSAP41 CNV",
    "RPSAP41 RNA"
  ],
  "CLIC4P2": [
    "CLIC4P2 CNV",
    "CLIC4P2 RNA"
  ],
  "DOCK11": [
    "DOCK11 CNV",
    "DOCK11 RNA",
    "DOCK11 Proteo"
  ],
  "USP32P1": [
    "USP32P1 CNV",
    "USP32P1 RNA"
  ],
  "RPL31P58": [
    "RPL31P58 CNV",
    "RPL31P58 RNA"
  ],
  "ATP5F1EP1": [
    "ATP5F1EP1 CNV",
    "ATP5F1EP1 RNA"
  ],
  "ZIC5": [
    "ZIC5 CNV",
    "ZIC5 RNA"
  ],
  "NAB1P1": [
    "NAB1P1 CNV",
    "NAB1P1 RNA"
  ],
  "KCTD7": [
    "KCTD7 CNV",
    "KCTD7 RNA",
    "KCTD7 Proteo"
  ],
  "EEF2KMT": [
    "EEF2KMT CNV",
    "EEF2KMT RNA",
    "EEF2KMT Proteo"
  ],
  "PDCL3P1": [
    "PDCL3P1 CNV",
    "PDCL3P1 RNA"
  ],
  "TNK1": [
    "TNK1 CNV",
    "TNK1 RNA",
    "TNK1 Proteo"
  ],
  "LRRC9": [
    "LRRC9 CNV",
    "LRRC9 RNA"
  ],
  "SARAF": [
    "SARAF CNV",
    "SARAF RNA",
    "SARAF Proteo"
  ],
  "AGMO": [
    "AGMO CNV",
    "AGMO RNA"
  ],
  "USP9YP15": [
    "USP9YP15 CNV",
    "USP9YP15 RNA"
  ],
  "ZNF28": [
    "ZNF28 CNV",
    "ZNF28 RNA",
    "ZNF28 Proteo"
  ],
  "CLEC19A": [
    "CLEC19A CNV",
    "CLEC19A RNA"
  ],
  "BPIFC": [
    "BPIFC CNV",
    "BPIFC RNA"
  ],
  "IGBP1P4": [
    "IGBP1P4 CNV",
    "IGBP1P4 RNA"
  ],
  "TAB2": [
    "TAB2 CNV",
    "TAB2 RNA",
    "TAB2 Proteo"
  ],
  "ACSM6": [
    "ACSM6 CNV",
    "ACSM6 RNA"
  ],
  "NKX3-1": [
    "NKX3-1 CNV",
    "NKX3-1 RNA"
  ],
  "FOLR2": [
    "FOLR2 CNV",
    "FOLR2 RNA",
    "FOLR2 Proteo"
  ],
  "CDK11B": [
    "CDK11B CNV",
    "CDK11B RNA",
    "CDK11B Proteo"
  ],
  "HAUS6P2": [
    "HAUS6P2 CNV",
    "HAUS6P2 RNA"
  ],
  "KCTD3": [
    "KCTD3 CNV",
    "KCTD3 RNA",
    "KCTD3 Proteo"
  ],
  "DPY19L2P5": [
    "DPY19L2P5 CNV",
    "DPY19L2P5 RNA"
  ],
  "FRG1EP": [
    "FRG1EP CNV",
    "FRG1EP RNA"
  ],
  "FLNA": [
    "FLNA CNV",
    "FLNA RNA",
    "FLNA Proteo"
  ],
  "HEPACAM": [
    "HEPACAM CNV",
    "HEPACAM RNA",
    "HEPACAM Proteo"
  ],
  "PYCR1": [
    "PYCR1 CNV",
    "PYCR1 RNA",
    "PYCR1 Proteo"
  ],
  "XCR1": [
    "XCR1 CNV",
    "XCR1 RNA"
  ],
  "ATG12": [
    "ATG12 CNV",
    "ATG12 RNA",
    "ATG12 Proteo"
  ],
  "MRPL42P2": [
    "MRPL42P2 CNV",
    "MRPL42P2 RNA"
  ],
  "WFS1": [
    "WFS1 CNV",
    "WFS1 RNA",
    "WFS1 Proteo"
  ],
  "TRIM45": [
    "TRIM45 CNV",
    "TRIM45 RNA"
  ],
  "VMO1": [
    "VMO1 CNV",
    "VMO1 RNA"
  ],
  "CASP4LP": [
    "CASP4LP CNV",
    "CASP4LP RNA"
  ],
  "TOP1MT": [
    "TOP1MT CNV",
    "TOP1MT RNA"
  ],
  "ERI1": [
    "ERI1 CNV",
    "ERI1 RNA",
    "ERI1 Proteo"
  ],
  "SYT2": [
    "SYT2 CNV",
    "SYT2 RNA"
  ],
  "SLC7A1": [
    "SLC7A1 CNV",
    "SLC7A1 RNA",
    "SLC7A1 Proteo"
  ],
  "RPL9P18": [
    "RPL9P18 CNV",
    "RPL9P18 RNA"
  ],
  "MAD2L2": [
    "MAD2L2 CNV",
    "MAD2L2 RNA",
    "MAD2L2 Proteo"
  ],
  "POLR3K": [
    "POLR3K CNV",
    "POLR3K RNA",
    "POLR3K Proteo"
  ],
  "ZSCAN26": [
    "ZSCAN26 CNV",
    "ZSCAN26 RNA",
    "ZSCAN26 Proteo"
  ],
  "ZNF84": [
    "ZNF84 CNV",
    "ZNF84 RNA"
  ],
  "APEX1": [
    "APEX1 CNV",
    "APEX1 RNA",
    "APEX1 Proteo"
  ],
  "VN1R28P": [
    "VN1R28P CNV",
    "VN1R28P RNA"
  ],
  "OR52W1": [
    "OR52W1 CNV",
    "OR52W1 RNA"
  ],
  "THSD7A": [
    "THSD7A CNV",
    "THSD7A RNA"
  ],
  "OSTCP3": [
    "OSTCP3 CNV",
    "OSTCP3 RNA"
  ],
  "IGKV3D-15": [
    "IGKV3D-15 Proteo"
  ],
  "FAM126B": [
    "FAM126B CNV",
    "FAM126B RNA",
    "FAM126B Proteo"
  ],
  "C6orf89": [
    "C6orf89 CNV",
    "C6orf89 RNA",
    "C6orf89 Proteo"
  ],
  "PAIP2": [
    "PAIP2 CNV",
    "PAIP2 RNA",
    "PAIP2 Proteo"
  ],
  "IGHV3-11": [
    "IGHV3-11 Proteo"
  ],
  "ZNF71": [
    "ZNF71 CNV",
    "ZNF71 RNA"
  ],
  "RHO": [
    "RHO CNV",
    "RHO RNA"
  ],
  "VAT1L": [
    "VAT1L CNV",
    "VAT1L RNA",
    "VAT1L Proteo"
  ],
  "PIK3R6": [
    "PIK3R6 CNV",
    "PIK3R6 RNA",
    "PIK3R6 Proteo"
  ],
  "QRFP": [
    "QRFP CNV",
    "QRFP RNA"
  ],
  "SORCS2": [
    "SORCS2 CNV",
    "SORCS2 RNA",
    "SORCS2 Proteo"
  ],
  "NAGPA": [
    "NAGPA CNV",
    "NAGPA RNA",
    "NAGPA Proteo"
  ],
  "IGKV1OR-2": [
    "IGKV1OR-2 CNV",
    "IGKV1OR-2 RNA"
  ],
  "NOTCH4": [
    "NOTCH4 CNV",
    "NOTCH4 RNA",
    "NOTCH4 Proteo"
  ],
  "MYCLP1": [
    "MYCLP1 CNV",
    "MYCLP1 RNA"
  ],
  "KRTAP5-3": [
    "KRTAP5-3 CNV",
    "KRTAP5-3 RNA"
  ],
  "ZNF488": [
    "ZNF488 CNV",
    "ZNF488 RNA"
  ],
  "PRR33": [
    "PRR33 CNV",
    "PRR33 RNA"
  ],
  "RIMBP3": [
    "RIMBP3 CNV",
    "RIMBP3 RNA"
  ],
  "KIAA0319": [
    "KIAA0319 CNV",
    "KIAA0319 RNA"
  ],
  "GAPDHP67": [
    "GAPDHP67 CNV",
    "GAPDHP67 RNA"
  ],
  "DOK7": [
    "DOK7 CNV",
    "DOK7 RNA"
  ],
  "CSNK2B": [
    "CSNK2B CNV",
    "CSNK2B RNA",
    "CSNK2B Proteo"
  ],
  "STIMATE-MUSTN1": [
    "STIMATE-MUSTN1 Proteo"
  ],
  "GPHB5": [
    "GPHB5 CNV",
    "GPHB5 RNA"
  ],
  "SNAPIN": [
    "SNAPIN CNV",
    "SNAPIN RNA",
    "SNAPIN Proteo"
  ],
  "ANAPC1P4": [
    "ANAPC1P4 CNV",
    "ANAPC1P4 RNA"
  ],
  "MAD1L1": [
    "MAD1L1 CNV",
    "MAD1L1 RNA",
    "MAD1L1 Proteo"
  ],
  "SARS1": [
    "SARS1 CNV",
    "SARS1 RNA",
    "SARS1 Proteo"
  ],
  "AFG3L2": [
    "AFG3L2 CNV",
    "AFG3L2 RNA",
    "AFG3L2 Proteo"
  ],
  "LYL1": [
    "LYL1 CNV",
    "LYL1 RNA"
  ],
  "RPL36AP23": [
    "RPL36AP23 CNV",
    "RPL36AP23 RNA"
  ],
  "FUT2": [
    "FUT2 CNV",
    "FUT2 RNA"
  ],
  "ZNF117": [
    "ZNF117 CNV",
    "ZNF117 RNA"
  ],
  "PSG8": [
    "PSG8 CNV",
    "PSG8 RNA"
  ],
  "SPDYE16": [
    "SPDYE16 CNV",
    "SPDYE16 RNA"
  ],
  "HCFC2P1": [
    "HCFC2P1 CNV",
    "HCFC2P1 RNA"
  ],
  "GSTO3P": [
    "GSTO3P CNV",
    "GSTO3P RNA"
  ],
  "TCAP": [
    "TCAP CNV",
    "TCAP RNA",
    "TCAP Proteo"
  ],
  "ZNF439": [
    "ZNF439 CNV",
    "ZNF439 RNA"
  ],
  "PTAR1": [
    "PTAR1 CNV",
    "PTAR1 RNA",
    "PTAR1 Proteo"
  ],
  "ODAD3": [
    "ODAD3 CNV",
    "ODAD3 RNA"
  ],
  "GRAMD4P1": [
    "GRAMD4P1 CNV",
    "GRAMD4P1 RNA"
  ],
  "CLDN34": [
    "CLDN34 CNV",
    "CLDN34 RNA"
  ],
  "WBP1LP5": [
    "WBP1LP5 CNV",
    "WBP1LP5 RNA"
  ],
  "ZNF57": [
    "ZNF57 CNV",
    "ZNF57 RNA"
  ],
  "RPL17P36": [
    "RPL17P36 CNV",
    "RPL17P36 RNA"
  ],
  "EPHB3": [
    "EPHB3 CNV",
    "EPHB3 RNA",
    "EPHB3 Proteo"
  ],
  "EVA1B": [
    "EVA1B CNV",
    "EVA1B RNA",
    "EVA1B Proteo"
  ],
  "OR6M3P": [
    "OR6M3P CNV",
    "OR6M3P RNA"
  ],
  "ONECUT2": [
    "ONECUT2 CNV",
    "ONECUT2 RNA"
  ],
  "ZBTB25": [
    "ZBTB25 CNV",
    "ZBTB25 RNA"
  ],
  "MTND5P21": [
    "MTND5P21 CNV",
    "MTND5P21 RNA"
  ],
  "MKRN2OS": [
    "MKRN2OS CNV",
    "MKRN2OS RNA"
  ],
  "GNPATP": [
    "GNPATP CNV",
    "GNPATP RNA"
  ],
  "MYO10": [
    "MYO10 CNV",
    "MYO10 RNA",
    "MYO10 Proteo"
  ],
  "TRPM7": [
    "TRPM7 CNV",
    "TRPM7 RNA",
    "TRPM7 Proteo"
  ],
  "SPECC1": [
    "SPECC1 CNV",
    "SPECC1 RNA",
    "SPECC1 Proteo"
  ],
  "WFDC10A": [
    "WFDC10A CNV",
    "WFDC10A RNA"
  ],
  "HNRNPA1P53": [
    "HNRNPA1P53 CNV",
    "HNRNPA1P53 RNA"
  ],
  "ADAMTS19": [
    "ADAMTS19 CNV",
    "ADAMTS19 RNA"
  ],
  "AMZ2": [
    "AMZ2 CNV",
    "AMZ2 RNA",
    "AMZ2 Proteo"
  ],
  "RBMY2JP": [
    "RBMY2JP CNV",
    "RBMY2JP RNA"
  ],
  "CDKL3": [
    "CDKL3 CNV",
    "CDKL3 RNA"
  ],
  "OR2W4P": [
    "OR2W4P CNV",
    "OR2W4P RNA"
  ],
  "POLR3H": [
    "POLR3H CNV",
    "POLR3H RNA",
    "POLR3H Proteo"
  ],
  "AGAP11": [
    "AGAP11 CNV",
    "AGAP11 RNA"
  ],
  "RPS3AP4": [
    "RPS3AP4 CNV",
    "RPS3AP4 RNA"
  ],
  "ARRB1": [
    "ARRB1 CNV",
    "ARRB1 RNA",
    "ARRB1 Proteo"
  ],
  "COCH": [
    "COCH CNV",
    "COCH RNA",
    "COCH Proteo"
  ],
  "JMJD1C": [
    "JMJD1C CNV",
    "JMJD1C RNA",
    "JMJD1C Proteo"
  ],
  "GPR137C": [
    "GPR137C CNV",
    "GPR137C RNA"
  ],
  "CKS1BP2": [
    "CKS1BP2 CNV",
    "CKS1BP2 RNA"
  ],
  "ATP5MC2P3": [
    "ATP5MC2P3 CNV",
    "ATP5MC2P3 RNA"
  ],
  "IHH": [
    "IHH CNV",
    "IHH RNA"
  ],
  "KRT125P": [
    "KRT125P CNV",
    "KRT125P RNA"
  ],
  "LRRC34": [
    "LRRC34 CNV",
    "LRRC34 RNA"
  ],
  "NREP": [
    "NREP CNV",
    "NREP RNA"
  ],
  "ARHGEF5": [
    "ARHGEF5 CNV",
    "ARHGEF5 RNA",
    "ARHGEF5 Proteo"
  ],
  "USP38": [
    "USP38 CNV",
    "USP38 RNA",
    "USP38 Proteo"
  ],
  "OR7E33P": [
    "OR7E33P CNV",
    "OR7E33P RNA"
  ],
  "WDR95P": [
    "WDR95P CNV",
    "WDR95P RNA"
  ],
  "TMEM253": [
    "TMEM253 CNV",
    "TMEM253 RNA"
  ],
  "RPS3AP21": [
    "RPS3AP21 CNV",
    "RPS3AP21 RNA"
  ],
  "LOXL4": [
    "LOXL4 CNV",
    "LOXL4 RNA",
    "LOXL4 Proteo"
  ],
  "ACOT13": [
    "ACOT13 CNV",
    "ACOT13 RNA",
    "ACOT13 Proteo"
  ],
  "BCAS1": [
    "BCAS1 CNV",
    "BCAS1 RNA",
    "BCAS1 Proteo"
  ],
  "CARM1": [
    "CARM1 CNV",
    "CARM1 RNA",
    "CARM1 Proteo"
  ],
  "BEST2": [
    "BEST2 CNV",
    "BEST2 RNA"
  ],
  "TNIP2": [
    "TNIP2 CNV",
    "TNIP2 RNA",
    "TNIP2 Proteo"
  ],
  "MORF4L2": [
    "MORF4L2 CNV",
    "MORF4L2 RNA",
    "MORF4L2 Proteo"
  ],
  "KIAA1614": [
    "KIAA1614 CNV",
    "KIAA1614 RNA"
  ],
  "SLC4A5": [
    "SLC4A5 CNV",
    "SLC4A5 RNA"
  ],
  "CHRNB4": [
    "CHRNB4 CNV",
    "CHRNB4 RNA"
  ],
  "WASH4P": [
    "WASH4P CNV",
    "WASH4P RNA"
  ],
  "PGAP2": [
    "PGAP2 CNV",
    "PGAP2 RNA",
    "PGAP2 Proteo"
  ],
  "RPL7P8": [
    "RPL7P8 CNV",
    "RPL7P8 RNA"
  ],
  "IGHV3-76": [
    "IGHV3-76 CNV",
    "IGHV3-76 RNA"
  ],
  "CASP1P1": [
    "CASP1P1 CNV",
    "CASP1P1 RNA"
  ],
  "HMGN2": [
    "HMGN2 CNV",
    "HMGN2 RNA",
    "HMGN2 Proteo"
  ],
  "ACACA": [
    "ACACA CNV",
    "ACACA RNA",
    "ACACA Proteo"
  ],
  "RPL5P28": [
    "RPL5P28 CNV",
    "RPL5P28 RNA"
  ],
  "NHLH2": [
    "NHLH2 CNV",
    "NHLH2 RNA"
  ],
  "GALNT5": [
    "GALNT5 CNV",
    "GALNT5 RNA",
    "GALNT5 Proteo"
  ],
  "H3P33": [
    "H3P33 CNV",
    "H3P33 RNA"
  ],
  "USP26": [
    "USP26 CNV",
    "USP26 RNA"
  ],
  "IGKV2D-18": [
    "IGKV2D-18 CNV",
    "IGKV2D-18 RNA"
  ],
  "OR7E19P": [
    "OR7E19P CNV",
    "OR7E19P RNA"
  ],
  "KCNJ11": [
    "KCNJ11 CNV",
    "KCNJ11 RNA"
  ],
  "ANGPTL1": [
    "ANGPTL1 CNV",
    "ANGPTL1 RNA"
  ],
  "RPL21P31": [
    "RPL21P31 CNV",
    "RPL21P31 RNA"
  ],
  "ADAT3": [
    "ADAT3 CNV",
    "ADAT3 RNA",
    "ADAT3 Proteo"
  ],
  "BLOC1S2P1": [
    "BLOC1S2P1 CNV",
    "BLOC1S2P1 RNA"
  ],
  "UBL5P1": [
    "UBL5P1 CNV",
    "UBL5P1 RNA"
  ],
  "POLE3": [
    "POLE3 CNV",
    "POLE3 RNA",
    "POLE3 Proteo"
  ],
  "CSHL1": [
    "CSHL1 CNV",
    "CSHL1 RNA"
  ],
  "LYRM4": [
    "LYRM4 CNV",
    "LYRM4 RNA",
    "LYRM4 Proteo"
  ],
  "ATP4A": [
    "ATP4A CNV",
    "ATP4A RNA",
    "ATP4A Proteo"
  ],
  "HMGA1P6": [
    "HMGA1P6 CNV",
    "HMGA1P6 RNA"
  ],
  "GALNT17": [
    "GALNT17 CNV",
    "GALNT17 RNA"
  ],
  "USP9YP32": [
    "USP9YP32 CNV",
    "USP9YP32 RNA"
  ],
  "RSPO2": [
    "RSPO2 CNV",
    "RSPO2 RNA"
  ],
  "TPH1": [
    "TPH1 CNV",
    "TPH1 RNA"
  ],
  "RNA5SP456": [
    "RNA5SP456 CNV",
    "RNA5SP456 RNA"
  ],
  "FAM240B": [
    "FAM240B CNV",
    "FAM240B RNA"
  ],
  "NDC80": [
    "NDC80 CNV",
    "NDC80 RNA",
    "NDC80 Proteo"
  ],
  "ZNF358": [
    "ZNF358 CNV",
    "ZNF358 RNA",
    "ZNF358 Proteo"
  ],
  "TPST1": [
    "TPST1 CNV",
    "TPST1 RNA",
    "TPST1 Proteo"
  ],
  "LIN28A": [
    "LIN28A CNV",
    "LIN28A RNA",
    "LIN28A Proteo"
  ],
  "DLG3": [
    "DLG3 CNV",
    "DLG3 RNA",
    "DLG3 Proteo"
  ],
  "GPHN": [
    "GPHN CNV",
    "GPHN RNA",
    "GPHN Proteo"
  ],
  "RPS17": [
    "RPS17 CNV",
    "RPS17 RNA"
  ],
  "PROK1": [
    "PROK1 CNV",
    "PROK1 RNA"
  ],
  "PPIAP75": [
    "PPIAP75 CNV",
    "PPIAP75 RNA"
  ],
  "ART3": [
    "ART3 CNV",
    "ART3 RNA",
    "ART3 Proteo"
  ],
  "RPL10P4": [
    "RPL10P4 CNV",
    "RPL10P4 RNA"
  ],
  "SPA17P1": [
    "SPA17P1 CNV",
    "SPA17P1 RNA"
  ],
  "CYP26A1": [
    "CYP26A1 CNV",
    "CYP26A1 RNA"
  ],
  "IMPDH1P9": [
    "IMPDH1P9 CNV",
    "IMPDH1P9 RNA"
  ],
  "C2": [
    "C2 CNV",
    "C2 RNA",
    "C2 Proteo"
  ],
  "SLC7A11": [
    "SLC7A11 CNV",
    "SLC7A11 RNA",
    "SLC7A11 Proteo"
  ],
  "HEMK1": [
    "HEMK1 CNV",
    "HEMK1 RNA",
    "HEMK1 Proteo"
  ],
  "NCAPGP2": [
    "NCAPGP2 CNV",
    "NCAPGP2 RNA"
  ],
  "NIPA2P4": [
    "NIPA2P4 CNV",
    "NIPA2P4 RNA"
  ],
  "CFAP97D2": [
    "CFAP97D2 CNV",
    "CFAP97D2 RNA"
  ],
  "SSBP2": [
    "SSBP2 CNV",
    "SSBP2 RNA",
    "SSBP2 Proteo"
  ],
  "MT-ND2": [
    "MT-ND2 RNA",
    "MT-ND2 Proteo"
  ],
  "RGS8": [
    "RGS8 CNV",
    "RGS8 RNA"
  ],
  "SENP1": [
    "SENP1 CNV",
    "SENP1 RNA",
    "SENP1 Proteo"
  ],
  "RHOJ": [
    "RHOJ CNV",
    "RHOJ RNA",
    "RHOJ Proteo"
  ],
  "CRYGGP": [
    "CRYGGP CNV",
    "CRYGGP RNA"
  ],
  "SIGLEC29P": [
    "SIGLEC29P CNV",
    "SIGLEC29P RNA"
  ],
  "EIF4BP3": [
    "EIF4BP3 CNV",
    "EIF4BP3 RNA"
  ],
  "RPL23AP55": [
    "RPL23AP55 CNV",
    "RPL23AP55 RNA"
  ],
  "IGSF11": [
    "IGSF11 CNV",
    "IGSF11 RNA",
    "IGSF11 Proteo"
  ],
  "DLX5": [
    "DLX5 CNV",
    "DLX5 RNA"
  ],
  "SLC5A10": [
    "SLC5A10 CNV",
    "SLC5A10 RNA"
  ],
  "SDF2L1": [
    "SDF2L1 CNV",
    "SDF2L1 RNA",
    "SDF2L1 Proteo"
  ],
  "IK": [
    "IK CNV",
    "IK RNA",
    "IK Proteo"
  ],
  "LIG4": [
    "LIG4 CNV",
    "LIG4 RNA",
    "LIG4 Proteo"
  ],
  "ATP6AP2": [
    "ATP6AP2 CNV",
    "ATP6AP2 RNA",
    "ATP6AP2 Proteo"
  ],
  "GRID2IP": [
    "GRID2IP CNV",
    "GRID2IP RNA"
  ],
  "KIAA1522": [
    "KIAA1522 CNV",
    "KIAA1522 RNA",
    "KIAA1522 Proteo"
  ],
  "INSM2": [
    "INSM2 CNV",
    "INSM2 RNA"
  ],
  "PRR20B": [
    "PRR20B CNV",
    "PRR20B RNA"
  ],
  "WASH5P": [
    "WASH5P CNV",
    "WASH5P RNA"
  ],
  "FTH1P13": [
    "FTH1P13 CNV",
    "FTH1P13 RNA"
  ],
  "VPS26B": [
    "VPS26B CNV",
    "VPS26B RNA",
    "VPS26B Proteo"
  ],
  "STRA6": [
    "STRA6 CNV",
    "STRA6 RNA",
    "STRA6 Proteo"
  ],
  "DYRK4": [
    "DYRK4 CNV",
    "DYRK4 RNA"
  ],
  "GNB1": [
    "GNB1 CNV",
    "GNB1 RNA",
    "GNB1 Proteo"
  ],
  "ASPHD1": [
    "ASPHD1 CNV",
    "ASPHD1 RNA",
    "ASPHD1 Proteo"
  ],
  "CALM2P1": [
    "CALM2P1 CNV",
    "CALM2P1 RNA"
  ],
  "HIF1AN": [
    "HIF1AN CNV",
    "HIF1AN RNA",
    "HIF1AN Proteo"
  ],
  "MT-ATP6": [
    "MT-ATP6 RNA",
    "MT-ATP6 Proteo"
  ],
  "MT-ND4L": [
    "MT-ND4L RNA"
  ],
  "A2ML1": [
    "A2ML1 CNV",
    "A2ML1 RNA",
    "A2ML1 Proteo"
  ],
  "CAPN3": [
    "CAPN3 CNV",
    "CAPN3 RNA",
    "CAPN3 Proteo"
  ],
  "PABPC1P10": [
    "PABPC1P10 CNV",
    "PABPC1P10 RNA"
  ],
  "GLDC": [
    "GLDC CNV",
    "GLDC RNA",
    "GLDC Proteo"
  ],
  "CBS": [
    "CBS CNV",
    "CBS RNA",
    "CBS Proteo"
  ],
  "FBXO32": [
    "FBXO32 CNV",
    "FBXO32 RNA"
  ],
  "GGTLC3": [
    "GGTLC3 CNV",
    "GGTLC3 RNA"
  ],
  "EIF4A1": [
    "EIF4A1 CNV",
    "EIF4A1 RNA",
    "EIF4A1 Proteo"
  ],
  "TPRX2": [
    "TPRX2 CNV",
    "TPRX2 RNA"
  ],
  "TGFBI": [
    "TGFBI CNV",
    "TGFBI RNA",
    "TGFBI Proteo"
  ],
  "TLCD3B": [
    "TLCD3B CNV",
    "TLCD3B RNA"
  ],
  "PEX10": [
    "PEX10 CNV",
    "PEX10 RNA",
    "PEX10 Proteo"
  ],
  "KRT18P38": [
    "KRT18P38 CNV",
    "KRT18P38 RNA"
  ],
  "FCRL4": [
    "FCRL4 CNV",
    "FCRL4 RNA"
  ],
  "RPL7AP48": [
    "RPL7AP48 CNV",
    "RPL7AP48 RNA"
  ],
  "PIGU": [
    "PIGU CNV",
    "PIGU RNA",
    "PIGU Proteo"
  ],
  "C4orf48": [
    "C4orf48 CNV",
    "C4orf48 RNA",
    "C4orf48 Proteo"
  ],
  "GAR1": [
    "GAR1 CNV",
    "GAR1 RNA",
    "GAR1 Proteo"
  ],
  "OR2T32P": [
    "OR2T32P CNV",
    "OR2T32P RNA"
  ],
  "PCDHGA11": [
    "PCDHGA11 CNV",
    "PCDHGA11 RNA"
  ],
  "CUL9": [
    "CUL9 CNV",
    "CUL9 RNA",
    "CUL9 Proteo"
  ],
  "RPL7AP32": [
    "RPL7AP32 CNV",
    "RPL7AP32 RNA"
  ],
  "ARVCF": [
    "ARVCF CNV",
    "ARVCF RNA",
    "ARVCF Proteo"
  ],
  "OLFML1": [
    "OLFML1 CNV",
    "OLFML1 RNA",
    "OLFML1 Proteo"
  ],
  "OR10U1P": [
    "OR10U1P CNV",
    "OR10U1P RNA"
  ],
  "HPDL": [
    "HPDL CNV",
    "HPDL RNA",
    "HPDL Proteo"
  ],
  "ATP6V1D": [
    "ATP6V1D CNV",
    "ATP6V1D RNA",
    "ATP6V1D Proteo"
  ],
  "ZNF829": [
    "ZNF829 CNV",
    "ZNF829 RNA"
  ],
  "SHISA5": [
    "SHISA5 CNV",
    "SHISA5 RNA"
  ],
  "GJA8": [
    "GJA8 CNV",
    "GJA8 RNA"
  ],
  "HMGB1P22": [
    "HMGB1P22 CNV",
    "HMGB1P22 RNA"
  ],
  "ZBED2": [
    "ZBED2 CNV",
    "ZBED2 RNA"
  ],
  "ACTG1P2": [
    "ACTG1P2 CNV",
    "ACTG1P2 RNA"
  ],
  "MAGEB17": [
    "MAGEB17 CNV",
    "MAGEB17 RNA"
  ],
  "HERC2P10": [
    "HERC2P10 CNV",
    "HERC2P10 RNA"
  ],
  "ZNF839": [
    "ZNF839 CNV",
    "ZNF839 RNA"
  ],
  "OFD1P13Y": [
    "OFD1P13Y CNV",
    "OFD1P13Y RNA"
  ],
  "ALG1": [
    "ALG1 CNV",
    "ALG1 RNA",
    "ALG1 Proteo"
  ],
  "PTMAP6": [
    "PTMAP6 CNV",
    "PTMAP6 RNA"
  ],
  "NOLC1P1": [
    "NOLC1P1 CNV",
    "NOLC1P1 RNA"
  ],
  "CD6": [
    "CD6 CNV",
    "CD6 RNA",
    "CD6 Proteo"
  ],
  "THOC6": [
    "THOC6 CNV",
    "THOC6 RNA",
    "THOC6 Proteo"
  ],
  "NTF4": [
    "NTF4 CNV",
    "NTF4 RNA"
  ],
  "GGNBP2": [
    "GGNBP2 CNV",
    "GGNBP2 RNA",
    "GGNBP2 Proteo"
  ],
  "DCST2": [
    "DCST2 CNV",
    "DCST2 RNA"
  ],
  "OR10K2": [
    "OR10K2 CNV",
    "OR10K2 RNA"
  ],
  "HSPA5": [
    "HSPA5 CNV",
    "HSPA5 RNA",
    "HSPA5 Proteo"
  ],
  "BNIP3P23": [
    "BNIP3P23 CNV",
    "BNIP3P23 RNA"
  ],
  "OR10J2P": [
    "OR10J2P CNV",
    "OR10J2P RNA"
  ],
  "ASS1P7": [
    "ASS1P7 CNV",
    "ASS1P7 RNA"
  ],
  "PLS1": [
    "PLS1 CNV",
    "PLS1 RNA",
    "PLS1 Proteo"
  ],
  "GGT4P": [
    "GGT4P CNV",
    "GGT4P RNA"
  ],
  "GBP6": [
    "GBP6 CNV",
    "GBP6 RNA",
    "GBP6 Proteo"
  ],
  "TMEM41A": [
    "TMEM41A CNV",
    "TMEM41A RNA",
    "TMEM41A Proteo"
  ],
  "CHCHD7": [
    "CHCHD7 CNV",
    "CHCHD7 RNA",
    "CHCHD7 Proteo"
  ],
  "GNG4": [
    "GNG4 CNV",
    "GNG4 RNA",
    "GNG4 Proteo"
  ],
  "SLC25A39P1": [
    "SLC25A39P1 CNV",
    "SLC25A39P1 RNA"
  ],
  "RSU1": [
    "RSU1 CNV",
    "RSU1 RNA",
    "RSU1 Proteo"
  ],
  "KIF3C": [
    "KIF3C CNV",
    "KIF3C RNA",
    "KIF3C Proteo"
  ],
  "RGL3": [
    "RGL3 CNV",
    "RGL3 RNA",
    "RGL3 Proteo"
  ],
  "HVCN1": [
    "HVCN1 CNV",
    "HVCN1 RNA",
    "HVCN1 Proteo"
  ],
  "SLAMF8": [
    "SLAMF8 CNV",
    "SLAMF8 RNA",
    "SLAMF8 Proteo"
  ],
  "CASP14": [
    "CASP14 CNV",
    "CASP14 RNA",
    "CASP14 Proteo"
  ],
  "IQSEC3": [
    "IQSEC3 CNV",
    "IQSEC3 RNA"
  ],
  "EEF1AKMT3": [
    "EEF1AKMT3 CNV",
    "EEF1AKMT3 RNA"
  ],
  "LRIT3": [
    "LRIT3 CNV",
    "LRIT3 RNA"
  ],
  "STK33P1": [
    "STK33P1 CNV",
    "STK33P1 RNA"
  ],
  "TREX1": [
    "TREX1 CNV",
    "TREX1 RNA",
    "TREX1 Proteo"
  ],
  "HNRNPLP1": [
    "HNRNPLP1 CNV",
    "HNRNPLP1 RNA"
  ],
  "ZNF175": [
    "ZNF175 CNV",
    "ZNF175 RNA"
  ],
  "OVOL3": [
    "OVOL3 CNV",
    "OVOL3 RNA"
  ],
  "RPS15P4": [
    "RPS15P4 CNV",
    "RPS15P4 RNA"
  ],
  "SAMD4B": [
    "SAMD4B CNV",
    "SAMD4B RNA",
    "SAMD4B Proteo"
  ],
  "IGHJ1P": [
    "IGHJ1P CNV",
    "IGHJ1P RNA"
  ],
  "NAA30": [
    "NAA30 CNV",
    "NAA30 RNA",
    "NAA30 Proteo"
  ],
  "DEFB125": [
    "DEFB125 CNV",
    "DEFB125 RNA"
  ],
  "IARS1": [
    "IARS1 CNV",
    "IARS1 RNA",
    "IARS1 Proteo"
  ],
  "RNA5SP135": [
    "RNA5SP135 CNV",
    "RNA5SP135 RNA"
  ],
  "CORIN": [
    "CORIN CNV",
    "CORIN RNA"
  ],
  "HERC2P11": [
    "HERC2P11 CNV",
    "HERC2P11 RNA"
  ],
  "BNIP3P7": [
    "BNIP3P7 CNV",
    "BNIP3P7 RNA"
  ],
  "UBE2O": [
    "UBE2O CNV",
    "UBE2O RNA",
    "UBE2O Proteo"
  ],
  "BTF3P14": [
    "BTF3P14 CNV",
    "BTF3P14 RNA"
  ],
  "FOLR1P1": [
    "FOLR1P1 CNV",
    "FOLR1P1 RNA"
  ],
  "MTND3P22": [
    "MTND3P22 CNV",
    "MTND3P22 RNA"
  ],
  "SLC35D3": [
    "SLC35D3 CNV",
    "SLC35D3 RNA"
  ],
  "SLC26A6": [
    "SLC26A6 CNV",
    "SLC26A6 RNA",
    "SLC26A6 Proteo"
  ],
  "ZC3H12B": [
    "ZC3H12B CNV",
    "ZC3H12B RNA"
  ],
  "OR51E2": [
    "OR51E2 CNV",
    "OR51E2 RNA"
  ],
  "KRT8P1": [
    "KRT8P1 CNV",
    "KRT8P1 RNA"
  ],
  "EFS": [
    "EFS CNV",
    "EFS RNA",
    "EFS Proteo"
  ],
  "RPTN": [
    "RPTN CNV",
    "RPTN RNA"
  ],
  "TBX5": [
    "TBX5 CNV",
    "TBX5 RNA"
  ],
  "ZSCAN30": [
    "ZSCAN30 CNV",
    "ZSCAN30 RNA"
  ],
  "RAC1P3": [
    "RAC1P3 CNV",
    "RAC1P3 RNA"
  ],
  "IGHV1OR16-2": [
    "IGHV1OR16-2 CNV",
    "IGHV1OR16-2 RNA"
  ],
  "THRB": [
    "THRB CNV",
    "THRB RNA"
  ],
  "AUTS2": [
    "AUTS2 CNV",
    "AUTS2 RNA"
  ],
  "ZYG11B": [
    "ZYG11B CNV",
    "ZYG11B RNA",
    "ZYG11B Proteo"
  ],
  "GAPDHP71": [
    "GAPDHP71 CNV",
    "GAPDHP71 RNA"
  ],
  "RPL39P26": [
    "RPL39P26 CNV",
    "RPL39P26 RNA"
  ],
  "ABCC4": [
    "ABCC4 CNV",
    "ABCC4 RNA",
    "ABCC4 Proteo"
  ],
  "CCIN": [
    "CCIN CNV",
    "CCIN RNA"
  ],
  "ANLN": [
    "ANLN CNV",
    "ANLN RNA",
    "ANLN Proteo"
  ],
  "SENP2": [
    "SENP2 CNV",
    "SENP2 RNA",
    "SENP2 Proteo"
  ],
  "TMCO1": [
    "TMCO1 CNV",
    "TMCO1 RNA",
    "TMCO1 Proteo"
  ],
  "SLC50A1": [
    "SLC50A1 CNV",
    "SLC50A1 RNA",
    "SLC50A1 Proteo"
  ],
  "TRAPPC11": [
    "TRAPPC11 CNV",
    "TRAPPC11 RNA",
    "TRAPPC11 Proteo"
  ],
  "TLL1": [
    "TLL1 CNV",
    "TLL1 RNA"
  ],
  "DCUN1D3": [
    "DCUN1D3 CNV",
    "DCUN1D3 RNA",
    "DCUN1D3 Proteo"
  ],
  "HMGN2P30": [
    "HMGN2P30 CNV",
    "HMGN2P30 RNA"
  ],
  "SLC7A9": [
    "SLC7A9 CNV",
    "SLC7A9 RNA"
  ],
  "PRR13P1": [
    "PRR13P1 CNV",
    "PRR13P1 RNA"
  ],
  "PTCHD4": [
    "PTCHD4 CNV",
    "PTCHD4 RNA"
  ],
  "SIX2": [
    "SIX2 CNV",
    "SIX2 RNA"
  ],
  "RGPD4": [
    "RGPD4 CNV",
    "RGPD4 RNA"
  ],
  "KLHL2": [
    "KLHL2 CNV",
    "KLHL2 RNA"
  ],
  "PPP1R18": [
    "PPP1R18 CNV",
    "PPP1R18 RNA",
    "PPP1R18 Proteo"
  ],
  "HSFX2": [
    "HSFX2 CNV",
    "HSFX2 RNA"
  ],
  "THPO": [
    "THPO CNV",
    "THPO RNA"
  ],
  "OR6P1": [
    "OR6P1 CNV",
    "OR6P1 RNA"
  ],
  "MUC16": [
    "MUC16 CNV",
    "MUC16 RNA",
    "MUC16 Proteo"
  ],
  "CTNNB1": [
    "CTNNB1 CNV",
    "CTNNB1 RNA",
    "CTNNB1 Proteo"
  ],
  "SMAGP": [
    "SMAGP CNV",
    "SMAGP RNA"
  ],
  "VAMP5": [
    "VAMP5 CNV",
    "VAMP5 RNA",
    "VAMP5 Proteo"
  ],
  "SNX20": [
    "SNX20 CNV",
    "SNX20 RNA",
    "SNX20 Proteo"
  ],
  "MALL": [
    "MALL CNV",
    "MALL RNA"
  ],
  "MATK": [
    "MATK CNV",
    "MATK RNA",
    "MATK Proteo"
  ],
  "FNBP4": [
    "FNBP4 CNV",
    "FNBP4 RNA",
    "FNBP4 Proteo"
  ],
  "COMMD4P2": [
    "COMMD4P2 CNV",
    "COMMD4P2 RNA"
  ],
  "RCC2P1": [
    "RCC2P1 CNV",
    "RCC2P1 RNA"
  ],
  "CNN2P1": [
    "CNN2P1 CNV",
    "CNN2P1 RNA"
  ],
  "RPS29P29": [
    "RPS29P29 CNV",
    "RPS29P29 RNA"
  ],
  "HOXD3": [
    "HOXD3 CNV",
    "HOXD3 RNA"
  ],
  "DDX60": [
    "DDX60 CNV",
    "DDX60 RNA",
    "DDX60 Proteo"
  ],
  "MICE": [
    "MICE CNV",
    "MICE RNA"
  ],
  "ACTL9": [
    "ACTL9 CNV",
    "ACTL9 RNA"
  ],
  "RPS29P28": [
    "RPS29P28 CNV",
    "RPS29P28 RNA"
  ],
  "SAPCD1": [
    "SAPCD1 CNV",
    "SAPCD1 RNA"
  ],
  "ZNF414": [
    "ZNF414 CNV",
    "ZNF414 RNA",
    "ZNF414 Proteo"
  ],
  "CSF3": [
    "CSF3 CNV",
    "CSF3 RNA"
  ],
  "VN1R33P": [
    "VN1R33P CNV",
    "VN1R33P RNA"
  ],
  "PRSS38": [
    "PRSS38 CNV",
    "PRSS38 RNA"
  ],
  "RCBTB1": [
    "RCBTB1 CNV",
    "RCBTB1 RNA",
    "RCBTB1 Proteo"
  ],
  "RPL34P31": [
    "RPL34P31 CNV",
    "RPL34P31 RNA"
  ],
  "ABCC6P1": [
    "ABCC6P1 CNV",
    "ABCC6P1 RNA"
  ],
  "TNFSF12-TNFSF13": [
    "TNFSF12-TNFSF13 Proteo"
  ],
  "KLF2P1": [
    "KLF2P1 CNV",
    "KLF2P1 RNA"
  ],
  "EDNRB": [
    "EDNRB CNV",
    "EDNRB RNA",
    "EDNRB Proteo"
  ],
  "CCT4": [
    "CCT4 CNV",
    "CCT4 RNA",
    "CCT4 Proteo"
  ],
  "CILK1": [
    "CILK1 CNV",
    "CILK1 RNA",
    "CILK1 Proteo"
  ],
  "PLEKHD1": [
    "PLEKHD1 CNV",
    "PLEKHD1 RNA"
  ],
  "ARFIP2": [
    "ARFIP2 CNV",
    "ARFIP2 RNA",
    "ARFIP2 Proteo"
  ],
  "OPALIN": [
    "OPALIN CNV",
    "OPALIN RNA"
  ],
  "EIF1AXP1": [
    "EIF1AXP1 CNV",
    "EIF1AXP1 RNA"
  ],
  "OR8K2P": [
    "OR8K2P CNV",
    "OR8K2P RNA"
  ],
  "CES2": [
    "CES2 CNV",
    "CES2 RNA",
    "CES2 Proteo"
  ],
  "WSCD2": [
    "WSCD2 CNV",
    "WSCD2 RNA"
  ],
  "CCL3L3": [
    "CCL3L3 CNV",
    "CCL3L3 RNA"
  ],
  "MC5R": [
    "MC5R CNV",
    "MC5R RNA"
  ],
  "SULT4A1": [
    "SULT4A1 CNV",
    "SULT4A1 RNA"
  ],
  "TMEM256P1": [
    "TMEM256P1 CNV",
    "TMEM256P1 RNA"
  ],
  "DAPK2": [
    "DAPK2 CNV",
    "DAPK2 RNA",
    "DAPK2 Proteo"
  ],
  "IGHV1OR16-1": [
    "IGHV1OR16-1 CNV",
    "IGHV1OR16-1 RNA"
  ],
  "CST1": [
    "CST1 CNV",
    "CST1 RNA",
    "CST1 Proteo"
  ],
  "SNRK": [
    "SNRK CNV",
    "SNRK RNA",
    "SNRK Proteo"
  ],
  "PPP1R14A": [
    "PPP1R14A CNV",
    "PPP1R14A RNA",
    "PPP1R14A Proteo"
  ],
  "PNPLA5": [
    "PNPLA5 CNV",
    "PNPLA5 RNA"
  ],
  "LALBA": [
    "LALBA CNV",
    "LALBA RNA"
  ],
  "C2CD3": [
    "C2CD3 CNV",
    "C2CD3 RNA",
    "C2CD3 Proteo"
  ],
  "OR10J6P": [
    "OR10J6P CNV",
    "OR10J6P RNA"
  ],
  "ATP5MFP3": [
    "ATP5MFP3 CNV",
    "ATP5MFP3 RNA"
  ],
  "SNRPEP5": [
    "SNRPEP5 CNV",
    "SNRPEP5 RNA"
  ],
  "OR5BP1P": [
    "OR5BP1P CNV",
    "OR5BP1P RNA"
  ],
  "EREG": [
    "EREG CNV",
    "EREG RNA"
  ],
  "GGN": [
    "GGN CNV",
    "GGN RNA"
  ],
  "USP17L25": [
    "USP17L25 CNV",
    "USP17L25 RNA"
  ],
  "IGHGP": [
    "IGHGP CNV",
    "IGHGP RNA"
  ],
  "GMCL1P2": [
    "GMCL1P2 CNV",
    "GMCL1P2 RNA"
  ],
  "H2AL3": [
    "H2AL3 CNV",
    "H2AL3 RNA"
  ],
  "C15orf62": [
    "C15orf62 CNV",
    "C15orf62 RNA"
  ],
  "TSPAN1": [
    "TSPAN1 CNV",
    "TSPAN1 RNA"
  ],
  "HS3ST3A1": [
    "HS3ST3A1 CNV",
    "HS3ST3A1 RNA"
  ],
  "CNGA2": [
    "CNGA2 CNV",
    "CNGA2 RNA"
  ],
  "OSCP1": [
    "OSCP1 CNV",
    "OSCP1 RNA",
    "OSCP1 Proteo"
  ],
  "LARP1BP1": [
    "LARP1BP1 CNV",
    "LARP1BP1 RNA"
  ],
  "LENG1": [
    "LENG1 CNV",
    "LENG1 RNA",
    "LENG1 Proteo"
  ],
  "NR3C1": [
    "NR3C1 CNV",
    "NR3C1 RNA",
    "NR3C1 Proteo"
  ],
  "RIOK3P1": [
    "RIOK3P1 CNV",
    "RIOK3P1 RNA"
  ],
  "CHD1": [
    "CHD1 CNV",
    "CHD1 RNA",
    "CHD1 Proteo"
  ],
  "CHST6": [
    "CHST6 CNV",
    "CHST6 RNA",
    "CHST6 Proteo"
  ],
  "CXXC5": [
    "CXXC5 CNV",
    "CXXC5 RNA",
    "CXXC5 Proteo"
  ],
  "PRAMEF15": [
    "PRAMEF15 CNV",
    "PRAMEF15 RNA",
    "PRAMEF15 Proteo"
  ],
  "HSPD1P14": [
    "HSPD1P14 CNV",
    "HSPD1P14 RNA"
  ],
  "FN3K": [
    "FN3K CNV",
    "FN3K RNA",
    "FN3K Proteo"
  ],
  "RPL9P28": [
    "RPL9P28 CNV",
    "RPL9P28 RNA"
  ],
  "GALNT18": [
    "GALNT18 CNV",
    "GALNT18 RNA"
  ],
  "KRTAP4-12": [
    "KRTAP4-12 CNV",
    "KRTAP4-12 RNA"
  ],
  "CYB5AP5": [
    "CYB5AP5 CNV",
    "CYB5AP5 RNA"
  ],
  "IL6STP1": [
    "IL6STP1 CNV",
    "IL6STP1 RNA"
  ],
  "FBXW9": [
    "FBXW9 CNV",
    "FBXW9 RNA",
    "FBXW9 Proteo"
  ],
  "PKP4": [
    "PKP4 CNV",
    "PKP4 RNA",
    "PKP4 Proteo"
  ],
  "TOMM40P4": [
    "TOMM40P4 CNV",
    "TOMM40P4 RNA"
  ],
  "PECAM1": [
    "PECAM1 CNV",
    "PECAM1 RNA",
    "PECAM1 Proteo"
  ],
  "PXN": [
    "PXN CNV",
    "PXN RNA",
    "PXN Proteo"
  ],
  "RAE1": [
    "RAE1 CNV",
    "RAE1 RNA",
    "RAE1 Proteo"
  ],
  "SAGE4P": [
    "SAGE4P CNV",
    "SAGE4P RNA"
  ],
  "MFGE8": [
    "MFGE8 CNV",
    "MFGE8 RNA",
    "MFGE8 Proteo"
  ],
  "RAC1P7": [
    "RAC1P7 CNV",
    "RAC1P7 RNA"
  ],
  "SHQ1P1": [
    "SHQ1P1 CNV",
    "SHQ1P1 RNA"
  ],
  "PRMT1": [
    "PRMT1 CNV",
    "PRMT1 RNA",
    "PRMT1 Proteo"
  ],
  "PHLDB3": [
    "PHLDB3 CNV",
    "PHLDB3 RNA",
    "PHLDB3 Proteo"
  ],
  "PRAMEF6": [
    "PRAMEF6 CNV",
    "PRAMEF6 RNA"
  ],
  "RNF186": [
    "RNF186 CNV",
    "RNF186 RNA"
  ],
  "LRIG2": [
    "LRIG2 CNV",
    "LRIG2 RNA",
    "LRIG2 Proteo"
  ],
  "FAM8A2P": [
    "FAM8A2P CNV",
    "FAM8A2P RNA"
  ],
  "MTMR7": [
    "MTMR7 CNV",
    "MTMR7 RNA"
  ],
  "ADGRE1": [
    "ADGRE1 CNV",
    "ADGRE1 RNA",
    "ADGRE1 Proteo"
  ],
  "MOGAT1": [
    "MOGAT1 CNV",
    "MOGAT1 RNA"
  ],
  "FGF22": [
    "FGF22 CNV",
    "FGF22 RNA"
  ],
  "UBTFL6": [
    "UBTFL6 CNV",
    "UBTFL6 RNA"
  ],
  "AKR1B1P1": [
    "AKR1B1P1 CNV",
    "AKR1B1P1 RNA"
  ],
  "NARF": [
    "NARF CNV",
    "NARF RNA",
    "NARF Proteo"
  ],
  "RPL35AP35": [
    "RPL35AP35 CNV",
    "RPL35AP35 RNA"
  ],
  "C11orf96": [
    "C11orf96 CNV",
    "C11orf96 RNA",
    "C11orf96 Proteo"
  ],
  "MTND2P4": [
    "MTND2P4 CNV",
    "MTND2P4 RNA"
  ],
  "IL1A": [
    "IL1A CNV",
    "IL1A RNA"
  ],
  "ELOCP20": [
    "ELOCP20 CNV",
    "ELOCP20 RNA"
  ],
  "CLDN11": [
    "CLDN11 CNV",
    "CLDN11 RNA"
  ],
  "GAGE12B": [
    "GAGE12B CNV",
    "GAGE12B RNA"
  ],
  "IAPP": [
    "IAPP CNV",
    "IAPP RNA"
  ],
  "RPL31P45": [
    "RPL31P45 CNV",
    "RPL31P45 RNA"
  ],
  "PDIA5": [
    "PDIA5 CNV",
    "PDIA5 RNA",
    "PDIA5 Proteo"
  ],
  "CCDC141": [
    "CCDC141 CNV",
    "CCDC141 RNA",
    "CCDC141 Proteo"
  ],
  "IL15": [
    "IL15 CNV",
    "IL15 RNA"
  ],
  "WNT8A": [
    "WNT8A CNV",
    "WNT8A RNA"
  ],
  "CDRT15P12": [
    "CDRT15P12 CNV",
    "CDRT15P12 RNA"
  ],
  "SPRR2A": [
    "SPRR2A CNV",
    "SPRR2A RNA",
    "SPRR2A Proteo"
  ],
  "TMEM51": [
    "TMEM51 CNV",
    "TMEM51 RNA",
    "TMEM51 Proteo"
  ],
  "OR1AB1P": [
    "OR1AB1P CNV",
    "OR1AB1P RNA"
  ],
  "EEF1A1P50": [
    "EEF1A1P50 CNV",
    "EEF1A1P50 RNA"
  ],
  "RPS27P23": [
    "RPS27P23 CNV",
    "RPS27P23 RNA"
  ],
  "CTSLP2": [
    "CTSLP2 CNV",
    "CTSLP2 RNA"
  ],
  "SPATA2": [
    "SPATA2 CNV",
    "SPATA2 RNA",
    "SPATA2 Proteo"
  ],
  "SOWAHD": [
    "SOWAHD CNV",
    "SOWAHD RNA",
    "SOWAHD Proteo"
  ],
  "ARSFP1": [
    "ARSFP1 CNV",
    "ARSFP1 RNA"
  ],
  "FAM187B": [
    "FAM187B CNV",
    "FAM187B RNA"
  ],
  "OSR1": [
    "OSR1 CNV",
    "OSR1 RNA"
  ],
  "COL1A2": [
    "COL1A2 CNV",
    "COL1A2 RNA",
    "COL1A2 Proteo"
  ],
  "HTN3": [
    "HTN3 CNV",
    "HTN3 RNA",
    "HTN3 Proteo"
  ],
  "UBE2V1P6": [
    "UBE2V1P6 CNV",
    "UBE2V1P6 RNA"
  ],
  "UHRF2P1": [
    "UHRF2P1 CNV",
    "UHRF2P1 RNA"
  ],
  "CELA3B": [
    "CELA3B CNV",
    "CELA3B RNA"
  ],
  "IFNA7": [
    "IFNA7 CNV",
    "IFNA7 RNA"
  ],
  "MAGEA5P": [
    "MAGEA5P CNV",
    "MAGEA5P RNA"
  ],
  "OVGP1": [
    "OVGP1 CNV",
    "OVGP1 RNA"
  ],
  "SMAD9": [
    "SMAD9 CNV",
    "SMAD9 RNA"
  ],
  "C3orf33": [
    "C3orf33 CNV",
    "C3orf33 RNA",
    "C3orf33 Proteo"
  ],
  "RAC1": [
    "RAC1 CNV",
    "RAC1 RNA",
    "RAC1 Proteo"
  ],
  "FBXL14": [
    "FBXL14 CNV",
    "FBXL14 RNA"
  ],
  "PLA2G7": [
    "PLA2G7 CNV",
    "PLA2G7 RNA",
    "PLA2G7 Proteo"
  ],
  "UBXN7": [
    "UBXN7 CNV",
    "UBXN7 RNA",
    "UBXN7 Proteo"
  ],
  "MTHFS": [
    "MTHFS CNV",
    "MTHFS RNA",
    "MTHFS Proteo"
  ],
  "PGBD1": [
    "PGBD1 CNV",
    "PGBD1 RNA",
    "PGBD1 Proteo"
  ],
  "KPNA5": [
    "KPNA5 CNV",
    "KPNA5 RNA",
    "KPNA5 Proteo"
  ],
  "CCDC12P1": [
    "CCDC12P1 CNV",
    "CCDC12P1 RNA"
  ],
  "OOSP1P1": [
    "OOSP1P1 CNV",
    "OOSP1P1 RNA"
  ],
  "ALS2CL": [
    "ALS2CL CNV",
    "ALS2CL RNA",
    "ALS2CL Proteo"
  ],
  "SMIM42": [
    "SMIM42 CNV",
    "SMIM42 RNA"
  ],
  "FBN1": [
    "FBN1 CNV",
    "FBN1 RNA",
    "FBN1 Proteo"
  ],
  "SYNE3": [
    "SYNE3 CNV",
    "SYNE3 RNA",
    "SYNE3 Proteo"
  ],
  "MGST2": [
    "MGST2 CNV",
    "MGST2 RNA",
    "MGST2 Proteo"
  ],
  "CRPP1": [
    "CRPP1 CNV",
    "CRPP1 RNA"
  ],
  "TOX2": [
    "TOX2 CNV",
    "TOX2 RNA",
    "TOX2 Proteo"
  ],
  "PRSS3P3": [
    "PRSS3P3 CNV",
    "PRSS3P3 RNA"
  ],
  "OXR1": [
    "OXR1 CNV",
    "OXR1 RNA",
    "OXR1 Proteo"
  ],
  "SAMD11P1": [
    "SAMD11P1 CNV",
    "SAMD11P1 RNA"
  ],
  "AATF": [
    "AATF CNV",
    "AATF RNA",
    "AATF Proteo"
  ],
  "ADGRG2": [
    "ADGRG2 CNV",
    "ADGRG2 RNA",
    "ADGRG2 Proteo"
  ],
  "CXCL13": [
    "CXCL13 CNV",
    "CXCL13 RNA",
    "CXCL13 Proteo"
  ],
  "MTND5P15": [
    "MTND5P15 CNV",
    "MTND5P15 RNA"
  ],
  "RFLNA": [
    "RFLNA CNV",
    "RFLNA RNA",
    "RFLNA Proteo"
  ],
  "GNA11": [
    "GNA11 CNV",
    "GNA11 RNA",
    "GNA11 Proteo"
  ],
  "CCNG2P1": [
    "CCNG2P1 CNV",
    "CCNG2P1 RNA"
  ],
  "CA9": [
    "CA9 CNV",
    "CA9 RNA",
    "CA9 Proteo"
  ],
  "CCDC107": [
    "CCDC107 CNV",
    "CCDC107 RNA"
  ],
  "RPL22P19": [
    "RPL22P19 CNV",
    "RPL22P19 RNA"
  ],
  "CEBPZOS": [
    "CEBPZOS CNV",
    "CEBPZOS RNA",
    "CEBPZOS Proteo"
  ],
  "SP3P": [
    "SP3P CNV",
    "SP3P RNA"
  ],
  "CNOT11": [
    "CNOT11 CNV",
    "CNOT11 RNA",
    "CNOT11 Proteo"
  ],
  "IGBP1P2": [
    "IGBP1P2 CNV",
    "IGBP1P2 RNA",
    "IGBP1P2 Proteo"
  ],
  "OR51A5P": [
    "OR51A5P CNV",
    "OR51A5P RNA"
  ],
  "DGKK": [
    "DGKK CNV",
    "DGKK RNA"
  ],
  "ARHGAP1": [
    "ARHGAP1 CNV",
    "ARHGAP1 RNA",
    "ARHGAP1 Proteo"
  ],
  "AP3D1": [
    "AP3D1 CNV",
    "AP3D1 RNA",
    "AP3D1 Proteo"
  ],
  "BRCA2": [
    "BRCA2 CNV",
    "BRCA2 RNA",
    "BRCA2 Proteo"
  ],
  "LCE1C": [
    "LCE1C CNV",
    "LCE1C RNA"
  ],
  "AKR7A2P2": [
    "AKR7A2P2 CNV",
    "AKR7A2P2 RNA"
  ],
  "PHB1P21": [
    "PHB1P21 CNV",
    "PHB1P21 RNA"
  ],
  "CENPNP1": [
    "CENPNP1 CNV",
    "CENPNP1 RNA"
  ],
  "SHISA3": [
    "SHISA3 CNV",
    "SHISA3 RNA"
  ],
  "TLR12P": [
    "TLR12P CNV",
    "TLR12P RNA"
  ],
  "RAB15": [
    "RAB15 CNV",
    "RAB15 RNA",
    "RAB15 Proteo"
  ],
  "COQ5": [
    "COQ5 CNV",
    "COQ5 RNA",
    "COQ5 Proteo"
  ],
  "MTCO3P12": [
    "MTCO3P12 CNV",
    "MTCO3P12 RNA"
  ],
  "LHFPL7": [
    "LHFPL7 CNV",
    "LHFPL7 RNA"
  ],
  "ZNF875": [
    "ZNF875 CNV",
    "ZNF875 RNA",
    "ZNF875 Proteo"
  ],
  "PPIAP67": [
    "PPIAP67 CNV",
    "PPIAP67 RNA"
  ],
  "DNAJC14": [
    "DNAJC14 CNV",
    "DNAJC14 RNA",
    "DNAJC14 Proteo"
  ],
  "USP10": [
    "USP10 CNV",
    "USP10 RNA",
    "USP10 Proteo"
  ],
  "HERPUD1": [
    "HERPUD1 CNV",
    "HERPUD1 RNA",
    "HERPUD1 Proteo"
  ],
  "MTND3P21": [
    "MTND3P21 CNV",
    "MTND3P21 RNA"
  ],
  "UBE2HP1": [
    "UBE2HP1 CNV",
    "UBE2HP1 RNA"
  ],
  "ITGB7": [
    "ITGB7 CNV",
    "ITGB7 RNA",
    "ITGB7 Proteo"
  ],
  "PAG1": [
    "PAG1 CNV",
    "PAG1 RNA",
    "PAG1 Proteo"
  ],
  "SF3B3": [
    "SF3B3 CNV",
    "SF3B3 RNA",
    "SF3B3 Proteo"
  ],
  "DBF4P1": [
    "DBF4P1 CNV",
    "DBF4P1 RNA"
  ],
  "SUB1P1": [
    "SUB1P1 CNV",
    "SUB1P1 RNA"
  ],
  "TRIM11": [
    "TRIM11 CNV",
    "TRIM11 RNA",
    "TRIM11 Proteo"
  ],
  "SPOPL": [
    "SPOPL CNV",
    "SPOPL RNA"
  ],
  "SYNE2": [
    "SYNE2 CNV",
    "SYNE2 RNA",
    "SYNE2 Proteo"
  ],
  "LENEP": [
    "LENEP CNV",
    "LENEP RNA"
  ],
  "IGLV9-49": [
    "IGLV9-49 Proteo"
  ],
  "CSP2": [
    "CSP2 CNV",
    "CSP2 RNA"
  ],
  "ANKRD30BL": [
    "ANKRD30BL CNV",
    "ANKRD30BL RNA"
  ],
  "PDCL2": [
    "PDCL2 CNV",
    "PDCL2 RNA"
  ],
  "NLGN1": [
    "NLGN1 CNV",
    "NLGN1 RNA",
    "NLGN1 Proteo"
  ],
  "KRT18P58": [
    "KRT18P58 CNV",
    "KRT18P58 RNA"
  ],
  "TMEM26": [
    "TMEM26 CNV",
    "TMEM26 RNA",
    "TMEM26 Proteo"
  ],
  "HNRNPA1P15": [
    "HNRNPA1P15 CNV",
    "HNRNPA1P15 RNA"
  ],
  "RPS10P16": [
    "RPS10P16 CNV",
    "RPS10P16 RNA"
  ],
  "CPSF4L": [
    "CPSF4L CNV",
    "CPSF4L RNA"
  ],
  "MTR": [
    "MTR CNV",
    "MTR RNA",
    "MTR Proteo"
  ],
  "FAM174C": [
    "FAM174C CNV",
    "FAM174C RNA"
  ],
  "PHF1": [
    "PHF1 CNV",
    "PHF1 RNA",
    "PHF1 Proteo"
  ],
  "MTF2": [
    "MTF2 CNV",
    "MTF2 RNA",
    "MTF2 Proteo"
  ],
  "PLEKHA5": [
    "PLEKHA5 CNV",
    "PLEKHA5 RNA",
    "PLEKHA5 Proteo"
  ],
  "PGLYRP2": [
    "PGLYRP2 CNV",
    "PGLYRP2 RNA",
    "PGLYRP2 Proteo"
  ],
  "ANGPTL7": [
    "ANGPTL7 CNV",
    "ANGPTL7 RNA",
    "ANGPTL7 Proteo"
  ],
  "TEX22": [
    "TEX22 CNV",
    "TEX22 RNA"
  ],
  "APOF": [
    "APOF CNV",
    "APOF RNA",
    "APOF Proteo"
  ],
  "EIF4EP4": [
    "EIF4EP4 CNV",
    "EIF4EP4 RNA"
  ],
  "CLEC6A": [
    "CLEC6A CNV",
    "CLEC6A RNA"
  ],
  "AUP1": [
    "AUP1 CNV",
    "AUP1 RNA",
    "AUP1 Proteo"
  ],
  "DMRT3": [
    "DMRT3 CNV",
    "DMRT3 RNA"
  ],
  "CTF1": [
    "CTF1 CNV",
    "CTF1 RNA",
    "CTF1 Proteo"
  ],
  "COL27A1": [
    "COL27A1 CNV",
    "COL27A1 RNA"
  ],
  "ACTL7A": [
    "ACTL7A CNV",
    "ACTL7A RNA"
  ],
  "GLYATL1P4": [
    "GLYATL1P4 CNV",
    "GLYATL1P4 RNA"
  ],
  "SIAH2": [
    "SIAH2 CNV",
    "SIAH2 RNA"
  ],
  "RNA5SP260": [
    "RNA5SP260 CNV",
    "RNA5SP260 RNA"
  ],
  "BRSK2": [
    "BRSK2 CNV",
    "BRSK2 RNA",
    "BRSK2 Proteo"
  ],
  "TAF11L8": [
    "TAF11L8 CNV",
    "TAF11L8 RNA"
  ],
  "ICE2P1": [
    "ICE2P1 CNV",
    "ICE2P1 RNA"
  ],
  "HELB": [
    "HELB CNV",
    "HELB RNA",
    "HELB Proteo"
  ],
  "PRKAG1": [
    "PRKAG1 CNV",
    "PRKAG1 RNA",
    "PRKAG1 Proteo"
  ],
  "OR6K1P": [
    "OR6K1P CNV",
    "OR6K1P RNA"
  ],
  "ICMT": [
    "ICMT CNV",
    "ICMT RNA",
    "ICMT Proteo"
  ],
  "TOR3A": [
    "TOR3A CNV",
    "TOR3A RNA",
    "TOR3A Proteo"
  ],
  "SEZ6L": [
    "SEZ6L CNV",
    "SEZ6L RNA"
  ],
  "C2orf80": [
    "C2orf80 CNV",
    "C2orf80 RNA"
  ],
  "SELENOKP3": [
    "SELENOKP3 CNV",
    "SELENOKP3 RNA"
  ],
  "WARS2": [
    "WARS2 CNV",
    "WARS2 RNA",
    "WARS2 Proteo"
  ],
  "RPS26P15": [
    "RPS26P15 CNV",
    "RPS26P15 RNA"
  ],
  "RAD54B": [
    "RAD54B CNV",
    "RAD54B RNA",
    "RAD54B Proteo"
  ],
  "ZNF662": [
    "ZNF662 CNV",
    "ZNF662 RNA"
  ],
  "NUTM2G": [
    "NUTM2G CNV",
    "NUTM2G RNA"
  ],
  "NFYAP1": [
    "NFYAP1 CNV",
    "NFYAP1 RNA"
  ],
  "RNA5SP444": [
    "RNA5SP444 CNV",
    "RNA5SP444 RNA"
  ],
  "ARL11": [
    "ARL11 CNV",
    "ARL11 RNA",
    "ARL11 Proteo"
  ],
  "IFNL2": [
    "IFNL2 CNV",
    "IFNL2 RNA"
  ],
  "ALDH16A1": [
    "ALDH16A1 CNV",
    "ALDH16A1 RNA",
    "ALDH16A1 Proteo"
  ],
  "BCL2L2-PABPN1": [
    "BCL2L2-PABPN1 Proteo"
  ],
  "CDC42EP4": [
    "CDC42EP4 CNV",
    "CDC42EP4 RNA",
    "CDC42EP4 Proteo"
  ],
  "RPL26P20": [
    "RPL26P20 CNV",
    "RPL26P20 RNA"
  ],
  "ZNF747": [
    "ZNF747 CNV",
    "ZNF747 RNA"
  ],
  "UBL7": [
    "UBL7 CNV",
    "UBL7 RNA",
    "UBL7 Proteo"
  ],
  "HSPD1P15": [
    "HSPD1P15 CNV",
    "HSPD1P15 RNA"
  ],
  "UBBP4": [
    "UBBP4 CNV",
    "UBBP4 RNA"
  ],
  "KRT18P33": [
    "KRT18P33 CNV",
    "KRT18P33 RNA"
  ],
  "CWH43": [
    "CWH43 CNV",
    "CWH43 RNA",
    "CWH43 Proteo"
  ],
  "USP9YP19": [
    "USP9YP19 CNV",
    "USP9YP19 RNA"
  ],
  "RNA5SP376": [
    "RNA5SP376 CNV",
    "RNA5SP376 RNA"
  ],
  "FSHR": [
    "FSHR CNV",
    "FSHR RNA"
  ],
  "EIF2S2P7": [
    "EIF2S2P7 CNV",
    "EIF2S2P7 RNA"
  ],
  "SLC25A40": [
    "SLC25A40 CNV",
    "SLC25A40 RNA",
    "SLC25A40 Proteo"
  ],
  "IL10RA": [
    "IL10RA CNV",
    "IL10RA RNA"
  ],
  "PRYP5": [
    "PRYP5 CNV",
    "PRYP5 RNA"
  ],
  "UBE4B": [
    "UBE4B CNV",
    "UBE4B RNA",
    "UBE4B Proteo"
  ],
  "TRPV3": [
    "TRPV3 CNV",
    "TRPV3 RNA"
  ],
  "GSTO2": [
    "GSTO2 CNV",
    "GSTO2 RNA"
  ],
  "CSMD1": [
    "CSMD1 CNV",
    "CSMD1 RNA"
  ],
  "ADAM5": [
    "ADAM5 CNV",
    "ADAM5 RNA"
  ],
  "RNA5SP176": [
    "RNA5SP176 CNV",
    "RNA5SP176 RNA"
  ],
  "XBP1": [
    "XBP1 CNV",
    "XBP1 RNA"
  ],
  "TMPRSS11B": [
    "TMPRSS11B CNV",
    "TMPRSS11B RNA"
  ],
  "GSDMB": [
    "GSDMB CNV",
    "GSDMB RNA",
    "GSDMB Proteo"
  ],
  "RPS10P7": [
    "RPS10P7 CNV",
    "RPS10P7 RNA"
  ],
  "LRAT": [
    "LRAT CNV",
    "LRAT RNA"
  ],
  "GTF2IP13": [
    "GTF2IP13 CNV",
    "GTF2IP13 RNA"
  ],
  "SEPTIN8": [
    "SEPTIN8 CNV",
    "SEPTIN8 RNA",
    "SEPTIN8 Proteo"
  ],
  "MLF2": [
    "MLF2 CNV",
    "MLF2 RNA",
    "MLF2 Proteo"
  ],
  "CNGA4": [
    "CNGA4 CNV",
    "CNGA4 RNA"
  ],
  "VSIG10L": [
    "VSIG10L CNV",
    "VSIG10L RNA",
    "VSIG10L Proteo"
  ],
  "ADCY7": [
    "ADCY7 CNV",
    "ADCY7 RNA",
    "ADCY7 Proteo"
  ],
  "CRMP1": [
    "CRMP1 CNV",
    "CRMP1 RNA",
    "CRMP1 Proteo"
  ],
  "ZNF90P2": [
    "ZNF90P2 CNV",
    "ZNF90P2 RNA"
  ],
  "C2orf50": [
    "C2orf50 CNV",
    "C2orf50 RNA"
  ],
  "PDE11A": [
    "PDE11A CNV",
    "PDE11A RNA"
  ],
  "BEND5": [
    "BEND5 CNV",
    "BEND5 RNA",
    "BEND5 Proteo"
  ],
  "HNRNPA1P33": [
    "HNRNPA1P33 CNV",
    "HNRNPA1P33 RNA"
  ],
  "GEMIN7": [
    "GEMIN7 CNV",
    "GEMIN7 RNA",
    "GEMIN7 Proteo"
  ],
  "GUCY1A2": [
    "GUCY1A2 CNV",
    "GUCY1A2 RNA",
    "GUCY1A2 Proteo"
  ],
  "OR6E1P": [
    "OR6E1P CNV",
    "OR6E1P RNA"
  ],
  "MS4A7": [
    "MS4A7 CNV",
    "MS4A7 RNA"
  ],
  "IL1F10": [
    "IL1F10 CNV",
    "IL1F10 RNA"
  ],
  "TEFM": [
    "TEFM CNV",
    "TEFM RNA",
    "TEFM Proteo"
  ],
  "ARPP19P1": [
    "ARPP19P1 CNV",
    "ARPP19P1 RNA"
  ],
  "PEX12": [
    "PEX12 CNV",
    "PEX12 RNA",
    "PEX12 Proteo"
  ],
  "PLCL1": [
    "PLCL1 CNV",
    "PLCL1 RNA",
    "PLCL1 Proteo"
  ],
  "NUBP2": [
    "NUBP2 CNV",
    "NUBP2 RNA",
    "NUBP2 Proteo"
  ],
  "ABCA2": [
    "ABCA2 CNV",
    "ABCA2 RNA",
    "ABCA2 Proteo"
  ],
  "GPR55": [
    "GPR55 CNV",
    "GPR55 RNA"
  ],
  "RPL7AP55": [
    "RPL7AP55 CNV",
    "RPL7AP55 RNA"
  ],
  "MEGF11": [
    "MEGF11 CNV",
    "MEGF11 RNA"
  ],
  "SLC35E4": [
    "SLC35E4 CNV",
    "SLC35E4 RNA"
  ],
  "C9orf85": [
    "C9orf85 CNV",
    "C9orf85 RNA",
    "C9orf85 Proteo"
  ],
  "ATRX": [
    "ATRX CNV",
    "ATRX RNA",
    "ATRX Proteo"
  ],
  "SPRR4": [
    "SPRR4 CNV",
    "SPRR4 RNA",
    "SPRR4 Proteo"
  ],
  "RPL7P52": [
    "RPL7P52 CNV",
    "RPL7P52 RNA"
  ],
  "MTX1P1": [
    "MTX1P1 CNV",
    "MTX1P1 RNA"
  ],
  "AHCYP5": [
    "AHCYP5 CNV",
    "AHCYP5 RNA"
  ],
  "TRIM75": [
    "TRIM75 CNV",
    "TRIM75 RNA"
  ],
  "ZNF654": [
    "ZNF654 CNV",
    "ZNF654 RNA",
    "ZNF654 Proteo"
  ],
  "SYNCRIP": [
    "SYNCRIP CNV",
    "SYNCRIP RNA",
    "SYNCRIP Proteo"
  ],
  "PDE4C": [
    "PDE4C CNV",
    "PDE4C RNA"
  ],
  "TERF1P3": [
    "TERF1P3 CNV",
    "TERF1P3 RNA"
  ],
  "MFSD14A": [
    "MFSD14A CNV",
    "MFSD14A RNA"
  ],
  "ELOCP11": [
    "ELOCP11 CNV",
    "ELOCP11 RNA"
  ],
  "FOXD4L1": [
    "FOXD4L1 CNV",
    "FOXD4L1 RNA"
  ],
  "SCFD2": [
    "SCFD2 CNV",
    "SCFD2 RNA",
    "SCFD2 Proteo"
  ],
  "RAB6A": [
    "RAB6A CNV",
    "RAB6A RNA",
    "RAB6A Proteo"
  ],
  "CPSF6": [
    "CPSF6 CNV",
    "CPSF6 RNA",
    "CPSF6 Proteo"
  ],
  "ADTRP": [
    "ADTRP CNV",
    "ADTRP RNA"
  ],
  "SDCBP": [
    "SDCBP CNV",
    "SDCBP RNA",
    "SDCBP Proteo"
  ],
  "RBMX2P1": [
    "RBMX2P1 CNV",
    "RBMX2P1 RNA"
  ],
  "F8": [
    "F8 CNV",
    "F8 RNA"
  ],
  "SNX19": [
    "SNX19 CNV",
    "SNX19 RNA",
    "SNX19 Proteo"
  ],
  "CTTNBP2NL": [
    "CTTNBP2NL CNV",
    "CTTNBP2NL RNA",
    "CTTNBP2NL Proteo"
  ],
  "PDCD6P1": [
    "PDCD6P1 CNV",
    "PDCD6P1 RNA"
  ],
  "RBBP6": [
    "RBBP6 CNV",
    "RBBP6 RNA",
    "RBBP6 Proteo"
  ],
  "RPS17P11": [
    "RPS17P11 CNV",
    "RPS17P11 RNA"
  ],
  "PSME2P3": [
    "PSME2P3 CNV",
    "PSME2P3 RNA"
  ],
  "COG2": [
    "COG2 CNV",
    "COG2 RNA",
    "COG2 Proteo"
  ],
  "BOD1P2": [
    "BOD1P2 CNV",
    "BOD1P2 RNA"
  ],
  "ODAD4": [
    "ODAD4 CNV",
    "ODAD4 RNA"
  ],
  "TSEN15P3": [
    "TSEN15P3 CNV",
    "TSEN15P3 RNA"
  ],
  "RNA5SP128": [
    "RNA5SP128 CNV",
    "RNA5SP128 RNA"
  ],
  "RNA5-8SP7": [
    "RNA5-8SP7 CNV",
    "RNA5-8SP7 RNA"
  ],
  "KRT18P12": [
    "KRT18P12 CNV",
    "KRT18P12 RNA"
  ],
  "TRAPPC2P9": [
    "TRAPPC2P9 CNV",
    "TRAPPC2P9 RNA"
  ],
  "RPL10": [
    "RPL10 CNV",
    "RPL10 RNA",
    "RPL10 Proteo"
  ],
  "IGHV3-73": [
    "IGHV3-73 Proteo"
  ],
  "TMEM178A": [
    "TMEM178A CNV",
    "TMEM178A RNA"
  ],
  "DIS3L2P1": [
    "DIS3L2P1 CNV",
    "DIS3L2P1 RNA"
  ],
  "KATNBL1P3": [
    "KATNBL1P3 CNV",
    "KATNBL1P3 RNA"
  ],
  "KRTAP19-9P": [
    "KRTAP19-9P CNV",
    "KRTAP19-9P RNA"
  ],
  "GORASP2": [
    "GORASP2 CNV",
    "GORASP2 RNA",
    "GORASP2 Proteo"
  ],
  "TMEM150C": [
    "TMEM150C CNV",
    "TMEM150C RNA"
  ],
  "ZNF487": [
    "ZNF487 CNV",
    "ZNF487 RNA"
  ],
  "DPPA2P4": [
    "DPPA2P4 CNV",
    "DPPA2P4 RNA"
  ],
  "CCT6B": [
    "CCT6B CNV",
    "CCT6B RNA",
    "CCT6B Proteo"
  ],
  "MRPS22P1": [
    "MRPS22P1 CNV",
    "MRPS22P1 RNA"
  ],
  "HMCES": [
    "HMCES CNV",
    "HMCES RNA",
    "HMCES Proteo"
  ],
  "GAS2L1P2": [
    "GAS2L1P2 CNV",
    "GAS2L1P2 RNA"
  ],
  "WIPF1": [
    "WIPF1 CNV",
    "WIPF1 RNA",
    "WIPF1 Proteo"
  ],
  "OR6C64P": [
    "OR6C64P CNV",
    "OR6C64P RNA"
  ],
  "RNA5SP495": [
    "RNA5SP495 CNV",
    "RNA5SP495 RNA"
  ],
  "KRTAP4-8": [
    "KRTAP4-8 CNV",
    "KRTAP4-8 RNA"
  ],
  "LTA4H": [
    "LTA4H CNV",
    "LTA4H RNA",
    "LTA4H Proteo"
  ],
  "MTCO1P35": [
    "MTCO1P35 CNV",
    "MTCO1P35 RNA"
  ],
  "SHOC1": [
    "SHOC1 CNV",
    "SHOC1 RNA"
  ],
  "OR1A2": [
    "OR1A2 CNV",
    "OR1A2 RNA"
  ],
  "UBE2Q2P1": [
    "UBE2Q2P1 CNV",
    "UBE2Q2P1 RNA"
  ],
  "CSTP1": [
    "CSTP1 CNV",
    "CSTP1 RNA"
  ],
  "EPHA2": [
    "EPHA2 CNV",
    "EPHA2 RNA",
    "EPHA2 Proteo"
  ],
  "ELOCP4": [
    "ELOCP4 CNV",
    "ELOCP4 RNA"
  ],
  "CISH": [
    "CISH CNV",
    "CISH RNA"
  ],
  "FRG1BP": [
    "FRG1BP CNV",
    "FRG1BP RNA"
  ],
  "MOK": [
    "MOK CNV",
    "MOK RNA"
  ],
  "ETFB": [
    "ETFB CNV",
    "ETFB RNA",
    "ETFB Proteo"
  ],
  "SLC2A10": [
    "SLC2A10 CNV",
    "SLC2A10 RNA",
    "SLC2A10 Proteo"
  ],
  "RIMS4": [
    "RIMS4 CNV",
    "RIMS4 RNA"
  ],
  "ADAMTS17": [
    "ADAMTS17 CNV",
    "ADAMTS17 RNA"
  ],
  "ERMAP": [
    "ERMAP CNV",
    "ERMAP RNA"
  ],
  "PRPF4BP1": [
    "PRPF4BP1 CNV",
    "PRPF4BP1 RNA"
  ],
  "DHX35": [
    "DHX35 CNV",
    "DHX35 RNA",
    "DHX35 Proteo"
  ],
  "FIP1L1": [
    "FIP1L1 CNV",
    "FIP1L1 RNA",
    "FIP1L1 Proteo"
  ],
  "WDR25": [
    "WDR25 CNV",
    "WDR25 RNA",
    "WDR25 Proteo"
  ],
  "KCNK9": [
    "KCNK9 CNV",
    "KCNK9 RNA"
  ],
  "UBA52": [
    "UBA52 CNV",
    "UBA52 RNA",
    "UBA52 Proteo"
  ],
  "RPS24P18": [
    "RPS24P18 CNV",
    "RPS24P18 RNA"
  ],
  "NPM1P35": [
    "NPM1P35 CNV",
    "NPM1P35 RNA"
  ],
  "GBP1P1": [
    "GBP1P1 CNV",
    "GBP1P1 RNA"
  ],
  "VN1R9P": [
    "VN1R9P CNV",
    "VN1R9P RNA"
  ],
  "CDH11": [
    "CDH11 CNV",
    "CDH11 RNA",
    "CDH11 Proteo"
  ],
  "RPL35AP5": [
    "RPL35AP5 CNV",
    "RPL35AP5 RNA"
  ],
  "F8A1": [
    "F8A1 CNV",
    "F8A1 RNA"
  ],
  "NBEAP2": [
    "NBEAP2 CNV",
    "NBEAP2 RNA"
  ],
  "PPP4R2": [
    "PPP4R2 CNV",
    "PPP4R2 RNA",
    "PPP4R2 Proteo"
  ],
  "PRDM13": [
    "PRDM13 CNV",
    "PRDM13 RNA"
  ],
  "AK7": [
    "AK7 CNV",
    "AK7 RNA",
    "AK7 Proteo"
  ],
  "SLC24A3": [
    "SLC24A3 CNV",
    "SLC24A3 RNA"
  ],
  "PON2": [
    "PON2 CNV",
    "PON2 RNA",
    "PON2 Proteo"
  ],
  "PITPNC1": [
    "PITPNC1 CNV",
    "PITPNC1 RNA",
    "PITPNC1 Proteo"
  ],
  "PTPRA": [
    "PTPRA CNV",
    "PTPRA RNA",
    "PTPRA Proteo"
  ],
  "SMPD4P1": [
    "SMPD4P1 CNV",
    "SMPD4P1 RNA"
  ],
  "OR2Y1": [
    "OR2Y1 CNV",
    "OR2Y1 RNA"
  ],
  "RPS2": [
    "RPS2 CNV",
    "RPS2 RNA",
    "RPS2 Proteo"
  ],
  "RAB18": [
    "RAB18 CNV",
    "RAB18 RNA",
    "RAB18 Proteo"
  ],
  "SLC16A14": [
    "SLC16A14 CNV",
    "SLC16A14 RNA"
  ],
  "MRPL42P4": [
    "MRPL42P4 CNV",
    "MRPL42P4 RNA"
  ],
  "DEF6": [
    "DEF6 CNV",
    "DEF6 RNA",
    "DEF6 Proteo"
  ],
  "ABHD8": [
    "ABHD8 CNV",
    "ABHD8 RNA"
  ],
  "SOD1P3": [
    "SOD1P3 CNV",
    "SOD1P3 RNA"
  ],
  "H2BL1P": [
    "H2BL1P CNV",
    "H2BL1P RNA"
  ],
  "CTSV": [
    "CTSV CNV",
    "CTSV RNA",
    "CTSV Proteo"
  ],
  "IGLVI-20": [
    "IGLVI-20 CNV",
    "IGLVI-20 RNA"
  ],
  "ADORA1": [
    "ADORA1 CNV",
    "ADORA1 RNA"
  ],
  "XRCC6": [
    "XRCC6 CNV",
    "XRCC6 RNA",
    "XRCC6 Proteo"
  ],
  "MS4A19P": [
    "MS4A19P CNV",
    "MS4A19P RNA"
  ],
  "NUDT12": [
    "NUDT12 CNV",
    "NUDT12 RNA",
    "NUDT12 Proteo"
  ],
  "DHTKD1": [
    "DHTKD1 CNV",
    "DHTKD1 RNA",
    "DHTKD1 Proteo"
  ],
  "GGA3": [
    "GGA3 CNV",
    "GGA3 RNA",
    "GGA3 Proteo"
  ],
  "DUX4L5": [
    "DUX4L5 CNV",
    "DUX4L5 RNA"
  ],
  "CDC27P2": [
    "CDC27P2 CNV",
    "CDC27P2 RNA"
  ],
  "TUBA1A": [
    "TUBA1A CNV",
    "TUBA1A RNA",
    "TUBA1A Proteo"
  ],
  "USP17L18": [
    "USP17L18 CNV",
    "USP17L18 RNA"
  ],
  "ATP6V1H": [
    "ATP6V1H CNV",
    "ATP6V1H RNA",
    "ATP6V1H Proteo"
  ],
  "C16orf87": [
    "C16orf87 CNV",
    "C16orf87 RNA"
  ],
  "KCNJ3": [
    "KCNJ3 CNV",
    "KCNJ3 RNA"
  ],
  "RNA5SP154": [
    "RNA5SP154 CNV",
    "RNA5SP154 RNA"
  ],
  "TUBB2BP1": [
    "TUBB2BP1 CNV",
    "TUBB2BP1 RNA"
  ],
  "KATNBL1P6": [
    "KATNBL1P6 CNV",
    "KATNBL1P6 RNA"
  ],
  "TDRD5": [
    "TDRD5 CNV",
    "TDRD5 RNA"
  ],
  "SLC6A10P": [
    "SLC6A10P CNV",
    "SLC6A10P RNA"
  ],
  "C9orf24": [
    "C9orf24 CNV",
    "C9orf24 RNA"
  ],
  "NDNF": [
    "NDNF CNV",
    "NDNF RNA"
  ],
  "IGKV2D-14": [
    "IGKV2D-14 CNV",
    "IGKV2D-14 RNA"
  ],
  "SETD2": [
    "SETD2 CNV",
    "SETD2 RNA",
    "SETD2 Proteo"
  ],
  "MYEF2": [
    "MYEF2 CNV",
    "MYEF2 RNA",
    "MYEF2 Proteo"
  ],
  "MICAL3": [
    "MICAL3 CNV",
    "MICAL3 RNA",
    "MICAL3 Proteo"
  ],
  "FUT5": [
    "FUT5 CNV",
    "FUT5 RNA",
    "FUT5 Proteo"
  ],
  "KRTAP6-3": [
    "KRTAP6-3 CNV",
    "KRTAP6-3 RNA"
  ],
  "DPYS": [
    "DPYS CNV",
    "DPYS RNA",
    "DPYS Proteo"
  ],
  "JRKL": [
    "JRKL CNV",
    "JRKL RNA",
    "JRKL Proteo"
  ],
  "SLC18A3": [
    "SLC18A3 CNV",
    "SLC18A3 RNA"
  ],
  "SPANXA1": [
    "SPANXA1 CNV",
    "SPANXA1 RNA"
  ],
  "DCUN1D5": [
    "DCUN1D5 CNV",
    "DCUN1D5 RNA",
    "DCUN1D5 Proteo"
  ],
  "CYCSP48": [
    "CYCSP48 CNV",
    "CYCSP48 RNA"
  ],
  "CDKN2C": [
    "CDKN2C CNV",
    "CDKN2C RNA",
    "CDKN2C Proteo"
  ],
  "SYCE3": [
    "SYCE3 CNV",
    "SYCE3 RNA"
  ],
  "ROPN1": [
    "ROPN1 CNV",
    "ROPN1 RNA"
  ],
  "ABHD17AP8": [
    "ABHD17AP8 CNV",
    "ABHD17AP8 RNA"
  ],
  "MTND1P22": [
    "MTND1P22 CNV",
    "MTND1P22 RNA"
  ],
  "CCDC73": [
    "CCDC73 CNV",
    "CCDC73 RNA"
  ],
  "PIGG": [
    "PIGG CNV",
    "PIGG RNA",
    "PIGG Proteo"
  ],
  "LRRD1": [
    "LRRD1 CNV",
    "LRRD1 RNA"
  ],
  "WASH8P": [
    "WASH8P CNV",
    "WASH8P RNA"
  ],
  "LGALS14": [
    "LGALS14 CNV",
    "LGALS14 RNA"
  ],
  "VENTXP1": [
    "VENTXP1 CNV",
    "VENTXP1 RNA"
  ],
  "PRG2": [
    "PRG2 CNV",
    "PRG2 RNA",
    "PRG2 Proteo"
  ],
  "TPM4P1": [
    "TPM4P1 CNV",
    "TPM4P1 RNA"
  ],
  "C2orf49": [
    "C2orf49 CNV",
    "C2orf49 RNA",
    "C2orf49 Proteo"
  ],
  "PGK2": [
    "PGK2 CNV",
    "PGK2 RNA",
    "PGK2 Proteo"
  ],
  "HDGFP1": [
    "HDGFP1 CNV",
    "HDGFP1 RNA"
  ],
  "C19orf85": [
    "C19orf85 CNV",
    "C19orf85 RNA"
  ],
  "RPL12P9": [
    "RPL12P9 CNV",
    "RPL12P9 RNA"
  ],
  "GPR3": [
    "GPR3 CNV",
    "GPR3 RNA"
  ],
  "DEFB104A": [
    "DEFB104A CNV",
    "DEFB104A RNA"
  ],
  "RABEPK": [
    "RABEPK CNV",
    "RABEPK RNA",
    "RABEPK Proteo"
  ],
  "AQP7P2": [
    "AQP7P2 CNV",
    "AQP7P2 RNA"
  ],
  "LRRC30": [
    "LRRC30 CNV",
    "LRRC30 RNA"
  ],
  "GSTA12P": [
    "GSTA12P CNV",
    "GSTA12P RNA"
  ],
  "ALOX15": [
    "ALOX15 CNV",
    "ALOX15 RNA",
    "ALOX15 Proteo"
  ],
  "ZDHHC7": [
    "ZDHHC7 CNV",
    "ZDHHC7 RNA",
    "ZDHHC7 Proteo"
  ],
  "ZNF500": [
    "ZNF500 CNV",
    "ZNF500 RNA"
  ],
  "LRCOL1": [
    "LRCOL1 CNV",
    "LRCOL1 RNA"
  ],
  "VAV3": [
    "VAV3 CNV",
    "VAV3 RNA",
    "VAV3 Proteo"
  ],
  "SLC45A1": [
    "SLC45A1 CNV",
    "SLC45A1 RNA"
  ],
  "RIOX2": [
    "RIOX2 CNV",
    "RIOX2 RNA",
    "RIOX2 Proteo"
  ],
  "NRL": [
    "NRL CNV",
    "NRL RNA"
  ],
  "AGBL1": [
    "AGBL1 CNV",
    "AGBL1 RNA"
  ],
  "OR5BM1P": [
    "OR5BM1P CNV",
    "OR5BM1P RNA"
  ],
  "NFE2L3": [
    "NFE2L3 CNV",
    "NFE2L3 RNA"
  ],
  "MYO1D": [
    "MYO1D CNV",
    "MYO1D RNA",
    "MYO1D Proteo"
  ],
  "SLC35E3": [
    "SLC35E3 CNV",
    "SLC35E3 RNA",
    "SLC35E3 Proteo"
  ],
  "NOC4L": [
    "NOC4L CNV",
    "NOC4L RNA",
    "NOC4L Proteo"
  ],
  "E2F2": [
    "E2F2 CNV",
    "E2F2 RNA"
  ],
  "MAGEA3": [
    "MAGEA3 CNV",
    "MAGEA3 RNA",
    "MAGEA3 Proteo"
  ],
  "RPAP2P1": [
    "RPAP2P1 CNV",
    "RPAP2P1 RNA"
  ],
  "FAM180B": [
    "FAM180B CNV",
    "FAM180B RNA",
    "FAM180B Proteo"
  ],
  "CACNA2D3": [
    "CACNA2D3 CNV",
    "CACNA2D3 RNA"
  ],
  "ZFR2": [
    "ZFR2 CNV",
    "ZFR2 RNA"
  ],
  "PIGH": [
    "PIGH CNV",
    "PIGH RNA",
    "PIGH Proteo"
  ],
  "DNAAF10": [
    "DNAAF10 CNV",
    "DNAAF10 RNA",
    "DNAAF10 Proteo"
  ],
  "IGKV1OR10-1": [
    "IGKV1OR10-1 CNV",
    "IGKV1OR10-1 RNA"
  ],
  "FAM86C1P": [
    "FAM86C1P CNV",
    "FAM86C1P RNA"
  ],
  "RPL26P37": [
    "RPL26P37 CNV",
    "RPL26P37 RNA"
  ],
  "MRM3P1": [
    "MRM3P1 CNV",
    "MRM3P1 RNA"
  ],
  "MRPS36P5": [
    "MRPS36P5 CNV",
    "MRPS36P5 RNA"
  ],
  "SNX6P1": [
    "SNX6P1 CNV",
    "SNX6P1 RNA"
  ],
  "RAD52": [
    "RAD52 CNV",
    "RAD52 RNA",
    "RAD52 Proteo"
  ],
  "TCTA": [
    "TCTA CNV",
    "TCTA RNA"
  ],
  "FAM86B3P": [
    "FAM86B3P CNV",
    "FAM86B3P RNA"
  ],
  "MTATP6P1": [
    "MTATP6P1 CNV",
    "MTATP6P1 RNA"
  ],
  "SLC35A4": [
    "SLC35A4 CNV",
    "SLC35A4 RNA",
    "SLC35A4 Proteo"
  ],
  "BMX": [
    "BMX CNV",
    "BMX RNA",
    "BMX Proteo"
  ],
  "MT1P3": [
    "MT1P3 CNV",
    "MT1P3 RNA"
  ],
  "PLD3": [
    "PLD3 CNV",
    "PLD3 RNA",
    "PLD3 Proteo"
  ],
  "AOX1": [
    "AOX1 CNV",
    "AOX1 RNA",
    "AOX1 Proteo"
  ],
  "AGRP": [
    "AGRP CNV",
    "AGRP RNA"
  ],
  "LLGL2": [
    "LLGL2 CNV",
    "LLGL2 RNA",
    "LLGL2 Proteo"
  ],
  "ITM2C": [
    "ITM2C CNV",
    "ITM2C RNA",
    "ITM2C Proteo"
  ],
  "OR2A15P": [
    "OR2A15P CNV",
    "OR2A15P RNA"
  ],
  "FA2H": [
    "FA2H CNV",
    "FA2H RNA",
    "FA2H Proteo"
  ],
  "IL1B": [
    "IL1B CNV",
    "IL1B RNA",
    "IL1B Proteo"
  ],
  "TPCN2": [
    "TPCN2 CNV",
    "TPCN2 RNA",
    "TPCN2 Proteo"
  ],
  "ENOPH1": [
    "ENOPH1 CNV",
    "ENOPH1 RNA",
    "ENOPH1 Proteo"
  ],
  "RIF1": [
    "RIF1 CNV",
    "RIF1 RNA",
    "RIF1 Proteo"
  ],
  "RPL21P110": [
    "RPL21P110 CNV",
    "RPL21P110 RNA"
  ],
  "LRRC61": [
    "LRRC61 CNV",
    "LRRC61 RNA"
  ],
  "OR52N1": [
    "OR52N1 CNV",
    "OR52N1 RNA"
  ],
  "MAP3K12": [
    "MAP3K12 CNV",
    "MAP3K12 RNA"
  ],
  "ZNRF3": [
    "ZNRF3 CNV",
    "ZNRF3 RNA"
  ],
  "TMEM97P2": [
    "TMEM97P2 CNV",
    "TMEM97P2 RNA"
  ],
  "KDELR1": [
    "KDELR1 CNV",
    "KDELR1 RNA",
    "KDELR1 Proteo"
  ],
  "TCIRG1": [
    "TCIRG1 CNV",
    "TCIRG1 RNA",
    "TCIRG1 Proteo"
  ],
  "PPP1R2C": [
    "PPP1R2C CNV",
    "PPP1R2C RNA"
  ],
  "METTL25B": [
    "METTL25B CNV",
    "METTL25B RNA",
    "METTL25B Proteo"
  ],
  "TPH2": [
    "TPH2 CNV",
    "TPH2 RNA"
  ],
  "RAD21L1": [
    "RAD21L1 CNV",
    "RAD21L1 RNA"
  ],
  "FNDC1": [
    "FNDC1 CNV",
    "FNDC1 RNA",
    "FNDC1 Proteo"
  ],
  "DEFB108C": [
    "DEFB108C CNV",
    "DEFB108C RNA"
  ],
  "OR2AK2": [
    "OR2AK2 CNV",
    "OR2AK2 RNA"
  ],
  "RPS15AP25": [
    "RPS15AP25 CNV",
    "RPS15AP25 RNA"
  ],
  "ACTR6": [
    "ACTR6 CNV",
    "ACTR6 RNA",
    "ACTR6 Proteo"
  ],
  "VN1R76P": [
    "VN1R76P CNV",
    "VN1R76P RNA"
  ],
  "KIF4A": [
    "KIF4A CNV",
    "KIF4A RNA",
    "KIF4A Proteo"
  ],
  "TMEM251P1": [
    "TMEM251P1 CNV",
    "TMEM251P1 RNA"
  ],
  "PPP1R26P2": [
    "PPP1R26P2 CNV",
    "PPP1R26P2 RNA"
  ],
  "GARIN4": [
    "GARIN4 CNV",
    "GARIN4 RNA"
  ],
  "CDRT15P9": [
    "CDRT15P9 CNV",
    "CDRT15P9 RNA"
  ],
  "PPM1M": [
    "PPM1M CNV",
    "PPM1M RNA",
    "PPM1M Proteo"
  ],
  "RPL37P3": [
    "RPL37P3 CNV",
    "RPL37P3 RNA"
  ],
  "ERI3": [
    "ERI3 CNV",
    "ERI3 RNA",
    "ERI3 Proteo"
  ],
  "MMP21": [
    "MMP21 CNV",
    "MMP21 RNA"
  ],
  "ADAMTS20": [
    "ADAMTS20 CNV",
    "ADAMTS20 RNA"
  ],
  "RTL4": [
    "RTL4 CNV",
    "RTL4 RNA"
  ],
  "FAM117B": [
    "FAM117B CNV",
    "FAM117B RNA",
    "FAM117B Proteo"
  ],
  "UNC13D": [
    "UNC13D CNV",
    "UNC13D RNA",
    "UNC13D Proteo"
  ],
  "FLRT2": [
    "FLRT2 CNV",
    "FLRT2 RNA",
    "FLRT2 Proteo"
  ],
  "HSD3B1": [
    "HSD3B1 CNV",
    "HSD3B1 RNA",
    "HSD3B1 Proteo"
  ],
  "RPL10AP5": [
    "RPL10AP5 CNV",
    "RPL10AP5 RNA"
  ],
  "PSMD1": [
    "PSMD1 CNV",
    "PSMD1 RNA",
    "PSMD1 Proteo"
  ],
  "GAPDHP20": [
    "GAPDHP20 CNV",
    "GAPDHP20 RNA"
  ],
  "KRTAP9-4": [
    "KRTAP9-4 CNV",
    "KRTAP9-4 RNA"
  ],
  "ZFP2": [
    "ZFP2 CNV",
    "ZFP2 RNA"
  ],
  "ZNF630": [
    "ZNF630 CNV",
    "ZNF630 RNA"
  ],
  "KRTAP19-8": [
    "KRTAP19-8 CNV",
    "KRTAP19-8 RNA"
  ],
  "PHEX": [
    "PHEX CNV",
    "PHEX RNA"
  ],
  "DNAJC1": [
    "DNAJC1 CNV",
    "DNAJC1 RNA",
    "DNAJC1 Proteo"
  ],
  "EEF1A1P46": [
    "EEF1A1P46 CNV",
    "EEF1A1P46 RNA"
  ],
  "RPL23AP41": [
    "RPL23AP41 CNV",
    "RPL23AP41 RNA"
  ],
  "WRAP73": [
    "WRAP73 CNV",
    "WRAP73 RNA",
    "WRAP73 Proteo"
  ],
  "RALGAPA2": [
    "RALGAPA2 CNV",
    "RALGAPA2 RNA",
    "RALGAPA2 Proteo"
  ],
  "GPR153": [
    "GPR153 CNV",
    "GPR153 RNA"
  ],
  "SEC13P1": [
    "SEC13P1 CNV",
    "SEC13P1 RNA"
  ],
  "HFM1": [
    "HFM1 CNV",
    "HFM1 RNA"
  ],
  "P4HB": [
    "P4HB CNV",
    "P4HB RNA",
    "P4HB Proteo"
  ],
  "TAFAZZIN": [
    "TAFAZZIN CNV",
    "TAFAZZIN RNA",
    "TAFAZZIN Proteo"
  ],
  "CKAP4": [
    "CKAP4 CNV",
    "CKAP4 RNA",
    "CKAP4 Proteo"
  ],
  "ZHX3": [
    "ZHX3 CNV",
    "ZHX3 RNA",
    "ZHX3 Proteo"
  ],
  "MMP27": [
    "MMP27 CNV",
    "MMP27 RNA"
  ],
  "DDX1": [
    "DDX1 CNV",
    "DDX1 RNA",
    "DDX1 Proteo"
  ],
  "DSTNP1": [
    "DSTNP1 CNV",
    "DSTNP1 RNA"
  ],
  "CCDC63": [
    "CCDC63 CNV",
    "CCDC63 RNA"
  ],
  "RPL36AP49": [
    "RPL36AP49 CNV",
    "RPL36AP49 RNA"
  ],
  "NDUFA6": [
    "NDUFA6 CNV",
    "NDUFA6 RNA",
    "NDUFA6 Proteo"
  ],
  "ENPP7P7": [
    "ENPP7P7 CNV",
    "ENPP7P7 RNA"
  ],
  "F8A2": [
    "F8A2 CNV",
    "F8A2 RNA",
    "F8A2 Proteo"
  ],
  "RPL36P18": [
    "RPL36P18 CNV",
    "RPL36P18 RNA"
  ],
  "FAM25A": [
    "FAM25A CNV",
    "FAM25A RNA",
    "FAM25A Proteo"
  ],
  "SSBL2P": [
    "SSBL2P CNV",
    "SSBL2P RNA"
  ],
  "ARHGAP22": [
    "ARHGAP22 CNV",
    "ARHGAP22 RNA",
    "ARHGAP22 Proteo"
  ],
  "MANF": [
    "MANF CNV",
    "MANF RNA",
    "MANF Proteo"
  ],
  "ZNF90P3": [
    "ZNF90P3 CNV",
    "ZNF90P3 RNA"
  ],
  "SSX8P": [
    "SSX8P CNV",
    "SSX8P RNA"
  ],
  "IFNK": [
    "IFNK CNV",
    "IFNK RNA"
  ],
  "TATDN1P1": [
    "TATDN1P1 CNV",
    "TATDN1P1 RNA"
  ],
  "NANOGNBP1": [
    "NANOGNBP1 CNV",
    "NANOGNBP1 RNA"
  ],
  "DUXAP4": [
    "DUXAP4 CNV",
    "DUXAP4 RNA"
  ],
  "ADAP2": [
    "ADAP2 CNV",
    "ADAP2 RNA",
    "ADAP2 Proteo"
  ],
  "RNA5SP490": [
    "RNA5SP490 CNV",
    "RNA5SP490 RNA"
  ],
  "ENPP7P1": [
    "ENPP7P1 CNV",
    "ENPP7P1 RNA"
  ],
  "ADIG": [
    "ADIG CNV",
    "ADIG RNA"
  ],
  "GPS2P1": [
    "GPS2P1 CNV",
    "GPS2P1 RNA"
  ],
  "ATR": [
    "ATR CNV",
    "ATR RNA",
    "ATR Proteo"
  ],
  "CCDC148": [
    "CCDC148 CNV",
    "CCDC148 RNA"
  ],
  "DGKE": [
    "DGKE CNV",
    "DGKE RNA",
    "DGKE Proteo"
  ],
  "HCG4B": [
    "HCG4B CNV",
    "HCG4B RNA"
  ],
  "MEIOB": [
    "MEIOB CNV",
    "MEIOB RNA"
  ],
  "TBC1D26": [
    "TBC1D26 CNV",
    "TBC1D26 RNA"
  ],
  "PVR": [
    "PVR CNV",
    "PVR RNA",
    "PVR Proteo"
  ],
  "ATP10B": [
    "ATP10B CNV",
    "ATP10B RNA",
    "ATP10B Proteo"
  ],
  "WNT9B": [
    "WNT9B CNV",
    "WNT9B RNA"
  ],
  "TM2D2": [
    "TM2D2 CNV",
    "TM2D2 RNA"
  ],
  "ZFAND3": [
    "ZFAND3 CNV",
    "ZFAND3 RNA",
    "ZFAND3 Proteo"
  ],
  "AKT3": [
    "AKT3 CNV",
    "AKT3 RNA",
    "AKT3 Proteo"
  ],
  "RASA4B": [
    "RASA4B CNV",
    "RASA4B RNA"
  ],
  "AKNA": [
    "AKNA CNV",
    "AKNA RNA",
    "AKNA Proteo"
  ],
  "AK6P1": [
    "AK6P1 CNV",
    "AK6P1 RNA"
  ],
  "RNF165": [
    "RNF165 CNV",
    "RNF165 RNA"
  ],
  "MARCOL": [
    "MARCOL CNV",
    "MARCOL RNA"
  ],
  "MPLKIP": [
    "MPLKIP CNV",
    "MPLKIP RNA",
    "MPLKIP Proteo"
  ],
  "SNX29P2": [
    "SNX29P2 CNV",
    "SNX29P2 RNA"
  ],
  "PSME3IP1": [
    "PSME3IP1 CNV",
    "PSME3IP1 RNA",
    "PSME3IP1 Proteo"
  ],
  "PTPRC": [
    "PTPRC CNV",
    "PTPRC RNA",
    "PTPRC Proteo"
  ],
  "DUTP1": [
    "DUTP1 CNV",
    "DUTP1 RNA"
  ],
  "XKRY": [
    "XKRY CNV",
    "XKRY RNA"
  ],
  "CLUHP11": [
    "CLUHP11 CNV",
    "CLUHP11 RNA"
  ],
  "CCSAP": [
    "CCSAP CNV",
    "CCSAP RNA",
    "CCSAP Proteo"
  ],
  "OR7E129P": [
    "OR7E129P CNV",
    "OR7E129P RNA"
  ],
  "MRPS21": [
    "MRPS21 CNV",
    "MRPS21 RNA",
    "MRPS21 Proteo"
  ],
  "GTF2H2B": [
    "GTF2H2B CNV",
    "GTF2H2B RNA"
  ],
  "KANTR": [
    "KANTR CNV",
    "KANTR RNA"
  ],
  "PIN1": [
    "PIN1 CNV",
    "PIN1 RNA",
    "PIN1 Proteo"
  ],
  "PDCD7": [
    "PDCD7 CNV",
    "PDCD7 RNA",
    "PDCD7 Proteo"
  ],
  "KIF9": [
    "KIF9 CNV",
    "KIF9 RNA"
  ],
  "OR14A2": [
    "OR14A2 CNV",
    "OR14A2 RNA"
  ],
  "C2orf73": [
    "C2orf73 CNV",
    "C2orf73 RNA"
  ],
  "MALT1": [
    "MALT1 CNV",
    "MALT1 RNA",
    "MALT1 Proteo"
  ],
  "MTND4LP11": [
    "MTND4LP11 CNV",
    "MTND4LP11 RNA"
  ],
  "KIF3AP1": [
    "KIF3AP1 CNV",
    "KIF3AP1 RNA"
  ],
  "MAGEA8": [
    "MAGEA8 CNV",
    "MAGEA8 RNA",
    "MAGEA8 Proteo"
  ],
  "CLNS1A": [
    "CLNS1A CNV",
    "CLNS1A RNA",
    "CLNS1A Proteo"
  ],
  "TMEM59": [
    "TMEM59 CNV",
    "TMEM59 RNA",
    "TMEM59 Proteo"
  ],
  "MBD5": [
    "MBD5 CNV",
    "MBD5 RNA"
  ],
  "MAP1LC3C": [
    "MAP1LC3C CNV",
    "MAP1LC3C RNA"
  ],
  "ESYT2": [
    "ESYT2 CNV",
    "ESYT2 RNA",
    "ESYT2 Proteo"
  ],
  "LGALS9DP": [
    "LGALS9DP CNV",
    "LGALS9DP RNA"
  ],
  "SGK1": [
    "SGK1 CNV",
    "SGK1 RNA",
    "SGK1 Proteo"
  ],
  "S100B": [
    "S100B CNV",
    "S100B RNA",
    "S100B Proteo"
  ],
  "FLNC": [
    "FLNC CNV",
    "FLNC RNA",
    "FLNC Proteo"
  ],
  "ZNF700": [
    "ZNF700 CNV",
    "ZNF700 RNA"
  ],
  "ZNF236": [
    "ZNF236 CNV",
    "ZNF236 RNA",
    "ZNF236 Proteo"
  ],
  "KIAA1210": [
    "KIAA1210 CNV",
    "KIAA1210 RNA"
  ],
  "POU5F1P7": [
    "POU5F1P7 CNV",
    "POU5F1P7 RNA"
  ],
  "PAX3": [
    "PAX3 CNV",
    "PAX3 RNA",
    "PAX3 Proteo"
  ],
  "YWHAG": [
    "YWHAG CNV",
    "YWHAG RNA",
    "YWHAG Proteo"
  ],
  "DPY19L2P2": [
    "DPY19L2P2 CNV",
    "DPY19L2P2 RNA"
  ],
  "KLHL38": [
    "KLHL38 CNV",
    "KLHL38 RNA"
  ],
  "TSPY25P": [
    "TSPY25P CNV",
    "TSPY25P RNA"
  ],
  "PRELID3BP4": [
    "PRELID3BP4 CNV",
    "PRELID3BP4 RNA"
  ],
  "LMLN": [
    "LMLN CNV",
    "LMLN RNA",
    "LMLN Proteo"
  ],
  "PTGIR": [
    "PTGIR CNV",
    "PTGIR RNA"
  ],
  "ATP6V0C": [
    "ATP6V0C CNV",
    "ATP6V0C RNA",
    "ATP6V0C Proteo"
  ],
  "CCNYL5": [
    "CCNYL5 CNV",
    "CCNYL5 RNA"
  ],
  "SLC11A1": [
    "SLC11A1 CNV",
    "SLC11A1 RNA",
    "SLC11A1 Proteo"
  ],
  "TWIST1": [
    "TWIST1 CNV",
    "TWIST1 RNA",
    "TWIST1 Proteo"
  ],
  "PRKCA": [
    "PRKCA CNV",
    "PRKCA RNA",
    "PRKCA Proteo"
  ],
  "BARHL1": [
    "BARHL1 CNV",
    "BARHL1 RNA"
  ],
  "NPY5R": [
    "NPY5R CNV",
    "NPY5R RNA"
  ],
  "ADAM17": [
    "ADAM17 CNV",
    "ADAM17 RNA",
    "ADAM17 Proteo"
  ],
  "LCE1D": [
    "LCE1D CNV",
    "LCE1D RNA"
  ],
  "LSM7": [
    "LSM7 CNV",
    "LSM7 RNA",
    "LSM7 Proteo"
  ],
  "PCSK6": [
    "PCSK6 CNV",
    "PCSK6 RNA",
    "PCSK6 Proteo"
  ],
  "RPL19P11": [
    "RPL19P11 CNV",
    "RPL19P11 RNA"
  ],
  "ELOCP16": [
    "ELOCP16 CNV",
    "ELOCP16 RNA"
  ],
  "ALOXE3": [
    "ALOXE3 CNV",
    "ALOXE3 RNA",
    "ALOXE3 Proteo"
  ],
  "OR10Q1": [
    "OR10Q1 CNV",
    "OR10Q1 RNA"
  ],
  "GAPDHP49": [
    "GAPDHP49 CNV",
    "GAPDHP49 RNA"
  ],
  "VDAC2P3": [
    "VDAC2P3 CNV",
    "VDAC2P3 RNA"
  ],
  "AKR1C3": [
    "AKR1C3 CNV",
    "AKR1C3 RNA",
    "AKR1C3 Proteo"
  ],
  "NF1P5": [
    "NF1P5 CNV",
    "NF1P5 RNA"
  ],
  "CT47A5": [
    "CT47A5 CNV",
    "CT47A5 RNA"
  ],
  "UBQLN1P1": [
    "UBQLN1P1 CNV",
    "UBQLN1P1 RNA"
  ],
  "B4GALNT2": [
    "B4GALNT2 CNV",
    "B4GALNT2 RNA"
  ],
  "ZXDA": [
    "ZXDA CNV",
    "ZXDA RNA",
    "ZXDA Proteo"
  ],
  "OR2B3": [
    "OR2B3 CNV",
    "OR2B3 RNA"
  ],
  "CBWD2": [
    "CBWD2 CNV",
    "CBWD2 RNA",
    "CBWD2 Proteo"
  ],
  "MRGPRX13P": [
    "MRGPRX13P CNV",
    "MRGPRX13P RNA"
  ],
  "BNIP3P29": [
    "BNIP3P29 CNV",
    "BNIP3P29 RNA"
  ],
  "MRPL17": [
    "MRPL17 CNV",
    "MRPL17 RNA",
    "MRPL17 Proteo"
  ],
  "GJB2": [
    "GJB2 CNV",
    "GJB2 RNA",
    "GJB2 Proteo"
  ],
  "PHGDH": [
    "PHGDH CNV",
    "PHGDH RNA",
    "PHGDH Proteo"
  ],
  "PRPF38B": [
    "PRPF38B CNV",
    "PRPF38B RNA",
    "PRPF38B Proteo"
  ],
  "ATP6V0E1P4": [
    "ATP6V0E1P4 CNV",
    "ATP6V0E1P4 RNA"
  ],
  "SYCP2": [
    "SYCP2 CNV",
    "SYCP2 RNA"
  ],
  "PCLAF": [
    "PCLAF CNV",
    "PCLAF RNA",
    "PCLAF Proteo"
  ],
  "TSKS": [
    "TSKS CNV",
    "TSKS RNA"
  ],
  "RMI1": [
    "RMI1 CNV",
    "RMI1 RNA",
    "RMI1 Proteo"
  ],
  "RCC1L": [
    "RCC1L CNV",
    "RCC1L RNA",
    "RCC1L Proteo"
  ],
  "ARG2": [
    "ARG2 CNV",
    "ARG2 RNA",
    "ARG2 Proteo"
  ],
  "KIF2A": [
    "KIF2A CNV",
    "KIF2A RNA",
    "KIF2A Proteo"
  ],
  "GAGE12D": [
    "GAGE12D CNV",
    "GAGE12D RNA"
  ],
  "PAXBP1P1": [
    "PAXBP1P1 CNV",
    "PAXBP1P1 RNA"
  ],
  "PMS2P14": [
    "PMS2P14 CNV",
    "PMS2P14 RNA"
  ],
  "RPL21P108": [
    "RPL21P108 CNV",
    "RPL21P108 RNA"
  ],
  "NPTN": [
    "NPTN CNV",
    "NPTN RNA",
    "NPTN Proteo"
  ],
  "ANKHD1-EIF4EBP3": [
    "ANKHD1-EIF4EBP3 Proteo"
  ],
  "NAE1": [
    "NAE1 CNV",
    "NAE1 RNA",
    "NAE1 Proteo"
  ],
  "RPS3AP6": [
    "RPS3AP6 CNV",
    "RPS3AP6 RNA"
  ],
  "RGS2": [
    "RGS2 CNV",
    "RGS2 RNA"
  ],
  "IRAK1": [
    "IRAK1 CNV",
    "IRAK1 RNA",
    "IRAK1 Proteo"
  ],
  "C11orf16": [
    "C11orf16 CNV",
    "C11orf16 RNA"
  ],
  "PCYOX1": [
    "PCYOX1 CNV",
    "PCYOX1 RNA",
    "PCYOX1 Proteo"
  ],
  "EEF1B2P7": [
    "EEF1B2P7 CNV",
    "EEF1B2P7 RNA"
  ],
  "COX6C": [
    "COX6C CNV",
    "COX6C RNA",
    "COX6C Proteo"
  ],
  "RBMY1B": [
    "RBMY1B CNV",
    "RBMY1B RNA"
  ],
  "TPI1P4": [
    "TPI1P4 CNV",
    "TPI1P4 RNA"
  ],
  "ACTBL2": [
    "ACTBL2 CNV",
    "ACTBL2 RNA",
    "ACTBL2 Proteo"
  ],
  "ACP5": [
    "ACP5 CNV",
    "ACP5 RNA",
    "ACP5 Proteo"
  ],
  "PLA2G15": [
    "PLA2G15 CNV",
    "PLA2G15 RNA",
    "PLA2G15 Proteo"
  ],
  "CHRNB2": [
    "CHRNB2 CNV",
    "CHRNB2 RNA"
  ],
  "OR51R1P": [
    "OR51R1P CNV",
    "OR51R1P RNA"
  ],
  "HOXA10": [
    "HOXA10 CNV",
    "HOXA10 RNA"
  ],
  "CTBP2P1": [
    "CTBP2P1 CNV",
    "CTBP2P1 RNA"
  ],
  "PROCR": [
    "PROCR CNV",
    "PROCR RNA",
    "PROCR Proteo"
  ],
  "TPMT": [
    "TPMT CNV",
    "TPMT RNA",
    "TPMT Proteo"
  ],
  "LMTK3": [
    "LMTK3 CNV",
    "LMTK3 RNA"
  ],
  "NRBF2P5": [
    "NRBF2P5 CNV",
    "NRBF2P5 RNA"
  ],
  "GLIPR1L1": [
    "GLIPR1L1 CNV",
    "GLIPR1L1 RNA"
  ],
  "EEF1A1P9": [
    "EEF1A1P9 CNV",
    "EEF1A1P9 RNA"
  ],
  "PHB1P16": [
    "PHB1P16 CNV",
    "PHB1P16 RNA"
  ],
  "RPF2P1": [
    "RPF2P1 CNV",
    "RPF2P1 RNA"
  ],
  "MKRN2": [
    "MKRN2 CNV",
    "MKRN2 RNA",
    "MKRN2 Proteo"
  ],
  "GAPDHP30": [
    "GAPDHP30 CNV",
    "GAPDHP30 RNA"
  ],
  "HTR1DP1": [
    "HTR1DP1 CNV",
    "HTR1DP1 RNA"
  ],
  "SLC7A2": [
    "SLC7A2 CNV",
    "SLC7A2 RNA",
    "SLC7A2 Proteo"
  ],
  "GPR33": [
    "GPR33 CNV",
    "GPR33 RNA"
  ],
  "LYARP1": [
    "LYARP1 CNV",
    "LYARP1 RNA"
  ],
  "SMIM31": [
    "SMIM31 CNV",
    "SMIM31 RNA"
  ],
  "FXYD7": [
    "FXYD7 CNV",
    "FXYD7 RNA"
  ],
  "FAM246A": [
    "FAM246A CNV",
    "FAM246A RNA"
  ],
  "MAOB": [
    "MAOB CNV",
    "MAOB RNA",
    "MAOB Proteo"
  ],
  "FMO8P": [
    "FMO8P CNV",
    "FMO8P RNA"
  ],
  "ZNF92": [
    "ZNF92 CNV",
    "ZNF92 RNA",
    "ZNF92 Proteo"
  ],
  "GTPBP4": [
    "GTPBP4 CNV",
    "GTPBP4 RNA",
    "GTPBP4 Proteo"
  ],
  "SOWAHC": [
    "SOWAHC CNV",
    "SOWAHC RNA",
    "SOWAHC Proteo"
  ],
  "IQCK": [
    "IQCK CNV",
    "IQCK RNA"
  ],
  "GAGE12E": [
    "GAGE12E CNV",
    "GAGE12E RNA"
  ],
  "NOPCHAP1": [
    "NOPCHAP1 CNV",
    "NOPCHAP1 RNA",
    "NOPCHAP1 Proteo"
  ],
  "RCCD1": [
    "RCCD1 CNV",
    "RCCD1 RNA",
    "RCCD1 Proteo"
  ],
  "TRUB1": [
    "TRUB1 CNV",
    "TRUB1 RNA",
    "TRUB1 Proteo"
  ],
  "CCDC82": [
    "CCDC82 CNV",
    "CCDC82 RNA",
    "CCDC82 Proteo"
  ],
  "MKKS_ENSG00000285508": [
    "MKKS_ENSG00000285508 RNA"
  ],
  "PLCB2": [
    "PLCB2 CNV",
    "PLCB2 RNA",
    "PLCB2 Proteo"
  ],
  "WNT11": [
    "WNT11 CNV",
    "WNT11 RNA"
  ],
  "NEDD9": [
    "NEDD9 CNV",
    "NEDD9 RNA",
    "NEDD9 Proteo"
  ],
  "FBXW2": [
    "FBXW2 CNV",
    "FBXW2 RNA",
    "FBXW2 Proteo"
  ],
  "RBP4": [
    "RBP4 CNV",
    "RBP4 RNA",
    "RBP4 Proteo"
  ],
  "LRRIQ3": [
    "LRRIQ3 CNV",
    "LRRIQ3 RNA"
  ],
  "ZNF491": [
    "ZNF491 CNV",
    "ZNF491 RNA"
  ],
  "CLIP1": [
    "CLIP1 CNV",
    "CLIP1 RNA",
    "CLIP1 Proteo"
  ],
  "SYNJ2BP-COX16": [
    "SYNJ2BP-COX16 Proteo"
  ],
  "CCDC32": [
    "CCDC32 CNV",
    "CCDC32 RNA",
    "CCDC32 Proteo"
  ],
  "SUMO2P18": [
    "SUMO2P18 CNV",
    "SUMO2P18 RNA"
  ],
  "RNA5SP408": [
    "RNA5SP408 CNV",
    "RNA5SP408 RNA"
  ],
  "CABP2": [
    "CABP2 CNV",
    "CABP2 RNA"
  ],
  "NDUFB10P1": [
    "NDUFB10P1 CNV",
    "NDUFB10P1 RNA"
  ],
  "KHDC3L": [
    "KHDC3L CNV",
    "KHDC3L RNA"
  ],
  "CEACAM4": [
    "CEACAM4 CNV",
    "CEACAM4 RNA"
  ],
  "ORC4": [
    "ORC4 CNV",
    "ORC4 RNA",
    "ORC4 Proteo"
  ],
  "STON1": [
    "STON1 CNV",
    "STON1 RNA"
  ],
  "ZNF618": [
    "ZNF618 CNV",
    "ZNF618 RNA",
    "ZNF618 Proteo"
  ],
  "GVQW3": [
    "GVQW3 CNV",
    "GVQW3 RNA"
  ],
  "TIMM8B": [
    "TIMM8B CNV",
    "TIMM8B RNA",
    "TIMM8B Proteo"
  ],
  "STAC2": [
    "STAC2 CNV",
    "STAC2 RNA"
  ],
  "TIMD4": [
    "TIMD4 CNV",
    "TIMD4 RNA"
  ],
  "RPS7P7": [
    "RPS7P7 CNV",
    "RPS7P7 RNA"
  ],
  "ZWILCH": [
    "ZWILCH CNV",
    "ZWILCH RNA",
    "ZWILCH Proteo"
  ],
  "GJB6": [
    "GJB6 CNV",
    "GJB6 RNA"
  ],
  "RNA5SP442": [
    "RNA5SP442 CNV",
    "RNA5SP442 RNA"
  ],
  "RITA1": [
    "RITA1 CNV",
    "RITA1 RNA"
  ],
  "PARD6A": [
    "PARD6A CNV",
    "PARD6A RNA"
  ],
  "NUDT10": [
    "NUDT10 CNV",
    "NUDT10 RNA",
    "NUDT10 Proteo"
  ],
  "ZNF215": [
    "ZNF215 CNV",
    "ZNF215 RNA"
  ],
  "TMEM35B": [
    "TMEM35B CNV",
    "TMEM35B RNA",
    "TMEM35B Proteo"
  ],
  "WASHC2C": [
    "WASHC2C CNV",
    "WASHC2C RNA",
    "WASHC2C Proteo"
  ],
  "TRAPPC6B": [
    "TRAPPC6B CNV",
    "TRAPPC6B RNA",
    "TRAPPC6B Proteo"
  ],
  "CT45A7": [
    "CT45A7 CNV",
    "CT45A7 RNA"
  ],
  "GOLGA2P3Y": [
    "GOLGA2P3Y CNV",
    "GOLGA2P3Y RNA"
  ],
  "PPIAP3": [
    "PPIAP3 CNV",
    "PPIAP3 RNA"
  ],
  "KCNJ5": [
    "KCNJ5 CNV",
    "KCNJ5 RNA",
    "KCNJ5 Proteo"
  ],
  "RAB31": [
    "RAB31 CNV",
    "RAB31 RNA",
    "RAB31 Proteo"
  ],
  "SPTY2D1": [
    "SPTY2D1 CNV",
    "SPTY2D1 RNA",
    "SPTY2D1 Proteo"
  ],
  "USP40": [
    "USP40 CNV",
    "USP40 RNA",
    "USP40 Proteo"
  ],
  "HNRNPCP10": [
    "HNRNPCP10 CNV",
    "HNRNPCP10 RNA"
  ],
  "SNX15": [
    "SNX15 CNV",
    "SNX15 RNA",
    "SNX15 Proteo"
  ],
  "USP17L10": [
    "USP17L10 CNV",
    "USP17L10 RNA",
    "USP17L10 Proteo"
  ],
  "CHCHD2": [
    "CHCHD2 CNV",
    "CHCHD2 RNA",
    "CHCHD2 Proteo"
  ],
  "PTTG1": [
    "PTTG1 CNV",
    "PTTG1 RNA",
    "PTTG1 Proteo"
  ],
  "TMEM104": [
    "TMEM104 CNV",
    "TMEM104 RNA",
    "TMEM104 Proteo"
  ],
  "IL4I1": [
    "IL4I1 CNV",
    "IL4I1 RNA",
    "IL4I1 Proteo"
  ],
  "TMEM232": [
    "TMEM232 CNV",
    "TMEM232 RNA"
  ],
  "OR11Q1P": [
    "OR11Q1P CNV",
    "OR11Q1P RNA"
  ],
  "PRDM6": [
    "PRDM6 CNV",
    "PRDM6 RNA"
  ],
  "MTND5P33": [
    "MTND5P33 CNV",
    "MTND5P33 RNA"
  ],
  "SNX18P13": [
    "SNX18P13 CNV",
    "SNX18P13 RNA"
  ],
  "SNX2P1": [
    "SNX2P1 CNV",
    "SNX2P1 RNA"
  ],
  "MTCYBP33": [
    "MTCYBP33 CNV",
    "MTCYBP33 RNA"
  ],
  "NSA2P3": [
    "NSA2P3 CNV",
    "NSA2P3 RNA"
  ],
  "FGFR1OP2": [
    "FGFR1OP2 CNV",
    "FGFR1OP2 RNA",
    "FGFR1OP2 Proteo"
  ],
  "STX4": [
    "STX4 CNV",
    "STX4 RNA",
    "STX4 Proteo"
  ],
  "ORMDL2": [
    "ORMDL2 CNV",
    "ORMDL2 RNA",
    "ORMDL2 Proteo"
  ],
  "MAS1": [
    "MAS1 CNV",
    "MAS1 RNA"
  ],
  "RPL7P27": [
    "RPL7P27 CNV",
    "RPL7P27 RNA"
  ],
  "LYRM7": [
    "LYRM7 CNV",
    "LYRM7 RNA",
    "LYRM7 Proteo"
  ],
  "ALDH3A2": [
    "ALDH3A2 CNV",
    "ALDH3A2 RNA",
    "ALDH3A2 Proteo"
  ],
  "TMEM170A": [
    "TMEM170A CNV",
    "TMEM170A RNA"
  ],
  "BMP3": [
    "BMP3 CNV",
    "BMP3 RNA"
  ],
  "ZNF420": [
    "ZNF420 CNV",
    "ZNF420 RNA"
  ],
  "OR5F1": [
    "OR5F1 CNV",
    "OR5F1 RNA"
  ],
  "SLC15A5": [
    "SLC15A5 CNV",
    "SLC15A5 RNA"
  ],
  "USP25": [
    "USP25 CNV",
    "USP25 RNA",
    "USP25 Proteo"
  ],
  "RAB17": [
    "RAB17 CNV",
    "RAB17 RNA",
    "RAB17 Proteo"
  ],
  "ABLIM2": [
    "ABLIM2 CNV",
    "ABLIM2 RNA",
    "ABLIM2 Proteo"
  ],
  "IGLC5": [
    "IGLC5 CNV",
    "IGLC5 RNA"
  ],
  "PGAP3": [
    "PGAP3 CNV",
    "PGAP3 RNA"
  ],
  "RPS4XP23": [
    "RPS4XP23 CNV",
    "RPS4XP23 RNA"
  ],
  "DCP1A": [
    "DCP1A CNV",
    "DCP1A RNA",
    "DCP1A Proteo"
  ],
  "MT1XP1": [
    "MT1XP1 CNV",
    "MT1XP1 RNA"
  ],
  "CRTC2": [
    "CRTC2 CNV",
    "CRTC2 RNA",
    "CRTC2 Proteo"
  ],
  "MRPS17P3": [
    "MRPS17P3 CNV",
    "MRPS17P3 RNA"
  ],
  "OR7E145P": [
    "OR7E145P CNV",
    "OR7E145P RNA"
  ],
  "MRPL42P6": [
    "MRPL42P6 CNV",
    "MRPL42P6 RNA"
  ],
  "MZB1": [
    "MZB1 CNV",
    "MZB1 RNA",
    "MZB1 Proteo"
  ],
  "MTCO1P49": [
    "MTCO1P49 CNV",
    "MTCO1P49 RNA"
  ],
  "NOS3": [
    "NOS3 CNV",
    "NOS3 RNA",
    "NOS3 Proteo"
  ],
  "ELAPOR2": [
    "ELAPOR2 CNV",
    "ELAPOR2 RNA"
  ],
  "GPATCH8": [
    "GPATCH8 CNV",
    "GPATCH8 RNA",
    "GPATCH8 Proteo"
  ],
  "NSUN2": [
    "NSUN2 CNV",
    "NSUN2 RNA",
    "NSUN2 Proteo"
  ],
  "TMEM244": [
    "TMEM244 CNV",
    "TMEM244 RNA"
  ],
  "CHST8": [
    "CHST8 CNV",
    "CHST8 RNA"
  ],
  "HDC": [
    "HDC CNV",
    "HDC RNA"
  ],
  "ANKRD49P3": [
    "ANKRD49P3 CNV",
    "ANKRD49P3 RNA"
  ],
  "VSNL1": [
    "VSNL1 CNV",
    "VSNL1 RNA",
    "VSNL1 Proteo"
  ],
  "SLC5A9": [
    "SLC5A9 CNV",
    "SLC5A9 RNA"
  ],
  "MTND4LP21": [
    "MTND4LP21 CNV",
    "MTND4LP21 RNA"
  ],
  "FAM153DP": [
    "FAM153DP CNV",
    "FAM153DP RNA"
  ],
  "MXD4": [
    "MXD4 CNV",
    "MXD4 RNA"
  ],
  "CD207": [
    "CD207 CNV",
    "CD207 RNA",
    "CD207 Proteo"
  ],
  "MTND1P10": [
    "MTND1P10 CNV",
    "MTND1P10 RNA"
  ],
  "VN1R84P": [
    "VN1R84P CNV",
    "VN1R84P RNA"
  ],
  "ETV3": [
    "ETV3 CNV",
    "ETV3 RNA",
    "ETV3 Proteo"
  ],
  "EIF2AK3": [
    "EIF2AK3 CNV",
    "EIF2AK3 RNA",
    "EIF2AK3 Proteo"
  ],
  "LYPD9P": [
    "LYPD9P CNV",
    "LYPD9P RNA"
  ],
  "RPS20P32": [
    "RPS20P32 CNV",
    "RPS20P32 RNA"
  ],
  "JRK": [
    "JRK CNV",
    "JRK RNA",
    "JRK Proteo"
  ],
  "CD5L": [
    "CD5L CNV",
    "CD5L RNA",
    "CD5L Proteo"
  ],
  "POGZ": [
    "POGZ CNV",
    "POGZ RNA",
    "POGZ Proteo"
  ],
  "GRID1": [
    "GRID1 CNV",
    "GRID1 RNA"
  ],
  "TKTL2": [
    "TKTL2 CNV",
    "TKTL2 RNA",
    "TKTL2 Proteo"
  ],
  "RBBP4P4": [
    "RBBP4P4 CNV",
    "RBBP4P4 RNA"
  ],
  "IRF2BP1": [
    "IRF2BP1 CNV",
    "IRF2BP1 RNA",
    "IRF2BP1 Proteo"
  ],
  "TPM3P5": [
    "TPM3P5 CNV",
    "TPM3P5 RNA"
  ],
  "PCMTD1": [
    "PCMTD1 CNV",
    "PCMTD1 RNA",
    "PCMTD1 Proteo"
  ],
  "ANKRD20A9P": [
    "ANKRD20A9P CNV",
    "ANKRD20A9P RNA"
  ],
  "HMG20A": [
    "HMG20A CNV",
    "HMG20A RNA",
    "HMG20A Proteo"
  ],
  "CICP12": [
    "CICP12 CNV",
    "CICP12 RNA"
  ],
  "SMARCA5": [
    "SMARCA5 CNV",
    "SMARCA5 RNA",
    "SMARCA5 Proteo"
  ],
  "VSIG10L2": [
    "VSIG10L2 CNV",
    "VSIG10L2 RNA"
  ],
  "TYROBP": [
    "TYROBP CNV",
    "TYROBP RNA",
    "TYROBP Proteo"
  ],
  "PRAMEF33": [
    "PRAMEF33 CNV",
    "PRAMEF33 RNA"
  ],
  "BIN2P1": [
    "BIN2P1 CNV",
    "BIN2P1 RNA"
  ],
  "CD1C": [
    "CD1C CNV",
    "CD1C RNA",
    "CD1C Proteo"
  ],
  "H2BW1": [
    "H2BW1 CNV",
    "H2BW1 RNA"
  ],
  "WBP1LP3": [
    "WBP1LP3 CNV",
    "WBP1LP3 RNA"
  ],
  "NES": [
    "NES CNV",
    "NES RNA",
    "NES Proteo"
  ],
  "RPL29P7": [
    "RPL29P7 CNV",
    "RPL29P7 RNA"
  ],
  "CXorf49": [
    "CXorf49 CNV",
    "CXorf49 RNA",
    "CXorf49 Proteo"
  ],
  "PTPRT": [
    "PTPRT CNV",
    "PTPRT RNA"
  ],
  "PIK3CDP1": [
    "PIK3CDP1 CNV",
    "PIK3CDP1 RNA"
  ],
  "RNA5SP475": [
    "RNA5SP475 CNV",
    "RNA5SP475 RNA"
  ],
  "TRIM73": [
    "TRIM73 CNV",
    "TRIM73 RNA"
  ],
  "ATP6V0D2": [
    "ATP6V0D2 CNV",
    "ATP6V0D2 RNA",
    "ATP6V0D2 Proteo"
  ],
  "SERPINA15P": [
    "SERPINA15P CNV",
    "SERPINA15P RNA"
  ],
  "RDM1P2": [
    "RDM1P2 CNV",
    "RDM1P2 RNA"
  ],
  "ELOVL3": [
    "ELOVL3 CNV",
    "ELOVL3 RNA"
  ],
  "LRRC3B": [
    "LRRC3B CNV",
    "LRRC3B RNA"
  ],
  "FKBP1AP1": [
    "FKBP1AP1 CNV",
    "FKBP1AP1 RNA"
  ],
  "RNA5SP236": [
    "RNA5SP236 CNV",
    "RNA5SP236 RNA"
  ],
  "CYTH4": [
    "CYTH4 CNV",
    "CYTH4 RNA",
    "CYTH4 Proteo"
  ],
  "CHD4": [
    "CHD4 CNV",
    "CHD4 RNA",
    "CHD4 Proteo"
  ],
  "KCTD12": [
    "KCTD12 CNV",
    "KCTD12 RNA",
    "KCTD12 Proteo"
  ],
  "HLA-E": [
    "HLA-E CNV",
    "HLA-E RNA",
    "HLA-E Proteo"
  ],
  "NDUFA4": [
    "NDUFA4 CNV",
    "NDUFA4 RNA",
    "NDUFA4 Proteo"
  ],
  "RPL23AP66": [
    "RPL23AP66 CNV",
    "RPL23AP66 RNA"
  ],
  "DUX4L52": [
    "DUX4L52 CNV",
    "DUX4L52 RNA"
  ],
  "ANKRD34A": [
    "ANKRD34A CNV",
    "ANKRD34A RNA"
  ],
  "TM4SF18": [
    "TM4SF18 CNV",
    "TM4SF18 RNA"
  ],
  "CYCSP39": [
    "CYCSP39 CNV",
    "CYCSP39 RNA"
  ],
  "CYP26B1": [
    "CYP26B1 CNV",
    "CYP26B1 RNA"
  ],
  "GFAP": [
    "GFAP CNV",
    "GFAP RNA",
    "GFAP Proteo"
  ],
  "FCF1P7": [
    "FCF1P7 CNV",
    "FCF1P7 RNA"
  ],
  "MBNL3": [
    "MBNL3 CNV",
    "MBNL3 RNA",
    "MBNL3 Proteo"
  ],
  "DUX4L35": [
    "DUX4L35 CNV",
    "DUX4L35 RNA"
  ],
  "BMS1P4": [
    "BMS1P4 CNV",
    "BMS1P4 RNA"
  ],
  "RHOF": [
    "RHOF CNV",
    "RHOF RNA",
    "RHOF Proteo"
  ],
  "CRYAB": [
    "CRYAB CNV",
    "CRYAB RNA",
    "CRYAB Proteo"
  ],
  "ATP2C2": [
    "ATP2C2 CNV",
    "ATP2C2 RNA"
  ],
  "RPL6": [
    "RPL6 CNV",
    "RPL6 RNA",
    "RPL6 Proteo"
  ],
  "ADAM8": [
    "ADAM8 CNV",
    "ADAM8 RNA",
    "ADAM8 Proteo"
  ],
  "ATXN1L": [
    "ATXN1L CNV",
    "ATXN1L RNA",
    "ATXN1L Proteo"
  ],
  "FGF13": [
    "FGF13 CNV",
    "FGF13 RNA",
    "FGF13 Proteo"
  ],
  "KATNA1": [
    "KATNA1 CNV",
    "KATNA1 RNA",
    "KATNA1 Proteo"
  ],
  "KCTD15": [
    "KCTD15 CNV",
    "KCTD15 RNA",
    "KCTD15 Proteo"
  ],
  "JAKMIP1": [
    "JAKMIP1 CNV",
    "JAKMIP1 RNA",
    "JAKMIP1 Proteo"
  ],
  "HSPA7": [
    "HSPA7 CNV",
    "HSPA7 RNA"
  ],
  "KIF22": [
    "KIF22 CNV",
    "KIF22 RNA",
    "KIF22 Proteo"
  ],
  "FOXJ3": [
    "FOXJ3 CNV",
    "FOXJ3 RNA",
    "FOXJ3 Proteo"
  ],
  "H1-6": [
    "H1-6 CNV",
    "H1-6 RNA",
    "H1-6 Proteo"
  ],
  "FAM181A": [
    "FAM181A CNV",
    "FAM181A RNA"
  ],
  "DNAJB6P2": [
    "DNAJB6P2 CNV",
    "DNAJB6P2 RNA"
  ],
  "CDC37L1": [
    "CDC37L1 CNV",
    "CDC37L1 RNA",
    "CDC37L1 Proteo"
  ],
  "PHAF1": [
    "PHAF1 CNV",
    "PHAF1 RNA",
    "PHAF1 Proteo"
  ],
  "SALL4P5": [
    "SALL4P5 CNV",
    "SALL4P5 RNA"
  ],
  "CT47A1": [
    "CT47A1 CNV",
    "CT47A1 RNA"
  ],
  "SLC27A4": [
    "SLC27A4 CNV",
    "SLC27A4 RNA",
    "SLC27A4 Proteo"
  ],
  "FTLP15": [
    "FTLP15 CNV",
    "FTLP15 RNA"
  ],
  "TNIP3": [
    "TNIP3 CNV",
    "TNIP3 RNA"
  ],
  "H2BP1": [
    "H2BP1 CNV",
    "H2BP1 RNA"
  ],
  "TERF1P2": [
    "TERF1P2 CNV",
    "TERF1P2 RNA"
  ],
  "PRR32": [
    "PRR32 CNV",
    "PRR32 RNA"
  ],
  "CSF1": [
    "CSF1 CNV",
    "CSF1 RNA"
  ],
  "PACC1": [
    "PACC1 CNV",
    "PACC1 RNA",
    "PACC1 Proteo"
  ],
  "RPL34P27": [
    "RPL34P27 CNV",
    "RPL34P27 RNA"
  ],
  "OR13D3P": [
    "OR13D3P CNV",
    "OR13D3P RNA"
  ],
  "MRAP": [
    "MRAP CNV",
    "MRAP RNA"
  ],
  "TMCO5B": [
    "TMCO5B CNV",
    "TMCO5B RNA"
  ],
  "PLA2G12AP1": [
    "PLA2G12AP1 CNV",
    "PLA2G12AP1 RNA"
  ],
  "THSD7B": [
    "THSD7B CNV",
    "THSD7B RNA"
  ],
  "OR4E1": [
    "OR4E1 CNV",
    "OR4E1 RNA"
  ],
  "DBT": [
    "DBT CNV",
    "DBT RNA",
    "DBT Proteo"
  ],
  "OR6K2": [
    "OR6K2 CNV",
    "OR6K2 RNA"
  ],
  "IFT20": [
    "IFT20 CNV",
    "IFT20 RNA",
    "IFT20 Proteo"
  ],
  "NDUFS4": [
    "NDUFS4 CNV",
    "NDUFS4 RNA",
    "NDUFS4 Proteo"
  ],
  "INKA2": [
    "INKA2 CNV",
    "INKA2 RNA"
  ],
  "ACTBP11": [
    "ACTBP11 CNV",
    "ACTBP11 RNA"
  ],
  "SDK1": [
    "SDK1 CNV",
    "SDK1 RNA",
    "SDK1 Proteo"
  ],
  "CDH16": [
    "CDH16 CNV",
    "CDH16 RNA"
  ],
  "RPS11P5": [
    "RPS11P5 CNV",
    "RPS11P5 RNA"
  ],
  "RAB5CP1": [
    "RAB5CP1 CNV",
    "RAB5CP1 RNA"
  ],
  "PRDM4": [
    "PRDM4 CNV",
    "PRDM4 RNA"
  ],
  "TBL3": [
    "TBL3 CNV",
    "TBL3 RNA",
    "TBL3 Proteo"
  ],
  "ST8SIA6": [
    "ST8SIA6 CNV",
    "ST8SIA6 RNA"
  ],
  "MTND5P11": [
    "MTND5P11 CNV",
    "MTND5P11 RNA"
  ],
  "DUSP26": [
    "DUSP26 CNV",
    "DUSP26 RNA"
  ],
  "HSPD1P8": [
    "HSPD1P8 CNV",
    "HSPD1P8 RNA"
  ],
  "KCNJ4": [
    "KCNJ4 CNV",
    "KCNJ4 RNA"
  ],
  "IGKV1-6": [
    "IGKV1-6 Proteo"
  ],
  "SF1": [
    "SF1 CNV",
    "SF1 RNA",
    "SF1 Proteo"
  ],
  "FANCD2": [
    "FANCD2 CNV",
    "FANCD2 RNA",
    "FANCD2 Proteo"
  ],
  "HMGB1P30": [
    "HMGB1P30 CNV",
    "HMGB1P30 RNA"
  ],
  "MPZL1": [
    "MPZL1 CNV",
    "MPZL1 RNA",
    "MPZL1 Proteo"
  ],
  "OR2G6": [
    "OR2G6 CNV",
    "OR2G6 RNA"
  ],
  "CCR1": [
    "CCR1 CNV",
    "CCR1 RNA",
    "CCR1 Proteo"
  ],
  "CDIN1": [
    "CDIN1 CNV",
    "CDIN1 RNA",
    "CDIN1 Proteo"
  ],
  "PRSS1": [
    "PRSS1 CNV",
    "PRSS1 RNA",
    "PRSS1 Proteo"
  ],
  "COPZ2": [
    "COPZ2 CNV",
    "COPZ2 RNA",
    "COPZ2 Proteo"
  ],
  "POLR2G": [
    "POLR2G CNV",
    "POLR2G RNA",
    "POLR2G Proteo"
  ],
  "SHLD1": [
    "SHLD1 CNV",
    "SHLD1 RNA"
  ],
  "SKA2": [
    "SKA2 CNV",
    "SKA2 RNA",
    "SKA2 Proteo"
  ],
  "ANGPTL3": [
    "ANGPTL3 CNV",
    "ANGPTL3 RNA"
  ],
  "SLC4A8": [
    "SLC4A8 CNV",
    "SLC4A8 RNA"
  ],
  "RPL23AP22": [
    "RPL23AP22 CNV",
    "RPL23AP22 RNA"
  ],
  "RAB11FIP1": [
    "RAB11FIP1 CNV",
    "RAB11FIP1 RNA",
    "RAB11FIP1 Proteo"
  ],
  "RPL21P32": [
    "RPL21P32 CNV",
    "RPL21P32 RNA"
  ],
  "KLHL8": [
    "KLHL8 CNV",
    "KLHL8 RNA",
    "KLHL8 Proteo"
  ],
  "MIF": [
    "MIF CNV",
    "MIF RNA",
    "MIF Proteo"
  ],
  "TMTC1": [
    "TMTC1 CNV",
    "TMTC1 RNA",
    "TMTC1 Proteo"
  ],
  "MIOX": [
    "MIOX CNV",
    "MIOX RNA"
  ],
  "B3GALT1": [
    "B3GALT1 CNV",
    "B3GALT1 RNA"
  ],
  "SLC25A24P1": [
    "SLC25A24P1 CNV",
    "SLC25A24P1 RNA"
  ],
  "ZC3H11A": [
    "ZC3H11A CNV",
    "ZC3H11A RNA",
    "ZC3H11A Proteo"
  ],
  "LAGE3": [
    "LAGE3 CNV",
    "LAGE3 RNA",
    "LAGE3 Proteo"
  ],
  "GLYATL1P2": [
    "GLYATL1P2 CNV",
    "GLYATL1P2 RNA"
  ],
  "TGFB3": [
    "TGFB3 CNV",
    "TGFB3 RNA"
  ],
  "PHKG2": [
    "PHKG2 CNV",
    "PHKG2 RNA",
    "PHKG2 Proteo"
  ],
  "COX6CP3": [
    "COX6CP3 CNV",
    "COX6CP3 RNA"
  ],
  "TMEM151B": [
    "TMEM151B CNV",
    "TMEM151B RNA"
  ],
  "CHMP1A": [
    "CHMP1A CNV",
    "CHMP1A RNA",
    "CHMP1A Proteo"
  ],
  "APOL2": [
    "APOL2 CNV",
    "APOL2 RNA",
    "APOL2 Proteo"
  ],
  "PIGK": [
    "PIGK CNV",
    "PIGK RNA",
    "PIGK Proteo"
  ],
  "SSUH2": [
    "SSUH2 CNV",
    "SSUH2 RNA"
  ],
  "RPS3AP43": [
    "RPS3AP43 CNV",
    "RPS3AP43 RNA"
  ],
  "IDH3B": [
    "IDH3B CNV",
    "IDH3B RNA",
    "IDH3B Proteo"
  ],
  "RDH8": [
    "RDH8 CNV",
    "RDH8 RNA"
  ],
  "TNFRSF17": [
    "TNFRSF17 CNV",
    "TNFRSF17 RNA"
  ],
  "SPAG7": [
    "SPAG7 CNV",
    "SPAG7 RNA",
    "SPAG7 Proteo"
  ],
  "MTND5P1": [
    "MTND5P1 CNV",
    "MTND5P1 RNA"
  ],
  "ACTRT1P1": [
    "ACTRT1P1 CNV",
    "ACTRT1P1 RNA"
  ],
  "RMND1": [
    "RMND1 CNV",
    "RMND1 RNA",
    "RMND1 Proteo"
  ],
  "HSPE1P14": [
    "HSPE1P14 CNV",
    "HSPE1P14 RNA"
  ],
  "TRPV4": [
    "TRPV4 CNV",
    "TRPV4 RNA",
    "TRPV4 Proteo"
  ],
  "UBA3": [
    "UBA3 CNV",
    "UBA3 RNA",
    "UBA3 Proteo"
  ],
  "PHGR1": [
    "PHGR1 CNV",
    "PHGR1 RNA"
  ],
  "KRT8": [
    "KRT8 CNV",
    "KRT8 RNA",
    "KRT8 Proteo"
  ],
  "MELTF": [
    "MELTF CNV",
    "MELTF RNA",
    "MELTF Proteo"
  ],
  "FKBP3": [
    "FKBP3 CNV",
    "FKBP3 RNA",
    "FKBP3 Proteo"
  ],
  "RPL4P5": [
    "RPL4P5 CNV",
    "RPL4P5 RNA"
  ],
  "LMNB1": [
    "LMNB1 CNV",
    "LMNB1 RNA",
    "LMNB1 Proteo"
  ],
  "TOR1AIP1": [
    "TOR1AIP1 CNV",
    "TOR1AIP1 RNA",
    "TOR1AIP1 Proteo"
  ],
  "WDR97": [
    "WDR97 CNV",
    "WDR97 RNA"
  ],
  "ZNF529": [
    "ZNF529 CNV",
    "ZNF529 RNA"
  ],
  "PDE5A": [
    "PDE5A CNV",
    "PDE5A RNA",
    "PDE5A Proteo"
  ],
  "ENAH": [
    "ENAH CNV",
    "ENAH RNA",
    "ENAH Proteo"
  ],
  "ORC1": [
    "ORC1 CNV",
    "ORC1 RNA",
    "ORC1 Proteo"
  ],
  "VWC2L": [
    "VWC2L CNV",
    "VWC2L RNA"
  ],
  "GPR160P1": [
    "GPR160P1 CNV",
    "GPR160P1 RNA"
  ],
  "MC3R": [
    "MC3R CNV",
    "MC3R RNA"
  ],
  "ADAP1": [
    "ADAP1 CNV",
    "ADAP1 RNA",
    "ADAP1 Proteo"
  ],
  "IMMP2L": [
    "IMMP2L CNV",
    "IMMP2L RNA",
    "IMMP2L Proteo"
  ],
  "BSNDP3": [
    "BSNDP3 CNV",
    "BSNDP3 RNA"
  ],
  "RPL7AP77": [
    "RPL7AP77 CNV",
    "RPL7AP77 RNA"
  ],
  "PYY3": [
    "PYY3 CNV",
    "PYY3 RNA"
  ],
  "SGF29": [
    "SGF29 CNV",
    "SGF29 RNA",
    "SGF29 Proteo"
  ],
  "MTND5P16": [
    "MTND5P16 CNV",
    "MTND5P16 RNA"
  ],
  "IGSF21": [
    "IGSF21 CNV",
    "IGSF21 RNA"
  ],
  "CES5AP1": [
    "CES5AP1 CNV",
    "CES5AP1 RNA"
  ],
  "SLC25A46": [
    "SLC25A46 CNV",
    "SLC25A46 RNA",
    "SLC25A46 Proteo"
  ],
  "PPP1R2B": [
    "PPP1R2B CNV",
    "PPP1R2B RNA"
  ],
  "TMEM67": [
    "TMEM67 CNV",
    "TMEM67 RNA",
    "TMEM67 Proteo"
  ],
  "NMUR1": [
    "NMUR1 CNV",
    "NMUR1 RNA"
  ],
  "TRPC4": [
    "TRPC4 CNV",
    "TRPC4 RNA"
  ],
  "AEBP1": [
    "AEBP1 CNV",
    "AEBP1 RNA",
    "AEBP1 Proteo"
  ],
  "STUB1P1": [
    "STUB1P1 CNV",
    "STUB1P1 RNA"
  ],
  "PABPC1P4": [
    "PABPC1P4 CNV",
    "PABPC1P4 RNA"
  ],
  "GGTLC5P": [
    "GGTLC5P CNV",
    "GGTLC5P RNA"
  ],
  "SORCS3": [
    "SORCS3 CNV",
    "SORCS3 RNA"
  ],
  "COMMD6": [
    "COMMD6 CNV",
    "COMMD6 RNA",
    "COMMD6 Proteo"
  ],
  "RPRM": [
    "RPRM CNV",
    "RPRM RNA"
  ],
  "TMEM88": [
    "TMEM88 CNV",
    "TMEM88 RNA"
  ],
  "BBS12": [
    "BBS12 CNV",
    "BBS12 RNA",
    "BBS12 Proteo"
  ],
  "TPMTP4": [
    "TPMTP4 CNV",
    "TPMTP4 RNA"
  ],
  "DEFB126": [
    "DEFB126 CNV",
    "DEFB126 RNA"
  ],
  "C1orf146": [
    "C1orf146 CNV",
    "C1orf146 RNA"
  ],
  "NMNAT1P4": [
    "NMNAT1P4 CNV",
    "NMNAT1P4 RNA"
  ],
  "SEMA3F": [
    "SEMA3F CNV",
    "SEMA3F RNA"
  ],
  "RPS6KA3": [
    "RPS6KA3 CNV",
    "RPS6KA3 RNA",
    "RPS6KA3 Proteo"
  ],
  "PRAMEF35P": [
    "PRAMEF35P CNV",
    "PRAMEF35P RNA"
  ],
  "ZNF738": [
    "ZNF738 CNV",
    "ZNF738 RNA"
  ],
  "RPL31P3": [
    "RPL31P3 CNV",
    "RPL31P3 RNA"
  ],
  "ACTR3B": [
    "ACTR3B CNV",
    "ACTR3B RNA",
    "ACTR3B Proteo"
  ],
  "BRK1P2": [
    "BRK1P2 CNV",
    "BRK1P2 RNA"
  ],
  "S100A8": [
    "S100A8 CNV",
    "S100A8 RNA",
    "S100A8 Proteo"
  ],
  "SEPTIN14P5": [
    "SEPTIN14P5 CNV",
    "SEPTIN14P5 RNA"
  ],
  "TMEM38A": [
    "TMEM38A CNV",
    "TMEM38A RNA",
    "TMEM38A Proteo"
  ],
  "ABI3": [
    "ABI3 CNV",
    "ABI3 RNA",
    "ABI3 Proteo"
  ],
  "MCOLN2": [
    "MCOLN2 CNV",
    "MCOLN2 RNA",
    "MCOLN2 Proteo"
  ],
  "UNC80": [
    "UNC80 CNV",
    "UNC80 RNA",
    "UNC80 Proteo"
  ],
  "ARMC7": [
    "ARMC7 CNV",
    "ARMC7 RNA",
    "ARMC7 Proteo"
  ],
  "RNF40": [
    "RNF40 CNV",
    "RNF40 RNA",
    "RNF40 Proteo"
  ],
  "CDH12P3": [
    "CDH12P3 CNV",
    "CDH12P3 RNA"
  ],
  "IFT27": [
    "IFT27 CNV",
    "IFT27 RNA",
    "IFT27 Proteo"
  ],
  "ZNF8": [
    "ZNF8 CNV",
    "ZNF8 RNA",
    "ZNF8 Proteo"
  ],
  "EMILIN1": [
    "EMILIN1 CNV",
    "EMILIN1 RNA",
    "EMILIN1 Proteo"
  ],
  "HEPACAM2": [
    "HEPACAM2 CNV",
    "HEPACAM2 RNA"
  ],
  "CGGBP1": [
    "CGGBP1 CNV",
    "CGGBP1 RNA",
    "CGGBP1 Proteo"
  ],
  "PSD4": [
    "PSD4 CNV",
    "PSD4 RNA",
    "PSD4 Proteo"
  ],
  "ELAVL2": [
    "ELAVL2 CNV",
    "ELAVL2 RNA",
    "ELAVL2 Proteo"
  ],
  "DUX4L46": [
    "DUX4L46 CNV",
    "DUX4L46 RNA"
  ],
  "PLXDC1": [
    "PLXDC1 CNV",
    "PLXDC1 RNA",
    "PLXDC1 Proteo"
  ],
  "BAG4": [
    "BAG4 CNV",
    "BAG4 RNA",
    "BAG4 Proteo"
  ],
  "SUZ12": [
    "SUZ12 CNV",
    "SUZ12 RNA",
    "SUZ12 Proteo"
  ],
  "PGK1P2": [
    "PGK1P2 CNV",
    "PGK1P2 RNA"
  ],
  "F11": [
    "F11 CNV",
    "F11 RNA",
    "F11 Proteo"
  ],
  "ALG1L12P": [
    "ALG1L12P CNV",
    "ALG1L12P RNA"
  ],
  "NID1": [
    "NID1 CNV",
    "NID1 RNA",
    "NID1 Proteo"
  ],
  "ULK3": [
    "ULK3 CNV",
    "ULK3 RNA",
    "ULK3 Proteo"
  ],
  "NANOGP6": [
    "NANOGP6 CNV",
    "NANOGP6 RNA"
  ],
  "ZNF615": [
    "ZNF615 CNV",
    "ZNF615 RNA"
  ],
  "ATXN3L": [
    "ATXN3L CNV",
    "ATXN3L RNA"
  ],
  "PARP11": [
    "PARP11 CNV",
    "PARP11 RNA"
  ],
  "RBMXP3": [
    "RBMXP3 CNV",
    "RBMXP3 RNA"
  ],
  "LIN7A": [
    "LIN7A CNV",
    "LIN7A RNA",
    "LIN7A Proteo"
  ],
  "RPL21P136": [
    "RPL21P136 CNV",
    "RPL21P136 RNA"
  ],
  "FBXO43": [
    "FBXO43 CNV",
    "FBXO43 RNA"
  ],
  "PUS1": [
    "PUS1 CNV",
    "PUS1 RNA",
    "PUS1 Proteo"
  ],
  "MRPS33P3": [
    "MRPS33P3 CNV",
    "MRPS33P3 RNA"
  ],
  "GUSBP12": [
    "GUSBP12 CNV",
    "GUSBP12 RNA"
  ],
  "SCN4A": [
    "SCN4A CNV",
    "SCN4A RNA"
  ],
  "FGF7P7": [
    "FGF7P7 CNV",
    "FGF7P7 RNA"
  ],
  "SCYGR7": [
    "SCYGR7 CNV",
    "SCYGR7 RNA"
  ],
  "OR10D5P": [
    "OR10D5P CNV",
    "OR10D5P RNA"
  ],
  "PPP1R27": [
    "PPP1R27 CNV",
    "PPP1R27 RNA"
  ],
  "SAR1AP2": [
    "SAR1AP2 CNV",
    "SAR1AP2 RNA"
  ],
  "NEDD4": [
    "NEDD4 CNV",
    "NEDD4 RNA",
    "NEDD4 Proteo"
  ],
  "SLC39A1": [
    "SLC39A1 CNV",
    "SLC39A1 RNA",
    "SLC39A1 Proteo"
  ],
  "QTRT1": [
    "QTRT1 CNV",
    "QTRT1 RNA",
    "QTRT1 Proteo"
  ],
  "INAVA": [
    "INAVA CNV",
    "INAVA RNA"
  ],
  "SPAG11B": [
    "SPAG11B CNV",
    "SPAG11B RNA"
  ],
  "SLC36A4": [
    "SLC36A4 CNV",
    "SLC36A4 RNA"
  ],
  "PIGT": [
    "PIGT CNV",
    "PIGT RNA",
    "PIGT Proteo"
  ],
  "ARL6IP4": [
    "ARL6IP4 CNV",
    "ARL6IP4 RNA",
    "ARL6IP4 Proteo"
  ],
  "RALYL": [
    "RALYL CNV",
    "RALYL RNA",
    "RALYL Proteo"
  ],
  "TTYH1": [
    "TTYH1 CNV",
    "TTYH1 RNA",
    "TTYH1 Proteo"
  ],
  "CLEC12A": [
    "CLEC12A CNV",
    "CLEC12A RNA",
    "CLEC12A Proteo"
  ],
  "OFD1P16Y": [
    "OFD1P16Y CNV",
    "OFD1P16Y RNA"
  ],
  "LONRF3": [
    "LONRF3 CNV",
    "LONRF3 RNA"
  ],
  "ETDA": [
    "ETDA CNV",
    "ETDA RNA"
  ],
  "METTL21C": [
    "METTL21C CNV",
    "METTL21C RNA"
  ],
  "DCLRE1CP1": [
    "DCLRE1CP1 CNV",
    "DCLRE1CP1 RNA"
  ],
  "ZNF37BP": [
    "ZNF37BP CNV",
    "ZNF37BP RNA"
  ],
  "DIAPH2": [
    "DIAPH2 CNV",
    "DIAPH2 RNA",
    "DIAPH2 Proteo"
  ],
  "CDC14C": [
    "CDC14C CNV",
    "CDC14C RNA"
  ],
  "ACSM5P1": [
    "ACSM5P1 CNV",
    "ACSM5P1 RNA"
  ],
  "NMNAT1P3": [
    "NMNAT1P3 CNV",
    "NMNAT1P3 RNA"
  ],
  "ZNF625": [
    "ZNF625 CNV",
    "ZNF625 RNA"
  ],
  "FOXRED1": [
    "FOXRED1 CNV",
    "FOXRED1 RNA",
    "FOXRED1 Proteo"
  ],
  "GOLGA8F": [
    "GOLGA8F CNV",
    "GOLGA8F RNA"
  ],
  "GOLGA8G": [
    "GOLGA8G CNV",
    "GOLGA8G RNA"
  ],
  "C1QC": [
    "C1QC CNV",
    "C1QC RNA",
    "C1QC Proteo"
  ],
  "MED12L": [
    "MED12L CNV",
    "MED12L RNA"
  ],
  "TP53TG3D": [
    "TP53TG3D CNV",
    "TP53TG3D RNA"
  ],
  "RNA5SP175": [
    "RNA5SP175 CNV",
    "RNA5SP175 RNA"
  ],
  "PCBD1": [
    "PCBD1 CNV",
    "PCBD1 RNA",
    "PCBD1 Proteo"
  ],
  "NOTCH2": [
    "NOTCH2 CNV",
    "NOTCH2 RNA",
    "NOTCH2 Proteo"
  ],
  "HMGN2P8": [
    "HMGN2P8 CNV",
    "HMGN2P8 RNA"
  ],
  "KRT18P48": [
    "KRT18P48 CNV",
    "KRT18P48 RNA"
  ],
  "MYH7B": [
    "MYH7B CNV",
    "MYH7B RNA"
  ],
  "CCDC80": [
    "CCDC80 CNV",
    "CCDC80 RNA",
    "CCDC80 Proteo"
  ],
  "KIF7": [
    "KIF7 CNV",
    "KIF7 RNA",
    "KIF7 Proteo"
  ],
  "TDGF1P3": [
    "TDGF1P3 CNV",
    "TDGF1P3 RNA"
  ],
  "UBE2N": [
    "UBE2N CNV",
    "UBE2N RNA",
    "UBE2N Proteo"
  ],
  "OSTC": [
    "OSTC CNV",
    "OSTC RNA",
    "OSTC Proteo"
  ],
  "UBE2Q2P11": [
    "UBE2Q2P11 CNV",
    "UBE2Q2P11 RNA"
  ],
  "CCDC191": [
    "CCDC191 CNV",
    "CCDC191 RNA"
  ],
  "SERTAD3": [
    "SERTAD3 CNV",
    "SERTAD3 RNA"
  ],
  "NRBP2": [
    "NRBP2 CNV",
    "NRBP2 RNA",
    "NRBP2 Proteo"
  ],
  "RGR": [
    "RGR CNV",
    "RGR RNA"
  ],
  "ST6GALNAC2": [
    "ST6GALNAC2 CNV",
    "ST6GALNAC2 RNA",
    "ST6GALNAC2 Proteo"
  ],
  "VPS35": [
    "VPS35 CNV",
    "VPS35 RNA",
    "VPS35 Proteo"
  ],
  "CPA1": [
    "CPA1 CNV",
    "CPA1 RNA"
  ],
  "PLCL2": [
    "PLCL2 CNV",
    "PLCL2 RNA",
    "PLCL2 Proteo"
  ],
  "FAM72B": [
    "FAM72B CNV",
    "FAM72B RNA"
  ],
  "PKD1": [
    "PKD1 CNV",
    "PKD1 RNA",
    "PKD1 Proteo"
  ],
  "RASL10B": [
    "RASL10B CNV",
    "RASL10B RNA"
  ],
  "RPS13P3": [
    "RPS13P3 CNV",
    "RPS13P3 RNA"
  ],
  "CFAP47": [
    "CFAP47 CNV",
    "CFAP47 RNA",
    "CFAP47 Proteo"
  ],
  "PRAMEF20": [
    "PRAMEF20 CNV",
    "PRAMEF20 RNA"
  ],
  "MSH3": [
    "MSH3 CNV",
    "MSH3 RNA",
    "MSH3 Proteo"
  ],
  "FDPSP1": [
    "FDPSP1 CNV",
    "FDPSP1 RNA"
  ],
  "BCL2L1": [
    "BCL2L1 CNV",
    "BCL2L1 RNA",
    "BCL2L1 Proteo"
  ],
  "LCE1A": [
    "LCE1A CNV",
    "LCE1A RNA"
  ],
  "SGCB": [
    "SGCB CNV",
    "SGCB RNA",
    "SGCB Proteo"
  ],
  "OLFM1": [
    "OLFM1 CNV",
    "OLFM1 RNA",
    "OLFM1 Proteo"
  ],
  "IGHVII-74-1": [
    "IGHVII-74-1 CNV",
    "IGHVII-74-1 RNA"
  ],
  "PTGES3P5": [
    "PTGES3P5 CNV",
    "PTGES3P5 RNA"
  ],
  "OSBPL9P3": [
    "OSBPL9P3 CNV",
    "OSBPL9P3 RNA"
  ],
  "IGKV1-35": [
    "IGKV1-35 CNV",
    "IGKV1-35 RNA"
  ],
  "PUM3": [
    "PUM3 CNV",
    "PUM3 RNA",
    "PUM3 Proteo"
  ],
  "NBPF18P": [
    "NBPF18P CNV",
    "NBPF18P RNA"
  ],
  "MAP6": [
    "MAP6 CNV",
    "MAP6 RNA"
  ],
  "RPL23AP64": [
    "RPL23AP64 CNV",
    "RPL23AP64 RNA"
  ],
  "TTF1": [
    "TTF1 CNV",
    "TTF1 RNA",
    "TTF1 Proteo"
  ],
  "SSR2": [
    "SSR2 CNV",
    "SSR2 RNA"
  ],
  "PIP4K2C": [
    "PIP4K2C CNV",
    "PIP4K2C RNA",
    "PIP4K2C Proteo"
  ],
  "GPR4": [
    "GPR4 CNV",
    "GPR4 RNA"
  ],
  "CNTNAP3B": [
    "CNTNAP3B CNV",
    "CNTNAP3B RNA",
    "CNTNAP3B Proteo"
  ],
  "ZNF365": [
    "ZNF365 CNV",
    "ZNF365 RNA"
  ],
  "SLC15A4": [
    "SLC15A4 CNV",
    "SLC15A4 RNA",
    "SLC15A4 Proteo"
  ],
  "PMS2P5": [
    "PMS2P5 CNV",
    "PMS2P5 RNA"
  ],
  "TP53I11": [
    "TP53I11 CNV",
    "TP53I11 RNA",
    "TP53I11 Proteo"
  ],
  "RPL12P29": [
    "RPL12P29 CNV",
    "RPL12P29 RNA"
  ],
  "ABCA6": [
    "ABCA6 CNV",
    "ABCA6 RNA",
    "ABCA6 Proteo"
  ],
  "SLC41A2": [
    "SLC41A2 CNV",
    "SLC41A2 RNA",
    "SLC41A2 Proteo"
  ],
  "KMT2C": [
    "KMT2C CNV",
    "KMT2C RNA",
    "KMT2C Proteo"
  ],
  "ANKK1": [
    "ANKK1 CNV",
    "ANKK1 RNA"
  ],
  "PRAMEF30P": [
    "PRAMEF30P CNV",
    "PRAMEF30P RNA"
  ],
  "STOX1": [
    "STOX1 CNV",
    "STOX1 RNA"
  ],
  "RPS3AP50": [
    "RPS3AP50 CNV",
    "RPS3AP50 RNA"
  ],
  "IRF2BPL": [
    "IRF2BPL CNV",
    "IRF2BPL RNA",
    "IRF2BPL Proteo"
  ],
  "BUD13": [
    "BUD13 CNV",
    "BUD13 RNA",
    "BUD13 Proteo"
  ],
  "DAXX": [
    "DAXX CNV",
    "DAXX RNA",
    "DAXX Proteo"
  ],
  "RNF185": [
    "RNF185 CNV",
    "RNF185 RNA",
    "RNF185 Proteo"
  ],
  "CNTNAP3P7": [
    "CNTNAP3P7 CNV",
    "CNTNAP3P7 RNA"
  ],
  "TBP": [
    "TBP CNV",
    "TBP RNA",
    "TBP Proteo"
  ],
  "FASTK": [
    "FASTK CNV",
    "FASTK RNA",
    "FASTK Proteo"
  ],
  "DPPA3P1": [
    "DPPA3P1 CNV",
    "DPPA3P1 RNA"
  ],
  "FADS2": [
    "FADS2 CNV",
    "FADS2 RNA",
    "FADS2 Proteo"
  ],
  "MDM2": [
    "MDM2 CNV",
    "MDM2 RNA",
    "MDM2 Proteo"
  ],
  "RAPGEFL1": [
    "RAPGEFL1 CNV",
    "RAPGEFL1 RNA",
    "RAPGEFL1 Proteo"
  ],
  "SLC10A5": [
    "SLC10A5 CNV",
    "SLC10A5 RNA"
  ],
  "TMCO5A": [
    "TMCO5A CNV",
    "TMCO5A RNA"
  ],
  "HBZ": [
    "HBZ CNV",
    "HBZ RNA",
    "HBZ Proteo"
  ],
  "DNAJC19P7": [
    "DNAJC19P7 CNV",
    "DNAJC19P7 RNA"
  ],
  "ARSB": [
    "ARSB CNV",
    "ARSB RNA",
    "ARSB Proteo"
  ],
  "DEFB108D": [
    "DEFB108D CNV",
    "DEFB108D RNA"
  ],
  "RPS18P6": [
    "RPS18P6 CNV",
    "RPS18P6 RNA"
  ],
  "TBC1D3K": [
    "TBC1D3K CNV",
    "TBC1D3K RNA"
  ],
  "IGHV3-21": [
    "IGHV3-21 Proteo"
  ],
  "ABCD4": [
    "ABCD4 CNV",
    "ABCD4 RNA",
    "ABCD4 Proteo"
  ],
  "HMGB3P30": [
    "HMGB3P30 CNV",
    "HMGB3P30 RNA"
  ],
  "OR4F1P": [
    "OR4F1P CNV",
    "OR4F1P RNA"
  ],
  "NCSTN": [
    "NCSTN CNV",
    "NCSTN RNA",
    "NCSTN Proteo"
  ],
  "PRDX6": [
    "PRDX6 CNV",
    "PRDX6 RNA",
    "PRDX6 Proteo"
  ],
  "SPTLC1": [
    "SPTLC1 CNV",
    "SPTLC1 RNA",
    "SPTLC1 Proteo"
  ],
  "THUMPD3": [
    "THUMPD3 CNV",
    "THUMPD3 RNA",
    "THUMPD3 Proteo"
  ],
  "KCNQ5": [
    "KCNQ5 CNV",
    "KCNQ5 RNA",
    "KCNQ5 Proteo"
  ],
  "HSPA8": [
    "HSPA8 CNV",
    "HSPA8 RNA",
    "HSPA8 Proteo"
  ],
  "PCMTD1P3": [
    "PCMTD1P3 CNV",
    "PCMTD1P3 RNA"
  ],
  "SKP1": [
    "SKP1 CNV",
    "SKP1 RNA"
  ],
  "IRS4": [
    "IRS4 CNV",
    "IRS4 RNA"
  ],
  "PABPC1L2B": [
    "PABPC1L2B CNV",
    "PABPC1L2B RNA"
  ],
  "PRPF19P1": [
    "PRPF19P1 CNV",
    "PRPF19P1 RNA"
  ],
  "TEX13D": [
    "TEX13D CNV",
    "TEX13D RNA"
  ],
  "SPECC1P2": [
    "SPECC1P2 CNV",
    "SPECC1P2 RNA"
  ],
  "TAF11L10": [
    "TAF11L10 CNV",
    "TAF11L10 RNA"
  ],
  "REXO2": [
    "REXO2 CNV",
    "REXO2 RNA",
    "REXO2 Proteo"
  ],
  "SCAP": [
    "SCAP CNV",
    "SCAP RNA",
    "SCAP Proteo"
  ],
  "PGAM1P4": [
    "PGAM1P4 CNV",
    "PGAM1P4 RNA"
  ],
  "TPI1P1": [
    "TPI1P1 CNV",
    "TPI1P1 RNA"
  ],
  "SMC3P1": [
    "SMC3P1 CNV",
    "SMC3P1 RNA"
  ],
  "AMD1P3": [
    "AMD1P3 CNV",
    "AMD1P3 RNA"
  ],
  "ARRDC3": [
    "ARRDC3 CNV",
    "ARRDC3 RNA",
    "ARRDC3 Proteo"
  ],
  "LEAP2": [
    "LEAP2 CNV",
    "LEAP2 RNA",
    "LEAP2 Proteo"
  ],
  "TGIF1": [
    "TGIF1 CNV",
    "TGIF1 RNA",
    "TGIF1 Proteo"
  ],
  "TFAP2B": [
    "TFAP2B CNV",
    "TFAP2B RNA"
  ],
  "MARVELD1": [
    "MARVELD1 CNV",
    "MARVELD1 RNA",
    "MARVELD1 Proteo"
  ],
  "IL22RA2": [
    "IL22RA2 CNV",
    "IL22RA2 RNA"
  ],
  "CD55": [
    "CD55 CNV",
    "CD55 RNA",
    "CD55 Proteo"
  ],
  "BPIFB1": [
    "BPIFB1 CNV",
    "BPIFB1 RNA",
    "BPIFB1 Proteo"
  ],
  "LDHAP5": [
    "LDHAP5 CNV",
    "LDHAP5 RNA"
  ],
  "RPL35AP16": [
    "RPL35AP16 CNV",
    "RPL35AP16 RNA"
  ],
  "NPFFR1": [
    "NPFFR1 CNV",
    "NPFFR1 RNA"
  ],
  "STK36": [
    "STK36 CNV",
    "STK36 RNA"
  ],
  "MARCO": [
    "MARCO CNV",
    "MARCO RNA",
    "MARCO Proteo"
  ],
  "MTND1P36": [
    "MTND1P36 CNV",
    "MTND1P36 RNA"
  ],
  "ARMS2": [
    "ARMS2 CNV",
    "ARMS2 RNA"
  ],
  "RPL11P1": [
    "RPL11P1 CNV",
    "RPL11P1 RNA"
  ],
  "SYNJ2BP": [
    "SYNJ2BP CNV",
    "SYNJ2BP RNA",
    "SYNJ2BP Proteo"
  ],
  "PLCD1": [
    "PLCD1 CNV",
    "PLCD1 RNA",
    "PLCD1 Proteo"
  ],
  "CACTIN": [
    "CACTIN CNV",
    "CACTIN RNA",
    "CACTIN Proteo"
  ],
  "CCDC39": [
    "CCDC39 CNV",
    "CCDC39 RNA"
  ],
  "RUNX1T1": [
    "RUNX1T1 CNV",
    "RUNX1T1 RNA"
  ],
  "MIPEP": [
    "MIPEP CNV",
    "MIPEP RNA",
    "MIPEP Proteo"
  ],
  "RNF151": [
    "RNF151 CNV",
    "RNF151 RNA"
  ],
  "ZPR1P1": [
    "ZPR1P1 CNV",
    "ZPR1P1 RNA"
  ],
  "MDGA1": [
    "MDGA1 CNV",
    "MDGA1 RNA"
  ],
  "SPCS2P4": [
    "SPCS2P4 CNV",
    "SPCS2P4 RNA"
  ],
  "ZNF334": [
    "ZNF334 CNV",
    "ZNF334 RNA"
  ],
  "CPEB2": [
    "CPEB2 CNV",
    "CPEB2 RNA",
    "CPEB2 Proteo"
  ],
  "RPL7P30": [
    "RPL7P30 CNV",
    "RPL7P30 RNA"
  ],
  "KLHL6": [
    "KLHL6 CNV",
    "KLHL6 RNA",
    "KLHL6 Proteo"
  ],
  "CDH9": [
    "CDH9 CNV",
    "CDH9 RNA"
  ],
  "GPR27": [
    "GPR27 CNV",
    "GPR27 RNA"
  ],
  "BNIP3P27": [
    "BNIP3P27 CNV",
    "BNIP3P27 RNA"
  ],
  "RTF1": [
    "RTF1 CNV",
    "RTF1 RNA",
    "RTF1 Proteo"
  ],
  "RUNDC3B": [
    "RUNDC3B CNV",
    "RUNDC3B RNA"
  ],
  "HMGB1P45": [
    "HMGB1P45 CNV",
    "HMGB1P45 RNA"
  ],
  "KLF18": [
    "KLF18 CNV",
    "KLF18 RNA"
  ],
  "SERHL2": [
    "SERHL2 CNV",
    "SERHL2 RNA"
  ],
  "FIZ1": [
    "FIZ1 CNV",
    "FIZ1 RNA",
    "FIZ1 Proteo"
  ],
  "ST3GAL1": [
    "ST3GAL1 CNV",
    "ST3GAL1 RNA",
    "ST3GAL1 Proteo"
  ],
  "AGAP2": [
    "AGAP2 CNV",
    "AGAP2 RNA",
    "AGAP2 Proteo"
  ],
  "AKNAD1": [
    "AKNAD1 CNV",
    "AKNAD1 RNA"
  ],
  "CCT5P2": [
    "CCT5P2 CNV",
    "CCT5P2 RNA"
  ],
  "C21orf91": [
    "C21orf91 CNV",
    "C21orf91 RNA",
    "C21orf91 Proteo"
  ],
  "ZCCHC9": [
    "ZCCHC9 CNV",
    "ZCCHC9 RNA",
    "ZCCHC9 Proteo"
  ],
  "NIPAL3": [
    "NIPAL3 CNV",
    "NIPAL3 RNA",
    "NIPAL3 Proteo"
  ],
  "RPL12P27": [
    "RPL12P27 CNV",
    "RPL12P27 RNA"
  ],
  "FTLP19": [
    "FTLP19 CNV",
    "FTLP19 RNA"
  ],
  "METTL3": [
    "METTL3 CNV",
    "METTL3 RNA",
    "METTL3 Proteo"
  ],
  "HSPBP1": [
    "HSPBP1 CNV",
    "HSPBP1 RNA",
    "HSPBP1 Proteo"
  ],
  "CLASP1": [
    "CLASP1 CNV",
    "CLASP1 RNA",
    "CLASP1 Proteo"
  ],
  "TMEM248": [
    "TMEM248 CNV",
    "TMEM248 RNA",
    "TMEM248 Proteo"
  ],
  "HIF1A": [
    "HIF1A CNV",
    "HIF1A RNA"
  ],
  "RPS12P20": [
    "RPS12P20 CNV",
    "RPS12P20 RNA"
  ],
  "C8orf89": [
    "C8orf89 CNV",
    "C8orf89 RNA"
  ],
  "RNA5SP220": [
    "RNA5SP220 CNV",
    "RNA5SP220 RNA"
  ],
  "RNF112": [
    "RNF112 CNV",
    "RNF112 RNA"
  ],
  "NEIL1": [
    "NEIL1 CNV",
    "NEIL1 RNA",
    "NEIL1 Proteo"
  ],
  "FGF2": [
    "FGF2 CNV",
    "FGF2 RNA",
    "FGF2 Proteo"
  ],
  "C6orf226": [
    "C6orf226 CNV",
    "C6orf226 RNA"
  ],
  "TXNP7": [
    "TXNP7 CNV",
    "TXNP7 RNA"
  ],
  "NPBWR1": [
    "NPBWR1 CNV",
    "NPBWR1 RNA"
  ],
  "CXCR2": [
    "CXCR2 CNV",
    "CXCR2 RNA",
    "CXCR2 Proteo"
  ],
  "MGAT2P1": [
    "MGAT2P1 CNV",
    "MGAT2P1 RNA"
  ],
  "RARRES2P10": [
    "RARRES2P10 CNV",
    "RARRES2P10 RNA"
  ],
  "GATM": [
    "GATM CNV",
    "GATM RNA",
    "GATM Proteo"
  ],
  "MARK2P13": [
    "MARK2P13 CNV",
    "MARK2P13 RNA"
  ],
  "SNAPC2": [
    "SNAPC2 CNV",
    "SNAPC2 RNA",
    "SNAPC2 Proteo"
  ],
  "TRAV32": [
    "TRAV32 CNV",
    "TRAV32 RNA"
  ],
  "FAM3D": [
    "FAM3D CNV",
    "FAM3D RNA",
    "FAM3D Proteo"
  ],
  "WFDC12": [
    "WFDC12 CNV",
    "WFDC12 RNA",
    "WFDC12 Proteo"
  ],
  "SLC25A18": [
    "SLC25A18 CNV",
    "SLC25A18 RNA",
    "SLC25A18 Proteo"
  ],
  "MBOAT4": [
    "MBOAT4 CNV",
    "MBOAT4 RNA"
  ],
  "H1-7": [
    "H1-7 CNV",
    "H1-7 RNA"
  ],
  "CSF2RB": [
    "CSF2RB CNV",
    "CSF2RB RNA",
    "CSF2RB Proteo"
  ],
  "APOBEC2": [
    "APOBEC2 CNV",
    "APOBEC2 RNA",
    "APOBEC2 Proteo"
  ],
  "ALDH7A1P4": [
    "ALDH7A1P4 CNV",
    "ALDH7A1P4 RNA"
  ],
  "TRIM8": [
    "TRIM8 CNV",
    "TRIM8 RNA",
    "TRIM8 Proteo"
  ],
  "EXD3": [
    "EXD3 CNV",
    "EXD3 RNA",
    "EXD3 Proteo"
  ],
  "FAM199X": [
    "FAM199X CNV",
    "FAM199X RNA",
    "FAM199X Proteo"
  ],
  "PLIN1": [
    "PLIN1 CNV",
    "PLIN1 RNA",
    "PLIN1 Proteo"
  ],
  "ASAP1": [
    "ASAP1 CNV",
    "ASAP1 RNA",
    "ASAP1 Proteo"
  ],
  "NXT1P1": [
    "NXT1P1 CNV",
    "NXT1P1 RNA"
  ],
  "CDC42P1": [
    "CDC42P1 CNV",
    "CDC42P1 RNA"
  ],
  "HGSNAT": [
    "HGSNAT CNV",
    "HGSNAT RNA",
    "HGSNAT Proteo"
  ],
  "PGM5": [
    "PGM5 CNV",
    "PGM5 RNA",
    "PGM5 Proteo"
  ],
  "ZNF534": [
    "ZNF534 CNV",
    "ZNF534 RNA"
  ],
  "GUSBP15": [
    "GUSBP15 CNV",
    "GUSBP15 RNA"
  ],
  "SLC6A14P3": [
    "SLC6A14P3 CNV",
    "SLC6A14P3 RNA"
  ],
  "VN2R3P": [
    "VN2R3P CNV",
    "VN2R3P RNA"
  ],
  "ODF3B": [
    "ODF3B CNV",
    "ODF3B RNA",
    "ODF3B Proteo"
  ],
  "LYPLAL1": [
    "LYPLAL1 CNV",
    "LYPLAL1 RNA",
    "LYPLAL1 Proteo"
  ],
  "OSTF1P1": [
    "OSTF1P1 CNV",
    "OSTF1P1 RNA"
  ],
  "CYP4Z2P": [
    "CYP4Z2P CNV",
    "CYP4Z2P RNA"
  ],
  "UBA52P3": [
    "UBA52P3 CNV",
    "UBA52P3 RNA"
  ],
  "EXTL2P1": [
    "EXTL2P1 CNV",
    "EXTL2P1 RNA"
  ],
  "DDX11L5": [
    "DDX11L5 CNV",
    "DDX11L5 RNA"
  ],
  "CDK4": [
    "CDK4 CNV",
    "CDK4 RNA",
    "CDK4 Proteo"
  ],
  "ANKRD13A": [
    "ANKRD13A CNV",
    "ANKRD13A RNA",
    "ANKRD13A Proteo"
  ],
  "CENPF": [
    "CENPF CNV",
    "CENPF RNA",
    "CENPF Proteo"
  ],
  "ARPC3P3": [
    "ARPC3P3 CNV",
    "ARPC3P3 RNA"
  ],
  "SP4": [
    "SP4 CNV",
    "SP4 RNA",
    "SP4 Proteo"
  ],
  "DIO3": [
    "DIO3 CNV",
    "DIO3 RNA"
  ],
  "LDHBP1": [
    "LDHBP1 CNV",
    "LDHBP1 RNA"
  ],
  "COX7A2": [
    "COX7A2 CNV",
    "COX7A2 RNA",
    "COX7A2 Proteo"
  ],
  "JAKMIP2": [
    "JAKMIP2 CNV",
    "JAKMIP2 RNA"
  ],
  "WBP11P3": [
    "WBP11P3 CNV",
    "WBP11P3 RNA"
  ],
  "ADAMTSL1": [
    "ADAMTSL1 CNV",
    "ADAMTSL1 RNA",
    "ADAMTSL1 Proteo"
  ],
  "KPNA4": [
    "KPNA4 CNV",
    "KPNA4 RNA",
    "KPNA4 Proteo"
  ],
  "MRPS33": [
    "MRPS33 CNV",
    "MRPS33 RNA",
    "MRPS33 Proteo"
  ],
  "KRT27": [
    "KRT27 CNV",
    "KRT27 RNA",
    "KRT27 Proteo"
  ],
  "STPG2": [
    "STPG2 CNV",
    "STPG2 RNA"
  ],
  "UBE2D1": [
    "UBE2D1 CNV",
    "UBE2D1 RNA",
    "UBE2D1 Proteo"
  ],
  "CERCAM": [
    "CERCAM CNV",
    "CERCAM RNA",
    "CERCAM Proteo"
  ],
  "MAPK6P4": [
    "MAPK6P4 CNV",
    "MAPK6P4 RNA"
  ],
  "PLXNA3": [
    "PLXNA3 CNV",
    "PLXNA3 RNA",
    "PLXNA3 Proteo"
  ],
  "RTP3": [
    "RTP3 CNV",
    "RTP3 RNA"
  ],
  "ARPIN-AP3S2": [
    "ARPIN-AP3S2 Proteo"
  ],
  "SPANXN2": [
    "SPANXN2 CNV",
    "SPANXN2 RNA"
  ],
  "PIGPP4": [
    "PIGPP4 CNV",
    "PIGPP4 RNA"
  ],
  "OR8I4P": [
    "OR8I4P CNV",
    "OR8I4P RNA"
  ],
  "TGFBR1": [
    "TGFBR1 CNV",
    "TGFBR1 RNA",
    "TGFBR1 Proteo"
  ],
  "SNX11": [
    "SNX11 CNV",
    "SNX11 RNA",
    "SNX11 Proteo"
  ],
  "MT4": [
    "MT4 CNV",
    "MT4 RNA"
  ],
  "KCTD14": [
    "KCTD14 CNV",
    "KCTD14 RNA",
    "KCTD14 Proteo"
  ],
  "MLPH": [
    "MLPH CNV",
    "MLPH RNA",
    "MLPH Proteo"
  ],
  "PARD3B": [
    "PARD3B CNV",
    "PARD3B RNA",
    "PARD3B Proteo"
  ],
  "PIGC": [
    "PIGC CNV",
    "PIGC RNA",
    "PIGC Proteo"
  ],
  "KIF26A": [
    "KIF26A CNV",
    "KIF26A RNA"
  ],
  "MYL9": [
    "MYL9 CNV",
    "MYL9 RNA",
    "MYL9 Proteo"
  ],
  "SAA2-SAA4": [
    "SAA2-SAA4 Proteo"
  ],
  "HLA-DRB5": [
    "HLA-DRB5 CNV",
    "HLA-DRB5 RNA",
    "HLA-DRB5 Proteo"
  ],
  "RNA5SP149": [
    "RNA5SP149 CNV",
    "RNA5SP149 RNA"
  ],
  "TBC1D27P": [
    "TBC1D27P CNV",
    "TBC1D27P RNA"
  ],
  "NEURL2": [
    "NEURL2 CNV",
    "NEURL2 RNA"
  ],
  "KRT1": [
    "KRT1 CNV",
    "KRT1 RNA",
    "KRT1 Proteo"
  ],
  "POP7": [
    "POP7 CNV",
    "POP7 RNA",
    "POP7 Proteo"
  ],
  "MEIKIN": [
    "MEIKIN CNV",
    "MEIKIN RNA"
  ],
  "POU5F2": [
    "POU5F2 CNV",
    "POU5F2 RNA"
  ],
  "OR52E6": [
    "OR52E6 CNV",
    "OR52E6 RNA"
  ],
  "BCHE": [
    "BCHE CNV",
    "BCHE RNA",
    "BCHE Proteo"
  ],
  "TXNDC9": [
    "TXNDC9 CNV",
    "TXNDC9 RNA",
    "TXNDC9 Proteo"
  ],
  "TP53TG3C": [
    "TP53TG3C CNV",
    "TP53TG3C RNA"
  ],
  "RNA5SP391": [
    "RNA5SP391 CNV",
    "RNA5SP391 RNA"
  ],
  "CRYZ": [
    "CRYZ CNV",
    "CRYZ RNA",
    "CRYZ Proteo"
  ],
  "RPSAP73": [
    "RPSAP73 CNV",
    "RPSAP73 RNA"
  ],
  "MTND4P15": [
    "MTND4P15 CNV",
    "MTND4P15 RNA"
  ],
  "SMPDL3B": [
    "SMPDL3B CNV",
    "SMPDL3B RNA",
    "SMPDL3B Proteo"
  ],
  "RHOT1P1": [
    "RHOT1P1 CNV",
    "RHOT1P1 RNA"
  ],
  "FMNL2": [
    "FMNL2 CNV",
    "FMNL2 RNA",
    "FMNL2 Proteo"
  ],
  "CLCN2": [
    "CLCN2 CNV",
    "CLCN2 RNA",
    "CLCN2 Proteo"
  ],
  "XCL2": [
    "XCL2 CNV",
    "XCL2 RNA"
  ],
  "ZNF628": [
    "ZNF628 CNV",
    "ZNF628 RNA"
  ],
  "ZDHHC24": [
    "ZDHHC24 CNV",
    "ZDHHC24 RNA",
    "ZDHHC24 Proteo"
  ],
  "HOMER2": [
    "HOMER2 CNV",
    "HOMER2 RNA",
    "HOMER2 Proteo"
  ],
  "OR52M1": [
    "OR52M1 CNV",
    "OR52M1 RNA"
  ],
  "AP4B1": [
    "AP4B1 CNV",
    "AP4B1 RNA",
    "AP4B1 Proteo"
  ],
  "SIGLEC14": [
    "SIGLEC14 CNV",
    "SIGLEC14 RNA"
  ],
  "IL10": [
    "IL10 CNV",
    "IL10 RNA"
  ],
  "PLXNA4": [
    "PLXNA4 CNV",
    "PLXNA4 RNA"
  ],
  "RPL35AP13": [
    "RPL35AP13 CNV",
    "RPL35AP13 RNA"
  ],
  "RPL7P5": [
    "RPL7P5 CNV",
    "RPL7P5 RNA"
  ],
  "GNL1": [
    "GNL1 CNV",
    "GNL1 RNA",
    "GNL1 Proteo"
  ],
  "PYDC1": [
    "PYDC1 CNV",
    "PYDC1 RNA"
  ],
  "OR56A5": [
    "OR56A5 CNV",
    "OR56A5 RNA"
  ],
  "MORN5": [
    "MORN5 CNV",
    "MORN5 RNA"
  ],
  "GC": [
    "GC CNV",
    "GC RNA",
    "GC Proteo"
  ],
  "HNRNPA1P46": [
    "HNRNPA1P46 CNV",
    "HNRNPA1P46 RNA"
  ],
  "VCX": [
    "VCX CNV",
    "VCX RNA"
  ],
  "MBP": [
    "MBP CNV",
    "MBP RNA",
    "MBP Proteo"
  ],
  "LPO": [
    "LPO CNV",
    "LPO RNA",
    "LPO Proteo"
  ],
  "FTLP1": [
    "FTLP1 CNV",
    "FTLP1 RNA"
  ],
  "GATA5": [
    "GATA5 CNV",
    "GATA5 RNA"
  ],
  "NYNRIN": [
    "NYNRIN CNV",
    "NYNRIN RNA",
    "NYNRIN Proteo"
  ],
  "KRT18P56": [
    "KRT18P56 CNV",
    "KRT18P56 RNA"
  ],
  "CDHR3": [
    "CDHR3 CNV",
    "CDHR3 RNA"
  ],
  "LYPLA1P3": [
    "LYPLA1P3 CNV",
    "LYPLA1P3 RNA"
  ],
  "OR5D15P": [
    "OR5D15P CNV",
    "OR5D15P RNA"
  ],
  "RALBP1": [
    "RALBP1 CNV",
    "RALBP1 RNA",
    "RALBP1 Proteo"
  ],
  "ITSN2": [
    "ITSN2 CNV",
    "ITSN2 RNA",
    "ITSN2 Proteo"
  ],
  "NUDT4": [
    "NUDT4 CNV",
    "NUDT4 RNA",
    "NUDT4 Proteo"
  ],
  "HMGB1P25": [
    "HMGB1P25 CNV",
    "HMGB1P25 RNA"
  ],
  "RPL37P10": [
    "RPL37P10 CNV",
    "RPL37P10 RNA"
  ],
  "ZNF840P": [
    "ZNF840P CNV",
    "ZNF840P RNA"
  ],
  "YWHAZP2": [
    "YWHAZP2 CNV",
    "YWHAZP2 RNA"
  ],
  "CSN1S1": [
    "CSN1S1 CNV",
    "CSN1S1 RNA"
  ],
  "B3GNT4": [
    "B3GNT4 CNV",
    "B3GNT4 RNA"
  ],
  "C22orf23": [
    "C22orf23 CNV",
    "C22orf23 RNA"
  ],
  "EIF3B": [
    "EIF3B CNV",
    "EIF3B RNA",
    "EIF3B Proteo"
  ],
  "RAC1P2": [
    "RAC1P2 CNV",
    "RAC1P2 RNA"
  ],
  "ACE2": [
    "ACE2 CNV",
    "ACE2 RNA"
  ],
  "CLDN18": [
    "CLDN18 CNV",
    "CLDN18 RNA"
  ],
  "HOXB1": [
    "HOXB1 CNV",
    "HOXB1 RNA"
  ],
  "OR4D1": [
    "OR4D1 CNV",
    "OR4D1 RNA"
  ],
  "WDR37": [
    "WDR37 CNV",
    "WDR37 RNA",
    "WDR37 Proteo"
  ],
  "RPL3P3": [
    "RPL3P3 CNV",
    "RPL3P3 RNA"
  ],
  "PIMREGP4": [
    "PIMREGP4 CNV",
    "PIMREGP4 RNA"
  ],
  "MARVELD2": [
    "MARVELD2 CNV",
    "MARVELD2 RNA"
  ],
  "DNAJA1P4": [
    "DNAJA1P4 CNV",
    "DNAJA1P4 RNA"
  ],
  "RPRD1A": [
    "RPRD1A CNV",
    "RPRD1A RNA",
    "RPRD1A Proteo"
  ],
  "OFD1P18Y": [
    "OFD1P18Y CNV",
    "OFD1P18Y RNA"
  ],
  "OR9R1P": [
    "OR9R1P CNV",
    "OR9R1P RNA"
  ],
  "FBXO10": [
    "FBXO10 CNV",
    "FBXO10 RNA"
  ],
  "VPS13C": [
    "VPS13C CNV",
    "VPS13C RNA",
    "VPS13C Proteo"
  ],
  "HLA-DOA": [
    "HLA-DOA CNV",
    "HLA-DOA RNA",
    "HLA-DOA Proteo"
  ],
  "RNA5SP504": [
    "RNA5SP504 CNV",
    "RNA5SP504 RNA"
  ],
  "PTPRM": [
    "PTPRM CNV",
    "PTPRM RNA",
    "PTPRM Proteo"
  ],
  "PAGE2B": [
    "PAGE2B CNV",
    "PAGE2B RNA"
  ],
  "SLC9A9": [
    "SLC9A9 CNV",
    "SLC9A9 RNA",
    "SLC9A9 Proteo"
  ],
  "TBC1D15": [
    "TBC1D15 CNV",
    "TBC1D15 RNA",
    "TBC1D15 Proteo"
  ],
  "TBCK": [
    "TBCK CNV",
    "TBCK RNA",
    "TBCK Proteo"
  ],
  "TMEM259": [
    "TMEM259 CNV",
    "TMEM259 RNA",
    "TMEM259 Proteo"
  ],
  "CARD16": [
    "CARD16 CNV",
    "CARD16 RNA",
    "CARD16 Proteo"
  ],
  "CRISP3": [
    "CRISP3 CNV",
    "CRISP3 RNA",
    "CRISP3 Proteo"
  ],
  "ZBTB38": [
    "ZBTB38 CNV",
    "ZBTB38 RNA",
    "ZBTB38 Proteo"
  ],
  "LCN2": [
    "LCN2 CNV",
    "LCN2 RNA",
    "LCN2 Proteo"
  ],
  "PPIL6": [
    "PPIL6 CNV",
    "PPIL6 RNA"
  ],
  "DCDC2C": [
    "DCDC2C CNV",
    "DCDC2C RNA"
  ],
  "SPTSSB": [
    "SPTSSB CNV",
    "SPTSSB RNA",
    "SPTSSB Proteo"
  ],
  "COMMD4": [
    "COMMD4 CNV",
    "COMMD4 RNA",
    "COMMD4 Proteo"
  ],
  "CYP51A1P2": [
    "CYP51A1P2 CNV",
    "CYP51A1P2 RNA"
  ],
  "ESR2": [
    "ESR2 CNV",
    "ESR2 RNA"
  ],
  "NUP188": [
    "NUP188 CNV",
    "NUP188 RNA",
    "NUP188 Proteo"
  ],
  "MYLK4": [
    "MYLK4 CNV",
    "MYLK4 RNA"
  ],
  "ARID3A": [
    "ARID3A CNV",
    "ARID3A RNA",
    "ARID3A Proteo"
  ],
  "TP73": [
    "TP73 CNV",
    "TP73 RNA"
  ],
  "SART3": [
    "SART3 CNV",
    "SART3 RNA",
    "SART3 Proteo"
  ],
  "CLGN": [
    "CLGN CNV",
    "CLGN RNA",
    "CLGN Proteo"
  ],
  "AKR1B1": [
    "AKR1B1 CNV",
    "AKR1B1 RNA",
    "AKR1B1 Proteo"
  ],
  "MTND3P9": [
    "MTND3P9 CNV",
    "MTND3P9 RNA"
  ],
  "USP17L16P": [
    "USP17L16P CNV",
    "USP17L16P RNA"
  ],
  "H2BC17": [
    "H2BC17 CNV",
    "H2BC17 RNA"
  ],
  "SMURF1": [
    "SMURF1 CNV",
    "SMURF1 RNA",
    "SMURF1 Proteo"
  ],
  "MTND1P23": [
    "MTND1P23 CNV",
    "MTND1P23 RNA"
  ],
  "LACTBL1": [
    "LACTBL1 CNV",
    "LACTBL1 RNA"
  ],
  "HNF4GP1": [
    "HNF4GP1 CNV",
    "HNF4GP1 RNA"
  ],
  "ADH1C": [
    "ADH1C CNV",
    "ADH1C RNA",
    "ADH1C Proteo"
  ],
  "NANP": [
    "NANP CNV",
    "NANP RNA",
    "NANP Proteo"
  ],
  "USP9YP17": [
    "USP9YP17 CNV",
    "USP9YP17 RNA"
  ],
  "EPYC": [
    "EPYC CNV",
    "EPYC RNA"
  ],
  "LAMTOR4": [
    "LAMTOR4 CNV",
    "LAMTOR4 RNA",
    "LAMTOR4 Proteo"
  ],
  "MTND4LP30": [
    "MTND4LP30 CNV",
    "MTND4LP30 RNA"
  ],
  "C4orf19": [
    "C4orf19 CNV",
    "C4orf19 RNA",
    "C4orf19 Proteo"
  ],
  "AP5Z1": [
    "AP5Z1 CNV",
    "AP5Z1 RNA",
    "AP5Z1 Proteo"
  ],
  "ODF4": [
    "ODF4 CNV",
    "ODF4 RNA"
  ],
  "PES1P2": [
    "PES1P2 CNV",
    "PES1P2 RNA"
  ],
  "KYNUP1": [
    "KYNUP1 CNV",
    "KYNUP1 RNA"
  ],
  "AMZ1": [
    "AMZ1 CNV",
    "AMZ1 RNA"
  ],
  "RPSAP17": [
    "RPSAP17 CNV",
    "RPSAP17 RNA"
  ],
  "CYP2C8": [
    "CYP2C8 CNV",
    "CYP2C8 RNA"
  ],
  "SOCS5P4": [
    "SOCS5P4 CNV",
    "SOCS5P4 RNA"
  ],
  "SBF1P2": [
    "SBF1P2 CNV",
    "SBF1P2 RNA"
  ],
  "OR8A3P": [
    "OR8A3P CNV",
    "OR8A3P RNA"
  ],
  "OR11H4": [
    "OR11H4 CNV",
    "OR11H4 RNA"
  ],
  "RPL23AP18": [
    "RPL23AP18 CNV",
    "RPL23AP18 RNA"
  ],
  "FAT3": [
    "FAT3 CNV",
    "FAT3 RNA"
  ],
  "PPIB": [
    "PPIB CNV",
    "PPIB RNA",
    "PPIB Proteo"
  ],
  "RPL39P33": [
    "RPL39P33 CNV",
    "RPL39P33 RNA"
  ],
  "SMAP2": [
    "SMAP2 CNV",
    "SMAP2 RNA",
    "SMAP2 Proteo"
  ],
  "GPR108": [
    "GPR108 CNV",
    "GPR108 RNA",
    "GPR108 Proteo"
  ],
  "TRIM53AP": [
    "TRIM53AP CNV",
    "TRIM53AP RNA"
  ],
  "LINC01529": [
    "LINC01529 CNV",
    "LINC01529 RNA"
  ],
  "IGLV4-69": [
    "IGLV4-69 Proteo"
  ],
  "CYP2R1": [
    "CYP2R1 CNV",
    "CYP2R1 RNA",
    "CYP2R1 Proteo"
  ],
  "CHRAC1": [
    "CHRAC1 CNV",
    "CHRAC1 RNA",
    "CHRAC1 Proteo"
  ],
  "CSPG4P11": [
    "CSPG4P11 CNV",
    "CSPG4P11 RNA"
  ],
  "HOOK2": [
    "HOOK2 CNV",
    "HOOK2 RNA",
    "HOOK2 Proteo"
  ],
  "ELK1P1": [
    "ELK1P1 CNV",
    "ELK1P1 RNA"
  ],
  "GOLGA6L7": [
    "GOLGA6L7 CNV",
    "GOLGA6L7 RNA"
  ],
  "RRAGAP1": [
    "RRAGAP1 CNV",
    "RRAGAP1 RNA"
  ],
  "SRP68P1": [
    "SRP68P1 CNV",
    "SRP68P1 RNA"
  ],
  "TSEN54": [
    "TSEN54 CNV",
    "TSEN54 RNA",
    "TSEN54 Proteo"
  ],
  "NCR3LG1": [
    "NCR3LG1 CNV",
    "NCR3LG1 RNA",
    "NCR3LG1 Proteo"
  ],
  "GVINP1": [
    "GVINP1 CNV",
    "GVINP1 RNA"
  ],
  "RAB4A": [
    "RAB4A CNV",
    "RAB4A RNA",
    "RAB4A Proteo"
  ],
  "AKAP12": [
    "AKAP12 CNV",
    "AKAP12 RNA",
    "AKAP12 Proteo"
  ],
  "ITGA10": [
    "ITGA10 CNV",
    "ITGA10 RNA",
    "ITGA10 Proteo"
  ],
  "MYO18B": [
    "MYO18B CNV",
    "MYO18B RNA"
  ],
  "OR5K1": [
    "OR5K1 CNV",
    "OR5K1 RNA"
  ],
  "USP9YP18": [
    "USP9YP18 CNV",
    "USP9YP18 RNA"
  ],
  "ZNF736P4Y": [
    "ZNF736P4Y CNV",
    "ZNF736P4Y RNA"
  ],
  "WWOX": [
    "WWOX CNV",
    "WWOX RNA",
    "WWOX Proteo"
  ],
  "PTP4A2": [
    "PTP4A2 CNV",
    "PTP4A2 RNA",
    "PTP4A2 Proteo"
  ],
  "NBPF7P": [
    "NBPF7P CNV",
    "NBPF7P RNA"
  ],
  "USP9Y": [
    "USP9Y CNV",
    "USP9Y RNA",
    "USP9Y Proteo"
  ],
  "LRFN4": [
    "LRFN4 CNV",
    "LRFN4 RNA",
    "LRFN4 Proteo"
  ],
  "SYTL5": [
    "SYTL5 CNV",
    "SYTL5 RNA",
    "SYTL5 Proteo"
  ],
  "RNA5SP507": [
    "RNA5SP507 CNV",
    "RNA5SP507 RNA"
  ],
  "UBAC2": [
    "UBAC2 CNV",
    "UBAC2 RNA",
    "UBAC2 Proteo"
  ],
  "CLEC17A": [
    "CLEC17A CNV",
    "CLEC17A RNA"
  ],
  "PNMA6E": [
    "PNMA6E CNV",
    "PNMA6E RNA"
  ],
  "SMIM18": [
    "SMIM18 CNV",
    "SMIM18 RNA"
  ],
  "TRAK2": [
    "TRAK2 CNV",
    "TRAK2 RNA",
    "TRAK2 Proteo"
  ],
  "NCBP1": [
    "NCBP1 CNV",
    "NCBP1 RNA",
    "NCBP1 Proteo"
  ],
  "PDSS1": [
    "PDSS1 CNV",
    "PDSS1 RNA",
    "PDSS1 Proteo"
  ],
  "SCN8A": [
    "SCN8A CNV",
    "SCN8A RNA"
  ],
  "MRPL12": [
    "MRPL12 CNV",
    "MRPL12 RNA",
    "MRPL12 Proteo"
  ],
  "AANAT": [
    "AANAT CNV",
    "AANAT RNA"
  ],
  "HMGN2P9": [
    "HMGN2P9 CNV",
    "HMGN2P9 RNA"
  ],
  "ATP6V1G1P3": [
    "ATP6V1G1P3 CNV",
    "ATP6V1G1P3 RNA"
  ],
  "ARPC3P2": [
    "ARPC3P2 CNV",
    "ARPC3P2 RNA"
  ],
  "RPL10P13": [
    "RPL10P13 CNV",
    "RPL10P13 RNA"
  ],
  "HMGXB4": [
    "HMGXB4 CNV",
    "HMGXB4 RNA",
    "HMGXB4 Proteo"
  ],
  "PPIAP46": [
    "PPIAP46 CNV",
    "PPIAP46 RNA"
  ],
  "ATF6": [
    "ATF6 CNV",
    "ATF6 RNA",
    "ATF6 Proteo"
  ],
  "SSH2": [
    "SSH2 CNV",
    "SSH2 RNA",
    "SSH2 Proteo"
  ],
  "IGHV3OR16-12": [
    "IGHV3OR16-12 Proteo"
  ],
  "SP7": [
    "SP7 CNV",
    "SP7 RNA"
  ],
  "ZFP69B": [
    "ZFP69B CNV",
    "ZFP69B RNA"
  ],
  "GNAI2P2": [
    "GNAI2P2 CNV",
    "GNAI2P2 RNA"
  ],
  "DNM1P34": [
    "DNM1P34 CNV",
    "DNM1P34 RNA"
  ],
  "TMEM9": [
    "TMEM9 CNV",
    "TMEM9 RNA",
    "TMEM9 Proteo"
  ],
  "CLEC4A": [
    "CLEC4A CNV",
    "CLEC4A RNA",
    "CLEC4A Proteo"
  ],
  "CLCN6": [
    "CLCN6 CNV",
    "CLCN6 RNA",
    "CLCN6 Proteo"
  ],
  "RNA5SP496": [
    "RNA5SP496 CNV",
    "RNA5SP496 RNA"
  ],
  "SCNN1G": [
    "SCNN1G CNV",
    "SCNN1G RNA"
  ],
  "MED17": [
    "MED17 CNV",
    "MED17 RNA",
    "MED17 Proteo"
  ],
  "ITGA11": [
    "ITGA11 CNV",
    "ITGA11 RNA",
    "ITGA11 Proteo"
  ],
  "PSMC1P1": [
    "PSMC1P1 CNV",
    "PSMC1P1 RNA"
  ],
  "TMEM179B": [
    "TMEM179B CNV",
    "TMEM179B RNA",
    "TMEM179B Proteo"
  ],
  "TMEM208": [
    "TMEM208 CNV",
    "TMEM208 RNA",
    "TMEM208 Proteo"
  ],
  "OR11H13P": [
    "OR11H13P CNV",
    "OR11H13P RNA"
  ],
  "TEX29": [
    "TEX29 CNV",
    "TEX29 RNA"
  ],
  "RPSAP20": [
    "RPSAP20 CNV",
    "RPSAP20 RNA"
  ],
  "APBA2": [
    "APBA2 CNV",
    "APBA2 RNA",
    "APBA2 Proteo"
  ],
  "TMEM18": [
    "TMEM18 CNV",
    "TMEM18 RNA"
  ],
  "GAPDHP33": [
    "GAPDHP33 CNV",
    "GAPDHP33 RNA"
  ],
  "PHOSPHO2": [
    "PHOSPHO2 CNV",
    "PHOSPHO2 RNA"
  ],
  "FRMPD2": [
    "FRMPD2 CNV",
    "FRMPD2 RNA"
  ],
  "NHLRC3": [
    "NHLRC3 CNV",
    "NHLRC3 RNA",
    "NHLRC3 Proteo"
  ],
  "MYOC": [
    "MYOC CNV",
    "MYOC RNA",
    "MYOC Proteo"
  ],
  "REEP3": [
    "REEP3 CNV",
    "REEP3 RNA",
    "REEP3 Proteo"
  ],
  "BOLA2": [
    "BOLA2 CNV",
    "BOLA2 RNA",
    "BOLA2 Proteo"
  ],
  "SRM": [
    "SRM CNV",
    "SRM RNA",
    "SRM Proteo"
  ],
  "OR6C75": [
    "OR6C75 CNV",
    "OR6C75 RNA"
  ],
  "RPL21P18": [
    "RPL21P18 CNV",
    "RPL21P18 RNA"
  ],
  "CWC27": [
    "CWC27 CNV",
    "CWC27 RNA",
    "CWC27 Proteo"
  ],
  "PLCB4": [
    "PLCB4 CNV",
    "PLCB4 RNA",
    "PLCB4 Proteo"
  ],
  "IGHV2-26": [
    "IGHV2-26 Proteo"
  ],
  "MEX3B": [
    "MEX3B CNV",
    "MEX3B RNA",
    "MEX3B Proteo"
  ],
  "SNRPGP1": [
    "SNRPGP1 CNV",
    "SNRPGP1 RNA"
  ],
  "CHIAP2": [
    "CHIAP2 CNV",
    "CHIAP2 RNA"
  ],
  "SNRPGP6": [
    "SNRPGP6 CNV",
    "SNRPGP6 RNA"
  ],
  "ALG1L11P": [
    "ALG1L11P CNV",
    "ALG1L11P RNA"
  ],
  "HDGFL3": [
    "HDGFL3 CNV",
    "HDGFL3 RNA",
    "HDGFL3 Proteo"
  ],
  "GALR1": [
    "GALR1 CNV",
    "GALR1 RNA"
  ],
  "IQCB2P": [
    "IQCB2P CNV",
    "IQCB2P RNA"
  ],
  "SFXN2": [
    "SFXN2 CNV",
    "SFXN2 RNA",
    "SFXN2 Proteo"
  ],
  "SEH1L": [
    "SEH1L CNV",
    "SEH1L RNA",
    "SEH1L Proteo"
  ],
  "RPS29P31": [
    "RPS29P31 CNV",
    "RPS29P31 RNA"
  ],
  "MTCO3P21": [
    "MTCO3P21 CNV",
    "MTCO3P21 RNA"
  ],
  "ZNF410": [
    "ZNF410 CNV",
    "ZNF410 RNA",
    "ZNF410 Proteo"
  ],
  "TRMT112P1": [
    "TRMT112P1 CNV",
    "TRMT112P1 RNA"
  ],
  "AK4P5": [
    "AK4P5 CNV",
    "AK4P5 RNA"
  ],
  "C8B": [
    "C8B CNV",
    "C8B RNA",
    "C8B Proteo"
  ],
  "SERPINA11": [
    "SERPINA11 CNV",
    "SERPINA11 RNA"
  ],
  "SETD1B": [
    "SETD1B CNV",
    "SETD1B RNA",
    "SETD1B Proteo"
  ],
  "MYH6": [
    "MYH6 CNV",
    "MYH6 RNA"
  ],
  "DHRS4L1": [
    "DHRS4L1 CNV",
    "DHRS4L1 RNA"
  ],
  "ADGRB3": [
    "ADGRB3 CNV",
    "ADGRB3 RNA"
  ],
  "LUC7L": [
    "LUC7L CNV",
    "LUC7L RNA",
    "LUC7L Proteo"
  ],
  "RPL17P15": [
    "RPL17P15 CNV",
    "RPL17P15 RNA"
  ],
  "GPR61": [
    "GPR61 CNV",
    "GPR61 RNA"
  ],
  "ITPK1": [
    "ITPK1 CNV",
    "ITPK1 RNA",
    "ITPK1 Proteo"
  ],
  "MTOR": [
    "MTOR CNV",
    "MTOR RNA",
    "MTOR Proteo"
  ],
  "MTCO3P8": [
    "MTCO3P8 CNV",
    "MTCO3P8 RNA"
  ],
  "ZNF773": [
    "ZNF773 CNV",
    "ZNF773 RNA",
    "ZNF773 Proteo"
  ],
  "NPC1": [
    "NPC1 CNV",
    "NPC1 RNA",
    "NPC1 Proteo"
  ],
  "DNAJC17P1": [
    "DNAJC17P1 CNV",
    "DNAJC17P1 RNA"
  ],
  "FPGT": [
    "FPGT CNV",
    "FPGT RNA",
    "FPGT Proteo"
  ],
  "MT1H": [
    "MT1H CNV",
    "MT1H RNA",
    "MT1H Proteo"
  ],
  "RNF34": [
    "RNF34 CNV",
    "RNF34 RNA",
    "RNF34 Proteo"
  ],
  "C7orf50": [
    "C7orf50 CNV",
    "C7orf50 RNA",
    "C7orf50 Proteo"
  ],
  "SLC6A13": [
    "SLC6A13 CNV",
    "SLC6A13 RNA"
  ],
  "UFC1": [
    "UFC1 CNV",
    "UFC1 RNA",
    "UFC1 Proteo"
  ],
  "SELENOKP2": [
    "SELENOKP2 CNV",
    "SELENOKP2 RNA"
  ],
  "RPF2": [
    "RPF2 CNV",
    "RPF2 RNA",
    "RPF2 Proteo"
  ],
  "DIDO1": [
    "DIDO1 CNV",
    "DIDO1 RNA",
    "DIDO1 Proteo"
  ],
  "MAGEC2": [
    "MAGEC2 CNV",
    "MAGEC2 RNA",
    "MAGEC2 Proteo"
  ],
  "HEBP2": [
    "HEBP2 CNV",
    "HEBP2 RNA",
    "HEBP2 Proteo"
  ],
  "CST11": [
    "CST11 CNV",
    "CST11 RNA"
  ],
  "NCL": [
    "NCL CNV",
    "NCL RNA",
    "NCL Proteo"
  ],
  "CLK3P2": [
    "CLK3P2 CNV",
    "CLK3P2 RNA"
  ],
  "TUBG2": [
    "TUBG2 CNV",
    "TUBG2 RNA",
    "TUBG2 Proteo"
  ],
  "ELF2": [
    "ELF2 CNV",
    "ELF2 RNA",
    "ELF2 Proteo"
  ],
  "DNM1P31": [
    "DNM1P31 CNV",
    "DNM1P31 RNA"
  ],
  "NBPF26": [
    "NBPF26 CNV",
    "NBPF26 RNA"
  ],
  "RRS1": [
    "RRS1 CNV",
    "RRS1 RNA",
    "RRS1 Proteo"
  ],
  "CASP2": [
    "CASP2 CNV",
    "CASP2 RNA",
    "CASP2 Proteo"
  ],
  "ADAMTS8": [
    "ADAMTS8 CNV",
    "ADAMTS8 RNA"
  ],
  "BSN": [
    "BSN CNV",
    "BSN RNA"
  ],
  "ERVMER34-1": [
    "ERVMER34-1 CNV",
    "ERVMER34-1 RNA"
  ],
  "WDR47": [
    "WDR47 CNV",
    "WDR47 RNA",
    "WDR47 Proteo"
  ],
  "MBD3L3": [
    "MBD3L3 CNV",
    "MBD3L3 RNA"
  ],
  "ESYT1": [
    "ESYT1 CNV",
    "ESYT1 RNA",
    "ESYT1 Proteo"
  ],
  "DEFB114": [
    "DEFB114 CNV",
    "DEFB114 RNA"
  ],
  "SYT17": [
    "SYT17 CNV",
    "SYT17 RNA"
  ],
  "STOML3": [
    "STOML3 CNV",
    "STOML3 RNA",
    "STOML3 Proteo"
  ],
  "KCTD1": [
    "KCTD1 CNV",
    "KCTD1 RNA",
    "KCTD1 Proteo"
  ],
  "MRPS31P4": [
    "MRPS31P4 CNV",
    "MRPS31P4 RNA"
  ],
  "MVB12B": [
    "MVB12B CNV",
    "MVB12B RNA",
    "MVB12B Proteo"
  ],
  "RPL26P27": [
    "RPL26P27 CNV",
    "RPL26P27 RNA"
  ],
  "CCL26": [
    "CCL26 CNV",
    "CCL26 RNA"
  ],
  "ANKRD20A6P": [
    "ANKRD20A6P CNV",
    "ANKRD20A6P RNA"
  ],
  "MT1A": [
    "MT1A CNV",
    "MT1A RNA"
  ],
  "GJA1": [
    "GJA1 CNV",
    "GJA1 RNA",
    "GJA1 Proteo"
  ],
  "CDY4P": [
    "CDY4P CNV",
    "CDY4P RNA"
  ],
  "RNA5SP131": [
    "RNA5SP131 CNV",
    "RNA5SP131 RNA"
  ],
  "RABGEF1P3": [
    "RABGEF1P3 CNV",
    "RABGEF1P3 RNA"
  ],
  "NTN4": [
    "NTN4 CNV",
    "NTN4 RNA"
  ],
  "IFI27L2": [
    "IFI27L2 CNV",
    "IFI27L2 RNA"
  ],
  "BMPR1AP1": [
    "BMPR1AP1 CNV",
    "BMPR1AP1 RNA"
  ],
  "ARHGAP18": [
    "ARHGAP18 CNV",
    "ARHGAP18 RNA",
    "ARHGAP18 Proteo"
  ],
  "JCADP1": [
    "JCADP1 CNV",
    "JCADP1 RNA"
  ],
  "TMEM17": [
    "TMEM17 CNV",
    "TMEM17 RNA",
    "TMEM17 Proteo"
  ],
  "OR4C12": [
    "OR4C12 CNV",
    "OR4C12 RNA"
  ],
  "TMA16": [
    "TMA16 CNV",
    "TMA16 RNA",
    "TMA16 Proteo"
  ],
  "TMC4": [
    "TMC4 CNV",
    "TMC4 RNA",
    "TMC4 Proteo"
  ],
  "ALG3": [
    "ALG3 CNV",
    "ALG3 RNA",
    "ALG3 Proteo"
  ],
  "PHKG1P1": [
    "PHKG1P1 CNV",
    "PHKG1P1 RNA"
  ],
  "LILRA2": [
    "LILRA2 CNV",
    "LILRA2 RNA",
    "LILRA2 Proteo"
  ],
  "LAPTM4BP2": [
    "LAPTM4BP2 CNV",
    "LAPTM4BP2 RNA"
  ],
  "SLC25A38P1": [
    "SLC25A38P1 CNV",
    "SLC25A38P1 RNA"
  ],
  "AHCYP4": [
    "AHCYP4 CNV",
    "AHCYP4 RNA"
  ],
  "LRRC7": [
    "LRRC7 CNV",
    "LRRC7 RNA",
    "LRRC7 Proteo"
  ],
  "TPT1P15": [
    "TPT1P15 CNV",
    "TPT1P15 RNA"
  ],
  "RNA5SP362": [
    "RNA5SP362 CNV",
    "RNA5SP362 RNA"
  ],
  "AMIGO2": [
    "AMIGO2 CNV",
    "AMIGO2 RNA",
    "AMIGO2 Proteo"
  ],
  "LYPD4": [
    "LYPD4 CNV",
    "LYPD4 RNA"
  ],
  "PLCXD1": [
    "PLCXD1 CNV",
    "PLCXD1 RNA",
    "PLCXD1 Proteo"
  ],
  "MPPED2": [
    "MPPED2 CNV",
    "MPPED2 RNA",
    "MPPED2 Proteo"
  ],
  "NFKB1": [
    "NFKB1 CNV",
    "NFKB1 RNA",
    "NFKB1 Proteo"
  ],
  "LRRC29": [
    "LRRC29 CNV",
    "LRRC29 RNA"
  ],
  "GPR42": [
    "GPR42 CNV",
    "GPR42 RNA"
  ],
  "NDUFAF2": [
    "NDUFAF2 CNV",
    "NDUFAF2 RNA",
    "NDUFAF2 Proteo"
  ],
  "OR11J7P": [
    "OR11J7P CNV",
    "OR11J7P RNA"
  ],
  "MAD2L1BP": [
    "MAD2L1BP CNV",
    "MAD2L1BP RNA",
    "MAD2L1BP Proteo"
  ],
  "LTBP4": [
    "LTBP4 CNV",
    "LTBP4 RNA",
    "LTBP4 Proteo"
  ],
  "PPIAP58": [
    "PPIAP58 CNV",
    "PPIAP58 RNA"
  ],
  "PCDHGA5": [
    "PCDHGA5 CNV",
    "PCDHGA5 RNA"
  ],
  "TIMM50": [
    "TIMM50 CNV",
    "TIMM50 RNA",
    "TIMM50 Proteo"
  ],
  "PRELID1P6": [
    "PRELID1P6 CNV",
    "PRELID1P6 RNA"
  ],
  "DTNB": [
    "DTNB CNV",
    "DTNB RNA",
    "DTNB Proteo"
  ],
  "CYP4F12": [
    "CYP4F12 CNV",
    "CYP4F12 RNA",
    "CYP4F12 Proteo"
  ],
  "CHST3": [
    "CHST3 CNV",
    "CHST3 RNA",
    "CHST3 Proteo"
  ],
  "VTI1BP4": [
    "VTI1BP4 CNV",
    "VTI1BP4 RNA"
  ],
  "CPLX3": [
    "CPLX3 CNV",
    "CPLX3 RNA"
  ],
  "ASF1B": [
    "ASF1B CNV",
    "ASF1B RNA",
    "ASF1B Proteo"
  ],
  "SLC25A23": [
    "SLC25A23 CNV",
    "SLC25A23 RNA",
    "SLC25A23 Proteo"
  ],
  "PXDN": [
    "PXDN CNV",
    "PXDN RNA",
    "PXDN Proteo"
  ],
  "OR6C3": [
    "OR6C3 CNV",
    "OR6C3 RNA"
  ],
  "PHYKPL": [
    "PHYKPL CNV",
    "PHYKPL RNA",
    "PHYKPL Proteo"
  ],
  "SPPL3": [
    "SPPL3 CNV",
    "SPPL3 RNA",
    "SPPL3 Proteo"
  ],
  "CBARP": [
    "CBARP CNV",
    "CBARP RNA",
    "CBARP Proteo"
  ],
  "MTND5P12": [
    "MTND5P12 CNV",
    "MTND5P12 RNA"
  ],
  "ZFP57": [
    "ZFP57 CNV",
    "ZFP57 RNA"
  ],
  "ACOT9": [
    "ACOT9 CNV",
    "ACOT9 RNA",
    "ACOT9 Proteo"
  ],
  "ASAH1": [
    "ASAH1 CNV",
    "ASAH1 RNA",
    "ASAH1 Proteo"
  ],
  "KCNN2": [
    "KCNN2 CNV",
    "KCNN2 RNA"
  ],
  "MYLKP1": [
    "MYLKP1 CNV",
    "MYLKP1 RNA"
  ],
  "TSPY3": [
    "TSPY3 CNV",
    "TSPY3 RNA"
  ],
  "HOXC8": [
    "HOXC8 CNV",
    "HOXC8 RNA"
  ],
  "GPRC5B": [
    "GPRC5B CNV",
    "GPRC5B RNA",
    "GPRC5B Proteo"
  ],
  "ACTG1P17": [
    "ACTG1P17 CNV",
    "ACTG1P17 RNA"
  ],
  "CTSE": [
    "CTSE CNV",
    "CTSE RNA"
  ],
  "RP9P": [
    "RP9P CNV",
    "RP9P RNA"
  ],
  "KIFBP": [
    "KIFBP CNV",
    "KIFBP RNA",
    "KIFBP Proteo"
  ],
  "PRICKLE3": [
    "PRICKLE3 CNV",
    "PRICKLE3 RNA",
    "PRICKLE3 Proteo"
  ],
  "RPS3AP5": [
    "RPS3AP5 CNV",
    "RPS3AP5 RNA"
  ],
  "RHOT1P2": [
    "RHOT1P2 CNV",
    "RHOT1P2 RNA"
  ],
  "IDSP1": [
    "IDSP1 CNV",
    "IDSP1 RNA"
  ],
  "NDUFA4P1": [
    "NDUFA4P1 CNV",
    "NDUFA4P1 RNA"
  ],
  "WASHC4": [
    "WASHC4 CNV",
    "WASHC4 RNA",
    "WASHC4 Proteo"
  ],
  "FAM126A": [
    "FAM126A CNV",
    "FAM126A RNA",
    "FAM126A Proteo"
  ],
  "TPM3": [
    "TPM3 CNV",
    "TPM3 RNA",
    "TPM3 Proteo"
  ],
  "RNA5SP519": [
    "RNA5SP519 CNV",
    "RNA5SP519 RNA"
  ],
  "NETO1": [
    "NETO1 CNV",
    "NETO1 RNA"
  ],
  "YY2": [
    "YY2 CNV",
    "YY2 RNA"
  ],
  "PRORP": [
    "PRORP CNV",
    "PRORP RNA",
    "PRORP Proteo"
  ],
  "SULF2": [
    "SULF2 CNV",
    "SULF2 RNA",
    "SULF2 Proteo"
  ],
  "GDAP1": [
    "GDAP1 CNV",
    "GDAP1 RNA",
    "GDAP1 Proteo"
  ],
  "SLC34A3": [
    "SLC34A3 CNV",
    "SLC34A3 RNA",
    "SLC34A3 Proteo"
  ],
  "SLC25A5P1": [
    "SLC25A5P1 CNV",
    "SLC25A5P1 RNA"
  ],
  "CD300E": [
    "CD300E CNV",
    "CD300E RNA"
  ],
  "RPL23AP16": [
    "RPL23AP16 CNV",
    "RPL23AP16 RNA"
  ],
  "TNFRSF13B": [
    "TNFRSF13B CNV",
    "TNFRSF13B RNA"
  ],
  "TAF9": [
    "TAF9 CNV",
    "TAF9 RNA",
    "TAF9 Proteo"
  ],
  "LIPG": [
    "LIPG CNV",
    "LIPG RNA"
  ],
  "SPI1": [
    "SPI1 CNV",
    "SPI1 RNA",
    "SPI1 Proteo"
  ],
  "ELMO2P1": [
    "ELMO2P1 CNV",
    "ELMO2P1 RNA"
  ],
  "NAGK": [
    "NAGK CNV",
    "NAGK RNA",
    "NAGK Proteo"
  ],
  "SCN3A": [
    "SCN3A CNV",
    "SCN3A RNA"
  ],
  "PRSS54": [
    "PRSS54 CNV",
    "PRSS54 RNA"
  ],
  "SGO2": [
    "SGO2 CNV",
    "SGO2 RNA",
    "SGO2 Proteo"
  ],
  "ZP4": [
    "ZP4 CNV",
    "ZP4 RNA"
  ],
  "C6orf118": [
    "C6orf118 CNV",
    "C6orf118 RNA"
  ],
  "KLHL28": [
    "KLHL28 CNV",
    "KLHL28 RNA"
  ],
  "OR5P2": [
    "OR5P2 CNV",
    "OR5P2 RNA"
  ],
  "NSFP1": [
    "NSFP1 CNV",
    "NSFP1 RNA"
  ],
  "CDC42BPA": [
    "CDC42BPA CNV",
    "CDC42BPA RNA",
    "CDC42BPA Proteo"
  ],
  "MARCHF4": [
    "MARCHF4 CNV",
    "MARCHF4 RNA"
  ],
  "DYNC2H1": [
    "DYNC2H1 CNV",
    "DYNC2H1 RNA",
    "DYNC2H1 Proteo"
  ],
  "GSK3B": [
    "GSK3B CNV",
    "GSK3B RNA",
    "GSK3B Proteo"
  ],
  "SSU72P7": [
    "SSU72P7 CNV",
    "SSU72P7 RNA"
  ],
  "CHMP1AP1": [
    "CHMP1AP1 CNV",
    "CHMP1AP1 RNA"
  ],
  "NPVF": [
    "NPVF CNV",
    "NPVF RNA"
  ],
  "HSPB6": [
    "HSPB6 CNV",
    "HSPB6 RNA",
    "HSPB6 Proteo"
  ],
  "MTND6P8": [
    "MTND6P8 CNV",
    "MTND6P8 RNA"
  ],
  "NUDT19P4": [
    "NUDT19P4 CNV",
    "NUDT19P4 RNA"
  ],
  "MAP3K9": [
    "MAP3K9 CNV",
    "MAP3K9 RNA"
  ],
  "H3C6": [
    "H3C6 CNV",
    "H3C6 RNA"
  ],
  "CLUHP5": [
    "CLUHP5 CNV",
    "CLUHP5 RNA"
  ],
  "UTP25": [
    "UTP25 CNV",
    "UTP25 RNA",
    "UTP25 Proteo"
  ],
  "OR5M6P": [
    "OR5M6P CNV",
    "OR5M6P RNA"
  ],
  "IGHM": [
    "IGHM Proteo"
  ],
  "MED29": [
    "MED29 CNV",
    "MED29 RNA",
    "MED29 Proteo"
  ],
  "MTND4P25": [
    "MTND4P25 CNV",
    "MTND4P25 RNA"
  ],
  "CACNA2D4": [
    "CACNA2D4 CNV",
    "CACNA2D4 RNA"
  ],
  "HYLS1": [
    "HYLS1 CNV",
    "HYLS1 RNA"
  ],
  "ADD3": [
    "ADD3 CNV",
    "ADD3 RNA",
    "ADD3 Proteo"
  ],
  "OR52I2": [
    "OR52I2 CNV",
    "OR52I2 RNA"
  ],
  "EIF4A2P1": [
    "EIF4A2P1 CNV",
    "EIF4A2P1 RNA"
  ],
  "WASH9P": [
    "WASH9P CNV",
    "WASH9P RNA"
  ],
  "DAG1": [
    "DAG1 CNV",
    "DAG1 RNA",
    "DAG1 Proteo"
  ],
  "SHROOM1": [
    "SHROOM1 CNV",
    "SHROOM1 RNA",
    "SHROOM1 Proteo"
  ],
  "OTP": [
    "OTP CNV",
    "OTP RNA"
  ],
  "DUX4L31": [
    "DUX4L31 CNV",
    "DUX4L31 RNA"
  ],
  "AGBL2": [
    "AGBL2 CNV",
    "AGBL2 RNA"
  ],
  "COMP": [
    "COMP CNV",
    "COMP RNA",
    "COMP Proteo"
  ],
  "CARTPT": [
    "CARTPT CNV",
    "CARTPT RNA"
  ],
  "DCTN5": [
    "DCTN5 CNV",
    "DCTN5 RNA",
    "DCTN5 Proteo"
  ],
  "IGF2BP1": [
    "IGF2BP1 CNV",
    "IGF2BP1 RNA",
    "IGF2BP1 Proteo"
  ],
  "ORM2": [
    "ORM2 CNV",
    "ORM2 RNA",
    "ORM2 Proteo"
  ],
  "ZNF235": [
    "ZNF235 CNV",
    "ZNF235 RNA"
  ],
  "RNA5SP364": [
    "RNA5SP364 CNV",
    "RNA5SP364 RNA"
  ],
  "SIAH1P1": [
    "SIAH1P1 CNV",
    "SIAH1P1 RNA"
  ],
  "PCM1": [
    "PCM1 CNV",
    "PCM1 RNA",
    "PCM1 Proteo"
  ],
  "ADIPOR1P1": [
    "ADIPOR1P1 CNV",
    "ADIPOR1P1 RNA"
  ],
  "RNA5SP140": [
    "RNA5SP140 CNV",
    "RNA5SP140 RNA"
  ],
  "UBE2CP2": [
    "UBE2CP2 CNV",
    "UBE2CP2 RNA"
  ],
  "RPL7P1": [
    "RPL7P1 CNV",
    "RPL7P1 RNA"
  ],
  "HSPA4L": [
    "HSPA4L CNV",
    "HSPA4L RNA",
    "HSPA4L Proteo"
  ],
  "CXCL14": [
    "CXCL14 CNV",
    "CXCL14 RNA",
    "CXCL14 Proteo"
  ],
  "PRRG1": [
    "PRRG1 CNV",
    "PRRG1 RNA"
  ],
  "FOXN2": [
    "FOXN2 CNV",
    "FOXN2 RNA"
  ],
  "CTU1": [
    "CTU1 CNV",
    "CTU1 RNA",
    "CTU1 Proteo"
  ],
  "PLCD4": [
    "PLCD4 CNV",
    "PLCD4 RNA",
    "PLCD4 Proteo"
  ],
  "RPS26P5": [
    "RPS26P5 CNV",
    "RPS26P5 RNA"
  ],
  "CIDECP1": [
    "CIDECP1 CNV",
    "CIDECP1 RNA"
  ],
  "ERG28": [
    "ERG28 CNV",
    "ERG28 RNA",
    "ERG28 Proteo"
  ],
  "EAF1": [
    "EAF1 CNV",
    "EAF1 RNA",
    "EAF1 Proteo"
  ],
  "OTC": [
    "OTC CNV",
    "OTC RNA",
    "OTC Proteo"
  ],
  "LCTL": [
    "LCTL CNV",
    "LCTL RNA"
  ],
  "MEF2C": [
    "MEF2C CNV",
    "MEF2C RNA",
    "MEF2C Proteo"
  ],
  "CFAP20DC": [
    "CFAP20DC CNV",
    "CFAP20DC RNA"
  ],
  "C11orf94": [
    "C11orf94 CNV",
    "C11orf94 RNA"
  ],
  "ZNF446": [
    "ZNF446 CNV",
    "ZNF446 RNA",
    "ZNF446 Proteo"
  ],
  "GPATCH11": [
    "GPATCH11 CNV",
    "GPATCH11 RNA",
    "GPATCH11 Proteo"
  ],
  "SLC30A8": [
    "SLC30A8 CNV",
    "SLC30A8 RNA"
  ],
  "MEOX1": [
    "MEOX1 CNV",
    "MEOX1 RNA"
  ],
  "MTAPP1": [
    "MTAPP1 CNV",
    "MTAPP1 RNA"
  ],
  "HELZ": [
    "HELZ CNV",
    "HELZ RNA",
    "HELZ Proteo"
  ],
  "PURA": [
    "PURA CNV",
    "PURA RNA",
    "PURA Proteo"
  ],
  "CHPF2": [
    "CHPF2 CNV",
    "CHPF2 RNA",
    "CHPF2 Proteo"
  ],
  "UBXN1": [
    "UBXN1 CNV",
    "UBXN1 RNA",
    "UBXN1 Proteo"
  ],
  "CTAGE4": [
    "CTAGE4 CNV",
    "CTAGE4 RNA"
  ],
  "FLYWCH1": [
    "FLYWCH1 CNV",
    "FLYWCH1 RNA",
    "FLYWCH1 Proteo"
  ],
  "SLC25A13": [
    "SLC25A13 CNV",
    "SLC25A13 RNA",
    "SLC25A13 Proteo"
  ],
  "SLC22A2": [
    "SLC22A2 CNV",
    "SLC22A2 RNA"
  ],
  "ZNF542P": [
    "ZNF542P CNV",
    "ZNF542P RNA"
  ],
  "LYNX1": [
    "LYNX1 CNV",
    "LYNX1 RNA"
  ],
  "RASA4CP": [
    "RASA4CP CNV",
    "RASA4CP RNA"
  ],
  "TMEM30CP": [
    "TMEM30CP CNV",
    "TMEM30CP RNA"
  ],
  "PUS7L": [
    "PUS7L CNV",
    "PUS7L RNA",
    "PUS7L Proteo"
  ],
  "TMEM14A": [
    "TMEM14A CNV",
    "TMEM14A RNA"
  ],
  "TMC2": [
    "TMC2 CNV",
    "TMC2 RNA"
  ],
  "LATS2": [
    "LATS2 CNV",
    "LATS2 RNA",
    "LATS2 Proteo"
  ],
  "SNRPFP1": [
    "SNRPFP1 CNV",
    "SNRPFP1 RNA"
  ],
  "PRKACA": [
    "PRKACA CNV",
    "PRKACA RNA",
    "PRKACA Proteo"
  ],
  "SLC17A3": [
    "SLC17A3 CNV",
    "SLC17A3 RNA"
  ],
  "SMPD4BP": [
    "SMPD4BP CNV",
    "SMPD4BP RNA"
  ],
  "MTCYBP28": [
    "MTCYBP28 CNV",
    "MTCYBP28 RNA"
  ],
  "UNC93B3": [
    "UNC93B3 CNV",
    "UNC93B3 RNA"
  ],
  "PPIEL": [
    "PPIEL CNV",
    "PPIEL RNA"
  ],
  "RPS6KA1": [
    "RPS6KA1 CNV",
    "RPS6KA1 RNA",
    "RPS6KA1 Proteo"
  ],
  "TTC16": [
    "TTC16 CNV",
    "TTC16 RNA"
  ],
  "GFM2": [
    "GFM2 CNV",
    "GFM2 RNA",
    "GFM2 Proteo"
  ],
  "SLF2": [
    "SLF2 CNV",
    "SLF2 RNA",
    "SLF2 Proteo"
  ],
  "CHMP2B": [
    "CHMP2B CNV",
    "CHMP2B RNA",
    "CHMP2B Proteo"
  ],
  "SNRPCP10": [
    "SNRPCP10 CNV",
    "SNRPCP10 RNA"
  ],
  "TMED6": [
    "TMED6 CNV",
    "TMED6 RNA"
  ],
  "TRIM6": [
    "TRIM6 CNV",
    "TRIM6 RNA"
  ],
  "ZNRD1ASP": [
    "ZNRD1ASP CNV",
    "ZNRD1ASP RNA"
  ],
  "CBLL1P1": [
    "CBLL1P1 CNV",
    "CBLL1P1 RNA"
  ],
  "SUMO2P7": [
    "SUMO2P7 CNV",
    "SUMO2P7 RNA"
  ],
  "A1CF": [
    "A1CF CNV",
    "A1CF RNA",
    "A1CF Proteo"
  ],
  "TADA2B": [
    "TADA2B CNV",
    "TADA2B RNA",
    "TADA2B Proteo"
  ],
  "PFAS": [
    "PFAS CNV",
    "PFAS RNA",
    "PFAS Proteo"
  ],
  "WDR6": [
    "WDR6 CNV",
    "WDR6 RNA",
    "WDR6 Proteo"
  ],
  "PPP1R14BP2": [
    "PPP1R14BP2 CNV",
    "PPP1R14BP2 RNA"
  ],
  "RPL10P17": [
    "RPL10P17 CNV",
    "RPL10P17 RNA"
  ],
  "MEF2D": [
    "MEF2D CNV",
    "MEF2D RNA",
    "MEF2D Proteo"
  ],
  "NISCH": [
    "NISCH CNV",
    "NISCH RNA",
    "NISCH Proteo"
  ],
  "POLR2J": [
    "POLR2J CNV",
    "POLR2J RNA",
    "POLR2J Proteo"
  ],
  "UBE2Q2P4Y": [
    "UBE2Q2P4Y CNV",
    "UBE2Q2P4Y RNA"
  ],
  "FAM241B": [
    "FAM241B CNV",
    "FAM241B RNA",
    "FAM241B Proteo"
  ],
  "RAB27A": [
    "RAB27A CNV",
    "RAB27A RNA",
    "RAB27A Proteo"
  ],
  "BMS1P2": [
    "BMS1P2 CNV",
    "BMS1P2 RNA"
  ],
  "DEFB109C": [
    "DEFB109C CNV",
    "DEFB109C RNA"
  ],
  "RNH1": [
    "RNH1 CNV",
    "RNH1 RNA",
    "RNH1 Proteo"
  ],
  "HDAC6": [
    "HDAC6 CNV",
    "HDAC6 RNA",
    "HDAC6 Proteo"
  ],
  "KRT18P16": [
    "KRT18P16 CNV",
    "KRT18P16 RNA"
  ],
  "MIEF2": [
    "MIEF2 CNV",
    "MIEF2 RNA",
    "MIEF2 Proteo"
  ],
  "CFAP65": [
    "CFAP65 CNV",
    "CFAP65 RNA"
  ],
  "FHOD1": [
    "FHOD1 CNV",
    "FHOD1 RNA",
    "FHOD1 Proteo"
  ],
  "TPPP2": [
    "TPPP2 CNV",
    "TPPP2 RNA"
  ],
  "WDR77": [
    "WDR77 CNV",
    "WDR77 RNA",
    "WDR77 Proteo"
  ],
  "OR6C73P": [
    "OR6C73P CNV",
    "OR6C73P RNA"
  ],
  "ZNF885P": [
    "ZNF885P CNV",
    "ZNF885P RNA"
  ],
  "DBF4B": [
    "DBF4B CNV",
    "DBF4B RNA"
  ],
  "NATD1": [
    "NATD1 CNV",
    "NATD1 RNA",
    "NATD1 Proteo"
  ],
  "GAPDHP42": [
    "GAPDHP42 CNV",
    "GAPDHP42 RNA"
  ],
  "TRIP10": [
    "TRIP10 CNV",
    "TRIP10 RNA",
    "TRIP10 Proteo"
  ],
  "NPAS3": [
    "NPAS3 CNV",
    "NPAS3 RNA"
  ],
  "RMDN3": [
    "RMDN3 CNV",
    "RMDN3 RNA",
    "RMDN3 Proteo"
  ],
  "LYPLA2": [
    "LYPLA2 CNV",
    "LYPLA2 RNA",
    "LYPLA2 Proteo"
  ],
  "MTND6P18": [
    "MTND6P18 CNV",
    "MTND6P18 RNA"
  ],
  "TRIAP1": [
    "TRIAP1 CNV",
    "TRIAP1 RNA",
    "TRIAP1 Proteo"
  ],
  "MTREX": [
    "MTREX CNV",
    "MTREX RNA",
    "MTREX Proteo"
  ],
  "ADGRE3": [
    "ADGRE3 CNV",
    "ADGRE3 RNA"
  ],
  "NUDT1": [
    "NUDT1 CNV",
    "NUDT1 RNA",
    "NUDT1 Proteo"
  ],
  "SNX25P1": [
    "SNX25P1 CNV",
    "SNX25P1 RNA"
  ],
  "TEX30": [
    "TEX30 CNV",
    "TEX30 RNA",
    "TEX30 Proteo"
  ],
  "GJE1": [
    "GJE1 CNV",
    "GJE1 RNA"
  ],
  "RAB3A": [
    "RAB3A CNV",
    "RAB3A RNA",
    "RAB3A Proteo"
  ],
  "KCNN3": [
    "KCNN3 CNV",
    "KCNN3 RNA",
    "KCNN3 Proteo"
  ],
  "TXNDC17": [
    "TXNDC17 CNV",
    "TXNDC17 RNA",
    "TXNDC17 Proteo"
  ],
  "DMRT1": [
    "DMRT1 CNV",
    "DMRT1 RNA"
  ],
  "HIPK3": [
    "HIPK3 CNV",
    "HIPK3 RNA"
  ],
  "LRRC57": [
    "LRRC57 CNV",
    "LRRC57 RNA",
    "LRRC57 Proteo"
  ],
  "RPL38P4": [
    "RPL38P4 CNV",
    "RPL38P4 RNA"
  ],
  "PHKG1P2": [
    "PHKG1P2 CNV",
    "PHKG1P2 RNA"
  ],
  "NOP56P2": [
    "NOP56P2 CNV",
    "NOP56P2 RNA"
  ],
  "CYP1B1": [
    "CYP1B1 CNV",
    "CYP1B1 RNA",
    "CYP1B1 Proteo"
  ],
  "ELL2": [
    "ELL2 CNV",
    "ELL2 RNA",
    "ELL2 Proteo"
  ],
  "CA3": [
    "CA3 CNV",
    "CA3 RNA",
    "CA3 Proteo"
  ],
  "VDAC1P7": [
    "VDAC1P7 CNV",
    "VDAC1P7 RNA"
  ],
  "RALGPS2": [
    "RALGPS2 CNV",
    "RALGPS2 RNA",
    "RALGPS2 Proteo"
  ],
  "GLTPD2": [
    "GLTPD2 CNV",
    "GLTPD2 RNA"
  ],
  "MAP1A": [
    "MAP1A CNV",
    "MAP1A RNA",
    "MAP1A Proteo"
  ],
  "RPL5P31": [
    "RPL5P31 CNV",
    "RPL5P31 RNA"
  ],
  "H2AC5P": [
    "H2AC5P CNV",
    "H2AC5P RNA"
  ],
  "DAO": [
    "DAO CNV",
    "DAO RNA"
  ],
  "HNRNPA3P10": [
    "HNRNPA3P10 CNV",
    "HNRNPA3P10 RNA"
  ],
  "KATNBL1P5": [
    "KATNBL1P5 CNV",
    "KATNBL1P5 RNA"
  ],
  "SLITRK4": [
    "SLITRK4 CNV",
    "SLITRK4 RNA"
  ],
  "MSX1": [
    "MSX1 CNV",
    "MSX1 RNA"
  ],
  "ZC3H7A": [
    "ZC3H7A CNV",
    "ZC3H7A RNA",
    "ZC3H7A Proteo"
  ],
  "PTMAP11": [
    "PTMAP11 CNV",
    "PTMAP11 RNA"
  ],
  "CAPZA3": [
    "CAPZA3 CNV",
    "CAPZA3 RNA"
  ],
  "CCR3": [
    "CCR3 CNV",
    "CCR3 RNA"
  ],
  "ADSL": [
    "ADSL CNV",
    "ADSL RNA",
    "ADSL Proteo"
  ],
  "ZBTB46": [
    "ZBTB46 CNV",
    "ZBTB46 RNA"
  ],
  "CCNYL1": [
    "CCNYL1 CNV",
    "CCNYL1 RNA",
    "CCNYL1 Proteo"
  ],
  "KLKB1": [
    "KLKB1 CNV",
    "KLKB1 RNA",
    "KLKB1 Proteo"
  ],
  "ZNF485": [
    "ZNF485 CNV",
    "ZNF485 RNA"
  ],
  "UGT8": [
    "UGT8 CNV",
    "UGT8 RNA",
    "UGT8 Proteo"
  ],
  "TEX35": [
    "TEX35 CNV",
    "TEX35 RNA"
  ],
  "ARHGEF17": [
    "ARHGEF17 CNV",
    "ARHGEF17 RNA",
    "ARHGEF17 Proteo"
  ],
  "LRRC74A": [
    "LRRC74A CNV",
    "LRRC74A RNA"
  ],
  "SPACA5": [
    "SPACA5 CNV",
    "SPACA5 RNA"
  ],
  "RAB20": [
    "RAB20 CNV",
    "RAB20 RNA",
    "RAB20 Proteo"
  ],
  "CHMP4B": [
    "CHMP4B CNV",
    "CHMP4B RNA",
    "CHMP4B Proteo"
  ],
  "HDAC11": [
    "HDAC11 CNV",
    "HDAC11 RNA",
    "HDAC11 Proteo"
  ],
  "TECTA": [
    "TECTA CNV",
    "TECTA RNA"
  ],
  "TOMM5": [
    "TOMM5 CNV",
    "TOMM5 RNA",
    "TOMM5 Proteo"
  ],
  "PDZD8": [
    "PDZD8 CNV",
    "PDZD8 RNA",
    "PDZD8 Proteo"
  ],
  "ARHGAP45": [
    "ARHGAP45 CNV",
    "ARHGAP45 RNA",
    "ARHGAP45 Proteo"
  ],
  "RNA5SP422": [
    "RNA5SP422 CNV",
    "RNA5SP422 RNA"
  ],
  "TOMM40P3": [
    "TOMM40P3 CNV",
    "TOMM40P3 RNA"
  ],
  "NDUFV3": [
    "NDUFV3 CNV",
    "NDUFV3 RNA",
    "NDUFV3 Proteo"
  ],
  "ZNF540": [
    "ZNF540 CNV",
    "ZNF540 RNA"
  ],
  "ALDH1A2": [
    "ALDH1A2 CNV",
    "ALDH1A2 RNA",
    "ALDH1A2 Proteo"
  ],
  "RPL23AP60": [
    "RPL23AP60 CNV",
    "RPL23AP60 RNA"
  ],
  "THUMPD1": [
    "THUMPD1 CNV",
    "THUMPD1 RNA",
    "THUMPD1 Proteo"
  ],
  "RPL21P11": [
    "RPL21P11 CNV",
    "RPL21P11 RNA"
  ],
  "GNAI1": [
    "GNAI1 CNV",
    "GNAI1 RNA",
    "GNAI1 Proteo"
  ],
  "ADRA1B": [
    "ADRA1B CNV",
    "ADRA1B RNA"
  ],
  "MAPK8IP1P1": [
    "MAPK8IP1P1 CNV",
    "MAPK8IP1P1 RNA"
  ],
  "AQP7B": [
    "AQP7B CNV",
    "AQP7B RNA"
  ],
  "SF3B6": [
    "SF3B6 CNV",
    "SF3B6 RNA",
    "SF3B6 Proteo"
  ],
  "GDE1": [
    "GDE1 CNV",
    "GDE1 RNA",
    "GDE1 Proteo"
  ],
  "MRPL47": [
    "MRPL47 CNV",
    "MRPL47 RNA",
    "MRPL47 Proteo"
  ],
  "CIAO2AP2": [
    "CIAO2AP2 CNV",
    "CIAO2AP2 RNA"
  ],
  "RTP1": [
    "RTP1 CNV",
    "RTP1 RNA"
  ],
  "RNMT": [
    "RNMT CNV",
    "RNMT RNA",
    "RNMT Proteo"
  ],
  "GSTA5": [
    "GSTA5 CNV",
    "GSTA5 RNA",
    "GSTA5 Proteo"
  ],
  "CCDC69": [
    "CCDC69 CNV",
    "CCDC69 RNA",
    "CCDC69 Proteo"
  ],
  "PIMREGP3": [
    "PIMREGP3 CNV",
    "PIMREGP3 RNA"
  ],
  "ECD": [
    "ECD CNV",
    "ECD RNA",
    "ECD Proteo"
  ],
  "IGKV3OR2-5": [
    "IGKV3OR2-5 CNV",
    "IGKV3OR2-5 RNA"
  ],
  "MGAT4C": [
    "MGAT4C CNV",
    "MGAT4C RNA"
  ],
  "CRHR2": [
    "CRHR2 CNV",
    "CRHR2 RNA"
  ],
  "NHEJ1": [
    "NHEJ1 CNV",
    "NHEJ1 RNA",
    "NHEJ1 Proteo"
  ],
  "RPLP1": [
    "RPLP1 CNV",
    "RPLP1 RNA",
    "RPLP1 Proteo"
  ],
  "GMPSP1": [
    "GMPSP1 CNV",
    "GMPSP1 RNA"
  ],
  "TARP": [
    "TARP CNV",
    "TARP RNA"
  ],
  "MED28": [
    "MED28 CNV",
    "MED28 RNA",
    "MED28 Proteo"
  ],
  "NKAIN1P2": [
    "NKAIN1P2 CNV",
    "NKAIN1P2 RNA"
  ],
  "SPATA31C1": [
    "SPATA31C1 CNV",
    "SPATA31C1 RNA"
  ],
  "OR7D4": [
    "OR7D4 CNV",
    "OR7D4 RNA"
  ],
  "SLC2A8": [
    "SLC2A8 CNV",
    "SLC2A8 RNA",
    "SLC2A8 Proteo"
  ],
  "DNER": [
    "DNER CNV",
    "DNER RNA"
  ],
  "TTC34": [
    "TTC34 CNV",
    "TTC34 RNA"
  ],
  "SLC2A13": [
    "SLC2A13 CNV",
    "SLC2A13 RNA",
    "SLC2A13 Proteo"
  ],
  "ASH2LP1": [
    "ASH2LP1 CNV",
    "ASH2LP1 RNA"
  ],
  "ZNF658B": [
    "ZNF658B CNV",
    "ZNF658B RNA"
  ],
  "CD79A": [
    "CD79A CNV",
    "CD79A RNA",
    "CD79A Proteo"
  ],
  "SELENOH": [
    "SELENOH CNV",
    "SELENOH RNA",
    "SELENOH Proteo"
  ],
  "HSPD1P9": [
    "HSPD1P9 CNV",
    "HSPD1P9 RNA"
  ],
  "PSKH2": [
    "PSKH2 CNV",
    "PSKH2 RNA"
  ],
  "ATP1A4": [
    "ATP1A4 CNV",
    "ATP1A4 RNA"
  ],
  "RNF128": [
    "RNF128 CNV",
    "RNF128 RNA"
  ],
  "MS4A15": [
    "MS4A15 CNV",
    "MS4A15 RNA"
  ],
  "SURF1": [
    "SURF1 CNV",
    "SURF1 RNA",
    "SURF1 Proteo"
  ],
  "RPL15P13": [
    "RPL15P13 CNV",
    "RPL15P13 RNA"
  ],
  "MEA1": [
    "MEA1 CNV",
    "MEA1 RNA",
    "MEA1 Proteo"
  ],
  "PSMA4": [
    "PSMA4 CNV",
    "PSMA4 RNA",
    "PSMA4 Proteo"
  ],
  "CXCL1": [
    "CXCL1 CNV",
    "CXCL1 RNA"
  ],
  "SPOUT1": [
    "SPOUT1 CNV",
    "SPOUT1 RNA",
    "SPOUT1 Proteo"
  ],
  "RBPMS": [
    "RBPMS CNV",
    "RBPMS RNA",
    "RBPMS Proteo"
  ],
  "MTCO1P12": [
    "MTCO1P12 CNV",
    "MTCO1P12 RNA"
  ],
  "PHF20": [
    "PHF20 CNV",
    "PHF20 RNA",
    "PHF20 Proteo"
  ],
  "IMPDH1": [
    "IMPDH1 CNV",
    "IMPDH1 RNA",
    "IMPDH1 Proteo"
  ],
  "FAM177B": [
    "FAM177B CNV",
    "FAM177B RNA"
  ],
  "GLP1R": [
    "GLP1R CNV",
    "GLP1R RNA"
  ],
  "UBBP5": [
    "UBBP5 CNV",
    "UBBP5 RNA"
  ],
  "H2BW3P": [
    "H2BW3P CNV",
    "H2BW3P RNA"
  ],
  "RNA5SP258": [
    "RNA5SP258 CNV",
    "RNA5SP258 RNA"
  ],
  "TPT1P6": [
    "TPT1P6 CNV",
    "TPT1P6 RNA"
  ],
  "CLIC4P3": [
    "CLIC4P3 CNV",
    "CLIC4P3 RNA"
  ],
  "DHRSX": [
    "DHRSX CNV",
    "DHRSX RNA",
    "DHRSX Proteo"
  ],
  "PLOD1": [
    "PLOD1 CNV",
    "PLOD1 RNA",
    "PLOD1 Proteo"
  ],
  "TMEM192": [
    "TMEM192 CNV",
    "TMEM192 RNA",
    "TMEM192 Proteo"
  ],
  "PMS2": [
    "PMS2 CNV",
    "PMS2 RNA",
    "PMS2 Proteo"
  ],
  "KRTAP21-1": [
    "KRTAP21-1 CNV",
    "KRTAP21-1 RNA"
  ],
  "TLE6": [
    "TLE6 CNV",
    "TLE6 RNA"
  ],
  "GOLGA6L9": [
    "GOLGA6L9 CNV",
    "GOLGA6L9 RNA"
  ],
  "SLC35B4": [
    "SLC35B4 CNV",
    "SLC35B4 RNA",
    "SLC35B4 Proteo"
  ],
  "RPL37P12": [
    "RPL37P12 CNV",
    "RPL37P12 RNA"
  ],
  "BET1": [
    "BET1 CNV",
    "BET1 RNA",
    "BET1 Proteo"
  ],
  "USP32P4": [
    "USP32P4 CNV",
    "USP32P4 RNA"
  ],
  "DNAJC28": [
    "DNAJC28 CNV",
    "DNAJC28 RNA"
  ],
  "ELAPOR1": [
    "ELAPOR1 CNV",
    "ELAPOR1 RNA",
    "ELAPOR1 Proteo"
  ],
  "SOST": [
    "SOST CNV",
    "SOST RNA"
  ],
  "ATP6V1E1P1": [
    "ATP6V1E1P1 CNV",
    "ATP6V1E1P1 RNA"
  ],
  "SMIM15P2": [
    "SMIM15P2 CNV",
    "SMIM15P2 RNA"
  ],
  "GJD2": [
    "GJD2 CNV",
    "GJD2 RNA"
  ],
  "CRTAC1": [
    "CRTAC1 CNV",
    "CRTAC1 RNA",
    "CRTAC1 Proteo"
  ],
  "KLB": [
    "KLB CNV",
    "KLB RNA"
  ],
  "OR5AS1": [
    "OR5AS1 CNV",
    "OR5AS1 RNA"
  ],
  "CYCSP29": [
    "CYCSP29 CNV",
    "CYCSP29 RNA"
  ],
  "PEAR1": [
    "PEAR1 CNV",
    "PEAR1 RNA",
    "PEAR1 Proteo"
  ],
  "HTATSF1P2": [
    "HTATSF1P2 CNV",
    "HTATSF1P2 RNA"
  ],
  "IL7": [
    "IL7 CNV",
    "IL7 RNA"
  ],
  "RPL13AP17": [
    "RPL13AP17 CNV",
    "RPL13AP17 RNA"
  ],
  "CEP131": [
    "CEP131 CNV",
    "CEP131 RNA",
    "CEP131 Proteo"
  ],
  "COX7BP2": [
    "COX7BP2 CNV",
    "COX7BP2 RNA"
  ],
  "CCDC186": [
    "CCDC186 CNV",
    "CCDC186 RNA",
    "CCDC186 Proteo"
  ],
  "ZNF687": [
    "ZNF687 CNV",
    "ZNF687 RNA",
    "ZNF687 Proteo"
  ],
  "CD96": [
    "CD96 CNV",
    "CD96 RNA",
    "CD96 Proteo"
  ],
  "SLC16A1": [
    "SLC16A1 CNV",
    "SLC16A1 RNA",
    "SLC16A1 Proteo"
  ],
  "LLPH": [
    "LLPH CNV",
    "LLPH RNA",
    "LLPH Proteo"
  ],
  "MEN1": [
    "MEN1 CNV",
    "MEN1 RNA",
    "MEN1 Proteo"
  ],
  "MPC2": [
    "MPC2 CNV",
    "MPC2 RNA",
    "MPC2 Proteo"
  ],
  "IGFALS": [
    "IGFALS CNV",
    "IGFALS RNA",
    "IGFALS Proteo"
  ],
  "TMEM268": [
    "TMEM268 CNV",
    "TMEM268 RNA",
    "TMEM268 Proteo"
  ],
  "CIB1": [
    "CIB1 CNV",
    "CIB1 RNA",
    "CIB1 Proteo"
  ],
  "PADI4": [
    "PADI4 CNV",
    "PADI4 RNA",
    "PADI4 Proteo"
  ],
  "SPIC": [
    "SPIC CNV",
    "SPIC RNA"
  ],
  "TRNAU1AP": [
    "TRNAU1AP CNV",
    "TRNAU1AP RNA",
    "TRNAU1AP Proteo"
  ],
  "COLEC12": [
    "COLEC12 CNV",
    "COLEC12 RNA",
    "COLEC12 Proteo"
  ],
  "LRP2": [
    "LRP2 CNV",
    "LRP2 RNA",
    "LRP2 Proteo"
  ],
  "CRTC1": [
    "CRTC1 CNV",
    "CRTC1 RNA",
    "CRTC1 Proteo"
  ],
  "CXCL9": [
    "CXCL9 CNV",
    "CXCL9 RNA",
    "CXCL9 Proteo"
  ],
  "SPATA31A6": [
    "SPATA31A6 CNV",
    "SPATA31A6 RNA"
  ],
  "SLC26A1": [
    "SLC26A1 CNV",
    "SLC26A1 RNA"
  ],
  "C12orf54": [
    "C12orf54 CNV",
    "C12orf54 RNA"
  ],
  "USP9YP29": [
    "USP9YP29 CNV",
    "USP9YP29 RNA"
  ],
  "AKIRIN1P1": [
    "AKIRIN1P1 CNV",
    "AKIRIN1P1 RNA"
  ],
  "ATP6V0CP1": [
    "ATP6V0CP1 CNV",
    "ATP6V0CP1 RNA"
  ],
  "EIF4G2": [
    "EIF4G2 CNV",
    "EIF4G2 RNA",
    "EIF4G2 Proteo"
  ],
  "PHYHD1": [
    "PHYHD1 CNV",
    "PHYHD1 RNA",
    "PHYHD1 Proteo"
  ],
  "ERGIC3": [
    "ERGIC3 CNV",
    "ERGIC3 RNA",
    "ERGIC3 Proteo"
  ],
  "RSU1P2": [
    "RSU1P2 CNV",
    "RSU1P2 RNA"
  ],
  "OR10H3": [
    "OR10H3 CNV",
    "OR10H3 RNA"
  ],
  "CSH1": [
    "CSH1 CNV",
    "CSH1 RNA"
  ],
  "SKIL": [
    "SKIL CNV",
    "SKIL RNA",
    "SKIL Proteo"
  ],
  "AURKC": [
    "AURKC CNV",
    "AURKC RNA"
  ],
  "HBE1": [
    "HBE1 CNV",
    "HBE1 RNA",
    "HBE1 Proteo"
  ],
  "MFSD5": [
    "MFSD5 CNV",
    "MFSD5 RNA",
    "MFSD5 Proteo"
  ],
  "FOXN1": [
    "FOXN1 CNV",
    "FOXN1 RNA"
  ],
  "SPACA4": [
    "SPACA4 CNV",
    "SPACA4 RNA"
  ],
  "PPTC7": [
    "PPTC7 CNV",
    "PPTC7 RNA",
    "PPTC7 Proteo"
  ],
  "HNRNPH2": [
    "HNRNPH2 CNV",
    "HNRNPH2 RNA",
    "HNRNPH2 Proteo"
  ],
  "VPS16": [
    "VPS16 CNV",
    "VPS16 RNA",
    "VPS16 Proteo"
  ],
  "GAGE13": [
    "GAGE13 CNV",
    "GAGE13 RNA",
    "GAGE13 Proteo"
  ],
  "STK24P1": [
    "STK24P1 CNV",
    "STK24P1 RNA"
  ],
  "OR51M1": [
    "OR51M1 CNV",
    "OR51M1 RNA"
  ],
  "FBXL17": [
    "FBXL17 CNV",
    "FBXL17 RNA",
    "FBXL17 Proteo"
  ],
  "C12orf40": [
    "C12orf40 CNV",
    "C12orf40 RNA"
  ],
  "SLFN5": [
    "SLFN5 CNV",
    "SLFN5 RNA",
    "SLFN5 Proteo"
  ],
  "CFAP52": [
    "CFAP52 CNV",
    "CFAP52 RNA"
  ],
  "MTATP6P27": [
    "MTATP6P27 CNV",
    "MTATP6P27 RNA"
  ],
  "APOA5": [
    "APOA5 CNV",
    "APOA5 RNA",
    "APOA5 Proteo"
  ],
  "COX5B": [
    "COX5B CNV",
    "COX5B RNA",
    "COX5B Proteo"
  ],
  "TMEM177": [
    "TMEM177 CNV",
    "TMEM177 RNA",
    "TMEM177 Proteo"
  ],
  "IDI2": [
    "IDI2 CNV",
    "IDI2 RNA"
  ],
  "UBE2V1P16": [
    "UBE2V1P16 CNV",
    "UBE2V1P16 RNA"
  ],
  "PIM1": [
    "PIM1 CNV",
    "PIM1 RNA"
  ],
  "IGHV3-22": [
    "IGHV3-22 CNV",
    "IGHV3-22 RNA"
  ],
  "SHROOM2P1": [
    "SHROOM2P1 CNV",
    "SHROOM2P1 RNA"
  ],
  "PGGT1BP2": [
    "PGGT1BP2 CNV",
    "PGGT1BP2 RNA"
  ],
  "MARCHF7": [
    "MARCHF7 CNV",
    "MARCHF7 RNA",
    "MARCHF7 Proteo"
  ],
  "SLC22A20P": [
    "SLC22A20P CNV",
    "SLC22A20P RNA"
  ],
  "ECSIT": [
    "ECSIT CNV",
    "ECSIT RNA",
    "ECSIT Proteo"
  ],
  "PRUNE2": [
    "PRUNE2 CNV",
    "PRUNE2 RNA",
    "PRUNE2 Proteo"
  ],
  "TNFRSF13C": [
    "TNFRSF13C CNV",
    "TNFRSF13C RNA"
  ],
  "OR2M3": [
    "OR2M3 CNV",
    "OR2M3 RNA"
  ],
  "METTL21EP": [
    "METTL21EP CNV",
    "METTL21EP RNA"
  ],
  "PATE3": [
    "PATE3 CNV",
    "PATE3 RNA"
  ],
  "PDCD6IPP1": [
    "PDCD6IPP1 CNV",
    "PDCD6IPP1 RNA"
  ],
  "ZC2HC1B": [
    "ZC2HC1B CNV",
    "ZC2HC1B RNA",
    "ZC2HC1B Proteo"
  ],
  "SPAG4": [
    "SPAG4 CNV",
    "SPAG4 RNA"
  ],
  "RASAL3": [
    "RASAL3 CNV",
    "RASAL3 RNA",
    "RASAL3 Proteo"
  ],
  "RPL7P45": [
    "RPL7P45 CNV",
    "RPL7P45 RNA"
  ],
  "PRPH": [
    "PRPH CNV",
    "PRPH RNA",
    "PRPH Proteo"
  ],
  "RPS3AP24": [
    "RPS3AP24 CNV",
    "RPS3AP24 RNA"
  ],
  "YRDCP3": [
    "YRDCP3 CNV",
    "YRDCP3 RNA"
  ],
  "TP53RK": [
    "TP53RK CNV",
    "TP53RK RNA",
    "TP53RK Proteo"
  ],
  "MPV17L2": [
    "MPV17L2 CNV",
    "MPV17L2 RNA",
    "MPV17L2 Proteo"
  ],
  "OR2T27": [
    "OR2T27 CNV",
    "OR2T27 RNA"
  ],
  "NMRK1": [
    "NMRK1 CNV",
    "NMRK1 RNA",
    "NMRK1 Proteo"
  ],
  "PRELID3BP1": [
    "PRELID3BP1 CNV",
    "PRELID3BP1 RNA"
  ],
  "PRDX4P1": [
    "PRDX4P1 CNV",
    "PRDX4P1 RNA"
  ],
  "RNF167": [
    "RNF167 CNV",
    "RNF167 RNA",
    "RNF167 Proteo"
  ],
  "PDE4B": [
    "PDE4B CNV",
    "PDE4B RNA",
    "PDE4B Proteo"
  ],
  "SORT1": [
    "SORT1 CNV",
    "SORT1 RNA",
    "SORT1 Proteo"
  ],
  "OR8I2": [
    "OR8I2 CNV",
    "OR8I2 RNA"
  ],
  "AHR": [
    "AHR CNV",
    "AHR RNA",
    "AHR Proteo"
  ],
  "NUCKS1P1": [
    "NUCKS1P1 CNV",
    "NUCKS1P1 RNA"
  ],
  "MNS1": [
    "MNS1 CNV",
    "MNS1 RNA"
  ],
  "WFDC8": [
    "WFDC8 CNV",
    "WFDC8 RNA"
  ],
  "H3P7": [
    "H3P7 CNV",
    "H3P7 RNA"
  ],
  "DYRK1A": [
    "DYRK1A CNV",
    "DYRK1A RNA",
    "DYRK1A Proteo"
  ],
  "DPM2": [
    "DPM2 CNV",
    "DPM2 RNA"
  ],
  "RPL15P18": [
    "RPL15P18 CNV",
    "RPL15P18 RNA"
  ],
  "NVL": [
    "NVL CNV",
    "NVL RNA",
    "NVL Proteo"
  ],
  "CADM2": [
    "CADM2 CNV",
    "CADM2 RNA"
  ],
  "USP17L9P": [
    "USP17L9P CNV",
    "USP17L9P RNA"
  ],
  "HOXB8": [
    "HOXB8 CNV",
    "HOXB8 RNA",
    "HOXB8 Proteo"
  ],
  "ARF1P1": [
    "ARF1P1 CNV",
    "ARF1P1 RNA"
  ],
  "RNA5SP510": [
    "RNA5SP510 CNV",
    "RNA5SP510 RNA"
  ],
  "DDX27": [
    "DDX27 CNV",
    "DDX27 RNA",
    "DDX27 Proteo"
  ],
  "ARNT": [
    "ARNT CNV",
    "ARNT RNA",
    "ARNT Proteo"
  ],
  "TRIM44": [
    "TRIM44 CNV",
    "TRIM44 RNA",
    "TRIM44 Proteo"
  ],
  "CEND1": [
    "CEND1 CNV",
    "CEND1 RNA"
  ],
  "SLC26A2": [
    "SLC26A2 CNV",
    "SLC26A2 RNA",
    "SLC26A2 Proteo"
  ],
  "GATAD2A": [
    "GATAD2A CNV",
    "GATAD2A RNA",
    "GATAD2A Proteo"
  ],
  "OXSR1": [
    "OXSR1 CNV",
    "OXSR1 RNA",
    "OXSR1 Proteo"
  ],
  "SLC25A5": [
    "SLC25A5 CNV",
    "SLC25A5 RNA",
    "SLC25A5 Proteo"
  ],
  "RNA5SP499": [
    "RNA5SP499 CNV",
    "RNA5SP499 RNA"
  ],
  "PRMT2": [
    "PRMT2 CNV",
    "PRMT2 RNA",
    "PRMT2 Proteo"
  ],
  "SDHAF1": [
    "SDHAF1 CNV",
    "SDHAF1 RNA"
  ],
  "H1-5": [
    "H1-5 CNV",
    "H1-5 RNA",
    "H1-5 Proteo"
  ],
  "NDUFS1": [
    "NDUFS1 CNV",
    "NDUFS1 RNA",
    "NDUFS1 Proteo"
  ],
  "IL5RA": [
    "IL5RA CNV",
    "IL5RA RNA"
  ],
  "RNA5SP330": [
    "RNA5SP330 CNV",
    "RNA5SP330 RNA"
  ],
  "IGHV3OR16-6": [
    "IGHV3OR16-6 CNV",
    "IGHV3OR16-6 RNA"
  ],
  "OR56B4": [
    "OR56B4 CNV",
    "OR56B4 RNA"
  ],
  "OR13Z3P": [
    "OR13Z3P CNV",
    "OR13Z3P RNA"
  ],
  "PSMA5": [
    "PSMA5 CNV",
    "PSMA5 RNA",
    "PSMA5 Proteo"
  ],
  "CHTF8": [
    "CHTF8 CNV",
    "CHTF8 RNA",
    "CHTF8 Proteo"
  ],
  "SIGLEC1": [
    "SIGLEC1 CNV",
    "SIGLEC1 RNA",
    "SIGLEC1 Proteo"
  ],
  "ALG10": [
    "ALG10 CNV",
    "ALG10 RNA",
    "ALG10 Proteo"
  ],
  "CENPVL2": [
    "CENPVL2 CNV",
    "CENPVL2 RNA"
  ],
  "GPA33": [
    "GPA33 CNV",
    "GPA33 RNA",
    "GPA33 Proteo"
  ],
  "ZDHHC20P3": [
    "ZDHHC20P3 CNV",
    "ZDHHC20P3 RNA"
  ],
  "UQCRHP3": [
    "UQCRHP3 CNV",
    "UQCRHP3 RNA"
  ],
  "H2BC7": [
    "H2BC7 CNV",
    "H2BC7 RNA"
  ],
  "RAPGEF6": [
    "RAPGEF6 CNV",
    "RAPGEF6 RNA",
    "RAPGEF6 Proteo"
  ],
  "OSBPL9P5": [
    "OSBPL9P5 CNV",
    "OSBPL9P5 RNA"
  ],
  "KATNBL1P1": [
    "KATNBL1P1 CNV",
    "KATNBL1P1 RNA"
  ],
  "KCNIP3": [
    "KCNIP3 CNV",
    "KCNIP3 RNA"
  ],
  "HPSE": [
    "HPSE CNV",
    "HPSE RNA",
    "HPSE Proteo"
  ],
  "MTND2P8": [
    "MTND2P8 CNV",
    "MTND2P8 RNA"
  ],
  "RPS29P25": [
    "RPS29P25 CNV",
    "RPS29P25 RNA"
  ],
  "COL20A1": [
    "COL20A1 CNV",
    "COL20A1 RNA",
    "COL20A1 Proteo"
  ],
  "MIP": [
    "MIP CNV",
    "MIP RNA"
  ],
  "COPS7B": [
    "COPS7B CNV",
    "COPS7B RNA",
    "COPS7B Proteo"
  ],
  "ZBTB11": [
    "ZBTB11 CNV",
    "ZBTB11 RNA",
    "ZBTB11 Proteo"
  ],
  "SMAD7": [
    "SMAD7 CNV",
    "SMAD7 RNA"
  ],
  "OR8B10P": [
    "OR8B10P CNV",
    "OR8B10P RNA"
  ],
  "OR4T1P": [
    "OR4T1P CNV",
    "OR4T1P RNA"
  ],
  "PRAMEF2": [
    "PRAMEF2 CNV",
    "PRAMEF2 RNA"
  ],
  "TTC5": [
    "TTC5 CNV",
    "TTC5 RNA",
    "TTC5 Proteo"
  ],
  "PCCB": [
    "PCCB CNV",
    "PCCB RNA",
    "PCCB Proteo"
  ],
  "CLK2P1": [
    "CLK2P1 CNV",
    "CLK2P1 RNA"
  ],
  "PPP1R42": [
    "PPP1R42 CNV",
    "PPP1R42 RNA"
  ],
  "C3orf38": [
    "C3orf38 CNV",
    "C3orf38 RNA",
    "C3orf38 Proteo"
  ],
  "SLC22A1": [
    "SLC22A1 CNV",
    "SLC22A1 RNA"
  ],
  "FRZB": [
    "FRZB CNV",
    "FRZB RNA",
    "FRZB Proteo"
  ],
  "DNAAF8": [
    "DNAAF8 CNV",
    "DNAAF8 RNA"
  ],
  "CD101": [
    "CD101 CNV",
    "CD101 RNA",
    "CD101 Proteo"
  ],
  "TLCD2": [
    "TLCD2 CNV",
    "TLCD2 RNA"
  ],
  "CTBP2P7": [
    "CTBP2P7 CNV",
    "CTBP2P7 RNA"
  ],
  "APOC1": [
    "APOC1 CNV",
    "APOC1 RNA",
    "APOC1 Proteo"
  ],
  "VPS45": [
    "VPS45 CNV",
    "VPS45 RNA",
    "VPS45 Proteo"
  ],
  "BNIPL": [
    "BNIPL CNV",
    "BNIPL RNA",
    "BNIPL Proteo"
  ],
  "PAQR3": [
    "PAQR3 CNV",
    "PAQR3 RNA"
  ],
  "C20orf202": [
    "C20orf202 CNV",
    "C20orf202 RNA"
  ],
  "RNA5SP349": [
    "RNA5SP349 CNV",
    "RNA5SP349 RNA"
  ],
  "ITGB5": [
    "ITGB5 CNV",
    "ITGB5 RNA",
    "ITGB5 Proteo"
  ],
  "LRFN2": [
    "LRFN2 CNV",
    "LRFN2 RNA"
  ],
  "PEX7": [
    "PEX7 CNV",
    "PEX7 RNA",
    "PEX7 Proteo"
  ],
  "IQCM": [
    "IQCM CNV",
    "IQCM RNA"
  ],
  "GPR155": [
    "GPR155 CNV",
    "GPR155 RNA",
    "GPR155 Proteo"
  ],
  "OR6C69P": [
    "OR6C69P CNV",
    "OR6C69P RNA"
  ],
  "ENTPD3": [
    "ENTPD3 CNV",
    "ENTPD3 RNA"
  ],
  "LRRC37A6P": [
    "LRRC37A6P CNV",
    "LRRC37A6P RNA"
  ],
  "PRDM1": [
    "PRDM1 CNV",
    "PRDM1 RNA",
    "PRDM1 Proteo"
  ],
  "PCDH1": [
    "PCDH1 CNV",
    "PCDH1 RNA",
    "PCDH1 Proteo"
  ],
  "OR8J1": [
    "OR8J1 CNV",
    "OR8J1 RNA"
  ],
  "ZNF160": [
    "ZNF160 CNV",
    "ZNF160 RNA",
    "ZNF160 Proteo"
  ],
  "OAF": [
    "OAF CNV",
    "OAF RNA",
    "OAF Proteo"
  ],
  "ZNF736P6Y": [
    "ZNF736P6Y CNV",
    "ZNF736P6Y RNA"
  ],
  "ZNHIT1": [
    "ZNHIT1 CNV",
    "ZNHIT1 RNA",
    "ZNHIT1 Proteo"
  ],
  "PIK3R2": [
    "PIK3R2 CNV",
    "PIK3R2 RNA",
    "PIK3R2 Proteo"
  ],
  "SIDT1": [
    "SIDT1 CNV",
    "SIDT1 RNA"
  ],
  "MYRFL": [
    "MYRFL CNV",
    "MYRFL RNA"
  ],
  "RPL29P3": [
    "RPL29P3 CNV",
    "RPL29P3 RNA"
  ],
  "OR4A42P": [
    "OR4A42P CNV",
    "OR4A42P RNA"
  ],
  "CENPV": [
    "CENPV CNV",
    "CENPV RNA",
    "CENPV Proteo"
  ],
  "SAA4": [
    "SAA4 CNV",
    "SAA4 RNA"
  ],
  "DPP3P1": [
    "DPP3P1 CNV",
    "DPP3P1 RNA"
  ],
  "FADS3": [
    "FADS3 CNV",
    "FADS3 RNA",
    "FADS3 Proteo"
  ],
  "RUNDC1": [
    "RUNDC1 CNV",
    "RUNDC1 RNA",
    "RUNDC1 Proteo"
  ],
  "KRT7": [
    "KRT7 CNV",
    "KRT7 RNA",
    "KRT7 Proteo"
  ],
  "YBX2P1": [
    "YBX2P1 CNV",
    "YBX2P1 RNA"
  ],
  "SERTAD4": [
    "SERTAD4 CNV",
    "SERTAD4 RNA"
  ],
  "RBPJL": [
    "RBPJL CNV",
    "RBPJL RNA"
  ],
  "BTN3A2": [
    "BTN3A2 CNV",
    "BTN3A2 RNA",
    "BTN3A2 Proteo"
  ],
  "DERPC": [
    "DERPC CNV",
    "DERPC RNA",
    "DERPC Proteo"
  ],
  "MMP19": [
    "MMP19 CNV",
    "MMP19 RNA",
    "MMP19 Proteo"
  ],
  "GPR143P": [
    "GPR143P CNV",
    "GPR143P RNA"
  ],
  "UROS": [
    "UROS CNV",
    "UROS RNA",
    "UROS Proteo"
  ],
  "ZNFX1": [
    "ZNFX1 CNV",
    "ZNFX1 RNA",
    "ZNFX1 Proteo"
  ],
  "FOXB1": [
    "FOXB1 CNV",
    "FOXB1 RNA",
    "FOXB1 Proteo"
  ],
  "GPIHBP1": [
    "GPIHBP1 CNV",
    "GPIHBP1 RNA"
  ],
  "VN1R34P": [
    "VN1R34P CNV",
    "VN1R34P RNA"
  ],
  "HSD3BP4": [
    "HSD3BP4 CNV",
    "HSD3BP4 RNA"
  ],
  "MTND4LP13": [
    "MTND4LP13 CNV",
    "MTND4LP13 RNA"
  ],
  "H3C13": [
    "H3C13 CNV",
    "H3C13 RNA",
    "H3C13 Proteo"
  ],
  "ATP5MF-PTCD1": [
    "ATP5MF-PTCD1 Proteo"
  ],
  "PCDHGA1": [
    "PCDHGA1 CNV",
    "PCDHGA1 RNA"
  ],
  "FRG1JP": [
    "FRG1JP CNV",
    "FRG1JP RNA"
  ],
  "PAGE2": [
    "PAGE2 CNV",
    "PAGE2 RNA",
    "PAGE2 Proteo"
  ],
  "MRPS34": [
    "MRPS34 CNV",
    "MRPS34 RNA",
    "MRPS34 Proteo"
  ],
  "SNX18P25": [
    "SNX18P25 CNV",
    "SNX18P25 RNA"
  ],
  "MTND3P10": [
    "MTND3P10 CNV",
    "MTND3P10 RNA"
  ],
  "DCST1": [
    "DCST1 CNV",
    "DCST1 RNA"
  ],
  "RSPH1": [
    "RSPH1 CNV",
    "RSPH1 RNA"
  ],
  "FAM177A1": [
    "FAM177A1 CNV",
    "FAM177A1 RNA",
    "FAM177A1 Proteo"
  ],
  "CDKN1A": [
    "CDKN1A CNV",
    "CDKN1A RNA",
    "CDKN1A Proteo"
  ],
  "ATP5PBP4": [
    "ATP5PBP4 CNV",
    "ATP5PBP4 RNA"
  ],
  "GPR37L1": [
    "GPR37L1 CNV",
    "GPR37L1 RNA"
  ],
  "LMO1": [
    "LMO1 CNV",
    "LMO1 RNA"
  ],
  "EIF3EP2": [
    "EIF3EP2 CNV",
    "EIF3EP2 RNA"
  ],
  "SPATS2L": [
    "SPATS2L CNV",
    "SPATS2L RNA",
    "SPATS2L Proteo"
  ],
  "HADH": [
    "HADH CNV",
    "HADH RNA",
    "HADH Proteo"
  ],
  "PITRM1": [
    "PITRM1 CNV",
    "PITRM1 RNA",
    "PITRM1 Proteo"
  ],
  "OR52E5": [
    "OR52E5 CNV",
    "OR52E5 RNA"
  ],
  "SPR": [
    "SPR CNV",
    "SPR RNA",
    "SPR Proteo"
  ],
  "TRAF3IP1": [
    "TRAF3IP1 CNV",
    "TRAF3IP1 RNA",
    "TRAF3IP1 Proteo"
  ],
  "ST13P12": [
    "ST13P12 CNV",
    "ST13P12 RNA"
  ],
  "ACSS1": [
    "ACSS1 CNV",
    "ACSS1 RNA",
    "ACSS1 Proteo"
  ],
  "FLI1": [
    "FLI1 CNV",
    "FLI1 RNA",
    "FLI1 Proteo"
  ],
  "UBE2E2": [
    "UBE2E2 CNV",
    "UBE2E2 RNA",
    "UBE2E2 Proteo"
  ],
  "RPL7P34": [
    "RPL7P34 CNV",
    "RPL7P34 RNA"
  ],
  "RPS19P6": [
    "RPS19P6 CNV",
    "RPS19P6 RNA"
  ],
  "RPL36AP48": [
    "RPL36AP48 CNV",
    "RPL36AP48 RNA"
  ],
  "OASL2P": [
    "OASL2P CNV",
    "OASL2P RNA"
  ],
  "ISLR2": [
    "ISLR2 CNV",
    "ISLR2 RNA"
  ],
  "SPANXB1": [
    "SPANXB1 CNV",
    "SPANXB1 RNA"
  ],
  "GLRX5P3": [
    "GLRX5P3 CNV",
    "GLRX5P3 RNA"
  ],
  "HSD17B6": [
    "HSD17B6 CNV",
    "HSD17B6 RNA",
    "HSD17B6 Proteo"
  ],
  "DHFRP1": [
    "DHFRP1 CNV",
    "DHFRP1 RNA"
  ],
  "RPL30P2": [
    "RPL30P2 CNV",
    "RPL30P2 RNA"
  ],
  "RNA5SP419": [
    "RNA5SP419 CNV",
    "RNA5SP419 RNA"
  ],
  "ANO8": [
    "ANO8 CNV",
    "ANO8 RNA",
    "ANO8 Proteo"
  ],
  "ENKD1": [
    "ENKD1 CNV",
    "ENKD1 RNA",
    "ENKD1 Proteo"
  ],
  "HNRNPA1P66": [
    "HNRNPA1P66 CNV",
    "HNRNPA1P66 RNA"
  ],
  "RPSAP14": [
    "RPSAP14 CNV",
    "RPSAP14 RNA"
  ],
  "FAM197Y9": [
    "FAM197Y9 CNV",
    "FAM197Y9 RNA"
  ],
  "NF1P9": [
    "NF1P9 CNV",
    "NF1P9 RNA"
  ],
  "CYGB": [
    "CYGB CNV",
    "CYGB RNA",
    "CYGB Proteo"
  ],
  "NUP54": [
    "NUP54 CNV",
    "NUP54 RNA",
    "NUP54 Proteo"
  ],
  "RPRD2": [
    "RPRD2 CNV",
    "RPRD2 RNA",
    "RPRD2 Proteo"
  ],
  "PGBD5": [
    "PGBD5 CNV",
    "PGBD5 RNA"
  ],
  "KCNT2": [
    "KCNT2 CNV",
    "KCNT2 RNA"
  ],
  "LRRC38": [
    "LRRC38 CNV",
    "LRRC38 RNA"
  ],
  "AK3P5": [
    "AK3P5 CNV",
    "AK3P5 RNA"
  ],
  "IFI6": [
    "IFI6 CNV",
    "IFI6 RNA"
  ],
  "NOP56P1": [
    "NOP56P1 CNV",
    "NOP56P1 RNA"
  ],
  "LHX5": [
    "LHX5 CNV",
    "LHX5 RNA"
  ],
  "STAB1": [
    "STAB1 CNV",
    "STAB1 RNA",
    "STAB1 Proteo"
  ],
  "FGF6": [
    "FGF6 CNV",
    "FGF6 RNA"
  ],
  "TNPO1": [
    "TNPO1 CNV",
    "TNPO1 RNA",
    "TNPO1 Proteo"
  ],
  "UBR5": [
    "UBR5 CNV",
    "UBR5 RNA",
    "UBR5 Proteo"
  ],
  "LMNTD1": [
    "LMNTD1 CNV",
    "LMNTD1 RNA"
  ],
  "RFPL4A": [
    "RFPL4A CNV",
    "RFPL4A RNA"
  ],
  "CDYL": [
    "CDYL CNV",
    "CDYL RNA",
    "CDYL Proteo"
  ],
  "NUDCD3": [
    "NUDCD3 CNV",
    "NUDCD3 RNA",
    "NUDCD3 Proteo"
  ],
  "DDX18P4": [
    "DDX18P4 CNV",
    "DDX18P4 RNA"
  ],
  "PLP2": [
    "PLP2 CNV",
    "PLP2 RNA",
    "PLP2 Proteo"
  ],
  "CATSPERE": [
    "CATSPERE CNV",
    "CATSPERE RNA"
  ],
  "FBXO27": [
    "FBXO27 CNV",
    "FBXO27 RNA"
  ],
  "SH3BGR": [
    "SH3BGR CNV",
    "SH3BGR RNA"
  ],
  "TMF1P1": [
    "TMF1P1 CNV",
    "TMF1P1 RNA"
  ],
  "SEPTIN2P1": [
    "SEPTIN2P1 CNV",
    "SEPTIN2P1 RNA"
  ],
  "MPC1": [
    "MPC1 CNV",
    "MPC1 RNA",
    "MPC1 Proteo"
  ],
  "PHOSPHO1": [
    "PHOSPHO1 CNV",
    "PHOSPHO1 RNA"
  ],
  "RNF212": [
    "RNF212 CNV",
    "RNF212 RNA"
  ],
  "YWHAEP3": [
    "YWHAEP3 CNV",
    "YWHAEP3 RNA"
  ],
  "C2CD4C": [
    "C2CD4C CNV",
    "C2CD4C RNA",
    "C2CD4C Proteo"
  ],
  "PRICKLE4": [
    "PRICKLE4 CNV",
    "PRICKLE4 RNA"
  ],
  "CICP21": [
    "CICP21 CNV",
    "CICP21 RNA"
  ],
  "MRM3P2": [
    "MRM3P2 CNV",
    "MRM3P2 RNA"
  ],
  "HDGFL3P1": [
    "HDGFL3P1 CNV",
    "HDGFL3P1 RNA"
  ],
  "CFTR": [
    "CFTR CNV",
    "CFTR RNA"
  ],
  "HSPA8P7": [
    "HSPA8P7 CNV",
    "HSPA8P7 RNA"
  ],
  "TBC1D10C": [
    "TBC1D10C CNV",
    "TBC1D10C RNA",
    "TBC1D10C Proteo"
  ],
  "ATF7IP2": [
    "ATF7IP2 CNV",
    "ATF7IP2 RNA"
  ],
  "ZNF561": [
    "ZNF561 CNV",
    "ZNF561 RNA"
  ],
  "IFITM5": [
    "IFITM5 CNV",
    "IFITM5 RNA"
  ],
  "CAPN12": [
    "CAPN12 CNV",
    "CAPN12 RNA"
  ],
  "SYNGR3": [
    "SYNGR3 CNV",
    "SYNGR3 RNA",
    "SYNGR3 Proteo"
  ],
  "KRT8P23": [
    "KRT8P23 CNV",
    "KRT8P23 RNA"
  ],
  "ANKRD20A3P": [
    "ANKRD20A3P CNV",
    "ANKRD20A3P RNA"
  ],
  "SPARC": [
    "SPARC CNV",
    "SPARC RNA",
    "SPARC Proteo"
  ],
  "GPR32P1": [
    "GPR32P1 CNV",
    "GPR32P1 RNA"
  ],
  "MTSS1": [
    "MTSS1 CNV",
    "MTSS1 RNA",
    "MTSS1 Proteo"
  ],
  "TCF23": [
    "TCF23 CNV",
    "TCF23 RNA"
  ],
  "GTF2IP4": [
    "GTF2IP4 CNV",
    "GTF2IP4 RNA"
  ],
  "POMP": [
    "POMP CNV",
    "POMP RNA",
    "POMP Proteo"
  ],
  "TUBB3P1": [
    "TUBB3P1 CNV",
    "TUBB3P1 RNA"
  ],
  "SPINT2": [
    "SPINT2 CNV",
    "SPINT2 RNA",
    "SPINT2 Proteo"
  ],
  "RPS26P52": [
    "RPS26P52 CNV",
    "RPS26P52 RNA"
  ],
  "NDUFS5P6": [
    "NDUFS5P6 CNV",
    "NDUFS5P6 RNA"
  ],
  "WBP1LP4": [
    "WBP1LP4 CNV",
    "WBP1LP4 RNA"
  ],
  "NUBP1": [
    "NUBP1 CNV",
    "NUBP1 RNA",
    "NUBP1 Proteo"
  ],
  "FAM167A": [
    "FAM167A CNV",
    "FAM167A RNA"
  ],
  "HAUS1": [
    "HAUS1 CNV",
    "HAUS1 RNA",
    "HAUS1 Proteo"
  ],
  "ZNF462": [
    "ZNF462 CNV",
    "ZNF462 RNA",
    "ZNF462 Proteo"
  ],
  "MTCO3P46": [
    "MTCO3P46 CNV",
    "MTCO3P46 RNA"
  ],
  "RBPMSLP": [
    "RBPMSLP CNV",
    "RBPMSLP RNA"
  ],
  "SOCS5P1": [
    "SOCS5P1 CNV",
    "SOCS5P1 RNA"
  ],
  "RAMP3": [
    "RAMP3 CNV",
    "RAMP3 RNA"
  ],
  "C17orf97": [
    "C17orf97 CNV",
    "C17orf97 RNA",
    "C17orf97 Proteo"
  ],
  "SAMD5": [
    "SAMD5 CNV",
    "SAMD5 RNA"
  ],
  "TUBAP9": [
    "TUBAP9 CNV",
    "TUBAP9 RNA"
  ],
  "ALOX12B": [
    "ALOX12B CNV",
    "ALOX12B RNA",
    "ALOX12B Proteo"
  ],
  "HMGN1P9": [
    "HMGN1P9 CNV",
    "HMGN1P9 RNA"
  ],
  "CHP1": [
    "CHP1 CNV",
    "CHP1 RNA",
    "CHP1 Proteo"
  ],
  "RPL35AP37": [
    "RPL35AP37 CNV",
    "RPL35AP37 RNA"
  ],
  "IGSF9B": [
    "IGSF9B CNV",
    "IGSF9B RNA"
  ],
  "HAUS8": [
    "HAUS8 CNV",
    "HAUS8 RNA",
    "HAUS8 Proteo"
  ],
  "DNAL4": [
    "DNAL4 CNV",
    "DNAL4 RNA",
    "DNAL4 Proteo"
  ],
  "SGO1P1": [
    "SGO1P1 CNV",
    "SGO1P1 RNA"
  ],
  "OAZ2": [
    "OAZ2 CNV",
    "OAZ2 RNA"
  ],
  "C1orf116": [
    "C1orf116 CNV",
    "C1orf116 RNA",
    "C1orf116 Proteo"
  ],
  "PRR29": [
    "PRR29 CNV",
    "PRR29 RNA"
  ],
  "FTH1P10": [
    "FTH1P10 CNV",
    "FTH1P10 RNA"
  ],
  "FBLN2": [
    "FBLN2 CNV",
    "FBLN2 RNA",
    "FBLN2 Proteo"
  ],
  "MFSD3": [
    "MFSD3 CNV",
    "MFSD3 RNA",
    "MFSD3 Proteo"
  ],
  "POLR1A": [
    "POLR1A CNV",
    "POLR1A RNA",
    "POLR1A Proteo"
  ],
  "IGHV4-4": [
    "IGHV4-4 Proteo"
  ],
  "PRAC1": [
    "PRAC1 CNV",
    "PRAC1 RNA"
  ],
  "EVI5L": [
    "EVI5L CNV",
    "EVI5L RNA",
    "EVI5L Proteo"
  ],
  "OR51B5": [
    "OR51B5 CNV",
    "OR51B5 RNA"
  ],
  "DDX51": [
    "DDX51 CNV",
    "DDX51 RNA",
    "DDX51 Proteo"
  ],
  "TAMALIN": [
    "TAMALIN CNV",
    "TAMALIN RNA",
    "TAMALIN Proteo"
  ],
  "ATP5PDP3": [
    "ATP5PDP3 CNV",
    "ATP5PDP3 RNA"
  ],
  "RNA5SP157": [
    "RNA5SP157 CNV",
    "RNA5SP157 RNA"
  ],
  "GPR17": [
    "GPR17 CNV",
    "GPR17 RNA"
  ],
  "SSXP1": [
    "SSXP1 CNV",
    "SSXP1 RNA"
  ],
  "SNRPCP13": [
    "SNRPCP13 CNV",
    "SNRPCP13 RNA"
  ],
  "C1QBPP1": [
    "C1QBPP1 CNV",
    "C1QBPP1 RNA"
  ],
  "PARP4P1": [
    "PARP4P1 CNV",
    "PARP4P1 RNA"
  ],
  "SFTPA1": [
    "SFTPA1 CNV",
    "SFTPA1 RNA"
  ],
  "AGGF1": [
    "AGGF1 CNV",
    "AGGF1 RNA",
    "AGGF1 Proteo"
  ],
  "SEMA6B": [
    "SEMA6B CNV",
    "SEMA6B RNA",
    "SEMA6B Proteo"
  ],
  "CTBP1": [
    "CTBP1 CNV",
    "CTBP1 RNA",
    "CTBP1 Proteo"
  ],
  "TNFRSF10C": [
    "TNFRSF10C CNV",
    "TNFRSF10C RNA"
  ],
  "GOLGA6L10": [
    "GOLGA6L10 CNV",
    "GOLGA6L10 RNA"
  ],
  "S1PR3": [
    "S1PR3 CNV",
    "S1PR3 RNA"
  ],
  "RPSAP65": [
    "RPSAP65 CNV",
    "RPSAP65 RNA"
  ],
  "ANGPTL4": [
    "ANGPTL4 CNV",
    "ANGPTL4 RNA",
    "ANGPTL4 Proteo"
  ],
  "OR7E14P": [
    "OR7E14P CNV",
    "OR7E14P RNA"
  ],
  "WDR53": [
    "WDR53 CNV",
    "WDR53 RNA",
    "WDR53 Proteo"
  ],
  "RPS14": [
    "RPS14 CNV",
    "RPS14 RNA",
    "RPS14 Proteo"
  ],
  "RPL7AP35": [
    "RPL7AP35 CNV",
    "RPL7AP35 RNA"
  ],
  "HSPB1": [
    "HSPB1 CNV",
    "HSPB1 RNA",
    "HSPB1 Proteo"
  ],
  "SCARA3": [
    "SCARA3 CNV",
    "SCARA3 RNA",
    "SCARA3 Proteo"
  ],
  "NOXA1": [
    "NOXA1 CNV",
    "NOXA1 RNA",
    "NOXA1 Proteo"
  ],
  "RPS27AP19": [
    "RPS27AP19 CNV",
    "RPS27AP19 RNA"
  ],
  "NSFL1C": [
    "NSFL1C CNV",
    "NSFL1C RNA",
    "NSFL1C Proteo"
  ],
  "TIMMDC1": [
    "TIMMDC1 CNV",
    "TIMMDC1 RNA",
    "TIMMDC1 Proteo"
  ],
  "SLC43A1": [
    "SLC43A1 CNV",
    "SLC43A1 RNA",
    "SLC43A1 Proteo"
  ],
  "GOLM2P1": [
    "GOLM2P1 CNV",
    "GOLM2P1 RNA"
  ],
  "OR2AD1P": [
    "OR2AD1P CNV",
    "OR2AD1P RNA"
  ],
  "EEF1A1P35": [
    "EEF1A1P35 CNV",
    "EEF1A1P35 RNA"
  ],
  "HLA-L": [
    "HLA-L CNV",
    "HLA-L RNA"
  ],
  "ULK4": [
    "ULK4 CNV",
    "ULK4 RNA"
  ],
  "SOX6": [
    "SOX6 CNV",
    "SOX6 RNA",
    "SOX6 Proteo"
  ],
  "LINC01347": [
    "LINC01347 CNV",
    "LINC01347 RNA"
  ],
  "DDB2": [
    "DDB2 CNV",
    "DDB2 RNA",
    "DDB2 Proteo"
  ],
  "PTPN20": [
    "PTPN20 CNV",
    "PTPN20 RNA"
  ],
  "OR4C13": [
    "OR4C13 CNV",
    "OR4C13 RNA"
  ],
  "KRTAP9-10P": [
    "KRTAP9-10P CNV",
    "KRTAP9-10P RNA"
  ],
  "TBC1D17": [
    "TBC1D17 CNV",
    "TBC1D17 RNA",
    "TBC1D17 Proteo"
  ],
  "DEFB109A": [
    "DEFB109A CNV",
    "DEFB109A RNA"
  ],
  "PPAT": [
    "PPAT CNV",
    "PPAT RNA",
    "PPAT Proteo"
  ],
  "TMEM217": [
    "TMEM217 CNV",
    "TMEM217 RNA"
  ],
  "LIMK2P1": [
    "LIMK2P1 CNV",
    "LIMK2P1 RNA"
  ],
  "PDCD1LG2": [
    "PDCD1LG2 CNV",
    "PDCD1LG2 RNA",
    "PDCD1LG2 Proteo"
  ],
  "FAM47E": [
    "FAM47E CNV",
    "FAM47E RNA"
  ],
  "LANCL3": [
    "LANCL3 CNV",
    "LANCL3 RNA"
  ],
  "C11orf52": [
    "C11orf52 CNV",
    "C11orf52 RNA",
    "C11orf52 Proteo"
  ],
  "CLTA": [
    "CLTA CNV",
    "CLTA RNA",
    "CLTA Proteo"
  ],
  "PGPEP1": [
    "PGPEP1 CNV",
    "PGPEP1 RNA",
    "PGPEP1 Proteo"
  ],
  "HMGB3P10": [
    "HMGB3P10 CNV",
    "HMGB3P10 RNA"
  ],
  "AHSG": [
    "AHSG CNV",
    "AHSG RNA",
    "AHSG Proteo"
  ],
  "POU2F2": [
    "POU2F2 CNV",
    "POU2F2 RNA"
  ],
  "RTL9": [
    "RTL9 CNV",
    "RTL9 RNA"
  ],
  "PLEKHA4": [
    "PLEKHA4 CNV",
    "PLEKHA4 RNA",
    "PLEKHA4 Proteo"
  ],
  "SLC41A1": [
    "SLC41A1 CNV",
    "SLC41A1 RNA"
  ],
  "CCL2": [
    "CCL2 CNV",
    "CCL2 RNA"
  ],
  "LINC01881": [
    "LINC01881 CNV",
    "LINC01881 RNA"
  ],
  "EEF1A1": [
    "EEF1A1 CNV",
    "EEF1A1 RNA",
    "EEF1A1 Proteo"
  ],
  "RAB38": [
    "RAB38 CNV",
    "RAB38 RNA",
    "RAB38 Proteo"
  ],
  "EIF4A1P1": [
    "EIF4A1P1 CNV",
    "EIF4A1P1 RNA"
  ],
  "POGK": [
    "POGK CNV",
    "POGK RNA",
    "POGK Proteo"
  ],
  "ZNF567": [
    "ZNF567 CNV",
    "ZNF567 RNA"
  ],
  "BRINP3": [
    "BRINP3 CNV",
    "BRINP3 RNA"
  ],
  "RPL9P2": [
    "RPL9P2 CNV",
    "RPL9P2 RNA"
  ],
  "ZDHHC19": [
    "ZDHHC19 CNV",
    "ZDHHC19 RNA"
  ],
  "RASL11B": [
    "RASL11B CNV",
    "RASL11B RNA"
  ],
  "SORBS2": [
    "SORBS2 CNV",
    "SORBS2 RNA",
    "SORBS2 Proteo"
  ],
  "NMD3P1": [
    "NMD3P1 CNV",
    "NMD3P1 RNA"
  ],
  "RPL7AP15": [
    "RPL7AP15 CNV",
    "RPL7AP15 RNA"
  ],
  "TECR": [
    "TECR CNV",
    "TECR RNA",
    "TECR Proteo"
  ],
  "PPIP5K1": [
    "PPIP5K1 CNV",
    "PPIP5K1 RNA",
    "PPIP5K1 Proteo"
  ],
  "SETSIP": [
    "SETSIP CNV",
    "SETSIP RNA"
  ],
  "ADAMTS5": [
    "ADAMTS5 CNV",
    "ADAMTS5 RNA",
    "ADAMTS5 Proteo"
  ],
  "EXOC7P1": [
    "EXOC7P1 CNV",
    "EXOC7P1 RNA"
  ],
  "TMEM210": [
    "TMEM210 CNV",
    "TMEM210 RNA"
  ],
  "SFRP5": [
    "SFRP5 CNV",
    "SFRP5 RNA"
  ],
  "IMPA1P1": [
    "IMPA1P1 CNV",
    "IMPA1P1 RNA"
  ],
  "ANKRD20A1": [
    "ANKRD20A1 CNV",
    "ANKRD20A1 RNA"
  ],
  "BCKDHB": [
    "BCKDHB CNV",
    "BCKDHB RNA",
    "BCKDHB Proteo"
  ],
  "SPINDOC": [
    "SPINDOC CNV",
    "SPINDOC RNA",
    "SPINDOC Proteo"
  ],
  "PILRA": [
    "PILRA CNV",
    "PILRA RNA",
    "PILRA Proteo"
  ],
  "RPGRIP1L": [
    "RPGRIP1L CNV",
    "RPGRIP1L RNA",
    "RPGRIP1L Proteo"
  ],
  "RNA5SP255": [
    "RNA5SP255 CNV",
    "RNA5SP255 RNA"
  ],
  "COG6": [
    "COG6 CNV",
    "COG6 RNA",
    "COG6 Proteo"
  ],
  "MLLT10P1": [
    "MLLT10P1 CNV",
    "MLLT10P1 RNA"
  ],
  "APBA3": [
    "APBA3 CNV",
    "APBA3 RNA",
    "APBA3 Proteo"
  ],
  "CCNQP1": [
    "CCNQP1 CNV",
    "CCNQP1 RNA"
  ],
  "RPL23AP69": [
    "RPL23AP69 CNV",
    "RPL23AP69 RNA"
  ],
  "MTHFD1": [
    "MTHFD1 CNV",
    "MTHFD1 RNA",
    "MTHFD1 Proteo"
  ],
  "IGKV2-23": [
    "IGKV2-23 CNV",
    "IGKV2-23 RNA"
  ],
  "IGHV3-30-2": [
    "IGHV3-30-2 CNV",
    "IGHV3-30-2 RNA"
  ],
  "C2orf76": [
    "C2orf76 CNV",
    "C2orf76 RNA",
    "C2orf76 Proteo"
  ],
  "CPT1C": [
    "CPT1C CNV",
    "CPT1C RNA",
    "CPT1C Proteo"
  ],
  "RPS24P14": [
    "RPS24P14 CNV",
    "RPS24P14 RNA"
  ],
  "VKORC1": [
    "VKORC1 CNV",
    "VKORC1 RNA",
    "VKORC1 Proteo"
  ],
  "CAMLG": [
    "CAMLG CNV",
    "CAMLG RNA",
    "CAMLG Proteo"
  ],
  "RPL32P26": [
    "RPL32P26 CNV",
    "RPL32P26 RNA"
  ],
  "TRIM64FP": [
    "TRIM64FP CNV",
    "TRIM64FP RNA"
  ],
  "SMARCE1P6": [
    "SMARCE1P6 CNV",
    "SMARCE1P6 RNA"
  ],
  "CCDC178": [
    "CCDC178 CNV",
    "CCDC178 RNA"
  ],
  "PMCH": [
    "PMCH CNV",
    "PMCH RNA"
  ],
  "MSL2": [
    "MSL2 CNV",
    "MSL2 RNA",
    "MSL2 Proteo"
  ],
  "OPN3": [
    "OPN3 CNV",
    "OPN3 RNA"
  ],
  "H3P4": [
    "H3P4 CNV",
    "H3P4 RNA"
  ],
  "FBXW4": [
    "FBXW4 CNV",
    "FBXW4 RNA",
    "FBXW4 Proteo"
  ],
  "TUBD1": [
    "TUBD1 CNV",
    "TUBD1 RNA",
    "TUBD1 Proteo"
  ],
  "ALYREF": [
    "ALYREF CNV",
    "ALYREF RNA",
    "ALYREF Proteo"
  ],
  "NUDT18": [
    "NUDT18 CNV",
    "NUDT18 RNA",
    "NUDT18 Proteo"
  ],
  "RAB5C": [
    "RAB5C CNV",
    "RAB5C RNA",
    "RAB5C Proteo"
  ],
  "RBM19": [
    "RBM19 CNV",
    "RBM19 RNA",
    "RBM19 Proteo"
  ],
  "GJA9": [
    "GJA9 CNV",
    "GJA9 RNA"
  ],
  "DDX3Y": [
    "DDX3Y CNV",
    "DDX3Y RNA",
    "DDX3Y Proteo"
  ],
  "MRPL40": [
    "MRPL40 CNV",
    "MRPL40 RNA",
    "MRPL40 Proteo"
  ],
  "SEC63P2": [
    "SEC63P2 CNV",
    "SEC63P2 RNA"
  ],
  "RFC2": [
    "RFC2 CNV",
    "RFC2 RNA",
    "RFC2 Proteo"
  ],
  "NCKIPSD": [
    "NCKIPSD CNV",
    "NCKIPSD RNA",
    "NCKIPSD Proteo"
  ],
  "SPANXN4": [
    "SPANXN4 CNV",
    "SPANXN4 RNA"
  ],
  "RSPH10B": [
    "RSPH10B CNV",
    "RSPH10B RNA"
  ],
  "CHGB": [
    "CHGB CNV",
    "CHGB RNA"
  ],
  "CUL1P1": [
    "CUL1P1 CNV",
    "CUL1P1 RNA"
  ],
  "ZNF426": [
    "ZNF426 CNV",
    "ZNF426 RNA"
  ],
  "BRWD1": [
    "BRWD1 CNV",
    "BRWD1 RNA",
    "BRWD1 Proteo"
  ],
  "SNX18P24": [
    "SNX18P24 CNV",
    "SNX18P24 RNA"
  ],
  "IMPDH2": [
    "IMPDH2 CNV",
    "IMPDH2 RNA",
    "IMPDH2 Proteo"
  ],
  "ADGRA1": [
    "ADGRA1 CNV",
    "ADGRA1 RNA"
  ],
  "IFT80": [
    "IFT80 CNV",
    "IFT80 RNA",
    "IFT80 Proteo"
  ],
  "SEPHS1": [
    "SEPHS1 CNV",
    "SEPHS1 RNA",
    "SEPHS1 Proteo"
  ],
  "OR7E93P": [
    "OR7E93P CNV",
    "OR7E93P RNA"
  ],
  "VTA1": [
    "VTA1 CNV",
    "VTA1 RNA",
    "VTA1 Proteo"
  ],
  "KCNC2": [
    "KCNC2 CNV",
    "KCNC2 RNA"
  ],
  "Plasma_cells": [
    "Plasma_cells Cell_type"
  ],
  "CERK": [
    "CERK CNV",
    "CERK RNA",
    "CERK Proteo"
  ],
  "SNX13": [
    "SNX13 CNV",
    "SNX13 RNA",
    "SNX13 Proteo"
  ],
  "ST13P16": [
    "ST13P16 CNV",
    "ST13P16 RNA"
  ],
  "DNAJC19P2": [
    "DNAJC19P2 CNV",
    "DNAJC19P2 RNA"
  ],
  "TERF1P4": [
    "TERF1P4 CNV",
    "TERF1P4 RNA"
  ],
  "IGHVIII-38-1": [
    "IGHVIII-38-1 CNV",
    "IGHVIII-38-1 RNA"
  ],
  "COLCA2": [
    "COLCA2 CNV",
    "COLCA2 RNA"
  ],
  "NSUN5": [
    "NSUN5 CNV",
    "NSUN5 RNA",
    "NSUN5 Proteo"
  ],
  "C3orf86": [
    "C3orf86 CNV",
    "C3orf86 RNA"
  ],
  "KRT18P53": [
    "KRT18P53 CNV",
    "KRT18P53 RNA"
  ],
  "FBN3": [
    "FBN3 CNV",
    "FBN3 RNA",
    "FBN3 Proteo"
  ],
  "B4GALT5": [
    "B4GALT5 CNV",
    "B4GALT5 RNA",
    "B4GALT5 Proteo"
  ],
  "H3P38": [
    "H3P38 CNV",
    "H3P38 RNA"
  ],
  "TFAP4": [
    "TFAP4 CNV",
    "TFAP4 RNA",
    "TFAP4 Proteo"
  ],
  "TMEM50B": [
    "TMEM50B CNV",
    "TMEM50B RNA",
    "TMEM50B Proteo"
  ],
  "GP1BA": [
    "GP1BA CNV",
    "GP1BA RNA",
    "GP1BA Proteo"
  ],
  "MTCO1P25": [
    "MTCO1P25 CNV",
    "MTCO1P25 RNA"
  ],
  "MTND6P9": [
    "MTND6P9 CNV",
    "MTND6P9 RNA"
  ],
  "SLCO1B7": [
    "SLCO1B7 CNV",
    "SLCO1B7 RNA"
  ],
  "KLHL11": [
    "KLHL11 CNV",
    "KLHL11 RNA",
    "KLHL11 Proteo"
  ],
  "GPR68": [
    "GPR68 CNV",
    "GPR68 RNA",
    "GPR68 Proteo"
  ],
  "SOX14": [
    "SOX14 CNV",
    "SOX14 RNA"
  ],
  "SRP72": [
    "SRP72 CNV",
    "SRP72 RNA",
    "SRP72 Proteo"
  ],
  "ZNF200": [
    "ZNF200 CNV",
    "ZNF200 RNA"
  ],
  "TNFSF9": [
    "TNFSF9 CNV",
    "TNFSF9 RNA"
  ],
  "REST": [
    "REST CNV",
    "REST RNA",
    "REST Proteo"
  ],
  "VWA3B": [
    "VWA3B CNV",
    "VWA3B RNA",
    "VWA3B Proteo"
  ],
  "DDX6": [
    "DDX6 CNV",
    "DDX6 RNA",
    "DDX6 Proteo"
  ],
  "SLC25A36P1": [
    "SLC25A36P1 CNV",
    "SLC25A36P1 RNA"
  ],
  "SNCB": [
    "SNCB CNV",
    "SNCB RNA"
  ],
  "RNF138": [
    "RNF138 CNV",
    "RNF138 RNA",
    "RNF138 Proteo"
  ],
  "TMSB10P2": [
    "TMSB10P2 CNV",
    "TMSB10P2 RNA"
  ],
  "ZNF362": [
    "ZNF362 CNV",
    "ZNF362 RNA",
    "ZNF362 Proteo"
  ],
  "RPS20P13": [
    "RPS20P13 CNV",
    "RPS20P13 RNA"
  ],
  "NECAP2": [
    "NECAP2 CNV",
    "NECAP2 RNA",
    "NECAP2 Proteo"
  ],
  "HSD3BP3": [
    "HSD3BP3 CNV",
    "HSD3BP3 RNA"
  ],
  "RBMY1E": [
    "RBMY1E CNV",
    "RBMY1E RNA"
  ],
  "RPSAP42": [
    "RPSAP42 CNV",
    "RPSAP42 RNA"
  ],
  "ALPK1": [
    "ALPK1 CNV",
    "ALPK1 RNA",
    "ALPK1 Proteo"
  ],
  "DCAKD": [
    "DCAKD CNV",
    "DCAKD RNA",
    "DCAKD Proteo"
  ],
  "PLK5": [
    "PLK5 CNV",
    "PLK5 RNA"
  ],
  "VTI1A": [
    "VTI1A CNV",
    "VTI1A RNA",
    "VTI1A Proteo"
  ],
  "MTCYBP7": [
    "MTCYBP7 CNV",
    "MTCYBP7 RNA"
  ],
  "GREM1": [
    "GREM1 CNV",
    "GREM1 RNA",
    "GREM1 Proteo"
  ],
  "FBXL5": [
    "FBXL5 CNV",
    "FBXL5 RNA"
  ],
  "CUEDC1": [
    "CUEDC1 CNV",
    "CUEDC1 RNA",
    "CUEDC1 Proteo"
  ],
  "AHCYL2": [
    "AHCYL2 CNV",
    "AHCYL2 RNA",
    "AHCYL2 Proteo"
  ],
  "ZNF682": [
    "ZNF682 CNV",
    "ZNF682 RNA"
  ],
  "FKBP1AP3": [
    "FKBP1AP3 CNV",
    "FKBP1AP3 RNA"
  ],
  "RPS6P20": [
    "RPS6P20 CNV",
    "RPS6P20 RNA"
  ],
  "CDH8": [
    "CDH8 CNV",
    "CDH8 RNA"
  ],
  "FCAR": [
    "FCAR CNV",
    "FCAR RNA",
    "FCAR Proteo"
  ],
  "ITGB1BP2": [
    "ITGB1BP2 CNV",
    "ITGB1BP2 RNA"
  ],
  "MDM4P1": [
    "MDM4P1 CNV",
    "MDM4P1 RNA"
  ],
  "POU4F2": [
    "POU4F2 CNV",
    "POU4F2 RNA"
  ],
  "COG1": [
    "COG1 CNV",
    "COG1 RNA",
    "COG1 Proteo"
  ],
  "NAPSA": [
    "NAPSA CNV",
    "NAPSA RNA",
    "NAPSA Proteo"
  ],
  "OAZ1": [
    "OAZ1 CNV",
    "OAZ1 RNA"
  ],
  "TAF11L13": [
    "TAF11L13 CNV",
    "TAF11L13 RNA"
  ],
  "CCER2": [
    "CCER2 CNV",
    "CCER2 RNA"
  ],
  "CT45A2": [
    "CT45A2 CNV",
    "CT45A2 RNA",
    "CT45A2 Proteo"
  ],
  "BSPRY": [
    "BSPRY CNV",
    "BSPRY RNA",
    "BSPRY Proteo"
  ],
  "CLINT1": [
    "CLINT1 CNV",
    "CLINT1 RNA",
    "CLINT1 Proteo"
  ],
  "UGT1A3": [
    "UGT1A3 CNV",
    "UGT1A3 RNA"
  ],
  "CXCL16": [
    "CXCL16 CNV",
    "CXCL16 RNA"
  ],
  "CLTB": [
    "CLTB CNV",
    "CLTB RNA",
    "CLTB Proteo"
  ],
  "RFPL3": [
    "RFPL3 CNV",
    "RFPL3 RNA"
  ],
  "NCK2": [
    "NCK2 CNV",
    "NCK2 RNA",
    "NCK2 Proteo"
  ],
  "TRPC6P10": [
    "TRPC6P10 CNV",
    "TRPC6P10 RNA"
  ],
  "GABPB1": [
    "GABPB1 CNV",
    "GABPB1 RNA",
    "GABPB1 Proteo"
  ],
  "NYAP2": [
    "NYAP2 CNV",
    "NYAP2 RNA"
  ],
  "USP3": [
    "USP3 CNV",
    "USP3 RNA",
    "USP3 Proteo"
  ],
  "TMEM61": [
    "TMEM61 CNV",
    "TMEM61 RNA"
  ],
  "RPL7AP38": [
    "RPL7AP38 CNV",
    "RPL7AP38 RNA"
  ],
  "ATP5MFP2": [
    "ATP5MFP2 CNV",
    "ATP5MFP2 RNA"
  ],
  "HNRNPABP1": [
    "HNRNPABP1 CNV",
    "HNRNPABP1 RNA"
  ],
  "MMP9": [
    "MMP9 CNV",
    "MMP9 RNA",
    "MMP9 Proteo"
  ],
  "PTK2": [
    "PTK2 CNV",
    "PTK2 RNA",
    "PTK2 Proteo"
  ],
  "FLYWCH2": [
    "FLYWCH2 CNV",
    "FLYWCH2 RNA",
    "FLYWCH2 Proteo"
  ],
  "ATP6V1G1P2": [
    "ATP6V1G1P2 CNV",
    "ATP6V1G1P2 RNA"
  ],
  "HSPE1P9": [
    "HSPE1P9 CNV",
    "HSPE1P9 RNA"
  ],
  "LONP1": [
    "LONP1 CNV",
    "LONP1 RNA",
    "LONP1 Proteo"
  ],
  "DEFB116": [
    "DEFB116 CNV",
    "DEFB116 RNA"
  ],
  "CYBB": [
    "CYBB CNV",
    "CYBB RNA",
    "CYBB Proteo"
  ],
  "VPS4A": [
    "VPS4A CNV",
    "VPS4A RNA",
    "VPS4A Proteo"
  ],
  "TRBV3-1": [
    "TRBV3-1 Proteo"
  ],
  "TERF2IP": [
    "TERF2IP CNV",
    "TERF2IP RNA",
    "TERF2IP Proteo"
  ],
  "ASB10": [
    "ASB10 CNV",
    "ASB10 RNA"
  ],
  "GPR21": [
    "GPR21 CNV",
    "GPR21 RNA"
  ],
  "RPL31P28": [
    "RPL31P28 CNV",
    "RPL31P28 RNA"
  ],
  "LCE7A": [
    "LCE7A CNV",
    "LCE7A RNA"
  ],
  "IL6ST": [
    "IL6ST CNV",
    "IL6ST RNA",
    "IL6ST Proteo"
  ],
  "SNRPCP14": [
    "SNRPCP14 CNV",
    "SNRPCP14 RNA"
  ],
  "MTND6P17": [
    "MTND6P17 CNV",
    "MTND6P17 RNA"
  ],
  "HNRNPA1P42": [
    "HNRNPA1P42 CNV",
    "HNRNPA1P42 RNA"
  ],
  "RPL9P21": [
    "RPL9P21 CNV",
    "RPL9P21 RNA"
  ],
  "CETN3": [
    "CETN3 CNV",
    "CETN3 RNA",
    "CETN3 Proteo"
  ],
  "TMEM37": [
    "TMEM37 CNV",
    "TMEM37 RNA"
  ],
  "IGLL4P": [
    "IGLL4P CNV",
    "IGLL4P RNA"
  ],
  "FTMT": [
    "FTMT CNV",
    "FTMT RNA"
  ],
  "SLAIN1": [
    "SLAIN1 CNV",
    "SLAIN1 RNA",
    "SLAIN1 Proteo"
  ],
  "GDF6": [
    "GDF6 CNV",
    "GDF6 RNA"
  ],
  "PRKX": [
    "PRKX CNV",
    "PRKX RNA",
    "PRKX Proteo"
  ],
  "DDX3X": [
    "DDX3X CNV",
    "DDX3X RNA",
    "DDX3X Proteo"
  ],
  "ELN": [
    "ELN CNV",
    "ELN RNA",
    "ELN Proteo"
  ],
  "OR13C8": [
    "OR13C8 CNV",
    "OR13C8 RNA"
  ],
  "ZNF56P": [
    "ZNF56P CNV",
    "ZNF56P RNA"
  ],
  "SEL1L": [
    "SEL1L CNV",
    "SEL1L RNA",
    "SEL1L Proteo"
  ],
  "DSE": [
    "DSE CNV",
    "DSE RNA",
    "DSE Proteo"
  ],
  "FAM174B": [
    "FAM174B CNV",
    "FAM174B RNA",
    "FAM174B Proteo"
  ],
  "RALGPS1": [
    "RALGPS1 CNV",
    "RALGPS1 RNA"
  ],
  "PHB2": [
    "PHB2 CNV",
    "PHB2 RNA",
    "PHB2 Proteo"
  ],
  "MED11": [
    "MED11 CNV",
    "MED11 RNA",
    "MED11 Proteo"
  ],
  "MTND2P31": [
    "MTND2P31 CNV",
    "MTND2P31 RNA"
  ],
  "KSR1": [
    "KSR1 CNV",
    "KSR1 RNA",
    "KSR1 Proteo"
  ],
  "PARP8": [
    "PARP8 CNV",
    "PARP8 RNA"
  ],
  "CDH4": [
    "CDH4 CNV",
    "CDH4 RNA"
  ],
  "FBXW11P1": [
    "FBXW11P1 CNV",
    "FBXW11P1 RNA"
  ],
  "RTL8A": [
    "RTL8A CNV",
    "RTL8A RNA",
    "RTL8A Proteo"
  ],
  "FAM90A9": [
    "FAM90A9 CNV",
    "FAM90A9 RNA"
  ],
  "SLX4": [
    "SLX4 CNV",
    "SLX4 RNA",
    "SLX4 Proteo"
  ],
  "GNAT2": [
    "GNAT2 CNV",
    "GNAT2 RNA"
  ],
  "EPSTI1": [
    "EPSTI1 CNV",
    "EPSTI1 RNA",
    "EPSTI1 Proteo"
  ],
  "ZNF75BP": [
    "ZNF75BP CNV",
    "ZNF75BP RNA"
  ],
  "TSPAN9": [
    "TSPAN9 CNV",
    "TSPAN9 RNA",
    "TSPAN9 Proteo"
  ],
  "RNA5SP273": [
    "RNA5SP273 CNV",
    "RNA5SP273 RNA"
  ],
  "RPL23AP81": [
    "RPL23AP81 CNV",
    "RPL23AP81 RNA"
  ],
  "CSPG4P10": [
    "CSPG4P10 CNV",
    "CSPG4P10 RNA"
  ],
  "CICP16": [
    "CICP16 CNV",
    "CICP16 RNA"
  ],
  "SUGT1P3": [
    "SUGT1P3 CNV",
    "SUGT1P3 RNA"
  ],
  "APMAP": [
    "APMAP CNV",
    "APMAP RNA",
    "APMAP Proteo"
  ],
  "SSX3": [
    "SSX3 CNV",
    "SSX3 RNA"
  ],
  "CAPSL": [
    "CAPSL CNV",
    "CAPSL RNA"
  ],
  "GFRA1": [
    "GFRA1 CNV",
    "GFRA1 RNA",
    "GFRA1 Proteo"
  ],
  "HLA-DRB6": [
    "HLA-DRB6 CNV",
    "HLA-DRB6 RNA"
  ],
  "NDUFA4L2": [
    "NDUFA4L2 CNV",
    "NDUFA4L2 RNA",
    "NDUFA4L2 Proteo"
  ],
  "OGFOD1P1": [
    "OGFOD1P1 CNV",
    "OGFOD1P1 RNA"
  ],
  "SLC45A2": [
    "SLC45A2 CNV",
    "SLC45A2 RNA",
    "SLC45A2 Proteo"
  ],
  "KLF14": [
    "KLF14 CNV",
    "KLF14 RNA"
  ],
  "MSX2": [
    "MSX2 CNV",
    "MSX2 RNA"
  ],
  "HMGB1P32": [
    "HMGB1P32 CNV",
    "HMGB1P32 RNA"
  ],
  "MRPS16P2": [
    "MRPS16P2 CNV",
    "MRPS16P2 RNA"
  ],
  "SPDL1": [
    "SPDL1 CNV",
    "SPDL1 RNA",
    "SPDL1 Proteo"
  ],
  "KRT18P46": [
    "KRT18P46 CNV",
    "KRT18P46 RNA"
  ],
  "RANBP1": [
    "RANBP1 CNV",
    "RANBP1 RNA",
    "RANBP1 Proteo"
  ],
  "RPL15P2": [
    "RPL15P2 CNV",
    "RPL15P2 RNA"
  ],
  "IGHVII-30-21": [
    "IGHVII-30-21 CNV",
    "IGHVII-30-21 RNA"
  ],
  "SLA": [
    "SLA CNV",
    "SLA RNA",
    "SLA Proteo"
  ],
  "RNF113A": [
    "RNF113A CNV",
    "RNF113A RNA",
    "RNF113A Proteo"
  ],
  "NDUFB9": [
    "NDUFB9 CNV",
    "NDUFB9 RNA",
    "NDUFB9 Proteo"
  ],
  "ASB3": [
    "ASB3 CNV",
    "ASB3 RNA",
    "ASB3 Proteo"
  ],
  "OR4G6P": [
    "OR4G6P CNV",
    "OR4G6P RNA"
  ],
  "GGACT": [
    "GGACT CNV",
    "GGACT RNA",
    "GGACT Proteo"
  ],
  "RPSAP61": [
    "RPSAP61 CNV",
    "RPSAP61 RNA"
  ],
  "PGM1": [
    "PGM1 CNV",
    "PGM1 RNA",
    "PGM1 Proteo"
  ],
  "NXF1": [
    "NXF1 CNV",
    "NXF1 RNA",
    "NXF1 Proteo"
  ],
  "SPRR3": [
    "SPRR3 CNV",
    "SPRR3 RNA",
    "SPRR3 Proteo"
  ],
  "RPL35AP27": [
    "RPL35AP27 CNV",
    "RPL35AP27 RNA"
  ],
  "MTND4LP31": [
    "MTND4LP31 CNV",
    "MTND4LP31 RNA"
  ],
  "TBC1D22B": [
    "TBC1D22B CNV",
    "TBC1D22B RNA",
    "TBC1D22B Proteo"
  ],
  "PLEKHM1P1": [
    "PLEKHM1P1 CNV",
    "PLEKHM1P1 RNA"
  ],
  "RNA5SP130": [
    "RNA5SP130 CNV",
    "RNA5SP130 RNA"
  ],
  "GH2": [
    "GH2 CNV",
    "GH2 RNA"
  ],
  "RPL6P30": [
    "RPL6P30 CNV",
    "RPL6P30 RNA"
  ],
  "NDUFB9P3": [
    "NDUFB9P3 CNV",
    "NDUFB9P3 RNA"
  ],
  "CCR6": [
    "CCR6 CNV",
    "CCR6 RNA",
    "CCR6 Proteo"
  ],
  "NPM1P48": [
    "NPM1P48 CNV",
    "NPM1P48 RNA"
  ],
  "PRDM9": [
    "PRDM9 CNV",
    "PRDM9 RNA",
    "PRDM9 Proteo"
  ],
  "MSI2": [
    "MSI2 CNV",
    "MSI2 RNA",
    "MSI2 Proteo"
  ],
  "GOLGA6L16P": [
    "GOLGA6L16P CNV",
    "GOLGA6L16P RNA"
  ],
  "SMURF2P1": [
    "SMURF2P1 CNV",
    "SMURF2P1 RNA"
  ],
  "TNPO2": [
    "TNPO2 CNV",
    "TNPO2 RNA",
    "TNPO2 Proteo"
  ],
  "NKD2": [
    "NKD2 CNV",
    "NKD2 RNA"
  ],
  "CREB1": [
    "CREB1 CNV",
    "CREB1 RNA",
    "CREB1 Proteo"
  ],
  "DPP10": [
    "DPP10 CNV",
    "DPP10 RNA",
    "DPP10 Proteo"
  ],
  "CDO1": [
    "CDO1 CNV",
    "CDO1 RNA"
  ],
  "A2M": [
    "A2M CNV",
    "A2M RNA",
    "A2M Proteo"
  ],
  "SCUBE1": [
    "SCUBE1 CNV",
    "SCUBE1 RNA"
  ],
  "RNA5SP305": [
    "RNA5SP305 CNV",
    "RNA5SP305 RNA"
  ],
  "BCCIP": [
    "BCCIP CNV",
    "BCCIP RNA",
    "BCCIP Proteo"
  ],
  "DLSTP1": [
    "DLSTP1 CNV",
    "DLSTP1 RNA"
  ],
  "PGAM1P13": [
    "PGAM1P13 CNV",
    "PGAM1P13 RNA"
  ],
  "NPM1P2": [
    "NPM1P2 CNV",
    "NPM1P2 RNA"
  ],
  "BRD2": [
    "BRD2 CNV",
    "BRD2 RNA",
    "BRD2 Proteo"
  ],
  "SOHLH2": [
    "SOHLH2 CNV",
    "SOHLH2 RNA"
  ],
  "ARSH": [
    "ARSH CNV",
    "ARSH RNA"
  ],
  "PDILT": [
    "PDILT CNV",
    "PDILT RNA"
  ],
  "CETN1": [
    "CETN1 CNV",
    "CETN1 RNA"
  ],
  "BLOC1S3": [
    "BLOC1S3 CNV",
    "BLOC1S3 RNA",
    "BLOC1S3 Proteo"
  ],
  "KCNA10": [
    "KCNA10 CNV",
    "KCNA10 RNA"
  ],
  "NPM1P49": [
    "NPM1P49 CNV",
    "NPM1P49 RNA"
  ],
  "ZSCAN32": [
    "ZSCAN32 CNV",
    "ZSCAN32 RNA"
  ],
  "DUX4": [
    "DUX4 CNV",
    "DUX4 RNA"
  ],
  "CAMK2D": [
    "CAMK2D CNV",
    "CAMK2D RNA",
    "CAMK2D Proteo"
  ],
  "SETP14": [
    "SETP14 CNV",
    "SETP14 RNA"
  ],
  "MCUR1P2": [
    "MCUR1P2 CNV",
    "MCUR1P2 RNA"
  ],
  "POTED": [
    "POTED CNV",
    "POTED RNA"
  ],
  "ATXN7L3P1": [
    "ATXN7L3P1 CNV",
    "ATXN7L3P1 RNA"
  ],
  "TUBG1": [
    "TUBG1 CNV",
    "TUBG1 RNA",
    "TUBG1 Proteo"
  ],
  "RPL30P6": [
    "RPL30P6 CNV",
    "RPL30P6 RNA"
  ],
  "GPR149": [
    "GPR149 CNV",
    "GPR149 RNA"
  ],
  "NEK2": [
    "NEK2 CNV",
    "NEK2 RNA"
  ],
  "RPL32P36": [
    "RPL32P36 CNV",
    "RPL32P36 RNA"
  ],
  "RPL23AP83": [
    "RPL23AP83 CNV",
    "RPL23AP83 RNA"
  ],
  "POC5": [
    "POC5 CNV",
    "POC5 RNA",
    "POC5 Proteo"
  ],
  "MYL7": [
    "MYL7 CNV",
    "MYL7 RNA"
  ],
  "RPL21P23": [
    "RPL21P23 CNV",
    "RPL21P23 RNA"
  ],
  "AP2M1": [
    "AP2M1 CNV",
    "AP2M1 RNA",
    "AP2M1 Proteo"
  ],
  "LILRP1": [
    "LILRP1 CNV",
    "LILRP1 RNA"
  ],
  "FN1": [
    "FN1 CNV",
    "FN1 RNA",
    "FN1 Proteo"
  ],
  "ITGA6": [
    "ITGA6 CNV",
    "ITGA6 RNA",
    "ITGA6 Proteo"
  ],
  "OFD1P1Y": [
    "OFD1P1Y CNV",
    "OFD1P1Y RNA"
  ],
  "MYOCOS": [
    "MYOCOS CNV",
    "MYOCOS RNA"
  ],
  "RECK": [
    "RECK CNV",
    "RECK RNA",
    "RECK Proteo"
  ],
  "E2F3": [
    "E2F3 CNV",
    "E2F3 RNA",
    "E2F3 Proteo"
  ],
  "BSCL2": [
    "BSCL2 CNV",
    "BSCL2 RNA",
    "BSCL2 Proteo"
  ],
  "ECI2": [
    "ECI2 CNV",
    "ECI2 RNA",
    "ECI2 Proteo"
  ],
  "AGFG2": [
    "AGFG2 CNV",
    "AGFG2 RNA",
    "AGFG2 Proteo"
  ],
  "RNA5SP177": [
    "RNA5SP177 CNV",
    "RNA5SP177 RNA"
  ],
  "OR7E86P": [
    "OR7E86P CNV",
    "OR7E86P RNA"
  ],
  "NAALAD2": [
    "NAALAD2 CNV",
    "NAALAD2 RNA"
  ],
  "MAGOH": [
    "MAGOH CNV",
    "MAGOH RNA",
    "MAGOH Proteo"
  ],
  "RPF1": [
    "RPF1 CNV",
    "RPF1 RNA",
    "RPF1 Proteo"
  ],
  "DEFA4": [
    "DEFA4 CNV",
    "DEFA4 RNA",
    "DEFA4 Proteo"
  ],
  "HMGB3P31": [
    "HMGB3P31 CNV",
    "HMGB3P31 RNA"
  ],
  "GGT3P": [
    "GGT3P CNV",
    "GGT3P RNA"
  ],
  "B4GALT3": [
    "B4GALT3 CNV",
    "B4GALT3 RNA",
    "B4GALT3 Proteo"
  ],
  "F2": [
    "F2 CNV",
    "F2 RNA",
    "F2 Proteo"
  ],
  "RGL2": [
    "RGL2 CNV",
    "RGL2 RNA",
    "RGL2 Proteo"
  ],
  "MTCO2P18": [
    "MTCO2P18 CNV",
    "MTCO2P18 RNA"
  ],
  "COPS8P3": [
    "COPS8P3 CNV",
    "COPS8P3 RNA"
  ],
  "RPL6P28": [
    "RPL6P28 CNV",
    "RPL6P28 RNA"
  ],
  "OR10G2": [
    "OR10G2 CNV",
    "OR10G2 RNA"
  ],
  "XRCC6P5": [
    "XRCC6P5 CNV",
    "XRCC6P5 RNA"
  ],
  "ZNF703": [
    "ZNF703 CNV",
    "ZNF703 RNA",
    "ZNF703 Proteo"
  ],
  "METTL24": [
    "METTL24 CNV",
    "METTL24 RNA"
  ],
  "CPT1B": [
    "CPT1B CNV",
    "CPT1B RNA",
    "CPT1B Proteo"
  ],
  "FTH1": [
    "FTH1 CNV",
    "FTH1 RNA",
    "FTH1 Proteo"
  ],
  "NIFKP6": [
    "NIFKP6 CNV",
    "NIFKP6 RNA"
  ],
  "IGLVV-58": [
    "IGLVV-58 CNV",
    "IGLVV-58 RNA"
  ],
  "NLGN4X": [
    "NLGN4X CNV",
    "NLGN4X RNA",
    "NLGN4X Proteo"
  ],
  "IPCEF1": [
    "IPCEF1 CNV",
    "IPCEF1 RNA"
  ],
  "PHB1P6": [
    "PHB1P6 CNV",
    "PHB1P6 RNA"
  ],
  "CPB1": [
    "CPB1 CNV",
    "CPB1 RNA"
  ],
  "GKAP1": [
    "GKAP1 CNV",
    "GKAP1 RNA"
  ],
  "EFHD1": [
    "EFHD1 CNV",
    "EFHD1 RNA",
    "EFHD1 Proteo"
  ],
  "DEFB134": [
    "DEFB134 CNV",
    "DEFB134 RNA"
  ],
  "R3HDM2P1": [
    "R3HDM2P1 CNV",
    "R3HDM2P1 RNA"
  ],
  "ATP6V1E1": [
    "ATP6V1E1 CNV",
    "ATP6V1E1 RNA",
    "ATP6V1E1 Proteo"
  ],
  "P2RX5": [
    "P2RX5 CNV",
    "P2RX5 RNA"
  ],
  "PEG3": [
    "PEG3 CNV",
    "PEG3 RNA"
  ],
  "BANF1P4": [
    "BANF1P4 CNV",
    "BANF1P4 RNA"
  ],
  "PTMAP12": [
    "PTMAP12 CNV",
    "PTMAP12 RNA"
  ],
  "CALML5": [
    "CALML5 CNV",
    "CALML5 RNA",
    "CALML5 Proteo"
  ],
  "DVL2": [
    "DVL2 CNV",
    "DVL2 RNA",
    "DVL2 Proteo"
  ],
  "HTN1": [
    "HTN1 CNV",
    "HTN1 RNA",
    "HTN1 Proteo"
  ],
  "RPL30P9": [
    "RPL30P9 CNV",
    "RPL30P9 RNA"
  ],
  "DRD5": [
    "DRD5 CNV",
    "DRD5 RNA"
  ],
  "KIAA0825": [
    "KIAA0825 CNV",
    "KIAA0825 RNA"
  ],
  "CTNNA1P1": [
    "CTNNA1P1 CNV",
    "CTNNA1P1 RNA"
  ],
  "EEF1B2P3": [
    "EEF1B2P3 CNV",
    "EEF1B2P3 RNA"
  ],
  "OR13D2P": [
    "OR13D2P CNV",
    "OR13D2P RNA"
  ],
  "VN1R7P": [
    "VN1R7P CNV",
    "VN1R7P RNA"
  ],
  "H3P26": [
    "H3P26 CNV",
    "H3P26 RNA"
  ],
  "HK3": [
    "HK3 CNV",
    "HK3 RNA",
    "HK3 Proteo"
  ],
  "NCOR1P3": [
    "NCOR1P3 CNV",
    "NCOR1P3 RNA"
  ],
  "SLC1A1": [
    "SLC1A1 CNV",
    "SLC1A1 RNA"
  ],
  "RNA5SP158": [
    "RNA5SP158 CNV",
    "RNA5SP158 RNA"
  ],
  "NATP": [
    "NATP CNV",
    "NATP RNA"
  ],
  "INS": [
    "INS CNV",
    "INS RNA"
  ],
  "NUP88": [
    "NUP88 CNV",
    "NUP88 RNA",
    "NUP88 Proteo"
  ],
  "PIERCE1": [
    "PIERCE1 CNV",
    "PIERCE1 RNA"
  ],
  "MEIS3P2": [
    "MEIS3P2 CNV",
    "MEIS3P2 RNA"
  ],
  "TMEM258": [
    "TMEM258 CNV",
    "TMEM258 RNA",
    "TMEM258 Proteo"
  ],
  "CALHM2": [
    "CALHM2 CNV",
    "CALHM2 RNA",
    "CALHM2 Proteo"
  ],
  "CARD11": [
    "CARD11 CNV",
    "CARD11 RNA",
    "CARD11 Proteo"
  ],
  "RNA5SP406": [
    "RNA5SP406 CNV",
    "RNA5SP406 RNA"
  ],
  "PCYOX1L": [
    "PCYOX1L CNV",
    "PCYOX1L RNA",
    "PCYOX1L Proteo"
  ],
  "XRN2": [
    "XRN2 CNV",
    "XRN2 RNA",
    "XRN2 Proteo"
  ],
  "KMT2CP2": [
    "KMT2CP2 CNV",
    "KMT2CP2 RNA"
  ],
  "SEPTIN10": [
    "SEPTIN10 CNV",
    "SEPTIN10 RNA",
    "SEPTIN10 Proteo"
  ],
  "SLC44A1": [
    "SLC44A1 CNV",
    "SLC44A1 RNA",
    "SLC44A1 Proteo"
  ],
  "MOCS3": [
    "MOCS3 CNV",
    "MOCS3 RNA",
    "MOCS3 Proteo"
  ],
  "STK26": [
    "STK26 CNV",
    "STK26 RNA",
    "STK26 Proteo"
  ],
  "RPS27P1": [
    "RPS27P1 CNV",
    "RPS27P1 RNA"
  ],
  "INTS14": [
    "INTS14 CNV",
    "INTS14 RNA",
    "INTS14 Proteo"
  ],
  "GOT2P1": [
    "GOT2P1 CNV",
    "GOT2P1 RNA"
  ],
  "ELOCP2": [
    "ELOCP2 CNV",
    "ELOCP2 RNA"
  ],
  "OAS2": [
    "OAS2 CNV",
    "OAS2 RNA",
    "OAS2 Proteo"
  ],
  "PSEN1": [
    "PSEN1 CNV",
    "PSEN1 RNA",
    "PSEN1 Proteo"
  ],
  "SMCO4": [
    "SMCO4 CNV",
    "SMCO4 RNA",
    "SMCO4 Proteo"
  ],
  "RALGAPA1": [
    "RALGAPA1 CNV",
    "RALGAPA1 RNA",
    "RALGAPA1 Proteo"
  ],
  "IFITM3P9": [
    "IFITM3P9 CNV",
    "IFITM3P9 RNA"
  ],
  "IL9": [
    "IL9 CNV",
    "IL9 RNA"
  ],
  "CCSER2": [
    "CCSER2 CNV",
    "CCSER2 RNA",
    "CCSER2 Proteo"
  ],
  "RPL7AP10": [
    "RPL7AP10 CNV",
    "RPL7AP10 RNA"
  ],
  "UBXN6": [
    "UBXN6 CNV",
    "UBXN6 RNA",
    "UBXN6 Proteo"
  ],
  "OR4K6P": [
    "OR4K6P CNV",
    "OR4K6P RNA"
  ],
  "BID": [
    "BID CNV",
    "BID RNA",
    "BID Proteo"
  ],
  "SELENOO": [
    "SELENOO CNV",
    "SELENOO RNA",
    "SELENOO Proteo"
  ],
  "ISCUP1": [
    "ISCUP1 CNV",
    "ISCUP1 RNA"
  ],
  "EIF1P4": [
    "EIF1P4 CNV",
    "EIF1P4 RNA"
  ],
  "HSP90AA1": [
    "HSP90AA1 CNV",
    "HSP90AA1 RNA",
    "HSP90AA1 Proteo"
  ],
  "YTHDF2": [
    "YTHDF2 CNV",
    "YTHDF2 RNA",
    "YTHDF2 Proteo"
  ],
  "MTND1P31": [
    "MTND1P31 CNV",
    "MTND1P31 RNA"
  ],
  "CMTM4": [
    "CMTM4 CNV",
    "CMTM4 RNA",
    "CMTM4 Proteo"
  ],
  "IGHV3-25": [
    "IGHV3-25 CNV",
    "IGHV3-25 RNA"
  ],
  "RPL7AP82": [
    "RPL7AP82 CNV",
    "RPL7AP82 RNA"
  ],
  "CNOT1": [
    "CNOT1 CNV",
    "CNOT1 RNA",
    "CNOT1 Proteo"
  ],
  "SH3GL1P3": [
    "SH3GL1P3 CNV",
    "SH3GL1P3 RNA"
  ],
  "SLC9B1P2": [
    "SLC9B1P2 CNV",
    "SLC9B1P2 RNA"
  ],
  "RASGRP1": [
    "RASGRP1 CNV",
    "RASGRP1 RNA"
  ],
  "CDK5RAP3": [
    "CDK5RAP3 CNV",
    "CDK5RAP3 RNA",
    "CDK5RAP3 Proteo"
  ],
  "THAP12P1": [
    "THAP12P1 CNV",
    "THAP12P1 RNA"
  ],
  "RNA5SP24": [
    "RNA5SP24 CNV",
    "RNA5SP24 RNA"
  ],
  "OR5H2": [
    "OR5H2 CNV",
    "OR5H2 RNA"
  ],
  "CHCHD2P6": [
    "CHCHD2P6 CNV",
    "CHCHD2P6 RNA"
  ],
  "TSPY11P": [
    "TSPY11P CNV",
    "TSPY11P RNA"
  ],
  "DIMT1": [
    "DIMT1 CNV",
    "DIMT1 RNA",
    "DIMT1 Proteo"
  ],
  "NCOA3": [
    "NCOA3 CNV",
    "NCOA3 RNA",
    "NCOA3 Proteo"
  ],
  "PCMT1": [
    "PCMT1 CNV",
    "PCMT1 RNA",
    "PCMT1 Proteo"
  ],
  "RPL7P39": [
    "RPL7P39 CNV",
    "RPL7P39 RNA"
  ],
  "SERTAD1": [
    "SERTAD1 CNV",
    "SERTAD1 RNA"
  ],
  "RAB23": [
    "RAB23 CNV",
    "RAB23 RNA",
    "RAB23 Proteo"
  ],
  "PITPNM3": [
    "PITPNM3 CNV",
    "PITPNM3 RNA"
  ],
  "ST13P3": [
    "ST13P3 CNV",
    "ST13P3 RNA"
  ],
  "SEMA3D": [
    "SEMA3D CNV",
    "SEMA3D RNA",
    "SEMA3D Proteo"
  ],
  "SUGP2": [
    "SUGP2 CNV",
    "SUGP2 RNA",
    "SUGP2 Proteo"
  ],
  "CLEC18C": [
    "CLEC18C CNV",
    "CLEC18C RNA"
  ],
  "TOB1": [
    "TOB1 CNV",
    "TOB1 RNA"
  ],
  "METTL15P1": [
    "METTL15P1 CNV",
    "METTL15P1 RNA"
  ],
  "NPM1P14": [
    "NPM1P14 CNV",
    "NPM1P14 RNA"
  ],
  "CDA": [
    "CDA CNV",
    "CDA RNA",
    "CDA Proteo"
  ],
  "PFN5P": [
    "PFN5P CNV",
    "PFN5P RNA"
  ],
  "KALRN": [
    "KALRN CNV",
    "KALRN RNA",
    "KALRN Proteo"
  ],
  "NEGR1": [
    "NEGR1 CNV",
    "NEGR1 RNA",
    "NEGR1 Proteo"
  ],
  "PPIAP54": [
    "PPIAP54 CNV",
    "PPIAP54 RNA"
  ],
  "OR51A1P": [
    "OR51A1P CNV",
    "OR51A1P RNA"
  ],
  "ADGRV1": [
    "ADGRV1 CNV",
    "ADGRV1 RNA",
    "ADGRV1 Proteo"
  ],
  "ARAFP1": [
    "ARAFP1 CNV",
    "ARAFP1 RNA"
  ],
  "PRSS30P": [
    "PRSS30P CNV",
    "PRSS30P RNA"
  ],
  "BEND3P2": [
    "BEND3P2 CNV",
    "BEND3P2 RNA"
  ],
  "ZBTB3": [
    "ZBTB3 CNV",
    "ZBTB3 RNA",
    "ZBTB3 Proteo"
  ],
  "MTCO2P17": [
    "MTCO2P17 CNV",
    "MTCO2P17 RNA"
  ],
  "AGT": [
    "AGT CNV",
    "AGT RNA",
    "AGT Proteo"
  ],
  "DUX4L14": [
    "DUX4L14 CNV",
    "DUX4L14 RNA"
  ],
  "NUP155": [
    "NUP155 CNV",
    "NUP155 RNA",
    "NUP155 Proteo"
  ],
  "INPP5D": [
    "INPP5D CNV",
    "INPP5D RNA",
    "INPP5D Proteo"
  ],
  "PDZD9": [
    "PDZD9 CNV",
    "PDZD9 RNA"
  ],
  "OR5AU1": [
    "OR5AU1 CNV",
    "OR5AU1 RNA"
  ],
  "WTIP": [
    "WTIP CNV",
    "WTIP RNA",
    "WTIP Proteo"
  ],
  "PAIP1": [
    "PAIP1 CNV",
    "PAIP1 RNA",
    "PAIP1 Proteo"
  ],
  "RPL23AP89": [
    "RPL23AP89 CNV",
    "RPL23AP89 RNA"
  ],
  "PDE8B": [
    "PDE8B CNV",
    "PDE8B RNA"
  ],
  "OR6W1P": [
    "OR6W1P CNV",
    "OR6W1P RNA"
  ],
  "CICP2": [
    "CICP2 CNV",
    "CICP2 RNA"
  ],
  "POMGNT1": [
    "POMGNT1 CNV",
    "POMGNT1 RNA",
    "POMGNT1 Proteo"
  ],
  "OR7E41P": [
    "OR7E41P CNV",
    "OR7E41P RNA"
  ],
  "S100A7P1": [
    "S100A7P1 CNV",
    "S100A7P1 RNA"
  ],
  "FAM166B": [
    "FAM166B CNV",
    "FAM166B RNA"
  ],
  "SLC25A15": [
    "SLC25A15 CNV",
    "SLC25A15 RNA",
    "SLC25A15 Proteo"
  ],
  "RND1": [
    "RND1 CNV",
    "RND1 RNA"
  ],
  "CXCR5": [
    "CXCR5 CNV",
    "CXCR5 RNA"
  ],
  "PFN1P1": [
    "PFN1P1 CNV",
    "PFN1P1 RNA"
  ],
  "SLC25A28": [
    "SLC25A28 CNV",
    "SLC25A28 RNA",
    "SLC25A28 Proteo"
  ],
  "H4C2": [
    "H4C2 CNV",
    "H4C2 RNA"
  ],
  "FMO4": [
    "FMO4 CNV",
    "FMO4 RNA",
    "FMO4 Proteo"
  ],
  "IGFBP4": [
    "IGFBP4 CNV",
    "IGFBP4 RNA",
    "IGFBP4 Proteo"
  ],
  "TMEM198B": [
    "TMEM198B CNV",
    "TMEM198B RNA"
  ],
  "SLC35G5": [
    "SLC35G5 CNV",
    "SLC35G5 RNA"
  ],
  "CYP4F59P": [
    "CYP4F59P CNV",
    "CYP4F59P RNA"
  ],
  "SMC2": [
    "SMC2 CNV",
    "SMC2 RNA",
    "SMC2 Proteo"
  ],
  "LDHAP2": [
    "LDHAP2 CNV",
    "LDHAP2 RNA"
  ],
  "ABHD14A": [
    "ABHD14A CNV",
    "ABHD14A RNA"
  ],
  "FLRT3": [
    "FLRT3 CNV",
    "FLRT3 RNA",
    "FLRT3 Proteo"
  ],
  "CSN2": [
    "CSN2 CNV",
    "CSN2 RNA"
  ],
  "ARHGEF39": [
    "ARHGEF39 CNV",
    "ARHGEF39 RNA",
    "ARHGEF39 Proteo"
  ],
  "HNRNPUL1": [
    "HNRNPUL1 CNV",
    "HNRNPUL1 RNA",
    "HNRNPUL1 Proteo"
  ],
  "ELOBP3": [
    "ELOBP3 CNV",
    "ELOBP3 RNA"
  ],
  "RPL7P6": [
    "RPL7P6 CNV",
    "RPL7P6 RNA"
  ],
  "HNRNPA1P61": [
    "HNRNPA1P61 CNV",
    "HNRNPA1P61 RNA"
  ],
  "NAT8L": [
    "NAT8L CNV",
    "NAT8L RNA",
    "NAT8L Proteo"
  ],
  "PPIAP6": [
    "PPIAP6 CNV",
    "PPIAP6 RNA"
  ],
  "CIR1P3": [
    "CIR1P3 CNV",
    "CIR1P3 RNA"
  ],
  "OTUD7A": [
    "OTUD7A CNV",
    "OTUD7A RNA"
  ],
  "SRRM1": [
    "SRRM1 CNV",
    "SRRM1 RNA",
    "SRRM1 Proteo"
  ],
  "BCAT1": [
    "BCAT1 CNV",
    "BCAT1 RNA",
    "BCAT1 Proteo"
  ],
  "ZNF782": [
    "ZNF782 CNV",
    "ZNF782 RNA"
  ],
  "DAZ3": [
    "DAZ3 CNV",
    "DAZ3 RNA"
  ],
  "UFSP1": [
    "UFSP1 CNV",
    "UFSP1 RNA",
    "UFSP1 Proteo"
  ],
  "RPL23AP11": [
    "RPL23AP11 CNV",
    "RPL23AP11 RNA"
  ],
  "OGA": [
    "OGA CNV",
    "OGA RNA",
    "OGA Proteo"
  ],
  "CCT8L2": [
    "CCT8L2 CNV",
    "CCT8L2 RNA"
  ],
  "UBE2D3P4": [
    "UBE2D3P4 CNV",
    "UBE2D3P4 RNA"
  ],
  "RHOT2": [
    "RHOT2 CNV",
    "RHOT2 RNA",
    "RHOT2 Proteo"
  ],
  "CYP4F2": [
    "CYP4F2 CNV",
    "CYP4F2 RNA"
  ],
  "TMEM14C": [
    "TMEM14C CNV",
    "TMEM14C RNA",
    "TMEM14C Proteo"
  ],
  "NFX1": [
    "NFX1 CNV",
    "NFX1 RNA",
    "NFX1 Proteo"
  ],
  "IL22": [
    "IL22 CNV",
    "IL22 RNA"
  ],
  "LST1": [
    "LST1 CNV",
    "LST1 RNA",
    "LST1 Proteo"
  ],
  "TBC1D3P3": [
    "TBC1D3P3 CNV",
    "TBC1D3P3 RNA"
  ],
  "IL12RB1": [
    "IL12RB1 CNV",
    "IL12RB1 RNA"
  ],
  "EIF3K": [
    "EIF3K CNV",
    "EIF3K RNA",
    "EIF3K Proteo"
  ],
  "MACO1": [
    "MACO1 CNV",
    "MACO1 RNA",
    "MACO1 Proteo"
  ],
  "SART1": [
    "SART1 CNV",
    "SART1 RNA",
    "SART1 Proteo"
  ],
  "ZNF280B": [
    "ZNF280B CNV",
    "ZNF280B RNA"
  ],
  "MAPK11": [
    "MAPK11 CNV",
    "MAPK11 RNA",
    "MAPK11 Proteo"
  ],
  "BUD31P1": [
    "BUD31P1 CNV",
    "BUD31P1 RNA"
  ],
  "C16orf92": [
    "C16orf92 CNV",
    "C16orf92 RNA"
  ],
  "C9orf57": [
    "C9orf57 CNV",
    "C9orf57 RNA"
  ],
  "OR2Q1P": [
    "OR2Q1P CNV",
    "OR2Q1P RNA"
  ],
  "MMP24OS": [
    "MMP24OS CNV",
    "MMP24OS RNA",
    "MMP24OS Proteo"
  ],
  "CHMP4C": [
    "CHMP4C CNV",
    "CHMP4C RNA",
    "CHMP4C Proteo"
  ],
  "ING5": [
    "ING5 CNV",
    "ING5 RNA",
    "ING5 Proteo"
  ],
  "EIF4E1B": [
    "EIF4E1B CNV",
    "EIF4E1B RNA"
  ],
  "RPS7P6": [
    "RPS7P6 CNV",
    "RPS7P6 RNA"
  ],
  "EN2": [
    "EN2 CNV",
    "EN2 RNA",
    "EN2 Proteo"
  ],
  "GATA1": [
    "GATA1 CNV",
    "GATA1 RNA"
  ],
  "TCTN1": [
    "TCTN1 CNV",
    "TCTN1 RNA",
    "TCTN1 Proteo"
  ],
  "OPRPN": [
    "OPRPN CNV",
    "OPRPN RNA"
  ],
  "FYTTD1": [
    "FYTTD1 CNV",
    "FYTTD1 RNA",
    "FYTTD1 Proteo"
  ],
  "VPS25": [
    "VPS25 CNV",
    "VPS25 RNA",
    "VPS25 Proteo"
  ],
  "NCKAP5L": [
    "NCKAP5L CNV",
    "NCKAP5L RNA",
    "NCKAP5L Proteo"
  ],
  "TCEAL6": [
    "TCEAL6 CNV",
    "TCEAL6 RNA"
  ],
  "SSR1": [
    "SSR1 CNV",
    "SSR1 RNA",
    "SSR1 Proteo"
  ],
  "PGM5P4": [
    "PGM5P4 CNV",
    "PGM5P4 RNA"
  ],
  "RABGEF1P2": [
    "RABGEF1P2 CNV",
    "RABGEF1P2 RNA"
  ],
  "GAPDHP23": [
    "GAPDHP23 CNV",
    "GAPDHP23 RNA"
  ],
  "RNF187": [
    "RNF187 CNV",
    "RNF187 RNA",
    "RNF187 Proteo"
  ],
  "ACTG1P23": [
    "ACTG1P23 CNV",
    "ACTG1P23 RNA"
  ],
  "TREHP1": [
    "TREHP1 CNV",
    "TREHP1 RNA"
  ],
  "KRT18P52": [
    "KRT18P52 CNV",
    "KRT18P52 RNA"
  ],
  "SLC5A2": [
    "SLC5A2 CNV",
    "SLC5A2 RNA"
  ],
  "FBXL20": [
    "FBXL20 CNV",
    "FBXL20 RNA",
    "FBXL20 Proteo"
  ],
  "DTX3": [
    "DTX3 CNV",
    "DTX3 RNA",
    "DTX3 Proteo"
  ],
  "SNRPD3": [
    "SNRPD3 CNV",
    "SNRPD3 RNA",
    "SNRPD3 Proteo"
  ],
  "PKIG": [
    "PKIG CNV",
    "PKIG RNA",
    "PKIG Proteo"
  ],
  "GALNT9": [
    "GALNT9 CNV",
    "GALNT9 RNA"
  ],
  "RPL6P14": [
    "RPL6P14 CNV",
    "RPL6P14 RNA"
  ],
  "EEF1GP2": [
    "EEF1GP2 CNV",
    "EEF1GP2 RNA"
  ],
  "ZNF598": [
    "ZNF598 CNV",
    "ZNF598 RNA",
    "ZNF598 Proteo"
  ],
  "TESC": [
    "TESC CNV",
    "TESC RNA",
    "TESC Proteo"
  ],
  "SKINT1L": [
    "SKINT1L CNV",
    "SKINT1L RNA"
  ],
  "GNPAT": [
    "GNPAT CNV",
    "GNPAT RNA",
    "GNPAT Proteo"
  ],
  "APAF1": [
    "APAF1 CNV",
    "APAF1 RNA",
    "APAF1 Proteo"
  ],
  "IGKV2-18": [
    "IGKV2-18 CNV",
    "IGKV2-18 RNA"
  ],
  "BAZ2A": [
    "BAZ2A CNV",
    "BAZ2A RNA",
    "BAZ2A Proteo"
  ],
  "SPIRE1": [
    "SPIRE1 CNV",
    "SPIRE1 RNA",
    "SPIRE1 Proteo"
  ],
  "AGPAT5P1": [
    "AGPAT5P1 CNV",
    "AGPAT5P1 RNA"
  ],
  "GPC5": [
    "GPC5 CNV",
    "GPC5 RNA"
  ],
  "TPMTP2": [
    "TPMTP2 CNV",
    "TPMTP2 RNA"
  ],
  "ZSCAN16": [
    "ZSCAN16 CNV",
    "ZSCAN16 RNA"
  ],
  "PMPCAP1": [
    "PMPCAP1 CNV",
    "PMPCAP1 RNA"
  ],
  "ACTG1P16": [
    "ACTG1P16 CNV",
    "ACTG1P16 RNA"
  ],
  "IRX4": [
    "IRX4 CNV",
    "IRX4 RNA"
  ],
  "RPS3AP17": [
    "RPS3AP17 CNV",
    "RPS3AP17 RNA"
  ],
  "RPL7AP9": [
    "RPL7AP9 CNV",
    "RPL7AP9 RNA"
  ],
  "RPL6P11": [
    "RPL6P11 CNV",
    "RPL6P11 RNA"
  ],
  "MALRD1": [
    "MALRD1 CNV",
    "MALRD1 RNA"
  ],
  "UBE3AP2": [
    "UBE3AP2 CNV",
    "UBE3AP2 RNA"
  ],
  "TTLL1": [
    "TTLL1 CNV",
    "TTLL1 RNA"
  ],
  "TH": [
    "TH CNV",
    "TH RNA",
    "TH Proteo"
  ],
  "ABCF2-H2BK1": [
    "ABCF2-H2BK1 Proteo"
  ],
  "NF1P3": [
    "NF1P3 CNV",
    "NF1P3 RNA"
  ],
  "ABCF2P1": [
    "ABCF2P1 CNV",
    "ABCF2P1 RNA"
  ],
  "SPDYE17": [
    "SPDYE17 CNV",
    "SPDYE17 RNA"
  ],
  "NDUFB1P1": [
    "NDUFB1P1 CNV",
    "NDUFB1P1 RNA"
  ],
  "RPS4XP20": [
    "RPS4XP20 CNV",
    "RPS4XP20 RNA"
  ],
  "MAMLD1": [
    "MAMLD1 CNV",
    "MAMLD1 RNA"
  ],
  "MRPS31P1": [
    "MRPS31P1 CNV",
    "MRPS31P1 RNA"
  ],
  "PHF3": [
    "PHF3 CNV",
    "PHF3 RNA",
    "PHF3 Proteo"
  ],
  "LRRC49": [
    "LRRC49 CNV",
    "LRRC49 RNA",
    "LRRC49 Proteo"
  ],
  "CIRBP": [
    "CIRBP CNV",
    "CIRBP RNA",
    "CIRBP Proteo"
  ],
  "MPL": [
    "MPL CNV",
    "MPL RNA"
  ],
  "SIGLEC10": [
    "SIGLEC10 CNV",
    "SIGLEC10 RNA",
    "SIGLEC10 Proteo"
  ],
  "HNRNPKP5": [
    "HNRNPKP5 CNV",
    "HNRNPKP5 RNA"
  ],
  "CEP104": [
    "CEP104 CNV",
    "CEP104 RNA",
    "CEP104 Proteo"
  ],
  "FHL3": [
    "FHL3 CNV",
    "FHL3 RNA",
    "FHL3 Proteo"
  ],
  "KCNA5": [
    "KCNA5 CNV",
    "KCNA5 RNA"
  ],
  "NAPGP1": [
    "NAPGP1 CNV",
    "NAPGP1 RNA"
  ],
  "CCDC22": [
    "CCDC22 CNV",
    "CCDC22 RNA",
    "CCDC22 Proteo"
  ],
  "REM2": [
    "REM2 CNV",
    "REM2 RNA"
  ],
  "LDHAP1": [
    "LDHAP1 CNV",
    "LDHAP1 RNA"
  ],
  "SEPTIN7P1": [
    "SEPTIN7P1 CNV",
    "SEPTIN7P1 RNA"
  ],
  "RNA5SP152": [
    "RNA5SP152 CNV",
    "RNA5SP152 RNA"
  ],
  "CYP27B1": [
    "CYP27B1 CNV",
    "CYP27B1 RNA",
    "CYP27B1 Proteo"
  ],
  "RPL34P26": [
    "RPL34P26 CNV",
    "RPL34P26 RNA"
  ],
  "TUBGCP2": [
    "TUBGCP2 CNV",
    "TUBGCP2 RNA",
    "TUBGCP2 Proteo"
  ],
  "ZNF883": [
    "ZNF883 CNV",
    "ZNF883 RNA"
  ],
  "CBLL2": [
    "CBLL2 CNV",
    "CBLL2 RNA"
  ],
  "OR4X7P": [
    "OR4X7P CNV",
    "OR4X7P RNA"
  ],
  "TLR6": [
    "TLR6 CNV",
    "TLR6 RNA",
    "TLR6 Proteo"
  ],
  "S100A12": [
    "S100A12 CNV",
    "S100A12 RNA",
    "S100A12 Proteo"
  ],
  "SERAC1": [
    "SERAC1 CNV",
    "SERAC1 RNA",
    "SERAC1 Proteo"
  ],
  "SSXP10": [
    "SSXP10 CNV",
    "SSXP10 RNA"
  ],
  "SLC20A1": [
    "SLC20A1 CNV",
    "SLC20A1 RNA",
    "SLC20A1 Proteo"
  ],
  "TM7SF2": [
    "TM7SF2 CNV",
    "TM7SF2 RNA",
    "TM7SF2 Proteo"
  ],
  "C19orf12": [
    "C19orf12 CNV",
    "C19orf12 RNA",
    "C19orf12 Proteo"
  ],
  "SCRT2": [
    "SCRT2 CNV",
    "SCRT2 RNA"
  ],
  "DEFB4A": [
    "DEFB4A CNV",
    "DEFB4A RNA"
  ],
  "DHRS4L2": [
    "DHRS4L2 CNV",
    "DHRS4L2 RNA"
  ],
  "ATP8A1": [
    "ATP8A1 CNV",
    "ATP8A1 RNA",
    "ATP8A1 Proteo"
  ],
  "FGFR3P5": [
    "FGFR3P5 CNV",
    "FGFR3P5 RNA"
  ],
  "BTBD6": [
    "BTBD6 CNV",
    "BTBD6 RNA"
  ],
  "VGLL1": [
    "VGLL1 CNV",
    "VGLL1 RNA"
  ],
  "NRP2": [
    "NRP2 CNV",
    "NRP2 RNA",
    "NRP2 Proteo"
  ],
  "KLHL33": [
    "KLHL33 CNV",
    "KLHL33 RNA"
  ],
  "GNG3": [
    "GNG3 CNV",
    "GNG3 RNA"
  ],
  "WASF3": [
    "WASF3 CNV",
    "WASF3 RNA",
    "WASF3 Proteo"
  ],
  "VASN": [
    "VASN CNV",
    "VASN RNA",
    "VASN Proteo"
  ],
  "CYP27C1": [
    "CYP27C1 CNV",
    "CYP27C1 RNA",
    "CYP27C1 Proteo"
  ],
  "TMEM115": [
    "TMEM115 CNV",
    "TMEM115 RNA",
    "TMEM115 Proteo"
  ],
  "MMEL1": [
    "MMEL1 CNV",
    "MMEL1 RNA"
  ],
  "DPY19L3": [
    "DPY19L3 CNV",
    "DPY19L3 RNA",
    "DPY19L3 Proteo"
  ],
  "RIPPLY1": [
    "RIPPLY1 CNV",
    "RIPPLY1 RNA"
  ],
  "RPS26P39": [
    "RPS26P39 CNV",
    "RPS26P39 RNA"
  ],
  "C1DP5": [
    "C1DP5 CNV",
    "C1DP5 RNA"
  ],
  "PRRX1": [
    "PRRX1 CNV",
    "PRRX1 RNA",
    "PRRX1 Proteo"
  ],
  "RNA5SP346": [
    "RNA5SP346 CNV",
    "RNA5SP346 RNA"
  ],
  "ZNF562": [
    "ZNF562 CNV",
    "ZNF562 RNA",
    "ZNF562 Proteo"
  ],
  "UBE2QL1": [
    "UBE2QL1 CNV",
    "UBE2QL1 RNA"
  ],
  "RAB32": [
    "RAB32 CNV",
    "RAB32 RNA",
    "RAB32 Proteo"
  ],
  "MTERF3": [
    "MTERF3 CNV",
    "MTERF3 RNA",
    "MTERF3 Proteo"
  ],
  "DPPA2P3": [
    "DPPA2P3 CNV",
    "DPPA2P3 RNA"
  ],
  "TAS2R7": [
    "TAS2R7 CNV",
    "TAS2R7 RNA"
  ],
  "STAT5B": [
    "STAT5B CNV",
    "STAT5B RNA",
    "STAT5B Proteo"
  ],
  "DDA1": [
    "DDA1 CNV",
    "DDA1 RNA",
    "DDA1 Proteo"
  ],
  "CFAP119": [
    "CFAP119 CNV",
    "CFAP119 RNA"
  ],
  "S100A16": [
    "S100A16 CNV",
    "S100A16 RNA",
    "S100A16 Proteo"
  ],
  "HNRNPA1P74": [
    "HNRNPA1P74 CNV",
    "HNRNPA1P74 RNA"
  ],
  "DMAC2": [
    "DMAC2 CNV",
    "DMAC2 RNA",
    "DMAC2 Proteo"
  ],
  "BIK": [
    "BIK CNV",
    "BIK RNA"
  ],
  "SHLD2P3": [
    "SHLD2P3 CNV",
    "SHLD2P3 RNA"
  ],
  "ADPRHL1": [
    "ADPRHL1 CNV",
    "ADPRHL1 RNA"
  ],
  "MRGPRX2": [
    "MRGPRX2 CNV",
    "MRGPRX2 RNA"
  ],
  "TOX4P1": [
    "TOX4P1 CNV",
    "TOX4P1 RNA"
  ],
  "POU4F1": [
    "POU4F1 CNV",
    "POU4F1 RNA"
  ],
  "DNAI1": [
    "DNAI1 CNV",
    "DNAI1 RNA"
  ],
  "C1orf112": [
    "C1orf112 CNV",
    "C1orf112 RNA",
    "C1orf112 Proteo"
  ],
  "UBA5": [
    "UBA5 CNV",
    "UBA5 RNA",
    "UBA5 Proteo"
  ],
  "FGF19": [
    "FGF19 CNV",
    "FGF19 RNA"
  ],
  "EPRS1": [
    "EPRS1 CNV",
    "EPRS1 RNA",
    "EPRS1 Proteo"
  ],
  "RNA5SP223": [
    "RNA5SP223 CNV",
    "RNA5SP223 RNA"
  ],
  "LIN52": [
    "LIN52 CNV",
    "LIN52 RNA",
    "LIN52 Proteo"
  ],
  "SPINT3": [
    "SPINT3 CNV",
    "SPINT3 RNA"
  ],
  "TAOK2": [
    "TAOK2 CNV",
    "TAOK2 RNA",
    "TAOK2 Proteo"
  ],
  "EIF3C": [
    "EIF3C CNV",
    "EIF3C RNA",
    "EIF3C Proteo"
  ],
  "WSB2": [
    "WSB2 CNV",
    "WSB2 RNA",
    "WSB2 Proteo"
  ],
  "SLC2A1": [
    "SLC2A1 CNV",
    "SLC2A1 RNA",
    "SLC2A1 Proteo"
  ],
  "F9": [
    "F9 CNV",
    "F9 RNA",
    "F9 Proteo"
  ],
  "NXT2": [
    "NXT2 CNV",
    "NXT2 RNA",
    "NXT2 Proteo"
  ],
  "NUDT7": [
    "NUDT7 CNV",
    "NUDT7 RNA",
    "NUDT7 Proteo"
  ],
  "FBXO45": [
    "FBXO45 CNV",
    "FBXO45 RNA",
    "FBXO45 Proteo"
  ],
  "KRTAP19-5": [
    "KRTAP19-5 CNV",
    "KRTAP19-5 RNA"
  ],
  "DDX19A": [
    "DDX19A CNV",
    "DDX19A RNA",
    "DDX19A Proteo"
  ],
  "PYHIN1": [
    "PYHIN1 CNV",
    "PYHIN1 RNA",
    "PYHIN1 Proteo"
  ],
  "MANEA": [
    "MANEA CNV",
    "MANEA RNA",
    "MANEA Proteo"
  ],
  "AGPS": [
    "AGPS CNV",
    "AGPS RNA",
    "AGPS Proteo"
  ],
  "BICC1": [
    "BICC1 CNV",
    "BICC1 RNA",
    "BICC1 Proteo"
  ],
  "GPRIN3": [
    "GPRIN3 CNV",
    "GPRIN3 RNA",
    "GPRIN3 Proteo"
  ],
  "CICP24": [
    "CICP24 CNV",
    "CICP24 RNA"
  ],
  "ZNF736P8Y": [
    "ZNF736P8Y CNV",
    "ZNF736P8Y RNA"
  ],
  "GPR37": [
    "GPR37 CNV",
    "GPR37 RNA",
    "GPR37 Proteo"
  ],
  "EXOSC1": [
    "EXOSC1 CNV",
    "EXOSC1 RNA",
    "EXOSC1 Proteo"
  ],
  "OR6K3": [
    "OR6K3 CNV",
    "OR6K3 RNA"
  ],
  "RPL18AP8": [
    "RPL18AP8 CNV",
    "RPL18AP8 RNA"
  ],
  "CTAG1B": [
    "CTAG1B CNV",
    "CTAG1B RNA",
    "CTAG1B Proteo"
  ],
  "KCNU1": [
    "KCNU1 CNV",
    "KCNU1 RNA"
  ],
  "KANSL1L": [
    "KANSL1L CNV",
    "KANSL1L RNA"
  ],
  "DEPTOR": [
    "DEPTOR CNV",
    "DEPTOR RNA",
    "DEPTOR Proteo"
  ],
  "HECTD2": [
    "HECTD2 CNV",
    "HECTD2 RNA",
    "HECTD2 Proteo"
  ],
  "EMSY": [
    "EMSY CNV",
    "EMSY RNA",
    "EMSY Proteo"
  ],
  "DEPP1": [
    "DEPP1 CNV",
    "DEPP1 RNA"
  ],
  "ARIH2": [
    "ARIH2 CNV",
    "ARIH2 RNA",
    "ARIH2 Proteo"
  ],
  "NACA4P": [
    "NACA4P CNV",
    "NACA4P RNA"
  ],
  "SBDS": [
    "SBDS CNV",
    "SBDS RNA",
    "SBDS Proteo"
  ],
  "PAFAH1B2": [
    "PAFAH1B2 CNV",
    "PAFAH1B2 RNA",
    "PAFAH1B2 Proteo"
  ],
  "TMEM109": [
    "TMEM109 CNV",
    "TMEM109 RNA",
    "TMEM109 Proteo"
  ],
  "GAPDHP17": [
    "GAPDHP17 CNV",
    "GAPDHP17 RNA"
  ],
  "RPL30P16": [
    "RPL30P16 CNV",
    "RPL30P16 RNA"
  ],
  "RBMY2CP": [
    "RBMY2CP CNV",
    "RBMY2CP RNA"
  ],
  "LAMP2": [
    "LAMP2 CNV",
    "LAMP2 RNA",
    "LAMP2 Proteo"
  ],
  "MTND5P28": [
    "MTND5P28 CNV",
    "MTND5P28 RNA"
  ],
  "PRAMEF27": [
    "PRAMEF27 CNV",
    "PRAMEF27 RNA"
  ],
  "VN1R25P": [
    "VN1R25P CNV",
    "VN1R25P RNA"
  ],
  "GMPPB": [
    "GMPPB CNV",
    "GMPPB RNA",
    "GMPPB Proteo"
  ],
  "OR52E4": [
    "OR52E4 CNV",
    "OR52E4 RNA"
  ],
  "SCG2": [
    "SCG2 CNV",
    "SCG2 RNA",
    "SCG2 Proteo"
  ],
  "HLA-DRB1": [
    "HLA-DRB1 CNV",
    "HLA-DRB1 RNA",
    "HLA-DRB1 Proteo"
  ],
  "H4C15": [
    "H4C15 CNV",
    "H4C15 RNA"
  ],
  "ZFAND4": [
    "ZFAND4 CNV",
    "ZFAND4 RNA"
  ],
  "COL15A1": [
    "COL15A1 CNV",
    "COL15A1 RNA",
    "COL15A1 Proteo"
  ],
  "RHBG": [
    "RHBG CNV",
    "RHBG RNA"
  ],
  "OR4C49P": [
    "OR4C49P CNV",
    "OR4C49P RNA"
  ],
  "WBP1LP8": [
    "WBP1LP8 CNV",
    "WBP1LP8 RNA"
  ],
  "FNTAP2": [
    "FNTAP2 CNV",
    "FNTAP2 RNA"
  ],
  "IGKV3-34": [
    "IGKV3-34 CNV",
    "IGKV3-34 RNA"
  ],
  "RNA5SP114": [
    "RNA5SP114 CNV",
    "RNA5SP114 RNA"
  ],
  "PROSER2": [
    "PROSER2 CNV",
    "PROSER2 RNA",
    "PROSER2 Proteo"
  ],
  "IL6": [
    "IL6 CNV",
    "IL6 RNA"
  ],
  "KRBOX4": [
    "KRBOX4 CNV",
    "KRBOX4 RNA"
  ],
  "GMNC": [
    "GMNC CNV",
    "GMNC RNA"
  ],
  "OR7G15P": [
    "OR7G15P CNV",
    "OR7G15P RNA"
  ],
  "LINGO4": [
    "LINGO4 CNV",
    "LINGO4 RNA"
  ],
  "GDNF": [
    "GDNF CNV",
    "GDNF RNA"
  ],
  "FMN2": [
    "FMN2 CNV",
    "FMN2 RNA"
  ],
  "TMEM185AP1": [
    "TMEM185AP1 CNV",
    "TMEM185AP1 RNA"
  ],
  "NEK11": [
    "NEK11 CNV",
    "NEK11 RNA",
    "NEK11 Proteo"
  ],
  "SEPTIN7P6": [
    "SEPTIN7P6 CNV",
    "SEPTIN7P6 RNA"
  ],
  "PDPK1": [
    "PDPK1 CNV",
    "PDPK1 RNA",
    "PDPK1 Proteo"
  ],
  "H2BC10": [
    "H2BC10 CNV",
    "H2BC10 RNA"
  ],
  "DNAJC2": [
    "DNAJC2 CNV",
    "DNAJC2 RNA",
    "DNAJC2 Proteo"
  ],
  "ZNF506": [
    "ZNF506 CNV",
    "ZNF506 RNA"
  ],
  "CACNA1A": [
    "CACNA1A CNV",
    "CACNA1A RNA"
  ],
  "BTF3P15": [
    "BTF3P15 CNV",
    "BTF3P15 RNA"
  ],
  "TFCP2": [
    "TFCP2 CNV",
    "TFCP2 RNA",
    "TFCP2 Proteo"
  ],
  "UPP1": [
    "UPP1 CNV",
    "UPP1 RNA",
    "UPP1 Proteo"
  ],
  "EXOC3L2": [
    "EXOC3L2 CNV",
    "EXOC3L2 RNA",
    "EXOC3L2 Proteo"
  ],
  "BLCAP": [
    "BLCAP CNV",
    "BLCAP RNA"
  ],
  "ELOVL4": [
    "ELOVL4 CNV",
    "ELOVL4 RNA",
    "ELOVL4 Proteo"
  ],
  "ITGAX": [
    "ITGAX CNV",
    "ITGAX RNA",
    "ITGAX Proteo"
  ],
  "MTCO2P7": [
    "MTCO2P7 CNV",
    "MTCO2P7 RNA"
  ],
  "VDAC3": [
    "VDAC3 CNV",
    "VDAC3 RNA",
    "VDAC3 Proteo"
  ],
  "KLRC2": [
    "KLRC2 CNV",
    "KLRC2 RNA"
  ],
  "CYP4F22": [
    "CYP4F22 CNV",
    "CYP4F22 RNA",
    "CYP4F22 Proteo"
  ],
  "ATP9B": [
    "ATP9B CNV",
    "ATP9B RNA",
    "ATP9B Proteo"
  ],
  "SEC24C": [
    "SEC24C CNV",
    "SEC24C RNA",
    "SEC24C Proteo"
  ],
  "KCNH1": [
    "KCNH1 CNV",
    "KCNH1 RNA"
  ],
  "IQSEC2": [
    "IQSEC2 CNV",
    "IQSEC2 RNA",
    "IQSEC2 Proteo"
  ],
  "FAM114A1": [
    "FAM114A1 CNV",
    "FAM114A1 RNA",
    "FAM114A1 Proteo"
  ],
  "ZNF107": [
    "ZNF107 CNV",
    "ZNF107 RNA"
  ],
  "MTND5P17": [
    "MTND5P17 CNV",
    "MTND5P17 RNA"
  ],
  "MRPS35P2": [
    "MRPS35P2 CNV",
    "MRPS35P2 RNA"
  ],
  "SEMA6C": [
    "SEMA6C CNV",
    "SEMA6C RNA"
  ],
  "HMGCR": [
    "HMGCR CNV",
    "HMGCR RNA",
    "HMGCR Proteo"
  ],
  "EDDM3CP": [
    "EDDM3CP CNV",
    "EDDM3CP RNA"
  ],
  "MYRIP": [
    "MYRIP CNV",
    "MYRIP RNA"
  ],
  "ERCC6L2": [
    "ERCC6L2 CNV",
    "ERCC6L2 RNA",
    "ERCC6L2 Proteo"
  ],
  "OR2T6": [
    "OR2T6 CNV",
    "OR2T6 RNA"
  ],
  "SLC25A34": [
    "SLC25A34 CNV",
    "SLC25A34 RNA"
  ],
  "OR5G4P": [
    "OR5G4P CNV",
    "OR5G4P RNA"
  ],
  "GRAMD2B": [
    "GRAMD2B CNV",
    "GRAMD2B RNA",
    "GRAMD2B Proteo"
  ],
  "RNA5SP439": [
    "RNA5SP439 CNV",
    "RNA5SP439 RNA"
  ],
  "CYP4F11": [
    "CYP4F11 CNV",
    "CYP4F11 RNA",
    "CYP4F11 Proteo"
  ],
  "PPIAP82": [
    "PPIAP82 CNV",
    "PPIAP82 RNA"
  ],
  "COL26A1": [
    "COL26A1 CNV",
    "COL26A1 RNA"
  ],
  "SSU72P6": [
    "SSU72P6 CNV",
    "SSU72P6 RNA"
  ],
  "ACER3": [
    "ACER3 CNV",
    "ACER3 RNA"
  ],
  "CDC42EP3P1": [
    "CDC42EP3P1 CNV",
    "CDC42EP3P1 RNA"
  ],
  "SRCAP": [
    "SRCAP CNV",
    "SRCAP RNA",
    "SRCAP Proteo"
  ],
  "SOX3": [
    "SOX3 CNV",
    "SOX3 RNA"
  ],
  "MEX3D": [
    "MEX3D CNV",
    "MEX3D RNA",
    "MEX3D Proteo"
  ],
  "SOD3": [
    "SOD3 CNV",
    "SOD3 RNA",
    "SOD3 Proteo"
  ],
  "DERL2": [
    "DERL2 CNV",
    "DERL2 RNA",
    "DERL2 Proteo"
  ],
  "USP12": [
    "USP12 CNV",
    "USP12 RNA",
    "USP12 Proteo"
  ],
  "AGGF1P7": [
    "AGGF1P7 CNV",
    "AGGF1P7 RNA"
  ],
  "SPATA9": [
    "SPATA9 CNV",
    "SPATA9 RNA"
  ],
  "VPREB1": [
    "VPREB1 CNV",
    "VPREB1 RNA"
  ],
  "NT5DC3": [
    "NT5DC3 CNV",
    "NT5DC3 RNA",
    "NT5DC3 Proteo"
  ],
  "IGKV1-27": [
    "IGKV1-27 Proteo"
  ],
  "SCNN1D": [
    "SCNN1D CNV",
    "SCNN1D RNA"
  ],
  "CDC20B": [
    "CDC20B CNV",
    "CDC20B RNA"
  ],
  "IL17C": [
    "IL17C CNV",
    "IL17C RNA"
  ],
  "POFUT1": [
    "POFUT1 CNV",
    "POFUT1 RNA",
    "POFUT1 Proteo"
  ],
  "FMO3": [
    "FMO3 CNV",
    "FMO3 RNA",
    "FMO3 Proteo"
  ],
  "GAB2": [
    "GAB2 CNV",
    "GAB2 RNA",
    "GAB2 Proteo"
  ],
  "RPS12P24": [
    "RPS12P24 CNV",
    "RPS12P24 RNA"
  ],
  "OR5BN1P": [
    "OR5BN1P CNV",
    "OR5BN1P RNA"
  ],
  "CPEB1": [
    "CPEB1 CNV",
    "CPEB1 RNA"
  ],
  "GFRA3": [
    "GFRA3 CNV",
    "GFRA3 RNA",
    "GFRA3 Proteo"
  ],
  "KCTD21": [
    "KCTD21 CNV",
    "KCTD21 RNA",
    "KCTD21 Proteo"
  ],
  "CDY12P": [
    "CDY12P CNV",
    "CDY12P RNA"
  ],
  "OR2T1": [
    "OR2T1 CNV",
    "OR2T1 RNA"
  ],
  "MTCL1P1": [
    "MTCL1P1 CNV",
    "MTCL1P1 RNA"
  ],
  "SNRPD2": [
    "SNRPD2 CNV",
    "SNRPD2 RNA",
    "SNRPD2 Proteo"
  ],
  "IGKV7-3": [
    "IGKV7-3 CNV",
    "IGKV7-3 RNA"
  ],
  "CFI": [
    "CFI CNV",
    "CFI RNA",
    "CFI Proteo"
  ],
  "PPIF": [
    "PPIF CNV",
    "PPIF RNA",
    "PPIF Proteo"
  ],
  "TRIM49C": [
    "TRIM49C CNV",
    "TRIM49C RNA"
  ],
  "PMCHL2": [
    "PMCHL2 CNV",
    "PMCHL2 RNA"
  ],
  "AIF1L": [
    "AIF1L CNV",
    "AIF1L RNA",
    "AIF1L Proteo"
  ],
  "OR10P1": [
    "OR10P1 CNV",
    "OR10P1 RNA"
  ],
  "CORO2B": [
    "CORO2B CNV",
    "CORO2B RNA",
    "CORO2B Proteo"
  ],
  "SNX18P26": [
    "SNX18P26 CNV",
    "SNX18P26 RNA"
  ],
  "PPP1R36": [
    "PPP1R36 CNV",
    "PPP1R36 RNA"
  ],
  "ELOCP6": [
    "ELOCP6 CNV",
    "ELOCP6 RNA"
  ],
  "PAK2": [
    "PAK2 CNV",
    "PAK2 RNA",
    "PAK2 Proteo"
  ],
  "CCDC179": [
    "CCDC179 CNV",
    "CCDC179 RNA"
  ],
  "TCN2": [
    "TCN2 CNV",
    "TCN2 RNA",
    "TCN2 Proteo"
  ],
  "RNA5SP116": [
    "RNA5SP116 CNV",
    "RNA5SP116 RNA"
  ],
  "SCOC": [
    "SCOC CNV",
    "SCOC RNA",
    "SCOC Proteo"
  ],
  "SLC16A10": [
    "SLC16A10 CNV",
    "SLC16A10 RNA"
  ],
  "PCID2": [
    "PCID2 CNV",
    "PCID2 RNA",
    "PCID2 Proteo"
  ],
  "NDUFA5P11": [
    "NDUFA5P11 CNV",
    "NDUFA5P11 RNA"
  ],
  "C4orf45": [
    "C4orf45 CNV",
    "C4orf45 RNA"
  ],
  "EIF3E": [
    "EIF3E CNV",
    "EIF3E RNA",
    "EIF3E Proteo"
  ],
  "PHF24": [
    "PHF24 CNV",
    "PHF24 RNA",
    "PHF24 Proteo"
  ],
  "GNL3": [
    "GNL3 CNV",
    "GNL3 RNA",
    "GNL3 Proteo"
  ],
  "RBMXL1": [
    "RBMXL1 CNV",
    "RBMXL1 RNA",
    "RBMXL1 Proteo"
  ],
  "FNDC8": [
    "FNDC8 CNV",
    "FNDC8 RNA"
  ],
  "MKRN9P": [
    "MKRN9P CNV",
    "MKRN9P RNA"
  ],
  "EIF2B3": [
    "EIF2B3 CNV",
    "EIF2B3 RNA",
    "EIF2B3 Proteo"
  ],
  "POLR2E": [
    "POLR2E CNV",
    "POLR2E RNA",
    "POLR2E Proteo"
  ],
  "KRT18P6": [
    "KRT18P6 CNV",
    "KRT18P6 RNA"
  ],
  "RRAS": [
    "RRAS CNV",
    "RRAS RNA",
    "RRAS Proteo"
  ],
  "SLCO1C1": [
    "SLCO1C1 CNV",
    "SLCO1C1 RNA"
  ],
  "LRRC1": [
    "LRRC1 CNV",
    "LRRC1 RNA",
    "LRRC1 Proteo"
  ],
  "PEDS1": [
    "PEDS1 CNV",
    "PEDS1 RNA",
    "PEDS1 Proteo"
  ],
  "ABCB6": [
    "ABCB6 CNV",
    "ABCB6 RNA",
    "ABCB6 Proteo"
  ],
  "TMPRSS11A": [
    "TMPRSS11A CNV",
    "TMPRSS11A RNA"
  ],
  "TOX": [
    "TOX CNV",
    "TOX RNA",
    "TOX Proteo"
  ],
  "FRG2": [
    "FRG2 CNV",
    "FRG2 RNA"
  ],
  "NOX1": [
    "NOX1 CNV",
    "NOX1 RNA"
  ],
  "RPL32P31": [
    "RPL32P31 CNV",
    "RPL32P31 RNA"
  ],
  "OR5AM1P": [
    "OR5AM1P CNV",
    "OR5AM1P RNA"
  ],
  "DYNLT3P2": [
    "DYNLT3P2 CNV",
    "DYNLT3P2 RNA"
  ],
  "MCCD1": [
    "MCCD1 CNV",
    "MCCD1 RNA"
  ],
  "PUM1": [
    "PUM1 CNV",
    "PUM1 RNA",
    "PUM1 Proteo"
  ],
  "UBA52P6": [
    "UBA52P6 CNV",
    "UBA52P6 RNA"
  ],
  "RNF2P1": [
    "RNF2P1 CNV",
    "RNF2P1 RNA"
  ],
  "BCRP5": [
    "BCRP5 CNV",
    "BCRP5 RNA"
  ],
  "SULT6B2P": [
    "SULT6B2P CNV",
    "SULT6B2P RNA"
  ],
  "RAB11FIP1P1": [
    "RAB11FIP1P1 CNV",
    "RAB11FIP1P1 RNA"
  ],
  "KRBA1": [
    "KRBA1 CNV",
    "KRBA1 RNA",
    "KRBA1 Proteo"
  ],
  "C1QTNF3": [
    "C1QTNF3 CNV",
    "C1QTNF3 RNA",
    "C1QTNF3 Proteo"
  ],
  "NDUFB11P1": [
    "NDUFB11P1 CNV",
    "NDUFB11P1 RNA"
  ],
  "LCN12": [
    "LCN12 CNV",
    "LCN12 RNA"
  ],
  "CPNE9": [
    "CPNE9 CNV",
    "CPNE9 RNA"
  ],
  "RGS16": [
    "RGS16 CNV",
    "RGS16 RNA"
  ],
  "C8G": [
    "C8G CNV",
    "C8G RNA",
    "C8G Proteo"
  ],
  "OR4A9P": [
    "OR4A9P CNV",
    "OR4A9P RNA"
  ],
  "UNC93B7": [
    "UNC93B7 CNV",
    "UNC93B7 RNA"
  ],
  "RECQL4": [
    "RECQL4 CNV",
    "RECQL4 RNA",
    "RECQL4 Proteo"
  ],
  "PEA15": [
    "PEA15 CNV",
    "PEA15 RNA",
    "PEA15 Proteo"
  ],
  "SETD1A": [
    "SETD1A CNV",
    "SETD1A RNA",
    "SETD1A Proteo"
  ],
  "MGAT3": [
    "MGAT3 CNV",
    "MGAT3 RNA",
    "MGAT3 Proteo"
  ],
  "BORCS7-ASMT": [
    "BORCS7-ASMT Proteo"
  ],
  "WEE2": [
    "WEE2 CNV",
    "WEE2 RNA"
  ],
  "STK25P1": [
    "STK25P1 CNV",
    "STK25P1 RNA"
  ],
  "MAGEA7P": [
    "MAGEA7P CNV",
    "MAGEA7P RNA"
  ],
  "SSTR2": [
    "SSTR2 CNV",
    "SSTR2 RNA"
  ],
  "UBN2": [
    "UBN2 CNV",
    "UBN2 RNA",
    "UBN2 Proteo"
  ],
  "CDHR4": [
    "CDHR4 CNV",
    "CDHR4 RNA"
  ],
  "AMZ2P1": [
    "AMZ2P1 CNV",
    "AMZ2P1 RNA"
  ],
  "NOL7": [
    "NOL7 CNV",
    "NOL7 RNA",
    "NOL7 Proteo"
  ],
  "CES1P1": [
    "CES1P1 CNV",
    "CES1P1 RNA"
  ],
  "EEF1A1P8": [
    "EEF1A1P8 CNV",
    "EEF1A1P8 RNA"
  ],
  "TPM3P1": [
    "TPM3P1 CNV",
    "TPM3P1 RNA"
  ],
  "RBMY1HP": [
    "RBMY1HP CNV",
    "RBMY1HP RNA"
  ],
  "FAM32EP": [
    "FAM32EP CNV",
    "FAM32EP RNA"
  ],
  "CREB3L2": [
    "CREB3L2 CNV",
    "CREB3L2 RNA",
    "CREB3L2 Proteo"
  ],
  "ATP5MC2": [
    "ATP5MC2 CNV",
    "ATP5MC2 RNA"
  ],
  "MYBPHL": [
    "MYBPHL CNV",
    "MYBPHL RNA"
  ],
  "RPSAP10": [
    "RPSAP10 CNV",
    "RPSAP10 RNA"
  ],
  "ELOBP2": [
    "ELOBP2 CNV",
    "ELOBP2 RNA"
  ],
  "AMER2": [
    "AMER2 CNV",
    "AMER2 RNA"
  ],
  "TAF1A": [
    "TAF1A CNV",
    "TAF1A RNA",
    "TAF1A Proteo"
  ],
  "GEMIN6": [
    "GEMIN6 CNV",
    "GEMIN6 RNA",
    "GEMIN6 Proteo"
  ],
  "FAM216B": [
    "FAM216B CNV",
    "FAM216B RNA"
  ],
  "TRMT9B": [
    "TRMT9B CNV",
    "TRMT9B RNA"
  ],
  "P3H2": [
    "P3H2 CNV",
    "P3H2 RNA",
    "P3H2 Proteo"
  ],
  "RBMS2": [
    "RBMS2 CNV",
    "RBMS2 RNA",
    "RBMS2 Proteo"
  ],
  "NDUFB10": [
    "NDUFB10 CNV",
    "NDUFB10 RNA",
    "NDUFB10 Proteo"
  ],
  "PAOX": [
    "PAOX CNV",
    "PAOX RNA",
    "PAOX Proteo"
  ],
  "ODF1": [
    "ODF1 CNV",
    "ODF1 RNA"
  ],
  "ELL2P3": [
    "ELL2P3 CNV",
    "ELL2P3 RNA"
  ],
  "RPL21P34": [
    "RPL21P34 CNV",
    "RPL21P34 RNA"
  ],
  "SLC35B2": [
    "SLC35B2 CNV",
    "SLC35B2 RNA",
    "SLC35B2 Proteo"
  ],
  "SMIM10": [
    "SMIM10 CNV",
    "SMIM10 RNA",
    "SMIM10 Proteo"
  ],
  "CHIAP3": [
    "CHIAP3 CNV",
    "CHIAP3 RNA"
  ],
  "MYO1E": [
    "MYO1E CNV",
    "MYO1E RNA",
    "MYO1E Proteo"
  ],
  "ERCC5": [
    "ERCC5 CNV",
    "ERCC5 RNA",
    "ERCC5 Proteo"
  ],
  "DEFB130C": [
    "DEFB130C CNV",
    "DEFB130C RNA"
  ],
  "CYCSP6": [
    "CYCSP6 CNV",
    "CYCSP6 RNA"
  ],
  "TRIB1": [
    "TRIB1 CNV",
    "TRIB1 RNA",
    "TRIB1 Proteo"
  ],
  "WFIKKN2": [
    "WFIKKN2 CNV",
    "WFIKKN2 RNA"
  ],
  "FBXO34": [
    "FBXO34 CNV",
    "FBXO34 RNA",
    "FBXO34 Proteo"
  ],
  "NDUFA5P8": [
    "NDUFA5P8 CNV",
    "NDUFA5P8 RNA"
  ],
  "FAM3A": [
    "FAM3A CNV",
    "FAM3A RNA",
    "FAM3A Proteo"
  ],
  "PTGDS": [
    "PTGDS CNV",
    "PTGDS RNA",
    "PTGDS Proteo"
  ],
  "OR5AC4P": [
    "OR5AC4P CNV",
    "OR5AC4P RNA"
  ],
  "CXCL11": [
    "CXCL11 CNV",
    "CXCL11 RNA"
  ],
  "CLEC4OP": [
    "CLEC4OP CNV",
    "CLEC4OP RNA"
  ],
  "PABIR2": [
    "PABIR2 CNV",
    "PABIR2 RNA",
    "PABIR2 Proteo"
  ],
  "KCNK18": [
    "KCNK18 CNV",
    "KCNK18 RNA"
  ],
  "SUMF1": [
    "SUMF1 CNV",
    "SUMF1 RNA",
    "SUMF1 Proteo"
  ],
  "SLC28A2": [
    "SLC28A2 CNV",
    "SLC28A2 RNA"
  ],
  "PLAC9": [
    "PLAC9 CNV",
    "PLAC9 RNA",
    "PLAC9 Proteo"
  ],
  "AOC1": [
    "AOC1 CNV",
    "AOC1 RNA",
    "AOC1 Proteo"
  ],
  "CELF1": [
    "CELF1 CNV",
    "CELF1 RNA",
    "CELF1 Proteo"
  ],
  "RAB28P3": [
    "RAB28P3 CNV",
    "RAB28P3 RNA"
  ],
  "H2BP3": [
    "H2BP3 CNV",
    "H2BP3 RNA"
  ],
  "MAP3K10": [
    "MAP3K10 CNV",
    "MAP3K10 RNA"
  ],
  "RPL17P43": [
    "RPL17P43 CNV",
    "RPL17P43 RNA"
  ],
  "NDOR1": [
    "NDOR1 CNV",
    "NDOR1 RNA",
    "NDOR1 Proteo"
  ],
  "MIF4GD": [
    "MIF4GD CNV",
    "MIF4GD RNA",
    "MIF4GD Proteo"
  ],
  "ASCC1": [
    "ASCC1 CNV",
    "ASCC1 RNA",
    "ASCC1 Proteo"
  ],
  "TMEM63B": [
    "TMEM63B CNV",
    "TMEM63B RNA",
    "TMEM63B Proteo"
  ],
  "DNAJC8": [
    "DNAJC8 CNV",
    "DNAJC8 RNA",
    "DNAJC8 Proteo"
  ],
  "SEPTIN11": [
    "SEPTIN11 CNV",
    "SEPTIN11 RNA",
    "SEPTIN11 Proteo"
  ],
  "SRRM3": [
    "SRRM3 CNV",
    "SRRM3 RNA"
  ],
  "PARP1P1": [
    "PARP1P1 CNV",
    "PARP1P1 RNA"
  ],
  "TECTB": [
    "TECTB CNV",
    "TECTB RNA"
  ],
  "HNRNPA1P45": [
    "HNRNPA1P45 CNV",
    "HNRNPA1P45 RNA"
  ],
  "SYAP1": [
    "SYAP1 CNV",
    "SYAP1 RNA",
    "SYAP1 Proteo"
  ],
  "PDLIM4": [
    "PDLIM4 CNV",
    "PDLIM4 RNA",
    "PDLIM4 Proteo"
  ],
  "UTS2R": [
    "UTS2R CNV",
    "UTS2R RNA"
  ],
  "LCP2": [
    "LCP2 CNV",
    "LCP2 RNA",
    "LCP2 Proteo"
  ],
  "USP17L22": [
    "USP17L22 CNV",
    "USP17L22 RNA"
  ],
  "ZNF519P4": [
    "ZNF519P4 CNV",
    "ZNF519P4 RNA"
  ],
  "CILP2": [
    "CILP2 CNV",
    "CILP2 RNA",
    "CILP2 Proteo"
  ],
  "INO80": [
    "INO80 CNV",
    "INO80 RNA",
    "INO80 Proteo"
  ],
  "CCS": [
    "CCS CNV",
    "CCS RNA",
    "CCS Proteo"
  ],
  "RPS2P25": [
    "RPS2P25 CNV",
    "RPS2P25 RNA"
  ],
  "MALLP2": [
    "MALLP2 CNV",
    "MALLP2 RNA"
  ],
  "ELL2P2": [
    "ELL2P2 CNV",
    "ELL2P2 RNA"
  ],
  "MTND4LP10": [
    "MTND4LP10 CNV",
    "MTND4LP10 RNA"
  ],
  "EDDM3DP": [
    "EDDM3DP CNV",
    "EDDM3DP RNA"
  ],
  "RPS7P13": [
    "RPS7P13 CNV",
    "RPS7P13 RNA"
  ],
  "MACROH2A2": [
    "MACROH2A2 CNV",
    "MACROH2A2 RNA",
    "MACROH2A2 Proteo"
  ],
  "UBE2L6": [
    "UBE2L6 CNV",
    "UBE2L6 RNA",
    "UBE2L6 Proteo"
  ],
  "RPL23AP50": [
    "RPL23AP50 CNV",
    "RPL23AP50 RNA"
  ],
  "WFDC5": [
    "WFDC5 CNV",
    "WFDC5 RNA",
    "WFDC5 Proteo"
  ],
  "DPEP1": [
    "DPEP1 CNV",
    "DPEP1 RNA",
    "DPEP1 Proteo"
  ],
  "OR3B1P": [
    "OR3B1P CNV",
    "OR3B1P RNA"
  ],
  "EFCAB8": [
    "EFCAB8 CNV",
    "EFCAB8 RNA"
  ],
  "OTOL1": [
    "OTOL1 CNV",
    "OTOL1 RNA"
  ],
  "IGHVII-30-1": [
    "IGHVII-30-1 CNV",
    "IGHVII-30-1 RNA"
  ],
  "MESD": [
    "MESD CNV",
    "MESD RNA",
    "MESD Proteo"
  ],
  "RPL23AP90": [
    "RPL23AP90 CNV",
    "RPL23AP90 RNA"
  ],
  "NKG7": [
    "NKG7 CNV",
    "NKG7 RNA"
  ],
  "TYMSP2": [
    "TYMSP2 CNV",
    "TYMSP2 RNA"
  ],
  "HYAL1": [
    "HYAL1 CNV",
    "HYAL1 RNA"
  ],
  "EDC3": [
    "EDC3 CNV",
    "EDC3 RNA",
    "EDC3 Proteo"
  ],
  "USP6NL": [
    "USP6NL CNV",
    "USP6NL RNA",
    "USP6NL Proteo"
  ],
  "ACOT6": [
    "ACOT6 CNV",
    "ACOT6 RNA"
  ],
  "DENND3": [
    "DENND3 CNV",
    "DENND3 RNA",
    "DENND3 Proteo"
  ],
  "COX6B1P2": [
    "COX6B1P2 CNV",
    "COX6B1P2 RNA"
  ],
  "ACTBP9": [
    "ACTBP9 CNV",
    "ACTBP9 RNA"
  ],
  "ERICH4": [
    "ERICH4 CNV",
    "ERICH4 RNA"
  ],
  "DDX18P1": [
    "DDX18P1 CNV",
    "DDX18P1 RNA"
  ],
  "NDUFA5P1": [
    "NDUFA5P1 CNV",
    "NDUFA5P1 RNA"
  ],
  "CBX3P6": [
    "CBX3P6 CNV",
    "CBX3P6 RNA"
  ],
  "GABRE": [
    "GABRE CNV",
    "GABRE RNA"
  ],
  "RAI14": [
    "RAI14 CNV",
    "RAI14 RNA",
    "RAI14 Proteo"
  ],
  "ZNF185": [
    "ZNF185 CNV",
    "ZNF185 RNA",
    "ZNF185 Proteo"
  ],
  "HNRNPLP2": [
    "HNRNPLP2 CNV",
    "HNRNPLP2 RNA"
  ],
  "LINC01667": [
    "LINC01667 CNV",
    "LINC01667 RNA"
  ],
  "LMOD1": [
    "LMOD1 CNV",
    "LMOD1 RNA",
    "LMOD1 Proteo"
  ],
  "KLF5": [
    "KLF5 CNV",
    "KLF5 RNA"
  ],
  "TMC3": [
    "TMC3 CNV",
    "TMC3 RNA"
  ],
  "PPIL1": [
    "PPIL1 CNV",
    "PPIL1 RNA",
    "PPIL1 Proteo"
  ],
  "RPS8P10": [
    "RPS8P10 CNV",
    "RPS8P10 RNA"
  ],
  "HSP90AA2P": [
    "HSP90AA2P CNV",
    "HSP90AA2P RNA"
  ],
  "RFPL4AP1": [
    "RFPL4AP1 CNV",
    "RFPL4AP1 RNA"
  ],
  "NCAN": [
    "NCAN CNV",
    "NCAN RNA"
  ],
  "RPS29P27": [
    "RPS29P27 CNV",
    "RPS29P27 RNA"
  ],
  "RPL7P60": [
    "RPL7P60 CNV",
    "RPL7P60 RNA"
  ],
  "TSR1": [
    "TSR1 CNV",
    "TSR1 RNA",
    "TSR1 Proteo"
  ],
  "PPM1N": [
    "PPM1N CNV",
    "PPM1N RNA",
    "PPM1N Proteo"
  ],
  "CLASRP": [
    "CLASRP CNV",
    "CLASRP RNA",
    "CLASRP Proteo"
  ],
  "TMEM45B": [
    "TMEM45B CNV",
    "TMEM45B RNA"
  ],
  "UPK3B": [
    "UPK3B CNV",
    "UPK3B RNA",
    "UPK3B Proteo"
  ],
  "ALK": [
    "ALK CNV",
    "ALK RNA"
  ],
  "COP1P1": [
    "COP1P1 CNV",
    "COP1P1 RNA"
  ],
  "TRO": [
    "TRO CNV",
    "TRO RNA",
    "TRO Proteo"
  ],
  "ADAM20": [
    "ADAM20 CNV",
    "ADAM20 RNA"
  ],
  "TCF25": [
    "TCF25 CNV",
    "TCF25 RNA",
    "TCF25 Proteo"
  ],
  "KLRF1": [
    "KLRF1 CNV",
    "KLRF1 RNA"
  ],
  "GAPDHP74": [
    "GAPDHP74 CNV",
    "GAPDHP74 RNA"
  ],
  "DNAJC25": [
    "DNAJC25 CNV",
    "DNAJC25 RNA",
    "DNAJC25 Proteo"
  ],
  "TBXA2R": [
    "TBXA2R CNV",
    "TBXA2R RNA",
    "TBXA2R Proteo"
  ],
  "MBD4": [
    "MBD4 CNV",
    "MBD4 RNA",
    "MBD4 Proteo"
  ],
  "ACAT2": [
    "ACAT2 CNV",
    "ACAT2 RNA",
    "ACAT2 Proteo"
  ],
  "NAA20": [
    "NAA20 CNV",
    "NAA20 RNA",
    "NAA20 Proteo"
  ],
  "LHCGR": [
    "LHCGR CNV",
    "LHCGR RNA"
  ],
  "RHNO1": [
    "RHNO1 CNV",
    "RHNO1 RNA"
  ],
  "CPE": [
    "CPE CNV",
    "CPE RNA",
    "CPE Proteo"
  ],
  "CABLES1": [
    "CABLES1 CNV",
    "CABLES1 RNA",
    "CABLES1 Proteo"
  ],
  "MYNN": [
    "MYNN CNV",
    "MYNN RNA",
    "MYNN Proteo"
  ],
  "IGHV3OR16-11": [
    "IGHV3OR16-11 CNV",
    "IGHV3OR16-11 RNA"
  ],
  "FAM86B2": [
    "FAM86B2 CNV",
    "FAM86B2 RNA"
  ],
  "SEC61B": [
    "SEC61B CNV",
    "SEC61B RNA",
    "SEC61B Proteo"
  ],
  "GON4L": [
    "GON4L CNV",
    "GON4L RNA",
    "GON4L Proteo"
  ],
  "GRID2": [
    "GRID2 CNV",
    "GRID2 RNA"
  ],
  "KRT18P49": [
    "KRT18P49 CNV",
    "KRT18P49 RNA"
  ],
  "ATP8B1": [
    "ATP8B1 CNV",
    "ATP8B1 RNA",
    "ATP8B1 Proteo"
  ],
  "TRIP13": [
    "TRIP13 CNV",
    "TRIP13 RNA",
    "TRIP13 Proteo"
  ],
  "AHSA2P": [
    "AHSA2P CNV",
    "AHSA2P RNA"
  ],
  "CSNK1E": [
    "CSNK1E CNV",
    "CSNK1E RNA",
    "CSNK1E Proteo"
  ],
  "YWHAZP4": [
    "YWHAZP4 CNV",
    "YWHAZP4 RNA"
  ],
  "RPL23P2": [
    "RPL23P2 CNV",
    "RPL23P2 RNA"
  ],
  "ARFGEF1": [
    "ARFGEF1 CNV",
    "ARFGEF1 RNA",
    "ARFGEF1 Proteo"
  ],
  "SPINK4": [
    "SPINK4 CNV",
    "SPINK4 RNA"
  ],
  "GTF2IP7": [
    "GTF2IP7 CNV",
    "GTF2IP7 RNA"
  ],
  "NKRF": [
    "NKRF CNV",
    "NKRF RNA",
    "NKRF Proteo"
  ],
  "ZNF30": [
    "ZNF30 CNV",
    "ZNF30 RNA"
  ],
  "TXNL4A": [
    "TXNL4A CNV",
    "TXNL4A RNA",
    "TXNL4A Proteo"
  ],
  "DECR2": [
    "DECR2 CNV",
    "DECR2 RNA",
    "DECR2 Proteo"
  ],
  "NUDT14": [
    "NUDT14 CNV",
    "NUDT14 RNA",
    "NUDT14 Proteo"
  ],
  "GLYATL2": [
    "GLYATL2 CNV",
    "GLYATL2 RNA"
  ],
  "RPS10P5": [
    "RPS10P5 CNV",
    "RPS10P5 RNA"
  ],
  "FAM197Y5": [
    "FAM197Y5 CNV",
    "FAM197Y5 RNA"
  ],
  "TMOD3": [
    "TMOD3 CNV",
    "TMOD3 RNA",
    "TMOD3 Proteo"
  ],
  "MYADML2": [
    "MYADML2 CNV",
    "MYADML2 RNA"
  ],
  "HMGB1P23": [
    "HMGB1P23 CNV",
    "HMGB1P23 RNA"
  ],
  "KRT17P2": [
    "KRT17P2 CNV",
    "KRT17P2 RNA"
  ],
  "ARID2": [
    "ARID2 CNV",
    "ARID2 RNA",
    "ARID2 Proteo"
  ],
  "MATN3": [
    "MATN3 CNV",
    "MATN3 RNA"
  ],
  "RNA5SP115": [
    "RNA5SP115 CNV",
    "RNA5SP115 RNA"
  ],
  "KRTAP19-4": [
    "KRTAP19-4 CNV",
    "KRTAP19-4 RNA"
  ],
  "SMAD4": [
    "SMAD4 CNV",
    "SMAD4 RNA",
    "SMAD4 Proteo"
  ],
  "MMP25": [
    "MMP25 CNV",
    "MMP25 RNA",
    "MMP25 Proteo"
  ],
  "C3orf62": [
    "C3orf62 CNV",
    "C3orf62 RNA"
  ],
  "SCGB1C1": [
    "SCGB1C1 CNV",
    "SCGB1C1 RNA"
  ],
  "MTCO1P19": [
    "MTCO1P19 CNV",
    "MTCO1P19 RNA"
  ],
  "LDHB": [
    "LDHB CNV",
    "LDHB RNA",
    "LDHB Proteo"
  ],
  "LHB": [
    "LHB CNV",
    "LHB RNA"
  ],
  "GSTA7P": [
    "GSTA7P CNV",
    "GSTA7P RNA"
  ],
  "TEX13A": [
    "TEX13A CNV",
    "TEX13A RNA"
  ],
  "ISG15": [
    "ISG15 CNV",
    "ISG15 RNA",
    "ISG15 Proteo"
  ],
  "ZBTB10": [
    "ZBTB10 CNV",
    "ZBTB10 RNA",
    "ZBTB10 Proteo"
  ],
  "CNRIP1": [
    "CNRIP1 CNV",
    "CNRIP1 RNA",
    "CNRIP1 Proteo"
  ],
  "ATP8B4": [
    "ATP8B4 CNV",
    "ATP8B4 RNA"
  ],
  "OR2I1P": [
    "OR2I1P CNV",
    "OR2I1P RNA"
  ],
  "TRIP12": [
    "TRIP12 CNV",
    "TRIP12 RNA",
    "TRIP12 Proteo"
  ],
  "IRF6": [
    "IRF6 CNV",
    "IRF6 RNA",
    "IRF6 Proteo"
  ],
  "CDC16": [
    "CDC16 CNV",
    "CDC16 RNA",
    "CDC16 Proteo"
  ],
  "IGHV3OR16-15": [
    "IGHV3OR16-15 CNV",
    "IGHV3OR16-15 RNA"
  ],
  "RPS2P18": [
    "RPS2P18 CNV",
    "RPS2P18 RNA"
  ],
  "KLHL18": [
    "KLHL18 CNV",
    "KLHL18 RNA",
    "KLHL18 Proteo"
  ],
  "SERBP1": [
    "SERBP1 CNV",
    "SERBP1 RNA",
    "SERBP1 Proteo"
  ],
  "MON1A": [
    "MON1A CNV",
    "MON1A RNA",
    "MON1A Proteo"
  ],
  "SLC24A1": [
    "SLC24A1 CNV",
    "SLC24A1 RNA"
  ],
  "RPL12P8": [
    "RPL12P8 CNV",
    "RPL12P8 RNA"
  ],
  "TCP1P3": [
    "TCP1P3 CNV",
    "TCP1P3 RNA"
  ],
  "MGA": [
    "MGA CNV",
    "MGA RNA",
    "MGA Proteo"
  ],
  "NPIPB14P": [
    "NPIPB14P CNV",
    "NPIPB14P RNA"
  ],
  "EEF1A1P34": [
    "EEF1A1P34 CNV",
    "EEF1A1P34 RNA"
  ],
  "EMP3": [
    "EMP3 CNV",
    "EMP3 RNA",
    "EMP3 Proteo"
  ],
  "STK40": [
    "STK40 CNV",
    "STK40 RNA"
  ],
  "MELK": [
    "MELK CNV",
    "MELK RNA",
    "MELK Proteo"
  ],
  "RPL23P11": [
    "RPL23P11 CNV",
    "RPL23P11 RNA"
  ],
  "PGAM1P2": [
    "PGAM1P2 CNV",
    "PGAM1P2 RNA"
  ],
  "DGAT2L6": [
    "DGAT2L6 CNV",
    "DGAT2L6 RNA",
    "DGAT2L6 Proteo"
  ],
  "RANP5": [
    "RANP5 CNV",
    "RANP5 RNA"
  ],
  "SUSD5": [
    "SUSD5 CNV",
    "SUSD5 RNA",
    "SUSD5 Proteo"
  ],
  "ARHGAP4": [
    "ARHGAP4 CNV",
    "ARHGAP4 RNA",
    "ARHGAP4 Proteo"
  ],
  "MYOT": [
    "MYOT CNV",
    "MYOT RNA",
    "MYOT Proteo"
  ],
  "H1-10": [
    "H1-10 CNV",
    "H1-10 RNA",
    "H1-10 Proteo"
  ],
  "SKOR2": [
    "SKOR2 CNV",
    "SKOR2 RNA"
  ],
  "CPNE8": [
    "CPNE8 CNV",
    "CPNE8 RNA",
    "CPNE8 Proteo"
  ],
  "DEFB136": [
    "DEFB136 CNV",
    "DEFB136 RNA"
  ],
  "RND2": [
    "RND2 CNV",
    "RND2 RNA"
  ],
  "PABPC1P7": [
    "PABPC1P7 CNV",
    "PABPC1P7 RNA"
  ],
  "INTS4P1": [
    "INTS4P1 CNV",
    "INTS4P1 RNA"
  ],
  "RNF13": [
    "RNF13 CNV",
    "RNF13 RNA",
    "RNF13 Proteo"
  ],
  "SLC29A1": [
    "SLC29A1 CNV",
    "SLC29A1 RNA",
    "SLC29A1 Proteo"
  ],
  "SNX18P23": [
    "SNX18P23 CNV",
    "SNX18P23 RNA"
  ],
  "MAT1A": [
    "MAT1A CNV",
    "MAT1A RNA",
    "MAT1A Proteo"
  ],
  "SLFN12": [
    "SLFN12 CNV",
    "SLFN12 RNA",
    "SLFN12 Proteo"
  ],
  "POLB": [
    "POLB CNV",
    "POLB RNA",
    "POLB Proteo"
  ],
  "TRIM68": [
    "TRIM68 CNV",
    "TRIM68 RNA",
    "TRIM68 Proteo"
  ],
  "GLYATL1": [
    "GLYATL1 CNV",
    "GLYATL1 RNA"
  ],
  "ARHGAP27": [
    "ARHGAP27 CNV",
    "ARHGAP27 RNA",
    "ARHGAP27 Proteo"
  ],
  "C2orf69P1": [
    "C2orf69P1 CNV",
    "C2orf69P1 RNA"
  ],
  "SEPTIN5": [
    "SEPTIN5 CNV",
    "SEPTIN5 RNA",
    "SEPTIN5 Proteo"
  ],
  "SRPK2": [
    "SRPK2 CNV",
    "SRPK2 RNA",
    "SRPK2 Proteo"
  ],
  "T_FH": [
    "T_FH Cell_type"
  ],
  "FAM174A": [
    "FAM174A CNV",
    "FAM174A RNA",
    "FAM174A Proteo"
  ],
  "RNA5SP481": [
    "RNA5SP481 CNV",
    "RNA5SP481 RNA"
  ],
  "IGHVIV-44-1": [
    "IGHVIV-44-1 CNV",
    "IGHVIV-44-1 RNA"
  ],
  "CCER1": [
    "CCER1 CNV",
    "CCER1 RNA"
  ],
  "BOC": [
    "BOC CNV",
    "BOC RNA"
  ],
  "HHATL": [
    "HHATL CNV",
    "HHATL RNA",
    "HHATL Proteo"
  ],
  "SLC51B": [
    "SLC51B CNV",
    "SLC51B RNA"
  ],
  "EEF1DP2": [
    "EEF1DP2 CNV",
    "EEF1DP2 RNA"
  ],
  "POM121L14P": [
    "POM121L14P CNV",
    "POM121L14P RNA"
  ],
  "MRPL22P1": [
    "MRPL22P1 CNV",
    "MRPL22P1 RNA"
  ],
  "SEPTIN14P2": [
    "SEPTIN14P2 CNV",
    "SEPTIN14P2 RNA"
  ],
  "RPSAP19": [
    "RPSAP19 CNV",
    "RPSAP19 RNA"
  ],
  "LCK": [
    "LCK CNV",
    "LCK RNA",
    "LCK Proteo"
  ],
  "CROCCP2": [
    "CROCCP2 CNV",
    "CROCCP2 RNA"
  ],
  "PDPR": [
    "PDPR CNV",
    "PDPR RNA",
    "PDPR Proteo"
  ],
  "PARD6BP1": [
    "PARD6BP1 CNV",
    "PARD6BP1 RNA"
  ],
  "OR7A10": [
    "OR7A10 CNV",
    "OR7A10 RNA"
  ],
  "FADS1": [
    "FADS1 CNV",
    "FADS1 RNA",
    "FADS1 Proteo"
  ],
  "MSLN": [
    "MSLN CNV",
    "MSLN RNA",
    "MSLN Proteo"
  ],
  "RNA5SP281": [
    "RNA5SP281 CNV",
    "RNA5SP281 RNA"
  ],
  "FAM186A": [
    "FAM186A CNV",
    "FAM186A RNA"
  ],
  "GTF2IP22": [
    "GTF2IP22 CNV",
    "GTF2IP22 RNA"
  ],
  "FCGR1BP": [
    "FCGR1BP CNV",
    "FCGR1BP RNA"
  ],
  "RNF122": [
    "RNF122 CNV",
    "RNF122 RNA"
  ],
  "GNG7": [
    "GNG7 CNV",
    "GNG7 RNA",
    "GNG7 Proteo"
  ],
  "EVA1CP1": [
    "EVA1CP1 CNV",
    "EVA1CP1 RNA"
  ],
  "OR1L3": [
    "OR1L3 CNV",
    "OR1L3 RNA"
  ],
  "DEFA5": [
    "DEFA5 CNV",
    "DEFA5 RNA"
  ],
  "FAM3C": [
    "FAM3C CNV",
    "FAM3C RNA",
    "FAM3C Proteo"
  ],
  "ACTBP2": [
    "ACTBP2 CNV",
    "ACTBP2 RNA"
  ],
  "EPHB1": [
    "EPHB1 CNV",
    "EPHB1 RNA"
  ],
  "PROCA1": [
    "PROCA1 CNV",
    "PROCA1 RNA"
  ],
  "COX6A1": [
    "COX6A1 CNV",
    "COX6A1 RNA",
    "COX6A1 Proteo"
  ],
  "SMIM36": [
    "SMIM36 CNV",
    "SMIM36 RNA"
  ],
  "OR51F4P": [
    "OR51F4P CNV",
    "OR51F4P RNA"
  ],
  "SIAE": [
    "SIAE CNV",
    "SIAE RNA",
    "SIAE Proteo"
  ],
  "ATP6V1G2": [
    "ATP6V1G2 CNV",
    "ATP6V1G2 RNA"
  ],
  "MTCO3P7": [
    "MTCO3P7 CNV",
    "MTCO3P7 RNA"
  ],
  "TMPOP2": [
    "TMPOP2 CNV",
    "TMPOP2 RNA"
  ],
  "CFAP210": [
    "CFAP210 CNV",
    "CFAP210 RNA"
  ],
  "USP39": [
    "USP39 CNV",
    "USP39 RNA",
    "USP39 Proteo"
  ],
  "GAGE2A": [
    "GAGE2A CNV",
    "GAGE2A RNA"
  ],
  "ARHGAP23P1": [
    "ARHGAP23P1 CNV",
    "ARHGAP23P1 RNA"
  ],
  "PEX12P1": [
    "PEX12P1 CNV",
    "PEX12P1 RNA"
  ],
  "C11orf1": [
    "C11orf1 CNV",
    "C11orf1 RNA"
  ],
  "STARD6": [
    "STARD6 CNV",
    "STARD6 RNA"
  ],
  "CYP4F34P": [
    "CYP4F34P CNV",
    "CYP4F34P RNA"
  ],
  "DEFB4B": [
    "DEFB4B CNV",
    "DEFB4B RNA"
  ],
  "NAPA": [
    "NAPA CNV",
    "NAPA RNA",
    "NAPA Proteo"
  ],
  "SLIRP": [
    "SLIRP CNV",
    "SLIRP RNA",
    "SLIRP Proteo"
  ],
  "CCT4P1": [
    "CCT4P1 CNV",
    "CCT4P1 RNA"
  ],
  "NIPSNAP1": [
    "NIPSNAP1 CNV",
    "NIPSNAP1 RNA",
    "NIPSNAP1 Proteo"
  ],
  "HNRNPL": [
    "HNRNPL CNV",
    "HNRNPL RNA",
    "HNRNPL Proteo"
  ],
  "JCAD": [
    "JCAD CNV",
    "JCAD RNA",
    "JCAD Proteo"
  ],
  "PARP4P3": [
    "PARP4P3 CNV",
    "PARP4P3 RNA"
  ],
  "CKAP2P1": [
    "CKAP2P1 CNV",
    "CKAP2P1 RNA"
  ],
  "RPL17P2": [
    "RPL17P2 CNV",
    "RPL17P2 RNA"
  ],
  "NBPF20": [
    "NBPF20 CNV",
    "NBPF20 RNA"
  ],
  "SEPTIN7P10": [
    "SEPTIN7P10 CNV",
    "SEPTIN7P10 RNA"
  ],
  "OR4F21": [
    "OR4F21 CNV",
    "OR4F21 RNA"
  ],
  "C16orf86": [
    "C16orf86 CNV",
    "C16orf86 RNA",
    "C16orf86 Proteo"
  ],
  "TMEM33": [
    "TMEM33 CNV",
    "TMEM33 RNA",
    "TMEM33 Proteo"
  ],
  "TMEM167A": [
    "TMEM167A CNV",
    "TMEM167A RNA",
    "TMEM167A Proteo"
  ],
  "TRPT1": [
    "TRPT1 CNV",
    "TRPT1 RNA",
    "TRPT1 Proteo"
  ],
  "EIF4G3": [
    "EIF4G3 CNV",
    "EIF4G3 RNA",
    "EIF4G3 Proteo"
  ],
  "ARL2BPP2": [
    "ARL2BPP2 CNV",
    "ARL2BPP2 RNA"
  ],
  "DEFB110": [
    "DEFB110 CNV",
    "DEFB110 RNA"
  ],
  "ZNF19": [
    "ZNF19 CNV",
    "ZNF19 RNA"
  ],
  "CBY1": [
    "CBY1 CNV",
    "CBY1 RNA",
    "CBY1 Proteo"
  ],
  "MRPS11": [
    "MRPS11 CNV",
    "MRPS11 RNA",
    "MRPS11 Proteo"
  ],
  "AHNAK2": [
    "AHNAK2 CNV",
    "AHNAK2 RNA",
    "AHNAK2 Proteo"
  ],
  "SYT1": [
    "SYT1 CNV",
    "SYT1 RNA",
    "SYT1 Proteo"
  ],
  "RPL5P18": [
    "RPL5P18 CNV",
    "RPL5P18 RNA"
  ],
  "TTLL8": [
    "TTLL8 CNV",
    "TTLL8 RNA"
  ],
  "EIF4HP1": [
    "EIF4HP1 CNV",
    "EIF4HP1 RNA"
  ],
  "ARPC5": [
    "ARPC5 CNV",
    "ARPC5 RNA",
    "ARPC5 Proteo"
  ],
  "SPATA31D3": [
    "SPATA31D3 CNV",
    "SPATA31D3 RNA"
  ],
  "HNRNPA1P59": [
    "HNRNPA1P59 CNV",
    "HNRNPA1P59 RNA"
  ],
  "PCDHGA4": [
    "PCDHGA4 CNV",
    "PCDHGA4 RNA"
  ],
  "PTPRVP": [
    "PTPRVP CNV",
    "PTPRVP RNA"
  ],
  "MRPS5P3": [
    "MRPS5P3 CNV",
    "MRPS5P3 RNA"
  ],
  "C5orf15": [
    "C5orf15 CNV",
    "C5orf15 RNA",
    "C5orf15 Proteo"
  ],
  "OR6C74": [
    "OR6C74 CNV",
    "OR6C74 RNA"
  ],
  "MRPL44": [
    "MRPL44 CNV",
    "MRPL44 RNA",
    "MRPL44 Proteo"
  ],
  "H2AC13": [
    "H2AC13 CNV",
    "H2AC13 RNA"
  ],
  "H2BC16P": [
    "H2BC16P CNV",
    "H2BC16P RNA"
  ],
  "LDHAL6EP": [
    "LDHAL6EP CNV",
    "LDHAL6EP RNA"
  ],
  "RIC8A": [
    "RIC8A CNV",
    "RIC8A RNA",
    "RIC8A Proteo"
  ],
  "MTCYBP40": [
    "MTCYBP40 CNV",
    "MTCYBP40 RNA"
  ],
  "BORCS7": [
    "BORCS7 CNV",
    "BORCS7 RNA"
  ],
  "NT5C1A": [
    "NT5C1A CNV",
    "NT5C1A RNA"
  ],
  "FMR1NB": [
    "FMR1NB CNV",
    "FMR1NB RNA"
  ],
  "DENND2D": [
    "DENND2D CNV",
    "DENND2D RNA",
    "DENND2D Proteo"
  ],
  "ADK": [
    "ADK CNV",
    "ADK RNA",
    "ADK Proteo"
  ],
  "PLEKHM3": [
    "PLEKHM3 CNV",
    "PLEKHM3 RNA",
    "PLEKHM3 Proteo"
  ],
  "RPL17P3": [
    "RPL17P3 CNV",
    "RPL17P3 RNA"
  ],
  "NSA2P7": [
    "NSA2P7 CNV",
    "NSA2P7 RNA"
  ],
  "VASH2": [
    "VASH2 CNV",
    "VASH2 RNA"
  ],
  "ZNF736P9Y": [
    "ZNF736P9Y CNV",
    "ZNF736P9Y RNA"
  ],
  "RPL23AP76": [
    "RPL23AP76 CNV",
    "RPL23AP76 RNA"
  ],
  "STXBP5L": [
    "STXBP5L CNV",
    "STXBP5L RNA",
    "STXBP5L Proteo"
  ],
  "SNRPCP17": [
    "SNRPCP17 CNV",
    "SNRPCP17 RNA"
  ],
  "VGLL4": [
    "VGLL4 CNV",
    "VGLL4 RNA",
    "VGLL4 Proteo"
  ],
  "DNAAF3": [
    "DNAAF3 CNV",
    "DNAAF3 RNA",
    "DNAAF3 Proteo"
  ],
  "PRELID3BP10": [
    "PRELID3BP10 CNV",
    "PRELID3BP10 RNA"
  ],
  "RPL21P133": [
    "RPL21P133 CNV",
    "RPL21P133 RNA"
  ],
  "RPL5P24": [
    "RPL5P24 CNV",
    "RPL5P24 RNA"
  ],
  "FAM131B": [
    "FAM131B CNV",
    "FAM131B RNA"
  ],
  "WHAMMP2": [
    "WHAMMP2 CNV",
    "WHAMMP2 RNA"
  ],
  "ERN2": [
    "ERN2 CNV",
    "ERN2 RNA"
  ],
  "RPL23AP77": [
    "RPL23AP77 CNV",
    "RPL23AP77 RNA"
  ],
  "IKBIP": [
    "IKBIP CNV",
    "IKBIP RNA",
    "IKBIP Proteo"
  ],
  "RANBP3": [
    "RANBP3 CNV",
    "RANBP3 RNA",
    "RANBP3 Proteo"
  ],
  "RPL29P33": [
    "RPL29P33 CNV",
    "RPL29P33 RNA"
  ],
  "HNRNPA1P18": [
    "HNRNPA1P18 CNV",
    "HNRNPA1P18 RNA"
  ],
  "BMERB1": [
    "BMERB1 CNV",
    "BMERB1 RNA",
    "BMERB1 Proteo"
  ],
  "AADACL4": [
    "AADACL4 CNV",
    "AADACL4 RNA"
  ],
  "RNA5SP22": [
    "RNA5SP22 CNV",
    "RNA5SP22 RNA"
  ],
  "MTND1P27": [
    "MTND1P27 CNV",
    "MTND1P27 RNA"
  ],
  "CNEP1R1P1": [
    "CNEP1R1P1 CNV",
    "CNEP1R1P1 RNA"
  ],
  "ZFX": [
    "ZFX CNV",
    "ZFX RNA",
    "ZFX Proteo"
  ],
  "TUBGCP5": [
    "TUBGCP5 CNV",
    "TUBGCP5 RNA",
    "TUBGCP5 Proteo"
  ],
  "NRBF2P4": [
    "NRBF2P4 CNV",
    "NRBF2P4 RNA"
  ],
  "RPL5P12": [
    "RPL5P12 CNV",
    "RPL5P12 RNA"
  ],
  "MAGOHB": [
    "MAGOHB CNV",
    "MAGOHB RNA",
    "MAGOHB Proteo"
  ],
  "H1-9P": [
    "H1-9P CNV",
    "H1-9P RNA"
  ],
  "SCEL": [
    "SCEL CNV",
    "SCEL RNA",
    "SCEL Proteo"
  ],
  "TMEM31": [
    "TMEM31 CNV",
    "TMEM31 RNA"
  ],
  "RPL31P7": [
    "RPL31P7 CNV",
    "RPL31P7 RNA"
  ],
  "CDC25A": [
    "CDC25A CNV",
    "CDC25A RNA"
  ],
  "SLC48A1": [
    "SLC48A1 CNV",
    "SLC48A1 RNA",
    "SLC48A1 Proteo"
  ],
  "GPSM1": [
    "GPSM1 CNV",
    "GPSM1 RNA",
    "GPSM1 Proteo"
  ],
  "NTMT2": [
    "NTMT2 CNV",
    "NTMT2 RNA"
  ],
  "SPAM1": [
    "SPAM1 CNV",
    "SPAM1 RNA"
  ],
  "SLC31A1": [
    "SLC31A1 CNV",
    "SLC31A1 RNA",
    "SLC31A1 Proteo"
  ],
  "ELP6": [
    "ELP6 CNV",
    "ELP6 RNA",
    "ELP6 Proteo"
  ],
  "C22orf31": [
    "C22orf31 CNV",
    "C22orf31 RNA"
  ],
  "C11orf65": [
    "C11orf65 CNV",
    "C11orf65 RNA"
  ],
  "CIDEA": [
    "CIDEA CNV",
    "CIDEA RNA"
  ],
  "SNX5": [
    "SNX5 CNV",
    "SNX5 RNA",
    "SNX5 Proteo"
  ],
  "ZNF341": [
    "ZNF341 CNV",
    "ZNF341 RNA"
  ],
  "RGL4": [
    "RGL4 CNV",
    "RGL4 RNA"
  ],
  "STYK1": [
    "STYK1 CNV",
    "STYK1 RNA"
  ],
  "TPRXL": [
    "TPRXL CNV",
    "TPRXL RNA"
  ],
  "YTHDF3": [
    "YTHDF3 CNV",
    "YTHDF3 RNA",
    "YTHDF3 Proteo"
  ],
  "HS3ST1": [
    "HS3ST1 CNV",
    "HS3ST1 RNA"
  ],
  "GDF7": [
    "GDF7 CNV",
    "GDF7 RNA"
  ],
  "AZGP1P2": [
    "AZGP1P2 CNV",
    "AZGP1P2 RNA"
  ],
  "GGT1": [
    "GGT1 CNV",
    "GGT1 RNA",
    "GGT1 Proteo"
  ],
  "WBP1LP2": [
    "WBP1LP2 CNV",
    "WBP1LP2 RNA"
  ],
  "IGKV1-13": [
    "IGKV1-13 CNV",
    "IGKV1-13 RNA"
  ],
  "TMEM179": [
    "TMEM179 CNV",
    "TMEM179 RNA"
  ],
  "SPANXN5": [
    "SPANXN5 CNV",
    "SPANXN5 RNA"
  ],
  "TRPC5": [
    "TRPC5 CNV",
    "TRPC5 RNA"
  ],
  "ADAD1": [
    "ADAD1 CNV",
    "ADAD1 RNA"
  ],
  "AGRN": [
    "AGRN CNV",
    "AGRN RNA",
    "AGRN Proteo"
  ],
  "PRAMEF14": [
    "PRAMEF14 CNV",
    "PRAMEF14 RNA"
  ],
  "SERPINB4": [
    "SERPINB4 CNV",
    "SERPINB4 RNA",
    "SERPINB4 Proteo"
  ],
  "NLRP3P1": [
    "NLRP3P1 CNV",
    "NLRP3P1 RNA"
  ],
  "USP9YP12": [
    "USP9YP12 CNV",
    "USP9YP12 RNA"
  ],
  "CDKN2AIPNLP1": [
    "CDKN2AIPNLP1 CNV",
    "CDKN2AIPNLP1 RNA"
  ],
  "NPRL2": [
    "NPRL2 CNV",
    "NPRL2 RNA",
    "NPRL2 Proteo"
  ],
  "PSG10P": [
    "PSG10P CNV",
    "PSG10P RNA"
  ],
  "ALG1L14P": [
    "ALG1L14P CNV",
    "ALG1L14P RNA"
  ],
  "SUMO2P6": [
    "SUMO2P6 CNV",
    "SUMO2P6 RNA"
  ],
  "OR7E2P": [
    "OR7E2P CNV",
    "OR7E2P RNA"
  ],
  "MUC6": [
    "MUC6 CNV",
    "MUC6 RNA"
  ],
  "HERC2P8": [
    "HERC2P8 CNV",
    "HERC2P8 RNA"
  ],
  "PLEKHB2": [
    "PLEKHB2 CNV",
    "PLEKHB2 RNA",
    "PLEKHB2 Proteo"
  ],
  "COX5A": [
    "COX5A CNV",
    "COX5A RNA",
    "COX5A Proteo"
  ],
  "MREG": [
    "MREG CNV",
    "MREG RNA",
    "MREG Proteo"
  ],
  "AKR1E2": [
    "AKR1E2 CNV",
    "AKR1E2 RNA"
  ],
  "C8orf74": [
    "C8orf74 CNV",
    "C8orf74 RNA"
  ],
  "OR1J1": [
    "OR1J1 CNV",
    "OR1J1 RNA"
  ],
  "RPS24P6": [
    "RPS24P6 CNV",
    "RPS24P6 RNA"
  ],
  "TLR8": [
    "TLR8 CNV",
    "TLR8 RNA",
    "TLR8 Proteo"
  ],
  "RXFP2": [
    "RXFP2 CNV",
    "RXFP2 RNA"
  ],
  "VILL": [
    "VILL CNV",
    "VILL RNA",
    "VILL Proteo"
  ],
  "HSFX1": [
    "HSFX1 CNV",
    "HSFX1 RNA"
  ],
  "MYL1": [
    "MYL1 CNV",
    "MYL1 RNA",
    "MYL1 Proteo"
  ],
  "BEST4": [
    "BEST4 CNV",
    "BEST4 RNA"
  ],
  "UGT2B29P": [
    "UGT2B29P CNV",
    "UGT2B29P RNA"
  ],
  "RSPO3": [
    "RSPO3 CNV",
    "RSPO3 RNA"
  ],
  "CYP4F30P": [
    "CYP4F30P CNV",
    "CYP4F30P RNA"
  ],
  "PTPRQ": [
    "PTPRQ CNV",
    "PTPRQ RNA"
  ],
  "RPL37P2": [
    "RPL37P2 CNV",
    "RPL37P2 RNA"
  ],
  "EIF1P5": [
    "EIF1P5 CNV",
    "EIF1P5 RNA"
  ],
  "GUCY2D": [
    "GUCY2D CNV",
    "GUCY2D RNA"
  ],
  "BTN2A1": [
    "BTN2A1 CNV",
    "BTN2A1 RNA",
    "BTN2A1 Proteo"
  ],
  "TM4SF19": [
    "TM4SF19 CNV",
    "TM4SF19 RNA"
  ],
  "KLF8P1": [
    "KLF8P1 CNV",
    "KLF8P1 RNA"
  ],
  "MTRFR": [
    "MTRFR CNV",
    "MTRFR RNA",
    "MTRFR Proteo"
  ],
  "HOOK3": [
    "HOOK3 CNV",
    "HOOK3 RNA",
    "HOOK3 Proteo"
  ],
  "TAP2": [
    "TAP2 CNV",
    "TAP2 RNA",
    "TAP2 Proteo"
  ],
  "OR7E109P": [
    "OR7E109P CNV",
    "OR7E109P RNA"
  ],
  "DCAF7": [
    "DCAF7 CNV",
    "DCAF7 RNA",
    "DCAF7 Proteo"
  ],
  "CSNK1A1": [
    "CSNK1A1 CNV",
    "CSNK1A1 RNA",
    "CSNK1A1 Proteo"
  ],
  "HAUS6P3": [
    "HAUS6P3 CNV",
    "HAUS6P3 RNA"
  ],
  "ZNF445": [
    "ZNF445 CNV",
    "ZNF445 RNA",
    "ZNF445 Proteo"
  ],
  "ANAPC1P3": [
    "ANAPC1P3 CNV",
    "ANAPC1P3 RNA"
  ],
  "HNRNPA1P37": [
    "HNRNPA1P37 CNV",
    "HNRNPA1P37 RNA"
  ],
  "YTHDC1": [
    "YTHDC1 CNV",
    "YTHDC1 RNA",
    "YTHDC1 Proteo"
  ],
  "OR7E55P": [
    "OR7E55P CNV",
    "OR7E55P RNA"
  ],
  "FAM219B": [
    "FAM219B CNV",
    "FAM219B RNA",
    "FAM219B Proteo"
  ],
  "ACBD4": [
    "ACBD4 CNV",
    "ACBD4 RNA",
    "ACBD4 Proteo"
  ],
  "CYFIP1": [
    "CYFIP1 CNV",
    "CYFIP1 RNA",
    "CYFIP1 Proteo"
  ],
  "RPS15AP17": [
    "RPS15AP17 CNV",
    "RPS15AP17 RNA"
  ],
  "KRT18P14": [
    "KRT18P14 CNV",
    "KRT18P14 RNA"
  ],
  "PVRIG": [
    "PVRIG CNV",
    "PVRIG RNA"
  ],
  "IGHVIII-13-1": [
    "IGHVIII-13-1 CNV",
    "IGHVIII-13-1 RNA"
  ],
  "UNC13B": [
    "UNC13B CNV",
    "UNC13B RNA",
    "UNC13B Proteo"
  ],
  "DLGAP5P2": [
    "DLGAP5P2 CNV",
    "DLGAP5P2 RNA"
  ],
  "SRSF9": [
    "SRSF9 CNV",
    "SRSF9 RNA",
    "SRSF9 Proteo"
  ],
  "COL5A3": [
    "COL5A3 CNV",
    "COL5A3 RNA",
    "COL5A3 Proteo"
  ],
  "MARCKS": [
    "MARCKS CNV",
    "MARCKS RNA",
    "MARCKS Proteo"
  ],
  "PLA2G2D": [
    "PLA2G2D CNV",
    "PLA2G2D RNA"
  ],
  "RPL19P4": [
    "RPL19P4 CNV",
    "RPL19P4 RNA"
  ],
  "AGAP5": [
    "AGAP5 CNV",
    "AGAP5 RNA"
  ],
  "VKORC1P1": [
    "VKORC1P1 CNV",
    "VKORC1P1 RNA"
  ],
  "MRPS36P3": [
    "MRPS36P3 CNV",
    "MRPS36P3 RNA"
  ],
  "BCL6B": [
    "BCL6B CNV",
    "BCL6B RNA"
  ],
  "OR2U1P": [
    "OR2U1P CNV",
    "OR2U1P RNA"
  ],
  "RNA5SP326": [
    "RNA5SP326 CNV",
    "RNA5SP326 RNA"
  ],
  "PCDHA8": [
    "PCDHA8 CNV",
    "PCDHA8 RNA"
  ],
  "ARHGEF35": [
    "ARHGEF35 CNV",
    "ARHGEF35 RNA",
    "ARHGEF35 Proteo"
  ],
  "IL2": [
    "IL2 CNV",
    "IL2 RNA"
  ],
  "GPR35": [
    "GPR35 CNV",
    "GPR35 RNA"
  ],
  "YWHAZP7": [
    "YWHAZP7 CNV",
    "YWHAZP7 RNA"
  ],
  "VN2R1P": [
    "VN2R1P CNV",
    "VN2R1P RNA"
  ],
  "IQCA1L": [
    "IQCA1L CNV",
    "IQCA1L RNA",
    "IQCA1L Proteo"
  ],
  "HLA-A": [
    "HLA-A CNV",
    "HLA-A RNA",
    "HLA-A Proteo"
  ],
  "ZNF611": [
    "ZNF611 CNV",
    "ZNF611 RNA"
  ],
  "ARMCX4": [
    "ARMCX4 CNV",
    "ARMCX4 RNA",
    "ARMCX4 Proteo"
  ],
  "CALU": [
    "CALU CNV",
    "CALU RNA",
    "CALU Proteo"
  ],
  "LONP2": [
    "LONP2 CNV",
    "LONP2 RNA",
    "LONP2 Proteo"
  ],
  "ZNF804A": [
    "ZNF804A CNV",
    "ZNF804A RNA"
  ],
  "GLUD1P4": [
    "GLUD1P4 CNV",
    "GLUD1P4 RNA"
  ],
  "DUX4L16": [
    "DUX4L16 CNV",
    "DUX4L16 RNA"
  ],
  "CBX3P1": [
    "CBX3P1 CNV",
    "CBX3P1 RNA"
  ],
  "THRSP": [
    "THRSP CNV",
    "THRSP RNA"
  ],
  "SENP3": [
    "SENP3 CNV",
    "SENP3 RNA",
    "SENP3 Proteo"
  ],
  "IMPACT": [
    "IMPACT CNV",
    "IMPACT RNA",
    "IMPACT Proteo"
  ],
  "MTIF2": [
    "MTIF2 CNV",
    "MTIF2 RNA",
    "MTIF2 Proteo"
  ],
  "RPS26P56": [
    "RPS26P56 CNV",
    "RPS26P56 RNA"
  ],
  "RPL32P19": [
    "RPL32P19 CNV",
    "RPL32P19 RNA"
  ],
  "RORA": [
    "RORA CNV",
    "RORA RNA"
  ],
  "LHX9": [
    "LHX9 CNV",
    "LHX9 RNA"
  ],
  "ZC3H12C": [
    "ZC3H12C CNV",
    "ZC3H12C RNA",
    "ZC3H12C Proteo"
  ],
  "IGHV3-69-1": [
    "IGHV3-69-1 CNV",
    "IGHV3-69-1 RNA"
  ],
  "MTCYBP45": [
    "MTCYBP45 CNV",
    "MTCYBP45 RNA"
  ],
  "DOK1": [
    "DOK1 CNV",
    "DOK1 RNA",
    "DOK1 Proteo"
  ],
  "KLHL1": [
    "KLHL1 CNV",
    "KLHL1 RNA"
  ],
  "HMGCS1": [
    "HMGCS1 CNV",
    "HMGCS1 RNA",
    "HMGCS1 Proteo"
  ],
  "HIKESHIP3": [
    "HIKESHIP3 CNV",
    "HIKESHIP3 RNA"
  ],
  "COPE": [
    "COPE CNV",
    "COPE RNA",
    "COPE Proteo"
  ],
  "POLD3": [
    "POLD3 CNV",
    "POLD3 RNA",
    "POLD3 Proteo"
  ],
  "IL17RC": [
    "IL17RC CNV",
    "IL17RC RNA"
  ],
  "PPIHP1": [
    "PPIHP1 CNV",
    "PPIHP1 RNA"
  ],
  "NR1H5P": [
    "NR1H5P CNV",
    "NR1H5P RNA"
  ],
  "CARD6": [
    "CARD6 CNV",
    "CARD6 RNA",
    "CARD6 Proteo"
  ],
  "TMEM130": [
    "TMEM130 CNV",
    "TMEM130 RNA"
  ],
  "GIPC1": [
    "GIPC1 CNV",
    "GIPC1 RNA",
    "GIPC1 Proteo"
  ],
  "GHRHR": [
    "GHRHR CNV",
    "GHRHR RNA"
  ],
  "PPP3CB": [
    "PPP3CB CNV",
    "PPP3CB RNA",
    "PPP3CB Proteo"
  ],
  "CRIPT": [
    "CRIPT CNV",
    "CRIPT RNA",
    "CRIPT Proteo"
  ],
  "IKBKB": [
    "IKBKB CNV",
    "IKBKB RNA",
    "IKBKB Proteo"
  ],
  "GIN1": [
    "GIN1 CNV",
    "GIN1 RNA"
  ],
  "COPZ1": [
    "COPZ1 CNV",
    "COPZ1 RNA",
    "COPZ1 Proteo"
  ],
  "IGLVVI-25-1": [
    "IGLVVI-25-1 CNV",
    "IGLVVI-25-1 RNA"
  ],
  "ZNF396": [
    "ZNF396 CNV",
    "ZNF396 RNA"
  ],
  "NT5C3AP1": [
    "NT5C3AP1 CNV",
    "NT5C3AP1 RNA"
  ],
  "ASS1": [
    "ASS1 CNV",
    "ASS1 RNA",
    "ASS1 Proteo"
  ],
  "BTF3P4": [
    "BTF3P4 CNV",
    "BTF3P4 RNA"
  ],
  "BICDL2": [
    "BICDL2 CNV",
    "BICDL2 RNA",
    "BICDL2 Proteo"
  ],
  "DNAJC15": [
    "DNAJC15 CNV",
    "DNAJC15 RNA",
    "DNAJC15 Proteo"
  ],
  "GABRA4": [
    "GABRA4 CNV",
    "GABRA4 RNA"
  ],
  "DUSP12": [
    "DUSP12 CNV",
    "DUSP12 RNA",
    "DUSP12 Proteo"
  ],
  "NDUFB3": [
    "NDUFB3 CNV",
    "NDUFB3 RNA",
    "NDUFB3 Proteo"
  ],
  "CD160": [
    "CD160 CNV",
    "CD160 RNA"
  ],
  "SLAMF6P1": [
    "SLAMF6P1 CNV",
    "SLAMF6P1 RNA"
  ],
  "SLC13A5": [
    "SLC13A5 CNV",
    "SLC13A5 RNA"
  ],
  "GGT6": [
    "GGT6 CNV",
    "GGT6 RNA",
    "GGT6 Proteo"
  ],
  "KIR3DL3": [
    "KIR3DL3 CNV",
    "KIR3DL3 RNA"
  ],
  "RPS20P23": [
    "RPS20P23 CNV",
    "RPS20P23 RNA"
  ],
  "NPM1P42": [
    "NPM1P42 CNV",
    "NPM1P42 RNA"
  ],
  "CYP4A11": [
    "CYP4A11 CNV",
    "CYP4A11 RNA"
  ],
  "RPSAP9": [
    "RPSAP9 CNV",
    "RPSAP9 RNA"
  ],
  "SH3TC1": [
    "SH3TC1 CNV",
    "SH3TC1 RNA",
    "SH3TC1 Proteo"
  ],
  "OR5P3": [
    "OR5P3 CNV",
    "OR5P3 RNA"
  ],
  "RPS3AP42": [
    "RPS3AP42 CNV",
    "RPS3AP42 RNA"
  ],
  "TCEAL4": [
    "TCEAL4 CNV",
    "TCEAL4 RNA",
    "TCEAL4 Proteo"
  ],
  "IGHV3OR16-7": [
    "IGHV3OR16-7 CNV",
    "IGHV3OR16-7 RNA"
  ],
  "HAVCR1": [
    "HAVCR1 CNV",
    "HAVCR1 RNA"
  ],
  "AGAP3": [
    "AGAP3 CNV",
    "AGAP3 RNA",
    "AGAP3 Proteo"
  ],
  "DUTP8": [
    "DUTP8 CNV",
    "DUTP8 RNA"
  ],
  "TPBGL": [
    "TPBGL CNV",
    "TPBGL RNA",
    "TPBGL Proteo"
  ],
  "SMC1B": [
    "SMC1B CNV",
    "SMC1B RNA",
    "SMC1B Proteo"
  ],
  "TNFAIP3": [
    "TNFAIP3 CNV",
    "TNFAIP3 RNA",
    "TNFAIP3 Proteo"
  ],
  "PBK": [
    "PBK CNV",
    "PBK RNA",
    "PBK Proteo"
  ],
  "OR7A1P": [
    "OR7A1P CNV",
    "OR7A1P RNA"
  ],
  "PLAAT1": [
    "PLAAT1 CNV",
    "PLAAT1 RNA"
  ],
  "FLACC1": [
    "FLACC1 CNV",
    "FLACC1 RNA"
  ],
  "PRM1": [
    "PRM1 CNV",
    "PRM1 RNA"
  ],
  "ZMPSTE24": [
    "ZMPSTE24 CNV",
    "ZMPSTE24 RNA",
    "ZMPSTE24 Proteo"
  ],
  "FAM24B": [
    "FAM24B CNV",
    "FAM24B RNA"
  ],
  "UCHL1": [
    "UCHL1 CNV",
    "UCHL1 RNA",
    "UCHL1 Proteo"
  ],
  "NPM1P34": [
    "NPM1P34 CNV",
    "NPM1P34 RNA"
  ],
  "NCOA7": [
    "NCOA7 CNV",
    "NCOA7 RNA",
    "NCOA7 Proteo"
  ],
  "UBE2B": [
    "UBE2B CNV",
    "UBE2B RNA",
    "UBE2B Proteo"
  ],
  "CLIC6": [
    "CLIC6 CNV",
    "CLIC6 RNA",
    "CLIC6 Proteo"
  ],
  "TBK1": [
    "TBK1 CNV",
    "TBK1 RNA",
    "TBK1 Proteo"
  ],
  "PLGLA": [
    "PLGLA CNV",
    "PLGLA RNA"
  ],
  "DKKL1P1": [
    "DKKL1P1 CNV",
    "DKKL1P1 RNA"
  ],
  "RTCB": [
    "RTCB CNV",
    "RTCB RNA",
    "RTCB Proteo"
  ],
  "IGHG1": [
    "IGHG1 Proteo"
  ],
  "PRICKLE1": [
    "PRICKLE1 CNV",
    "PRICKLE1 RNA"
  ],
  "CHCHD2P5": [
    "CHCHD2P5 CNV",
    "CHCHD2P5 RNA"
  ],
  "IFRD2": [
    "IFRD2 CNV",
    "IFRD2 RNA",
    "IFRD2 Proteo"
  ],
  "FAHD1": [
    "FAHD1 CNV",
    "FAHD1 RNA",
    "FAHD1 Proteo"
  ],
  "ORAI2": [
    "ORAI2 CNV",
    "ORAI2 RNA",
    "ORAI2 Proteo"
  ],
  "BPIFA4P": [
    "BPIFA4P CNV",
    "BPIFA4P RNA"
  ],
  "PHF5A": [
    "PHF5A CNV",
    "PHF5A RNA",
    "PHF5A Proteo"
  ],
  "ABI1": [
    "ABI1 CNV",
    "ABI1 RNA",
    "ABI1 Proteo"
  ],
  "FOLR3": [
    "FOLR3 CNV",
    "FOLR3 RNA"
  ],
  "MTCO1P9": [
    "MTCO1P9 CNV",
    "MTCO1P9 RNA"
  ],
  "RBM34": [
    "RBM34 CNV",
    "RBM34 RNA",
    "RBM34 Proteo"
  ],
  "OLA1P2": [
    "OLA1P2 CNV",
    "OLA1P2 RNA"
  ],
  "IGLV5-45": [
    "IGLV5-45 Proteo"
  ],
  "SSU72P8": [
    "SSU72P8 CNV",
    "SSU72P8 RNA"
  ],
  "C1orf87": [
    "C1orf87 CNV",
    "C1orf87 RNA"
  ],
  "TMEM262": [
    "TMEM262 CNV",
    "TMEM262 RNA"
  ],
  "UBE2V1P8": [
    "UBE2V1P8 CNV",
    "UBE2V1P8 RNA"
  ],
  "LPIN3": [
    "LPIN3 CNV",
    "LPIN3 RNA",
    "LPIN3 Proteo"
  ],
  "TENM4": [
    "TENM4 CNV",
    "TENM4 RNA",
    "TENM4 Proteo"
  ],
  "TNFRSF8": [
    "TNFRSF8 CNV",
    "TNFRSF8 RNA"
  ],
  "CCR7": [
    "CCR7 CNV",
    "CCR7 RNA"
  ],
  "HNRNPA1P69": [
    "HNRNPA1P69 CNV",
    "HNRNPA1P69 RNA"
  ],
  "USP9YP5": [
    "USP9YP5 CNV",
    "USP9YP5 RNA"
  ],
  "SETP15": [
    "SETP15 CNV",
    "SETP15 RNA"
  ],
  "ST6GAL1": [
    "ST6GAL1 CNV",
    "ST6GAL1 RNA",
    "ST6GAL1 Proteo"
  ],
  "OAZ1P1": [
    "OAZ1P1 CNV",
    "OAZ1P1 RNA"
  ],
  "RIPK2": [
    "RIPK2 CNV",
    "RIPK2 RNA",
    "RIPK2 Proteo"
  ],
  "CAPG": [
    "CAPG CNV",
    "CAPG RNA",
    "CAPG Proteo"
  ],
  "ARL2BPP5": [
    "ARL2BPP5 CNV",
    "ARL2BPP5 RNA"
  ],
  "SLC46A3": [
    "SLC46A3 CNV",
    "SLC46A3 RNA",
    "SLC46A3 Proteo"
  ],
  "HP": [
    "HP CNV",
    "HP RNA",
    "HP Proteo"
  ],
  "ALPK3": [
    "ALPK3 CNV",
    "ALPK3 RNA"
  ],
  "ARID4B": [
    "ARID4B CNV",
    "ARID4B RNA",
    "ARID4B Proteo"
  ],
  "DAGLA": [
    "DAGLA CNV",
    "DAGLA RNA",
    "DAGLA Proteo"
  ],
  "IL17RD": [
    "IL17RD CNV",
    "IL17RD RNA",
    "IL17RD Proteo"
  ],
  "IGLV1-47": [
    "IGLV1-47 Proteo"
  ],
  "TEX21P": [
    "TEX21P CNV",
    "TEX21P RNA"
  ],
  "IGSF3P1": [
    "IGSF3P1 CNV",
    "IGSF3P1 RNA"
  ],
  "OR5H15": [
    "OR5H15 CNV",
    "OR5H15 RNA"
  ],
  "PTP4A1P6": [
    "PTP4A1P6 CNV",
    "PTP4A1P6 RNA"
  ],
  "BLNK": [
    "BLNK CNV",
    "BLNK RNA",
    "BLNK Proteo"
  ],
  "CBY1P1": [
    "CBY1P1 CNV",
    "CBY1P1 RNA"
  ],
  "ITGAM": [
    "ITGAM CNV",
    "ITGAM RNA",
    "ITGAM Proteo"
  ],
  "HS3ST4": [
    "HS3ST4 CNV",
    "HS3ST4 RNA"
  ],
  "DCAF13": [
    "DCAF13 CNV",
    "DCAF13 RNA",
    "DCAF13 Proteo"
  ],
  "GCSAML": [
    "GCSAML CNV",
    "GCSAML RNA"
  ],
  "UQCRFS1P1": [
    "UQCRFS1P1 CNV",
    "UQCRFS1P1 RNA"
  ],
  "USP6": [
    "USP6 CNV",
    "USP6 RNA"
  ],
  "RPS8P4": [
    "RPS8P4 CNV",
    "RPS8P4 RNA"
  ],
  "BNIP3P26": [
    "BNIP3P26 CNV",
    "BNIP3P26 RNA"
  ],
  "C1orf185": [
    "C1orf185 CNV",
    "C1orf185 RNA"
  ],
  "QDPR": [
    "QDPR CNV",
    "QDPR RNA",
    "QDPR Proteo"
  ],
  "SGK3": [
    "SGK3 CNV",
    "SGK3 RNA",
    "SGK3 Proteo"
  ],
  "IGBP1P1": [
    "IGBP1P1 CNV",
    "IGBP1P1 RNA"
  ],
  "SIRT4": [
    "SIRT4 CNV",
    "SIRT4 RNA"
  ],
  "MAPRE1P2": [
    "MAPRE1P2 CNV",
    "MAPRE1P2 RNA"
  ],
  "SLC25A51P3": [
    "SLC25A51P3 CNV",
    "SLC25A51P3 RNA"
  ],
  "ARHGAP26": [
    "ARHGAP26 CNV",
    "ARHGAP26 RNA",
    "ARHGAP26 Proteo"
  ],
  "RTP5": [
    "RTP5 CNV",
    "RTP5 RNA"
  ],
  "AMELX": [
    "AMELX CNV",
    "AMELX RNA"
  ],
  "WASF1": [
    "WASF1 CNV",
    "WASF1 RNA",
    "WASF1 Proteo"
  ],
  "CTAGE3P": [
    "CTAGE3P CNV",
    "CTAGE3P RNA"
  ],
  "RBMS1P1": [
    "RBMS1P1 CNV",
    "RBMS1P1 RNA"
  ],
  "GMNN": [
    "GMNN CNV",
    "GMNN RNA",
    "GMNN Proteo"
  ],
  "KRT18P65": [
    "KRT18P65 CNV",
    "KRT18P65 RNA"
  ],
  "TSC1": [
    "TSC1 CNV",
    "TSC1 RNA",
    "TSC1 Proteo"
  ],
  "NDUFS7": [
    "NDUFS7 CNV",
    "NDUFS7 RNA",
    "NDUFS7 Proteo"
  ],
  "STING1": [
    "STING1 CNV",
    "STING1 RNA",
    "STING1 Proteo"
  ],
  "OR11K1P": [
    "OR11K1P CNV",
    "OR11K1P RNA"
  ],
  "MAP1S": [
    "MAP1S CNV",
    "MAP1S RNA",
    "MAP1S Proteo"
  ],
  "CBX3P7": [
    "CBX3P7 CNV",
    "CBX3P7 RNA"
  ],
  "EID3": [
    "EID3 CNV",
    "EID3 RNA"
  ],
  "DNAH1": [
    "DNAH1 CNV",
    "DNAH1 RNA",
    "DNAH1 Proteo"
  ],
  "CSNK1G3": [
    "CSNK1G3 CNV",
    "CSNK1G3 RNA",
    "CSNK1G3 Proteo"
  ],
  "SAMD15": [
    "SAMD15 CNV",
    "SAMD15 RNA"
  ],
  "RPL21P44": [
    "RPL21P44 CNV",
    "RPL21P44 RNA"
  ],
  "SEMA7A": [
    "SEMA7A CNV",
    "SEMA7A RNA",
    "SEMA7A Proteo"
  ],
  "CALM3": [
    "CALM3 CNV",
    "CALM3 RNA",
    "CALM3 Proteo"
  ],
  "OTUD5": [
    "OTUD5 CNV",
    "OTUD5 RNA",
    "OTUD5 Proteo"
  ],
  "SMAD2": [
    "SMAD2 CNV",
    "SMAD2 RNA",
    "SMAD2 Proteo"
  ],
  "HMGB4": [
    "HMGB4 CNV",
    "HMGB4 RNA"
  ],
  "USP17L11": [
    "USP17L11 CNV",
    "USP17L11 RNA"
  ],
  "SNX1": [
    "SNX1 CNV",
    "SNX1 RNA",
    "SNX1 Proteo"
  ],
  "PSMD7": [
    "PSMD7 CNV",
    "PSMD7 RNA",
    "PSMD7 Proteo"
  ],
  "FRRS1L": [
    "FRRS1L CNV",
    "FRRS1L RNA"
  ],
  "GPHA2": [
    "GPHA2 CNV",
    "GPHA2 RNA"
  ],
  "PTPN5": [
    "PTPN5 CNV",
    "PTPN5 RNA"
  ],
  "PKD1P3": [
    "PKD1P3 CNV",
    "PKD1P3 RNA"
  ],
  "ITPRIPL2": [
    "ITPRIPL2 CNV",
    "ITPRIPL2 RNA",
    "ITPRIPL2 Proteo"
  ],
  "FITM2": [
    "FITM2 CNV",
    "FITM2 RNA",
    "FITM2 Proteo"
  ],
  "HPN": [
    "HPN CNV",
    "HPN RNA"
  ],
  "PPIAP13": [
    "PPIAP13 CNV",
    "PPIAP13 RNA"
  ],
  "EVA1CP6": [
    "EVA1CP6 CNV",
    "EVA1CP6 RNA"
  ],
  "ZNF280A": [
    "ZNF280A CNV",
    "ZNF280A RNA"
  ],
  "MTMR9": [
    "MTMR9 CNV",
    "MTMR9 RNA",
    "MTMR9 Proteo"
  ],
  "TSPY14P": [
    "TSPY14P CNV",
    "TSPY14P RNA"
  ],
  "DNAAF11P1": [
    "DNAAF11P1 CNV",
    "DNAAF11P1 RNA"
  ],
  "ACVR1B": [
    "ACVR1B CNV",
    "ACVR1B RNA",
    "ACVR1B Proteo"
  ],
  "LGSN": [
    "LGSN CNV",
    "LGSN RNA"
  ],
  "SNTB2": [
    "SNTB2 CNV",
    "SNTB2 RNA",
    "SNTB2 Proteo"
  ],
  "KIFC1": [
    "KIFC1 CNV",
    "KIFC1 RNA",
    "KIFC1 Proteo"
  ],
  "RBFOX2": [
    "RBFOX2 CNV",
    "RBFOX2 RNA",
    "RBFOX2 Proteo"
  ],
  "SLC7A5": [
    "SLC7A5 CNV",
    "SLC7A5 RNA",
    "SLC7A5 Proteo"
  ],
  "RPL7P43": [
    "RPL7P43 CNV",
    "RPL7P43 RNA"
  ],
  "RPH3A": [
    "RPH3A CNV",
    "RPH3A RNA"
  ],
  "PLA2R1": [
    "PLA2R1 CNV",
    "PLA2R1 RNA",
    "PLA2R1 Proteo"
  ],
  "CREB3": [
    "CREB3 CNV",
    "CREB3 RNA"
  ],
  "CPM": [
    "CPM CNV",
    "CPM RNA",
    "CPM Proteo"
  ],
  "SLC25A35": [
    "SLC25A35 CNV",
    "SLC25A35 RNA",
    "SLC25A35 Proteo"
  ],
  "LCP1": [
    "LCP1 CNV",
    "LCP1 RNA",
    "LCP1 Proteo"
  ],
  "DLX1": [
    "DLX1 CNV",
    "DLX1 RNA",
    "DLX1 Proteo"
  ],
  "MRPS36P1": [
    "MRPS36P1 CNV",
    "MRPS36P1 RNA"
  ],
  "FER1L5": [
    "FER1L5 CNV",
    "FER1L5 RNA"
  ],
  "AGGF1P5": [
    "AGGF1P5 CNV",
    "AGGF1P5 RNA"
  ],
  "ENPP3": [
    "ENPP3 CNV",
    "ENPP3 RNA"
  ],
  "ENPP7P13": [
    "ENPP7P13 CNV",
    "ENPP7P13 RNA"
  ],
  "APOBEC3AP1": [
    "APOBEC3AP1 CNV",
    "APOBEC3AP1 RNA"
  ],
  "TSGA13": [
    "TSGA13 CNV",
    "TSGA13 RNA"
  ],
  "SMKR1": [
    "SMKR1 CNV",
    "SMKR1 RNA"
  ],
  "THNSL2": [
    "THNSL2 CNV",
    "THNSL2 RNA",
    "THNSL2 Proteo"
  ],
  "CTDSP1": [
    "CTDSP1 CNV",
    "CTDSP1 RNA",
    "CTDSP1 Proteo"
  ],
  "CCR10": [
    "CCR10 CNV",
    "CCR10 RNA"
  ],
  "MTCO1P27": [
    "MTCO1P27 CNV",
    "MTCO1P27 RNA"
  ],
  "SRGAP2D": [
    "SRGAP2D CNV",
    "SRGAP2D RNA"
  ],
  "RTKN2": [
    "RTKN2 CNV",
    "RTKN2 RNA",
    "RTKN2 Proteo"
  ],
  "SLC41A3": [
    "SLC41A3 CNV",
    "SLC41A3 RNA",
    "SLC41A3 Proteo"
  ],
  "TXLNGY": [
    "TXLNGY CNV",
    "TXLNGY RNA"
  ],
  "C17orf114": [
    "C17orf114 CNV",
    "C17orf114 RNA"
  ],
  "OCLNP1": [
    "OCLNP1 CNV",
    "OCLNP1 RNA"
  ],
  "SHC1": [
    "SHC1 CNV",
    "SHC1 RNA",
    "SHC1 Proteo"
  ],
  "OFD1P10Y": [
    "OFD1P10Y CNV",
    "OFD1P10Y RNA"
  ],
  "MAPRE2": [
    "MAPRE2 CNV",
    "MAPRE2 RNA",
    "MAPRE2 Proteo"
  ],
  "OR8B6P": [
    "OR8B6P CNV",
    "OR8B6P RNA"
  ],
  "SDHAF2": [
    "SDHAF2 CNV",
    "SDHAF2 RNA",
    "SDHAF2 Proteo"
  ],
  "UBE2FP2": [
    "UBE2FP2 CNV",
    "UBE2FP2 RNA"
  ],
  "ADGRG1": [
    "ADGRG1 CNV",
    "ADGRG1 RNA",
    "ADGRG1 Proteo"
  ],
  "WASL": [
    "WASL CNV",
    "WASL RNA",
    "WASL Proteo"
  ],
  "NSD3": [
    "NSD3 CNV",
    "NSD3 RNA",
    "NSD3 Proteo"
  ],
  "KDM8": [
    "KDM8 CNV",
    "KDM8 RNA",
    "KDM8 Proteo"
  ],
  "LEF1": [
    "LEF1 CNV",
    "LEF1 RNA",
    "LEF1 Proteo"
  ],
  "OR9L1P": [
    "OR9L1P CNV",
    "OR9L1P RNA"
  ],
  "MUSK": [
    "MUSK CNV",
    "MUSK RNA"
  ],
  "ZNF174": [
    "ZNF174 CNV",
    "ZNF174 RNA",
    "ZNF174 Proteo"
  ],
  "AKIRIN2P1": [
    "AKIRIN2P1 CNV",
    "AKIRIN2P1 RNA"
  ],
  "MAGI3": [
    "MAGI3 CNV",
    "MAGI3 RNA",
    "MAGI3 Proteo"
  ],
  "MAP3K6": [
    "MAP3K6 CNV",
    "MAP3K6 RNA",
    "MAP3K6 Proteo"
  ],
  "BABAM2": [
    "BABAM2 CNV",
    "BABAM2 RNA",
    "BABAM2 Proteo"
  ],
  "PRR16": [
    "PRR16 CNV",
    "PRR16 RNA"
  ],
  "SKA3": [
    "SKA3 CNV",
    "SKA3 RNA",
    "SKA3 Proteo"
  ],
  "SLC25A30": [
    "SLC25A30 CNV",
    "SLC25A30 RNA",
    "SLC25A30 Proteo"
  ],
  "AFF3": [
    "AFF3 CNV",
    "AFF3 RNA",
    "AFF3 Proteo"
  ],
  "AMELY": [
    "AMELY CNV",
    "AMELY RNA"
  ],
  "NPAP1": [
    "NPAP1 CNV",
    "NPAP1 RNA"
  ],
  "FOXD4L3": [
    "FOXD4L3 CNV",
    "FOXD4L3 RNA"
  ],
  "PRCPP1": [
    "PRCPP1 CNV",
    "PRCPP1 RNA"
  ],
  "ZNF207": [
    "ZNF207 CNV",
    "ZNF207 RNA",
    "ZNF207 Proteo"
  ],
  "GALNT14": [
    "GALNT14 CNV",
    "GALNT14 RNA",
    "GALNT14 Proteo"
  ],
  "NPM1P33": [
    "NPM1P33 CNV",
    "NPM1P33 RNA"
  ],
  "CDK14": [
    "CDK14 CNV",
    "CDK14 RNA",
    "CDK14 Proteo"
  ],
  "TMEM174": [
    "TMEM174 CNV",
    "TMEM174 RNA"
  ],
  "CBX6": [
    "CBX6 CNV",
    "CBX6 RNA",
    "CBX6 Proteo"
  ],
  "RPL36P4": [
    "RPL36P4 CNV",
    "RPL36P4 RNA"
  ],
  "MTND5P40": [
    "MTND5P40 CNV",
    "MTND5P40 RNA"
  ],
  "DNPEP": [
    "DNPEP CNV",
    "DNPEP RNA",
    "DNPEP Proteo"
  ],
  "GRAMD1A": [
    "GRAMD1A CNV",
    "GRAMD1A RNA",
    "GRAMD1A Proteo"
  ],
  "RNF125": [
    "RNF125 CNV",
    "RNF125 RNA"
  ],
  "PSMA6P3": [
    "PSMA6P3 CNV",
    "PSMA6P3 RNA"
  ],
  "CSNK2A2": [
    "CSNK2A2 CNV",
    "CSNK2A2 RNA",
    "CSNK2A2 Proteo"
  ],
  "OR10AA1P": [
    "OR10AA1P CNV",
    "OR10AA1P RNA"
  ],
  "LIPH": [
    "LIPH CNV",
    "LIPH RNA"
  ],
  "DNMT3AP1": [
    "DNMT3AP1 CNV",
    "DNMT3AP1 RNA"
  ],
  "DCAF16": [
    "DCAF16 CNV",
    "DCAF16 RNA",
    "DCAF16 Proteo"
  ],
  "SEC14L3": [
    "SEC14L3 CNV",
    "SEC14L3 RNA"
  ],
  "USP9YP33": [
    "USP9YP33 CNV",
    "USP9YP33 RNA"
  ],
  "NBL1": [
    "NBL1 CNV",
    "NBL1 RNA",
    "NBL1 Proteo"
  ],
  "RNA5SP431": [
    "RNA5SP431 CNV",
    "RNA5SP431 RNA"
  ],
  "RPL17": [
    "RPL17 CNV",
    "RPL17 RNA",
    "RPL17 Proteo"
  ],
  "ESRRG": [
    "ESRRG CNV",
    "ESRRG RNA"
  ],
  "RPL23P5": [
    "RPL23P5 CNV",
    "RPL23P5 RNA"
  ],
  "PSMA2": [
    "PSMA2 CNV",
    "PSMA2 RNA",
    "PSMA2 Proteo"
  ],
  "SPATA7": [
    "SPATA7 CNV",
    "SPATA7 RNA"
  ],
  "VWA1": [
    "VWA1 CNV",
    "VWA1 RNA",
    "VWA1 Proteo"
  ],
  "TACC1P1": [
    "TACC1P1 CNV",
    "TACC1P1 RNA"
  ],
  "EBPL": [
    "EBPL CNV",
    "EBPL RNA"
  ],
  "ROCK2": [
    "ROCK2 CNV",
    "ROCK2 RNA",
    "ROCK2 Proteo"
  ],
  "METTL1": [
    "METTL1 CNV",
    "METTL1 RNA",
    "METTL1 Proteo"
  ],
  "SLC51A": [
    "SLC51A CNV",
    "SLC51A RNA"
  ],
  "SPATA31E3P": [
    "SPATA31E3P CNV",
    "SPATA31E3P RNA"
  ],
  "CD47": [
    "CD47 CNV",
    "CD47 RNA",
    "CD47 Proteo"
  ],
  "OR52N4": [
    "OR52N4 CNV",
    "OR52N4 RNA"
  ],
  "MASP1": [
    "MASP1 CNV",
    "MASP1 RNA",
    "MASP1 Proteo"
  ],
  "FJX1": [
    "FJX1 CNV",
    "FJX1 RNA"
  ],
  "HMGN1P38": [
    "HMGN1P38 CNV",
    "HMGN1P38 RNA"
  ],
  "BATF": [
    "BATF CNV",
    "BATF RNA"
  ],
  "ABHD12": [
    "ABHD12 CNV",
    "ABHD12 RNA",
    "ABHD12 Proteo"
  ],
  "PA2G4": [
    "PA2G4 CNV",
    "PA2G4 RNA",
    "PA2G4 Proteo"
  ],
  "DYNC1H1": [
    "DYNC1H1 CNV",
    "DYNC1H1 RNA",
    "DYNC1H1 Proteo"
  ],
  "ANKRD6": [
    "ANKRD6 CNV",
    "ANKRD6 RNA",
    "ANKRD6 Proteo"
  ],
  "S100A11P5": [
    "S100A11P5 CNV",
    "S100A11P5 RNA"
  ],
  "RPS17P8": [
    "RPS17P8 CNV",
    "RPS17P8 RNA"
  ],
  "SEC16B": [
    "SEC16B CNV",
    "SEC16B RNA",
    "SEC16B Proteo"
  ],
  "CCNK": [
    "CCNK CNV",
    "CCNK RNA",
    "CCNK Proteo"
  ],
  "OR5AL2P": [
    "OR5AL2P CNV",
    "OR5AL2P RNA"
  ],
  "COA7": [
    "COA7 CNV",
    "COA7 RNA",
    "COA7 Proteo"
  ],
  "OR52R1": [
    "OR52R1 CNV",
    "OR52R1 RNA"
  ],
  "C18orf54": [
    "C18orf54 CNV",
    "C18orf54 RNA"
  ],
  "HNRNPA1P64": [
    "HNRNPA1P64 CNV",
    "HNRNPA1P64 RNA"
  ],
  "DENND1B": [
    "DENND1B CNV",
    "DENND1B RNA",
    "DENND1B Proteo"
  ],
  "ZNF570": [
    "ZNF570 CNV",
    "ZNF570 RNA"
  ],
  "P3R3URF": [
    "P3R3URF CNV",
    "P3R3URF RNA"
  ],
  "OR11J5P": [
    "OR11J5P CNV",
    "OR11J5P RNA"
  ],
  "MAP2K5": [
    "MAP2K5 CNV",
    "MAP2K5 RNA",
    "MAP2K5 Proteo"
  ],
  "CGB8": [
    "CGB8 CNV",
    "CGB8 RNA"
  ],
  "ZNF879": [
    "ZNF879 CNV",
    "ZNF879 RNA"
  ],
  "LRRC37B": [
    "LRRC37B CNV",
    "LRRC37B RNA"
  ],
  "H3C10": [
    "H3C10 CNV",
    "H3C10 RNA"
  ],
  "SLC16A5": [
    "SLC16A5 CNV",
    "SLC16A5 RNA"
  ],
  "TDGF1P6": [
    "TDGF1P6 CNV",
    "TDGF1P6 RNA"
  ],
  "KRT8P37": [
    "KRT8P37 CNV",
    "KRT8P37 RNA"
  ],
  "PHOX2A": [
    "PHOX2A CNV",
    "PHOX2A RNA"
  ],
  "MMGT1": [
    "MMGT1 CNV",
    "MMGT1 RNA",
    "MMGT1 Proteo"
  ],
  "SMC4": [
    "SMC4 CNV",
    "SMC4 RNA",
    "SMC4 Proteo"
  ],
  "MRPS28": [
    "MRPS28 CNV",
    "MRPS28 RNA",
    "MRPS28 Proteo"
  ],
  "LCNL1": [
    "LCNL1 CNV",
    "LCNL1 RNA"
  ],
  "GAPDHP41": [
    "GAPDHP41 CNV",
    "GAPDHP41 RNA"
  ],
  "OR7E91P": [
    "OR7E91P CNV",
    "OR7E91P RNA"
  ],
  "NEK4P1": [
    "NEK4P1 CNV",
    "NEK4P1 RNA"
  ],
  "HMGN5": [
    "HMGN5 CNV",
    "HMGN5 RNA",
    "HMGN5 Proteo"
  ],
  "UBE2Q1": [
    "UBE2Q1 CNV",
    "UBE2Q1 RNA",
    "UBE2Q1 Proteo"
  ],
  "LDHAP4": [
    "LDHAP4 CNV",
    "LDHAP4 RNA"
  ],
  "RLN3": [
    "RLN3 CNV",
    "RLN3 RNA"
  ],
  "REELD1": [
    "REELD1 CNV",
    "REELD1 RNA"
  ],
  "FAM98C": [
    "FAM98C CNV",
    "FAM98C RNA",
    "FAM98C Proteo"
  ],
  "OR2M1P": [
    "OR2M1P CNV",
    "OR2M1P RNA"
  ],
  "MRPS16": [
    "MRPS16 CNV",
    "MRPS16 RNA",
    "MRPS16 Proteo"
  ],
  "UBE2Q2": [
    "UBE2Q2 CNV",
    "UBE2Q2 RNA",
    "UBE2Q2 Proteo"
  ],
  "UBAC1": [
    "UBAC1 CNV",
    "UBAC1 RNA",
    "UBAC1 Proteo"
  ],
  "RTP2": [
    "RTP2 CNV",
    "RTP2 RNA"
  ],
  "NUAK1": [
    "NUAK1 CNV",
    "NUAK1 RNA"
  ],
  "BRK1": [
    "BRK1 CNV",
    "BRK1 RNA",
    "BRK1 Proteo"
  ],
  "BIRC8": [
    "BIRC8 CNV",
    "BIRC8 RNA"
  ],
  "ZMYND12": [
    "ZMYND12 CNV",
    "ZMYND12 RNA"
  ],
  "KLF4P1": [
    "KLF4P1 CNV",
    "KLF4P1 RNA"
  ],
  "MAB21L1": [
    "MAB21L1 CNV",
    "MAB21L1 RNA"
  ],
  "ZNF397": [
    "ZNF397 CNV",
    "ZNF397 RNA",
    "ZNF397 Proteo"
  ],
  "FBXO21": [
    "FBXO21 CNV",
    "FBXO21 RNA",
    "FBXO21 Proteo"
  ],
  "S1PR2": [
    "S1PR2 CNV",
    "S1PR2 RNA",
    "S1PR2 Proteo"
  ],
  "GLRX5P1": [
    "GLRX5P1 CNV",
    "GLRX5P1 RNA"
  ],
  "SGMS2": [
    "SGMS2 CNV",
    "SGMS2 RNA"
  ],
  "C22orf15": [
    "C22orf15 CNV",
    "C22orf15 RNA"
  ],
  "PNMA1": [
    "PNMA1 CNV",
    "PNMA1 RNA",
    "PNMA1 Proteo"
  ],
  "CDY14P": [
    "CDY14P CNV",
    "CDY14P RNA"
  ],
  "RPL12P41": [
    "RPL12P41 CNV",
    "RPL12P41 RNA"
  ],
  "OR5B12": [
    "OR5B12 CNV",
    "OR5B12 RNA"
  ],
  "C20orf203": [
    "C20orf203 CNV",
    "C20orf203 RNA"
  ],
  "TWF2": [
    "TWF2 CNV",
    "TWF2 RNA",
    "TWF2 Proteo"
  ],
  "ZNF705A": [
    "ZNF705A CNV",
    "ZNF705A RNA"
  ],
  "ZNF705D": [
    "ZNF705D CNV",
    "ZNF705D RNA"
  ],
  "HMGB3P21": [
    "HMGB3P21 CNV",
    "HMGB3P21 RNA"
  ],
  "CT45A5": [
    "CT45A5 CNV",
    "CT45A5 RNA"
  ],
  "RNA5SP35": [
    "RNA5SP35 CNV",
    "RNA5SP35 RNA"
  ],
  "ZKSCAN1": [
    "ZKSCAN1 CNV",
    "ZKSCAN1 RNA",
    "ZKSCAN1 Proteo"
  ],
  "IL9RP2": [
    "IL9RP2 CNV",
    "IL9RP2 RNA"
  ],
  "SLC37A4": [
    "SLC37A4 CNV",
    "SLC37A4 RNA",
    "SLC37A4 Proteo"
  ],
  "PSTK": [
    "PSTK CNV",
    "PSTK RNA"
  ],
  "CTAGE1": [
    "CTAGE1 CNV",
    "CTAGE1 RNA"
  ],
  "SIGLEC20P": [
    "SIGLEC20P CNV",
    "SIGLEC20P RNA"
  ],
  "ARL17A": [
    "ARL17A CNV",
    "ARL17A RNA"
  ],
  "PBX4": [
    "PBX4 CNV",
    "PBX4 RNA"
  ],
  "KRT8P21": [
    "KRT8P21 CNV",
    "KRT8P21 RNA"
  ],
  "XRCC2": [
    "XRCC2 CNV",
    "XRCC2 RNA",
    "XRCC2 Proteo"
  ],
  "HLA-F": [
    "HLA-F CNV",
    "HLA-F RNA",
    "HLA-F Proteo"
  ],
  "UBL4B": [
    "UBL4B CNV",
    "UBL4B RNA"
  ],
  "CKS1BP3": [
    "CKS1BP3 CNV",
    "CKS1BP3 RNA"
  ],
  "SLC7A8": [
    "SLC7A8 CNV",
    "SLC7A8 RNA",
    "SLC7A8 Proteo"
  ],
  "RPSAP71": [
    "RPSAP71 CNV",
    "RPSAP71 RNA"
  ],
  "METAP2P1": [
    "METAP2P1 CNV",
    "METAP2P1 RNA"
  ],
  "ART4": [
    "ART4 CNV",
    "ART4 RNA",
    "ART4 Proteo"
  ],
  "PPIAP88": [
    "PPIAP88 CNV",
    "PPIAP88 RNA"
  ],
  "SKAP1": [
    "SKAP1 CNV",
    "SKAP1 RNA",
    "SKAP1 Proteo"
  ],
  "RAB7B": [
    "RAB7B CNV",
    "RAB7B RNA",
    "RAB7B Proteo"
  ],
  "FAM9A": [
    "FAM9A CNV",
    "FAM9A RNA"
  ],
  "OTULINL": [
    "OTULINL CNV",
    "OTULINL RNA",
    "OTULINL Proteo"
  ],
  "PSMD10P2": [
    "PSMD10P2 CNV",
    "PSMD10P2 RNA"
  ],
  "G2E3": [
    "G2E3 CNV",
    "G2E3 RNA"
  ],
  "NPIPB2": [
    "NPIPB2 CNV",
    "NPIPB2 RNA"
  ],
  "COL4A2": [
    "COL4A2 CNV",
    "COL4A2 RNA",
    "COL4A2 Proteo"
  ],
  "RPL27": [
    "RPL27 CNV",
    "RPL27 RNA",
    "RPL27 Proteo"
  ],
  "OR5M1": [
    "OR5M1 CNV",
    "OR5M1 RNA"
  ],
  "KRTAP4-17P": [
    "KRTAP4-17P CNV",
    "KRTAP4-17P RNA"
  ],
  "APH1A": [
    "APH1A CNV",
    "APH1A RNA",
    "APH1A Proteo"
  ],
  "PSG4": [
    "PSG4 CNV",
    "PSG4 RNA"
  ],
  "SNRNP70": [
    "SNRNP70 CNV",
    "SNRNP70 RNA",
    "SNRNP70 Proteo"
  ],
  "OR2L6P": [
    "OR2L6P CNV",
    "OR2L6P RNA"
  ],
  "NAT2": [
    "NAT2 CNV",
    "NAT2 RNA"
  ],
  "ALDH1L1": [
    "ALDH1L1 CNV",
    "ALDH1L1 RNA",
    "ALDH1L1 Proteo"
  ],
  "ITPK1P1": [
    "ITPK1P1 CNV",
    "ITPK1P1 RNA"
  ],
  "MTCYBP13": [
    "MTCYBP13 CNV",
    "MTCYBP13 RNA"
  ],
  "RPL23AP88": [
    "RPL23AP88 CNV",
    "RPL23AP88 RNA"
  ],
  "IGLC2": [
    "IGLC2 Proteo"
  ],
  "EPHX1": [
    "EPHX1 CNV",
    "EPHX1 RNA",
    "EPHX1 Proteo"
  ],
  "SRSF12": [
    "SRSF12 CNV",
    "SRSF12 RNA",
    "SRSF12 Proteo"
  ],
  "BEND4": [
    "BEND4 CNV",
    "BEND4 RNA"
  ],
  "DUX4L12": [
    "DUX4L12 CNV",
    "DUX4L12 RNA"
  ],
  "PIAS2": [
    "PIAS2 CNV",
    "PIAS2 RNA",
    "PIAS2 Proteo"
  ],
  "SETP20": [
    "SETP20 CNV",
    "SETP20 RNA"
  ],
  "RPS27P14": [
    "RPS27P14 CNV",
    "RPS27P14 RNA"
  ],
  "CAVIN3": [
    "CAVIN3 CNV",
    "CAVIN3 RNA",
    "CAVIN3 Proteo"
  ],
  "ANKZF1": [
    "ANKZF1 CNV",
    "ANKZF1 RNA",
    "ANKZF1 Proteo"
  ],
  "BTK": [
    "BTK CNV",
    "BTK RNA",
    "BTK Proteo"
  ],
  "SUV39H1": [
    "SUV39H1 CNV",
    "SUV39H1 RNA",
    "SUV39H1 Proteo"
  ],
  "RGP1": [
    "RGP1 CNV",
    "RGP1 RNA",
    "RGP1 Proteo"
  ],
  "MOGS": [
    "MOGS CNV",
    "MOGS RNA",
    "MOGS Proteo"
  ],
  "FAT2": [
    "FAT2 CNV",
    "FAT2 RNA",
    "FAT2 Proteo"
  ],
  "TNFRSF10A": [
    "TNFRSF10A CNV",
    "TNFRSF10A RNA",
    "TNFRSF10A Proteo"
  ],
  "PROM1": [
    "PROM1 CNV",
    "PROM1 RNA",
    "PROM1 Proteo"
  ],
  "MTCYBP31": [
    "MTCYBP31 CNV",
    "MTCYBP31 RNA"
  ],
  "FBN2": [
    "FBN2 CNV",
    "FBN2 RNA",
    "FBN2 Proteo"
  ],
  "OR1D3P": [
    "OR1D3P CNV",
    "OR1D3P RNA"
  ],
  "EDN1": [
    "EDN1 CNV",
    "EDN1 RNA"
  ],
  "RABL6": [
    "RABL6 CNV",
    "RABL6 RNA",
    "RABL6 Proteo"
  ],
  "ENSAP3": [
    "ENSAP3 CNV",
    "ENSAP3 RNA"
  ],
  "SYNC": [
    "SYNC CNV",
    "SYNC RNA",
    "SYNC Proteo"
  ],
  "RBMY1A1": [
    "RBMY1A1 CNV",
    "RBMY1A1 RNA"
  ],
  "PHYH": [
    "PHYH CNV",
    "PHYH RNA",
    "PHYH Proteo"
  ],
  "RPS3AP49": [
    "RPS3AP49 CNV",
    "RPS3AP49 RNA"
  ],
  "PMEPA1": [
    "PMEPA1 CNV",
    "PMEPA1 RNA"
  ],
  "FAM13A": [
    "FAM13A CNV",
    "FAM13A RNA",
    "FAM13A Proteo"
  ],
  "AFMID": [
    "AFMID CNV",
    "AFMID RNA",
    "AFMID Proteo"
  ],
  "PKNOX2": [
    "PKNOX2 CNV",
    "PKNOX2 RNA"
  ],
  "NDUFB2": [
    "NDUFB2 CNV",
    "NDUFB2 RNA",
    "NDUFB2 Proteo"
  ],
  "FERP1": [
    "FERP1 CNV",
    "FERP1 RNA"
  ],
  "RPS25": [
    "RPS25 CNV",
    "RPS25 RNA",
    "RPS25 Proteo"
  ],
  "RPL19P16": [
    "RPL19P16 CNV",
    "RPL19P16 RNA"
  ],
  "CYCSP38": [
    "CYCSP38 CNV",
    "CYCSP38 RNA"
  ],
  "DSCC1": [
    "DSCC1 CNV",
    "DSCC1 RNA",
    "DSCC1 Proteo"
  ],
  "RPS29P22": [
    "RPS29P22 CNV",
    "RPS29P22 RNA"
  ],
  "CEP57L1P1": [
    "CEP57L1P1 CNV",
    "CEP57L1P1 RNA"
  ],
  "CIBAR1P1": [
    "CIBAR1P1 CNV",
    "CIBAR1P1 RNA"
  ],
  "CENATAC": [
    "CENATAC CNV",
    "CENATAC RNA",
    "CENATAC Proteo"
  ],
  "ABCG8": [
    "ABCG8 CNV",
    "ABCG8 RNA"
  ],
  "ZYG11AP1": [
    "ZYG11AP1 CNV",
    "ZYG11AP1 RNA"
  ],
  "CCDC197": [
    "CCDC197 CNV",
    "CCDC197 RNA"
  ],
  "AMT": [
    "AMT CNV",
    "AMT RNA",
    "AMT Proteo"
  ],
  "MRPL42P3": [
    "MRPL42P3 CNV",
    "MRPL42P3 RNA"
  ],
  "KIF6": [
    "KIF6 CNV",
    "KIF6 RNA"
  ],
  "RASL11A": [
    "RASL11A CNV",
    "RASL11A RNA"
  ],
  "IGKV2OR2-2": [
    "IGKV2OR2-2 CNV",
    "IGKV2OR2-2 RNA"
  ],
  "MCHR2": [
    "MCHR2 CNV",
    "MCHR2 RNA"
  ],
  "FAM228A": [
    "FAM228A CNV",
    "FAM228A RNA"
  ],
  "FUT9": [
    "FUT9 CNV",
    "FUT9 RNA"
  ],
  "HMGN1P11": [
    "HMGN1P11 CNV",
    "HMGN1P11 RNA"
  ],
  "PSAT1P2": [
    "PSAT1P2 CNV",
    "PSAT1P2 RNA"
  ],
  "IGKV3-31": [
    "IGKV3-31 CNV",
    "IGKV3-31 RNA"
  ],
  "C12orf4": [
    "C12orf4 CNV",
    "C12orf4 RNA",
    "C12orf4 Proteo"
  ],
  "ITM2BP1": [
    "ITM2BP1 CNV",
    "ITM2BP1 RNA"
  ],
  "ZNF876P": [
    "ZNF876P CNV",
    "ZNF876P RNA"
  ],
  "PTPN22": [
    "PTPN22 CNV",
    "PTPN22 RNA",
    "PTPN22 Proteo"
  ],
  "PTGER4": [
    "PTGER4 CNV",
    "PTGER4 RNA"
  ],
  "BIN2": [
    "BIN2 CNV",
    "BIN2 RNA",
    "BIN2 Proteo"
  ],
  "BTBD19": [
    "BTBD19 CNV",
    "BTBD19 RNA",
    "BTBD19 Proteo"
  ],
  "SIGLEC30P": [
    "SIGLEC30P CNV",
    "SIGLEC30P RNA"
  ],
  "RPRD1B": [
    "RPRD1B CNV",
    "RPRD1B RNA",
    "RPRD1B Proteo"
  ],
  "TMEM191C": [
    "TMEM191C CNV",
    "TMEM191C RNA"
  ],
  "HMGB1P8": [
    "HMGB1P8 CNV",
    "HMGB1P8 RNA"
  ],
  "DUSP4": [
    "DUSP4 CNV",
    "DUSP4 RNA",
    "DUSP4 Proteo"
  ],
  "CYP2A7P1": [
    "CYP2A7P1 CNV",
    "CYP2A7P1 RNA"
  ],
  "CD2": [
    "CD2 CNV",
    "CD2 RNA",
    "CD2 Proteo"
  ],
  "RFPL1": [
    "RFPL1 CNV",
    "RFPL1 RNA"
  ],
  "ZNF234": [
    "ZNF234 CNV",
    "ZNF234 RNA",
    "ZNF234 Proteo"
  ],
  "LRRC8D": [
    "LRRC8D CNV",
    "LRRC8D RNA",
    "LRRC8D Proteo"
  ],
  "HIGD1B": [
    "HIGD1B CNV",
    "HIGD1B RNA"
  ],
  "OR5G5P": [
    "OR5G5P CNV",
    "OR5G5P RNA"
  ],
  "ANKH": [
    "ANKH CNV",
    "ANKH RNA",
    "ANKH Proteo"
  ],
  "CYP4F25P": [
    "CYP4F25P CNV",
    "CYP4F25P RNA"
  ],
  "RBP2": [
    "RBP2 CNV",
    "RBP2 RNA",
    "RBP2 Proteo"
  ],
  "ZNF592": [
    "ZNF592 CNV",
    "ZNF592 RNA",
    "ZNF592 Proteo"
  ],
  "ACVR1": [
    "ACVR1 CNV",
    "ACVR1 RNA",
    "ACVR1 Proteo"
  ],
  "GAS8": [
    "GAS8 CNV",
    "GAS8 RNA",
    "GAS8 Proteo"
  ],
  "KRTAP5-11": [
    "KRTAP5-11 CNV",
    "KRTAP5-11 RNA"
  ],
  "LRIF1": [
    "LRIF1 CNV",
    "LRIF1 RNA",
    "LRIF1 Proteo"
  ],
  "NR2C2": [
    "NR2C2 CNV",
    "NR2C2 RNA",
    "NR2C2 Proteo"
  ],
  "SELENOTP2": [
    "SELENOTP2 CNV",
    "SELENOTP2 RNA"
  ],
  "GOLGA6L25P": [
    "GOLGA6L25P CNV",
    "GOLGA6L25P RNA"
  ],
  "LCN1": [
    "LCN1 CNV",
    "LCN1 RNA",
    "LCN1 Proteo"
  ],
  "ZFP91P1": [
    "ZFP91P1 CNV",
    "ZFP91P1 RNA"
  ],
  "VTA1P1": [
    "VTA1P1 CNV",
    "VTA1P1 RNA"
  ],
  "URB2": [
    "URB2 CNV",
    "URB2 RNA",
    "URB2 Proteo"
  ],
  "PLPP6": [
    "PLPP6 CNV",
    "PLPP6 RNA",
    "PLPP6 Proteo"
  ],
  "SRSF1P1": [
    "SRSF1P1 CNV",
    "SRSF1P1 RNA"
  ],
  "NNMT": [
    "NNMT CNV",
    "NNMT RNA",
    "NNMT Proteo"
  ],
  "WEE1P1": [
    "WEE1P1 CNV",
    "WEE1P1 RNA"
  ],
  "ARMT1": [
    "ARMT1 CNV",
    "ARMT1 RNA",
    "ARMT1 Proteo"
  ],
  "DUX4L32": [
    "DUX4L32 CNV",
    "DUX4L32 RNA"
  ],
  "TESK1": [
    "TESK1 CNV",
    "TESK1 RNA"
  ],
  "CRYZP1": [
    "CRYZP1 CNV",
    "CRYZP1 RNA"
  ],
  "FAM86B1": [
    "FAM86B1 CNV",
    "FAM86B1 RNA"
  ],
  "TAF9BP1": [
    "TAF9BP1 CNV",
    "TAF9BP1 RNA"
  ],
  "DGKB": [
    "DGKB CNV",
    "DGKB RNA"
  ],
  "MTATP6P8": [
    "MTATP6P8 CNV",
    "MTATP6P8 RNA"
  ],
  "ELAC1": [
    "ELAC1 CNV",
    "ELAC1 RNA",
    "ELAC1 Proteo"
  ],
  "LRTM1": [
    "LRTM1 CNV",
    "LRTM1 RNA"
  ],
  "PIGY": [
    "PIGY CNV",
    "PIGY RNA"
  ],
  "MGAT4D": [
    "MGAT4D CNV",
    "MGAT4D RNA"
  ],
  "TUFMP1": [
    "TUFMP1 CNV",
    "TUFMP1 RNA"
  ],
  "CDC14B": [
    "CDC14B CNV",
    "CDC14B RNA"
  ],
  "ELL2P4": [
    "ELL2P4 CNV",
    "ELL2P4 RNA"
  ],
  "KRT6C": [
    "KRT6C CNV",
    "KRT6C RNA",
    "KRT6C Proteo"
  ],
  "ZXDB": [
    "ZXDB CNV",
    "ZXDB RNA"
  ],
  "IFNA12P": [
    "IFNA12P CNV",
    "IFNA12P RNA"
  ],
  "HIGD1A": [
    "HIGD1A CNV",
    "HIGD1A RNA",
    "HIGD1A Proteo"
  ],
  "TIFA": [
    "TIFA CNV",
    "TIFA RNA",
    "TIFA Proteo"
  ],
  "HSPA1B": [
    "HSPA1B CNV",
    "HSPA1B RNA",
    "HSPA1B Proteo"
  ],
  "C11orf71": [
    "C11orf71 CNV",
    "C11orf71 RNA"
  ],
  "ZNF587": [
    "ZNF587 CNV",
    "ZNF587 RNA"
  ],
  "ANKRD20A8P": [
    "ANKRD20A8P CNV",
    "ANKRD20A8P RNA"
  ],
  "GAPDHP55": [
    "GAPDHP55 CNV",
    "GAPDHP55 RNA"
  ],
  "PPIAP62": [
    "PPIAP62 CNV",
    "PPIAP62 RNA"
  ],
  "CLNS1AP1": [
    "CLNS1AP1 CNV",
    "CLNS1AP1 RNA"
  ],
  "SLC35B1": [
    "SLC35B1 CNV",
    "SLC35B1 RNA",
    "SLC35B1 Proteo"
  ],
  "GOLGA6L17P": [
    "GOLGA6L17P CNV",
    "GOLGA6L17P RNA"
  ],
  "SPTB": [
    "SPTB CNV",
    "SPTB RNA",
    "SPTB Proteo"
  ],
  "TMA16P1": [
    "TMA16P1 CNV",
    "TMA16P1 RNA"
  ],
  "FAM186B": [
    "FAM186B CNV",
    "FAM186B RNA",
    "FAM186B Proteo"
  ],
  "VAPA": [
    "VAPA CNV",
    "VAPA RNA",
    "VAPA Proteo"
  ],
  "HPS4": [
    "HPS4 CNV",
    "HPS4 RNA",
    "HPS4 Proteo"
  ],
  "LSM2": [
    "LSM2 CNV",
    "LSM2 RNA",
    "LSM2 Proteo"
  ],
  "NR2F2": [
    "NR2F2 CNV",
    "NR2F2 RNA",
    "NR2F2 Proteo"
  ],
  "IGFL1": [
    "IGFL1 CNV",
    "IGFL1 RNA"
  ],
  "TRIO": [
    "TRIO CNV",
    "TRIO RNA",
    "TRIO Proteo"
  ],
  "RNA5SP301": [
    "RNA5SP301 CNV",
    "RNA5SP301 RNA"
  ],
  "IRGM": [
    "IRGM CNV",
    "IRGM RNA"
  ],
  "ANP32E": [
    "ANP32E CNV",
    "ANP32E RNA",
    "ANP32E Proteo"
  ],
  "RASIP1": [
    "RASIP1 CNV",
    "RASIP1 RNA",
    "RASIP1 Proteo"
  ],
  "KDM7A": [
    "KDM7A CNV",
    "KDM7A RNA",
    "KDM7A Proteo"
  ],
  "STMN4": [
    "STMN4 CNV",
    "STMN4 RNA"
  ],
  "MTND4P23": [
    "MTND4P23 CNV",
    "MTND4P23 RNA"
  ],
  "OR9K2": [
    "OR9K2 CNV",
    "OR9K2 RNA"
  ],
  "HBS1L": [
    "HBS1L CNV",
    "HBS1L RNA",
    "HBS1L Proteo"
  ],
  "PHB2P1": [
    "PHB2P1 CNV",
    "PHB2P1 RNA"
  ],
  "RPS6KA2": [
    "RPS6KA2 CNV",
    "RPS6KA2 RNA"
  ],
  "MTND2P24": [
    "MTND2P24 CNV",
    "MTND2P24 RNA"
  ],
  "SCGB3A2": [
    "SCGB3A2 CNV",
    "SCGB3A2 RNA"
  ],
  "PABPN1P1": [
    "PABPN1P1 CNV",
    "PABPN1P1 RNA"
  ],
  "MATR3_ENSG00000280987": [
    "MATR3_ENSG00000280987 RNA",
    "MATR3_ENSG00000280987 Proteo"
  ],
  "KRTAP1-3": [
    "KRTAP1-3 CNV",
    "KRTAP1-3 RNA"
  ],
  "MAGED4": [
    "MAGED4 CNV",
    "MAGED4 RNA"
  ],
  "PTPN4": [
    "PTPN4 CNV",
    "PTPN4 RNA",
    "PTPN4 Proteo"
  ],
  "IGHV3-7": [
    "IGHV3-7 Proteo"
  ],
  "WDR12": [
    "WDR12 CNV",
    "WDR12 RNA",
    "WDR12 Proteo"
  ],
  "OR2T5": [
    "OR2T5 CNV",
    "OR2T5 RNA"
  ],
  "DPPA5P4": [
    "DPPA5P4 CNV",
    "DPPA5P4 RNA"
  ],
  "NAMPTP2": [
    "NAMPTP2 CNV",
    "NAMPTP2 RNA"
  ],
  "PLAAT5": [
    "PLAAT5 CNV",
    "PLAAT5 RNA"
  ],
  "JPH2": [
    "JPH2 CNV",
    "JPH2 RNA",
    "JPH2 Proteo"
  ],
  "TMEM39A": [
    "TMEM39A CNV",
    "TMEM39A RNA",
    "TMEM39A Proteo"
  ],
  "NCAPD3": [
    "NCAPD3 CNV",
    "NCAPD3 RNA",
    "NCAPD3 Proteo"
  ],
  "RNA5SP91": [
    "RNA5SP91 CNV",
    "RNA5SP91 RNA"
  ],
  "DDAH1": [
    "DDAH1 CNV",
    "DDAH1 RNA",
    "DDAH1 Proteo"
  ],
  "FAM136A": [
    "FAM136A CNV",
    "FAM136A RNA",
    "FAM136A Proteo"
  ],
  "MICB": [
    "MICB CNV",
    "MICB RNA"
  ],
  "HSPB11": [
    "HSPB11 CNV",
    "HSPB11 RNA",
    "HSPB11 Proteo"
  ],
  "CDRT15P6": [
    "CDRT15P6 CNV",
    "CDRT15P6 RNA"
  ],
  "ABRAXAS1": [
    "ABRAXAS1 CNV",
    "ABRAXAS1 RNA",
    "ABRAXAS1 Proteo"
  ],
  "KRTAP20-4": [
    "KRTAP20-4 CNV",
    "KRTAP20-4 RNA"
  ],
  "AKR1D1P1": [
    "AKR1D1P1 CNV",
    "AKR1D1P1 RNA"
  ],
  "RPL21P24": [
    "RPL21P24 CNV",
    "RPL21P24 RNA"
  ],
  "C4orf36": [
    "C4orf36 CNV",
    "C4orf36 RNA"
  ],
  "PPP4R3C": [
    "PPP4R3C CNV",
    "PPP4R3C RNA"
  ],
  "FBXO4": [
    "FBXO4 CNV",
    "FBXO4 RNA",
    "FBXO4 Proteo"
  ],
  "GEMIN8P1": [
    "GEMIN8P1 CNV",
    "GEMIN8P1 RNA"
  ],
  "OR51P1P": [
    "OR51P1P CNV",
    "OR51P1P RNA"
  ],
  "TUBAP12": [
    "TUBAP12 CNV",
    "TUBAP12 RNA"
  ],
  "DDX18P6": [
    "DDX18P6 CNV",
    "DDX18P6 RNA"
  ],
  "FGG": [
    "FGG CNV",
    "FGG RNA",
    "FGG Proteo"
  ],
  "SUPT3H": [
    "SUPT3H CNV",
    "SUPT3H RNA",
    "SUPT3H Proteo"
  ],
  "SLIT1": [
    "SLIT1 CNV",
    "SLIT1 RNA",
    "SLIT1 Proteo"
  ],
  "TNIP2P1": [
    "TNIP2P1 CNV",
    "TNIP2P1 RNA"
  ],
  "ECI1": [
    "ECI1 CNV",
    "ECI1 RNA",
    "ECI1 Proteo"
  ],
  "NSA2": [
    "NSA2 CNV",
    "NSA2 RNA",
    "NSA2 Proteo"
  ],
  "CCDC14": [
    "CCDC14 CNV",
    "CCDC14 RNA",
    "CCDC14 Proteo"
  ],
  "BTF3L4P4": [
    "BTF3L4P4 CNV",
    "BTF3L4P4 RNA"
  ],
  "TTC7B": [
    "TTC7B CNV",
    "TTC7B RNA",
    "TTC7B Proteo"
  ],
  "FOXG1": [
    "FOXG1 CNV",
    "FOXG1 RNA"
  ],
  "SRGNP1": [
    "SRGNP1 CNV",
    "SRGNP1 RNA"
  ],
  "CALHM1": [
    "CALHM1 CNV",
    "CALHM1 RNA"
  ],
  "STX11": [
    "STX11 CNV",
    "STX11 RNA",
    "STX11 Proteo"
  ],
  "JUN": [
    "JUN CNV",
    "JUN RNA",
    "JUN Proteo"
  ],
  "RABGAP1": [
    "RABGAP1 CNV",
    "RABGAP1 RNA",
    "RABGAP1 Proteo"
  ],
  "BMS1P12": [
    "BMS1P12 CNV",
    "BMS1P12 RNA"
  ],
  "MTND4LP2": [
    "MTND4LP2 CNV",
    "MTND4LP2 RNA"
  ],
  "MTCYBP17": [
    "MTCYBP17 CNV",
    "MTCYBP17 RNA"
  ],
  "CCNG1P1": [
    "CCNG1P1 CNV",
    "CCNG1P1 RNA"
  ],
  "ISY1-RAB43": [
    "ISY1-RAB43 Proteo"
  ],
  "PPP1R10": [
    "PPP1R10 CNV",
    "PPP1R10 RNA",
    "PPP1R10 Proteo"
  ],
  "HSPE1P27": [
    "HSPE1P27 CNV",
    "HSPE1P27 RNA"
  ],
  "CCDC158": [
    "CCDC158 CNV",
    "CCDC158 RNA",
    "CCDC158 Proteo"
  ],
  "PGAM1P3": [
    "PGAM1P3 CNV",
    "PGAM1P3 RNA"
  ],
  "PA2G4P4": [
    "PA2G4P4 CNV",
    "PA2G4P4 RNA"
  ],
  "ARL16": [
    "ARL16 CNV",
    "ARL16 RNA"
  ],
  "LRRC46": [
    "LRRC46 CNV",
    "LRRC46 RNA"
  ],
  "CNOT2": [
    "CNOT2 CNV",
    "CNOT2 RNA",
    "CNOT2 Proteo"
  ],
  "RNA5SP513": [
    "RNA5SP513 CNV",
    "RNA5SP513 RNA"
  ],
  "KCTD19": [
    "KCTD19 CNV",
    "KCTD19 RNA"
  ],
  "DUX4L6": [
    "DUX4L6 CNV",
    "DUX4L6 RNA"
  ],
  "OR2P1P": [
    "OR2P1P CNV",
    "OR2P1P RNA"
  ],
  "MAMSTR": [
    "MAMSTR CNV",
    "MAMSTR RNA"
  ],
  "GNAQP1": [
    "GNAQP1 CNV",
    "GNAQP1 RNA"
  ],
  "ASCC2": [
    "ASCC2 CNV",
    "ASCC2 RNA",
    "ASCC2 Proteo"
  ],
  "PWWP2AP1": [
    "PWWP2AP1 CNV",
    "PWWP2AP1 RNA"
  ],
  "SLC7A6OS": [
    "SLC7A6OS CNV",
    "SLC7A6OS RNA",
    "SLC7A6OS Proteo"
  ],
  "ANAPC5": [
    "ANAPC5 CNV",
    "ANAPC5 RNA",
    "ANAPC5 Proteo"
  ],
  "CTNND2": [
    "CTNND2 CNV",
    "CTNND2 RNA"
  ],
  "RPL18P11": [
    "RPL18P11 CNV",
    "RPL18P11 RNA"
  ],
  "HCG4": [
    "HCG4 CNV",
    "HCG4 RNA"
  ],
  "ZNF849P": [
    "ZNF849P CNV",
    "ZNF849P RNA"
  ],
  "ARMC12": [
    "ARMC12 CNV",
    "ARMC12 RNA"
  ],
  "RPL36AP2": [
    "RPL36AP2 CNV",
    "RPL36AP2 RNA"
  ],
  "ASS1P14": [
    "ASS1P14 CNV",
    "ASS1P14 RNA"
  ],
  "RPL14P6": [
    "RPL14P6 CNV",
    "RPL14P6 RNA"
  ],
  "FGFR2": [
    "FGFR2 CNV",
    "FGFR2 RNA"
  ],
  "TLCD1": [
    "TLCD1 CNV",
    "TLCD1 RNA",
    "TLCD1 Proteo"
  ],
  "CRHBP": [
    "CRHBP CNV",
    "CRHBP RNA"
  ],
  "CCNB1IP1": [
    "CCNB1IP1 CNV",
    "CCNB1IP1 RNA"
  ],
  "OR7E4P": [
    "OR7E4P CNV",
    "OR7E4P RNA"
  ],
  "KLHDC10": [
    "KLHDC10 CNV",
    "KLHDC10 RNA",
    "KLHDC10 Proteo"
  ],
  "AGAP10P": [
    "AGAP10P CNV",
    "AGAP10P RNA"
  ],
  "KRAS": [
    "KRAS CNV",
    "KRAS RNA",
    "KRAS Proteo"
  ],
  "ZNF575": [
    "ZNF575 CNV",
    "ZNF575 RNA"
  ],
  "ZNF548": [
    "ZNF548 CNV",
    "ZNF548 RNA"
  ],
  "IGHG4": [
    "IGHG4 Proteo"
  ],
  "IFNA5": [
    "IFNA5 CNV",
    "IFNA5 RNA"
  ],
  "JAZF1": [
    "JAZF1 CNV",
    "JAZF1 RNA",
    "JAZF1 Proteo"
  ],
  "DNAJC4": [
    "DNAJC4 CNV",
    "DNAJC4 RNA",
    "DNAJC4 Proteo"
  ],
  "CNN1": [
    "CNN1 CNV",
    "CNN1 RNA",
    "CNN1 Proteo"
  ],
  "PSG5": [
    "PSG5 CNV",
    "PSG5 RNA"
  ],
  "ARL2BPP10": [
    "ARL2BPP10 CNV",
    "ARL2BPP10 RNA"
  ],
  "FTH1P21": [
    "FTH1P21 CNV",
    "FTH1P21 RNA"
  ],
  "HMGB1P29": [
    "HMGB1P29 CNV",
    "HMGB1P29 RNA"
  ],
  "RPL9P5": [
    "RPL9P5 CNV",
    "RPL9P5 RNA"
  ],
  "NPAP1P2": [
    "NPAP1P2 CNV",
    "NPAP1P2 RNA"
  ],
  "OR2AF1P": [
    "OR2AF1P CNV",
    "OR2AF1P RNA"
  ],
  "TOMM40P1": [
    "TOMM40P1 CNV",
    "TOMM40P1 RNA"
  ],
  "FLII": [
    "FLII CNV",
    "FLII RNA",
    "FLII Proteo"
  ],
  "GALT": [
    "GALT CNV",
    "GALT RNA",
    "GALT Proteo"
  ],
  "RPS4XP6": [
    "RPS4XP6 CNV",
    "RPS4XP6 RNA"
  ],
  "ATP5MC1P4": [
    "ATP5MC1P4 CNV",
    "ATP5MC1P4 RNA"
  ],
  "WDR82P2": [
    "WDR82P2 CNV",
    "WDR82P2 RNA"
  ],
  "RPL7AP36": [
    "RPL7AP36 CNV",
    "RPL7AP36 RNA"
  ],
  "RNA5SP80": [
    "RNA5SP80 CNV",
    "RNA5SP80 RNA"
  ],
  "ARL14EP": [
    "ARL14EP CNV",
    "ARL14EP RNA",
    "ARL14EP Proteo"
  ],
  "SHB": [
    "SHB CNV",
    "SHB RNA",
    "SHB Proteo"
  ],
  "LY96": [
    "LY96 CNV",
    "LY96 RNA",
    "LY96 Proteo"
  ],
  "VN1R42P": [
    "VN1R42P CNV",
    "VN1R42P RNA"
  ],
  "SPACA5B": [
    "SPACA5B CNV",
    "SPACA5B RNA"
  ],
  "CWF19L1": [
    "CWF19L1 CNV",
    "CWF19L1 RNA",
    "CWF19L1 Proteo"
  ],
  "EVI2A": [
    "EVI2A CNV",
    "EVI2A RNA"
  ],
  "PLXND1": [
    "PLXND1 CNV",
    "PLXND1 RNA",
    "PLXND1 Proteo"
  ],
  "IGLV2-5": [
    "IGLV2-5 CNV",
    "IGLV2-5 RNA"
  ],
  "NMRAL2P": [
    "NMRAL2P CNV",
    "NMRAL2P RNA"
  ],
  "MTCO1P44": [
    "MTCO1P44 CNV",
    "MTCO1P44 RNA"
  ],
  "OR51G2": [
    "OR51G2 CNV",
    "OR51G2 RNA"
  ],
  "RNA5SP120": [
    "RNA5SP120 CNV",
    "RNA5SP120 RNA"
  ],
  "OR5D3P": [
    "OR5D3P CNV",
    "OR5D3P RNA"
  ],
  "SLFNL1": [
    "SLFNL1 CNV",
    "SLFNL1 RNA"
  ],
  "ABCF2": [
    "ABCF2 CNV",
    "ABCF2 RNA"
  ],
  "RINL": [
    "RINL CNV",
    "RINL RNA",
    "RINL Proteo"
  ],
  "GNG5P3": [
    "GNG5P3 CNV",
    "GNG5P3 RNA"
  ],
  "HLF": [
    "HLF CNV",
    "HLF RNA"
  ],
  "ASTN1": [
    "ASTN1 CNV",
    "ASTN1 RNA"
  ],
  "RFT1": [
    "RFT1 CNV",
    "RFT1 RNA",
    "RFT1 Proteo"
  ],
  "PNPLA10P": [
    "PNPLA10P CNV",
    "PNPLA10P RNA"
  ],
  "EGLN3P1": [
    "EGLN3P1 CNV",
    "EGLN3P1 RNA"
  ],
  "RHOH": [
    "RHOH CNV",
    "RHOH RNA",
    "RHOH Proteo"
  ],
  "THY1": [
    "THY1 CNV",
    "THY1 RNA",
    "THY1 Proteo"
  ],
  "EMD": [
    "EMD CNV",
    "EMD RNA",
    "EMD Proteo"
  ],
  "CCDC66": [
    "CCDC66 CNV",
    "CCDC66 RNA",
    "CCDC66 Proteo"
  ],
  "DNAJB9": [
    "DNAJB9 CNV",
    "DNAJB9 RNA",
    "DNAJB9 Proteo"
  ],
  "EN1": [
    "EN1 CNV",
    "EN1 RNA"
  ],
  "CA6": [
    "CA6 CNV",
    "CA6 RNA",
    "CA6 Proteo"
  ],
  "KRT8P28": [
    "KRT8P28 CNV",
    "KRT8P28 RNA"
  ],
  "H3P21": [
    "H3P21 CNV",
    "H3P21 RNA"
  ],
  "KPNA3": [
    "KPNA3 CNV",
    "KPNA3 RNA",
    "KPNA3 Proteo"
  ],
  "NBPF13P": [
    "NBPF13P CNV",
    "NBPF13P RNA"
  ],
  "IMMP1L": [
    "IMMP1L CNV",
    "IMMP1L RNA",
    "IMMP1L Proteo"
  ],
  "DUXAP3": [
    "DUXAP3 CNV",
    "DUXAP3 RNA"
  ],
  "HCAR2": [
    "HCAR2 CNV",
    "HCAR2 RNA"
  ],
  "NIFKP4": [
    "NIFKP4 CNV",
    "NIFKP4 RNA"
  ],
  "HNRNPA1P54": [
    "HNRNPA1P54 CNV",
    "HNRNPA1P54 RNA"
  ],
  "SERPINB5": [
    "SERPINB5 CNV",
    "SERPINB5 RNA",
    "SERPINB5 Proteo"
  ],
  "TERF1P1": [
    "TERF1P1 CNV",
    "TERF1P1 RNA"
  ],
  "KRTAP4-7": [
    "KRTAP4-7 CNV",
    "KRTAP4-7 RNA"
  ],
  "PAXX": [
    "PAXX CNV",
    "PAXX RNA",
    "PAXX Proteo"
  ],
  "FBLIM1P1": [
    "FBLIM1P1 CNV",
    "FBLIM1P1 RNA"
  ],
  "NOL4L": [
    "NOL4L CNV",
    "NOL4L RNA",
    "NOL4L Proteo"
  ],
  "MTCYBP4": [
    "MTCYBP4 CNV",
    "MTCYBP4 RNA"
  ],
  "IMPDH1P2": [
    "IMPDH1P2 CNV",
    "IMPDH1P2 RNA"
  ],
  "IL6R": [
    "IL6R CNV",
    "IL6R RNA",
    "IL6R Proteo"
  ],
  "CACNA2D2": [
    "CACNA2D2 CNV",
    "CACNA2D2 RNA",
    "CACNA2D2 Proteo"
  ],
  "CD79B": [
    "CD79B CNV",
    "CD79B RNA"
  ],
  "ERC1": [
    "ERC1 CNV",
    "ERC1 RNA",
    "ERC1 Proteo"
  ],
  "SLC16A7": [
    "SLC16A7 CNV",
    "SLC16A7 RNA",
    "SLC16A7 Proteo"
  ],
  "ZNF962P": [
    "ZNF962P CNV",
    "ZNF962P RNA"
  ],
  "ZNF428": [
    "ZNF428 CNV",
    "ZNF428 RNA",
    "ZNF428 Proteo"
  ],
  "OR7E38P": [
    "OR7E38P CNV",
    "OR7E38P RNA"
  ],
  "KRT18P4": [
    "KRT18P4 CNV",
    "KRT18P4 RNA"
  ],
  "ITFG2": [
    "ITFG2 CNV",
    "ITFG2 RNA",
    "ITFG2 Proteo"
  ],
  "AKR1B1P2": [
    "AKR1B1P2 CNV",
    "AKR1B1P2 RNA"
  ],
  "NSUN5P2": [
    "NSUN5P2 CNV",
    "NSUN5P2 RNA"
  ],
  "FAM238B": [
    "FAM238B CNV",
    "FAM238B RNA"
  ],
  "ZNF808": [
    "ZNF808 CNV",
    "ZNF808 RNA",
    "ZNF808 Proteo"
  ],
  "MRPS21P9": [
    "MRPS21P9 CNV",
    "MRPS21P9 RNA"
  ],
  "MIS18A": [
    "MIS18A CNV",
    "MIS18A RNA",
    "MIS18A Proteo"
  ],
  "RPRML": [
    "RPRML CNV",
    "RPRML RNA"
  ],
  "PAK3": [
    "PAK3 CNV",
    "PAK3 RNA"
  ],
  "RNF126P1": [
    "RNF126P1 CNV",
    "RNF126P1 RNA"
  ],
  "ADGRE5": [
    "ADGRE5 CNV",
    "ADGRE5 RNA",
    "ADGRE5 Proteo"
  ],
  "OR2A5": [
    "OR2A5 CNV",
    "OR2A5 RNA"
  ],
  "MTND3P15": [
    "MTND3P15 CNV",
    "MTND3P15 RNA"
  ],
  "IGHV1OR15-3": [
    "IGHV1OR15-3 CNV",
    "IGHV1OR15-3 RNA"
  ],
  "OR10G8": [
    "OR10G8 CNV",
    "OR10G8 RNA"
  ],
  "ARSD": [
    "ARSD CNV",
    "ARSD RNA",
    "ARSD Proteo"
  ],
  "MORF4L1P3": [
    "MORF4L1P3 CNV",
    "MORF4L1P3 RNA"
  ],
  "TGM2": [
    "TGM2 CNV",
    "TGM2 RNA",
    "TGM2 Proteo"
  ],
  "EDDM3B": [
    "EDDM3B CNV",
    "EDDM3B RNA"
  ],
  "FAN1": [
    "FAN1 CNV",
    "FAN1 RNA",
    "FAN1 Proteo"
  ],
  "GBA2": [
    "GBA2 CNV",
    "GBA2 RNA",
    "GBA2 Proteo"
  ],
  "ARHGAP30": [
    "ARHGAP30 CNV",
    "ARHGAP30 RNA",
    "ARHGAP30 Proteo"
  ],
  "LAPTM4BP1": [
    "LAPTM4BP1 CNV",
    "LAPTM4BP1 RNA"
  ],
  "KRT72": [
    "KRT72 CNV",
    "KRT72 RNA",
    "KRT72 Proteo"
  ],
  "IQCH": [
    "IQCH CNV",
    "IQCH RNA"
  ],
  "IGF2BP2": [
    "IGF2BP2 CNV",
    "IGF2BP2 RNA",
    "IGF2BP2 Proteo"
  ],
  "CCL4": [
    "CCL4 CNV",
    "CCL4 RNA"
  ],
  "CTTNBP2": [
    "CTTNBP2 CNV",
    "CTTNBP2 RNA",
    "CTTNBP2 Proteo"
  ],
  "KRT23": [
    "KRT23 CNV",
    "KRT23 RNA",
    "KRT23 Proteo"
  ],
  "SH3BP4": [
    "SH3BP4 CNV",
    "SH3BP4 RNA",
    "SH3BP4 Proteo"
  ],
  "SLC25A38": [
    "SLC25A38 CNV",
    "SLC25A38 RNA",
    "SLC25A38 Proteo"
  ],
  "NUPR1": [
    "NUPR1 CNV",
    "NUPR1 RNA",
    "NUPR1 Proteo"
  ],
  "SRIP2": [
    "SRIP2 CNV",
    "SRIP2 RNA"
  ],
  "HAGHL": [
    "HAGHL CNV",
    "HAGHL RNA",
    "HAGHL Proteo"
  ],
  "CNOT7": [
    "CNOT7 CNV",
    "CNOT7 RNA",
    "CNOT7 Proteo"
  ],
  "ALB": [
    "ALB CNV",
    "ALB RNA",
    "ALB Proteo"
  ],
  "HBB": [
    "HBB CNV",
    "HBB RNA",
    "HBB Proteo"
  ],
  "RNF24": [
    "RNF24 CNV",
    "RNF24 RNA"
  ],
  "CSTL1": [
    "CSTL1 CNV",
    "CSTL1 RNA"
  ],
  "UBE2S": [
    "UBE2S CNV",
    "UBE2S RNA",
    "UBE2S Proteo"
  ],
  "TRPV5": [
    "TRPV5 CNV",
    "TRPV5 RNA"
  ],
  "ZNF853": [
    "ZNF853 CNV",
    "ZNF853 RNA",
    "ZNF853 Proteo"
  ],
  "MLNR": [
    "MLNR CNV",
    "MLNR RNA"
  ],
  "EEF1B2P8": [
    "EEF1B2P8 CNV",
    "EEF1B2P8 RNA"
  ],
  "SELENOKP1": [
    "SELENOKP1 CNV",
    "SELENOKP1 RNA"
  ],
  "ASB2": [
    "ASB2 CNV",
    "ASB2 RNA"
  ],
  "GPR152": [
    "GPR152 CNV",
    "GPR152 RNA"
  ],
  "VN2R10P": [
    "VN2R10P CNV",
    "VN2R10P RNA"
  ],
  "ELOCP22": [
    "ELOCP22 CNV",
    "ELOCP22 RNA"
  ],
  "OR51H1": [
    "OR51H1 CNV",
    "OR51H1 RNA"
  ],
  "DAPK1": [
    "DAPK1 CNV",
    "DAPK1 RNA",
    "DAPK1 Proteo"
  ],
  "EXOSC8": [
    "EXOSC8 CNV",
    "EXOSC8 RNA",
    "EXOSC8 Proteo"
  ],
  "TMED10P2": [
    "TMED10P2 CNV",
    "TMED10P2 RNA"
  ],
  "RPL8": [
    "RPL8 CNV",
    "RPL8 RNA",
    "RPL8 Proteo"
  ],
  "SMTNL2": [
    "SMTNL2 CNV",
    "SMTNL2 RNA"
  ],
  "SIRPB1": [
    "SIRPB1 CNV",
    "SIRPB1 RNA",
    "SIRPB1 Proteo"
  ],
  "PIK3IP1": [
    "PIK3IP1 CNV",
    "PIK3IP1 RNA",
    "PIK3IP1 Proteo"
  ],
  "RPS27A": [
    "RPS27A CNV",
    "RPS27A RNA",
    "RPS27A Proteo"
  ],
  "CCDC9B": [
    "CCDC9B CNV",
    "CCDC9B RNA",
    "CCDC9B Proteo"
  ],
  "CEMP1": [
    "CEMP1 CNV",
    "CEMP1 RNA"
  ],
  "SMIM7P1": [
    "SMIM7P1 CNV",
    "SMIM7P1 RNA"
  ],
  "IDH3G": [
    "IDH3G CNV",
    "IDH3G RNA",
    "IDH3G Proteo"
  ],
  "RRN3": [
    "RRN3 CNV",
    "RRN3 RNA",
    "RRN3 Proteo"
  ],
  "HMGN1P35": [
    "HMGN1P35 CNV",
    "HMGN1P35 RNA"
  ],
  "IHO1": [
    "IHO1 CNV",
    "IHO1 RNA"
  ],
  "PTMS": [
    "PTMS CNV",
    "PTMS RNA",
    "PTMS Proteo"
  ],
  "MYORG": [
    "MYORG CNV",
    "MYORG RNA",
    "MYORG Proteo"
  ],
  "RGPD6": [
    "RGPD6 CNV",
    "RGPD6 RNA",
    "RGPD6 Proteo"
  ],
  "OR7E35P": [
    "OR7E35P CNV",
    "OR7E35P RNA"
  ],
  "RPS15AP7": [
    "RPS15AP7 CNV",
    "RPS15AP7 RNA"
  ],
  "PDCD5": [
    "PDCD5 CNV",
    "PDCD5 RNA",
    "PDCD5 Proteo"
  ],
  "SELE": [
    "SELE CNV",
    "SELE RNA"
  ],
  "ZFTRAF1": [
    "ZFTRAF1 CNV",
    "ZFTRAF1 RNA",
    "ZFTRAF1 Proteo"
  ],
  "RPS26P13": [
    "RPS26P13 CNV",
    "RPS26P13 RNA"
  ],
  "BIRC3": [
    "BIRC3 CNV",
    "BIRC3 RNA"
  ],
  "GOLPH3L": [
    "GOLPH3L CNV",
    "GOLPH3L RNA",
    "GOLPH3L Proteo"
  ],
  "AGAP14P": [
    "AGAP14P CNV",
    "AGAP14P RNA"
  ],
  "THEM5": [
    "THEM5 CNV",
    "THEM5 RNA",
    "THEM5 Proteo"
  ],
  "SLC35D2": [
    "SLC35D2 CNV",
    "SLC35D2 RNA",
    "SLC35D2 Proteo"
  ],
  "OR8B3": [
    "OR8B3 CNV",
    "OR8B3 RNA"
  ],
  "LDHC": [
    "LDHC CNV",
    "LDHC RNA",
    "LDHC Proteo"
  ],
  "MTND3P4": [
    "MTND3P4 CNV",
    "MTND3P4 RNA"
  ],
  "ZSWIM1": [
    "ZSWIM1 CNV",
    "ZSWIM1 RNA"
  ],
  "ACTP1": [
    "ACTP1 CNV",
    "ACTP1 RNA"
  ],
  "SULT1C2P2": [
    "SULT1C2P2 CNV",
    "SULT1C2P2 RNA"
  ],
  "CFL1P1": [
    "CFL1P1 CNV",
    "CFL1P1 RNA"
  ],
  "SLC66A2": [
    "SLC66A2 CNV",
    "SLC66A2 RNA",
    "SLC66A2 Proteo"
  ],
  "ANKRD36P1": [
    "ANKRD36P1 CNV",
    "ANKRD36P1 RNA"
  ],
  "FNTB": [
    "FNTB CNV",
    "FNTB RNA",
    "FNTB Proteo"
  ],
  "GRB14": [
    "GRB14 CNV",
    "GRB14 RNA"
  ],
  "MTCO2P29": [
    "MTCO2P29 CNV",
    "MTCO2P29 RNA"
  ],
  "WBP2": [
    "WBP2 CNV",
    "WBP2 RNA",
    "WBP2 Proteo"
  ],
  "SLC27A5": [
    "SLC27A5 CNV",
    "SLC27A5 RNA"
  ],
  "FSCN2": [
    "FSCN2 CNV",
    "FSCN2 RNA",
    "FSCN2 Proteo"
  ],
  "ANO4": [
    "ANO4 CNV",
    "ANO4 RNA"
  ],
  "DHPS": [
    "DHPS CNV",
    "DHPS RNA",
    "DHPS Proteo"
  ],
  "FRMD8": [
    "FRMD8 CNV",
    "FRMD8 RNA",
    "FRMD8 Proteo"
  ],
  "RAP1BP2": [
    "RAP1BP2 CNV",
    "RAP1BP2 RNA"
  ],
  "LINC00993": [
    "LINC00993 CNV",
    "LINC00993 RNA"
  ],
  "URI1": [
    "URI1 CNV",
    "URI1 RNA",
    "URI1 Proteo"
  ],
  "VENTX": [
    "VENTX CNV",
    "VENTX RNA"
  ],
  "KLF2": [
    "KLF2 CNV",
    "KLF2 RNA",
    "KLF2 Proteo"
  ],
  "RPL9P6": [
    "RPL9P6 CNV",
    "RPL9P6 RNA"
  ],
  "CCDC70": [
    "CCDC70 CNV",
    "CCDC70 RNA"
  ],
  "RFC3": [
    "RFC3 CNV",
    "RFC3 RNA",
    "RFC3 Proteo"
  ],
  "TXNL4AP1": [
    "TXNL4AP1 CNV",
    "TXNL4AP1 RNA"
  ],
  "YWHAQ": [
    "YWHAQ CNV",
    "YWHAQ RNA",
    "YWHAQ Proteo"
  ],
  "TP53": [
    "TP53 CNV",
    "TP53 RNA",
    "TP53 Proteo"
  ],
  "PBDC1": [
    "PBDC1 CNV",
    "PBDC1 RNA",
    "PBDC1 Proteo"
  ],
  "PHIP": [
    "PHIP CNV",
    "PHIP RNA",
    "PHIP Proteo"
  ],
  "RIPOR2": [
    "RIPOR2 CNV",
    "RIPOR2 RNA",
    "RIPOR2 Proteo"
  ],
  "SRSF5": [
    "SRSF5 CNV",
    "SRSF5 RNA",
    "SRSF5 Proteo"
  ],
  "RPL38P2": [
    "RPL38P2 CNV",
    "RPL38P2 RNA"
  ],
  "EEF1D": [
    "EEF1D CNV",
    "EEF1D RNA",
    "EEF1D Proteo"
  ],
  "H1-4": [
    "H1-4 CNV",
    "H1-4 RNA",
    "H1-4 Proteo"
  ],
  "PPATP2": [
    "PPATP2 CNV",
    "PPATP2 RNA"
  ],
  "EIF3J": [
    "EIF3J CNV",
    "EIF3J RNA",
    "EIF3J Proteo"
  ],
  "RPL36P11": [
    "RPL36P11 CNV",
    "RPL36P11 RNA"
  ],
  "ERLEC1P1": [
    "ERLEC1P1 CNV",
    "ERLEC1P1 RNA"
  ],
  "NF2": [
    "NF2 CNV",
    "NF2 RNA",
    "NF2 Proteo"
  ],
  "OR5F2P": [
    "OR5F2P CNV",
    "OR5F2P RNA"
  ],
  "RNF2": [
    "RNF2 CNV",
    "RNF2 RNA",
    "RNF2 Proteo"
  ],
  "ZWINT": [
    "ZWINT CNV",
    "ZWINT RNA",
    "ZWINT Proteo"
  ],
  "SEPTIN14P8": [
    "SEPTIN14P8 CNV",
    "SEPTIN14P8 RNA"
  ],
  "FSTL3": [
    "FSTL3 CNV",
    "FSTL3 RNA",
    "FSTL3 Proteo"
  ],
  "PRPS2": [
    "PRPS2 CNV",
    "PRPS2 RNA",
    "PRPS2 Proteo"
  ],
  "EIF3G": [
    "EIF3G CNV",
    "EIF3G RNA",
    "EIF3G Proteo"
  ],
  "DRD2": [
    "DRD2 CNV",
    "DRD2 RNA"
  ],
  "SELENOK": [
    "SELENOK CNV",
    "SELENOK RNA",
    "SELENOK Proteo"
  ],
  "DDX55P1": [
    "DDX55P1 CNV",
    "DDX55P1 RNA"
  ],
  "SOGA1": [
    "SOGA1 CNV",
    "SOGA1 RNA",
    "SOGA1 Proteo"
  ],
  "MAU2": [
    "MAU2 CNV",
    "MAU2 RNA",
    "MAU2 Proteo"
  ],
  "RPL7AP57": [
    "RPL7AP57 CNV",
    "RPL7AP57 RNA"
  ],
  "SPRTN": [
    "SPRTN CNV",
    "SPRTN RNA",
    "SPRTN Proteo"
  ],
  "TPST2P1": [
    "TPST2P1 CNV",
    "TPST2P1 RNA"
  ],
  "ZNF888": [
    "ZNF888 CNV",
    "ZNF888 RNA"
  ],
  "RTL6": [
    "RTL6 CNV",
    "RTL6 RNA"
  ],
  "TST": [
    "TST CNV",
    "TST RNA",
    "TST Proteo"
  ],
  "SLFN13": [
    "SLFN13 CNV",
    "SLFN13 RNA",
    "SLFN13 Proteo"
  ],
  "RASSF1": [
    "RASSF1 CNV",
    "RASSF1 RNA",
    "RASSF1 Proteo"
  ],
  "H2BP9": [
    "H2BP9 CNV",
    "H2BP9 RNA"
  ],
  "ABHD17B": [
    "ABHD17B CNV",
    "ABHD17B RNA",
    "ABHD17B Proteo"
  ],
  "WNT5A": [
    "WNT5A CNV",
    "WNT5A RNA",
    "WNT5A Proteo"
  ],
  "OR52J3": [
    "OR52J3 CNV",
    "OR52J3 RNA"
  ],
  "RNA5SP389": [
    "RNA5SP389 CNV",
    "RNA5SP389 RNA"
  ],
  "MTND3P16": [
    "MTND3P16 CNV",
    "MTND3P16 RNA"
  ],
  "HNRNPA1P23": [
    "HNRNPA1P23 CNV",
    "HNRNPA1P23 RNA"
  ],
  "CCDC92B": [
    "CCDC92B CNV",
    "CCDC92B RNA"
  ],
  "TAF4": [
    "TAF4 CNV",
    "TAF4 RNA",
    "TAF4 Proteo"
  ],
  "PM20D1": [
    "PM20D1 CNV",
    "PM20D1 RNA",
    "PM20D1 Proteo"
  ],
  "AMDHD2": [
    "AMDHD2 CNV",
    "AMDHD2 RNA",
    "AMDHD2 Proteo"
  ],
  "NUCB1": [
    "NUCB1 CNV",
    "NUCB1 RNA",
    "NUCB1 Proteo"
  ],
  "RTN1": [
    "RTN1 CNV",
    "RTN1 RNA",
    "RTN1 Proteo"
  ],
  "USP37": [
    "USP37 CNV",
    "USP37 RNA",
    "USP37 Proteo"
  ],
  "SPTA1": [
    "SPTA1 CNV",
    "SPTA1 RNA",
    "SPTA1 Proteo"
  ],
  "TMEM9B": [
    "TMEM9B CNV",
    "TMEM9B RNA",
    "TMEM9B Proteo"
  ],
  "TFAP2D": [
    "TFAP2D CNV",
    "TFAP2D RNA"
  ],
  "KRT18": [
    "KRT18 CNV",
    "KRT18 RNA",
    "KRT18 Proteo"
  ],
  "WAC": [
    "WAC CNV",
    "WAC RNA",
    "WAC Proteo"
  ],
  "AGPAT5": [
    "AGPAT5 CNV",
    "AGPAT5 RNA",
    "AGPAT5 Proteo"
  ],
  "MDM4": [
    "MDM4 CNV",
    "MDM4 RNA",
    "MDM4 Proteo"
  ],
  "IGKV2-30": [
    "IGKV2-30 Proteo"
  ],
  "SRI": [
    "SRI CNV",
    "SRI RNA",
    "SRI Proteo"
  ],
  "SMIM11": [
    "SMIM11 CNV",
    "SMIM11 RNA"
  ],
  "RPL37P13": [
    "RPL37P13 CNV",
    "RPL37P13 RNA"
  ],
  "LYPD1": [
    "LYPD1 CNV",
    "LYPD1 RNA"
  ],
  "HMX1": [
    "HMX1 CNV",
    "HMX1 RNA"
  ],
  "RPSAP27": [
    "RPSAP27 CNV",
    "RPSAP27 RNA"
  ],
  "FTLP8": [
    "FTLP8 CNV",
    "FTLP8 RNA"
  ],
  "CLDN22": [
    "CLDN22 CNV",
    "CLDN22 RNA"
  ],
  "MYZAP": [
    "MYZAP CNV",
    "MYZAP RNA"
  ],
  "PCSK5": [
    "PCSK5 CNV",
    "PCSK5 RNA",
    "PCSK5 Proteo"
  ],
  "PIK3AP1": [
    "PIK3AP1 CNV",
    "PIK3AP1 RNA",
    "PIK3AP1 Proteo"
  ],
  "FAM236C": [
    "FAM236C CNV",
    "FAM236C RNA"
  ],
  "NBPF11": [
    "NBPF11 CNV",
    "NBPF11 RNA"
  ],
  "KRTAP8-3P": [
    "KRTAP8-3P CNV",
    "KRTAP8-3P RNA"
  ],
  "GFY": [
    "GFY CNV",
    "GFY RNA"
  ],
  "PXYLP1": [
    "PXYLP1 CNV",
    "PXYLP1 RNA",
    "PXYLP1 Proteo"
  ],
  "PPP2R5D": [
    "PPP2R5D CNV",
    "PPP2R5D RNA",
    "PPP2R5D Proteo"
  ],
  "SUSD2P2": [
    "SUSD2P2 CNV",
    "SUSD2P2 RNA"
  ],
  "HNRNPKP2": [
    "HNRNPKP2 CNV",
    "HNRNPKP2 RNA"
  ],
  "MAML3": [
    "MAML3 CNV",
    "MAML3 RNA",
    "MAML3 Proteo"
  ],
  "RPS13": [
    "RPS13 CNV",
    "RPS13 RNA",
    "RPS13 Proteo"
  ],
  "SPTAN1": [
    "SPTAN1 CNV",
    "SPTAN1 RNA",
    "SPTAN1 Proteo"
  ],
  "RBM17P1": [
    "RBM17P1 CNV",
    "RBM17P1 RNA"
  ],
  "IGBP1P5": [
    "IGBP1P5 CNV",
    "IGBP1P5 RNA"
  ],
  "SCYGR2": [
    "SCYGR2 CNV",
    "SCYGR2 RNA"
  ],
  "MTPN": [
    "MTPN CNV",
    "MTPN RNA",
    "MTPN Proteo"
  ],
  "MTCO1P4": [
    "MTCO1P4 CNV",
    "MTCO1P4 RNA"
  ],
  "ASIP": [
    "ASIP CNV",
    "ASIP RNA"
  ],
  "ZNF677": [
    "ZNF677 CNV",
    "ZNF677 RNA"
  ],
  "ATP6V1FNB": [
    "ATP6V1FNB CNV",
    "ATP6V1FNB RNA"
  ],
  "FGF3": [
    "FGF3 CNV",
    "FGF3 RNA"
  ],
  "DYRK3": [
    "DYRK3 CNV",
    "DYRK3 RNA"
  ],
  "TUT4": [
    "TUT4 CNV",
    "TUT4 RNA",
    "TUT4 Proteo"
  ],
  "PLA1A": [
    "PLA1A CNV",
    "PLA1A RNA",
    "PLA1A Proteo"
  ],
  "CDY13P": [
    "CDY13P CNV",
    "CDY13P RNA"
  ],
  "TJP2": [
    "TJP2 CNV",
    "TJP2 RNA",
    "TJP2 Proteo"
  ],
  "TXNIP": [
    "TXNIP CNV",
    "TXNIP RNA",
    "TXNIP Proteo"
  ],
  "TYW3": [
    "TYW3 CNV",
    "TYW3 RNA",
    "TYW3 Proteo"
  ],
  "PMS2P10": [
    "PMS2P10 CNV",
    "PMS2P10 RNA"
  ],
  "ARID3B": [
    "ARID3B CNV",
    "ARID3B RNA",
    "ARID3B Proteo"
  ],
  "LIX1": [
    "LIX1 CNV",
    "LIX1 RNA"
  ],
  "KRTAP9-6": [
    "KRTAP9-6 CNV",
    "KRTAP9-6 RNA"
  ],
  "TSPAN31": [
    "TSPAN31 CNV",
    "TSPAN31 RNA",
    "TSPAN31 Proteo"
  ],
  "UBL4A": [
    "UBL4A CNV",
    "UBL4A RNA",
    "UBL4A Proteo"
  ],
  "TMED8": [
    "TMED8 CNV",
    "TMED8 RNA",
    "TMED8 Proteo"
  ],
  "GTSF1": [
    "GTSF1 CNV",
    "GTSF1 RNA",
    "GTSF1 Proteo"
  ],
  "PTCD2P1": [
    "PTCD2P1 CNV",
    "PTCD2P1 RNA"
  ],
  "ARX": [
    "ARX CNV",
    "ARX RNA"
  ],
  "ADAM33": [
    "ADAM33 CNV",
    "ADAM33 RNA"
  ],
  "GDF11": [
    "GDF11 CNV",
    "GDF11 RNA"
  ],
  "SLC23A2": [
    "SLC23A2 CNV",
    "SLC23A2 RNA",
    "SLC23A2 Proteo"
  ],
  "POLR1G": [
    "POLR1G CNV",
    "POLR1G RNA",
    "POLR1G Proteo"
  ],
  "RCC1": [
    "RCC1 CNV",
    "RCC1 RNA",
    "RCC1 Proteo"
  ],
  "RHOQ": [
    "RHOQ CNV",
    "RHOQ RNA",
    "RHOQ Proteo"
  ],
  "MTCYBP11": [
    "MTCYBP11 CNV",
    "MTCYBP11 RNA"
  ],
  "FBXO36P1": [
    "FBXO36P1 CNV",
    "FBXO36P1 RNA"
  ],
  "KRT8P30": [
    "KRT8P30 CNV",
    "KRT8P30 RNA"
  ],
  "TMEM95": [
    "TMEM95 CNV",
    "TMEM95 RNA"
  ],
  "TRIT1": [
    "TRIT1 CNV",
    "TRIT1 RNA",
    "TRIT1 Proteo"
  ],
  "ZNF626": [
    "ZNF626 CNV",
    "ZNF626 RNA"
  ],
  "TAF6": [
    "TAF6 CNV",
    "TAF6 RNA",
    "TAF6 Proteo"
  ],
  "KRT78": [
    "KRT78 CNV",
    "KRT78 RNA",
    "KRT78 Proteo"
  ],
  "PPP1CB": [
    "PPP1CB CNV",
    "PPP1CB RNA",
    "PPP1CB Proteo"
  ],
  "FLT3LG": [
    "FLT3LG CNV",
    "FLT3LG RNA"
  ],
  "OR51B4": [
    "OR51B4 CNV",
    "OR51B4 RNA"
  ],
  "CYB5D1": [
    "CYB5D1 CNV",
    "CYB5D1 RNA"
  ],
  "DRC7": [
    "DRC7 CNV",
    "DRC7 RNA"
  ],
  "TRBVB": [
    "TRBVB CNV",
    "TRBVB RNA"
  ],
  "BMP10": [
    "BMP10 CNV",
    "BMP10 RNA"
  ],
  "KMO": [
    "KMO CNV",
    "KMO RNA",
    "KMO Proteo"
  ],
  "HOXD13": [
    "HOXD13 CNV",
    "HOXD13 RNA",
    "HOXD13 Proteo"
  ],
  "CDC27": [
    "CDC27 CNV",
    "CDC27 RNA",
    "CDC27 Proteo"
  ],
  "PHRF1": [
    "PHRF1 CNV",
    "PHRF1 RNA",
    "PHRF1 Proteo"
  ],
  "ZNF16": [
    "ZNF16 CNV",
    "ZNF16 RNA",
    "ZNF16 Proteo"
  ],
  "SCARF1": [
    "SCARF1 CNV",
    "SCARF1 RNA",
    "SCARF1 Proteo"
  ],
  "RASL12": [
    "RASL12 CNV",
    "RASL12 RNA",
    "RASL12 Proteo"
  ],
  "RPS3AP20": [
    "RPS3AP20 CNV",
    "RPS3AP20 RNA"
  ],
  "PABIR1": [
    "PABIR1 CNV",
    "PABIR1 RNA",
    "PABIR1 Proteo"
  ],
  "KAT7": [
    "KAT7 CNV",
    "KAT7 RNA",
    "KAT7 Proteo"
  ],
  "BCAS2P1": [
    "BCAS2P1 CNV",
    "BCAS2P1 RNA"
  ],
  "RPL35AP24": [
    "RPL35AP24 CNV",
    "RPL35AP24 RNA"
  ],
  "OR1J2": [
    "OR1J2 CNV",
    "OR1J2 RNA"
  ],
  "STUM": [
    "STUM CNV",
    "STUM RNA"
  ],
  "CHEK2P6": [
    "CHEK2P6 CNV",
    "CHEK2P6 RNA"
  ],
  "RABGEF1P1": [
    "RABGEF1P1 CNV",
    "RABGEF1P1 RNA"
  ],
  "RCOR3": [
    "RCOR3 CNV",
    "RCOR3 RNA",
    "RCOR3 Proteo"
  ],
  "HNRNPA1P24": [
    "HNRNPA1P24 CNV",
    "HNRNPA1P24 RNA"
  ],
  "IMPA1": [
    "IMPA1 CNV",
    "IMPA1 RNA",
    "IMPA1 Proteo"
  ],
  "SPIDR": [
    "SPIDR CNV",
    "SPIDR RNA",
    "SPIDR Proteo"
  ],
  "MTCO3P42": [
    "MTCO3P42 CNV",
    "MTCO3P42 RNA"
  ],
  "DNAI2": [
    "DNAI2 CNV",
    "DNAI2 RNA"
  ],
  "ABT1P1": [
    "ABT1P1 CNV",
    "ABT1P1 RNA"
  ],
  "C9orf43": [
    "C9orf43 CNV",
    "C9orf43 RNA"
  ],
  "OXNAD1": [
    "OXNAD1 CNV",
    "OXNAD1 RNA",
    "OXNAD1 Proteo"
  ],
  "CCDC78": [
    "CCDC78 CNV",
    "CCDC78 RNA"
  ],
  "RHOQP2": [
    "RHOQP2 CNV",
    "RHOQP2 RNA"
  ],
  "FCGRT": [
    "FCGRT CNV",
    "FCGRT RNA",
    "FCGRT Proteo"
  ],
  "SPATA5L1": [
    "SPATA5L1 CNV",
    "SPATA5L1 RNA",
    "SPATA5L1 Proteo"
  ],
  "GSTA4": [
    "GSTA4 CNV",
    "GSTA4 RNA",
    "GSTA4 Proteo"
  ],
  "GOLGA8J": [
    "GOLGA8J CNV",
    "GOLGA8J RNA"
  ],
  "LDLRAP1": [
    "LDLRAP1 CNV",
    "LDLRAP1 RNA",
    "LDLRAP1 Proteo"
  ],
  "VPS37C": [
    "VPS37C CNV",
    "VPS37C RNA",
    "VPS37C Proteo"
  ],
  "ATP5F1A": [
    "ATP5F1A CNV",
    "ATP5F1A RNA",
    "ATP5F1A Proteo"
  ],
  "AARS1P1": [
    "AARS1P1 CNV",
    "AARS1P1 RNA"
  ],
  "WNT7B": [
    "WNT7B CNV",
    "WNT7B RNA"
  ],
  "PROX2": [
    "PROX2 CNV",
    "PROX2 RNA"
  ],
  "ZCWPW1": [
    "ZCWPW1 CNV",
    "ZCWPW1 RNA"
  ],
  "DEFB135": [
    "DEFB135 CNV",
    "DEFB135 RNA"
  ],
  "MTND1P9": [
    "MTND1P9 CNV",
    "MTND1P9 RNA"
  ],
  "RHOXF1P1": [
    "RHOXF1P1 CNV",
    "RHOXF1P1 RNA"
  ],
  "CFC1B": [
    "CFC1B CNV",
    "CFC1B RNA"
  ],
  "MICU1": [
    "MICU1 CNV",
    "MICU1 RNA",
    "MICU1 Proteo"
  ],
  "RAB12": [
    "RAB12 CNV",
    "RAB12 RNA",
    "RAB12 Proteo"
  ],
  "SYN2": [
    "SYN2 CNV",
    "SYN2 RNA"
  ],
  "RAP1AP": [
    "RAP1AP CNV",
    "RAP1AP RNA"
  ],
  "PPIH": [
    "PPIH CNV",
    "PPIH RNA",
    "PPIH Proteo"
  ],
  "TMEM98": [
    "TMEM98 CNV",
    "TMEM98 RNA",
    "TMEM98 Proteo"
  ],
  "CFAP53": [
    "CFAP53 CNV",
    "CFAP53 RNA"
  ],
  "CRYZL1": [
    "CRYZL1 CNV",
    "CRYZL1 RNA",
    "CRYZL1 Proteo"
  ],
  "TMPRSS9": [
    "TMPRSS9 CNV",
    "TMPRSS9 RNA"
  ],
  "RHBDL1": [
    "RHBDL1 CNV",
    "RHBDL1 RNA"
  ],
  "RPL36AP54": [
    "RPL36AP54 CNV",
    "RPL36AP54 RNA"
  ],
  "IGKV2D-19": [
    "IGKV2D-19 CNV",
    "IGKV2D-19 RNA"
  ],
  "SEPTIN14P24": [
    "SEPTIN14P24 CNV",
    "SEPTIN14P24 RNA"
  ],
  "RNF5": [
    "RNF5 CNV",
    "RNF5 RNA",
    "RNF5 Proteo"
  ],
  "OR8R1P": [
    "OR8R1P CNV",
    "OR8R1P RNA"
  ],
  "FBXO22": [
    "FBXO22 CNV",
    "FBXO22 RNA",
    "FBXO22 Proteo"
  ],
  "HNRNPD": [
    "HNRNPD CNV",
    "HNRNPD RNA",
    "HNRNPD Proteo"
  ],
  "ERVW-1": [
    "ERVW-1 CNV",
    "ERVW-1 RNA"
  ],
  "LGI2": [
    "LGI2 CNV",
    "LGI2 RNA"
  ],
  "PIEZO1": [
    "PIEZO1 CNV",
    "PIEZO1 RNA",
    "PIEZO1 Proteo"
  ],
  "SPATC1": [
    "SPATC1 CNV",
    "SPATC1 RNA"
  ],
  "METAP2": [
    "METAP2 CNV",
    "METAP2 RNA",
    "METAP2 Proteo"
  ],
  "TXNL4B": [
    "TXNL4B CNV",
    "TXNL4B RNA",
    "TXNL4B Proteo"
  ],
  "C9orf153": [
    "C9orf153 CNV",
    "C9orf153 RNA"
  ],
  "SLC45A3": [
    "SLC45A3 CNV",
    "SLC45A3 RNA"
  ],
  "RPS6P15": [
    "RPS6P15 CNV",
    "RPS6P15 RNA"
  ],
  "RPL6P26": [
    "RPL6P26 CNV",
    "RPL6P26 RNA"
  ],
  "TNS2": [
    "TNS2 CNV",
    "TNS2 RNA",
    "TNS2 Proteo"
  ],
  "MICOS13": [
    "MICOS13 CNV",
    "MICOS13 RNA",
    "MICOS13 Proteo"
  ],
  "MTCO1P48": [
    "MTCO1P48 CNV",
    "MTCO1P48 RNA"
  ],
  "MCM3": [
    "MCM3 CNV",
    "MCM3 RNA",
    "MCM3 Proteo"
  ],
  "ADORA2BP1": [
    "ADORA2BP1 CNV",
    "ADORA2BP1 RNA"
  ],
  "CRY2": [
    "CRY2 CNV",
    "CRY2 RNA",
    "CRY2 Proteo"
  ],
  "UBA52P9": [
    "UBA52P9 CNV",
    "UBA52P9 RNA"
  ],
  "PDS5B": [
    "PDS5B CNV",
    "PDS5B RNA",
    "PDS5B Proteo"
  ],
  "OSBPL8": [
    "OSBPL8 CNV",
    "OSBPL8 RNA",
    "OSBPL8 Proteo"
  ],
  "NDUFS5P2": [
    "NDUFS5P2 CNV",
    "NDUFS5P2 RNA"
  ],
  "ELOVL6": [
    "ELOVL6 CNV",
    "ELOVL6 RNA"
  ],
  "TBC1D3L": [
    "TBC1D3L CNV",
    "TBC1D3L RNA"
  ],
  "EPS15": [
    "EPS15 CNV",
    "EPS15 RNA",
    "EPS15 Proteo"
  ],
  "TRIM13": [
    "TRIM13 CNV",
    "TRIM13 RNA",
    "TRIM13 Proteo"
  ],
  "TNRC18P2": [
    "TNRC18P2 CNV",
    "TNRC18P2 RNA"
  ],
  "CABP4": [
    "CABP4 CNV",
    "CABP4 RNA"
  ],
  "LIPJ": [
    "LIPJ CNV",
    "LIPJ RNA"
  ],
  "SLC25A51P1": [
    "SLC25A51P1 CNV",
    "SLC25A51P1 RNA"
  ],
  "ARV1": [
    "ARV1 CNV",
    "ARV1 RNA",
    "ARV1 Proteo"
  ],
  "NDUFC1": [
    "NDUFC1 CNV",
    "NDUFC1 RNA",
    "NDUFC1 Proteo"
  ],
  "SGCD": [
    "SGCD CNV",
    "SGCD RNA",
    "SGCD Proteo"
  ],
  "RNLS": [
    "RNLS CNV",
    "RNLS RNA",
    "RNLS Proteo"
  ],
  "NAPRT": [
    "NAPRT CNV",
    "NAPRT RNA",
    "NAPRT Proteo"
  ],
  "ABHD17AP7": [
    "ABHD17AP7 CNV",
    "ABHD17AP7 RNA"
  ],
  "OR5M2P": [
    "OR5M2P CNV",
    "OR5M2P RNA"
  ],
  "TMEM233": [
    "TMEM233 CNV",
    "TMEM233 RNA"
  ],
  "SPATA31A7": [
    "SPATA31A7 CNV",
    "SPATA31A7 RNA"
  ],
  "IL34": [
    "IL34 CNV",
    "IL34 RNA"
  ],
  "HLA-S": [
    "HLA-S CNV",
    "HLA-S RNA"
  ],
  "AVP": [
    "AVP CNV",
    "AVP RNA"
  ],
  "ZSCAN5C": [
    "ZSCAN5C CNV",
    "ZSCAN5C RNA"
  ],
  "TRIB2": [
    "TRIB2 CNV",
    "TRIB2 RNA"
  ],
  "VAPB": [
    "VAPB CNV",
    "VAPB RNA",
    "VAPB Proteo"
  ],
  "SLC23A4P": [
    "SLC23A4P CNV",
    "SLC23A4P RNA"
  ],
  "OR11J2P": [
    "OR11J2P CNV",
    "OR11J2P RNA"
  ],
  "FAM43B": [
    "FAM43B CNV",
    "FAM43B RNA"
  ],
  "IGHVIII-5-2": [
    "IGHVIII-5-2 CNV",
    "IGHVIII-5-2 RNA"
  ],
  "ASH2LP3": [
    "ASH2LP3 CNV",
    "ASH2LP3 RNA"
  ],
  "TLCD4": [
    "TLCD4 CNV",
    "TLCD4 RNA",
    "TLCD4 Proteo"
  ],
  "MPHOSPH6P1": [
    "MPHOSPH6P1 CNV",
    "MPHOSPH6P1 RNA"
  ],
  "URB1": [
    "URB1 CNV",
    "URB1 RNA",
    "URB1 Proteo"
  ],
  "B3GALT5": [
    "B3GALT5 CNV",
    "B3GALT5 RNA",
    "B3GALT5 Proteo"
  ],
  "PICK1": [
    "PICK1 CNV",
    "PICK1 RNA",
    "PICK1 Proteo"
  ],
  "SCAF1": [
    "SCAF1 CNV",
    "SCAF1 RNA",
    "SCAF1 Proteo"
  ],
  "RILPL1": [
    "RILPL1 CNV",
    "RILPL1 RNA",
    "RILPL1 Proteo"
  ],
  "TCAF2C": [
    "TCAF2C CNV",
    "TCAF2C RNA"
  ],
  "RPL23AP58": [
    "RPL23AP58 CNV",
    "RPL23AP58 RNA"
  ],
  "OR6F1": [
    "OR6F1 CNV",
    "OR6F1 RNA"
  ],
  "SHD": [
    "SHD CNV",
    "SHD RNA"
  ],
  "CACYBPP2": [
    "CACYBPP2 CNV",
    "CACYBPP2 RNA"
  ],
  "DYSF": [
    "DYSF CNV",
    "DYSF RNA",
    "DYSF Proteo"
  ],
  "OR7E43P": [
    "OR7E43P CNV",
    "OR7E43P RNA"
  ],
  "EVI2B": [
    "EVI2B CNV",
    "EVI2B RNA",
    "EVI2B Proteo"
  ],
  "TRDN": [
    "TRDN CNV",
    "TRDN RNA"
  ],
  "S100A15A": [
    "S100A15A CNV",
    "S100A15A RNA"
  ],
  "CASP4": [
    "CASP4 CNV",
    "CASP4 RNA",
    "CASP4 Proteo"
  ],
  "C21orf58": [
    "C21orf58 CNV",
    "C21orf58 RNA"
  ],
  "OR7E161P": [
    "OR7E161P CNV",
    "OR7E161P RNA"
  ],
  "FAM72C": [
    "FAM72C CNV",
    "FAM72C RNA"
  ],
  "ANAPC15P1": [
    "ANAPC15P1 CNV",
    "ANAPC15P1 RNA"
  ],
  "RPS29P8": [
    "RPS29P8 CNV",
    "RPS29P8 RNA"
  ],
  "HS3ST3B1": [
    "HS3ST3B1 CNV",
    "HS3ST3B1 RNA"
  ],
  "CCDC61": [
    "CCDC61 CNV",
    "CCDC61 RNA",
    "CCDC61 Proteo"
  ],
  "FOXRED2": [
    "FOXRED2 CNV",
    "FOXRED2 RNA",
    "FOXRED2 Proteo"
  ],
  "GET3": [
    "GET3 CNV",
    "GET3 RNA",
    "GET3 Proteo"
  ],
  "RRBP1P2": [
    "RRBP1P2 CNV",
    "RRBP1P2 RNA"
  ],
  "SREK1IP1P1": [
    "SREK1IP1P1 CNV",
    "SREK1IP1P1 RNA"
  ],
  "OR5B3": [
    "OR5B3 CNV",
    "OR5B3 RNA"
  ],
  "LAMP5": [
    "LAMP5 CNV",
    "LAMP5 RNA"
  ],
  "OR4B2P": [
    "OR4B2P CNV",
    "OR4B2P RNA"
  ],
  "FAM163A": [
    "FAM163A CNV",
    "FAM163A RNA"
  ],
  "VPS54": [
    "VPS54 CNV",
    "VPS54 RNA",
    "VPS54 Proteo"
  ],
  "MORF4L1P4": [
    "MORF4L1P4 CNV",
    "MORF4L1P4 RNA"
  ],
  "SLC47A2": [
    "SLC47A2 CNV",
    "SLC47A2 RNA"
  ],
  "MPEG1": [
    "MPEG1 CNV",
    "MPEG1 RNA",
    "MPEG1 Proteo"
  ],
  "SPINT1": [
    "SPINT1 CNV",
    "SPINT1 RNA",
    "SPINT1 Proteo"
  ],
  "DPY19L2P1": [
    "DPY19L2P1 CNV",
    "DPY19L2P1 RNA"
  ],
  "DYNLL1P6": [
    "DYNLL1P6 CNV",
    "DYNLL1P6 RNA"
  ],
  "MTX3": [
    "MTX3 CNV",
    "MTX3 RNA",
    "MTX3 Proteo"
  ],
  "DNAJC10": [
    "DNAJC10 CNV",
    "DNAJC10 RNA",
    "DNAJC10 Proteo"
  ],
  "NCEH1": [
    "NCEH1 CNV",
    "NCEH1 RNA",
    "NCEH1 Proteo"
  ],
  "C3P1": [
    "C3P1 CNV",
    "C3P1 RNA"
  ],
  "FAM157B": [
    "FAM157B CNV",
    "FAM157B RNA"
  ],
  "SLCO6A1": [
    "SLCO6A1 CNV",
    "SLCO6A1 RNA"
  ],
  "LRFN3": [
    "LRFN3 CNV",
    "LRFN3 RNA",
    "LRFN3 Proteo"
  ],
  "RNF14P2": [
    "RNF14P2 CNV",
    "RNF14P2 RNA"
  ],
  "HACL1": [
    "HACL1 CNV",
    "HACL1 RNA",
    "HACL1 Proteo"
  ],
  "GSN": [
    "GSN CNV",
    "GSN RNA",
    "GSN Proteo"
  ],
  "GABRG2": [
    "GABRG2 CNV",
    "GABRG2 RNA"
  ],
  "FTH1P6": [
    "FTH1P6 CNV",
    "FTH1P6 RNA"
  ],
  "PABPC1P12": [
    "PABPC1P12 CNV",
    "PABPC1P12 RNA"
  ],
  "CRISPLD1": [
    "CRISPLD1 CNV",
    "CRISPLD1 RNA"
  ],
  "ETFDH": [
    "ETFDH CNV",
    "ETFDH RNA",
    "ETFDH Proteo"
  ],
  "TBXT": [
    "TBXT CNV",
    "TBXT RNA"
  ],
  "PRY2": [
    "PRY2 CNV",
    "PRY2 RNA"
  ],
  "PPP6R2": [
    "PPP6R2 CNV",
    "PPP6R2 RNA",
    "PPP6R2 Proteo"
  ],
  "RANP1": [
    "RANP1 CNV",
    "RANP1 RNA"
  ],
  "TSEN2": [
    "TSEN2 CNV",
    "TSEN2 RNA",
    "TSEN2 Proteo"
  ],
  "RNF43": [
    "RNF43 CNV",
    "RNF43 RNA"
  ],
  "ZNF229": [
    "ZNF229 CNV",
    "ZNF229 RNA"
  ],
  "RCBTB2": [
    "RCBTB2 CNV",
    "RCBTB2 RNA",
    "RCBTB2 Proteo"
  ],
  "RNA5SP357": [
    "RNA5SP357 CNV",
    "RNA5SP357 RNA"
  ],
  "CNR1": [
    "CNR1 CNV",
    "CNR1 RNA"
  ],
  "HOXA3": [
    "HOXA3 CNV",
    "HOXA3 RNA"
  ],
  "OR5D2P": [
    "OR5D2P CNV",
    "OR5D2P RNA"
  ],
  "DOCK10": [
    "DOCK10 CNV",
    "DOCK10 RNA",
    "DOCK10 Proteo"
  ],
  "ABCD3": [
    "ABCD3 CNV",
    "ABCD3 RNA",
    "ABCD3 Proteo"
  ],
  "TRIM60P11Y": [
    "TRIM60P11Y CNV",
    "TRIM60P11Y RNA"
  ],
  "RPL7AP50": [
    "RPL7AP50 CNV",
    "RPL7AP50 RNA"
  ],
  "MTND5P20": [
    "MTND5P20 CNV",
    "MTND5P20 RNA"
  ],
  "SCN1B": [
    "SCN1B CNV",
    "SCN1B RNA"
  ],
  "PRND": [
    "PRND CNV",
    "PRND RNA",
    "PRND Proteo"
  ],
  "PLCXD2": [
    "PLCXD2 CNV",
    "PLCXD2 RNA"
  ],
  "RPL12P3": [
    "RPL12P3 CNV",
    "RPL12P3 RNA"
  ],
  "ACTR1A": [
    "ACTR1A CNV",
    "ACTR1A RNA",
    "ACTR1A Proteo"
  ],
  "SETP17": [
    "SETP17 CNV",
    "SETP17 RNA"
  ],
  "OR6C70": [
    "OR6C70 CNV",
    "OR6C70 RNA"
  ],
  "FBXO47": [
    "FBXO47 CNV",
    "FBXO47 RNA"
  ],
  "FXYD2": [
    "FXYD2 CNV",
    "FXYD2 RNA",
    "FXYD2 Proteo"
  ],
  "VPS8": [
    "VPS8 CNV",
    "VPS8 RNA",
    "VPS8 Proteo"
  ],
  "MPHOSPH10P6": [
    "MPHOSPH10P6 CNV",
    "MPHOSPH10P6 RNA"
  ],
  "SGMS1": [
    "SGMS1 CNV",
    "SGMS1 RNA",
    "SGMS1 Proteo"
  ],
  "NEURL3": [
    "NEURL3 CNV",
    "NEURL3 RNA"
  ],
  "C1RL": [
    "C1RL CNV",
    "C1RL RNA",
    "C1RL Proteo"
  ],
  "AKR1B1P8": [
    "AKR1B1P8 CNV",
    "AKR1B1P8 RNA"
  ],
  "COX7B2": [
    "COX7B2 CNV",
    "COX7B2 RNA"
  ],
  "DIAPH3": [
    "DIAPH3 CNV",
    "DIAPH3 RNA",
    "DIAPH3 Proteo"
  ],
  "ZNF271P": [
    "ZNF271P CNV",
    "ZNF271P RNA"
  ],
  "CD53": [
    "CD53 CNV",
    "CD53 RNA",
    "CD53 Proteo"
  ],
  "RPL39": [
    "RPL39 CNV",
    "RPL39 RNA",
    "RPL39 Proteo"
  ],
  "ARHGEF26": [
    "ARHGEF26 CNV",
    "ARHGEF26 RNA",
    "ARHGEF26 Proteo"
  ],
  "TTC28": [
    "TTC28 CNV",
    "TTC28 RNA",
    "TTC28 Proteo"
  ],
  "ATP5MGP2": [
    "ATP5MGP2 CNV",
    "ATP5MGP2 RNA"
  ],
  "ADAM15": [
    "ADAM15 CNV",
    "ADAM15 RNA",
    "ADAM15 Proteo"
  ],
  "RNA5SP361": [
    "RNA5SP361 CNV",
    "RNA5SP361 RNA"
  ],
  "OR52B4": [
    "OR52B4 CNV",
    "OR52B4 RNA"
  ],
  "DMP1": [
    "DMP1 CNV",
    "DMP1 RNA"
  ],
  "GULOP": [
    "GULOP CNV",
    "GULOP RNA"
  ],
  "FAM13C": [
    "FAM13C CNV",
    "FAM13C RNA",
    "FAM13C Proteo"
  ],
  "RPL7AP14": [
    "RPL7AP14 CNV",
    "RPL7AP14 RNA"
  ],
  "IGBP1": [
    "IGBP1 CNV",
    "IGBP1 RNA",
    "IGBP1 Proteo"
  ],
  "RPL19P13": [
    "RPL19P13 CNV",
    "RPL19P13 RNA"
  ],
  "RPS15AP28": [
    "RPS15AP28 CNV",
    "RPS15AP28 RNA"
  ],
  "IGHJ2P": [
    "IGHJ2P CNV",
    "IGHJ2P RNA"
  ],
  "KIAA0753": [
    "KIAA0753 CNV",
    "KIAA0753 RNA",
    "KIAA0753 Proteo"
  ],
  "MAGEA6": [
    "MAGEA6 CNV",
    "MAGEA6 RNA",
    "MAGEA6 Proteo"
  ],
  "PWP1": [
    "PWP1 CNV",
    "PWP1 RNA",
    "PWP1 Proteo"
  ],
  "TPM2P1": [
    "TPM2P1 CNV",
    "TPM2P1 RNA"
  ],
  "PMVK": [
    "PMVK CNV",
    "PMVK RNA",
    "PMVK Proteo"
  ],
  "JADE3": [
    "JADE3 CNV",
    "JADE3 RNA",
    "JADE3 Proteo"
  ],
  "COLEC11": [
    "COLEC11 CNV",
    "COLEC11 RNA",
    "COLEC11 Proteo"
  ],
  "A3GALT2": [
    "A3GALT2 CNV",
    "A3GALT2 RNA"
  ],
  "SHC4": [
    "SHC4 CNV",
    "SHC4 RNA",
    "SHC4 Proteo"
  ],
  "OR2V2": [
    "OR2V2 CNV",
    "OR2V2 RNA"
  ],
  "PSMC5": [
    "PSMC5 CNV",
    "PSMC5 RNA",
    "PSMC5 Proteo"
  ],
  "SUZ12P1": [
    "SUZ12P1 CNV",
    "SUZ12P1 RNA"
  ],
  "TBC1D3I": [
    "TBC1D3I CNV",
    "TBC1D3I RNA"
  ],
  "KRT16P1": [
    "KRT16P1 CNV",
    "KRT16P1 RNA"
  ],
  "SCAMP4": [
    "SCAMP4 CNV",
    "SCAMP4 RNA",
    "SCAMP4 Proteo"
  ],
  "ERI2": [
    "ERI2 CNV",
    "ERI2 RNA"
  ],
  "TMED9": [
    "TMED9 CNV",
    "TMED9 RNA",
    "TMED9 Proteo"
  ],
  "CROCCP5": [
    "CROCCP5 CNV",
    "CROCCP5 RNA"
  ],
  "FAR2P1": [
    "FAR2P1 CNV",
    "FAR2P1 RNA"
  ],
  "HSP90AA5P": [
    "HSP90AA5P CNV",
    "HSP90AA5P RNA"
  ],
  "FARP2": [
    "FARP2 CNV",
    "FARP2 RNA",
    "FARP2 Proteo"
  ],
  "CYP2AC1P": [
    "CYP2AC1P CNV",
    "CYP2AC1P RNA"
  ],
  "TTC32": [
    "TTC32 CNV",
    "TTC32 RNA"
  ],
  "USP30": [
    "USP30 CNV",
    "USP30 RNA",
    "USP30 Proteo"
  ],
  "MTCO1P5": [
    "MTCO1P5 CNV",
    "MTCO1P5 RNA"
  ],
  "UFM1P3": [
    "UFM1P3 CNV",
    "UFM1P3 RNA"
  ],
  "COBLL1": [
    "COBLL1 CNV",
    "COBLL1 RNA",
    "COBLL1 Proteo"
  ],
  "ZNF112": [
    "ZNF112 CNV",
    "ZNF112 RNA",
    "ZNF112 Proteo"
  ],
  "CCL11": [
    "CCL11 CNV",
    "CCL11 RNA"
  ],
  "INSYN1": [
    "INSYN1 CNV",
    "INSYN1 RNA"
  ],
  "OSBPL9": [
    "OSBPL9 CNV",
    "OSBPL9 RNA",
    "OSBPL9 Proteo"
  ],
  "PKP2": [
    "PKP2 CNV",
    "PKP2 RNA",
    "PKP2 Proteo"
  ],
  "INSRR": [
    "INSRR CNV",
    "INSRR RNA"
  ],
  "DEFB131E": [
    "DEFB131E CNV",
    "DEFB131E RNA"
  ],
  "RAB3GAP1": [
    "RAB3GAP1 CNV",
    "RAB3GAP1 RNA",
    "RAB3GAP1 Proteo"
  ],
  "MBD2": [
    "MBD2 CNV",
    "MBD2 RNA",
    "MBD2 Proteo"
  ],
  "PIK3CD": [
    "PIK3CD CNV",
    "PIK3CD RNA",
    "PIK3CD Proteo"
  ],
  "ERCC8": [
    "ERCC8 CNV",
    "ERCC8 RNA",
    "ERCC8 Proteo"
  ],
  "SPATA5": [
    "SPATA5 CNV",
    "SPATA5 RNA",
    "SPATA5 Proteo"
  ],
  "PCCA": [
    "PCCA CNV",
    "PCCA RNA",
    "PCCA Proteo"
  ],
  "FAM86HP": [
    "FAM86HP CNV",
    "FAM86HP RNA"
  ],
  "CDKN2AIPNL": [
    "CDKN2AIPNL CNV",
    "CDKN2AIPNL RNA",
    "CDKN2AIPNL Proteo"
  ],
  "ALG1L2": [
    "ALG1L2 CNV",
    "ALG1L2 RNA"
  ],
  "CYTH1P1": [
    "CYTH1P1 CNV",
    "CYTH1P1 RNA"
  ],
  "MICALL1": [
    "MICALL1 CNV",
    "MICALL1 RNA",
    "MICALL1 Proteo"
  ],
  "ATP5F1AP8": [
    "ATP5F1AP8 CNV",
    "ATP5F1AP8 RNA"
  ],
  "UGT1A8": [
    "UGT1A8 CNV",
    "UGT1A8 RNA"
  ],
  "NFKBIE": [
    "NFKBIE CNV",
    "NFKBIE RNA",
    "NFKBIE Proteo"
  ],
  "HNRNPA1P32": [
    "HNRNPA1P32 CNV",
    "HNRNPA1P32 RNA"
  ],
  "RPS27P16": [
    "RPS27P16 CNV",
    "RPS27P16 RNA"
  ],
  "STX8": [
    "STX8 CNV",
    "STX8 RNA",
    "STX8 Proteo"
  ],
  "PRH1": [
    "PRH1 CNV",
    "PRH1 RNA",
    "PRH1 Proteo"
  ],
  "SRP72P1": [
    "SRP72P1 CNV",
    "SRP72P1 RNA"
  ],
  "CAST": [
    "CAST CNV",
    "CAST RNA",
    "CAST Proteo"
  ],
  "ARL9": [
    "ARL9 CNV",
    "ARL9 RNA"
  ],
  "SELENOP": [
    "SELENOP CNV",
    "SELENOP RNA",
    "SELENOP Proteo"
  ],
  "PRSS23": [
    "PRSS23 CNV",
    "PRSS23 RNA",
    "PRSS23 Proteo"
  ],
  "CRYM-AS1": [
    "CRYM-AS1 CNV",
    "CRYM-AS1 RNA"
  ],
  "SMARCE1": [
    "SMARCE1 CNV",
    "SMARCE1 RNA",
    "SMARCE1 Proteo"
  ],
  "LHX3": [
    "LHX3 CNV",
    "LHX3 RNA"
  ],
  "SPATA19": [
    "SPATA19 CNV",
    "SPATA19 RNA"
  ],
  "IGKV1OR22-1": [
    "IGKV1OR22-1 CNV",
    "IGKV1OR22-1 RNA"
  ],
  "FABP12P1": [
    "FABP12P1 CNV",
    "FABP12P1 RNA"
  ],
  "USP9YP25": [
    "USP9YP25 CNV",
    "USP9YP25 RNA"
  ],
  "GYS2": [
    "GYS2 CNV",
    "GYS2 RNA",
    "GYS2 Proteo"
  ],
  "OR2B11": [
    "OR2B11 CNV",
    "OR2B11 RNA"
  ],
  "RPL6P15": [
    "RPL6P15 CNV",
    "RPL6P15 RNA"
  ],
  "MUC20P1": [
    "MUC20P1 CNV",
    "MUC20P1 RNA"
  ],
  "DEPDC5": [
    "DEPDC5 CNV",
    "DEPDC5 RNA",
    "DEPDC5 Proteo"
  ],
  "F2R": [
    "F2R CNV",
    "F2R RNA",
    "F2R Proteo"
  ],
  "CSPP1": [
    "CSPP1 CNV",
    "CSPP1 RNA",
    "CSPP1 Proteo"
  ],
  "COL12A1": [
    "COL12A1 CNV",
    "COL12A1 RNA",
    "COL12A1 Proteo"
  ],
  "CDKN2AIPNLP3": [
    "CDKN2AIPNLP3 CNV",
    "CDKN2AIPNLP3 RNA"
  ],
  "NUS1": [
    "NUS1 CNV",
    "NUS1 RNA",
    "NUS1 Proteo"
  ],
  "LIPT2": [
    "LIPT2 CNV",
    "LIPT2 RNA",
    "LIPT2 Proteo"
  ],
  "RANBP20P": [
    "RANBP20P CNV",
    "RANBP20P RNA"
  ],
  "ZNF433": [
    "ZNF433 CNV",
    "ZNF433 RNA"
  ],
  "ADAMTS4": [
    "ADAMTS4 CNV",
    "ADAMTS4 RNA",
    "ADAMTS4 Proteo"
  ],
  "CHCHD4P5": [
    "CHCHD4P5 CNV",
    "CHCHD4P5 RNA"
  ],
  "C10orf90": [
    "C10orf90 CNV",
    "C10orf90 RNA"
  ],
  "CAMP": [
    "CAMP CNV",
    "CAMP RNA",
    "CAMP Proteo"
  ],
  "LUZP1": [
    "LUZP1 CNV",
    "LUZP1 RNA",
    "LUZP1 Proteo"
  ],
  "IGHV3-52": [
    "IGHV3-52 CNV",
    "IGHV3-52 RNA"
  ],
  "MTND5P24": [
    "MTND5P24 CNV",
    "MTND5P24 RNA"
  ],
  "AIMP1": [
    "AIMP1 CNV",
    "AIMP1 RNA",
    "AIMP1 Proteo"
  ],
  "PLD1": [
    "PLD1 CNV",
    "PLD1 RNA",
    "PLD1 Proteo"
  ],
  "C19orf47": [
    "C19orf47 CNV",
    "C19orf47 RNA",
    "C19orf47 Proteo"
  ],
  "GSTT4": [
    "GSTT4 CNV",
    "GSTT4 RNA"
  ],
  "KRT37": [
    "KRT37 CNV",
    "KRT37 RNA"
  ],
  "CA11": [
    "CA11 CNV",
    "CA11 RNA",
    "CA11 Proteo"
  ],
  "OXA1L": [
    "OXA1L CNV",
    "OXA1L RNA",
    "OXA1L Proteo"
  ],
  "OR52M2P": [
    "OR52M2P CNV",
    "OR52M2P RNA"
  ],
  "GAPDHP40": [
    "GAPDHP40 CNV",
    "GAPDHP40 RNA"
  ],
  "CCDC28B": [
    "CCDC28B CNV",
    "CCDC28B RNA",
    "CCDC28B Proteo"
  ],
  "CSPG4": [
    "CSPG4 CNV",
    "CSPG4 RNA",
    "CSPG4 Proteo"
  ],
  "RIMS1": [
    "RIMS1 CNV",
    "RIMS1 RNA"
  ],
  "TENM2": [
    "TENM2 CNV",
    "TENM2 RNA",
    "TENM2 Proteo"
  ],
  "WDR18": [
    "WDR18 CNV",
    "WDR18 RNA",
    "WDR18 Proteo"
  ],
  "OR13H1": [
    "OR13H1 CNV",
    "OR13H1 RNA"
  ],
  "MZT2A": [
    "MZT2A CNV",
    "MZT2A RNA",
    "MZT2A Proteo"
  ],
  "PPAN": [
    "PPAN CNV",
    "PPAN RNA"
  ],
  "SYNGAP1": [
    "SYNGAP1 CNV",
    "SYNGAP1 RNA",
    "SYNGAP1 Proteo"
  ],
  "MTCO2P23": [
    "MTCO2P23 CNV",
    "MTCO2P23 RNA"
  ],
  "PPP1R3G": [
    "PPP1R3G CNV",
    "PPP1R3G RNA",
    "PPP1R3G Proteo"
  ],
  "ZBTB18": [
    "ZBTB18 CNV",
    "ZBTB18 RNA",
    "ZBTB18 Proteo"
  ],
  "RNA5SP212": [
    "RNA5SP212 CNV",
    "RNA5SP212 RNA"
  ],
  "PRSS40A": [
    "PRSS40A CNV",
    "PRSS40A RNA"
  ],
  "TMEM88B": [
    "TMEM88B CNV",
    "TMEM88B RNA"
  ],
  "ZNF202": [
    "ZNF202 CNV",
    "ZNF202 RNA",
    "ZNF202 Proteo"
  ],
  "HNRNPA1P40": [
    "HNRNPA1P40 CNV",
    "HNRNPA1P40 RNA"
  ],
  "CHD7": [
    "CHD7 CNV",
    "CHD7 RNA",
    "CHD7 Proteo"
  ],
  "ASAH2": [
    "ASAH2 CNV",
    "ASAH2 RNA"
  ],
  "ADAMTSL5": [
    "ADAMTSL5 CNV",
    "ADAMTSL5 RNA",
    "ADAMTSL5 Proteo"
  ],
  "HRH3": [
    "HRH3 CNV",
    "HRH3 RNA"
  ],
  "NEMF": [
    "NEMF CNV",
    "NEMF RNA",
    "NEMF Proteo"
  ],
  "CHCHD4P4": [
    "CHCHD4P4 CNV",
    "CHCHD4P4 RNA"
  ],
  "TPT1P3": [
    "TPT1P3 CNV",
    "TPT1P3 RNA"
  ],
  "ZNF736P2Y": [
    "ZNF736P2Y CNV",
    "ZNF736P2Y RNA"
  ],
  "TRMT112P4": [
    "TRMT112P4 CNV",
    "TRMT112P4 RNA"
  ],
  "SMLR1": [
    "SMLR1 CNV",
    "SMLR1 RNA"
  ],
  "TCERG1P1": [
    "TCERG1P1 CNV",
    "TCERG1P1 RNA"
  ],
  "TBC1D3H": [
    "TBC1D3H CNV",
    "TBC1D3H RNA"
  ],
  "ZNF280C": [
    "ZNF280C CNV",
    "ZNF280C RNA",
    "ZNF280C Proteo"
  ],
  "TP53TG3E": [
    "TP53TG3E CNV",
    "TP53TG3E RNA"
  ],
  "SNX22": [
    "SNX22 CNV",
    "SNX22 RNA"
  ],
  "HTR1A": [
    "HTR1A CNV",
    "HTR1A RNA"
  ],
  "MLLT11": [
    "MLLT11 CNV",
    "MLLT11 RNA",
    "MLLT11 Proteo"
  ],
  "DDIAS": [
    "DDIAS CNV",
    "DDIAS RNA"
  ],
  "CSN1S2AP": [
    "CSN1S2AP CNV",
    "CSN1S2AP RNA"
  ],
  "STRN3": [
    "STRN3 CNV",
    "STRN3 RNA",
    "STRN3 Proteo"
  ],
  "C17orf58": [
    "C17orf58 CNV",
    "C17orf58 RNA"
  ],
  "LGALS7": [
    "LGALS7 CNV",
    "LGALS7 RNA"
  ],
  "CBX3P9": [
    "CBX3P9 CNV",
    "CBX3P9 RNA"
  ],
  "PRPS1P1": [
    "PRPS1P1 CNV",
    "PRPS1P1 RNA"
  ],
  "TSC2": [
    "TSC2 CNV",
    "TSC2 RNA",
    "TSC2 Proteo"
  ],
  "DUS2": [
    "DUS2 CNV",
    "DUS2 RNA",
    "DUS2 Proteo"
  ],
  "H2BC6": [
    "H2BC6 CNV",
    "H2BC6 RNA"
  ],
  "GLYR1": [
    "GLYR1 CNV",
    "GLYR1 RNA",
    "GLYR1 Proteo"
  ],
  "CYCSP2": [
    "CYCSP2 CNV",
    "CYCSP2 RNA"
  ],
  "ATP5PFP1": [
    "ATP5PFP1 CNV",
    "ATP5PFP1 RNA"
  ],
  "COX6A1P3": [
    "COX6A1P3 CNV",
    "COX6A1P3 RNA"
  ],
  "NIPSNAP3B": [
    "NIPSNAP3B CNV",
    "NIPSNAP3B RNA",
    "NIPSNAP3B Proteo"
  ],
  "OR7E26P": [
    "OR7E26P CNV",
    "OR7E26P RNA"
  ],
  "PRSS3": [
    "PRSS3 CNV",
    "PRSS3 RNA",
    "PRSS3 Proteo"
  ],
  "TMEM143": [
    "TMEM143 CNV",
    "TMEM143 RNA",
    "TMEM143 Proteo"
  ],
  "DPY19L1P1": [
    "DPY19L1P1 CNV",
    "DPY19L1P1 RNA"
  ],
  "WBP1L": [
    "WBP1L CNV",
    "WBP1L RNA",
    "WBP1L Proteo"
  ],
  "EIF4E3": [
    "EIF4E3 CNV",
    "EIF4E3 RNA",
    "EIF4E3 Proteo"
  ],
  "TREML5P": [
    "TREML5P CNV",
    "TREML5P RNA"
  ],
  "BNIP3P10": [
    "BNIP3P10 CNV",
    "BNIP3P10 RNA"
  ],
  "DAZAP1": [
    "DAZAP1 CNV",
    "DAZAP1 RNA",
    "DAZAP1 Proteo"
  ],
  "UCK1": [
    "UCK1 CNV",
    "UCK1 RNA",
    "UCK1 Proteo"
  ],
  "ADAM7": [
    "ADAM7 CNV",
    "ADAM7 RNA"
  ],
  "MRPS11P1": [
    "MRPS11P1 CNV",
    "MRPS11P1 RNA"
  ],
  "TIMM29": [
    "TIMM29 CNV",
    "TIMM29 RNA",
    "TIMM29 Proteo"
  ],
  "CARMIL3": [
    "CARMIL3 CNV",
    "CARMIL3 RNA"
  ],
  "RDX": [
    "RDX CNV",
    "RDX RNA",
    "RDX Proteo"
  ],
  "ZNF816": [
    "ZNF816 CNV",
    "ZNF816 RNA",
    "ZNF816 Proteo"
  ],
  "PRAMEF18": [
    "PRAMEF18 CNV",
    "PRAMEF18 RNA"
  ],
  "HECTD3": [
    "HECTD3 CNV",
    "HECTD3 RNA",
    "HECTD3 Proteo"
  ],
  "RPL23AP75": [
    "RPL23AP75 CNV",
    "RPL23AP75 RNA"
  ],
  "H3-7": [
    "H3-7 CNV",
    "H3-7 RNA",
    "H3-7 Proteo"
  ],
  "RPSAP56": [
    "RPSAP56 CNV",
    "RPSAP56 RNA"
  ],
  "OR5B15P": [
    "OR5B15P CNV",
    "OR5B15P RNA"
  ],
  "BBX": [
    "BBX CNV",
    "BBX RNA",
    "BBX Proteo"
  ],
  "SLC3A1": [
    "SLC3A1 CNV",
    "SLC3A1 RNA"
  ],
  "MSR1": [
    "MSR1 CNV",
    "MSR1 RNA",
    "MSR1 Proteo"
  ],
  "ZNF285": [
    "ZNF285 CNV",
    "ZNF285 RNA"
  ],
  "FAM47A": [
    "FAM47A CNV",
    "FAM47A RNA"
  ],
  "C3orf52": [
    "C3orf52 CNV",
    "C3orf52 RNA"
  ],
  "NABP2": [
    "NABP2 CNV",
    "NABP2 RNA",
    "NABP2 Proteo"
  ],
  "INPP5E": [
    "INPP5E CNV",
    "INPP5E RNA",
    "INPP5E Proteo"
  ],
  "XNDC1N": [
    "XNDC1N CNV",
    "XNDC1N RNA"
  ],
  "CDK8P2": [
    "CDK8P2 CNV",
    "CDK8P2 RNA"
  ],
  "MYO5BP1": [
    "MYO5BP1 CNV",
    "MYO5BP1 RNA"
  ],
  "SNX24": [
    "SNX24 CNV",
    "SNX24 RNA",
    "SNX24 Proteo"
  ],
  "OSGEPL1": [
    "OSGEPL1 CNV",
    "OSGEPL1 RNA",
    "OSGEPL1 Proteo"
  ],
  "CAGE1": [
    "CAGE1 CNV",
    "CAGE1 RNA"
  ],
  "TOX4": [
    "TOX4 CNV",
    "TOX4 RNA",
    "TOX4 Proteo"
  ],
  "ELOCP13": [
    "ELOCP13 CNV",
    "ELOCP13 RNA"
  ],
  "TRIM51FP": [
    "TRIM51FP CNV",
    "TRIM51FP RNA"
  ],
  "SNAP23": [
    "SNAP23 CNV",
    "SNAP23 RNA",
    "SNAP23 Proteo"
  ],
  "EIF2S2P5": [
    "EIF2S2P5 CNV",
    "EIF2S2P5 RNA"
  ],
  "OR6K6": [
    "OR6K6 CNV",
    "OR6K6 RNA"
  ],
  "ZNF354C": [
    "ZNF354C CNV",
    "ZNF354C RNA"
  ],
  "CEP85": [
    "CEP85 CNV",
    "CEP85 RNA",
    "CEP85 Proteo"
  ],
  "HNF1A": [
    "HNF1A CNV",
    "HNF1A RNA",
    "HNF1A Proteo"
  ],
  "TIMELESS": [
    "TIMELESS CNV",
    "TIMELESS RNA",
    "TIMELESS Proteo"
  ],
  "RNA5SP292": [
    "RNA5SP292 CNV",
    "RNA5SP292 RNA"
  ],
  "PNLIPRP1": [
    "PNLIPRP1 CNV",
    "PNLIPRP1 RNA"
  ],
  "SPON2": [
    "SPON2 CNV",
    "SPON2 RNA",
    "SPON2 Proteo"
  ],
  "TSTD1": [
    "TSTD1 CNV",
    "TSTD1 RNA",
    "TSTD1 Proteo"
  ],
  "OR8B9P": [
    "OR8B9P CNV",
    "OR8B9P RNA"
  ],
  "USP17L23": [
    "USP17L23 CNV",
    "USP17L23 RNA"
  ],
  "TMCC1": [
    "TMCC1 CNV",
    "TMCC1 RNA",
    "TMCC1 Proteo"
  ],
  "PSMD12": [
    "PSMD12 CNV",
    "PSMD12 RNA",
    "PSMD12 Proteo"
  ],
  "GXYLT1P2": [
    "GXYLT1P2 CNV",
    "GXYLT1P2 RNA"
  ],
  "GOSR2": [
    "GOSR2 CNV",
    "GOSR2 RNA",
    "GOSR2 Proteo"
  ],
  "CHRNB3": [
    "CHRNB3 CNV",
    "CHRNB3 RNA"
  ],
  "COL23A1": [
    "COL23A1 CNV",
    "COL23A1 RNA"
  ],
  "SQSTM1": [
    "SQSTM1 CNV",
    "SQSTM1 RNA",
    "SQSTM1 Proteo"
  ],
  "GRAMD4P3": [
    "GRAMD4P3 CNV",
    "GRAMD4P3 RNA"
  ],
  "SSX2B": [
    "SSX2B CNV",
    "SSX2B RNA"
  ],
  "SPTBN1": [
    "SPTBN1 CNV",
    "SPTBN1 RNA",
    "SPTBN1 Proteo"
  ],
  "GAPDHP29": [
    "GAPDHP29 CNV",
    "GAPDHP29 RNA"
  ],
  "PXT1": [
    "PXT1 CNV",
    "PXT1 RNA"
  ],
  "GLIPR2": [
    "GLIPR2 CNV",
    "GLIPR2 RNA",
    "GLIPR2 Proteo"
  ],
  "TRAPPC8": [
    "TRAPPC8 CNV",
    "TRAPPC8 RNA",
    "TRAPPC8 Proteo"
  ],
  "CREBZF": [
    "CREBZF CNV",
    "CREBZF RNA",
    "CREBZF Proteo"
  ],
  "RRP12": [
    "RRP12 CNV",
    "RRP12 RNA",
    "RRP12 Proteo"
  ],
  "ZNF76": [
    "ZNF76 CNV",
    "ZNF76 RNA",
    "ZNF76 Proteo"
  ],
  "MTCYBP27": [
    "MTCYBP27 CNV",
    "MTCYBP27 RNA"
  ],
  "DCTN4": [
    "DCTN4 CNV",
    "DCTN4 RNA",
    "DCTN4 Proteo"
  ],
  "TEX26": [
    "TEX26 CNV",
    "TEX26 RNA"
  ],
  "KRTAP3-3": [
    "KRTAP3-3 CNV",
    "KRTAP3-3 RNA"
  ],
  "HNRNPK": [
    "HNRNPK CNV",
    "HNRNPK RNA",
    "HNRNPK Proteo"
  ],
  "LGI3": [
    "LGI3 CNV",
    "LGI3 RNA",
    "LGI3 Proteo"
  ],
  "FUT6": [
    "FUT6 CNV",
    "FUT6 RNA"
  ],
  "C12orf71": [
    "C12orf71 CNV",
    "C12orf71 RNA"
  ],
  "PRXL2B": [
    "PRXL2B CNV",
    "PRXL2B RNA",
    "PRXL2B Proteo"
  ],
  "IFI35": [
    "IFI35 CNV",
    "IFI35 RNA",
    "IFI35 Proteo"
  ],
  "BCRP2": [
    "BCRP2 CNV",
    "BCRP2 RNA"
  ],
  "SBNO1": [
    "SBNO1 CNV",
    "SBNO1 RNA",
    "SBNO1 Proteo"
  ],
  "FBXL15": [
    "FBXL15 CNV",
    "FBXL15 RNA",
    "FBXL15 Proteo"
  ],
  "SLC26A7": [
    "SLC26A7 CNV",
    "SLC26A7 RNA"
  ],
  "FKBP4": [
    "FKBP4 CNV",
    "FKBP4 RNA",
    "FKBP4 Proteo"
  ],
  "EXOC6": [
    "EXOC6 CNV",
    "EXOC6 RNA",
    "EXOC6 Proteo"
  ],
  "C14orf39": [
    "C14orf39 CNV",
    "C14orf39 RNA"
  ],
  "PRDX2P2": [
    "PRDX2P2 CNV",
    "PRDX2P2 RNA"
  ],
  "MED15P4": [
    "MED15P4 CNV",
    "MED15P4 RNA"
  ],
  "NPM1P43": [
    "NPM1P43 CNV",
    "NPM1P43 RNA"
  ],
  "NEIL3": [
    "NEIL3 CNV",
    "NEIL3 RNA",
    "NEIL3 Proteo"
  ],
  "FRA10AC1": [
    "FRA10AC1 CNV",
    "FRA10AC1 RNA",
    "FRA10AC1 Proteo"
  ],
  "H6PD": [
    "H6PD CNV",
    "H6PD RNA",
    "H6PD Proteo"
  ],
  "ANXA2P1": [
    "ANXA2P1 CNV",
    "ANXA2P1 RNA"
  ],
  "ZNF141": [
    "ZNF141 CNV",
    "ZNF141 RNA",
    "ZNF141 Proteo"
  ],
  "CFL1": [
    "CFL1 CNV",
    "CFL1 RNA",
    "CFL1 Proteo"
  ],
  "RPS27AP8": [
    "RPS27AP8 CNV",
    "RPS27AP8 RNA"
  ],
  "CPZ": [
    "CPZ CNV",
    "CPZ RNA",
    "CPZ Proteo"
  ],
  "PRKAA2": [
    "PRKAA2 CNV",
    "PRKAA2 RNA"
  ],
  "HMGB1P11": [
    "HMGB1P11 CNV",
    "HMGB1P11 RNA"
  ],
  "INHA": [
    "INHA CNV",
    "INHA RNA"
  ],
  "PRSS41": [
    "PRSS41 CNV",
    "PRSS41 RNA"
  ],
  "ZFP1": [
    "ZFP1 CNV",
    "ZFP1 RNA",
    "ZFP1 Proteo"
  ],
  "NMD3": [
    "NMD3 CNV",
    "NMD3 RNA",
    "NMD3 Proteo"
  ],
  "KLC4": [
    "KLC4 CNV",
    "KLC4 RNA",
    "KLC4 Proteo"
  ],
  "HSFY3P": [
    "HSFY3P CNV",
    "HSFY3P RNA"
  ],
  "DNAJC19P9": [
    "DNAJC19P9 CNV",
    "DNAJC19P9 RNA"
  ],
  "RPL23AP80": [
    "RPL23AP80 CNV",
    "RPL23AP80 RNA"
  ],
  "OR4D10": [
    "OR4D10 CNV",
    "OR4D10 RNA"
  ],
  "STAG1": [
    "STAG1 CNV",
    "STAG1 RNA",
    "STAG1 Proteo"
  ],
  "GNG11": [
    "GNG11 CNV",
    "GNG11 RNA",
    "GNG11 Proteo"
  ],
  "SGCEP1": [
    "SGCEP1 CNV",
    "SGCEP1 RNA"
  ],
  "RPL3P4": [
    "RPL3P4 CNV",
    "RPL3P4 RNA"
  ],
  "CBY3": [
    "CBY3 CNV",
    "CBY3 RNA"
  ],
  "PFN3": [
    "PFN3 CNV",
    "PFN3 RNA",
    "PFN3 Proteo"
  ],
  "GAPDHP73": [
    "GAPDHP73 CNV",
    "GAPDHP73 RNA"
  ],
  "THEMIS": [
    "THEMIS CNV",
    "THEMIS RNA",
    "THEMIS Proteo"
  ],
  "STAT4": [
    "STAT4 CNV",
    "STAT4 RNA",
    "STAT4 Proteo"
  ],
  "OSER1": [
    "OSER1 CNV",
    "OSER1 RNA"
  ],
  "CHMP4A": [
    "CHMP4A CNV",
    "CHMP4A RNA",
    "CHMP4A Proteo"
  ],
  "RBP5": [
    "RBP5 CNV",
    "RBP5 RNA",
    "RBP5 Proteo"
  ],
  "SLC5A5": [
    "SLC5A5 CNV",
    "SLC5A5 RNA"
  ],
  "TRIM52": [
    "TRIM52 CNV",
    "TRIM52 RNA"
  ],
  "USP9YP23": [
    "USP9YP23 CNV",
    "USP9YP23 RNA"
  ],
  "LMF2": [
    "LMF2 CNV",
    "LMF2 RNA",
    "LMF2 Proteo"
  ],
  "TSPAN14": [
    "TSPAN14 CNV",
    "TSPAN14 RNA",
    "TSPAN14 Proteo"
  ],
  "NIFKP2": [
    "NIFKP2 CNV",
    "NIFKP2 RNA"
  ],
  "USP9YP24": [
    "USP9YP24 CNV",
    "USP9YP24 RNA"
  ],
  "EEF1A1P5": [
    "EEF1A1P5 CNV",
    "EEF1A1P5 RNA"
  ],
  "DENND2C": [
    "DENND2C CNV",
    "DENND2C RNA"
  ],
  "OR10J1": [
    "OR10J1 CNV",
    "OR10J1 RNA"
  ],
  "PPIAP47": [
    "PPIAP47 CNV",
    "PPIAP47 RNA"
  ],
  "UGT2B24P": [
    "UGT2B24P CNV",
    "UGT2B24P RNA"
  ],
  "ACTR10": [
    "ACTR10 CNV",
    "ACTR10 RNA",
    "ACTR10 Proteo"
  ],
  "RNA5SP403": [
    "RNA5SP403 CNV",
    "RNA5SP403 RNA"
  ],
  "OR2AS1P": [
    "OR2AS1P CNV",
    "OR2AS1P RNA"
  ],
  "KIFC2": [
    "KIFC2 CNV",
    "KIFC2 RNA"
  ],
  "PHKA2": [
    "PHKA2 CNV",
    "PHKA2 RNA",
    "PHKA2 Proteo"
  ],
  "HNRNPA1P49": [
    "HNRNPA1P49 CNV",
    "HNRNPA1P49 RNA"
  ],
  "RNA5SP186": [
    "RNA5SP186 CNV",
    "RNA5SP186 RNA"
  ],
  "TTBK2": [
    "TTBK2 CNV",
    "TTBK2 RNA",
    "TTBK2 Proteo"
  ],
  "DUOXA2": [
    "DUOXA2 CNV",
    "DUOXA2 RNA"
  ],
  "ZBTB8A": [
    "ZBTB8A CNV",
    "ZBTB8A RNA"
  ],
  "RPL22P4": [
    "RPL22P4 CNV",
    "RPL22P4 RNA"
  ],
  "COX15": [
    "COX15 CNV",
    "COX15 RNA",
    "COX15 Proteo"
  ],
  "RYK": [
    "RYK CNV",
    "RYK RNA",
    "RYK Proteo"
  ],
  "LRRC69": [
    "LRRC69 CNV",
    "LRRC69 RNA"
  ],
  "SNX5P1": [
    "SNX5P1 CNV",
    "SNX5P1 RNA"
  ],
  "NUFIP1P1": [
    "NUFIP1P1 CNV",
    "NUFIP1P1 RNA"
  ],
  "STAMBPL1": [
    "STAMBPL1 CNV",
    "STAMBPL1 RNA",
    "STAMBPL1 Proteo"
  ],
  "SYTL3": [
    "SYTL3 CNV",
    "SYTL3 RNA"
  ],
  "GABRA2": [
    "GABRA2 CNV",
    "GABRA2 RNA"
  ],
  "CARD17": [
    "CARD17 CNV",
    "CARD17 RNA"
  ],
  "LINC00933": [
    "LINC00933 CNV",
    "LINC00933 RNA"
  ],
  "SPATA13": [
    "SPATA13 CNV",
    "SPATA13 RNA",
    "SPATA13 Proteo"
  ],
  "WDR76": [
    "WDR76 CNV",
    "WDR76 RNA",
    "WDR76 Proteo"
  ],
  "OR7E99P": [
    "OR7E99P CNV",
    "OR7E99P RNA"
  ],
  "HNRNPA1P70": [
    "HNRNPA1P70 CNV",
    "HNRNPA1P70 RNA"
  ],
  "RCC2": [
    "RCC2 CNV",
    "RCC2 RNA",
    "RCC2 Proteo"
  ],
  "CBX1P5": [
    "CBX1P5 CNV",
    "CBX1P5 RNA"
  ],
  "INPP4B": [
    "INPP4B CNV",
    "INPP4B RNA",
    "INPP4B Proteo"
  ],
  "DIPK1A": [
    "DIPK1A CNV",
    "DIPK1A RNA",
    "DIPK1A Proteo"
  ],
  "H2BC13": [
    "H2BC13 CNV",
    "H2BC13 RNA"
  ],
  "BPNT2": [
    "BPNT2 CNV",
    "BPNT2 RNA",
    "BPNT2 Proteo"
  ],
  "ELOVL1": [
    "ELOVL1 CNV",
    "ELOVL1 RNA",
    "ELOVL1 Proteo"
  ],
  "OR4K17": [
    "OR4K17 CNV",
    "OR4K17 RNA"
  ],
  "GSTA6P": [
    "GSTA6P CNV",
    "GSTA6P RNA"
  ],
  "UPK1A": [
    "UPK1A CNV",
    "UPK1A RNA"
  ],
  "DLEC1": [
    "DLEC1 CNV",
    "DLEC1 RNA"
  ],
  "PPIAP87": [
    "PPIAP87 CNV",
    "PPIAP87 RNA"
  ],
  "GOLGA8VP": [
    "GOLGA8VP CNV",
    "GOLGA8VP RNA"
  ],
  "TTF2": [
    "TTF2 CNV",
    "TTF2 RNA",
    "TTF2 Proteo"
  ],
  "LEFTY2": [
    "LEFTY2 CNV",
    "LEFTY2 RNA"
  ],
  "IGLCOR22-2": [
    "IGLCOR22-2 CNV",
    "IGLCOR22-2 RNA"
  ],
  "SMIM39": [
    "SMIM39 CNV",
    "SMIM39 RNA"
  ],
  "CD84": [
    "CD84 CNV",
    "CD84 RNA",
    "CD84 Proteo"
  ],
  "RPL36AP51": [
    "RPL36AP51 CNV",
    "RPL36AP51 RNA"
  ],
  "FAM120B": [
    "FAM120B CNV",
    "FAM120B RNA",
    "FAM120B Proteo"
  ],
  "CT47A10": [
    "CT47A10 CNV",
    "CT47A10 RNA"
  ],
  "RPL31P40": [
    "RPL31P40 CNV",
    "RPL31P40 RNA"
  ],
  "LMNB2": [
    "LMNB2 CNV",
    "LMNB2 RNA",
    "LMNB2 Proteo"
  ],
  "GOLGA8R": [
    "GOLGA8R CNV",
    "GOLGA8R RNA",
    "GOLGA8R Proteo"
  ],
  "RTL8C": [
    "RTL8C CNV",
    "RTL8C RNA",
    "RTL8C Proteo"
  ],
  "IGHV3-57": [
    "IGHV3-57 CNV",
    "IGHV3-57 RNA"
  ],
  "NADK": [
    "NADK CNV",
    "NADK RNA",
    "NADK Proteo"
  ],
  "KIR3DL1": [
    "KIR3DL1 CNV",
    "KIR3DL1 RNA"
  ],
  "ZNF177": [
    "ZNF177 CNV",
    "ZNF177 RNA"
  ],
  "NLRC4": [
    "NLRC4 CNV",
    "NLRC4 RNA",
    "NLRC4 Proteo"
  ],
  "SPDYE2": [
    "SPDYE2 CNV",
    "SPDYE2 RNA"
  ],
  "ZNF285DP": [
    "ZNF285DP CNV",
    "ZNF285DP RNA"
  ],
  "APOBEC3F": [
    "APOBEC3F CNV",
    "APOBEC3F RNA",
    "APOBEC3F Proteo"
  ],
  "DNPH1": [
    "DNPH1 CNV",
    "DNPH1 RNA",
    "DNPH1 Proteo"
  ],
  "IGLV2-28": [
    "IGLV2-28 CNV",
    "IGLV2-28 RNA"
  ],
  "CHM": [
    "CHM CNV",
    "CHM RNA",
    "CHM Proteo"
  ],
  "ECT2": [
    "ECT2 CNV",
    "ECT2 RNA",
    "ECT2 Proteo"
  ],
  "CABS1": [
    "CABS1 CNV",
    "CABS1 RNA"
  ],
  "ATP13A5": [
    "ATP13A5 CNV",
    "ATP13A5 RNA"
  ],
  "DZIP1": [
    "DZIP1 CNV",
    "DZIP1 RNA"
  ],
  "KTN1": [
    "KTN1 CNV",
    "KTN1 RNA",
    "KTN1 Proteo"
  ],
  "TUBB4B": [
    "TUBB4B CNV",
    "TUBB4B RNA",
    "TUBB4B Proteo"
  ],
  "TAMM41": [
    "TAMM41 CNV",
    "TAMM41 RNA",
    "TAMM41 Proteo"
  ],
  "ZNF547": [
    "ZNF547 CNV",
    "ZNF547 RNA"
  ],
  "FSD2": [
    "FSD2 CNV",
    "FSD2 RNA"
  ],
  "XKR9": [
    "XKR9 CNV",
    "XKR9 RNA"
  ],
  "RPS28P5": [
    "RPS28P5 CNV",
    "RPS28P5 RNA"
  ],
  "NT5ELP": [
    "NT5ELP CNV",
    "NT5ELP RNA"
  ],
  "VPS26A": [
    "VPS26A CNV",
    "VPS26A RNA",
    "VPS26A Proteo"
  ],
  "GCNT1P4": [
    "GCNT1P4 CNV",
    "GCNT1P4 RNA"
  ],
  "SPATA2P1": [
    "SPATA2P1 CNV",
    "SPATA2P1 RNA"
  ],
  "ADAMTSL4": [
    "ADAMTSL4 CNV",
    "ADAMTSL4 RNA",
    "ADAMTSL4 Proteo"
  ],
  "OXT": [
    "OXT CNV",
    "OXT RNA"
  ],
  "TMX3": [
    "TMX3 CNV",
    "TMX3 RNA",
    "TMX3 Proteo"
  ],
  "KRT19P1": [
    "KRT19P1 CNV",
    "KRT19P1 RNA"
  ],
  "GPX2": [
    "GPX2 CNV",
    "GPX2 RNA",
    "GPX2 Proteo"
  ],
  "EIF2AK1": [
    "EIF2AK1 CNV",
    "EIF2AK1 RNA",
    "EIF2AK1 Proteo"
  ],
  "CLPTM1L": [
    "CLPTM1L CNV",
    "CLPTM1L RNA",
    "CLPTM1L Proteo"
  ],
  "HMGB1P42": [
    "HMGB1P42 CNV",
    "HMGB1P42 RNA"
  ],
  "WDR64": [
    "WDR64 CNV",
    "WDR64 RNA"
  ],
  "DNM1P38": [
    "DNM1P38 CNV",
    "DNM1P38 RNA"
  ],
  "OR55B1P": [
    "OR55B1P CNV",
    "OR55B1P RNA"
  ],
  "TRBV23OR9-2": [
    "TRBV23OR9-2 CNV",
    "TRBV23OR9-2 RNA"
  ],
  "TPRA1": [
    "TPRA1 CNV",
    "TPRA1 RNA",
    "TPRA1 Proteo"
  ],
  "CDRT15P7": [
    "CDRT15P7 CNV",
    "CDRT15P7 RNA"
  ],
  "EIF4A2": [
    "EIF4A2 CNV",
    "EIF4A2 RNA",
    "EIF4A2 Proteo"
  ],
  "GPD1": [
    "GPD1 CNV",
    "GPD1 RNA",
    "GPD1 Proteo"
  ],
  "CDY3P": [
    "CDY3P CNV",
    "CDY3P RNA"
  ],
  "RPL41P2": [
    "RPL41P2 CNV",
    "RPL41P2 RNA"
  ],
  "CNTN4": [
    "CNTN4 CNV",
    "CNTN4 RNA",
    "CNTN4 Proteo"
  ],
  "CTBP2P9": [
    "CTBP2P9 CNV",
    "CTBP2P9 RNA"
  ],
  "SLC30A3": [
    "SLC30A3 CNV",
    "SLC30A3 RNA"
  ],
  "PSMD4": [
    "PSMD4 CNV",
    "PSMD4 RNA",
    "PSMD4 Proteo"
  ],
  "PTPRCAP": [
    "PTPRCAP CNV",
    "PTPRCAP RNA",
    "PTPRCAP Proteo"
  ],
  "CARF": [
    "CARF CNV",
    "CARF RNA"
  ],
  "ING2": [
    "ING2 CNV",
    "ING2 RNA",
    "ING2 Proteo"
  ],
  "PGBD4P5": [
    "PGBD4P5 CNV",
    "PGBD4P5 RNA"
  ],
  "ANO9": [
    "ANO9 CNV",
    "ANO9 RNA",
    "ANO9 Proteo"
  ],
  "KCNJ6": [
    "KCNJ6 CNV",
    "KCNJ6 RNA"
  ],
  "OR4P1P": [
    "OR4P1P CNV",
    "OR4P1P RNA"
  ],
  "CYP2B7P": [
    "CYP2B7P CNV",
    "CYP2B7P RNA"
  ],
  "ZP3P1": [
    "ZP3P1 CNV",
    "ZP3P1 RNA"
  ],
  "GRK1": [
    "GRK1 CNV",
    "GRK1 RNA"
  ],
  "MTCO3P22": [
    "MTCO3P22 CNV",
    "MTCO3P22 RNA"
  ],
  "COMMD10": [
    "COMMD10 CNV",
    "COMMD10 RNA",
    "COMMD10 Proteo"
  ],
  "PRKG1": [
    "PRKG1 CNV",
    "PRKG1 RNA",
    "PRKG1 Proteo"
  ],
  "OR1G1": [
    "OR1G1 CNV",
    "OR1G1 RNA"
  ],
  "SLC19A2": [
    "SLC19A2 CNV",
    "SLC19A2 RNA"
  ],
  "RACGAP1": [
    "RACGAP1 CNV",
    "RACGAP1 RNA",
    "RACGAP1 Proteo"
  ],
  "PSMG1": [
    "PSMG1 CNV",
    "PSMG1 RNA",
    "PSMG1 Proteo"
  ],
  "RPL22P22": [
    "RPL22P22 CNV",
    "RPL22P22 RNA"
  ],
  "PURG": [
    "PURG CNV",
    "PURG RNA"
  ],
  "PRAMEF36P": [
    "PRAMEF36P CNV",
    "PRAMEF36P RNA"
  ],
  "DDHD1": [
    "DDHD1 CNV",
    "DDHD1 RNA",
    "DDHD1 Proteo"
  ],
  "DHRS7": [
    "DHRS7 CNV",
    "DHRS7 RNA",
    "DHRS7 Proteo"
  ],
  "ULK4P2": [
    "ULK4P2 CNV",
    "ULK4P2 RNA"
  ],
  "HAPLN2": [
    "HAPLN2 CNV",
    "HAPLN2 RNA"
  ],
  "SNRPGP19": [
    "SNRPGP19 CNV",
    "SNRPGP19 RNA"
  ],
  "CCDC34P1": [
    "CCDC34P1 CNV",
    "CCDC34P1 RNA"
  ],
  "FABP5P11": [
    "FABP5P11 CNV",
    "FABP5P11 RNA"
  ],
  "DST": [
    "DST CNV",
    "DST RNA",
    "DST Proteo"
  ],
  "ECM1P1": [
    "ECM1P1 CNV",
    "ECM1P1 RNA"
  ],
  "ANKRD30B": [
    "ANKRD30B CNV",
    "ANKRD30B RNA"
  ],
  "ZNF77": [
    "ZNF77 CNV",
    "ZNF77 RNA"
  ],
  "CXCL6": [
    "CXCL6 CNV",
    "CXCL6 RNA"
  ],
  "CANT1": [
    "CANT1 CNV",
    "CANT1 RNA",
    "CANT1 Proteo"
  ],
  "CDK5RAP2": [
    "CDK5RAP2 CNV",
    "CDK5RAP2 RNA",
    "CDK5RAP2 Proteo"
  ],
  "PLXNB1": [
    "PLXNB1 CNV",
    "PLXNB1 RNA",
    "PLXNB1 Proteo"
  ],
  "MBOAT7": [
    "MBOAT7 CNV",
    "MBOAT7 RNA",
    "MBOAT7 Proteo"
  ],
  "RARS2": [
    "RARS2 CNV",
    "RARS2 RNA",
    "RARS2 Proteo"
  ],
  "ECEL1P3": [
    "ECEL1P3 CNV",
    "ECEL1P3 RNA"
  ],
  "GPX5": [
    "GPX5 CNV",
    "GPX5 RNA"
  ],
  "CD302": [
    "CD302 CNV",
    "CD302 RNA"
  ],
  "THYN1": [
    "THYN1 CNV",
    "THYN1 RNA",
    "THYN1 Proteo"
  ],
  "TMED10": [
    "TMED10 CNV",
    "TMED10 RNA",
    "TMED10 Proteo"
  ],
  "AKAP14": [
    "AKAP14 CNV",
    "AKAP14 RNA"
  ],
  "NONOP2": [
    "NONOP2 CNV",
    "NONOP2 RNA"
  ],
  "RUFY2": [
    "RUFY2 CNV",
    "RUFY2 RNA",
    "RUFY2 Proteo"
  ],
  "OR1I1": [
    "OR1I1 CNV",
    "OR1I1 RNA"
  ],
  "NDUFB7": [
    "NDUFB7 CNV",
    "NDUFB7 RNA",
    "NDUFB7 Proteo"
  ],
  "RAB25": [
    "RAB25 CNV",
    "RAB25 RNA",
    "RAB25 Proteo"
  ],
  "EEF1GP7": [
    "EEF1GP7 CNV",
    "EEF1GP7 RNA"
  ],
  "BAHCC1": [
    "BAHCC1 CNV",
    "BAHCC1 RNA",
    "BAHCC1 Proteo"
  ],
  "TRIM64B": [
    "TRIM64B CNV",
    "TRIM64B RNA"
  ],
  "THBD": [
    "THBD CNV",
    "THBD RNA",
    "THBD Proteo"
  ],
  "MMP23B": [
    "MMP23B CNV",
    "MMP23B RNA",
    "MMP23B Proteo"
  ],
  "USP41": [
    "USP41 CNV",
    "USP41 RNA"
  ],
  "PRODH2": [
    "PRODH2 CNV",
    "PRODH2 RNA"
  ],
  "TVP23A": [
    "TVP23A CNV",
    "TVP23A RNA"
  ],
  "MED15": [
    "MED15 CNV",
    "MED15 RNA",
    "MED15 Proteo"
  ],
  "ERAP2": [
    "ERAP2 CNV",
    "ERAP2 RNA",
    "ERAP2 Proteo"
  ],
  "ZNF680": [
    "ZNF680 CNV",
    "ZNF680 RNA"
  ],
  "HPS5": [
    "HPS5 CNV",
    "HPS5 RNA",
    "HPS5 Proteo"
  ],
  "MTCYBP34": [
    "MTCYBP34 CNV",
    "MTCYBP34 RNA"
  ],
  "HSFX4": [
    "HSFX4 CNV",
    "HSFX4 RNA"
  ],
  "CCL28": [
    "CCL28 CNV",
    "CCL28 RNA"
  ],
  "COX7B": [
    "COX7B CNV",
    "COX7B RNA",
    "COX7B Proteo"
  ],
  "UBE3B": [
    "UBE3B CNV",
    "UBE3B RNA",
    "UBE3B Proteo"
  ],
  "RPSAP5": [
    "RPSAP5 CNV",
    "RPSAP5 RNA"
  ],
  "RPEP5": [
    "RPEP5 CNV",
    "RPEP5 RNA"
  ],
  "RPL15P21": [
    "RPL15P21 CNV",
    "RPL15P21 RNA"
  ],
  "CTU2": [
    "CTU2 CNV",
    "CTU2 RNA",
    "CTU2 Proteo"
  ],
  "MACC1": [
    "MACC1 CNV",
    "MACC1 RNA",
    "MACC1 Proteo"
  ],
  "SLC4A4": [
    "SLC4A4 CNV",
    "SLC4A4 RNA"
  ],
  "STK24": [
    "STK24 CNV",
    "STK24 RNA",
    "STK24 Proteo"
  ],
  "MFAP4": [
    "MFAP4 CNV",
    "MFAP4 RNA",
    "MFAP4 Proteo"
  ],
  "OR7E156P": [
    "OR7E156P CNV",
    "OR7E156P RNA"
  ],
  "GRIPAP1": [
    "GRIPAP1 CNV",
    "GRIPAP1 RNA",
    "GRIPAP1 Proteo"
  ],
  "TRBV12-2": [
    "TRBV12-2 CNV",
    "TRBV12-2 RNA"
  ],
  "GCH1": [
    "GCH1 CNV",
    "GCH1 RNA",
    "GCH1 Proteo"
  ],
  "PNLIPRP3": [
    "PNLIPRP3 CNV",
    "PNLIPRP3 RNA",
    "PNLIPRP3 Proteo"
  ],
  "AMY1C": [
    "AMY1C CNV",
    "AMY1C RNA"
  ],
  "RPP40": [
    "RPP40 CNV",
    "RPP40 RNA",
    "RPP40 Proteo"
  ],
  "BFSP1": [
    "BFSP1 CNV",
    "BFSP1 RNA"
  ],
  "COL25A1": [
    "COL25A1 CNV",
    "COL25A1 RNA"
  ],
  "CTBP2P6": [
    "CTBP2P6 CNV",
    "CTBP2P6 RNA"
  ],
  "CDY19P": [
    "CDY19P CNV",
    "CDY19P RNA"
  ],
  "NKAIN1": [
    "NKAIN1 CNV",
    "NKAIN1 RNA"
  ],
  "SESN1": [
    "SESN1 CNV",
    "SESN1 RNA",
    "SESN1 Proteo"
  ],
  "IL21R": [
    "IL21R CNV",
    "IL21R RNA"
  ],
  "SRGAP1": [
    "SRGAP1 CNV",
    "SRGAP1 RNA",
    "SRGAP1 Proteo"
  ],
  "KDM6B": [
    "KDM6B CNV",
    "KDM6B RNA",
    "KDM6B Proteo"
  ],
  "TAAR8": [
    "TAAR8 CNV",
    "TAAR8 RNA"
  ],
  "EEF1B2P5": [
    "EEF1B2P5 CNV",
    "EEF1B2P5 RNA"
  ],
  "TEX264": [
    "TEX264 CNV",
    "TEX264 RNA",
    "TEX264 Proteo"
  ],
  "TRBV22OR9-2": [
    "TRBV22OR9-2 CNV",
    "TRBV22OR9-2 RNA"
  ],
  "C7": [
    "C7 CNV",
    "C7 RNA",
    "C7 Proteo"
  ],
  "MYDGF": [
    "MYDGF CNV",
    "MYDGF RNA",
    "MYDGF Proteo"
  ],
  "SURF6": [
    "SURF6 CNV",
    "SURF6 RNA",
    "SURF6 Proteo"
  ],
  "STK32B": [
    "STK32B CNV",
    "STK32B RNA"
  ],
  "HCRTR2": [
    "HCRTR2 CNV",
    "HCRTR2 RNA"
  ],
  "IFI44": [
    "IFI44 CNV",
    "IFI44 RNA",
    "IFI44 Proteo"
  ],
  "PHF6": [
    "PHF6 CNV",
    "PHF6 RNA",
    "PHF6 Proteo"
  ],
  "ARHGAP10": [
    "ARHGAP10 CNV",
    "ARHGAP10 RNA",
    "ARHGAP10 Proteo"
  ],
  "BAZ1A": [
    "BAZ1A CNV",
    "BAZ1A RNA",
    "BAZ1A Proteo"
  ],
  "HAND1": [
    "HAND1 CNV",
    "HAND1 RNA"
  ],
  "HSPA9": [
    "HSPA9 CNV",
    "HSPA9 RNA",
    "HSPA9 Proteo"
  ],
  "SMIM21": [
    "SMIM21 CNV",
    "SMIM21 RNA"
  ],
  "OR2AQ1P": [
    "OR2AQ1P CNV",
    "OR2AQ1P RNA"
  ],
  "USP24": [
    "USP24 CNV",
    "USP24 RNA",
    "USP24 Proteo"
  ],
  "TAF9BP2": [
    "TAF9BP2 CNV",
    "TAF9BP2 RNA"
  ],
  "UBE2Z": [
    "UBE2Z CNV",
    "UBE2Z RNA",
    "UBE2Z Proteo"
  ],
  "ALS2": [
    "ALS2 CNV",
    "ALS2 RNA",
    "ALS2 Proteo"
  ],
  "KCNAB3": [
    "KCNAB3 CNV",
    "KCNAB3 RNA"
  ],
  "CPTP": [
    "CPTP CNV",
    "CPTP RNA",
    "CPTP Proteo"
  ],
  "ZNF292": [
    "ZNF292 CNV",
    "ZNF292 RNA",
    "ZNF292 Proteo"
  ],
  "MTCO1P21": [
    "MTCO1P21 CNV",
    "MTCO1P21 RNA"
  ],
  "MAP1LC3BP1": [
    "MAP1LC3BP1 CNV",
    "MAP1LC3BP1 RNA"
  ],
  "CSAG1": [
    "CSAG1 CNV",
    "CSAG1 RNA"
  ],
  "RBCK1": [
    "RBCK1 CNV",
    "RBCK1 RNA",
    "RBCK1 Proteo"
  ],
  "WAPL": [
    "WAPL CNV",
    "WAPL RNA",
    "WAPL Proteo"
  ],
  "UPK3BP1": [
    "UPK3BP1 CNV",
    "UPK3BP1 RNA"
  ],
  "NPLOC4": [
    "NPLOC4 CNV",
    "NPLOC4 RNA",
    "NPLOC4 Proteo"
  ],
  "LEO1": [
    "LEO1 CNV",
    "LEO1 RNA",
    "LEO1 Proteo"
  ],
  "POLR3A": [
    "POLR3A CNV",
    "POLR3A RNA",
    "POLR3A Proteo"
  ],
  "DET1": [
    "DET1 CNV",
    "DET1 RNA",
    "DET1 Proteo"
  ],
  "IGHV4-55": [
    "IGHV4-55 CNV",
    "IGHV4-55 RNA"
  ],
  "TGIF2LX": [
    "TGIF2LX CNV",
    "TGIF2LX RNA"
  ],
  "KCNIP2": [
    "KCNIP2 CNV",
    "KCNIP2 RNA"
  ],
  "PPP1R16A": [
    "PPP1R16A CNV",
    "PPP1R16A RNA",
    "PPP1R16A Proteo"
  ],
  "ATE1-AS1": [
    "ATE1-AS1 CNV",
    "ATE1-AS1 RNA"
  ],
  "EGR4": [
    "EGR4 CNV",
    "EGR4 RNA"
  ],
  "EIF3IP1": [
    "EIF3IP1 CNV",
    "EIF3IP1 RNA"
  ],
  "MTCYBP1": [
    "MTCYBP1 CNV",
    "MTCYBP1 RNA"
  ],
  "RPL7L1P5": [
    "RPL7L1P5 CNV",
    "RPL7L1P5 RNA"
  ],
  "FZD8": [
    "FZD8 CNV",
    "FZD8 RNA"
  ],
  "HCG4P8": [
    "HCG4P8 CNV",
    "HCG4P8 RNA"
  ],
  "ATP5MC1P3": [
    "ATP5MC1P3 CNV",
    "ATP5MC1P3 RNA"
  ],
  "FAM234B": [
    "FAM234B CNV",
    "FAM234B RNA",
    "FAM234B Proteo"
  ],
  "RPL10P2": [
    "RPL10P2 CNV",
    "RPL10P2 RNA"
  ],
  "FAM90A24P": [
    "FAM90A24P CNV",
    "FAM90A24P RNA"
  ],
  "CD99L2": [
    "CD99L2 CNV",
    "CD99L2 RNA",
    "CD99L2 Proteo"
  ],
  "MTND4P5": [
    "MTND4P5 CNV",
    "MTND4P5 RNA"
  ],
  "PRDX3P1": [
    "PRDX3P1 CNV",
    "PRDX3P1 RNA"
  ],
  "RRAD": [
    "RRAD CNV",
    "RRAD RNA",
    "RRAD Proteo"
  ],
  "STARP1": [
    "STARP1 CNV",
    "STARP1 RNA"
  ],
  "JADE1": [
    "JADE1 CNV",
    "JADE1 RNA",
    "JADE1 Proteo"
  ],
  "MED12": [
    "MED12 CNV",
    "MED12 RNA",
    "MED12 Proteo"
  ],
  "OR4C9P": [
    "OR4C9P CNV",
    "OR4C9P RNA"
  ],
  "MPZ": [
    "MPZ CNV",
    "MPZ RNA",
    "MPZ Proteo"
  ],
  "IGHV3-20": [
    "IGHV3-20 Proteo"
  ],
  "TCTN2": [
    "TCTN2 CNV",
    "TCTN2 RNA",
    "TCTN2 Proteo"
  ],
  "SNRPGP11": [
    "SNRPGP11 CNV",
    "SNRPGP11 RNA"
  ],
  "SETD4": [
    "SETD4 CNV",
    "SETD4 RNA"
  ],
  "ATXN7": [
    "ATXN7 CNV",
    "ATXN7 RNA",
    "ATXN7 Proteo"
  ],
  "CEP83": [
    "CEP83 CNV",
    "CEP83 RNA",
    "CEP83 Proteo"
  ],
  "OR13G1": [
    "OR13G1 CNV",
    "OR13G1 RNA"
  ],
  "COMMD4P1": [
    "COMMD4P1 CNV",
    "COMMD4P1 RNA"
  ],
  "MEMO1P5": [
    "MEMO1P5 CNV",
    "MEMO1P5 RNA"
  ],
  "IL31": [
    "IL31 CNV",
    "IL31 RNA"
  ],
  "ANXA6": [
    "ANXA6 CNV",
    "ANXA6 RNA",
    "ANXA6 Proteo"
  ],
  "GAL3ST4": [
    "GAL3ST4 CNV",
    "GAL3ST4 RNA",
    "GAL3ST4 Proteo"
  ],
  "ATL3": [
    "ATL3 CNV",
    "ATL3 RNA",
    "ATL3 Proteo"
  ],
  "OR4C3": [
    "OR4C3 CNV",
    "OR4C3 RNA"
  ],
  "NASPP1": [
    "NASPP1 CNV",
    "NASPP1 RNA"
  ],
  "SH3RF1": [
    "SH3RF1 CNV",
    "SH3RF1 RNA",
    "SH3RF1 Proteo"
  ],
  "HNRNPA1P36": [
    "HNRNPA1P36 CNV",
    "HNRNPA1P36 RNA"
  ],
  "ZNHIT6": [
    "ZNHIT6 CNV",
    "ZNHIT6 RNA",
    "ZNHIT6 Proteo"
  ],
  "DYNLL1P5": [
    "DYNLL1P5 CNV",
    "DYNLL1P5 RNA"
  ],
  "STAG3": [
    "STAG3 CNV",
    "STAG3 RNA",
    "STAG3 Proteo"
  ],
  "INCA1": [
    "INCA1 CNV",
    "INCA1 RNA"
  ],
  "MPHOSPH10P3": [
    "MPHOSPH10P3 CNV",
    "MPHOSPH10P3 RNA"
  ],
  "CCDC170": [
    "CCDC170 CNV",
    "CCDC170 RNA",
    "CCDC170 Proteo"
  ],
  "KCNJ16": [
    "KCNJ16 CNV",
    "KCNJ16 RNA"
  ],
  "SPRED2": [
    "SPRED2 CNV",
    "SPRED2 RNA",
    "SPRED2 Proteo"
  ],
  "SUOX": [
    "SUOX CNV",
    "SUOX RNA",
    "SUOX Proteo"
  ],
  "LINC00301": [
    "LINC00301 CNV",
    "LINC00301 RNA"
  ],
  "TMEM45A": [
    "TMEM45A CNV",
    "TMEM45A RNA"
  ],
  "GABBR2": [
    "GABBR2 CNV",
    "GABBR2 RNA"
  ],
  "DGKH": [
    "DGKH CNV",
    "DGKH RNA",
    "DGKH Proteo"
  ],
  "RPL23AP97": [
    "RPL23AP97 CNV",
    "RPL23AP97 RNA"
  ],
  "LRP12": [
    "LRP12 CNV",
    "LRP12 RNA",
    "LRP12 Proteo"
  ],
  "PRELID3BP3": [
    "PRELID3BP3 CNV",
    "PRELID3BP3 RNA"
  ],
  "RNA5SP164": [
    "RNA5SP164 CNV",
    "RNA5SP164 RNA"
  ],
  "SFTPA2": [
    "SFTPA2 CNV",
    "SFTPA2 RNA",
    "SFTPA2 Proteo"
  ],
  "IGHV3-13": [
    "IGHV3-13 Proteo"
  ],
  "TMEM41B": [
    "TMEM41B CNV",
    "TMEM41B RNA",
    "TMEM41B Proteo"
  ],
  "FOXO4": [
    "FOXO4 CNV",
    "FOXO4 RNA",
    "FOXO4 Proteo"
  ],
  "HSFY5P": [
    "HSFY5P CNV",
    "HSFY5P RNA"
  ],
  "USP17L1": [
    "USP17L1 CNV",
    "USP17L1 RNA"
  ],
  "RPH3AL": [
    "RPH3AL CNV",
    "RPH3AL RNA"
  ],
  "ZEB2P1": [
    "ZEB2P1 CNV",
    "ZEB2P1 RNA"
  ],
  "ANKLE1": [
    "ANKLE1 CNV",
    "ANKLE1 RNA"
  ],
  "C5orf46": [
    "C5orf46 CNV",
    "C5orf46 RNA"
  ],
  "DNLZ": [
    "DNLZ CNV",
    "DNLZ RNA",
    "DNLZ Proteo"
  ],
  "NDUFA3P1": [
    "NDUFA3P1 CNV",
    "NDUFA3P1 RNA"
  ],
  "ZFYVE9P2": [
    "ZFYVE9P2 CNV",
    "ZFYVE9P2 RNA"
  ],
  "HMGN1P19": [
    "HMGN1P19 CNV",
    "HMGN1P19 RNA"
  ],
  "H3P47": [
    "H3P47 CNV",
    "H3P47 RNA"
  ],
  "HK1": [
    "HK1 CNV",
    "HK1 RNA",
    "HK1 Proteo"
  ],
  "HECTD1": [
    "HECTD1 CNV",
    "HECTD1 RNA",
    "HECTD1 Proteo"
  ],
  "FRMPD1": [
    "FRMPD1 CNV",
    "FRMPD1 RNA"
  ],
  "RPL41P5": [
    "RPL41P5 CNV",
    "RPL41P5 RNA"
  ],
  "HGFAC": [
    "HGFAC CNV",
    "HGFAC RNA",
    "HGFAC Proteo"
  ],
  "DNAJC19P6": [
    "DNAJC19P6 CNV",
    "DNAJC19P6 RNA"
  ],
  "GNPTAB": [
    "GNPTAB CNV",
    "GNPTAB RNA",
    "GNPTAB Proteo"
  ],
  "HTR2A": [
    "HTR2A CNV",
    "HTR2A RNA"
  ],
  "COQ4": [
    "COQ4 CNV",
    "COQ4 RNA",
    "COQ4 Proteo"
  ],
  "GRPEL2P2": [
    "GRPEL2P2 CNV",
    "GRPEL2P2 RNA"
  ],
  "FUNDC2P4": [
    "FUNDC2P4 CNV",
    "FUNDC2P4 RNA"
  ],
  "BNIP3P18": [
    "BNIP3P18 CNV",
    "BNIP3P18 RNA"
  ],
  "GNG10": [
    "GNG10 CNV",
    "GNG10 RNA",
    "GNG10 Proteo"
  ],
  "VNN1": [
    "VNN1 CNV",
    "VNN1 RNA",
    "VNN1 Proteo"
  ],
  "KRT6A": [
    "KRT6A CNV",
    "KRT6A RNA",
    "KRT6A Proteo"
  ],
  "FHIP1A": [
    "FHIP1A CNV",
    "FHIP1A RNA",
    "FHIP1A Proteo"
  ],
  "RPL36P1": [
    "RPL36P1 CNV",
    "RPL36P1 RNA"
  ],
  "LSM3P4": [
    "LSM3P4 CNV",
    "LSM3P4 RNA"
  ],
  "OPN4": [
    "OPN4 CNV",
    "OPN4 RNA"
  ],
  "ATAD1": [
    "ATAD1 CNV",
    "ATAD1 RNA",
    "ATAD1 Proteo"
  ],
  "PLCD3": [
    "PLCD3 CNV",
    "PLCD3 RNA",
    "PLCD3 Proteo"
  ],
  "PCSK4": [
    "PCSK4 CNV",
    "PCSK4 RNA"
  ],
  "ZCCHC13": [
    "ZCCHC13 CNV",
    "ZCCHC13 RNA"
  ],
  "POLR3F": [
    "POLR3F CNV",
    "POLR3F RNA",
    "POLR3F Proteo"
  ],
  "RPS15AP5": [
    "RPS15AP5 CNV",
    "RPS15AP5 RNA"
  ],
  "OR11P1P": [
    "OR11P1P CNV",
    "OR11P1P RNA"
  ],
  "SPATA17": [
    "SPATA17 CNV",
    "SPATA17 RNA"
  ],
  "TXNDC15": [
    "TXNDC15 CNV",
    "TXNDC15 RNA",
    "TXNDC15 Proteo"
  ],
  "RPL24": [
    "RPL24 CNV",
    "RPL24 RNA",
    "RPL24 Proteo"
  ],
  "DYNLL1P3": [
    "DYNLL1P3 CNV",
    "DYNLL1P3 RNA"
  ],
  "PEX14": [
    "PEX14 CNV",
    "PEX14 RNA",
    "PEX14 Proteo"
  ],
  "TIGD4": [
    "TIGD4 CNV",
    "TIGD4 RNA"
  ],
  "GGTLC1": [
    "GGTLC1 CNV",
    "GGTLC1 RNA"
  ],
  "PTCH1": [
    "PTCH1 CNV",
    "PTCH1 RNA"
  ],
  "OR10T1P": [
    "OR10T1P CNV",
    "OR10T1P RNA"
  ],
  "UBE2V2P4": [
    "UBE2V2P4 CNV",
    "UBE2V2P4 RNA"
  ],
  "NACAD": [
    "NACAD CNV",
    "NACAD RNA",
    "NACAD Proteo"
  ],
  "MRPL15P1": [
    "MRPL15P1 CNV",
    "MRPL15P1 RNA"
  ],
  "ZNF402P": [
    "ZNF402P CNV",
    "ZNF402P RNA"
  ],
  "CCDC171": [
    "CCDC171 CNV",
    "CCDC171 RNA"
  ],
  "SYK": [
    "SYK CNV",
    "SYK RNA",
    "SYK Proteo"
  ],
  "FGF21": [
    "FGF21 CNV",
    "FGF21 RNA"
  ],
  "RNA5SP148": [
    "RNA5SP148 CNV",
    "RNA5SP148 RNA"
  ],
  "TRIM4": [
    "TRIM4 CNV",
    "TRIM4 RNA",
    "TRIM4 Proteo"
  ],
  "MTCO3P35": [
    "MTCO3P35 CNV",
    "MTCO3P35 RNA"
  ],
  "DUSP5P1": [
    "DUSP5P1 CNV",
    "DUSP5P1 RNA"
  ],
  "EXOSC3": [
    "EXOSC3 CNV",
    "EXOSC3 RNA",
    "EXOSC3 Proteo"
  ],
  "TAF11L11": [
    "TAF11L11 CNV",
    "TAF11L11 RNA"
  ],
  "TOMM40P2": [
    "TOMM40P2 CNV",
    "TOMM40P2 RNA"
  ],
  "DUSP6": [
    "DUSP6 CNV",
    "DUSP6 RNA",
    "DUSP6 Proteo"
  ],
  "DIP2C": [
    "DIP2C CNV",
    "DIP2C RNA",
    "DIP2C Proteo"
  ],
  "AARD": [
    "AARD CNV",
    "AARD RNA"
  ],
  "ACBD6": [
    "ACBD6 CNV",
    "ACBD6 RNA",
    "ACBD6 Proteo"
  ],
  "HDX": [
    "HDX CNV",
    "HDX RNA"
  ],
  "KCNK4": [
    "KCNK4 CNV",
    "KCNK4 RNA"
  ],
  "ATP23": [
    "ATP23 CNV",
    "ATP23 RNA",
    "ATP23 Proteo"
  ],
  "AGA": [
    "AGA CNV",
    "AGA RNA",
    "AGA Proteo"
  ],
  "IFNW1": [
    "IFNW1 CNV",
    "IFNW1 RNA"
  ],
  "IGDCC4": [
    "IGDCC4 CNV",
    "IGDCC4 RNA",
    "IGDCC4 Proteo"
  ],
  "PRDX5": [
    "PRDX5 CNV",
    "PRDX5 RNA",
    "PRDX5 Proteo"
  ],
  "OTX1": [
    "OTX1 CNV",
    "OTX1 RNA",
    "OTX1 Proteo"
  ],
  "LRRTM1": [
    "LRRTM1 CNV",
    "LRRTM1 RNA"
  ],
  "HPSE2": [
    "HPSE2 CNV",
    "HPSE2 RNA"
  ],
  "RICTOR": [
    "RICTOR CNV",
    "RICTOR RNA",
    "RICTOR Proteo"
  ],
  "SCFD1": [
    "SCFD1 CNV",
    "SCFD1 RNA",
    "SCFD1 Proteo"
  ],
  "RPS16P8": [
    "RPS16P8 CNV",
    "RPS16P8 RNA"
  ],
  "PDCL2P2": [
    "PDCL2P2 CNV",
    "PDCL2P2 RNA"
  ],
  "NDUFA4P2": [
    "NDUFA4P2 CNV",
    "NDUFA4P2 RNA"
  ],
  "ZNF416": [
    "ZNF416 CNV",
    "ZNF416 RNA"
  ],
  "EBF3": [
    "EBF3 CNV",
    "EBF3 RNA",
    "EBF3 Proteo"
  ],
  "POLI": [
    "POLI CNV",
    "POLI RNA",
    "POLI Proteo"
  ],
  "HAX1": [
    "HAX1 CNV",
    "HAX1 RNA",
    "HAX1 Proteo"
  ],
  "SARDH": [
    "SARDH CNV",
    "SARDH RNA",
    "SARDH Proteo"
  ],
  "H2AB1": [
    "H2AB1 CNV",
    "H2AB1 RNA"
  ],
  "ZNF563": [
    "ZNF563 CNV",
    "ZNF563 RNA"
  ],
  "PPIAP59": [
    "PPIAP59 CNV",
    "PPIAP59 RNA"
  ],
  "TOP3BP1": [
    "TOP3BP1 CNV",
    "TOP3BP1 RNA"
  ],
  "ATP5F1C": [
    "ATP5F1C CNV",
    "ATP5F1C RNA",
    "ATP5F1C Proteo"
  ],
  "CFAP44": [
    "CFAP44 CNV",
    "CFAP44 RNA"
  ],
  "FBXO38": [
    "FBXO38 CNV",
    "FBXO38 RNA",
    "FBXO38 Proteo"
  ],
  "USP17L20": [
    "USP17L20 CNV",
    "USP17L20 RNA"
  ],
  "FAM86FP": [
    "FAM86FP CNV",
    "FAM86FP RNA"
  ],
  "EIF4BP2": [
    "EIF4BP2 CNV",
    "EIF4BP2 RNA"
  ],
  "EQTN": [
    "EQTN CNV",
    "EQTN RNA"
  ],
  "LILRB2": [
    "LILRB2 CNV",
    "LILRB2 RNA",
    "LILRB2 Proteo"
  ],
  "TBC1D3P7": [
    "TBC1D3P7 CNV",
    "TBC1D3P7 RNA"
  ],
  "MTL3P": [
    "MTL3P CNV",
    "MTL3P RNA"
  ],
  "IGHV3-32": [
    "IGHV3-32 CNV",
    "IGHV3-32 RNA"
  ],
  "USHBP1": [
    "USHBP1 CNV",
    "USHBP1 RNA"
  ],
  "MAPK14": [
    "MAPK14 CNV",
    "MAPK14 RNA",
    "MAPK14 Proteo"
  ],
  "ADORA2A": [
    "ADORA2A CNV",
    "ADORA2A RNA"
  ],
  "TSLP": [
    "TSLP CNV",
    "TSLP RNA"
  ],
  "CA12": [
    "CA12 CNV",
    "CA12 RNA",
    "CA12 Proteo"
  ],
  "CHST11": [
    "CHST11 CNV",
    "CHST11 RNA",
    "CHST11 Proteo"
  ],
  "TARS3": [
    "TARS3 CNV",
    "TARS3 RNA",
    "TARS3 Proteo"
  ],
  "NOM1": [
    "NOM1 CNV",
    "NOM1 RNA",
    "NOM1 Proteo"
  ],
  "MUCL3": [
    "MUCL3 CNV",
    "MUCL3 RNA"
  ],
  "FAT1": [
    "FAT1 CNV",
    "FAT1 RNA",
    "FAT1 Proteo"
  ],
  "ATP1A2": [
    "ATP1A2 CNV",
    "ATP1A2 RNA",
    "ATP1A2 Proteo"
  ],
  "POTEE": [
    "POTEE CNV",
    "POTEE RNA"
  ],
  "BCL10": [
    "BCL10 CNV",
    "BCL10 RNA",
    "BCL10 Proteo"
  ],
  "RNF10P1": [
    "RNF10P1 CNV",
    "RNF10P1 RNA"
  ],
  "SMCO1": [
    "SMCO1 CNV",
    "SMCO1 RNA"
  ],
  "PRB1": [
    "PRB1 CNV",
    "PRB1 RNA"
  ],
  "HNRNPA3P4": [
    "HNRNPA3P4 CNV",
    "HNRNPA3P4 RNA"
  ],
  "ST13": [
    "ST13 CNV",
    "ST13 RNA",
    "ST13 Proteo"
  ],
  "COPRS": [
    "COPRS CNV",
    "COPRS RNA",
    "COPRS Proteo"
  ],
  "RNA5SP95": [
    "RNA5SP95 CNV",
    "RNA5SP95 RNA"
  ],
  "CMTR2": [
    "CMTR2 CNV",
    "CMTR2 RNA",
    "CMTR2 Proteo"
  ],
  "B3GAT3P1": [
    "B3GAT3P1 CNV",
    "B3GAT3P1 RNA"
  ],
  "ZSCAN5DP": [
    "ZSCAN5DP CNV",
    "ZSCAN5DP RNA"
  ],
  "OC90": [
    "OC90 CNV",
    "OC90 RNA"
  ],
  "RAD51AP2": [
    "RAD51AP2 CNV",
    "RAD51AP2 RNA"
  ],
  "MYOZ3": [
    "MYOZ3 CNV",
    "MYOZ3 RNA"
  ],
  "KCNH3": [
    "KCNH3 CNV",
    "KCNH3 RNA"
  ],
  "RNFT1": [
    "RNFT1 CNV",
    "RNFT1 RNA",
    "RNFT1 Proteo"
  ],
  "TRIM60P13": [
    "TRIM60P13 CNV",
    "TRIM60P13 RNA"
  ],
  "CBWD6": [
    "CBWD6 CNV",
    "CBWD6 RNA",
    "CBWD6 Proteo"
  ],
  "MARK2P6": [
    "MARK2P6 CNV",
    "MARK2P6 RNA"
  ],
  "VCY": [
    "VCY CNV",
    "VCY RNA"
  ],
  "C22orf39": [
    "C22orf39 CNV",
    "C22orf39 RNA",
    "C22orf39 Proteo"
  ],
  "OR4F7P": [
    "OR4F7P CNV",
    "OR4F7P RNA"
  ],
  "OAS1": [
    "OAS1 CNV",
    "OAS1 RNA",
    "OAS1 Proteo"
  ],
  "EPB41L4A": [
    "EPB41L4A CNV",
    "EPB41L4A RNA",
    "EPB41L4A Proteo"
  ],
  "DBR1": [
    "DBR1 CNV",
    "DBR1 RNA",
    "DBR1 Proteo"
  ],
  "PARP1P2": [
    "PARP1P2 CNV",
    "PARP1P2 RNA"
  ],
  "NDUFA5P7": [
    "NDUFA5P7 CNV",
    "NDUFA5P7 RNA"
  ],
  "POLR3KP2": [
    "POLR3KP2 CNV",
    "POLR3KP2 RNA"
  ],
  "IL33": [
    "IL33 CNV",
    "IL33 RNA",
    "IL33 Proteo"
  ],
  "LIMS1": [
    "LIMS1 CNV",
    "LIMS1 RNA",
    "LIMS1 Proteo"
  ],
  "RPL7AP78": [
    "RPL7AP78 CNV",
    "RPL7AP78 RNA"
  ],
  "TAS2R46": [
    "TAS2R46 CNV",
    "TAS2R46 RNA"
  ],
  "UBE3A": [
    "UBE3A CNV",
    "UBE3A RNA",
    "UBE3A Proteo"
  ],
  "CDC26P1": [
    "CDC26P1 CNV",
    "CDC26P1 RNA"
  ],
  "RPL13A": [
    "RPL13A CNV",
    "RPL13A RNA",
    "RPL13A Proteo"
  ],
  "PRPF8": [
    "PRPF8 CNV",
    "PRPF8 RNA",
    "PRPF8 Proteo"
  ],
  "VPS33A": [
    "VPS33A CNV",
    "VPS33A RNA",
    "VPS33A Proteo"
  ],
  "TAF11L3": [
    "TAF11L3 CNV",
    "TAF11L3 RNA"
  ],
  "MN1": [
    "MN1 CNV",
    "MN1 RNA"
  ],
  "RNA5SP98": [
    "RNA5SP98 CNV",
    "RNA5SP98 RNA"
  ],
  "IZUMO2": [
    "IZUMO2 CNV",
    "IZUMO2 RNA"
  ],
  "RSL24D1P2": [
    "RSL24D1P2 CNV",
    "RSL24D1P2 RNA"
  ],
  "PPP1R1AP2": [
    "PPP1R1AP2 CNV",
    "PPP1R1AP2 RNA"
  ],
  "FAM24A": [
    "FAM24A CNV",
    "FAM24A RNA"
  ],
  "H3P36": [
    "H3P36 CNV",
    "H3P36 RNA"
  ],
  "TMBIM7P": [
    "TMBIM7P CNV",
    "TMBIM7P RNA"
  ],
  "OR4C5": [
    "OR4C5 CNV",
    "OR4C5 RNA"
  ],
  "BRWD1P2": [
    "BRWD1P2 CNV",
    "BRWD1P2 RNA"
  ],
  "TMEM135": [
    "TMEM135 CNV",
    "TMEM135 RNA",
    "TMEM135 Proteo"
  ],
  "OGFR": [
    "OGFR CNV",
    "OGFR RNA",
    "OGFR Proteo"
  ],
  "PPARD": [
    "PPARD CNV",
    "PPARD RNA",
    "PPARD Proteo"
  ],
  "NAGS": [
    "NAGS CNV",
    "NAGS RNA",
    "NAGS Proteo"
  ],
  "BMPR1AP2": [
    "BMPR1AP2 CNV",
    "BMPR1AP2 RNA"
  ],
  "C2orf68": [
    "C2orf68 CNV",
    "C2orf68 RNA",
    "C2orf68 Proteo"
  ],
  "CACFD1": [
    "CACFD1 CNV",
    "CACFD1 RNA",
    "CACFD1 Proteo"
  ],
  "KRT8P20": [
    "KRT8P20 CNV",
    "KRT8P20 RNA"
  ],
  "DND1": [
    "DND1 CNV",
    "DND1 RNA"
  ],
  "MIER2": [
    "MIER2 CNV",
    "MIER2 RNA"
  ],
  "PIGW": [
    "PIGW CNV",
    "PIGW RNA",
    "PIGW Proteo"
  ],
  "C18orf25": [
    "C18orf25 CNV",
    "C18orf25 RNA",
    "C18orf25 Proteo"
  ],
  "LCN6": [
    "LCN6 CNV",
    "LCN6 RNA"
  ],
  "CDY1": [
    "CDY1 CNV",
    "CDY1 RNA"
  ],
  "KRTCAP2": [
    "KRTCAP2 CNV",
    "KRTCAP2 RNA",
    "KRTCAP2 Proteo"
  ],
  "DNAJC9": [
    "DNAJC9 CNV",
    "DNAJC9 RNA",
    "DNAJC9 Proteo"
  ],
  "TCP10L3": [
    "TCP10L3 CNV",
    "TCP10L3 RNA"
  ],
  "TMEM131": [
    "TMEM131 CNV",
    "TMEM131 RNA",
    "TMEM131 Proteo"
  ],
  "MAP4K1": [
    "MAP4K1 CNV",
    "MAP4K1 RNA",
    "MAP4K1 Proteo"
  ],
  "POLR2L": [
    "POLR2L CNV",
    "POLR2L RNA",
    "POLR2L Proteo"
  ],
  "RSKR": [
    "RSKR CNV",
    "RSKR RNA"
  ],
  "TRMT6": [
    "TRMT6 CNV",
    "TRMT6 RNA",
    "TRMT6 Proteo"
  ],
  "DQX1": [
    "DQX1 CNV",
    "DQX1 RNA"
  ],
  "AZIN2": [
    "AZIN2 CNV",
    "AZIN2 RNA"
  ],
  "KHDC1": [
    "KHDC1 CNV",
    "KHDC1 RNA"
  ],
  "ROBO2P1": [
    "ROBO2P1 CNV",
    "ROBO2P1 RNA"
  ],
  "TAGLN3": [
    "TAGLN3 CNV",
    "TAGLN3 RNA",
    "TAGLN3 Proteo"
  ],
  "ABCB4": [
    "ABCB4 CNV",
    "ABCB4 RNA",
    "ABCB4 Proteo"
  ],
  "KISS1": [
    "KISS1 CNV",
    "KISS1 RNA"
  ],
  "PLAAT3": [
    "PLAAT3 CNV",
    "PLAAT3 RNA",
    "PLAAT3 Proteo"
  ],
  "MYPOP": [
    "MYPOP CNV",
    "MYPOP RNA",
    "MYPOP Proteo"
  ],
  "MSANTD3P1": [
    "MSANTD3P1 CNV",
    "MSANTD3P1 RNA"
  ],
  "IGLV3-7": [
    "IGLV3-7 CNV",
    "IGLV3-7 RNA"
  ],
  "CTBP2P3": [
    "CTBP2P3 CNV",
    "CTBP2P3 RNA"
  ],
  "UBR4": [
    "UBR4 CNV",
    "UBR4 RNA",
    "UBR4 Proteo"
  ],
  "LTB": [
    "LTB CNV",
    "LTB RNA",
    "LTB Proteo"
  ],
  "IL36A": [
    "IL36A CNV",
    "IL36A RNA"
  ],
  "TDGF1P4": [
    "TDGF1P4 CNV",
    "TDGF1P4 RNA"
  ],
  "NUS1P1": [
    "NUS1P1 CNV",
    "NUS1P1 RNA"
  ],
  "MTND1P6": [
    "MTND1P6 CNV",
    "MTND1P6 RNA"
  ],
  "SLN": [
    "SLN CNV",
    "SLN RNA"
  ],
  "ICAM3": [
    "ICAM3 CNV",
    "ICAM3 RNA",
    "ICAM3 Proteo"
  ],
  "LSP1P4": [
    "LSP1P4 CNV",
    "LSP1P4 RNA"
  ],
  "CTCFL": [
    "CTCFL CNV",
    "CTCFL RNA"
  ],
  "RPL23AP23": [
    "RPL23AP23 CNV",
    "RPL23AP23 RNA"
  ],
  "IFT81": [
    "IFT81 CNV",
    "IFT81 RNA",
    "IFT81 Proteo"
  ],
  "RPL31P35": [
    "RPL31P35 CNV",
    "RPL31P35 RNA"
  ],
  "ARCN1": [
    "ARCN1 CNV",
    "ARCN1 RNA",
    "ARCN1 Proteo"
  ],
  "TOPORS": [
    "TOPORS CNV",
    "TOPORS RNA",
    "TOPORS Proteo"
  ],
  "RPL31P30": [
    "RPL31P30 CNV",
    "RPL31P30 RNA"
  ],
  "PODNL1": [
    "PODNL1 CNV",
    "PODNL1 RNA",
    "PODNL1 Proteo"
  ],
  "RGS11": [
    "RGS11 CNV",
    "RGS11 RNA"
  ],
  "PBXIP1": [
    "PBXIP1 CNV",
    "PBXIP1 RNA",
    "PBXIP1 Proteo"
  ],
  "LPA": [
    "LPA CNV",
    "LPA RNA",
    "LPA Proteo"
  ],
  "ELOA3BP": [
    "ELOA3BP CNV",
    "ELOA3BP RNA"
  ],
  "RRP9": [
    "RRP9 CNV",
    "RRP9 RNA",
    "RRP9 Proteo"
  ],
  "FAM240C": [
    "FAM240C CNV",
    "FAM240C RNA"
  ],
  "CT47A3": [
    "CT47A3 CNV",
    "CT47A3 RNA"
  ],
  "ABHD17AP9": [
    "ABHD17AP9 CNV",
    "ABHD17AP9 RNA"
  ],
  "HIGD1C": [
    "HIGD1C CNV",
    "HIGD1C RNA"
  ],
  "DHRS3": [
    "DHRS3 CNV",
    "DHRS3 RNA",
    "DHRS3 Proteo"
  ],
  "DCXR": [
    "DCXR CNV",
    "DCXR RNA",
    "DCXR Proteo"
  ],
  "DOK2": [
    "DOK2 CNV",
    "DOK2 RNA",
    "DOK2 Proteo"
  ],
  "ARHGAP35": [
    "ARHGAP35 CNV",
    "ARHGAP35 RNA",
    "ARHGAP35 Proteo"
  ],
  "CDH5": [
    "CDH5 CNV",
    "CDH5 RNA",
    "CDH5 Proteo"
  ],
  "PCNA": [
    "PCNA CNV",
    "PCNA RNA",
    "PCNA Proteo"
  ],
  "GAPDHP24": [
    "GAPDHP24 CNV",
    "GAPDHP24 RNA"
  ],
  "LEP": [
    "LEP CNV",
    "LEP RNA"
  ],
  "CCDC8": [
    "CCDC8 CNV",
    "CCDC8 RNA",
    "CCDC8 Proteo"
  ],
  "MUC5B": [
    "MUC5B CNV",
    "MUC5B RNA",
    "MUC5B Proteo"
  ],
  "TRAPPC2B": [
    "TRAPPC2B CNV",
    "TRAPPC2B RNA"
  ],
  "GNPDA2": [
    "GNPDA2 CNV",
    "GNPDA2 RNA",
    "GNPDA2 Proteo"
  ],
  "PSMC2": [
    "PSMC2 CNV",
    "PSMC2 RNA",
    "PSMC2 Proteo"
  ],
  "POT1": [
    "POT1 CNV",
    "POT1 RNA",
    "POT1 Proteo"
  ],
  "C12orf56": [
    "C12orf56 CNV",
    "C12orf56 RNA"
  ],
  "TAFA1": [
    "TAFA1 CNV",
    "TAFA1 RNA"
  ],
  "SMIM12P1": [
    "SMIM12P1 CNV",
    "SMIM12P1 RNA"
  ],
  "MARCHF1": [
    "MARCHF1 CNV",
    "MARCHF1 RNA"
  ],
  "NECAP1": [
    "NECAP1 CNV",
    "NECAP1 RNA",
    "NECAP1 Proteo"
  ],
  "PTPN3": [
    "PTPN3 CNV",
    "PTPN3 RNA",
    "PTPN3 Proteo"
  ],
  "CYP39A1": [
    "CYP39A1 CNV",
    "CYP39A1 RNA"
  ],
  "AP1S2P1": [
    "AP1S2P1 CNV",
    "AP1S2P1 RNA"
  ],
  "RPS23P4": [
    "RPS23P4 CNV",
    "RPS23P4 RNA"
  ],
  "CMIP": [
    "CMIP CNV",
    "CMIP RNA",
    "CMIP Proteo"
  ],
  "PRSS29P": [
    "PRSS29P CNV",
    "PRSS29P RNA"
  ],
  "TMEM249": [
    "TMEM249 CNV",
    "TMEM249 RNA"
  ],
  "SKP1P3": [
    "SKP1P3 CNV",
    "SKP1P3 RNA"
  ],
  "RBMXP2": [
    "RBMXP2 CNV",
    "RBMXP2 RNA"
  ],
  "ZNF560": [
    "ZNF560 CNV",
    "ZNF560 RNA"
  ],
  "TPGS1": [
    "TPGS1 CNV",
    "TPGS1 RNA",
    "TPGS1 Proteo"
  ],
  "RASA4": [
    "RASA4 CNV",
    "RASA4 RNA",
    "RASA4 Proteo"
  ],
  "LYPLA1": [
    "LYPLA1 CNV",
    "LYPLA1 RNA",
    "LYPLA1 Proteo"
  ],
  "RGS13": [
    "RGS13 CNV",
    "RGS13 RNA"
  ],
  "NTSR1": [
    "NTSR1 CNV",
    "NTSR1 RNA"
  ],
  "SNX9": [
    "SNX9 CNV",
    "SNX9 RNA",
    "SNX9 Proteo"
  ],
  "WARS1": [
    "WARS1 CNV",
    "WARS1 RNA",
    "WARS1 Proteo"
  ],
  "TMSB4XP3": [
    "TMSB4XP3 CNV",
    "TMSB4XP3 RNA"
  ],
  "SRSF3P5": [
    "SRSF3P5 CNV",
    "SRSF3P5 RNA"
  ],
  "OR52B6": [
    "OR52B6 CNV",
    "OR52B6 RNA"
  ],
  "USP9YP26": [
    "USP9YP26 CNV",
    "USP9YP26 RNA"
  ],
  "SPCS3": [
    "SPCS3 CNV",
    "SPCS3 RNA",
    "SPCS3 Proteo"
  ],
  "HYKK": [
    "HYKK CNV",
    "HYKK RNA",
    "HYKK Proteo"
  ],
  "UBE2T": [
    "UBE2T CNV",
    "UBE2T RNA",
    "UBE2T Proteo"
  ],
  "ZNF768": [
    "ZNF768 CNV",
    "ZNF768 RNA",
    "ZNF768 Proteo"
  ],
  "RAB1A": [
    "RAB1A CNV",
    "RAB1A RNA",
    "RAB1A Proteo"
  ],
  "EIF3MP1": [
    "EIF3MP1 CNV",
    "EIF3MP1 RNA"
  ],
  "IFNA20P": [
    "IFNA20P CNV",
    "IFNA20P RNA"
  ],
  "AP1S2": [
    "AP1S2 CNV",
    "AP1S2 RNA",
    "AP1S2 Proteo"
  ],
  "DPY30": [
    "DPY30 CNV",
    "DPY30 RNA",
    "DPY30 Proteo"
  ],
  "CAMKMT": [
    "CAMKMT CNV",
    "CAMKMT RNA",
    "CAMKMT Proteo"
  ],
  "RPL6P22": [
    "RPL6P22 CNV",
    "RPL6P22 RNA"
  ],
  "MS4A4A": [
    "MS4A4A CNV",
    "MS4A4A RNA"
  ],
  "CEACAM22P": [
    "CEACAM22P CNV",
    "CEACAM22P RNA"
  ],
  "SZRD1": [
    "SZRD1 CNV",
    "SZRD1 RNA",
    "SZRD1 Proteo"
  ],
  "PML": [
    "PML CNV",
    "PML RNA",
    "PML Proteo"
  ],
  "CBX1P2": [
    "CBX1P2 CNV",
    "CBX1P2 RNA"
  ],
  "TRPC6P9": [
    "TRPC6P9 CNV",
    "TRPC6P9 RNA"
  ],
  "RAB9AP3": [
    "RAB9AP3 CNV",
    "RAB9AP3 RNA"
  ],
  "DHH": [
    "DHH CNV",
    "DHH RNA"
  ],
  "ARAP3": [
    "ARAP3 CNV",
    "ARAP3 RNA",
    "ARAP3 Proteo"
  ],
  "TMEM167B": [
    "TMEM167B CNV",
    "TMEM167B RNA",
    "TMEM167B Proteo"
  ],
  "TUBBP9": [
    "TUBBP9 CNV",
    "TUBBP9 RNA"
  ],
  "DUX4L22": [
    "DUX4L22 CNV",
    "DUX4L22 RNA"
  ],
  "KCNQ1": [
    "KCNQ1 CNV",
    "KCNQ1 RNA",
    "KCNQ1 Proteo"
  ],
  "SYDE1": [
    "SYDE1 CNV",
    "SYDE1 RNA",
    "SYDE1 Proteo"
  ],
  "HBM": [
    "HBM CNV",
    "HBM RNA",
    "HBM Proteo"
  ],
  "RPL5P11": [
    "RPL5P11 CNV",
    "RPL5P11 RNA"
  ],
  "CT45A3": [
    "CT45A3 CNV",
    "CT45A3 RNA"
  ],
  "SHF": [
    "SHF CNV",
    "SHF RNA",
    "SHF Proteo"
  ],
  "ABCA9": [
    "ABCA9 CNV",
    "ABCA9 RNA",
    "ABCA9 Proteo"
  ],
  "CASP10": [
    "CASP10 CNV",
    "CASP10 RNA",
    "CASP10 Proteo"
  ],
  "TCF24": [
    "TCF24 CNV",
    "TCF24 RNA"
  ],
  "MTCO2P1": [
    "MTCO2P1 CNV",
    "MTCO2P1 RNA"
  ],
  "KRTAP8-2P": [
    "KRTAP8-2P CNV",
    "KRTAP8-2P RNA"
  ],
  "HILPDA": [
    "HILPDA CNV",
    "HILPDA RNA",
    "HILPDA Proteo"
  ],
  "EMP2P1": [
    "EMP2P1 CNV",
    "EMP2P1 RNA"
  ],
  "POM121C": [
    "POM121C CNV",
    "POM121C RNA",
    "POM121C Proteo"
  ],
  "CDRT15L2": [
    "CDRT15L2 CNV",
    "CDRT15L2 RNA"
  ],
  "GLYATL3": [
    "GLYATL3 CNV",
    "GLYATL3 RNA"
  ],
  "DEXI": [
    "DEXI CNV",
    "DEXI RNA"
  ],
  "NLRP2B": [
    "NLRP2B CNV",
    "NLRP2B RNA"
  ],
  "MLYCD": [
    "MLYCD CNV",
    "MLYCD RNA",
    "MLYCD Proteo"
  ],
  "RPL10AP6": [
    "RPL10AP6 CNV",
    "RPL10AP6 RNA"
  ],
  "HDAC9": [
    "HDAC9 CNV",
    "HDAC9 RNA",
    "HDAC9 Proteo"
  ],
  "DZANK1": [
    "DZANK1 CNV",
    "DZANK1 RNA",
    "DZANK1 Proteo"
  ],
  "WDR4": [
    "WDR4 CNV",
    "WDR4 RNA",
    "WDR4 Proteo"
  ],
  "WNK2": [
    "WNK2 CNV",
    "WNK2 RNA",
    "WNK2 Proteo"
  ],
  "SH2D4B": [
    "SH2D4B CNV",
    "SH2D4B RNA"
  ],
  "INHBA": [
    "INHBA CNV",
    "INHBA RNA",
    "INHBA Proteo"
  ],
  "OR7A11P": [
    "OR7A11P CNV",
    "OR7A11P RNA"
  ],
  "EPS8": [
    "EPS8 CNV",
    "EPS8 RNA",
    "EPS8 Proteo"
  ],
  "NPPA": [
    "NPPA CNV",
    "NPPA RNA"
  ],
  "COMMD3-BMI1": [
    "COMMD3-BMI1 Proteo"
  ],
  "UGT2A3": [
    "UGT2A3 CNV",
    "UGT2A3 RNA",
    "UGT2A3 Proteo"
  ],
  "KLF2P2": [
    "KLF2P2 CNV",
    "KLF2P2 RNA"
  ],
  "MAMDC4": [
    "MAMDC4 CNV",
    "MAMDC4 RNA"
  ],
  "DDX11L16": [
    "DDX11L16 CNV",
    "DDX11L16 RNA"
  ],
  "CYCSP43": [
    "CYCSP43 CNV",
    "CYCSP43 RNA"
  ],
  "PCNX2": [
    "PCNX2 CNV",
    "PCNX2 RNA"
  ],
  "HM13": [
    "HM13 CNV",
    "HM13 RNA",
    "HM13 Proteo"
  ],
  "HOXA9": [
    "HOXA9 CNV",
    "HOXA9 RNA"
  ],
  "ABCA7": [
    "ABCA7 CNV",
    "ABCA7 RNA",
    "ABCA7 Proteo"
  ],
  "MTUS2": [
    "MTUS2 CNV",
    "MTUS2 RNA"
  ],
  "EPO": [
    "EPO CNV",
    "EPO RNA"
  ],
  "TMED10P1": [
    "TMED10P1 CNV",
    "TMED10P1 RNA"
  ],
  "ZFRP1": [
    "ZFRP1 CNV",
    "ZFRP1 RNA"
  ],
  "ODC1": [
    "ODC1 CNV",
    "ODC1 RNA"
  ],
  "CATSPER2P1": [
    "CATSPER2P1 CNV",
    "CATSPER2P1 RNA"
  ],
  "CR2": [
    "CR2 CNV",
    "CR2 RNA",
    "CR2 Proteo"
  ],
  "CCDC183": [
    "CCDC183 CNV",
    "CCDC183 RNA"
  ],
  "TUBB8P1": [
    "TUBB8P1 CNV",
    "TUBB8P1 RNA"
  ],
  "RPL12P18": [
    "RPL12P18 CNV",
    "RPL12P18 RNA"
  ],
  "TAF11L12": [
    "TAF11L12 CNV",
    "TAF11L12 RNA"
  ],
  "TIMM8BP2": [
    "TIMM8BP2 CNV",
    "TIMM8BP2 RNA"
  ],
  "RYR3": [
    "RYR3 CNV",
    "RYR3 RNA"
  ],
  "EEF2K": [
    "EEF2K CNV",
    "EEF2K RNA",
    "EEF2K Proteo"
  ],
  "TRABD2A": [
    "TRABD2A CNV",
    "TRABD2A RNA"
  ],
  "DPYSL4": [
    "DPYSL4 CNV",
    "DPYSL4 RNA",
    "DPYSL4 Proteo"
  ],
  "S100A13": [
    "S100A13 CNV",
    "S100A13 RNA",
    "S100A13 Proteo"
  ],
  "SMARCAD1": [
    "SMARCAD1 CNV",
    "SMARCAD1 RNA",
    "SMARCAD1 Proteo"
  ],
  "OR5K3": [
    "OR5K3 CNV",
    "OR5K3 RNA"
  ],
  "OR5C1": [
    "OR5C1 CNV",
    "OR5C1 RNA"
  ],
  "ANAPC10": [
    "ANAPC10 CNV",
    "ANAPC10 RNA",
    "ANAPC10 Proteo"
  ],
  "FTH1P25": [
    "FTH1P25 CNV",
    "FTH1P25 RNA"
  ],
  "ARPC3": [
    "ARPC3 CNV",
    "ARPC3 RNA",
    "ARPC3 Proteo"
  ],
  "C9": [
    "C9 CNV",
    "C9 RNA",
    "C9 Proteo"
  ],
  "PRELID1P5": [
    "PRELID1P5 CNV",
    "PRELID1P5 RNA"
  ],
  "PPIAP17": [
    "PPIAP17 CNV",
    "PPIAP17 RNA"
  ],
  "AMOTL2": [
    "AMOTL2 CNV",
    "AMOTL2 RNA",
    "AMOTL2 Proteo"
  ],
  "IL18BP": [
    "IL18BP CNV",
    "IL18BP RNA",
    "IL18BP Proteo"
  ],
  "CD248": [
    "CD248 CNV",
    "CD248 RNA",
    "CD248 Proteo"
  ],
  "ESX1": [
    "ESX1 CNV",
    "ESX1 RNA"
  ],
  "TRAPPC2P8": [
    "TRAPPC2P8 CNV",
    "TRAPPC2P8 RNA"
  ],
  "TRAFD1": [
    "TRAFD1 CNV",
    "TRAFD1 RNA",
    "TRAFD1 Proteo"
  ],
  "GNG5": [
    "GNG5 CNV",
    "GNG5 RNA",
    "GNG5 Proteo"
  ],
  "RNF17": [
    "RNF17 CNV",
    "RNF17 RNA"
  ],
  "SAMD3": [
    "SAMD3 CNV",
    "SAMD3 RNA"
  ],
  "MTCO3P1": [
    "MTCO3P1 CNV",
    "MTCO3P1 RNA"
  ],
  "SNRPA1P1": [
    "SNRPA1P1 CNV",
    "SNRPA1P1 RNA"
  ],
  "KLF15": [
    "KLF15 CNV",
    "KLF15 RNA"
  ],
  "IMPDH1P3": [
    "IMPDH1P3 CNV",
    "IMPDH1P3 RNA"
  ],
  "G6PD": [
    "G6PD CNV",
    "G6PD RNA",
    "G6PD Proteo"
  ],
  "KBTBD13": [
    "KBTBD13 CNV",
    "KBTBD13 RNA",
    "KBTBD13 Proteo"
  ],
  "GMIP": [
    "GMIP CNV",
    "GMIP RNA",
    "GMIP Proteo"
  ],
  "NAPEPLD": [
    "NAPEPLD CNV",
    "NAPEPLD RNA",
    "NAPEPLD Proteo"
  ],
  "RPL24P4": [
    "RPL24P4 CNV",
    "RPL24P4 RNA"
  ],
  "SHMT1P1": [
    "SHMT1P1 CNV",
    "SHMT1P1 RNA"
  ],
  "ARHGAP17": [
    "ARHGAP17 CNV",
    "ARHGAP17 RNA",
    "ARHGAP17 Proteo"
  ],
  "APPL2": [
    "APPL2 CNV",
    "APPL2 RNA",
    "APPL2 Proteo"
  ],
  "TRBVA": [
    "TRBVA CNV",
    "TRBVA RNA"
  ],
  "ODF2L": [
    "ODF2L CNV",
    "ODF2L RNA",
    "ODF2L Proteo"
  ],
  "ABHD17AP3": [
    "ABHD17AP3 CNV",
    "ABHD17AP3 RNA"
  ],
  "PPP2R2C": [
    "PPP2R2C CNV",
    "PPP2R2C RNA",
    "PPP2R2C Proteo"
  ],
  "DVL1": [
    "DVL1 CNV",
    "DVL1 RNA",
    "DVL1 Proteo"
  ],
  "MTND4P11": [
    "MTND4P11 CNV",
    "MTND4P11 RNA"
  ],
  "DNAAF5": [
    "DNAAF5 CNV",
    "DNAAF5 RNA",
    "DNAAF5 Proteo"
  ],
  "CUBNP1": [
    "CUBNP1 CNV",
    "CUBNP1 RNA"
  ],
  "RPS2P55": [
    "RPS2P55 CNV",
    "RPS2P55 RNA"
  ],
  "SPAG17": [
    "SPAG17 CNV",
    "SPAG17 RNA"
  ],
  "KLHDC7B": [
    "KLHDC7B CNV",
    "KLHDC7B RNA",
    "KLHDC7B Proteo"
  ],
  "ZIM3": [
    "ZIM3 CNV",
    "ZIM3 RNA"
  ],
  "CARD10": [
    "CARD10 CNV",
    "CARD10 RNA",
    "CARD10 Proteo"
  ],
  "IGKV2D-29": [
    "IGKV2D-29 Proteo"
  ],
  "PLOD2": [
    "PLOD2 CNV",
    "PLOD2 RNA",
    "PLOD2 Proteo"
  ],
  "IGKV1OR1-1": [
    "IGKV1OR1-1 CNV",
    "IGKV1OR1-1 RNA"
  ],
  "KARS1P1": [
    "KARS1P1 CNV",
    "KARS1P1 RNA"
  ],
  "ZBTB33": [
    "ZBTB33 CNV",
    "ZBTB33 RNA",
    "ZBTB33 Proteo"
  ],
  "ZNF275": [
    "ZNF275 CNV",
    "ZNF275 RNA",
    "ZNF275 Proteo"
  ],
  "TAAR5": [
    "TAAR5 CNV",
    "TAAR5 RNA"
  ],
  "IFITM2": [
    "IFITM2 CNV",
    "IFITM2 RNA"
  ],
  "H2BC20P": [
    "H2BC20P CNV",
    "H2BC20P RNA"
  ],
  "COLGALT1": [
    "COLGALT1 CNV",
    "COLGALT1 RNA",
    "COLGALT1 Proteo"
  ],
  "CASP1P2": [
    "CASP1P2 CNV",
    "CASP1P2 RNA"
  ],
  "NANOGP1": [
    "NANOGP1 CNV",
    "NANOGP1 RNA"
  ],
  "TMEM65": [
    "TMEM65 CNV",
    "TMEM65 RNA",
    "TMEM65 Proteo"
  ],
  "C4orf3": [
    "C4orf3 CNV",
    "C4orf3 RNA",
    "C4orf3 Proteo"
  ],
  "BMS1P7": [
    "BMS1P7 CNV",
    "BMS1P7 RNA"
  ],
  "NKAPD1": [
    "NKAPD1 CNV",
    "NKAPD1 RNA",
    "NKAPD1 Proteo"
  ],
  "AMN": [
    "AMN CNV",
    "AMN RNA"
  ],
  "IRAK4": [
    "IRAK4 CNV",
    "IRAK4 RNA",
    "IRAK4 Proteo"
  ],
  "TMPRSS11E": [
    "TMPRSS11E CNV",
    "TMPRSS11E RNA"
  ],
  "MRPS18AP1": [
    "MRPS18AP1 CNV",
    "MRPS18AP1 RNA"
  ],
  "EIF2D": [
    "EIF2D CNV",
    "EIF2D RNA",
    "EIF2D Proteo"
  ],
  "CNN2P11": [
    "CNN2P11 CNV",
    "CNN2P11 RNA"
  ],
  "PRSS56": [
    "PRSS56 CNV",
    "PRSS56 RNA",
    "PRSS56 Proteo"
  ],
  "SHCBP1L": [
    "SHCBP1L CNV",
    "SHCBP1L RNA"
  ],
  "TANC1": [
    "TANC1 CNV",
    "TANC1 RNA",
    "TANC1 Proteo"
  ],
  "OTUD7B": [
    "OTUD7B CNV",
    "OTUD7B RNA",
    "OTUD7B Proteo"
  ],
  "TENT5A": [
    "TENT5A CNV",
    "TENT5A RNA",
    "TENT5A Proteo"
  ],
  "ZNF783": [
    "ZNF783 CNV",
    "ZNF783 RNA"
  ],
  "IL17RA": [
    "IL17RA CNV",
    "IL17RA RNA",
    "IL17RA Proteo"
  ],
  "ATP8A2P2": [
    "ATP8A2P2 CNV",
    "ATP8A2P2 RNA"
  ],
  "PPIL4": [
    "PPIL4 CNV",
    "PPIL4 RNA",
    "PPIL4 Proteo"
  ],
  "HSD17B13": [
    "HSD17B13 CNV",
    "HSD17B13 RNA"
  ],
  "ORM1": [
    "ORM1 CNV",
    "ORM1 RNA",
    "ORM1 Proteo"
  ],
  "PPIAP66": [
    "PPIAP66 CNV",
    "PPIAP66 RNA"
  ],
  "IVL": [
    "IVL CNV",
    "IVL RNA",
    "IVL Proteo"
  ],
  "HHLA2": [
    "HHLA2 CNV",
    "HHLA2 RNA"
  ],
  "CYTL1": [
    "CYTL1 CNV",
    "CYTL1 RNA",
    "CYTL1 Proteo"
  ],
  "MLLT6": [
    "MLLT6 CNV",
    "MLLT6 RNA",
    "MLLT6 Proteo"
  ],
  "FKRP": [
    "FKRP CNV",
    "FKRP RNA",
    "FKRP Proteo"
  ],
  "MFSD13B": [
    "MFSD13B CNV",
    "MFSD13B RNA"
  ],
  "KRT19P6": [
    "KRT19P6 CNV",
    "KRT19P6 RNA"
  ],
  "PHLDB1": [
    "PHLDB1 CNV",
    "PHLDB1 RNA",
    "PHLDB1 Proteo"
  ],
  "IFNE": [
    "IFNE CNV",
    "IFNE RNA"
  ],
  "PLA2G4D": [
    "PLA2G4D CNV",
    "PLA2G4D RNA",
    "PLA2G4D Proteo"
  ],
  "FLG2": [
    "FLG2 CNV",
    "FLG2 RNA",
    "FLG2 Proteo"
  ],
  "FAF2": [
    "FAF2 CNV",
    "FAF2 RNA",
    "FAF2 Proteo"
  ],
  "KLHDC8B": [
    "KLHDC8B CNV",
    "KLHDC8B RNA",
    "KLHDC8B Proteo"
  ],
  "FAM241A": [
    "FAM241A CNV",
    "FAM241A RNA",
    "FAM241A Proteo"
  ],
  "RPS27P15": [
    "RPS27P15 CNV",
    "RPS27P15 RNA"
  ],
  "SLC35E2A": [
    "SLC35E2A CNV",
    "SLC35E2A RNA"
  ],
  "GLI1": [
    "GLI1 CNV",
    "GLI1 RNA"
  ],
  "DHFR2": [
    "DHFR2 CNV",
    "DHFR2 RNA"
  ],
  "RNA5SP107": [
    "RNA5SP107 CNV",
    "RNA5SP107 RNA"
  ],
  "GTF2E2": [
    "GTF2E2 CNV",
    "GTF2E2 RNA",
    "GTF2E2 Proteo"
  ],
  "MORN1": [
    "MORN1 CNV",
    "MORN1 RNA"
  ],
  "KCNH6": [
    "KCNH6 CNV",
    "KCNH6 RNA"
  ],
  "GPX7": [
    "GPX7 CNV",
    "GPX7 RNA",
    "GPX7 Proteo"
  ],
  "SEC23A": [
    "SEC23A CNV",
    "SEC23A RNA",
    "SEC23A Proteo"
  ],
  "CUL5": [
    "CUL5 CNV",
    "CUL5 RNA",
    "CUL5 Proteo"
  ],
  "TAPBPL": [
    "TAPBPL CNV",
    "TAPBPL RNA",
    "TAPBPL Proteo"
  ],
  "SLC44A3": [
    "SLC44A3 CNV",
    "SLC44A3 RNA",
    "SLC44A3 Proteo"
  ],
  "F3": [
    "F3 CNV",
    "F3 RNA",
    "F3 Proteo"
  ],
  "SAP30L": [
    "SAP30L CNV",
    "SAP30L RNA",
    "SAP30L Proteo"
  ],
  "TAF1B": [
    "TAF1B CNV",
    "TAF1B RNA",
    "TAF1B Proteo"
  ],
  "OR7E59P": [
    "OR7E59P CNV",
    "OR7E59P RNA"
  ],
  "SYNPO2L": [
    "SYNPO2L CNV",
    "SYNPO2L RNA"
  ],
  "ZNF33B": [
    "ZNF33B CNV",
    "ZNF33B RNA"
  ],
  "RPL35AP8": [
    "RPL35AP8 CNV",
    "RPL35AP8 RNA"
  ],
  "SRSF3P6": [
    "SRSF3P6 CNV",
    "SRSF3P6 RNA"
  ],
  "KRTAP12-3": [
    "KRTAP12-3 CNV",
    "KRTAP12-3 RNA"
  ],
  "PPIAL4A": [
    "PPIAL4A CNV",
    "PPIAL4A RNA"
  ],
  "ZNF599": [
    "ZNF599 CNV",
    "ZNF599 RNA"
  ],
  "KRT18P37": [
    "KRT18P37 CNV",
    "KRT18P37 RNA"
  ],
  "BRINP1": [
    "BRINP1 CNV",
    "BRINP1 RNA"
  ],
  "EDIL3": [
    "EDIL3 CNV",
    "EDIL3 RNA",
    "EDIL3 Proteo"
  ],
  "PLOD3": [
    "PLOD3 CNV",
    "PLOD3 RNA",
    "PLOD3 Proteo"
  ],
  "CENPU": [
    "CENPU CNV",
    "CENPU RNA",
    "CENPU Proteo"
  ],
  "C11orf86": [
    "C11orf86 CNV",
    "C11orf86 RNA"
  ],
  "KRT18P23": [
    "KRT18P23 CNV",
    "KRT18P23 RNA"
  ],
  "HPS3": [
    "HPS3 CNV",
    "HPS3 RNA",
    "HPS3 Proteo"
  ],
  "EIF3EP1": [
    "EIF3EP1 CNV",
    "EIF3EP1 RNA"
  ],
  "ILRUN": [
    "ILRUN CNV",
    "ILRUN RNA",
    "ILRUN Proteo"
  ],
  "GOLGA6GP": [
    "GOLGA6GP CNV",
    "GOLGA6GP RNA"
  ],
  "POLL": [
    "POLL CNV",
    "POLL RNA",
    "POLL Proteo"
  ],
  "KNOP1P3": [
    "KNOP1P3 CNV",
    "KNOP1P3 RNA"
  ],
  "LAPTM4B": [
    "LAPTM4B CNV",
    "LAPTM4B RNA"
  ],
  "NUDT11": [
    "NUDT11 CNV",
    "NUDT11 RNA"
  ],
  "CACNA1F": [
    "CACNA1F CNV",
    "CACNA1F RNA"
  ],
  "OR6C6": [
    "OR6C6 CNV",
    "OR6C6 RNA"
  ],
  "IFNA17": [
    "IFNA17 CNV",
    "IFNA17 RNA"
  ],
  "SCHIP1": [
    "SCHIP1 CNV",
    "SCHIP1 RNA"
  ],
  "ZNF649": [
    "ZNF649 CNV",
    "ZNF649 RNA",
    "ZNF649 Proteo"
  ],
  "C1orf232": [
    "C1orf232 CNV",
    "C1orf232 RNA"
  ],
  "HSD17B12": [
    "HSD17B12 CNV",
    "HSD17B12 RNA",
    "HSD17B12 Proteo"
  ],
  "LYZL6": [
    "LYZL6 CNV",
    "LYZL6 RNA"
  ],
  "RCBTB2P1": [
    "RCBTB2P1 CNV",
    "RCBTB2P1 RNA"
  ],
  "OR5M11": [
    "OR5M11 CNV",
    "OR5M11 RNA"
  ],
  "FRG2HP": [
    "FRG2HP CNV",
    "FRG2HP RNA"
  ],
  "BCL2L15": [
    "BCL2L15 CNV",
    "BCL2L15 RNA",
    "BCL2L15 Proteo"
  ],
  "EEF1A1P17": [
    "EEF1A1P17 CNV",
    "EEF1A1P17 RNA"
  ],
  "MAP3K3": [
    "MAP3K3 CNV",
    "MAP3K3 RNA",
    "MAP3K3 Proteo"
  ],
  "SPIB": [
    "SPIB CNV",
    "SPIB RNA"
  ],
  "ATP5MC1P1": [
    "ATP5MC1P1 CNV",
    "ATP5MC1P1 RNA"
  ],
  "KRTAP9-11P": [
    "KRTAP9-11P CNV",
    "KRTAP9-11P RNA"
  ],
  "RNA5SP417": [
    "RNA5SP417 CNV",
    "RNA5SP417 RNA"
  ],
  "VDAC1P2": [
    "VDAC1P2 CNV",
    "VDAC1P2 RNA"
  ],
  "SLCO1A2": [
    "SLCO1A2 CNV",
    "SLCO1A2 RNA"
  ],
  "SLC1A2": [
    "SLC1A2 CNV",
    "SLC1A2 RNA"
  ],
  "OSGEP": [
    "OSGEP CNV",
    "OSGEP RNA",
    "OSGEP Proteo"
  ],
  "SP5": [
    "SP5 CNV",
    "SP5 RNA"
  ],
  "ZNF519": [
    "ZNF519 CNV",
    "ZNF519 RNA"
  ],
  "ADAM21": [
    "ADAM21 CNV",
    "ADAM21 RNA"
  ],
  "EIF5B": [
    "EIF5B CNV",
    "EIF5B RNA",
    "EIF5B Proteo"
  ],
  "PLEKHH2": [
    "PLEKHH2 CNV",
    "PLEKHH2 RNA",
    "PLEKHH2 Proteo"
  ],
  "ATG4C": [
    "ATG4C CNV",
    "ATG4C RNA",
    "ATG4C Proteo"
  ],
  "OR10T2": [
    "OR10T2 CNV",
    "OR10T2 RNA"
  ],
  "ZDHHC20P4": [
    "ZDHHC20P4 CNV",
    "ZDHHC20P4 RNA"
  ],
  "CYP4F33P": [
    "CYP4F33P CNV",
    "CYP4F33P RNA"
  ],
  "MINDY3": [
    "MINDY3 CNV",
    "MINDY3 RNA",
    "MINDY3 Proteo"
  ],
  "CFHR1": [
    "CFHR1 CNV",
    "CFHR1 RNA",
    "CFHR1 Proteo"
  ],
  "RNA5SP282": [
    "RNA5SP282 CNV",
    "RNA5SP282 RNA"
  ],
  "SEC14L2": [
    "SEC14L2 CNV",
    "SEC14L2 RNA",
    "SEC14L2 Proteo"
  ],
  "C11orf24": [
    "C11orf24 CNV",
    "C11orf24 RNA",
    "C11orf24 Proteo"
  ],
  "GLYCAM1": [
    "GLYCAM1 CNV",
    "GLYCAM1 RNA"
  ],
  "TNFRSF10D": [
    "TNFRSF10D CNV",
    "TNFRSF10D RNA"
  ],
  "MAGEB6B": [
    "MAGEB6B CNV",
    "MAGEB6B RNA"
  ],
  "RPL7P13": [
    "RPL7P13 CNV",
    "RPL7P13 RNA"
  ],
  "CCDC180": [
    "CCDC180 CNV",
    "CCDC180 RNA"
  ],
  "DENR": [
    "DENR CNV",
    "DENR RNA",
    "DENR Proteo"
  ],
  "POLD2P1": [
    "POLD2P1 CNV",
    "POLD2P1 RNA"
  ],
  "DAPP1": [
    "DAPP1 CNV",
    "DAPP1 RNA",
    "DAPP1 Proteo"
  ],
  "MRPL15": [
    "MRPL15 CNV",
    "MRPL15 RNA",
    "MRPL15 Proteo"
  ],
  "MRPS24": [
    "MRPS24 CNV",
    "MRPS24 RNA",
    "MRPS24 Proteo"
  ],
  "THOC2": [
    "THOC2 CNV",
    "THOC2 RNA",
    "THOC2 Proteo"
  ],
  "SAV1": [
    "SAV1 CNV",
    "SAV1 RNA",
    "SAV1 Proteo"
  ],
  "UEVLD": [
    "UEVLD CNV",
    "UEVLD RNA",
    "UEVLD Proteo"
  ],
  "CPLX4": [
    "CPLX4 CNV",
    "CPLX4 RNA"
  ],
  "ANGEL1": [
    "ANGEL1 CNV",
    "ANGEL1 RNA",
    "ANGEL1 Proteo"
  ],
  "OFD1P2Y": [
    "OFD1P2Y CNV",
    "OFD1P2Y RNA"
  ],
  "STRCP1": [
    "STRCP1 CNV",
    "STRCP1 RNA"
  ],
  "RBX1": [
    "RBX1 CNV",
    "RBX1 RNA",
    "RBX1 Proteo"
  ],
  "MLIP": [
    "MLIP CNV",
    "MLIP RNA",
    "MLIP Proteo"
  ],
  "RPL13AP20": [
    "RPL13AP20 CNV",
    "RPL13AP20 RNA"
  ],
  "FBH1": [
    "FBH1 CNV",
    "FBH1 RNA",
    "FBH1 Proteo"
  ],
  "CLEC1B": [
    "CLEC1B CNV",
    "CLEC1B RNA"
  ],
  "RPL6P5": [
    "RPL6P5 CNV",
    "RPL6P5 RNA"
  ],
  "EIF4BP9": [
    "EIF4BP9 CNV",
    "EIF4BP9 RNA"
  ],
  "SLC29A3": [
    "SLC29A3 CNV",
    "SLC29A3 RNA",
    "SLC29A3 Proteo"
  ],
  "BMS1P13": [
    "BMS1P13 CNV",
    "BMS1P13 RNA"
  ],
  "RERE": [
    "RERE CNV",
    "RERE RNA",
    "RERE Proteo"
  ],
  "SEC63": [
    "SEC63 CNV",
    "SEC63 RNA",
    "SEC63 Proteo"
  ],
  "COX6B1": [
    "COX6B1 CNV",
    "COX6B1 RNA",
    "COX6B1 Proteo"
  ],
  "FMO7P": [
    "FMO7P CNV",
    "FMO7P RNA"
  ],
  "ZNRF2P3": [
    "ZNRF2P3 CNV",
    "ZNRF2P3 RNA"
  ],
  "RNA5SP224": [
    "RNA5SP224 CNV",
    "RNA5SP224 RNA"
  ],
  "TMEM243": [
    "TMEM243 CNV",
    "TMEM243 RNA",
    "TMEM243 Proteo"
  ],
  "MTCO1P29": [
    "MTCO1P29 CNV",
    "MTCO1P29 RNA"
  ],
  "IL12RB2": [
    "IL12RB2 CNV",
    "IL12RB2 RNA"
  ],
  "ZNF679": [
    "ZNF679 CNV",
    "ZNF679 RNA"
  ],
  "HSPD1P12": [
    "HSPD1P12 CNV",
    "HSPD1P12 RNA"
  ],
  "TBC1D10B": [
    "TBC1D10B CNV",
    "TBC1D10B RNA",
    "TBC1D10B Proteo"
  ],
  "KCNJ14": [
    "KCNJ14 CNV",
    "KCNJ14 RNA"
  ],
  "F2RL3": [
    "F2RL3 CNV",
    "F2RL3 RNA"
  ],
  "ANKRD28": [
    "ANKRD28 CNV",
    "ANKRD28 RNA",
    "ANKRD28 Proteo"
  ],
  "SRGAP2C": [
    "SRGAP2C CNV",
    "SRGAP2C RNA"
  ],
  "PPP1R14BP4": [
    "PPP1R14BP4 CNV",
    "PPP1R14BP4 RNA"
  ],
  "DRGX": [
    "DRGX CNV",
    "DRGX RNA"
  ],
  "CCDC17": [
    "CCDC17 CNV",
    "CCDC17 RNA"
  ],
  "TTC9B": [
    "TTC9B CNV",
    "TTC9B RNA"
  ],
  "ARID4A": [
    "ARID4A CNV",
    "ARID4A RNA",
    "ARID4A Proteo"
  ],
  "HDAC2": [
    "HDAC2 CNV",
    "HDAC2 RNA",
    "HDAC2 Proteo"
  ],
  "ZNF287": [
    "ZNF287 CNV",
    "ZNF287 RNA"
  ],
  "PEX11B": [
    "PEX11B CNV",
    "PEX11B RNA",
    "PEX11B Proteo"
  ],
  "CHFR": [
    "CHFR CNV",
    "CHFR RNA",
    "CHFR Proteo"
  ],
  "YAF2": [
    "YAF2 CNV",
    "YAF2 RNA",
    "YAF2 Proteo"
  ],
  "YIPF4": [
    "YIPF4 CNV",
    "YIPF4 RNA",
    "YIPF4 Proteo"
  ],
  "OR52L1": [
    "OR52L1 CNV",
    "OR52L1 RNA"
  ],
  "MAGI2": [
    "MAGI2 CNV",
    "MAGI2 RNA",
    "MAGI2 Proteo"
  ],
  "RPL36P10": [
    "RPL36P10 CNV",
    "RPL36P10 RNA"
  ],
  "MAMDC2": [
    "MAMDC2 CNV",
    "MAMDC2 RNA",
    "MAMDC2 Proteo"
  ],
  "MTND6P32": [
    "MTND6P32 CNV",
    "MTND6P32 RNA"
  ],
  "GALNT4": [
    "GALNT4 CNV",
    "GALNT4 RNA",
    "GALNT4 Proteo"
  ],
  "MLXIP": [
    "MLXIP CNV",
    "MLXIP RNA",
    "MLXIP Proteo"
  ],
  "TRIM26": [
    "TRIM26 CNV",
    "TRIM26 RNA",
    "TRIM26 Proteo"
  ],
  "PNPLA2": [
    "PNPLA2 CNV",
    "PNPLA2 RNA",
    "PNPLA2 Proteo"
  ],
  "MST1P2": [
    "MST1P2 CNV",
    "MST1P2 RNA"
  ],
  "NT5C3A": [
    "NT5C3A CNV",
    "NT5C3A RNA",
    "NT5C3A Proteo"
  ],
  "PABPN1L": [
    "PABPN1L CNV",
    "PABPN1L RNA"
  ],
  "IGHV3-65": [
    "IGHV3-65 CNV",
    "IGHV3-65 RNA"
  ],
  "IGKV2D-40": [
    "IGKV2D-40 Proteo"
  ],
  "PRADC1P1": [
    "PRADC1P1 CNV",
    "PRADC1P1 RNA"
  ],
  "TUBA3D": [
    "TUBA3D CNV",
    "TUBA3D RNA"
  ],
  "AIMP2": [
    "AIMP2 CNV",
    "AIMP2 RNA",
    "AIMP2 Proteo"
  ],
  "CYP11A1": [
    "CYP11A1 CNV",
    "CYP11A1 RNA"
  ],
  "PAFAH1B1P1": [
    "PAFAH1B1P1 CNV",
    "PAFAH1B1P1 RNA"
  ],
  "PFN1P12": [
    "PFN1P12 CNV",
    "PFN1P12 RNA"
  ],
  "CDH15": [
    "CDH15 CNV",
    "CDH15 RNA",
    "CDH15 Proteo"
  ],
  "KIF23": [
    "KIF23 CNV",
    "KIF23 RNA",
    "KIF23 Proteo"
  ],
  "TGDS": [
    "TGDS CNV",
    "TGDS RNA",
    "TGDS Proteo"
  ],
  "CHDH": [
    "CHDH CNV",
    "CHDH RNA",
    "CHDH Proteo"
  ],
  "POMT1": [
    "POMT1 CNV",
    "POMT1 RNA",
    "POMT1 Proteo"
  ],
  "ARID1A": [
    "ARID1A CNV",
    "ARID1A RNA",
    "ARID1A Proteo"
  ],
  "ANP32BP2": [
    "ANP32BP2 CNV",
    "ANP32BP2 RNA"
  ],
  "ARHGAP28": [
    "ARHGAP28 CNV",
    "ARHGAP28 RNA",
    "ARHGAP28 Proteo"
  ],
  "KYAT1": [
    "KYAT1 CNV",
    "KYAT1 RNA",
    "KYAT1 Proteo"
  ],
  "VSIG10": [
    "VSIG10 CNV",
    "VSIG10 RNA",
    "VSIG10 Proteo"
  ],
  "HOXC9": [
    "HOXC9 CNV",
    "HOXC9 RNA",
    "HOXC9 Proteo"
  ],
  "MFSD10": [
    "MFSD10 CNV",
    "MFSD10 RNA",
    "MFSD10 Proteo"
  ],
  "GLRX": [
    "GLRX CNV",
    "GLRX RNA",
    "GLRX Proteo"
  ],
  "CCDC83": [
    "CCDC83 CNV",
    "CCDC83 RNA"
  ],
  "SLC22A14": [
    "SLC22A14 CNV",
    "SLC22A14 RNA"
  ],
  "KCTD9P6": [
    "KCTD9P6 CNV",
    "KCTD9P6 RNA"
  ],
  "COPS8P1": [
    "COPS8P1 CNV",
    "COPS8P1 RNA"
  ],
  "UBE2V1P15": [
    "UBE2V1P15 CNV",
    "UBE2V1P15 RNA"
  ],
  "EIF5": [
    "EIF5 CNV",
    "EIF5 RNA",
    "EIF5 Proteo"
  ],
  "KRTAP12-6P": [
    "KRTAP12-6P CNV",
    "KRTAP12-6P RNA"
  ],
  "MTHFD2L": [
    "MTHFD2L CNV",
    "MTHFD2L RNA",
    "MTHFD2L Proteo"
  ],
  "OTOAP1": [
    "OTOAP1 CNV",
    "OTOAP1 RNA"
  ],
  "DACH2": [
    "DACH2 CNV",
    "DACH2 RNA"
  ],
  "RNA5SP185": [
    "RNA5SP185 CNV",
    "RNA5SP185 RNA"
  ],
  "NF1": [
    "NF1 CNV",
    "NF1 RNA",
    "NF1 Proteo"
  ],
  "EEF1DP6": [
    "EEF1DP6 CNV",
    "EEF1DP6 RNA"
  ],
  "FGF7": [
    "FGF7 CNV",
    "FGF7 RNA"
  ],
  "RARRES2P1": [
    "RARRES2P1 CNV",
    "RARRES2P1 RNA"
  ],
  "WDR49": [
    "WDR49 CNV",
    "WDR49 RNA"
  ],
  "TEKT2": [
    "TEKT2 CNV",
    "TEKT2 RNA"
  ],
  "HAUS2": [
    "HAUS2 CNV",
    "HAUS2 RNA",
    "HAUS2 Proteo"
  ],
  "RSL24D1P9": [
    "RSL24D1P9 CNV",
    "RSL24D1P9 RNA"
  ],
  "MAP1LC3P": [
    "MAP1LC3P CNV",
    "MAP1LC3P RNA"
  ],
  "REG3G": [
    "REG3G CNV",
    "REG3G RNA"
  ],
  "SYNJ1": [
    "SYNJ1 CNV",
    "SYNJ1 RNA",
    "SYNJ1 Proteo"
  ],
  "EML2": [
    "EML2 CNV",
    "EML2 RNA",
    "EML2 Proteo"
  ],
  "AMTN": [
    "AMTN CNV",
    "AMTN RNA"
  ],
  "RPL21P89": [
    "RPL21P89 CNV",
    "RPL21P89 RNA"
  ],
  "ZNF324B": [
    "ZNF324B CNV",
    "ZNF324B RNA"
  ],
  "OR12D2": [
    "OR12D2 CNV",
    "OR12D2 RNA"
  ],
  "RPL31P50": [
    "RPL31P50 CNV",
    "RPL31P50 RNA"
  ],
  "NEDD1": [
    "NEDD1 CNV",
    "NEDD1 RNA",
    "NEDD1 Proteo"
  ],
  "HEXIM1": [
    "HEXIM1 CNV",
    "HEXIM1 RNA",
    "HEXIM1 Proteo"
  ],
  "POFUT2": [
    "POFUT2 CNV",
    "POFUT2 RNA",
    "POFUT2 Proteo"
  ],
  "PROSER3": [
    "PROSER3 CNV",
    "PROSER3 RNA",
    "PROSER3 Proteo"
  ],
  "IQGAP2": [
    "IQGAP2 CNV",
    "IQGAP2 RNA",
    "IQGAP2 Proteo"
  ],
  "DNMT3A": [
    "DNMT3A CNV",
    "DNMT3A RNA",
    "DNMT3A Proteo"
  ],
  "OR51A2": [
    "OR51A2 CNV",
    "OR51A2 RNA"
  ],
  "GHRL": [
    "GHRL CNV",
    "GHRL RNA"
  ],
  "NPM1P29": [
    "NPM1P29 CNV",
    "NPM1P29 RNA"
  ],
  "RGMA": [
    "RGMA CNV",
    "RGMA RNA",
    "RGMA Proteo"
  ],
  "NDUFB4P2": [
    "NDUFB4P2 CNV",
    "NDUFB4P2 RNA"
  ],
  "SLC28A3": [
    "SLC28A3 CNV",
    "SLC28A3 RNA"
  ],
  "RPL7P42": [
    "RPL7P42 CNV",
    "RPL7P42 RNA"
  ],
  "MT1B": [
    "MT1B CNV",
    "MT1B RNA"
  ],
  "RPF2P2": [
    "RPF2P2 CNV",
    "RPF2P2 RNA"
  ],
  "TOP2B": [
    "TOP2B CNV",
    "TOP2B RNA",
    "TOP2B Proteo"
  ],
  "OR2A41P": [
    "OR2A41P CNV",
    "OR2A41P RNA"
  ],
  "NCOA4P1": [
    "NCOA4P1 CNV",
    "NCOA4P1 RNA"
  ],
  "BICRA": [
    "BICRA CNV",
    "BICRA RNA",
    "BICRA Proteo"
  ],
  "CYP51A1": [
    "CYP51A1 CNV",
    "CYP51A1 RNA",
    "CYP51A1 Proteo"
  ],
  "ABL1": [
    "ABL1 CNV",
    "ABL1 RNA",
    "ABL1 Proteo"
  ],
  "SCP2D1": [
    "SCP2D1 CNV",
    "SCP2D1 RNA"
  ],
  "PLA2G2A": [
    "PLA2G2A CNV",
    "PLA2G2A RNA",
    "PLA2G2A Proteo"
  ],
  "CD46": [
    "CD46 CNV",
    "CD46 RNA",
    "CD46 Proteo"
  ],
  "TFPI2": [
    "TFPI2 CNV",
    "TFPI2 RNA",
    "TFPI2 Proteo"
  ],
  "GDF10": [
    "GDF10 CNV",
    "GDF10 RNA"
  ],
  "TMEM182": [
    "TMEM182 CNV",
    "TMEM182 RNA"
  ],
  "ZNF335": [
    "ZNF335 CNV",
    "ZNF335 RNA",
    "ZNF335 Proteo"
  ],
  "ENDOV": [
    "ENDOV CNV",
    "ENDOV RNA",
    "ENDOV Proteo"
  ],
  "TERF1P6": [
    "TERF1P6 CNV",
    "TERF1P6 RNA"
  ],
  "NPY4R2": [
    "NPY4R2 CNV",
    "NPY4R2 RNA"
  ],
  "UBTFL9": [
    "UBTFL9 CNV",
    "UBTFL9 RNA"
  ],
  "CAPS": [
    "CAPS CNV",
    "CAPS RNA",
    "CAPS Proteo"
  ],
  "PRELP": [
    "PRELP CNV",
    "PRELP RNA",
    "PRELP Proteo"
  ],
  "DAAM2": [
    "DAAM2 CNV",
    "DAAM2 RNA",
    "DAAM2 Proteo"
  ],
  "RPL37P25": [
    "RPL37P25 CNV",
    "RPL37P25 RNA"
  ],
  "MAGEA12": [
    "MAGEA12 CNV",
    "MAGEA12 RNA"
  ],
  "RPL24P9": [
    "RPL24P9 CNV",
    "RPL24P9 RNA"
  ],
  "ACKR3": [
    "ACKR3 CNV",
    "ACKR3 RNA"
  ],
  "FUNDC2P1": [
    "FUNDC2P1 CNV",
    "FUNDC2P1 RNA"
  ],
  "COTL1P1": [
    "COTL1P1 CNV",
    "COTL1P1 RNA"
  ],
  "RNF141": [
    "RNF141 CNV",
    "RNF141 RNA",
    "RNF141 Proteo"
  ],
  "ANXA7": [
    "ANXA7 CNV",
    "ANXA7 RNA",
    "ANXA7 Proteo"
  ],
  "RPS19BP1": [
    "RPS19BP1 CNV",
    "RPS19BP1 RNA",
    "RPS19BP1 Proteo"
  ],
  "NME6": [
    "NME6 CNV",
    "NME6 RNA",
    "NME6 Proteo"
  ],
  "CT47A7": [
    "CT47A7 CNV",
    "CT47A7 RNA"
  ],
  "RPS27P22": [
    "RPS27P22 CNV",
    "RPS27P22 RNA"
  ],
  "FAM209A": [
    "FAM209A CNV",
    "FAM209A RNA"
  ],
  "POLR1E": [
    "POLR1E CNV",
    "POLR1E RNA",
    "POLR1E Proteo"
  ],
  "ZCCHC10": [
    "ZCCHC10 CNV",
    "ZCCHC10 RNA",
    "ZCCHC10 Proteo"
  ],
  "PSMB8": [
    "PSMB8 CNV",
    "PSMB8 RNA",
    "PSMB8 Proteo"
  ],
  "GUSBP8": [
    "GUSBP8 CNV",
    "GUSBP8 RNA"
  ],
  "DNAJB2": [
    "DNAJB2 CNV",
    "DNAJB2 RNA",
    "DNAJB2 Proteo"
  ],
  "CIAO1": [
    "CIAO1 CNV",
    "CIAO1 RNA",
    "CIAO1 Proteo"
  ],
  "SLC35A1": [
    "SLC35A1 CNV",
    "SLC35A1 RNA",
    "SLC35A1 Proteo"
  ],
  "PPP5D1P": [
    "PPP5D1P CNV",
    "PPP5D1P RNA"
  ],
  "HSPE1P6": [
    "HSPE1P6 CNV",
    "HSPE1P6 RNA"
  ],
  "TTR": [
    "TTR CNV",
    "TTR RNA",
    "TTR Proteo"
  ],
  "CDC37P2": [
    "CDC37P2 CNV",
    "CDC37P2 RNA"
  ],
  "NRTN": [
    "NRTN CNV",
    "NRTN RNA"
  ],
  "BMP5": [
    "BMP5 CNV",
    "BMP5 RNA"
  ],
  "CEP97": [
    "CEP97 CNV",
    "CEP97 RNA",
    "CEP97 Proteo"
  ],
  "MRPL14": [
    "MRPL14 CNV",
    "MRPL14 RNA",
    "MRPL14 Proteo"
  ],
  "KLHL24": [
    "KLHL24 CNV",
    "KLHL24 RNA",
    "KLHL24 Proteo"
  ],
  "MSS51": [
    "MSS51 CNV",
    "MSS51 RNA"
  ],
  "MFAP3L": [
    "MFAP3L CNV",
    "MFAP3L RNA",
    "MFAP3L Proteo"
  ],
  "TMEM171": [
    "TMEM171 CNV",
    "TMEM171 RNA"
  ],
  "BDH2": [
    "BDH2 CNV",
    "BDH2 RNA",
    "BDH2 Proteo"
  ],
  "RBM48": [
    "RBM48 CNV",
    "RBM48 RNA",
    "RBM48 Proteo"
  ],
  "RPS12P2": [
    "RPS12P2 CNV",
    "RPS12P2 RNA"
  ],
  "CARD9": [
    "CARD9 CNV",
    "CARD9 RNA",
    "CARD9 Proteo"
  ],
  "PPP1R13L": [
    "PPP1R13L CNV",
    "PPP1R13L RNA",
    "PPP1R13L Proteo"
  ],
  "IRGQ": [
    "IRGQ CNV",
    "IRGQ RNA",
    "IRGQ Proteo"
  ],
  "TEKT1": [
    "TEKT1 CNV",
    "TEKT1 RNA"
  ],
  "CYBRD1": [
    "CYBRD1 CNV",
    "CYBRD1 RNA",
    "CYBRD1 Proteo"
  ],
  "PTPN1": [
    "PTPN1 CNV",
    "PTPN1 RNA",
    "PTPN1 Proteo"
  ],
  "RPA4": [
    "RPA4 CNV",
    "RPA4 RNA"
  ],
  "CACNG3": [
    "CACNG3 CNV",
    "CACNG3 RNA"
  ],
  "NSD1": [
    "NSD1 CNV",
    "NSD1 RNA",
    "NSD1 Proteo"
  ],
  "ID3": [
    "ID3 CNV",
    "ID3 RNA"
  ],
  "GAL": [
    "GAL CNV",
    "GAL RNA"
  ],
  "CASQ2": [
    "CASQ2 CNV",
    "CASQ2 RNA",
    "CASQ2 Proteo"
  ],
  "CHN2": [
    "CHN2 CNV",
    "CHN2 RNA",
    "CHN2 Proteo"
  ],
  "ATP5PD": [
    "ATP5PD CNV",
    "ATP5PD RNA",
    "ATP5PD Proteo"
  ],
  "LRG1": [
    "LRG1 CNV",
    "LRG1 RNA",
    "LRG1 Proteo"
  ],
  "EID2": [
    "EID2 CNV",
    "EID2 RNA",
    "EID2 Proteo"
  ],
  "CYP1A1": [
    "CYP1A1 CNV",
    "CYP1A1 RNA"
  ],
  "UBR2": [
    "UBR2 CNV",
    "UBR2 RNA",
    "UBR2 Proteo"
  ],
  "RNA5SP508": [
    "RNA5SP508 CNV",
    "RNA5SP508 RNA"
  ],
  "TAS2R16": [
    "TAS2R16 CNV",
    "TAS2R16 RNA"
  ],
  "PCDH8": [
    "PCDH8 CNV",
    "PCDH8 RNA"
  ],
  "ENPP5": [
    "ENPP5 CNV",
    "ENPP5 RNA"
  ],
  "CABIN1": [
    "CABIN1 CNV",
    "CABIN1 RNA",
    "CABIN1 Proteo"
  ],
  "MTND2P18": [
    "MTND2P18 CNV",
    "MTND2P18 RNA"
  ],
  "TMEM126B": [
    "TMEM126B CNV",
    "TMEM126B RNA",
    "TMEM126B Proteo"
  ],
  "ANXA4": [
    "ANXA4 CNV",
    "ANXA4 RNA",
    "ANXA4 Proteo"
  ],
  "PRC1": [
    "PRC1 CNV",
    "PRC1 RNA",
    "PRC1 Proteo"
  ],
  "MYL6P4": [
    "MYL6P4 CNV",
    "MYL6P4 RNA"
  ],
  "SHROOM2": [
    "SHROOM2 CNV",
    "SHROOM2 RNA",
    "SHROOM2 Proteo"
  ],
  "PANK2": [
    "PANK2 CNV",
    "PANK2 RNA",
    "PANK2 Proteo"
  ],
  "TRAPPC2": [
    "TRAPPC2 CNV",
    "TRAPPC2 RNA",
    "TRAPPC2 Proteo"
  ],
  "DDIT4L": [
    "DDIT4L CNV",
    "DDIT4L RNA"
  ],
  "STC1": [
    "STC1 CNV",
    "STC1 RNA",
    "STC1 Proteo"
  ],
  "UNC13A": [
    "UNC13A CNV",
    "UNC13A RNA"
  ],
  "NR2C1": [
    "NR2C1 CNV",
    "NR2C1 RNA",
    "NR2C1 Proteo"
  ],
  "SH2D1A": [
    "SH2D1A CNV",
    "SH2D1A RNA",
    "SH2D1A Proteo"
  ],
  "BCAS4": [
    "BCAS4 CNV",
    "BCAS4 RNA",
    "BCAS4 Proteo"
  ],
  "CDC42EP2": [
    "CDC42EP2 CNV",
    "CDC42EP2 RNA",
    "CDC42EP2 Proteo"
  ],
  "PFN1": [
    "PFN1 CNV",
    "PFN1 RNA",
    "PFN1 Proteo"
  ],
  "MMRN1": [
    "MMRN1 CNV",
    "MMRN1 RNA",
    "MMRN1 Proteo"
  ],
  "TBC1D9": [
    "TBC1D9 CNV",
    "TBC1D9 RNA",
    "TBC1D9 Proteo"
  ],
  "RPL10AP2": [
    "RPL10AP2 CNV",
    "RPL10AP2 RNA"
  ],
  "STXBP6": [
    "STXBP6 CNV",
    "STXBP6 RNA",
    "STXBP6 Proteo"
  ],
  "GALE": [
    "GALE CNV",
    "GALE RNA",
    "GALE Proteo"
  ],
  "POC1B": [
    "POC1B CNV",
    "POC1B RNA",
    "POC1B Proteo"
  ],
  "STX5": [
    "STX5 CNV",
    "STX5 RNA",
    "STX5 Proteo"
  ],
  "TSPAN4": [
    "TSPAN4 CNV",
    "TSPAN4 RNA",
    "TSPAN4 Proteo"
  ],
  "RPL35AP26": [
    "RPL35AP26 CNV",
    "RPL35AP26 RNA"
  ],
  "MTATP6P24": [
    "MTATP6P24 CNV",
    "MTATP6P24 RNA"
  ],
  "TMEM219": [
    "TMEM219 CNV",
    "TMEM219 RNA",
    "TMEM219 Proteo"
  ],
  "TBC1D2B": [
    "TBC1D2B CNV",
    "TBC1D2B RNA",
    "TBC1D2B Proteo"
  ],
  "FAM104B": [
    "FAM104B CNV",
    "FAM104B RNA"
  ],
  "PTX4": [
    "PTX4 CNV",
    "PTX4 RNA"
  ],
  "HCST": [
    "HCST CNV",
    "HCST RNA",
    "HCST Proteo"
  ],
  "SYNPO": [
    "SYNPO CNV",
    "SYNPO RNA",
    "SYNPO Proteo"
  ],
  "CILP": [
    "CILP CNV",
    "CILP RNA",
    "CILP Proteo"
  ],
  "PPIAP44": [
    "PPIAP44 CNV",
    "PPIAP44 RNA"
  ],
  "GGCX": [
    "GGCX CNV",
    "GGCX RNA",
    "GGCX Proteo"
  ],
  "NR1H4": [
    "NR1H4 CNV",
    "NR1H4 RNA"
  ],
  "MED4": [
    "MED4 CNV",
    "MED4 RNA",
    "MED4 Proteo"
  ],
  "ZDHHC17": [
    "ZDHHC17 CNV",
    "ZDHHC17 RNA",
    "ZDHHC17 Proteo"
  ],
  "FEM1AP1": [
    "FEM1AP1 CNV",
    "FEM1AP1 RNA"
  ],
  "ZNF724": [
    "ZNF724 CNV",
    "ZNF724 RNA"
  ],
  "HMSD": [
    "HMSD CNV",
    "HMSD RNA"
  ],
  "EP400": [
    "EP400 CNV",
    "EP400 RNA",
    "EP400 Proteo"
  ],
  "SPRR1B": [
    "SPRR1B CNV",
    "SPRR1B RNA",
    "SPRR1B Proteo"
  ],
  "OR9P1P": [
    "OR9P1P CNV",
    "OR9P1P RNA"
  ],
  "BECN1P2": [
    "BECN1P2 CNV",
    "BECN1P2 RNA"
  ],
  "JAG2": [
    "JAG2 CNV",
    "JAG2 RNA"
  ],
  "ZNF205": [
    "ZNF205 CNV",
    "ZNF205 RNA"
  ],
  "RBMY2QP": [
    "RBMY2QP CNV",
    "RBMY2QP RNA"
  ],
  "RNA5SP277": [
    "RNA5SP277 CNV",
    "RNA5SP277 RNA"
  ],
  "ARHGEF16": [
    "ARHGEF16 CNV",
    "ARHGEF16 RNA",
    "ARHGEF16 Proteo"
  ],
  "GEN1": [
    "GEN1 CNV",
    "GEN1 RNA",
    "GEN1 Proteo"
  ],
  "PPIAP33": [
    "PPIAP33 CNV",
    "PPIAP33 RNA"
  ],
  "NAA11": [
    "NAA11 CNV",
    "NAA11 RNA",
    "NAA11 Proteo"
  ],
  "RPLP0P6": [
    "RPLP0P6 CNV",
    "RPLP0P6 RNA"
  ],
  "AAMDC": [
    "AAMDC CNV",
    "AAMDC RNA",
    "AAMDC Proteo"
  ],
  "NPM1": [
    "NPM1 CNV",
    "NPM1 RNA",
    "NPM1 Proteo"
  ],
  "ADI1P2": [
    "ADI1P2 CNV",
    "ADI1P2 RNA"
  ],
  "CAPNS1": [
    "CAPNS1 CNV",
    "CAPNS1 RNA",
    "CAPNS1 Proteo"
  ],
  "PANX1": [
    "PANX1 CNV",
    "PANX1 RNA",
    "PANX1 Proteo"
  ],
  "BECN1": [
    "BECN1 CNV",
    "BECN1 RNA",
    "BECN1 Proteo"
  ],
  "ZNF728": [
    "ZNF728 CNV",
    "ZNF728 RNA"
  ],
  "RHOXF2": [
    "RHOXF2 CNV",
    "RHOXF2 RNA"
  ],
  "SPATA6": [
    "SPATA6 CNV",
    "SPATA6 RNA"
  ],
  "GINS2": [
    "GINS2 CNV",
    "GINS2 RNA",
    "GINS2 Proteo"
  ],
  "INTS1": [
    "INTS1 CNV",
    "INTS1 RNA",
    "INTS1 Proteo"
  ],
  "MARK2P10": [
    "MARK2P10 CNV",
    "MARK2P10 RNA"
  ],
  "CHST1": [
    "CHST1 CNV",
    "CHST1 RNA"
  ],
  "TF": [
    "TF CNV",
    "TF RNA",
    "TF Proteo"
  ],
  "ACTR1AP1": [
    "ACTR1AP1 CNV",
    "ACTR1AP1 RNA"
  ],
  "SNRPG": [
    "SNRPG CNV",
    "SNRPG RNA",
    "SNRPG Proteo"
  ],
  "ZSCAN10": [
    "ZSCAN10 CNV",
    "ZSCAN10 RNA"
  ],
  "CNTF": [
    "CNTF CNV",
    "CNTF RNA"
  ],
  "SUGCT": [
    "SUGCT CNV",
    "SUGCT RNA",
    "SUGCT Proteo"
  ],
  "TYW5": [
    "TYW5 CNV",
    "TYW5 RNA",
    "TYW5 Proteo"
  ],
  "IGLVI-38": [
    "IGLVI-38 CNV",
    "IGLVI-38 RNA"
  ],
  "ARF1P3": [
    "ARF1P3 CNV",
    "ARF1P3 RNA"
  ],
  "HSPE1P23": [
    "HSPE1P23 CNV",
    "HSPE1P23 RNA"
  ],
  "UBE2J1": [
    "UBE2J1 CNV",
    "UBE2J1 RNA",
    "UBE2J1 Proteo"
  ],
  "MAPKAPK5": [
    "MAPKAPK5 CNV",
    "MAPKAPK5 RNA",
    "MAPKAPK5 Proteo"
  ],
  "ZNF277": [
    "ZNF277 CNV",
    "ZNF277 RNA",
    "ZNF277 Proteo"
  ],
  "FAM47C": [
    "FAM47C CNV",
    "FAM47C RNA"
  ],
  "TSPAN6": [
    "TSPAN6 CNV",
    "TSPAN6 RNA",
    "TSPAN6 Proteo"
  ],
  "AURKAIP1": [
    "AURKAIP1 CNV",
    "AURKAIP1 RNA",
    "AURKAIP1 Proteo"
  ],
  "ST13P14": [
    "ST13P14 CNV",
    "ST13P14 RNA"
  ],
  "MBOAT1": [
    "MBOAT1 CNV",
    "MBOAT1 RNA",
    "MBOAT1 Proteo"
  ],
  "ANO3": [
    "ANO3 CNV",
    "ANO3 RNA"
  ],
  "EEF1A1P7": [
    "EEF1A1P7 CNV",
    "EEF1A1P7 RNA"
  ],
  "KRT18P60": [
    "KRT18P60 CNV",
    "KRT18P60 RNA"
  ],
  "ACTG1P18": [
    "ACTG1P18 CNV",
    "ACTG1P18 RNA"
  ],
  "LDHAL6CP": [
    "LDHAL6CP CNV",
    "LDHAL6CP RNA"
  ],
  "HOMER2P2": [
    "HOMER2P2 CNV",
    "HOMER2P2 RNA"
  ],
  "C9orf129": [
    "C9orf129 CNV",
    "C9orf129 RNA"
  ],
  "XKR4": [
    "XKR4 CNV",
    "XKR4 RNA"
  ],
  "CREM": [
    "CREM CNV",
    "CREM RNA",
    "CREM Proteo"
  ],
  "ALG1L": [
    "ALG1L CNV",
    "ALG1L RNA"
  ],
  "EIF4A1P11": [
    "EIF4A1P11 CNV",
    "EIF4A1P11 RNA"
  ],
  "AMY1A": [
    "AMY1A CNV",
    "AMY1A RNA"
  ],
  "ADAM22": [
    "ADAM22 CNV",
    "ADAM22 RNA"
  ],
  "AGXT2": [
    "AGXT2 CNV",
    "AGXT2 RNA"
  ],
  "ATRIP": [
    "ATRIP CNV",
    "ATRIP RNA",
    "ATRIP Proteo"
  ],
  "CD82": [
    "CD82 CNV",
    "CD82 RNA",
    "CD82 Proteo"
  ],
  "HNRNPM": [
    "HNRNPM CNV",
    "HNRNPM RNA",
    "HNRNPM Proteo"
  ],
  "ELOVL7": [
    "ELOVL7 CNV",
    "ELOVL7 RNA"
  ],
  "SMIM9": [
    "SMIM9 CNV",
    "SMIM9 RNA"
  ],
  "SRRM5": [
    "SRRM5 CNV",
    "SRRM5 RNA"
  ],
  "SLC27A6": [
    "SLC27A6 CNV",
    "SLC27A6 RNA"
  ],
  "DBI": [
    "DBI CNV",
    "DBI RNA",
    "DBI Proteo"
  ],
  "KIF26B": [
    "KIF26B CNV",
    "KIF26B RNA",
    "KIF26B Proteo"
  ],
  "ZNF594": [
    "ZNF594 CNV",
    "ZNF594 RNA"
  ],
  "RPS11P1": [
    "RPS11P1 CNV",
    "RPS11P1 RNA"
  ],
  "COX18": [
    "COX18 CNV",
    "COX18 RNA",
    "COX18 Proteo"
  ],
  "HNF4G": [
    "HNF4G CNV",
    "HNF4G RNA"
  ],
  "YBX1P4": [
    "YBX1P4 CNV",
    "YBX1P4 RNA"
  ],
  "SPNS3": [
    "SPNS3 CNV",
    "SPNS3 RNA"
  ],
  "ELAVL3": [
    "ELAVL3 CNV",
    "ELAVL3 RNA"
  ],
  "HOXD12": [
    "HOXD12 CNV",
    "HOXD12 RNA"
  ],
  "TRBV5-2": [
    "TRBV5-2 CNV",
    "TRBV5-2 RNA"
  ],
  "OPRM1": [
    "OPRM1 CNV",
    "OPRM1 RNA"
  ],
  "CT47A9": [
    "CT47A9 CNV",
    "CT47A9 RNA"
  ],
  "GABRQ": [
    "GABRQ CNV",
    "GABRQ RNA"
  ],
  "PLAGL2": [
    "PLAGL2 CNV",
    "PLAGL2 RNA"
  ],
  "CXorf51A": [
    "CXorf51A CNV",
    "CXorf51A RNA"
  ],
  "RNA5SP471": [
    "RNA5SP471 CNV",
    "RNA5SP471 RNA"
  ],
  "GOLGA8S": [
    "GOLGA8S CNV",
    "GOLGA8S RNA"
  ],
  "SARNP": [
    "SARNP CNV",
    "SARNP RNA",
    "SARNP Proteo"
  ],
  "ASGR1": [
    "ASGR1 CNV",
    "ASGR1 RNA"
  ],
  "RNA5SP312": [
    "RNA5SP312 CNV",
    "RNA5SP312 RNA"
  ],
  "ZNF394": [
    "ZNF394 CNV",
    "ZNF394 RNA"
  ],
  "MTCO3P44": [
    "MTCO3P44 CNV",
    "MTCO3P44 RNA"
  ],
  "ZNF554": [
    "ZNF554 CNV",
    "ZNF554 RNA"
  ],
  "AXIN2": [
    "AXIN2 CNV",
    "AXIN2 RNA"
  ],
  "CDK2": [
    "CDK2 CNV",
    "CDK2 RNA",
    "CDK2 Proteo"
  ],
  "CFTRP2": [
    "CFTRP2 CNV",
    "CFTRP2 RNA"
  ],
  "MMP2": [
    "MMP2 CNV",
    "MMP2 RNA",
    "MMP2 Proteo"
  ],
  "BMPR1A": [
    "BMPR1A CNV",
    "BMPR1A RNA",
    "BMPR1A Proteo"
  ],
  "ADI1P1": [
    "ADI1P1 CNV",
    "ADI1P1 RNA"
  ],
  "GTF2IP12": [
    "GTF2IP12 CNV",
    "GTF2IP12 RNA"
  ],
  "RPSA": [
    "RPSA CNV",
    "RPSA RNA",
    "RPSA Proteo"
  ],
  "SOX13": [
    "SOX13 CNV",
    "SOX13 RNA",
    "SOX13 Proteo"
  ],
  "RPL39P25": [
    "RPL39P25 CNV",
    "RPL39P25 RNA"
  ],
  "FKBP1C": [
    "FKBP1C CNV",
    "FKBP1C RNA",
    "FKBP1C Proteo"
  ],
  "PIK3C2B": [
    "PIK3C2B CNV",
    "PIK3C2B RNA",
    "PIK3C2B Proteo"
  ],
  "NOL10": [
    "NOL10 CNV",
    "NOL10 RNA",
    "NOL10 Proteo"
  ],
  "CYP3A43": [
    "CYP3A43 CNV",
    "CYP3A43 RNA"
  ],
  "ARNTL": [
    "ARNTL CNV",
    "ARNTL RNA",
    "ARNTL Proteo"
  ],
  "RPL5P21": [
    "RPL5P21 CNV",
    "RPL5P21 RNA"
  ],
  "DPY19L4P2": [
    "DPY19L4P2 CNV",
    "DPY19L4P2 RNA"
  ],
  "TANK": [
    "TANK CNV",
    "TANK RNA",
    "TANK Proteo"
  ],
  "PNLIP": [
    "PNLIP CNV",
    "PNLIP RNA"
  ],
  "LAMB4": [
    "LAMB4 CNV",
    "LAMB4 RNA"
  ],
  "SEPTIN14P4": [
    "SEPTIN14P4 CNV",
    "SEPTIN14P4 RNA"
  ],
  "SET": [
    "SET CNV",
    "SET RNA",
    "SET Proteo"
  ],
  "GTF2IRD2P1": [
    "GTF2IRD2P1 CNV",
    "GTF2IRD2P1 RNA"
  ],
  "RNA5SP40": [
    "RNA5SP40 CNV",
    "RNA5SP40 RNA"
  ],
  "S100A7": [
    "S100A7 CNV",
    "S100A7 RNA",
    "S100A7 Proteo"
  ],
  "PARPBP": [
    "PARPBP CNV",
    "PARPBP RNA"
  ],
  "CYCSP7": [
    "CYCSP7 CNV",
    "CYCSP7 RNA"
  ],
  "RPL21P66": [
    "RPL21P66 CNV",
    "RPL21P66 RNA"
  ],
  "LCN9": [
    "LCN9 CNV",
    "LCN9 RNA"
  ],
  "AIFM1": [
    "AIFM1 CNV",
    "AIFM1 RNA",
    "AIFM1 Proteo"
  ],
  "OR2G3": [
    "OR2G3 CNV",
    "OR2G3 RNA"
  ],
  "RPL36AP20": [
    "RPL36AP20 CNV",
    "RPL36AP20 RNA"
  ],
  "GARIN2": [
    "GARIN2 CNV",
    "GARIN2 RNA"
  ],
  "IGKV3D-31": [
    "IGKV3D-31 CNV",
    "IGKV3D-31 RNA"
  ],
  "RPS8": [
    "RPS8 CNV",
    "RPS8 RNA",
    "RPS8 Proteo"
  ],
  "VCX2": [
    "VCX2 CNV",
    "VCX2 RNA",
    "VCX2 Proteo"
  ],
  "RPS19P7": [
    "RPS19P7 CNV",
    "RPS19P7 RNA"
  ],
  "SMIM23": [
    "SMIM23 CNV",
    "SMIM23 RNA"
  ],
  "EFHD2": [
    "EFHD2 CNV",
    "EFHD2 RNA",
    "EFHD2 Proteo"
  ],
  "CADPS2": [
    "CADPS2 CNV",
    "CADPS2 RNA",
    "CADPS2 Proteo"
  ],
  "ANKFY1": [
    "ANKFY1 CNV",
    "ANKFY1 RNA",
    "ANKFY1 Proteo"
  ],
  "ITIH1": [
    "ITIH1 CNV",
    "ITIH1 RNA",
    "ITIH1 Proteo"
  ],
  "DPEP2NB": [
    "DPEP2NB CNV",
    "DPEP2NB RNA"
  ],
  "ZC3H12D": [
    "ZC3H12D CNV",
    "ZC3H12D RNA",
    "ZC3H12D Proteo"
  ],
  "TXNRD2": [
    "TXNRD2 CNV",
    "TXNRD2 RNA",
    "TXNRD2 Proteo"
  ],
  "FAM118B": [
    "FAM118B CNV",
    "FAM118B RNA",
    "FAM118B Proteo"
  ],
  "FAM90A15P": [
    "FAM90A15P CNV",
    "FAM90A15P RNA"
  ],
  "KRTAP4-9": [
    "KRTAP4-9 CNV",
    "KRTAP4-9 RNA"
  ],
  "ERV3-1": [
    "ERV3-1 CNV",
    "ERV3-1 RNA",
    "ERV3-1 Proteo"
  ],
  "PILRB": [
    "PILRB CNV",
    "PILRB RNA"
  ],
  "NECAB2": [
    "NECAB2 CNV",
    "NECAB2 RNA"
  ],
  "H3P45": [
    "H3P45 CNV",
    "H3P45 RNA"
  ],
  "ULK4P3": [
    "ULK4P3 CNV",
    "ULK4P3 RNA"
  ],
  "PPP1R17": [
    "PPP1R17 CNV",
    "PPP1R17 RNA"
  ],
  "RET": [
    "RET CNV",
    "RET RNA"
  ],
  "SRRM2": [
    "SRRM2 CNV",
    "SRRM2 RNA",
    "SRRM2 Proteo"
  ],
  "OR52A5": [
    "OR52A5 CNV",
    "OR52A5 RNA"
  ],
  "B3GALNT1": [
    "B3GALNT1 CNV",
    "B3GALNT1 RNA",
    "B3GALNT1 Proteo"
  ],
  "MTA3": [
    "MTA3 CNV",
    "MTA3 RNA",
    "MTA3 Proteo"
  ],
  "MAN1A1": [
    "MAN1A1 CNV",
    "MAN1A1 RNA",
    "MAN1A1 Proteo"
  ],
  "SLC38A6": [
    "SLC38A6 CNV",
    "SLC38A6 RNA"
  ],
  "SLC30A9": [
    "SLC30A9 CNV",
    "SLC30A9 RNA",
    "SLC30A9 Proteo"
  ],
  "NUCB2": [
    "NUCB2 CNV",
    "NUCB2 RNA",
    "NUCB2 Proteo"
  ],
  "GAPDHP60": [
    "GAPDHP60 CNV",
    "GAPDHP60 RNA"
  ],
  "TRIM60P9Y": [
    "TRIM60P9Y CNV",
    "TRIM60P9Y RNA"
  ],
  "TMEM81": [
    "TMEM81 CNV",
    "TMEM81 RNA"
  ],
  "Neutrophils": [
    "Neutrophils Cell_type"
  ],
  "ICE2P2": [
    "ICE2P2 CNV",
    "ICE2P2 RNA"
  ],
  "FAM149B1": [
    "FAM149B1 CNV",
    "FAM149B1 RNA"
  ],
  "TSHZ2": [
    "TSHZ2 CNV",
    "TSHZ2 RNA"
  ],
  "SFI1": [
    "SFI1 CNV",
    "SFI1 RNA"
  ],
  "SYCP2L": [
    "SYCP2L CNV",
    "SYCP2L RNA"
  ],
  "HNRNPA1P43": [
    "HNRNPA1P43 CNV",
    "HNRNPA1P43 RNA"
  ],
  "LIN7B": [
    "LIN7B CNV",
    "LIN7B RNA"
  ],
  "SLC25A4": [
    "SLC25A4 CNV",
    "SLC25A4 RNA",
    "SLC25A4 Proteo"
  ],
  "EFCAB12": [
    "EFCAB12 CNV",
    "EFCAB12 RNA"
  ],
  "ZNF155": [
    "ZNF155 CNV",
    "ZNF155 RNA"
  ],
  "SRSF10": [
    "SRSF10 CNV",
    "SRSF10 RNA",
    "SRSF10 Proteo"
  ],
  "HMGB3P11": [
    "HMGB3P11 CNV",
    "HMGB3P11 RNA"
  ],
  "KRTAP19-10P": [
    "KRTAP19-10P CNV",
    "KRTAP19-10P RNA"
  ],
  "PEBP1P3": [
    "PEBP1P3 CNV",
    "PEBP1P3 RNA"
  ],
  "ADH5P5": [
    "ADH5P5 CNV",
    "ADH5P5 RNA"
  ],
  "POU5F1B": [
    "POU5F1B CNV",
    "POU5F1B RNA"
  ],
  "RNA5SP511": [
    "RNA5SP511 CNV",
    "RNA5SP511 RNA"
  ],
  "CIB2": [
    "CIB2 CNV",
    "CIB2 RNA"
  ],
  "KRT8P17": [
    "KRT8P17 CNV",
    "KRT8P17 RNA"
  ],
  "CTSB": [
    "CTSB CNV",
    "CTSB RNA",
    "CTSB Proteo"
  ],
  "MTND1P21": [
    "MTND1P21 CNV",
    "MTND1P21 RNA"
  ],
  "FEM1C": [
    "FEM1C CNV",
    "FEM1C RNA",
    "FEM1C Proteo"
  ],
  "SNAP91": [
    "SNAP91 CNV",
    "SNAP91 RNA"
  ],
  "ASB9P1": [
    "ASB9P1 CNV",
    "ASB9P1 RNA"
  ],
  "RPSAP72": [
    "RPSAP72 CNV",
    "RPSAP72 RNA"
  ],
  "SMS": [
    "SMS CNV",
    "SMS RNA",
    "SMS Proteo"
  ],
  "TSPYL1": [
    "TSPYL1 CNV",
    "TSPYL1 RNA",
    "TSPYL1 Proteo"
  ],
  "OR9G2P": [
    "OR9G2P CNV",
    "OR9G2P RNA"
  ],
  "NAIPP1": [
    "NAIPP1 CNV",
    "NAIPP1 RNA"
  ],
  "RNF212B": [
    "RNF212B CNV",
    "RNF212B RNA"
  ],
  "FAR2P3": [
    "FAR2P3 CNV",
    "FAR2P3 RNA"
  ],
  "C12orf50": [
    "C12orf50 CNV",
    "C12orf50 RNA"
  ],
  "ZNF623": [
    "ZNF623 CNV",
    "ZNF623 RNA",
    "ZNF623 Proteo"
  ],
  "NPTX1": [
    "NPTX1 CNV",
    "NPTX1 RNA",
    "NPTX1 Proteo"
  ],
  "WBP11P2": [
    "WBP11P2 CNV",
    "WBP11P2 RNA"
  ],
  "BMS1P9": [
    "BMS1P9 CNV",
    "BMS1P9 RNA"
  ],
  "TBC1D28": [
    "TBC1D28 CNV",
    "TBC1D28 RNA"
  ],
  "SLC35C1": [
    "SLC35C1 CNV",
    "SLC35C1 RNA",
    "SLC35C1 Proteo"
  ],
  "HNRNPAB": [
    "HNRNPAB CNV",
    "HNRNPAB RNA",
    "HNRNPAB Proteo"
  ],
  "BNIP3P3": [
    "BNIP3P3 CNV",
    "BNIP3P3 RNA"
  ],
  "MPHOSPH8": [
    "MPHOSPH8 CNV",
    "MPHOSPH8 RNA",
    "MPHOSPH8 Proteo"
  ],
  "OR9M1P": [
    "OR9M1P CNV",
    "OR9M1P RNA"
  ],
  "SRSF3P1": [
    "SRSF3P1 CNV",
    "SRSF3P1 RNA"
  ],
  "OR56B1": [
    "OR56B1 CNV",
    "OR56B1 RNA"
  ],
  "MAPKBP1": [
    "MAPKBP1 CNV",
    "MAPKBP1 RNA",
    "MAPKBP1 Proteo"
  ],
  "PFN1P9": [
    "PFN1P9 CNV",
    "PFN1P9 RNA"
  ],
  "RCN3": [
    "RCN3 CNV",
    "RCN3 RNA",
    "RCN3 Proteo"
  ],
  "PRYP6": [
    "PRYP6 CNV",
    "PRYP6 RNA"
  ],
  "SCGB1D2": [
    "SCGB1D2 CNV",
    "SCGB1D2 RNA",
    "SCGB1D2 Proteo"
  ],
  "DACT1": [
    "DACT1 CNV",
    "DACT1 RNA"
  ],
  "GPATCH2L": [
    "GPATCH2L CNV",
    "GPATCH2L RNA",
    "GPATCH2L Proteo"
  ],
  "CD63": [
    "CD63 CNV",
    "CD63 RNA",
    "CD63 Proteo"
  ],
  "ANAPC11": [
    "ANAPC11 CNV",
    "ANAPC11 RNA"
  ],
  "KRT18P62": [
    "KRT18P62 CNV",
    "KRT18P62 RNA"
  ],
  "SULT1A2": [
    "SULT1A2 CNV",
    "SULT1A2 RNA",
    "SULT1A2 Proteo"
  ],
  "STX19": [
    "STX19 CNV",
    "STX19 RNA"
  ],
  "RPS3AP34": [
    "RPS3AP34 CNV",
    "RPS3AP34 RNA"
  ],
  "VN1R78P": [
    "VN1R78P CNV",
    "VN1R78P RNA"
  ],
  "C1QTNF8": [
    "C1QTNF8 CNV",
    "C1QTNF8 RNA"
  ],
  "RTN4RL1": [
    "RTN4RL1 CNV",
    "RTN4RL1 RNA"
  ],
  "RPS2P39": [
    "RPS2P39 CNV",
    "RPS2P39 RNA"
  ],
  "ADCY5": [
    "ADCY5 CNV",
    "ADCY5 RNA"
  ],
  "PAK1": [
    "PAK1 CNV",
    "PAK1 RNA",
    "PAK1 Proteo"
  ],
  "MXRA7P1": [
    "MXRA7P1 CNV",
    "MXRA7P1 RNA"
  ],
  "KCNMB4": [
    "KCNMB4 CNV",
    "KCNMB4 RNA"
  ],
  "PAQR5": [
    "PAQR5 CNV",
    "PAQR5 RNA",
    "PAQR5 Proteo"
  ],
  "RBM22P6": [
    "RBM22P6 CNV",
    "RBM22P6 RNA"
  ],
  "LAMB2P1": [
    "LAMB2P1 CNV",
    "LAMB2P1 RNA"
  ],
  "LYG1": [
    "LYG1 CNV",
    "LYG1 RNA"
  ],
  "RPL15P5": [
    "RPL15P5 CNV",
    "RPL15P5 RNA"
  ],
  "SCGB2B3P": [
    "SCGB2B3P CNV",
    "SCGB2B3P RNA"
  ],
  "IGHVII-1-1": [
    "IGHVII-1-1 CNV",
    "IGHVII-1-1 RNA"
  ],
  "Tregs": [
    "Tregs Cell_type"
  ],
  "SPSB3": [
    "SPSB3 CNV",
    "SPSB3 RNA"
  ],
  "RRP1": [
    "RRP1 CNV",
    "RRP1 RNA",
    "RRP1 Proteo"
  ],
  "LPAR3": [
    "LPAR3 CNV",
    "LPAR3 RNA"
  ],
  "ZSCAN1": [
    "ZSCAN1 CNV",
    "ZSCAN1 RNA"
  ],
  "COL8A2": [
    "COL8A2 CNV",
    "COL8A2 RNA"
  ],
  "HGD": [
    "HGD CNV",
    "HGD RNA",
    "HGD Proteo"
  ],
  "NDUFS2": [
    "NDUFS2 CNV",
    "NDUFS2 RNA",
    "NDUFS2 Proteo"
  ],
  "AP3B2": [
    "AP3B2 CNV",
    "AP3B2 RNA",
    "AP3B2 Proteo"
  ],
  "CNBD1": [
    "CNBD1 CNV",
    "CNBD1 RNA"
  ],
  "MRM2": [
    "MRM2 CNV",
    "MRM2 RNA",
    "MRM2 Proteo"
  ],
  "NLRP11": [
    "NLRP11 CNV",
    "NLRP11 RNA"
  ],
  "SBK2": [
    "SBK2 CNV",
    "SBK2 RNA"
  ],
  "YTHDC2": [
    "YTHDC2 CNV",
    "YTHDC2 RNA",
    "YTHDC2 Proteo"
  ],
  "RAB9AP5": [
    "RAB9AP5 CNV",
    "RAB9AP5 RNA"
  ],
  "LINS1": [
    "LINS1 CNV",
    "LINS1 RNA",
    "LINS1 Proteo"
  ],
  "ZFR": [
    "ZFR CNV",
    "ZFR RNA",
    "ZFR Proteo"
  ],
  "SLC35F5": [
    "SLC35F5 CNV",
    "SLC35F5 RNA",
    "SLC35F5 Proteo"
  ],
  "UBTFL5": [
    "UBTFL5 CNV",
    "UBTFL5 RNA"
  ],
  "MYBBP1A": [
    "MYBBP1A CNV",
    "MYBBP1A RNA",
    "MYBBP1A Proteo"
  ],
  "CHRNA4": [
    "CHRNA4 CNV",
    "CHRNA4 RNA"
  ],
  "HIVEP1": [
    "HIVEP1 CNV",
    "HIVEP1 RNA",
    "HIVEP1 Proteo"
  ],
  "NEMP2": [
    "NEMP2 CNV",
    "NEMP2 RNA",
    "NEMP2 Proteo"
  ],
  "MTCO2P25": [
    "MTCO2P25 CNV",
    "MTCO2P25 RNA"
  ],
  "PCBP2P3": [
    "PCBP2P3 CNV",
    "PCBP2P3 RNA"
  ],
  "RNA5SP55": [
    "RNA5SP55 CNV",
    "RNA5SP55 RNA"
  ],
  "SHISA7": [
    "SHISA7 CNV",
    "SHISA7 RNA"
  ],
  "B3GLCT": [
    "B3GLCT CNV",
    "B3GLCT RNA",
    "B3GLCT Proteo"
  ],
  "TRGVA": [
    "TRGVA CNV",
    "TRGVA RNA"
  ],
  "NIPSNAP3A": [
    "NIPSNAP3A CNV",
    "NIPSNAP3A RNA",
    "NIPSNAP3A Proteo"
  ],
  "ZSWIM8": [
    "ZSWIM8 CNV",
    "ZSWIM8 RNA",
    "ZSWIM8 Proteo"
  ],
  "CT47B1": [
    "CT47B1 CNV",
    "CT47B1 RNA"
  ],
  "SEZ6L2": [
    "SEZ6L2 CNV",
    "SEZ6L2 RNA",
    "SEZ6L2 Proteo"
  ],
  "TIMM9": [
    "TIMM9 CNV",
    "TIMM9 RNA",
    "TIMM9 Proteo"
  ],
  "DPPA2P1": [
    "DPPA2P1 CNV",
    "DPPA2P1 RNA"
  ],
  "COMMD8": [
    "COMMD8 CNV",
    "COMMD8 RNA",
    "COMMD8 Proteo"
  ],
  "FAM238A": [
    "FAM238A CNV",
    "FAM238A RNA"
  ],
  "FAM237A": [
    "FAM237A CNV",
    "FAM237A RNA"
  ],
  "PIGFP2": [
    "PIGFP2 CNV",
    "PIGFP2 RNA"
  ],
  "ZNF792": [
    "ZNF792 CNV",
    "ZNF792 RNA"
  ],
  "XRCC6P4": [
    "XRCC6P4 CNV",
    "XRCC6P4 RNA"
  ],
  "MTND1P16": [
    "MTND1P16 CNV",
    "MTND1P16 RNA"
  ],
  "ZNF603P": [
    "ZNF603P CNV",
    "ZNF603P RNA"
  ],
  "SLC2A11": [
    "SLC2A11 CNV",
    "SLC2A11 RNA"
  ],
  "PLPBP": [
    "PLPBP CNV",
    "PLPBP RNA",
    "PLPBP Proteo"
  ],
  "SMR3A": [
    "SMR3A CNV",
    "SMR3A RNA"
  ],
  "KANSL3": [
    "KANSL3 CNV",
    "KANSL3 RNA",
    "KANSL3 Proteo"
  ],
  "LIMK2": [
    "LIMK2 CNV",
    "LIMK2 RNA",
    "LIMK2 Proteo"
  ],
  "U2AF1": [
    "U2AF1 CNV",
    "U2AF1 RNA",
    "U2AF1 Proteo"
  ],
  "ACTBP8": [
    "ACTBP8 CNV",
    "ACTBP8 RNA"
  ],
  "SLC2A4RG": [
    "SLC2A4RG CNV",
    "SLC2A4RG RNA"
  ],
  "MAPK8IP1P2": [
    "MAPK8IP1P2 CNV",
    "MAPK8IP1P2 RNA"
  ],
  "ARAFP2": [
    "ARAFP2 CNV",
    "ARAFP2 RNA"
  ],
  "LRRC26": [
    "LRRC26 CNV",
    "LRRC26 RNA"
  ],
  "PPIAP63": [
    "PPIAP63 CNV",
    "PPIAP63 RNA"
  ],
  "GPBP1": [
    "GPBP1 CNV",
    "GPBP1 RNA",
    "GPBP1 Proteo"
  ],
  "IL37": [
    "IL37 CNV",
    "IL37 RNA"
  ],
  "TAF11L4": [
    "TAF11L4 CNV",
    "TAF11L4 RNA"
  ],
  "CACNA1I": [
    "CACNA1I CNV",
    "CACNA1I RNA"
  ],
  "HUS1B": [
    "HUS1B CNV",
    "HUS1B RNA"
  ],
  "TRIM51": [
    "TRIM51 CNV",
    "TRIM51 RNA"
  ],
  "KISS1R": [
    "KISS1R CNV",
    "KISS1R RNA"
  ],
  "OR4C10P": [
    "OR4C10P CNV",
    "OR4C10P RNA"
  ],
  "NDUFB4P9": [
    "NDUFB4P9 CNV",
    "NDUFB4P9 RNA"
  ],
  "RPL6P6": [
    "RPL6P6 CNV",
    "RPL6P6 RNA"
  ],
  "GOLGA6D": [
    "GOLGA6D CNV",
    "GOLGA6D RNA"
  ],
  "TMLHE": [
    "TMLHE CNV",
    "TMLHE RNA",
    "TMLHE Proteo"
  ],
  "TMEM203": [
    "TMEM203 CNV",
    "TMEM203 RNA"
  ],
  "MYO7A": [
    "MYO7A CNV",
    "MYO7A RNA",
    "MYO7A Proteo"
  ],
  "ZBTB26": [
    "ZBTB26 CNV",
    "ZBTB26 RNA"
  ],
  "SPDYE10": [
    "SPDYE10 CNV",
    "SPDYE10 RNA"
  ],
  "PLBD2": [
    "PLBD2 CNV",
    "PLBD2 RNA",
    "PLBD2 Proteo"
  ],
  "IFNL4P1": [
    "IFNL4P1 CNV",
    "IFNL4P1 RNA"
  ],
  "FAM171B": [
    "FAM171B CNV",
    "FAM171B RNA"
  ],
  "EIF1AX": [
    "EIF1AX CNV",
    "EIF1AX RNA",
    "EIF1AX Proteo"
  ],
  "MBTD1": [
    "MBTD1 CNV",
    "MBTD1 RNA",
    "MBTD1 Proteo"
  ],
  "CRIP2": [
    "CRIP2 CNV",
    "CRIP2 RNA",
    "CRIP2 Proteo"
  ],
  "RSL1D1": [
    "RSL1D1 CNV",
    "RSL1D1 RNA",
    "RSL1D1 Proteo"
  ],
  "TMEM38B": [
    "TMEM38B CNV",
    "TMEM38B RNA",
    "TMEM38B Proteo"
  ],
  "PDE1A": [
    "PDE1A CNV",
    "PDE1A RNA",
    "PDE1A Proteo"
  ],
  "KRT38": [
    "KRT38 CNV",
    "KRT38 RNA"
  ],
  "NUDT19P5": [
    "NUDT19P5 CNV",
    "NUDT19P5 RNA"
  ],
  "NUP205": [
    "NUP205 CNV",
    "NUP205 RNA",
    "NUP205 Proteo"
  ],
  "OR13I1P": [
    "OR13I1P CNV",
    "OR13I1P RNA"
  ],
  "SOX18": [
    "SOX18 CNV",
    "SOX18 RNA"
  ],
  "ITIH6": [
    "ITIH6 CNV",
    "ITIH6 RNA",
    "ITIH6 Proteo"
  ],
  "GPR171": [
    "GPR171 CNV",
    "GPR171 RNA"
  ],
  "DEFA3": [
    "DEFA3 CNV",
    "DEFA3 RNA",
    "DEFA3 Proteo"
  ],
  "SIGLEC6": [
    "SIGLEC6 CNV",
    "SIGLEC6 RNA"
  ],
  "JAKMIP1-DT": [
    "JAKMIP1-DT CNV",
    "JAKMIP1-DT RNA"
  ],
  "DMD": [
    "DMD CNV",
    "DMD RNA",
    "DMD Proteo"
  ],
  "TMEM87A": [
    "TMEM87A CNV",
    "TMEM87A RNA",
    "TMEM87A Proteo"
  ],
  "FABP5P2": [
    "FABP5P2 CNV",
    "FABP5P2 RNA"
  ],
  "ART1": [
    "ART1 CNV",
    "ART1 RNA"
  ],
  "TUBAL3": [
    "TUBAL3 CNV",
    "TUBAL3 RNA",
    "TUBAL3 Proteo"
  ],
  "VAV1": [
    "VAV1 CNV",
    "VAV1 RNA",
    "VAV1 Proteo"
  ],
  "SDR42E1P3": [
    "SDR42E1P3 CNV",
    "SDR42E1P3 RNA"
  ],
  "DTX2": [
    "DTX2 CNV",
    "DTX2 RNA",
    "DTX2 Proteo"
  ],
  "CHMP5": [
    "CHMP5 CNV",
    "CHMP5 RNA",
    "CHMP5 Proteo"
  ],
  "GABARAP": [
    "GABARAP CNV",
    "GABARAP RNA",
    "GABARAP Proteo"
  ],
  "IST1": [
    "IST1 CNV",
    "IST1 RNA",
    "IST1 Proteo"
  ],
  "ARHGAP20": [
    "ARHGAP20 CNV",
    "ARHGAP20 RNA"
  ],
  "CENPO": [
    "CENPO CNV",
    "CENPO RNA",
    "CENPO Proteo"
  ],
  "BLM": [
    "BLM CNV",
    "BLM RNA",
    "BLM Proteo"
  ],
  "HCG22": [
    "HCG22 CNV",
    "HCG22 RNA"
  ],
  "ZFAT": [
    "ZFAT CNV",
    "ZFAT RNA",
    "ZFAT Proteo"
  ],
  "BNC1": [
    "BNC1 CNV",
    "BNC1 RNA"
  ],
  "OR4A10P": [
    "OR4A10P CNV",
    "OR4A10P RNA"
  ],
  "LRRC36": [
    "LRRC36 CNV",
    "LRRC36 RNA"
  ],
  "CD33": [
    "CD33 CNV",
    "CD33 RNA",
    "CD33 Proteo"
  ],
  "ZBTB43": [
    "ZBTB43 CNV",
    "ZBTB43 RNA",
    "ZBTB43 Proteo"
  ],
  "GADD45G": [
    "GADD45G CNV",
    "GADD45G RNA"
  ],
  "MANBA": [
    "MANBA CNV",
    "MANBA RNA",
    "MANBA Proteo"
  ],
  "KCNT1": [
    "KCNT1 CNV",
    "KCNT1 RNA",
    "KCNT1 Proteo"
  ],
  "PLVAP": [
    "PLVAP CNV",
    "PLVAP RNA",
    "PLVAP Proteo"
  ],
  "PLG": [
    "PLG CNV",
    "PLG RNA",
    "PLG Proteo"
  ],
  "EPS8L1": [
    "EPS8L1 CNV",
    "EPS8L1 RNA",
    "EPS8L1 Proteo"
  ],
  "RHOB": [
    "RHOB CNV",
    "RHOB RNA",
    "RHOB Proteo"
  ],
  "FFAR3": [
    "FFAR3 CNV",
    "FFAR3 RNA"
  ],
  "PDCD1": [
    "PDCD1 CNV",
    "PDCD1 RNA",
    "PDCD1 Proteo"
  ],
  "OR5B19P": [
    "OR5B19P CNV",
    "OR5B19P RNA"
  ],
  "TMOD2": [
    "TMOD2 CNV",
    "TMOD2 RNA",
    "TMOD2 Proteo"
  ],
  "HEBP1": [
    "HEBP1 CNV",
    "HEBP1 RNA",
    "HEBP1 Proteo"
  ],
  "SETP8": [
    "SETP8 CNV",
    "SETP8 RNA"
  ],
  "FERMT1": [
    "FERMT1 CNV",
    "FERMT1 RNA",
    "FERMT1 Proteo"
  ],
  "CLEC4D": [
    "CLEC4D CNV",
    "CLEC4D RNA",
    "CLEC4D Proteo"
  ],
  "SMARCD2": [
    "SMARCD2 CNV",
    "SMARCD2 RNA",
    "SMARCD2 Proteo"
  ],
  "ZNF624": [
    "ZNF624 CNV",
    "ZNF624 RNA",
    "ZNF624 Proteo"
  ],
  "TSPY8": [
    "TSPY8 CNV",
    "TSPY8 RNA"
  ],
  "TJAP1": [
    "TJAP1 CNV",
    "TJAP1 RNA",
    "TJAP1 Proteo"
  ],
  "TMEM256": [
    "TMEM256 CNV",
    "TMEM256 RNA",
    "TMEM256 Proteo"
  ],
  "TMEM255B": [
    "TMEM255B CNV",
    "TMEM255B RNA"
  ],
  "CCNL1": [
    "CCNL1 CNV",
    "CCNL1 RNA",
    "CCNL1 Proteo"
  ],
  "CDK7": [
    "CDK7 CNV",
    "CDK7 RNA",
    "CDK7 Proteo"
  ],
  "RGL1": [
    "RGL1 CNV",
    "RGL1 RNA",
    "RGL1 Proteo"
  ],
  "TAL2": [
    "TAL2 CNV",
    "TAL2 RNA"
  ],
  "TUBB1P2": [
    "TUBB1P2 CNV",
    "TUBB1P2 RNA"
  ],
  "VWA7": [
    "VWA7 CNV",
    "VWA7 RNA",
    "VWA7 Proteo"
  ],
  "POU2F3": [
    "POU2F3 CNV",
    "POU2F3 RNA"
  ],
  "PAFAH1B1": [
    "PAFAH1B1 CNV",
    "PAFAH1B1 RNA",
    "PAFAH1B1 Proteo"
  ],
  "FBL": [
    "FBL CNV",
    "FBL RNA",
    "FBL Proteo"
  ],
  "GLB1L": [
    "GLB1L CNV",
    "GLB1L RNA",
    "GLB1L Proteo"
  ],
  "ARL5B": [
    "ARL5B CNV",
    "ARL5B RNA",
    "ARL5B Proteo"
  ],
  "XKRY2": [
    "XKRY2 CNV",
    "XKRY2 RNA"
  ],
  "RNA5SP100": [
    "RNA5SP100 CNV",
    "RNA5SP100 RNA"
  ],
  "ALPL": [
    "ALPL CNV",
    "ALPL RNA",
    "ALPL Proteo"
  ],
  "NFASC": [
    "NFASC CNV",
    "NFASC RNA",
    "NFASC Proteo"
  ],
  "VDAC3P1": [
    "VDAC3P1 CNV",
    "VDAC3P1 RNA"
  ],
  "FABP5P8": [
    "FABP5P8 CNV",
    "FABP5P8 RNA"
  ],
  "IGHV3-23": [
    "IGHV3-23 Proteo"
  ],
  "ZSWIM5P1": [
    "ZSWIM5P1 CNV",
    "ZSWIM5P1 RNA"
  ],
  "RANP7": [
    "RANP7 CNV",
    "RANP7 RNA"
  ],
  "MRGPRX9P": [
    "MRGPRX9P CNV",
    "MRGPRX9P RNA"
  ],
  "P2RX7": [
    "P2RX7 CNV",
    "P2RX7 RNA",
    "P2RX7 Proteo"
  ],
  "INTS9": [
    "INTS9 CNV",
    "INTS9 RNA",
    "INTS9 Proteo"
  ],
  "RNA5SP199": [
    "RNA5SP199 CNV",
    "RNA5SP199 RNA"
  ],
  "SOCS2P2": [
    "SOCS2P2 CNV",
    "SOCS2P2 RNA"
  ],
  "UBXN4": [
    "UBXN4 CNV",
    "UBXN4 RNA",
    "UBXN4 Proteo"
  ],
  "INHBB": [
    "INHBB CNV",
    "INHBB RNA"
  ],
  "MS4A2": [
    "MS4A2 CNV",
    "MS4A2 RNA"
  ],
  "BTG1": [
    "BTG1 CNV",
    "BTG1 RNA",
    "BTG1 Proteo"
  ],
  "HECW1": [
    "HECW1 CNV",
    "HECW1 RNA"
  ],
  "PPIAP57": [
    "PPIAP57 CNV",
    "PPIAP57 RNA"
  ],
  "SMCO4P1": [
    "SMCO4P1 CNV",
    "SMCO4P1 RNA"
  ],
  "YPEL5P1": [
    "YPEL5P1 CNV",
    "YPEL5P1 RNA"
  ],
  "RNA5SP378": [
    "RNA5SP378 CNV",
    "RNA5SP378 RNA"
  ],
  "LYPLA2P3": [
    "LYPLA2P3 CNV",
    "LYPLA2P3 RNA"
  ],
  "UBE2Q2P6": [
    "UBE2Q2P6 CNV",
    "UBE2Q2P6 RNA"
  ],
  "LHX1": [
    "LHX1 CNV",
    "LHX1 RNA"
  ],
  "WDR43": [
    "WDR43 CNV",
    "WDR43 RNA",
    "WDR43 Proteo"
  ],
  "RBMY2OP": [
    "RBMY2OP CNV",
    "RBMY2OP RNA"
  ],
  "MKRN8P": [
    "MKRN8P CNV",
    "MKRN8P RNA"
  ],
  "ST13P7": [
    "ST13P7 CNV",
    "ST13P7 RNA"
  ],
  "PABPC1": [
    "PABPC1 CNV",
    "PABPC1 RNA",
    "PABPC1 Proteo"
  ],
  "TRBV7-5": [
    "TRBV7-5 CNV",
    "TRBV7-5 RNA"
  ],
  "CEP295": [
    "CEP295 CNV",
    "CEP295 RNA",
    "CEP295 Proteo"
  ],
  "THA1P": [
    "THA1P CNV",
    "THA1P RNA"
  ],
  "SCCPDH": [
    "SCCPDH CNV",
    "SCCPDH RNA",
    "SCCPDH Proteo"
  ],
  "ZNF267": [
    "ZNF267 CNV",
    "ZNF267 RNA",
    "ZNF267 Proteo"
  ],
  "PHB1P14": [
    "PHB1P14 CNV",
    "PHB1P14 RNA"
  ],
  "RPL17P37": [
    "RPL17P37 CNV",
    "RPL17P37 RNA"
  ],
  "GOLGA3": [
    "GOLGA3 CNV",
    "GOLGA3 RNA",
    "GOLGA3 Proteo"
  ],
  "VN1R65P": [
    "VN1R65P CNV",
    "VN1R65P RNA"
  ],
  "SYCE2": [
    "SYCE2 CNV",
    "SYCE2 RNA"
  ],
  "DDX42": [
    "DDX42 CNV",
    "DDX42 RNA",
    "DDX42 Proteo"
  ],
  "RPS6P14": [
    "RPS6P14 CNV",
    "RPS6P14 RNA"
  ],
  "SMIM8": [
    "SMIM8 CNV",
    "SMIM8 RNA",
    "SMIM8 Proteo"
  ],
  "CDSN": [
    "CDSN CNV",
    "CDSN RNA",
    "CDSN Proteo"
  ],
  "APOO": [
    "APOO CNV",
    "APOO RNA",
    "APOO Proteo"
  ],
  "ZC4H2": [
    "ZC4H2 CNV",
    "ZC4H2 RNA"
  ],
  "YIPF1": [
    "YIPF1 CNV",
    "YIPF1 RNA",
    "YIPF1 Proteo"
  ],
  "CLEC10A": [
    "CLEC10A CNV",
    "CLEC10A RNA"
  ],
  "CEL": [
    "CEL CNV",
    "CEL RNA"
  ],
  "TRPC1": [
    "TRPC1 CNV",
    "TRPC1 RNA"
  ],
  "RPL7AP44": [
    "RPL7AP44 CNV",
    "RPL7AP44 RNA"
  ],
  "DYNC1LI1": [
    "DYNC1LI1 CNV",
    "DYNC1LI1 RNA",
    "DYNC1LI1 Proteo"
  ],
  "THSD4": [
    "THSD4 CNV",
    "THSD4 RNA",
    "THSD4 Proteo"
  ],
  "SFSWAP": [
    "SFSWAP CNV",
    "SFSWAP RNA",
    "SFSWAP Proteo"
  ],
  "ARRDC4": [
    "ARRDC4 CNV",
    "ARRDC4 RNA"
  ],
  "MTND2P33": [
    "MTND2P33 CNV",
    "MTND2P33 RNA"
  ],
  "TXN2": [
    "TXN2 CNV",
    "TXN2 RNA",
    "TXN2 Proteo"
  ],
  "GSX1": [
    "GSX1 CNV",
    "GSX1 RNA"
  ],
  "IL5": [
    "IL5 CNV",
    "IL5 RNA"
  ],
  "PHACTR2": [
    "PHACTR2 CNV",
    "PHACTR2 RNA",
    "PHACTR2 Proteo"
  ],
  "EPHA4": [
    "EPHA4 CNV",
    "EPHA4 RNA",
    "EPHA4 Proteo"
  ],
  "SCD": [
    "SCD CNV",
    "SCD RNA",
    "SCD Proteo"
  ],
  "LINC00032": [
    "LINC00032 CNV",
    "LINC00032 RNA"
  ],
  "CSPG4P5": [
    "CSPG4P5 CNV",
    "CSPG4P5 RNA"
  ],
  "PPL": [
    "PPL CNV",
    "PPL RNA",
    "PPL Proteo"
  ],
  "SLC25A12": [
    "SLC25A12 CNV",
    "SLC25A12 RNA",
    "SLC25A12 Proteo"
  ],
  "ZNF770": [
    "ZNF770 CNV",
    "ZNF770 RNA",
    "ZNF770 Proteo"
  ],
  "FTLP3": [
    "FTLP3 CNV",
    "FTLP3 RNA"
  ],
  "CLDN5": [
    "CLDN5 CNV",
    "CLDN5 RNA"
  ],
  "AKT2": [
    "AKT2 CNV",
    "AKT2 RNA",
    "AKT2 Proteo"
  ],
  "GRIN2B": [
    "GRIN2B CNV",
    "GRIN2B RNA"
  ],
  "ZNF543": [
    "ZNF543 CNV",
    "ZNF543 RNA"
  ],
  "PNPLA1": [
    "PNPLA1 CNV",
    "PNPLA1 RNA"
  ],
  "MYO15B": [
    "MYO15B CNV",
    "MYO15B RNA",
    "MYO15B Proteo"
  ],
  "RAN": [
    "RAN CNV",
    "RAN RNA",
    "RAN Proteo"
  ],
  "GRXCR2": [
    "GRXCR2 CNV",
    "GRXCR2 RNA"
  ],
  "DHX57": [
    "DHX57 CNV",
    "DHX57 RNA",
    "DHX57 Proteo"
  ],
  "RPLP2P1": [
    "RPLP2P1 CNV",
    "RPLP2P1 RNA"
  ],
  "NF1P10": [
    "NF1P10 CNV",
    "NF1P10 RNA"
  ],
  "HMGN1P31": [
    "HMGN1P31 CNV",
    "HMGN1P31 RNA"
  ],
  "CTSW": [
    "CTSW CNV",
    "CTSW RNA",
    "CTSW Proteo"
  ],
  "WNT7A": [
    "WNT7A CNV",
    "WNT7A RNA"
  ],
  "CHD8": [
    "CHD8 CNV",
    "CHD8 RNA",
    "CHD8 Proteo"
  ],
  "MYH13": [
    "MYH13 CNV",
    "MYH13 RNA",
    "MYH13 Proteo"
  ],
  "EXOC1L": [
    "EXOC1L CNV",
    "EXOC1L RNA"
  ],
  "RUBCNL": [
    "RUBCNL CNV",
    "RUBCNL RNA",
    "RUBCNL Proteo"
  ],
  "RBBP4P5": [
    "RBBP4P5 CNV",
    "RBBP4P5 RNA"
  ],
  "RBMXP5": [
    "RBMXP5 CNV",
    "RBMXP5 RNA"
  ],
  "FABP5P15": [
    "FABP5P15 CNV",
    "FABP5P15 RNA"
  ],
  "ANKRD18CP": [
    "ANKRD18CP CNV",
    "ANKRD18CP RNA"
  ],
  "NAA50P1": [
    "NAA50P1 CNV",
    "NAA50P1 RNA"
  ],
  "ZNF969P": [
    "ZNF969P CNV",
    "ZNF969P RNA"
  ],
  "RNA5SP321": [
    "RNA5SP321 CNV",
    "RNA5SP321 RNA"
  ],
  "ZAP70": [
    "ZAP70 CNV",
    "ZAP70 RNA",
    "ZAP70 Proteo"
  ],
  "BMS1": [
    "BMS1 CNV",
    "BMS1 RNA",
    "BMS1 Proteo"
  ],
  "TDRD9": [
    "TDRD9 CNV",
    "TDRD9 RNA"
  ],
  "BCOR": [
    "BCOR CNV",
    "BCOR RNA",
    "BCOR Proteo"
  ],
  "PHOX2B": [
    "PHOX2B CNV",
    "PHOX2B RNA",
    "PHOX2B Proteo"
  ],
  "STX17": [
    "STX17 CNV",
    "STX17 RNA",
    "STX17 Proteo"
  ],
  "ARL6IP1": [
    "ARL6IP1 CNV",
    "ARL6IP1 RNA"
  ],
  "ADRA2B": [
    "ADRA2B CNV",
    "ADRA2B RNA"
  ],
  "RPL5P7": [
    "RPL5P7 CNV",
    "RPL5P7 RNA"
  ],
  "FRMD7": [
    "FRMD7 CNV",
    "FRMD7 RNA"
  ],
  "ANKAR": [
    "ANKAR CNV",
    "ANKAR RNA"
  ],
  "SMIM40": [
    "SMIM40 CNV",
    "SMIM40 RNA"
  ],
  "EEFSEC": [
    "EEFSEC CNV",
    "EEFSEC RNA",
    "EEFSEC Proteo"
  ],
  "TTTY11": [
    "TTTY11 CNV",
    "TTTY11 RNA"
  ],
  "IRX1": [
    "IRX1 CNV",
    "IRX1 RNA"
  ],
  "APOOP4": [
    "APOOP4 CNV",
    "APOOP4 RNA"
  ],
  "SCYGR4": [
    "SCYGR4 CNV",
    "SCYGR4 RNA"
  ],
  "OTUB1": [
    "OTUB1 CNV",
    "OTUB1 RNA",
    "OTUB1 Proteo"
  ],
  "SYNE4": [
    "SYNE4 CNV",
    "SYNE4 RNA"
  ],
  "CLEC3B": [
    "CLEC3B CNV",
    "CLEC3B RNA",
    "CLEC3B Proteo"
  ],
  "PCNAP4": [
    "PCNAP4 CNV",
    "PCNAP4 RNA"
  ],
  "ZNF501": [
    "ZNF501 CNV",
    "ZNF501 RNA",
    "ZNF501 Proteo"
  ],
  "SFT2D1": [
    "SFT2D1 CNV",
    "SFT2D1 RNA",
    "SFT2D1 Proteo"
  ],
  "C18orf63": [
    "C18orf63 CNV",
    "C18orf63 RNA"
  ],
  "RNF11": [
    "RNF11 CNV",
    "RNF11 RNA",
    "RNF11 Proteo"
  ],
  "ANXA1": [
    "ANXA1 CNV",
    "ANXA1 RNA",
    "ANXA1 Proteo"
  ],
  "RPS20": [
    "RPS20 CNV",
    "RPS20 RNA",
    "RPS20 Proteo"
  ],
  "ZFP82": [
    "ZFP82 CNV",
    "ZFP82 RNA",
    "ZFP82 Proteo"
  ],
  "ARL6IP1P2": [
    "ARL6IP1P2 CNV",
    "ARL6IP1P2 RNA"
  ],
  "PODN": [
    "PODN CNV",
    "PODN RNA",
    "PODN Proteo"
  ],
  "TUBB": [
    "TUBB CNV",
    "TUBB RNA",
    "TUBB Proteo"
  ],
  "ODF3": [
    "ODF3 CNV",
    "ODF3 RNA"
  ],
  "ARPIN": [
    "ARPIN CNV",
    "ARPIN RNA",
    "ARPIN Proteo"
  ],
  "OR2W6P": [
    "OR2W6P CNV",
    "OR2W6P RNA"
  ],
  "RING1": [
    "RING1 CNV",
    "RING1 RNA",
    "RING1 Proteo"
  ],
  "CYCSP26": [
    "CYCSP26 CNV",
    "CYCSP26 RNA"
  ],
  "NLRP5": [
    "NLRP5 CNV",
    "NLRP5 RNA"
  ],
  "LEFTY3P": [
    "LEFTY3P CNV",
    "LEFTY3P RNA"
  ],
  "NKIRAS1": [
    "NKIRAS1 CNV",
    "NKIRAS1 RNA",
    "NKIRAS1 Proteo"
  ],
  "RDM1P3": [
    "RDM1P3 CNV",
    "RDM1P3 RNA"
  ],
  "TRAF2": [
    "TRAF2 CNV",
    "TRAF2 RNA",
    "TRAF2 Proteo"
  ],
  "RPS6KA6": [
    "RPS6KA6 CNV",
    "RPS6KA6 RNA"
  ],
  "GAPDHP26": [
    "GAPDHP26 CNV",
    "GAPDHP26 RNA"
  ],
  "ZNF346": [
    "ZNF346 CNV",
    "ZNF346 RNA",
    "ZNF346 Proteo"
  ],
  "PPIAL4G": [
    "PPIAL4G CNV",
    "PPIAL4G RNA"
  ],
  "SIKE1": [
    "SIKE1 CNV",
    "SIKE1 RNA",
    "SIKE1 Proteo"
  ],
  "RIBC2": [
    "RIBC2 CNV",
    "RIBC2 RNA"
  ],
  "MOB1AP2": [
    "MOB1AP2 CNV",
    "MOB1AP2 RNA"
  ],
  "XAGE1A": [
    "XAGE1A CNV",
    "XAGE1A RNA",
    "XAGE1A Proteo"
  ],
  "UBQLNL": [
    "UBQLNL CNV",
    "UBQLNL RNA"
  ],
  "ADH1B": [
    "ADH1B CNV",
    "ADH1B RNA",
    "ADH1B Proteo"
  ],
  "MITD1": [
    "MITD1 CNV",
    "MITD1 RNA",
    "MITD1 Proteo"
  ],
  "EIF2S2P6": [
    "EIF2S2P6 CNV",
    "EIF2S2P6 RNA"
  ],
  "MTFR2P2": [
    "MTFR2P2 CNV",
    "MTFR2P2 RNA"
  ],
  "PBRM1": [
    "PBRM1 CNV",
    "PBRM1 RNA",
    "PBRM1 Proteo"
  ],
  "MTIF3": [
    "MTIF3 CNV",
    "MTIF3 RNA",
    "MTIF3 Proteo"
  ],
  "KAT14": [
    "KAT14 CNV",
    "KAT14 RNA",
    "KAT14 Proteo"
  ],
  "ARHGAP15": [
    "ARHGAP15 CNV",
    "ARHGAP15 RNA",
    "ARHGAP15 Proteo"
  ],
  "CCL1": [
    "CCL1 CNV",
    "CCL1 RNA"
  ],
  "ZNF407": [
    "ZNF407 CNV",
    "ZNF407 RNA",
    "ZNF407 Proteo"
  ],
  "APOL4": [
    "APOL4 CNV",
    "APOL4 RNA"
  ],
  "UNC5C": [
    "UNC5C CNV",
    "UNC5C RNA",
    "UNC5C Proteo"
  ],
  "PAH": [
    "PAH CNV",
    "PAH RNA"
  ],
  "DDN": [
    "DDN CNV",
    "DDN RNA"
  ],
  "UBE2CP3": [
    "UBE2CP3 CNV",
    "UBE2CP3 RNA"
  ],
  "TCEA3": [
    "TCEA3 CNV",
    "TCEA3 RNA",
    "TCEA3 Proteo"
  ],
  "TATDN1": [
    "TATDN1 CNV",
    "TATDN1 RNA",
    "TATDN1 Proteo"
  ],
  "ZNF684": [
    "ZNF684 CNV",
    "ZNF684 RNA"
  ],
  "CCDC201": [
    "CCDC201 CNV",
    "CCDC201 RNA"
  ],
  "TNKS1BP1": [
    "TNKS1BP1 CNV",
    "TNKS1BP1 RNA",
    "TNKS1BP1 Proteo"
  ],
  "SLC52A2": [
    "SLC52A2 CNV",
    "SLC52A2 RNA",
    "SLC52A2 Proteo"
  ],
  "RPS3AP36": [
    "RPS3AP36 CNV",
    "RPS3AP36 RNA"
  ],
  "SYCN": [
    "SYCN CNV",
    "SYCN RNA"
  ],
  "SIGLEC21P": [
    "SIGLEC21P CNV",
    "SIGLEC21P RNA"
  ],
  "MED18": [
    "MED18 CNV",
    "MED18 RNA",
    "MED18 Proteo"
  ],
  "REG1B": [
    "REG1B CNV",
    "REG1B RNA"
  ],
  "CCDC192": [
    "CCDC192 CNV",
    "CCDC192 RNA"
  ],
  "MTCO3P27": [
    "MTCO3P27 CNV",
    "MTCO3P27 RNA"
  ],
  "S100A7L2": [
    "S100A7L2 CNV",
    "S100A7L2 RNA"
  ],
  "YWHAQP5": [
    "YWHAQP5 CNV",
    "YWHAQP5 RNA"
  ],
  "TDRD15": [
    "TDRD15 CNV",
    "TDRD15 RNA"
  ],
  "ZNF723": [
    "ZNF723 CNV",
    "ZNF723 RNA"
  ],
  "KDM4B": [
    "KDM4B CNV",
    "KDM4B RNA",
    "KDM4B Proteo"
  ],
  "CACNA1D": [
    "CACNA1D CNV",
    "CACNA1D RNA"
  ],
  "MRPL48": [
    "MRPL48 CNV",
    "MRPL48 RNA",
    "MRPL48 Proteo"
  ],
  "GCC1": [
    "GCC1 CNV",
    "GCC1 RNA",
    "GCC1 Proteo"
  ],
  "TAF11": [
    "TAF11 CNV",
    "TAF11 RNA",
    "TAF11 Proteo"
  ],
  "HNRNPA1P58": [
    "HNRNPA1P58 CNV",
    "HNRNPA1P58 RNA"
  ],
  "PSORS1C1": [
    "PSORS1C1 CNV",
    "PSORS1C1 RNA"
  ],
  "PDE9A": [
    "PDE9A CNV",
    "PDE9A RNA",
    "PDE9A Proteo"
  ],
  "OR5W2": [
    "OR5W2 CNV",
    "OR5W2 RNA"
  ],
  "SPAST": [
    "SPAST CNV",
    "SPAST RNA",
    "SPAST Proteo"
  ],
  "PRSS37": [
    "PRSS37 CNV",
    "PRSS37 RNA"
  ],
  "KRT18P22": [
    "KRT18P22 CNV",
    "KRT18P22 RNA"
  ],
  "SEPHS1P4": [
    "SEPHS1P4 CNV",
    "SEPHS1P4 RNA"
  ],
  "SOCS6": [
    "SOCS6 CNV",
    "SOCS6 RNA",
    "SOCS6 Proteo"
  ],
  "ZNF317": [
    "ZNF317 CNV",
    "ZNF317 RNA",
    "ZNF317 Proteo"
  ],
  "CKB": [
    "CKB CNV",
    "CKB RNA",
    "CKB Proteo"
  ],
  "UQCRH": [
    "UQCRH CNV",
    "UQCRH RNA",
    "UQCRH Proteo"
  ],
  "TNFRSF25": [
    "TNFRSF25 CNV",
    "TNFRSF25 RNA"
  ],
  "FAAHP1": [
    "FAAHP1 CNV",
    "FAAHP1 RNA"
  ],
  "RPL21P116": [
    "RPL21P116 CNV",
    "RPL21P116 RNA"
  ],
  "OR5AK4P": [
    "OR5AK4P CNV",
    "OR5AK4P RNA"
  ],
  "GPAT3": [
    "GPAT3 CNV",
    "GPAT3 RNA",
    "GPAT3 Proteo"
  ],
  "PRKD1": [
    "PRKD1 CNV",
    "PRKD1 RNA",
    "PRKD1 Proteo"
  ],
  "H3P17": [
    "H3P17 CNV",
    "H3P17 RNA"
  ],
  "MTND3P17": [
    "MTND3P17 CNV",
    "MTND3P17 RNA"
  ],
  "RELA": [
    "RELA CNV",
    "RELA RNA",
    "RELA Proteo"
  ],
  "ST6GALNAC1": [
    "ST6GALNAC1 CNV",
    "ST6GALNAC1 RNA",
    "ST6GALNAC1 Proteo"
  ],
  "NDUFAF2P1": [
    "NDUFAF2P1 CNV",
    "NDUFAF2P1 RNA"
  ],
  "SCAF4": [
    "SCAF4 CNV",
    "SCAF4 RNA",
    "SCAF4 Proteo"
  ],
  "BPIFB2": [
    "BPIFB2 CNV",
    "BPIFB2 RNA"
  ],
  "SIGLEC18P": [
    "SIGLEC18P CNV",
    "SIGLEC18P RNA"
  ],
  "ADA": [
    "ADA CNV",
    "ADA RNA",
    "ADA Proteo"
  ],
  "MLANA": [
    "MLANA CNV",
    "MLANA RNA",
    "MLANA Proteo"
  ],
  "AMDHD1": [
    "AMDHD1 CNV",
    "AMDHD1 RNA"
  ],
  "FAM218BP": [
    "FAM218BP CNV",
    "FAM218BP RNA"
  ],
  "SUMO1P1": [
    "SUMO1P1 CNV",
    "SUMO1P1 RNA"
  ],
  "ENPP7P10": [
    "ENPP7P10 CNV",
    "ENPP7P10 RNA"
  ],
  "AGGF1P9": [
    "AGGF1P9 CNV",
    "AGGF1P9 RNA"
  ],
  "AGGF1P4": [
    "AGGF1P4 CNV",
    "AGGF1P4 RNA"
  ],
  "KIAA1549L": [
    "KIAA1549L CNV",
    "KIAA1549L RNA",
    "KIAA1549L Proteo"
  ],
  "PPFIA2": [
    "PPFIA2 CNV",
    "PPFIA2 RNA",
    "PPFIA2 Proteo"
  ],
  "KLRK1": [
    "KLRK1 CNV",
    "KLRK1 RNA"
  ],
  "KRT34": [
    "KRT34 CNV",
    "KRT34 RNA"
  ],
  "ING1": [
    "ING1 CNV",
    "ING1 RNA",
    "ING1 Proteo"
  ],
  "CD200R1": [
    "CD200R1 CNV",
    "CD200R1 RNA",
    "CD200R1 Proteo"
  ],
  "OR8A1": [
    "OR8A1 CNV",
    "OR8A1 RNA"
  ],
  "MAGED1": [
    "MAGED1 CNV",
    "MAGED1 RNA",
    "MAGED1 Proteo"
  ],
  "TMEM14EP": [
    "TMEM14EP CNV",
    "TMEM14EP RNA"
  ],
  "TWNK": [
    "TWNK CNV",
    "TWNK RNA",
    "TWNK Proteo"
  ],
  "MKRN5P": [
    "MKRN5P CNV",
    "MKRN5P RNA"
  ],
  "AGFG1": [
    "AGFG1 CNV",
    "AGFG1 RNA",
    "AGFG1 Proteo"
  ],
  "P2RX2": [
    "P2RX2 CNV",
    "P2RX2 RNA"
  ],
  "PPIAP64": [
    "PPIAP64 CNV",
    "PPIAP64 RNA"
  ],
  "CATSPER4": [
    "CATSPER4 CNV",
    "CATSPER4 RNA"
  ],
  "PYY2": [
    "PYY2 CNV",
    "PYY2 RNA"
  ],
  "SETP16": [
    "SETP16 CNV",
    "SETP16 RNA"
  ],
  "COTL1P2": [
    "COTL1P2 CNV",
    "COTL1P2 RNA"
  ],
  "RPL7AP24": [
    "RPL7AP24 CNV",
    "RPL7AP24 RNA"
  ],
  "PTPN2": [
    "PTPN2 CNV",
    "PTPN2 RNA",
    "PTPN2 Proteo"
  ],
  "BUD23": [
    "BUD23 CNV",
    "BUD23 RNA",
    "BUD23 Proteo"
  ],
  "CYCSP27": [
    "CYCSP27 CNV",
    "CYCSP27 RNA"
  ],
  "CT47A6": [
    "CT47A6 CNV",
    "CT47A6 RNA"
  ],
  "DUSP5": [
    "DUSP5 CNV",
    "DUSP5 RNA"
  ],
  "OR7E100P": [
    "OR7E100P CNV",
    "OR7E100P RNA"
  ],
  "MTND2P14": [
    "MTND2P14 CNV",
    "MTND2P14 RNA"
  ],
  "ZNF847P": [
    "ZNF847P CNV",
    "ZNF847P RNA"
  ],
  "IMPG1": [
    "IMPG1 CNV",
    "IMPG1 RNA"
  ],
  "SERPINB10": [
    "SERPINB10 CNV",
    "SERPINB10 RNA",
    "SERPINB10 Proteo"
  ],
  "ARHGEF3": [
    "ARHGEF3 CNV",
    "ARHGEF3 RNA",
    "ARHGEF3 Proteo"
  ],
  "IL18": [
    "IL18 CNV",
    "IL18 RNA",
    "IL18 Proteo"
  ],
  "OR1C1": [
    "OR1C1 CNV",
    "OR1C1 RNA"
  ],
  "C17orf75": [
    "C17orf75 CNV",
    "C17orf75 RNA",
    "C17orf75 Proteo"
  ],
  "SOCS4": [
    "SOCS4 CNV",
    "SOCS4 RNA"
  ],
  "LAMB1": [
    "LAMB1 CNV",
    "LAMB1 RNA",
    "LAMB1 Proteo"
  ],
  "SGSM1": [
    "SGSM1 CNV",
    "SGSM1 RNA"
  ],
  "PITPNB": [
    "PITPNB CNV",
    "PITPNB RNA",
    "PITPNB Proteo"
  ],
  "KRTAP1-5": [
    "KRTAP1-5 CNV",
    "KRTAP1-5 RNA"
  ],
  "DNAJA1P1": [
    "DNAJA1P1 CNV",
    "DNAJA1P1 RNA"
  ],
  "CFL1P3": [
    "CFL1P3 CNV",
    "CFL1P3 RNA"
  ],
  "MCC": [
    "MCC CNV",
    "MCC RNA",
    "MCC Proteo"
  ],
  "KIAA0100": [
    "KIAA0100 CNV",
    "KIAA0100 RNA",
    "KIAA0100 Proteo"
  ],
  "SLC38A11": [
    "SLC38A11 CNV",
    "SLC38A11 RNA"
  ],
  "SEC11A": [
    "SEC11A CNV",
    "SEC11A RNA",
    "SEC11A Proteo"
  ],
  "ZNF607": [
    "ZNF607 CNV",
    "ZNF607 RNA"
  ],
  "MAST3": [
    "MAST3 CNV",
    "MAST3 RNA",
    "MAST3 Proteo"
  ],
  "FAM131C": [
    "FAM131C CNV",
    "FAM131C RNA"
  ],
  "RNA5SP197": [
    "RNA5SP197 CNV",
    "RNA5SP197 RNA"
  ],
  "CSNK2A1": [
    "CSNK2A1 CNV",
    "CSNK2A1 RNA",
    "CSNK2A1 Proteo"
  ],
  "MAL": [
    "MAL CNV",
    "MAL RNA"
  ],
  "FRMD6": [
    "FRMD6 CNV",
    "FRMD6 RNA",
    "FRMD6 Proteo"
  ],
  "GAPDHP36": [
    "GAPDHP36 CNV",
    "GAPDHP36 RNA"
  ],
  "TRAM1L1": [
    "TRAM1L1 CNV",
    "TRAM1L1 RNA"
  ],
  "COPB1": [
    "COPB1 CNV",
    "COPB1 RNA",
    "COPB1 Proteo"
  ],
  "SNRPGP10": [
    "SNRPGP10 CNV",
    "SNRPGP10 RNA"
  ],
  "A4GALT": [
    "A4GALT CNV",
    "A4GALT RNA"
  ],
  "TEX28P1": [
    "TEX28P1 CNV",
    "TEX28P1 RNA"
  ],
  "MAGEA9": [
    "MAGEA9 CNV",
    "MAGEA9 RNA",
    "MAGEA9 Proteo"
  ],
  "ODAM": [
    "ODAM CNV",
    "ODAM RNA"
  ],
  "STRN4": [
    "STRN4 CNV",
    "STRN4 RNA",
    "STRN4 Proteo"
  ],
  "CD276": [
    "CD276 CNV",
    "CD276 RNA",
    "CD276 Proteo"
  ],
  "OR7E85BP": [
    "OR7E85BP CNV",
    "OR7E85BP RNA"
  ],
  "STAU2": [
    "STAU2 CNV",
    "STAU2 RNA",
    "STAU2 Proteo"
  ],
  "ASB16": [
    "ASB16 CNV",
    "ASB16 RNA"
  ],
  "GPM6A": [
    "GPM6A CNV",
    "GPM6A RNA",
    "GPM6A Proteo"
  ],
  "OR4S2": [
    "OR4S2 CNV",
    "OR4S2 RNA"
  ],
  "MYOG": [
    "MYOG CNV",
    "MYOG RNA"
  ],
  "MARK2P16": [
    "MARK2P16 CNV",
    "MARK2P16 RNA"
  ],
  "TDGF1P2": [
    "TDGF1P2 CNV",
    "TDGF1P2 RNA"
  ],
  "NAP1L4P3": [
    "NAP1L4P3 CNV",
    "NAP1L4P3 RNA"
  ],
  "RPL12P34": [
    "RPL12P34 CNV",
    "RPL12P34 RNA"
  ],
  "TTI1": [
    "TTI1 CNV",
    "TTI1 RNA",
    "TTI1 Proteo"
  ],
  "RBM7P1": [
    "RBM7P1 CNV",
    "RBM7P1 RNA"
  ],
  "SPRY3": [
    "SPRY3 CNV",
    "SPRY3 RNA"
  ],
  "TEDDM1": [
    "TEDDM1 CNV",
    "TEDDM1 RNA"
  ],
  "RNF166": [
    "RNF166 CNV",
    "RNF166 RNA",
    "RNF166 Proteo"
  ],
  "RNA5SP501": [
    "RNA5SP501 CNV",
    "RNA5SP501 RNA"
  ],
  "LRCH4": [
    "LRCH4 CNV",
    "LRCH4 RNA",
    "LRCH4 Proteo"
  ],
  "SEPTIN7P5": [
    "SEPTIN7P5 CNV",
    "SEPTIN7P5 RNA"
  ],
  "ZER1": [
    "ZER1 CNV",
    "ZER1 RNA",
    "ZER1 Proteo"
  ],
  "PCDH9": [
    "PCDH9 CNV",
    "PCDH9 RNA",
    "PCDH9 Proteo"
  ],
  "RPL5P10": [
    "RPL5P10 CNV",
    "RPL5P10 RNA"
  ],
  "HNRNPDLP3": [
    "HNRNPDLP3 CNV",
    "HNRNPDLP3 RNA"
  ],
  "JAK2": [
    "JAK2 CNV",
    "JAK2 RNA",
    "JAK2 Proteo"
  ],
  "TFF2": [
    "TFF2 CNV",
    "TFF2 RNA"
  ],
  "SLC47A1P1": [
    "SLC47A1P1 CNV",
    "SLC47A1P1 RNA"
  ],
  "ZNF736P3Y": [
    "ZNF736P3Y CNV",
    "ZNF736P3Y RNA"
  ],
  "WFDC10B": [
    "WFDC10B CNV",
    "WFDC10B RNA"
  ],
  "EGLN1P1": [
    "EGLN1P1 CNV",
    "EGLN1P1 RNA"
  ],
  "MAP6D1": [
    "MAP6D1 CNV",
    "MAP6D1 RNA",
    "MAP6D1 Proteo"
  ],
  "RCC2P3": [
    "RCC2P3 CNV",
    "RCC2P3 RNA"
  ],
  "HEATR4": [
    "HEATR4 CNV",
    "HEATR4 RNA"
  ],
  "CXXC1": [
    "CXXC1 CNV",
    "CXXC1 RNA",
    "CXXC1 Proteo"
  ],
  "OR10AK1P": [
    "OR10AK1P CNV",
    "OR10AK1P RNA"
  ],
  "DUOXA1": [
    "DUOXA1 CNV",
    "DUOXA1 RNA"
  ],
  "ELOCP35": [
    "ELOCP35 CNV",
    "ELOCP35 RNA"
  ],
  "TFF3": [
    "TFF3 CNV",
    "TFF3 RNA",
    "TFF3 Proteo"
  ],
  "IFITM3P1": [
    "IFITM3P1 CNV",
    "IFITM3P1 RNA"
  ],
  "FOXL2NB": [
    "FOXL2NB CNV",
    "FOXL2NB RNA"
  ],
  "MRAP2": [
    "MRAP2 CNV",
    "MRAP2 RNA"
  ],
  "IL1RN": [
    "IL1RN CNV",
    "IL1RN RNA",
    "IL1RN Proteo"
  ],
  "RPL17P34": [
    "RPL17P34 CNV",
    "RPL17P34 RNA"
  ],
  "H3P46": [
    "H3P46 CNV",
    "H3P46 RNA"
  ],
  "CDC27P3": [
    "CDC27P3 CNV",
    "CDC27P3 RNA"
  ],
  "GTF3C6P1": [
    "GTF3C6P1 CNV",
    "GTF3C6P1 RNA"
  ],
  "RBMY2HP": [
    "RBMY2HP CNV",
    "RBMY2HP RNA"
  ],
  "ERCC4": [
    "ERCC4 CNV",
    "ERCC4 RNA",
    "ERCC4 Proteo"
  ],
  "SLC6A12": [
    "SLC6A12 CNV",
    "SLC6A12 RNA"
  ],
  "TNFSF13": [
    "TNFSF13 CNV",
    "TNFSF13 RNA"
  ],
  "FCRL5": [
    "FCRL5 CNV",
    "FCRL5 RNA",
    "FCRL5 Proteo"
  ],
  "MBD3L2": [
    "MBD3L2 CNV",
    "MBD3L2 RNA"
  ],
  "NDUFB8P2": [
    "NDUFB8P2 CNV",
    "NDUFB8P2 RNA"
  ],
  "GALNS": [
    "GALNS CNV",
    "GALNS RNA",
    "GALNS Proteo"
  ],
  "DYNC1I1": [
    "DYNC1I1 CNV",
    "DYNC1I1 RNA",
    "DYNC1I1 Proteo"
  ],
  "CACUL1": [
    "CACUL1 CNV",
    "CACUL1 RNA",
    "CACUL1 Proteo"
  ],
  "GSTK1": [
    "GSTK1 CNV",
    "GSTK1 RNA",
    "GSTK1 Proteo"
  ],
  "CDY17P": [
    "CDY17P CNV",
    "CDY17P RNA"
  ],
  "GPX8": [
    "GPX8 CNV",
    "GPX8 RNA",
    "GPX8 Proteo"
  ],
  "HSD3BP1": [
    "HSD3BP1 CNV",
    "HSD3BP1 RNA"
  ],
  "TMEM231": [
    "TMEM231 CNV",
    "TMEM231 RNA",
    "TMEM231 Proteo"
  ],
  "LZTS2": [
    "LZTS2 CNV",
    "LZTS2 RNA",
    "LZTS2 Proteo"
  ],
  "CCR8": [
    "CCR8 CNV",
    "CCR8 RNA"
  ],
  "CYP4F62P": [
    "CYP4F62P CNV",
    "CYP4F62P RNA"
  ],
  "CEP164": [
    "CEP164 CNV",
    "CEP164 RNA",
    "CEP164 Proteo"
  ],
  "TEX101": [
    "TEX101 CNV",
    "TEX101 RNA"
  ],
  "DES": [
    "DES CNV",
    "DES RNA",
    "DES Proteo"
  ],
  "TMED2": [
    "TMED2 CNV",
    "TMED2 RNA",
    "TMED2 Proteo"
  ],
  "TAF1D": [
    "TAF1D CNV",
    "TAF1D RNA",
    "TAF1D Proteo"
  ],
  "MRTO4": [
    "MRTO4 CNV",
    "MRTO4 RNA",
    "MRTO4 Proteo"
  ],
  "ZNF718": [
    "ZNF718 CNV",
    "ZNF718 RNA"
  ],
  "STK31": [
    "STK31 CNV",
    "STK31 RNA"
  ],
  "UBXN2B": [
    "UBXN2B CNV",
    "UBXN2B RNA",
    "UBXN2B Proteo"
  ],
  "SLIT3": [
    "SLIT3 CNV",
    "SLIT3 RNA",
    "SLIT3 Proteo"
  ],
  "TXNP5": [
    "TXNP5 CNV",
    "TXNP5 RNA"
  ],
  "ALDH5A1": [
    "ALDH5A1 CNV",
    "ALDH5A1 RNA",
    "ALDH5A1 Proteo"
  ],
  "EEF1A1P16": [
    "EEF1A1P16 CNV",
    "EEF1A1P16 RNA"
  ],
  "CASP7": [
    "CASP7 CNV",
    "CASP7 RNA",
    "CASP7 Proteo"
  ],
  "CTSZ": [
    "CTSZ CNV",
    "CTSZ RNA",
    "CTSZ Proteo"
  ],
  "ELOCP10": [
    "ELOCP10 CNV",
    "ELOCP10 RNA"
  ],
  "PTP4A1": [
    "PTP4A1 CNV",
    "PTP4A1 RNA",
    "PTP4A1 Proteo"
  ],
  "LCA5L": [
    "LCA5L CNV",
    "LCA5L RNA"
  ],
  "CYLC2": [
    "CYLC2 CNV",
    "CYLC2 RNA"
  ],
  "MKS1": [
    "MKS1 CNV",
    "MKS1 RNA",
    "MKS1 Proteo"
  ],
  "SLC30A4": [
    "SLC30A4 CNV",
    "SLC30A4 RNA",
    "SLC30A4 Proteo"
  ],
  "KIF5C": [
    "KIF5C CNV",
    "KIF5C RNA",
    "KIF5C Proteo"
  ],
  "HMGB3P5": [
    "HMGB3P5 CNV",
    "HMGB3P5 RNA"
  ],
  "DCLRE1B": [
    "DCLRE1B CNV",
    "DCLRE1B RNA",
    "DCLRE1B Proteo"
  ],
  "MRPS10": [
    "MRPS10 CNV",
    "MRPS10 RNA",
    "MRPS10 Proteo"
  ],
  "TCP1P1": [
    "TCP1P1 CNV",
    "TCP1P1 RNA"
  ],
  "CDH19": [
    "CDH19 CNV",
    "CDH19 RNA",
    "CDH19 Proteo"
  ],
  "ZNF224": [
    "ZNF224 CNV",
    "ZNF224 RNA"
  ],
  "FLVCR1": [
    "FLVCR1 CNV",
    "FLVCR1 RNA",
    "FLVCR1 Proteo"
  ],
  "ATP6V0A1": [
    "ATP6V0A1 CNV",
    "ATP6V0A1 RNA",
    "ATP6V0A1 Proteo"
  ],
  "AQP8": [
    "AQP8 CNV",
    "AQP8 RNA"
  ],
  "FKBP1AP4": [
    "FKBP1AP4 CNV",
    "FKBP1AP4 RNA"
  ],
  "SERPINH1": [
    "SERPINH1 CNV",
    "SERPINH1 RNA",
    "SERPINH1 Proteo"
  ],
  "HRNR": [
    "HRNR CNV",
    "HRNR RNA",
    "HRNR Proteo"
  ],
  "GUCY2GP": [
    "GUCY2GP CNV",
    "GUCY2GP RNA"
  ],
  "ARPC3P1": [
    "ARPC3P1 CNV",
    "ARPC3P1 RNA"
  ],
  "FZD10": [
    "FZD10 CNV",
    "FZD10 RNA"
  ],
  "ULK4P1": [
    "ULK4P1 CNV",
    "ULK4P1 RNA"
  ],
  "INSL6": [
    "INSL6 CNV",
    "INSL6 RNA"
  ],
  "PLA2G12A": [
    "PLA2G12A CNV",
    "PLA2G12A RNA",
    "PLA2G12A Proteo"
  ],
  "GDF3": [
    "GDF3 CNV",
    "GDF3 RNA"
  ],
  "NACAP7": [
    "NACAP7 CNV",
    "NACAP7 RNA"
  ],
  "H2AW": [
    "H2AW CNV",
    "H2AW RNA"
  ],
  "DLGAP4": [
    "DLGAP4 CNV",
    "DLGAP4 RNA",
    "DLGAP4 Proteo"
  ],
  "ATRAID": [
    "ATRAID CNV",
    "ATRAID RNA",
    "ATRAID Proteo"
  ],
  "UBE2D4": [
    "UBE2D4 CNV",
    "UBE2D4 RNA",
    "UBE2D4 Proteo"
  ],
  "NPM1P32": [
    "NPM1P32 CNV",
    "NPM1P32 RNA"
  ],
  "DAOA": [
    "DAOA CNV",
    "DAOA RNA"
  ],
  "TRIM63": [
    "TRIM63 CNV",
    "TRIM63 RNA",
    "TRIM63 Proteo"
  ],
  "OR7E108P": [
    "OR7E108P CNV",
    "OR7E108P RNA"
  ],
  "HSPE1P1": [
    "HSPE1P1 CNV",
    "HSPE1P1 RNA"
  ],
  "WDR74": [
    "WDR74 CNV",
    "WDR74 RNA",
    "WDR74 Proteo"
  ],
  "RAMACL": [
    "RAMACL CNV",
    "RAMACL RNA"
  ],
  "ELF2P1": [
    "ELF2P1 CNV",
    "ELF2P1 RNA"
  ],
  "MITF": [
    "MITF CNV",
    "MITF RNA",
    "MITF Proteo"
  ],
  "PCDHA3": [
    "PCDHA3 CNV",
    "PCDHA3 RNA"
  ],
  "GPRIN1": [
    "GPRIN1 CNV",
    "GPRIN1 RNA",
    "GPRIN1 Proteo"
  ],
  "PPIAP38": [
    "PPIAP38 CNV",
    "PPIAP38 RNA"
  ],
  "SUMO1P3": [
    "SUMO1P3 CNV",
    "SUMO1P3 RNA"
  ],
  "HNRNPCL2": [
    "HNRNPCL2 CNV",
    "HNRNPCL2 RNA"
  ],
  "TRIM56": [
    "TRIM56 CNV",
    "TRIM56 RNA",
    "TRIM56 Proteo"
  ],
  "GYG2P1": [
    "GYG2P1 CNV",
    "GYG2P1 RNA"
  ],
  "AGXT": [
    "AGXT CNV",
    "AGXT RNA"
  ],
  "ADPRM": [
    "ADPRM CNV",
    "ADPRM RNA"
  ],
  "CENPH": [
    "CENPH CNV",
    "CENPH RNA",
    "CENPH Proteo"
  ],
  "MEI1": [
    "MEI1 CNV",
    "MEI1 RNA"
  ],
  "FTH1P7": [
    "FTH1P7 CNV",
    "FTH1P7 RNA"
  ],
  "WRN": [
    "WRN CNV",
    "WRN RNA",
    "WRN Proteo"
  ],
  "C2orf69": [
    "C2orf69 CNV",
    "C2orf69 RNA",
    "C2orf69 Proteo"
  ],
  "KCTD8": [
    "KCTD8 CNV",
    "KCTD8 RNA"
  ],
  "OLA1P3": [
    "OLA1P3 CNV",
    "OLA1P3 RNA"
  ],
  "CD1B": [
    "CD1B CNV",
    "CD1B RNA",
    "CD1B Proteo"
  ],
  "BTN3A1": [
    "BTN3A1 CNV",
    "BTN3A1 RNA",
    "BTN3A1 Proteo"
  ],
  "PPIG": [
    "PPIG CNV",
    "PPIG RNA",
    "PPIG Proteo"
  ],
  "LILRP2": [
    "LILRP2 CNV",
    "LILRP2 RNA"
  ],
  "SBK3": [
    "SBK3 CNV",
    "SBK3 RNA"
  ],
  "PTGES3P4": [
    "PTGES3P4 CNV",
    "PTGES3P4 RNA"
  ],
  "KRTAP4-6": [
    "KRTAP4-6 CNV",
    "KRTAP4-6 RNA"
  ],
  "TXNP2": [
    "TXNP2 CNV",
    "TXNP2 RNA"
  ],
  "NPIPB6": [
    "NPIPB6 CNV",
    "NPIPB6 RNA"
  ],
  "FCN2": [
    "FCN2 CNV",
    "FCN2 RNA",
    "FCN2 Proteo"
  ],
  "DAB2IP": [
    "DAB2IP CNV",
    "DAB2IP RNA",
    "DAB2IP Proteo"
  ],
  "ZFP30": [
    "ZFP30 CNV",
    "ZFP30 RNA",
    "ZFP30 Proteo"
  ],
  "RPL21P129": [
    "RPL21P129 CNV",
    "RPL21P129 RNA"
  ],
  "WIPF3": [
    "WIPF3 CNV",
    "WIPF3 RNA",
    "WIPF3 Proteo"
  ],
  "MFSD4BP1": [
    "MFSD4BP1 CNV",
    "MFSD4BP1 RNA"
  ],
  "GSX2": [
    "GSX2 CNV",
    "GSX2 RNA"
  ],
  "SRP68": [
    "SRP68 CNV",
    "SRP68 RNA",
    "SRP68 Proteo"
  ],
  "ARF4P4": [
    "ARF4P4 CNV",
    "ARF4P4 RNA"
  ],
  "OR10R2": [
    "OR10R2 CNV",
    "OR10R2 RNA"
  ],
  "BNIP3P39": [
    "BNIP3P39 CNV",
    "BNIP3P39 RNA"
  ],
  "RBM3": [
    "RBM3 CNV",
    "RBM3 RNA",
    "RBM3 Proteo"
  ],
  "BTF3P5": [
    "BTF3P5 CNV",
    "BTF3P5 RNA"
  ],
  "PYGL": [
    "PYGL CNV",
    "PYGL RNA",
    "PYGL Proteo"
  ],
  "MYH3": [
    "MYH3 CNV",
    "MYH3 RNA"
  ],
  "USP17L17": [
    "USP17L17 CNV",
    "USP17L17 RNA"
  ],
  "TSTD2": [
    "TSTD2 CNV",
    "TSTD2 RNA",
    "TSTD2 Proteo"
  ],
  "ZNF395": [
    "ZNF395 CNV",
    "ZNF395 RNA"
  ],
  "MT1CP": [
    "MT1CP CNV",
    "MT1CP RNA"
  ],
  "EIF4EP2": [
    "EIF4EP2 CNV",
    "EIF4EP2 RNA"
  ],
  "LAMA3": [
    "LAMA3 CNV",
    "LAMA3 RNA",
    "LAMA3 Proteo"
  ],
  "KDM6A": [
    "KDM6A CNV",
    "KDM6A RNA",
    "KDM6A Proteo"
  ],
  "PEMT": [
    "PEMT CNV",
    "PEMT RNA",
    "PEMT Proteo"
  ],
  "ZIC4": [
    "ZIC4 CNV",
    "ZIC4 RNA"
  ],
  "CCDC74BP1": [
    "CCDC74BP1 CNV",
    "CCDC74BP1 RNA"
  ],
  "RPL37": [
    "RPL37 CNV",
    "RPL37 RNA",
    "RPL37 Proteo"
  ],
  "RPL32P12": [
    "RPL32P12 CNV",
    "RPL32P12 RNA"
  ],
  "MCF2L2": [
    "MCF2L2 CNV",
    "MCF2L2 RNA"
  ],
  "DCAF4L1": [
    "DCAF4L1 CNV",
    "DCAF4L1 RNA"
  ],
  "XIRP2": [
    "XIRP2 CNV",
    "XIRP2 RNA",
    "XIRP2 Proteo"
  ],
  "ANTXRLP1": [
    "ANTXRLP1 CNV",
    "ANTXRLP1 RNA"
  ],
  "OR7E8P": [
    "OR7E8P CNV",
    "OR7E8P RNA"
  ],
  "IFNA2": [
    "IFNA2 CNV",
    "IFNA2 RNA"
  ],
  "PPIAP78": [
    "PPIAP78 CNV",
    "PPIAP78 RNA"
  ],
  "LRRC4": [
    "LRRC4 CNV",
    "LRRC4 RNA"
  ],
  "MTATP6P2": [
    "MTATP6P2 CNV",
    "MTATP6P2 RNA"
  ],
  "KPNA2P2": [
    "KPNA2P2 CNV",
    "KPNA2P2 RNA"
  ],
  "HIGD1AP1": [
    "HIGD1AP1 CNV",
    "HIGD1AP1 RNA"
  ],
  "KLC2": [
    "KLC2 CNV",
    "KLC2 RNA",
    "KLC2 Proteo"
  ],
  "REPS1": [
    "REPS1 CNV",
    "REPS1 RNA",
    "REPS1 Proteo"
  ],
  "BIRC5": [
    "BIRC5 CNV",
    "BIRC5 RNA",
    "BIRC5 Proteo"
  ],
  "ACTR3BP5": [
    "ACTR3BP5 CNV",
    "ACTR3BP5 RNA"
  ],
  "UBE2V2": [
    "UBE2V2 CNV",
    "UBE2V2 RNA",
    "UBE2V2 Proteo"
  ],
  "DLL3": [
    "DLL3 CNV",
    "DLL3 RNA",
    "DLL3 Proteo"
  ],
  "CHPT1": [
    "CHPT1 CNV",
    "CHPT1 RNA",
    "CHPT1 Proteo"
  ],
  "PLLPP1": [
    "PLLPP1 CNV",
    "PLLPP1 RNA"
  ],
  "ANKRD26P3": [
    "ANKRD26P3 CNV",
    "ANKRD26P3 RNA"
  ],
  "ST6GALNAC5": [
    "ST6GALNAC5 CNV",
    "ST6GALNAC5 RNA"
  ],
  "CMTM8": [
    "CMTM8 CNV",
    "CMTM8 RNA"
  ],
  "KLF4": [
    "KLF4 CNV",
    "KLF4 RNA"
  ],
  "MPND": [
    "MPND CNV",
    "MPND RNA",
    "MPND Proteo"
  ],
  "MTCH1": [
    "MTCH1 CNV",
    "MTCH1 RNA",
    "MTCH1 Proteo"
  ],
  "BMP6": [
    "BMP6 CNV",
    "BMP6 RNA"
  ],
  "RPL36AP7": [
    "RPL36AP7 CNV",
    "RPL36AP7 RNA"
  ],
  "RGPD5": [
    "RGPD5 CNV",
    "RGPD5 RNA",
    "RGPD5 Proteo"
  ],
  "DEFB109D": [
    "DEFB109D CNV",
    "DEFB109D RNA"
  ],
  "ZNF260": [
    "ZNF260 CNV",
    "ZNF260 RNA"
  ],
  "RPSAP33": [
    "RPSAP33 CNV",
    "RPSAP33 RNA"
  ],
  "PIWIL4": [
    "PIWIL4 CNV",
    "PIWIL4 RNA"
  ],
  "ANO5": [
    "ANO5 CNV",
    "ANO5 RNA",
    "ANO5 Proteo"
  ],
  "E2F4P1": [
    "E2F4P1 CNV",
    "E2F4P1 RNA"
  ],
  "PSMC1P11": [
    "PSMC1P11 CNV",
    "PSMC1P11 RNA"
  ],
  "RPS24P16": [
    "RPS24P16 CNV",
    "RPS24P16 RNA"
  ],
  "BBS2": [
    "BBS2 CNV",
    "BBS2 RNA",
    "BBS2 Proteo"
  ],
  "HMGB3P32": [
    "HMGB3P32 CNV",
    "HMGB3P32 RNA"
  ],
  "CORO1CP1": [
    "CORO1CP1 CNV",
    "CORO1CP1 RNA"
  ],
  "LYG2": [
    "LYG2 CNV",
    "LYG2 RNA"
  ],
  "BBS5": [
    "BBS5 CNV",
    "BBS5 RNA"
  ],
  "SERPINA3": [
    "SERPINA3 CNV",
    "SERPINA3 RNA",
    "SERPINA3 Proteo"
  ],
  "DMRTC1B": [
    "DMRTC1B CNV",
    "DMRTC1B RNA"
  ],
  "KCNIP4": [
    "KCNIP4 CNV",
    "KCNIP4 RNA"
  ],
  "IGHV7-56": [
    "IGHV7-56 CNV",
    "IGHV7-56 RNA"
  ],
  "PCDHGB1": [
    "PCDHGB1 CNV",
    "PCDHGB1 RNA"
  ],
  "USP9YP35": [
    "USP9YP35 CNV",
    "USP9YP35 RNA"
  ],
  "EDDM13": [
    "EDDM13 CNV",
    "EDDM13 RNA"
  ],
  "EDA": [
    "EDA CNV",
    "EDA RNA"
  ],
  "SELENOM": [
    "SELENOM CNV",
    "SELENOM RNA",
    "SELENOM Proteo"
  ],
  "OR10A6": [
    "OR10A6 CNV",
    "OR10A6 RNA"
  ],
  "CEACAMP9": [
    "CEACAMP9 CNV",
    "CEACAMP9 RNA"
  ],
  "RPL23AP67": [
    "RPL23AP67 CNV",
    "RPL23AP67 RNA"
  ],
  "LDHBP3": [
    "LDHBP3 CNV",
    "LDHBP3 RNA"
  ],
  "HMGB1P13": [
    "HMGB1P13 CNV",
    "HMGB1P13 RNA"
  ],
  "RNA5SP53": [
    "RNA5SP53 CNV",
    "RNA5SP53 RNA"
  ],
  "BORCS6": [
    "BORCS6 CNV",
    "BORCS6 RNA",
    "BORCS6 Proteo"
  ],
  "ARHGAP39": [
    "ARHGAP39 CNV",
    "ARHGAP39 RNA",
    "ARHGAP39 Proteo"
  ],
  "SCG5": [
    "SCG5 CNV",
    "SCG5 RNA"
  ],
  "NAP1L6P": [
    "NAP1L6P CNV",
    "NAP1L6P RNA"
  ],
  "SPHKAP": [
    "SPHKAP CNV",
    "SPHKAP RNA"
  ],
  "RPL36AP35": [
    "RPL36AP35 CNV",
    "RPL36AP35 RNA"
  ],
  "BMS1P23": [
    "BMS1P23 CNV",
    "BMS1P23 RNA"
  ],
  "RNF38": [
    "RNF38 CNV",
    "RNF38 RNA"
  ],
  "CAPN9": [
    "CAPN9 CNV",
    "CAPN9 RNA"
  ],
  "ICE2": [
    "ICE2 CNV",
    "ICE2 RNA",
    "ICE2 Proteo"
  ],
  "SIX3": [
    "SIX3 CNV",
    "SIX3 RNA"
  ],
  "CCT7P1": [
    "CCT7P1 CNV",
    "CCT7P1 RNA"
  ],
  "RNA5SP69": [
    "RNA5SP69 CNV",
    "RNA5SP69 RNA"
  ],
  "SUMO2P16": [
    "SUMO2P16 CNV",
    "SUMO2P16 RNA"
  ],
  "TPI1P2": [
    "TPI1P2 CNV",
    "TPI1P2 RNA"
  ],
  "BSND": [
    "BSND CNV",
    "BSND RNA"
  ],
  "GGCTP1": [
    "GGCTP1 CNV",
    "GGCTP1 RNA"
  ],
  "SCGB3A1": [
    "SCGB3A1 CNV",
    "SCGB3A1 RNA"
  ],
  "MYOM3": [
    "MYOM3 CNV",
    "MYOM3 RNA"
  ],
  "JCHAIN": [
    "JCHAIN CNV",
    "JCHAIN RNA",
    "JCHAIN Proteo"
  ],
  "MPV17": [
    "MPV17 CNV",
    "MPV17 RNA",
    "MPV17 Proteo"
  ],
  "SENP7": [
    "SENP7 CNV",
    "SENP7 RNA",
    "SENP7 Proteo"
  ],
  "RNF225": [
    "RNF225 CNV",
    "RNF225 RNA"
  ],
  "DDX18P3": [
    "DDX18P3 CNV",
    "DDX18P3 RNA"
  ],
  "UBBP1": [
    "UBBP1 CNV",
    "UBBP1 RNA"
  ],
  "NAP1L3": [
    "NAP1L3 CNV",
    "NAP1L3 RNA"
  ],
  "LINC00265-3P": [
    "LINC00265-3P CNV",
    "LINC00265-3P RNA"
  ],
  "LYRM1": [
    "LYRM1 CNV",
    "LYRM1 RNA",
    "LYRM1 Proteo"
  ],
  "TFEB": [
    "TFEB CNV",
    "TFEB RNA",
    "TFEB Proteo"
  ],
  "IGLV7-35": [
    "IGLV7-35 CNV",
    "IGLV7-35 RNA"
  ],
  "CHODL": [
    "CHODL CNV",
    "CHODL RNA"
  ],
  "LVRN": [
    "LVRN CNV",
    "LVRN RNA"
  ],
  "ZNF467": [
    "ZNF467 CNV",
    "ZNF467 RNA"
  ],
  "IGHEP1": [
    "IGHEP1 CNV",
    "IGHEP1 RNA"
  ],
  "CSTB": [
    "CSTB CNV",
    "CSTB RNA",
    "CSTB Proteo"
  ],
  "MTND1P33": [
    "MTND1P33 CNV",
    "MTND1P33 RNA"
  ],
  "LRRC47": [
    "LRRC47 CNV",
    "LRRC47 RNA",
    "LRRC47 Proteo"
  ],
  "ELOVL2": [
    "ELOVL2 CNV",
    "ELOVL2 RNA",
    "ELOVL2 Proteo"
  ],
  "CFAP418": [
    "CFAP418 CNV",
    "CFAP418 RNA",
    "CFAP418 Proteo"
  ],
  "EIF4B": [
    "EIF4B CNV",
    "EIF4B RNA",
    "EIF4B Proteo"
  ],
  "MROH2A": [
    "MROH2A CNV",
    "MROH2A RNA"
  ],
  "PSMA7": [
    "PSMA7 CNV",
    "PSMA7 RNA",
    "PSMA7 Proteo"
  ],
  "NLRP1": [
    "NLRP1 CNV",
    "NLRP1 RNA",
    "NLRP1 Proteo"
  ],
  "ST13P18": [
    "ST13P18 CNV",
    "ST13P18 RNA"
  ],
  "RNA5SP514": [
    "RNA5SP514 CNV",
    "RNA5SP514 RNA"
  ],
  "NAB1": [
    "NAB1 CNV",
    "NAB1 RNA",
    "NAB1 Proteo"
  ],
  "RRP7BP": [
    "RRP7BP CNV",
    "RRP7BP RNA"
  ],
  "SLC39A9": [
    "SLC39A9 CNV",
    "SLC39A9 RNA",
    "SLC39A9 Proteo"
  ],
  "AFP": [
    "AFP CNV",
    "AFP RNA"
  ],
  "RPS15AP27": [
    "RPS15AP27 CNV",
    "RPS15AP27 RNA"
  ],
  "TLE1": [
    "TLE1 CNV",
    "TLE1 RNA",
    "TLE1 Proteo"
  ],
  "ITGAE": [
    "ITGAE CNV",
    "ITGAE RNA",
    "ITGAE Proteo"
  ],
  "ZBP1": [
    "ZBP1 CNV",
    "ZBP1 RNA",
    "ZBP1 Proteo"
  ],
  "MED26": [
    "MED26 CNV",
    "MED26 RNA",
    "MED26 Proteo"
  ],
  "SRSF6": [
    "SRSF6 CNV",
    "SRSF6 RNA",
    "SRSF6 Proteo"
  ],
  "COX6B1P1": [
    "COX6B1P1 CNV",
    "COX6B1P1 RNA"
  ],
  "KRTAP21-2": [
    "KRTAP21-2 CNV",
    "KRTAP21-2 RNA"
  ],
  "ANKRD18DP": [
    "ANKRD18DP CNV",
    "ANKRD18DP RNA"
  ],
  "CCNYL6": [
    "CCNYL6 CNV",
    "CCNYL6 RNA"
  ],
  "MTND2P39": [
    "MTND2P39 CNV",
    "MTND2P39 RNA"
  ],
  "ZNF75CP": [
    "ZNF75CP CNV",
    "ZNF75CP RNA"
  ],
  "SVIL-AS1": [
    "SVIL-AS1 CNV",
    "SVIL-AS1 RNA"
  ],
  "ZNF223": [
    "ZNF223 CNV",
    "ZNF223 RNA",
    "ZNF223 Proteo"
  ],
  "SCGB2B2": [
    "SCGB2B2 CNV",
    "SCGB2B2 RNA"
  ],
  "RPS20P31": [
    "RPS20P31 CNV",
    "RPS20P31 RNA"
  ],
  "BCRP1": [
    "BCRP1 CNV",
    "BCRP1 RNA"
  ],
  "TELO2": [
    "TELO2 CNV",
    "TELO2 RNA",
    "TELO2 Proteo"
  ],
  "SSU72P4": [
    "SSU72P4 CNV",
    "SSU72P4 RNA"
  ],
  "HSPA8P11": [
    "HSPA8P11 CNV",
    "HSPA8P11 RNA"
  ],
  "COX6A2": [
    "COX6A2 CNV",
    "COX6A2 RNA"
  ],
  "TBC1D3P6": [
    "TBC1D3P6 CNV",
    "TBC1D3P6 RNA"
  ],
  "FRG2JP": [
    "FRG2JP CNV",
    "FRG2JP RNA"
  ],
  "KIF17": [
    "KIF17 CNV",
    "KIF17 RNA"
  ],
  "ALG6": [
    "ALG6 CNV",
    "ALG6 RNA",
    "ALG6 Proteo"
  ],
  "AKAP6": [
    "AKAP6 CNV",
    "AKAP6 RNA",
    "AKAP6 Proteo"
  ],
  "SEL1L2": [
    "SEL1L2 CNV",
    "SEL1L2 RNA"
  ],
  "IPPKP1": [
    "IPPKP1 CNV",
    "IPPKP1 RNA"
  ],
  "BNIP3P6": [
    "BNIP3P6 CNV",
    "BNIP3P6 RNA"
  ],
  "MSANTD2": [
    "MSANTD2 CNV",
    "MSANTD2 RNA",
    "MSANTD2 Proteo"
  ],
  "DNAJC11": [
    "DNAJC11 CNV",
    "DNAJC11 RNA",
    "DNAJC11 Proteo"
  ],
  "JARID2": [
    "JARID2 CNV",
    "JARID2 RNA",
    "JARID2 Proteo"
  ],
  "ZBED3": [
    "ZBED3 CNV",
    "ZBED3 RNA",
    "ZBED3 Proteo"
  ],
  "PELI1": [
    "PELI1 CNV",
    "PELI1 RNA",
    "PELI1 Proteo"
  ],
  "SDC3": [
    "SDC3 CNV",
    "SDC3 RNA",
    "SDC3 Proteo"
  ],
  "TNFRSF1A": [
    "TNFRSF1A CNV",
    "TNFRSF1A RNA",
    "TNFRSF1A Proteo"
  ],
  "LGALS3": [
    "LGALS3 CNV",
    "LGALS3 RNA",
    "LGALS3 Proteo"
  ],
  "ACTBP12": [
    "ACTBP12 CNV",
    "ACTBP12 RNA"
  ],
  "CCDC62": [
    "CCDC62 CNV",
    "CCDC62 RNA"
  ],
  "FUNDC1": [
    "FUNDC1 CNV",
    "FUNDC1 RNA",
    "FUNDC1 Proteo"
  ],
  "AMZ2P3": [
    "AMZ2P3 CNV",
    "AMZ2P3 RNA"
  ],
  "SELENOTP1": [
    "SELENOTP1 CNV",
    "SELENOTP1 RNA"
  ],
  "ANKRD20A21P": [
    "ANKRD20A21P CNV",
    "ANKRD20A21P RNA"
  ],
  "ELAVL1": [
    "ELAVL1 CNV",
    "ELAVL1 RNA",
    "ELAVL1 Proteo"
  ],
  "ZNF764": [
    "ZNF764 CNV",
    "ZNF764 RNA"
  ],
  "PTP4A1P7": [
    "PTP4A1P7 CNV",
    "PTP4A1P7 RNA"
  ],
  "ADM": [
    "ADM CNV",
    "ADM RNA",
    "ADM Proteo"
  ],
  "FAM81A": [
    "FAM81A CNV",
    "FAM81A RNA"
  ],
  "RPL12P10": [
    "RPL12P10 CNV",
    "RPL12P10 RNA"
  ],
  "STRADA": [
    "STRADA CNV",
    "STRADA RNA",
    "STRADA Proteo"
  ],
  "Tumor": [
    "Tumor Cell_type"
  ],
  "KRT16": [
    "KRT16 CNV",
    "KRT16 RNA",
    "KRT16 Proteo"
  ],
  "KCNA1": [
    "KCNA1 CNV",
    "KCNA1 RNA"
  ],
  "APOOP5": [
    "APOOP5 CNV",
    "APOOP5 RNA"
  ],
  "PARP2": [
    "PARP2 CNV",
    "PARP2 RNA",
    "PARP2 Proteo"
  ],
  "MAP9": [
    "MAP9 CNV",
    "MAP9 RNA",
    "MAP9 Proteo"
  ],
  "CIR1": [
    "CIR1 CNV",
    "CIR1 RNA",
    "CIR1 Proteo"
  ],
  "TCF7L1": [
    "TCF7L1 CNV",
    "TCF7L1 RNA"
  ],
  "PDE4DIPP1": [
    "PDE4DIPP1 CNV",
    "PDE4DIPP1 RNA"
  ],
  "PIBF1": [
    "PIBF1 CNV",
    "PIBF1 RNA",
    "PIBF1 Proteo"
  ],
  "CNOT7P1": [
    "CNOT7P1 CNV",
    "CNOT7P1 RNA"
  ],
  "PIK3C3": [
    "PIK3C3 CNV",
    "PIK3C3 RNA",
    "PIK3C3 Proteo"
  ],
  "MEP1AP4": [
    "MEP1AP4 CNV",
    "MEP1AP4 RNA"
  ],
  "OR4C6": [
    "OR4C6 CNV",
    "OR4C6 RNA"
  ],
  "RPL30": [
    "RPL30 CNV",
    "RPL30 RNA",
    "RPL30 Proteo"
  ],
  "CREB3L3": [
    "CREB3L3 CNV",
    "CREB3L3 RNA"
  ],
  "C1orf122": [
    "C1orf122 CNV",
    "C1orf122 RNA",
    "C1orf122 Proteo"
  ],
  "DPY19L1": [
    "DPY19L1 CNV",
    "DPY19L1 RNA",
    "DPY19L1 Proteo"
  ],
  "ACOX3": [
    "ACOX3 CNV",
    "ACOX3 RNA",
    "ACOX3 Proteo"
  ],
  "CRYGN": [
    "CRYGN CNV",
    "CRYGN RNA"
  ],
  "SCYL1": [
    "SCYL1 CNV",
    "SCYL1 RNA",
    "SCYL1 Proteo"
  ],
  "H2AC17": [
    "H2AC17 CNV",
    "H2AC17 RNA"
  ],
  "MTCO1P30": [
    "MTCO1P30 CNV",
    "MTCO1P30 RNA"
  ],
  "CALD1": [
    "CALD1 CNV",
    "CALD1 RNA",
    "CALD1 Proteo"
  ],
  "HR": [
    "HR CNV",
    "HR RNA",
    "HR Proteo"
  ],
  "SYT16": [
    "SYT16 CNV",
    "SYT16 RNA"
  ],
  "DNAJC19P1": [
    "DNAJC19P1 CNV",
    "DNAJC19P1 RNA"
  ],
  "PYROXD2": [
    "PYROXD2 CNV",
    "PYROXD2 RNA",
    "PYROXD2 Proteo"
  ],
  "NUS1P3": [
    "NUS1P3 CNV",
    "NUS1P3 RNA"
  ],
  "MCAM": [
    "MCAM CNV",
    "MCAM RNA",
    "MCAM Proteo"
  ],
  "ZNF818P": [
    "ZNF818P CNV",
    "ZNF818P RNA"
  ],
  "OR5T3": [
    "OR5T3 CNV",
    "OR5T3 RNA"
  ],
  "UBA7": [
    "UBA7 CNV",
    "UBA7 RNA",
    "UBA7 Proteo"
  ],
  "FOXR2": [
    "FOXR2 CNV",
    "FOXR2 RNA"
  ],
  "ATP5ME": [
    "ATP5ME CNV",
    "ATP5ME RNA",
    "ATP5ME Proteo"
  ],
  "CYP4F36P": [
    "CYP4F36P CNV",
    "CYP4F36P RNA"
  ],
  "RTBDN": [
    "RTBDN CNV",
    "RTBDN RNA"
  ],
  "RPL21P1": [
    "RPL21P1 CNV",
    "RPL21P1 RNA"
  ],
  "WDR41": [
    "WDR41 CNV",
    "WDR41 RNA",
    "WDR41 Proteo"
  ],
  "MSL3": [
    "MSL3 CNV",
    "MSL3 RNA",
    "MSL3 Proteo"
  ],
  "SRSF3P2": [
    "SRSF3P2 CNV",
    "SRSF3P2 RNA"
  ],
  "NDUFV1": [
    "NDUFV1 CNV",
    "NDUFV1 RNA",
    "NDUFV1 Proteo"
  ],
  "RAP1GAP2": [
    "RAP1GAP2 CNV",
    "RAP1GAP2 RNA",
    "RAP1GAP2 Proteo"
  ],
  "RPS7P2": [
    "RPS7P2 CNV",
    "RPS7P2 RNA"
  ],
  "RPS19": [
    "RPS19 CNV",
    "RPS19 RNA",
    "RPS19 Proteo"
  ],
  "DNM1P28": [
    "DNM1P28 CNV",
    "DNM1P28 RNA"
  ],
  "RPL26P3": [
    "RPL26P3 CNV",
    "RPL26P3 RNA"
  ],
  "POLR3G": [
    "POLR3G CNV",
    "POLR3G RNA",
    "POLR3G Proteo"
  ],
  "HLA-DPB2": [
    "HLA-DPB2 CNV",
    "HLA-DPB2 RNA"
  ],
  "DEFB106A": [
    "DEFB106A CNV",
    "DEFB106A RNA"
  ],
  "TENT5B": [
    "TENT5B CNV",
    "TENT5B RNA"
  ],
  "PTTG1IP": [
    "PTTG1IP CNV",
    "PTTG1IP RNA",
    "PTTG1IP Proteo"
  ],
  "SPX": [
    "SPX CNV",
    "SPX RNA"
  ],
  "ATP5MFP1": [
    "ATP5MFP1 CNV",
    "ATP5MFP1 RNA"
  ],
  "SCGB2A1": [
    "SCGB2A1 CNV",
    "SCGB2A1 RNA"
  ],
  "GAGE12J": [
    "GAGE12J CNV",
    "GAGE12J RNA"
  ],
  "FAM90A8": [
    "FAM90A8 CNV",
    "FAM90A8 RNA"
  ],
  "OR4V1P": [
    "OR4V1P CNV",
    "OR4V1P RNA"
  ],
  "MTND4P13": [
    "MTND4P13 CNV",
    "MTND4P13 RNA"
  ],
  "OR7E84P": [
    "OR7E84P CNV",
    "OR7E84P RNA"
  ],
  "RGS10": [
    "RGS10 CNV",
    "RGS10 RNA",
    "RGS10 Proteo"
  ],
  "ITGA2": [
    "ITGA2 CNV",
    "ITGA2 RNA",
    "ITGA2 Proteo"
  ],
  "HMGB1P48": [
    "HMGB1P48 CNV",
    "HMGB1P48 RNA"
  ],
  "ZNF805": [
    "ZNF805 CNV",
    "ZNF805 RNA"
  ],
  "CYCSP53": [
    "CYCSP53 CNV",
    "CYCSP53 RNA"
  ],
  "MAGEE1": [
    "MAGEE1 CNV",
    "MAGEE1 RNA"
  ],
  "CKBP1": [
    "CKBP1 CNV",
    "CKBP1 RNA"
  ],
  "UFD1": [
    "UFD1 CNV",
    "UFD1 RNA",
    "UFD1 Proteo"
  ],
  "GOLM1": [
    "GOLM1 CNV",
    "GOLM1 RNA",
    "GOLM1 Proteo"
  ],
  "EXOC3L1": [
    "EXOC3L1 CNV",
    "EXOC3L1 RNA"
  ],
  "CCZ1B": [
    "CCZ1B CNV",
    "CCZ1B RNA",
    "CCZ1B Proteo"
  ],
  "GULP1": [
    "GULP1 CNV",
    "GULP1 RNA",
    "GULP1 Proteo"
  ],
  "RPL14": [
    "RPL14 CNV",
    "RPL14 RNA",
    "RPL14 Proteo"
  ],
  "PHB1P5": [
    "PHB1P5 CNV",
    "PHB1P5 RNA"
  ],
  "TDRKH": [
    "TDRKH CNV",
    "TDRKH RNA",
    "TDRKH Proteo"
  ],
  "LMBRD2": [
    "LMBRD2 CNV",
    "LMBRD2 RNA",
    "LMBRD2 Proteo"
  ],
  "FAM53B": [
    "FAM53B CNV",
    "FAM53B RNA",
    "FAM53B Proteo"
  ],
  "SPATA31D2P": [
    "SPATA31D2P CNV",
    "SPATA31D2P RNA"
  ],
  "CYB5R2": [
    "CYB5R2 CNV",
    "CYB5R2 RNA",
    "CYB5R2 Proteo"
  ],
  "SCGB1D1": [
    "SCGB1D1 CNV",
    "SCGB1D1 RNA"
  ],
  "PPIAP7": [
    "PPIAP7 CNV",
    "PPIAP7 RNA"
  ],
  "LHFPL5": [
    "LHFPL5 CNV",
    "LHFPL5 RNA"
  ],
  "TMPRSS11GP": [
    "TMPRSS11GP CNV",
    "TMPRSS11GP RNA"
  ],
  "PGGHG": [
    "PGGHG CNV",
    "PGGHG RNA",
    "PGGHG Proteo"
  ],
  "OR4F6": [
    "OR4F6 CNV",
    "OR4F6 RNA"
  ],
  "FANCG": [
    "FANCG CNV",
    "FANCG RNA",
    "FANCG Proteo"
  ],
  "ZNF512": [
    "ZNF512 CNV",
    "ZNF512 RNA",
    "ZNF512 Proteo"
  ],
  "DDAH2": [
    "DDAH2 CNV",
    "DDAH2 RNA",
    "DDAH2 Proteo"
  ],
  "RPSAP53": [
    "RPSAP53 CNV",
    "RPSAP53 RNA"
  ],
  "KMT2CP3": [
    "KMT2CP3 CNV",
    "KMT2CP3 RNA"
  ],
  "RPSAP38": [
    "RPSAP38 CNV",
    "RPSAP38 RNA"
  ],
  "CHCHD10": [
    "CHCHD10 CNV",
    "CHCHD10 RNA",
    "CHCHD10 Proteo"
  ],
  "GAD2": [
    "GAD2 CNV",
    "GAD2 RNA"
  ],
  "TRIM49D2": [
    "TRIM49D2 CNV",
    "TRIM49D2 RNA"
  ],
  "FABP5P7": [
    "FABP5P7 CNV",
    "FABP5P7 RNA"
  ],
  "FAM205C": [
    "FAM205C CNV",
    "FAM205C RNA"
  ],
  "H2ACP2": [
    "H2ACP2 CNV",
    "H2ACP2 RNA"
  ],
  "ZNF610": [
    "ZNF610 CNV",
    "ZNF610 RNA"
  ],
  "VRK3": [
    "VRK3 CNV",
    "VRK3 RNA",
    "VRK3 Proteo"
  ],
  "OR52B2": [
    "OR52B2 CNV",
    "OR52B2 RNA"
  ],
  "PDGFD": [
    "PDGFD CNV",
    "PDGFD RNA",
    "PDGFD Proteo"
  ],
  "TMTC4": [
    "TMTC4 CNV",
    "TMTC4 RNA",
    "TMTC4 Proteo"
  ],
  "SH2D5": [
    "SH2D5 CNV",
    "SH2D5 RNA"
  ],
  "ARRDC5": [
    "ARRDC5 CNV",
    "ARRDC5 RNA"
  ],
  "RDH16": [
    "RDH16 CNV",
    "RDH16 RNA"
  ],
  "NIPA2P2": [
    "NIPA2P2 CNV",
    "NIPA2P2 RNA"
  ],
  "PRPSAP2": [
    "PRPSAP2 CNV",
    "PRPSAP2 RNA",
    "PRPSAP2 Proteo"
  ],
  "TGM3": [
    "TGM3 CNV",
    "TGM3 RNA",
    "TGM3 Proteo"
  ],
  "TBC1D31": [
    "TBC1D31 CNV",
    "TBC1D31 RNA",
    "TBC1D31 Proteo"
  ],
  "POM121L7P": [
    "POM121L7P CNV",
    "POM121L7P RNA"
  ],
  "MTND5P35": [
    "MTND5P35 CNV",
    "MTND5P35 RNA"
  ],
  "MC1R": [
    "MC1R CNV",
    "MC1R RNA"
  ],
  "PPIAP52": [
    "PPIAP52 CNV",
    "PPIAP52 RNA"
  ],
  "OR4X1": [
    "OR4X1 CNV",
    "OR4X1 RNA"
  ],
  "RPS7P11": [
    "RPS7P11 CNV",
    "RPS7P11 RNA"
  ],
  "NSA2P5": [
    "NSA2P5 CNV",
    "NSA2P5 RNA"
  ],
  "HOXB7": [
    "HOXB7 CNV",
    "HOXB7 RNA",
    "HOXB7 Proteo"
  ],
  "ASS1P13": [
    "ASS1P13 CNV",
    "ASS1P13 RNA"
  ],
  "GAPDHP31": [
    "GAPDHP31 CNV",
    "GAPDHP31 RNA"
  ],
  "MCTS2": [
    "MCTS2 CNV",
    "MCTS2 RNA"
  ],
  "ZFYVE19": [
    "ZFYVE19 CNV",
    "ZFYVE19 RNA",
    "ZFYVE19 Proteo"
  ],
  "SERPINF2": [
    "SERPINF2 CNV",
    "SERPINF2 RNA",
    "SERPINF2 Proteo"
  ],
  "CRYBB2": [
    "CRYBB2 CNV",
    "CRYBB2 RNA"
  ],
  "CRISPLD2": [
    "CRISPLD2 CNV",
    "CRISPLD2 RNA",
    "CRISPLD2 Proteo"
  ],
  "EEF2": [
    "EEF2 CNV",
    "EEF2 RNA",
    "EEF2 Proteo"
  ],
  "DENND10P1": [
    "DENND10P1 CNV",
    "DENND10P1 RNA"
  ],
  "OR1N1": [
    "OR1N1 CNV",
    "OR1N1 RNA"
  ],
  "DIS3L": [
    "DIS3L CNV",
    "DIS3L RNA",
    "DIS3L Proteo"
  ],
  "TNFSF4": [
    "TNFSF4 CNV",
    "TNFSF4 RNA"
  ],
  "CHRNA2": [
    "CHRNA2 CNV",
    "CHRNA2 RNA"
  ],
  "DUX4L9": [
    "DUX4L9 CNV",
    "DUX4L9 RNA"
  ],
  "LINC00431": [
    "LINC00431 CNV",
    "LINC00431 RNA"
  ],
  "PROM2": [
    "PROM2 CNV",
    "PROM2 RNA",
    "PROM2 Proteo"
  ],
  "PCDH7": [
    "PCDH7 CNV",
    "PCDH7 RNA",
    "PCDH7 Proteo"
  ],
  "HSPA8P16": [
    "HSPA8P16 CNV",
    "HSPA8P16 RNA"
  ],
  "MAFB": [
    "MAFB CNV",
    "MAFB RNA"
  ],
  "PCDHGB4": [
    "PCDHGB4 CNV",
    "PCDHGB4 RNA"
  ],
  "OR56A7P": [
    "OR56A7P CNV",
    "OR56A7P RNA"
  ],
  "LAMB2": [
    "LAMB2 CNV",
    "LAMB2 RNA",
    "LAMB2 Proteo"
  ],
  "SLC33A1": [
    "SLC33A1 CNV",
    "SLC33A1 RNA",
    "SLC33A1 Proteo"
  ],
  "RPA3P1": [
    "RPA3P1 CNV",
    "RPA3P1 RNA"
  ],
  "RNA5SP400": [
    "RNA5SP400 CNV",
    "RNA5SP400 RNA"
  ],
  "DUX4L1": [
    "DUX4L1 CNV",
    "DUX4L1 RNA"
  ],
  "IKZF1": [
    "IKZF1 CNV",
    "IKZF1 RNA",
    "IKZF1 Proteo"
  ],
  "NAT9": [
    "NAT9 CNV",
    "NAT9 RNA",
    "NAT9 Proteo"
  ],
  "TOMM22": [
    "TOMM22 CNV",
    "TOMM22 RNA",
    "TOMM22 Proteo"
  ],
  "KIAA1549": [
    "KIAA1549 CNV",
    "KIAA1549 RNA"
  ],
  "GDF9": [
    "GDF9 CNV",
    "GDF9 RNA"
  ],
  "ZNF33A": [
    "ZNF33A CNV",
    "ZNF33A RNA",
    "ZNF33A Proteo"
  ],
  "NDUFA3P3": [
    "NDUFA3P3 CNV",
    "NDUFA3P3 RNA"
  ],
  "ENTPD6": [
    "ENTPD6 CNV",
    "ENTPD6 RNA",
    "ENTPD6 Proteo"
  ],
  "RAP1GAP": [
    "RAP1GAP CNV",
    "RAP1GAP RNA",
    "RAP1GAP Proteo"
  ],
  "ZRANB2": [
    "ZRANB2 CNV",
    "ZRANB2 RNA",
    "ZRANB2 Proteo"
  ],
  "INO80B": [
    "INO80B CNV",
    "INO80B RNA",
    "INO80B Proteo"
  ],
  "KRT25": [
    "KRT25 CNV",
    "KRT25 RNA",
    "KRT25 Proteo"
  ],
  "ANXA2P2": [
    "ANXA2P2 CNV",
    "ANXA2P2 RNA"
  ],
  "P3H1": [
    "P3H1 CNV",
    "P3H1 RNA",
    "P3H1 Proteo"
  ],
  "RPS14P4": [
    "RPS14P4 CNV",
    "RPS14P4 RNA"
  ],
  "RNF126": [
    "RNF126 CNV",
    "RNF126 RNA",
    "RNF126 Proteo"
  ],
  "KRT31": [
    "KRT31 CNV",
    "KRT31 RNA",
    "KRT31 Proteo"
  ],
  "EDDM3A": [
    "EDDM3A CNV",
    "EDDM3A RNA"
  ],
  "MIB1": [
    "MIB1 CNV",
    "MIB1 RNA",
    "MIB1 Proteo"
  ],
  "KLHL13": [
    "KLHL13 CNV",
    "KLHL13 RNA",
    "KLHL13 Proteo"
  ],
  "PLPPR3": [
    "PLPPR3 CNV",
    "PLPPR3 RNA",
    "PLPPR3 Proteo"
  ],
  "RPSAP55": [
    "RPSAP55 CNV",
    "RPSAP55 RNA"
  ],
  "CTAGE15": [
    "CTAGE15 CNV",
    "CTAGE15 RNA"
  ],
  "TMEM214": [
    "TMEM214 CNV",
    "TMEM214 RNA",
    "TMEM214 Proteo"
  ],
  "COX7A2L": [
    "COX7A2L CNV",
    "COX7A2L RNA",
    "COX7A2L Proteo"
  ],
  "TMEM263": [
    "TMEM263 CNV",
    "TMEM263 RNA",
    "TMEM263 Proteo"
  ],
  "RAB3B": [
    "RAB3B CNV",
    "RAB3B RNA",
    "RAB3B Proteo"
  ],
  "DAP3": [
    "DAP3 CNV",
    "DAP3 RNA",
    "DAP3 Proteo"
  ],
  "TCP10L2": [
    "TCP10L2 CNV",
    "TCP10L2 RNA"
  ],
  "RAET1G": [
    "RAET1G CNV",
    "RAET1G RNA",
    "RAET1G Proteo"
  ],
  "AP3B1": [
    "AP3B1 CNV",
    "AP3B1 RNA",
    "AP3B1 Proteo"
  ],
  "EBLN2": [
    "EBLN2 CNV",
    "EBLN2 RNA"
  ],
  "GOLGA6L4": [
    "GOLGA6L4 CNV",
    "GOLGA6L4 RNA"
  ],
  "ZNF608": [
    "ZNF608 CNV",
    "ZNF608 RNA",
    "ZNF608 Proteo"
  ],
  "HMOX1": [
    "HMOX1 CNV",
    "HMOX1 RNA",
    "HMOX1 Proteo"
  ],
  "FAF1": [
    "FAF1 CNV",
    "FAF1 RNA",
    "FAF1 Proteo"
  ],
  "TMEM40": [
    "TMEM40 CNV",
    "TMEM40 RNA",
    "TMEM40 Proteo"
  ],
  "SUSD4": [
    "SUSD4 CNV",
    "SUSD4 RNA"
  ],
  "SLIT2": [
    "SLIT2 CNV",
    "SLIT2 RNA",
    "SLIT2 Proteo"
  ],
  "USP14": [
    "USP14 CNV",
    "USP14 RNA",
    "USP14 Proteo"
  ],
  "R3HDM1": [
    "R3HDM1 CNV",
    "R3HDM1 RNA",
    "R3HDM1 Proteo"
  ],
  "BRMS1L": [
    "BRMS1L CNV",
    "BRMS1L RNA",
    "BRMS1L Proteo"
  ],
  "PPP1R2": [
    "PPP1R2 CNV",
    "PPP1R2 RNA",
    "PPP1R2 Proteo"
  ],
  "ZNF518B": [
    "ZNF518B CNV",
    "ZNF518B RNA",
    "ZNF518B Proteo"
  ],
  "MPP7": [
    "MPP7 CNV",
    "MPP7 RNA",
    "MPP7 Proteo"
  ],
  "CLEC1A": [
    "CLEC1A CNV",
    "CLEC1A RNA"
  ],
  "EEF1A1P37": [
    "EEF1A1P37 CNV",
    "EEF1A1P37 RNA"
  ],
  "BPIFA3": [
    "BPIFA3 CNV",
    "BPIFA3 RNA"
  ],
  "THAP12P3": [
    "THAP12P3 CNV",
    "THAP12P3 RNA"
  ],
  "NDUFB8P1": [
    "NDUFB8P1 CNV",
    "NDUFB8P1 RNA"
  ],
  "ECEL1P1": [
    "ECEL1P1 CNV",
    "ECEL1P1 RNA"
  ],
  "CYB5R1": [
    "CYB5R1 CNV",
    "CYB5R1 RNA",
    "CYB5R1 Proteo"
  ],
  "STX10": [
    "STX10 CNV",
    "STX10 RNA",
    "STX10 Proteo"
  ],
  "EPHB6": [
    "EPHB6 CNV",
    "EPHB6 RNA",
    "EPHB6 Proteo"
  ],
  "FAM90A14": [
    "FAM90A14 CNV",
    "FAM90A14 RNA"
  ],
  "CRLF2": [
    "CRLF2 CNV",
    "CRLF2 RNA"
  ],
  "ZBTB8OS": [
    "ZBTB8OS CNV",
    "ZBTB8OS RNA",
    "ZBTB8OS Proteo"
  ],
  "ATP6V0E1P1": [
    "ATP6V0E1P1 CNV",
    "ATP6V0E1P1 RNA"
  ],
  "IREB2": [
    "IREB2 CNV",
    "IREB2 RNA",
    "IREB2 Proteo"
  ],
  "PPM1F": [
    "PPM1F CNV",
    "PPM1F RNA",
    "PPM1F Proteo"
  ],
  "IDO1": [
    "IDO1 CNV",
    "IDO1 RNA",
    "IDO1 Proteo"
  ],
  "SLC44A2": [
    "SLC44A2 CNV",
    "SLC44A2 RNA",
    "SLC44A2 Proteo"
  ],
  "PDE7A": [
    "PDE7A CNV",
    "PDE7A RNA",
    "PDE7A Proteo"
  ],
  "CHURC1": [
    "CHURC1 CNV",
    "CHURC1 RNA",
    "CHURC1 Proteo"
  ],
  "MZT1P1": [
    "MZT1P1 CNV",
    "MZT1P1 RNA"
  ],
  "DMTN": [
    "DMTN CNV",
    "DMTN RNA",
    "DMTN Proteo"
  ],
  "VHLL": [
    "VHLL CNV",
    "VHLL RNA"
  ],
  "CICP11": [
    "CICP11 CNV",
    "CICP11 RNA"
  ],
  "CSGALNACT2P2": [
    "CSGALNACT2P2 CNV",
    "CSGALNACT2P2 RNA"
  ],
  "OR56B3P": [
    "OR56B3P CNV",
    "OR56B3P RNA"
  ],
  "ADH4": [
    "ADH4 CNV",
    "ADH4 RNA"
  ],
  "MYO1B": [
    "MYO1B CNV",
    "MYO1B RNA",
    "MYO1B Proteo"
  ],
  "PUF60": [
    "PUF60 CNV",
    "PUF60 RNA",
    "PUF60 Proteo"
  ],
  "ARAP1": [
    "ARAP1 CNV",
    "ARAP1 RNA",
    "ARAP1 Proteo"
  ],
  "F12": [
    "F12 CNV",
    "F12 RNA",
    "F12 Proteo"
  ],
  "TRAPPC5": [
    "TRAPPC5 CNV",
    "TRAPPC5 RNA",
    "TRAPPC5 Proteo"
  ],
  "TVP23C": [
    "TVP23C CNV",
    "TVP23C RNA",
    "TVP23C Proteo"
  ],
  "ATP12A": [
    "ATP12A CNV",
    "ATP12A RNA",
    "ATP12A Proteo"
  ],
  "ZNF566": [
    "ZNF566 CNV",
    "ZNF566 RNA",
    "ZNF566 Proteo"
  ],
  "C8orf76": [
    "C8orf76 CNV",
    "C8orf76 RNA",
    "C8orf76 Proteo"
  ],
  "TRIM9": [
    "TRIM9 CNV",
    "TRIM9 RNA",
    "TRIM9 Proteo"
  ],
  "EEF1A1P12": [
    "EEF1A1P12 CNV",
    "EEF1A1P12 RNA"
  ],
  "GOLGB1": [
    "GOLGB1 CNV",
    "GOLGB1 RNA",
    "GOLGB1 Proteo"
  ],
  "CLEC9A": [
    "CLEC9A CNV",
    "CLEC9A RNA"
  ],
  "HAUS1P2": [
    "HAUS1P2 CNV",
    "HAUS1P2 RNA"
  ],
  "HNRNPA1P52": [
    "HNRNPA1P52 CNV",
    "HNRNPA1P52 RNA"
  ],
  "XKRYP3": [
    "XKRYP3 CNV",
    "XKRYP3 RNA"
  ],
  "MKNK2P1": [
    "MKNK2P1 CNV",
    "MKNK2P1 RNA"
  ],
  "SETP22": [
    "SETP22 CNV",
    "SETP22 RNA"
  ],
  "RNASE3": [
    "RNASE3 CNV",
    "RNASE3 RNA",
    "RNASE3 Proteo"
  ],
  "GATC": [
    "GATC CNV",
    "GATC RNA"
  ],
  "CPSF7": [
    "CPSF7 CNV",
    "CPSF7 RNA",
    "CPSF7 Proteo"
  ],
  "CEACAMP8": [
    "CEACAMP8 CNV",
    "CEACAMP8 RNA"
  ],
  "OR51I1": [
    "OR51I1 CNV",
    "OR51I1 RNA"
  ],
  "ELF5": [
    "ELF5 CNV",
    "ELF5 RNA"
  ],
  "BCS1L": [
    "BCS1L CNV",
    "BCS1L RNA",
    "BCS1L Proteo"
  ],
  "VN1R12P": [
    "VN1R12P CNV",
    "VN1R12P RNA"
  ],
  "SLC15A2": [
    "SLC15A2 CNV",
    "SLC15A2 RNA"
  ],
  "MRGPRX10P": [
    "MRGPRX10P CNV",
    "MRGPRX10P RNA"
  ],
  "RNA5SP173": [
    "RNA5SP173 CNV",
    "RNA5SP173 RNA"
  ],
  "GYS1": [
    "GYS1 CNV",
    "GYS1 RNA",
    "GYS1 Proteo"
  ],
  "GBA": [
    "GBA CNV",
    "GBA RNA",
    "GBA Proteo"
  ],
  "SPATA31E1": [
    "SPATA31E1 CNV",
    "SPATA31E1 RNA"
  ],
  "TM4SF4": [
    "TM4SF4 CNV",
    "TM4SF4 RNA"
  ],
  "EBAG9P1": [
    "EBAG9P1 CNV",
    "EBAG9P1 RNA"
  ],
  "CIR1P2": [
    "CIR1P2 CNV",
    "CIR1P2 RNA"
  ],
  "PRSS52P": [
    "PRSS52P CNV",
    "PRSS52P RNA"
  ],
  "TINAGL1": [
    "TINAGL1 CNV",
    "TINAGL1 RNA",
    "TINAGL1 Proteo"
  ],
  "RNA5SP106": [
    "RNA5SP106 CNV",
    "RNA5SP106 RNA"
  ],
  "KLK13": [
    "KLK13 CNV",
    "KLK13 RNA",
    "KLK13 Proteo"
  ],
  "ATP13A4": [
    "ATP13A4 CNV",
    "ATP13A4 RNA"
  ],
  "RNA5SP137": [
    "RNA5SP137 CNV",
    "RNA5SP137 RNA"
  ],
  "KATNAL1": [
    "KATNAL1 CNV",
    "KATNAL1 RNA",
    "KATNAL1 Proteo"
  ],
  "OR5J1P": [
    "OR5J1P CNV",
    "OR5J1P RNA"
  ],
  "ARL2BPP6": [
    "ARL2BPP6 CNV",
    "ARL2BPP6 RNA"
  ],
  "RAB39B": [
    "RAB39B CNV",
    "RAB39B RNA",
    "RAB39B Proteo"
  ],
  "HMGN2P10": [
    "HMGN2P10 CNV",
    "HMGN2P10 RNA"
  ],
  "FAM118A": [
    "FAM118A CNV",
    "FAM118A RNA",
    "FAM118A Proteo"
  ],
  "GLUD1": [
    "GLUD1 CNV",
    "GLUD1 RNA",
    "GLUD1 Proteo"
  ],
  "LONRF2P5": [
    "LONRF2P5 CNV",
    "LONRF2P5 RNA"
  ],
  "IGFLR1": [
    "IGFLR1 CNV",
    "IGFLR1 RNA",
    "IGFLR1 Proteo"
  ],
  "FANK1": [
    "FANK1 CNV",
    "FANK1 RNA"
  ],
  "DACT2": [
    "DACT2 CNV",
    "DACT2 RNA"
  ],
  "BCL9": [
    "BCL9 CNV",
    "BCL9 RNA",
    "BCL9 Proteo"
  ],
  "CYP3A54P": [
    "CYP3A54P CNV",
    "CYP3A54P RNA"
  ],
  "B3GALT9": [
    "B3GALT9 CNV",
    "B3GALT9 RNA"
  ],
  "USE1": [
    "USE1 CNV",
    "USE1 RNA",
    "USE1 Proteo"
  ],
  "RPS3AP23": [
    "RPS3AP23 CNV",
    "RPS3AP23 RNA"
  ],
  "SYT5": [
    "SYT5 CNV",
    "SYT5 RNA"
  ],
  "NPSR1": [
    "NPSR1 CNV",
    "NPSR1 RNA"
  ],
  "ZSCAN25": [
    "ZSCAN25 CNV",
    "ZSCAN25 RNA",
    "ZSCAN25 Proteo"
  ],
  "WBP2P1": [
    "WBP2P1 CNV",
    "WBP2P1 RNA"
  ],
  "ATP5MC1": [
    "ATP5MC1 CNV",
    "ATP5MC1 RNA",
    "ATP5MC1 Proteo"
  ],
  "RPL32P13": [
    "RPL32P13 CNV",
    "RPL32P13 RNA"
  ],
  "INGX": [
    "INGX CNV",
    "INGX RNA"
  ],
  "TUBB4BP8": [
    "TUBB4BP8 CNV",
    "TUBB4BP8 RNA"
  ],
  "RPL19P5": [
    "RPL19P5 CNV",
    "RPL19P5 RNA"
  ],
  "KRT42P": [
    "KRT42P CNV",
    "KRT42P RNA"
  ],
  "TRAPPC2P10": [
    "TRAPPC2P10 CNV",
    "TRAPPC2P10 RNA"
  ],
  "CR1L": [
    "CR1L CNV",
    "CR1L RNA"
  ],
  "CACNB4": [
    "CACNB4 CNV",
    "CACNB4 RNA",
    "CACNB4 Proteo"
  ],
  "DUX4L8": [
    "DUX4L8 CNV",
    "DUX4L8 RNA"
  ],
  "SLC25A51P4": [
    "SLC25A51P4 CNV",
    "SLC25A51P4 RNA"
  ],
  "REPS2": [
    "REPS2 CNV",
    "REPS2 RNA",
    "REPS2 Proteo"
  ],
  "ANKRD54P1": [
    "ANKRD54P1 CNV",
    "ANKRD54P1 RNA"
  ],
  "EZR": [
    "EZR CNV",
    "EZR RNA",
    "EZR Proteo"
  ],
  "UGT2A1": [
    "UGT2A1 CNV",
    "UGT2A1 RNA"
  ],
  "PSME2P1": [
    "PSME2P1 CNV",
    "PSME2P1 RNA"
  ],
  "SRPRA": [
    "SRPRA CNV",
    "SRPRA RNA",
    "SRPRA Proteo"
  ],
  "HERC2P2": [
    "HERC2P2 CNV",
    "HERC2P2 RNA"
  ],
  "DEAF1": [
    "DEAF1 CNV",
    "DEAF1 RNA",
    "DEAF1 Proteo"
  ],
  "ZNF680P1": [
    "ZNF680P1 CNV",
    "ZNF680P1 RNA"
  ],
  "RAC1P6": [
    "RAC1P6 CNV",
    "RAC1P6 RNA"
  ],
  "RPL39P38": [
    "RPL39P38 CNV",
    "RPL39P38 RNA"
  ],
  "C10orf62": [
    "C10orf62 CNV",
    "C10orf62 RNA"
  ],
  "TEKT3": [
    "TEKT3 CNV",
    "TEKT3 RNA"
  ],
  "COL5A1": [
    "COL5A1 CNV",
    "COL5A1 RNA",
    "COL5A1 Proteo"
  ],
  "UBFD1": [
    "UBFD1 CNV",
    "UBFD1 RNA",
    "UBFD1 Proteo"
  ],
  "ABHD17AP1": [
    "ABHD17AP1 CNV",
    "ABHD17AP1 RNA"
  ],
  "ADAMTSL2": [
    "ADAMTSL2 CNV",
    "ADAMTSL2 RNA"
  ],
  "NSUN4": [
    "NSUN4 CNV",
    "NSUN4 RNA",
    "NSUN4 Proteo"
  ],
  "PPIAL4D": [
    "PPIAL4D CNV",
    "PPIAL4D RNA"
  ],
  "XPNPEP2": [
    "XPNPEP2 CNV",
    "XPNPEP2 RNA",
    "XPNPEP2 Proteo"
  ],
  "PSMD2": [
    "PSMD2 CNV",
    "PSMD2 RNA",
    "PSMD2 Proteo"
  ],
  "ENDOG": [
    "ENDOG CNV",
    "ENDOG RNA",
    "ENDOG Proteo"
  ],
  "THRA": [
    "THRA CNV",
    "THRA RNA",
    "THRA Proteo"
  ],
  "USP9YP3": [
    "USP9YP3 CNV",
    "USP9YP3 RNA"
  ],
  "CHUK": [
    "CHUK CNV",
    "CHUK RNA",
    "CHUK Proteo"
  ],
  "CCNB2": [
    "CCNB2 CNV",
    "CCNB2 RNA",
    "CCNB2 Proteo"
  ],
  "ARGFX": [
    "ARGFX CNV",
    "ARGFX RNA"
  ],
  "RBM39P1": [
    "RBM39P1 CNV",
    "RBM39P1 RNA"
  ],
  "ABHD17AP5": [
    "ABHD17AP5 CNV",
    "ABHD17AP5 RNA"
  ],
  "PHC2": [
    "PHC2 CNV",
    "PHC2 RNA",
    "PHC2 Proteo"
  ],
  "TEX36": [
    "TEX36 CNV",
    "TEX36 RNA"
  ],
  "MNDA": [
    "MNDA CNV",
    "MNDA RNA",
    "MNDA Proteo"
  ],
  "RPL5P20": [
    "RPL5P20 CNV",
    "RPL5P20 RNA"
  ],
  "RPS21P4": [
    "RPS21P4 CNV",
    "RPS21P4 RNA"
  ],
  "ADAT2": [
    "ADAT2 CNV",
    "ADAT2 RNA",
    "ADAT2 Proteo"
  ],
  "DDX6P1": [
    "DDX6P1 CNV",
    "DDX6P1 RNA"
  ],
  "S100A11": [
    "S100A11 CNV",
    "S100A11 RNA",
    "S100A11 Proteo"
  ],
  "TMPRSS12": [
    "TMPRSS12 CNV",
    "TMPRSS12 RNA"
  ],
  "KRT19": [
    "KRT19 CNV",
    "KRT19 RNA",
    "KRT19 Proteo"
  ],
  "BCKDK": [
    "BCKDK CNV",
    "BCKDK RNA",
    "BCKDK Proteo"
  ],
  "PSMB9": [
    "PSMB9 CNV",
    "PSMB9 RNA",
    "PSMB9 Proteo"
  ],
  "FOXJ1": [
    "FOXJ1 CNV",
    "FOXJ1 RNA"
  ],
  "COPB2": [
    "COPB2 CNV",
    "COPB2 RNA",
    "COPB2 Proteo"
  ],
  "KRTAP10-3": [
    "KRTAP10-3 CNV",
    "KRTAP10-3 RNA"
  ],
  "ZNF14": [
    "ZNF14 CNV",
    "ZNF14 RNA",
    "ZNF14 Proteo"
  ],
  "SLC52A3": [
    "SLC52A3 CNV",
    "SLC52A3 RNA"
  ],
  "IL1R2": [
    "IL1R2 CNV",
    "IL1R2 RNA",
    "IL1R2 Proteo"
  ],
  "OR52L2P": [
    "OR52L2P CNV",
    "OR52L2P RNA"
  ],
  "RPL13AP19": [
    "RPL13AP19 CNV",
    "RPL13AP19 RNA"
  ],
  "SHANK1": [
    "SHANK1 CNV",
    "SHANK1 RNA",
    "SHANK1 Proteo"
  ],
  "CYP24A1": [
    "CYP24A1 CNV",
    "CYP24A1 RNA",
    "CYP24A1 Proteo"
  ],
  "PIANP": [
    "PIANP CNV",
    "PIANP RNA"
  ],
  "SPDYE13": [
    "SPDYE13 CNV",
    "SPDYE13 RNA"
  ],
  "WHAMMP3": [
    "WHAMMP3 CNV",
    "WHAMMP3 RNA"
  ],
  "GAN": [
    "GAN CNV",
    "GAN RNA",
    "GAN Proteo"
  ],
  "M6PRP1": [
    "M6PRP1 CNV",
    "M6PRP1 RNA"
  ],
  "SOCS5P2": [
    "SOCS5P2 CNV",
    "SOCS5P2 RNA"
  ],
  "IGHV4-31": [
    "IGHV4-31 Proteo"
  ],
  "OR7E90P": [
    "OR7E90P CNV",
    "OR7E90P RNA"
  ],
  "CCDC54": [
    "CCDC54 CNV",
    "CCDC54 RNA"
  ],
  "BZW2": [
    "BZW2 CNV",
    "BZW2 RNA",
    "BZW2 Proteo"
  ],
  "ESYT3": [
    "ESYT3 CNV",
    "ESYT3 RNA"
  ],
  "NWD2": [
    "NWD2 CNV",
    "NWD2 RNA"
  ],
  "TRPS1": [
    "TRPS1 CNV",
    "TRPS1 RNA",
    "TRPS1 Proteo"
  ],
  "NYX": [
    "NYX CNV",
    "NYX RNA"
  ],
  "ACSL3": [
    "ACSL3 CNV",
    "ACSL3 RNA",
    "ACSL3 Proteo"
  ],
  "RPL7P3": [
    "RPL7P3 CNV",
    "RPL7P3 RNA"
  ],
  "ZNF75A": [
    "ZNF75A CNV",
    "ZNF75A RNA"
  ],
  "SALL2": [
    "SALL2 CNV",
    "SALL2 RNA"
  ],
  "SAP25": [
    "SAP25 CNV",
    "SAP25 RNA",
    "SAP25 Proteo"
  ],
  "GRHL1": [
    "GRHL1 CNV",
    "GRHL1 RNA",
    "GRHL1 Proteo"
  ],
  "LUM": [
    "LUM CNV",
    "LUM RNA",
    "LUM Proteo"
  ],
  "RPL26P13": [
    "RPL26P13 CNV",
    "RPL26P13 RNA"
  ],
  "LNX2": [
    "LNX2 CNV",
    "LNX2 RNA",
    "LNX2 Proteo"
  ],
  "SPCS2P2": [
    "SPCS2P2 CNV",
    "SPCS2P2 RNA"
  ],
  "UQCRC2P1": [
    "UQCRC2P1 CNV",
    "UQCRC2P1 RNA"
  ],
  "NKX6-2": [
    "NKX6-2 CNV",
    "NKX6-2 RNA"
  ],
  "ARHGAP16P": [
    "ARHGAP16P CNV",
    "ARHGAP16P RNA"
  ],
  "SRARP": [
    "SRARP CNV",
    "SRARP RNA"
  ],
  "TRIM49": [
    "TRIM49 CNV",
    "TRIM49 RNA"
  ],
  "STX6": [
    "STX6 CNV",
    "STX6 RNA",
    "STX6 Proteo"
  ],
  "XPOT": [
    "XPOT CNV",
    "XPOT RNA",
    "XPOT Proteo"
  ],
  "NPS": [
    "NPS CNV",
    "NPS RNA"
  ],
  "OR52A4P": [
    "OR52A4P CNV",
    "OR52A4P RNA"
  ],
  "PLAU": [
    "PLAU CNV",
    "PLAU RNA",
    "PLAU Proteo"
  ],
  "RRAGC": [
    "RRAGC CNV",
    "RRAGC RNA",
    "RRAGC Proteo"
  ],
  "GAL3ST1": [
    "GAL3ST1 CNV",
    "GAL3ST1 RNA"
  ],
  "XKR3": [
    "XKR3 CNV",
    "XKR3 RNA",
    "XKR3 Proteo"
  ],
  "IGHV3-71": [
    "IGHV3-71 CNV",
    "IGHV3-71 RNA"
  ],
  "MYCBP2": [
    "MYCBP2 CNV",
    "MYCBP2 RNA",
    "MYCBP2 Proteo"
  ],
  "OR14L1P": [
    "OR14L1P CNV",
    "OR14L1P RNA"
  ],
  "RPAP2": [
    "RPAP2 CNV",
    "RPAP2 RNA",
    "RPAP2 Proteo"
  ],
  "FAM102B": [
    "FAM102B CNV",
    "FAM102B RNA",
    "FAM102B Proteo"
  ],
  "SSBP3": [
    "SSBP3 CNV",
    "SSBP3 RNA",
    "SSBP3 Proteo"
  ],
  "ZNF230": [
    "ZNF230 CNV",
    "ZNF230 RNA"
  ],
  "PLEKHG7": [
    "PLEKHG7 CNV",
    "PLEKHG7 RNA"
  ],
  "CAP2": [
    "CAP2 CNV",
    "CAP2 RNA",
    "CAP2 Proteo"
  ],
  "CD209": [
    "CD209 CNV",
    "CD209 RNA",
    "CD209 Proteo"
  ],
  "SSX2": [
    "SSX2 CNV",
    "SSX2 RNA"
  ],
  "NDUFB4P4": [
    "NDUFB4P4 CNV",
    "NDUFB4P4 RNA"
  ],
  "TAF9B": [
    "TAF9B CNV",
    "TAF9B RNA",
    "TAF9B Proteo"
  ],
  "OR5BT1P": [
    "OR5BT1P CNV",
    "OR5BT1P RNA"
  ],
  "RGS17": [
    "RGS17 CNV",
    "RGS17 RNA"
  ],
  "EPHA6": [
    "EPHA6 CNV",
    "EPHA6 RNA"
  ],
  "EFL1P1": [
    "EFL1P1 CNV",
    "EFL1P1 RNA"
  ],
  "PCDH20": [
    "PCDH20 CNV",
    "PCDH20 RNA"
  ],
  "PLD5": [
    "PLD5 CNV",
    "PLD5 RNA"
  ],
  "H3P1": [
    "H3P1 CNV",
    "H3P1 RNA"
  ],
  "PPP1R12BP1": [
    "PPP1R12BP1 CNV",
    "PPP1R12BP1 RNA"
  ],
  "PPATP1": [
    "PPATP1 CNV",
    "PPATP1 RNA"
  ],
  "CICP22": [
    "CICP22 CNV",
    "CICP22 RNA"
  ],
  "KHSRP": [
    "KHSRP CNV",
    "KHSRP RNA",
    "KHSRP Proteo"
  ],
  "ZNF665": [
    "ZNF665 CNV",
    "ZNF665 RNA"
  ],
  "HNRNPCL3": [
    "HNRNPCL3 CNV",
    "HNRNPCL3 RNA",
    "HNRNPCL3 Proteo"
  ],
  "ZNF713": [
    "ZNF713 CNV",
    "ZNF713 RNA"
  ],
  "PTPRK": [
    "PTPRK CNV",
    "PTPRK RNA",
    "PTPRK Proteo"
  ],
  "LBHD2": [
    "LBHD2 CNV",
    "LBHD2 RNA"
  ],
  "HNRNPCP2": [
    "HNRNPCP2 CNV",
    "HNRNPCP2 RNA"
  ],
  "RBPJP7": [
    "RBPJP7 CNV",
    "RBPJP7 RNA"
  ],
  "NIPSNAP2": [
    "NIPSNAP2 CNV",
    "NIPSNAP2 RNA",
    "NIPSNAP2 Proteo"
  ],
  "CCL3": [
    "CCL3 CNV",
    "CCL3 RNA",
    "CCL3 Proteo"
  ],
  "RPS26": [
    "RPS26 CNV",
    "RPS26 RNA",
    "RPS26 Proteo"
  ],
  "EPPIN": [
    "EPPIN CNV",
    "EPPIN RNA"
  ],
  "PRY": [
    "PRY CNV",
    "PRY RNA"
  ],
  "MYEOV": [
    "MYEOV CNV",
    "MYEOV RNA"
  ],
  "SMU1P1": [
    "SMU1P1 CNV",
    "SMU1P1 RNA"
  ],
  "NIBAN1": [
    "NIBAN1 CNV",
    "NIBAN1 RNA",
    "NIBAN1 Proteo"
  ],
  "PAX6": [
    "PAX6 CNV",
    "PAX6 RNA"
  ],
  "SLC35G1": [
    "SLC35G1 CNV",
    "SLC35G1 RNA",
    "SLC35G1 Proteo"
  ],
  "OR4D7P": [
    "OR4D7P CNV",
    "OR4D7P RNA"
  ],
  "CATSPER1": [
    "CATSPER1 CNV",
    "CATSPER1 RNA"
  ],
  "OR7E116P": [
    "OR7E116P CNV",
    "OR7E116P RNA"
  ],
  "HPS1": [
    "HPS1 CNV",
    "HPS1 RNA",
    "HPS1 Proteo"
  ],
  "SC5D": [
    "SC5D CNV",
    "SC5D RNA",
    "SC5D Proteo"
  ],
  "ATPAF1": [
    "ATPAF1 CNV",
    "ATPAF1 RNA",
    "ATPAF1 Proteo"
  ],
  "SEMA4B": [
    "SEMA4B CNV",
    "SEMA4B RNA",
    "SEMA4B Proteo"
  ],
  "CYP19A1": [
    "CYP19A1 CNV",
    "CYP19A1 RNA"
  ],
  "AURKA": [
    "AURKA CNV",
    "AURKA RNA",
    "AURKA Proteo"
  ],
  "RALGAPB": [
    "RALGAPB CNV",
    "RALGAPB RNA",
    "RALGAPB Proteo"
  ],
  "RHBDD3": [
    "RHBDD3 CNV",
    "RHBDD3 RNA",
    "RHBDD3 Proteo"
  ],
  "HNRNPA2B1": [
    "HNRNPA2B1 CNV",
    "HNRNPA2B1 RNA",
    "HNRNPA2B1 Proteo"
  ],
  "CLIC4": [
    "CLIC4 CNV",
    "CLIC4 RNA",
    "CLIC4 Proteo"
  ],
  "RNF157": [
    "RNF157 CNV",
    "RNF157 RNA",
    "RNF157 Proteo"
  ],
  "C1QA": [
    "C1QA CNV",
    "C1QA RNA",
    "C1QA Proteo"
  ],
  "RPS12": [
    "RPS12 CNV",
    "RPS12 RNA",
    "RPS12 Proteo"
  ],
  "IAH1": [
    "IAH1 CNV",
    "IAH1 RNA",
    "IAH1 Proteo"
  ],
  "NECAB1": [
    "NECAB1 CNV",
    "NECAB1 RNA"
  ],
  "ZNF622": [
    "ZNF622 CNV",
    "ZNF622 RNA",
    "ZNF622 Proteo"
  ],
  "FEM1A": [
    "FEM1A CNV",
    "FEM1A RNA",
    "FEM1A Proteo"
  ],
  "ZACN": [
    "ZACN CNV",
    "ZACN RNA"
  ],
  "CBX1": [
    "CBX1 CNV",
    "CBX1 RNA",
    "CBX1 Proteo"
  ],
  "ZNF48": [
    "ZNF48 CNV",
    "ZNF48 RNA",
    "ZNF48 Proteo"
  ],
  "PXMP2": [
    "PXMP2 CNV",
    "PXMP2 RNA",
    "PXMP2 Proteo"
  ],
  "HMG20B": [
    "HMG20B CNV",
    "HMG20B RNA",
    "HMG20B Proteo"
  ],
  "CACHD1": [
    "CACHD1 CNV",
    "CACHD1 RNA",
    "CACHD1 Proteo"
  ],
  "NMT2": [
    "NMT2 CNV",
    "NMT2 RNA",
    "NMT2 Proteo"
  ],
  "TTLL3": [
    "TTLL3 CNV",
    "TTLL3 RNA"
  ],
  "RPL7AP8": [
    "RPL7AP8 CNV",
    "RPL7AP8 RNA"
  ],
  "SLC18A1": [
    "SLC18A1 CNV",
    "SLC18A1 RNA"
  ],
  "IFFO1": [
    "IFFO1 CNV",
    "IFFO1 RNA",
    "IFFO1 Proteo"
  ],
  "USPL1": [
    "USPL1 CNV",
    "USPL1 RNA"
  ],
  "SH3BGRL": [
    "SH3BGRL CNV",
    "SH3BGRL RNA",
    "SH3BGRL Proteo"
  ],
  "BBIP1": [
    "BBIP1 CNV",
    "BBIP1 RNA"
  ],
  "WNT3": [
    "WNT3 CNV",
    "WNT3 RNA"
  ],
  "GPAA1P1": [
    "GPAA1P1 CNV",
    "GPAA1P1 RNA"
  ],
  "FAM25BP": [
    "FAM25BP CNV",
    "FAM25BP RNA"
  ],
  "POTEKP": [
    "POTEKP CNV",
    "POTEKP RNA"
  ],
  "SLC16A8": [
    "SLC16A8 CNV",
    "SLC16A8 RNA"
  ],
  "KRT24": [
    "KRT24 CNV",
    "KRT24 RNA",
    "KRT24 Proteo"
  ],
  "NDUFV2": [
    "NDUFV2 CNV",
    "NDUFV2 RNA",
    "NDUFV2 Proteo"
  ],
  "NDUFB4P10": [
    "NDUFB4P10 CNV",
    "NDUFB4P10 RNA"
  ],
  "LYRM2": [
    "LYRM2 CNV",
    "LYRM2 RNA",
    "LYRM2 Proteo"
  ],
  "EAPP": [
    "EAPP CNV",
    "EAPP RNA",
    "EAPP Proteo"
  ],
  "PLEK": [
    "PLEK CNV",
    "PLEK RNA",
    "PLEK Proteo"
  ],
  "SEC1P": [
    "SEC1P CNV",
    "SEC1P RNA"
  ],
  "PJA1": [
    "PJA1 CNV",
    "PJA1 RNA",
    "PJA1 Proteo"
  ],
  "KCNK13": [
    "KCNK13 CNV",
    "KCNK13 RNA"
  ],
  "ACE3P": [
    "ACE3P CNV",
    "ACE3P RNA"
  ],
  "CDK2AP2": [
    "CDK2AP2 CNV",
    "CDK2AP2 RNA"
  ],
  "DAZ1": [
    "DAZ1 CNV",
    "DAZ1 RNA"
  ],
  "TRMT10C": [
    "TRMT10C CNV",
    "TRMT10C RNA",
    "TRMT10C Proteo"
  ],
  "KRT8P8": [
    "KRT8P8 CNV",
    "KRT8P8 RNA"
  ],
  "ANKRD18A": [
    "ANKRD18A CNV",
    "ANKRD18A RNA"
  ],
  "HOXC6": [
    "HOXC6 CNV",
    "HOXC6 RNA"
  ],
  "NEFLP1": [
    "NEFLP1 CNV",
    "NEFLP1 RNA"
  ],
  "TUBB8P5": [
    "TUBB8P5 CNV",
    "TUBB8P5 RNA"
  ],
  "ACP4": [
    "ACP4 CNV",
    "ACP4 RNA"
  ],
  "FAM136GP": [
    "FAM136GP CNV",
    "FAM136GP RNA"
  ],
  "C13orf46": [
    "C13orf46 CNV",
    "C13orf46 RNA"
  ],
  "PAPOLB": [
    "PAPOLB CNV",
    "PAPOLB RNA"
  ],
  "MTCO3P5": [
    "MTCO3P5 CNV",
    "MTCO3P5 RNA"
  ],
  "MTND2P5": [
    "MTND2P5 CNV",
    "MTND2P5 RNA"
  ],
  "SPATA20": [
    "SPATA20 CNV",
    "SPATA20 RNA",
    "SPATA20 Proteo"
  ],
  "PMM2": [
    "PMM2 CNV",
    "PMM2 RNA",
    "PMM2 Proteo"
  ],
  "RBFA": [
    "RBFA CNV",
    "RBFA RNA",
    "RBFA Proteo"
  ],
  "GPR143": [
    "GPR143 CNV",
    "GPR143 RNA",
    "GPR143 Proteo"
  ],
  "MSRB3": [
    "MSRB3 CNV",
    "MSRB3 RNA",
    "MSRB3 Proteo"
  ],
  "ZNF101P2": [
    "ZNF101P2 CNV",
    "ZNF101P2 RNA"
  ],
  "C2orf69P3": [
    "C2orf69P3 CNV",
    "C2orf69P3 RNA"
  ],
  "KIR3DX1": [
    "KIR3DX1 CNV",
    "KIR3DX1 RNA"
  ],
  "KRT18P32": [
    "KRT18P32 CNV",
    "KRT18P32 RNA"
  ],
  "MTND2P20": [
    "MTND2P20 CNV",
    "MTND2P20 RNA"
  ],
  "RGS19": [
    "RGS19 CNV",
    "RGS19 RNA",
    "RGS19 Proteo"
  ],
  "RPL35AP20": [
    "RPL35AP20 CNV",
    "RPL35AP20 RNA"
  ],
  "PARP3": [
    "PARP3 CNV",
    "PARP3 RNA"
  ],
  "ALDH3B1": [
    "ALDH3B1 CNV",
    "ALDH3B1 RNA",
    "ALDH3B1 Proteo"
  ],
  "TMCO3": [
    "TMCO3 CNV",
    "TMCO3 RNA",
    "TMCO3 Proteo"
  ],
  "ANKRD61": [
    "ANKRD61 CNV",
    "ANKRD61 RNA"
  ],
  "KLRA1P": [
    "KLRA1P CNV",
    "KLRA1P RNA"
  ],
  "ACAT1": [
    "ACAT1 CNV",
    "ACAT1 RNA",
    "ACAT1 Proteo"
  ],
  "GUSBP17": [
    "GUSBP17 CNV",
    "GUSBP17 RNA"
  ],
  "SERPINE3": [
    "SERPINE3 CNV",
    "SERPINE3 RNA"
  ],
  "CTAGE13P": [
    "CTAGE13P CNV",
    "CTAGE13P RNA"
  ],
  "SUMO2P20": [
    "SUMO2P20 CNV",
    "SUMO2P20 RNA"
  ],
  "TMEM129": [
    "TMEM129 CNV",
    "TMEM129 RNA",
    "TMEM129 Proteo"
  ],
  "SLC12A6": [
    "SLC12A6 CNV",
    "SLC12A6 RNA",
    "SLC12A6 Proteo"
  ],
  "SMARCE1P7": [
    "SMARCE1P7 CNV",
    "SMARCE1P7 RNA"
  ],
  "ZNF726": [
    "ZNF726 CNV",
    "ZNF726 RNA"
  ],
  "MYL5": [
    "MYL5 CNV",
    "MYL5 RNA",
    "MYL5 Proteo"
  ],
  "FAM8A1": [
    "FAM8A1 CNV",
    "FAM8A1 RNA",
    "FAM8A1 Proteo"
  ],
  "DNAJC22": [
    "DNAJC22 CNV",
    "DNAJC22 RNA"
  ],
  "IGHV3-54": [
    "IGHV3-54 CNV",
    "IGHV3-54 RNA"
  ],
  "CYCSP34": [
    "CYCSP34 CNV",
    "CYCSP34 RNA"
  ],
  "SREBF2": [
    "SREBF2 CNV",
    "SREBF2 RNA",
    "SREBF2 Proteo"
  ],
  "PAK5": [
    "PAK5 CNV",
    "PAK5 RNA"
  ],
  "FABP5P1": [
    "FABP5P1 CNV",
    "FABP5P1 RNA"
  ],
  "SALL4P2": [
    "SALL4P2 CNV",
    "SALL4P2 RNA"
  ],
  "CDK5RAP1": [
    "CDK5RAP1 CNV",
    "CDK5RAP1 RNA",
    "CDK5RAP1 Proteo"
  ],
  "LGR4": [
    "LGR4 CNV",
    "LGR4 RNA",
    "LGR4 Proteo"
  ],
  "CPN1": [
    "CPN1 CNV",
    "CPN1 RNA",
    "CPN1 Proteo"
  ],
  "CHST4": [
    "CHST4 CNV",
    "CHST4 RNA"
  ],
  "OR9Q2": [
    "OR9Q2 CNV",
    "OR9Q2 RNA"
  ],
  "PACSIN3": [
    "PACSIN3 CNV",
    "PACSIN3 RNA",
    "PACSIN3 Proteo"
  ],
  "ZW10": [
    "ZW10 CNV",
    "ZW10 RNA",
    "ZW10 Proteo"
  ],
  "GAPDHS": [
    "GAPDHS CNV",
    "GAPDHS RNA",
    "GAPDHS Proteo"
  ],
  "ZFPL1": [
    "ZFPL1 CNV",
    "ZFPL1 RNA",
    "ZFPL1 Proteo"
  ],
  "DNAJB8": [
    "DNAJB8 CNV",
    "DNAJB8 RNA"
  ],
  "HLA-DPA1": [
    "HLA-DPA1 CNV",
    "HLA-DPA1 RNA",
    "HLA-DPA1 Proteo"
  ],
  "GRM2": [
    "GRM2 CNV",
    "GRM2 RNA"
  ],
  "AGER": [
    "AGER CNV",
    "AGER RNA",
    "AGER Proteo"
  ],
  "FAM210CP": [
    "FAM210CP CNV",
    "FAM210CP RNA"
  ],
  "TRIM5": [
    "TRIM5 CNV",
    "TRIM5 RNA",
    "TRIM5 Proteo"
  ],
  "ACVR2A": [
    "ACVR2A CNV",
    "ACVR2A RNA",
    "ACVR2A Proteo"
  ],
  "SMIM45": [
    "SMIM45 CNV",
    "SMIM45 RNA"
  ],
  "XRCC6P2": [
    "XRCC6P2 CNV",
    "XRCC6P2 RNA"
  ],
  "PRKN": [
    "PRKN CNV",
    "PRKN RNA"
  ],
  "SPSB1": [
    "SPSB1 CNV",
    "SPSB1 RNA"
  ],
  "RPL7AP47": [
    "RPL7AP47 CNV",
    "RPL7AP47 RNA"
  ],
  "PDZPH1P": [
    "PDZPH1P CNV",
    "PDZPH1P RNA"
  ],
  "HNRNPRP1": [
    "HNRNPRP1 CNV",
    "HNRNPRP1 RNA"
  ],
  "KREMEN2": [
    "KREMEN2 CNV",
    "KREMEN2 RNA"
  ],
  "CACNA2D1": [
    "CACNA2D1 CNV",
    "CACNA2D1 RNA",
    "CACNA2D1 Proteo"
  ],
  "KATNBL1P2": [
    "KATNBL1P2 CNV",
    "KATNBL1P2 RNA"
  ],
  "CNTNAP2": [
    "CNTNAP2 CNV",
    "CNTNAP2 RNA"
  ],
  "CLIP4": [
    "CLIP4 CNV",
    "CLIP4 RNA",
    "CLIP4 Proteo"
  ],
  "RPL32P15": [
    "RPL32P15 CNV",
    "RPL32P15 RNA"
  ],
  "ZNF814": [
    "ZNF814 CNV",
    "ZNF814 RNA"
  ],
  "HECA": [
    "HECA CNV",
    "HECA RNA",
    "HECA Proteo"
  ],
  "DSN1": [
    "DSN1 CNV",
    "DSN1 RNA",
    "DSN1 Proteo"
  ],
  "PAX1": [
    "PAX1 CNV",
    "PAX1 RNA"
  ],
  "LDHAL6B": [
    "LDHAL6B CNV",
    "LDHAL6B RNA",
    "LDHAL6B Proteo"
  ],
  "CAVIN1": [
    "CAVIN1 CNV",
    "CAVIN1 RNA",
    "CAVIN1 Proteo"
  ],
  "TMEM240": [
    "TMEM240 CNV",
    "TMEM240 RNA"
  ],
  "CHST7": [
    "CHST7 CNV",
    "CHST7 RNA",
    "CHST7 Proteo"
  ],
  "CCN1": [
    "CCN1 CNV",
    "CCN1 RNA",
    "CCN1 Proteo"
  ],
  "IZUMO3": [
    "IZUMO3 CNV",
    "IZUMO3 RNA"
  ],
  "IGHVII-40-1": [
    "IGHVII-40-1 CNV",
    "IGHVII-40-1 RNA"
  ],
  "KRT39": [
    "KRT39 CNV",
    "KRT39 RNA"
  ],
  "ANKRD18B": [
    "ANKRD18B CNV",
    "ANKRD18B RNA"
  ],
  "BTG3": [
    "BTG3 CNV",
    "BTG3 RNA",
    "BTG3 Proteo"
  ],
  "CDCA3": [
    "CDCA3 CNV",
    "CDCA3 RNA",
    "CDCA3 Proteo"
  ],
  "BTN2A3P": [
    "BTN2A3P CNV",
    "BTN2A3P RNA"
  ],
  "SP3": [
    "SP3 CNV",
    "SP3 RNA",
    "SP3 Proteo"
  ],
  "PLSCR4": [
    "PLSCR4 CNV",
    "PLSCR4 RNA",
    "PLSCR4 Proteo"
  ],
  "PRPH2": [
    "PRPH2 CNV",
    "PRPH2 RNA"
  ],
  "KCNG3": [
    "KCNG3 CNV",
    "KCNG3 RNA"
  ],
  "BMS1P20": [
    "BMS1P20 CNV",
    "BMS1P20 RNA"
  ],
  "CSTP2": [
    "CSTP2 CNV",
    "CSTP2 RNA"
  ],
  "MBNL2": [
    "MBNL2 CNV",
    "MBNL2 RNA",
    "MBNL2 Proteo"
  ],
  "GAL3ST2": [
    "GAL3ST2 CNV",
    "GAL3ST2 RNA"
  ],
  "KRTAP19-2": [
    "KRTAP19-2 CNV",
    "KRTAP19-2 RNA"
  ],
  "CWC15": [
    "CWC15 CNV",
    "CWC15 RNA",
    "CWC15 Proteo"
  ],
  "ARL6IP1P1": [
    "ARL6IP1P1 CNV",
    "ARL6IP1P1 RNA"
  ],
  "MRPL53P1": [
    "MRPL53P1 CNV",
    "MRPL53P1 RNA"
  ],
  "GLRA3": [
    "GLRA3 CNV",
    "GLRA3 RNA"
  ],
  "GLP2R": [
    "GLP2R CNV",
    "GLP2R RNA"
  ],
  "PCDHB3": [
    "PCDHB3 CNV",
    "PCDHB3 RNA",
    "PCDHB3 Proteo"
  ],
  "ARMC3": [
    "ARMC3 CNV",
    "ARMC3 RNA"
  ],
  "DPP9": [
    "DPP9 CNV",
    "DPP9 RNA",
    "DPP9 Proteo"
  ],
  "PRMT5": [
    "PRMT5 CNV",
    "PRMT5 RNA",
    "PRMT5 Proteo"
  ],
  "CHAF1B": [
    "CHAF1B CNV",
    "CHAF1B RNA",
    "CHAF1B Proteo"
  ],
  "PFDN6": [
    "PFDN6 CNV",
    "PFDN6 RNA",
    "PFDN6 Proteo"
  ],
  "PTCD1": [
    "PTCD1 CNV",
    "PTCD1 RNA"
  ],
  "ZDHHC6": [
    "ZDHHC6 CNV",
    "ZDHHC6 RNA",
    "ZDHHC6 Proteo"
  ],
  "HTR1B": [
    "HTR1B CNV",
    "HTR1B RNA"
  ],
  "CLIC5": [
    "CLIC5 CNV",
    "CLIC5 RNA",
    "CLIC5 Proteo"
  ],
  "ZNF26": [
    "ZNF26 CNV",
    "ZNF26 RNA"
  ],
  "CNTFR": [
    "CNTFR CNV",
    "CNTFR RNA",
    "CNTFR Proteo"
  ],
  "RNF19A": [
    "RNF19A CNV",
    "RNF19A RNA",
    "RNF19A Proteo"
  ],
  "SPATC1L": [
    "SPATC1L CNV",
    "SPATC1L RNA"
  ],
  "RPSAP45": [
    "RPSAP45 CNV",
    "RPSAP45 RNA"
  ],
  "FAM8A6P": [
    "FAM8A6P CNV",
    "FAM8A6P RNA"
  ],
  "H4C10P": [
    "H4C10P CNV",
    "H4C10P RNA"
  ],
  "MCUR1": [
    "MCUR1 CNV",
    "MCUR1 RNA",
    "MCUR1 Proteo"
  ],
  "SDHDP5": [
    "SDHDP5 CNV",
    "SDHDP5 RNA"
  ],
  "PRKAR2A": [
    "PRKAR2A CNV",
    "PRKAR2A RNA",
    "PRKAR2A Proteo"
  ],
  "OR52V1P": [
    "OR52V1P CNV",
    "OR52V1P RNA"
  ],
  "MUC22": [
    "MUC22 CNV",
    "MUC22 RNA"
  ],
  "SFTPD": [
    "SFTPD CNV",
    "SFTPD RNA",
    "SFTPD Proteo"
  ],
  "OPHN1": [
    "OPHN1 CNV",
    "OPHN1 RNA",
    "OPHN1 Proteo"
  ],
  "MYBL1": [
    "MYBL1 CNV",
    "MYBL1 RNA"
  ],
  "EID1": [
    "EID1 CNV",
    "EID1 RNA"
  ],
  "MINPP1": [
    "MINPP1 CNV",
    "MINPP1 RNA",
    "MINPP1 Proteo"
  ],
  "RNA5SP210": [
    "RNA5SP210 CNV",
    "RNA5SP210 RNA"
  ],
  "PTPN6": [
    "PTPN6 CNV",
    "PTPN6 RNA",
    "PTPN6 Proteo"
  ],
  "SMIM13": [
    "SMIM13 CNV",
    "SMIM13 RNA",
    "SMIM13 Proteo"
  ],
  "HYAL2": [
    "HYAL2 CNV",
    "HYAL2 RNA",
    "HYAL2 Proteo"
  ],
  "IFIT2": [
    "IFIT2 CNV",
    "IFIT2 RNA",
    "IFIT2 Proteo"
  ],
  "NECTIN1": [
    "NECTIN1 CNV",
    "NECTIN1 RNA",
    "NECTIN1 Proteo"
  ],
  "H3C5P": [
    "H3C5P CNV",
    "H3C5P RNA"
  ],
  "LAMA1": [
    "LAMA1 CNV",
    "LAMA1 RNA",
    "LAMA1 Proteo"
  ],
  "GNLY": [
    "GNLY CNV",
    "GNLY RNA",
    "GNLY Proteo"
  ],
  "GTF2IP9": [
    "GTF2IP9 CNV",
    "GTF2IP9 RNA"
  ],
  "KIF12": [
    "KIF12 CNV",
    "KIF12 RNA"
  ],
  "HTRA2": [
    "HTRA2 CNV",
    "HTRA2 RNA",
    "HTRA2 Proteo"
  ],
  "NOL6": [
    "NOL6 CNV",
    "NOL6 RNA",
    "NOL6 Proteo"
  ],
  "DDX25": [
    "DDX25 CNV",
    "DDX25 RNA",
    "DDX25 Proteo"
  ],
  "ZNF33CP": [
    "ZNF33CP CNV",
    "ZNF33CP RNA"
  ],
  "TRAF6": [
    "TRAF6 CNV",
    "TRAF6 RNA",
    "TRAF6 Proteo"
  ],
  "TRIM38": [
    "TRIM38 CNV",
    "TRIM38 RNA",
    "TRIM38 Proteo"
  ],
  "FOXD1": [
    "FOXD1 CNV",
    "FOXD1 RNA"
  ],
  "C10orf88B": [
    "C10orf88B CNV",
    "C10orf88B RNA"
  ],
  "S1PR1": [
    "S1PR1 CNV",
    "S1PR1 RNA"
  ],
  "NOTCH2NLB": [
    "NOTCH2NLB CNV",
    "NOTCH2NLB RNA"
  ],
  "COX6B1P3": [
    "COX6B1P3 CNV",
    "COX6B1P3 RNA"
  ],
  "GSTM4": [
    "GSTM4 CNV",
    "GSTM4 RNA",
    "GSTM4 Proteo"
  ],
  "TTLL2": [
    "TTLL2 CNV",
    "TTLL2 RNA"
  ],
  "NLRP12": [
    "NLRP12 CNV",
    "NLRP12 RNA"
  ],
  "TNFAIP8L2": [
    "TNFAIP8L2 CNV",
    "TNFAIP8L2 RNA",
    "TNFAIP8L2 Proteo"
  ],
  "EEF1DP5": [
    "EEF1DP5 CNV",
    "EEF1DP5 RNA"
  ],
  "PAXBP1": [
    "PAXBP1 CNV",
    "PAXBP1 RNA",
    "PAXBP1 Proteo"
  ],
  "FTLP2": [
    "FTLP2 CNV",
    "FTLP2 RNA"
  ],
  "OOSP1": [
    "OOSP1 CNV",
    "OOSP1 RNA"
  ],
  "NUDT17": [
    "NUDT17 CNV",
    "NUDT17 RNA"
  ],
  "CHRM4": [
    "CHRM4 CNV",
    "CHRM4 RNA"
  ],
  "UMOD": [
    "UMOD CNV",
    "UMOD RNA"
  ],
  "LGMNP1": [
    "LGMNP1 CNV",
    "LGMNP1 RNA"
  ],
  "ARHGAP11A": [
    "ARHGAP11A CNV",
    "ARHGAP11A RNA",
    "ARHGAP11A Proteo"
  ],
  "OR2A14": [
    "OR2A14 CNV",
    "OR2A14 RNA"
  ],
  "FAM83H": [
    "FAM83H CNV",
    "FAM83H RNA",
    "FAM83H Proteo"
  ],
  "PLCZ1": [
    "PLCZ1 CNV",
    "PLCZ1 RNA"
  ],
  "NOTO": [
    "NOTO CNV",
    "NOTO RNA"
  ],
  "NBAS": [
    "NBAS CNV",
    "NBAS RNA",
    "NBAS Proteo"
  ],
  "OR51A9P": [
    "OR51A9P CNV",
    "OR51A9P RNA"
  ],
  "THUMPD1P1": [
    "THUMPD1P1 CNV",
    "THUMPD1P1 RNA"
  ],
  "CELF3": [
    "CELF3 CNV",
    "CELF3 RNA"
  ],
  "KRT18P7": [
    "KRT18P7 CNV",
    "KRT18P7 RNA"
  ],
  "IGHV1-2": [
    "IGHV1-2 Proteo"
  ],
  "EVA1CP3": [
    "EVA1CP3 CNV",
    "EVA1CP3 RNA"
  ],
  "OR10AH1P": [
    "OR10AH1P CNV",
    "OR10AH1P RNA"
  ],
  "CEP164P1": [
    "CEP164P1 CNV",
    "CEP164P1 RNA"
  ],
  "TRIM66": [
    "TRIM66 CNV",
    "TRIM66 RNA"
  ],
  "LYST": [
    "LYST CNV",
    "LYST RNA",
    "LYST Proteo"
  ],
  "ZP2": [
    "ZP2 CNV",
    "ZP2 RNA"
  ],
  "PGLYRP4": [
    "PGLYRP4 CNV",
    "PGLYRP4 RNA"
  ],
  "SPEM1": [
    "SPEM1 CNV",
    "SPEM1 RNA"
  ],
  "VNN3P": [
    "VNN3P CNV",
    "VNN3P RNA"
  ],
  "MTCO3P39": [
    "MTCO3P39 CNV",
    "MTCO3P39 RNA"
  ],
  "SPACA6": [
    "SPACA6 CNV",
    "SPACA6 RNA"
  ],
  "ZNF729": [
    "ZNF729 CNV",
    "ZNF729 RNA"
  ],
  "TAOK3": [
    "TAOK3 CNV",
    "TAOK3 RNA",
    "TAOK3 Proteo"
  ],
  "DDX11L1": [
    "DDX11L1 CNV",
    "DDX11L1 RNA"
  ],
  "SLC6A19": [
    "SLC6A19 CNV",
    "SLC6A19 RNA"
  ],
  "FBXL12P1": [
    "FBXL12P1 CNV",
    "FBXL12P1 RNA"
  ],
  "ZNF81": [
    "ZNF81 CNV",
    "ZNF81 RNA"
  ],
  "EPHB4": [
    "EPHB4 CNV",
    "EPHB4 RNA",
    "EPHB4 Proteo"
  ],
  "RNF183": [
    "RNF183 CNV",
    "RNF183 RNA"
  ],
  "KHDC4": [
    "KHDC4 CNV",
    "KHDC4 RNA",
    "KHDC4 Proteo"
  ],
  "VAV2": [
    "VAV2 CNV",
    "VAV2 RNA",
    "VAV2 Proteo"
  ],
  "UBE2V1P2": [
    "UBE2V1P2 CNV",
    "UBE2V1P2 RNA"
  ],
  "CKM": [
    "CKM CNV",
    "CKM RNA",
    "CKM Proteo"
  ],
  "BTBD10P1": [
    "BTBD10P1 CNV",
    "BTBD10P1 RNA"
  ],
  "H2AC1": [
    "H2AC1 CNV",
    "H2AC1 RNA"
  ],
  "PCSK2": [
    "PCSK2 CNV",
    "PCSK2 RNA"
  ],
  "H2AC20": [
    "H2AC20 CNV",
    "H2AC20 RNA",
    "H2AC20 Proteo"
  ],
  "MTND1P30": [
    "MTND1P30 CNV",
    "MTND1P30 RNA"
  ],
  "COX6CP7": [
    "COX6CP7 CNV",
    "COX6CP7 RNA"
  ],
  "CENPI": [
    "CENPI CNV",
    "CENPI RNA",
    "CENPI Proteo"
  ],
  "RNA5SP407": [
    "RNA5SP407 CNV",
    "RNA5SP407 RNA"
  ],
  "MYL3": [
    "MYL3 CNV",
    "MYL3 RNA",
    "MYL3 Proteo"
  ],
  "NDUFA10": [
    "NDUFA10 CNV",
    "NDUFA10 RNA",
    "NDUFA10 Proteo"
  ],
  "RPL22": [
    "RPL22 CNV",
    "RPL22 RNA",
    "RPL22 Proteo"
  ],
  "ANXA5": [
    "ANXA5 CNV",
    "ANXA5 RNA",
    "ANXA5 Proteo"
  ],
  "FLT3": [
    "FLT3 CNV",
    "FLT3 RNA"
  ],
  "PGLYRP1": [
    "PGLYRP1 CNV",
    "PGLYRP1 RNA",
    "PGLYRP1 Proteo"
  ],
  "ZNF691": [
    "ZNF691 CNV",
    "ZNF691 RNA",
    "ZNF691 Proteo"
  ],
  "ZNF807P": [
    "ZNF807P CNV",
    "ZNF807P RNA"
  ],
  "MISP3": [
    "MISP3 CNV",
    "MISP3 RNA",
    "MISP3 Proteo"
  ],
  "MEP1A": [
    "MEP1A CNV",
    "MEP1A RNA"
  ],
  "CLDN8": [
    "CLDN8 CNV",
    "CLDN8 RNA"
  ],
  "HOXC11": [
    "HOXC11 CNV",
    "HOXC11 RNA"
  ],
  "RASA1": [
    "RASA1 CNV",
    "RASA1 RNA",
    "RASA1 Proteo"
  ],
  "FPR3": [
    "FPR3 CNV",
    "FPR3 RNA",
    "FPR3 Proteo"
  ],
  "ELL3": [
    "ELL3 CNV",
    "ELL3 RNA"
  ],
  "NFU1P2": [
    "NFU1P2 CNV",
    "NFU1P2 RNA"
  ],
  "ADAM6": [
    "ADAM6 CNV",
    "ADAM6 RNA"
  ],
  "CICP1": [
    "CICP1 CNV",
    "CICP1 RNA"
  ],
  "AIP": [
    "AIP CNV",
    "AIP RNA",
    "AIP Proteo"
  ],
  "CDY11P": [
    "CDY11P CNV",
    "CDY11P RNA"
  ],
  "MT-ND3": [
    "MT-ND3 RNA",
    "MT-ND3 Proteo"
  ],
  "ITGB8": [
    "ITGB8 CNV",
    "ITGB8 RNA",
    "ITGB8 Proteo"
  ],
  "WFDC3": [
    "WFDC3 CNV",
    "WFDC3 RNA"
  ],
  "KIF2B": [
    "KIF2B CNV",
    "KIF2B RNA"
  ],
  "FAR1P1": [
    "FAR1P1 CNV",
    "FAR1P1 RNA"
  ],
  "SLC7A6": [
    "SLC7A6 CNV",
    "SLC7A6 RNA",
    "SLC7A6 Proteo"
  ],
  "PANK4": [
    "PANK4 CNV",
    "PANK4 RNA",
    "PANK4 Proteo"
  ],
  "OCM2": [
    "OCM2 CNV",
    "OCM2 RNA"
  ],
  "SLIRPP2": [
    "SLIRPP2 CNV",
    "SLIRPP2 RNA"
  ],
  "MIPOL1": [
    "MIPOL1 CNV",
    "MIPOL1 RNA"
  ],
  "SERBP1P4": [
    "SERBP1P4 CNV",
    "SERBP1P4 RNA"
  ],
  "FAM227B": [
    "FAM227B CNV",
    "FAM227B RNA"
  ],
  "SUMO2P1": [
    "SUMO2P1 CNV",
    "SUMO2P1 RNA"
  ],
  "YWHAQP7": [
    "YWHAQP7 CNV",
    "YWHAQP7 RNA"
  ],
  "DOK4": [
    "DOK4 CNV",
    "DOK4 RNA"
  ],
  "SLC12A7": [
    "SLC12A7 CNV",
    "SLC12A7 RNA",
    "SLC12A7 Proteo"
  ],
  "HTD2": [
    "HTD2 CNV",
    "HTD2 RNA",
    "HTD2 Proteo"
  ],
  "FABP7P2": [
    "FABP7P2 CNV",
    "FABP7P2 RNA"
  ],
  "XKR7": [
    "XKR7 CNV",
    "XKR7 RNA"
  ],
  "PTPRG": [
    "PTPRG CNV",
    "PTPRG RNA",
    "PTPRG Proteo"
  ],
  "TRBV21OR9-2": [
    "TRBV21OR9-2 CNV",
    "TRBV21OR9-2 RNA"
  ],
  "TUBE1": [
    "TUBE1 CNV",
    "TUBE1 RNA",
    "TUBE1 Proteo"
  ],
  "GLUD2": [
    "GLUD2 CNV",
    "GLUD2 RNA",
    "GLUD2 Proteo"
  ],
  "AOPEP": [
    "AOPEP CNV",
    "AOPEP RNA"
  ],
  "RPS17P2": [
    "RPS17P2 CNV",
    "RPS17P2 RNA"
  ],
  "IGLVIV-66-1": [
    "IGLVIV-66-1 CNV",
    "IGLVIV-66-1 RNA"
  ],
  "MDFI": [
    "MDFI CNV",
    "MDFI RNA"
  ],
  "OR2V1": [
    "OR2V1 CNV",
    "OR2V1 RNA"
  ],
  "SS18L2": [
    "SS18L2 CNV",
    "SS18L2 RNA",
    "SS18L2 Proteo"
  ],
  "MFSD8": [
    "MFSD8 CNV",
    "MFSD8 RNA",
    "MFSD8 Proteo"
  ],
  "RAB29": [
    "RAB29 CNV",
    "RAB29 RNA",
    "RAB29 Proteo"
  ],
  "OSBPL11": [
    "OSBPL11 CNV",
    "OSBPL11 RNA",
    "OSBPL11 Proteo"
  ],
  "PGM2": [
    "PGM2 CNV",
    "PGM2 RNA",
    "PGM2 Proteo"
  ],
  "ANXA8L1": [
    "ANXA8L1 CNV",
    "ANXA8L1 RNA",
    "ANXA8L1 Proteo"
  ],
  "SPATA12": [
    "SPATA12 CNV",
    "SPATA12 RNA"
  ],
  "LITAF": [
    "LITAF CNV",
    "LITAF RNA",
    "LITAF Proteo"
  ],
  "IGHV1OR16-4": [
    "IGHV1OR16-4 CNV",
    "IGHV1OR16-4 RNA"
  ],
  "STXBP4": [
    "STXBP4 CNV",
    "STXBP4 RNA",
    "STXBP4 Proteo"
  ],
  "SERINC5": [
    "SERINC5 CNV",
    "SERINC5 RNA",
    "SERINC5 Proteo"
  ],
  "NME1-NME2": [
    "NME1-NME2 Proteo"
  ],
  "DAND5": [
    "DAND5 CNV",
    "DAND5 RNA"
  ],
  "PGBD4": [
    "PGBD4 CNV",
    "PGBD4 RNA",
    "PGBD4 Proteo"
  ],
  "TGFB1I1": [
    "TGFB1I1 CNV",
    "TGFB1I1 RNA",
    "TGFB1I1 Proteo"
  ],
  "QKI": [
    "QKI CNV",
    "QKI RNA",
    "QKI Proteo"
  ],
  "INPP5J": [
    "INPP5J CNV",
    "INPP5J RNA"
  ],
  "DPH3P1": [
    "DPH3P1 CNV",
    "DPH3P1 RNA"
  ],
  "ZNF492": [
    "ZNF492 CNV",
    "ZNF492 RNA"
  ],
  "SLC16A14P1": [
    "SLC16A14P1 CNV",
    "SLC16A14P1 RNA"
  ],
  "MTND1P5": [
    "MTND1P5 CNV",
    "MTND1P5 RNA"
  ],
  "MTND1P12": [
    "MTND1P12 CNV",
    "MTND1P12 RNA"
  ],
  "FBLN1": [
    "FBLN1 CNV",
    "FBLN1 RNA",
    "FBLN1 Proteo"
  ],
  "NF1P6": [
    "NF1P6 CNV",
    "NF1P6 RNA"
  ],
  "SNX18P3": [
    "SNX18P3 CNV",
    "SNX18P3 RNA"
  ],
  "COQ3": [
    "COQ3 CNV",
    "COQ3 RNA",
    "COQ3 Proteo"
  ],
  "BSNDP1": [
    "BSNDP1 CNV",
    "BSNDP1 RNA"
  ],
  "OR6K4P": [
    "OR6K4P CNV",
    "OR6K4P RNA"
  ],
  "SELL": [
    "SELL CNV",
    "SELL RNA",
    "SELL Proteo"
  ],
  "MTND4P31": [
    "MTND4P31 CNV",
    "MTND4P31 RNA"
  ],
  "PCDHGB6": [
    "PCDHGB6 CNV",
    "PCDHGB6 RNA",
    "PCDHGB6 Proteo"
  ],
  "PLAT": [
    "PLAT CNV",
    "PLAT RNA",
    "PLAT Proteo"
  ],
  "UBXN11": [
    "UBXN11 CNV",
    "UBXN11 RNA",
    "UBXN11 Proteo"
  ],
  "SLC2A12": [
    "SLC2A12 CNV",
    "SLC2A12 RNA"
  ],
  "BRINP2": [
    "BRINP2 CNV",
    "BRINP2 RNA"
  ],
  "RNF44": [
    "RNF44 CNV",
    "RNF44 RNA"
  ],
  "NADK2": [
    "NADK2 CNV",
    "NADK2 RNA",
    "NADK2 Proteo"
  ],
  "MECR": [
    "MECR CNV",
    "MECR RNA",
    "MECR Proteo"
  ],
  "KCNA6": [
    "KCNA6 CNV",
    "KCNA6 RNA"
  ],
  "CYP2C19": [
    "CYP2C19 CNV",
    "CYP2C19 RNA"
  ],
  "VENTXP4": [
    "VENTXP4 CNV",
    "VENTXP4 RNA"
  ],
  "ZBTB16": [
    "ZBTB16 CNV",
    "ZBTB16 RNA"
  ],
  "PHF11": [
    "PHF11 CNV",
    "PHF11 RNA",
    "PHF11 Proteo"
  ],
  "PWWP4": [
    "PWWP4 CNV",
    "PWWP4 RNA"
  ],
  "AMOTL1": [
    "AMOTL1 CNV",
    "AMOTL1 RNA",
    "AMOTL1 Proteo"
  ],
  "KRTAP20-3": [
    "KRTAP20-3 CNV",
    "KRTAP20-3 RNA"
  ],
  "GPT2": [
    "GPT2 CNV",
    "GPT2 RNA",
    "GPT2 Proteo"
  ],
  "RNA5SP90": [
    "RNA5SP90 CNV",
    "RNA5SP90 RNA"
  ],
  "NT5DC4": [
    "NT5DC4 CNV",
    "NT5DC4 RNA"
  ],
  "HABP4": [
    "HABP4 CNV",
    "HABP4 RNA",
    "HABP4 Proteo"
  ],
  "LRRC3": [
    "LRRC3 CNV",
    "LRRC3 RNA"
  ],
  "OR4C4P": [
    "OR4C4P CNV",
    "OR4C4P RNA"
  ],
  "AZGP1P1": [
    "AZGP1P1 CNV",
    "AZGP1P1 RNA"
  ],
  "MTND1P1": [
    "MTND1P1 CNV",
    "MTND1P1 RNA"
  ],
  "SH3YL1": [
    "SH3YL1 CNV",
    "SH3YL1 RNA",
    "SH3YL1 Proteo"
  ],
  "PFDN4": [
    "PFDN4 CNV",
    "PFDN4 RNA",
    "PFDN4 Proteo"
  ],
  "TMEM191B": [
    "TMEM191B CNV",
    "TMEM191B RNA"
  ],
  "SPINK8": [
    "SPINK8 CNV",
    "SPINK8 RNA"
  ],
  "AMMECR1L": [
    "AMMECR1L CNV",
    "AMMECR1L RNA",
    "AMMECR1L Proteo"
  ],
  "HMGN2P34": [
    "HMGN2P34 CNV",
    "HMGN2P34 RNA"
  ],
  "MYCN": [
    "MYCN CNV",
    "MYCN RNA"
  ],
  "TIMM10": [
    "TIMM10 CNV",
    "TIMM10 RNA",
    "TIMM10 Proteo"
  ],
  "RAD23BP1": [
    "RAD23BP1 CNV",
    "RAD23BP1 RNA"
  ],
  "GPC6": [
    "GPC6 CNV",
    "GPC6 RNA",
    "GPC6 Proteo"
  ],
  "CEP250": [
    "CEP250 CNV",
    "CEP250 RNA",
    "CEP250 Proteo"
  ],
  "IGHV1-17": [
    "IGHV1-17 CNV",
    "IGHV1-17 RNA"
  ],
  "UST": [
    "UST CNV",
    "UST RNA",
    "UST Proteo"
  ],
  "TAGLN2P1": [
    "TAGLN2P1 CNV",
    "TAGLN2P1 RNA"
  ],
  "EVC2": [
    "EVC2 CNV",
    "EVC2 RNA",
    "EVC2 Proteo"
  ],
  "RPS24P7": [
    "RPS24P7 CNV",
    "RPS24P7 RNA"
  ],
  "NLRC3": [
    "NLRC3 CNV",
    "NLRC3 RNA",
    "NLRC3 Proteo"
  ],
  "UBR1": [
    "UBR1 CNV",
    "UBR1 RNA",
    "UBR1 Proteo"
  ],
  "HNRNPA3P7": [
    "HNRNPA3P7 CNV",
    "HNRNPA3P7 RNA"
  ],
  "ZSWIM5": [
    "ZSWIM5 CNV",
    "ZSWIM5 RNA"
  ],
  "LY6E": [
    "LY6E CNV",
    "LY6E RNA",
    "LY6E Proteo"
  ],
  "DHRS2": [
    "DHRS2 CNV",
    "DHRS2 RNA",
    "DHRS2 Proteo"
  ],
  "OR5H1": [
    "OR5H1 CNV",
    "OR5H1 RNA"
  ],
  "RPSAP12": [
    "RPSAP12 CNV",
    "RPSAP12 RNA"
  ],
  "ZFYVE21": [
    "ZFYVE21 CNV",
    "ZFYVE21 RNA",
    "ZFYVE21 Proteo"
  ],
  "KMT2B": [
    "KMT2B CNV",
    "KMT2B RNA",
    "KMT2B Proteo"
  ],
  "C5orf52": [
    "C5orf52 CNV",
    "C5orf52 RNA"
  ],
  "TTC8": [
    "TTC8 CNV",
    "TTC8 RNA",
    "TTC8 Proteo"
  ],
  "GPR135": [
    "GPR135 CNV",
    "GPR135 RNA"
  ],
  "RPS3AP18": [
    "RPS3AP18 CNV",
    "RPS3AP18 RNA"
  ],
  "RBMX2": [
    "RBMX2 CNV",
    "RBMX2 RNA",
    "RBMX2 Proteo"
  ],
  "SLC30A2": [
    "SLC30A2 CNV",
    "SLC30A2 RNA"
  ],
  "OR2T33": [
    "OR2T33 CNV",
    "OR2T33 RNA"
  ],
  "PRAMEF32P": [
    "PRAMEF32P CNV",
    "PRAMEF32P RNA"
  ],
  "ANXA2R": [
    "ANXA2R CNV",
    "ANXA2R RNA"
  ],
  "TNC": [
    "TNC CNV",
    "TNC RNA",
    "TNC Proteo"
  ],
  "HIGD1AP4": [
    "HIGD1AP4 CNV",
    "HIGD1AP4 RNA"
  ],
  "PRODH": [
    "PRODH CNV",
    "PRODH RNA",
    "PRODH Proteo"
  ],
  "TMEM80": [
    "TMEM80 CNV",
    "TMEM80 RNA"
  ],
  "IGKV2OR2-10": [
    "IGKV2OR2-10 CNV",
    "IGKV2OR2-10 RNA"
  ],
  "KRTAP27-1": [
    "KRTAP27-1 CNV",
    "KRTAP27-1 RNA"
  ],
  "ZNF343": [
    "ZNF343 CNV",
    "ZNF343 RNA"
  ],
  "TRPM5": [
    "TRPM5 CNV",
    "TRPM5 RNA"
  ],
  "CCN6": [
    "CCN6 CNV",
    "CCN6 RNA"
  ],
  "IQCF3": [
    "IQCF3 CNV",
    "IQCF3 RNA"
  ],
  "ZBED8": [
    "ZBED8 CNV",
    "ZBED8 RNA",
    "ZBED8 Proteo"
  ],
  "RPS27P27": [
    "RPS27P27 CNV",
    "RPS27P27 RNA"
  ],
  "SLC25A16": [
    "SLC25A16 CNV",
    "SLC25A16 RNA",
    "SLC25A16 Proteo"
  ],
  "NAMPT": [
    "NAMPT CNV",
    "NAMPT RNA",
    "NAMPT Proteo"
  ],
  "SHTN1": [
    "SHTN1 CNV",
    "SHTN1 RNA",
    "SHTN1 Proteo"
  ],
  "RPL23AP35": [
    "RPL23AP35 CNV",
    "RPL23AP35 RNA"
  ],
  "GBP4": [
    "GBP4 CNV",
    "GBP4 RNA",
    "GBP4 Proteo"
  ],
  "MED15P1": [
    "MED15P1 CNV",
    "MED15P1 RNA"
  ],
  "MAPK6P1": [
    "MAPK6P1 CNV",
    "MAPK6P1 RNA"
  ],
  "PRMT3": [
    "PRMT3 CNV",
    "PRMT3 RNA",
    "PRMT3 Proteo"
  ],
  "HMGA1": [
    "HMGA1 CNV",
    "HMGA1 RNA",
    "HMGA1 Proteo"
  ],
  "TPT1P14": [
    "TPT1P14 CNV",
    "TPT1P14 RNA"
  ],
  "EEF1A1P38": [
    "EEF1A1P38 CNV",
    "EEF1A1P38 RNA"
  ],
  "TBC1D22A": [
    "TBC1D22A CNV",
    "TBC1D22A RNA",
    "TBC1D22A Proteo"
  ],
  "PRR23B": [
    "PRR23B CNV",
    "PRR23B RNA"
  ],
  "NANS": [
    "NANS CNV",
    "NANS RNA",
    "NANS Proteo"
  ],
  "LSM8": [
    "LSM8 CNV",
    "LSM8 RNA",
    "LSM8 Proteo"
  ],
  "TEKT5": [
    "TEKT5 CNV",
    "TEKT5 RNA"
  ],
  "CXorf51B": [
    "CXorf51B CNV",
    "CXorf51B RNA"
  ],
  "OR8D4": [
    "OR8D4 CNV",
    "OR8D4 RNA"
  ],
  "GPSM3": [
    "GPSM3 CNV",
    "GPSM3 RNA",
    "GPSM3 Proteo"
  ],
  "TMEM50A": [
    "TMEM50A CNV",
    "TMEM50A RNA",
    "TMEM50A Proteo"
  ],
  "TRIP11": [
    "TRIP11 CNV",
    "TRIP11 RNA",
    "TRIP11 Proteo"
  ],
  "NLRP8": [
    "NLRP8 CNV",
    "NLRP8 RNA"
  ],
  "C9orf78": [
    "C9orf78 CNV",
    "C9orf78 RNA",
    "C9orf78 Proteo"
  ],
  "SUMO1": [
    "SUMO1 CNV",
    "SUMO1 RNA",
    "SUMO1 Proteo"
  ],
  "KDM4C": [
    "KDM4C CNV",
    "KDM4C RNA",
    "KDM4C Proteo"
  ],
  "SERPINA1": [
    "SERPINA1 CNV",
    "SERPINA1 RNA",
    "SERPINA1 Proteo"
  ],
  "IFI16": [
    "IFI16 CNV",
    "IFI16 RNA",
    "IFI16 Proteo"
  ],
  "DNAJC12": [
    "DNAJC12 CNV",
    "DNAJC12 RNA",
    "DNAJC12 Proteo"
  ],
  "CCDC13": [
    "CCDC13 CNV",
    "CCDC13 RNA"
  ],
  "SLC7A10": [
    "SLC7A10 CNV",
    "SLC7A10 RNA"
  ],
  "PSMD10": [
    "PSMD10 CNV",
    "PSMD10 RNA",
    "PSMD10 Proteo"
  ],
  "RUVBL2P1": [
    "RUVBL2P1 CNV",
    "RUVBL2P1 RNA"
  ],
  "LIMA1": [
    "LIMA1 CNV",
    "LIMA1 RNA",
    "LIMA1 Proteo"
  ],
  "RPL3P10": [
    "RPL3P10 CNV",
    "RPL3P10 RNA"
  ],
  "CHRM3": [
    "CHRM3 CNV",
    "CHRM3 RNA"
  ],
  "PIP5KL1": [
    "PIP5KL1 CNV",
    "PIP5KL1 RNA"
  ],
  "LKAAEAR1": [
    "LKAAEAR1 CNV",
    "LKAAEAR1 RNA"
  ],
  "FADS6": [
    "FADS6 CNV",
    "FADS6 RNA",
    "FADS6 Proteo"
  ],
  "MUC17": [
    "MUC17 CNV",
    "MUC17 RNA"
  ],
  "FMO2": [
    "FMO2 CNV",
    "FMO2 RNA"
  ],
  "VN1R71P": [
    "VN1R71P CNV",
    "VN1R71P RNA"
  ],
  "EMC4": [
    "EMC4 CNV",
    "EMC4 RNA",
    "EMC4 Proteo"
  ],
  "CCDC138": [
    "CCDC138 CNV",
    "CCDC138 RNA",
    "CCDC138 Proteo"
  ],
  "CYCSP28": [
    "CYCSP28 CNV",
    "CYCSP28 RNA"
  ],
  "SS18L2P1": [
    "SS18L2P1 CNV",
    "SS18L2P1 RNA"
  ],
  "STPG3": [
    "STPG3 CNV",
    "STPG3 RNA"
  ],
  "HOXA7": [
    "HOXA7 CNV",
    "HOXA7 RNA"
  ],
  "COPG1": [
    "COPG1 CNV",
    "COPG1 RNA",
    "COPG1 Proteo"
  ],
  "COQ6": [
    "COQ6 CNV",
    "COQ6 RNA",
    "COQ6 Proteo"
  ],
  "ATOX1": [
    "ATOX1 CNV",
    "ATOX1 RNA",
    "ATOX1 Proteo"
  ],
  "BTF3": [
    "BTF3 CNV",
    "BTF3 RNA",
    "BTF3 Proteo"
  ],
  "CTNNBL1P1": [
    "CTNNBL1P1 CNV",
    "CTNNBL1P1 RNA"
  ],
  "IGKV2-14": [
    "IGKV2-14 CNV",
    "IGKV2-14 RNA"
  ],
  "DMAC2L": [
    "DMAC2L CNV",
    "DMAC2L RNA",
    "DMAC2L Proteo"
  ],
  "GGT5": [
    "GGT5 CNV",
    "GGT5 RNA",
    "GGT5 Proteo"
  ],
  "PRDX1": [
    "PRDX1 CNV",
    "PRDX1 RNA",
    "PRDX1 Proteo"
  ],
  "C19orf25": [
    "C19orf25 CNV",
    "C19orf25 RNA",
    "C19orf25 Proteo"
  ],
  "SPATA45": [
    "SPATA45 CNV",
    "SPATA45 RNA"
  ],
  "RPS3AP10": [
    "RPS3AP10 CNV",
    "RPS3AP10 RNA"
  ],
  "TOP3B": [
    "TOP3B CNV",
    "TOP3B RNA",
    "TOP3B Proteo"
  ],
  "SPAG6": [
    "SPAG6 CNV",
    "SPAG6 RNA"
  ],
  "IGF1R": [
    "IGF1R CNV",
    "IGF1R RNA",
    "IGF1R Proteo"
  ],
  "IGFN1": [
    "IGFN1 CNV",
    "IGFN1 RNA",
    "IGFN1 Proteo"
  ],
  "ZNF254": [
    "ZNF254 CNV",
    "ZNF254 RNA"
  ],
  "BMS1P19": [
    "BMS1P19 CNV",
    "BMS1P19 RNA"
  ],
  "GSTM5P1": [
    "GSTM5P1 CNV",
    "GSTM5P1 RNA"
  ],
  "PROS1": [
    "PROS1 CNV",
    "PROS1 RNA",
    "PROS1 Proteo"
  ],
  "KRTAP10-9": [
    "KRTAP10-9 CNV",
    "KRTAP10-9 RNA"
  ],
  "PROK2": [
    "PROK2 CNV",
    "PROK2 RNA"
  ],
  "EBAG9": [
    "EBAG9 CNV",
    "EBAG9 RNA",
    "EBAG9 Proteo"
  ],
  "STX1A": [
    "STX1A CNV",
    "STX1A RNA"
  ],
  "MAGEA2B": [
    "MAGEA2B CNV",
    "MAGEA2B RNA"
  ],
  "HLA-P": [
    "HLA-P CNV",
    "HLA-P RNA"
  ],
  "CA15P2": [
    "CA15P2 CNV",
    "CA15P2 RNA"
  ],
  "APCS": [
    "APCS CNV",
    "APCS RNA",
    "APCS Proteo"
  ],
  "COL21A1": [
    "COL21A1 CNV",
    "COL21A1 RNA",
    "COL21A1 Proteo"
  ],
  "RNF227": [
    "RNF227 CNV",
    "RNF227 RNA"
  ],
  "RTKN": [
    "RTKN CNV",
    "RTKN RNA",
    "RTKN Proteo"
  ],
  "CNOT9": [
    "CNOT9 CNV",
    "CNOT9 RNA",
    "CNOT9 Proteo"
  ],
  "ACTG2": [
    "ACTG2 CNV",
    "ACTG2 RNA",
    "ACTG2 Proteo"
  ],
  "TMEM200A": [
    "TMEM200A CNV",
    "TMEM200A RNA"
  ],
  "EMC6": [
    "EMC6 CNV",
    "EMC6 RNA",
    "EMC6 Proteo"
  ],
  "FAM83F": [
    "FAM83F CNV",
    "FAM83F RNA",
    "FAM83F Proteo"
  ],
  "HSP90AB6P": [
    "HSP90AB6P CNV",
    "HSP90AB6P RNA"
  ],
  "DNAJC19": [
    "DNAJC19 CNV",
    "DNAJC19 RNA",
    "DNAJC19 Proteo"
  ],
  "PGM3": [
    "PGM3 CNV",
    "PGM3 RNA",
    "PGM3 Proteo"
  ],
  "AK5": [
    "AK5 CNV",
    "AK5 RNA",
    "AK5 Proteo"
  ],
  "RNA5SP52": [
    "RNA5SP52 CNV",
    "RNA5SP52 RNA"
  ],
  "C3orf84": [
    "C3orf84 CNV",
    "C3orf84 RNA"
  ],
  "RPS20P25": [
    "RPS20P25 CNV",
    "RPS20P25 RNA"
  ],
  "CHRNA6": [
    "CHRNA6 CNV",
    "CHRNA6 RNA"
  ],
  "JPH4": [
    "JPH4 CNV",
    "JPH4 RNA"
  ],
  "EOMES": [
    "EOMES CNV",
    "EOMES RNA",
    "EOMES Proteo"
  ],
  "HSPA4": [
    "HSPA4 CNV",
    "HSPA4 RNA",
    "HSPA4 Proteo"
  ],
  "EGFL6": [
    "EGFL6 CNV",
    "EGFL6 RNA"
  ],
  "FAM189A2": [
    "FAM189A2 CNV",
    "FAM189A2 RNA",
    "FAM189A2 Proteo"
  ],
  "PKD1L3": [
    "PKD1L3 CNV",
    "PKD1L3 RNA"
  ],
  "SLC37A3": [
    "SLC37A3 CNV",
    "SLC37A3 RNA",
    "SLC37A3 Proteo"
  ],
  "SBSN": [
    "SBSN CNV",
    "SBSN RNA",
    "SBSN Proteo"
  ],
  "CXCL17": [
    "CXCL17 CNV",
    "CXCL17 RNA"
  ],
  "CISD1": [
    "CISD1 CNV",
    "CISD1 RNA",
    "CISD1 Proteo"
  ],
  "RPS24P21": [
    "RPS24P21 CNV",
    "RPS24P21 RNA"
  ],
  "MED6P1": [
    "MED6P1 CNV",
    "MED6P1 RNA"
  ],
  "CASD1": [
    "CASD1 CNV",
    "CASD1 RNA",
    "CASD1 Proteo"
  ],
  "THAP7": [
    "THAP7 CNV",
    "THAP7 RNA",
    "THAP7 Proteo"
  ],
  "MEPE": [
    "MEPE CNV",
    "MEPE RNA"
  ],
  "COX6CP12": [
    "COX6CP12 CNV",
    "COX6CP12 RNA"
  ],
  "UBALD2": [
    "UBALD2 CNV",
    "UBALD2 RNA"
  ],
  "SLC6A9": [
    "SLC6A9 CNV",
    "SLC6A9 RNA"
  ],
  "RNA5SP469": [
    "RNA5SP469 CNV",
    "RNA5SP469 RNA"
  ],
  "GLRB": [
    "GLRB CNV",
    "GLRB RNA"
  ],
  "DUX4L18": [
    "DUX4L18 CNV",
    "DUX4L18 RNA"
  ],
  "TMEM11": [
    "TMEM11 CNV",
    "TMEM11 RNA",
    "TMEM11 Proteo"
  ],
  "ACACB": [
    "ACACB CNV",
    "ACACB RNA",
    "ACACB Proteo"
  ],
  "TANGO6": [
    "TANGO6 CNV",
    "TANGO6 RNA",
    "TANGO6 Proteo"
  ],
  "MYL12B": [
    "MYL12B CNV",
    "MYL12B RNA"
  ],
  "NMT1": [
    "NMT1 CNV",
    "NMT1 RNA",
    "NMT1 Proteo"
  ],
  "THEM4": [
    "THEM4 CNV",
    "THEM4 RNA",
    "THEM4 Proteo"
  ],
  "ARFGAP2": [
    "ARFGAP2 CNV",
    "ARFGAP2 RNA",
    "ARFGAP2 Proteo"
  ],
  "PSRC1": [
    "PSRC1 CNV",
    "PSRC1 RNA",
    "PSRC1 Proteo"
  ],
  "ZNF971P": [
    "ZNF971P CNV",
    "ZNF971P RNA"
  ],
  "SLC35A3": [
    "SLC35A3 CNV",
    "SLC35A3 RNA"
  ],
  "SCN2A": [
    "SCN2A CNV",
    "SCN2A RNA"
  ],
  "UBDP1": [
    "UBDP1 CNV",
    "UBDP1 RNA"
  ],
  "RNA5SP45": [
    "RNA5SP45 CNV",
    "RNA5SP45 RNA"
  ],
  "OR11I1P": [
    "OR11I1P CNV",
    "OR11I1P RNA"
  ],
  "CYB561A3": [
    "CYB561A3 CNV",
    "CYB561A3 RNA",
    "CYB561A3 Proteo"
  ],
  "PCBP1": [
    "PCBP1 CNV",
    "PCBP1 RNA",
    "PCBP1 Proteo"
  ],
  "ZNF815P": [
    "ZNF815P CNV",
    "ZNF815P RNA"
  ],
  "IGHV4-34": [
    "IGHV4-34 Proteo"
  ],
  "PITX1": [
    "PITX1 CNV",
    "PITX1 RNA"
  ],
  "KRBOX1": [
    "KRBOX1 CNV",
    "KRBOX1 RNA"
  ],
  "ANHX": [
    "ANHX CNV",
    "ANHX RNA"
  ],
  "WBP4": [
    "WBP4 CNV",
    "WBP4 RNA",
    "WBP4 Proteo"
  ],
  "GUCY1A1": [
    "GUCY1A1 CNV",
    "GUCY1A1 RNA",
    "GUCY1A1 Proteo"
  ],
  "MTA1": [
    "MTA1 CNV",
    "MTA1 RNA",
    "MTA1 Proteo"
  ],
  "LHX6": [
    "LHX6 CNV",
    "LHX6 RNA"
  ],
  "TRAM1": [
    "TRAM1 CNV",
    "TRAM1 RNA",
    "TRAM1 Proteo"
  ],
  "OR7A15P": [
    "OR7A15P CNV",
    "OR7A15P RNA"
  ],
  "MAPRE1P1": [
    "MAPRE1P1 CNV",
    "MAPRE1P1 RNA"
  ],
  "ENPP7P2": [
    "ENPP7P2 CNV",
    "ENPP7P2 RNA"
  ],
  "NHP2P2": [
    "NHP2P2 CNV",
    "NHP2P2 RNA"
  ],
  "JAML": [
    "JAML CNV",
    "JAML RNA",
    "JAML Proteo"
  ],
  "TFAP2E": [
    "TFAP2E CNV",
    "TFAP2E RNA"
  ],
  "SEMG2": [
    "SEMG2 CNV",
    "SEMG2 RNA"
  ],
  "RPS2P17": [
    "RPS2P17 CNV",
    "RPS2P17 RNA"
  ],
  "ZNF791": [
    "ZNF791 CNV",
    "ZNF791 RNA"
  ],
  "PHLPP2": [
    "PHLPP2 CNV",
    "PHLPP2 RNA",
    "PHLPP2 Proteo"
  ],
  "PLA2G2F": [
    "PLA2G2F CNV",
    "PLA2G2F RNA"
  ],
  "RPS29P1": [
    "RPS29P1 CNV",
    "RPS29P1 RNA"
  ],
  "VSIG1": [
    "VSIG1 CNV",
    "VSIG1 RNA"
  ],
  "SMG1P7": [
    "SMG1P7 CNV",
    "SMG1P7 RNA"
  ],
  "RPSAP60": [
    "RPSAP60 CNV",
    "RPSAP60 RNA"
  ],
  "TSPY9": [
    "TSPY9 CNV",
    "TSPY9 RNA"
  ],
  "ATP5MC2P2": [
    "ATP5MC2P2 CNV",
    "ATP5MC2P2 RNA"
  ],
  "PEAK1": [
    "PEAK1 CNV",
    "PEAK1 RNA",
    "PEAK1 Proteo"
  ],
  "FCN3": [
    "FCN3 CNV",
    "FCN3 RNA",
    "FCN3 Proteo"
  ],
  "PCOLCE2": [
    "PCOLCE2 CNV",
    "PCOLCE2 RNA",
    "PCOLCE2 Proteo"
  ],
  "LIPN": [
    "LIPN CNV",
    "LIPN RNA"
  ],
  "POLRMT": [
    "POLRMT CNV",
    "POLRMT RNA",
    "POLRMT Proteo"
  ],
  "SPDYE9": [
    "SPDYE9 CNV",
    "SPDYE9 RNA"
  ],
  "CCKBR": [
    "CCKBR CNV",
    "CCKBR RNA"
  ],
  "HSPA12B": [
    "HSPA12B CNV",
    "HSPA12B RNA",
    "HSPA12B Proteo"
  ],
  "UGT2B25P": [
    "UGT2B25P CNV",
    "UGT2B25P RNA"
  ],
  "MRE11": [
    "MRE11 CNV",
    "MRE11 RNA",
    "MRE11 Proteo"
  ],
  "LIN28B": [
    "LIN28B CNV",
    "LIN28B RNA",
    "LIN28B Proteo"
  ],
  "TMPRSS15": [
    "TMPRSS15 CNV",
    "TMPRSS15 RNA"
  ],
  "GBX1": [
    "GBX1 CNV",
    "GBX1 RNA"
  ],
  "PHF2P2": [
    "PHF2P2 CNV",
    "PHF2P2 RNA"
  ],
  "DCTN1": [
    "DCTN1 CNV",
    "DCTN1 RNA",
    "DCTN1 Proteo"
  ],
  "CYP2C9": [
    "CYP2C9 CNV",
    "CYP2C9 RNA"
  ],
  "RNA5SP193": [
    "RNA5SP193 CNV",
    "RNA5SP193 RNA"
  ],
  "SLC4A1": [
    "SLC4A1 CNV",
    "SLC4A1 RNA",
    "SLC4A1 Proteo"
  ],
  "MMP3": [
    "MMP3 CNV",
    "MMP3 RNA",
    "MMP3 Proteo"
  ],
  "VPS13A": [
    "VPS13A CNV",
    "VPS13A RNA",
    "VPS13A Proteo"
  ],
  "SSBP3P1": [
    "SSBP3P1 CNV",
    "SSBP3P1 RNA"
  ],
  "DDX21": [
    "DDX21 CNV",
    "DDX21 RNA",
    "DDX21 Proteo"
  ],
  "FTH1P4": [
    "FTH1P4 CNV",
    "FTH1P4 RNA"
  ],
  "SYF2P2": [
    "SYF2P2 CNV",
    "SYF2P2 RNA"
  ],
  "LSM14A": [
    "LSM14A CNV",
    "LSM14A RNA",
    "LSM14A Proteo"
  ],
  "TGM7": [
    "TGM7 CNV",
    "TGM7 RNA"
  ],
  "CSAG3": [
    "CSAG3 CNV",
    "CSAG3 RNA"
  ],
  "KRTAP5-8": [
    "KRTAP5-8 CNV",
    "KRTAP5-8 RNA"
  ],
  "OSBPL10": [
    "OSBPL10 CNV",
    "OSBPL10 RNA",
    "OSBPL10 Proteo"
  ],
  "CHID1": [
    "CHID1 CNV",
    "CHID1 RNA",
    "CHID1 Proteo"
  ],
  "XPO6": [
    "XPO6 CNV",
    "XPO6 RNA",
    "XPO6 Proteo"
  ],
  "MMP1": [
    "MMP1 CNV",
    "MMP1 RNA",
    "MMP1 Proteo"
  ],
  "MAPKAPK3": [
    "MAPKAPK3 CNV",
    "MAPKAPK3 RNA",
    "MAPKAPK3 Proteo"
  ],
  "HERC2P5": [
    "HERC2P5 CNV",
    "HERC2P5 RNA"
  ],
  "NAA35": [
    "NAA35 CNV",
    "NAA35 RNA",
    "NAA35 Proteo"
  ],
  "IFNA22P": [
    "IFNA22P CNV",
    "IFNA22P RNA"
  ],
  "ANO7L1": [
    "ANO7L1 CNV",
    "ANO7L1 RNA"
  ],
  "IGHV3-42": [
    "IGHV3-42 CNV",
    "IGHV3-42 RNA"
  ],
  "TEX19": [
    "TEX19 CNV",
    "TEX19 RNA"
  ],
  "FAM184B": [
    "FAM184B CNV",
    "FAM184B RNA"
  ],
  "SSBP3P2": [
    "SSBP3P2 CNV",
    "SSBP3P2 RNA"
  ],
  "NXPE2P1": [
    "NXPE2P1 CNV",
    "NXPE2P1 RNA"
  ],
  "AIMP1P2": [
    "AIMP1P2 CNV",
    "AIMP1P2 RNA"
  ],
  "C12orf75": [
    "C12orf75 CNV",
    "C12orf75 RNA",
    "C12orf75 Proteo"
  ],
  "RPA2P1": [
    "RPA2P1 CNV",
    "RPA2P1 RNA"
  ],
  "DPP6": [
    "DPP6 CNV",
    "DPP6 RNA"
  ],
  "OR4P4": [
    "OR4P4 CNV",
    "OR4P4 RNA"
  ],
  "ZNF436": [
    "ZNF436 CNV",
    "ZNF436 RNA",
    "ZNF436 Proteo"
  ],
  "RPL12P24": [
    "RPL12P24 CNV",
    "RPL12P24 RNA"
  ],
  "TAF11L5": [
    "TAF11L5 CNV",
    "TAF11L5 RNA"
  ],
  "OR5M4P": [
    "OR5M4P CNV",
    "OR5M4P RNA"
  ],
  "IL12A": [
    "IL12A CNV",
    "IL12A RNA"
  ],
  "ERLIN1": [
    "ERLIN1 CNV",
    "ERLIN1 RNA",
    "ERLIN1 Proteo"
  ],
  "MTNR1A": [
    "MTNR1A CNV",
    "MTNR1A RNA"
  ],
  "KRT8P11": [
    "KRT8P11 CNV",
    "KRT8P11 RNA"
  ],
  "KRTAP2-3": [
    "KRTAP2-3 CNV",
    "KRTAP2-3 RNA"
  ],
  "HSPH1": [
    "HSPH1 CNV",
    "HSPH1 RNA",
    "HSPH1 Proteo"
  ],
  "RBFOX3": [
    "RBFOX3 CNV",
    "RBFOX3 RNA"
  ],
  "SNX18P1Y": [
    "SNX18P1Y CNV",
    "SNX18P1Y RNA"
  ],
  "TIGD3": [
    "TIGD3 CNV",
    "TIGD3 RNA"
  ],
  "GRIFIN": [
    "GRIFIN CNV",
    "GRIFIN RNA"
  ],
  "HMGN1P2": [
    "HMGN1P2 CNV",
    "HMGN1P2 RNA"
  ],
  "DNAJB12": [
    "DNAJB12 CNV",
    "DNAJB12 RNA",
    "DNAJB12 Proteo"
  ],
  "C17orf99": [
    "C17orf99 CNV",
    "C17orf99 RNA"
  ],
  "PASD1": [
    "PASD1 CNV",
    "PASD1 RNA"
  ],
  "HMGB3P13": [
    "HMGB3P13 CNV",
    "HMGB3P13 RNA"
  ],
  "ECM2": [
    "ECM2 CNV",
    "ECM2 RNA",
    "ECM2 Proteo"
  ],
  "ERP44": [
    "ERP44 CNV",
    "ERP44 RNA",
    "ERP44 Proteo"
  ],
  "IMPDH1P11": [
    "IMPDH1P11 CNV",
    "IMPDH1P11 RNA"
  ],
  "RPL7AP40": [
    "RPL7AP40 CNV",
    "RPL7AP40 RNA"
  ],
  "YPEL5P3": [
    "YPEL5P3 CNV",
    "YPEL5P3 RNA"
  ],
  "KCNV2": [
    "KCNV2 CNV",
    "KCNV2 RNA"
  ],
  "KCTD16": [
    "KCTD16 CNV",
    "KCTD16 RNA"
  ],
  "SND1": [
    "SND1 CNV",
    "SND1 RNA",
    "SND1 Proteo"
  ],
  "PRR20D": [
    "PRR20D CNV",
    "PRR20D RNA"
  ],
  "NUP42": [
    "NUP42 CNV",
    "NUP42 RNA",
    "NUP42 Proteo"
  ],
  "GOLGA8T": [
    "GOLGA8T CNV",
    "GOLGA8T RNA"
  ],
  "ACTR1B": [
    "ACTR1B CNV",
    "ACTR1B RNA",
    "ACTR1B Proteo"
  ],
  "TATDN3": [
    "TATDN3 CNV",
    "TATDN3 RNA",
    "TATDN3 Proteo"
  ],
  "TSTD3": [
    "TSTD3 CNV",
    "TSTD3 RNA"
  ],
  "SLC35F3": [
    "SLC35F3 CNV",
    "SLC35F3 RNA"
  ],
  "PPCDC": [
    "PPCDC CNV",
    "PPCDC RNA",
    "PPCDC Proteo"
  ],
  "LAG3": [
    "LAG3 CNV",
    "LAG3 RNA",
    "LAG3 Proteo"
  ],
  "PPP1R35": [
    "PPP1R35 CNV",
    "PPP1R35 RNA",
    "PPP1R35 Proteo"
  ],
  "YTHDF1": [
    "YTHDF1 CNV",
    "YTHDF1 RNA",
    "YTHDF1 Proteo"
  ],
  "PEX19": [
    "PEX19 CNV",
    "PEX19 RNA",
    "PEX19 Proteo"
  ],
  "NMTRS-TGA3-1": [
    "NMTRS-TGA3-1 CNV",
    "NMTRS-TGA3-1 RNA"
  ],
  "CIAO2B": [
    "CIAO2B CNV",
    "CIAO2B RNA",
    "CIAO2B Proteo"
  ],
  "C17orf64": [
    "C17orf64 CNV",
    "C17orf64 RNA"
  ],
  "TRIM23": [
    "TRIM23 CNV",
    "TRIM23 RNA",
    "TRIM23 Proteo"
  ],
  "OR7E39P": [
    "OR7E39P CNV",
    "OR7E39P RNA"
  ],
  "NXPE1": [
    "NXPE1 CNV",
    "NXPE1 RNA"
  ],
  "TMPRSS2": [
    "TMPRSS2 CNV",
    "TMPRSS2 RNA"
  ],
  "RNA5SP484": [
    "RNA5SP484 CNV",
    "RNA5SP484 RNA"
  ],
  "CD200": [
    "CD200 CNV",
    "CD200 RNA",
    "CD200 Proteo"
  ],
  "MTND4P19": [
    "MTND4P19 CNV",
    "MTND4P19 RNA"
  ],
  "VN1R20P": [
    "VN1R20P CNV",
    "VN1R20P RNA"
  ],
  "COLGALT2": [
    "COLGALT2 CNV",
    "COLGALT2 RNA",
    "COLGALT2 Proteo"
  ],
  "FAM229A": [
    "FAM229A CNV",
    "FAM229A RNA"
  ],
  "PRELID3B": [
    "PRELID3B CNV",
    "PRELID3B RNA",
    "PRELID3B Proteo"
  ],
  "SETD3": [
    "SETD3 CNV",
    "SETD3 RNA",
    "SETD3 Proteo"
  ],
  "PPP1R2P5": [
    "PPP1R2P5 CNV",
    "PPP1R2P5 RNA"
  ],
  "RPGR": [
    "RPGR CNV",
    "RPGR RNA",
    "RPGR Proteo"
  ],
  "OR4A13P": [
    "OR4A13P CNV",
    "OR4A13P RNA"
  ],
  "ENPP6": [
    "ENPP6 CNV",
    "ENPP6 RNA"
  ],
  "BCRP4": [
    "BCRP4 CNV",
    "BCRP4 RNA"
  ],
  "UTRN": [
    "UTRN CNV",
    "UTRN RNA",
    "UTRN Proteo"
  ],
  "DMRTC2": [
    "DMRTC2 CNV",
    "DMRTC2 RNA"
  ],
  "ERBB4": [
    "ERBB4 CNV",
    "ERBB4 RNA"
  ],
  "TAS1R1": [
    "TAS1R1 CNV",
    "TAS1R1 RNA"
  ],
  "ELOCP30": [
    "ELOCP30 CNV",
    "ELOCP30 RNA"
  ],
  "KIAA1143P2": [
    "KIAA1143P2 CNV",
    "KIAA1143P2 RNA"
  ],
  "P4HA1": [
    "P4HA1 CNV",
    "P4HA1 RNA",
    "P4HA1 Proteo"
  ],
  "SAA2": [
    "SAA2 CNV",
    "SAA2 RNA",
    "SAA2 Proteo"
  ],
  "VCL": [
    "VCL CNV",
    "VCL RNA",
    "VCL Proteo"
  ],
  "NDUFS3": [
    "NDUFS3 CNV",
    "NDUFS3 RNA",
    "NDUFS3 Proteo"
  ],
  "SDHAP3": [
    "SDHAP3 CNV",
    "SDHAP3 RNA"
  ],
  "ZMYM6": [
    "ZMYM6 CNV",
    "ZMYM6 RNA",
    "ZMYM6 Proteo"
  ],
  "OR2A9P": [
    "OR2A9P CNV",
    "OR2A9P RNA"
  ],
  "UGT1A5": [
    "UGT1A5 CNV",
    "UGT1A5 RNA"
  ],
  "GTF3AP1": [
    "GTF3AP1 CNV",
    "GTF3AP1 RNA"
  ],
  "CKAP2": [
    "CKAP2 CNV",
    "CKAP2 RNA",
    "CKAP2 Proteo"
  ],
  "PPARA": [
    "PPARA CNV",
    "PPARA RNA"
  ],
  "OR11H12": [
    "OR11H12 CNV",
    "OR11H12 RNA"
  ],
  "RPL34P36": [
    "RPL34P36 CNV",
    "RPL34P36 RNA"
  ],
  "JPT1": [
    "JPT1 CNV",
    "JPT1 RNA",
    "JPT1 Proteo"
  ],
  "ZNF841": [
    "ZNF841 CNV",
    "ZNF841 RNA"
  ],
  "MT-ND5": [
    "MT-ND5 RNA",
    "MT-ND5 Proteo"
  ],
  "TPT1P13": [
    "TPT1P13 CNV",
    "TPT1P13 RNA"
  ],
  "SEC63P1": [
    "SEC63P1 CNV",
    "SEC63P1 RNA"
  ],
  "TNFAIP8L1": [
    "TNFAIP8L1 CNV",
    "TNFAIP8L1 RNA"
  ],
  "AZU1P1": [
    "AZU1P1 CNV",
    "AZU1P1 RNA"
  ],
  "SLC13A3": [
    "SLC13A3 CNV",
    "SLC13A3 RNA"
  ],
  "CCDC146": [
    "CCDC146 CNV",
    "CCDC146 RNA"
  ],
  "OR2H4P": [
    "OR2H4P CNV",
    "OR2H4P RNA"
  ],
  "CYB5D2": [
    "CYB5D2 CNV",
    "CYB5D2 RNA",
    "CYB5D2 Proteo"
  ],
  "HMMR": [
    "HMMR CNV",
    "HMMR RNA",
    "HMMR Proteo"
  ],
  "AIDAP3": [
    "AIDAP3 CNV",
    "AIDAP3 RNA"
  ],
  "EXD2": [
    "EXD2 CNV",
    "EXD2 RNA",
    "EXD2 Proteo"
  ],
  "RNA5SP423": [
    "RNA5SP423 CNV",
    "RNA5SP423 RNA"
  ],
  "RAPH1": [
    "RAPH1 CNV",
    "RAPH1 RNA",
    "RAPH1 Proteo"
  ],
  "RCL1": [
    "RCL1 CNV",
    "RCL1 RNA",
    "RCL1 Proteo"
  ],
  "ADCK5": [
    "ADCK5 CNV",
    "ADCK5 RNA",
    "ADCK5 Proteo"
  ],
  "KRTAP10-2": [
    "KRTAP10-2 CNV",
    "KRTAP10-2 RNA"
  ],
  "CLDN16": [
    "CLDN16 CNV",
    "CLDN16 RNA"
  ],
  "ENOSF1": [
    "ENOSF1 CNV",
    "ENOSF1 RNA",
    "ENOSF1 Proteo"
  ],
  "RPL29P28": [
    "RPL29P28 CNV",
    "RPL29P28 RNA"
  ],
  "PRMT6": [
    "PRMT6 CNV",
    "PRMT6 RNA",
    "PRMT6 Proteo"
  ],
  "PCDHGC3": [
    "PCDHGC3 CNV",
    "PCDHGC3 RNA",
    "PCDHGC3 Proteo"
  ],
  "VIL1": [
    "VIL1 CNV",
    "VIL1 RNA",
    "VIL1 Proteo"
  ],
  "CDC42P4": [
    "CDC42P4 CNV",
    "CDC42P4 RNA"
  ],
  "PSIP1P1": [
    "PSIP1P1 CNV",
    "PSIP1P1 RNA"
  ],
  "CEACAM19": [
    "CEACAM19 CNV",
    "CEACAM19 RNA"
  ],
  "OR4K4P": [
    "OR4K4P CNV",
    "OR4K4P RNA"
  ],
  "DYNLRB2": [
    "DYNLRB2 CNV",
    "DYNLRB2 RNA"
  ],
  "TP53TG3GP": [
    "TP53TG3GP CNV",
    "TP53TG3GP RNA"
  ],
  "GPAM": [
    "GPAM CNV",
    "GPAM RNA",
    "GPAM Proteo"
  ],
  "DAZAP2": [
    "DAZAP2 CNV",
    "DAZAP2 RNA",
    "DAZAP2 Proteo"
  ],
  "SLC9B1P1": [
    "SLC9B1P1 CNV",
    "SLC9B1P1 RNA"
  ],
  "POGLUT3": [
    "POGLUT3 CNV",
    "POGLUT3 RNA",
    "POGLUT3 Proteo"
  ],
  "LRRC32": [
    "LRRC32 CNV",
    "LRRC32 RNA",
    "LRRC32 Proteo"
  ],
  "SS18": [
    "SS18 CNV",
    "SS18 RNA",
    "SS18 Proteo"
  ],
  "THAP3": [
    "THAP3 CNV",
    "THAP3 RNA",
    "THAP3 Proteo"
  ],
  "LIPT1": [
    "LIPT1 CNV",
    "LIPT1 RNA",
    "LIPT1 Proteo"
  ],
  "DIRAS3": [
    "DIRAS3 CNV",
    "DIRAS3 RNA"
  ],
  "PLA2G5": [
    "PLA2G5 CNV",
    "PLA2G5 RNA"
  ],
  "RAB8A": [
    "RAB8A CNV",
    "RAB8A RNA",
    "RAB8A Proteo"
  ],
  "RPL18AP15": [
    "RPL18AP15 CNV",
    "RPL18AP15 RNA"
  ],
  "RNASE11": [
    "RNASE11 CNV",
    "RNASE11 RNA"
  ],
  "BLK": [
    "BLK CNV",
    "BLK RNA",
    "BLK Proteo"
  ],
  "RPL18AP2": [
    "RPL18AP2 CNV",
    "RPL18AP2 RNA"
  ],
  "RPL36AP36": [
    "RPL36AP36 CNV",
    "RPL36AP36 RNA"
  ],
  "GOLGA6L22": [
    "GOLGA6L22 CNV",
    "GOLGA6L22 RNA"
  ],
  "LCN10": [
    "LCN10 CNV",
    "LCN10 RNA"
  ],
  "GTF3C2": [
    "GTF3C2 CNV",
    "GTF3C2 RNA",
    "GTF3C2 Proteo"
  ],
  "RDH11": [
    "RDH11 CNV",
    "RDH11 RNA",
    "RDH11 Proteo"
  ],
  "CDC37P1": [
    "CDC37P1 CNV",
    "CDC37P1 RNA"
  ],
  "RPL23AP54": [
    "RPL23AP54 CNV",
    "RPL23AP54 RNA"
  ],
  "PPP2R2A": [
    "PPP2R2A CNV",
    "PPP2R2A RNA",
    "PPP2R2A Proteo"
  ],
  "ZBTB32": [
    "ZBTB32 CNV",
    "ZBTB32 RNA"
  ],
  "ZNF581": [
    "ZNF581 CNV",
    "ZNF581 RNA",
    "ZNF581 Proteo"
  ],
  "PDE3B": [
    "PDE3B CNV",
    "PDE3B RNA",
    "PDE3B Proteo"
  ],
  "ARSJ": [
    "ARSJ CNV",
    "ARSJ RNA"
  ],
  "RPL35AP30": [
    "RPL35AP30 CNV",
    "RPL35AP30 RNA"
  ],
  "C2orf69P4": [
    "C2orf69P4 CNV",
    "C2orf69P4 RNA"
  ],
  "CYP2G2P": [
    "CYP2G2P CNV",
    "CYP2G2P RNA"
  ],
  "EPHA3": [
    "EPHA3 CNV",
    "EPHA3 RNA",
    "EPHA3 Proteo"
  ],
  "UQCRC2": [
    "UQCRC2 CNV",
    "UQCRC2 RNA",
    "UQCRC2 Proteo"
  ],
  "SHH": [
    "SHH CNV",
    "SHH RNA"
  ],
  "RFX1": [
    "RFX1 CNV",
    "RFX1 RNA",
    "RFX1 Proteo"
  ],
  "BAIAP2": [
    "BAIAP2 CNV",
    "BAIAP2 RNA",
    "BAIAP2 Proteo"
  ],
  "AS3MT": [
    "AS3MT CNV",
    "AS3MT RNA",
    "AS3MT Proteo"
  ],
  "SUCLG2": [
    "SUCLG2 CNV",
    "SUCLG2 RNA",
    "SUCLG2 Proteo"
  ],
  "GAPDHP1": [
    "GAPDHP1 CNV",
    "GAPDHP1 RNA"
  ],
  "OR6C68": [
    "OR6C68 CNV",
    "OR6C68 RNA"
  ],
  "MSC": [
    "MSC CNV",
    "MSC RNA"
  ],
  "RPSAP24": [
    "RPSAP24 CNV",
    "RPSAP24 RNA"
  ],
  "JMJD6": [
    "JMJD6 CNV",
    "JMJD6 RNA",
    "JMJD6 Proteo"
  ],
  "PERCC1": [
    "PERCC1 CNV",
    "PERCC1 RNA"
  ],
  "C7orf57": [
    "C7orf57 CNV",
    "C7orf57 RNA"
  ],
  "AICDA": [
    "AICDA CNV",
    "AICDA RNA"
  ],
  "SFMBT1": [
    "SFMBT1 CNV",
    "SFMBT1 RNA",
    "SFMBT1 Proteo"
  ],
  "TMEM207": [
    "TMEM207 CNV",
    "TMEM207 RNA"
  ],
  "GAPVD1": [
    "GAPVD1 CNV",
    "GAPVD1 RNA",
    "GAPVD1 Proteo"
  ],
  "BHLHB9": [
    "BHLHB9 CNV",
    "BHLHB9 RNA"
  ],
  "PSPC1P1": [
    "PSPC1P1 CNV",
    "PSPC1P1 RNA"
  ],
  "MTCO1P18": [
    "MTCO1P18 CNV",
    "MTCO1P18 RNA"
  ],
  "MTND3P25": [
    "MTND3P25 CNV",
    "MTND3P25 RNA"
  ],
  "RUSC1": [
    "RUSC1 CNV",
    "RUSC1 RNA",
    "RUSC1 Proteo"
  ],
  "CTF2P": [
    "CTF2P CNV",
    "CTF2P RNA"
  ],
  "GFRAL": [
    "GFRAL CNV",
    "GFRAL RNA"
  ],
  "GNA13P1": [
    "GNA13P1 CNV",
    "GNA13P1 RNA"
  ],
  "PDLIM2": [
    "PDLIM2 CNV",
    "PDLIM2 RNA",
    "PDLIM2 Proteo"
  ],
  "MORF4L1P7": [
    "MORF4L1P7 CNV",
    "MORF4L1P7 RNA"
  ],
  "RPL12P47": [
    "RPL12P47 CNV",
    "RPL12P47 RNA"
  ],
  "SAP18": [
    "SAP18 CNV",
    "SAP18 RNA",
    "SAP18 Proteo"
  ],
  "SUPT4H1P2": [
    "SUPT4H1P2 CNV",
    "SUPT4H1P2 RNA"
  ],
  "TBC1D5": [
    "TBC1D5 CNV",
    "TBC1D5 RNA",
    "TBC1D5 Proteo"
  ],
  "RNF170": [
    "RNF170 CNV",
    "RNF170 RNA",
    "RNF170 Proteo"
  ],
  "SMN2": [
    "SMN2 CNV",
    "SMN2 RNA"
  ],
  "SASS6": [
    "SASS6 CNV",
    "SASS6 RNA",
    "SASS6 Proteo"
  ],
  "OLIG3": [
    "OLIG3 CNV",
    "OLIG3 RNA"
  ],
  "DARS1": [
    "DARS1 CNV",
    "DARS1 RNA",
    "DARS1 Proteo"
  ],
  "HMGN2P2": [
    "HMGN2P2 CNV",
    "HMGN2P2 RNA"
  ],
  "EEF1A1P4": [
    "EEF1A1P4 CNV",
    "EEF1A1P4 RNA"
  ],
  "DPF3": [
    "DPF3 CNV",
    "DPF3 RNA",
    "DPF3 Proteo"
  ],
  "BTG4P1": [
    "BTG4P1 CNV",
    "BTG4P1 RNA"
  ],
  "OR4R1P": [
    "OR4R1P CNV",
    "OR4R1P RNA"
  ],
  "CTNNBIP1": [
    "CTNNBIP1 CNV",
    "CTNNBIP1 RNA",
    "CTNNBIP1 Proteo"
  ],
  "RPL21P127": [
    "RPL21P127 CNV",
    "RPL21P127 RNA"
  ],
  "CD34": [
    "CD34 CNV",
    "CD34 RNA",
    "CD34 Proteo"
  ],
  "USP17L2": [
    "USP17L2 CNV",
    "USP17L2 RNA"
  ],
  "OPN1MW2": [
    "OPN1MW2 CNV",
    "OPN1MW2 RNA"
  ],
  "NACC2": [
    "NACC2 CNV",
    "NACC2 RNA",
    "NACC2 Proteo"
  ],
  "TCP10L": [
    "TCP10L CNV",
    "TCP10L RNA"
  ],
  "MRPS36P2": [
    "MRPS36P2 CNV",
    "MRPS36P2 RNA"
  ],
  "KICS2": [
    "KICS2 CNV",
    "KICS2 RNA",
    "KICS2 Proteo"
  ],
  "GNMT": [
    "GNMT CNV",
    "GNMT RNA"
  ],
  "TUG1": [
    "TUG1 CNV",
    "TUG1 RNA"
  ],
  "GLIS1": [
    "GLIS1 CNV",
    "GLIS1 RNA"
  ],
  "RPL21P106": [
    "RPL21P106 CNV",
    "RPL21P106 RNA"
  ],
  "RFXANK": [
    "RFXANK CNV",
    "RFXANK RNA",
    "RFXANK Proteo"
  ],
  "SLPI": [
    "SLPI CNV",
    "SLPI RNA",
    "SLPI Proteo"
  ],
  "PIGM": [
    "PIGM CNV",
    "PIGM RNA",
    "PIGM Proteo"
  ],
  "NNT": [
    "NNT CNV",
    "NNT RNA",
    "NNT Proteo"
  ],
  "TYW1B": [
    "TYW1B CNV",
    "TYW1B RNA"
  ],
  "POU3F3": [
    "POU3F3 CNV",
    "POU3F3 RNA",
    "POU3F3 Proteo"
  ],
  "TBPL2": [
    "TBPL2 CNV",
    "TBPL2 RNA"
  ],
  "CARS2": [
    "CARS2 CNV",
    "CARS2 RNA",
    "CARS2 Proteo"
  ],
  "HIGD1AP8": [
    "HIGD1AP8 CNV",
    "HIGD1AP8 RNA"
  ],
  "GARS1": [
    "GARS1 CNV",
    "GARS1 RNA",
    "GARS1 Proteo"
  ],
  "SAA1": [
    "SAA1 CNV",
    "SAA1 RNA",
    "SAA1 Proteo"
  ],
  "RCC2P4": [
    "RCC2P4 CNV",
    "RCC2P4 RNA"
  ],
  "CTSL": [
    "CTSL CNV",
    "CTSL RNA",
    "CTSL Proteo"
  ],
  "RAD17P2": [
    "RAD17P2 CNV",
    "RAD17P2 RNA"
  ],
  "RPS4XP19": [
    "RPS4XP19 CNV",
    "RPS4XP19 RNA"
  ],
  "KRT18P54": [
    "KRT18P54 CNV",
    "KRT18P54 RNA"
  ],
  "CTR9": [
    "CTR9 CNV",
    "CTR9 RNA",
    "CTR9 Proteo"
  ],
  "GABRR1": [
    "GABRR1 CNV",
    "GABRR1 RNA"
  ],
  "NCF1": [
    "NCF1 CNV",
    "NCF1 RNA",
    "NCF1 Proteo"
  ],
  "EWSR1": [
    "EWSR1 CNV",
    "EWSR1 RNA",
    "EWSR1 Proteo"
  ],
  "LEUTX": [
    "LEUTX CNV",
    "LEUTX RNA"
  ],
  "FARSB": [
    "FARSB CNV",
    "FARSB RNA",
    "FARSB Proteo"
  ],
  "TRAF3IP2": [
    "TRAF3IP2 CNV",
    "TRAF3IP2 RNA",
    "TRAF3IP2 Proteo"
  ],
  "FAM30C": [
    "FAM30C CNV",
    "FAM30C RNA"
  ],
  "MTCYBP9": [
    "MTCYBP9 CNV",
    "MTCYBP9 RNA"
  ],
  "C15orf48": [
    "C15orf48 CNV",
    "C15orf48 RNA",
    "C15orf48 Proteo"
  ],
  "RAD17": [
    "RAD17 CNV",
    "RAD17 RNA",
    "RAD17 Proteo"
  ],
  "FKBP11": [
    "FKBP11 CNV",
    "FKBP11 RNA",
    "FKBP11 Proteo"
  ],
  "AHNAK": [
    "AHNAK CNV",
    "AHNAK RNA",
    "AHNAK Proteo"
  ],
  "ENTR1": [
    "ENTR1 CNV",
    "ENTR1 RNA",
    "ENTR1 Proteo"
  ],
  "TIGIT": [
    "TIGIT CNV",
    "TIGIT RNA"
  ],
  "IRAK3": [
    "IRAK3 CNV",
    "IRAK3 RNA",
    "IRAK3 Proteo"
  ],
  "PPOX": [
    "PPOX CNV",
    "PPOX RNA",
    "PPOX Proteo"
  ],
  "LDLRAD4": [
    "LDLRAD4 CNV",
    "LDLRAD4 RNA"
  ],
  "GK2": [
    "GK2 CNV",
    "GK2 RNA"
  ],
  "PATL1": [
    "PATL1 CNV",
    "PATL1 RNA",
    "PATL1 Proteo"
  ],
  "LCN1P1": [
    "LCN1P1 CNV",
    "LCN1P1 RNA"
  ],
  "ARHGAP33": [
    "ARHGAP33 CNV",
    "ARHGAP33 RNA"
  ],
  "BNIP3": [
    "BNIP3 CNV",
    "BNIP3 RNA",
    "BNIP3 Proteo"
  ],
  "SDF4": [
    "SDF4 CNV",
    "SDF4 RNA",
    "SDF4 Proteo"
  ],
  "RBM15": [
    "RBM15 CNV",
    "RBM15 RNA",
    "RBM15 Proteo"
  ],
  "IL3": [
    "IL3 CNV",
    "IL3 RNA"
  ],
  "H2BP7": [
    "H2BP7 CNV",
    "H2BP7 RNA"
  ],
  "C1QBPP2": [
    "C1QBPP2 CNV",
    "C1QBPP2 RNA"
  ],
  "OMD": [
    "OMD CNV",
    "OMD RNA",
    "OMD Proteo"
  ],
  "GRIK1": [
    "GRIK1 CNV",
    "GRIK1 RNA"
  ],
  "FOXF2": [
    "FOXF2 CNV",
    "FOXF2 RNA"
  ],
  "LONRF2P4": [
    "LONRF2P4 CNV",
    "LONRF2P4 RNA"
  ],
  "UCN2": [
    "UCN2 CNV",
    "UCN2 RNA"
  ],
  "OR4A21P": [
    "OR4A21P CNV",
    "OR4A21P RNA"
  ],
  "OR14K1": [
    "OR14K1 CNV",
    "OR14K1 RNA"
  ],
  "CLNK": [
    "CLNK CNV",
    "CLNK RNA"
  ],
  "PRR14": [
    "PRR14 CNV",
    "PRR14 RNA",
    "PRR14 Proteo"
  ],
  "TRMT5": [
    "TRMT5 CNV",
    "TRMT5 RNA",
    "TRMT5 Proteo"
  ],
  "FBXO25": [
    "FBXO25 CNV",
    "FBXO25 RNA"
  ],
  "DARS2": [
    "DARS2 CNV",
    "DARS2 RNA",
    "DARS2 Proteo"
  ],
  "CEACAMP5": [
    "CEACAMP5 CNV",
    "CEACAMP5 RNA"
  ],
  "WIZ": [
    "WIZ CNV",
    "WIZ RNA",
    "WIZ Proteo"
  ],
  "ADAM30": [
    "ADAM30 CNV",
    "ADAM30 RNA"
  ],
  "PLPP3": [
    "PLPP3 CNV",
    "PLPP3 RNA",
    "PLPP3 Proteo"
  ],
  "RNA5SP110": [
    "RNA5SP110 CNV",
    "RNA5SP110 RNA"
  ],
  "RPL26P31": [
    "RPL26P31 CNV",
    "RPL26P31 RNA"
  ],
  "LSP1": [
    "LSP1 CNV",
    "LSP1 RNA",
    "LSP1 Proteo"
  ],
  "RPL18AP16": [
    "RPL18AP16 CNV",
    "RPL18AP16 RNA"
  ],
  "RPS6KB1": [
    "RPS6KB1 CNV",
    "RPS6KB1 RNA",
    "RPS6KB1 Proteo"
  ],
  "MFNG": [
    "MFNG CNV",
    "MFNG RNA",
    "MFNG Proteo"
  ],
  "HNRNPA3P5": [
    "HNRNPA3P5 CNV",
    "HNRNPA3P5 RNA"
  ],
  "MAT2B": [
    "MAT2B CNV",
    "MAT2B RNA",
    "MAT2B Proteo"
  ],
  "OR7C1": [
    "OR7C1 CNV",
    "OR7C1 RNA"
  ],
  "PGLYRP3": [
    "PGLYRP3 CNV",
    "PGLYRP3 RNA"
  ],
  "SMARCE1P4": [
    "SMARCE1P4 CNV",
    "SMARCE1P4 RNA"
  ],
  "ACSBG2": [
    "ACSBG2 CNV",
    "ACSBG2 RNA"
  ],
  "HSPD1P3": [
    "HSPD1P3 CNV",
    "HSPD1P3 RNA"
  ],
  "C12orf29": [
    "C12orf29 CNV",
    "C12orf29 RNA",
    "C12orf29 Proteo"
  ],
  "ALG12": [
    "ALG12 CNV",
    "ALG12 RNA",
    "ALG12 Proteo"
  ],
  "NEU2": [
    "NEU2 CNV",
    "NEU2 RNA"
  ],
  "BCORP1": [
    "BCORP1 CNV",
    "BCORP1 RNA"
  ],
  "GLRXP1": [
    "GLRXP1 CNV",
    "GLRXP1 RNA"
  ],
  "VSTM4": [
    "VSTM4 CNV",
    "VSTM4 RNA"
  ],
  "RNA5SP200": [
    "RNA5SP200 CNV",
    "RNA5SP200 RNA"
  ],
  "PAQR7": [
    "PAQR7 CNV",
    "PAQR7 RNA"
  ],
  "MICU3": [
    "MICU3 CNV",
    "MICU3 RNA",
    "MICU3 Proteo"
  ],
  "IGKV2D-23": [
    "IGKV2D-23 CNV",
    "IGKV2D-23 RNA"
  ],
  "TMSB4XP6": [
    "TMSB4XP6 CNV",
    "TMSB4XP6 RNA"
  ],
  "UBTFL2": [
    "UBTFL2 CNV",
    "UBTFL2 RNA"
  ],
  "PIGP": [
    "PIGP CNV",
    "PIGP RNA",
    "PIGP Proteo"
  ],
  "GALNT10": [
    "GALNT10 CNV",
    "GALNT10 RNA",
    "GALNT10 Proteo"
  ],
  "NPM1P17": [
    "NPM1P17 CNV",
    "NPM1P17 RNA"
  ],
  "NEDD4L": [
    "NEDD4L CNV",
    "NEDD4L RNA",
    "NEDD4L Proteo"
  ],
  "AHCYP2": [
    "AHCYP2 CNV",
    "AHCYP2 RNA"
  ],
  "ZFP64": [
    "ZFP64 CNV",
    "ZFP64 RNA",
    "ZFP64 Proteo"
  ],
  "TTC7A": [
    "TTC7A CNV",
    "TTC7A RNA",
    "TTC7A Proteo"
  ],
  "OR4A46P": [
    "OR4A46P CNV",
    "OR4A46P RNA"
  ],
  "TRBC2": [
    "TRBC2 Proteo"
  ],
  "DOC2B": [
    "DOC2B CNV",
    "DOC2B RNA"
  ],
  "CFAP100": [
    "CFAP100 CNV",
    "CFAP100 RNA"
  ],
  "ALPI": [
    "ALPI CNV",
    "ALPI RNA"
  ],
  "PTCD2": [
    "PTCD2 CNV",
    "PTCD2 RNA",
    "PTCD2 Proteo"
  ],
  "PSG1": [
    "PSG1 CNV",
    "PSG1 RNA"
  ],
  "SLC30A10": [
    "SLC30A10 CNV",
    "SLC30A10 RNA"
  ],
  "RPLP2": [
    "RPLP2 CNV",
    "RPLP2 RNA",
    "RPLP2 Proteo"
  ],
  "HEATR9": [
    "HEATR9 CNV",
    "HEATR9 RNA"
  ],
  "CLIP2": [
    "CLIP2 CNV",
    "CLIP2 RNA",
    "CLIP2 Proteo"
  ],
  "TNXA": [
    "TNXA CNV",
    "TNXA RNA"
  ],
  "FRMPD4": [
    "FRMPD4 CNV",
    "FRMPD4 RNA"
  ],
  "BARX1": [
    "BARX1 CNV",
    "BARX1 RNA"
  ],
  "EI24P2": [
    "EI24P2 CNV",
    "EI24P2 RNA"
  ],
  "MTCO3P9": [
    "MTCO3P9 CNV",
    "MTCO3P9 RNA"
  ],
  "KLHL36": [
    "KLHL36 CNV",
    "KLHL36 RNA",
    "KLHL36 Proteo"
  ],
  "HS3ST5": [
    "HS3ST5 CNV",
    "HS3ST5 RNA"
  ],
  "SLURP2": [
    "SLURP2 CNV",
    "SLURP2 RNA",
    "SLURP2 Proteo"
  ],
  "MTND5P3": [
    "MTND5P3 CNV",
    "MTND5P3 RNA"
  ],
  "OR4N2": [
    "OR4N2 CNV",
    "OR4N2 RNA"
  ],
  "LINC02218": [
    "LINC02218 CNV",
    "LINC02218 RNA"
  ],
  "GAPDHP32": [
    "GAPDHP32 CNV",
    "GAPDHP32 RNA"
  ],
  "HNRNPA1L3": [
    "HNRNPA1L3 CNV",
    "HNRNPA1L3 RNA",
    "HNRNPA1L3 Proteo"
  ],
  "PYCARD": [
    "PYCARD CNV",
    "PYCARD RNA",
    "PYCARD Proteo"
  ],
  "KRTAP24-1": [
    "KRTAP24-1 CNV",
    "KRTAP24-1 RNA"
  ],
  "ANKRD20A11P": [
    "ANKRD20A11P CNV",
    "ANKRD20A11P RNA"
  ],
  "SEPTIN2": [
    "SEPTIN2 CNV",
    "SEPTIN2 RNA",
    "SEPTIN2 Proteo"
  ],
  "RPS6P12": [
    "RPS6P12 CNV",
    "RPS6P12 RNA"
  ],
  "GDI2P1": [
    "GDI2P1 CNV",
    "GDI2P1 RNA"
  ],
  "RPL7P4": [
    "RPL7P4 CNV",
    "RPL7P4 RNA"
  ],
  "DKK2": [
    "DKK2 CNV",
    "DKK2 RNA"
  ],
  "ZBTB5": [
    "ZBTB5 CNV",
    "ZBTB5 RNA",
    "ZBTB5 Proteo"
  ],
  "AAR2": [
    "AAR2 CNV",
    "AAR2 RNA",
    "AAR2 Proteo"
  ],
  "SUN5": [
    "SUN5 CNV",
    "SUN5 RNA"
  ],
  "CHCHD2P2": [
    "CHCHD2P2 CNV",
    "CHCHD2P2 RNA"
  ],
  "SDF2": [
    "SDF2 CNV",
    "SDF2 RNA",
    "SDF2 Proteo"
  ],
  "TPM3P3": [
    "TPM3P3 CNV",
    "TPM3P3 RNA"
  ],
  "IGLL5": [
    "IGLL5 CNV",
    "IGLL5 RNA",
    "IGLL5 Proteo"
  ],
  "MBD3L5": [
    "MBD3L5 CNV",
    "MBD3L5 RNA"
  ],
  "ZNF442": [
    "ZNF442 CNV",
    "ZNF442 RNA"
  ],
  "MED16": [
    "MED16 CNV",
    "MED16 RNA",
    "MED16 Proteo"
  ],
  "RPL21P126": [
    "RPL21P126 CNV",
    "RPL21P126 RNA"
  ],
  "TRPC6P7": [
    "TRPC6P7 CNV",
    "TRPC6P7 RNA"
  ],
  "GOLGA2P9": [
    "GOLGA2P9 CNV",
    "GOLGA2P9 RNA"
  ],
  "TAFA3": [
    "TAFA3 CNV",
    "TAFA3 RNA"
  ],
  "PM20D2": [
    "PM20D2 CNV",
    "PM20D2 RNA",
    "PM20D2 Proteo"
  ],
  "RPL23AP65": [
    "RPL23AP65 CNV",
    "RPL23AP65 RNA"
  ],
  "PCOLCE": [
    "PCOLCE CNV",
    "PCOLCE RNA",
    "PCOLCE Proteo"
  ],
  "MRS2": [
    "MRS2 CNV",
    "MRS2 RNA",
    "MRS2 Proteo"
  ],
  "TFF1": [
    "TFF1 CNV",
    "TFF1 RNA"
  ],
  "RNA5SP517": [
    "RNA5SP517 CNV",
    "RNA5SP517 RNA"
  ],
  "MRPS17P1": [
    "MRPS17P1 CNV",
    "MRPS17P1 RNA"
  ],
  "CYCSP35": [
    "CYCSP35 CNV",
    "CYCSP35 RNA"
  ],
  "PIGB": [
    "PIGB CNV",
    "PIGB RNA",
    "PIGB Proteo"
  ],
  "PLCH2": [
    "PLCH2 CNV",
    "PLCH2 RNA"
  ],
  "DCP1B": [
    "DCP1B CNV",
    "DCP1B RNA",
    "DCP1B Proteo"
  ],
  "SNX4": [
    "SNX4 CNV",
    "SNX4 RNA",
    "SNX4 Proteo"
  ],
  "ECHDC1": [
    "ECHDC1 CNV",
    "ECHDC1 RNA",
    "ECHDC1 Proteo"
  ],
  "ADGRG3": [
    "ADGRG3 CNV",
    "ADGRG3 RNA",
    "ADGRG3 Proteo"
  ],
  "DLG5": [
    "DLG5 CNV",
    "DLG5 RNA",
    "DLG5 Proteo"
  ],
  "FAM204A": [
    "FAM204A CNV",
    "FAM204A RNA",
    "FAM204A Proteo"
  ],
  "ANP32AP1": [
    "ANP32AP1 CNV",
    "ANP32AP1 RNA"
  ],
  "TDRD6": [
    "TDRD6 CNV",
    "TDRD6 RNA"
  ],
  "RNA5SP38": [
    "RNA5SP38 CNV",
    "RNA5SP38 RNA"
  ],
  "IGLV3-27": [
    "IGLV3-27 Proteo"
  ],
  "RPL31P33": [
    "RPL31P33 CNV",
    "RPL31P33 RNA"
  ],
  "OSR2": [
    "OSR2 CNV",
    "OSR2 RNA"
  ],
  "RAB5CP2": [
    "RAB5CP2 CNV",
    "RAB5CP2 RNA"
  ],
  "AK4P2": [
    "AK4P2 CNV",
    "AK4P2 RNA"
  ],
  "NIBAN3": [
    "NIBAN3 CNV",
    "NIBAN3 RNA",
    "NIBAN3 Proteo"
  ],
  "CECR2": [
    "CECR2 CNV",
    "CECR2 RNA",
    "CECR2 Proteo"
  ],
  "RNA5SP339": [
    "RNA5SP339 CNV",
    "RNA5SP339 RNA"
  ],
  "MAPK3": [
    "MAPK3 CNV",
    "MAPK3 RNA",
    "MAPK3 Proteo"
  ],
  "MARS2": [
    "MARS2 CNV",
    "MARS2 RNA",
    "MARS2 Proteo"
  ],
  "CCNJP1": [
    "CCNJP1 CNV",
    "CCNJP1 RNA"
  ],
  "PATE1": [
    "PATE1 CNV",
    "PATE1 RNA"
  ],
  "GRM6": [
    "GRM6 CNV",
    "GRM6 RNA"
  ],
  "HACE1": [
    "HACE1 CNV",
    "HACE1 RNA",
    "HACE1 Proteo"
  ],
  "OR8B12": [
    "OR8B12 CNV",
    "OR8B12 RNA"
  ],
  "TUBB7P": [
    "TUBB7P CNV",
    "TUBB7P RNA"
  ],
  "ZNF606": [
    "ZNF606 CNV",
    "ZNF606 RNA"
  ],
  "OSBPL5": [
    "OSBPL5 CNV",
    "OSBPL5 RNA",
    "OSBPL5 Proteo"
  ],
  "KRT36": [
    "KRT36 CNV",
    "KRT36 RNA",
    "KRT36 Proteo"
  ],
  "USP17L15": [
    "USP17L15 CNV",
    "USP17L15 RNA"
  ],
  "OFD1P11Y": [
    "OFD1P11Y CNV",
    "OFD1P11Y RNA"
  ],
  "DOK6": [
    "DOK6 CNV",
    "DOK6 RNA"
  ],
  "CD86": [
    "CD86 CNV",
    "CD86 RNA"
  ],
  "SLC6A16": [
    "SLC6A16 CNV",
    "SLC6A16 RNA"
  ],
  "ENPP2": [
    "ENPP2 CNV",
    "ENPP2 RNA",
    "ENPP2 Proteo"
  ],
  "RARRES2P8": [
    "RARRES2P8 CNV",
    "RARRES2P8 RNA"
  ],
  "RPS7P1": [
    "RPS7P1 CNV",
    "RPS7P1 RNA"
  ],
  "PCDHB14": [
    "PCDHB14 CNV",
    "PCDHB14 RNA",
    "PCDHB14 Proteo"
  ],
  "PLAC8": [
    "PLAC8 CNV",
    "PLAC8 RNA"
  ],
  "PPIAP34": [
    "PPIAP34 CNV",
    "PPIAP34 RNA"
  ],
  "SLC25A27": [
    "SLC25A27 CNV",
    "SLC25A27 RNA"
  ],
  "PRRC2CP1": [
    "PRRC2CP1 CNV",
    "PRRC2CP1 RNA"
  ],
  "PSMB6": [
    "PSMB6 CNV",
    "PSMB6 RNA",
    "PSMB6 Proteo"
  ],
  "PAICSP2": [
    "PAICSP2 CNV",
    "PAICSP2 RNA"
  ],
  "SCN9A": [
    "SCN9A CNV",
    "SCN9A RNA"
  ],
  "TRAV8-5": [
    "TRAV8-5 CNV",
    "TRAV8-5 RNA"
  ],
  "DSG4": [
    "DSG4 CNV",
    "DSG4 RNA"
  ],
  "ID2": [
    "ID2 CNV",
    "ID2 RNA"
  ],
  "GUSBP1": [
    "GUSBP1 CNV",
    "GUSBP1 RNA"
  ],
  "C11orf87": [
    "C11orf87 CNV",
    "C11orf87 RNA"
  ],
  "AK3P2": [
    "AK3P2 CNV",
    "AK3P2 RNA"
  ],
  "RPL5P19": [
    "RPL5P19 CNV",
    "RPL5P19 RNA"
  ],
  "NUTM2A": [
    "NUTM2A CNV",
    "NUTM2A RNA"
  ],
  "OR4F8BP": [
    "OR4F8BP CNV",
    "OR4F8BP RNA"
  ],
  "MT-ATP8": [
    "MT-ATP8 RNA",
    "MT-ATP8 Proteo"
  ],
  "ANKRD30BP2": [
    "ANKRD30BP2 CNV",
    "ANKRD30BP2 RNA"
  ],
  "SEC16A": [
    "SEC16A CNV",
    "SEC16A RNA",
    "SEC16A Proteo"
  ],
  "SUMO2P10": [
    "SUMO2P10 CNV",
    "SUMO2P10 RNA"
  ],
  "ZNF189": [
    "ZNF189 CNV",
    "ZNF189 RNA",
    "ZNF189 Proteo"
  ],
  "GTF2A1": [
    "GTF2A1 CNV",
    "GTF2A1 RNA",
    "GTF2A1 Proteo"
  ],
  "LSR": [
    "LSR CNV",
    "LSR RNA",
    "LSR Proteo"
  ],
  "NKAIN4": [
    "NKAIN4 CNV",
    "NKAIN4 RNA"
  ],
  "NLRP10": [
    "NLRP10 CNV",
    "NLRP10 RNA"
  ],
  "ADAMTS2": [
    "ADAMTS2 CNV",
    "ADAMTS2 RNA",
    "ADAMTS2 Proteo"
  ],
  "DAW1": [
    "DAW1 CNV",
    "DAW1 RNA"
  ],
  "PHETA1": [
    "PHETA1 CNV",
    "PHETA1 RNA",
    "PHETA1 Proteo"
  ],
  "FGFBP3": [
    "FGFBP3 CNV",
    "FGFBP3 RNA"
  ],
  "ZNF774": [
    "ZNF774 CNV",
    "ZNF774 RNA"
  ],
  "NAP1L1P2": [
    "NAP1L1P2 CNV",
    "NAP1L1P2 RNA"
  ],
  "SLC30A6": [
    "SLC30A6 CNV",
    "SLC30A6 RNA",
    "SLC30A6 Proteo"
  ],
  "CYCSP22": [
    "CYCSP22 CNV",
    "CYCSP22 RNA"
  ],
  "ARF4P1": [
    "ARF4P1 CNV",
    "ARF4P1 RNA"
  ],
  "FHIT": [
    "FHIT CNV",
    "FHIT RNA",
    "FHIT Proteo"
  ],
  "CLEC18A": [
    "CLEC18A CNV",
    "CLEC18A RNA"
  ],
  "EFTUD2": [
    "EFTUD2 CNV",
    "EFTUD2 RNA",
    "EFTUD2 Proteo"
  ],
  "CASP8AP2": [
    "CASP8AP2 CNV",
    "CASP8AP2 RNA",
    "CASP8AP2 Proteo"
  ],
  "PDZD2": [
    "PDZD2 CNV",
    "PDZD2 RNA",
    "PDZD2 Proteo"
  ],
  "GOLGA8Q": [
    "GOLGA8Q CNV",
    "GOLGA8Q RNA"
  ],
  "NPM1P10": [
    "NPM1P10 CNV",
    "NPM1P10 RNA"
  ],
  "XRCC3": [
    "XRCC3 CNV",
    "XRCC3 RNA",
    "XRCC3 Proteo"
  ],
  "SNAP29": [
    "SNAP29 CNV",
    "SNAP29 RNA",
    "SNAP29 Proteo"
  ],
  "SP2": [
    "SP2 CNV",
    "SP2 RNA",
    "SP2 Proteo"
  ],
  "ZNF600": [
    "ZNF600 CNV",
    "ZNF600 RNA"
  ],
  "CDY7P": [
    "CDY7P CNV",
    "CDY7P RNA"
  ],
  "ANKRD29": [
    "ANKRD29 CNV",
    "ANKRD29 RNA"
  ],
  "H2AC19": [
    "H2AC19 CNV",
    "H2AC19 RNA"
  ],
  "CARD18": [
    "CARD18 CNV",
    "CARD18 RNA",
    "CARD18 Proteo"
  ],
  "CPHXL2": [
    "CPHXL2 CNV",
    "CPHXL2 RNA"
  ],
  "ZNF239": [
    "ZNF239 CNV",
    "ZNF239 RNA"
  ],
  "OR52I1": [
    "OR52I1 CNV",
    "OR52I1 RNA"
  ],
  "ZCCHC4": [
    "ZCCHC4 CNV",
    "ZCCHC4 RNA",
    "ZCCHC4 Proteo"
  ],
  "NKTR": [
    "NKTR CNV",
    "NKTR RNA",
    "NKTR Proteo"
  ],
  "ALKBH8": [
    "ALKBH8 CNV",
    "ALKBH8 RNA",
    "ALKBH8 Proteo"
  ],
  "RASSF3": [
    "RASSF3 CNV",
    "RASSF3 RNA",
    "RASSF3 Proteo"
  ],
  "OR4M2": [
    "OR4M2 CNV",
    "OR4M2 RNA"
  ],
  "OR8K1": [
    "OR8K1 CNV",
    "OR8K1 RNA"
  ],
  "TAF9P3": [
    "TAF9P3 CNV",
    "TAF9P3 RNA"
  ],
  "F2RL1": [
    "F2RL1 CNV",
    "F2RL1 RNA"
  ],
  "NDUFA3P2": [
    "NDUFA3P2 CNV",
    "NDUFA3P2 RNA"
  ],
  "PAF1": [
    "PAF1 CNV",
    "PAF1 RNA",
    "PAF1 Proteo"
  ],
  "OR1X1P": [
    "OR1X1P CNV",
    "OR1X1P RNA"
  ],
  "IL17REL": [
    "IL17REL CNV",
    "IL17REL RNA"
  ],
  "SMARCAL1": [
    "SMARCAL1 CNV",
    "SMARCAL1 RNA",
    "SMARCAL1 Proteo"
  ],
  "OR10D3": [
    "OR10D3 CNV",
    "OR10D3 RNA"
  ],
  "PDLIM1P1": [
    "PDLIM1P1 CNV",
    "PDLIM1P1 RNA"
  ],
  "FKBP1AP2": [
    "FKBP1AP2 CNV",
    "FKBP1AP2 RNA"
  ],
  "RCC2P5": [
    "RCC2P5 CNV",
    "RCC2P5 RNA"
  ],
  "SPATA31D1": [
    "SPATA31D1 CNV",
    "SPATA31D1 RNA"
  ],
  "AWAT1": [
    "AWAT1 CNV",
    "AWAT1 RNA"
  ],
  "ABHD17A": [
    "ABHD17A CNV",
    "ABHD17A RNA",
    "ABHD17A Proteo"
  ],
  "SLC22A24": [
    "SLC22A24 CNV",
    "SLC22A24 RNA"
  ],
  "HSPE1P21": [
    "HSPE1P21 CNV",
    "HSPE1P21 RNA"
  ],
  "CRLF1": [
    "CRLF1 CNV",
    "CRLF1 RNA",
    "CRLF1 Proteo"
  ],
  "FPR1": [
    "FPR1 CNV",
    "FPR1 RNA",
    "FPR1 Proteo"
  ],
  "CLCNKA": [
    "CLCNKA CNV",
    "CLCNKA RNA"
  ],
  "KRTAP9-8": [
    "KRTAP9-8 CNV",
    "KRTAP9-8 RNA"
  ],
  "GCGR": [
    "GCGR CNV",
    "GCGR RNA"
  ],
  "CST3": [
    "CST3 CNV",
    "CST3 RNA",
    "CST3 Proteo"
  ],
  "FOXP1": [
    "FOXP1 CNV",
    "FOXP1 RNA",
    "FOXP1 Proteo"
  ],
  "OR4G11P": [
    "OR4G11P CNV",
    "OR4G11P RNA"
  ],
  "RPL23AP33": [
    "RPL23AP33 CNV",
    "RPL23AP33 RNA"
  ],
  "IGHV3-35": [
    "IGHV3-35 Proteo"
  ],
  "THRAP3": [
    "THRAP3 CNV",
    "THRAP3 RNA",
    "THRAP3 Proteo"
  ],
  "NXF3": [
    "NXF3 CNV",
    "NXF3 RNA"
  ],
  "TEDC2": [
    "TEDC2 CNV",
    "TEDC2 RNA",
    "TEDC2 Proteo"
  ],
  "HSP90AB1": [
    "HSP90AB1 CNV",
    "HSP90AB1 RNA",
    "HSP90AB1 Proteo"
  ],
  "ZNF324": [
    "ZNF324 CNV",
    "ZNF324 RNA",
    "ZNF324 Proteo"
  ],
  "NPIPB13": [
    "NPIPB13 CNV",
    "NPIPB13 RNA"
  ],
  "OR11J6P": [
    "OR11J6P CNV",
    "OR11J6P RNA"
  ],
  "REC114": [
    "REC114 CNV",
    "REC114 RNA"
  ],
  "KLHDC2": [
    "KLHDC2 CNV",
    "KLHDC2 RNA",
    "KLHDC2 Proteo"
  ],
  "H2AC8": [
    "H2AC8 CNV",
    "H2AC8 RNA",
    "H2AC8 Proteo"
  ],
  "AFAP1L1": [
    "AFAP1L1 CNV",
    "AFAP1L1 RNA",
    "AFAP1L1 Proteo"
  ],
  "PPP1R2P6": [
    "PPP1R2P6 CNV",
    "PPP1R2P6 RNA"
  ],
  "HAUS1P1": [
    "HAUS1P1 CNV",
    "HAUS1P1 RNA"
  ],
  "MAP3K13": [
    "MAP3K13 CNV",
    "MAP3K13 RNA"
  ],
  "DBF4P3": [
    "DBF4P3 CNV",
    "DBF4P3 RNA"
  ],
  "COL9A1": [
    "COL9A1 CNV",
    "COL9A1 RNA",
    "COL9A1 Proteo"
  ],
  "IL1RL1": [
    "IL1RL1 CNV",
    "IL1RL1 RNA"
  ],
  "MBD3L2B": [
    "MBD3L2B CNV",
    "MBD3L2B RNA"
  ],
  "NDST2": [
    "NDST2 CNV",
    "NDST2 RNA",
    "NDST2 Proteo"
  ],
  "RNF133": [
    "RNF133 CNV",
    "RNF133 RNA"
  ],
  "MYBPC1": [
    "MYBPC1 CNV",
    "MYBPC1 RNA",
    "MYBPC1 Proteo"
  ],
  "ZP3": [
    "ZP3 CNV",
    "ZP3 RNA"
  ],
  "SMPD4P2": [
    "SMPD4P2 CNV",
    "SMPD4P2 RNA"
  ],
  "MTND2P11": [
    "MTND2P11 CNV",
    "MTND2P11 RNA"
  ],
  "PI4KAP2": [
    "PI4KAP2 CNV",
    "PI4KAP2 RNA"
  ],
  "UGT3A2": [
    "UGT3A2 CNV",
    "UGT3A2 RNA"
  ],
  "ATOH1": [
    "ATOH1 CNV",
    "ATOH1 RNA"
  ],
  "RPS9": [
    "RPS9 CNV",
    "RPS9 RNA",
    "RPS9 Proteo"
  ],
  "MARK2P11": [
    "MARK2P11 CNV",
    "MARK2P11 RNA"
  ],
  "GPALPP1": [
    "GPALPP1 CNV",
    "GPALPP1 RNA",
    "GPALPP1 Proteo"
  ],
  "SPPL2A": [
    "SPPL2A CNV",
    "SPPL2A RNA",
    "SPPL2A Proteo"
  ],
  "RPL7L1P9": [
    "RPL7L1P9 CNV",
    "RPL7L1P9 RNA"
  ],
  "INTS12": [
    "INTS12 CNV",
    "INTS12 RNA",
    "INTS12 Proteo"
  ],
  "LAMA5": [
    "LAMA5 CNV",
    "LAMA5 RNA",
    "LAMA5 Proteo"
  ],
  "CUX2P1": [
    "CUX2P1 CNV",
    "CUX2P1 RNA"
  ],
  "ALCAM": [
    "ALCAM CNV",
    "ALCAM RNA",
    "ALCAM Proteo"
  ],
  "EEF1AKMT1": [
    "EEF1AKMT1 CNV",
    "EEF1AKMT1 RNA",
    "EEF1AKMT1 Proteo"
  ],
  "PRKCH": [
    "PRKCH CNV",
    "PRKCH RNA",
    "PRKCH Proteo"
  ],
  "RFX2": [
    "RFX2 CNV",
    "RFX2 RNA",
    "RFX2 Proteo"
  ],
  "TPRKB": [
    "TPRKB CNV",
    "TPRKB RNA",
    "TPRKB Proteo"
  ],
  "KRT6B": [
    "KRT6B CNV",
    "KRT6B RNA",
    "KRT6B Proteo"
  ],
  "IFTAP": [
    "IFTAP CNV",
    "IFTAP RNA",
    "IFTAP Proteo"
  ],
  "B4GALT7": [
    "B4GALT7 CNV",
    "B4GALT7 RNA",
    "B4GALT7 Proteo"
  ],
  "NUP214": [
    "NUP214 CNV",
    "NUP214 RNA",
    "NUP214 Proteo"
  ],
  "OR5H6": [
    "OR5H6 CNV",
    "OR5H6 RNA"
  ],
  "MTM1": [
    "MTM1 CNV",
    "MTM1 RNA",
    "MTM1 Proteo"
  ],
  "TOB2": [
    "TOB2 CNV",
    "TOB2 RNA",
    "TOB2 Proteo"
  ],
  "PCDH19": [
    "PCDH19 CNV",
    "PCDH19 RNA"
  ],
  "TTL": [
    "TTL CNV",
    "TTL RNA",
    "TTL Proteo"
  ],
  "GPN3P1": [
    "GPN3P1 CNV",
    "GPN3P1 RNA"
  ],
  "ADCYAP1R1": [
    "ADCYAP1R1 CNV",
    "ADCYAP1R1 RNA"
  ],
  "LIG3": [
    "LIG3 CNV",
    "LIG3 RNA",
    "LIG3 Proteo"
  ],
  "CNNM1": [
    "CNNM1 CNV",
    "CNNM1 RNA"
  ],
  "TBCE": [
    "TBCE CNV",
    "TBCE RNA",
    "TBCE Proteo"
  ],
  "GLT8D1": [
    "GLT8D1 CNV",
    "GLT8D1 RNA",
    "GLT8D1 Proteo"
  ],
  "FUCA1": [
    "FUCA1 CNV",
    "FUCA1 RNA",
    "FUCA1 Proteo"
  ],
  "RBISP2": [
    "RBISP2 CNV",
    "RBISP2 RNA"
  ],
  "ALAS1": [
    "ALAS1 CNV",
    "ALAS1 RNA",
    "ALAS1 Proteo"
  ],
  "CYCSP17": [
    "CYCSP17 CNV",
    "CYCSP17 RNA"
  ],
  "EHBP1L1": [
    "EHBP1L1 CNV",
    "EHBP1L1 RNA",
    "EHBP1L1 Proteo"
  ],
  "FRG2B": [
    "FRG2B CNV",
    "FRG2B RNA"
  ],
  "ABRAXAS2": [
    "ABRAXAS2 CNV",
    "ABRAXAS2 RNA",
    "ABRAXAS2 Proteo"
  ],
  "CNIH4": [
    "CNIH4 CNV",
    "CNIH4 RNA",
    "CNIH4 Proteo"
  ],
  "SEPTIN4": [
    "SEPTIN4 CNV",
    "SEPTIN4 RNA",
    "SEPTIN4 Proteo"
  ],
  "KAT8": [
    "KAT8 CNV",
    "KAT8 RNA",
    "KAT8 Proteo"
  ],
  "RPS3AP39": [
    "RPS3AP39 CNV",
    "RPS3AP39 RNA"
  ],
  "ANKRA2": [
    "ANKRA2 CNV",
    "ANKRA2 RNA",
    "ANKRA2 Proteo"
  ],
  "GRB7": [
    "GRB7 CNV",
    "GRB7 RNA",
    "GRB7 Proteo"
  ],
  "PROKR1": [
    "PROKR1 CNV",
    "PROKR1 RNA"
  ],
  "SLC9A1": [
    "SLC9A1 CNV",
    "SLC9A1 RNA",
    "SLC9A1 Proteo"
  ],
  "OXTR": [
    "OXTR CNV",
    "OXTR RNA"
  ],
  "DMTF1": [
    "DMTF1 CNV",
    "DMTF1 RNA",
    "DMTF1 Proteo"
  ],
  "NOMO1": [
    "NOMO1 CNV",
    "NOMO1 RNA",
    "NOMO1 Proteo"
  ],
  "ELF1": [
    "ELF1 CNV",
    "ELF1 RNA",
    "ELF1 Proteo"
  ],
  "TRPM6": [
    "TRPM6 CNV",
    "TRPM6 RNA"
  ],
  "KRTAP2-2": [
    "KRTAP2-2 CNV",
    "KRTAP2-2 RNA"
  ],
  "UNG": [
    "UNG CNV",
    "UNG RNA",
    "UNG Proteo"
  ],
  "BAK1": [
    "BAK1 CNV",
    "BAK1 RNA",
    "BAK1 Proteo"
  ],
  "RPL39L": [
    "RPL39L CNV",
    "RPL39L RNA"
  ],
  "LRRC75B": [
    "LRRC75B CNV",
    "LRRC75B RNA"
  ],
  "CDY5P": [
    "CDY5P CNV",
    "CDY5P RNA"
  ],
  "WDR54": [
    "WDR54 CNV",
    "WDR54 RNA",
    "WDR54 Proteo"
  ],
  "POTEH": [
    "POTEH CNV",
    "POTEH RNA"
  ],
  "COX11P1": [
    "COX11P1 CNV",
    "COX11P1 RNA"
  ],
  "BCL9P1": [
    "BCL9P1 CNV",
    "BCL9P1 RNA"
  ],
  "OR8A2P": [
    "OR8A2P CNV",
    "OR8A2P RNA"
  ],
  "UQCRB": [
    "UQCRB CNV",
    "UQCRB RNA",
    "UQCRB Proteo"
  ],
  "D2HGDH": [
    "D2HGDH CNV",
    "D2HGDH RNA",
    "D2HGDH Proteo"
  ],
  "RAB1C": [
    "RAB1C CNV",
    "RAB1C RNA"
  ],
  "DLST": [
    "DLST CNV",
    "DLST RNA",
    "DLST Proteo"
  ],
  "MS4A1": [
    "MS4A1 CNV",
    "MS4A1 RNA",
    "MS4A1 Proteo"
  ],
  "HMGB1P5": [
    "HMGB1P5 CNV",
    "HMGB1P5 RNA"
  ],
  "RPSAP32": [
    "RPSAP32 CNV",
    "RPSAP32 RNA"
  ],
  "RAB11B": [
    "RAB11B CNV",
    "RAB11B RNA",
    "RAB11B Proteo"
  ],
  "MUC2": [
    "MUC2 CNV",
    "MUC2 RNA",
    "MUC2 Proteo"
  ],
  "TMEM160": [
    "TMEM160 CNV",
    "TMEM160 RNA",
    "TMEM160 Proteo"
  ],
  "MTRES1": [
    "MTRES1 CNV",
    "MTRES1 RNA",
    "MTRES1 Proteo"
  ],
  "C7orf25": [
    "C7orf25 CNV",
    "C7orf25 RNA",
    "C7orf25 Proteo"
  ],
  "SEPTIN7P4": [
    "SEPTIN7P4 CNV",
    "SEPTIN7P4 RNA"
  ],
  "RRH": [
    "RRH CNV",
    "RRH RNA"
  ],
  "CXCR4": [
    "CXCR4 CNV",
    "CXCR4 RNA",
    "CXCR4 Proteo"
  ],
  "H2AZP1": [
    "H2AZP1 CNV",
    "H2AZP1 RNA"
  ],
  "TPI1P3": [
    "TPI1P3 CNV",
    "TPI1P3 RNA"
  ],
  "LIN28AP1": [
    "LIN28AP1 CNV",
    "LIN28AP1 RNA"
  ],
  "TRIM49B": [
    "TRIM49B CNV",
    "TRIM49B RNA"
  ],
  "NR1I2": [
    "NR1I2 CNV",
    "NR1I2 RNA"
  ],
  "NEFL": [
    "NEFL CNV",
    "NEFL RNA",
    "NEFL Proteo"
  ],
  "MTND4P18": [
    "MTND4P18 CNV",
    "MTND4P18 RNA"
  ],
  "ZNF10": [
    "ZNF10 CNV",
    "ZNF10 RNA"
  ],
  "MAP2K1": [
    "MAP2K1 CNV",
    "MAP2K1 RNA",
    "MAP2K1 Proteo"
  ],
  "RYBP": [
    "RYBP CNV",
    "RYBP RNA",
    "RYBP Proteo"
  ],
  "RBMY2FP": [
    "RBMY2FP CNV",
    "RBMY2FP RNA"
  ],
  "RPL9P13": [
    "RPL9P13 CNV",
    "RPL9P13 RNA"
  ],
  "FBXO33": [
    "FBXO33 CNV",
    "FBXO33 RNA",
    "FBXO33 Proteo"
  ],
  "NPM1P22": [
    "NPM1P22 CNV",
    "NPM1P22 RNA"
  ],
  "GTF2IP2": [
    "GTF2IP2 CNV",
    "GTF2IP2 RNA"
  ],
  "ACR": [
    "ACR CNV",
    "ACR RNA"
  ],
  "TMEM107": [
    "TMEM107 CNV",
    "TMEM107 RNA"
  ],
  "LHFPL6": [
    "LHFPL6 CNV",
    "LHFPL6 RNA",
    "LHFPL6 Proteo"
  ],
  "IER5": [
    "IER5 CNV",
    "IER5 RNA"
  ],
  "TOGARAM2": [
    "TOGARAM2 CNV",
    "TOGARAM2 RNA"
  ],
  "RPL23AP40": [
    "RPL23AP40 CNV",
    "RPL23AP40 RNA"
  ],
  "MED21": [
    "MED21 CNV",
    "MED21 RNA",
    "MED21 Proteo"
  ],
  "CCNT2P1": [
    "CCNT2P1 CNV",
    "CCNT2P1 RNA"
  ],
  "MYL2": [
    "MYL2 CNV",
    "MYL2 RNA",
    "MYL2 Proteo"
  ],
  "CFAP70": [
    "CFAP70 CNV",
    "CFAP70 RNA"
  ],
  "GRK7": [
    "GRK7 CNV",
    "GRK7 RNA"
  ],
  "HPCAL1": [
    "HPCAL1 CNV",
    "HPCAL1 RNA",
    "HPCAL1 Proteo"
  ],
  "DMXL1": [
    "DMXL1 CNV",
    "DMXL1 RNA",
    "DMXL1 Proteo"
  ],
  "EEF1G": [
    "EEF1G CNV",
    "EEF1G RNA",
    "EEF1G Proteo"
  ],
  "RNA5SP306": [
    "RNA5SP306 CNV",
    "RNA5SP306 RNA"
  ],
  "CHORDC2P": [
    "CHORDC2P CNV",
    "CHORDC2P RNA"
  ],
  "KLHL5": [
    "KLHL5 CNV",
    "KLHL5 RNA",
    "KLHL5 Proteo"
  ],
  "TMEM121B": [
    "TMEM121B CNV",
    "TMEM121B RNA"
  ],
  "NFILZ": [
    "NFILZ CNV",
    "NFILZ RNA"
  ],
  "USP9YP1": [
    "USP9YP1 CNV",
    "USP9YP1 RNA"
  ],
  "OR5AQ1P": [
    "OR5AQ1P CNV",
    "OR5AQ1P RNA"
  ],
  "DCHS1": [
    "DCHS1 CNV",
    "DCHS1 RNA",
    "DCHS1 Proteo"
  ],
  "PPP2R3B": [
    "PPP2R3B CNV",
    "PPP2R3B RNA",
    "PPP2R3B Proteo"
  ],
  "CCNL2": [
    "CCNL2 CNV",
    "CCNL2 RNA",
    "CCNL2 Proteo"
  ],
  "LAP3": [
    "LAP3 CNV",
    "LAP3 RNA",
    "LAP3 Proteo"
  ],
  "DOK3": [
    "DOK3 CNV",
    "DOK3 RNA",
    "DOK3 Proteo"
  ],
  "RBM22P12": [
    "RBM22P12 CNV",
    "RBM22P12 RNA"
  ],
  "MTCYBP14": [
    "MTCYBP14 CNV",
    "MTCYBP14 RNA"
  ],
  "DNAJB4": [
    "DNAJB4 CNV",
    "DNAJB4 RNA",
    "DNAJB4 Proteo"
  ],
  "ASH1L": [
    "ASH1L CNV",
    "ASH1L RNA",
    "ASH1L Proteo"
  ],
  "FNBP1L": [
    "FNBP1L CNV",
    "FNBP1L RNA",
    "FNBP1L Proteo"
  ],
  "WBP1LP10": [
    "WBP1LP10 CNV",
    "WBP1LP10 RNA"
  ],
  "ACOT4": [
    "ACOT4 CNV",
    "ACOT4 RNA",
    "ACOT4 Proteo"
  ],
  "MTCYBP2": [
    "MTCYBP2 CNV",
    "MTCYBP2 RNA"
  ],
  "NMRAL1": [
    "NMRAL1 CNV",
    "NMRAL1 RNA",
    "NMRAL1 Proteo"
  ],
  "ATP5PF": [
    "ATP5PF CNV",
    "ATP5PF RNA",
    "ATP5PF Proteo"
  ],
  "SLU7": [
    "SLU7 CNV",
    "SLU7 RNA",
    "SLU7 Proteo"
  ],
  "MEF2AP1": [
    "MEF2AP1 CNV",
    "MEF2AP1 RNA"
  ],
  "CCNA2": [
    "CCNA2 CNV",
    "CCNA2 RNA",
    "CCNA2 Proteo"
  ],
  "HLA-B": [
    "HLA-B CNV",
    "HLA-B RNA",
    "HLA-B Proteo"
  ],
  "BGN": [
    "BGN CNV",
    "BGN RNA",
    "BGN Proteo"
  ],
  "PABPC1P6": [
    "PABPC1P6 CNV",
    "PABPC1P6 RNA"
  ],
  "RPL23AP46": [
    "RPL23AP46 CNV",
    "RPL23AP46 RNA"
  ],
  "CDCA4P2": [
    "CDCA4P2 CNV",
    "CDCA4P2 RNA"
  ],
  "CYP2C18": [
    "CYP2C18 CNV",
    "CYP2C18 RNA"
  ],
  "ABCA5": [
    "ABCA5 CNV",
    "ABCA5 RNA",
    "ABCA5 Proteo"
  ],
  "DEFB118": [
    "DEFB118 CNV",
    "DEFB118 RNA"
  ],
  "LATS1": [
    "LATS1 CNV",
    "LATS1 RNA",
    "LATS1 Proteo"
  ],
  "OR4G2P": [
    "OR4G2P CNV",
    "OR4G2P RNA"
  ],
  "RPL31P52": [
    "RPL31P52 CNV",
    "RPL31P52 RNA"
  ],
  "SCAI": [
    "SCAI CNV",
    "SCAI RNA",
    "SCAI Proteo"
  ],
  "MICD": [
    "MICD CNV",
    "MICD RNA"
  ],
  "HIC2": [
    "HIC2 CNV",
    "HIC2 RNA"
  ],
  "PGS1": [
    "PGS1 CNV",
    "PGS1 RNA",
    "PGS1 Proteo"
  ],
  "KDM4A": [
    "KDM4A CNV",
    "KDM4A RNA",
    "KDM4A Proteo"
  ],
  "CUTALP": [
    "CUTALP CNV",
    "CUTALP RNA"
  ],
  "TUBAP11": [
    "TUBAP11 CNV",
    "TUBAP11 RNA"
  ],
  "BCAM": [
    "BCAM CNV",
    "BCAM RNA",
    "BCAM Proteo"
  ],
  "SMG5": [
    "SMG5 CNV",
    "SMG5 RNA",
    "SMG5 Proteo"
  ],
  "HSD17B7P1": [
    "HSD17B7P1 CNV",
    "HSD17B7P1 RNA"
  ],
  "MLC1": [
    "MLC1 CNV",
    "MLC1 RNA"
  ],
  "GGT7": [
    "GGT7 CNV",
    "GGT7 RNA",
    "GGT7 Proteo"
  ],
  "DPH3P2": [
    "DPH3P2 CNV",
    "DPH3P2 RNA"
  ],
  "METTL2B": [
    "METTL2B CNV",
    "METTL2B RNA",
    "METTL2B Proteo"
  ],
  "PSME1": [
    "PSME1 CNV",
    "PSME1 RNA",
    "PSME1 Proteo"
  ],
  "DHX33": [
    "DHX33 CNV",
    "DHX33 RNA",
    "DHX33 Proteo"
  ],
  "GDF5": [
    "GDF5 CNV",
    "GDF5 RNA"
  ],
  "STOML2": [
    "STOML2 CNV",
    "STOML2 RNA",
    "STOML2 Proteo"
  ],
  "DCANP1": [
    "DCANP1 CNV",
    "DCANP1 RNA"
  ],
  "COL6A2": [
    "COL6A2 CNV",
    "COL6A2 RNA",
    "COL6A2 Proteo"
  ],
  "APOBEC3B": [
    "APOBEC3B CNV",
    "APOBEC3B RNA",
    "APOBEC3B Proteo"
  ],
  "BPNT1": [
    "BPNT1 CNV",
    "BPNT1 RNA",
    "BPNT1 Proteo"
  ],
  "AGTR2": [
    "AGTR2 CNV",
    "AGTR2 RNA"
  ],
  "WDHD1": [
    "WDHD1 CNV",
    "WDHD1 RNA",
    "WDHD1 Proteo"
  ],
  "INPP5K": [
    "INPP5K CNV",
    "INPP5K RNA",
    "INPP5K Proteo"
  ],
  "VPS35L": [
    "VPS35L CNV",
    "VPS35L RNA",
    "VPS35L Proteo"
  ],
  "CYRIA": [
    "CYRIA CNV",
    "CYRIA RNA",
    "CYRIA Proteo"
  ],
  "DNAI4": [
    "DNAI4 CNV",
    "DNAI4 RNA"
  ],
  "ZMAT2": [
    "ZMAT2 CNV",
    "ZMAT2 RNA",
    "ZMAT2 Proteo"
  ],
  "DDX39AP1": [
    "DDX39AP1 CNV",
    "DDX39AP1 RNA"
  ],
  "CKLF": [
    "CKLF CNV",
    "CKLF RNA",
    "CKLF Proteo"
  ],
  "CD24": [
    "CD24 CNV",
    "CD24 RNA"
  ],
  "IDI1P1": [
    "IDI1P1 CNV",
    "IDI1P1 RNA"
  ],
  "RIOK1": [
    "RIOK1 CNV",
    "RIOK1 RNA",
    "RIOK1 Proteo"
  ],
  "MAGEB6": [
    "MAGEB6 CNV",
    "MAGEB6 RNA"
  ],
  "SLC22A9": [
    "SLC22A9 CNV",
    "SLC22A9 RNA"
  ],
  "MSH2": [
    "MSH2 CNV",
    "MSH2 RNA",
    "MSH2 Proteo"
  ],
  "SYVN1": [
    "SYVN1 CNV",
    "SYVN1 RNA",
    "SYVN1 Proteo"
  ],
  "SERINC3": [
    "SERINC3 CNV",
    "SERINC3 RNA",
    "SERINC3 Proteo"
  ],
  "TMEM275": [
    "TMEM275 CNV",
    "TMEM275 RNA",
    "TMEM275 Proteo"
  ],
  "PIGL": [
    "PIGL CNV",
    "PIGL RNA",
    "PIGL Proteo"
  ],
  "PACS1": [
    "PACS1 CNV",
    "PACS1 RNA",
    "PACS1 Proteo"
  ],
  "KRT8P31": [
    "KRT8P31 CNV",
    "KRT8P31 RNA"
  ],
  "IGHVIII-11-1": [
    "IGHVIII-11-1 CNV",
    "IGHVIII-11-1 RNA"
  ],
  "RPL26L1": [
    "RPL26L1 CNV",
    "RPL26L1 RNA",
    "RPL26L1 Proteo"
  ],
  "IGLV2-18": [
    "IGLV2-18 Proteo"
  ],
  "ZNF965P": [
    "ZNF965P CNV",
    "ZNF965P RNA"
  ],
  "EEF1A1P26": [
    "EEF1A1P26 CNV",
    "EEF1A1P26 RNA"
  ],
  "RETN": [
    "RETN CNV",
    "RETN RNA",
    "RETN Proteo"
  ],
  "TRIM24": [
    "TRIM24 CNV",
    "TRIM24 RNA",
    "TRIM24 Proteo"
  ],
  "INIP": [
    "INIP CNV",
    "INIP RNA",
    "INIP Proteo"
  ],
  "TTC39B": [
    "TTC39B CNV",
    "TTC39B RNA",
    "TTC39B Proteo"
  ],
  "ZNF326": [
    "ZNF326 CNV",
    "ZNF326 RNA",
    "ZNF326 Proteo"
  ],
  "ELOCP23": [
    "ELOCP23 CNV",
    "ELOCP23 RNA"
  ],
  "ESR1": [
    "ESR1 CNV",
    "ESR1 RNA",
    "ESR1 Proteo"
  ],
  "RGS3": [
    "RGS3 CNV",
    "RGS3 RNA",
    "RGS3 Proteo"
  ],
  "DHX36": [
    "DHX36 CNV",
    "DHX36 RNA",
    "DHX36 Proteo"
  ],
  "OR4D11": [
    "OR4D11 CNV",
    "OR4D11 RNA"
  ],
  "NEU1": [
    "NEU1 CNV",
    "NEU1 RNA",
    "NEU1 Proteo"
  ],
  "TMSB4X": [
    "TMSB4X CNV",
    "TMSB4X RNA",
    "TMSB4X Proteo"
  ],
  "RNASE4": [
    "RNASE4 CNV",
    "RNASE4 RNA",
    "RNASE4 Proteo"
  ],
  "NUCKS1": [
    "NUCKS1 CNV",
    "NUCKS1 RNA",
    "NUCKS1 Proteo"
  ],
  "LIMS3": [
    "LIMS3 CNV",
    "LIMS3 RNA"
  ],
  "TADA1": [
    "TADA1 CNV",
    "TADA1 RNA",
    "TADA1 Proteo"
  ],
  "IER5L": [
    "IER5L CNV",
    "IER5L RNA"
  ],
  "SHC1P2": [
    "SHC1P2 CNV",
    "SHC1P2 RNA"
  ],
  "TPSP2": [
    "TPSP2 CNV",
    "TPSP2 RNA"
  ],
  "NAIPP2": [
    "NAIPP2 CNV",
    "NAIPP2 RNA"
  ],
  "GGT8P": [
    "GGT8P CNV",
    "GGT8P RNA"
  ],
  "ADAM20P1": [
    "ADAM20P1 CNV",
    "ADAM20P1 RNA"
  ],
  "RBM14": [
    "RBM14 CNV",
    "RBM14 RNA",
    "RBM14 Proteo"
  ],
  "DPY19L1P2": [
    "DPY19L1P2 CNV",
    "DPY19L1P2 RNA"
  ],
  "ZNF564": [
    "ZNF564 CNV",
    "ZNF564 RNA",
    "ZNF564 Proteo"
  ],
  "TGFB1": [
    "TGFB1 CNV",
    "TGFB1 RNA",
    "TGFB1 Proteo"
  ],
  "RB1": [
    "RB1 CNV",
    "RB1 RNA",
    "RB1 Proteo"
  ],
  "RPL12P1": [
    "RPL12P1 CNV",
    "RPL12P1 RNA"
  ],
  "SPATA31A1": [
    "SPATA31A1 CNV",
    "SPATA31A1 RNA"
  ],
  "OR52K1": [
    "OR52K1 CNV",
    "OR52K1 RNA"
  ],
  "PHB1P12": [
    "PHB1P12 CNV",
    "PHB1P12 RNA"
  ],
  "NOS1AP": [
    "NOS1AP CNV",
    "NOS1AP RNA",
    "NOS1AP Proteo"
  ],
  "RPL32P14": [
    "RPL32P14 CNV",
    "RPL32P14 RNA"
  ],
  "PSD": [
    "PSD CNV",
    "PSD RNA"
  ],
  "VCPIP1": [
    "VCPIP1 CNV",
    "VCPIP1 RNA",
    "VCPIP1 Proteo"
  ],
  "ZNF366": [
    "ZNF366 CNV",
    "ZNF366 RNA"
  ],
  "CDR2": [
    "CDR2 CNV",
    "CDR2 RNA",
    "CDR2 Proteo"
  ],
  "PHC1P1": [
    "PHC1P1 CNV",
    "PHC1P1 RNA"
  ],
  "APBB2": [
    "APBB2 CNV",
    "APBB2 RNA",
    "APBB2 Proteo"
  ],
  "GDI2": [
    "GDI2 CNV",
    "GDI2 RNA",
    "GDI2 Proteo"
  ],
  "NPAS2": [
    "NPAS2 CNV",
    "NPAS2 RNA"
  ],
  "VPS37D": [
    "VPS37D CNV",
    "VPS37D RNA"
  ],
  "ZFPM2": [
    "ZFPM2 CNV",
    "ZFPM2 RNA"
  ],
  "STMN1": [
    "STMN1 CNV",
    "STMN1 RNA",
    "STMN1 Proteo"
  ],
  "ABCA10": [
    "ABCA10 CNV",
    "ABCA10 RNA"
  ],
  "DAPK3": [
    "DAPK3 CNV",
    "DAPK3 RNA",
    "DAPK3 Proteo"
  ],
  "YY1P1": [
    "YY1P1 CNV",
    "YY1P1 RNA"
  ],
  "PRCP": [
    "PRCP CNV",
    "PRCP RNA",
    "PRCP Proteo"
  ],
  "UVSSA": [
    "UVSSA CNV",
    "UVSSA RNA",
    "UVSSA Proteo"
  ],
  "RPL26P30": [
    "RPL26P30 CNV",
    "RPL26P30 RNA"
  ],
  "IGKV1-22": [
    "IGKV1-22 CNV",
    "IGKV1-22 RNA"
  ],
  "LHFPL4": [
    "LHFPL4 CNV",
    "LHFPL4 RNA"
  ],
  "DNAJA2": [
    "DNAJA2 CNV",
    "DNAJA2 RNA",
    "DNAJA2 Proteo"
  ],
  "LARP7P2": [
    "LARP7P2 CNV",
    "LARP7P2 RNA"
  ],
  "DUSP18": [
    "DUSP18 CNV",
    "DUSP18 RNA"
  ],
  "NPM1P38": [
    "NPM1P38 CNV",
    "NPM1P38 RNA"
  ],
  "PGA4": [
    "PGA4 CNV",
    "PGA4 RNA"
  ],
  "RPL35AP32": [
    "RPL35AP32 CNV",
    "RPL35AP32 RNA"
  ],
  "RPL17P25": [
    "RPL17P25 CNV",
    "RPL17P25 RNA"
  ],
  "DPH6": [
    "DPH6 CNV",
    "DPH6 RNA",
    "DPH6 Proteo"
  ],
  "ENTPD8": [
    "ENTPD8 CNV",
    "ENTPD8 RNA"
  ],
  "ARSLP1": [
    "ARSLP1 CNV",
    "ARSLP1 RNA"
  ],
  "COX5AP2": [
    "COX5AP2 CNV",
    "COX5AP2 RNA"
  ],
  "PARD3": [
    "PARD3 CNV",
    "PARD3 RNA",
    "PARD3 Proteo"
  ],
  "NPC2": [
    "NPC2 CNV",
    "NPC2 RNA",
    "NPC2 Proteo"
  ],
  "FAHD2B": [
    "FAHD2B CNV",
    "FAHD2B RNA",
    "FAHD2B Proteo"
  ],
  "C19orf53": [
    "C19orf53 CNV",
    "C19orf53 RNA",
    "C19orf53 Proteo"
  ],
  "KCNC3": [
    "KCNC3 CNV",
    "KCNC3 RNA"
  ],
  "ACTR3BP1": [
    "ACTR3BP1 CNV",
    "ACTR3BP1 RNA"
  ],
  "FBXO31": [
    "FBXO31 CNV",
    "FBXO31 RNA",
    "FBXO31 Proteo"
  ],
  "IFNNP1": [
    "IFNNP1 CNV",
    "IFNNP1 RNA"
  ],
  "RPL7AP6": [
    "RPL7AP6 CNV",
    "RPL7AP6 RNA"
  ],
  "BIRC2": [
    "BIRC2 CNV",
    "BIRC2 RNA",
    "BIRC2 Proteo"
  ],
  "YBX1P1": [
    "YBX1P1 CNV",
    "YBX1P1 RNA"
  ],
  "PRSS3P4": [
    "PRSS3P4 CNV",
    "PRSS3P4 RNA"
  ],
  "GUCY1B1": [
    "GUCY1B1 CNV",
    "GUCY1B1 RNA",
    "GUCY1B1 Proteo"
  ],
  "OR2A13P": [
    "OR2A13P CNV",
    "OR2A13P RNA"
  ],
  "MFSD14B": [
    "MFSD14B CNV",
    "MFSD14B RNA",
    "MFSD14B Proteo"
  ],
  "NDFIP2": [
    "NDFIP2 CNV",
    "NDFIP2 RNA",
    "NDFIP2 Proteo"
  ],
  "REEP1": [
    "REEP1 CNV",
    "REEP1 RNA",
    "REEP1 Proteo"
  ],
  "LGI4": [
    "LGI4 CNV",
    "LGI4 RNA",
    "LGI4 Proteo"
  ],
  "SLC6A3": [
    "SLC6A3 CNV",
    "SLC6A3 RNA"
  ],
  "SLC20A1P2": [
    "SLC20A1P2 CNV",
    "SLC20A1P2 RNA"
  ],
  "COX6B1P5": [
    "COX6B1P5 CNV",
    "COX6B1P5 RNA"
  ],
  "PDLIM5": [
    "PDLIM5 CNV",
    "PDLIM5 RNA",
    "PDLIM5 Proteo"
  ],
  "PLAC9P1": [
    "PLAC9P1 CNV",
    "PLAC9P1 RNA"
  ],
  "OR51L1": [
    "OR51L1 CNV",
    "OR51L1 RNA"
  ],
  "RTRAF": [
    "RTRAF CNV",
    "RTRAF RNA",
    "RTRAF Proteo"
  ],
  "RNA5-8SP2": [
    "RNA5-8SP2 CNV",
    "RNA5-8SP2 RNA"
  ],
  "CDK5R2": [
    "CDK5R2 CNV",
    "CDK5R2 RNA"
  ],
  "IGFBP3": [
    "IGFBP3 CNV",
    "IGFBP3 RNA",
    "IGFBP3 Proteo"
  ],
  "KRT8P3": [
    "KRT8P3 CNV",
    "KRT8P3 RNA"
  ],
  "DPP7": [
    "DPP7 CNV",
    "DPP7 RNA",
    "DPP7 Proteo"
  ],
  "NPM1P19": [
    "NPM1P19 CNV",
    "NPM1P19 RNA"
  ],
  "RABGGTB": [
    "RABGGTB CNV",
    "RABGGTB RNA",
    "RABGGTB Proteo"
  ],
  "SQOR": [
    "SQOR CNV",
    "SQOR RNA",
    "SQOR Proteo"
  ],
  "SPPL2C": [
    "SPPL2C CNV",
    "SPPL2C RNA"
  ],
  "ZBTB45": [
    "ZBTB45 CNV",
    "ZBTB45 RNA",
    "ZBTB45 Proteo"
  ],
  "MRPL23": [
    "MRPL23 CNV",
    "MRPL23 RNA",
    "MRPL23 Proteo"
  ],
  "GOLGA6L2": [
    "GOLGA6L2 CNV",
    "GOLGA6L2 RNA"
  ],
  "PSMA2P1": [
    "PSMA2P1 CNV",
    "PSMA2P1 RNA"
  ],
  "XRCC5": [
    "XRCC5 CNV",
    "XRCC5 RNA",
    "XRCC5 Proteo"
  ],
  "PLK4": [
    "PLK4 CNV",
    "PLK4 RNA"
  ],
  "ENDOU": [
    "ENDOU CNV",
    "ENDOU RNA"
  ],
  "GUSBP9": [
    "GUSBP9 CNV",
    "GUSBP9 RNA"
  ],
  "ATP5MFP4": [
    "ATP5MFP4 CNV",
    "ATP5MFP4 RNA"
  ],
  "IGSF8": [
    "IGSF8 CNV",
    "IGSF8 RNA",
    "IGSF8 Proteo"
  ],
  "FCER2": [
    "FCER2 CNV",
    "FCER2 RNA",
    "FCER2 Proteo"
  ],
  "TXNDC12": [
    "TXNDC12 CNV",
    "TXNDC12 RNA",
    "TXNDC12 Proteo"
  ],
  "HCN2": [
    "HCN2 CNV",
    "HCN2 RNA"
  ],
  "FABP2": [
    "FABP2 CNV",
    "FABP2 RNA"
  ],
  "L3HYPDH": [
    "L3HYPDH CNV",
    "L3HYPDH RNA",
    "L3HYPDH Proteo"
  ],
  "IPO4": [
    "IPO4 CNV",
    "IPO4 RNA",
    "IPO4 Proteo"
  ],
  "ZNF493": [
    "ZNF493 CNV",
    "ZNF493 RNA"
  ],
  "TUBG1P": [
    "TUBG1P CNV",
    "TUBG1P RNA"
  ],
  "MFRP": [
    "MFRP CNV",
    "MFRP RNA"
  ],
  "BUB1P1": [
    "BUB1P1 CNV",
    "BUB1P1 RNA"
  ],
  "SDHCP2": [
    "SDHCP2 CNV",
    "SDHCP2 RNA"
  ],
  "GALNT13": [
    "GALNT13 CNV",
    "GALNT13 RNA",
    "GALNT13 Proteo"
  ],
  "MPRIPP1": [
    "MPRIPP1 CNV",
    "MPRIPP1 RNA"
  ],
  "RNA5SP360": [
    "RNA5SP360 CNV",
    "RNA5SP360 RNA"
  ],
  "EXOSC3P2": [
    "EXOSC3P2 CNV",
    "EXOSC3P2 RNA"
  ],
  "BTNL8": [
    "BTNL8 CNV",
    "BTNL8 RNA"
  ],
  "GOLGA6L6": [
    "GOLGA6L6 CNV",
    "GOLGA6L6 RNA"
  ],
  "PRKCZ": [
    "PRKCZ CNV",
    "PRKCZ RNA",
    "PRKCZ Proteo"
  ],
  "TRIM16": [
    "TRIM16 CNV",
    "TRIM16 RNA",
    "TRIM16 Proteo"
  ],
  "PDIA3": [
    "PDIA3 CNV",
    "PDIA3 RNA",
    "PDIA3 Proteo"
  ],
  "LARP1": [
    "LARP1 CNV",
    "LARP1 RNA",
    "LARP1 Proteo"
  ],
  "PTPA": [
    "PTPA CNV",
    "PTPA RNA",
    "PTPA Proteo"
  ],
  "DYNLT4": [
    "DYNLT4 CNV",
    "DYNLT4 RNA"
  ],
  "ENPP4": [
    "ENPP4 CNV",
    "ENPP4 RNA",
    "ENPP4 Proteo"
  ],
  "SMIM35": [
    "SMIM35 CNV",
    "SMIM35 RNA"
  ],
  "RUFY4": [
    "RUFY4 CNV",
    "RUFY4 RNA"
  ],
  "F13B": [
    "F13B CNV",
    "F13B RNA",
    "F13B Proteo"
  ],
  "PLCB1": [
    "PLCB1 CNV",
    "PLCB1 RNA",
    "PLCB1 Proteo"
  ],
  "ATP6V0A4": [
    "ATP6V0A4 CNV",
    "ATP6V0A4 RNA",
    "ATP6V0A4 Proteo"
  ],
  "RSPO4": [
    "RSPO4 CNV",
    "RSPO4 RNA"
  ],
  "SMYD3": [
    "SMYD3 CNV",
    "SMYD3 RNA",
    "SMYD3 Proteo"
  ],
  "PES1": [
    "PES1 CNV",
    "PES1 RNA",
    "PES1 Proteo"
  ],
  "ZDHHC9": [
    "ZDHHC9 CNV",
    "ZDHHC9 RNA"
  ],
  "TNFRSF6B": [
    "TNFRSF6B CNV",
    "TNFRSF6B RNA",
    "TNFRSF6B Proteo"
  ],
  "CCDC159": [
    "CCDC159 CNV",
    "CCDC159 RNA"
  ],
  "SETD9": [
    "SETD9 CNV",
    "SETD9 RNA",
    "SETD9 Proteo"
  ],
  "ANXA2P3": [
    "ANXA2P3 CNV",
    "ANXA2P3 RNA"
  ],
  "OR2F1": [
    "OR2F1 CNV",
    "OR2F1 RNA"
  ],
  "DPPA4": [
    "DPPA4 CNV",
    "DPPA4 RNA"
  ],
  "HSD17B4": [
    "HSD17B4 CNV",
    "HSD17B4 RNA",
    "HSD17B4 Proteo"
  ],
  "RPS27AP10": [
    "RPS27AP10 CNV",
    "RPS27AP10 RNA"
  ],
  "MNT": [
    "MNT CNV",
    "MNT RNA",
    "MNT Proteo"
  ],
  "SMG1": [
    "SMG1 CNV",
    "SMG1 RNA",
    "SMG1 Proteo"
  ],
  "TCERG1": [
    "TCERG1 CNV",
    "TCERG1 RNA",
    "TCERG1 Proteo"
  ],
  "POPDC3": [
    "POPDC3 CNV",
    "POPDC3 RNA"
  ],
  "ZC3H14": [
    "ZC3H14 CNV",
    "ZC3H14 RNA",
    "ZC3H14 Proteo"
  ],
  "MGME1": [
    "MGME1 CNV",
    "MGME1 RNA",
    "MGME1 Proteo"
  ],
  "BMS1P1": [
    "BMS1P1 CNV",
    "BMS1P1 RNA"
  ],
  "MATN2": [
    "MATN2 CNV",
    "MATN2 RNA",
    "MATN2 Proteo"
  ],
  "SCAPER": [
    "SCAPER CNV",
    "SCAPER RNA",
    "SCAPER Proteo"
  ],
  "FBF1": [
    "FBF1 CNV",
    "FBF1 RNA",
    "FBF1 Proteo"
  ],
  "OR8V1P": [
    "OR8V1P CNV",
    "OR8V1P RNA"
  ],
  "OR4G1P": [
    "OR4G1P CNV",
    "OR4G1P RNA"
  ],
  "ZNF734P": [
    "ZNF734P CNV",
    "ZNF734P RNA"
  ],
  "HNRNPDLP2": [
    "HNRNPDLP2 CNV",
    "HNRNPDLP2 RNA"
  ],
  "CHCHD3": [
    "CHCHD3 CNV",
    "CHCHD3 RNA",
    "CHCHD3 Proteo"
  ],
  "TUSC1": [
    "TUSC1 CNV",
    "TUSC1 RNA",
    "TUSC1 Proteo"
  ],
  "NLGN4Y": [
    "NLGN4Y CNV",
    "NLGN4Y RNA"
  ],
  "ZSCAN31": [
    "ZSCAN31 CNV",
    "ZSCAN31 RNA"
  ],
  "HADHA": [
    "HADHA CNV",
    "HADHA RNA",
    "HADHA Proteo"
  ],
  "MFSD6L": [
    "MFSD6L CNV",
    "MFSD6L RNA"
  ],
  "NDST3": [
    "NDST3 CNV",
    "NDST3 RNA"
  ],
  "HIGD2AP1": [
    "HIGD2AP1 CNV",
    "HIGD2AP1 RNA"
  ],
  "MRAS": [
    "MRAS CNV",
    "MRAS RNA",
    "MRAS Proteo"
  ],
  "CDC20": [
    "CDC20 CNV",
    "CDC20 RNA",
    "CDC20 Proteo"
  ],
  "NECTIN4": [
    "NECTIN4 CNV",
    "NECTIN4 RNA",
    "NECTIN4 Proteo"
  ],
  "CCND3P1": [
    "CCND3P1 CNV",
    "CCND3P1 RNA"
  ],
  "H2AC21": [
    "H2AC21 CNV",
    "H2AC21 RNA",
    "H2AC21 Proteo"
  ],
  "GMEB2": [
    "GMEB2 CNV",
    "GMEB2 RNA",
    "GMEB2 Proteo"
  ],
  "RAC1P9": [
    "RAC1P9 CNV",
    "RAC1P9 RNA"
  ],
  "CHST15": [
    "CHST15 CNV",
    "CHST15 RNA",
    "CHST15 Proteo"
  ],
  "VINAC1P": [
    "VINAC1P CNV",
    "VINAC1P RNA"
  ],
  "FBXO6": [
    "FBXO6 CNV",
    "FBXO6 RNA",
    "FBXO6 Proteo"
  ],
  "CKAP2L": [
    "CKAP2L CNV",
    "CKAP2L RNA",
    "CKAP2L Proteo"
  ],
  "C6orf141": [
    "C6orf141 CNV",
    "C6orf141 RNA"
  ],
  "RASAL1": [
    "RASAL1 CNV",
    "RASAL1 RNA",
    "RASAL1 Proteo"
  ],
  "RAD54L2P1": [
    "RAD54L2P1 CNV",
    "RAD54L2P1 RNA"
  ],
  "PRTG": [
    "PRTG CNV",
    "PRTG RNA"
  ],
  "PRMT9": [
    "PRMT9 CNV",
    "PRMT9 RNA",
    "PRMT9 Proteo"
  ],
  "COL11A2P1": [
    "COL11A2P1 CNV",
    "COL11A2P1 RNA"
  ],
  "IGHV1OR15-2": [
    "IGHV1OR15-2 CNV",
    "IGHV1OR15-2 RNA"
  ],
  "RPS27P10": [
    "RPS27P10 CNV",
    "RPS27P10 RNA"
  ],
  "RCVRN": [
    "RCVRN CNV",
    "RCVRN RNA"
  ],
  "RHCE": [
    "RHCE CNV",
    "RHCE RNA",
    "RHCE Proteo"
  ],
  "AARSD1P1": [
    "AARSD1P1 CNV",
    "AARSD1P1 RNA"
  ],
  "REPIN1": [
    "REPIN1 CNV",
    "REPIN1 RNA",
    "REPIN1 Proteo"
  ],
  "CACNG1": [
    "CACNG1 CNV",
    "CACNG1 RNA"
  ],
  "TMEM60": [
    "TMEM60 CNV",
    "TMEM60 RNA"
  ],
  "ADO": [
    "ADO CNV",
    "ADO RNA",
    "ADO Proteo"
  ],
  "PEX11G": [
    "PEX11G CNV",
    "PEX11G RNA",
    "PEX11G Proteo"
  ],
  "GUCA2A": [
    "GUCA2A CNV",
    "GUCA2A RNA"
  ],
  "PCNX1": [
    "PCNX1 CNV",
    "PCNX1 RNA",
    "PCNX1 Proteo"
  ],
  "CYP4F60P": [
    "CYP4F60P CNV",
    "CYP4F60P RNA"
  ],
  "PSKH1": [
    "PSKH1 CNV",
    "PSKH1 RNA"
  ],
  "CMKLR1": [
    "CMKLR1 CNV",
    "CMKLR1 RNA",
    "CMKLR1 Proteo"
  ],
  "AK4P3": [
    "AK4P3 CNV",
    "AK4P3 RNA"
  ],
  "SLC9C2": [
    "SLC9C2 CNV",
    "SLC9C2 RNA"
  ],
  "DDX11L8": [
    "DDX11L8 CNV",
    "DDX11L8 RNA"
  ],
  "ABCC1": [
    "ABCC1 CNV",
    "ABCC1 RNA",
    "ABCC1 Proteo"
  ],
  "HTR5A": [
    "HTR5A CNV",
    "HTR5A RNA"
  ],
  "RNA5SP341": [
    "RNA5SP341 CNV",
    "RNA5SP341 RNA"
  ],
  "OVCA2": [
    "OVCA2 CNV",
    "OVCA2 RNA",
    "OVCA2 Proteo"
  ],
  "SBF2": [
    "SBF2 CNV",
    "SBF2 RNA",
    "SBF2 Proteo"
  ],
  "SIRT5": [
    "SIRT5 CNV",
    "SIRT5 RNA",
    "SIRT5 Proteo"
  ],
  "FANCE": [
    "FANCE CNV",
    "FANCE RNA",
    "FANCE Proteo"
  ],
  "TMEM119": [
    "TMEM119 CNV",
    "TMEM119 RNA",
    "TMEM119 Proteo"
  ],
  "SLC7A4": [
    "SLC7A4 CNV",
    "SLC7A4 RNA",
    "SLC7A4 Proteo"
  ],
  "USP47": [
    "USP47 CNV",
    "USP47 RNA",
    "USP47 Proteo"
  ],
  "FAM185A": [
    "FAM185A CNV",
    "FAM185A RNA",
    "FAM185A Proteo"
  ],
  "IGKV2D-10": [
    "IGKV2D-10 CNV",
    "IGKV2D-10 RNA"
  ],
  "VDAC2P4": [
    "VDAC2P4 CNV",
    "VDAC2P4 RNA"
  ],
  "FAM183BP": [
    "FAM183BP CNV",
    "FAM183BP RNA"
  ],
  "NWD1": [
    "NWD1 CNV",
    "NWD1 RNA"
  ],
  "KRT2": [
    "KRT2 CNV",
    "KRT2 RNA",
    "KRT2 Proteo"
  ],
  "KRT8P41": [
    "KRT8P41 CNV",
    "KRT8P41 RNA"
  ],
  "CCDC96": [
    "CCDC96 CNV",
    "CCDC96 RNA"
  ],
  "SIGLEC11": [
    "SIGLEC11 CNV",
    "SIGLEC11 RNA"
  ],
  "YBX1P6": [
    "YBX1P6 CNV",
    "YBX1P6 RNA"
  ],
  "ANTXR1": [
    "ANTXR1 CNV",
    "ANTXR1 RNA",
    "ANTXR1 Proteo"
  ],
  "MROH9": [
    "MROH9 CNV",
    "MROH9 RNA"
  ],
  "OCEL1": [
    "OCEL1 CNV",
    "OCEL1 RNA"
  ],
  "ANP32BP1": [
    "ANP32BP1 CNV",
    "ANP32BP1 RNA"
  ],
  "MOV10L1": [
    "MOV10L1 CNV",
    "MOV10L1 RNA"
  ],
  "ACTN4": [
    "ACTN4 CNV",
    "ACTN4 RNA",
    "ACTN4 Proteo"
  ],
  "SYT6": [
    "SYT6 CNV",
    "SYT6 RNA"
  ],
  "ATAD2": [
    "ATAD2 CNV",
    "ATAD2 RNA",
    "ATAD2 Proteo"
  ],
  "UCN": [
    "UCN CNV",
    "UCN RNA"
  ],
  "KRTAP9-9": [
    "KRTAP9-9 CNV",
    "KRTAP9-9 RNA"
  ],
  "RPL13P2": [
    "RPL13P2 CNV",
    "RPL13P2 RNA"
  ],
  "KMT2E": [
    "KMT2E CNV",
    "KMT2E RNA",
    "KMT2E Proteo"
  ],
  "ATP7A": [
    "ATP7A CNV",
    "ATP7A RNA",
    "ATP7A Proteo"
  ],
  "SLC43A2": [
    "SLC43A2 CNV",
    "SLC43A2 RNA",
    "SLC43A2 Proteo"
  ],
  "AKR1A1": [
    "AKR1A1 CNV",
    "AKR1A1 RNA",
    "AKR1A1 Proteo"
  ],
  "IGHVII-44-2": [
    "IGHVII-44-2 CNV",
    "IGHVII-44-2 RNA"
  ],
  "MORF4L1P6": [
    "MORF4L1P6 CNV",
    "MORF4L1P6 RNA"
  ],
  "RTN4R": [
    "RTN4R CNV",
    "RTN4R RNA"
  ],
  "NLRP2": [
    "NLRP2 CNV",
    "NLRP2 RNA",
    "NLRP2 Proteo"
  ],
  "HMGN2P13": [
    "HMGN2P13 CNV",
    "HMGN2P13 RNA"
  ],
  "DUXAP2": [
    "DUXAP2 CNV",
    "DUXAP2 RNA"
  ],
  "SNRPFP3": [
    "SNRPFP3 CNV",
    "SNRPFP3 RNA"
  ],
  "PUM2": [
    "PUM2 CNV",
    "PUM2 RNA",
    "PUM2 Proteo"
  ],
  "ACOX1": [
    "ACOX1 CNV",
    "ACOX1 RNA",
    "ACOX1 Proteo"
  ],
  "KAT2A": [
    "KAT2A CNV",
    "KAT2A RNA",
    "KAT2A Proteo"
  ],
  "MOS": [
    "MOS CNV",
    "MOS RNA"
  ],
  "AMACR": [
    "AMACR CNV",
    "AMACR RNA",
    "AMACR Proteo"
  ],
  "PDSS2": [
    "PDSS2 CNV",
    "PDSS2 RNA",
    "PDSS2 Proteo"
  ],
  "KLF10": [
    "KLF10 CNV",
    "KLF10 RNA"
  ],
  "NARS1P2": [
    "NARS1P2 CNV",
    "NARS1P2 RNA"
  ],
  "GLRA4": [
    "GLRA4 CNV",
    "GLRA4 RNA"
  ],
  "S100A10": [
    "S100A10 CNV",
    "S100A10 RNA",
    "S100A10 Proteo"
  ],
  "HOMER3": [
    "HOMER3 CNV",
    "HOMER3 RNA",
    "HOMER3 Proteo"
  ],
  "TUBAP13": [
    "TUBAP13 CNV",
    "TUBAP13 RNA"
  ],
  "ARTN": [
    "ARTN CNV",
    "ARTN RNA"
  ],
  "PCDHGA2": [
    "PCDHGA2 CNV",
    "PCDHGA2 RNA"
  ],
  "C16orf91": [
    "C16orf91 CNV",
    "C16orf91 RNA",
    "C16orf91 Proteo"
  ],
  "NBEAL2": [
    "NBEAL2 CNV",
    "NBEAL2 RNA",
    "NBEAL2 Proteo"
  ],
  "TRIQK": [
    "TRIQK CNV",
    "TRIQK RNA",
    "TRIQK Proteo"
  ],
  "LYSMD1": [
    "LYSMD1 CNV",
    "LYSMD1 RNA",
    "LYSMD1 Proteo"
  ],
  "RNF5P1": [
    "RNF5P1 CNV",
    "RNF5P1 RNA"
  ],
  "SF3B4": [
    "SF3B4 CNV",
    "SF3B4 RNA",
    "SF3B4 Proteo"
  ],
  "PACSIN2": [
    "PACSIN2 CNV",
    "PACSIN2 RNA",
    "PACSIN2 Proteo"
  ],
  "TSSK1B": [
    "TSSK1B CNV",
    "TSSK1B RNA"
  ],
  "TUBB4A": [
    "TUBB4A CNV",
    "TUBB4A RNA",
    "TUBB4A Proteo"
  ],
  "GUSBP4": [
    "GUSBP4 CNV",
    "GUSBP4 RNA"
  ],
  "MAPK9": [
    "MAPK9 CNV",
    "MAPK9 RNA",
    "MAPK9 Proteo"
  ],
  "HYOU1": [
    "HYOU1 CNV",
    "HYOU1 RNA",
    "HYOU1 Proteo"
  ],
  "CKAP5": [
    "CKAP5 CNV",
    "CKAP5 RNA",
    "CKAP5 Proteo"
  ],
  "ABCC10": [
    "ABCC10 CNV",
    "ABCC10 RNA",
    "ABCC10 Proteo"
  ],
  "OR9A3P": [
    "OR9A3P CNV",
    "OR9A3P RNA"
  ],
  "XAGE2": [
    "XAGE2 CNV",
    "XAGE2 RNA"
  ],
  "TMA7": [
    "TMA7 CNV",
    "TMA7 RNA",
    "TMA7 Proteo"
  ],
  "PNMA2": [
    "PNMA2 CNV",
    "PNMA2 RNA",
    "PNMA2 Proteo"
  ],
  "MRGPRX12P": [
    "MRGPRX12P CNV",
    "MRGPRX12P RNA"
  ],
  "RFPL4B": [
    "RFPL4B CNV",
    "RFPL4B RNA"
  ],
  "MTHFD2": [
    "MTHFD2 CNV",
    "MTHFD2 RNA",
    "MTHFD2 Proteo"
  ],
  "ADARB1": [
    "ADARB1 CNV",
    "ADARB1 RNA",
    "ADARB1 Proteo"
  ],
  "PCP4L1": [
    "PCP4L1 CNV",
    "PCP4L1 RNA",
    "PCP4L1 Proteo"
  ],
  "SPOCK1": [
    "SPOCK1 CNV",
    "SPOCK1 RNA"
  ],
  "IGSF22": [
    "IGSF22 CNV",
    "IGSF22 RNA"
  ],
  "MTND4LP17": [
    "MTND4LP17 CNV",
    "MTND4LP17 RNA"
  ],
  "APOBEC3D": [
    "APOBEC3D CNV",
    "APOBEC3D RNA",
    "APOBEC3D Proteo"
  ],
  "OR2L13": [
    "OR2L13 CNV",
    "OR2L13 RNA"
  ],
  "OR4K14": [
    "OR4K14 CNV",
    "OR4K14 RNA"
  ],
  "ZNF827": [
    "ZNF827 CNV",
    "ZNF827 RNA",
    "ZNF827 Proteo"
  ],
  "H2AZ2": [
    "H2AZ2 CNV",
    "H2AZ2 RNA",
    "H2AZ2 Proteo"
  ],
  "DMRTA1": [
    "DMRTA1 CNV",
    "DMRTA1 RNA"
  ],
  "OR5B2": [
    "OR5B2 CNV",
    "OR5B2 RNA"
  ],
  "IGHD": [
    "IGHD Proteo"
  ],
  "ZPBP": [
    "ZPBP CNV",
    "ZPBP RNA"
  ],
  "TBX22": [
    "TBX22 CNV",
    "TBX22 RNA"
  ],
  "SF3B2": [
    "SF3B2 CNV",
    "SF3B2 RNA",
    "SF3B2 Proteo"
  ],
  "NLN": [
    "NLN CNV",
    "NLN RNA",
    "NLN Proteo"
  ],
  "SIK1": [
    "SIK1 CNV",
    "SIK1 RNA"
  ],
  "MRTFB": [
    "MRTFB CNV",
    "MRTFB RNA",
    "MRTFB Proteo"
  ],
  "SUMO2P21": [
    "SUMO2P21 CNV",
    "SUMO2P21 RNA"
  ],
  "MESTP2": [
    "MESTP2 CNV",
    "MESTP2 RNA"
  ],
  "CNGA3": [
    "CNGA3 CNV",
    "CNGA3 RNA"
  ],
  "HNRNPA3P16": [
    "HNRNPA3P16 CNV",
    "HNRNPA3P16 RNA"
  ],
  "CLDN10": [
    "CLDN10 CNV",
    "CLDN10 RNA"
  ],
  "OTUD4": [
    "OTUD4 CNV",
    "OTUD4 RNA",
    "OTUD4 Proteo"
  ],
  "SLC35B3": [
    "SLC35B3 CNV",
    "SLC35B3 RNA",
    "SLC35B3 Proteo"
  ],
  "SERPINB3": [
    "SERPINB3 CNV",
    "SERPINB3 RNA",
    "SERPINB3 Proteo"
  ],
  "TCAIM": [
    "TCAIM CNV",
    "TCAIM RNA",
    "TCAIM Proteo"
  ],
  "RPL29P30": [
    "RPL29P30 CNV",
    "RPL29P30 RNA"
  ],
  "OR10AE3P": [
    "OR10AE3P CNV",
    "OR10AE3P RNA"
  ],
  "SCML4": [
    "SCML4 CNV",
    "SCML4 RNA",
    "SCML4 Proteo"
  ],
  "CNTLN": [
    "CNTLN CNV",
    "CNTLN RNA",
    "CNTLN Proteo"
  ],
  "OR10S1": [
    "OR10S1 CNV",
    "OR10S1 RNA"
  ],
  "NMU": [
    "NMU CNV",
    "NMU RNA"
  ],
  "DCAF1": [
    "DCAF1 CNV",
    "DCAF1 RNA",
    "DCAF1 Proteo"
  ],
  "WASH6P": [
    "WASH6P CNV",
    "WASH6P RNA",
    "WASH6P Proteo"
  ],
  "IGLVI-56": [
    "IGLVI-56 CNV",
    "IGLVI-56 RNA"
  ],
  "SHLD2": [
    "SHLD2 CNV",
    "SHLD2 RNA"
  ],
  "MTND6P6": [
    "MTND6P6 CNV",
    "MTND6P6 RNA"
  ],
  "ARF4P3": [
    "ARF4P3 CNV",
    "ARF4P3 RNA"
  ],
  "NEIL2": [
    "NEIL2 CNV",
    "NEIL2 RNA",
    "NEIL2 Proteo"
  ],
  "MARK2P9": [
    "MARK2P9 CNV",
    "MARK2P9 RNA"
  ],
  "B3GAT1": [
    "B3GAT1 CNV",
    "B3GAT1 RNA"
  ],
  "GPKOW": [
    "GPKOW CNV",
    "GPKOW RNA",
    "GPKOW Proteo"
  ],
  "CACNA1S": [
    "CACNA1S CNV",
    "CACNA1S RNA"
  ],
  "VN1R4": [
    "VN1R4 CNV",
    "VN1R4 RNA"
  ],
  "MYOZ2": [
    "MYOZ2 CNV",
    "MYOZ2 RNA"
  ],
  "CNNM3": [
    "CNNM3 CNV",
    "CNNM3 RNA",
    "CNNM3 Proteo"
  ],
  "CD300LG": [
    "CD300LG CNV",
    "CD300LG RNA",
    "CD300LG Proteo"
  ],
  "TMTC2": [
    "TMTC2 CNV",
    "TMTC2 RNA",
    "TMTC2 Proteo"
  ],
  "HEATR1": [
    "HEATR1 CNV",
    "HEATR1 RNA",
    "HEATR1 Proteo"
  ],
  "MORN3": [
    "MORN3 CNV",
    "MORN3 RNA"
  ],
  "POLR2LP1": [
    "POLR2LP1 CNV",
    "POLR2LP1 RNA"
  ],
  "CHAC2": [
    "CHAC2 CNV",
    "CHAC2 RNA",
    "CHAC2 Proteo"
  ],
  "SPTBN5": [
    "SPTBN5 CNV",
    "SPTBN5 RNA"
  ],
  "TRAPPC2L": [
    "TRAPPC2L CNV",
    "TRAPPC2L RNA",
    "TRAPPC2L Proteo"
  ],
  "BNIP3P2": [
    "BNIP3P2 CNV",
    "BNIP3P2 RNA"
  ],
  "TOM1": [
    "TOM1 CNV",
    "TOM1 RNA",
    "TOM1 Proteo"
  ],
  "PUS7": [
    "PUS7 CNV",
    "PUS7 RNA",
    "PUS7 Proteo"
  ],
  "TNIP1": [
    "TNIP1 CNV",
    "TNIP1 RNA",
    "TNIP1 Proteo"
  ],
  "UCN3": [
    "UCN3 CNV",
    "UCN3 RNA"
  ],
  "PNKP": [
    "PNKP CNV",
    "PNKP RNA",
    "PNKP Proteo"
  ],
  "ADAD2": [
    "ADAD2 CNV",
    "ADAD2 RNA"
  ],
  "SLC12A5": [
    "SLC12A5 CNV",
    "SLC12A5 RNA",
    "SLC12A5 Proteo"
  ],
  "RPS10P14": [
    "RPS10P14 CNV",
    "RPS10P14 RNA"
  ],
  "TRIM64C": [
    "TRIM64C CNV",
    "TRIM64C RNA"
  ],
  "KCNK12": [
    "KCNK12 CNV",
    "KCNK12 RNA"
  ],
  "LRRC37A7P": [
    "LRRC37A7P CNV",
    "LRRC37A7P RNA"
  ],
  "FAM168B": [
    "FAM168B CNV",
    "FAM168B RNA",
    "FAM168B Proteo"
  ],
  "COX6CP4": [
    "COX6CP4 CNV",
    "COX6CP4 RNA"
  ],
  "HMGN2P6": [
    "HMGN2P6 CNV",
    "HMGN2P6 RNA"
  ],
  "RPL9P15": [
    "RPL9P15 CNV",
    "RPL9P15 RNA"
  ],
  "CLK2": [
    "CLK2 CNV",
    "CLK2 RNA",
    "CLK2 Proteo"
  ],
  "KDM3A": [
    "KDM3A CNV",
    "KDM3A RNA",
    "KDM3A Proteo"
  ],
  "GHITM": [
    "GHITM CNV",
    "GHITM RNA",
    "GHITM Proteo"
  ],
  "MTATP6P26": [
    "MTATP6P26 CNV",
    "MTATP6P26 RNA"
  ],
  "RNA5SP132": [
    "RNA5SP132 CNV",
    "RNA5SP132 RNA"
  ],
  "RNA5SP290": [
    "RNA5SP290 CNV",
    "RNA5SP290 RNA"
  ],
  "PDLIM1P3": [
    "PDLIM1P3 CNV",
    "PDLIM1P3 RNA"
  ],
  "MYL12BP2": [
    "MYL12BP2 CNV",
    "MYL12BP2 RNA"
  ],
  "MOCS1P1": [
    "MOCS1P1 CNV",
    "MOCS1P1 RNA"
  ],
  "MOXD2P": [
    "MOXD2P CNV",
    "MOXD2P RNA"
  ],
  "SWT1": [
    "SWT1 CNV",
    "SWT1 RNA"
  ],
  "UQCC2": [
    "UQCC2 CNV",
    "UQCC2 RNA",
    "UQCC2 Proteo"
  ],
  "PSMD6": [
    "PSMD6 CNV",
    "PSMD6 RNA",
    "PSMD6 Proteo"
  ],
  "SERPINA7P1": [
    "SERPINA7P1 CNV",
    "SERPINA7P1 RNA"
  ],
  "ITGB3": [
    "ITGB3 CNV",
    "ITGB3 RNA",
    "ITGB3 Proteo"
  ],
  "SMNDC1": [
    "SMNDC1 CNV",
    "SMNDC1 RNA",
    "SMNDC1 Proteo"
  ],
  "OFD1P9Y": [
    "OFD1P9Y CNV",
    "OFD1P9Y RNA"
  ],
  "TRBV21-1": [
    "TRBV21-1 CNV",
    "TRBV21-1 RNA"
  ],
  "GAA": [
    "GAA CNV",
    "GAA RNA",
    "GAA Proteo"
  ],
  "ACTB": [
    "ACTB CNV",
    "ACTB RNA",
    "ACTB Proteo"
  ],
  "PAN2": [
    "PAN2 CNV",
    "PAN2 RNA",
    "PAN2 Proteo"
  ],
  "FRG1": [
    "FRG1 CNV",
    "FRG1 RNA",
    "FRG1 Proteo"
  ],
  "RPL27AP4": [
    "RPL27AP4 CNV",
    "RPL27AP4 RNA"
  ],
  "TLE2": [
    "TLE2 CNV",
    "TLE2 RNA"
  ],
  "SFXN4P1": [
    "SFXN4P1 CNV",
    "SFXN4P1 RNA"
  ],
  "CICP20": [
    "CICP20 CNV",
    "CICP20 RNA"
  ],
  "PDZD3": [
    "PDZD3 CNV",
    "PDZD3 RNA"
  ],
  "PHKG1": [
    "PHKG1 CNV",
    "PHKG1 RNA"
  ],
  "THEM6": [
    "THEM6 CNV",
    "THEM6 RNA",
    "THEM6 Proteo"
  ],
  "PPIL2": [
    "PPIL2 CNV",
    "PPIL2 RNA",
    "PPIL2 Proteo"
  ],
  "TXNP6": [
    "TXNP6 CNV",
    "TXNP6 RNA"
  ],
  "PCDHA11": [
    "PCDHA11 CNV",
    "PCDHA11 RNA"
  ],
  "MTCO2P4": [
    "MTCO2P4 CNV",
    "MTCO2P4 RNA"
  ],
  "EI24P1": [
    "EI24P1 CNV",
    "EI24P1 RNA"
  ],
  "RPL23P8": [
    "RPL23P8 CNV",
    "RPL23P8 RNA"
  ],
  "HORMAD1": [
    "HORMAD1 CNV",
    "HORMAD1 RNA"
  ],
  "REXO1L2P": [
    "REXO1L2P CNV",
    "REXO1L2P RNA"
  ],
  "ZNF182": [
    "ZNF182 CNV",
    "ZNF182 RNA"
  ],
  "CT45A6": [
    "CT45A6 CNV",
    "CT45A6 RNA"
  ],
  "RPS3AP29": [
    "RPS3AP29 CNV",
    "RPS3AP29 RNA"
  ],
  "HTATSF1P1": [
    "HTATSF1P1 CNV",
    "HTATSF1P1 RNA"
  ],
  "PLAG1": [
    "PLAG1 CNV",
    "PLAG1 RNA"
  ],
  "PHLPP1": [
    "PHLPP1 CNV",
    "PHLPP1 RNA",
    "PHLPP1 Proteo"
  ],
  "CRTC3": [
    "CRTC3 CNV",
    "CRTC3 RNA",
    "CRTC3 Proteo"
  ],
  "CDC6": [
    "CDC6 CNV",
    "CDC6 RNA",
    "CDC6 Proteo"
  ],
  "KCNN1": [
    "KCNN1 CNV",
    "KCNN1 RNA"
  ],
  "PLSCR1": [
    "PLSCR1 CNV",
    "PLSCR1 RNA",
    "PLSCR1 Proteo"
  ],
  "CCKAR": [
    "CCKAR CNV",
    "CCKAR RNA"
  ],
  "DRD4": [
    "DRD4 CNV",
    "DRD4 RNA"
  ],
  "GJC1": [
    "GJC1 CNV",
    "GJC1 RNA"
  ],
  "TBC1D3P2": [
    "TBC1D3P2 CNV",
    "TBC1D3P2 RNA"
  ],
  "ISCA1P6": [
    "ISCA1P6 CNV",
    "ISCA1P6 RNA"
  ],
  "OR2D3": [
    "OR2D3 CNV",
    "OR2D3 RNA"
  ],
  "SLITRK6": [
    "SLITRK6 CNV",
    "SLITRK6 RNA",
    "SLITRK6 Proteo"
  ],
  "TDRD1": [
    "TDRD1 CNV",
    "TDRD1 RNA"
  ],
  "FADS2B": [
    "FADS2B CNV",
    "FADS2B RNA"
  ],
  "SERPINB8": [
    "SERPINB8 CNV",
    "SERPINB8 RNA",
    "SERPINB8 Proteo"
  ],
  "TRAP1": [
    "TRAP1 CNV",
    "TRAP1 RNA",
    "TRAP1 Proteo"
  ],
  "NME1": [
    "NME1 CNV",
    "NME1 RNA",
    "NME1 Proteo"
  ],
  "KLHL32": [
    "KLHL32 CNV",
    "KLHL32 RNA"
  ],
  "ZNF627": [
    "ZNF627 CNV",
    "ZNF627 RNA",
    "ZNF627 Proteo"
  ],
  "PROP1": [
    "PROP1 CNV",
    "PROP1 RNA"
  ],
  "USP42": [
    "USP42 CNV",
    "USP42 RNA",
    "USP42 Proteo"
  ],
  "KLHL9": [
    "KLHL9 CNV",
    "KLHL9 RNA",
    "KLHL9 Proteo"
  ],
  "CDT1": [
    "CDT1 CNV",
    "CDT1 RNA",
    "CDT1 Proteo"
  ],
  "BCAS2P2": [
    "BCAS2P2 CNV",
    "BCAS2P2 RNA"
  ],
  "SH3GL2": [
    "SH3GL2 CNV",
    "SH3GL2 RNA"
  ],
  "TCERG1P2": [
    "TCERG1P2 CNV",
    "TCERG1P2 RNA"
  ],
  "RPSAP1": [
    "RPSAP1 CNV",
    "RPSAP1 RNA"
  ],
  "C10orf71": [
    "C10orf71 CNV",
    "C10orf71 RNA"
  ],
  "MCCD1P1": [
    "MCCD1P1 CNV",
    "MCCD1P1 RNA"
  ],
  "STXBP2": [
    "STXBP2 CNV",
    "STXBP2 RNA",
    "STXBP2 Proteo"
  ],
  "GIPR": [
    "GIPR CNV",
    "GIPR RNA"
  ],
  "TMEM161B": [
    "TMEM161B CNV",
    "TMEM161B RNA",
    "TMEM161B Proteo"
  ],
  "RBM44": [
    "RBM44 CNV",
    "RBM44 RNA"
  ],
  "OR2L8": [
    "OR2L8 CNV",
    "OR2L8 RNA"
  ],
  "MTND5P13": [
    "MTND5P13 CNV",
    "MTND5P13 RNA"
  ],
  "CHD3": [
    "CHD3 CNV",
    "CHD3 RNA",
    "CHD3 Proteo"
  ],
  "SALL1": [
    "SALL1 CNV",
    "SALL1 RNA"
  ],
  "TRBV26": [
    "TRBV26 CNV",
    "TRBV26 RNA"
  ],
  "QTRT1P1": [
    "QTRT1P1 CNV",
    "QTRT1P1 RNA"
  ],
  "CALM2P2": [
    "CALM2P2 CNV",
    "CALM2P2 RNA"
  ],
  "E4F1": [
    "E4F1 CNV",
    "E4F1 RNA",
    "E4F1 Proteo"
  ],
  "SATL1": [
    "SATL1 CNV",
    "SATL1 RNA"
  ],
  "CDH12P2": [
    "CDH12P2 CNV",
    "CDH12P2 RNA"
  ],
  "VN1R91P": [
    "VN1R91P CNV",
    "VN1R91P RNA"
  ],
  "OR13A1": [
    "OR13A1 CNV",
    "OR13A1 RNA"
  ],
  "VN1R36P": [
    "VN1R36P CNV",
    "VN1R36P RNA"
  ],
  "DUX4L24": [
    "DUX4L24 CNV",
    "DUX4L24 RNA"
  ],
  "KRT16P2": [
    "KRT16P2 CNV",
    "KRT16P2 RNA"
  ],
  "SLITRK1": [
    "SLITRK1 CNV",
    "SLITRK1 RNA",
    "SLITRK1 Proteo"
  ],
  "IFNB1": [
    "IFNB1 CNV",
    "IFNB1 RNA"
  ],
  "TAF9P2": [
    "TAF9P2 CNV",
    "TAF9P2 RNA"
  ],
  "ARL6IP1P3": [
    "ARL6IP1P3 CNV",
    "ARL6IP1P3 RNA"
  ],
  "IRAG1": [
    "IRAG1 CNV",
    "IRAG1 RNA",
    "IRAG1 Proteo"
  ],
  "RPL10P19": [
    "RPL10P19 CNV",
    "RPL10P19 RNA"
  ],
  "LINC02618": [
    "LINC02618 CNV",
    "LINC02618 RNA"
  ],
  "PKP1": [
    "PKP1 CNV",
    "PKP1 RNA",
    "PKP1 Proteo"
  ],
  "NEMP1": [
    "NEMP1 CNV",
    "NEMP1 RNA",
    "NEMP1 Proteo"
  ],
  "PNMA5": [
    "PNMA5 CNV",
    "PNMA5 RNA",
    "PNMA5 Proteo"
  ],
  "UBE2Q2L": [
    "UBE2Q2L CNV",
    "UBE2Q2L RNA"
  ],
  "GHR": [
    "GHR CNV",
    "GHR RNA"
  ],
  "TERB2": [
    "TERB2 CNV",
    "TERB2 RNA"
  ],
  "RBM22P1": [
    "RBM22P1 CNV",
    "RBM22P1 RNA"
  ],
  "SSU72P2": [
    "SSU72P2 CNV",
    "SSU72P2 RNA"
  ],
  "TRIM80P": [
    "TRIM80P CNV",
    "TRIM80P RNA"
  ],
  "AP1M1": [
    "AP1M1 CNV",
    "AP1M1 RNA",
    "AP1M1 Proteo"
  ],
  "KHK": [
    "KHK CNV",
    "KHK RNA",
    "KHK Proteo"
  ],
  "PLEKHF2": [
    "PLEKHF2 CNV",
    "PLEKHF2 RNA",
    "PLEKHF2 Proteo"
  ],
  "CHIA": [
    "CHIA CNV",
    "CHIA RNA"
  ],
  "ZNF280D": [
    "ZNF280D CNV",
    "ZNF280D RNA",
    "ZNF280D Proteo"
  ],
  "RAP1GDS1": [
    "RAP1GDS1 CNV",
    "RAP1GDS1 RNA",
    "RAP1GDS1 Proteo"
  ],
  "ARMC8P1": [
    "ARMC8P1 CNV",
    "ARMC8P1 RNA"
  ],
  "NFE2": [
    "NFE2 CNV",
    "NFE2 RNA"
  ],
  "KDM5DP1": [
    "KDM5DP1 CNV",
    "KDM5DP1 RNA"
  ],
  "WDR89": [
    "WDR89 CNV",
    "WDR89 RNA",
    "WDR89 Proteo"
  ],
  "GTF2E1": [
    "GTF2E1 CNV",
    "GTF2E1 RNA",
    "GTF2E1 Proteo"
  ],
  "CNIH3": [
    "CNIH3 CNV",
    "CNIH3 RNA",
    "CNIH3 Proteo"
  ],
  "SETDB2": [
    "SETDB2 CNV",
    "SETDB2 RNA",
    "SETDB2 Proteo"
  ],
  "NRIP1": [
    "NRIP1 CNV",
    "NRIP1 RNA",
    "NRIP1 Proteo"
  ],
  "RNF148": [
    "RNF148 CNV",
    "RNF148 RNA"
  ],
  "OR2J4P": [
    "OR2J4P CNV",
    "OR2J4P RNA"
  ],
  "ZNF880": [
    "ZNF880 CNV",
    "ZNF880 RNA"
  ],
  "MYCBPAP": [
    "MYCBPAP CNV",
    "MYCBPAP RNA"
  ],
  "TPBG": [
    "TPBG CNV",
    "TPBG RNA",
    "TPBG Proteo"
  ],
  "B4GALNT2P1": [
    "B4GALNT2P1 CNV",
    "B4GALNT2P1 RNA"
  ],
  "FTLP4": [
    "FTLP4 CNV",
    "FTLP4 RNA"
  ],
  "CAMSAP1": [
    "CAMSAP1 CNV",
    "CAMSAP1 RNA",
    "CAMSAP1 Proteo"
  ],
  "RPL4P1": [
    "RPL4P1 CNV",
    "RPL4P1 RNA"
  ],
  "CHMP4AP1": [
    "CHMP4AP1 CNV",
    "CHMP4AP1 RNA"
  ],
  "TOMM22P2": [
    "TOMM22P2 CNV",
    "TOMM22P2 RNA"
  ],
  "VGLL3": [
    "VGLL3 CNV",
    "VGLL3 RNA"
  ],
  "RPE65": [
    "RPE65 CNV",
    "RPE65 RNA"
  ],
  "AK4P4": [
    "AK4P4 CNV",
    "AK4P4 RNA"
  ],
  "UXS1": [
    "UXS1 CNV",
    "UXS1 RNA",
    "UXS1 Proteo"
  ],
  "WDR5": [
    "WDR5 CNV",
    "WDR5 RNA",
    "WDR5 Proteo"
  ],
  "ARAP2": [
    "ARAP2 CNV",
    "ARAP2 RNA",
    "ARAP2 Proteo"
  ],
  "MRPL43": [
    "MRPL43 CNV",
    "MRPL43 RNA",
    "MRPL43 Proteo"
  ],
  "PEX5L": [
    "PEX5L CNV",
    "PEX5L RNA"
  ],
  "TNN": [
    "TNN CNV",
    "TNN RNA",
    "TNN Proteo"
  ],
  "RNA5SP367": [
    "RNA5SP367 CNV",
    "RNA5SP367 RNA"
  ],
  "PCNP": [
    "PCNP CNV",
    "PCNP RNA",
    "PCNP Proteo"
  ],
  "NUP153": [
    "NUP153 CNV",
    "NUP153 RNA",
    "NUP153 Proteo"
  ],
  "HMGB3P23": [
    "HMGB3P23 CNV",
    "HMGB3P23 RNA"
  ],
  "RBM23": [
    "RBM23 CNV",
    "RBM23 RNA",
    "RBM23 Proteo"
  ],
  "PCDHGB5": [
    "PCDHGB5 CNV",
    "PCDHGB5 RNA",
    "PCDHGB5 Proteo"
  ],
  "TMSB4XP1": [
    "TMSB4XP1 CNV",
    "TMSB4XP1 RNA"
  ],
  "NAB2": [
    "NAB2 CNV",
    "NAB2 RNA",
    "NAB2 Proteo"
  ],
  "KANSL1": [
    "KANSL1 CNV",
    "KANSL1 RNA",
    "KANSL1 Proteo"
  ],
  "OR10B1P": [
    "OR10B1P CNV",
    "OR10B1P RNA"
  ],
  "CLDN24": [
    "CLDN24 CNV",
    "CLDN24 RNA"
  ],
  "ZNF786": [
    "ZNF786 CNV",
    "ZNF786 RNA"
  ],
  "BORCS8": [
    "BORCS8 CNV",
    "BORCS8 RNA",
    "BORCS8 Proteo"
  ],
  "ARHGEF38": [
    "ARHGEF38 CNV",
    "ARHGEF38 RNA"
  ],
  "VPS51": [
    "VPS51 CNV",
    "VPS51 RNA",
    "VPS51 Proteo"
  ],
  "EEF1A1P29": [
    "EEF1A1P29 CNV",
    "EEF1A1P29 RNA"
  ],
  "YPEL3": [
    "YPEL3 CNV",
    "YPEL3 RNA"
  ],
  "C4orf46": [
    "C4orf46 CNV",
    "C4orf46 RNA",
    "C4orf46 Proteo"
  ],
  "ITPR2": [
    "ITPR2 CNV",
    "ITPR2 RNA",
    "ITPR2 Proteo"
  ],
  "PPP1CA": [
    "PPP1CA CNV",
    "PPP1CA RNA",
    "PPP1CA Proteo"
  ],
  "DGCR8": [
    "DGCR8 CNV",
    "DGCR8 RNA",
    "DGCR8 Proteo"
  ],
  "SPIN4": [
    "SPIN4 CNV",
    "SPIN4 RNA",
    "SPIN4 Proteo"
  ],
  "DEPDC1B": [
    "DEPDC1B CNV",
    "DEPDC1B RNA",
    "DEPDC1B Proteo"
  ],
  "TP53I13": [
    "TP53I13 CNV",
    "TP53I13 RNA",
    "TP53I13 Proteo"
  ],
  "EXOSC7": [
    "EXOSC7 CNV",
    "EXOSC7 RNA",
    "EXOSC7 Proteo"
  ],
  "FBXL2": [
    "FBXL2 CNV",
    "FBXL2 RNA",
    "FBXL2 Proteo"
  ],
  "MTCO3P43": [
    "MTCO3P43 CNV",
    "MTCO3P43 RNA"
  ],
  "TFPI": [
    "TFPI CNV",
    "TFPI RNA",
    "TFPI Proteo"
  ],
  "TMEM71": [
    "TMEM71 CNV",
    "TMEM71 RNA"
  ],
  "POLD1": [
    "POLD1 CNV",
    "POLD1 RNA",
    "POLD1 Proteo"
  ],
  "ST6GALNAC3": [
    "ST6GALNAC3 CNV",
    "ST6GALNAC3 RNA",
    "ST6GALNAC3 Proteo"
  ],
  "YAP1P3": [
    "YAP1P3 CNV",
    "YAP1P3 RNA"
  ],
  "MND1": [
    "MND1 CNV",
    "MND1 RNA"
  ],
  "PPIAP65": [
    "PPIAP65 CNV",
    "PPIAP65 RNA"
  ],
  "CRIP1P2": [
    "CRIP1P2 CNV",
    "CRIP1P2 RNA"
  ],
  "IL27": [
    "IL27 CNV",
    "IL27 RNA"
  ],
  "TEX45": [
    "TEX45 CNV",
    "TEX45 RNA"
  ],
  "GPR158": [
    "GPR158 CNV",
    "GPR158 RNA"
  ],
  "CEP170P1": [
    "CEP170P1 CNV",
    "CEP170P1 RNA"
  ],
  "FASTKD1": [
    "FASTKD1 CNV",
    "FASTKD1 RNA",
    "FASTKD1 Proteo"
  ],
  "GOT2P2": [
    "GOT2P2 CNV",
    "GOT2P2 RNA"
  ],
  "HMGN2P41": [
    "HMGN2P41 CNV",
    "HMGN2P41 RNA"
  ],
  "RBL2": [
    "RBL2 CNV",
    "RBL2 RNA",
    "RBL2 Proteo"
  ],
  "IGHV3-63": [
    "IGHV3-63 CNV",
    "IGHV3-63 RNA"
  ],
  "HMGB3P19": [
    "HMGB3P19 CNV",
    "HMGB3P19 RNA"
  ],
  "SPHK1": [
    "SPHK1 CNV",
    "SPHK1 RNA",
    "SPHK1 Proteo"
  ],
  "DEFB105A": [
    "DEFB105A CNV",
    "DEFB105A RNA"
  ],
  "RPS21": [
    "RPS21 CNV",
    "RPS21 RNA",
    "RPS21 Proteo"
  ],
  "TLK2": [
    "TLK2 CNV",
    "TLK2 RNA",
    "TLK2 Proteo"
  ],
  "BOK": [
    "BOK CNV",
    "BOK RNA",
    "BOK Proteo"
  ],
  "HNRNPDL": [
    "HNRNPDL CNV",
    "HNRNPDL RNA",
    "HNRNPDL Proteo"
  ],
  "CCN2": [
    "CCN2 CNV",
    "CCN2 RNA",
    "CCN2 Proteo"
  ],
  "USP11": [
    "USP11 CNV",
    "USP11 RNA",
    "USP11 Proteo"
  ],
  "USP9YP8": [
    "USP9YP8 CNV",
    "USP9YP8 RNA"
  ],
  "RPL36AP8": [
    "RPL36AP8 CNV",
    "RPL36AP8 RNA"
  ],
  "SLC3A2": [
    "SLC3A2 CNV",
    "SLC3A2 RNA",
    "SLC3A2 Proteo"
  ],
  "TPST2": [
    "TPST2 CNV",
    "TPST2 RNA",
    "TPST2 Proteo"
  ],
  "ZNF714": [
    "ZNF714 CNV",
    "ZNF714 RNA"
  ],
  "FAM214A": [
    "FAM214A CNV",
    "FAM214A RNA"
  ],
  "SLC16A6": [
    "SLC16A6 CNV",
    "SLC16A6 RNA",
    "SLC16A6 Proteo"
  ],
  "TPT1P9": [
    "TPT1P9 CNV",
    "TPT1P9 RNA"
  ],
  "ATXN2": [
    "ATXN2 CNV",
    "ATXN2 RNA",
    "ATXN2 Proteo"
  ],
  "KRTAP10-6": [
    "KRTAP10-6 CNV",
    "KRTAP10-6 RNA"
  ],
  "GLUD1P9": [
    "GLUD1P9 CNV",
    "GLUD1P9 RNA"
  ],
  "OR4A16": [
    "OR4A16 CNV",
    "OR4A16 RNA"
  ],
  "HSDL2": [
    "HSDL2 CNV",
    "HSDL2 RNA",
    "HSDL2 Proteo"
  ],
  "HSF2BP": [
    "HSF2BP CNV",
    "HSF2BP RNA"
  ],
  "LINC03009": [
    "LINC03009 CNV",
    "LINC03009 RNA"
  ],
  "P2RX1": [
    "P2RX1 CNV",
    "P2RX1 RNA"
  ],
  "SUMO2": [
    "SUMO2 CNV",
    "SUMO2 RNA",
    "SUMO2 Proteo"
  ],
  "SLC9A3R2": [
    "SLC9A3R2 CNV",
    "SLC9A3R2 RNA",
    "SLC9A3R2 Proteo"
  ],
  "MAGED4B": [
    "MAGED4B CNV",
    "MAGED4B RNA",
    "MAGED4B Proteo"
  ],
  "ST8SIA1": [
    "ST8SIA1 CNV",
    "ST8SIA1 RNA"
  ],
  "ZNF418": [
    "ZNF418 CNV",
    "ZNF418 RNA"
  ],
  "MRPS26": [
    "MRPS26 CNV",
    "MRPS26 RNA",
    "MRPS26 Proteo"
  ],
  "NCBP2": [
    "NCBP2 CNV",
    "NCBP2 RNA",
    "NCBP2 Proteo"
  ],
  "USP2": [
    "USP2 CNV",
    "USP2 RNA",
    "USP2 Proteo"
  ],
  "SLC25A45": [
    "SLC25A45 CNV",
    "SLC25A45 RNA"
  ],
  "H4-16": [
    "H4-16 CNV",
    "H4-16 RNA"
  ],
  "C22orf42": [
    "C22orf42 CNV",
    "C22orf42 RNA"
  ],
  "PSMA6P2": [
    "PSMA6P2 CNV",
    "PSMA6P2 RNA"
  ],
  "SAMD1": [
    "SAMD1 CNV",
    "SAMD1 RNA",
    "SAMD1 Proteo"
  ],
  "OOEPP1": [
    "OOEPP1 CNV",
    "OOEPP1 RNA"
  ],
  "HS3ST2": [
    "HS3ST2 CNV",
    "HS3ST2 RNA"
  ],
  "AP1B1": [
    "AP1B1 CNV",
    "AP1B1 RNA",
    "AP1B1 Proteo"
  ],
  "IGHV1OR16-3": [
    "IGHV1OR16-3 CNV",
    "IGHV1OR16-3 RNA"
  ],
  "ABHD16B": [
    "ABHD16B CNV",
    "ABHD16B RNA"
  ],
  "ASS1P3": [
    "ASS1P3 CNV",
    "ASS1P3 RNA"
  ],
  "RPL7AP71": [
    "RPL7AP71 CNV",
    "RPL7AP71 RNA"
  ],
  "BCLAF1P1": [
    "BCLAF1P1 CNV",
    "BCLAF1P1 RNA"
  ],
  "EIF3A": [
    "EIF3A CNV",
    "EIF3A RNA",
    "EIF3A Proteo"
  ],
  "FBXL22": [
    "FBXL22 CNV",
    "FBXL22 RNA"
  ],
  "IGF2": [
    "IGF2 CNV",
    "IGF2 RNA",
    "IGF2 Proteo"
  ],
  "PCDHGB7": [
    "PCDHGB7 CNV",
    "PCDHGB7 RNA",
    "PCDHGB7 Proteo"
  ],
  "C19orf84": [
    "C19orf84 CNV",
    "C19orf84 RNA"
  ],
  "NXF4": [
    "NXF4 CNV",
    "NXF4 RNA"
  ],
  "PPY2P": [
    "PPY2P CNV",
    "PPY2P RNA"
  ],
  "MTND5P4": [
    "MTND5P4 CNV",
    "MTND5P4 RNA"
  ],
  "C16orf96": [
    "C16orf96 CNV",
    "C16orf96 RNA"
  ],
  "LAMTOR3": [
    "LAMTOR3 CNV",
    "LAMTOR3 RNA",
    "LAMTOR3 Proteo"
  ],
  "PRAME": [
    "PRAME CNV",
    "PRAME RNA",
    "PRAME Proteo"
  ],
  "SLC49A3": [
    "SLC49A3 CNV",
    "SLC49A3 RNA",
    "SLC49A3 Proteo"
  ],
  "KBTBD8": [
    "KBTBD8 CNV",
    "KBTBD8 RNA",
    "KBTBD8 Proteo"
  ],
  "TRIM43B": [
    "TRIM43B CNV",
    "TRIM43B RNA"
  ],
  "HNRNPA1P12": [
    "HNRNPA1P12 CNV",
    "HNRNPA1P12 RNA"
  ],
  "RANBP6": [
    "RANBP6 CNV",
    "RANBP6 RNA",
    "RANBP6 Proteo"
  ],
  "FXYD4": [
    "FXYD4 CNV",
    "FXYD4 RNA"
  ],
  "POM121L13P": [
    "POM121L13P CNV",
    "POM121L13P RNA"
  ],
  "RELB": [
    "RELB CNV",
    "RELB RNA",
    "RELB Proteo"
  ],
  "ASS1P11": [
    "ASS1P11 CNV",
    "ASS1P11 RNA"
  ],
  "NUDT5": [
    "NUDT5 CNV",
    "NUDT5 RNA",
    "NUDT5 Proteo"
  ],
  "OR52H2P": [
    "OR52H2P CNV",
    "OR52H2P RNA"
  ],
  "HLA-DQA1": [
    "HLA-DQA1 CNV",
    "HLA-DQA1 RNA",
    "HLA-DQA1 Proteo"
  ],
  "SLC25A47P1": [
    "SLC25A47P1 CNV",
    "SLC25A47P1 RNA"
  ],
  "RNA5SP379": [
    "RNA5SP379 CNV",
    "RNA5SP379 RNA"
  ],
  "EIF5A": [
    "EIF5A CNV",
    "EIF5A RNA",
    "EIF5A Proteo"
  ],
  "FBXW8": [
    "FBXW8 CNV",
    "FBXW8 RNA",
    "FBXW8 Proteo"
  ],
  "XNDC1CP": [
    "XNDC1CP CNV",
    "XNDC1CP RNA"
  ],
  "ASB1": [
    "ASB1 CNV",
    "ASB1 RNA",
    "ASB1 Proteo"
  ],
  "SNX19P1": [
    "SNX19P1 CNV",
    "SNX19P1 RNA"
  ],
  "GPR146": [
    "GPR146 CNV",
    "GPR146 RNA"
  ],
  "KIF1B": [
    "KIF1B CNV",
    "KIF1B RNA",
    "KIF1B Proteo"
  ],
  "PSMC1P7": [
    "PSMC1P7 CNV",
    "PSMC1P7 RNA"
  ],
  "CT47A8": [
    "CT47A8 CNV",
    "CT47A8 RNA"
  ],
  "CRLF3P3": [
    "CRLF3P3 CNV",
    "CRLF3P3 RNA"
  ],
  "PRR13P3": [
    "PRR13P3 CNV",
    "PRR13P3 RNA"
  ],
  "TUBAP7": [
    "TUBAP7 CNV",
    "TUBAP7 RNA"
  ],
  "GSTO1": [
    "GSTO1 CNV",
    "GSTO1 RNA",
    "GSTO1 Proteo"
  ],
  "ZNF429": [
    "ZNF429 CNV",
    "ZNF429 RNA"
  ],
  "KLRC3": [
    "KLRC3 CNV",
    "KLRC3 RNA"
  ],
  "EPN2": [
    "EPN2 CNV",
    "EPN2 RNA",
    "EPN2 Proteo"
  ],
  "IQCJ": [
    "IQCJ CNV",
    "IQCJ RNA"
  ],
  "PRPF38A": [
    "PRPF38A CNV",
    "PRPF38A RNA",
    "PRPF38A Proteo"
  ],
  "SPRING1": [
    "SPRING1 CNV",
    "SPRING1 RNA",
    "SPRING1 Proteo"
  ],
  "ZDHHC11B": [
    "ZDHHC11B CNV",
    "ZDHHC11B RNA"
  ],
  "ZNF316": [
    "ZNF316 CNV",
    "ZNF316 RNA",
    "ZNF316 Proteo"
  ],
  "ACER2P1": [
    "ACER2P1 CNV",
    "ACER2P1 RNA"
  ],
  "SRA1": [
    "SRA1 CNV",
    "SRA1 RNA",
    "SRA1 Proteo"
  ],
  "NT5DC1P2": [
    "NT5DC1P2 CNV",
    "NT5DC1P2 RNA"
  ],
  "DNM1P30": [
    "DNM1P30 CNV",
    "DNM1P30 RNA"
  ],
  "SYMPK": [
    "SYMPK CNV",
    "SYMPK RNA",
    "SYMPK Proteo"
  ],
  "CBX1P4": [
    "CBX1P4 CNV",
    "CBX1P4 RNA"
  ],
  "XKRYP2": [
    "XKRYP2 CNV",
    "XKRYP2 RNA"
  ],
  "NT5C2": [
    "NT5C2 CNV",
    "NT5C2 RNA",
    "NT5C2 Proteo"
  ],
  "FAM90A3P": [
    "FAM90A3P CNV",
    "FAM90A3P RNA"
  ],
  "MRPL13": [
    "MRPL13 CNV",
    "MRPL13 RNA",
    "MRPL13 Proteo"
  ],
  "RPL18P1": [
    "RPL18P1 CNV",
    "RPL18P1 RNA"
  ],
  "RPL26P35": [
    "RPL26P35 CNV",
    "RPL26P35 RNA"
  ],
  "ACAA2P1": [
    "ACAA2P1 CNV",
    "ACAA2P1 RNA"
  ],
  "ERFE": [
    "ERFE CNV",
    "ERFE RNA"
  ],
  "IGLVV-66": [
    "IGLVV-66 CNV",
    "IGLVV-66 RNA"
  ],
  "OR10A4": [
    "OR10A4 CNV",
    "OR10A4 RNA"
  ],
  "BRWD3": [
    "BRWD3 CNV",
    "BRWD3 RNA",
    "BRWD3 Proteo"
  ],
  "NEK2P1": [
    "NEK2P1 CNV",
    "NEK2P1 RNA"
  ],
  "SDCBP2": [
    "SDCBP2 CNV",
    "SDCBP2 RNA",
    "SDCBP2 Proteo"
  ],
  "PLLP": [
    "PLLP CNV",
    "PLLP RNA",
    "PLLP Proteo"
  ],
  "IL13RA1": [
    "IL13RA1 CNV",
    "IL13RA1 RNA",
    "IL13RA1 Proteo"
  ],
  "RPL35AP28": [
    "RPL35AP28 CNV",
    "RPL35AP28 RNA"
  ],
  "STX2": [
    "STX2 CNV",
    "STX2 RNA",
    "STX2 Proteo"
  ],
  "DNAJC17": [
    "DNAJC17 CNV",
    "DNAJC17 RNA",
    "DNAJC17 Proteo"
  ],
  "MTND6P16": [
    "MTND6P16 CNV",
    "MTND6P16 RNA"
  ],
  "ICE1": [
    "ICE1 CNV",
    "ICE1 RNA",
    "ICE1 Proteo"
  ],
  "ACTL11P": [
    "ACTL11P CNV",
    "ACTL11P RNA"
  ],
  "RDM1P1": [
    "RDM1P1 CNV",
    "RDM1P1 RNA"
  ],
  "PPIAP9": [
    "PPIAP9 CNV",
    "PPIAP9 RNA"
  ],
  "MEIOC": [
    "MEIOC CNV",
    "MEIOC RNA"
  ],
  "CMC1": [
    "CMC1 CNV",
    "CMC1 RNA",
    "CMC1 Proteo"
  ],
  "SOX30": [
    "SOX30 CNV",
    "SOX30 RNA"
  ],
  "TPM3P4": [
    "TPM3P4 CNV",
    "TPM3P4 RNA"
  ],
  "TRIM50": [
    "TRIM50 CNV",
    "TRIM50 RNA"
  ],
  "PABPC1P9": [
    "PABPC1P9 CNV",
    "PABPC1P9 RNA"
  ],
  "HSPB7": [
    "HSPB7 CNV",
    "HSPB7 RNA",
    "HSPB7 Proteo"
  ],
  "OR7E110P": [
    "OR7E110P CNV",
    "OR7E110P RNA"
  ],
  "IFI27": [
    "IFI27 CNV",
    "IFI27 RNA",
    "IFI27 Proteo"
  ],
  "H2AZP3": [
    "H2AZP3 CNV",
    "H2AZP3 RNA"
  ],
  "ISOC2": [
    "ISOC2 CNV",
    "ISOC2 RNA",
    "ISOC2 Proteo"
  ],
  "LHX8": [
    "LHX8 CNV",
    "LHX8 RNA",
    "LHX8 Proteo"
  ],
  "PLXNA1": [
    "PLXNA1 CNV",
    "PLXNA1 RNA",
    "PLXNA1 Proteo"
  ],
  "DDX5": [
    "DDX5 CNV",
    "DDX5 RNA",
    "DDX5 Proteo"
  ],
  "HPS6": [
    "HPS6 CNV",
    "HPS6 RNA",
    "HPS6 Proteo"
  ],
  "SEC24A": [
    "SEC24A CNV",
    "SEC24A RNA",
    "SEC24A Proteo"
  ],
  "CCNP": [
    "CCNP CNV",
    "CCNP RNA"
  ],
  "TRAF3IP3": [
    "TRAF3IP3 CNV",
    "TRAF3IP3 RNA",
    "TRAF3IP3 Proteo"
  ],
  "SEC22B2P": [
    "SEC22B2P CNV",
    "SEC22B2P RNA"
  ],
  "TWF1P1": [
    "TWF1P1 CNV",
    "TWF1P1 RNA"
  ],
  "GAB4": [
    "GAB4 CNV",
    "GAB4 RNA"
  ],
  "TSPY5P": [
    "TSPY5P CNV",
    "TSPY5P RNA"
  ],
  "ARHGAP31": [
    "ARHGAP31 CNV",
    "ARHGAP31 RNA",
    "ARHGAP31 Proteo"
  ],
  "TRDMT1": [
    "TRDMT1 CNV",
    "TRDMT1 RNA",
    "TRDMT1 Proteo"
  ],
  "RPL23AP39": [
    "RPL23AP39 CNV",
    "RPL23AP39 RNA"
  ],
  "ALG1L6P": [
    "ALG1L6P CNV",
    "ALG1L6P RNA"
  ],
  "MGST3": [
    "MGST3 CNV",
    "MGST3 RNA",
    "MGST3 Proteo"
  ],
  "RNPS1P1": [
    "RNPS1P1 CNV",
    "RNPS1P1 RNA"
  ],
  "IGLVI-70": [
    "IGLVI-70 CNV",
    "IGLVI-70 RNA"
  ],
  "SMIM19": [
    "SMIM19 CNV",
    "SMIM19 RNA",
    "SMIM19 Proteo"
  ],
  "OTX2": [
    "OTX2 CNV",
    "OTX2 RNA"
  ],
  "USP9YP22": [
    "USP9YP22 CNV",
    "USP9YP22 RNA"
  ],
  "ARMCX2": [
    "ARMCX2 CNV",
    "ARMCX2 RNA",
    "ARMCX2 Proteo"
  ],
  "MYO3A": [
    "MYO3A CNV",
    "MYO3A RNA"
  ],
  "PROZ": [
    "PROZ CNV",
    "PROZ RNA",
    "PROZ Proteo"
  ],
  "LMX1A": [
    "LMX1A CNV",
    "LMX1A RNA"
  ],
  "POLE4": [
    "POLE4 CNV",
    "POLE4 RNA",
    "POLE4 Proteo"
  ],
  "RPL27P7": [
    "RPL27P7 CNV",
    "RPL27P7 RNA"
  ],
  "TEX28P2": [
    "TEX28P2 CNV",
    "TEX28P2 RNA"
  ],
  "CDC7": [
    "CDC7 CNV",
    "CDC7 RNA",
    "CDC7 Proteo"
  ],
  "RBMY2UP": [
    "RBMY2UP CNV",
    "RBMY2UP RNA"
  ],
  "CAFs": [
    "CAFs Cell_type"
  ],
  "NFYB": [
    "NFYB CNV",
    "NFYB RNA",
    "NFYB Proteo"
  ],
  "ENO2": [
    "ENO2 CNV",
    "ENO2 RNA",
    "ENO2 Proteo"
  ],
  "OPTC": [
    "OPTC CNV",
    "OPTC RNA"
  ],
  "RAB28P1": [
    "RAB28P1 CNV",
    "RAB28P1 RNA"
  ],
  "RFK": [
    "RFK CNV",
    "RFK RNA",
    "RFK Proteo"
  ],
  "CD70": [
    "CD70 CNV",
    "CD70 RNA",
    "CD70 Proteo"
  ],
  "ETV5": [
    "ETV5 CNV",
    "ETV5 RNA"
  ],
  "MRPL36": [
    "MRPL36 CNV",
    "MRPL36 RNA"
  ],
  "PHB1P10": [
    "PHB1P10 CNV",
    "PHB1P10 RNA"
  ],
  "CCDC144CP": [
    "CCDC144CP CNV",
    "CCDC144CP RNA"
  ],
  "ANKFN1": [
    "ANKFN1 CNV",
    "ANKFN1 RNA",
    "ANKFN1 Proteo"
  ],
  "SYN3": [
    "SYN3 CNV",
    "SYN3 RNA"
  ],
  "TPM3P2": [
    "TPM3P2 CNV",
    "TPM3P2 RNA"
  ],
  "EEF1DP8": [
    "EEF1DP8 CNV",
    "EEF1DP8 RNA"
  ],
  "RPS6KC1": [
    "RPS6KC1 CNV",
    "RPS6KC1 RNA",
    "RPS6KC1 Proteo"
  ],
  "H2AL1Q": [
    "H2AL1Q CNV",
    "H2AL1Q RNA"
  ],
  "ASIC2": [
    "ASIC2 CNV",
    "ASIC2 RNA"
  ],
  "FTLP18": [
    "FTLP18 CNV",
    "FTLP18 RNA"
  ],
  "OPRL1": [
    "OPRL1 CNV",
    "OPRL1 RNA"
  ],
  "UNC50": [
    "UNC50 CNV",
    "UNC50 RNA"
  ],
  "OFD1P6Y": [
    "OFD1P6Y CNV",
    "OFD1P6Y RNA"
  ],
  "SMG9": [
    "SMG9 CNV",
    "SMG9 RNA",
    "SMG9 Proteo"
  ],
  "ISCA2": [
    "ISCA2 CNV",
    "ISCA2 RNA",
    "ISCA2 Proteo"
  ],
  "UTP14C": [
    "UTP14C CNV",
    "UTP14C RNA"
  ],
  "VENTXP7": [
    "VENTXP7 CNV",
    "VENTXP7 RNA"
  ],
  "PAK1IP1": [
    "PAK1IP1 CNV",
    "PAK1IP1 RNA",
    "PAK1IP1 Proteo"
  ],
  "CENPA": [
    "CENPA CNV",
    "CENPA RNA",
    "CENPA Proteo"
  ],
  "S100A11P6": [
    "S100A11P6 CNV",
    "S100A11P6 RNA"
  ],
  "PRPS1": [
    "PRPS1 CNV",
    "PRPS1 RNA",
    "PRPS1 Proteo"
  ],
  "SMARCA2": [
    "SMARCA2 CNV",
    "SMARCA2 RNA",
    "SMARCA2 Proteo"
  ],
  "APOLD1": [
    "APOLD1 CNV",
    "APOLD1 RNA"
  ],
  "RPL17P44": [
    "RPL17P44 CNV",
    "RPL17P44 RNA"
  ],
  "TULP3P1": [
    "TULP3P1 CNV",
    "TULP3P1 RNA"
  ],
  "NF1P4": [
    "NF1P4 CNV",
    "NF1P4 RNA"
  ],
  "PMPCA": [
    "PMPCA CNV",
    "PMPCA RNA",
    "PMPCA Proteo"
  ],
  "BCRP7": [
    "BCRP7 CNV",
    "BCRP7 RNA"
  ],
  "NCR2": [
    "NCR2 CNV",
    "NCR2 RNA"
  ],
  "GABRR2": [
    "GABRR2 CNV",
    "GABRR2 RNA"
  ],
  "KLK7": [
    "KLK7 CNV",
    "KLK7 RNA",
    "KLK7 Proteo"
  ],
  "FAM135A": [
    "FAM135A CNV",
    "FAM135A RNA",
    "FAM135A Proteo"
  ],
  "ACSF3": [
    "ACSF3 CNV",
    "ACSF3 RNA",
    "ACSF3 Proteo"
  ],
  "FAAP20": [
    "FAAP20 CNV",
    "FAAP20 RNA"
  ],
  "TNS4": [
    "TNS4 CNV",
    "TNS4 RNA",
    "TNS4 Proteo"
  ],
  "EMX1": [
    "EMX1 CNV",
    "EMX1 RNA"
  ],
  "OR5M3": [
    "OR5M3 CNV",
    "OR5M3 RNA"
  ],
  "BTBD17": [
    "BTBD17 CNV",
    "BTBD17 RNA"
  ],
  "RPP25L": [
    "RPP25L CNV",
    "RPP25L RNA",
    "RPP25L Proteo"
  ],
  "CELF5": [
    "CELF5 CNV",
    "CELF5 RNA"
  ],
  "MKI67P1": [
    "MKI67P1 CNV",
    "MKI67P1 RNA"
  ],
  "PRAMEF7": [
    "PRAMEF7 CNV",
    "PRAMEF7 RNA"
  ],
  "ZNF530": [
    "ZNF530 CNV",
    "ZNF530 RNA"
  ],
  "MUC13": [
    "MUC13 CNV",
    "MUC13 RNA",
    "MUC13 Proteo"
  ],
  "RPL29P25": [
    "RPL29P25 CNV",
    "RPL29P25 RNA"
  ],
  "ASS1P4": [
    "ASS1P4 CNV",
    "ASS1P4 RNA"
  ],
  "NEK2P2": [
    "NEK2P2 CNV",
    "NEK2P2 RNA"
  ],
  "ZMYND10": [
    "ZMYND10 CNV",
    "ZMYND10 RNA"
  ],
  "EEF1A1P49": [
    "EEF1A1P49 CNV",
    "EEF1A1P49 RNA"
  ],
  "BNIP3P36": [
    "BNIP3P36 CNV",
    "BNIP3P36 RNA"
  ],
  "SAT1": [
    "SAT1 CNV",
    "SAT1 RNA"
  ],
  "MCM5": [
    "MCM5 CNV",
    "MCM5 RNA",
    "MCM5 Proteo"
  ],
  "TFEC": [
    "TFEC CNV",
    "TFEC RNA",
    "TFEC Proteo"
  ],
  "DEFA6": [
    "DEFA6 CNV",
    "DEFA6 RNA"
  ],
  "COX6CP14": [
    "COX6CP14 CNV",
    "COX6CP14 RNA"
  ],
  "EIF3JP1": [
    "EIF3JP1 CNV",
    "EIF3JP1 RNA"
  ],
  "OR2A20P": [
    "OR2A20P CNV",
    "OR2A20P RNA"
  ],
  "ANKRD30BP1": [
    "ANKRD30BP1 CNV",
    "ANKRD30BP1 RNA"
  ],
  "NUP58P1": [
    "NUP58P1 CNV",
    "NUP58P1 RNA"
  ],
  "CYLC1": [
    "CYLC1 CNV",
    "CYLC1 RNA"
  ],
  "UBE2SP2": [
    "UBE2SP2 CNV",
    "UBE2SP2 RNA"
  ],
  "SIN3B": [
    "SIN3B CNV",
    "SIN3B RNA",
    "SIN3B Proteo"
  ],
  "TMPRSS5": [
    "TMPRSS5 CNV",
    "TMPRSS5 RNA"
  ],
  "CDY6P": [
    "CDY6P CNV",
    "CDY6P RNA"
  ],
  "CDC34": [
    "CDC34 CNV",
    "CDC34 RNA",
    "CDC34 Proteo"
  ],
  "DHDH": [
    "DHDH CNV",
    "DHDH RNA"
  ],
  "SMG6": [
    "SMG6 CNV",
    "SMG6 RNA",
    "SMG6 Proteo"
  ],
  "CEP152": [
    "CEP152 CNV",
    "CEP152 RNA",
    "CEP152 Proteo"
  ],
  "SRSF8": [
    "SRSF8 CNV",
    "SRSF8 RNA",
    "SRSF8 Proteo"
  ],
  "TSPAN15": [
    "TSPAN15 CNV",
    "TSPAN15 RNA",
    "TSPAN15 Proteo"
  ],
  "PLCE1": [
    "PLCE1 CNV",
    "PLCE1 RNA"
  ],
  "RPS12P10": [
    "RPS12P10 CNV",
    "RPS12P10 RNA"
  ],
  "BRI3P3": [
    "BRI3P3 CNV",
    "BRI3P3 RNA"
  ],
  "HES1": [
    "HES1 CNV",
    "HES1 RNA",
    "HES1 Proteo"
  ],
  "AFAP1": [
    "AFAP1 CNV",
    "AFAP1 RNA",
    "AFAP1 Proteo"
  ],
  "PSMD11": [
    "PSMD11 CNV",
    "PSMD11 RNA",
    "PSMD11 Proteo"
  ],
  "METTL4": [
    "METTL4 CNV",
    "METTL4 RNA",
    "METTL4 Proteo"
  ],
  "VOPP1": [
    "VOPP1 CNV",
    "VOPP1 RNA",
    "VOPP1 Proteo"
  ],
  "MLLT1": [
    "MLLT1 CNV",
    "MLLT1 RNA",
    "MLLT1 Proteo"
  ],
  "SERF1B": [
    "SERF1B CNV",
    "SERF1B RNA"
  ],
  "KNOP1P1": [
    "KNOP1P1 CNV",
    "KNOP1P1 RNA"
  ],
  "BLMH": [
    "BLMH CNV",
    "BLMH RNA",
    "BLMH Proteo"
  ],
  "DCAF12L1": [
    "DCAF12L1 CNV",
    "DCAF12L1 RNA"
  ],
  "LEMD3": [
    "LEMD3 CNV",
    "LEMD3 RNA",
    "LEMD3 Proteo"
  ],
  "ZDHHC4": [
    "ZDHHC4 CNV",
    "ZDHHC4 RNA",
    "ZDHHC4 Proteo"
  ],
  "SREK1IP1": [
    "SREK1IP1 CNV",
    "SREK1IP1 RNA",
    "SREK1IP1 Proteo"
  ],
  "CTAGE11P": [
    "CTAGE11P CNV",
    "CTAGE11P RNA"
  ],
  "STAM2": [
    "STAM2 CNV",
    "STAM2 RNA",
    "STAM2 Proteo"
  ],
  "SPINK14": [
    "SPINK14 CNV",
    "SPINK14 RNA"
  ],
  "SOCS3": [
    "SOCS3 CNV",
    "SOCS3 RNA"
  ],
  "RPL7P19": [
    "RPL7P19 CNV",
    "RPL7P19 RNA"
  ],
  "CD22": [
    "CD22 CNV",
    "CD22 RNA",
    "CD22 Proteo"
  ],
  "RBM18": [
    "RBM18 CNV",
    "RBM18 RNA",
    "RBM18 Proteo"
  ],
  "RPS5P7": [
    "RPS5P7 CNV",
    "RPS5P7 RNA"
  ],
  "ACAP2": [
    "ACAP2 CNV",
    "ACAP2 RNA",
    "ACAP2 Proteo"
  ],
  "SETP5": [
    "SETP5 CNV",
    "SETP5 RNA"
  ],
  "FAM220CP": [
    "FAM220CP CNV",
    "FAM220CP RNA"
  ],
  "IKBKGP1": [
    "IKBKGP1 CNV",
    "IKBKGP1 RNA"
  ],
  "ARL14EPL": [
    "ARL14EPL CNV",
    "ARL14EPL RNA"
  ],
  "CLVS1": [
    "CLVS1 CNV",
    "CLVS1 RNA"
  ],
  "KPNB1": [
    "KPNB1 CNV",
    "KPNB1 RNA",
    "KPNB1 Proteo"
  ],
  "ZKSCAN3": [
    "ZKSCAN3 CNV",
    "ZKSCAN3 RNA",
    "ZKSCAN3 Proteo"
  ],
  "GSKIP": [
    "GSKIP CNV",
    "GSKIP RNA",
    "GSKIP Proteo"
  ],
  "PCMTD2": [
    "PCMTD2 CNV",
    "PCMTD2 RNA",
    "PCMTD2 Proteo"
  ],
  "RPL21P16": [
    "RPL21P16 CNV",
    "RPL21P16 RNA"
  ],
  "RNA5SP123": [
    "RNA5SP123 CNV",
    "RNA5SP123 RNA"
  ],
  "MAPK8IP2": [
    "MAPK8IP2 CNV",
    "MAPK8IP2 RNA"
  ],
  "B3GAT2": [
    "B3GAT2 CNV",
    "B3GAT2 RNA"
  ],
  "CDH13": [
    "CDH13 CNV",
    "CDH13 RNA",
    "CDH13 Proteo"
  ],
  "SEC24B": [
    "SEC24B CNV",
    "SEC24B RNA",
    "SEC24B Proteo"
  ],
  "EIF2S2P4": [
    "EIF2S2P4 CNV",
    "EIF2S2P4 RNA"
  ],
  "FAM90A28P": [
    "FAM90A28P CNV",
    "FAM90A28P RNA"
  ],
  "BTF3P13": [
    "BTF3P13 CNV",
    "BTF3P13 RNA"
  ],
  "PPIAP20": [
    "PPIAP20 CNV",
    "PPIAP20 RNA"
  ],
  "ALPK2": [
    "ALPK2 CNV",
    "ALPK2 RNA"
  ],
  "LENG9": [
    "LENG9 CNV",
    "LENG9 RNA",
    "LENG9 Proteo"
  ],
  "RTN2": [
    "RTN2 CNV",
    "RTN2 RNA",
    "RTN2 Proteo"
  ],
  "UBE2G1": [
    "UBE2G1 CNV",
    "UBE2G1 RNA",
    "UBE2G1 Proteo"
  ],
  "KIAA1143": [
    "KIAA1143 CNV",
    "KIAA1143 RNA",
    "KIAA1143 Proteo"
  ],
  "KEAP1": [
    "KEAP1 CNV",
    "KEAP1 RNA",
    "KEAP1 Proteo"
  ],
  "ARF4P2": [
    "ARF4P2 CNV",
    "ARF4P2 RNA"
  ],
  "SLC20A1P1": [
    "SLC20A1P1 CNV",
    "SLC20A1P1 RNA"
  ],
  "RBM17P3": [
    "RBM17P3 CNV",
    "RBM17P3 RNA"
  ],
  "DBH": [
    "DBH CNV",
    "DBH RNA",
    "DBH Proteo"
  ],
  "IPO13": [
    "IPO13 CNV",
    "IPO13 RNA",
    "IPO13 Proteo"
  ],
  "SNRPCP3": [
    "SNRPCP3 CNV",
    "SNRPCP3 RNA"
  ],
  "TRIM35": [
    "TRIM35 CNV",
    "TRIM35 RNA",
    "TRIM35 Proteo"
  ],
  "ATOH7": [
    "ATOH7 CNV",
    "ATOH7 RNA"
  ],
  "RPL21P131": [
    "RPL21P131 CNV",
    "RPL21P131 RNA"
  ],
  "LY6L": [
    "LY6L CNV",
    "LY6L RNA"
  ],
  "GTF2B": [
    "GTF2B CNV",
    "GTF2B RNA",
    "GTF2B Proteo"
  ],
  "CHCHD1": [
    "CHCHD1 CNV",
    "CHCHD1 RNA",
    "CHCHD1 Proteo"
  ],
  "RPL27P5": [
    "RPL27P5 CNV",
    "RPL27P5 RNA"
  ],
  "HNRNPA1P38": [
    "HNRNPA1P38 CNV",
    "HNRNPA1P38 RNA"
  ],
  "BDH1": [
    "BDH1 CNV",
    "BDH1 RNA",
    "BDH1 Proteo"
  ],
  "SSR4P1": [
    "SSR4P1 CNV",
    "SSR4P1 RNA"
  ],
  "COA1": [
    "COA1 CNV",
    "COA1 RNA",
    "COA1 Proteo"
  ],
  "HHLA1": [
    "HHLA1 CNV",
    "HHLA1 RNA"
  ],
  "SLC22A3": [
    "SLC22A3 CNV",
    "SLC22A3 RNA",
    "SLC22A3 Proteo"
  ],
  "HRH1": [
    "HRH1 CNV",
    "HRH1 RNA"
  ],
  "CNOT6LP1": [
    "CNOT6LP1 CNV",
    "CNOT6LP1 RNA"
  ],
  "SLC27A1": [
    "SLC27A1 CNV",
    "SLC27A1 RNA",
    "SLC27A1 Proteo"
  ],
  "TMEM132B": [
    "TMEM132B CNV",
    "TMEM132B RNA"
  ],
  "RLN1": [
    "RLN1 CNV",
    "RLN1 RNA"
  ],
  "CYCSP30": [
    "CYCSP30 CNV",
    "CYCSP30 RNA"
  ],
  "ARHGAP42P3": [
    "ARHGAP42P3 CNV",
    "ARHGAP42P3 RNA"
  ],
  "PPIAP23": [
    "PPIAP23 CNV",
    "PPIAP23 RNA"
  ],
  "BOLA3P4": [
    "BOLA3P4 CNV",
    "BOLA3P4 RNA"
  ],
  "IGSF3P2": [
    "IGSF3P2 CNV",
    "IGSF3P2 RNA"
  ],
  "MEMO1P4": [
    "MEMO1P4 CNV",
    "MEMO1P4 RNA"
  ],
  "CCP110": [
    "CCP110 CNV",
    "CCP110 RNA",
    "CCP110 Proteo"
  ],
  "DEFB108E": [
    "DEFB108E CNV",
    "DEFB108E RNA"
  ],
  "GABRR3": [
    "GABRR3 CNV",
    "GABRR3 RNA"
  ],
  "CRTAM": [
    "CRTAM CNV",
    "CRTAM RNA"
  ],
  "TSPY6P": [
    "TSPY6P CNV",
    "TSPY6P RNA"
  ],
  "TMEM223": [
    "TMEM223 CNV",
    "TMEM223 RNA",
    "TMEM223 Proteo"
  ],
  "TMA16P2": [
    "TMA16P2 CNV",
    "TMA16P2 RNA"
  ],
  "SELENOI": [
    "SELENOI CNV",
    "SELENOI RNA",
    "SELENOI Proteo"
  ],
  "DOCK4": [
    "DOCK4 CNV",
    "DOCK4 RNA",
    "DOCK4 Proteo"
  ],
  "IL7R": [
    "IL7R CNV",
    "IL7R RNA"
  ],
  "EIF4A1P13": [
    "EIF4A1P13 CNV",
    "EIF4A1P13 RNA"
  ],
  "OR4F29": [
    "OR4F29 CNV",
    "OR4F29 RNA"
  ],
  "LRFN1": [
    "LRFN1 CNV",
    "LRFN1 RNA"
  ],
  "OR4D5": [
    "OR4D5 CNV",
    "OR4D5 RNA"
  ],
  "FAM200A": [
    "FAM200A CNV",
    "FAM200A RNA"
  ],
  "CNR2": [
    "CNR2 CNV",
    "CNR2 RNA"
  ],
  "CD247": [
    "CD247 CNV",
    "CD247 RNA",
    "CD247 Proteo"
  ],
  "MZT2B": [
    "MZT2B CNV",
    "MZT2B RNA",
    "MZT2B Proteo"
  ],
  "TUBB2A": [
    "TUBB2A CNV",
    "TUBB2A RNA",
    "TUBB2A Proteo"
  ],
  "ZSWIM3": [
    "ZSWIM3 CNV",
    "ZSWIM3 RNA"
  ],
  "CDH12": [
    "CDH12 CNV",
    "CDH12 RNA"
  ],
  "WNT6": [
    "WNT6 CNV",
    "WNT6 RNA"
  ],
  "MARCHF5": [
    "MARCHF5 CNV",
    "MARCHF5 RNA",
    "MARCHF5 Proteo"
  ],
  "DNAH6": [
    "DNAH6 CNV",
    "DNAH6 RNA"
  ],
  "NUP160": [
    "NUP160 CNV",
    "NUP160 RNA",
    "NUP160 Proteo"
  ],
  "PRSS51": [
    "PRSS51 CNV",
    "PRSS51 RNA"
  ],
  "MT1L": [
    "MT1L CNV",
    "MT1L RNA"
  ],
  "CHCHD2P4": [
    "CHCHD2P4 CNV",
    "CHCHD2P4 RNA"
  ],
  "CCDC144BP": [
    "CCDC144BP CNV",
    "CCDC144BP RNA"
  ],
  "SLC2A6": [
    "SLC2A6 CNV",
    "SLC2A6 RNA",
    "SLC2A6 Proteo"
  ],
  "PALMD": [
    "PALMD CNV",
    "PALMD RNA",
    "PALMD Proteo"
  ],
  "UBE2V1P7": [
    "UBE2V1P7 CNV",
    "UBE2V1P7 RNA"
  ],
  "NDUFA5P12": [
    "NDUFA5P12 CNV",
    "NDUFA5P12 RNA"
  ],
  "RPS6KA4": [
    "RPS6KA4 CNV",
    "RPS6KA4 RNA",
    "RPS6KA4 Proteo"
  ],
  "TBCB": [
    "TBCB CNV",
    "TBCB RNA",
    "TBCB Proteo"
  ],
  "PSMC4": [
    "PSMC4 CNV",
    "PSMC4 RNA",
    "PSMC4 Proteo"
  ],
  "CCDC149": [
    "CCDC149 CNV",
    "CCDC149 RNA",
    "CCDC149 Proteo"
  ],
  "ANKRD17": [
    "ANKRD17 CNV",
    "ANKRD17 RNA",
    "ANKRD17 Proteo"
  ],
  "BRD7P6": [
    "BRD7P6 CNV",
    "BRD7P6 RNA"
  ],
  "CCR5": [
    "CCR5 CNV",
    "CCR5 RNA",
    "CCR5 Proteo"
  ],
  "KRTAP29-1": [
    "KRTAP29-1 CNV",
    "KRTAP29-1 RNA"
  ],
  "SYN1": [
    "SYN1 CNV",
    "SYN1 RNA",
    "SYN1 Proteo"
  ],
  "MZF1": [
    "MZF1 CNV",
    "MZF1 RNA"
  ],
  "LILRB4": [
    "LILRB4 CNV",
    "LILRB4 RNA",
    "LILRB4 Proteo"
  ],
  "RPS15AP32": [
    "RPS15AP32 CNV",
    "RPS15AP32 RNA"
  ],
  "SYPL2": [
    "SYPL2 CNV",
    "SYPL2 RNA",
    "SYPL2 Proteo"
  ],
  "NRXN2": [
    "NRXN2 CNV",
    "NRXN2 RNA"
  ],
  "MTND1P14": [
    "MTND1P14 CNV",
    "MTND1P14 RNA"
  ],
  "FBXL7": [
    "FBXL7 CNV",
    "FBXL7 RNA",
    "FBXL7 Proteo"
  ],
  "ANOS1": [
    "ANOS1 CNV",
    "ANOS1 RNA",
    "ANOS1 Proteo"
  ],
  "GTF2IP1": [
    "GTF2IP1 CNV",
    "GTF2IP1 RNA"
  ],
  "HMGB1P14": [
    "HMGB1P14 CNV",
    "HMGB1P14 RNA"
  ],
  "FNDC7": [
    "FNDC7 CNV",
    "FNDC7 RNA"
  ],
  "ACBD5": [
    "ACBD5 CNV",
    "ACBD5 RNA",
    "ACBD5 Proteo"
  ],
  "CEP57L1": [
    "CEP57L1 CNV",
    "CEP57L1 RNA"
  ],
  "SCRG1": [
    "SCRG1 CNV",
    "SCRG1 RNA"
  ],
  "WWC2": [
    "WWC2 CNV",
    "WWC2 RNA",
    "WWC2 Proteo"
  ],
  "USP45": [
    "USP45 CNV",
    "USP45 RNA"
  ],
  "DUX4L23": [
    "DUX4L23 CNV",
    "DUX4L23 RNA"
  ],
  "C6orf62": [
    "C6orf62 CNV",
    "C6orf62 RNA"
  ],
  "KLHDC3": [
    "KLHDC3 CNV",
    "KLHDC3 RNA",
    "KLHDC3 Proteo"
  ],
  "MAPRE3": [
    "MAPRE3 CNV",
    "MAPRE3 RNA",
    "MAPRE3 Proteo"
  ],
  "DEFT1P2": [
    "DEFT1P2 CNV",
    "DEFT1P2 RNA"
  ],
  "ATP5F1AP1": [
    "ATP5F1AP1 CNV",
    "ATP5F1AP1 RNA"
  ],
  "RPL36AP9": [
    "RPL36AP9 CNV",
    "RPL36AP9 RNA"
  ],
  "SLC25A1P3": [
    "SLC25A1P3 CNV",
    "SLC25A1P3 RNA"
  ],
  "ASTE1": [
    "ASTE1 CNV",
    "ASTE1 RNA",
    "ASTE1 Proteo"
  ],
  "PTP4A1P4": [
    "PTP4A1P4 CNV",
    "PTP4A1P4 RNA"
  ],
  "CLSTN1": [
    "CLSTN1 CNV",
    "CLSTN1 RNA",
    "CLSTN1 Proteo"
  ],
  "TUBB8P2": [
    "TUBB8P2 CNV",
    "TUBB8P2 RNA"
  ],
  "OLFML3": [
    "OLFML3 CNV",
    "OLFML3 RNA",
    "OLFML3 Proteo"
  ],
  "IGLV3-26": [
    "IGLV3-26 CNV",
    "IGLV3-26 RNA"
  ],
  "SCN5A": [
    "SCN5A CNV",
    "SCN5A RNA"
  ],
  "ARHGAP5": [
    "ARHGAP5 CNV",
    "ARHGAP5 RNA",
    "ARHGAP5 Proteo"
  ],
  "ASS1P10": [
    "ASS1P10 CNV",
    "ASS1P10 RNA"
  ],
  "SNRPEP2": [
    "SNRPEP2 CNV",
    "SNRPEP2 RNA"
  ],
  "PRPF31": [
    "PRPF31 CNV",
    "PRPF31 RNA",
    "PRPF31 Proteo"
  ],
  "SPTLC3": [
    "SPTLC3 CNV",
    "SPTLC3 RNA",
    "SPTLC3 Proteo"
  ],
  "DNA2": [
    "DNA2 CNV",
    "DNA2 RNA",
    "DNA2 Proteo"
  ],
  "MOSPD1": [
    "MOSPD1 CNV",
    "MOSPD1 RNA",
    "MOSPD1 Proteo"
  ],
  "OPN1LW": [
    "OPN1LW CNV",
    "OPN1LW RNA"
  ],
  "RNA5SP147": [
    "RNA5SP147 CNV",
    "RNA5SP147 RNA"
  ],
  "SERPINF1": [
    "SERPINF1 CNV",
    "SERPINF1 RNA",
    "SERPINF1 Proteo"
  ],
  "FGF18": [
    "FGF18 CNV",
    "FGF18 RNA"
  ],
  "H2AZ1": [
    "H2AZ1 CNV",
    "H2AZ1 RNA",
    "H2AZ1 Proteo"
  ],
  "OR4A18P": [
    "OR4A18P CNV",
    "OR4A18P RNA"
  ],
  "MTATP6P21": [
    "MTATP6P21 CNV",
    "MTATP6P21 RNA"
  ],
  "DHX34": [
    "DHX34 CNV",
    "DHX34 RNA",
    "DHX34 Proteo"
  ],
  "INPPL1": [
    "INPPL1 CNV",
    "INPPL1 RNA",
    "INPPL1 Proteo"
  ],
  "NCBP2AS2": [
    "NCBP2AS2 CNV",
    "NCBP2AS2 RNA",
    "NCBP2AS2 Proteo"
  ],
  "MTCO3P10": [
    "MTCO3P10 CNV",
    "MTCO3P10 RNA"
  ],
  "HNRNPA1P39": [
    "HNRNPA1P39 CNV",
    "HNRNPA1P39 RNA"
  ],
  "TCEAL7": [
    "TCEAL7 CNV",
    "TCEAL7 RNA"
  ],
  "ZBTB24": [
    "ZBTB24 CNV",
    "ZBTB24 RNA",
    "ZBTB24 Proteo"
  ],
  "DENND2A": [
    "DENND2A CNV",
    "DENND2A RNA",
    "DENND2A Proteo"
  ],
  "TASOR": [
    "TASOR CNV",
    "TASOR RNA",
    "TASOR Proteo"
  ],
  "EXOC1": [
    "EXOC1 CNV",
    "EXOC1 RNA",
    "EXOC1 Proteo"
  ],
  "SPINK1": [
    "SPINK1 CNV",
    "SPINK1 RNA"
  ],
  "TTPAL": [
    "TTPAL CNV",
    "TTPAL RNA",
    "TTPAL Proteo"
  ],
  "RBMY2DP": [
    "RBMY2DP CNV",
    "RBMY2DP RNA"
  ],
  "IGHVII-53-1": [
    "IGHVII-53-1 CNV",
    "IGHVII-53-1 RNA"
  ],
  "ANAPC1P5": [
    "ANAPC1P5 CNV",
    "ANAPC1P5 RNA"
  ],
  "TNFSF13B": [
    "TNFSF13B CNV",
    "TNFSF13B RNA",
    "TNFSF13B Proteo"
  ],
  "DDX39BP1": [
    "DDX39BP1 CNV",
    "DDX39BP1 RNA"
  ],
  "GNB2": [
    "GNB2 CNV",
    "GNB2 RNA",
    "GNB2 Proteo"
  ],
  "CCL14": [
    "CCL14 CNV",
    "CCL14 RNA"
  ],
  "IGKV3-11": [
    "IGKV3-11 Proteo"
  ],
  "SLMAP": [
    "SLMAP CNV",
    "SLMAP RNA",
    "SLMAP Proteo"
  ],
  "NSUN7": [
    "NSUN7 CNV",
    "NSUN7 RNA"
  ],
  "KSR1P1": [
    "KSR1P1 CNV",
    "KSR1P1 RNA"
  ],
  "RHOG": [
    "RHOG CNV",
    "RHOG RNA",
    "RHOG Proteo"
  ],
  "OR7D1P": [
    "OR7D1P CNV",
    "OR7D1P RNA"
  ],
  "TTC36": [
    "TTC36 CNV",
    "TTC36 RNA"
  ],
  "PRAC2": [
    "PRAC2 CNV",
    "PRAC2 RNA"
  ],
  "UBE2R2": [
    "UBE2R2 CNV",
    "UBE2R2 RNA",
    "UBE2R2 Proteo"
  ],
  "H3P37": [
    "H3P37 CNV",
    "H3P37 RNA"
  ],
  "USP9YP31": [
    "USP9YP31 CNV",
    "USP9YP31 RNA"
  ],
  "IGLVIV-53": [
    "IGLVIV-53 CNV",
    "IGLVIV-53 RNA"
  ],
  "RMND5A": [
    "RMND5A CNV",
    "RMND5A RNA",
    "RMND5A Proteo"
  ],
  "PHACTR3": [
    "PHACTR3 CNV",
    "PHACTR3 RNA"
  ],
  "GTF3C4": [
    "GTF3C4 CNV",
    "GTF3C4 RNA",
    "GTF3C4 Proteo"
  ],
  "SLC6A1": [
    "SLC6A1 CNV",
    "SLC6A1 RNA"
  ],
  "IGLV3-2": [
    "IGLV3-2 CNV",
    "IGLV3-2 RNA"
  ],
  "ING4": [
    "ING4 CNV",
    "ING4 RNA",
    "ING4 Proteo"
  ],
  "ARIH2P1": [
    "ARIH2P1 CNV",
    "ARIH2P1 RNA"
  ],
  "TM7SF3": [
    "TM7SF3 CNV",
    "TM7SF3 RNA",
    "TM7SF3 Proteo"
  ],
  "QSOX1": [
    "QSOX1 CNV",
    "QSOX1 RNA",
    "QSOX1 Proteo"
  ],
  "RPL36P15": [
    "RPL36P15 CNV",
    "RPL36P15 RNA"
  ],
  "CFAP126": [
    "CFAP126 CNV",
    "CFAP126 RNA"
  ],
  "GNRH1": [
    "GNRH1 CNV",
    "GNRH1 RNA"
  ],
  "OR4D8P": [
    "OR4D8P CNV",
    "OR4D8P RNA"
  ],
  "PDCD6": [
    "PDCD6 CNV",
    "PDCD6 RNA",
    "PDCD6 Proteo"
  ],
  "FXYD6P1": [
    "FXYD6P1 CNV",
    "FXYD6P1 RNA"
  ],
  "MTND4P20": [
    "MTND4P20 CNV",
    "MTND4P20 RNA"
  ],
  "CD48": [
    "CD48 CNV",
    "CD48 RNA",
    "CD48 Proteo"
  ],
  "SMCP": [
    "SMCP CNV",
    "SMCP RNA"
  ],
  "HNRNPA3P3": [
    "HNRNPA3P3 CNV",
    "HNRNPA3P3 RNA"
  ],
  "MARF1": [
    "MARF1 CNV",
    "MARF1 RNA",
    "MARF1 Proteo"
  ],
  "CD24P1": [
    "CD24P1 CNV",
    "CD24P1 RNA"
  ],
  "DTWD1": [
    "DTWD1 CNV",
    "DTWD1 RNA",
    "DTWD1 Proteo"
  ],
  "ADCY9": [
    "ADCY9 CNV",
    "ADCY9 RNA",
    "ADCY9 Proteo"
  ],
  "TAS2R30": [
    "TAS2R30 CNV",
    "TAS2R30 RNA"
  ],
  "TCHH": [
    "TCHH CNV",
    "TCHH RNA",
    "TCHH Proteo"
  ],
  "OR5H4P": [
    "OR5H4P CNV",
    "OR5H4P RNA"
  ],
  "ABCA4": [
    "ABCA4 CNV",
    "ABCA4 RNA"
  ],
  "H1-3": [
    "H1-3 CNV",
    "H1-3 RNA",
    "H1-3 Proteo"
  ],
  "GNG14": [
    "GNG14 CNV",
    "GNG14 RNA"
  ],
  "RBM27": [
    "RBM27 CNV",
    "RBM27 RNA",
    "RBM27 Proteo"
  ],
  "LGR5": [
    "LGR5 CNV",
    "LGR5 RNA"
  ],
  "KCNJ8": [
    "KCNJ8 CNV",
    "KCNJ8 RNA"
  ],
  "CERKL": [
    "CERKL CNV",
    "CERKL RNA"
  ],
  "CLIC1P1": [
    "CLIC1P1 CNV",
    "CLIC1P1 RNA"
  ],
  "B3GNT7": [
    "B3GNT7 CNV",
    "B3GNT7 RNA"
  ],
  "RNA5SP165": [
    "RNA5SP165 CNV",
    "RNA5SP165 RNA"
  ],
  "CERS1": [
    "CERS1 CNV",
    "CERS1 RNA",
    "CERS1 Proteo"
  ],
  "ASIC4": [
    "ASIC4 CNV",
    "ASIC4 RNA"
  ],
  "SEPTIN14P22": [
    "SEPTIN14P22 CNV",
    "SEPTIN14P22 RNA"
  ],
  "GPR101": [
    "GPR101 CNV",
    "GPR101 RNA"
  ],
  "LARGE1": [
    "LARGE1 CNV",
    "LARGE1 RNA",
    "LARGE1 Proteo"
  ],
  "HIRA": [
    "HIRA CNV",
    "HIRA RNA",
    "HIRA Proteo"
  ],
  "RPS14P7": [
    "RPS14P7 CNV",
    "RPS14P7 RNA"
  ],
  "UBE2V2P2": [
    "UBE2V2P2 CNV",
    "UBE2V2P2 RNA"
  ],
  "KIAA0586": [
    "KIAA0586 CNV",
    "KIAA0586 RNA",
    "KIAA0586 Proteo"
  ],
  "GTF2IRD1P1": [
    "GTF2IRD1P1 CNV",
    "GTF2IRD1P1 RNA"
  ],
  "FRG1HP": [
    "FRG1HP CNV",
    "FRG1HP RNA"
  ],
  "VIPAS39": [
    "VIPAS39 CNV",
    "VIPAS39 RNA",
    "VIPAS39 Proteo"
  ],
  "B3GNT8": [
    "B3GNT8 CNV",
    "B3GNT8 RNA"
  ],
  "TNFAIP8": [
    "TNFAIP8 CNV",
    "TNFAIP8 RNA",
    "TNFAIP8 Proteo"
  ],
  "GLULP6": [
    "GLULP6 CNV",
    "GLULP6 RNA"
  ],
  "TIMM13": [
    "TIMM13 CNV",
    "TIMM13 RNA",
    "TIMM13 Proteo"
  ],
  "UBE2V1P5": [
    "UBE2V1P5 CNV",
    "UBE2V1P5 RNA"
  ],
  "RPL12P6": [
    "RPL12P6 CNV",
    "RPL12P6 RNA"
  ],
  "PPM1L": [
    "PPM1L CNV",
    "PPM1L RNA",
    "PPM1L Proteo"
  ],
  "DHRS7C": [
    "DHRS7C CNV",
    "DHRS7C RNA"
  ],
  "MYCBP": [
    "MYCBP CNV",
    "MYCBP RNA",
    "MYCBP Proteo"
  ],
  "RPL12P32": [
    "RPL12P32 CNV",
    "RPL12P32 RNA"
  ],
  "RNASEH1P1": [
    "RNASEH1P1 CNV",
    "RNASEH1P1 RNA"
  ],
  "ACADL": [
    "ACADL CNV",
    "ACADL RNA",
    "ACADL Proteo"
  ],
  "C4BPA": [
    "C4BPA CNV",
    "C4BPA RNA",
    "C4BPA Proteo"
  ],
  "CBX1P1": [
    "CBX1P1 CNV",
    "CBX1P1 RNA"
  ],
  "KRT18P51": [
    "KRT18P51 CNV",
    "KRT18P51 RNA"
  ],
  "ETFA": [
    "ETFA CNV",
    "ETFA RNA",
    "ETFA Proteo"
  ],
  "HDDC2": [
    "HDDC2 CNV",
    "HDDC2 RNA",
    "HDDC2 Proteo"
  ],
  "ARNT2": [
    "ARNT2 CNV",
    "ARNT2 RNA",
    "ARNT2 Proteo"
  ],
  "COQ10A": [
    "COQ10A CNV",
    "COQ10A RNA",
    "COQ10A Proteo"
  ],
  "LILRB1": [
    "LILRB1 CNV",
    "LILRB1 RNA",
    "LILRB1 Proteo"
  ],
  "CFAP46": [
    "CFAP46 CNV",
    "CFAP46 RNA"
  ],
  "SMIM26": [
    "SMIM26 CNV",
    "SMIM26 RNA",
    "SMIM26 Proteo"
  ],
  "NBPF22P": [
    "NBPF22P CNV",
    "NBPF22P RNA"
  ],
  "DPH7": [
    "DPH7 CNV",
    "DPH7 RNA",
    "DPH7 Proteo"
  ],
  "PSMB3P2": [
    "PSMB3P2 CNV",
    "PSMB3P2 RNA"
  ],
  "RAP1BL": [
    "RAP1BL CNV",
    "RAP1BL RNA"
  ],
  "MAGEA10": [
    "MAGEA10 CNV",
    "MAGEA10 RNA",
    "MAGEA10 Proteo"
  ],
  "RNA5SP293": [
    "RNA5SP293 CNV",
    "RNA5SP293 RNA"
  ],
  "PNCK": [
    "PNCK CNV",
    "PNCK RNA"
  ],
  "RFX4": [
    "RFX4 CNV",
    "RFX4 RNA"
  ],
  "CALCB": [
    "CALCB CNV",
    "CALCB RNA"
  ],
  "TBL1YP1": [
    "TBL1YP1 CNV",
    "TBL1YP1 RNA"
  ],
  "GTF2IP20": [
    "GTF2IP20 CNV",
    "GTF2IP20 RNA"
  ],
  "SIGLEC24P": [
    "SIGLEC24P CNV",
    "SIGLEC24P RNA"
  ],
  "CCR2": [
    "CCR2 CNV",
    "CCR2 RNA"
  ],
  "TMEM170B": [
    "TMEM170B CNV",
    "TMEM170B RNA"
  ],
  "IGLV3-31": [
    "IGLV3-31 CNV",
    "IGLV3-31 RNA"
  ],
  "KRT20": [
    "KRT20 CNV",
    "KRT20 RNA",
    "KRT20 Proteo"
  ],
  "PDE7B": [
    "PDE7B CNV",
    "PDE7B RNA"
  ],
  "PPIAL4C": [
    "PPIAL4C CNV",
    "PPIAL4C RNA"
  ],
  "KIFC3": [
    "KIFC3 CNV",
    "KIFC3 RNA",
    "KIFC3 Proteo"
  ],
  "SMYD2": [
    "SMYD2 CNV",
    "SMYD2 RNA",
    "SMYD2 Proteo"
  ],
  "MTHFD2P2": [
    "MTHFD2P2 CNV",
    "MTHFD2P2 RNA"
  ],
  "GGCTP2": [
    "GGCTP2 CNV",
    "GGCTP2 RNA"
  ],
  "SPP1": [
    "SPP1 CNV",
    "SPP1 RNA",
    "SPP1 Proteo"
  ],
  "CIP2A": [
    "CIP2A CNV",
    "CIP2A RNA",
    "CIP2A Proteo"
  ],
  "GAS2L1P1": [
    "GAS2L1P1 CNV",
    "GAS2L1P1 RNA"
  ],
  "SLC26A9": [
    "SLC26A9 CNV",
    "SLC26A9 RNA"
  ],
  "TMIE": [
    "TMIE CNV",
    "TMIE RNA"
  ],
  "RAD51AP1": [
    "RAD51AP1 CNV",
    "RAD51AP1 RNA",
    "RAD51AP1 Proteo"
  ],
  "PSMG2": [
    "PSMG2 CNV",
    "PSMG2 RNA",
    "PSMG2 Proteo"
  ],
  "POP4": [
    "POP4 CNV",
    "POP4 RNA",
    "POP4 Proteo"
  ],
  "SERPINI2": [
    "SERPINI2 CNV",
    "SERPINI2 RNA"
  ],
  "BNIP3P1": [
    "BNIP3P1 CNV",
    "BNIP3P1 RNA"
  ],
  "CCDC43": [
    "CCDC43 CNV",
    "CCDC43 RNA",
    "CCDC43 Proteo"
  ],
  "HSD17B2": [
    "HSD17B2 CNV",
    "HSD17B2 RNA",
    "HSD17B2 Proteo"
  ],
  "ASH2L": [
    "ASH2L CNV",
    "ASH2L RNA",
    "ASH2L Proteo"
  ],
  "WNT10B": [
    "WNT10B CNV",
    "WNT10B RNA"
  ],
  "MTND3P8": [
    "MTND3P8 CNV",
    "MTND3P8 RNA"
  ],
  "KLHL21": [
    "KLHL21 CNV",
    "KLHL21 RNA",
    "KLHL21 Proteo"
  ],
  "LINGO2": [
    "LINGO2 CNV",
    "LINGO2 RNA",
    "LINGO2 Proteo"
  ],
  "MARK3P1": [
    "MARK3P1 CNV",
    "MARK3P1 RNA"
  ],
  "GPR26": [
    "GPR26 CNV",
    "GPR26 RNA"
  ],
  "TXNDC11": [
    "TXNDC11 CNV",
    "TXNDC11 RNA",
    "TXNDC11 Proteo"
  ],
  "OR7A19P": [
    "OR7A19P CNV",
    "OR7A19P RNA"
  ],
  "WNT16": [
    "WNT16 CNV",
    "WNT16 RNA"
  ],
  "TMPRSS11F": [
    "TMPRSS11F CNV",
    "TMPRSS11F RNA"
  ],
  "DEFB117": [
    "DEFB117 CNV",
    "DEFB117 RNA"
  ],
  "BEGAIN": [
    "BEGAIN CNV",
    "BEGAIN RNA"
  ],
  "SLC35F6": [
    "SLC35F6 CNV",
    "SLC35F6 RNA",
    "SLC35F6 Proteo"
  ],
  "MICAL2": [
    "MICAL2 CNV",
    "MICAL2 RNA",
    "MICAL2 Proteo"
  ],
  "SERPINE2": [
    "SERPINE2 CNV",
    "SERPINE2 RNA",
    "SERPINE2 Proteo"
  ],
  "SPCS2P3": [
    "SPCS2P3 CNV",
    "SPCS2P3 RNA"
  ],
  "SLC38A1": [
    "SLC38A1 CNV",
    "SLC38A1 RNA",
    "SLC38A1 Proteo"
  ],
  "NDUFS8": [
    "NDUFS8 CNV",
    "NDUFS8 RNA",
    "NDUFS8 Proteo"
  ],
  "SECISBP2": [
    "SECISBP2 CNV",
    "SECISBP2 RNA",
    "SECISBP2 Proteo"
  ],
  "PLTP": [
    "PLTP CNV",
    "PLTP RNA",
    "PLTP Proteo"
  ],
  "OPN1MW3": [
    "OPN1MW3 CNV",
    "OPN1MW3 RNA"
  ],
  "DERL1": [
    "DERL1 CNV",
    "DERL1 RNA",
    "DERL1 Proteo"
  ],
  "RFXAP": [
    "RFXAP CNV",
    "RFXAP RNA",
    "RFXAP Proteo"
  ],
  "WARS2P1": [
    "WARS2P1 CNV",
    "WARS2P1 RNA"
  ],
  "STARD5": [
    "STARD5 CNV",
    "STARD5 RNA",
    "STARD5 Proteo"
  ],
  "NPY6R": [
    "NPY6R CNV",
    "NPY6R RNA"
  ],
  "KLRD1": [
    "KLRD1 CNV",
    "KLRD1 RNA"
  ],
  "NUTM2HP": [
    "NUTM2HP CNV",
    "NUTM2HP RNA"
  ],
  "ZNF213": [
    "ZNF213 CNV",
    "ZNF213 RNA",
    "ZNF213 Proteo"
  ],
  "H2AC12": [
    "H2AC12 CNV",
    "H2AC12 RNA"
  ],
  "EMC7": [
    "EMC7 CNV",
    "EMC7 RNA",
    "EMC7 Proteo"
  ],
  "LRGUK": [
    "LRGUK CNV",
    "LRGUK RNA"
  ],
  "IL20RB": [
    "IL20RB CNV",
    "IL20RB RNA"
  ],
  "GNG5P1": [
    "GNG5P1 CNV",
    "GNG5P1 RNA"
  ],
  "ACAD8": [
    "ACAD8 CNV",
    "ACAD8 RNA",
    "ACAD8 Proteo"
  ],
  "DSTYK": [
    "DSTYK CNV",
    "DSTYK RNA",
    "DSTYK Proteo"
  ],
  "ATG16L2": [
    "ATG16L2 CNV",
    "ATG16L2 RNA",
    "ATG16L2 Proteo"
  ],
  "RPL23AP30": [
    "RPL23AP30 CNV",
    "RPL23AP30 RNA"
  ],
  "SNRPB2": [
    "SNRPB2 CNV",
    "SNRPB2 RNA",
    "SNRPB2 Proteo"
  ],
  "PPFIA4": [
    "PPFIA4 CNV",
    "PPFIA4 RNA"
  ],
  "CD163L1": [
    "CD163L1 CNV",
    "CD163L1 RNA",
    "CD163L1 Proteo"
  ],
  "CDY23P": [
    "CDY23P CNV",
    "CDY23P RNA"
  ],
  "PSMD5": [
    "PSMD5 CNV",
    "PSMD5 RNA",
    "PSMD5 Proteo"
  ],
  "DYNLL2": [
    "DYNLL2 CNV",
    "DYNLL2 RNA",
    "DYNLL2 Proteo"
  ],
  "ISCU": [
    "ISCU CNV",
    "ISCU RNA",
    "ISCU Proteo"
  ],
  "EEF1GP8": [
    "EEF1GP8 CNV",
    "EEF1GP8 RNA"
  ],
  "OR7E29P": [
    "OR7E29P CNV",
    "OR7E29P RNA"
  ],
  "SMIM33": [
    "SMIM33 CNV",
    "SMIM33 RNA"
  ],
  "LRRC58": [
    "LRRC58 CNV",
    "LRRC58 RNA",
    "LRRC58 Proteo"
  ],
  "TFAM": [
    "TFAM CNV",
    "TFAM RNA",
    "TFAM Proteo"
  ],
  "PFN4": [
    "PFN4 CNV",
    "PFN4 RNA"
  ],
  "OR8B8": [
    "OR8B8 CNV",
    "OR8B8 RNA"
  ],
  "FNBP1P1": [
    "FNBP1P1 CNV",
    "FNBP1P1 RNA"
  ],
  "DEFB132": [
    "DEFB132 CNV",
    "DEFB132 RNA"
  ],
  "DAPL1": [
    "DAPL1 CNV",
    "DAPL1 RNA",
    "DAPL1 Proteo"
  ],
  "OR7E66P": [
    "OR7E66P CNV",
    "OR7E66P RNA"
  ],
  "CNIH2": [
    "CNIH2 CNV",
    "CNIH2 RNA"
  ],
  "PCDHAC1": [
    "PCDHAC1 CNV",
    "PCDHAC1 RNA"
  ],
  "TACC3": [
    "TACC3 CNV",
    "TACC3 RNA",
    "TACC3 Proteo"
  ],
  "IMPDH1P5": [
    "IMPDH1P5 CNV",
    "IMPDH1P5 RNA"
  ],
  "ACE": [
    "ACE CNV",
    "ACE RNA",
    "ACE Proteo"
  ],
  "TEX9": [
    "TEX9 CNV",
    "TEX9 RNA"
  ],
  "ZDHHC8P1": [
    "ZDHHC8P1 CNV",
    "ZDHHC8P1 RNA"
  ],
  "RPS16P2": [
    "RPS16P2 CNV",
    "RPS16P2 RNA"
  ],
  "FCAMR": [
    "FCAMR CNV",
    "FCAMR RNA"
  ],
  "TCEA2": [
    "TCEA2 CNV",
    "TCEA2 RNA",
    "TCEA2 Proteo"
  ],
  "TSPYL2": [
    "TSPYL2 CNV",
    "TSPYL2 RNA",
    "TSPYL2 Proteo"
  ],
  "ANKRD26P2": [
    "ANKRD26P2 CNV",
    "ANKRD26P2 RNA"
  ],
  "GOLGA2P5": [
    "GOLGA2P5 CNV",
    "GOLGA2P5 RNA"
  ],
  "MTND6P22": [
    "MTND6P22 CNV",
    "MTND6P22 RNA"
  ],
  "PCTP": [
    "PCTP CNV",
    "PCTP RNA",
    "PCTP Proteo"
  ],
  "AGBL5": [
    "AGBL5 CNV",
    "AGBL5 RNA"
  ],
  "MRRFP1": [
    "MRRFP1 CNV",
    "MRRFP1 RNA"
  ],
  "TAF9P1": [
    "TAF9P1 CNV",
    "TAF9P1 RNA"
  ],
  "KCNC1": [
    "KCNC1 CNV",
    "KCNC1 RNA"
  ],
  "RPL7AP53": [
    "RPL7AP53 CNV",
    "RPL7AP53 RNA"
  ],
  "RFPL2": [
    "RFPL2 CNV",
    "RFPL2 RNA"
  ],
  "MAPK7": [
    "MAPK7 CNV",
    "MAPK7 RNA",
    "MAPK7 Proteo"
  ],
  "KRTAP13-3": [
    "KRTAP13-3 CNV",
    "KRTAP13-3 RNA"
  ],
  "GPX4": [
    "GPX4 CNV",
    "GPX4 RNA",
    "GPX4 Proteo"
  ],
  "SERHL": [
    "SERHL CNV",
    "SERHL RNA"
  ],
  "SNED1": [
    "SNED1 CNV",
    "SNED1 RNA",
    "SNED1 Proteo"
  ],
  "GET1P1": [
    "GET1P1 CNV",
    "GET1P1 RNA"
  ],
  "NOTCH2NLC": [
    "NOTCH2NLC CNV",
    "NOTCH2NLC RNA"
  ],
  "DALRD3": [
    "DALRD3 CNV",
    "DALRD3 RNA",
    "DALRD3 Proteo"
  ],
  "RHOT1": [
    "RHOT1 CNV",
    "RHOT1 RNA",
    "RHOT1 Proteo"
  ],
  "PRKRA": [
    "PRKRA CNV",
    "PRKRA RNA",
    "PRKRA Proteo"
  ],
  "SYT8": [
    "SYT8 CNV",
    "SYT8 RNA"
  ],
  "PIEZO1P1": [
    "PIEZO1P1 CNV",
    "PIEZO1P1 RNA"
  ],
  "SNRPA1": [
    "SNRPA1 CNV",
    "SNRPA1 RNA",
    "SNRPA1 Proteo"
  ],
  "DLX3": [
    "DLX3 CNV",
    "DLX3 RNA"
  ],
  "WIPI1": [
    "WIPI1 CNV",
    "WIPI1 RNA",
    "WIPI1 Proteo"
  ],
  "PRKAA1": [
    "PRKAA1 CNV",
    "PRKAA1 RNA",
    "PRKAA1 Proteo"
  ],
  "TESPA1": [
    "TESPA1 CNV",
    "TESPA1 RNA"
  ],
  "RPS14P8": [
    "RPS14P8 CNV",
    "RPS14P8 RNA"
  ],
  "CYP2A7": [
    "CYP2A7 CNV",
    "CYP2A7 RNA"
  ],
  "SMG8": [
    "SMG8 CNV",
    "SMG8 RNA",
    "SMG8 Proteo"
  ],
  "MIDN": [
    "MIDN CNV",
    "MIDN RNA",
    "MIDN Proteo"
  ],
  "MYOD1": [
    "MYOD1 CNV",
    "MYOD1 RNA"
  ],
  "DDX60L": [
    "DDX60L CNV",
    "DDX60L RNA",
    "DDX60L Proteo"
  ],
  "GZF1": [
    "GZF1 CNV",
    "GZF1 RNA",
    "GZF1 Proteo"
  ],
  "TRIM43": [
    "TRIM43 CNV",
    "TRIM43 RNA"
  ],
  "SMPD2": [
    "SMPD2 CNV",
    "SMPD2 RNA",
    "SMPD2 Proteo"
  ],
  "ZCCHC7": [
    "ZCCHC7 CNV",
    "ZCCHC7 RNA",
    "ZCCHC7 Proteo"
  ],
  "LAMA4": [
    "LAMA4 CNV",
    "LAMA4 RNA",
    "LAMA4 Proteo"
  ],
  "LGALS8": [
    "LGALS8 CNV",
    "LGALS8 RNA",
    "LGALS8 Proteo"
  ],
  "RPS29P4": [
    "RPS29P4 CNV",
    "RPS29P4 RNA"
  ],
  "SLC12A1": [
    "SLC12A1 CNV",
    "SLC12A1 RNA"
  ],
  "RPL27AP5": [
    "RPL27AP5 CNV",
    "RPL27AP5 RNA"
  ],
  "MTCO1P14": [
    "MTCO1P14 CNV",
    "MTCO1P14 RNA"
  ],
  "TMEM184A": [
    "TMEM184A CNV",
    "TMEM184A RNA"
  ],
  "USP48": [
    "USP48 CNV",
    "USP48 RNA",
    "USP48 Proteo"
  ],
  "SEMA4D": [
    "SEMA4D CNV",
    "SEMA4D RNA",
    "SEMA4D Proteo"
  ],
  "KLRG2": [
    "KLRG2 CNV",
    "KLRG2 RNA",
    "KLRG2 Proteo"
  ],
  "PTPN7": [
    "PTPN7 CNV",
    "PTPN7 RNA",
    "PTPN7 Proteo"
  ],
  "MTND5P27": [
    "MTND5P27 CNV",
    "MTND5P27 RNA"
  ],
  "PAQR6": [
    "PAQR6 CNV",
    "PAQR6 RNA"
  ],
  "PNPLA7": [
    "PNPLA7 CNV",
    "PNPLA7 RNA",
    "PNPLA7 Proteo"
  ],
  "IQCJ-SCHIP1": [
    "IQCJ-SCHIP1 Proteo"
  ],
  "FTH1P20": [
    "FTH1P20 CNV",
    "FTH1P20 RNA"
  ],
  "NBPF21P": [
    "NBPF21P CNV",
    "NBPF21P RNA"
  ],
  "UBXN10": [
    "UBXN10 CNV",
    "UBXN10 RNA",
    "UBXN10 Proteo"
  ],
  "CIT": [
    "CIT CNV",
    "CIT RNA",
    "CIT Proteo"
  ],
  "WDR26": [
    "WDR26 CNV",
    "WDR26 RNA",
    "WDR26 Proteo"
  ],
  "OR2L1P": [
    "OR2L1P CNV",
    "OR2L1P RNA"
  ],
  "NUBPL": [
    "NUBPL CNV",
    "NUBPL RNA",
    "NUBPL Proteo"
  ],
  "DYNC2I1": [
    "DYNC2I1 CNV",
    "DYNC2I1 RNA",
    "DYNC2I1 Proteo"
  ],
  "OR7E87P": [
    "OR7E87P CNV",
    "OR7E87P RNA"
  ],
  "AKTIP": [
    "AKTIP CNV",
    "AKTIP RNA",
    "AKTIP Proteo"
  ],
  "ZDHHC2": [
    "ZDHHC2 CNV",
    "ZDHHC2 RNA",
    "ZDHHC2 Proteo"
  ],
  "LSM3": [
    "LSM3 CNV",
    "LSM3 RNA",
    "LSM3 Proteo"
  ],
  "TSPAN3": [
    "TSPAN3 CNV",
    "TSPAN3 RNA",
    "TSPAN3 Proteo"
  ],
  "PIP4K2A": [
    "PIP4K2A CNV",
    "PIP4K2A RNA",
    "PIP4K2A Proteo"
  ],
  "DEFB107B": [
    "DEFB107B CNV",
    "DEFB107B RNA"
  ],
  "TBC1D29P": [
    "TBC1D29P CNV",
    "TBC1D29P RNA"
  ],
  "SPTLC1P3": [
    "SPTLC1P3 CNV",
    "SPTLC1P3 RNA"
  ],
  "FAM9CP1": [
    "FAM9CP1 CNV",
    "FAM9CP1 RNA"
  ],
  "RPS3AP14": [
    "RPS3AP14 CNV",
    "RPS3AP14 RNA"
  ],
  "ANKRD1": [
    "ANKRD1 CNV",
    "ANKRD1 RNA",
    "ANKRD1 Proteo"
  ],
  "CAPZA1P5": [
    "CAPZA1P5 CNV",
    "CAPZA1P5 RNA"
  ],
  "RPS13P2": [
    "RPS13P2 CNV",
    "RPS13P2 RNA"
  ],
  "OR7E7P": [
    "OR7E7P CNV",
    "OR7E7P RNA"
  ],
  "RPS2P41": [
    "RPS2P41 CNV",
    "RPS2P41 RNA"
  ],
  "ICOS": [
    "ICOS CNV",
    "ICOS RNA",
    "ICOS Proteo"
  ],
  "FAM156B": [
    "FAM156B CNV",
    "FAM156B RNA"
  ],
  "SAP30": [
    "SAP30 CNV",
    "SAP30 RNA",
    "SAP30 Proteo"
  ],
  "ST3GAL3": [
    "ST3GAL3 CNV",
    "ST3GAL3 RNA",
    "ST3GAL3 Proteo"
  ],
  "NMNAT1": [
    "NMNAT1 CNV",
    "NMNAT1 RNA",
    "NMNAT1 Proteo"
  ],
  "FAM91A2P": [
    "FAM91A2P CNV",
    "FAM91A2P RNA"
  ],
  "GCSHP5": [
    "GCSHP5 CNV",
    "GCSHP5 RNA"
  ],
  "OR5M9": [
    "OR5M9 CNV",
    "OR5M9 RNA"
  ],
  "MMS19": [
    "MMS19 CNV",
    "MMS19 RNA",
    "MMS19 Proteo"
  ],
  "LHFPL3": [
    "LHFPL3 CNV",
    "LHFPL3 RNA"
  ],
  "FYB2": [
    "FYB2 CNV",
    "FYB2 RNA"
  ],
  "CAMK1G": [
    "CAMK1G CNV",
    "CAMK1G RNA"
  ],
  "TTC37": [
    "TTC37 CNV",
    "TTC37 RNA",
    "TTC37 Proteo"
  ],
  "RNA5SP39": [
    "RNA5SP39 CNV",
    "RNA5SP39 RNA"
  ],
  "FAM197Y3": [
    "FAM197Y3 CNV",
    "FAM197Y3 RNA"
  ],
  "SLC22A13": [
    "SLC22A13 CNV",
    "SLC22A13 RNA"
  ],
  "MTCO1P23": [
    "MTCO1P23 CNV",
    "MTCO1P23 RNA"
  ],
  "PLEKHA7": [
    "PLEKHA7 CNV",
    "PLEKHA7 RNA",
    "PLEKHA7 Proteo"
  ],
  "MAK": [
    "MAK CNV",
    "MAK RNA"
  ],
  "TKTL1": [
    "TKTL1 CNV",
    "TKTL1 RNA",
    "TKTL1 Proteo"
  ],
  "C18orf21": [
    "C18orf21 CNV",
    "C18orf21 RNA",
    "C18orf21 Proteo"
  ],
  "CCDC106": [
    "CCDC106 CNV",
    "CCDC106 RNA",
    "CCDC106 Proteo"
  ],
  "C6orf47": [
    "C6orf47 CNV",
    "C6orf47 RNA",
    "C6orf47 Proteo"
  ],
  "SMARCD1": [
    "SMARCD1 CNV",
    "SMARCD1 RNA",
    "SMARCD1 Proteo"
  ],
  "UACA": [
    "UACA CNV",
    "UACA RNA",
    "UACA Proteo"
  ],
  "TRPC5OS": [
    "TRPC5OS CNV",
    "TRPC5OS RNA"
  ],
  "FAM193A": [
    "FAM193A CNV",
    "FAM193A RNA",
    "FAM193A Proteo"
  ],
  "C9orf50": [
    "C9orf50 CNV",
    "C9orf50 RNA"
  ],
  "TFR2": [
    "TFR2 CNV",
    "TFR2 RNA"
  ],
  "CDC5L": [
    "CDC5L CNV",
    "CDC5L RNA",
    "CDC5L Proteo"
  ],
  "USP1": [
    "USP1 CNV",
    "USP1 RNA",
    "USP1 Proteo"
  ],
  "RFX6": [
    "RFX6 CNV",
    "RFX6 RNA"
  ],
  "HLA-C": [
    "HLA-C CNV",
    "HLA-C RNA",
    "HLA-C Proteo"
  ],
  "PAFAH1B3": [
    "PAFAH1B3 CNV",
    "PAFAH1B3 RNA",
    "PAFAH1B3 Proteo"
  ],
  "PGPEP1L": [
    "PGPEP1L CNV",
    "PGPEP1L RNA"
  ],
  "MAGEB18": [
    "MAGEB18 CNV",
    "MAGEB18 RNA"
  ],
  "BTAF1": [
    "BTAF1 CNV",
    "BTAF1 RNA",
    "BTAF1 Proteo"
  ],
  "ZMYND19P1": [
    "ZMYND19P1 CNV",
    "ZMYND19P1 RNA"
  ],
  "PATZ1": [
    "PATZ1 CNV",
    "PATZ1 RNA",
    "PATZ1 Proteo"
  ],
  "SNX29P1": [
    "SNX29P1 CNV",
    "SNX29P1 RNA"
  ],
  "CDC123": [
    "CDC123 CNV",
    "CDC123 RNA",
    "CDC123 Proteo"
  ],
  "KYNUP3": [
    "KYNUP3 CNV",
    "KYNUP3 RNA"
  ],
  "FCF1P5": [
    "FCF1P5 CNV",
    "FCF1P5 RNA"
  ],
  "DEFB119": [
    "DEFB119 CNV",
    "DEFB119 RNA"
  ],
  "DEFB130A": [
    "DEFB130A CNV",
    "DEFB130A RNA"
  ],
  "NOTCH2NLR": [
    "NOTCH2NLR CNV",
    "NOTCH2NLR RNA"
  ],
  "ST3GAL4": [
    "ST3GAL4 CNV",
    "ST3GAL4 RNA",
    "ST3GAL4 Proteo"
  ],
  "OR4C16": [
    "OR4C16 CNV",
    "OR4C16 RNA"
  ],
  "IGHV7-40": [
    "IGHV7-40 CNV",
    "IGHV7-40 RNA"
  ],
  "NAP1L1P3": [
    "NAP1L1P3 CNV",
    "NAP1L1P3 RNA"
  ],
  "CCDC103": [
    "CCDC103 CNV",
    "CCDC103 RNA"
  ],
  "RPL5": [
    "RPL5 CNV",
    "RPL5 RNA",
    "RPL5 Proteo"
  ],
  "GOLGA7B": [
    "GOLGA7B CNV",
    "GOLGA7B RNA",
    "GOLGA7B Proteo"
  ],
  "SFPQP1": [
    "SFPQP1 CNV",
    "SFPQP1 RNA"
  ],
  "RNA5SP231": [
    "RNA5SP231 CNV",
    "RNA5SP231 RNA"
  ],
  "GPN1": [
    "GPN1 CNV",
    "GPN1 RNA",
    "GPN1 Proteo"
  ],
  "ENO4": [
    "ENO4 CNV",
    "ENO4 RNA"
  ],
  "TTLL5": [
    "TTLL5 CNV",
    "TTLL5 RNA",
    "TTLL5 Proteo"
  ],
  "IGHV7-34-1": [
    "IGHV7-34-1 CNV",
    "IGHV7-34-1 RNA"
  ],
  "GAPDHP45": [
    "GAPDHP45 CNV",
    "GAPDHP45 RNA"
  ],
  "UQCRQ": [
    "UQCRQ CNV",
    "UQCRQ RNA",
    "UQCRQ Proteo"
  ],
  "TEF": [
    "TEF CNV",
    "TEF RNA",
    "TEF Proteo"
  ],
  "CSTF3": [
    "CSTF3 CNV",
    "CSTF3 RNA",
    "CSTF3 Proteo"
  ],
  "FOLH1": [
    "FOLH1 CNV",
    "FOLH1 RNA",
    "FOLH1 Proteo"
  ],
  "POTEG": [
    "POTEG CNV",
    "POTEG RNA"
  ],
  "COPS5P1": [
    "COPS5P1 CNV",
    "COPS5P1 RNA"
  ],
  "SAT2": [
    "SAT2 CNV",
    "SAT2 RNA",
    "SAT2 Proteo"
  ],
  "IL23A": [
    "IL23A CNV",
    "IL23A RNA"
  ],
  "LINC00888": [
    "LINC00888 CNV",
    "LINC00888 RNA"
  ],
  "GNG10P1": [
    "GNG10P1 CNV",
    "GNG10P1 RNA"
  ],
  "ARL2BPP1": [
    "ARL2BPP1 CNV",
    "ARL2BPP1 RNA"
  ],
  "TREML1": [
    "TREML1 CNV",
    "TREML1 RNA"
  ],
  "POU6F1": [
    "POU6F1 CNV",
    "POU6F1 RNA"
  ],
  "RPL21P38": [
    "RPL21P38 CNV",
    "RPL21P38 RNA"
  ],
  "MCM3AP": [
    "MCM3AP CNV",
    "MCM3AP RNA",
    "MCM3AP Proteo"
  ],
  "USB1": [
    "USB1 CNV",
    "USB1 RNA",
    "USB1 Proteo"
  ],
  "ZNF22": [
    "ZNF22 CNV",
    "ZNF22 RNA",
    "ZNF22 Proteo"
  ],
  "GTDC1": [
    "GTDC1 CNV",
    "GTDC1 RNA",
    "GTDC1 Proteo"
  ],
  "ZNF470": [
    "ZNF470 CNV",
    "ZNF470 RNA"
  ],
  "LDHAP7": [
    "LDHAP7 CNV",
    "LDHAP7 RNA"
  ],
  "COX7C": [
    "COX7C CNV",
    "COX7C RNA",
    "COX7C Proteo"
  ],
  "CWC25": [
    "CWC25 CNV",
    "CWC25 RNA",
    "CWC25 Proteo"
  ],
  "CD7": [
    "CD7 CNV",
    "CD7 RNA",
    "CD7 Proteo"
  ],
  "HLA-DMB": [
    "HLA-DMB CNV",
    "HLA-DMB RNA",
    "HLA-DMB Proteo"
  ],
  "OR13D1": [
    "OR13D1 CNV",
    "OR13D1 RNA"
  ],
  "SPSB2": [
    "SPSB2 CNV",
    "SPSB2 RNA"
  ],
  "GCNT7": [
    "GCNT7 CNV",
    "GCNT7 RNA"
  ],
  "ZNF597": [
    "ZNF597 CNV",
    "ZNF597 RNA",
    "ZNF597 Proteo"
  ],
  "MBLAC1": [
    "MBLAC1 CNV",
    "MBLAC1 RNA",
    "MBLAC1 Proteo"
  ],
  "PCDHB5": [
    "PCDHB5 CNV",
    "PCDHB5 RNA"
  ],
  "RPL23AP37": [
    "RPL23AP37 CNV",
    "RPL23AP37 RNA"
  ],
  "RPL6P25": [
    "RPL6P25 CNV",
    "RPL6P25 RNA"
  ],
  "CST2P1": [
    "CST2P1 CNV",
    "CST2P1 RNA"
  ],
  "RPL37P24": [
    "RPL37P24 CNV",
    "RPL37P24 RNA"
  ],
  "RPL23AP8": [
    "RPL23AP8 CNV",
    "RPL23AP8 RNA"
  ],
  "TNK2": [
    "TNK2 CNV",
    "TNK2 RNA",
    "TNK2 Proteo"
  ],
  "AP3M2": [
    "AP3M2 CNV",
    "AP3M2 RNA",
    "AP3M2 Proteo"
  ],
  "TUBB3": [
    "TUBB3 CNV",
    "TUBB3 RNA",
    "TUBB3 Proteo"
  ],
  "KIAA2026": [
    "KIAA2026 CNV",
    "KIAA2026 RNA",
    "KIAA2026 Proteo"
  ],
  "RNA5SP159": [
    "RNA5SP159 CNV",
    "RNA5SP159 RNA"
  ],
  "BAALC": [
    "BAALC CNV",
    "BAALC RNA",
    "BAALC Proteo"
  ],
  "TTLL11": [
    "TTLL11 CNV",
    "TTLL11 RNA"
  ],
  "MAP2K4": [
    "MAP2K4 CNV",
    "MAP2K4 RNA",
    "MAP2K4 Proteo"
  ],
  "CHST5": [
    "CHST5 CNV",
    "CHST5 RNA"
  ],
  "CCDC144A": [
    "CCDC144A CNV",
    "CCDC144A RNA"
  ],
  "IGHVIII-5-1": [
    "IGHVIII-5-1 CNV",
    "IGHVIII-5-1 RNA"
  ],
  "PSMD14P1": [
    "PSMD14P1 CNV",
    "PSMD14P1 RNA"
  ],
  "ATP6V1G3": [
    "ATP6V1G3 CNV",
    "ATP6V1G3 RNA"
  ],
  "GAPDHP21": [
    "GAPDHP21 CNV",
    "GAPDHP21 RNA"
  ],
  "PDHA1P1": [
    "PDHA1P1 CNV",
    "PDHA1P1 RNA"
  ],
  "PPIAP42": [
    "PPIAP42 CNV",
    "PPIAP42 RNA"
  ],
  "TMEM266": [
    "TMEM266 CNV",
    "TMEM266 RNA"
  ],
  "DEFB123": [
    "DEFB123 CNV",
    "DEFB123 RNA"
  ],
  "CNN2P3": [
    "CNN2P3 CNV",
    "CNN2P3 RNA"
  ],
  "HHAT": [
    "HHAT CNV",
    "HHAT RNA",
    "HHAT Proteo"
  ],
  "MBD3L1": [
    "MBD3L1 CNV",
    "MBD3L1 RNA"
  ],
  "STK32C": [
    "STK32C CNV",
    "STK32C RNA",
    "STK32C Proteo"
  ],
  "HINT3": [
    "HINT3 CNV",
    "HINT3 RNA",
    "HINT3 Proteo"
  ],
  "ADSS2": [
    "ADSS2 CNV",
    "ADSS2 RNA",
    "ADSS2 Proteo"
  ],
  "RPS6P21": [
    "RPS6P21 CNV",
    "RPS6P21 RNA"
  ],
  "USP50": [
    "USP50 CNV",
    "USP50 RNA"
  ],
  "ATG13": [
    "ATG13 CNV",
    "ATG13 RNA",
    "ATG13 Proteo"
  ],
  "UGT2B11": [
    "UGT2B11 CNV",
    "UGT2B11 RNA"
  ],
  "REV3L": [
    "REV3L CNV",
    "REV3L RNA",
    "REV3L Proteo"
  ],
  "CPEB4": [
    "CPEB4 CNV",
    "CPEB4 RNA",
    "CPEB4 Proteo"
  ],
  "RAB3C": [
    "RAB3C CNV",
    "RAB3C RNA",
    "RAB3C Proteo"
  ],
  "JPH3": [
    "JPH3 CNV",
    "JPH3 RNA"
  ],
  "RPL7AP43": [
    "RPL7AP43 CNV",
    "RPL7AP43 RNA"
  ],
  "IGLVVI-22-1": [
    "IGLVVI-22-1 CNV",
    "IGLVVI-22-1 RNA"
  ],
  "RPL9P30": [
    "RPL9P30 CNV",
    "RPL9P30 RNA"
  ],
  "FABP3": [
    "FABP3 CNV",
    "FABP3 RNA",
    "FABP3 Proteo"
  ],
  "MS4A10": [
    "MS4A10 CNV",
    "MS4A10 RNA"
  ],
  "INVS": [
    "INVS CNV",
    "INVS RNA",
    "INVS Proteo"
  ],
  "CRYBB3": [
    "CRYBB3 CNV",
    "CRYBB3 RNA"
  ],
  "FAM177A1P1": [
    "FAM177A1P1 CNV",
    "FAM177A1P1 RNA"
  ],
  "RNA5SP142": [
    "RNA5SP142 CNV",
    "RNA5SP142 RNA"
  ],
  "VSTM1": [
    "VSTM1 CNV",
    "VSTM1 RNA"
  ],
  "KCNN4": [
    "KCNN4 CNV",
    "KCNN4 RNA",
    "KCNN4 Proteo"
  ],
  "BTF3L4P3": [
    "BTF3L4P3 CNV",
    "BTF3L4P3 RNA"
  ],
  "SNRPA": [
    "SNRPA CNV",
    "SNRPA RNA",
    "SNRPA Proteo"
  ],
  "TXLNG": [
    "TXLNG CNV",
    "TXLNG RNA",
    "TXLNG Proteo"
  ],
  "YIF1B": [
    "YIF1B CNV",
    "YIF1B RNA",
    "YIF1B Proteo"
  ],
  "PTH": [
    "PTH CNV",
    "PTH RNA"
  ],
  "CAB39L": [
    "CAB39L CNV",
    "CAB39L RNA",
    "CAB39L Proteo"
  ],
  "NEPRO": [
    "NEPRO CNV",
    "NEPRO RNA",
    "NEPRO Proteo"
  ],
  "DXO": [
    "DXO CNV",
    "DXO RNA",
    "DXO Proteo"
  ],
  "CLDN7P1": [
    "CLDN7P1 CNV",
    "CLDN7P1 RNA"
  ],
  "DCLRE1A": [
    "DCLRE1A CNV",
    "DCLRE1A RNA"
  ],
  "HMGB3": [
    "HMGB3 CNV",
    "HMGB3 RNA",
    "HMGB3 Proteo"
  ],
  "PFN2": [
    "PFN2 CNV",
    "PFN2 RNA",
    "PFN2 Proteo"
  ],
  "TRIM51BP": [
    "TRIM51BP CNV",
    "TRIM51BP RNA"
  ],
  "EFCC1": [
    "EFCC1 CNV",
    "EFCC1 RNA"
  ],
  "OR3A3": [
    "OR3A3 CNV",
    "OR3A3 RNA"
  ],
  "SLCO1B3": [
    "SLCO1B3 CNV",
    "SLCO1B3 RNA"
  ],
  "ZNF512B": [
    "ZNF512B CNV",
    "ZNF512B RNA",
    "ZNF512B Proteo"
  ],
  "RNA5SP418": [
    "RNA5SP418 CNV",
    "RNA5SP418 RNA"
  ],
  "KDF1": [
    "KDF1 CNV",
    "KDF1 RNA",
    "KDF1 Proteo"
  ],
  "TMSB15A": [
    "TMSB15A CNV",
    "TMSB15A RNA",
    "TMSB15A Proteo"
  ],
  "BNIP5": [
    "BNIP5 CNV",
    "BNIP5 RNA",
    "BNIP5 Proteo"
  ],
  "SHISA6": [
    "SHISA6 CNV",
    "SHISA6 RNA"
  ],
  "CYP4F23P": [
    "CYP4F23P CNV",
    "CYP4F23P RNA"
  ],
  "MTND2P41": [
    "MTND2P41 CNV",
    "MTND2P41 RNA"
  ],
  "EIF4E2P1": [
    "EIF4E2P1 CNV",
    "EIF4E2P1 RNA"
  ],
  "DDX11": [
    "DDX11 CNV",
    "DDX11 RNA",
    "DDX11 Proteo"
  ],
  "DNALI1": [
    "DNALI1 CNV",
    "DNALI1 RNA",
    "DNALI1 Proteo"
  ],
  "ANKRD11P2": [
    "ANKRD11P2 CNV",
    "ANKRD11P2 RNA"
  ],
  "CCDC169": [
    "CCDC169 CNV",
    "CCDC169 RNA"
  ],
  "EEF1A1P2": [
    "EEF1A1P2 CNV",
    "EEF1A1P2 RNA"
  ],
  "FAM189A1": [
    "FAM189A1 CNV",
    "FAM189A1 RNA"
  ],
  "HNRNPA1P4": [
    "HNRNPA1P4 CNV",
    "HNRNPA1P4 RNA"
  ],
  "GPR18": [
    "GPR18 CNV",
    "GPR18 RNA"
  ],
  "CCDC122": [
    "CCDC122 CNV",
    "CCDC122 RNA"
  ],
  "STX7": [
    "STX7 CNV",
    "STX7 RNA",
    "STX7 Proteo"
  ],
  "RBM6": [
    "RBM6 CNV",
    "RBM6 RNA",
    "RBM6 Proteo"
  ],
  "IGLVIV-64": [
    "IGLVIV-64 CNV",
    "IGLVIV-64 RNA"
  ],
  "RPS10P27": [
    "RPS10P27 CNV",
    "RPS10P27 RNA"
  ],
  "MCMDC2": [
    "MCMDC2 CNV",
    "MCMDC2 RNA"
  ],
  "FTLP13": [
    "FTLP13 CNV",
    "FTLP13 RNA"
  ],
  "GABARAPL2": [
    "GABARAPL2 CNV",
    "GABARAPL2 RNA",
    "GABARAPL2 Proteo"
  ],
  "MTCO2P15": [
    "MTCO2P15 CNV",
    "MTCO2P15 RNA"
  ],
  "ACTG1P10": [
    "ACTG1P10 CNV",
    "ACTG1P10 RNA"
  ],
  "ZNF639": [
    "ZNF639 CNV",
    "ZNF639 RNA",
    "ZNF639 Proteo"
  ],
  "DENND2B": [
    "DENND2B CNV",
    "DENND2B RNA",
    "DENND2B Proteo"
  ],
  "TSSK2": [
    "TSSK2 CNV",
    "TSSK2 RNA"
  ],
  "PRKAG3": [
    "PRKAG3 CNV",
    "PRKAG3 RNA"
  ],
  "RPS5P3": [
    "RPS5P3 CNV",
    "RPS5P3 RNA"
  ],
  "OR2A1": [
    "OR2A1 CNV",
    "OR2A1 RNA"
  ],
  "Mast_Cells": [
    "Mast_Cells Cell_type"
  ],
  "RNF144A": [
    "RNF144A CNV",
    "RNF144A RNA"
  ],
  "RANP9": [
    "RANP9 CNV",
    "RANP9 RNA"
  ],
  "OR7E125P": [
    "OR7E125P CNV",
    "OR7E125P RNA"
  ],
  "HELLS": [
    "HELLS CNV",
    "HELLS RNA",
    "HELLS Proteo"
  ],
  "MED28P2": [
    "MED28P2 CNV",
    "MED28P2 RNA"
  ],
  "TRPM8": [
    "TRPM8 CNV",
    "TRPM8 RNA"
  ],
  "CEP170": [
    "CEP170 CNV",
    "CEP170 RNA",
    "CEP170 Proteo"
  ],
  "VKORC1L1": [
    "VKORC1L1 CNV",
    "VKORC1L1 RNA",
    "VKORC1L1 Proteo"
  ],
  "ZKSCAN5": [
    "ZKSCAN5 CNV",
    "ZKSCAN5 RNA"
  ],
  "FAM197Y4": [
    "FAM197Y4 CNV",
    "FAM197Y4 RNA"
  ],
  "CTXN2": [
    "CTXN2 CNV",
    "CTXN2 RNA"
  ],
  "ZNF35": [
    "ZNF35 CNV",
    "ZNF35 RNA"
  ],
  "MS4A5": [
    "MS4A5 CNV",
    "MS4A5 RNA"
  ],
  "DDX43P3": [
    "DDX43P3 CNV",
    "DDX43P3 RNA"
  ],
  "SDC1": [
    "SDC1 CNV",
    "SDC1 RNA",
    "SDC1 Proteo"
  ],
  "MSH6": [
    "MSH6 CNV",
    "MSH6 RNA",
    "MSH6 Proteo"
  ],
  "RSPH4A": [
    "RSPH4A CNV",
    "RSPH4A RNA"
  ],
  "OR52K2": [
    "OR52K2 CNV",
    "OR52K2 RNA"
  ],
  "BTF3P7": [
    "BTF3P7 CNV",
    "BTF3P7 RNA"
  ],
  "NARS2": [
    "NARS2 CNV",
    "NARS2 RNA",
    "NARS2 Proteo"
  ],
  "ANK3": [
    "ANK3 CNV",
    "ANK3 RNA",
    "ANK3 Proteo"
  ],
  "KLHL41": [
    "KLHL41 CNV",
    "KLHL41 RNA",
    "KLHL41 Proteo"
  ],
  "C1QL1P1": [
    "C1QL1P1 CNV",
    "C1QL1P1 RNA"
  ],
  "Adipose": [
    "Adipose Cell_type"
  ],
  "SLC14A1": [
    "SLC14A1 CNV",
    "SLC14A1 RNA",
    "SLC14A1 Proteo"
  ],
  "RPL10P6": [
    "RPL10P6 CNV",
    "RPL10P6 RNA"
  ],
  "MSL3P1": [
    "MSL3P1 CNV",
    "MSL3P1 RNA"
  ],
  "WDTC1": [
    "WDTC1 CNV",
    "WDTC1 RNA",
    "WDTC1 Proteo"
  ],
  "HNRNPA1P8": [
    "HNRNPA1P8 CNV",
    "HNRNPA1P8 RNA"
  ],
  "LARP1BP2": [
    "LARP1BP2 CNV",
    "LARP1BP2 RNA"
  ],
  "IGHV1-46": [
    "IGHV1-46 Proteo"
  ],
  "ADM2": [
    "ADM2 CNV",
    "ADM2 RNA"
  ],
  "TRIM60P14": [
    "TRIM60P14 CNV",
    "TRIM60P14 RNA"
  ],
  "PRR36": [
    "PRR36 CNV",
    "PRR36 RNA"
  ],
  "DEGS2": [
    "DEGS2 CNV",
    "DEGS2 RNA",
    "DEGS2 Proteo"
  ],
  "ZNF526": [
    "ZNF526 CNV",
    "ZNF526 RNA",
    "ZNF526 Proteo"
  ],
  "PEPD": [
    "PEPD CNV",
    "PEPD RNA",
    "PEPD Proteo"
  ],
  "ERF": [
    "ERF CNV",
    "ERF RNA",
    "ERF Proteo"
  ],
  "CYTH2": [
    "CYTH2 CNV",
    "CYTH2 RNA",
    "CYTH2 Proteo"
  ],
  "IGHVIII-22-2": [
    "IGHVIII-22-2 CNV",
    "IGHVIII-22-2 RNA"
  ],
  "LRRC37A4P": [
    "LRRC37A4P CNV",
    "LRRC37A4P RNA"
  ],
  "ATF1P1": [
    "ATF1P1 CNV",
    "ATF1P1 RNA"
  ],
  "LPCAT4": [
    "LPCAT4 CNV",
    "LPCAT4 RNA",
    "LPCAT4 Proteo"
  ],
  "VIT": [
    "VIT CNV",
    "VIT RNA",
    "VIT Proteo"
  ],
  "RPL35AP15": [
    "RPL35AP15 CNV",
    "RPL35AP15 RNA"
  ],
  "EEF1A1P13": [
    "EEF1A1P13 CNV",
    "EEF1A1P13 RNA"
  ],
  "FRMPD3": [
    "FRMPD3 CNV",
    "FRMPD3 RNA"
  ],
  "OR10G6": [
    "OR10G6 CNV",
    "OR10G6 RNA"
  ],
  "SGSH": [
    "SGSH CNV",
    "SGSH RNA",
    "SGSH Proteo"
  ],
  "ZCCHC14": [
    "ZCCHC14 CNV",
    "ZCCHC14 RNA",
    "ZCCHC14 Proteo"
  ],
  "FAM110B": [
    "FAM110B CNV",
    "FAM110B RNA",
    "FAM110B Proteo"
  ],
  "MTCO1P2": [
    "MTCO1P2 CNV",
    "MTCO1P2 RNA"
  ],
  "PAFAH1B2P1": [
    "PAFAH1B2P1 CNV",
    "PAFAH1B2P1 RNA"
  ],
  "LRRTM3": [
    "LRRTM3 CNV",
    "LRRTM3 RNA"
  ],
  "DOCK3": [
    "DOCK3 CNV",
    "DOCK3 RNA"
  ],
  "OR10G1P": [
    "OR10G1P CNV",
    "OR10G1P RNA"
  ],
  "BEND2": [
    "BEND2 CNV",
    "BEND2 RNA"
  ],
  "PCBP3": [
    "PCBP3 CNV",
    "PCBP3 RNA",
    "PCBP3 Proteo"
  ],
  "ALG8": [
    "ALG8 CNV",
    "ALG8 RNA",
    "ALG8 Proteo"
  ],
  "MTCYBP16": [
    "MTCYBP16 CNV",
    "MTCYBP16 RNA"
  ],
  "PALD1": [
    "PALD1 CNV",
    "PALD1 RNA",
    "PALD1 Proteo"
  ],
  "OR10AD1": [
    "OR10AD1 CNV",
    "OR10AD1 RNA"
  ],
  "RPL32P33": [
    "RPL32P33 CNV",
    "RPL32P33 RNA"
  ],
  "BPY2C": [
    "BPY2C CNV",
    "BPY2C RNA"
  ],
  "HTATIP2": [
    "HTATIP2 CNV",
    "HTATIP2 RNA",
    "HTATIP2 Proteo"
  ],
  "CYP2A7P2": [
    "CYP2A7P2 CNV",
    "CYP2A7P2 RNA"
  ],
  "SLC38A10": [
    "SLC38A10 CNV",
    "SLC38A10 RNA",
    "SLC38A10 Proteo"
  ],
  "RPL7P10": [
    "RPL7P10 CNV",
    "RPL7P10 RNA"
  ],
  "C1QTNF1": [
    "C1QTNF1 CNV",
    "C1QTNF1 RNA",
    "C1QTNF1 Proteo"
  ],
  "EPB41L5": [
    "EPB41L5 CNV",
    "EPB41L5 RNA",
    "EPB41L5 Proteo"
  ],
  "COL6A4P1": [
    "COL6A4P1 CNV",
    "COL6A4P1 RNA"
  ],
  "SNX30": [
    "SNX30 CNV",
    "SNX30 RNA",
    "SNX30 Proteo"
  ],
  "DEF8": [
    "DEF8 CNV",
    "DEF8 RNA",
    "DEF8 Proteo"
  ],
  "QSER1": [
    "QSER1 CNV",
    "QSER1 RNA",
    "QSER1 Proteo"
  ],
  "MRPS15P1": [
    "MRPS15P1 CNV",
    "MRPS15P1 RNA"
  ],
  "NANOGP2": [
    "NANOGP2 CNV",
    "NANOGP2 RNA"
  ],
  "TLX1": [
    "TLX1 CNV",
    "TLX1 RNA"
  ],
  "RIPK3": [
    "RIPK3 CNV",
    "RIPK3 RNA",
    "RIPK3 Proteo"
  ],
  "USP17L26": [
    "USP17L26 CNV",
    "USP17L26 RNA"
  ],
  "FABP6": [
    "FABP6 CNV",
    "FABP6 RNA"
  ],
  "ZNF709": [
    "ZNF709 CNV",
    "ZNF709 RNA",
    "ZNF709 Proteo"
  ],
  "USP33": [
    "USP33 CNV",
    "USP33 RNA",
    "USP33 Proteo"
  ],
  "MTND6P12": [
    "MTND6P12 CNV",
    "MTND6P12 RNA"
  ],
  "RBBP4P6": [
    "RBBP4P6 CNV",
    "RBBP4P6 RNA"
  ],
  "RPL10P11": [
    "RPL10P11 CNV",
    "RPL10P11 RNA"
  ],
  "RNA5SP388": [
    "RNA5SP388 CNV",
    "RNA5SP388 RNA"
  ],
  "SCUBE2": [
    "SCUBE2 CNV",
    "SCUBE2 RNA",
    "SCUBE2 Proteo"
  ],
  "CCNT2": [
    "CCNT2 CNV",
    "CCNT2 RNA",
    "CCNT2 Proteo"
  ],
  "OR6C72P": [
    "OR6C72P CNV",
    "OR6C72P RNA"
  ],
  "NFATC2IP": [
    "NFATC2IP CNV",
    "NFATC2IP RNA",
    "NFATC2IP Proteo"
  ],
  "UQCRBP1": [
    "UQCRBP1 CNV",
    "UQCRBP1 RNA"
  ],
  "MTMR2": [
    "MTMR2 CNV",
    "MTMR2 RNA",
    "MTMR2 Proteo"
  ],
  "PHC1": [
    "PHC1 CNV",
    "PHC1 RNA",
    "PHC1 Proteo"
  ],
  "STK39": [
    "STK39 CNV",
    "STK39 RNA",
    "STK39 Proteo"
  ],
  "RPL7P15": [
    "RPL7P15 CNV",
    "RPL7P15 RNA"
  ],
  "KCNK2": [
    "KCNK2 CNV",
    "KCNK2 RNA"
  ],
  "RNASE2": [
    "RNASE2 CNV",
    "RNASE2 RNA",
    "RNASE2 Proteo"
  ],
  "CCDC86": [
    "CCDC86 CNV",
    "CCDC86 RNA",
    "CCDC86 Proteo"
  ],
  "CALR": [
    "CALR CNV",
    "CALR RNA",
    "CALR Proteo"
  ],
  "ZNF678": [
    "ZNF678 CNV",
    "ZNF678 RNA"
  ],
  "MYO6": [
    "MYO6 CNV",
    "MYO6 RNA",
    "MYO6 Proteo"
  ],
  "ACADVL": [
    "ACADVL CNV",
    "ACADVL RNA",
    "ACADVL Proteo"
  ],
  "SH3KBP1": [
    "SH3KBP1 CNV",
    "SH3KBP1 RNA",
    "SH3KBP1 Proteo"
  ],
  "ATP6V0A2": [
    "ATP6V0A2 CNV",
    "ATP6V0A2 RNA",
    "ATP6V0A2 Proteo"
  ],
  "NUFIP2": [
    "NUFIP2 CNV",
    "NUFIP2 RNA",
    "NUFIP2 Proteo"
  ],
  "OR1X5P": [
    "OR1X5P CNV",
    "OR1X5P RNA"
  ],
  "BAIAP2L2": [
    "BAIAP2L2 CNV",
    "BAIAP2L2 RNA",
    "BAIAP2L2 Proteo"
  ],
  "CEBPA": [
    "CEBPA CNV",
    "CEBPA RNA",
    "CEBPA Proteo"
  ],
  "VN1R21P": [
    "VN1R21P CNV",
    "VN1R21P RNA"
  ],
  "KRT128P": [
    "KRT128P CNV",
    "KRT128P RNA"
  ],
  "MRPL48P1": [
    "MRPL48P1 CNV",
    "MRPL48P1 RNA"
  ],
  "FAM133A": [
    "FAM133A CNV",
    "FAM133A RNA"
  ],
  "FAM120AOS": [
    "FAM120AOS CNV",
    "FAM120AOS RNA"
  ],
  "NAA25": [
    "NAA25 CNV",
    "NAA25 RNA",
    "NAA25 Proteo"
  ],
  "NEPNP": [
    "NEPNP CNV",
    "NEPNP RNA"
  ],
  "OARD1": [
    "OARD1 CNV",
    "OARD1 RNA",
    "OARD1 Proteo"
  ],
  "DNM1P49": [
    "DNM1P49 CNV",
    "DNM1P49 RNA"
  ],
  "NME2P1": [
    "NME2P1 CNV",
    "NME2P1 RNA"
  ],
  "EIF4EP3": [
    "EIF4EP3 CNV",
    "EIF4EP3 RNA"
  ],
  "RNA5SP44": [
    "RNA5SP44 CNV",
    "RNA5SP44 RNA"
  ],
  "HSD3BP5": [
    "HSD3BP5 CNV",
    "HSD3BP5 RNA"
  ],
  "TREML2": [
    "TREML2 CNV",
    "TREML2 RNA"
  ],
  "RAVER1": [
    "RAVER1 CNV",
    "RAVER1 RNA",
    "RAVER1 Proteo"
  ],
  "RPL23AP36": [
    "RPL23AP36 CNV",
    "RPL23AP36 RNA"
  ],
  "NIF3L1": [
    "NIF3L1 CNV",
    "NIF3L1 RNA",
    "NIF3L1 Proteo"
  ],
  "ABTB3": [
    "ABTB3 CNV",
    "ABTB3 RNA",
    "ABTB3 Proteo"
  ],
  "SLC9B1P3": [
    "SLC9B1P3 CNV",
    "SLC9B1P3 RNA"
  ],
  "BBS4": [
    "BBS4 CNV",
    "BBS4 RNA",
    "BBS4 Proteo"
  ],
  "HTRA3": [
    "HTRA3 CNV",
    "HTRA3 RNA",
    "HTRA3 Proteo"
  ],
  "IGHV7-27": [
    "IGHV7-27 CNV",
    "IGHV7-27 RNA"
  ],
  "ST13P19": [
    "ST13P19 CNV",
    "ST13P19 RNA"
  ],
  "ARHGAP42P2": [
    "ARHGAP42P2 CNV",
    "ARHGAP42P2 RNA"
  ],
  "CREG2": [
    "CREG2 CNV",
    "CREG2 RNA"
  ],
  "C1QTNF9": [
    "C1QTNF9 CNV",
    "C1QTNF9 RNA"
  ],
  "PRKAR1A": [
    "PRKAR1A CNV",
    "PRKAR1A RNA",
    "PRKAR1A Proteo"
  ],
  "MEIS1": [
    "MEIS1 CNV",
    "MEIS1 RNA",
    "MEIS1 Proteo"
  ],
  "LRRC34P2": [
    "LRRC34P2 CNV",
    "LRRC34P2 RNA"
  ],
  "IGKV1OR9-2": [
    "IGKV1OR9-2 CNV",
    "IGKV1OR9-2 RNA"
  ],
  "NPM1P31": [
    "NPM1P31 CNV",
    "NPM1P31 RNA"
  ],
  "HOXD9": [
    "HOXD9 CNV",
    "HOXD9 RNA",
    "HOXD9 Proteo"
  ],
  "SPDYE22P": [
    "SPDYE22P CNV",
    "SPDYE22P RNA"
  ],
  "PRR13P5": [
    "PRR13P5 CNV",
    "PRR13P5 RNA"
  ],
  "NUDT4P2": [
    "NUDT4P2 CNV",
    "NUDT4P2 RNA"
  ],
  "CAP1P2": [
    "CAP1P2 CNV",
    "CAP1P2 RNA"
  ],
  "OR52J2P": [
    "OR52J2P CNV",
    "OR52J2P RNA"
  ],
  "RPL3P13": [
    "RPL3P13 CNV",
    "RPL3P13 RNA"
  ],
  "ISCA1": [
    "ISCA1 CNV",
    "ISCA1 RNA",
    "ISCA1 Proteo"
  ],
  "TAS2R31": [
    "TAS2R31 CNV",
    "TAS2R31 RNA"
  ],
  "AP2B1P1": [
    "AP2B1P1 CNV",
    "AP2B1P1 RNA"
  ],
  "PCDHGC4": [
    "PCDHGC4 CNV",
    "PCDHGC4 RNA"
  ],
  "DAZ4": [
    "DAZ4 CNV",
    "DAZ4 RNA"
  ],
  "SPDYE5": [
    "SPDYE5 CNV",
    "SPDYE5 RNA"
  ],
  "SLC25A3P2": [
    "SLC25A3P2 CNV",
    "SLC25A3P2 RNA"
  ],
  "ATP5MGP8": [
    "ATP5MGP8 CNV",
    "ATP5MGP8 RNA"
  ],
  "POU3F1": [
    "POU3F1 CNV",
    "POU3F1 RNA",
    "POU3F1 Proteo"
  ],
  "GLIS3": [
    "GLIS3 CNV",
    "GLIS3 RNA"
  ],
  "OR2T34": [
    "OR2T34 CNV",
    "OR2T34 RNA"
  ],
  "DDX39BP2": [
    "DDX39BP2 CNV",
    "DDX39BP2 RNA"
  ],
  "ADAR": [
    "ADAR CNV",
    "ADAR RNA",
    "ADAR Proteo"
  ],
  "AP5B1": [
    "AP5B1 CNV",
    "AP5B1 RNA",
    "AP5B1 Proteo"
  ],
  "AQP7P5": [
    "AQP7P5 CNV",
    "AQP7P5 RNA"
  ],
  "AKAP8P1": [
    "AKAP8P1 CNV",
    "AKAP8P1 RNA"
  ],
  "RPL7P36": [
    "RPL7P36 CNV",
    "RPL7P36 RNA"
  ],
  "LUZP2": [
    "LUZP2 CNV",
    "LUZP2 RNA"
  ],
  "ORC1P1": [
    "ORC1P1 CNV",
    "ORC1P1 RNA"
  ],
  "PTGER3": [
    "PTGER3 CNV",
    "PTGER3 RNA"
  ],
  "SPRR1A": [
    "SPRR1A CNV",
    "SPRR1A RNA",
    "SPRR1A Proteo"
  ],
  "C1orf50": [
    "C1orf50 CNV",
    "C1orf50 RNA",
    "C1orf50 Proteo"
  ],
  "CELA1": [
    "CELA1 CNV",
    "CELA1 RNA"
  ],
  "ERICH5": [
    "ERICH5 CNV",
    "ERICH5 RNA"
  ],
  "VN1R13P": [
    "VN1R13P CNV",
    "VN1R13P RNA"
  ],
  "CD8A": [
    "CD8A CNV",
    "CD8A RNA",
    "CD8A Proteo"
  ],
  "EMG1": [
    "EMG1 CNV",
    "EMG1 RNA",
    "EMG1 Proteo"
  ],
  "MT1P1": [
    "MT1P1 CNV",
    "MT1P1 RNA"
  ],
  "PCDHA7": [
    "PCDHA7 CNV",
    "PCDHA7 RNA"
  ],
  "MTCO3P4": [
    "MTCO3P4 CNV",
    "MTCO3P4 RNA"
  ],
  "GTF2H4": [
    "GTF2H4 CNV",
    "GTF2H4 RNA",
    "GTF2H4 Proteo"
  ],
  "TDGF1P7": [
    "TDGF1P7 CNV",
    "TDGF1P7 RNA"
  ],
  "SAP18P1": [
    "SAP18P1 CNV",
    "SAP18P1 RNA"
  ],
  "HNRNPA1P73": [
    "HNRNPA1P73 CNV",
    "HNRNPA1P73 RNA"
  ],
  "SERPINA9": [
    "SERPINA9 CNV",
    "SERPINA9 RNA"
  ],
  "STRN": [
    "STRN CNV",
    "STRN RNA",
    "STRN Proteo"
  ],
  "DMRTC1": [
    "DMRTC1 CNV",
    "DMRTC1 RNA"
  ],
  "TTC19": [
    "TTC19 CNV",
    "TTC19 RNA",
    "TTC19 Proteo"
  ],
  "ZNF559": [
    "ZNF559 CNV",
    "ZNF559 RNA"
  ],
  "MTA2": [
    "MTA2 CNV",
    "MTA2 RNA",
    "MTA2 Proteo"
  ],
  "NEFH": [
    "NEFH CNV",
    "NEFH RNA",
    "NEFH Proteo"
  ],
  "PRSS53": [
    "PRSS53 CNV",
    "PRSS53 RNA"
  ],
  "NTNG1": [
    "NTNG1 CNV",
    "NTNG1 RNA"
  ],
  "RPL12P44": [
    "RPL12P44 CNV",
    "RPL12P44 RNA"
  ],
  "OR2L9P": [
    "OR2L9P CNV",
    "OR2L9P RNA"
  ],
  "SH3BP1": [
    "SH3BP1 CNV",
    "SH3BP1 RNA",
    "SH3BP1 Proteo"
  ],
  "PACRGL": [
    "PACRGL CNV",
    "PACRGL RNA"
  ],
  "ASPDH": [
    "ASPDH CNV",
    "ASPDH RNA"
  ],
  "SIGLEC7": [
    "SIGLEC7 CNV",
    "SIGLEC7 RNA",
    "SIGLEC7 Proteo"
  ],
  "SORD": [
    "SORD CNV",
    "SORD RNA",
    "SORD Proteo"
  ],
  "PSMB7": [
    "PSMB7 CNV",
    "PSMB7 RNA",
    "PSMB7 Proteo"
  ],
  "LZIC": [
    "LZIC CNV",
    "LZIC RNA",
    "LZIC Proteo"
  ],
  "TOMM22P3": [
    "TOMM22P3 CNV",
    "TOMM22P3 RNA"
  ],
  "KRT126P": [
    "KRT126P CNV",
    "KRT126P RNA"
  ],
  "DNASE1L3": [
    "DNASE1L3 CNV",
    "DNASE1L3 RNA"
  ],
  "PPA1": [
    "PPA1 CNV",
    "PPA1 RNA",
    "PPA1 Proteo"
  ],
  "H3-3B": [
    "H3-3B CNV",
    "H3-3B RNA",
    "H3-3B Proteo"
  ],
  "OR2X1P": [
    "OR2X1P CNV",
    "OR2X1P RNA"
  ],
  "ZBTB22": [
    "ZBTB22 CNV",
    "ZBTB22 RNA"
  ],
  "PLPPR5": [
    "PLPPR5 CNV",
    "PLPPR5 RNA"
  ],
  "PRYP3": [
    "PRYP3 CNV",
    "PRYP3 RNA"
  ],
  "MTAP": [
    "MTAP CNV",
    "MTAP RNA",
    "MTAP Proteo"
  ],
  "RAI1": [
    "RAI1 CNV",
    "RAI1 RNA",
    "RAI1 Proteo"
  ],
  "RPS10P3": [
    "RPS10P3 CNV",
    "RPS10P3 RNA"
  ],
  "PIMREGP1": [
    "PIMREGP1 CNV",
    "PIMREGP1 RNA"
  ],
  "CXADRP1": [
    "CXADRP1 CNV",
    "CXADRP1 RNA"
  ],
  "HEXIM2": [
    "HEXIM2 CNV",
    "HEXIM2 RNA",
    "HEXIM2 Proteo"
  ],
  "MAPK8": [
    "MAPK8 CNV",
    "MAPK8 RNA",
    "MAPK8 Proteo"
  ],
  "MUS81": [
    "MUS81 CNV",
    "MUS81 RNA",
    "MUS81 Proteo"
  ],
  "DCPS": [
    "DCPS CNV",
    "DCPS RNA",
    "DCPS Proteo"
  ],
  "KIAA0895L": [
    "KIAA0895L CNV",
    "KIAA0895L RNA"
  ],
  "NAALADL2": [
    "NAALADL2 CNV",
    "NAALADL2 RNA",
    "NAALADL2 Proteo"
  ],
  "KCND1": [
    "KCND1 CNV",
    "KCND1 RNA"
  ],
  "RNFT2": [
    "RNFT2 CNV",
    "RNFT2 RNA",
    "RNFT2 Proteo"
  ],
  "ABCG5": [
    "ABCG5 CNV",
    "ABCG5 RNA"
  ],
  "CDC45": [
    "CDC45 CNV",
    "CDC45 RNA",
    "CDC45 Proteo"
  ],
  "GTF2H3": [
    "GTF2H3 CNV",
    "GTF2H3 RNA",
    "GTF2H3 Proteo"
  ],
  "ANTKMT": [
    "ANTKMT CNV",
    "ANTKMT RNA",
    "ANTKMT Proteo"
  ],
  "BOLA3P3": [
    "BOLA3P3 CNV",
    "BOLA3P3 RNA"
  ],
  "RPL6P18": [
    "RPL6P18 CNV",
    "RPL6P18 RNA"
  ],
  "TAC3": [
    "TAC3 CNV",
    "TAC3 RNA"
  ],
  "RNF11P2": [
    "RNF11P2 CNV",
    "RNF11P2 RNA"
  ],
  "HDAC3": [
    "HDAC3 CNV",
    "HDAC3 RNA",
    "HDAC3 Proteo"
  ],
  "CSGALNACT2": [
    "CSGALNACT2 CNV",
    "CSGALNACT2 RNA",
    "CSGALNACT2 Proteo"
  ],
  "OR13Z1P": [
    "OR13Z1P CNV",
    "OR13Z1P RNA"
  ],
  "LRRC10": [
    "LRRC10 CNV",
    "LRRC10 RNA"
  ],
  "BOP1": [
    "BOP1 CNV",
    "BOP1 RNA",
    "BOP1 Proteo"
  ],
  "OSTN": [
    "OSTN CNV",
    "OSTN RNA"
  ],
  "EEF1GP3": [
    "EEF1GP3 CNV",
    "EEF1GP3 RNA"
  ],
  "RPL7P2": [
    "RPL7P2 CNV",
    "RPL7P2 RNA"
  ],
  "RPL12": [
    "RPL12 CNV",
    "RPL12 RNA",
    "RPL12 Proteo"
  ],
  "GFI1B": [
    "GFI1B CNV",
    "GFI1B RNA"
  ],
  "FBXL18": [
    "FBXL18 CNV",
    "FBXL18 RNA",
    "FBXL18 Proteo"
  ],
  "RPS2P6": [
    "RPS2P6 CNV",
    "RPS2P6 RNA"
  ],
  "SLC25A6P5": [
    "SLC25A6P5 CNV",
    "SLC25A6P5 RNA"
  ],
  "ASPG": [
    "ASPG CNV",
    "ASPG RNA"
  ],
  "PDCL2P1": [
    "PDCL2P1 CNV",
    "PDCL2P1 RNA"
  ],
  "RPL3P2": [
    "RPL3P2 CNV",
    "RPL3P2 RNA"
  ],
  "OR10Z1": [
    "OR10Z1 CNV",
    "OR10Z1 RNA"
  ],
  "CRAMP1": [
    "CRAMP1 CNV",
    "CRAMP1 RNA",
    "CRAMP1 Proteo"
  ],
  "RNA5SP201": [
    "RNA5SP201 CNV",
    "RNA5SP201 RNA"
  ],
  "AIG1P1": [
    "AIG1P1 CNV",
    "AIG1P1 RNA"
  ],
  "OR7A3P": [
    "OR7A3P CNV",
    "OR7A3P RNA"
  ],
  "IFT52": [
    "IFT52 CNV",
    "IFT52 RNA",
    "IFT52 Proteo"
  ],
  "PRDX3P4": [
    "PRDX3P4 CNV",
    "PRDX3P4 RNA"
  ],
  "ATF4P2": [
    "ATF4P2 CNV",
    "ATF4P2 RNA"
  ],
  "CFAP73": [
    "CFAP73 CNV",
    "CFAP73 RNA"
  ],
  "RNA5SP59": [
    "RNA5SP59 CNV",
    "RNA5SP59 RNA"
  ],
  "P2RY11": [
    "P2RY11 CNV",
    "P2RY11 RNA"
  ],
  "RPL36AP1": [
    "RPL36AP1 CNV",
    "RPL36AP1 RNA"
  ],
  "TEX15": [
    "TEX15 CNV",
    "TEX15 RNA",
    "TEX15 Proteo"
  ],
  "FAM13B": [
    "FAM13B CNV",
    "FAM13B RNA",
    "FAM13B Proteo"
  ],
  "YBX1P5": [
    "YBX1P5 CNV",
    "YBX1P5 RNA"
  ],
  "CLCN7": [
    "CLCN7 CNV",
    "CLCN7 RNA",
    "CLCN7 Proteo"
  ],
  "SHISA8": [
    "SHISA8 CNV",
    "SHISA8 RNA"
  ],
  "CEBPE": [
    "CEBPE CNV",
    "CEBPE RNA"
  ],
  "TRBV12-1": [
    "TRBV12-1 CNV",
    "TRBV12-1 RNA"
  ],
  "OR11K1BP": [
    "OR11K1BP CNV",
    "OR11K1BP RNA"
  ],
  "IFNA13": [
    "IFNA13 CNV",
    "IFNA13 RNA"
  ],
  "ARL5C": [
    "ARL5C CNV",
    "ARL5C RNA"
  ],
  "RPS26P38": [
    "RPS26P38 CNV",
    "RPS26P38 RNA"
  ],
  "PPM1H": [
    "PPM1H CNV",
    "PPM1H RNA",
    "PPM1H Proteo"
  ],
  "PABPN1": [
    "PABPN1 CNV",
    "PABPN1 RNA",
    "PABPN1 Proteo"
  ],
  "AP2A1": [
    "AP2A1 CNV",
    "AP2A1 RNA",
    "AP2A1 Proteo"
  ],
  "ARHGAP8": [
    "ARHGAP8 CNV",
    "ARHGAP8 RNA"
  ],
  "TAF15": [
    "TAF15 CNV",
    "TAF15 RNA",
    "TAF15 Proteo"
  ],
  "MRPS5": [
    "MRPS5 CNV",
    "MRPS5 RNA",
    "MRPS5 Proteo"
  ],
  "CUTC": [
    "CUTC CNV",
    "CUTC RNA",
    "CUTC Proteo"
  ],
  "VN1R67P": [
    "VN1R67P CNV",
    "VN1R67P RNA"
  ],
  "PROSER1": [
    "PROSER1 CNV",
    "PROSER1 RNA",
    "PROSER1 Proteo"
  ],
  "LRRC17": [
    "LRRC17 CNV",
    "LRRC17 RNA",
    "LRRC17 Proteo"
  ],
  "PRF1": [
    "PRF1 CNV",
    "PRF1 RNA",
    "PRF1 Proteo"
  ],
  "RPL26P28": [
    "RPL26P28 CNV",
    "RPL26P28 RNA"
  ],
  "ENAM": [
    "ENAM CNV",
    "ENAM RNA"
  ],
  "RPS4Y1": [
    "RPS4Y1 CNV",
    "RPS4Y1 RNA",
    "RPS4Y1 Proteo"
  ],
  "ATP5F1EP2": [
    "ATP5F1EP2 CNV",
    "ATP5F1EP2 RNA"
  ],
  "GLULP5": [
    "GLULP5 CNV",
    "GLULP5 RNA"
  ],
  "FSCN1P1": [
    "FSCN1P1 CNV",
    "FSCN1P1 RNA"
  ],
  "SH3GL3": [
    "SH3GL3 CNV",
    "SH3GL3 RNA"
  ],
  "CRYBG1": [
    "CRYBG1 CNV",
    "CRYBG1 RNA",
    "CRYBG1 Proteo"
  ],
  "KRTAP6-2": [
    "KRTAP6-2 CNV",
    "KRTAP6-2 RNA"
  ],
  "LNPEP": [
    "LNPEP CNV",
    "LNPEP RNA",
    "LNPEP Proteo"
  ],
  "RPSAP40": [
    "RPSAP40 CNV",
    "RPSAP40 RNA"
  ],
  "KAT6B": [
    "KAT6B CNV",
    "KAT6B RNA",
    "KAT6B Proteo"
  ],
  "OR7E23P": [
    "OR7E23P CNV",
    "OR7E23P RNA"
  ],
  "CHD1L": [
    "CHD1L CNV",
    "CHD1L RNA",
    "CHD1L Proteo"
  ],
  "OR7E163P": [
    "OR7E163P CNV",
    "OR7E163P RNA"
  ],
  "RPSAP66": [
    "RPSAP66 CNV",
    "RPSAP66 RNA"
  ],
  "IGLVIV-65": [
    "IGLVIV-65 CNV",
    "IGLVIV-65 RNA"
  ],
  "ELMO3": [
    "ELMO3 CNV",
    "ELMO3 RNA",
    "ELMO3 Proteo"
  ],
  "CAT": [
    "CAT CNV",
    "CAT RNA",
    "CAT Proteo"
  ],
  "OR5L1": [
    "OR5L1 CNV",
    "OR5L1 RNA"
  ],
  "GNL2": [
    "GNL2 CNV",
    "GNL2 RNA",
    "GNL2 Proteo"
  ],
  "AARS1": [
    "AARS1 CNV",
    "AARS1 RNA",
    "AARS1 Proteo"
  ],
  "KIT": [
    "KIT CNV",
    "KIT RNA",
    "KIT Proteo"
  ],
  "HMGB3P24": [
    "HMGB3P24 CNV",
    "HMGB3P24 RNA"
  ],
  "RPL29P11": [
    "RPL29P11 CNV",
    "RPL29P11 RNA"
  ],
  "DIPK1C": [
    "DIPK1C CNV",
    "DIPK1C RNA",
    "DIPK1C Proteo"
  ],
  "CICP27": [
    "CICP27 CNV",
    "CICP27 RNA"
  ],
  "ABCA8": [
    "ABCA8 CNV",
    "ABCA8 RNA",
    "ABCA8 Proteo"
  ],
  "SH3BP2": [
    "SH3BP2 CNV",
    "SH3BP2 RNA",
    "SH3BP2 Proteo"
  ],
  "FAM214B": [
    "FAM214B CNV",
    "FAM214B RNA",
    "FAM214B Proteo"
  ],
  "RBM39": [
    "RBM39 CNV",
    "RBM39 RNA",
    "RBM39 Proteo"
  ],
  "UBE2G2": [
    "UBE2G2 CNV",
    "UBE2G2 RNA",
    "UBE2G2 Proteo"
  ],
  "RXRG": [
    "RXRG CNV",
    "RXRG RNA",
    "RXRG Proteo"
  ],
  "CDY1B": [
    "CDY1B CNV",
    "CDY1B RNA"
  ],
  "CORO7": [
    "CORO7 CNV",
    "CORO7 RNA",
    "CORO7 Proteo"
  ],
  "MPRIP": [
    "MPRIP CNV",
    "MPRIP RNA",
    "MPRIP Proteo"
  ],
  "RCSD1": [
    "RCSD1 CNV",
    "RCSD1 RNA",
    "RCSD1 Proteo"
  ],
  "FBXO24": [
    "FBXO24 CNV",
    "FBXO24 RNA"
  ],
  "SINHCAFP2": [
    "SINHCAFP2 CNV",
    "SINHCAFP2 RNA"
  ],
  "ATF4": [
    "ATF4 CNV",
    "ATF4 RNA"
  ],
  "SNRPGP20": [
    "SNRPGP20 CNV",
    "SNRPGP20 RNA"
  ],
  "ASAH2B": [
    "ASAH2B CNV",
    "ASAH2B RNA"
  ],
  "MSTO2P": [
    "MSTO2P CNV",
    "MSTO2P RNA"
  ],
  "MUL1": [
    "MUL1 CNV",
    "MUL1 RNA",
    "MUL1 Proteo"
  ],
  "ANKIB1": [
    "ANKIB1 CNV",
    "ANKIB1 RNA",
    "ANKIB1 Proteo"
  ],
  "GPCPD1": [
    "GPCPD1 CNV",
    "GPCPD1 RNA",
    "GPCPD1 Proteo"
  ],
  "RPL32P7": [
    "RPL32P7 CNV",
    "RPL32P7 RNA"
  ],
  "ASB18": [
    "ASB18 CNV",
    "ASB18 RNA"
  ],
  "RPL32P5": [
    "RPL32P5 CNV",
    "RPL32P5 RNA"
  ],
  "HOXC4": [
    "HOXC4 CNV",
    "HOXC4 RNA"
  ],
  "PPIAP48": [
    "PPIAP48 CNV",
    "PPIAP48 RNA"
  ],
  "SBSPON": [
    "SBSPON CNV",
    "SBSPON RNA",
    "SBSPON Proteo"
  ],
  "CCL13": [
    "CCL13 CNV",
    "CCL13 RNA"
  ],
  "RPL18P10": [
    "RPL18P10 CNV",
    "RPL18P10 RNA"
  ],
  "MAP1LC3B2": [
    "MAP1LC3B2 CNV",
    "MAP1LC3B2 RNA"
  ],
  "DEFB124": [
    "DEFB124 CNV",
    "DEFB124 RNA"
  ],
  "USP21P2": [
    "USP21P2 CNV",
    "USP21P2 RNA"
  ],
  "SHFL": [
    "SHFL CNV",
    "SHFL RNA",
    "SHFL Proteo"
  ],
  "EDC4": [
    "EDC4 CNV",
    "EDC4 RNA",
    "EDC4 Proteo"
  ],
  "EGLN3": [
    "EGLN3 CNV",
    "EGLN3 RNA"
  ],
  "RPS4XP15": [
    "RPS4XP15 CNV",
    "RPS4XP15 RNA"
  ],
  "TMED1": [
    "TMED1 CNV",
    "TMED1 RNA",
    "TMED1 Proteo"
  ],
  "HES3": [
    "HES3 CNV",
    "HES3 RNA"
  ],
  "EXPH5": [
    "EXPH5 CNV",
    "EXPH5 RNA",
    "EXPH5 Proteo"
  ],
  "C17orf100": [
    "C17orf100 CNV",
    "C17orf100 RNA"
  ],
  "TIMM8A": [
    "TIMM8A CNV",
    "TIMM8A RNA",
    "TIMM8A Proteo"
  ],
  "RIBC1": [
    "RIBC1 CNV",
    "RIBC1 RNA"
  ],
  "PASK": [
    "PASK CNV",
    "PASK RNA",
    "PASK Proteo"
  ],
  "MIPEPP3": [
    "MIPEPP3 CNV",
    "MIPEPP3 RNA"
  ],
  "SOD2": [
    "SOD2 CNV",
    "SOD2 RNA",
    "SOD2 Proteo"
  ],
  "ANKS4B": [
    "ANKS4B CNV",
    "ANKS4B RNA"
  ],
  "PYCR3": [
    "PYCR3 CNV",
    "PYCR3 RNA",
    "PYCR3 Proteo"
  ],
  "CASC3": [
    "CASC3 CNV",
    "CASC3 RNA",
    "CASC3 Proteo"
  ],
  "KLK15": [
    "KLK15 CNV",
    "KLK15 RNA"
  ],
  "PIP4K2B": [
    "PIP4K2B CNV",
    "PIP4K2B RNA",
    "PIP4K2B Proteo"
  ],
  "NGLY1": [
    "NGLY1 CNV",
    "NGLY1 RNA",
    "NGLY1 Proteo"
  ],
  "ZMYM3": [
    "ZMYM3 CNV",
    "ZMYM3 RNA",
    "ZMYM3 Proteo"
  ],
  "IGKV2D-28": [
    "IGKV2D-28 Proteo"
  ],
  "TICRR": [
    "TICRR CNV",
    "TICRR RNA"
  ],
  "PXDC1": [
    "PXDC1 CNV",
    "PXDC1 RNA",
    "PXDC1 Proteo"
  ],
  "FAM90A20P": [
    "FAM90A20P CNV",
    "FAM90A20P RNA"
  ],
  "ACTL6B": [
    "ACTL6B CNV",
    "ACTL6B RNA",
    "ACTL6B Proteo"
  ],
  "E2F7": [
    "E2F7 CNV",
    "E2F7 RNA"
  ],
  "PUS3": [
    "PUS3 CNV",
    "PUS3 RNA",
    "PUS3 Proteo"
  ],
  "RPL5P30": [
    "RPL5P30 CNV",
    "RPL5P30 RNA"
  ],
  "MTCO2P19": [
    "MTCO2P19 CNV",
    "MTCO2P19 RNA"
  ],
  "AIRE": [
    "AIRE CNV",
    "AIRE RNA"
  ],
  "PADI3": [
    "PADI3 CNV",
    "PADI3 RNA",
    "PADI3 Proteo"
  ],
  "RPL36AP46": [
    "RPL36AP46 CNV",
    "RPL36AP46 RNA"
  ],
  "GARS1P1": [
    "GARS1P1 CNV",
    "GARS1P1 RNA"
  ],
  "CX3CR1": [
    "CX3CR1 CNV",
    "CX3CR1 RNA",
    "CX3CR1 Proteo"
  ],
  "FAM133FP": [
    "FAM133FP CNV",
    "FAM133FP RNA"
  ],
  "PPBPP2": [
    "PPBPP2 CNV",
    "PPBPP2 RNA"
  ],
  "TK2": [
    "TK2 CNV",
    "TK2 RNA",
    "TK2 Proteo"
  ],
  "VRK1": [
    "VRK1 CNV",
    "VRK1 RNA",
    "VRK1 Proteo"
  ],
  "THAP6": [
    "THAP6 CNV",
    "THAP6 RNA"
  ],
  "DEFB106B": [
    "DEFB106B CNV",
    "DEFB106B RNA"
  ],
  "AAGAB": [
    "AAGAB CNV",
    "AAGAB RNA",
    "AAGAB Proteo"
  ],
  "ST13P11": [
    "ST13P11 CNV",
    "ST13P11 RNA"
  ],
  "CIB3": [
    "CIB3 CNV",
    "CIB3 RNA"
  ],
  "HS6ST2": [
    "HS6ST2 CNV",
    "HS6ST2 RNA",
    "HS6ST2 Proteo"
  ],
  "PCLO": [
    "PCLO CNV",
    "PCLO RNA",
    "PCLO Proteo"
  ],
  "CELA2B": [
    "CELA2B CNV",
    "CELA2B RNA"
  ],
  "ZNF861P": [
    "ZNF861P CNV",
    "ZNF861P RNA"
  ],
  "XKRX": [
    "XKRX CNV",
    "XKRX RNA"
  ],
  "PPIAL4H": [
    "PPIAL4H CNV",
    "PPIAL4H RNA",
    "PPIAL4H Proteo"
  ],
  "RUFY1": [
    "RUFY1 CNV",
    "RUFY1 RNA",
    "RUFY1 Proteo"
  ],
  "CCNHP1": [
    "CCNHP1 CNV",
    "CCNHP1 RNA"
  ],
  "IGHVIII-44": [
    "IGHVIII-44 CNV",
    "IGHVIII-44 RNA"
  ],
  "ZNF248": [
    "ZNF248 CNV",
    "ZNF248 RNA"
  ],
  "NCOA5": [
    "NCOA5 CNV",
    "NCOA5 RNA",
    "NCOA5 Proteo"
  ],
  "TRPC6P5": [
    "TRPC6P5 CNV",
    "TRPC6P5 RNA"
  ],
  "RFNG": [
    "RFNG CNV",
    "RFNG RNA",
    "RFNG Proteo"
  ],
  "IGHVIII-67-3": [
    "IGHVIII-67-3 CNV",
    "IGHVIII-67-3 RNA"
  ],
  "SPATA25": [
    "SPATA25 CNV",
    "SPATA25 RNA"
  ],
  "WDR86": [
    "WDR86 CNV",
    "WDR86 RNA"
  ],
  "ZNF833P": [
    "ZNF833P CNV",
    "ZNF833P RNA"
  ],
  "NOLC1": [
    "NOLC1 CNV",
    "NOLC1 RNA",
    "NOLC1 Proteo"
  ],
  "CDRT15P8": [
    "CDRT15P8 CNV",
    "CDRT15P8 RNA"
  ],
  "DYNLT2": [
    "DYNLT2 CNV",
    "DYNLT2 RNA"
  ],
  "CHST2": [
    "CHST2 CNV",
    "CHST2 RNA",
    "CHST2 Proteo"
  ],
  "NBPF5P": [
    "NBPF5P CNV",
    "NBPF5P RNA"
  ],
  "C4BPAP1": [
    "C4BPAP1 CNV",
    "C4BPAP1 RNA"
  ],
  "UBE2Q2P9": [
    "UBE2Q2P9 CNV",
    "UBE2Q2P9 RNA"
  ],
  "EXOC2": [
    "EXOC2 CNV",
    "EXOC2 RNA",
    "EXOC2 Proteo"
  ],
  "ZBTB47": [
    "ZBTB47 CNV",
    "ZBTB47 RNA",
    "ZBTB47 Proteo"
  ],
  "CLUHP2": [
    "CLUHP2 CNV",
    "CLUHP2 RNA"
  ],
  "BNIP3P9": [
    "BNIP3P9 CNV",
    "BNIP3P9 RNA"
  ],
  "PFKFB1": [
    "PFKFB1 CNV",
    "PFKFB1 RNA"
  ],
  "TMEM8B": [
    "TMEM8B CNV",
    "TMEM8B RNA"
  ],
  "MEMO1P2": [
    "MEMO1P2 CNV",
    "MEMO1P2 RNA"
  ],
  "CDKN1C": [
    "CDKN1C CNV",
    "CDKN1C RNA",
    "CDKN1C Proteo"
  ],
  "USP9YP20": [
    "USP9YP20 CNV",
    "USP9YP20 RNA"
  ],
  "RPLP0P8": [
    "RPLP0P8 CNV",
    "RPLP0P8 RNA"
  ],
  "CFAP157": [
    "CFAP157 CNV",
    "CFAP157 RNA"
  ],
  "UFL1": [
    "UFL1 CNV",
    "UFL1 RNA",
    "UFL1 Proteo"
  ],
  "GCNT2P1": [
    "GCNT2P1 CNV",
    "GCNT2P1 RNA"
  ],
  "SCDP1": [
    "SCDP1 CNV",
    "SCDP1 RNA"
  ],
  "C9orf40": [
    "C9orf40 CNV",
    "C9orf40 RNA",
    "C9orf40 Proteo"
  ],
  "PTGS1": [
    "PTGS1 CNV",
    "PTGS1 RNA",
    "PTGS1 Proteo"
  ],
  "ZNF146": [
    "ZNF146 CNV",
    "ZNF146 RNA",
    "ZNF146 Proteo"
  ],
  "SLC17A7": [
    "SLC17A7 CNV",
    "SLC17A7 RNA"
  ],
  "RNA5SP454": [
    "RNA5SP454 CNV",
    "RNA5SP454 RNA"
  ],
  "STX12": [
    "STX12 CNV",
    "STX12 RNA",
    "STX12 Proteo"
  ],
  "SETP4": [
    "SETP4 CNV",
    "SETP4 RNA"
  ],
  "TMEM150B": [
    "TMEM150B CNV",
    "TMEM150B RNA"
  ],
  "WNT10A": [
    "WNT10A CNV",
    "WNT10A RNA"
  ],
  "LRRC28": [
    "LRRC28 CNV",
    "LRRC28 RNA",
    "LRRC28 Proteo"
  ],
  "CEP290": [
    "CEP290 CNV",
    "CEP290 RNA",
    "CEP290 Proteo"
  ],
  "ZNF844": [
    "ZNF844 CNV",
    "ZNF844 RNA"
  ],
  "SKIDA1": [
    "SKIDA1 CNV",
    "SKIDA1 RNA"
  ],
  "KLHL42": [
    "KLHL42 CNV",
    "KLHL42 RNA",
    "KLHL42 Proteo"
  ],
  "VEZF1": [
    "VEZF1 CNV",
    "VEZF1 RNA",
    "VEZF1 Proteo"
  ],
  "TNFRSF12A": [
    "TNFRSF12A CNV",
    "TNFRSF12A RNA",
    "TNFRSF12A Proteo"
  ],
  "CPQ": [
    "CPQ CNV",
    "CPQ RNA",
    "CPQ Proteo"
  ],
  "CD4": [
    "CD4 CNV",
    "CD4 RNA",
    "CD4 Proteo"
  ],
  "CYCS": [
    "CYCS CNV",
    "CYCS RNA",
    "CYCS Proteo"
  ],
  "SLC5A6": [
    "SLC5A6 CNV",
    "SLC5A6 RNA",
    "SLC5A6 Proteo"
  ],
  "ZNF736P1Y": [
    "ZNF736P1Y CNV",
    "ZNF736P1Y RNA"
  ],
  "NUP210P2": [
    "NUP210P2 CNV",
    "NUP210P2 RNA"
  ],
  "NDUFB8": [
    "NDUFB8 CNV",
    "NDUFB8 RNA",
    "NDUFB8 Proteo"
  ],
  "OR4K12P": [
    "OR4K12P CNV",
    "OR4K12P RNA"
  ],
  "LDHA": [
    "LDHA CNV",
    "LDHA RNA",
    "LDHA Proteo"
  ],
  "MMP14": [
    "MMP14 CNV",
    "MMP14 RNA",
    "MMP14 Proteo"
  ],
  "TOR1A": [
    "TOR1A CNV",
    "TOR1A RNA",
    "TOR1A Proteo"
  ],
  "RELCH": [
    "RELCH CNV",
    "RELCH RNA",
    "RELCH Proteo"
  ],
  "FOXI2": [
    "FOXI2 CNV",
    "FOXI2 RNA"
  ],
  "MYOF": [
    "MYOF CNV",
    "MYOF RNA",
    "MYOF Proteo"
  ],
  "POU5F1P2": [
    "POU5F1P2 CNV",
    "POU5F1P2 RNA"
  ],
  "RPL7AP33": [
    "RPL7AP33 CNV",
    "RPL7AP33 RNA"
  ],
  "SARM1": [
    "SARM1 CNV",
    "SARM1 RNA",
    "SARM1 Proteo"
  ],
  "RPS3A": [
    "RPS3A CNV",
    "RPS3A RNA",
    "RPS3A Proteo"
  ],
  "GRM8": [
    "GRM8 CNV",
    "GRM8 RNA"
  ],
  "HMGB1P17": [
    "HMGB1P17 CNV",
    "HMGB1P17 RNA"
  ],
  "ECEL1": [
    "ECEL1 CNV",
    "ECEL1 RNA"
  ],
  "KIF27": [
    "KIF27 CNV",
    "KIF27 RNA",
    "KIF27 Proteo"
  ],
  "USP46": [
    "USP46 CNV",
    "USP46 RNA",
    "USP46 Proteo"
  ],
  "MYH8": [
    "MYH8 CNV",
    "MYH8 RNA",
    "MYH8 Proteo"
  ],
  "ZNF461": [
    "ZNF461 CNV",
    "ZNF461 RNA"
  ],
  "ATP10D": [
    "ATP10D CNV",
    "ATP10D RNA",
    "ATP10D Proteo"
  ],
  "ARHGEF4": [
    "ARHGEF4 CNV",
    "ARHGEF4 RNA"
  ],
  "OR4A12P": [
    "OR4A12P CNV",
    "OR4A12P RNA"
  ],
  "FAM217B": [
    "FAM217B CNV",
    "FAM217B RNA"
  ],
  "SCYGR6": [
    "SCYGR6 CNV",
    "SCYGR6 RNA"
  ],
  "MSANTD5": [
    "MSANTD5 CNV",
    "MSANTD5 RNA"
  ],
  "RNA5SP235": [
    "RNA5SP235 CNV",
    "RNA5SP235 RNA"
  ],
  "SAMD8": [
    "SAMD8 CNV",
    "SAMD8 RNA",
    "SAMD8 Proteo"
  ],
  "DEFB108F": [
    "DEFB108F CNV",
    "DEFB108F RNA"
  ],
  "C6": [
    "C6 CNV",
    "C6 RNA",
    "C6 Proteo"
  ],
  "DDO": [
    "DDO CNV",
    "DDO RNA",
    "DDO Proteo"
  ],
  "KRT8P14": [
    "KRT8P14 CNV",
    "KRT8P14 RNA"
  ],
  "PTPMT1": [
    "PTPMT1 CNV",
    "PTPMT1 RNA",
    "PTPMT1 Proteo"
  ],
  "ATP8B2": [
    "ATP8B2 CNV",
    "ATP8B2 RNA",
    "ATP8B2 Proteo"
  ],
  "RPL10P5": [
    "RPL10P5 CNV",
    "RPL10P5 RNA"
  ],
  "FTH1P9": [
    "FTH1P9 CNV",
    "FTH1P9 RNA"
  ],
  "HERC4": [
    "HERC4 CNV",
    "HERC4 RNA",
    "HERC4 Proteo"
  ],
  "ACTR8": [
    "ACTR8 CNV",
    "ACTR8 RNA",
    "ACTR8 Proteo"
  ],
  "RANBP3L": [
    "RANBP3L CNV",
    "RANBP3L RNA"
  ],
  "OR5D14": [
    "OR5D14 CNV",
    "OR5D14 RNA"
  ],
  "MLF1": [
    "MLF1 CNV",
    "MLF1 RNA",
    "MLF1 Proteo"
  ],
  "RNA5SP214": [
    "RNA5SP214 CNV",
    "RNA5SP214 RNA"
  ],
  "LSS": [
    "LSS CNV",
    "LSS RNA",
    "LSS Proteo"
  ],
  "RBM15B": [
    "RBM15B CNV",
    "RBM15B RNA",
    "RBM15B Proteo"
  ],
  "HEXA": [
    "HEXA CNV",
    "HEXA RNA",
    "HEXA Proteo"
  ],
  "TMEM256P2": [
    "TMEM256P2 CNV",
    "TMEM256P2 RNA"
  ],
  "BCL11B": [
    "BCL11B CNV",
    "BCL11B RNA",
    "BCL11B Proteo"
  ],
  "RASD1": [
    "RASD1 CNV",
    "RASD1 RNA"
  ],
  "MTCO2P24": [
    "MTCO2P24 CNV",
    "MTCO2P24 RNA"
  ],
  "IGKV1-5": [
    "IGKV1-5 Proteo"
  ],
  "SBNO2": [
    "SBNO2 CNV",
    "SBNO2 RNA",
    "SBNO2 Proteo"
  ],
  "PARK7": [
    "PARK7 CNV",
    "PARK7 RNA",
    "PARK7 Proteo"
  ],
  "PCDHGA3": [
    "PCDHGA3 CNV",
    "PCDHGA3 RNA"
  ],
  "MED14": [
    "MED14 CNV",
    "MED14 RNA",
    "MED14 Proteo"
  ],
  "EYA4": [
    "EYA4 CNV",
    "EYA4 RNA"
  ],
  "IFNA8": [
    "IFNA8 CNV",
    "IFNA8 RNA"
  ],
  "PYGO1": [
    "PYGO1 CNV",
    "PYGO1 RNA"
  ],
  "SLC6A17": [
    "SLC6A17 CNV",
    "SLC6A17 RNA",
    "SLC6A17 Proteo"
  ],
  "TSPAN32": [
    "TSPAN32 CNV",
    "TSPAN32 RNA"
  ],
  "RNF145": [
    "RNF145 CNV",
    "RNF145 RNA",
    "RNF145 Proteo"
  ],
  "OR4A1P": [
    "OR4A1P CNV",
    "OR4A1P RNA"
  ],
  "IRF3": [
    "IRF3 CNV",
    "IRF3 RNA",
    "IRF3 Proteo"
  ],
  "FKTN": [
    "FKTN CNV",
    "FKTN RNA"
  ],
  "SYNJ2": [
    "SYNJ2 CNV",
    "SYNJ2 RNA",
    "SYNJ2 Proteo"
  ],
  "MUC3A": [
    "MUC3A CNV",
    "MUC3A RNA"
  ],
  "POLR1H": [
    "POLR1H CNV",
    "POLR1H RNA",
    "POLR1H Proteo"
  ],
  "TSACC": [
    "TSACC CNV",
    "TSACC RNA"
  ],
  "E2F6": [
    "E2F6 CNV",
    "E2F6 RNA",
    "E2F6 Proteo"
  ],
  "NELFA": [
    "NELFA CNV",
    "NELFA RNA",
    "NELFA Proteo"
  ],
  "RPL21P7": [
    "RPL21P7 CNV",
    "RPL21P7 RNA"
  ],
  "ZNF740": [
    "ZNF740 CNV",
    "ZNF740 RNA",
    "ZNF740 Proteo"
  ],
  "RNF113B": [
    "RNF113B CNV",
    "RNF113B RNA"
  ],
  "USP16": [
    "USP16 CNV",
    "USP16 RNA",
    "USP16 Proteo"
  ],
  "CNOT4": [
    "CNOT4 CNV",
    "CNOT4 RNA",
    "CNOT4 Proteo"
  ],
  "AAAS": [
    "AAAS CNV",
    "AAAS RNA",
    "AAAS Proteo"
  ],
  "MMD": [
    "MMD CNV",
    "MMD RNA"
  ],
  "NELL2": [
    "NELL2 CNV",
    "NELL2 RNA"
  ],
  "TM4SF1": [
    "TM4SF1 CNV",
    "TM4SF1 RNA",
    "TM4SF1 Proteo"
  ],
  "KRT18P42": [
    "KRT18P42 CNV",
    "KRT18P42 RNA"
  ],
  "SDHDP2": [
    "SDHDP2 CNV",
    "SDHDP2 RNA"
  ],
  "HMGB1P47": [
    "HMGB1P47 CNV",
    "HMGB1P47 RNA"
  ],
  "UNC45A": [
    "UNC45A CNV",
    "UNC45A RNA",
    "UNC45A Proteo"
  ],
  "AGAP13P": [
    "AGAP13P CNV",
    "AGAP13P RNA"
  ],
  "ZNF148": [
    "ZNF148 CNV",
    "ZNF148 RNA",
    "ZNF148 Proteo"
  ],
  "IMMP1LP2": [
    "IMMP1LP2 CNV",
    "IMMP1LP2 RNA"
  ],
  "TTLL10": [
    "TTLL10 CNV",
    "TTLL10 RNA"
  ],
  "TRABD": [
    "TRABD CNV",
    "TRABD RNA",
    "TRABD Proteo"
  ],
  "EIF4E2": [
    "EIF4E2 CNV",
    "EIF4E2 RNA",
    "EIF4E2 Proteo"
  ],
  "PDLIM3": [
    "PDLIM3 CNV",
    "PDLIM3 RNA",
    "PDLIM3 Proteo"
  ],
  "FNDC3CP": [
    "FNDC3CP CNV",
    "FNDC3CP RNA"
  ],
  "HNRNPA3P6": [
    "HNRNPA3P6 CNV",
    "HNRNPA3P6 RNA"
  ],
  "ZBTB2P1": [
    "ZBTB2P1 CNV",
    "ZBTB2P1 RNA"
  ],
  "CFAP161": [
    "CFAP161 CNV",
    "CFAP161 RNA"
  ],
  "CCDC134": [
    "CCDC134 CNV",
    "CCDC134 RNA",
    "CCDC134 Proteo"
  ],
  "OR1H1P": [
    "OR1H1P CNV",
    "OR1H1P RNA"
  ],
  "HEPH": [
    "HEPH CNV",
    "HEPH RNA",
    "HEPH Proteo"
  ],
  "MAJIN": [
    "MAJIN CNV",
    "MAJIN RNA"
  ],
  "YEATS2": [
    "YEATS2 CNV",
    "YEATS2 RNA",
    "YEATS2 Proteo"
  ],
  "FAM90A11P": [
    "FAM90A11P CNV",
    "FAM90A11P RNA"
  ],
  "RPL15P1": [
    "RPL15P1 CNV",
    "RPL15P1 RNA"
  ],
  "PCGF6": [
    "PCGF6 CNV",
    "PCGF6 RNA",
    "PCGF6 Proteo"
  ],
  "ABTB2": [
    "ABTB2 CNV",
    "ABTB2 RNA",
    "ABTB2 Proteo"
  ],
  "CEP89": [
    "CEP89 CNV",
    "CEP89 RNA",
    "CEP89 Proteo"
  ],
  "MTND4LP7": [
    "MTND4LP7 CNV",
    "MTND4LP7 RNA"
  ],
  "MPHOSPH10": [
    "MPHOSPH10 CNV",
    "MPHOSPH10 RNA",
    "MPHOSPH10 Proteo"
  ],
  "GTSF1L": [
    "GTSF1L CNV",
    "GTSF1L RNA"
  ],
  "VSIG8": [
    "VSIG8 CNV",
    "VSIG8 RNA",
    "VSIG8 Proteo"
  ],
  "ERICH6B": [
    "ERICH6B CNV",
    "ERICH6B RNA"
  ],
  "SPON1": [
    "SPON1 CNV",
    "SPON1 RNA",
    "SPON1 Proteo"
  ],
  "PLA2G2C": [
    "PLA2G2C CNV",
    "PLA2G2C RNA"
  ],
  "EDNRA": [
    "EDNRA CNV",
    "EDNRA RNA"
  ],
  "CA13": [
    "CA13 CNV",
    "CA13 RNA",
    "CA13 Proteo"
  ],
  "ZNF221": [
    "ZNF221 CNV",
    "ZNF221 RNA",
    "ZNF221 Proteo"
  ],
  "CCDC162P": [
    "CCDC162P CNV",
    "CCDC162P RNA"
  ],
  "DCTD": [
    "DCTD CNV",
    "DCTD RNA",
    "DCTD Proteo"
  ],
  "IFNAR1": [
    "IFNAR1 CNV",
    "IFNAR1 RNA",
    "IFNAR1 Proteo"
  ],
  "ZNF454": [
    "ZNF454 CNV",
    "ZNF454 RNA"
  ],
  "MTND3P6": [
    "MTND3P6 CNV",
    "MTND3P6 RNA"
  ],
  "BLVRA": [
    "BLVRA CNV",
    "BLVRA RNA",
    "BLVRA Proteo"
  ],
  "PEBP4": [
    "PEBP4 CNV",
    "PEBP4 RNA"
  ],
  "MTND4P29": [
    "MTND4P29 CNV",
    "MTND4P29 RNA"
  ],
  "TNNT1": [
    "TNNT1 CNV",
    "TNNT1 RNA",
    "TNNT1 Proteo"
  ],
  "AKAP17A": [
    "AKAP17A CNV",
    "AKAP17A RNA",
    "AKAP17A Proteo"
  ],
  "POLR2M": [
    "POLR2M CNV",
    "POLR2M RNA",
    "POLR2M Proteo"
  ],
  "TMED4": [
    "TMED4 CNV",
    "TMED4 RNA",
    "TMED4 Proteo"
  ],
  "TET1": [
    "TET1 CNV",
    "TET1 RNA",
    "TET1 Proteo"
  ],
  "RAB11FIP3": [
    "RAB11FIP3 CNV",
    "RAB11FIP3 RNA",
    "RAB11FIP3 Proteo"
  ],
  "SLC9B2": [
    "SLC9B2 CNV",
    "SLC9B2 RNA",
    "SLC9B2 Proteo"
  ],
  "MOGAT2": [
    "MOGAT2 CNV",
    "MOGAT2 RNA"
  ],
  "LRRC2": [
    "LRRC2 CNV",
    "LRRC2 RNA"
  ],
  "GPR6": [
    "GPR6 CNV",
    "GPR6 RNA"
  ],
  "ACSL5": [
    "ACSL5 CNV",
    "ACSL5 RNA",
    "ACSL5 Proteo"
  ],
  "TEX12": [
    "TEX12 CNV",
    "TEX12 RNA"
  ],
  "ANKRD50": [
    "ANKRD50 CNV",
    "ANKRD50 RNA",
    "ANKRD50 Proteo"
  ],
  "RIN1": [
    "RIN1 CNV",
    "RIN1 RNA",
    "RIN1 Proteo"
  ],
  "SLC25A42": [
    "SLC25A42 CNV",
    "SLC25A42 RNA",
    "SLC25A42 Proteo"
  ],
  "RPL30P12": [
    "RPL30P12 CNV",
    "RPL30P12 RNA"
  ],
  "YME1L1P1": [
    "YME1L1P1 CNV",
    "YME1L1P1 RNA"
  ],
  "ZNF469": [
    "ZNF469 CNV",
    "ZNF469 RNA"
  ],
  "FOXN3P1": [
    "FOXN3P1 CNV",
    "FOXN3P1 RNA"
  ],
  "SEPHS1P6": [
    "SEPHS1P6 CNV",
    "SEPHS1P6 RNA"
  ],
  "WFDC21P": [
    "WFDC21P CNV",
    "WFDC21P RNA"
  ],
  "HMGN2P3": [
    "HMGN2P3 CNV",
    "HMGN2P3 RNA"
  ],
  "RPL4P4": [
    "RPL4P4 CNV",
    "RPL4P4 RNA"
  ],
  "HSPB9": [
    "HSPB9 CNV",
    "HSPB9 RNA"
  ],
  "BET1L": [
    "BET1L CNV",
    "BET1L RNA",
    "BET1L Proteo"
  ],
  "MYL10": [
    "MYL10 CNV",
    "MYL10 RNA"
  ],
  "ABCF2P2": [
    "ABCF2P2 CNV",
    "ABCF2P2 RNA"
  ],
  "TPTE2P2": [
    "TPTE2P2 CNV",
    "TPTE2P2 RNA"
  ],
  "SSB": [
    "SSB CNV",
    "SSB RNA",
    "SSB Proteo"
  ],
  "FAM25E": [
    "FAM25E CNV",
    "FAM25E RNA"
  ],
  "OR7E37P": [
    "OR7E37P CNV",
    "OR7E37P RNA"
  ],
  "KRT222": [
    "KRT222 CNV",
    "KRT222 RNA"
  ],
  "OR4A50P": [
    "OR4A50P CNV",
    "OR4A50P RNA"
  ],
  "H2AQ1P": [
    "H2AQ1P CNV",
    "H2AQ1P RNA"
  ],
  "SLC4A7": [
    "SLC4A7 CNV",
    "SLC4A7 RNA",
    "SLC4A7 Proteo"
  ],
  "TCF4": [
    "TCF4 CNV",
    "TCF4 RNA",
    "TCF4 Proteo"
  ],
  "PNP": [
    "PNP CNV",
    "PNP RNA",
    "PNP Proteo"
  ],
  "AKAP9": [
    "AKAP9 CNV",
    "AKAP9 RNA",
    "AKAP9 Proteo"
  ],
  "PPM1G": [
    "PPM1G CNV",
    "PPM1G RNA",
    "PPM1G Proteo"
  ],
  "HS6ST3": [
    "HS6ST3 CNV",
    "HS6ST3 RNA"
  ],
  "CHORDC1P1": [
    "CHORDC1P1 CNV",
    "CHORDC1P1 RNA"
  ],
  "UBTFL1": [
    "UBTFL1 CNV",
    "UBTFL1 RNA"
  ],
  "ZNF114": [
    "ZNF114 CNV",
    "ZNF114 RNA"
  ],
  "USP17L12": [
    "USP17L12 CNV",
    "USP17L12 RNA"
  ],
  "NEU4": [
    "NEU4 CNV",
    "NEU4 RNA"
  ],
  "RAB28P5": [
    "RAB28P5 CNV",
    "RAB28P5 RNA"
  ],
  "EIF4EBP1": [
    "EIF4EBP1 CNV",
    "EIF4EBP1 RNA",
    "EIF4EBP1 Proteo"
  ],
  "UHRF1BP1L": [
    "UHRF1BP1L CNV",
    "UHRF1BP1L RNA",
    "UHRF1BP1L Proteo"
  ],
  "COL6A3": [
    "COL6A3 CNV",
    "COL6A3 RNA",
    "COL6A3 Proteo"
  ],
  "ZNF655": [
    "ZNF655 CNV",
    "ZNF655 RNA",
    "ZNF655 Proteo"
  ],
  "TRMT1": [
    "TRMT1 CNV",
    "TRMT1 RNA",
    "TRMT1 Proteo"
  ],
  "RNA5SP118": [
    "RNA5SP118 CNV",
    "RNA5SP118 RNA"
  ],
  "ENOX1": [
    "ENOX1 CNV",
    "ENOX1 RNA",
    "ENOX1 Proteo"
  ],
  "CACNG7": [
    "CACNG7 CNV",
    "CACNG7 RNA"
  ],
  "BPY2B": [
    "BPY2B CNV",
    "BPY2B RNA"
  ],
  "CREBRF": [
    "CREBRF CNV",
    "CREBRF RNA"
  ],
  "NOS2P3": [
    "NOS2P3 CNV",
    "NOS2P3 RNA"
  ],
  "KCNRG": [
    "KCNRG CNV",
    "KCNRG RNA"
  ],
  "PPP3R1": [
    "PPP3R1 CNV",
    "PPP3R1 RNA",
    "PPP3R1 Proteo"
  ],
  "ENPP1": [
    "ENPP1 CNV",
    "ENPP1 RNA",
    "ENPP1 Proteo"
  ],
  "BMS1P21": [
    "BMS1P21 CNV",
    "BMS1P21 RNA"
  ],
  "NRG1": [
    "NRG1 CNV",
    "NRG1 RNA"
  ],
  "EEF1B2P4": [
    "EEF1B2P4 CNV",
    "EEF1B2P4 RNA"
  ],
  "SPRR5": [
    "SPRR5 CNV",
    "SPRR5 RNA"
  ],
  "TPMTP1": [
    "TPMTP1 CNV",
    "TPMTP1 RNA"
  ],
  "STK11IP": [
    "STK11IP CNV",
    "STK11IP RNA",
    "STK11IP Proteo"
  ],
  "MTCO2P9": [
    "MTCO2P9 CNV",
    "MTCO2P9 RNA"
  ],
  "MRPL32": [
    "MRPL32 CNV",
    "MRPL32 RNA",
    "MRPL32 Proteo"
  ],
  "AK8": [
    "AK8 CNV",
    "AK8 RNA"
  ],
  "GINS3": [
    "GINS3 CNV",
    "GINS3 RNA",
    "GINS3 Proteo"
  ],
  "MSH5": [
    "MSH5 CNV",
    "MSH5 RNA"
  ],
  "CCNJP2": [
    "CCNJP2 CNV",
    "CCNJP2 RNA"
  ],
  "IGKV1OR2-6": [
    "IGKV1OR2-6 CNV",
    "IGKV1OR2-6 RNA"
  ],
  "OR6R2P": [
    "OR6R2P CNV",
    "OR6R2P RNA"
  ],
  "UBC": [
    "UBC CNV",
    "UBC RNA",
    "UBC Proteo"
  ],
  "YBX1P9": [
    "YBX1P9 CNV",
    "YBX1P9 RNA"
  ],
  "PCBP2P2": [
    "PCBP2P2 CNV",
    "PCBP2P2 RNA"
  ],
  "MYO5A": [
    "MYO5A CNV",
    "MYO5A RNA",
    "MYO5A Proteo"
  ],
  "GSPT1": [
    "GSPT1 CNV",
    "GSPT1 RNA",
    "GSPT1 Proteo"
  ],
  "SLC38A2": [
    "SLC38A2 CNV",
    "SLC38A2 RNA",
    "SLC38A2 Proteo"
  ],
  "ZNF565": [
    "ZNF565 CNV",
    "ZNF565 RNA"
  ],
  "MRPS17P5": [
    "MRPS17P5 CNV",
    "MRPS17P5 RNA"
  ],
  "VN1R51P": [
    "VN1R51P CNV",
    "VN1R51P RNA"
  ],
  "SAPCD2P2": [
    "SAPCD2P2 CNV",
    "SAPCD2P2 RNA"
  ],
  "OR2H5P": [
    "OR2H5P CNV",
    "OR2H5P RNA"
  ],
  "CCDC18": [
    "CCDC18 CNV",
    "CCDC18 RNA"
  ],
  "GBP1": [
    "GBP1 CNV",
    "GBP1 RNA",
    "GBP1 Proteo"
  ],
  "GPR174": [
    "GPR174 CNV",
    "GPR174 RNA"
  ],
  "POM121L15P": [
    "POM121L15P CNV",
    "POM121L15P RNA"
  ],
  "MBIP": [
    "MBIP CNV",
    "MBIP RNA",
    "MBIP Proteo"
  ],
  "SCN10A": [
    "SCN10A CNV",
    "SCN10A RNA"
  ],
  "CCNE2": [
    "CCNE2 CNV",
    "CCNE2 RNA"
  ],
  "GJC2": [
    "GJC2 CNV",
    "GJC2 RNA"
  ],
  "DPAGT1": [
    "DPAGT1 CNV",
    "DPAGT1 RNA",
    "DPAGT1 Proteo"
  ],
  "VDAC2": [
    "VDAC2 CNV",
    "VDAC2 RNA",
    "VDAC2 Proteo"
  ],
  "PPIAP72": [
    "PPIAP72 CNV",
    "PPIAP72 RNA"
  ],
  "PIGN": [
    "PIGN CNV",
    "PIGN RNA",
    "PIGN Proteo"
  ],
  "MRPS33P4": [
    "MRPS33P4 CNV",
    "MRPS33P4 RNA"
  ],
  "TEX46": [
    "TEX46 CNV",
    "TEX46 RNA"
  ],
  "ZMAT4": [
    "ZMAT4 CNV",
    "ZMAT4 RNA"
  ],
  "GOLGA8O": [
    "GOLGA8O CNV",
    "GOLGA8O RNA"
  ],
  "RPL7AP75": [
    "RPL7AP75 CNV",
    "RPL7AP75 RNA"
  ],
  "SLC39A3": [
    "SLC39A3 CNV",
    "SLC39A3 RNA",
    "SLC39A3 Proteo"
  ],
  "NALF1": [
    "NALF1 CNV",
    "NALF1 RNA"
  ],
  "CACYBPP3": [
    "CACYBPP3 CNV",
    "CACYBPP3 RNA"
  ],
  "ASXL1": [
    "ASXL1 CNV",
    "ASXL1 RNA",
    "ASXL1 Proteo"
  ],
  "ZNF483": [
    "ZNF483 CNV",
    "ZNF483 RNA",
    "ZNF483 Proteo"
  ],
  "BHMT": [
    "BHMT CNV",
    "BHMT RNA"
  ],
  "MTHFD2P5": [
    "MTHFD2P5 CNV",
    "MTHFD2P5 RNA"
  ],
  "NBPF3": [
    "NBPF3 CNV",
    "NBPF3 RNA"
  ],
  "HNRNPA1P63": [
    "HNRNPA1P63 CNV",
    "HNRNPA1P63 RNA"
  ],
  "HSPA5P1": [
    "HSPA5P1 CNV",
    "HSPA5P1 RNA"
  ],
  "RCE1": [
    "RCE1 CNV",
    "RCE1 RNA",
    "RCE1 Proteo"
  ],
  "DUOX2": [
    "DUOX2 CNV",
    "DUOX2 RNA"
  ],
  "S100A6": [
    "S100A6 CNV",
    "S100A6 RNA",
    "S100A6 Proteo"
  ],
  "LRRC18": [
    "LRRC18 CNV",
    "LRRC18 RNA"
  ],
  "PPM1E": [
    "PPM1E CNV",
    "PPM1E RNA",
    "PPM1E Proteo"
  ],
  "PROB1": [
    "PROB1 CNV",
    "PROB1 RNA"
  ],
  "RAD50": [
    "RAD50 CNV",
    "RAD50 RNA",
    "RAD50 Proteo"
  ],
  "XRCC6P1": [
    "XRCC6P1 CNV",
    "XRCC6P1 RNA"
  ],
  "CREBL2": [
    "CREBL2 CNV",
    "CREBL2 RNA"
  ],
  "TMEM181": [
    "TMEM181 CNV",
    "TMEM181 RNA",
    "TMEM181 Proteo"
  ],
  "SMYD4": [
    "SMYD4 CNV",
    "SMYD4 RNA",
    "SMYD4 Proteo"
  ],
  "C3orf85": [
    "C3orf85 CNV",
    "C3orf85 RNA"
  ],
  "MRPL10": [
    "MRPL10 CNV",
    "MRPL10 RNA",
    "MRPL10 Proteo"
  ],
  "LRATD2": [
    "LRATD2 CNV",
    "LRATD2 RNA",
    "LRATD2 Proteo"
  ],
  "DHRS4": [
    "DHRS4 CNV",
    "DHRS4 RNA",
    "DHRS4 Proteo"
  ],
  "CENPX": [
    "CENPX CNV",
    "CENPX RNA",
    "CENPX Proteo"
  ],
  "SLC25A6P1": [
    "SLC25A6P1 CNV",
    "SLC25A6P1 RNA"
  ],
  "C1QTNF7": [
    "C1QTNF7 CNV",
    "C1QTNF7 RNA"
  ],
  "IRAK2": [
    "IRAK2 CNV",
    "IRAK2 RNA",
    "IRAK2 Proteo"
  ],
  "PON3": [
    "PON3 CNV",
    "PON3 RNA",
    "PON3 Proteo"
  ],
  "TGS1": [
    "TGS1 CNV",
    "TGS1 RNA",
    "TGS1 Proteo"
  ],
  "PPIAP1": [
    "PPIAP1 CNV",
    "PPIAP1 RNA"
  ],
  "POLR2MP1": [
    "POLR2MP1 CNV",
    "POLR2MP1 RNA"
  ],
  "INTS10": [
    "INTS10 CNV",
    "INTS10 RNA",
    "INTS10 Proteo"
  ],
  "RPL5P2": [
    "RPL5P2 CNV",
    "RPL5P2 RNA"
  ],
  "PCDHB7": [
    "PCDHB7 CNV",
    "PCDHB7 RNA"
  ],
  "CLDN23": [
    "CLDN23 CNV",
    "CLDN23 RNA"
  ],
  "SPDYE14": [
    "SPDYE14 CNV",
    "SPDYE14 RNA"
  ],
  "SLC6A18": [
    "SLC6A18 CNV",
    "SLC6A18 RNA"
  ],
  "H3P23": [
    "H3P23 CNV",
    "H3P23 RNA"
  ],
  "NEK2P4": [
    "NEK2P4 CNV",
    "NEK2P4 RNA"
  ],
  "RPL21P92": [
    "RPL21P92 CNV",
    "RPL21P92 RNA"
  ],
  "LAMTOR5": [
    "LAMTOR5 CNV",
    "LAMTOR5 RNA",
    "LAMTOR5 Proteo"
  ],
  "RSU1P1": [
    "RSU1P1 CNV",
    "RSU1P1 RNA"
  ],
  "ABCC12": [
    "ABCC12 CNV",
    "ABCC12 RNA"
  ],
  "RNA5SP488": [
    "RNA5SP488 CNV",
    "RNA5SP488 RNA"
  ],
  "UBE2L3": [
    "UBE2L3 CNV",
    "UBE2L3 RNA",
    "UBE2L3 Proteo"
  ],
  "RPN1": [
    "RPN1 CNV",
    "RPN1 RNA",
    "RPN1 Proteo"
  ],
  "RAD1P1": [
    "RAD1P1 CNV",
    "RAD1P1 RNA"
  ],
  "RNF32": [
    "RNF32 CNV",
    "RNF32 RNA"
  ],
  "GAPDHP25": [
    "GAPDHP25 CNV",
    "GAPDHP25 RNA"
  ],
  "REG4": [
    "REG4 CNV",
    "REG4 RNA"
  ],
  "BEAN1": [
    "BEAN1 CNV",
    "BEAN1 RNA"
  ],
  "C8orf48": [
    "C8orf48 CNV",
    "C8orf48 RNA"
  ],
  "CRNKL1": [
    "CRNKL1 CNV",
    "CRNKL1 RNA",
    "CRNKL1 Proteo"
  ],
  "TIPINP1": [
    "TIPINP1 CNV",
    "TIPINP1 RNA"
  ],
  "CHTF18": [
    "CHTF18 CNV",
    "CHTF18 RNA",
    "CHTF18 Proteo"
  ],
  "ABHD17AP4": [
    "ABHD17AP4 CNV",
    "ABHD17AP4 RNA"
  ],
  "RAC1P8": [
    "RAC1P8 CNV",
    "RAC1P8 RNA"
  ],
  "MT1E": [
    "MT1E CNV",
    "MT1E RNA",
    "MT1E Proteo"
  ],
  "EVPLL": [
    "EVPLL CNV",
    "EVPLL RNA"
  ],
  "RSL24D1P11": [
    "RSL24D1P11 CNV",
    "RSL24D1P11 RNA"
  ],
  "IGHV3-29": [
    "IGHV3-29 CNV",
    "IGHV3-29 RNA"
  ],
  "KRTAP12-4": [
    "KRTAP12-4 CNV",
    "KRTAP12-4 RNA"
  ],
  "RPS27AP3": [
    "RPS27AP3 CNV",
    "RPS27AP3 RNA"
  ],
  "RPL21P8": [
    "RPL21P8 CNV",
    "RPL21P8 RNA"
  ],
  "LARP4": [
    "LARP4 CNV",
    "LARP4 RNA",
    "LARP4 Proteo"
  ],
  "LMOD3": [
    "LMOD3 CNV",
    "LMOD3 RNA",
    "LMOD3 Proteo"
  ],
  "SSU72P5": [
    "SSU72P5 CNV",
    "SSU72P5 RNA"
  ],
  "MARCHF2": [
    "MARCHF2 CNV",
    "MARCHF2 RNA"
  ],
  "FAM151B": [
    "FAM151B CNV",
    "FAM151B RNA",
    "FAM151B Proteo"
  ],
  "BCL7C": [
    "BCL7C CNV",
    "BCL7C RNA",
    "BCL7C Proteo"
  ],
  "KCNH7": [
    "KCNH7 CNV",
    "KCNH7 RNA"
  ],
  "MAPK8IP1": [
    "MAPK8IP1 CNV",
    "MAPK8IP1 RNA"
  ],
  "TUBA3FP": [
    "TUBA3FP CNV",
    "TUBA3FP RNA"
  ],
  "IER3IP1": [
    "IER3IP1 CNV",
    "IER3IP1 RNA",
    "IER3IP1 Proteo"
  ],
  "LPIN1": [
    "LPIN1 CNV",
    "LPIN1 RNA",
    "LPIN1 Proteo"
  ],
  "OSBPL3": [
    "OSBPL3 CNV",
    "OSBPL3 RNA",
    "OSBPL3 Proteo"
  ],
  "PHACTR4": [
    "PHACTR4 CNV",
    "PHACTR4 RNA",
    "PHACTR4 Proteo"
  ],
  "RPS4XP12": [
    "RPS4XP12 CNV",
    "RPS4XP12 RNA"
  ],
  "ANK1": [
    "ANK1 CNV",
    "ANK1 RNA",
    "ANK1 Proteo"
  ],
  "CPNE1": [
    "CPNE1 CNV",
    "CPNE1 RNA",
    "CPNE1 Proteo"
  ],
  "PTMAP2": [
    "PTMAP2 CNV",
    "PTMAP2 RNA"
  ],
  "SDC4": [
    "SDC4 CNV",
    "SDC4 RNA",
    "SDC4 Proteo"
  ],
  "OR1D4": [
    "OR1D4 CNV",
    "OR1D4 RNA"
  ],
  "PGAM1P9": [
    "PGAM1P9 CNV",
    "PGAM1P9 RNA"
  ],
  "ATP6V1B1": [
    "ATP6V1B1 CNV",
    "ATP6V1B1 RNA",
    "ATP6V1B1 Proteo"
  ],
  "AHI1": [
    "AHI1 CNV",
    "AHI1 RNA"
  ],
  "IGSF3": [
    "IGSF3 CNV",
    "IGSF3 RNA",
    "IGSF3 Proteo"
  ],
  "MGAT1": [
    "MGAT1 CNV",
    "MGAT1 RNA",
    "MGAT1 Proteo"
  ],
  "POU6F2": [
    "POU6F2 CNV",
    "POU6F2 RNA"
  ],
  "LIM2": [
    "LIM2 CNV",
    "LIM2 RNA"
  ],
  "GTF2IP8": [
    "GTF2IP8 CNV",
    "GTF2IP8 RNA"
  ],
  "DIMT1P1": [
    "DIMT1P1 CNV",
    "DIMT1P1 RNA"
  ],
  "IGKV3-20": [
    "IGKV3-20 Proteo"
  ],
  "SPEM3": [
    "SPEM3 CNV",
    "SPEM3 RNA"
  ],
  "SERTM1": [
    "SERTM1 CNV",
    "SERTM1 RNA"
  ],
  "TSPY13P": [
    "TSPY13P CNV",
    "TSPY13P RNA"
  ],
  "SMO": [
    "SMO CNV",
    "SMO RNA",
    "SMO Proteo"
  ],
  "NLRX1": [
    "NLRX1 CNV",
    "NLRX1 RNA",
    "NLRX1 Proteo"
  ],
  "LPCAT1": [
    "LPCAT1 CNV",
    "LPCAT1 RNA",
    "LPCAT1 Proteo"
  ],
  "KDM5D": [
    "KDM5D CNV",
    "KDM5D RNA",
    "KDM5D Proteo"
  ],
  "KDSR": [
    "KDSR CNV",
    "KDSR RNA",
    "KDSR Proteo"
  ],
  "EI24": [
    "EI24 CNV",
    "EI24 RNA",
    "EI24 Proteo"
  ],
  "RRAGA": [
    "RRAGA CNV",
    "RRAGA RNA",
    "RRAGA Proteo"
  ],
  "MATR3": [
    "MATR3 CNV",
    "MATR3 RNA",
    "MATR3 Proteo"
  ],
  "WNT1": [
    "WNT1 CNV",
    "WNT1 RNA"
  ],
  "NKX6-3": [
    "NKX6-3 CNV",
    "NKX6-3 RNA"
  ],
  "RPL17P20": [
    "RPL17P20 CNV",
    "RPL17P20 RNA"
  ],
  "DMRTA2": [
    "DMRTA2 CNV",
    "DMRTA2 RNA"
  ],
  "LRRC10B": [
    "LRRC10B CNV",
    "LRRC10B RNA"
  ],
  "CFLAR": [
    "CFLAR CNV",
    "CFLAR RNA",
    "CFLAR Proteo"
  ],
  "ARID5B": [
    "ARID5B CNV",
    "ARID5B RNA",
    "ARID5B Proteo"
  ],
  "CLUL1": [
    "CLUL1 CNV",
    "CLUL1 RNA"
  ],
  "TOP2A": [
    "TOP2A CNV",
    "TOP2A RNA",
    "TOP2A Proteo"
  ],
  "PTGFRN": [
    "PTGFRN CNV",
    "PTGFRN RNA",
    "PTGFRN Proteo"
  ],
  "XAGE5": [
    "XAGE5 CNV",
    "XAGE5 RNA"
  ],
  "POLR3E": [
    "POLR3E CNV",
    "POLR3E RNA",
    "POLR3E Proteo"
  ],
  "GPATCH1": [
    "GPATCH1 CNV",
    "GPATCH1 RNA",
    "GPATCH1 Proteo"
  ],
  "SLC26A3": [
    "SLC26A3 CNV",
    "SLC26A3 RNA"
  ],
  "OR7E121P": [
    "OR7E121P CNV",
    "OR7E121P RNA"
  ],
  "RELL2": [
    "RELL2 CNV",
    "RELL2 RNA"
  ],
  "AIF1": [
    "AIF1 CNV",
    "AIF1 RNA",
    "AIF1 Proteo"
  ],
  "CCT6P1": [
    "CCT6P1 CNV",
    "CCT6P1 RNA"
  ],
  "BAZ1B": [
    "BAZ1B CNV",
    "BAZ1B RNA",
    "BAZ1B Proteo"
  ],
  "EYA3": [
    "EYA3 CNV",
    "EYA3 RNA",
    "EYA3 Proteo"
  ],
  "NDUFB9P1": [
    "NDUFB9P1 CNV",
    "NDUFB9P1 RNA"
  ],
  "VRTN": [
    "VRTN CNV",
    "VRTN RNA"
  ],
  "SPATA31D5P": [
    "SPATA31D5P CNV",
    "SPATA31D5P RNA"
  ],
  "DBX2": [
    "DBX2 CNV",
    "DBX2 RNA"
  ],
  "PARD6B": [
    "PARD6B CNV",
    "PARD6B RNA",
    "PARD6B Proteo"
  ],
  "PVALEF": [
    "PVALEF CNV",
    "PVALEF RNA"
  ],
  "RNA5SP284": [
    "RNA5SP284 CNV",
    "RNA5SP284 RNA"
  ],
  "OR6Y1": [
    "OR6Y1 CNV",
    "OR6Y1 RNA"
  ],
  "DUOX1": [
    "DUOX1 CNV",
    "DUOX1 RNA",
    "DUOX1 Proteo"
  ],
  "APP": [
    "APP CNV",
    "APP RNA",
    "APP Proteo"
  ],
  "IGHV3OR16-16": [
    "IGHV3OR16-16 CNV",
    "IGHV3OR16-16 RNA"
  ],
  "CHKB": [
    "CHKB CNV",
    "CHKB RNA",
    "CHKB Proteo"
  ],
  "KRTAP19-6": [
    "KRTAP19-6 CNV",
    "KRTAP19-6 RNA"
  ],
  "CYP3A51P": [
    "CYP3A51P CNV",
    "CYP3A51P RNA"
  ],
  "CRELD2": [
    "CRELD2 CNV",
    "CRELD2 RNA",
    "CRELD2 Proteo"
  ],
  "ATP6V1B2": [
    "ATP6V1B2 CNV",
    "ATP6V1B2 RNA",
    "ATP6V1B2 Proteo"
  ],
  "ELOCP14": [
    "ELOCP14 CNV",
    "ELOCP14 RNA"
  ],
  "SKA2P1": [
    "SKA2P1 CNV",
    "SKA2P1 RNA"
  ],
  "BMI1": [
    "BMI1 CNV",
    "BMI1 RNA"
  ],
  "PNPO": [
    "PNPO CNV",
    "PNPO RNA",
    "PNPO Proteo"
  ],
  "ZBTB41": [
    "ZBTB41 CNV",
    "ZBTB41 RNA",
    "ZBTB41 Proteo"
  ],
  "TMEM47": [
    "TMEM47 CNV",
    "TMEM47 RNA"
  ],
  "ARGFXP2": [
    "ARGFXP2 CNV",
    "ARGFXP2 RNA"
  ],
  "STMP1": [
    "STMP1 CNV",
    "STMP1 RNA"
  ],
  "SERPINB7": [
    "SERPINB7 CNV",
    "SERPINB7 RNA",
    "SERPINB7 Proteo"
  ],
  "GUSBP7": [
    "GUSBP7 CNV",
    "GUSBP7 RNA"
  ],
  "HDGF": [
    "HDGF CNV",
    "HDGF RNA",
    "HDGF Proteo"
  ],
  "PGAP1": [
    "PGAP1 CNV",
    "PGAP1 RNA",
    "PGAP1 Proteo"
  ],
  "IGHV3-79": [
    "IGHV3-79 CNV",
    "IGHV3-79 RNA"
  ],
  "DTNA": [
    "DTNA CNV",
    "DTNA RNA",
    "DTNA Proteo"
  ],
  "DUXAP9": [
    "DUXAP9 CNV",
    "DUXAP9 RNA"
  ],
  "CCDC142": [
    "CCDC142 CNV",
    "CCDC142 RNA"
  ],
  "BNIP3P22": [
    "BNIP3P22 CNV",
    "BNIP3P22 RNA"
  ],
  "CYP2G1P": [
    "CYP2G1P CNV",
    "CYP2G1P RNA"
  ],
  "C1R": [
    "C1R CNV",
    "C1R RNA",
    "C1R Proteo"
  ],
  "P2RY10BP": [
    "P2RY10BP CNV",
    "P2RY10BP RNA"
  ],
  "ZNF839P1": [
    "ZNF839P1 CNV",
    "ZNF839P1 RNA"
  ],
  "PMAIP1": [
    "PMAIP1 CNV",
    "PMAIP1 RNA",
    "PMAIP1 Proteo"
  ],
  "RBBP4": [
    "RBBP4 CNV",
    "RBBP4 RNA",
    "RBBP4 Proteo"
  ],
  "DLK2": [
    "DLK2 CNV",
    "DLK2 RNA"
  ],
  "PER1": [
    "PER1 CNV",
    "PER1 RNA",
    "PER1 Proteo"
  ],
  "C2CD2L": [
    "C2CD2L CNV",
    "C2CD2L RNA",
    "C2CD2L Proteo"
  ],
  "SDHD": [
    "SDHD CNV",
    "SDHD RNA",
    "SDHD Proteo"
  ],
  "ABCD1P5": [
    "ABCD1P5 CNV",
    "ABCD1P5 RNA"
  ],
  "HRC": [
    "HRC CNV",
    "HRC RNA",
    "HRC Proteo"
  ],
  "RSRC1": [
    "RSRC1 CNV",
    "RSRC1 RNA",
    "RSRC1 Proteo"
  ],
  "RBM11": [
    "RBM11 CNV",
    "RBM11 RNA"
  ],
  "C19orf81": [
    "C19orf81 CNV",
    "C19orf81 RNA"
  ],
  "ARMC2": [
    "ARMC2 CNV",
    "ARMC2 RNA"
  ],
  "FGL2": [
    "FGL2 CNV",
    "FGL2 RNA",
    "FGL2 Proteo"
  ],
  "SEPHS1P7": [
    "SEPHS1P7 CNV",
    "SEPHS1P7 RNA"
  ],
  "SPTLC1P5": [
    "SPTLC1P5 CNV",
    "SPTLC1P5 RNA"
  ],
  "APOC4": [
    "APOC4 CNV",
    "APOC4 RNA"
  ],
  "TNFSF18": [
    "TNFSF18 CNV",
    "TNFSF18 RNA"
  ],
  "REXO1L4P": [
    "REXO1L4P CNV",
    "REXO1L4P RNA"
  ],
  "TRRAP": [
    "TRRAP CNV",
    "TRRAP RNA",
    "TRRAP Proteo"
  ],
  "HOXA4": [
    "HOXA4 CNV",
    "HOXA4 RNA"
  ],
  "WBP1LP6": [
    "WBP1LP6 CNV",
    "WBP1LP6 RNA"
  ],
  "SUMO2P4": [
    "SUMO2P4 CNV",
    "SUMO2P4 RNA"
  ],
  "TXNDC5": [
    "TXNDC5 CNV",
    "TXNDC5 RNA",
    "TXNDC5 Proteo"
  ],
  "PDE6H": [
    "PDE6H CNV",
    "PDE6H RNA"
  ],
  "ERGIC2": [
    "ERGIC2 CNV",
    "ERGIC2 RNA",
    "ERGIC2 Proteo"
  ],
  "CPSF2": [
    "CPSF2 CNV",
    "CPSF2 RNA",
    "CPSF2 Proteo"
  ],
  "ARHGDIG": [
    "ARHGDIG CNV",
    "ARHGDIG RNA"
  ],
  "PRSS55": [
    "PRSS55 CNV",
    "PRSS55 RNA"
  ],
  "MAP3K5": [
    "MAP3K5 CNV",
    "MAP3K5 RNA",
    "MAP3K5 Proteo"
  ],
  "POLE2": [
    "POLE2 CNV",
    "POLE2 RNA",
    "POLE2 Proteo"
  ],
  "GABPAP": [
    "GABPAP CNV",
    "GABPAP RNA"
  ],
  "MRPS35": [
    "MRPS35 CNV",
    "MRPS35 RNA",
    "MRPS35 Proteo"
  ],
  "EMC9": [
    "EMC9 CNV",
    "EMC9 RNA",
    "EMC9 Proteo"
  ],
  "CCDC127": [
    "CCDC127 CNV",
    "CCDC127 RNA",
    "CCDC127 Proteo"
  ],
  "ETF1P2": [
    "ETF1P2 CNV",
    "ETF1P2 RNA"
  ],
  "YWHAZP6": [
    "YWHAZP6 CNV",
    "YWHAZP6 RNA"
  ],
  "ZMAT5": [
    "ZMAT5 CNV",
    "ZMAT5 RNA",
    "ZMAT5 Proteo"
  ],
  "FGD4": [
    "FGD4 CNV",
    "FGD4 RNA",
    "FGD4 Proteo"
  ],
  "IGKV1-32": [
    "IGKV1-32 CNV",
    "IGKV1-32 RNA"
  ],
  "ACIN1": [
    "ACIN1 CNV",
    "ACIN1 RNA",
    "ACIN1 Proteo"
  ],
  "KLF2P4": [
    "KLF2P4 CNV",
    "KLF2P4 RNA"
  ],
  "KCNMB1": [
    "KCNMB1 CNV",
    "KCNMB1 RNA"
  ],
  "FAM136BP": [
    "FAM136BP CNV",
    "FAM136BP RNA"
  ],
  "HSBP1": [
    "HSBP1 CNV",
    "HSBP1 RNA",
    "HSBP1 Proteo"
  ],
  "ALDOC": [
    "ALDOC CNV",
    "ALDOC RNA",
    "ALDOC Proteo"
  ],
  "PVALB": [
    "PVALB CNV",
    "PVALB RNA",
    "PVALB Proteo"
  ],
  "VN1R88P": [
    "VN1R88P CNV",
    "VN1R88P RNA"
  ],
  "GCAT": [
    "GCAT CNV",
    "GCAT RNA",
    "GCAT Proteo"
  ],
  "UTP14A": [
    "UTP14A CNV",
    "UTP14A RNA",
    "UTP14A Proteo"
  ],
  "NDC1": [
    "NDC1 CNV",
    "NDC1 RNA",
    "NDC1 Proteo"
  ],
  "KRT18P63": [
    "KRT18P63 CNV",
    "KRT18P63 RNA"
  ],
  "RPL9": [
    "RPL9 CNV",
    "RPL9 RNA",
    "RPL9 Proteo"
  ],
  "DSTN": [
    "DSTN CNV",
    "DSTN RNA",
    "DSTN Proteo"
  ],
  "REREP2Y": [
    "REREP2Y CNV",
    "REREP2Y RNA"
  ],
  "MDH1B": [
    "MDH1B CNV",
    "MDH1B RNA"
  ],
  "HSBP1P2": [
    "HSBP1P2 CNV",
    "HSBP1P2 RNA"
  ],
  "GLYATL1P1": [
    "GLYATL1P1 CNV",
    "GLYATL1P1 RNA"
  ],
  "DDOST": [
    "DDOST CNV",
    "DDOST RNA",
    "DDOST Proteo"
  ],
  "ANKRD20A19P": [
    "ANKRD20A19P CNV",
    "ANKRD20A19P RNA"
  ],
  "NMB": [
    "NMB CNV",
    "NMB RNA"
  ],
  "ACTN3": [
    "ACTN3 CNV",
    "ACTN3 RNA",
    "ACTN3 Proteo"
  ],
  "SF3B1": [
    "SF3B1 CNV",
    "SF3B1 RNA",
    "SF3B1 Proteo"
  ],
  "CTDSP2": [
    "CTDSP2 CNV",
    "CTDSP2 RNA"
  ],
  "DNAJB6P4": [
    "DNAJB6P4 CNV",
    "DNAJB6P4 RNA"
  ],
  "ST6GALNAC4": [
    "ST6GALNAC4 CNV",
    "ST6GALNAC4 RNA"
  ],
  "IL11RA": [
    "IL11RA CNV",
    "IL11RA RNA"
  ],
  "EBI3": [
    "EBI3 CNV",
    "EBI3 RNA"
  ],
  "ACADS": [
    "ACADS CNV",
    "ACADS RNA",
    "ACADS Proteo"
  ],
  "CPA3": [
    "CPA3 CNV",
    "CPA3 RNA",
    "CPA3 Proteo"
  ],
  "ICAM5": [
    "ICAM5 CNV",
    "ICAM5 RNA",
    "ICAM5 Proteo"
  ],
  "SLC35G2": [
    "SLC35G2 CNV",
    "SLC35G2 RNA"
  ],
  "NOP56P3": [
    "NOP56P3 CNV",
    "NOP56P3 RNA"
  ],
  "SSX2IP": [
    "SSX2IP CNV",
    "SSX2IP RNA",
    "SSX2IP Proteo"
  ],
  "BTF3P8": [
    "BTF3P8 CNV",
    "BTF3P8 RNA"
  ],
  "CICP23": [
    "CICP23 CNV",
    "CICP23 RNA"
  ],
  "BTBD7P1": [
    "BTBD7P1 CNV",
    "BTBD7P1 RNA"
  ],
  "AHCYP3": [
    "AHCYP3 CNV",
    "AHCYP3 RNA"
  ],
  "FAM220BP": [
    "FAM220BP CNV",
    "FAM220BP RNA"
  ],
  "XAGE3": [
    "XAGE3 CNV",
    "XAGE3 RNA"
  ],
  "FGD1": [
    "FGD1 CNV",
    "FGD1 RNA",
    "FGD1 Proteo"
  ],
  "RPS27AP16": [
    "RPS27AP16 CNV",
    "RPS27AP16 RNA"
  ],
  "PYGB": [
    "PYGB CNV",
    "PYGB RNA",
    "PYGB Proteo"
  ],
  "KANK4": [
    "KANK4 CNV",
    "KANK4 RNA"
  ],
  "SSRP1": [
    "SSRP1 CNV",
    "SSRP1 RNA",
    "SSRP1 Proteo"
  ],
  "RNA5SP310": [
    "RNA5SP310 CNV",
    "RNA5SP310 RNA"
  ],
  "CRIP1P4": [
    "CRIP1P4 CNV",
    "CRIP1P4 RNA"
  ],
  "SAYSD1": [
    "SAYSD1 CNV",
    "SAYSD1 RNA",
    "SAYSD1 Proteo"
  ],
  "RNA5SP162": [
    "RNA5SP162 CNV",
    "RNA5SP162 RNA"
  ],
  "MYLK3": [
    "MYLK3 CNV",
    "MYLK3 RNA"
  ],
  "SLC5A7": [
    "SLC5A7 CNV",
    "SLC5A7 RNA"
  ],
  "TANGO2": [
    "TANGO2 CNV",
    "TANGO2 RNA",
    "TANGO2 Proteo"
  ],
  "NECTIN2": [
    "NECTIN2 CNV",
    "NECTIN2 RNA",
    "NECTIN2 Proteo"
  ],
  "SLITRK5": [
    "SLITRK5 CNV",
    "SLITRK5 RNA"
  ],
  "MRGBP": [
    "MRGBP CNV",
    "MRGBP RNA",
    "MRGBP Proteo"
  ],
  "QPCT": [
    "QPCT CNV",
    "QPCT RNA",
    "QPCT Proteo"
  ],
  "OR7D2": [
    "OR7D2 CNV",
    "OR7D2 RNA"
  ],
  "HCN4": [
    "HCN4 CNV",
    "HCN4 RNA"
  ],
  "IGLL1": [
    "IGLL1 CNV",
    "IGLL1 RNA",
    "IGLL1 Proteo"
  ],
  "HSPA1A": [
    "HSPA1A CNV",
    "HSPA1A RNA"
  ],
  "BNIP3P8": [
    "BNIP3P8 CNV",
    "BNIP3P8 RNA"
  ],
  "CXADRP2": [
    "CXADRP2 CNV",
    "CXADRP2 RNA"
  ],
  "NKX2-3": [
    "NKX2-3 CNV",
    "NKX2-3 RNA"
  ],
  "ICAM2": [
    "ICAM2 CNV",
    "ICAM2 RNA",
    "ICAM2 Proteo"
  ],
  "CLCN5": [
    "CLCN5 CNV",
    "CLCN5 RNA",
    "CLCN5 Proteo"
  ],
  "C16orf72": [
    "C16orf72 CNV",
    "C16orf72 RNA",
    "C16orf72 Proteo"
  ],
  "NOP10": [
    "NOP10 CNV",
    "NOP10 RNA",
    "NOP10 Proteo"
  ],
  "FAM90A5P": [
    "FAM90A5P CNV",
    "FAM90A5P RNA"
  ],
  "PLB1": [
    "PLB1 CNV",
    "PLB1 RNA"
  ],
  "ITGA7": [
    "ITGA7 CNV",
    "ITGA7 RNA",
    "ITGA7 Proteo"
  ],
  "SUMO2P14": [
    "SUMO2P14 CNV",
    "SUMO2P14 RNA"
  ],
  "RBM4": [
    "RBM4 CNV",
    "RBM4 RNA",
    "RBM4 Proteo"
  ],
  "KRTAP19-7": [
    "KRTAP19-7 CNV",
    "KRTAP19-7 RNA"
  ],
  "SLC25A26": [
    "SLC25A26 CNV",
    "SLC25A26 RNA",
    "SLC25A26 Proteo"
  ],
  "DNAI3": [
    "DNAI3 CNV",
    "DNAI3 RNA"
  ],
  "ACTBP15": [
    "ACTBP15 CNV",
    "ACTBP15 RNA"
  ],
  "ZNF208": [
    "ZNF208 CNV",
    "ZNF208 RNA"
  ],
  "NCF2": [
    "NCF2 CNV",
    "NCF2 RNA",
    "NCF2 Proteo"
  ],
  "HPGDS": [
    "HPGDS CNV",
    "HPGDS RNA",
    "HPGDS Proteo"
  ],
  "PRIMPOL": [
    "PRIMPOL CNV",
    "PRIMPOL RNA",
    "PRIMPOL Proteo"
  ],
  "OR4E2": [
    "OR4E2 CNV",
    "OR4E2 RNA"
  ],
  "KHDC1L": [
    "KHDC1L CNV",
    "KHDC1L RNA"
  ],
  "EIF4E2P2": [
    "EIF4E2P2 CNV",
    "EIF4E2P2 RNA"
  ],
  "KRR1": [
    "KRR1 CNV",
    "KRR1 RNA",
    "KRR1 Proteo"
  ],
  "CDK12": [
    "CDK12 CNV",
    "CDK12 RNA",
    "CDK12 Proteo"
  ],
  "ZC3H3": [
    "ZC3H3 CNV",
    "ZC3H3 RNA",
    "ZC3H3 Proteo"
  ],
  "PTDSS1": [
    "PTDSS1 CNV",
    "PTDSS1 RNA",
    "PTDSS1 Proteo"
  ],
  "RPL26P36": [
    "RPL26P36 CNV",
    "RPL26P36 RNA"
  ],
  "SGO1P2": [
    "SGO1P2 CNV",
    "SGO1P2 RNA"
  ],
  "RPL7AP31": [
    "RPL7AP31 CNV",
    "RPL7AP31 RNA"
  ],
  "CDKN2A": [
    "CDKN2A CNV",
    "CDKN2A RNA",
    "CDKN2A Proteo"
  ],
  "TAS2R60": [
    "TAS2R60 CNV",
    "TAS2R60 RNA"
  ],
  "GIP": [
    "GIP CNV",
    "GIP RNA"
  ],
  "ANKRD20A2P": [
    "ANKRD20A2P CNV",
    "ANKRD20A2P RNA"
  ],
  "MYL12AP1": [
    "MYL12AP1 CNV",
    "MYL12AP1 RNA"
  ],
  "HMGB1P7": [
    "HMGB1P7 CNV",
    "HMGB1P7 RNA"
  ],
  "GOLGA2P11": [
    "GOLGA2P11 CNV",
    "GOLGA2P11 RNA"
  ],
  "MEAF6": [
    "MEAF6 CNV",
    "MEAF6 RNA",
    "MEAF6 Proteo"
  ],
  "RPN2": [
    "RPN2 CNV",
    "RPN2 RNA",
    "RPN2 Proteo"
  ],
  "IGLV1-41": [
    "IGLV1-41 CNV",
    "IGLV1-41 RNA"
  ],
  "ATIC": [
    "ATIC CNV",
    "ATIC RNA",
    "ATIC Proteo"
  ],
  "GJA10": [
    "GJA10 CNV",
    "GJA10 RNA"
  ],
  "CSTF1": [
    "CSTF1 CNV",
    "CSTF1 RNA",
    "CSTF1 Proteo"
  ],
  "UBTD2": [
    "UBTD2 CNV",
    "UBTD2 RNA",
    "UBTD2 Proteo"
  ],
  "ITGA8": [
    "ITGA8 CNV",
    "ITGA8 RNA",
    "ITGA8 Proteo"
  ],
  "HDGFL2": [
    "HDGFL2 CNV",
    "HDGFL2 RNA",
    "HDGFL2 Proteo"
  ],
  "TMCO4": [
    "TMCO4 CNV",
    "TMCO4 RNA",
    "TMCO4 Proteo"
  ],
  "NMBR": [
    "NMBR CNV",
    "NMBR RNA"
  ],
  "TTC9C": [
    "TTC9C CNV",
    "TTC9C RNA",
    "TTC9C Proteo"
  ],
  "OR2M2": [
    "OR2M2 CNV",
    "OR2M2 RNA"
  ],
  "RPL21P90": [
    "RPL21P90 CNV",
    "RPL21P90 RNA"
  ],
  "SEC31B": [
    "SEC31B CNV",
    "SEC31B RNA"
  ],
  "RPS3AP52": [
    "RPS3AP52 CNV",
    "RPS3AP52 RNA"
  ],
  "SGTA": [
    "SGTA CNV",
    "SGTA RNA",
    "SGTA Proteo"
  ],
  "RBM17": [
    "RBM17 CNV",
    "RBM17 RNA",
    "RBM17 Proteo"
  ],
  "DGLUCY": [
    "DGLUCY CNV",
    "DGLUCY RNA",
    "DGLUCY Proteo"
  ],
  "AMY2B": [
    "AMY2B CNV",
    "AMY2B RNA"
  ],
  "WASHC2A": [
    "WASHC2A CNV",
    "WASHC2A RNA",
    "WASHC2A Proteo"
  ],
  "PTER": [
    "PTER CNV",
    "PTER RNA",
    "PTER Proteo"
  ],
  "METTL7A": [
    "METTL7A CNV",
    "METTL7A RNA",
    "METTL7A Proteo"
  ],
  "PLEKHF1": [
    "PLEKHF1 CNV",
    "PLEKHF1 RNA",
    "PLEKHF1 Proteo"
  ],
  "RPL23AP61": [
    "RPL23AP61 CNV",
    "RPL23AP61 RNA"
  ],
  "IGLV3-29": [
    "IGLV3-29 CNV",
    "IGLV3-29 RNA"
  ],
  "MEIG1": [
    "MEIG1 CNV",
    "MEIG1 RNA"
  ],
  "THOP1": [
    "THOP1 CNV",
    "THOP1 RNA",
    "THOP1 Proteo"
  ],
  "OR56B2P": [
    "OR56B2P CNV",
    "OR56B2P RNA"
  ],
  "UPF3AP1": [
    "UPF3AP1 CNV",
    "UPF3AP1 RNA"
  ],
  "PRDX2P1": [
    "PRDX2P1 CNV",
    "PRDX2P1 RNA"
  ],
  "EEF1A1P48": [
    "EEF1A1P48 CNV",
    "EEF1A1P48 RNA"
  ],
  "BBS9": [
    "BBS9 CNV",
    "BBS9 RNA",
    "BBS9 Proteo"
  ],
  "OR10H1": [
    "OR10H1 CNV",
    "OR10H1 RNA"
  ],
  "SIRPD": [
    "SIRPD CNV",
    "SIRPD RNA"
  ],
  "C1orf131": [
    "C1orf131 CNV",
    "C1orf131 RNA",
    "C1orf131 Proteo"
  ],
  "ZNF525": [
    "ZNF525 CNV",
    "ZNF525 RNA"
  ],
  "OR7E154P": [
    "OR7E154P CNV",
    "OR7E154P RNA"
  ],
  "CDCP2": [
    "CDCP2 CNV",
    "CDCP2 RNA"
  ],
  "SPRYD4": [
    "SPRYD4 CNV",
    "SPRYD4 RNA",
    "SPRYD4 Proteo"
  ],
  "FMC1": [
    "FMC1 CNV",
    "FMC1 RNA",
    "FMC1 Proteo"
  ],
  "FGF7P8": [
    "FGF7P8 CNV",
    "FGF7P8 RNA"
  ],
  "MTND2P29": [
    "MTND2P29 CNV",
    "MTND2P29 RNA"
  ],
  "VN1R66P": [
    "VN1R66P CNV",
    "VN1R66P RNA"
  ],
  "EEF1A1P14": [
    "EEF1A1P14 CNV",
    "EEF1A1P14 RNA"
  ],
  "MS4A6A": [
    "MS4A6A CNV",
    "MS4A6A RNA",
    "MS4A6A Proteo"
  ],
  "PTMAP8": [
    "PTMAP8 CNV",
    "PTMAP8 RNA"
  ],
  "CFAP276": [
    "CFAP276 CNV",
    "CFAP276 RNA"
  ],
  "CSGALNACT2P1": [
    "CSGALNACT2P1 CNV",
    "CSGALNACT2P1 RNA"
  ],
  "HEBP2P1": [
    "HEBP2P1 CNV",
    "HEBP2P1 RNA"
  ],
  "IRF4": [
    "IRF4 CNV",
    "IRF4 RNA",
    "IRF4 Proteo"
  ],
  "RPSAP11": [
    "RPSAP11 CNV",
    "RPSAP11 RNA"
  ],
  "SDAD1P2": [
    "SDAD1P2 CNV",
    "SDAD1P2 RNA"
  ],
  "COQ7": [
    "COQ7 CNV",
    "COQ7 RNA",
    "COQ7 Proteo"
  ],
  "C16orf95": [
    "C16orf95 CNV",
    "C16orf95 RNA"
  ],
  "RPS3AP35": [
    "RPS3AP35 CNV",
    "RPS3AP35 RNA"
  ],
  "HS3ST6": [
    "HS3ST6 CNV",
    "HS3ST6 RNA"
  ],
  "BVES": [
    "BVES CNV",
    "BVES RNA"
  ],
  "ZNF730": [
    "ZNF730 CNV",
    "ZNF730 RNA"
  ],
  "ATP5MGP4": [
    "ATP5MGP4 CNV",
    "ATP5MGP4 RNA"
  ],
  "TDGF1P1": [
    "TDGF1P1 CNV",
    "TDGF1P1 RNA"
  ],
  "PKD1L1": [
    "PKD1L1 CNV",
    "PKD1L1 RNA"
  ],
  "SYT9": [
    "SYT9 CNV",
    "SYT9 RNA"
  ],
  "CENPS": [
    "CENPS CNV",
    "CENPS RNA",
    "CENPS Proteo"
  ],
  "LRRC52": [
    "LRRC52 CNV",
    "LRRC52 RNA"
  ],
  "ISLR": [
    "ISLR CNV",
    "ISLR RNA",
    "ISLR Proteo"
  ],
  "LYPLA2P2": [
    "LYPLA2P2 CNV",
    "LYPLA2P2 RNA"
  ],
  "RPL34P18": [
    "RPL34P18 CNV",
    "RPL34P18 RNA"
  ],
  "AGAP4": [
    "AGAP4 CNV",
    "AGAP4 RNA"
  ],
  "CNN2P9": [
    "CNN2P9 CNV",
    "CNN2P9 RNA"
  ],
  "C7orf31": [
    "C7orf31 CNV",
    "C7orf31 RNA"
  ],
  "STRIT1": [
    "STRIT1 CNV",
    "STRIT1 RNA"
  ],
  "NUSAP1": [
    "NUSAP1 CNV",
    "NUSAP1 RNA",
    "NUSAP1 Proteo"
  ],
  "INPP5A": [
    "INPP5A CNV",
    "INPP5A RNA",
    "INPP5A Proteo"
  ],
  "MRPL2P1": [
    "MRPL2P1 CNV",
    "MRPL2P1 RNA"
  ],
  "RNA5SP62": [
    "RNA5SP62 CNV",
    "RNA5SP62 RNA"
  ],
  "PTGER1": [
    "PTGER1 CNV",
    "PTGER1 RNA"
  ],
  "MED15P3": [
    "MED15P3 CNV",
    "MED15P3 RNA"
  ],
  "FBXO41": [
    "FBXO41 CNV",
    "FBXO41 RNA",
    "FBXO41 Proteo"
  ],
  "MTCO3P20": [
    "MTCO3P20 CNV",
    "MTCO3P20 RNA"
  ],
  "ZNF134": [
    "ZNF134 CNV",
    "ZNF134 RNA"
  ],
  "GABPA": [
    "GABPA CNV",
    "GABPA RNA",
    "GABPA Proteo"
  ],
  "RNA5SP472": [
    "RNA5SP472 CNV",
    "RNA5SP472 RNA"
  ],
  "FSIP2LP": [
    "FSIP2LP CNV",
    "FSIP2LP RNA"
  ],
  "OR8B4": [
    "OR8B4 CNV",
    "OR8B4 RNA"
  ],
  "MCF2": [
    "MCF2 CNV",
    "MCF2 RNA"
  ],
  "RIT1": [
    "RIT1 CNV",
    "RIT1 RNA",
    "RIT1 Proteo"
  ],
  "ANXA8": [
    "ANXA8 CNV",
    "ANXA8 RNA",
    "ANXA8 Proteo"
  ],
  "NSMCE4A": [
    "NSMCE4A CNV",
    "NSMCE4A RNA",
    "NSMCE4A Proteo"
  ],
  "IGKV2D-38": [
    "IGKV2D-38 CNV",
    "IGKV2D-38 RNA"
  ],
  "ATP6V0B": [
    "ATP6V0B CNV",
    "ATP6V0B RNA"
  ],
  "ARL4D": [
    "ARL4D CNV",
    "ARL4D RNA"
  ],
  "MSGN1": [
    "MSGN1 CNV",
    "MSGN1 RNA"
  ],
  "TFDP1P1": [
    "TFDP1P1 CNV",
    "TFDP1P1 RNA"
  ],
  "KRT18P18": [
    "KRT18P18 CNV",
    "KRT18P18 RNA"
  ],
  "SRL": [
    "SRL CNV",
    "SRL RNA",
    "SRL Proteo"
  ],
  "RPL7L1": [
    "RPL7L1 CNV",
    "RPL7L1 RNA",
    "RPL7L1 Proteo"
  ],
  "ALG1L9P": [
    "ALG1L9P CNV",
    "ALG1L9P RNA"
  ],
  "FNTAP1": [
    "FNTAP1 CNV",
    "FNTAP1 RNA"
  ],
  "PAGE4": [
    "PAGE4 CNV",
    "PAGE4 RNA"
  ],
  "SPG11": [
    "SPG11 CNV",
    "SPG11 RNA",
    "SPG11 Proteo"
  ],
  "CST12P": [
    "CST12P CNV",
    "CST12P RNA"
  ],
  "KATNB1": [
    "KATNB1 CNV",
    "KATNB1 RNA",
    "KATNB1 Proteo"
  ],
  "DNAJB1": [
    "DNAJB1 CNV",
    "DNAJB1 RNA",
    "DNAJB1 Proteo"
  ],
  "TMEM69": [
    "TMEM69 CNV",
    "TMEM69 RNA",
    "TMEM69 Proteo"
  ],
  "MACROH2A1": [
    "MACROH2A1 CNV",
    "MACROH2A1 RNA",
    "MACROH2A1 Proteo"
  ],
  "BMP15": [
    "BMP15 CNV",
    "BMP15 RNA"
  ],
  "RPS23P2": [
    "RPS23P2 CNV",
    "RPS23P2 RNA"
  ],
  "CHRNB1": [
    "CHRNB1 CNV",
    "CHRNB1 RNA"
  ],
  "TFDP1": [
    "TFDP1 CNV",
    "TFDP1 RNA",
    "TFDP1 Proteo"
  ],
  "CHRNA10": [
    "CHRNA10 CNV",
    "CHRNA10 RNA"
  ],
  "TBCA": [
    "TBCA CNV",
    "TBCA RNA",
    "TBCA Proteo"
  ],
  "CAPZA1": [
    "CAPZA1 CNV",
    "CAPZA1 RNA",
    "CAPZA1 Proteo"
  ],
  "GRK5": [
    "GRK5 CNV",
    "GRK5 RNA",
    "GRK5 Proteo"
  ],
  "ZKSCAN8P2": [
    "ZKSCAN8P2 CNV",
    "ZKSCAN8P2 RNA"
  ],
  "GIMAP8": [
    "GIMAP8 CNV",
    "GIMAP8 RNA",
    "GIMAP8 Proteo"
  ],
  "PLA2G6": [
    "PLA2G6 CNV",
    "PLA2G6 RNA",
    "PLA2G6 Proteo"
  ],
  "EEF1A1P47": [
    "EEF1A1P47 CNV",
    "EEF1A1P47 RNA"
  ],
  "TBC1D24": [
    "TBC1D24 CNV",
    "TBC1D24 RNA",
    "TBC1D24 Proteo"
  ],
  "ANKRD36C": [
    "ANKRD36C CNV",
    "ANKRD36C RNA"
  ],
  "GBP5": [
    "GBP5 CNV",
    "GBP5 RNA",
    "GBP5 Proteo"
  ],
  "FDX2": [
    "FDX2 CNV",
    "FDX2 RNA",
    "FDX2 Proteo"
  ],
  "B4GALNT3": [
    "B4GALNT3 CNV",
    "B4GALNT3 RNA",
    "B4GALNT3 Proteo"
  ],
  "NPY": [
    "NPY CNV",
    "NPY RNA"
  ],
  "ETV1": [
    "ETV1 CNV",
    "ETV1 RNA"
  ],
  "TUBA3C": [
    "TUBA3C CNV",
    "TUBA3C RNA"
  ],
  "ZNF585A": [
    "ZNF585A CNV",
    "ZNF585A RNA"
  ],
  "ACBD7": [
    "ACBD7 CNV",
    "ACBD7 RNA",
    "ACBD7 Proteo"
  ],
  "RNA5SP318": [
    "RNA5SP318 CNV",
    "RNA5SP318 RNA"
  ],
  "PXK": [
    "PXK CNV",
    "PXK RNA",
    "PXK Proteo"
  ],
  "ACSM5": [
    "ACSM5 CNV",
    "ACSM5 RNA",
    "ACSM5 Proteo"
  ],
  "KRTAP22-1": [
    "KRTAP22-1 CNV",
    "KRTAP22-1 RNA"
  ],
  "DNAJB1P1": [
    "DNAJB1P1 CNV",
    "DNAJB1P1 RNA"
  ],
  "KRTAP13-6P": [
    "KRTAP13-6P CNV",
    "KRTAP13-6P RNA"
  ],
  "POLR3C": [
    "POLR3C CNV",
    "POLR3C RNA",
    "POLR3C Proteo"
  ],
  "PPP1R10P1": [
    "PPP1R10P1 CNV",
    "PPP1R10P1 RNA"
  ],
  "HERC2": [
    "HERC2 CNV",
    "HERC2 RNA",
    "HERC2 Proteo"
  ],
  "ZBTB20": [
    "ZBTB20 CNV",
    "ZBTB20 RNA",
    "ZBTB20 Proteo"
  ],
  "IL1RAPL1": [
    "IL1RAPL1 CNV",
    "IL1RAPL1 RNA"
  ],
  "TMX2": [
    "TMX2 CNV",
    "TMX2 RNA",
    "TMX2 Proteo"
  ],
  "RPS6P4": [
    "RPS6P4 CNV",
    "RPS6P4 RNA"
  ],
  "RPL7P28": [
    "RPL7P28 CNV",
    "RPL7P28 RNA"
  ],
  "PIPSL": [
    "PIPSL CNV",
    "PIPSL RNA"
  ],
  "TOPORSLP": [
    "TOPORSLP CNV",
    "TOPORSLP RNA"
  ],
  "CSDC2": [
    "CSDC2 CNV",
    "CSDC2 RNA"
  ],
  "RPL37A": [
    "RPL37A CNV",
    "RPL37A RNA",
    "RPL37A Proteo"
  ],
  "OR2T12": [
    "OR2T12 CNV",
    "OR2T12 RNA"
  ],
  "QRSL1P2": [
    "QRSL1P2 CNV",
    "QRSL1P2 RNA"
  ],
  "MTND2P23": [
    "MTND2P23 CNV",
    "MTND2P23 RNA"
  ],
  "NNAT": [
    "NNAT CNV",
    "NNAT RNA"
  ],
  "RNA5SP278": [
    "RNA5SP278 CNV",
    "RNA5SP278 RNA"
  ],
  "PCDHGA7": [
    "PCDHGA7 CNV",
    "PCDHGA7 RNA"
  ],
  "EFEMP1": [
    "EFEMP1 CNV",
    "EFEMP1 RNA",
    "EFEMP1 Proteo"
  ],
  "FGF17": [
    "FGF17 CNV",
    "FGF17 RNA"
  ],
  "GEMIN7P1": [
    "GEMIN7P1 CNV",
    "GEMIN7P1 RNA"
  ],
  "MRPS21P5": [
    "MRPS21P5 CNV",
    "MRPS21P5 RNA"
  ],
  "CATSPERB": [
    "CATSPERB CNV",
    "CATSPERB RNA"
  ],
  "ALDH3A1": [
    "ALDH3A1 CNV",
    "ALDH3A1 RNA",
    "ALDH3A1 Proteo"
  ],
  "KBTBD12": [
    "KBTBD12 CNV",
    "KBTBD12 RNA"
  ],
  "SERPINC1": [
    "SERPINC1 CNV",
    "SERPINC1 RNA",
    "SERPINC1 Proteo"
  ],
  "FAM104A": [
    "FAM104A CNV",
    "FAM104A RNA",
    "FAM104A Proteo"
  ],
  "SPATA31A3": [
    "SPATA31A3 CNV",
    "SPATA31A3 RNA"
  ],
  "OTUD3": [
    "OTUD3 CNV",
    "OTUD3 RNA",
    "OTUD3 Proteo"
  ],
  "MTND3P3": [
    "MTND3P3 CNV",
    "MTND3P3 RNA"
  ],
  "FBXO39": [
    "FBXO39 CNV",
    "FBXO39 RNA"
  ],
  "TTC26": [
    "TTC26 CNV",
    "TTC26 RNA",
    "TTC26 Proteo"
  ],
  "CD1E": [
    "CD1E CNV",
    "CD1E RNA",
    "CD1E Proteo"
  ],
  "RENBP": [
    "RENBP CNV",
    "RENBP RNA",
    "RENBP Proteo"
  ],
  "AIFM2": [
    "AIFM2 CNV",
    "AIFM2 RNA",
    "AIFM2 Proteo"
  ],
  "AFG3L2P1": [
    "AFG3L2P1 CNV",
    "AFG3L2P1 RNA"
  ],
  "PRRT4": [
    "PRRT4 CNV",
    "PRRT4 RNA"
  ],
  "FOXD3": [
    "FOXD3 CNV",
    "FOXD3 RNA",
    "FOXD3 Proteo"
  ],
  "PIDD1": [
    "PIDD1 CNV",
    "PIDD1 RNA"
  ],
  "AKR1B1P4": [
    "AKR1B1P4 CNV",
    "AKR1B1P4 RNA"
  ],
  "RPL13P6": [
    "RPL13P6 CNV",
    "RPL13P6 RNA"
  ],
  "EFNA2": [
    "EFNA2 CNV",
    "EFNA2 RNA"
  ],
  "CCDC9": [
    "CCDC9 CNV",
    "CCDC9 RNA",
    "CCDC9 Proteo"
  ],
  "UBA52P5": [
    "UBA52P5 CNV",
    "UBA52P5 RNA"
  ],
  "MTLN": [
    "MTLN CNV",
    "MTLN RNA"
  ],
  "BPTF": [
    "BPTF CNV",
    "BPTF RNA",
    "BPTF Proteo"
  ],
  "MVK": [
    "MVK CNV",
    "MVK RNA",
    "MVK Proteo"
  ],
  "MINDY2": [
    "MINDY2 CNV",
    "MINDY2 RNA",
    "MINDY2 Proteo"
  ],
  "MAP10": [
    "MAP10 CNV",
    "MAP10 RNA"
  ],
  "GOLGA8IP": [
    "GOLGA8IP CNV",
    "GOLGA8IP RNA"
  ],
  "USP18": [
    "USP18 CNV",
    "USP18 RNA",
    "USP18 Proteo"
  ],
  "EPS8L3": [
    "EPS8L3 CNV",
    "EPS8L3 RNA",
    "EPS8L3 Proteo"
  ],
  "TG": [
    "TG CNV",
    "TG RNA",
    "TG Proteo"
  ],
  "UNCX": [
    "UNCX CNV",
    "UNCX RNA",
    "UNCX Proteo"
  ],
  "RPS6P26": [
    "RPS6P26 CNV",
    "RPS6P26 RNA"
  ],
  "PCDHB11": [
    "PCDHB11 CNV",
    "PCDHB11 RNA",
    "PCDHB11 Proteo"
  ],
  "ATP6V0E1": [
    "ATP6V0E1 CNV",
    "ATP6V0E1 RNA"
  ],
  "USP17L19": [
    "USP17L19 CNV",
    "USP17L19 RNA"
  ],
  "AASDH": [
    "AASDH CNV",
    "AASDH RNA",
    "AASDH Proteo"
  ],
  "NAT16": [
    "NAT16 CNV",
    "NAT16 RNA"
  ],
  "PEBP1P1": [
    "PEBP1P1 CNV",
    "PEBP1P1 RNA"
  ],
  "NLGN2": [
    "NLGN2 CNV",
    "NLGN2 RNA",
    "NLGN2 Proteo"
  ],
  "MRPL38": [
    "MRPL38 CNV",
    "MRPL38 RNA",
    "MRPL38 Proteo"
  ],
  "SLITRK3": [
    "SLITRK3 CNV",
    "SLITRK3 RNA"
  ],
  "REG3A": [
    "REG3A CNV",
    "REG3A RNA",
    "REG3A Proteo"
  ],
  "SLC45A4": [
    "SLC45A4 CNV",
    "SLC45A4 RNA"
  ],
  "OR1E3": [
    "OR1E3 CNV",
    "OR1E3 RNA"
  ],
  "HMGB1P51": [
    "HMGB1P51 CNV",
    "HMGB1P51 RNA"
  ],
  "MTPAP": [
    "MTPAP CNV",
    "MTPAP RNA",
    "MTPAP Proteo"
  ],
  "UMAD1": [
    "UMAD1 CNV",
    "UMAD1 RNA",
    "UMAD1 Proteo"
  ],
  "MTCO1P43": [
    "MTCO1P43 CNV",
    "MTCO1P43 RNA"
  ],
  "MAGED2": [
    "MAGED2 CNV",
    "MAGED2 RNA",
    "MAGED2 Proteo"
  ],
  "PDGFA": [
    "PDGFA CNV",
    "PDGFA RNA",
    "PDGFA Proteo"
  ],
  "ARID3C": [
    "ARID3C CNV",
    "ARID3C RNA"
  ],
  "AAK1": [
    "AAK1 CNV",
    "AAK1 RNA",
    "AAK1 Proteo"
  ],
  "HABP2": [
    "HABP2 CNV",
    "HABP2 RNA",
    "HABP2 Proteo"
  ],
  "ATP2C1": [
    "ATP2C1 CNV",
    "ATP2C1 RNA",
    "ATP2C1 Proteo"
  ],
  "OR51V1": [
    "OR51V1 CNV",
    "OR51V1 RNA"
  ],
  "MID1IP1": [
    "MID1IP1 CNV",
    "MID1IP1 RNA",
    "MID1IP1 Proteo"
  ],
  "GPR12": [
    "GPR12 CNV",
    "GPR12 RNA"
  ],
  "FANCF": [
    "FANCF CNV",
    "FANCF RNA",
    "FANCF Proteo"
  ],
  "ODAD2P1": [
    "ODAD2P1 CNV",
    "ODAD2P1 RNA"
  ],
  "RPS26P4": [
    "RPS26P4 CNV",
    "RPS26P4 RNA"
  ],
  "RPL32P8": [
    "RPL32P8 CNV",
    "RPL32P8 RNA"
  ],
  "SPP2": [
    "SPP2 CNV",
    "SPP2 RNA",
    "SPP2 Proteo"
  ],
  "MAP3K8": [
    "MAP3K8 CNV",
    "MAP3K8 RNA",
    "MAP3K8 Proteo"
  ],
  "NTN1": [
    "NTN1 CNV",
    "NTN1 RNA",
    "NTN1 Proteo"
  ],
  "RPL6P16": [
    "RPL6P16 CNV",
    "RPL6P16 RNA"
  ],
  "SULT1A1": [
    "SULT1A1 CNV",
    "SULT1A1 RNA",
    "SULT1A1 Proteo"
  ],
  "OR1AA1P": [
    "OR1AA1P CNV",
    "OR1AA1P RNA"
  ],
  "ECHDC3": [
    "ECHDC3 CNV",
    "ECHDC3 RNA",
    "ECHDC3 Proteo"
  ],
  "DNAH14": [
    "DNAH14 CNV",
    "DNAH14 RNA"
  ],
  "BCAR3": [
    "BCAR3 CNV",
    "BCAR3 RNA",
    "BCAR3 Proteo"
  ],
  "KRASP1": [
    "KRASP1 CNV",
    "KRASP1 RNA"
  ],
  "OR4D2": [
    "OR4D2 CNV",
    "OR4D2 RNA"
  ],
  "APC": [
    "APC CNV",
    "APC RNA",
    "APC Proteo"
  ],
  "TBC1D20": [
    "TBC1D20 CNV",
    "TBC1D20 RNA",
    "TBC1D20 Proteo"
  ],
  "NR0B2": [
    "NR0B2 CNV",
    "NR0B2 RNA"
  ],
  "TERF1P5": [
    "TERF1P5 CNV",
    "TERF1P5 RNA"
  ],
  "VN1R53P": [
    "VN1R53P CNV",
    "VN1R53P RNA"
  ],
  "FTCD": [
    "FTCD CNV",
    "FTCD RNA"
  ],
  "AURKB": [
    "AURKB CNV",
    "AURKB RNA",
    "AURKB Proteo"
  ],
  "USP17L29": [
    "USP17L29 CNV",
    "USP17L29 RNA"
  ],
  "RNA5SP82": [
    "RNA5SP82 CNV",
    "RNA5SP82 RNA"
  ],
  "PHB1P9": [
    "PHB1P9 CNV",
    "PHB1P9 RNA"
  ],
  "RPL21P12": [
    "RPL21P12 CNV",
    "RPL21P12 RNA"
  ],
  "SMG1P3": [
    "SMG1P3 CNV",
    "SMG1P3 RNA"
  ],
  "VN1R104P": [
    "VN1R104P CNV",
    "VN1R104P RNA"
  ],
  "SH3BP5": [
    "SH3BP5 CNV",
    "SH3BP5 RNA",
    "SH3BP5 Proteo"
  ],
  "SMUG1P1": [
    "SMUG1P1 CNV",
    "SMUG1P1 RNA"
  ],
  "RDH13": [
    "RDH13 CNV",
    "RDH13 RNA",
    "RDH13 Proteo"
  ],
  "RNA5SP404": [
    "RNA5SP404 CNV",
    "RNA5SP404 RNA"
  ],
  "SMIM32": [
    "SMIM32 CNV",
    "SMIM32 RNA"
  ],
  "CRYBA2": [
    "CRYBA2 CNV",
    "CRYBA2 RNA"
  ],
  "EMILIN3": [
    "EMILIN3 CNV",
    "EMILIN3 RNA",
    "EMILIN3 Proteo"
  ],
  "RNA5SP74": [
    "RNA5SP74 CNV",
    "RNA5SP74 RNA"
  ],
  "NAGA": [
    "NAGA CNV",
    "NAGA RNA",
    "NAGA Proteo"
  ],
  "ANXA9": [
    "ANXA9 CNV",
    "ANXA9 RNA",
    "ANXA9 Proteo"
  ],
  "PIWIL3": [
    "PIWIL3 CNV",
    "PIWIL3 RNA"
  ],
  "TBC1D25": [
    "TBC1D25 CNV",
    "TBC1D25 RNA",
    "TBC1D25 Proteo"
  ],
  "YWHAEP7": [
    "YWHAEP7 CNV",
    "YWHAEP7 RNA"
  ],
  "XAF1": [
    "XAF1 CNV",
    "XAF1 RNA",
    "XAF1 Proteo"
  ],
  "TOMM7": [
    "TOMM7 CNV",
    "TOMM7 RNA",
    "TOMM7 Proteo"
  ],
  "AP4M1": [
    "AP4M1 CNV",
    "AP4M1 RNA",
    "AP4M1 Proteo"
  ],
  "RFTN1P1": [
    "RFTN1P1 CNV",
    "RFTN1P1 RNA"
  ],
  "NPB": [
    "NPB CNV",
    "NPB RNA"
  ],
  "RRAGD": [
    "RRAGD CNV",
    "RRAGD RNA",
    "RRAGD Proteo"
  ],
  "PCDHB6": [
    "PCDHB6 CNV",
    "PCDHB6 RNA",
    "PCDHB6 Proteo"
  ],
  "DDX23": [
    "DDX23 CNV",
    "DDX23 RNA",
    "DDX23 Proteo"
  ],
  "TYMSP1": [
    "TYMSP1 CNV",
    "TYMSP1 RNA"
  ],
  "BSX": [
    "BSX CNV",
    "BSX RNA"
  ],
  "MAP3K2": [
    "MAP3K2 CNV",
    "MAP3K2 RNA",
    "MAP3K2 Proteo"
  ],
  "CHST12": [
    "CHST12 CNV",
    "CHST12 RNA",
    "CHST12 Proteo"
  ],
  "ALG2": [
    "ALG2 CNV",
    "ALG2 RNA",
    "ALG2 Proteo"
  ],
  "HSPD1": [
    "HSPD1 CNV",
    "HSPD1 RNA",
    "HSPD1 Proteo"
  ],
  "RHOU": [
    "RHOU CNV",
    "RHOU RNA"
  ],
  "NLRP9P1": [
    "NLRP9P1 CNV",
    "NLRP9P1 RNA"
  ],
  "TMTC3": [
    "TMTC3 CNV",
    "TMTC3 RNA",
    "TMTC3 Proteo"
  ],
  "ESCO1": [
    "ESCO1 CNV",
    "ESCO1 RNA",
    "ESCO1 Proteo"
  ],
  "NUDT22": [
    "NUDT22 CNV",
    "NUDT22 RNA",
    "NUDT22 Proteo"
  ],
  "YWHAQP1": [
    "YWHAQP1 CNV",
    "YWHAQP1 RNA"
  ],
  "ATN1": [
    "ATN1 CNV",
    "ATN1 RNA",
    "ATN1 Proteo"
  ],
  "IGHVII-33-1": [
    "IGHVII-33-1 CNV",
    "IGHVII-33-1 RNA"
  ],
  "PCDH10": [
    "PCDH10 CNV",
    "PCDH10 RNA"
  ],
  "THAP8": [
    "THAP8 CNV",
    "THAP8 RNA"
  ],
  "VANGL2": [
    "VANGL2 CNV",
    "VANGL2 RNA",
    "VANGL2 Proteo"
  ],
  "RNA5SP209": [
    "RNA5SP209 CNV",
    "RNA5SP209 RNA"
  ],
  "RNA5SP180": [
    "RNA5SP180 CNV",
    "RNA5SP180 RNA"
  ],
  "RAP1BP1": [
    "RAP1BP1 CNV",
    "RAP1BP1 RNA"
  ],
  "ATP5MFP6": [
    "ATP5MFP6 CNV",
    "ATP5MFP6 RNA"
  ],
  "NPR1": [
    "NPR1 CNV",
    "NPR1 RNA",
    "NPR1 Proteo"
  ],
  "OSBPL9P2": [
    "OSBPL9P2 CNV",
    "OSBPL9P2 RNA"
  ],
  "RPL35AP21": [
    "RPL35AP21 CNV",
    "RPL35AP21 RNA"
  ],
  "NAXE": [
    "NAXE CNV",
    "NAXE RNA",
    "NAXE Proteo"
  ],
  "NDUFAF4": [
    "NDUFAF4 CNV",
    "NDUFAF4 RNA",
    "NDUFAF4 Proteo"
  ],
  "CCDC102B": [
    "CCDC102B CNV",
    "CCDC102B RNA"
  ],
  "SMAD1": [
    "SMAD1 CNV",
    "SMAD1 RNA",
    "SMAD1 Proteo"
  ],
  "KCNJ2": [
    "KCNJ2 CNV",
    "KCNJ2 RNA"
  ],
  "CDRT15P11": [
    "CDRT15P11 CNV",
    "CDRT15P11 RNA"
  ],
  "CYP4F32P": [
    "CYP4F32P CNV",
    "CYP4F32P RNA"
  ],
  "PGRMC1": [
    "PGRMC1 CNV",
    "PGRMC1 RNA",
    "PGRMC1 Proteo"
  ],
  "MAGEC3": [
    "MAGEC3 CNV",
    "MAGEC3 RNA"
  ],
  "NRAS": [
    "NRAS CNV",
    "NRAS RNA",
    "NRAS Proteo"
  ],
  "REXO1L6P": [
    "REXO1L6P CNV",
    "REXO1L6P RNA"
  ],
  "ARG1": [
    "ARG1 CNV",
    "ARG1 RNA",
    "ARG1 Proteo"
  ],
  "OR7E115P": [
    "OR7E115P CNV",
    "OR7E115P RNA"
  ],
  "RPS4XP1": [
    "RPS4XP1 CNV",
    "RPS4XP1 RNA"
  ],
  "RCC2P2": [
    "RCC2P2 CNV",
    "RCC2P2 RNA"
  ],
  "NACC1": [
    "NACC1 CNV",
    "NACC1 RNA",
    "NACC1 Proteo"
  ],
  "GALNTL5": [
    "GALNTL5 CNV",
    "GALNTL5 RNA"
  ],
  "CNTNAP3C": [
    "CNTNAP3C CNV",
    "CNTNAP3C RNA"
  ],
  "IRF7": [
    "IRF7 CNV",
    "IRF7 RNA",
    "IRF7 Proteo"
  ],
  "CDY9P": [
    "CDY9P CNV",
    "CDY9P RNA"
  ],
  "TNFSF15": [
    "TNFSF15 CNV",
    "TNFSF15 RNA"
  ],
  "ZNF252P": [
    "ZNF252P CNV",
    "ZNF252P RNA"
  ],
  "KRT8P12": [
    "KRT8P12 CNV",
    "KRT8P12 RNA"
  ],
  "MTHFD2P6": [
    "MTHFD2P6 CNV",
    "MTHFD2P6 RNA"
  ],
  "PKIA": [
    "PKIA CNV",
    "PKIA RNA"
  ],
  "PIK3R4": [
    "PIK3R4 CNV",
    "PIK3R4 RNA",
    "PIK3R4 Proteo"
  ],
  "RIPK1": [
    "RIPK1 CNV",
    "RIPK1 RNA",
    "RIPK1 Proteo"
  ],
  "MTND1P24": [
    "MTND1P24 CNV",
    "MTND1P24 RNA"
  ],
  "CNPY1": [
    "CNPY1 CNV",
    "CNPY1 RNA"
  ],
  "SPDYE4": [
    "SPDYE4 CNV",
    "SPDYE4 RNA"
  ],
  "RNA5SP47": [
    "RNA5SP47 CNV",
    "RNA5SP47 RNA"
  ],
  "RAPGEF3": [
    "RAPGEF3 CNV",
    "RAPGEF3 RNA",
    "RAPGEF3 Proteo"
  ],
  "GEMIN8": [
    "GEMIN8 CNV",
    "GEMIN8 RNA",
    "GEMIN8 Proteo"
  ],
  "CEPT1": [
    "CEPT1 CNV",
    "CEPT1 RNA",
    "CEPT1 Proteo"
  ],
  "RPL7P51": [
    "RPL7P51 CNV",
    "RPL7P51 RNA"
  ],
  "KRT18P25": [
    "KRT18P25 CNV",
    "KRT18P25 RNA"
  ],
  "SNX3P1X": [
    "SNX3P1X CNV",
    "SNX3P1X RNA"
  ],
  "ZNF415": [
    "ZNF415 CNV",
    "ZNF415 RNA"
  ],
  "SMDT1": [
    "SMDT1 CNV",
    "SMDT1 RNA",
    "SMDT1 Proteo"
  ],
  "MTCO1P7": [
    "MTCO1P7 CNV",
    "MTCO1P7 RNA"
  ],
  "BNIP1": [
    "BNIP1 CNV",
    "BNIP1 RNA",
    "BNIP1 Proteo"
  ],
  "SLC2AXP1": [
    "SLC2AXP1 CNV",
    "SLC2AXP1 RNA"
  ],
  "RFC5": [
    "RFC5 CNV",
    "RFC5 RNA",
    "RFC5 Proteo"
  ],
  "LASP1": [
    "LASP1 CNV",
    "LASP1 RNA",
    "LASP1 Proteo"
  ],
  "RNA5SP18": [
    "RNA5SP18 CNV",
    "RNA5SP18 RNA"
  ],
  "INMT": [
    "INMT CNV",
    "INMT RNA"
  ],
  "A2MP1": [
    "A2MP1 CNV",
    "A2MP1 RNA"
  ],
  "ARL5AP4": [
    "ARL5AP4 CNV",
    "ARL5AP4 RNA"
  ],
  "PYDC5": [
    "PYDC5 CNV",
    "PYDC5 RNA"
  ],
  "SRSF3": [
    "SRSF3 CNV",
    "SRSF3 RNA",
    "SRSF3 Proteo"
  ],
  "TMEM134": [
    "TMEM134 CNV",
    "TMEM134 RNA",
    "TMEM134 Proteo"
  ],
  "MRPL30": [
    "MRPL30 CNV",
    "MRPL30 RNA",
    "MRPL30 Proteo"
  ],
  "AKAP8": [
    "AKAP8 CNV",
    "AKAP8 RNA",
    "AKAP8 Proteo"
  ],
  "OR4M1": [
    "OR4M1 CNV",
    "OR4M1 RNA"
  ],
  "ERICH6": [
    "ERICH6 CNV",
    "ERICH6 RNA"
  ],
  "LCE5A": [
    "LCE5A CNV",
    "LCE5A RNA"
  ],
  "TEKT4": [
    "TEKT4 CNV",
    "TEKT4 RNA"
  ],
  "SNX8": [
    "SNX8 CNV",
    "SNX8 RNA",
    "SNX8 Proteo"
  ],
  "VSTM5": [
    "VSTM5 CNV",
    "VSTM5 RNA"
  ],
  "SLC16A11": [
    "SLC16A11 CNV",
    "SLC16A11 RNA"
  ],
  "ZDHHC18": [
    "ZDHHC18 CNV",
    "ZDHHC18 RNA",
    "ZDHHC18 Proteo"
  ],
  "ACTL7B": [
    "ACTL7B CNV",
    "ACTL7B RNA"
  ],
  "MCU": [
    "MCU CNV",
    "MCU RNA",
    "MCU Proteo"
  ],
  "CALCR": [
    "CALCR CNV",
    "CALCR RNA"
  ],
  "BCAS3": [
    "BCAS3 CNV",
    "BCAS3 RNA",
    "BCAS3 Proteo"
  ],
  "C1orf115": [
    "C1orf115 CNV",
    "C1orf115 RNA"
  ],
  "RPL21P91": [
    "RPL21P91 CNV",
    "RPL21P91 RNA"
  ],
  "BCAP31P1": [
    "BCAP31P1 CNV",
    "BCAP31P1 RNA"
  ],
  "NIP7P1": [
    "NIP7P1 CNV",
    "NIP7P1 RNA"
  ],
  "ESPN": [
    "ESPN CNV",
    "ESPN RNA",
    "ESPN Proteo"
  ],
  "HDAC5": [
    "HDAC5 CNV",
    "HDAC5 RNA",
    "HDAC5 Proteo"
  ],
  "MED15P7": [
    "MED15P7 CNV",
    "MED15P7 RNA"
  ],
  "RNA5-8SP4": [
    "RNA5-8SP4 CNV",
    "RNA5-8SP4 RNA"
  ],
  "CLEC4C": [
    "CLEC4C CNV",
    "CLEC4C RNA"
  ],
  "MAGEH1": [
    "MAGEH1 CNV",
    "MAGEH1 RNA",
    "MAGEH1 Proteo"
  ],
  "HIGD1AP5": [
    "HIGD1AP5 CNV",
    "HIGD1AP5 RNA"
  ],
  "PAM": [
    "PAM CNV",
    "PAM RNA",
    "PAM Proteo"
  ],
  "PRR12": [
    "PRR12 CNV",
    "PRR12 RNA",
    "PRR12 Proteo"
  ],
  "SAR1B": [
    "SAR1B CNV",
    "SAR1B RNA",
    "SAR1B Proteo"
  ],
  "PTPRF": [
    "PTPRF CNV",
    "PTPRF RNA",
    "PTPRF Proteo"
  ],
  "TSC22D3": [
    "TSC22D3 CNV",
    "TSC22D3 RNA",
    "TSC22D3 Proteo"
  ],
  "FXYD5": [
    "FXYD5 CNV",
    "FXYD5 RNA",
    "FXYD5 Proteo"
  ],
  "OR2A3P": [
    "OR2A3P CNV",
    "OR2A3P RNA"
  ],
  "HTR6": [
    "HTR6 CNV",
    "HTR6 RNA"
  ],
  "HOXC5": [
    "HOXC5 CNV",
    "HOXC5 RNA"
  ],
  "ST13P13": [
    "ST13P13 CNV",
    "ST13P13 RNA"
  ],
  "DUX4L2": [
    "DUX4L2 CNV",
    "DUX4L2 RNA"
  ],
  "ECPAS": [
    "ECPAS CNV",
    "ECPAS RNA",
    "ECPAS Proteo"
  ],
  "RPL12P30": [
    "RPL12P30 CNV",
    "RPL12P30 RNA"
  ],
  "SRD5A3": [
    "SRD5A3 CNV",
    "SRD5A3 RNA",
    "SRD5A3 Proteo"
  ],
  "ACHE": [
    "ACHE CNV",
    "ACHE RNA",
    "ACHE Proteo"
  ],
  "GBF1": [
    "GBF1 CNV",
    "GBF1 RNA",
    "GBF1 Proteo"
  ],
  "ACOT12": [
    "ACOT12 CNV",
    "ACOT12 RNA"
  ],
  "RPSAP34": [
    "RPSAP34 CNV",
    "RPSAP34 RNA"
  ],
  "ACAA2": [
    "ACAA2 CNV",
    "ACAA2 RNA",
    "ACAA2 Proteo"
  ],
  "EMB": [
    "EMB CNV",
    "EMB RNA",
    "EMB Proteo"
  ],
  "GOLM2": [
    "GOLM2 CNV",
    "GOLM2 RNA",
    "GOLM2 Proteo"
  ],
  "EPM2AIP1": [
    "EPM2AIP1 CNV",
    "EPM2AIP1 RNA",
    "EPM2AIP1 Proteo"
  ],
  "NRARP": [
    "NRARP CNV",
    "NRARP RNA"
  ],
  "CAP1": [
    "CAP1 CNV",
    "CAP1 RNA",
    "CAP1 Proteo"
  ],
  "PHETA2": [
    "PHETA2 CNV",
    "PHETA2 RNA",
    "PHETA2 Proteo"
  ],
  "RNA5-8SP5": [
    "RNA5-8SP5 CNV",
    "RNA5-8SP5 RNA"
  ],
  "HACD3": [
    "HACD3 CNV",
    "HACD3 RNA",
    "HACD3 Proteo"
  ],
  "RNA5SP368": [
    "RNA5SP368 CNV",
    "RNA5SP368 RNA"
  ],
  "TTC24": [
    "TTC24 CNV",
    "TTC24 RNA"
  ],
  "FABP5P13": [
    "FABP5P13 CNV",
    "FABP5P13 RNA"
  ],
  "GSTP1": [
    "GSTP1 CNV",
    "GSTP1 RNA",
    "GSTP1 Proteo"
  ],
  "DNM1P33": [
    "DNM1P33 CNV",
    "DNM1P33 RNA"
  ],
  "CYB5AP3": [
    "CYB5AP3 CNV",
    "CYB5AP3 RNA"
  ],
  "MCOLN3": [
    "MCOLN3 CNV",
    "MCOLN3 RNA",
    "MCOLN3 Proteo"
  ],
  "MMP15": [
    "MMP15 CNV",
    "MMP15 RNA",
    "MMP15 Proteo"
  ],
  "SLC16A4": [
    "SLC16A4 CNV",
    "SLC16A4 RNA",
    "SLC16A4 Proteo"
  ],
  "DCAF4L2": [
    "DCAF4L2 CNV",
    "DCAF4L2 RNA"
  ],
  "HNRNPH1P2": [
    "HNRNPH1P2 CNV",
    "HNRNPH1P2 RNA"
  ],
  "AZI2": [
    "AZI2 CNV",
    "AZI2 RNA",
    "AZI2 Proteo"
  ],
  "RNA5SP270": [
    "RNA5SP270 CNV",
    "RNA5SP270 RNA"
  ],
  "SAGE3P": [
    "SAGE3P CNV",
    "SAGE3P RNA"
  ],
  "NARS1": [
    "NARS1 CNV",
    "NARS1 RNA",
    "NARS1 Proteo"
  ],
  "GLYAT": [
    "GLYAT CNV",
    "GLYAT RNA"
  ],
  "RPS12P28": [
    "RPS12P28 CNV",
    "RPS12P28 RNA"
  ],
  "CCDC184": [
    "CCDC184 CNV",
    "CCDC184 RNA"
  ],
  "IGHJ3P": [
    "IGHJ3P CNV",
    "IGHJ3P RNA"
  ],
  "IGHVIII-16-1": [
    "IGHVIII-16-1 CNV",
    "IGHVIII-16-1 RNA"
  ],
  "COQ8B": [
    "COQ8B CNV",
    "COQ8B RNA",
    "COQ8B Proteo"
  ],
  "PSMD14": [
    "PSMD14 CNV",
    "PSMD14 RNA",
    "PSMD14 Proteo"
  ],
  "TMEM273": [
    "TMEM273 CNV",
    "TMEM273 RNA"
  ],
  "KRT15": [
    "KRT15 CNV",
    "KRT15 RNA",
    "KRT15 Proteo"
  ],
  "RPL10P8": [
    "RPL10P8 CNV",
    "RPL10P8 RNA"
  ],
  "LMAN1": [
    "LMAN1 CNV",
    "LMAN1 RNA",
    "LMAN1 Proteo"
  ],
  "CRCT1": [
    "CRCT1 CNV",
    "CRCT1 RNA"
  ],
  "AGK": [
    "AGK CNV",
    "AGK RNA",
    "AGK Proteo"
  ],
  "HLA-DQB1": [
    "HLA-DQB1 CNV",
    "HLA-DQB1 RNA",
    "HLA-DQB1 Proteo"
  ],
  "MOSPD3": [
    "MOSPD3 CNV",
    "MOSPD3 RNA",
    "MOSPD3 Proteo"
  ],
  "HSD17B11": [
    "HSD17B11 CNV",
    "HSD17B11 RNA",
    "HSD17B11 Proteo"
  ],
  "MAF1": [
    "MAF1 CNV",
    "MAF1 RNA",
    "MAF1 Proteo"
  ],
  "C17orf80": [
    "C17orf80 CNV",
    "C17orf80 RNA",
    "C17orf80 Proteo"
  ],
  "SDR16C5": [
    "SDR16C5 CNV",
    "SDR16C5 RNA",
    "SDR16C5 Proteo"
  ],
  "AGR3": [
    "AGR3 CNV",
    "AGR3 RNA",
    "AGR3 Proteo"
  ],
  "SLC25A2": [
    "SLC25A2 CNV",
    "SLC25A2 RNA"
  ],
  "NPM1P52": [
    "NPM1P52 CNV",
    "NPM1P52 RNA"
  ],
  "SLC9A3": [
    "SLC9A3 CNV",
    "SLC9A3 RNA",
    "SLC9A3 Proteo"
  ],
  "MVB12A": [
    "MVB12A CNV",
    "MVB12A RNA",
    "MVB12A Proteo"
  ],
  "MTND2P3": [
    "MTND2P3 CNV",
    "MTND2P3 RNA"
  ],
  "NPM1P45": [
    "NPM1P45 CNV",
    "NPM1P45 RNA"
  ],
  "PYURF": [
    "PYURF CNV",
    "PYURF RNA",
    "PYURF Proteo"
  ],
  "INPP4A": [
    "INPP4A CNV",
    "INPP4A RNA",
    "INPP4A Proteo"
  ],
  "PKD1P2": [
    "PKD1P2 CNV",
    "PKD1P2 RNA"
  ],
  "LYSMD4": [
    "LYSMD4 CNV",
    "LYSMD4 RNA"
  ],
  "PPP6C": [
    "PPP6C CNV",
    "PPP6C RNA",
    "PPP6C Proteo"
  ],
  "RAET1L": [
    "RAET1L CNV",
    "RAET1L RNA"
  ],
  "OR9A4": [
    "OR9A4 CNV",
    "OR9A4 RNA"
  ],
  "FTO": [
    "FTO CNV",
    "FTO RNA",
    "FTO Proteo"
  ],
  "PPT1": [
    "PPT1 CNV",
    "PPT1 RNA",
    "PPT1 Proteo"
  ],
  "MTMR12": [
    "MTMR12 CNV",
    "MTMR12 RNA",
    "MTMR12 Proteo"
  ],
  "NOX5": [
    "NOX5 CNV",
    "NOX5 RNA"
  ],
  "MST1L": [
    "MST1L CNV",
    "MST1L RNA"
  ],
  "RAD54L2": [
    "RAD54L2 CNV",
    "RAD54L2 RNA",
    "RAD54L2 Proteo"
  ],
  "PCDHB16": [
    "PCDHB16 CNV",
    "PCDHB16 RNA",
    "PCDHB16 Proteo"
  ],
  "ARHGEF11": [
    "ARHGEF11 CNV",
    "ARHGEF11 RNA",
    "ARHGEF11 Proteo"
  ],
  "VN1R6P": [
    "VN1R6P CNV",
    "VN1R6P RNA"
  ],
  "HMGN2P15": [
    "HMGN2P15 CNV",
    "HMGN2P15 RNA"
  ],
  "DCAF17": [
    "DCAF17 CNV",
    "DCAF17 RNA"
  ],
  "DEFB130D": [
    "DEFB130D CNV",
    "DEFB130D RNA"
  ],
  "OR5T2": [
    "OR5T2 CNV",
    "OR5T2 RNA"
  ],
  "TAS2R3": [
    "TAS2R3 CNV",
    "TAS2R3 RNA"
  ],
  "MFAP3": [
    "MFAP3 CNV",
    "MFAP3 RNA",
    "MFAP3 Proteo"
  ],
  "MLLT10P2": [
    "MLLT10P2 CNV",
    "MLLT10P2 RNA"
  ],
  "ALOX15P1": [
    "ALOX15P1 CNV",
    "ALOX15P1 RNA"
  ],
  "SLAIN2": [
    "SLAIN2 CNV",
    "SLAIN2 RNA",
    "SLAIN2 Proteo"
  ],
  "RPL3P6": [
    "RPL3P6 CNV",
    "RPL3P6 RNA"
  ],
  "CFAP221": [
    "CFAP221 CNV",
    "CFAP221 RNA"
  ],
  "TAS2R43": [
    "TAS2R43 CNV",
    "TAS2R43 RNA"
  ],
  "SDR42E1": [
    "SDR42E1 CNV",
    "SDR42E1 RNA"
  ],
  "FPR2": [
    "FPR2 CNV",
    "FPR2 RNA"
  ],
  "MATR3P1": [
    "MATR3P1 CNV",
    "MATR3P1 RNA"
  ],
  "NCOA4": [
    "NCOA4 CNV",
    "NCOA4 RNA",
    "NCOA4 Proteo"
  ],
  "MTCO3P29": [
    "MTCO3P29 CNV",
    "MTCO3P29 RNA"
  ],
  "ATP5MKP1": [
    "ATP5MKP1 CNV",
    "ATP5MKP1 RNA"
  ],
  "SLC16A13": [
    "SLC16A13 CNV",
    "SLC16A13 RNA"
  ],
  "RP9": [
    "RP9 CNV",
    "RP9 RNA",
    "RP9 Proteo"
  ],
  "DLEU7": [
    "DLEU7 CNV",
    "DLEU7 RNA"
  ],
  "KDM1B": [
    "KDM1B CNV",
    "KDM1B RNA",
    "KDM1B Proteo"
  ],
  "TRPC6P1": [
    "TRPC6P1 CNV",
    "TRPC6P1 RNA"
  ],
  "EP400P1": [
    "EP400P1 CNV",
    "EP400P1 RNA"
  ],
  "AUH": [
    "AUH CNV",
    "AUH RNA",
    "AUH Proteo"
  ],
  "ACTR5": [
    "ACTR5 CNV",
    "ACTR5 RNA",
    "ACTR5 Proteo"
  ],
  "OR52N5": [
    "OR52N5 CNV",
    "OR52N5 RNA"
  ],
  "RARRES2P9": [
    "RARRES2P9 CNV",
    "RARRES2P9 RNA"
  ],
  "ZBTB14": [
    "ZBTB14 CNV",
    "ZBTB14 RNA",
    "ZBTB14 Proteo"
  ],
  "COX6B1P6": [
    "COX6B1P6 CNV",
    "COX6B1P6 RNA"
  ],
  "OR4F28P": [
    "OR4F28P CNV",
    "OR4F28P RNA"
  ],
  "NSG1": [
    "NSG1 CNV",
    "NSG1 RNA",
    "NSG1 Proteo"
  ],
  "RPL21P33": [
    "RPL21P33 CNV",
    "RPL21P33 RNA"
  ],
  "H2AB3": [
    "H2AB3 CNV",
    "H2AB3 RNA"
  ],
  "OR5K2": [
    "OR5K2 CNV",
    "OR5K2 RNA"
  ],
  "SERPINA12": [
    "SERPINA12 CNV",
    "SERPINA12 RNA",
    "SERPINA12 Proteo"
  ],
  "FDPS": [
    "FDPS CNV",
    "FDPS RNA",
    "FDPS Proteo"
  ],
  "VEGFD": [
    "VEGFD CNV",
    "VEGFD RNA"
  ],
  "OR6A2": [
    "OR6A2 CNV",
    "OR6A2 RNA"
  ],
  "ELK4": [
    "ELK4 CNV",
    "ELK4 RNA",
    "ELK4 Proteo"
  ],
  "NSMCE2": [
    "NSMCE2 CNV",
    "NSMCE2 RNA",
    "NSMCE2 Proteo"
  ],
  "POLHP1": [
    "POLHP1 CNV",
    "POLHP1 RNA"
  ],
  "FMR1": [
    "FMR1 CNV",
    "FMR1 RNA",
    "FMR1 Proteo"
  ],
  "S100A3": [
    "S100A3 CNV",
    "S100A3 RNA",
    "S100A3 Proteo"
  ],
  "ABHD14B": [
    "ABHD14B CNV",
    "ABHD14B RNA",
    "ABHD14B Proteo"
  ],
  "ACTR3": [
    "ACTR3 CNV",
    "ACTR3 RNA",
    "ACTR3 Proteo"
  ],
  "ACSF2": [
    "ACSF2 CNV",
    "ACSF2 RNA",
    "ACSF2 Proteo"
  ],
  "OR2AT1P": [
    "OR2AT1P CNV",
    "OR2AT1P RNA"
  ],
  "ZYG11A": [
    "ZYG11A CNV",
    "ZYG11A RNA"
  ],
  "MRLN": [
    "MRLN CNV",
    "MRLN RNA"
  ],
  "HELT": [
    "HELT CNV",
    "HELT RNA"
  ],
  "MNAT1": [
    "MNAT1 CNV",
    "MNAT1 RNA",
    "MNAT1 Proteo"
  ],
  "TRAV31": [
    "TRAV31 CNV",
    "TRAV31 RNA"
  ],
  "ANKRD36": [
    "ANKRD36 CNV",
    "ANKRD36 RNA"
  ],
  "LIMCH1": [
    "LIMCH1 CNV",
    "LIMCH1 RNA",
    "LIMCH1 Proteo"
  ],
  "AMH": [
    "AMH CNV",
    "AMH RNA"
  ],
  "ZNF169": [
    "ZNF169 CNV",
    "ZNF169 RNA"
  ],
  "NANOS3": [
    "NANOS3 CNV",
    "NANOS3 RNA"
  ],
  "FOCAD": [
    "FOCAD CNV",
    "FOCAD RNA",
    "FOCAD Proteo"
  ],
  "IGHV3-37": [
    "IGHV3-37 CNV",
    "IGHV3-37 RNA"
  ],
  "CLN5": [
    "CLN5 CNV",
    "CLN5 RNA",
    "CLN5 Proteo"
  ],
  "CRYBG2": [
    "CRYBG2 CNV",
    "CRYBG2 RNA",
    "CRYBG2 Proteo"
  ],
  "DUX4L17": [
    "DUX4L17 CNV",
    "DUX4L17 RNA"
  ],
  "ISY1": [
    "ISY1 CNV",
    "ISY1 RNA"
  ],
  "BST1": [
    "BST1 CNV",
    "BST1 RNA",
    "BST1 Proteo"
  ],
  "MED28P4": [
    "MED28P4 CNV",
    "MED28P4 RNA"
  ],
  "CCDC194": [
    "CCDC194 CNV",
    "CCDC194 RNA"
  ],
  "RASA2": [
    "RASA2 CNV",
    "RASA2 RNA",
    "RASA2 Proteo"
  ],
  "LCE2B": [
    "LCE2B CNV",
    "LCE2B RNA"
  ],
  "FAM90A27P": [
    "FAM90A27P CNV",
    "FAM90A27P RNA"
  ],
  "UTP18": [
    "UTP18 CNV",
    "UTP18 RNA",
    "UTP18 Proteo"
  ],
  "PRKCG": [
    "PRKCG CNV",
    "PRKCG RNA"
  ],
  "MRPS18CP7": [
    "MRPS18CP7 CNV",
    "MRPS18CP7 RNA"
  ],
  "TRPM4": [
    "TRPM4 CNV",
    "TRPM4 RNA",
    "TRPM4 Proteo"
  ],
  "RPL27AP3": [
    "RPL27AP3 CNV",
    "RPL27AP3 RNA"
  ],
  "TPP1": [
    "TPP1 CNV",
    "TPP1 RNA",
    "TPP1 Proteo"
  ],
  "RNF111": [
    "RNF111 CNV",
    "RNF111 RNA",
    "RNF111 Proteo"
  ],
  "ASCC3": [
    "ASCC3 CNV",
    "ASCC3 RNA",
    "ASCC3 Proteo"
  ],
  "UNC93B5": [
    "UNC93B5 CNV",
    "UNC93B5 RNA"
  ],
  "IKBKE": [
    "IKBKE CNV",
    "IKBKE RNA",
    "IKBKE Proteo"
  ],
  "EIF2S2P3": [
    "EIF2S2P3 CNV",
    "EIF2S2P3 RNA"
  ],
  "PHB1P17": [
    "PHB1P17 CNV",
    "PHB1P17 RNA"
  ],
  "RPSAP69": [
    "RPSAP69 CNV",
    "RPSAP69 RNA"
  ],
  "IL16": [
    "IL16 CNV",
    "IL16 RNA",
    "IL16 Proteo"
  ],
  "PER2": [
    "PER2 CNV",
    "PER2 RNA"
  ],
  "EFCAB2": [
    "EFCAB2 CNV",
    "EFCAB2 RNA",
    "EFCAB2 Proteo"
  ],
  "PACSIN1": [
    "PACSIN1 CNV",
    "PACSIN1 RNA",
    "PACSIN1 Proteo"
  ],
  "PRSS12": [
    "PRSS12 CNV",
    "PRSS12 RNA"
  ],
  "CYCSP8": [
    "CYCSP8 CNV",
    "CYCSP8 RNA"
  ],
  "PPIAP90": [
    "PPIAP90 CNV",
    "PPIAP90 RNA"
  ],
  "MED15P6": [
    "MED15P6 CNV",
    "MED15P6 RNA"
  ],
  "HENMT1": [
    "HENMT1 CNV",
    "HENMT1 RNA",
    "HENMT1 Proteo"
  ],
  "BMP1": [
    "BMP1 CNV",
    "BMP1 RNA",
    "BMP1 Proteo"
  ],
  "KLRB1": [
    "KLRB1 CNV",
    "KLRB1 RNA"
  ],
  "TTC12": [
    "TTC12 CNV",
    "TTC12 RNA",
    "TTC12 Proteo"
  ],
  "HMCN1": [
    "HMCN1 CNV",
    "HMCN1 RNA",
    "HMCN1 Proteo"
  ],
  "SLURP1": [
    "SLURP1 CNV",
    "SLURP1 RNA",
    "SLURP1 Proteo"
  ],
  "KLHL14": [
    "KLHL14 CNV",
    "KLHL14 RNA",
    "KLHL14 Proteo"
  ],
  "GNG5P2": [
    "GNG5P2 CNV",
    "GNG5P2 RNA"
  ],
  "EPS15L1": [
    "EPS15L1 CNV",
    "EPS15L1 RNA",
    "EPS15L1 Proteo"
  ],
  "OR5BN2P": [
    "OR5BN2P CNV",
    "OR5BN2P RNA"
  ],
  "KAT2B": [
    "KAT2B CNV",
    "KAT2B RNA",
    "KAT2B Proteo"
  ],
  "DMWD": [
    "DMWD CNV",
    "DMWD RNA",
    "DMWD Proteo"
  ],
  "XKR5": [
    "XKR5 CNV",
    "XKR5 RNA"
  ],
  "RNA5SP287": [
    "RNA5SP287 CNV",
    "RNA5SP287 RNA"
  ],
  "UGT1A6": [
    "UGT1A6 CNV",
    "UGT1A6 RNA",
    "UGT1A6 Proteo"
  ],
  "RBM26": [
    "RBM26 CNV",
    "RBM26 RNA",
    "RBM26 Proteo"
  ],
  "CIAO2A": [
    "CIAO2A CNV",
    "CIAO2A RNA",
    "CIAO2A Proteo"
  ],
  "RPL37AP8": [
    "RPL37AP8 CNV",
    "RPL37AP8 RNA"
  ],
  "PNLDC1": [
    "PNLDC1 CNV",
    "PNLDC1 RNA"
  ],
  "PIGO": [
    "PIGO CNV",
    "PIGO RNA",
    "PIGO Proteo"
  ],
  "ST7": [
    "ST7 CNV",
    "ST7 RNA",
    "ST7 Proteo"
  ],
  "IGHV6-1": [
    "IGHV6-1 Proteo"
  ],
  "UNC79": [
    "UNC79 CNV",
    "UNC79 RNA"
  ],
  "IGLV1-62": [
    "IGLV1-62 CNV",
    "IGLV1-62 RNA"
  ],
  "PWP2": [
    "PWP2 CNV",
    "PWP2 RNA",
    "PWP2 Proteo"
  ],
  "HDAC4": [
    "HDAC4 CNV",
    "HDAC4 RNA",
    "HDAC4 Proteo"
  ],
  "TMEM237": [
    "TMEM237 CNV",
    "TMEM237 RNA",
    "TMEM237 Proteo"
  ],
  "ARHGEF10L": [
    "ARHGEF10L CNV",
    "ARHGEF10L RNA",
    "ARHGEF10L Proteo"
  ],
  "MTND4P6": [
    "MTND4P6 CNV",
    "MTND4P6 RNA"
  ],
  "BANK1": [
    "BANK1 CNV",
    "BANK1 RNA",
    "BANK1 Proteo"
  ],
  "NANOGP8": [
    "NANOGP8 CNV",
    "NANOGP8 RNA"
  ],
  "CAPZA1P4": [
    "CAPZA1P4 CNV",
    "CAPZA1P4 RNA"
  ],
  "IGLC7": [
    "IGLC7 Proteo"
  ],
  "TBX1": [
    "TBX1 CNV",
    "TBX1 RNA"
  ],
  "ABHD2": [
    "ABHD2 CNV",
    "ABHD2 RNA",
    "ABHD2 Proteo"
  ],
  "RPL35AP17": [
    "RPL35AP17 CNV",
    "RPL35AP17 RNA"
  ],
  "RAB1B": [
    "RAB1B CNV",
    "RAB1B RNA",
    "RAB1B Proteo"
  ],
  "CTBS": [
    "CTBS CNV",
    "CTBS RNA",
    "CTBS Proteo"
  ],
  "TFCP2L1": [
    "TFCP2L1 CNV",
    "TFCP2L1 RNA",
    "TFCP2L1 Proteo"
  ],
  "ATP6V1G1P5": [
    "ATP6V1G1P5 CNV",
    "ATP6V1G1P5 RNA"
  ],
  "CAPZA1P3": [
    "CAPZA1P3 CNV",
    "CAPZA1P3 RNA"
  ],
  "ITGBL1": [
    "ITGBL1 CNV",
    "ITGBL1 RNA",
    "ITGBL1 Proteo"
  ],
  "CHCHD2P7": [
    "CHCHD2P7 CNV",
    "CHCHD2P7 RNA"
  ],
  "TOR1B": [
    "TOR1B CNV",
    "TOR1B RNA",
    "TOR1B Proteo"
  ],
  "FAM114A2": [
    "FAM114A2 CNV",
    "FAM114A2 RNA",
    "FAM114A2 Proteo"
  ],
  "TAS2R50": [
    "TAS2R50 CNV",
    "TAS2R50 RNA"
  ],
  "VIPR2": [
    "VIPR2 CNV",
    "VIPR2 RNA"
  ],
  "CASZ1": [
    "CASZ1 CNV",
    "CASZ1 RNA",
    "CASZ1 Proteo"
  ],
  "NCR3": [
    "NCR3 CNV",
    "NCR3 RNA"
  ],
  "OR8B1P": [
    "OR8B1P CNV",
    "OR8B1P RNA"
  ],
  "ZFYVE26": [
    "ZFYVE26 CNV",
    "ZFYVE26 RNA",
    "ZFYVE26 Proteo"
  ],
  "BDP1P": [
    "BDP1P CNV",
    "BDP1P RNA"
  ],
  "MAGEA2": [
    "MAGEA2 CNV",
    "MAGEA2 RNA"
  ],
  "IFNL3": [
    "IFNL3 CNV",
    "IFNL3 RNA"
  ],
  "CDK6": [
    "CDK6 CNV",
    "CDK6 RNA",
    "CDK6 Proteo"
  ],
  "ZNF546": [
    "ZNF546 CNV",
    "ZNF546 RNA"
  ],
  "TUBGCP6": [
    "TUBGCP6 CNV",
    "TUBGCP6 RNA",
    "TUBGCP6 Proteo"
  ],
  "DDX50": [
    "DDX50 CNV",
    "DDX50 RNA",
    "DDX50 Proteo"
  ],
  "IGHVIII-2-1": [
    "IGHVIII-2-1 CNV",
    "IGHVIII-2-1 RNA"
  ],
  "HAUS4P1": [
    "HAUS4P1 CNV",
    "HAUS4P1 RNA"
  ],
  "PNO1": [
    "PNO1 CNV",
    "PNO1 RNA",
    "PNO1 Proteo"
  ],
  "DNAJC13": [
    "DNAJC13 CNV",
    "DNAJC13 RNA",
    "DNAJC13 Proteo"
  ],
  "RNA5SP415": [
    "RNA5SP415 CNV",
    "RNA5SP415 RNA"
  ],
  "PLPP5": [
    "PLPP5 CNV",
    "PLPP5 RNA"
  ],
  "CTAG1A": [
    "CTAG1A CNV",
    "CTAG1A RNA"
  ],
  "DUX4L28": [
    "DUX4L28 CNV",
    "DUX4L28 RNA"
  ],
  "RAB9AP2": [
    "RAB9AP2 CNV",
    "RAB9AP2 RNA"
  ],
  "PINX1": [
    "PINX1 CNV",
    "PINX1 RNA",
    "PINX1 Proteo"
  ],
  "RPL6P1": [
    "RPL6P1 CNV",
    "RPL6P1 RNA"
  ],
  "KLLN": [
    "KLLN CNV",
    "KLLN RNA"
  ],
  "OR9S24P": [
    "OR9S24P CNV",
    "OR9S24P RNA"
  ],
  "MYL6P5": [
    "MYL6P5 CNV",
    "MYL6P5 RNA"
  ],
  "SNRPGP8": [
    "SNRPGP8 CNV",
    "SNRPGP8 RNA"
  ],
  "MYO5C": [
    "MYO5C CNV",
    "MYO5C RNA",
    "MYO5C Proteo"
  ],
  "FANCM": [
    "FANCM CNV",
    "FANCM RNA"
  ],
  "DDX43P2": [
    "DDX43P2 CNV",
    "DDX43P2 RNA"
  ],
  "IPMK": [
    "IPMK CNV",
    "IPMK RNA",
    "IPMK Proteo"
  ],
  "MTCO1P45": [
    "MTCO1P45 CNV",
    "MTCO1P45 RNA"
  ],
  "RNA5SP122": [
    "RNA5SP122 CNV",
    "RNA5SP122 RNA"
  ],
  "SLC25A24": [
    "SLC25A24 CNV",
    "SLC25A24 RNA",
    "SLC25A24 Proteo"
  ],
  "PIGFP3": [
    "PIGFP3 CNV",
    "PIGFP3 RNA"
  ],
  "CARMIL1": [
    "CARMIL1 CNV",
    "CARMIL1 RNA",
    "CARMIL1 Proteo"
  ],
  "MYG1": [
    "MYG1 CNV",
    "MYG1 RNA",
    "MYG1 Proteo"
  ],
  "HSF5": [
    "HSF5 CNV",
    "HSF5 RNA"
  ],
  "UBLCP1": [
    "UBLCP1 CNV",
    "UBLCP1 RNA",
    "UBLCP1 Proteo"
  ],
  "WTAP": [
    "WTAP CNV",
    "WTAP RNA",
    "WTAP Proteo"
  ],
  "PGK1": [
    "PGK1 CNV",
    "PGK1 RNA",
    "PGK1 Proteo"
  ],
  "TRBV26OR9-2": [
    "TRBV26OR9-2 CNV",
    "TRBV26OR9-2 RNA"
  ],
  "ZNF345": [
    "ZNF345 CNV",
    "ZNF345 RNA",
    "ZNF345 Proteo"
  ],
  "KATNIP": [
    "KATNIP CNV",
    "KATNIP RNA",
    "KATNIP Proteo"
  ],
  "ADAM9": [
    "ADAM9 CNV",
    "ADAM9 RNA",
    "ADAM9 Proteo"
  ],
  "JCHAINP1": [
    "JCHAINP1 CNV",
    "JCHAINP1 RNA"
  ],
  "IDH2": [
    "IDH2 CNV",
    "IDH2 RNA",
    "IDH2 Proteo"
  ],
  "GOT2P3": [
    "GOT2P3 CNV",
    "GOT2P3 RNA"
  ],
  "VPS35P1": [
    "VPS35P1 CNV",
    "VPS35P1 RNA"
  ],
  "NEUROG3": [
    "NEUROG3 CNV",
    "NEUROG3 RNA"
  ],
  "FBLN7": [
    "FBLN7 CNV",
    "FBLN7 RNA",
    "FBLN7 Proteo"
  ],
  "RNA5SP112": [
    "RNA5SP112 CNV",
    "RNA5SP112 RNA"
  ],
  "NPHS1": [
    "NPHS1 CNV",
    "NPHS1 RNA"
  ],
  "GRAMD4P7": [
    "GRAMD4P7 CNV",
    "GRAMD4P7 RNA"
  ],
  "FAM210B": [
    "FAM210B CNV",
    "FAM210B RNA",
    "FAM210B Proteo"
  ],
  "TMEM44": [
    "TMEM44 CNV",
    "TMEM44 RNA",
    "TMEM44 Proteo"
  ],
  "SERF1AP1": [
    "SERF1AP1 CNV",
    "SERF1AP1 RNA"
  ],
  "LACTB2": [
    "LACTB2 CNV",
    "LACTB2 RNA",
    "LACTB2 Proteo"
  ],
  "PRYP2": [
    "PRYP2 CNV",
    "PRYP2 RNA"
  ],
  "BMS1P22": [
    "BMS1P22 CNV",
    "BMS1P22 RNA"
  ],
  "NBPF15": [
    "NBPF15 CNV",
    "NBPF15 RNA"
  ],
  "CDK15": [
    "CDK15 CNV",
    "CDK15 RNA"
  ],
  "TRMT13": [
    "TRMT13 CNV",
    "TRMT13 RNA",
    "TRMT13 Proteo"
  ],
  "DLGAP2": [
    "DLGAP2 CNV",
    "DLGAP2 RNA"
  ],
  "RPL23AP31": [
    "RPL23AP31 CNV",
    "RPL23AP31 RNA"
  ],
  "POU5F1": [
    "POU5F1 CNV",
    "POU5F1 RNA"
  ],
  "APOL3": [
    "APOL3 CNV",
    "APOL3 RNA",
    "APOL3 Proteo"
  ],
  "GABRP": [
    "GABRP CNV",
    "GABRP RNA"
  ],
  "RAET1E": [
    "RAET1E CNV",
    "RAET1E RNA"
  ],
  "CDH17": [
    "CDH17 CNV",
    "CDH17 RNA"
  ],
  "ATP5F1CP1": [
    "ATP5F1CP1 CNV",
    "ATP5F1CP1 RNA"
  ],
  "CST2": [
    "CST2 CNV",
    "CST2 RNA",
    "CST2 Proteo"
  ],
  "PCF11": [
    "PCF11 CNV",
    "PCF11 RNA",
    "PCF11 Proteo"
  ],
  "INTS13": [
    "INTS13 CNV",
    "INTS13 RNA",
    "INTS13 Proteo"
  ],
  "ZNF704": [
    "ZNF704 CNV",
    "ZNF704 RNA",
    "ZNF704 Proteo"
  ],
  "PTDSS2": [
    "PTDSS2 CNV",
    "PTDSS2 RNA",
    "PTDSS2 Proteo"
  ],
  "ZNF970P": [
    "ZNF970P CNV",
    "ZNF970P RNA"
  ],
  "TMEM106B": [
    "TMEM106B CNV",
    "TMEM106B RNA",
    "TMEM106B Proteo"
  ],
  "CXCL8": [
    "CXCL8 CNV",
    "CXCL8 RNA",
    "CXCL8 Proteo"
  ],
  "C17orf67": [
    "C17orf67 CNV",
    "C17orf67 RNA"
  ],
  "SRP9P1": [
    "SRP9P1 CNV",
    "SRP9P1 RNA"
  ],
  "RNASEH2CP1": [
    "RNASEH2CP1 CNV",
    "RNASEH2CP1 RNA"
  ],
  "DBNL": [
    "DBNL CNV",
    "DBNL RNA",
    "DBNL Proteo"
  ],
  "C2orf88": [
    "C2orf88 CNV",
    "C2orf88 RNA",
    "C2orf88 Proteo"
  ],
  "SYNGR2P1": [
    "SYNGR2P1 CNV",
    "SYNGR2P1 RNA"
  ],
  "POMZP3": [
    "POMZP3 CNV",
    "POMZP3 RNA"
  ],
  "STAG2": [
    "STAG2 CNV",
    "STAG2 RNA",
    "STAG2 Proteo"
  ],
  "SNRPFP4": [
    "SNRPFP4 CNV",
    "SNRPFP4 RNA"
  ],
  "RAP2C": [
    "RAP2C CNV",
    "RAP2C RNA",
    "RAP2C Proteo"
  ],
  "BNIP3P15": [
    "BNIP3P15 CNV",
    "BNIP3P15 RNA"
  ],
  "ETAA1": [
    "ETAA1 CNV",
    "ETAA1 RNA",
    "ETAA1 Proteo"
  ],
  "SLC7A5P1": [
    "SLC7A5P1 CNV",
    "SLC7A5P1 RNA"
  ],
  "CALM2": [
    "CALM2 CNV",
    "CALM2 RNA",
    "CALM2 Proteo"
  ],
  "TPMTP3": [
    "TPMTP3 CNV",
    "TPMTP3 RNA"
  ],
  "TMEM235": [
    "TMEM235 CNV",
    "TMEM235 RNA"
  ],
  "WDR45P1": [
    "WDR45P1 CNV",
    "WDR45P1 RNA"
  ],
  "GAPDHP52": [
    "GAPDHP52 CNV",
    "GAPDHP52 RNA"
  ],
  "KLF16": [
    "KLF16 CNV",
    "KLF16 RNA",
    "KLF16 Proteo"
  ],
  "SP6": [
    "SP6 CNV",
    "SP6 RNA"
  ],
  "PNLIPP1": [
    "PNLIPP1 CNV",
    "PNLIPP1 RNA"
  ],
  "KRT127P": [
    "KRT127P CNV",
    "KRT127P RNA"
  ],
  "MTATP6P3": [
    "MTATP6P3 CNV",
    "MTATP6P3 RNA"
  ],
  "H2BC18": [
    "H2BC18 CNV",
    "H2BC18 RNA",
    "H2BC18 Proteo"
  ],
  "NPIPB15": [
    "NPIPB15 CNV",
    "NPIPB15 RNA"
  ],
  "CD3G": [
    "CD3G CNV",
    "CD3G RNA",
    "CD3G Proteo"
  ],
  "MRFAP1": [
    "MRFAP1 CNV",
    "MRFAP1 RNA",
    "MRFAP1 Proteo"
  ],
  "RSF1": [
    "RSF1 CNV",
    "RSF1 RNA",
    "RSF1 Proteo"
  ],
  "CXorf58": [
    "CXorf58 CNV",
    "CXorf58 RNA"
  ],
  "DPRXP7": [
    "DPRXP7 CNV",
    "DPRXP7 RNA"
  ],
  "TNPO3P1": [
    "TNPO3P1 CNV",
    "TNPO3P1 RNA"
  ],
  "ZNF300P1": [
    "ZNF300P1 CNV",
    "ZNF300P1 RNA"
  ],
  "LOXL3": [
    "LOXL3 CNV",
    "LOXL3 RNA",
    "LOXL3 Proteo"
  ],
  "PAQR9": [
    "PAQR9 CNV",
    "PAQR9 RNA"
  ],
  "VN1R87P": [
    "VN1R87P CNV",
    "VN1R87P RNA"
  ],
  "ELOA3DP": [
    "ELOA3DP CNV",
    "ELOA3DP RNA"
  ],
  "IFNA10": [
    "IFNA10 CNV",
    "IFNA10 RNA"
  ],
  "KLF7P1": [
    "KLF7P1 CNV",
    "KLF7P1 RNA"
  ],
  "OR13C6P": [
    "OR13C6P CNV",
    "OR13C6P RNA"
  ],
  "PSPN": [
    "PSPN CNV",
    "PSPN RNA"
  ],
  "PPP1R15A": [
    "PPP1R15A CNV",
    "PPP1R15A RNA"
  ],
  "IGKV1-17": [
    "IGKV1-17 Proteo"
  ],
  "SNX14": [
    "SNX14 CNV",
    "SNX14 RNA",
    "SNX14 Proteo"
  ],
  "SEPTIN14P6": [
    "SEPTIN14P6 CNV",
    "SEPTIN14P6 RNA"
  ],
  "KLHL2P1": [
    "KLHL2P1 CNV",
    "KLHL2P1 RNA"
  ],
  "SCML1": [
    "SCML1 CNV",
    "SCML1 RNA"
  ],
  "GOLGA2P10": [
    "GOLGA2P10 CNV",
    "GOLGA2P10 RNA"
  ],
  "STAG3L1": [
    "STAG3L1 CNV",
    "STAG3L1 RNA"
  ],
  "PAQR8": [
    "PAQR8 CNV",
    "PAQR8 RNA",
    "PAQR8 Proteo"
  ],
  "LMF1": [
    "LMF1 CNV",
    "LMF1 RNA",
    "LMF1 Proteo"
  ],
  "OR5I1": [
    "OR5I1 CNV",
    "OR5I1 RNA"
  ],
  "MT1DP": [
    "MT1DP CNV",
    "MT1DP RNA"
  ],
  "TUBBP6": [
    "TUBBP6 CNV",
    "TUBBP6 RNA"
  ],
  "HROB": [
    "HROB CNV",
    "HROB RNA",
    "HROB Proteo"
  ],
  "LZTFL1": [
    "LZTFL1 CNV",
    "LZTFL1 RNA",
    "LZTFL1 Proteo"
  ],
  "GIMAP5": [
    "GIMAP5 CNV",
    "GIMAP5 RNA"
  ],
  "RNASET2": [
    "RNASET2 CNV",
    "RNASET2 RNA",
    "RNASET2 Proteo"
  ],
  "MCRIP2": [
    "MCRIP2 CNV",
    "MCRIP2 RNA",
    "MCRIP2 Proteo"
  ],
  "DECR1": [
    "DECR1 CNV",
    "DECR1 RNA",
    "DECR1 Proteo"
  ],
  "RNA5SP396": [
    "RNA5SP396 CNV",
    "RNA5SP396 RNA"
  ],
  "H3P6": [
    "H3P6 CNV",
    "H3P6 RNA"
  ],
  "SLC8B1": [
    "SLC8B1 CNV",
    "SLC8B1 RNA",
    "SLC8B1 Proteo"
  ],
  "PITX3": [
    "PITX3 CNV",
    "PITX3 RNA"
  ],
  "LRRC37A17P": [
    "LRRC37A17P CNV",
    "LRRC37A17P RNA"
  ],
  "SNAPC5P1": [
    "SNAPC5P1 CNV",
    "SNAPC5P1 RNA"
  ],
  "NPM1P11": [
    "NPM1P11 CNV",
    "NPM1P11 RNA"
  ],
  "AGAP1": [
    "AGAP1 CNV",
    "AGAP1 RNA",
    "AGAP1 Proteo"
  ],
  "EFEMP2": [
    "EFEMP2 CNV",
    "EFEMP2 RNA",
    "EFEMP2 Proteo"
  ],
  "HNRNPCP7": [
    "HNRNPCP7 CNV",
    "HNRNPCP7 RNA"
  ],
  "ATF6B": [
    "ATF6B CNV",
    "ATF6B RNA",
    "ATF6B Proteo"
  ],
  "RPL7AP76": [
    "RPL7AP76 CNV",
    "RPL7AP76 RNA"
  ],
  "UGT2B7": [
    "UGT2B7 CNV",
    "UGT2B7 RNA"
  ],
  "CLPP": [
    "CLPP CNV",
    "CLPP RNA",
    "CLPP Proteo"
  ],
  "PARVB": [
    "PARVB CNV",
    "PARVB RNA",
    "PARVB Proteo"
  ],
  "PTGFR": [
    "PTGFR CNV",
    "PTGFR RNA"
  ],
  "ZNF614": [
    "ZNF614 CNV",
    "ZNF614 RNA"
  ],
  "PELI3": [
    "PELI3 CNV",
    "PELI3 RNA"
  ],
  "C4orf54": [
    "C4orf54 CNV",
    "C4orf54 RNA",
    "C4orf54 Proteo"
  ],
  "SNRNP40": [
    "SNRNP40 CNV",
    "SNRNP40 RNA",
    "SNRNP40 Proteo"
  ],
  "NBPF1": [
    "NBPF1 CNV",
    "NBPF1 RNA"
  ],
  "SALL1P1": [
    "SALL1P1 CNV",
    "SALL1P1 RNA"
  ],
  "WDR1": [
    "WDR1 CNV",
    "WDR1 RNA",
    "WDR1 Proteo"
  ],
  "TGM6": [
    "TGM6 CNV",
    "TGM6 RNA"
  ],
  "ATP2A2": [
    "ATP2A2 CNV",
    "ATP2A2 RNA",
    "ATP2A2 Proteo"
  ],
  "DUX4L19": [
    "DUX4L19 CNV",
    "DUX4L19 RNA"
  ],
  "PLK1": [
    "PLK1 CNV",
    "PLK1 RNA",
    "PLK1 Proteo"
  ],
  "HNRNPA1P19": [
    "HNRNPA1P19 CNV",
    "HNRNPA1P19 RNA"
  ],
  "ENTPD1": [
    "ENTPD1 CNV",
    "ENTPD1 RNA",
    "ENTPD1 Proteo"
  ],
  "MYL6P1": [
    "MYL6P1 CNV",
    "MYL6P1 RNA"
  ],
  "CDPF1": [
    "CDPF1 CNV",
    "CDPF1 RNA",
    "CDPF1 Proteo"
  ],
  "SPEG": [
    "SPEG CNV",
    "SPEG RNA",
    "SPEG Proteo"
  ],
  "EFNB2": [
    "EFNB2 CNV",
    "EFNB2 RNA",
    "EFNB2 Proteo"
  ],
  "MRGPRX1": [
    "MRGPRX1 CNV",
    "MRGPRX1 RNA"
  ],
  "HMGB3P12": [
    "HMGB3P12 CNV",
    "HMGB3P12 RNA"
  ],
  "TBC1D3G": [
    "TBC1D3G CNV",
    "TBC1D3G RNA"
  ],
  "PPIAP81": [
    "PPIAP81 CNV",
    "PPIAP81 RNA"
  ],
  "CBX2": [
    "CBX2 CNV",
    "CBX2 RNA",
    "CBX2 Proteo"
  ],
  "CTSD": [
    "CTSD CNV",
    "CTSD RNA",
    "CTSD Proteo"
  ],
  "ICAM1": [
    "ICAM1 CNV",
    "ICAM1 RNA",
    "ICAM1 Proteo"
  ],
  "HPF1": [
    "HPF1 CNV",
    "HPF1 RNA",
    "HPF1 Proteo"
  ],
  "ATP6V1G1P1": [
    "ATP6V1G1P1 CNV",
    "ATP6V1G1P1 RNA"
  ],
  "SMC6": [
    "SMC6 CNV",
    "SMC6 RNA",
    "SMC6 Proteo"
  ],
  "MAP3K21": [
    "MAP3K21 CNV",
    "MAP3K21 RNA"
  ],
  "NLRP6": [
    "NLRP6 CNV",
    "NLRP6 RNA",
    "NLRP6 Proteo"
  ],
  "CDC42P5": [
    "CDC42P5 CNV",
    "CDC42P5 RNA"
  ],
  "DLC1": [
    "DLC1 CNV",
    "DLC1 RNA",
    "DLC1 Proteo"
  ],
  "ECSCR": [
    "ECSCR CNV",
    "ECSCR RNA"
  ],
  "SPIN2P1": [
    "SPIN2P1 CNV",
    "SPIN2P1 RNA"
  ],
  "RPL21P93": [
    "RPL21P93 CNV",
    "RPL21P93 RNA"
  ],
  "MRPS7": [
    "MRPS7 CNV",
    "MRPS7 RNA",
    "MRPS7 Proteo"
  ],
  "ZNF74": [
    "ZNF74 CNV",
    "ZNF74 RNA"
  ],
  "NEK6": [
    "NEK6 CNV",
    "NEK6 RNA",
    "NEK6 Proteo"
  ],
  "PABPC3": [
    "PABPC3 CNV",
    "PABPC3 RNA",
    "PABPC3 Proteo"
  ],
  "MARK2P14": [
    "MARK2P14 CNV",
    "MARK2P14 RNA"
  ],
  "WASHC3P1": [
    "WASHC3P1 CNV",
    "WASHC3P1 RNA"
  ],
  "LIFR": [
    "LIFR CNV",
    "LIFR RNA",
    "LIFR Proteo"
  ],
  "CASP16P": [
    "CASP16P CNV",
    "CASP16P RNA"
  ],
  "DYNC1LI2": [
    "DYNC1LI2 CNV",
    "DYNC1LI2 RNA",
    "DYNC1LI2 Proteo"
  ],
  "MROH2B": [
    "MROH2B CNV",
    "MROH2B RNA",
    "MROH2B Proteo"
  ],
  "ZNF423": [
    "ZNF423 CNV",
    "ZNF423 RNA"
  ],
  "POLR2KP2": [
    "POLR2KP2 CNV",
    "POLR2KP2 RNA"
  ],
  "CHRFAM7A": [
    "CHRFAM7A CNV",
    "CHRFAM7A RNA"
  ],
  "MARK1": [
    "MARK1 CNV",
    "MARK1 RNA",
    "MARK1 Proteo"
  ],
  "LRMDA": [
    "LRMDA CNV",
    "LRMDA RNA",
    "LRMDA Proteo"
  ],
  "RNA5SP89": [
    "RNA5SP89 CNV",
    "RNA5SP89 RNA"
  ],
  "SNX18P10": [
    "SNX18P10 CNV",
    "SNX18P10 RNA"
  ],
  "RPS15": [
    "RPS15 CNV",
    "RPS15 RNA",
    "RPS15 Proteo"
  ],
  "GARRE1": [
    "GARRE1 CNV",
    "GARRE1 RNA",
    "GARRE1 Proteo"
  ],
  "STAC": [
    "STAC CNV",
    "STAC RNA"
  ],
  "PCDHA6": [
    "PCDHA6 CNV",
    "PCDHA6 RNA"
  ],
  "KLF6": [
    "KLF6 CNV",
    "KLF6 RNA"
  ],
  "C1S": [
    "C1S CNV",
    "C1S RNA",
    "C1S Proteo"
  ],
  "RUVBL2": [
    "RUVBL2 CNV",
    "RUVBL2 RNA",
    "RUVBL2 Proteo"
  ],
  "TRIM60": [
    "TRIM60 CNV",
    "TRIM60 RNA"
  ],
  "RWDD3": [
    "RWDD3 CNV",
    "RWDD3 RNA",
    "RWDD3 Proteo"
  ],
  "MUC12": [
    "MUC12 CNV",
    "MUC12 RNA"
  ],
  "CALR3": [
    "CALR3 CNV",
    "CALR3 RNA"
  ],
  "SLC26A11": [
    "SLC26A11 CNV",
    "SLC26A11 RNA",
    "SLC26A11 Proteo"
  ],
  "NPDC1": [
    "NPDC1 CNV",
    "NPDC1 RNA"
  ],
  "PAK4": [
    "PAK4 CNV",
    "PAK4 RNA",
    "PAK4 Proteo"
  ],
  "OVCH2": [
    "OVCH2 CNV",
    "OVCH2 RNA"
  ],
  "RPS4XP9": [
    "RPS4XP9 CNV",
    "RPS4XP9 RNA"
  ],
  "MICU2": [
    "MICU2 CNV",
    "MICU2 RNA",
    "MICU2 Proteo"
  ],
  "LTB4R": [
    "LTB4R CNV",
    "LTB4R RNA",
    "LTB4R Proteo"
  ],
  "SLC1A3": [
    "SLC1A3 CNV",
    "SLC1A3 RNA",
    "SLC1A3 Proteo"
  ],
  "OR6B2": [
    "OR6B2 CNV",
    "OR6B2 RNA"
  ],
  "PMPCB": [
    "PMPCB CNV",
    "PMPCB RNA",
    "PMPCB Proteo"
  ],
  "KRTAP4-2": [
    "KRTAP4-2 CNV",
    "KRTAP4-2 RNA"
  ],
  "PAFAH1B2P2": [
    "PAFAH1B2P2 CNV",
    "PAFAH1B2P2 RNA"
  ],
  "RACK1P2": [
    "RACK1P2 CNV",
    "RACK1P2 RNA"
  ],
  "H2BU2P": [
    "H2BU2P CNV",
    "H2BU2P RNA"
  ],
  "CNKSR3": [
    "CNKSR3 CNV",
    "CNKSR3 RNA"
  ],
  "RPL34P23": [
    "RPL34P23 CNV",
    "RPL34P23 RNA"
  ],
  "CD72": [
    "CD72 CNV",
    "CD72 RNA",
    "CD72 Proteo"
  ],
  "AMD1": [
    "AMD1 CNV",
    "AMD1 RNA",
    "AMD1 Proteo"
  ],
  "ULBP3": [
    "ULBP3 CNV",
    "ULBP3 RNA",
    "ULBP3 Proteo"
  ],
  "HSF1": [
    "HSF1 CNV",
    "HSF1 RNA",
    "HSF1 Proteo"
  ],
  "REM1": [
    "REM1 CNV",
    "REM1 RNA",
    "REM1 Proteo"
  ],
  "MTND4P34": [
    "MTND4P34 CNV",
    "MTND4P34 RNA"
  ],
  "UBAP2L": [
    "UBAP2L CNV",
    "UBAP2L RNA",
    "UBAP2L Proteo"
  ],
  "TEX11": [
    "TEX11 CNV",
    "TEX11 RNA"
  ],
  "RESP18": [
    "RESP18 CNV",
    "RESP18 RNA"
  ],
  "HIGD1AP6": [
    "HIGD1AP6 CNV",
    "HIGD1AP6 RNA"
  ],
  "KRT18P55": [
    "KRT18P55 CNV",
    "KRT18P55 RNA"
  ],
  "SPATA24": [
    "SPATA24 CNV",
    "SPATA24 RNA"
  ],
  "RNA5SP427": [
    "RNA5SP427 CNV",
    "RNA5SP427 RNA"
  ],
  "JADE2": [
    "JADE2 CNV",
    "JADE2 RNA",
    "JADE2 Proteo"
  ],
  "PLEKHH3": [
    "PLEKHH3 CNV",
    "PLEKHH3 RNA",
    "PLEKHH3 Proteo"
  ],
  "FIGNL1": [
    "FIGNL1 CNV",
    "FIGNL1 RNA",
    "FIGNL1 Proteo"
  ],
  "ZNF648": [
    "ZNF648 CNV",
    "ZNF648 RNA"
  ],
  "ZNF619P1": [
    "ZNF619P1 CNV",
    "ZNF619P1 RNA"
  ],
  "C8orf34": [
    "C8orf34 CNV",
    "C8orf34 RNA"
  ],
  "CCDC144NL": [
    "CCDC144NL CNV",
    "CCDC144NL RNA"
  ],
  "PDE4DIPP10": [
    "PDE4DIPP10 CNV",
    "PDE4DIPP10 RNA"
  ],
  "ODAD1": [
    "ODAD1 CNV",
    "ODAD1 RNA"
  ],
  "RPS20P10": [
    "RPS20P10 CNV",
    "RPS20P10 RNA"
  ],
  "YIPF7": [
    "YIPF7 CNV",
    "YIPF7 RNA"
  ],
  "SMG1P6": [
    "SMG1P6 CNV",
    "SMG1P6 RNA"
  ],
  "ARHGAP42": [
    "ARHGAP42 CNV",
    "ARHGAP42 RNA",
    "ARHGAP42 Proteo"
  ],
  "MAN1A2": [
    "MAN1A2 CNV",
    "MAN1A2 RNA",
    "MAN1A2 Proteo"
  ],
  "LSG1": [
    "LSG1 CNV",
    "LSG1 RNA",
    "LSG1 Proteo"
  ],
  "AGL": [
    "AGL CNV",
    "AGL RNA",
    "AGL Proteo"
  ],
  "AKT1S1": [
    "AKT1S1 CNV",
    "AKT1S1 RNA",
    "AKT1S1 Proteo"
  ],
  "S100A11P2": [
    "S100A11P2 CNV",
    "S100A11P2 RNA"
  ],
  "HMGN1P30": [
    "HMGN1P30 CNV",
    "HMGN1P30 RNA"
  ],
  "TMPRSS4": [
    "TMPRSS4 CNV",
    "TMPRSS4 RNA"
  ],
  "LIPM": [
    "LIPM CNV",
    "LIPM RNA"
  ],
  "GAPDHP70": [
    "GAPDHP70 CNV",
    "GAPDHP70 RNA"
  ],
  "RNA5SP380": [
    "RNA5SP380 CNV",
    "RNA5SP380 RNA"
  ],
  "RNF6P1": [
    "RNF6P1 CNV",
    "RNF6P1 RNA"
  ],
  "MTCO1P17": [
    "MTCO1P17 CNV",
    "MTCO1P17 RNA"
  ],
  "KIFAP3": [
    "KIFAP3 CNV",
    "KIFAP3 RNA",
    "KIFAP3 Proteo"
  ],
  "PALM3": [
    "PALM3 CNV",
    "PALM3 RNA"
  ],
  "CT45A8": [
    "CT45A8 CNV",
    "CT45A8 RNA"
  ],
  "TMEM265": [
    "TMEM265 CNV",
    "TMEM265 RNA"
  ],
  "BTG4": [
    "BTG4 CNV",
    "BTG4 RNA"
  ],
  "IP6K1": [
    "IP6K1 CNV",
    "IP6K1 RNA",
    "IP6K1 Proteo"
  ],
  "FAM135B": [
    "FAM135B CNV",
    "FAM135B RNA"
  ],
  "ABHD3": [
    "ABHD3 CNV",
    "ABHD3 RNA",
    "ABHD3 Proteo"
  ],
  "HSD17B14": [
    "HSD17B14 CNV",
    "HSD17B14 RNA",
    "HSD17B14 Proteo"
  ],
  "TULP1": [
    "TULP1 CNV",
    "TULP1 RNA",
    "TULP1 Proteo"
  ],
  "RPS26P8": [
    "RPS26P8 CNV",
    "RPS26P8 RNA"
  ],
  "IQSEC3P1": [
    "IQSEC3P1 CNV",
    "IQSEC3P1 RNA"
  ],
  "HERC3": [
    "HERC3 CNV",
    "HERC3 RNA",
    "HERC3 Proteo"
  ],
  "LCN1P2": [
    "LCN1P2 CNV",
    "LCN1P2 RNA"
  ],
  "PRR13P7": [
    "PRR13P7 CNV",
    "PRR13P7 RNA"
  ],
  "FRMD4A": [
    "FRMD4A CNV",
    "FRMD4A RNA",
    "FRMD4A Proteo"
  ],
  "DFFA": [
    "DFFA CNV",
    "DFFA RNA",
    "DFFA Proteo"
  ],
  "OR4F13P": [
    "OR4F13P CNV",
    "OR4F13P RNA"
  ],
  "RNASEH1P2": [
    "RNASEH1P2 CNV",
    "RNASEH1P2 RNA"
  ],
  "TOM1L2": [
    "TOM1L2 CNV",
    "TOM1L2 RNA",
    "TOM1L2 Proteo"
  ],
  "AHCTF1": [
    "AHCTF1 CNV",
    "AHCTF1 RNA",
    "AHCTF1 Proteo"
  ],
  "ZNF835": [
    "ZNF835 CNV",
    "ZNF835 RNA"
  ],
  "OR5BS1P": [
    "OR5BS1P CNV",
    "OR5BS1P RNA"
  ],
  "MTND4LP19": [
    "MTND4LP19 CNV",
    "MTND4LP19 RNA"
  ],
  "TRAV37": [
    "TRAV37 CNV",
    "TRAV37 RNA"
  ],
  "EXOSC4": [
    "EXOSC4 CNV",
    "EXOSC4 RNA",
    "EXOSC4 Proteo"
  ],
  "BOLA3": [
    "BOLA3 CNV",
    "BOLA3 RNA",
    "BOLA3 Proteo"
  ],
  "STRA8": [
    "STRA8 CNV",
    "STRA8 RNA"
  ],
  "MSH4": [
    "MSH4 CNV",
    "MSH4 RNA"
  ],
  "ZNF653": [
    "ZNF653 CNV",
    "ZNF653 RNA",
    "ZNF653 Proteo"
  ],
  "OR4A47": [
    "OR4A47 CNV",
    "OR4A47 RNA"
  ],
  "NUDT16L1": [
    "NUDT16L1 CNV",
    "NUDT16L1 RNA",
    "NUDT16L1 Proteo"
  ],
  "MIGA2": [
    "MIGA2 CNV",
    "MIGA2 RNA",
    "MIGA2 Proteo"
  ],
  "CD81": [
    "CD81 CNV",
    "CD81 RNA",
    "CD81 Proteo"
  ],
  "ZNF484": [
    "ZNF484 CNV",
    "ZNF484 RNA"
  ],
  "TMC6": [
    "TMC6 CNV",
    "TMC6 RNA",
    "TMC6 Proteo"
  ],
  "CCNO": [
    "CCNO CNV",
    "CCNO RNA"
  ],
  "SLC22A7": [
    "SLC22A7 CNV",
    "SLC22A7 RNA"
  ],
  "NEXN": [
    "NEXN CNV",
    "NEXN RNA",
    "NEXN Proteo"
  ],
  "SRP9": [
    "SRP9 CNV",
    "SRP9 RNA",
    "SRP9 Proteo"
  ],
  "CREB5": [
    "CREB5 CNV",
    "CREB5 RNA",
    "CREB5 Proteo"
  ],
  "TMEM86B": [
    "TMEM86B CNV",
    "TMEM86B RNA"
  ],
  "SPDYE2B": [
    "SPDYE2B CNV",
    "SPDYE2B RNA"
  ],
  "CLIC4P1": [
    "CLIC4P1 CNV",
    "CLIC4P1 RNA"
  ],
  "ARHGEF18": [
    "ARHGEF18 CNV",
    "ARHGEF18 RNA",
    "ARHGEF18 Proteo"
  ],
  "NDFIP1": [
    "NDFIP1 CNV",
    "NDFIP1 RNA",
    "NDFIP1 Proteo"
  ],
  "RNA5SP420": [
    "RNA5SP420 CNV",
    "RNA5SP420 RNA"
  ],
  "RNF181": [
    "RNF181 CNV",
    "RNF181 RNA",
    "RNF181 Proteo"
  ],
  "TCTN3": [
    "TCTN3 CNV",
    "TCTN3 RNA",
    "TCTN3 Proteo"
  ],
  "TRAPPC1": [
    "TRAPPC1 CNV",
    "TRAPPC1 RNA",
    "TRAPPC1 Proteo"
  ],
  "STEAP3": [
    "STEAP3 CNV",
    "STEAP3 RNA",
    "STEAP3 Proteo"
  ],
  "RNA5-8SP6": [
    "RNA5-8SP6 CNV",
    "RNA5-8SP6 RNA"
  ],
  "RNA5SP78": [
    "RNA5SP78 CNV",
    "RNA5SP78 RNA"
  ],
  "RPL30P7": [
    "RPL30P7 CNV",
    "RPL30P7 RNA"
  ],
  "UBE2F": [
    "UBE2F CNV",
    "UBE2F RNA",
    "UBE2F Proteo"
  ],
  "MTCO1P55": [
    "MTCO1P55 CNV",
    "MTCO1P55 RNA"
  ],
  "BTBD7P2": [
    "BTBD7P2 CNV",
    "BTBD7P2 RNA"
  ],
  "OOEPP2": [
    "OOEPP2 CNV",
    "OOEPP2 RNA"
  ],
  "RNA5SP350": [
    "RNA5SP350 CNV",
    "RNA5SP350 RNA"
  ],
  "SNTG1": [
    "SNTG1 CNV",
    "SNTG1 RNA"
  ],
  "PPP2R1B": [
    "PPP2R1B CNV",
    "PPP2R1B RNA",
    "PPP2R1B Proteo"
  ],
  "CGB7": [
    "CGB7 CNV",
    "CGB7 RNA"
  ],
  "ZBED4": [
    "ZBED4 CNV",
    "ZBED4 RNA",
    "ZBED4 Proteo"
  ],
  "RP1L1": [
    "RP1L1 CNV",
    "RP1L1 RNA"
  ],
  "TCF3": [
    "TCF3 CNV",
    "TCF3 RNA",
    "TCF3 Proteo"
  ],
  "PTPRB": [
    "PTPRB CNV",
    "PTPRB RNA",
    "PTPRB Proteo"
  ],
  "BPIFB4": [
    "BPIFB4 CNV",
    "BPIFB4 RNA"
  ],
  "CCNE1": [
    "CCNE1 CNV",
    "CCNE1 RNA",
    "CCNE1 Proteo"
  ],
  "PRAMEF19": [
    "PRAMEF19 CNV",
    "PRAMEF19 RNA"
  ],
  "OSBP2": [
    "OSBP2 CNV",
    "OSBP2 RNA",
    "OSBP2 Proteo"
  ],
  "KRTAP19-11P": [
    "KRTAP19-11P CNV",
    "KRTAP19-11P RNA"
  ],
  "GPR119": [
    "GPR119 CNV",
    "GPR119 RNA"
  ],
  "BARX2": [
    "BARX2 CNV",
    "BARX2 RNA"
  ],
  "UAP1": [
    "UAP1 CNV",
    "UAP1 RNA",
    "UAP1 Proteo"
  ],
  "KNDC1": [
    "KNDC1 CNV",
    "KNDC1 RNA",
    "KNDC1 Proteo"
  ],
  "RPS27AP5": [
    "RPS27AP5 CNV",
    "RPS27AP5 RNA"
  ],
  "MIGA1": [
    "MIGA1 CNV",
    "MIGA1 RNA",
    "MIGA1 Proteo"
  ],
  "HMGN1P33": [
    "HMGN1P33 CNV",
    "HMGN1P33 RNA"
  ],
  "OCIAD2": [
    "OCIAD2 CNV",
    "OCIAD2 RNA",
    "OCIAD2 Proteo"
  ],
  "MTND4LP14": [
    "MTND4LP14 CNV",
    "MTND4LP14 RNA"
  ],
  "SCAF11": [
    "SCAF11 CNV",
    "SCAF11 RNA",
    "SCAF11 Proteo"
  ],
  "NUDT8": [
    "NUDT8 CNV",
    "NUDT8 RNA",
    "NUDT8 Proteo"
  ],
  "RANGAP1": [
    "RANGAP1 CNV",
    "RANGAP1 RNA",
    "RANGAP1 Proteo"
  ],
  "DYRK1B": [
    "DYRK1B CNV",
    "DYRK1B RNA",
    "DYRK1B Proteo"
  ],
  "MYMK": [
    "MYMK CNV",
    "MYMK RNA"
  ],
  "LSMEM2": [
    "LSMEM2 CNV",
    "LSMEM2 RNA"
  ],
  "SERBP1P2": [
    "SERBP1P2 CNV",
    "SERBP1P2 RNA"
  ],
  "FSTL1": [
    "FSTL1 CNV",
    "FSTL1 RNA",
    "FSTL1 Proteo"
  ],
  "IPMKP1": [
    "IPMKP1 CNV",
    "IPMKP1 RNA"
  ],
  "RASSF5": [
    "RASSF5 CNV",
    "RASSF5 RNA",
    "RASSF5 Proteo"
  ],
  "CARD8": [
    "CARD8 CNV",
    "CARD8 RNA",
    "CARD8 Proteo"
  ],
  "DNAJB5P1": [
    "DNAJB5P1 CNV",
    "DNAJB5P1 RNA"
  ],
  "ACOD1": [
    "ACOD1 CNV",
    "ACOD1 RNA"
  ],
  "LTN1": [
    "LTN1 CNV",
    "LTN1 RNA",
    "LTN1 Proteo"
  ],
  "PREX1": [
    "PREX1 CNV",
    "PREX1 RNA",
    "PREX1 Proteo"
  ],
  "LDC1P": [
    "LDC1P CNV",
    "LDC1P RNA"
  ],
  "OLAH": [
    "OLAH CNV",
    "OLAH RNA"
  ],
  "H2BC3": [
    "H2BC3 CNV",
    "H2BC3 RNA"
  ],
  "ATP2A1": [
    "ATP2A1 CNV",
    "ATP2A1 RNA",
    "ATP2A1 Proteo"
  ],
  "CORO1A": [
    "CORO1A CNV",
    "CORO1A RNA",
    "CORO1A Proteo"
  ],
  "RPS3AP16": [
    "RPS3AP16 CNV",
    "RPS3AP16 RNA"
  ],
  "PCNX4": [
    "PCNX4 CNV",
    "PCNX4 RNA"
  ],
  "IGKV3D-25": [
    "IGKV3D-25 CNV",
    "IGKV3D-25 RNA"
  ],
  "WDR48": [
    "WDR48 CNV",
    "WDR48 RNA",
    "WDR48 Proteo"
  ],
  "CBX1P3": [
    "CBX1P3 CNV",
    "CBX1P3 RNA"
  ],
  "FAM136CP": [
    "FAM136CP CNV",
    "FAM136CP RNA"
  ],
  "RPL23AP29": [
    "RPL23AP29 CNV",
    "RPL23AP29 RNA"
  ],
  "HSD17B1P1": [
    "HSD17B1P1 CNV",
    "HSD17B1P1 RNA"
  ],
  "ARSI": [
    "ARSI CNV",
    "ARSI RNA",
    "ARSI Proteo"
  ],
  "PPIAP51": [
    "PPIAP51 CNV",
    "PPIAP51 RNA"
  ],
  "GALNT7": [
    "GALNT7 CNV",
    "GALNT7 RNA",
    "GALNT7 Proteo"
  ],
  "TXLNA": [
    "TXLNA CNV",
    "TXLNA RNA",
    "TXLNA Proteo"
  ],
  "JKAMP": [
    "JKAMP CNV",
    "JKAMP RNA",
    "JKAMP Proteo"
  ],
  "ABHD1": [
    "ABHD1 CNV",
    "ABHD1 RNA"
  ],
  "F2RL2": [
    "F2RL2 CNV",
    "F2RL2 RNA"
  ],
  "RPS28P8": [
    "RPS28P8 CNV",
    "RPS28P8 RNA"
  ],
  "MICC": [
    "MICC CNV",
    "MICC RNA"
  ],
  "KLHDC4": [
    "KLHDC4 CNV",
    "KLHDC4 RNA",
    "KLHDC4 Proteo"
  ],
  "TMC7": [
    "TMC7 CNV",
    "TMC7 RNA"
  ],
  "NXNL2": [
    "NXNL2 CNV",
    "NXNL2 RNA"
  ],
  "RBM8A": [
    "RBM8A CNV",
    "RBM8A RNA",
    "RBM8A Proteo"
  ],
  "IGKV3-25": [
    "IGKV3-25 CNV",
    "IGKV3-25 RNA"
  ],
  "SLC26A8": [
    "SLC26A8 CNV",
    "SLC26A8 RNA"
  ],
  "DOCK11P1": [
    "DOCK11P1 CNV",
    "DOCK11P1 RNA"
  ],
  "ZIC1": [
    "ZIC1 CNV",
    "ZIC1 RNA"
  ],
  "OR14C36": [
    "OR14C36 CNV",
    "OR14C36 RNA"
  ],
  "HGH1": [
    "HGH1 CNV",
    "HGH1 RNA",
    "HGH1 Proteo"
  ],
  "RPL22P17": [
    "RPL22P17 CNV",
    "RPL22P17 RNA"
  ],
  "MTATP8P1": [
    "MTATP8P1 CNV",
    "MTATP8P1 RNA"
  ],
  "RPL23AP17": [
    "RPL23AP17 CNV",
    "RPL23AP17 RNA"
  ],
  "LOXHD1": [
    "LOXHD1 CNV",
    "LOXHD1 RNA",
    "LOXHD1 Proteo"
  ],
  "CNBP": [
    "CNBP CNV",
    "CNBP RNA",
    "CNBP Proteo"
  ],
  "RGPD8": [
    "RGPD8 CNV",
    "RGPD8 RNA",
    "RGPD8 Proteo"
  ],
  "SLC17A4": [
    "SLC17A4 CNV",
    "SLC17A4 RNA"
  ],
  "TRAV15": [
    "TRAV15 CNV",
    "TRAV15 RNA"
  ],
  "RPL32P3": [
    "RPL32P3 CNV",
    "RPL32P3 RNA"
  ],
  "ZGPAT": [
    "ZGPAT CNV",
    "ZGPAT RNA",
    "ZGPAT Proteo"
  ],
  "PUSL1": [
    "PUSL1 CNV",
    "PUSL1 RNA",
    "PUSL1 Proteo"
  ],
  "PWWP2B": [
    "PWWP2B CNV",
    "PWWP2B RNA",
    "PWWP2B Proteo"
  ],
  "CEACAM8": [
    "CEACAM8 CNV",
    "CEACAM8 RNA",
    "CEACAM8 Proteo"
  ],
  "LCEP1": [
    "LCEP1 CNV",
    "LCEP1 RNA"
  ],
  "OR2J1": [
    "OR2J1 CNV",
    "OR2J1 RNA"
  ],
  "TSPAN17": [
    "TSPAN17 CNV",
    "TSPAN17 RNA"
  ],
  "GYPB": [
    "GYPB CNV",
    "GYPB RNA"
  ],
  "RPS10P21": [
    "RPS10P21 CNV",
    "RPS10P21 RNA"
  ],
  "ANKRD27": [
    "ANKRD27 CNV",
    "ANKRD27 RNA",
    "ANKRD27 Proteo"
  ],
  "MFAP2": [
    "MFAP2 CNV",
    "MFAP2 RNA",
    "MFAP2 Proteo"
  ],
  "PRKY": [
    "PRKY CNV",
    "PRKY RNA"
  ],
  "RNA5SP337": [
    "RNA5SP337 CNV",
    "RNA5SP337 RNA"
  ],
  "SOCS2": [
    "SOCS2 CNV",
    "SOCS2 RNA",
    "SOCS2 Proteo"
  ],
  "CEMIP2": [
    "CEMIP2 CNV",
    "CEMIP2 RNA",
    "CEMIP2 Proteo"
  ],
  "TM9SF2": [
    "TM9SF2 CNV",
    "TM9SF2 RNA",
    "TM9SF2 Proteo"
  ],
  "PRX": [
    "PRX CNV",
    "PRX RNA",
    "PRX Proteo"
  ],
  "CYP2AB1P": [
    "CYP2AB1P CNV",
    "CYP2AB1P RNA"
  ],
  "UPF3A": [
    "UPF3A CNV",
    "UPF3A RNA",
    "UPF3A Proteo"
  ],
  "VWCE": [
    "VWCE CNV",
    "VWCE RNA"
  ],
  "METTL27": [
    "METTL27 CNV",
    "METTL27 RNA"
  ],
  "CLPTM1": [
    "CLPTM1 CNV",
    "CLPTM1 RNA",
    "CLPTM1 Proteo"
  ],
  "COL16A1": [
    "COL16A1 CNV",
    "COL16A1 RNA",
    "COL16A1 Proteo"
  ],
  "EEF1B2": [
    "EEF1B2 CNV",
    "EEF1B2 RNA",
    "EEF1B2 Proteo"
  ],
  "GPR39": [
    "GPR39 CNV",
    "GPR39 RNA"
  ],
  "CSE1L": [
    "CSE1L CNV",
    "CSE1L RNA",
    "CSE1L Proteo"
  ],
  "C1orf141": [
    "C1orf141 CNV",
    "C1orf141 RNA"
  ],
  "EEF1A2": [
    "EEF1A2 CNV",
    "EEF1A2 RNA",
    "EEF1A2 Proteo"
  ],
  "AHRR": [
    "AHRR CNV",
    "AHRR RNA"
  ],
  "ABCA12": [
    "ABCA12 CNV",
    "ABCA12 RNA",
    "ABCA12 Proteo"
  ],
  "GDI2P2": [
    "GDI2P2 CNV",
    "GDI2P2 RNA"
  ],
  "CT45A11P": [
    "CT45A11P CNV",
    "CT45A11P RNA"
  ],
  "PPIAL4E": [
    "PPIAL4E CNV",
    "PPIAL4E RNA"
  ],
  "SEMA3A": [
    "SEMA3A CNV",
    "SEMA3A RNA"
  ],
  "MTND1P18": [
    "MTND1P18 CNV",
    "MTND1P18 RNA"
  ],
  "CNTROB": [
    "CNTROB CNV",
    "CNTROB RNA",
    "CNTROB Proteo"
  ],
  "OR52S1P": [
    "OR52S1P CNV",
    "OR52S1P RNA"
  ],
  "MT1IP": [
    "MT1IP CNV",
    "MT1IP RNA"
  ],
  "UBE2D3P3": [
    "UBE2D3P3 CNV",
    "UBE2D3P3 RNA"
  ],
  "HSPE1P2": [
    "HSPE1P2 CNV",
    "HSPE1P2 RNA"
  ],
  "VDAC1P1": [
    "VDAC1P1 CNV",
    "VDAC1P1 RNA"
  ],
  "CYP4A22": [
    "CYP4A22 CNV",
    "CYP4A22 RNA"
  ],
  "TSPY10": [
    "TSPY10 CNV",
    "TSPY10 RNA"
  ],
  "RGS5": [
    "RGS5 CNV",
    "RGS5 RNA"
  ],
  "FAM236B": [
    "FAM236B CNV",
    "FAM236B RNA"
  ],
  "HMGB3P1": [
    "HMGB3P1 CNV",
    "HMGB3P1 RNA"
  ],
  "EOGT": [
    "EOGT CNV",
    "EOGT RNA",
    "EOGT Proteo"
  ],
  "RPS15AP14": [
    "RPS15AP14 CNV",
    "RPS15AP14 RNA"
  ],
  "MATN1": [
    "MATN1 CNV",
    "MATN1 RNA",
    "MATN1 Proteo"
  ],
  "MTCYBP18": [
    "MTCYBP18 CNV",
    "MTCYBP18 RNA"
  ],
  "MTCO2P34": [
    "MTCO2P34 CNV",
    "MTCO2P34 RNA"
  ],
  "CD163": [
    "CD163 CNV",
    "CD163 RNA",
    "CD163 Proteo"
  ],
  "TMEM62": [
    "TMEM62 CNV",
    "TMEM62 RNA",
    "TMEM62 Proteo"
  ],
  "SEC14L6": [
    "SEC14L6 CNV",
    "SEC14L6 RNA"
  ],
  "ASPRV1": [
    "ASPRV1 CNV",
    "ASPRV1 RNA",
    "ASPRV1 Proteo"
  ],
  "TPM2": [
    "TPM2 CNV",
    "TPM2 RNA",
    "TPM2 Proteo"
  ],
  "TRPM1": [
    "TRPM1 CNV",
    "TRPM1 RNA",
    "TRPM1 Proteo"
  ],
  "THSD8": [
    "THSD8 CNV",
    "THSD8 RNA"
  ],
  "PNPLA4P1": [
    "PNPLA4P1 CNV",
    "PNPLA4P1 RNA"
  ],
  "IFNWP15": [
    "IFNWP15 CNV",
    "IFNWP15 RNA"
  ],
  "ZNF317P1": [
    "ZNF317P1 CNV",
    "ZNF317P1 RNA"
  ],
  "KIF13A": [
    "KIF13A CNV",
    "KIF13A RNA",
    "KIF13A Proteo"
  ],
  "TMEM42": [
    "TMEM42 CNV",
    "TMEM42 RNA"
  ],
  "CD300LB": [
    "CD300LB CNV",
    "CD300LB RNA"
  ],
  "PA2G4P5": [
    "PA2G4P5 CNV",
    "PA2G4P5 RNA"
  ],
  "DUX4L37": [
    "DUX4L37 CNV",
    "DUX4L37 RNA"
  ],
  "PSMD9": [
    "PSMD9 CNV",
    "PSMD9 RNA",
    "PSMD9 Proteo"
  ],
  "QRFPR": [
    "QRFPR CNV",
    "QRFPR RNA"
  ],
  "DOP1A": [
    "DOP1A CNV",
    "DOP1A RNA",
    "DOP1A Proteo"
  ],
  "ZG16B": [
    "ZG16B CNV",
    "ZG16B RNA",
    "ZG16B Proteo"
  ],
  "ARPC2": [
    "ARPC2 CNV",
    "ARPC2 RNA",
    "ARPC2 Proteo"
  ],
  "HNRNPA3P9": [
    "HNRNPA3P9 CNV",
    "HNRNPA3P9 RNA"
  ],
  "CLEC2B": [
    "CLEC2B CNV",
    "CLEC2B RNA",
    "CLEC2B Proteo"
  ],
  "COMMD2": [
    "COMMD2 CNV",
    "COMMD2 RNA",
    "COMMD2 Proteo"
  ],
  "PDZD4": [
    "PDZD4 CNV",
    "PDZD4 RNA"
  ],
  "OR13C9": [
    "OR13C9 CNV",
    "OR13C9 RNA"
  ],
  "MTND1P32": [
    "MTND1P32 CNV",
    "MTND1P32 RNA"
  ],
  "SKP2P1": [
    "SKP2P1 CNV",
    "SKP2P1 RNA"
  ],
  "AP3M1": [
    "AP3M1 CNV",
    "AP3M1 RNA",
    "AP3M1 Proteo"
  ],
  "GCSHP1": [
    "GCSHP1 CNV",
    "GCSHP1 RNA"
  ],
  "RPL36AP6": [
    "RPL36AP6 CNV",
    "RPL36AP6 RNA"
  ],
  "DYNC2I2": [
    "DYNC2I2 CNV",
    "DYNC2I2 RNA",
    "DYNC2I2 Proteo"
  ],
  "TPO": [
    "TPO CNV",
    "TPO RNA"
  ],
  "ITSN1": [
    "ITSN1 CNV",
    "ITSN1 RNA",
    "ITSN1 Proteo"
  ],
  "GTF3C6P3": [
    "GTF3C6P3 CNV",
    "GTF3C6P3 RNA"
  ],
  "RPL10AP1": [
    "RPL10AP1 CNV",
    "RPL10AP1 RNA"
  ],
  "MAGEL2": [
    "MAGEL2 CNV",
    "MAGEL2 RNA",
    "MAGEL2 Proteo"
  ],
  "RPS27P26": [
    "RPS27P26 CNV",
    "RPS27P26 RNA"
  ],
  "PLXNB2": [
    "PLXNB2 CNV",
    "PLXNB2 RNA",
    "PLXNB2 Proteo"
  ],
  "EHD3": [
    "EHD3 CNV",
    "EHD3 RNA",
    "EHD3 Proteo"
  ],
  "CTSF": [
    "CTSF CNV",
    "CTSF RNA",
    "CTSF Proteo"
  ],
  "EIF2S1": [
    "EIF2S1 CNV",
    "EIF2S1 RNA",
    "EIF2S1 Proteo"
  ],
  "COLQ": [
    "COLQ CNV",
    "COLQ RNA"
  ],
  "GNGT1": [
    "GNGT1 CNV",
    "GNGT1 RNA",
    "GNGT1 Proteo"
  ],
  "VN1R64P": [
    "VN1R64P CNV",
    "VN1R64P RNA"
  ],
  "FAM32BP": [
    "FAM32BP CNV",
    "FAM32BP RNA"
  ],
  "TMEM230P1": [
    "TMEM230P1 CNV",
    "TMEM230P1 RNA"
  ],
  "CRIM1": [
    "CRIM1 CNV",
    "CRIM1 RNA",
    "CRIM1 Proteo"
  ],
  "KIAA1143P1": [
    "KIAA1143P1 CNV",
    "KIAA1143P1 RNA"
  ],
  "NXNL1": [
    "NXNL1 CNV",
    "NXNL1 RNA",
    "NXNL1 Proteo"
  ],
  "PSAT1": [
    "PSAT1 CNV",
    "PSAT1 RNA",
    "PSAT1 Proteo"
  ],
  "ZSCAN5B": [
    "ZSCAN5B CNV",
    "ZSCAN5B RNA"
  ],
  "OR51A3P": [
    "OR51A3P CNV",
    "OR51A3P RNA"
  ],
  "PPIAP40": [
    "PPIAP40 CNV",
    "PPIAP40 RNA"
  ],
  "EIF4A1P10": [
    "EIF4A1P10 CNV",
    "EIF4A1P10 RNA"
  ],
  "PPFIBP2": [
    "PPFIBP2 CNV",
    "PPFIBP2 RNA",
    "PPFIBP2 Proteo"
  ],
  "HSP90AB3P": [
    "HSP90AB3P CNV",
    "HSP90AB3P RNA"
  ],
  "VDAC1P5": [
    "VDAC1P5 CNV",
    "VDAC1P5 RNA"
  ],
  "YBX1": [
    "YBX1 CNV",
    "YBX1 RNA",
    "YBX1 Proteo"
  ],
  "TRMT112P3": [
    "TRMT112P3 CNV",
    "TRMT112P3 RNA"
  ],
  "ZBTB17": [
    "ZBTB17 CNV",
    "ZBTB17 RNA",
    "ZBTB17 Proteo"
  ],
  "ANKRD54": [
    "ANKRD54 CNV",
    "ANKRD54 RNA",
    "ANKRD54 Proteo"
  ],
  "SVOP": [
    "SVOP CNV",
    "SVOP RNA"
  ],
  "HBD": [
    "HBD CNV",
    "HBD RNA",
    "HBD Proteo"
  ],
  "ASPH": [
    "ASPH CNV",
    "ASPH RNA",
    "ASPH Proteo"
  ],
  "IGKJ4": [
    "IGKJ4 Proteo"
  ],
  "INHBC": [
    "INHBC CNV",
    "INHBC RNA",
    "INHBC Proteo"
  ],
  "FKBP6": [
    "FKBP6 CNV",
    "FKBP6 RNA"
  ],
  "C1DP2": [
    "C1DP2 CNV",
    "C1DP2 RNA"
  ],
  "TSPAN7": [
    "TSPAN7 CNV",
    "TSPAN7 RNA"
  ],
  "CCR4": [
    "CCR4 CNV",
    "CCR4 RNA"
  ],
  "CADM4": [
    "CADM4 CNV",
    "CADM4 RNA",
    "CADM4 Proteo"
  ],
  "PPME1": [
    "PPME1 CNV",
    "PPME1 RNA",
    "PPME1 Proteo"
  ],
  "HRG": [
    "HRG CNV",
    "HRG RNA",
    "HRG Proteo"
  ],
  "CARD19": [
    "CARD19 CNV",
    "CARD19 RNA",
    "CARD19 Proteo"
  ],
  "ATXN7L1": [
    "ATXN7L1 CNV",
    "ATXN7L1 RNA",
    "ATXN7L1 Proteo"
  ],
  "MCMBP": [
    "MCMBP CNV",
    "MCMBP RNA",
    "MCMBP Proteo"
  ],
  "PDE8A": [
    "PDE8A CNV",
    "PDE8A RNA",
    "PDE8A Proteo"
  ],
  "BBC3": [
    "BBC3 CNV",
    "BBC3 RNA",
    "BBC3 Proteo"
  ],
  "HMGB2": [
    "HMGB2 CNV",
    "HMGB2 RNA",
    "HMGB2 Proteo"
  ],
  "RIOX1": [
    "RIOX1 CNV",
    "RIOX1 RNA",
    "RIOX1 Proteo"
  ],
  "KRT17P4": [
    "KRT17P4 CNV",
    "KRT17P4 RNA"
  ],
  "LPAR1": [
    "LPAR1 CNV",
    "LPAR1 RNA",
    "LPAR1 Proteo"
  ],
  "CFAP92": [
    "CFAP92 CNV",
    "CFAP92 RNA"
  ],
  "STK19": [
    "STK19 CNV",
    "STK19 RNA",
    "STK19 Proteo"
  ],
  "PLIN5": [
    "PLIN5 CNV",
    "PLIN5 RNA",
    "PLIN5 Proteo"
  ],
  "SPC25": [
    "SPC25 CNV",
    "SPC25 RNA",
    "SPC25 Proteo"
  ],
  "HAMP": [
    "HAMP CNV",
    "HAMP RNA"
  ],
  "EXOC5P1": [
    "EXOC5P1 CNV",
    "EXOC5P1 RNA"
  ],
  "EYA2": [
    "EYA2 CNV",
    "EYA2 RNA"
  ],
  "SLC27A3": [
    "SLC27A3 CNV",
    "SLC27A3 RNA",
    "SLC27A3 Proteo"
  ],
  "FBXL13": [
    "FBXL13 CNV",
    "FBXL13 RNA"
  ],
  "SPART": [
    "SPART CNV",
    "SPART RNA",
    "SPART Proteo"
  ],
  "VARS1": [
    "VARS1 CNV",
    "VARS1 RNA",
    "VARS1 Proteo"
  ],
  "SLC27A2": [
    "SLC27A2 CNV",
    "SLC27A2 RNA",
    "SLC27A2 Proteo"
  ],
  "SEPHS2": [
    "SEPHS2 CNV",
    "SEPHS2 RNA",
    "SEPHS2 Proteo"
  ],
  "FIBIN": [
    "FIBIN CNV",
    "FIBIN RNA",
    "FIBIN Proteo"
  ],
  "PRAP1": [
    "PRAP1 CNV",
    "PRAP1 RNA"
  ],
  "DUXAP8": [
    "DUXAP8 CNV",
    "DUXAP8 RNA"
  ],
  "STK38": [
    "STK38 CNV",
    "STK38 RNA",
    "STK38 Proteo"
  ],
  "C5orf22": [
    "C5orf22 CNV",
    "C5orf22 RNA",
    "C5orf22 Proteo"
  ],
  "VAMP7": [
    "VAMP7 CNV",
    "VAMP7 RNA",
    "VAMP7 Proteo"
  ],
  "CALM1": [
    "CALM1 CNV",
    "CALM1 RNA",
    "CALM1 Proteo"
  ],
  "MTCYBP39": [
    "MTCYBP39 CNV",
    "MTCYBP39 RNA"
  ],
  "KBTBD2": [
    "KBTBD2 CNV",
    "KBTBD2 RNA",
    "KBTBD2 Proteo"
  ],
  "OR5BC1P": [
    "OR5BC1P CNV",
    "OR5BC1P RNA"
  ],
  "CYCSP11": [
    "CYCSP11 CNV",
    "CYCSP11 RNA"
  ],
  "ILVBL": [
    "ILVBL CNV",
    "ILVBL RNA",
    "ILVBL Proteo"
  ],
  "BMS1P3": [
    "BMS1P3 CNV",
    "BMS1P3 RNA"
  ],
  "MFSD11": [
    "MFSD11 CNV",
    "MFSD11 RNA",
    "MFSD11 Proteo"
  ],
  "PIK3R1": [
    "PIK3R1 CNV",
    "PIK3R1 RNA",
    "PIK3R1 Proteo"
  ],
  "TBC1D1": [
    "TBC1D1 CNV",
    "TBC1D1 RNA",
    "TBC1D1 Proteo"
  ],
  "GSTM5": [
    "GSTM5 CNV",
    "GSTM5 RNA",
    "GSTM5 Proteo"
  ],
  "KRTAP15-1": [
    "KRTAP15-1 CNV",
    "KRTAP15-1 RNA"
  ],
  "GEMIN4": [
    "GEMIN4 CNV",
    "GEMIN4 RNA",
    "GEMIN4 Proteo"
  ],
  "C19orf54": [
    "C19orf54 CNV",
    "C19orf54 RNA",
    "C19orf54 Proteo"
  ],
  "ACTN2": [
    "ACTN2 CNV",
    "ACTN2 RNA",
    "ACTN2 Proteo"
  ],
  "SLC39A5": [
    "SLC39A5 CNV",
    "SLC39A5 RNA"
  ],
  "KLF9": [
    "KLF9 CNV",
    "KLF9 RNA"
  ],
  "ROBO3": [
    "ROBO3 CNV",
    "ROBO3 RNA"
  ],
  "ZNF18": [
    "ZNF18 CNV",
    "ZNF18 RNA"
  ],
  "MILR1": [
    "MILR1 CNV",
    "MILR1 RNA",
    "MILR1 Proteo"
  ],
  "NDUFA2": [
    "NDUFA2 CNV",
    "NDUFA2 RNA",
    "NDUFA2 Proteo"
  ],
  "ERMP1": [
    "ERMP1 CNV",
    "ERMP1 RNA",
    "ERMP1 Proteo"
  ],
  "APBA1": [
    "APBA1 CNV",
    "APBA1 RNA",
    "APBA1 Proteo"
  ],
  "MICOS10P2": [
    "MICOS10P2 CNV",
    "MICOS10P2 RNA"
  ],
  "DNAJC30": [
    "DNAJC30 CNV",
    "DNAJC30 RNA",
    "DNAJC30 Proteo"
  ],
  "USP9YP9": [
    "USP9YP9 CNV",
    "USP9YP9 RNA"
  ],
  "DUX4L25": [
    "DUX4L25 CNV",
    "DUX4L25 RNA"
  ],
  "SHISA9": [
    "SHISA9 CNV",
    "SHISA9 RNA"
  ],
  "OR11M1P": [
    "OR11M1P CNV",
    "OR11M1P RNA"
  ],
  "IL36RN": [
    "IL36RN CNV",
    "IL36RN RNA",
    "IL36RN Proteo"
  ],
  "VWF": [
    "VWF CNV",
    "VWF RNA",
    "VWF Proteo"
  ],
  "CYCSP44": [
    "CYCSP44 CNV",
    "CYCSP44 RNA"
  ],
  "CDKL4": [
    "CDKL4 CNV",
    "CDKL4 RNA"
  ],
  "TSC22D2": [
    "TSC22D2 CNV",
    "TSC22D2 RNA",
    "TSC22D2 Proteo"
  ],
  "IMPDH1P4": [
    "IMPDH1P4 CNV",
    "IMPDH1P4 RNA"
  ],
  "PARP9": [
    "PARP9 CNV",
    "PARP9 RNA",
    "PARP9 Proteo"
  ],
  "TUBA1C": [
    "TUBA1C CNV",
    "TUBA1C RNA",
    "TUBA1C Proteo"
  ],
  "TRBV1": [
    "TRBV1 CNV",
    "TRBV1 RNA"
  ],
  "THAP12": [
    "THAP12 CNV",
    "THAP12 RNA",
    "THAP12 Proteo"
  ],
  "HERC2P1": [
    "HERC2P1 CNV",
    "HERC2P1 RNA"
  ],
  "AFDN": [
    "AFDN CNV",
    "AFDN RNA",
    "AFDN Proteo"
  ],
  "SRSF8BP": [
    "SRSF8BP CNV",
    "SRSF8BP RNA"
  ],
  "SEPTIN14P21": [
    "SEPTIN14P21 CNV",
    "SEPTIN14P21 RNA"
  ],
  "LECT2": [
    "LECT2 CNV",
    "LECT2 RNA",
    "LECT2 Proteo"
  ],
  "KLF11": [
    "KLF11 CNV",
    "KLF11 RNA"
  ],
  "MTDHP4": [
    "MTDHP4 CNV",
    "MTDHP4 RNA"
  ],
  "SNAI1": [
    "SNAI1 CNV",
    "SNAI1 RNA"
  ],
  "ZC3H10": [
    "ZC3H10 CNV",
    "ZC3H10 RNA",
    "ZC3H10 Proteo"
  ],
  "POU4F3": [
    "POU4F3 CNV",
    "POU4F3 RNA"
  ],
  "MGRN1": [
    "MGRN1 CNV",
    "MGRN1 RNA",
    "MGRN1 Proteo"
  ],
  "CCL23": [
    "CCL23 CNV",
    "CCL23 RNA"
  ],
  "TRA2A": [
    "TRA2A CNV",
    "TRA2A RNA",
    "TRA2A Proteo"
  ],
  "STK33": [
    "STK33 CNV",
    "STK33 RNA"
  ],
  "CROT": [
    "CROT CNV",
    "CROT RNA",
    "CROT Proteo"
  ],
  "EPHX3": [
    "EPHX3 CNV",
    "EPHX3 RNA"
  ],
  "SDHAP1": [
    "SDHAP1 CNV",
    "SDHAP1 RNA"
  ],
  "UNC5B": [
    "UNC5B CNV",
    "UNC5B RNA",
    "UNC5B Proteo"
  ],
  "SERPINB2": [
    "SERPINB2 CNV",
    "SERPINB2 RNA",
    "SERPINB2 Proteo"
  ],
  "TMEM63C": [
    "TMEM63C CNV",
    "TMEM63C RNA"
  ],
  "MMS22L": [
    "MMS22L CNV",
    "MMS22L RNA",
    "MMS22L Proteo"
  ],
  "NAMPTP1": [
    "NAMPTP1 CNV",
    "NAMPTP1 RNA"
  ],
  "FCF1P8": [
    "FCF1P8 CNV",
    "FCF1P8 RNA"
  ],
  "CT47A12": [
    "CT47A12 CNV",
    "CT47A12 RNA"
  ],
  "ZDHHC20": [
    "ZDHHC20 CNV",
    "ZDHHC20 RNA",
    "ZDHHC20 Proteo"
  ],
  "YEATS4": [
    "YEATS4 CNV",
    "YEATS4 RNA",
    "YEATS4 Proteo"
  ],
  "SOX21": [
    "SOX21 CNV",
    "SOX21 RNA"
  ],
  "LRRC19": [
    "LRRC19 CNV",
    "LRRC19 RNA"
  ],
  "KRT18P27": [
    "KRT18P27 CNV",
    "KRT18P27 RNA"
  ],
  "GABARAPL1": [
    "GABARAPL1 CNV",
    "GABARAPL1 RNA",
    "GABARAPL1 Proteo"
  ],
  "MYL12BP1": [
    "MYL12BP1 CNV",
    "MYL12BP1 RNA"
  ],
  "ASS1P5": [
    "ASS1P5 CNV",
    "ASS1P5 RNA"
  ],
  "SELENOW": [
    "SELENOW CNV",
    "SELENOW RNA",
    "SELENOW Proteo"
  ],
  "RPL36AP45": [
    "RPL36AP45 CNV",
    "RPL36AP45 RNA"
  ],
  "SERF2": [
    "SERF2 CNV",
    "SERF2 RNA",
    "SERF2 Proteo"
  ],
  "BRIP1": [
    "BRIP1 CNV",
    "BRIP1 RNA",
    "BRIP1 Proteo"
  ],
  "CDY20P": [
    "CDY20P CNV",
    "CDY20P RNA"
  ],
  "TPGS2": [
    "TPGS2 CNV",
    "TPGS2 RNA"
  ],
  "ERO1B": [
    "ERO1B CNV",
    "ERO1B RNA",
    "ERO1B Proteo"
  ],
  "RPL9P31": [
    "RPL9P31 CNV",
    "RPL9P31 RNA"
  ],
  "YRDCP1": [
    "YRDCP1 CNV",
    "YRDCP1 RNA"
  ],
  "GALNTL6": [
    "GALNTL6 CNV",
    "GALNTL6 RNA"
  ],
  "HAUS1P3": [
    "HAUS1P3 CNV",
    "HAUS1P3 RNA"
  ],
  "H3C1": [
    "H3C1 CNV",
    "H3C1 RNA"
  ],
  "ORMDL1": [
    "ORMDL1 CNV",
    "ORMDL1 RNA",
    "ORMDL1 Proteo"
  ],
  "RNA5SP31": [
    "RNA5SP31 CNV",
    "RNA5SP31 RNA"
  ],
  "TPRG1L": [
    "TPRG1L CNV",
    "TPRG1L RNA",
    "TPRG1L Proteo"
  ],
  "NXPE4": [
    "NXPE4 CNV",
    "NXPE4 RNA"
  ],
  "RPL23AP53": [
    "RPL23AP53 CNV",
    "RPL23AP53 RNA"
  ],
  "CALHM6": [
    "CALHM6 CNV",
    "CALHM6 RNA",
    "CALHM6 Proteo"
  ],
  "TOP1": [
    "TOP1 CNV",
    "TOP1 RNA",
    "TOP1 Proteo"
  ],
  "SLC9A2": [
    "SLC9A2 CNV",
    "SLC9A2 RNA"
  ],
  "NSA2P6": [
    "NSA2P6 CNV",
    "NSA2P6 RNA"
  ],
  "TNRC6A": [
    "TNRC6A CNV",
    "TNRC6A RNA",
    "TNRC6A Proteo"
  ],
  "TMCC1P1": [
    "TMCC1P1 CNV",
    "TMCC1P1 RNA"
  ],
  "ATP6V1G1P7": [
    "ATP6V1G1P7 CNV",
    "ATP6V1G1P7 RNA"
  ],
  "MTND4LP9": [
    "MTND4LP9 CNV",
    "MTND4LP9 RNA"
  ],
  "GDA": [
    "GDA CNV",
    "GDA RNA",
    "GDA Proteo"
  ],
  "SLC38A4": [
    "SLC38A4 CNV",
    "SLC38A4 RNA"
  ],
  "RPL22P2": [
    "RPL22P2 CNV",
    "RPL22P2 RNA"
  ],
  "TXNDC2": [
    "TXNDC2 CNV",
    "TXNDC2 RNA"
  ],
  "RGN": [
    "RGN CNV",
    "RGN RNA",
    "RGN Proteo"
  ],
  "GOT1L1": [
    "GOT1L1 CNV",
    "GOT1L1 RNA"
  ],
  "SOX12": [
    "SOX12 CNV",
    "SOX12 RNA",
    "SOX12 Proteo"
  ],
  "PRKRIP1": [
    "PRKRIP1 CNV",
    "PRKRIP1 RNA",
    "PRKRIP1 Proteo"
  ],
  "VTI1BP2": [
    "VTI1BP2 CNV",
    "VTI1BP2 RNA"
  ],
  "C2orf83": [
    "C2orf83 CNV",
    "C2orf83 RNA"
  ],
  "STAB2": [
    "STAB2 CNV",
    "STAB2 RNA",
    "STAB2 Proteo"
  ],
  "GPS1": [
    "GPS1 CNV",
    "GPS1 RNA",
    "GPS1 Proteo"
  ],
  "SUMO2P5": [
    "SUMO2P5 CNV",
    "SUMO2P5 RNA"
  ],
  "CCBE1": [
    "CCBE1 CNV",
    "CCBE1 RNA"
  ],
  "TMEM132E": [
    "TMEM132E CNV",
    "TMEM132E RNA"
  ],
  "RAB6B": [
    "RAB6B CNV",
    "RAB6B RNA",
    "RAB6B Proteo"
  ],
  "MR1": [
    "MR1 CNV",
    "MR1 RNA",
    "MR1 Proteo"
  ],
  "NRCAM": [
    "NRCAM CNV",
    "NRCAM RNA",
    "NRCAM Proteo"
  ],
  "BBS7": [
    "BBS7 CNV",
    "BBS7 RNA",
    "BBS7 Proteo"
  ],
  "WDFY1": [
    "WDFY1 CNV",
    "WDFY1 RNA",
    "WDFY1 Proteo"
  ],
  "REG1CP": [
    "REG1CP CNV",
    "REG1CP RNA"
  ],
  "OR2M7": [
    "OR2M7 CNV",
    "OR2M7 RNA"
  ],
  "RPL7AP29": [
    "RPL7AP29 CNV",
    "RPL7AP29 RNA"
  ],
  "NLRP9": [
    "NLRP9 CNV",
    "NLRP9 RNA"
  ],
  "IRX2": [
    "IRX2 CNV",
    "IRX2 RNA"
  ],
  "LYPLA2P1": [
    "LYPLA2P1 CNV",
    "LYPLA2P1 RNA"
  ],
  "CLYBL": [
    "CLYBL CNV",
    "CLYBL RNA",
    "CLYBL Proteo"
  ],
  "RUSF1": [
    "RUSF1 CNV",
    "RUSF1 RNA",
    "RUSF1 Proteo"
  ],
  "MDH1": [
    "MDH1 CNV",
    "MDH1 RNA",
    "MDH1 Proteo"
  ],
  "SMUG1": [
    "SMUG1 CNV",
    "SMUG1 RNA",
    "SMUG1 Proteo"
  ],
  "LONRF1": [
    "LONRF1 CNV",
    "LONRF1 RNA"
  ],
  "FRG2KP": [
    "FRG2KP CNV",
    "FRG2KP RNA"
  ],
  "S100PBP": [
    "S100PBP CNV",
    "S100PBP RNA",
    "S100PBP Proteo"
  ],
  "ATP6V1E2": [
    "ATP6V1E2 CNV",
    "ATP6V1E2 RNA",
    "ATP6V1E2 Proteo"
  ],
  "FKBP4P1": [
    "FKBP4P1 CNV",
    "FKBP4P1 RNA"
  ],
  "USP44": [
    "USP44 CNV",
    "USP44 RNA"
  ],
  "NFE2L2": [
    "NFE2L2 CNV",
    "NFE2L2 RNA",
    "NFE2L2 Proteo"
  ],
  "FSIP2": [
    "FSIP2 CNV",
    "FSIP2 RNA"
  ],
  "RPS2P28": [
    "RPS2P28 CNV",
    "RPS2P28 RNA"
  ],
  "SIGLEC12": [
    "SIGLEC12 CNV",
    "SIGLEC12 RNA"
  ],
  "ENPP7P14": [
    "ENPP7P14 CNV",
    "ENPP7P14 RNA"
  ],
  "TAT": [
    "TAT CNV",
    "TAT RNA"
  ],
  "CHMP2A": [
    "CHMP2A CNV",
    "CHMP2A RNA",
    "CHMP2A Proteo"
  ],
  "SYT4": [
    "SYT4 CNV",
    "SYT4 RNA"
  ],
  "RNA5SP308": [
    "RNA5SP308 CNV",
    "RNA5SP308 RNA"
  ],
  "INTS8": [
    "INTS8 CNV",
    "INTS8 RNA",
    "INTS8 Proteo"
  ],
  "UBQLN2": [
    "UBQLN2 CNV",
    "UBQLN2 RNA",
    "UBQLN2 Proteo"
  ],
  "AP1M2": [
    "AP1M2 CNV",
    "AP1M2 RNA",
    "AP1M2 Proteo"
  ],
  "CCDC97": [
    "CCDC97 CNV",
    "CCDC97 RNA",
    "CCDC97 Proteo"
  ],
  "TRIM77BP": [
    "TRIM77BP CNV",
    "TRIM77BP RNA"
  ],
  "GOLGA6C": [
    "GOLGA6C CNV",
    "GOLGA6C RNA"
  ],
  "LRRC23": [
    "LRRC23 CNV",
    "LRRC23 RNA"
  ],
  "SNTA1": [
    "SNTA1 CNV",
    "SNTA1 RNA",
    "SNTA1 Proteo"
  ],
  "HMGB1P28": [
    "HMGB1P28 CNV",
    "HMGB1P28 RNA"
  ],
  "RNA5SP256": [
    "RNA5SP256 CNV",
    "RNA5SP256 RNA"
  ],
  "RGS9BP": [
    "RGS9BP CNV",
    "RGS9BP RNA"
  ],
  "NANOGP9": [
    "NANOGP9 CNV",
    "NANOGP9 RNA"
  ],
  "RSBN1": [
    "RSBN1 CNV",
    "RSBN1 RNA",
    "RSBN1 Proteo"
  ],
  "HMGN2P25": [
    "HMGN2P25 CNV",
    "HMGN2P25 RNA"
  ],
  "NDUFS5P5": [
    "NDUFS5P5 CNV",
    "NDUFS5P5 RNA"
  ],
  "ZNF701": [
    "ZNF701 CNV",
    "ZNF701 RNA",
    "ZNF701 Proteo"
  ],
  "PDE10A": [
    "PDE10A CNV",
    "PDE10A RNA",
    "PDE10A Proteo"
  ],
  "MAEL": [
    "MAEL CNV",
    "MAEL RNA"
  ],
  "WDR5B": [
    "WDR5B CNV",
    "WDR5B RNA"
  ],
  "FBXO48": [
    "FBXO48 CNV",
    "FBXO48 RNA"
  ],
  "ZSCAN23": [
    "ZSCAN23 CNV",
    "ZSCAN23 RNA"
  ],
  "PRH2": [
    "PRH2 CNV",
    "PRH2 RNA"
  ],
  "MPZL3": [
    "MPZL3 CNV",
    "MPZL3 RNA"
  ],
  "C12orf57": [
    "C12orf57 CNV",
    "C12orf57 RNA",
    "C12orf57 Proteo"
  ],
  "HIGD1AP15": [
    "HIGD1AP15 CNV",
    "HIGD1AP15 RNA"
  ],
  "SMG7": [
    "SMG7 CNV",
    "SMG7 RNA",
    "SMG7 Proteo"
  ],
  "HEATR6": [
    "HEATR6 CNV",
    "HEATR6 RNA",
    "HEATR6 Proteo"
  ],
  "TSBP1": [
    "TSBP1 CNV",
    "TSBP1 RNA"
  ],
  "TREH": [
    "TREH CNV",
    "TREH RNA"
  ],
  "CYP4F44P": [
    "CYP4F44P CNV",
    "CYP4F44P RNA"
  ],
  "PSG2": [
    "PSG2 CNV",
    "PSG2 RNA"
  ],
  "ZNF585B": [
    "ZNF585B CNV",
    "ZNF585B RNA"
  ],
  "VN1R18P": [
    "VN1R18P CNV",
    "VN1R18P RNA"
  ],
  "CHMP6": [
    "CHMP6 CNV",
    "CHMP6 RNA",
    "CHMP6 Proteo"
  ],
  "H3P39": [
    "H3P39 CNV",
    "H3P39 RNA"
  ],
  "POP1": [
    "POP1 CNV",
    "POP1 RNA",
    "POP1 Proteo"
  ],
  "ZBTB8OSP2": [
    "ZBTB8OSP2 CNV",
    "ZBTB8OSP2 RNA"
  ],
  "NSL1": [
    "NSL1 CNV",
    "NSL1 RNA",
    "NSL1 Proteo"
  ],
  "DCLK2": [
    "DCLK2 CNV",
    "DCLK2 RNA",
    "DCLK2 Proteo"
  ],
  "KRBA2": [
    "KRBA2 CNV",
    "KRBA2 RNA"
  ],
  "RPL32P11": [
    "RPL32P11 CNV",
    "RPL32P11 RNA"
  ],
  "GFPT1": [
    "GFPT1 CNV",
    "GFPT1 RNA",
    "GFPT1 Proteo"
  ],
  "USO1": [
    "USO1 CNV",
    "USO1 RNA",
    "USO1 Proteo"
  ],
  "UQCR11": [
    "UQCR11 CNV",
    "UQCR11 RNA",
    "UQCR11 Proteo"
  ],
  "RPL30P10": [
    "RPL30P10 CNV",
    "RPL30P10 RNA"
  ],
  "SFXN1": [
    "SFXN1 CNV",
    "SFXN1 RNA",
    "SFXN1 Proteo"
  ],
  "RBMXL3": [
    "RBMXL3 CNV",
    "RBMXL3 RNA",
    "RBMXL3 Proteo"
  ],
  "UBE2V1P4": [
    "UBE2V1P4 CNV",
    "UBE2V1P4 RNA"
  ],
  "CENPK": [
    "CENPK CNV",
    "CENPK RNA",
    "CENPK Proteo"
  ],
  "C1GALT1C1": [
    "C1GALT1C1 CNV",
    "C1GALT1C1 RNA",
    "C1GALT1C1 Proteo"
  ],
  "TRAJ55": [
    "TRAJ55 CNV",
    "TRAJ55 RNA"
  ],
  "MPZL2": [
    "MPZL2 CNV",
    "MPZL2 RNA",
    "MPZL2 Proteo"
  ],
  "IKZF3": [
    "IKZF3 CNV",
    "IKZF3 RNA",
    "IKZF3 Proteo"
  ],
  "PRG4": [
    "PRG4 CNV",
    "PRG4 RNA",
    "PRG4 Proteo"
  ],
  "CNPY3": [
    "CNPY3 CNV",
    "CNPY3 RNA",
    "CNPY3 Proteo"
  ],
  "ADPGK": [
    "ADPGK CNV",
    "ADPGK RNA",
    "ADPGK Proteo"
  ],
  "PI4KAP1": [
    "PI4KAP1 CNV",
    "PI4KAP1 RNA"
  ],
  "MRPS35P3": [
    "MRPS35P3 CNV",
    "MRPS35P3 RNA"
  ],
  "S100A11P7": [
    "S100A11P7 CNV",
    "S100A11P7 RNA"
  ],
  "YIF1A": [
    "YIF1A CNV",
    "YIF1A RNA",
    "YIF1A Proteo"
  ],
  "SMPD4": [
    "SMPD4 CNV",
    "SMPD4 RNA",
    "SMPD4 Proteo"
  ],
  "ANAPC1P1": [
    "ANAPC1P1 CNV",
    "ANAPC1P1 RNA"
  ],
  "DUSP23": [
    "DUSP23 CNV",
    "DUSP23 RNA",
    "DUSP23 Proteo"
  ],
  "COMMD7": [
    "COMMD7 CNV",
    "COMMD7 RNA",
    "COMMD7 Proteo"
  ],
  "TTC14": [
    "TTC14 CNV",
    "TTC14 RNA",
    "TTC14 Proteo"
  ],
  "KRTAP11-1": [
    "KRTAP11-1 CNV",
    "KRTAP11-1 RNA"
  ],
  "FCGR3B": [
    "FCGR3B CNV",
    "FCGR3B RNA",
    "FCGR3B Proteo"
  ],
  "GAD1": [
    "GAD1 CNV",
    "GAD1 RNA"
  ],
  "POMGNT2": [
    "POMGNT2 CNV",
    "POMGNT2 RNA",
    "POMGNT2 Proteo"
  ],
  "DEFB108A": [
    "DEFB108A CNV",
    "DEFB108A RNA"
  ],
  "B3GALNT2": [
    "B3GALNT2 CNV",
    "B3GALNT2 RNA"
  ],
  "CLDN7": [
    "CLDN7 CNV",
    "CLDN7 RNA",
    "CLDN7 Proteo"
  ],
  "KRT40": [
    "KRT40 CNV",
    "KRT40 RNA"
  ],
  "ALKBH1": [
    "ALKBH1 CNV",
    "ALKBH1 RNA",
    "ALKBH1 Proteo"
  ],
  "GOLGA8M": [
    "GOLGA8M CNV",
    "GOLGA8M RNA"
  ],
  "AP1B1P1": [
    "AP1B1P1 CNV",
    "AP1B1P1 RNA"
  ],
  "PDSS1P1": [
    "PDSS1P1 CNV",
    "PDSS1P1 RNA"
  ],
  "ATP5MC1P8": [
    "ATP5MC1P8 CNV",
    "ATP5MC1P8 RNA"
  ],
  "DPY19L2P4": [
    "DPY19L2P4 CNV",
    "DPY19L2P4 RNA"
  ],
  "SORCS1": [
    "SORCS1 CNV",
    "SORCS1 RNA",
    "SORCS1 Proteo"
  ],
  "TRIM64": [
    "TRIM64 CNV",
    "TRIM64 RNA"
  ],
  "GOLGA2P2Y": [
    "GOLGA2P2Y CNV",
    "GOLGA2P2Y RNA"
  ],
  "PREP": [
    "PREP CNV",
    "PREP RNA",
    "PREP Proteo"
  ],
  "OR7E162P": [
    "OR7E162P CNV",
    "OR7E162P RNA"
  ],
  "LGALS1": [
    "LGALS1 CNV",
    "LGALS1 RNA",
    "LGALS1 Proteo"
  ],
  "PDIA6": [
    "PDIA6 CNV",
    "PDIA6 RNA",
    "PDIA6 Proteo"
  ],
  "RPL23AP49": [
    "RPL23AP49 CNV",
    "RPL23AP49 RNA"
  ],
  "USP9YP27": [
    "USP9YP27 CNV",
    "USP9YP27 RNA"
  ],
  "LRRC74B": [
    "LRRC74B CNV",
    "LRRC74B RNA"
  ],
  "OOEP": [
    "OOEP CNV",
    "OOEP RNA"
  ],
  "AZU1": [
    "AZU1 CNV",
    "AZU1 RNA",
    "AZU1 Proteo"
  ],
  "PARGP1": [
    "PARGP1 CNV",
    "PARGP1 RNA"
  ],
  "MRPL39": [
    "MRPL39 CNV",
    "MRPL39 RNA",
    "MRPL39 Proteo"
  ],
  "IFT140": [
    "IFT140 CNV",
    "IFT140 RNA",
    "IFT140 Proteo"
  ],
  "RAB42": [
    "RAB42 CNV",
    "RAB42 RNA",
    "RAB42 Proteo"
  ],
  "CCDC168": [
    "CCDC168 CNV",
    "CCDC168 RNA"
  ],
  "TMEM106A": [
    "TMEM106A CNV",
    "TMEM106A RNA",
    "TMEM106A Proteo"
  ],
  "PHF10": [
    "PHF10 CNV",
    "PHF10 RNA",
    "PHF10 Proteo"
  ],
  "NOL9": [
    "NOL9 CNV",
    "NOL9 RNA",
    "NOL9 Proteo"
  ],
  "GDPGP1": [
    "GDPGP1 CNV",
    "GDPGP1 RNA",
    "GDPGP1 Proteo"
  ],
  "ZFPM1": [
    "ZFPM1 CNV",
    "ZFPM1 RNA",
    "ZFPM1 Proteo"
  ],
  "EIF4EBP3": [
    "EIF4EBP3 CNV",
    "EIF4EBP3 RNA"
  ],
  "DPPA5P2": [
    "DPPA5P2 CNV",
    "DPPA5P2 RNA"
  ],
  "LTK": [
    "LTK CNV",
    "LTK RNA"
  ],
  "LAMTOR3P1": [
    "LAMTOR3P1 CNV",
    "LAMTOR3P1 RNA"
  ],
  "KLHL40": [
    "KLHL40 CNV",
    "KLHL40 RNA"
  ],
  "ADIRF": [
    "ADIRF CNV",
    "ADIRF RNA",
    "ADIRF Proteo"
  ],
  "ZNF750": [
    "ZNF750 CNV",
    "ZNF750 RNA"
  ],
  "NPM1P12": [
    "NPM1P12 CNV",
    "NPM1P12 RNA"
  ],
  "HNRNPA1P1": [
    "HNRNPA1P1 CNV",
    "HNRNPA1P1 RNA"
  ],
  "PAPSS1": [
    "PAPSS1 CNV",
    "PAPSS1 RNA",
    "PAPSS1 Proteo"
  ],
  "MBTPS1": [
    "MBTPS1 CNV",
    "MBTPS1 RNA",
    "MBTPS1 Proteo"
  ],
  "APOL5": [
    "APOL5 CNV",
    "APOL5 RNA"
  ],
  "POM121L4P": [
    "POM121L4P CNV",
    "POM121L4P RNA"
  ],
  "RDH14": [
    "RDH14 CNV",
    "RDH14 RNA",
    "RDH14 Proteo"
  ],
  "CYP4F24P": [
    "CYP4F24P CNV",
    "CYP4F24P RNA"
  ],
  "RAB9AP1": [
    "RAB9AP1 CNV",
    "RAB9AP1 RNA"
  ],
  "TTLL12": [
    "TTLL12 CNV",
    "TTLL12 RNA",
    "TTLL12 Proteo"
  ],
  "LILRA5": [
    "LILRA5 CNV",
    "LILRA5 RNA"
  ],
  "METTL1P1": [
    "METTL1P1 CNV",
    "METTL1P1 RNA"
  ],
  "MGAT4EP": [
    "MGAT4EP CNV",
    "MGAT4EP RNA"
  ],
  "RPS7P5": [
    "RPS7P5 CNV",
    "RPS7P5 RNA"
  ],
  "CER1": [
    "CER1 CNV",
    "CER1 RNA"
  ],
  "DAD1": [
    "DAD1 CNV",
    "DAD1 RNA",
    "DAD1 Proteo"
  ],
  "GABRA6": [
    "GABRA6 CNV",
    "GABRA6 RNA"
  ],
  "KRT79": [
    "KRT79 CNV",
    "KRT79 RNA",
    "KRT79 Proteo"
  ],
  "SLC22A23": [
    "SLC22A23 CNV",
    "SLC22A23 RNA",
    "SLC22A23 Proteo"
  ],
  "ANAPC16": [
    "ANAPC16 CNV",
    "ANAPC16 RNA",
    "ANAPC16 Proteo"
  ],
  "AJUBA": [
    "AJUBA CNV",
    "AJUBA RNA",
    "AJUBA Proteo"
  ],
  "IL10RB": [
    "IL10RB CNV",
    "IL10RB RNA"
  ],
  "SP1": [
    "SP1 CNV",
    "SP1 RNA",
    "SP1 Proteo"
  ],
  "LGALS4": [
    "LGALS4 CNV",
    "LGALS4 RNA",
    "LGALS4 Proteo"
  ],
  "GMCL2": [
    "GMCL2 CNV",
    "GMCL2 RNA",
    "GMCL2 Proteo"
  ],
  "PTHLH": [
    "PTHLH CNV",
    "PTHLH RNA"
  ],
  "GRAMD4P8": [
    "GRAMD4P8 CNV",
    "GRAMD4P8 RNA"
  ],
  "GOLGA6FP": [
    "GOLGA6FP CNV",
    "GOLGA6FP RNA"
  ],
  "ID2B": [
    "ID2B CNV",
    "ID2B RNA"
  ],
  "RBM33": [
    "RBM33 CNV",
    "RBM33 RNA",
    "RBM33 Proteo"
  ],
  "RTL1": [
    "RTL1 CNV",
    "RTL1 RNA"
  ],
  "ALX1": [
    "ALX1 CNV",
    "ALX1 RNA",
    "ALX1 Proteo"
  ],
  "RPS18P9": [
    "RPS18P9 CNV",
    "RPS18P9 RNA"
  ],
  "PTCD3": [
    "PTCD3 CNV",
    "PTCD3 RNA",
    "PTCD3 Proteo"
  ],
  "MTRF1LP1": [
    "MTRF1LP1 CNV",
    "MTRF1LP1 RNA"
  ],
  "ENPP7P8": [
    "ENPP7P8 CNV",
    "ENPP7P8 RNA"
  ],
  "HOXC10": [
    "HOXC10 CNV",
    "HOXC10 RNA",
    "HOXC10 Proteo"
  ],
  "TUT1": [
    "TUT1 CNV",
    "TUT1 RNA",
    "TUT1 Proteo"
  ],
  "RAC3": [
    "RAC3 CNV",
    "RAC3 RNA",
    "RAC3 Proteo"
  ],
  "TMEM94": [
    "TMEM94 CNV",
    "TMEM94 RNA",
    "TMEM94 Proteo"
  ],
  "EIF6": [
    "EIF6 CNV",
    "EIF6 RNA",
    "EIF6 Proteo"
  ],
  "ATXN3": [
    "ATXN3 CNV",
    "ATXN3 RNA",
    "ATXN3 Proteo"
  ],
  "PALM2AKAP2": [
    "PALM2AKAP2 CNV",
    "PALM2AKAP2 RNA",
    "PALM2AKAP2 Proteo"
  ],
  "MTG2": [
    "MTG2 CNV",
    "MTG2 RNA",
    "MTG2 Proteo"
  ],
  "NCKAP5": [
    "NCKAP5 CNV",
    "NCKAP5 RNA"
  ],
  "ARFRP1": [
    "ARFRP1 CNV",
    "ARFRP1 RNA",
    "ARFRP1 Proteo"
  ],
  "GRIK5": [
    "GRIK5 CNV",
    "GRIK5 RNA"
  ],
  "RPS4XP21": [
    "RPS4XP21 CNV",
    "RPS4XP21 RNA"
  ],
  "C20orf85": [
    "C20orf85 CNV",
    "C20orf85 RNA"
  ],
  "RPL26": [
    "RPL26 CNV",
    "RPL26 RNA",
    "RPL26 Proteo"
  ],
  "SIK2": [
    "SIK2 CNV",
    "SIK2 RNA",
    "SIK2 Proteo"
  ],
  "OR10J7P": [
    "OR10J7P CNV",
    "OR10J7P RNA"
  ],
  "IMP3P1": [
    "IMP3P1 CNV",
    "IMP3P1 RNA"
  ],
  "PSMC1P6": [
    "PSMC1P6 CNV",
    "PSMC1P6 RNA"
  ],
  "CPNE7": [
    "CPNE7 CNV",
    "CPNE7 RNA",
    "CPNE7 Proteo"
  ],
  "RADX": [
    "RADX CNV",
    "RADX RNA",
    "RADX Proteo"
  ],
  "GOLGA5": [
    "GOLGA5 CNV",
    "GOLGA5 RNA",
    "GOLGA5 Proteo"
  ],
  "RNA5SP448": [
    "RNA5SP448 CNV",
    "RNA5SP448 RNA"
  ],
  "RNA5SP433": [
    "RNA5SP433 CNV",
    "RNA5SP433 RNA"
  ],
  "MTND2P16": [
    "MTND2P16 CNV",
    "MTND2P16 RNA"
  ],
  "MTND2P40": [
    "MTND2P40 CNV",
    "MTND2P40 RNA"
  ],
  "RNA5SP230": [
    "RNA5SP230 CNV",
    "RNA5SP230 RNA"
  ],
  "OR13Z2P": [
    "OR13Z2P CNV",
    "OR13Z2P RNA"
  ],
  "MTND1P4": [
    "MTND1P4 CNV",
    "MTND1P4 RNA"
  ],
  "CRELD1": [
    "CRELD1 CNV",
    "CRELD1 RNA",
    "CRELD1 Proteo"
  ],
  "KRTAP23-1": [
    "KRTAP23-1 CNV",
    "KRTAP23-1 RNA"
  ],
  "TRAPPC3": [
    "TRAPPC3 CNV",
    "TRAPPC3 RNA",
    "TRAPPC3 Proteo"
  ],
  "EEF1AKMT4": [
    "EEF1AKMT4 CNV",
    "EEF1AKMT4 RNA",
    "EEF1AKMT4 Proteo"
  ],
  "SOD1": [
    "SOD1 CNV",
    "SOD1 RNA",
    "SOD1 Proteo"
  ],
  "TXNP1": [
    "TXNP1 CNV",
    "TXNP1 RNA"
  ],
  "RNA5SP516": [
    "RNA5SP516 CNV",
    "RNA5SP516 RNA"
  ],
  "DOT1L": [
    "DOT1L CNV",
    "DOT1L RNA",
    "DOT1L Proteo"
  ],
  "FANCD2P2": [
    "FANCD2P2 CNV",
    "FANCD2P2 RNA"
  ],
  "NT5DC2": [
    "NT5DC2 CNV",
    "NT5DC2 RNA",
    "NT5DC2 Proteo"
  ],
  "MTND4P32": [
    "MTND4P32 CNV",
    "MTND4P32 RNA"
  ],
  "FADD": [
    "FADD CNV",
    "FADD RNA",
    "FADD Proteo"
  ],
  "MTCYBP38": [
    "MTCYBP38 CNV",
    "MTCYBP38 RNA"
  ],
  "DNMT1": [
    "DNMT1 CNV",
    "DNMT1 RNA",
    "DNMT1 Proteo"
  ],
  "PI4KA": [
    "PI4KA CNV",
    "PI4KA RNA",
    "PI4KA Proteo"
  ],
  "RPL6P13": [
    "RPL6P13 CNV",
    "RPL6P13 RNA"
  ],
  "PTCHD3P3": [
    "PTCHD3P3 CNV",
    "PTCHD3P3 RNA"
  ],
  "COBL": [
    "COBL CNV",
    "COBL RNA",
    "COBL Proteo"
  ],
  "PYHIN5P": [
    "PYHIN5P CNV",
    "PYHIN5P RNA"
  ],
  "HMGN2P31": [
    "HMGN2P31 CNV",
    "HMGN2P31 RNA"
  ],
  "INF2": [
    "INF2 CNV",
    "INF2 RNA",
    "INF2 Proteo"
  ],
  "CAV1": [
    "CAV1 CNV",
    "CAV1 RNA",
    "CAV1 Proteo"
  ],
  "SPNS2": [
    "SPNS2 CNV",
    "SPNS2 RNA"
  ],
  "ENSAP2": [
    "ENSAP2 CNV",
    "ENSAP2 RNA"
  ],
  "ADCK1": [
    "ADCK1 CNV",
    "ADCK1 RNA",
    "ADCK1 Proteo"
  ],
  "CCDC195": [
    "CCDC195 CNV",
    "CCDC195 RNA"
  ],
  "DNAJC19P8": [
    "DNAJC19P8 CNV",
    "DNAJC19P8 RNA"
  ],
  "IFNA1": [
    "IFNA1 CNV",
    "IFNA1 RNA"
  ],
  "DMGDH": [
    "DMGDH CNV",
    "DMGDH RNA",
    "DMGDH Proteo"
  ],
  "PAFAH1B1P2": [
    "PAFAH1B1P2 CNV",
    "PAFAH1B1P2 RNA"
  ],
  "ARHGEF28": [
    "ARHGEF28 CNV",
    "ARHGEF28 RNA",
    "ARHGEF28 Proteo"
  ],
  "PKMP5": [
    "PKMP5 CNV",
    "PKMP5 RNA"
  ],
  "MTND4P21": [
    "MTND4P21 CNV",
    "MTND4P21 RNA"
  ],
  "MTND4LP26": [
    "MTND4LP26 CNV",
    "MTND4LP26 RNA"
  ],
  "TPT1P11": [
    "TPT1P11 CNV",
    "TPT1P11 RNA"
  ],
  "PUS10": [
    "PUS10 CNV",
    "PUS10 RNA",
    "PUS10 Proteo"
  ],
  "GALK2": [
    "GALK2 CNV",
    "GALK2 RNA",
    "GALK2 Proteo"
  ],
  "MORF4L1P1": [
    "MORF4L1P1 CNV",
    "MORF4L1P1 RNA"
  ],
  "TIPARP": [
    "TIPARP CNV",
    "TIPARP RNA"
  ],
  "SLC22A31": [
    "SLC22A31 CNV",
    "SLC22A31 RNA"
  ],
  "RSPH9": [
    "RSPH9 CNV",
    "RSPH9 RNA"
  ],
  "BHMT2": [
    "BHMT2 CNV",
    "BHMT2 RNA"
  ],
  "DBIL5P2": [
    "DBIL5P2 CNV",
    "DBIL5P2 RNA"
  ],
  "GDPD2": [
    "GDPD2 CNV",
    "GDPD2 RNA"
  ],
  "TIMM23": [
    "TIMM23 CNV",
    "TIMM23 RNA",
    "TIMM23 Proteo"
  ],
  "NCOR2": [
    "NCOR2 CNV",
    "NCOR2 RNA",
    "NCOR2 Proteo"
  ],
  "YY1AP1": [
    "YY1AP1 CNV",
    "YY1AP1 RNA",
    "YY1AP1 Proteo"
  ],
  "PPIAP26": [
    "PPIAP26 CNV",
    "PPIAP26 RNA"
  ],
  "RBKS": [
    "RBKS CNV",
    "RBKS RNA",
    "RBKS Proteo"
  ],
  "RAB2B": [
    "RAB2B CNV",
    "RAB2B RNA",
    "RAB2B Proteo"
  ],
  "PLAC8L1": [
    "PLAC8L1 CNV",
    "PLAC8L1 RNA"
  ],
  "IFNWP4": [
    "IFNWP4 CNV",
    "IFNWP4 RNA"
  ],
  "JOSD1": [
    "JOSD1 CNV",
    "JOSD1 RNA"
  ],
  "PTGS2": [
    "PTGS2 CNV",
    "PTGS2 RNA",
    "PTGS2 Proteo"
  ],
  "IFT46": [
    "IFT46 CNV",
    "IFT46 RNA",
    "IFT46 Proteo"
  ],
  "EVA1C": [
    "EVA1C CNV",
    "EVA1C RNA"
  ],
  "BUB1B": [
    "BUB1B CNV",
    "BUB1B RNA",
    "BUB1B Proteo"
  ],
  "NLRP14": [
    "NLRP14 CNV",
    "NLRP14 RNA"
  ],
  "NFYBP1": [
    "NFYBP1 CNV",
    "NFYBP1 RNA"
  ],
  "ANGPTL8": [
    "ANGPTL8 CNV",
    "ANGPTL8 RNA"
  ],
  "OR7E111P": [
    "OR7E111P CNV",
    "OR7E111P RNA"
  ],
  "RCAN1": [
    "RCAN1 CNV",
    "RCAN1 RNA",
    "RCAN1 Proteo"
  ],
  "CD14": [
    "CD14 CNV",
    "CD14 RNA",
    "CD14 Proteo"
  ],
  "EIF4EBP2P1": [
    "EIF4EBP2P1 CNV",
    "EIF4EBP2P1 RNA"
  ],
  "OR4A41P": [
    "OR4A41P CNV",
    "OR4A41P RNA"
  ],
  "YWHAQP9": [
    "YWHAQP9 CNV",
    "YWHAQP9 RNA"
  ],
  "TEKTIP1": [
    "TEKTIP1 CNV",
    "TEKTIP1 RNA"
  ],
  "FOXL2": [
    "FOXL2 CNV",
    "FOXL2 RNA"
  ],
  "ADH7": [
    "ADH7 CNV",
    "ADH7 RNA",
    "ADH7 Proteo"
  ],
  "RPS8P6": [
    "RPS8P6 CNV",
    "RPS8P6 RNA"
  ],
  "BYSL": [
    "BYSL CNV",
    "BYSL RNA",
    "BYSL Proteo"
  ],
  "EPPK1": [
    "EPPK1 CNV",
    "EPPK1 RNA",
    "EPPK1 Proteo"
  ],
  "MTFR1": [
    "MTFR1 CNV",
    "MTFR1 RNA",
    "MTFR1 Proteo"
  ],
  "PAQR4": [
    "PAQR4 CNV",
    "PAQR4 RNA",
    "PAQR4 Proteo"
  ],
  "TMEM139": [
    "TMEM139 CNV",
    "TMEM139 RNA"
  ],
  "MRM3": [
    "MRM3 CNV",
    "MRM3 RNA",
    "MRM3 Proteo"
  ],
  "SSTR3": [
    "SSTR3 CNV",
    "SSTR3 RNA"
  ],
  "IGHVII-15-1": [
    "IGHVII-15-1 CNV",
    "IGHVII-15-1 RNA"
  ],
  "CAD": [
    "CAD CNV",
    "CAD RNA",
    "CAD Proteo"
  ],
  "CPLX1": [
    "CPLX1 CNV",
    "CPLX1 RNA"
  ],
  "CD84P1": [
    "CD84P1 CNV",
    "CD84P1 RNA"
  ],
  "MMADHC": [
    "MMADHC CNV",
    "MMADHC RNA",
    "MMADHC Proteo"
  ],
  "RPL10L": [
    "RPL10L CNV",
    "RPL10L RNA"
  ],
  "TMEM200C": [
    "TMEM200C CNV",
    "TMEM200C RNA"
  ],
  "SNRNP35": [
    "SNRNP35 CNV",
    "SNRNP35 RNA",
    "SNRNP35 Proteo"
  ],
  "HMGB3P6": [
    "HMGB3P6 CNV",
    "HMGB3P6 RNA"
  ],
  "HMGB1P12": [
    "HMGB1P12 CNV",
    "HMGB1P12 RNA"
  ],
  "OR2T11": [
    "OR2T11 CNV",
    "OR2T11 RNA"
  ],
  "USP12P2": [
    "USP12P2 CNV",
    "USP12P2 RNA"
  ],
  "TPT1P7": [
    "TPT1P7 CNV",
    "TPT1P7 RNA"
  ],
  "IGLV3-6": [
    "IGLV3-6 CNV",
    "IGLV3-6 RNA"
  ],
  "VCPKMT": [
    "VCPKMT CNV",
    "VCPKMT RNA",
    "VCPKMT Proteo"
  ],
  "OR52A1": [
    "OR52A1 CNV",
    "OR52A1 RNA"
  ],
  "FAM161A": [
    "FAM161A CNV",
    "FAM161A RNA",
    "FAM161A Proteo"
  ],
  "TCF15": [
    "TCF15 CNV",
    "TCF15 RNA"
  ],
  "CLCP2": [
    "CLCP2 CNV",
    "CLCP2 RNA"
  ],
  "SNAI2": [
    "SNAI2 CNV",
    "SNAI2 RNA",
    "SNAI2 Proteo"
  ],
  "HNRNPDLP4": [
    "HNRNPDLP4 CNV",
    "HNRNPDLP4 RNA"
  ],
  "OTOP3": [
    "OTOP3 CNV",
    "OTOP3 RNA"
  ],
  "OR10C1": [
    "OR10C1 CNV",
    "OR10C1 RNA"
  ],
  "IPPK": [
    "IPPK CNV",
    "IPPK RNA"
  ],
  "LRCH3": [
    "LRCH3 CNV",
    "LRCH3 RNA",
    "LRCH3 Proteo"
  ],
  "THRAP3P2": [
    "THRAP3P2 CNV",
    "THRAP3P2 RNA"
  ],
  "NLRP4": [
    "NLRP4 CNV",
    "NLRP4 RNA"
  ],
  "MRPL50P4": [
    "MRPL50P4 CNV",
    "MRPL50P4 RNA"
  ],
  "SHKBP1": [
    "SHKBP1 CNV",
    "SHKBP1 RNA",
    "SHKBP1 Proteo"
  ],
  "SOX4": [
    "SOX4 CNV",
    "SOX4 RNA",
    "SOX4 Proteo"
  ],
  "COL6A5": [
    "COL6A5 CNV",
    "COL6A5 RNA",
    "COL6A5 Proteo"
  ],
  "HMGN2P48": [
    "HMGN2P48 CNV",
    "HMGN2P48 RNA"
  ],
  "TRIM65": [
    "TRIM65 CNV",
    "TRIM65 RNA",
    "TRIM65 Proteo"
  ],
  "CHIAP1": [
    "CHIAP1 CNV",
    "CHIAP1 RNA"
  ],
  "STK4": [
    "STK4 CNV",
    "STK4 RNA",
    "STK4 Proteo"
  ],
  "SLC35D1": [
    "SLC35D1 CNV",
    "SLC35D1 RNA",
    "SLC35D1 Proteo"
  ],
  "RPS2P16": [
    "RPS2P16 CNV",
    "RPS2P16 RNA"
  ],
  "C5AR1": [
    "C5AR1 CNV",
    "C5AR1 RNA",
    "C5AR1 Proteo"
  ],
  "NAA38": [
    "NAA38 CNV",
    "NAA38 RNA",
    "NAA38 Proteo"
  ],
  "KIF15": [
    "KIF15 CNV",
    "KIF15 RNA",
    "KIF15 Proteo"
  ],
  "SRMP3": [
    "SRMP3 CNV",
    "SRMP3 RNA"
  ],
  "NAAA": [
    "NAAA CNV",
    "NAAA RNA",
    "NAAA Proteo"
  ],
  "RPS3AP7": [
    "RPS3AP7 CNV",
    "RPS3AP7 RNA"
  ],
  "EFCAB14": [
    "EFCAB14 CNV",
    "EFCAB14 RNA",
    "EFCAB14 Proteo"
  ],
  "SNCG": [
    "SNCG CNV",
    "SNCG RNA",
    "SNCG Proteo"
  ],
  "AMMECR1": [
    "AMMECR1 CNV",
    "AMMECR1 RNA",
    "AMMECR1 Proteo"
  ],
  "GATB": [
    "GATB CNV",
    "GATB RNA",
    "GATB Proteo"
  ],
  "UBE2L2": [
    "UBE2L2 CNV",
    "UBE2L2 RNA"
  ],
  "PHLDA2": [
    "PHLDA2 CNV",
    "PHLDA2 RNA",
    "PHLDA2 Proteo"
  ],
  "CCND1": [
    "CCND1 CNV",
    "CCND1 RNA",
    "CCND1 Proteo"
  ],
  "RPL18P13": [
    "RPL18P13 CNV",
    "RPL18P13 RNA"
  ],
  "YDJC": [
    "YDJC CNV",
    "YDJC RNA",
    "YDJC Proteo"
  ],
  "NIM1K": [
    "NIM1K CNV",
    "NIM1K RNA"
  ],
  "PTGES3P1": [
    "PTGES3P1 CNV",
    "PTGES3P1 RNA"
  ],
  "PTK2B": [
    "PTK2B CNV",
    "PTK2B RNA",
    "PTK2B Proteo"
  ],
  "ZNF658": [
    "ZNF658 CNV",
    "ZNF658 RNA"
  ],
  "PRAMEF34P": [
    "PRAMEF34P CNV",
    "PRAMEF34P RNA"
  ],
  "DNAJB12P1": [
    "DNAJB12P1 CNV",
    "DNAJB12P1 RNA"
  ],
  "IL20": [
    "IL20 CNV",
    "IL20 RNA"
  ],
  "CORO1B": [
    "CORO1B CNV",
    "CORO1B RNA",
    "CORO1B Proteo"
  ],
  "RNA5SP394": [
    "RNA5SP394 CNV",
    "RNA5SP394 RNA"
  ],
  "PPIAP60": [
    "PPIAP60 CNV",
    "PPIAP60 RNA"
  ],
  "GNAT3": [
    "GNAT3 CNV",
    "GNAT3 RNA",
    "GNAT3 Proteo"
  ],
  "HMGN2P18": [
    "HMGN2P18 CNV",
    "HMGN2P18 RNA"
  ],
  "TEX54": [
    "TEX54 CNV",
    "TEX54 RNA"
  ],
  "MARK2P8": [
    "MARK2P8 CNV",
    "MARK2P8 RNA"
  ],
  "KRTAP13-5P": [
    "KRTAP13-5P CNV",
    "KRTAP13-5P RNA"
  ],
  "ANKRD62P1": [
    "ANKRD62P1 CNV",
    "ANKRD62P1 RNA"
  ],
  "SPIRE2": [
    "SPIRE2 CNV",
    "SPIRE2 RNA",
    "SPIRE2 Proteo"
  ],
  "MBL2": [
    "MBL2 CNV",
    "MBL2 RNA",
    "MBL2 Proteo"
  ],
  "SLC2A9": [
    "SLC2A9 CNV",
    "SLC2A9 RNA",
    "SLC2A9 Proteo"
  ],
  "ZNF17": [
    "ZNF17 CNV",
    "ZNF17 RNA"
  ],
  "ELSPBP1": [
    "ELSPBP1 CNV",
    "ELSPBP1 RNA"
  ],
  "PCDHB8": [
    "PCDHB8 CNV",
    "PCDHB8 RNA",
    "PCDHB8 Proteo"
  ],
  "PMM2P1": [
    "PMM2P1 CNV",
    "PMM2P1 RNA"
  ],
  "CTSL3P": [
    "CTSL3P CNV",
    "CTSL3P RNA"
  ],
  "GAPDHP35": [
    "GAPDHP35 CNV",
    "GAPDHP35 RNA"
  ],
  "SLC13A4": [
    "SLC13A4 CNV",
    "SLC13A4 RNA"
  ],
  "GOT2P6": [
    "GOT2P6 CNV",
    "GOT2P6 RNA"
  ],
  "MTCO1P51": [
    "MTCO1P51 CNV",
    "MTCO1P51 RNA"
  ],
  "RPL17P51": [
    "RPL17P51 CNV",
    "RPL17P51 RNA"
  ],
  "RNA5SP204": [
    "RNA5SP204 CNV",
    "RNA5SP204 RNA"
  ],
  "DCAF8L2": [
    "DCAF8L2 CNV",
    "DCAF8L2 RNA"
  ],
  "OR7E62P": [
    "OR7E62P CNV",
    "OR7E62P RNA"
  ],
  "RNA5SP311": [
    "RNA5SP311 CNV",
    "RNA5SP311 RNA"
  ],
  "CD177P1": [
    "CD177P1 CNV",
    "CD177P1 RNA"
  ],
  "HNRNPA1P25": [
    "HNRNPA1P25 CNV",
    "HNRNPA1P25 RNA"
  ],
  "IFNL1": [
    "IFNL1 CNV",
    "IFNL1 RNA"
  ],
  "DSG3": [
    "DSG3 CNV",
    "DSG3 RNA",
    "DSG3 Proteo"
  ],
  "GRHL2": [
    "GRHL2 CNV",
    "GRHL2 RNA",
    "GRHL2 Proteo"
  ],
  "RPL36AP10": [
    "RPL36AP10 CNV",
    "RPL36AP10 RNA"
  ],
  "RPS29P32": [
    "RPS29P32 CNV",
    "RPS29P32 RNA"
  ],
  "HSPE1P7": [
    "HSPE1P7 CNV",
    "HSPE1P7 RNA"
  ],
  "DDI1": [
    "DDI1 CNV",
    "DDI1 RNA"
  ],
  "CACNG5": [
    "CACNG5 CNV",
    "CACNG5 RNA"
  ],
  "MGAM": [
    "MGAM CNV",
    "MGAM RNA",
    "MGAM Proteo"
  ],
  "UMODL1": [
    "UMODL1 CNV",
    "UMODL1 RNA"
  ],
  "ZNF514": [
    "ZNF514 CNV",
    "ZNF514 RNA"
  ],
  "ITPA": [
    "ITPA CNV",
    "ITPA RNA",
    "ITPA Proteo"
  ],
  "CMTM5": [
    "CMTM5 CNV",
    "CMTM5 RNA",
    "CMTM5 Proteo"
  ],
  "GATAD1": [
    "GATAD1 CNV",
    "GATAD1 RNA",
    "GATAD1 Proteo"
  ],
  "RPL8P1": [
    "RPL8P1 CNV",
    "RPL8P1 RNA"
  ],
  "OR4S1": [
    "OR4S1 CNV",
    "OR4S1 RNA"
  ],
  "MIOS": [
    "MIOS CNV",
    "MIOS RNA",
    "MIOS Proteo"
  ],
  "DDR1": [
    "DDR1 CNV",
    "DDR1 RNA",
    "DDR1 Proteo"
  ],
  "RTRAFP1": [
    "RTRAFP1 CNV",
    "RTRAFP1 RNA"
  ],
  "NCF1C": [
    "NCF1C CNV",
    "NCF1C RNA"
  ],
  "SLC2A7": [
    "SLC2A7 CNV",
    "SLC2A7 RNA"
  ],
  "AFTPH": [
    "AFTPH CNV",
    "AFTPH RNA",
    "AFTPH Proteo"
  ],
  "SNX18P8": [
    "SNX18P8 CNV",
    "SNX18P8 RNA"
  ],
  "LINGO3": [
    "LINGO3 CNV",
    "LINGO3 RNA"
  ],
  "VN1R10P": [
    "VN1R10P CNV",
    "VN1R10P RNA"
  ],
  "ZDHHC8": [
    "ZDHHC8 CNV",
    "ZDHHC8 RNA",
    "ZDHHC8 Proteo"
  ],
  "GBX2": [
    "GBX2 CNV",
    "GBX2 RNA"
  ],
  "PRRX2": [
    "PRRX2 CNV",
    "PRRX2 RNA"
  ],
  "PLEKHG3": [
    "PLEKHG3 CNV",
    "PLEKHG3 RNA",
    "PLEKHG3 Proteo"
  ],
  "KIF24": [
    "KIF24 CNV",
    "KIF24 RNA"
  ],
  "OR10Q2P": [
    "OR10Q2P CNV",
    "OR10Q2P RNA"
  ],
  "ASNSP1": [
    "ASNSP1 CNV",
    "ASNSP1 RNA"
  ],
  "RPS24": [
    "RPS24 CNV",
    "RPS24 RNA",
    "RPS24 Proteo"
  ],
  "JPH1": [
    "JPH1 CNV",
    "JPH1 RNA",
    "JPH1 Proteo"
  ],
  "SKOR1": [
    "SKOR1 CNV",
    "SKOR1 RNA"
  ],
  "MTCYBP22": [
    "MTCYBP22 CNV",
    "MTCYBP22 RNA"
  ],
  "FERMT2": [
    "FERMT2 CNV",
    "FERMT2 RNA",
    "FERMT2 Proteo"
  ],
  "MMRN2": [
    "MMRN2 CNV",
    "MMRN2 RNA",
    "MMRN2 Proteo"
  ],
  "MTCO2P6": [
    "MTCO2P6 CNV",
    "MTCO2P6 RNA"
  ],
  "DOCK2": [
    "DOCK2 CNV",
    "DOCK2 RNA",
    "DOCK2 Proteo"
  ],
  "TXLNB": [
    "TXLNB CNV",
    "TXLNB RNA",
    "TXLNB Proteo"
  ],
  "RALB": [
    "RALB CNV",
    "RALB RNA",
    "RALB Proteo"
  ],
  "HMGN1P13": [
    "HMGN1P13 CNV",
    "HMGN1P13 RNA"
  ],
  "C4orf50": [
    "C4orf50 CNV",
    "C4orf50 RNA"
  ],
  "LSP1P2": [
    "LSP1P2 CNV",
    "LSP1P2 RNA"
  ],
  "MTMR10": [
    "MTMR10 CNV",
    "MTMR10 RNA",
    "MTMR10 Proteo"
  ],
  "H3P28": [
    "H3P28 CNV",
    "H3P28 RNA"
  ],
  "MYO16": [
    "MYO16 CNV",
    "MYO16 RNA"
  ],
  "BHLHE23": [
    "BHLHE23 CNV",
    "BHLHE23 RNA"
  ],
  "NTHL1": [
    "NTHL1 CNV",
    "NTHL1 RNA",
    "NTHL1 Proteo"
  ],
  "CTLA4": [
    "CTLA4 CNV",
    "CTLA4 RNA"
  ],
  "MTND4P24": [
    "MTND4P24 CNV",
    "MTND4P24 RNA"
  ],
  "CLRN3": [
    "CLRN3 CNV",
    "CLRN3 RNA",
    "CLRN3 Proteo"
  ],
  "MFSD4B": [
    "MFSD4B CNV",
    "MFSD4B RNA",
    "MFSD4B Proteo"
  ],
  "COL17A1": [
    "COL17A1 CNV",
    "COL17A1 RNA",
    "COL17A1 Proteo"
  ],
  "CALCA": [
    "CALCA CNV",
    "CALCA RNA"
  ],
  "STEAP4": [
    "STEAP4 CNV",
    "STEAP4 RNA",
    "STEAP4 Proteo"
  ],
  "MTCYBP10": [
    "MTCYBP10 CNV",
    "MTCYBP10 RNA"
  ],
  "NDUFAF3": [
    "NDUFAF3 CNV",
    "NDUFAF3 RNA",
    "NDUFAF3 Proteo"
  ],
  "COL1A1": [
    "COL1A1 CNV",
    "COL1A1 RNA",
    "COL1A1 Proteo"
  ],
  "KDELR3": [
    "KDELR3 CNV",
    "KDELR3 RNA",
    "KDELR3 Proteo"
  ],
  "GLOD5": [
    "GLOD5 CNV",
    "GLOD5 RNA"
  ],
  "MTCO1P57": [
    "MTCO1P57 CNV",
    "MTCO1P57 RNA"
  ],
  "KCND2": [
    "KCND2 CNV",
    "KCND2 RNA"
  ],
  "PLPP4": [
    "PLPP4 CNV",
    "PLPP4 RNA"
  ],
  "LPL": [
    "LPL CNV",
    "LPL RNA",
    "LPL Proteo"
  ],
  "PLPPR2": [
    "PLPPR2 CNV",
    "PLPPR2 RNA"
  ],
  "SLCO2A1": [
    "SLCO2A1 CNV",
    "SLCO2A1 RNA",
    "SLCO2A1 Proteo"
  ],
  "SRSF3P4": [
    "SRSF3P4 CNV",
    "SRSF3P4 RNA"
  ],
  "C2orf74": [
    "C2orf74 CNV",
    "C2orf74 RNA"
  ],
  "C2CD4A": [
    "C2CD4A CNV",
    "C2CD4A RNA"
  ],
  "GTPBP3": [
    "GTPBP3 CNV",
    "GTPBP3 RNA",
    "GTPBP3 Proteo"
  ],
  "IGHVIII-47-1": [
    "IGHVIII-47-1 CNV",
    "IGHVIII-47-1 RNA"
  ],
  "ACRP1": [
    "ACRP1 CNV",
    "ACRP1 RNA"
  ],
  "UBXN2A": [
    "UBXN2A CNV",
    "UBXN2A RNA",
    "UBXN2A Proteo"
  ],
  "ACKR4": [
    "ACKR4 CNV",
    "ACKR4 RNA"
  ],
  "SP140": [
    "SP140 CNV",
    "SP140 RNA",
    "SP140 Proteo"
  ],
  "ZNF480": [
    "ZNF480 CNV",
    "ZNF480 RNA"
  ],
  "PDLIM1P2": [
    "PDLIM1P2 CNV",
    "PDLIM1P2 RNA"
  ],
  "P2RY2": [
    "P2RY2 CNV",
    "P2RY2 RNA"
  ],
  "PRAMEF28P": [
    "PRAMEF28P CNV",
    "PRAMEF28P RNA"
  ],
  "IGHV3-33": [
    "IGHV3-33 Proteo"
  ],
  "NQO2": [
    "NQO2 CNV",
    "NQO2 RNA",
    "NQO2 Proteo"
  ],
  "UPF2": [
    "UPF2 CNV",
    "UPF2 RNA",
    "UPF2 Proteo"
  ],
  "RPL36AP47": [
    "RPL36AP47 CNV",
    "RPL36AP47 RNA"
  ],
  "RPSAP37": [
    "RPSAP37 CNV",
    "RPSAP37 RNA"
  ],
  "POU2AF2": [
    "POU2AF2 CNV",
    "POU2AF2 RNA"
  ],
  "PAICSP4": [
    "PAICSP4 CNV",
    "PAICSP4 RNA"
  ],
  "TUBB4BP4": [
    "TUBB4BP4 CNV",
    "TUBB4BP4 RNA"
  ],
  "PRAMEF17": [
    "PRAMEF17 CNV",
    "PRAMEF17 RNA"
  ],
  "IGLVVII-41-1": [
    "IGLVVII-41-1 CNV",
    "IGLVVII-41-1 RNA"
  ],
  "C11orf54": [
    "C11orf54 CNV",
    "C11orf54 RNA",
    "C11orf54 Proteo"
  ],
  "RNA5SP291": [
    "RNA5SP291 CNV",
    "RNA5SP291 RNA"
  ],
  "AK3P4": [
    "AK3P4 CNV",
    "AK3P4 RNA"
  ],
  "ZFP28": [
    "ZFP28 CNV",
    "ZFP28 RNA"
  ],
  "DLGAP3": [
    "DLGAP3 CNV",
    "DLGAP3 RNA"
  ],
  "POMC": [
    "POMC CNV",
    "POMC RNA"
  ],
  "TIMM17A": [
    "TIMM17A CNV",
    "TIMM17A RNA",
    "TIMM17A Proteo"
  ],
  "SLC26A4": [
    "SLC26A4 CNV",
    "SLC26A4 RNA"
  ],
  "LRRC51": [
    "LRRC51 CNV",
    "LRRC51 RNA"
  ],
  "SNCAIP": [
    "SNCAIP CNV",
    "SNCAIP RNA"
  ],
  "SSMEM1": [
    "SSMEM1 CNV",
    "SSMEM1 RNA"
  ],
  "ZC3HC1": [
    "ZC3HC1 CNV",
    "ZC3HC1 RNA",
    "ZC3HC1 Proteo"
  ],
  "TROAP": [
    "TROAP CNV",
    "TROAP RNA",
    "TROAP Proteo"
  ],
  "PKMYT1": [
    "PKMYT1 CNV",
    "PKMYT1 RNA",
    "PKMYT1 Proteo"
  ],
  "RNF144B": [
    "RNF144B CNV",
    "RNF144B RNA"
  ],
  "PRR7": [
    "PRR7 CNV",
    "PRR7 RNA"
  ],
  "AQP5": [
    "AQP5 CNV",
    "AQP5 RNA",
    "AQP5 Proteo"
  ],
  "GAPDHP50": [
    "GAPDHP50 CNV",
    "GAPDHP50 RNA"
  ],
  "SHMT2": [
    "SHMT2 CNV",
    "SHMT2 RNA",
    "SHMT2 Proteo"
  ],
  "DUSP2": [
    "DUSP2 CNV",
    "DUSP2 RNA"
  ],
  "APPL1": [
    "APPL1 CNV",
    "APPL1 RNA",
    "APPL1 Proteo"
  ],
  "HINT1": [
    "HINT1 CNV",
    "HINT1 RNA",
    "HINT1 Proteo"
  ],
  "GJB5": [
    "GJB5 CNV",
    "GJB5 RNA"
  ],
  "CRLF3P1": [
    "CRLF3P1 CNV",
    "CRLF3P1 RNA"
  ],
  "PPP1R26": [
    "PPP1R26 CNV",
    "PPP1R26 RNA"
  ],
  "RASGRP2": [
    "RASGRP2 CNV",
    "RASGRP2 RNA",
    "RASGRP2 Proteo"
  ],
  "BDH2P1": [
    "BDH2P1 CNV",
    "BDH2P1 RNA"
  ],
  "DCTPP1": [
    "DCTPP1 CNV",
    "DCTPP1 RNA",
    "DCTPP1 Proteo"
  ],
  "SUMO4": [
    "SUMO4 CNV",
    "SUMO4 RNA",
    "SUMO4 Proteo"
  ],
  "KCNJ15": [
    "KCNJ15 CNV",
    "KCNJ15 RNA"
  ],
  "MAP2K6": [
    "MAP2K6 CNV",
    "MAP2K6 RNA",
    "MAP2K6 Proteo"
  ],
  "HNRNPA1P31": [
    "HNRNPA1P31 CNV",
    "HNRNPA1P31 RNA"
  ],
  "FMN2P1": [
    "FMN2P1 CNV",
    "FMN2P1 RNA"
  ],
  "CAPNS2": [
    "CAPNS2 CNV",
    "CAPNS2 RNA",
    "CAPNS2 Proteo"
  ],
  "SPRY1": [
    "SPRY1 CNV",
    "SPRY1 RNA",
    "SPRY1 Proteo"
  ],
  "C4orf47": [
    "C4orf47 CNV",
    "C4orf47 RNA"
  ],
  "ZBTB7B": [
    "ZBTB7B CNV",
    "ZBTB7B RNA",
    "ZBTB7B Proteo"
  ],
  "OFD1P15Y": [
    "OFD1P15Y CNV",
    "OFD1P15Y RNA"
  ],
  "ZNF319": [
    "ZNF319 CNV",
    "ZNF319 RNA",
    "ZNF319 Proteo"
  ],
  "SEPTIN14P1": [
    "SEPTIN14P1 CNV",
    "SEPTIN14P1 RNA"
  ],
  "MTMR8": [
    "MTMR8 CNV",
    "MTMR8 RNA"
  ],
  "FDPSP4": [
    "FDPSP4 CNV",
    "FDPSP4 RNA"
  ],
  "NGDN": [
    "NGDN CNV",
    "NGDN RNA",
    "NGDN Proteo"
  ],
  "CUL2": [
    "CUL2 CNV",
    "CUL2 RNA",
    "CUL2 Proteo"
  ],
  "RHOXF1P3": [
    "RHOXF1P3 CNV",
    "RHOXF1P3 RNA"
  ],
  "TMEM229A": [
    "TMEM229A CNV",
    "TMEM229A RNA"
  ],
  "KBTBD11": [
    "KBTBD11 CNV",
    "KBTBD11 RNA",
    "KBTBD11 Proteo"
  ],
  "FAM102A": [
    "FAM102A CNV",
    "FAM102A RNA",
    "FAM102A Proteo"
  ],
  "GEMIN8P2": [
    "GEMIN8P2 CNV",
    "GEMIN8P2 RNA"
  ],
  "EHD1": [
    "EHD1 CNV",
    "EHD1 RNA",
    "EHD1 Proteo"
  ],
  "VIP": [
    "VIP CNV",
    "VIP RNA"
  ],
  "PAICSP3": [
    "PAICSP3 CNV",
    "PAICSP3 RNA"
  ],
  "ATP9A": [
    "ATP9A CNV",
    "ATP9A RNA",
    "ATP9A Proteo"
  ],
  "ENO3": [
    "ENO3 CNV",
    "ENO3 RNA",
    "ENO3 Proteo"
  ],
  "VCAN": [
    "VCAN CNV",
    "VCAN RNA",
    "VCAN Proteo"
  ],
  "PDYN": [
    "PDYN CNV",
    "PDYN RNA"
  ],
  "CNP": [
    "CNP CNV",
    "CNP RNA",
    "CNP Proteo"
  ],
  "CRB3": [
    "CRB3 CNV",
    "CRB3 RNA"
  ],
  "GCNT1P5": [
    "GCNT1P5 CNV",
    "GCNT1P5 RNA"
  ],
  "GATD1": [
    "GATD1 CNV",
    "GATD1 RNA",
    "GATD1 Proteo"
  ],
  "PTGES3L": [
    "PTGES3L CNV",
    "PTGES3L RNA"
  ],
  "CCDC198": [
    "CCDC198 CNV",
    "CCDC198 RNA"
  ],
  "FASTKD2": [
    "FASTKD2 CNV",
    "FASTKD2 RNA",
    "FASTKD2 Proteo"
  ],
  "YKT6": [
    "YKT6 CNV",
    "YKT6 RNA",
    "YKT6 Proteo"
  ],
  "RPS16": [
    "RPS16 CNV",
    "RPS16 RNA",
    "RPS16 Proteo"
  ],
  "LMTK2": [
    "LMTK2 CNV",
    "LMTK2 RNA",
    "LMTK2 Proteo"
  ],
  "PPEF1": [
    "PPEF1 CNV",
    "PPEF1 RNA"
  ],
  "SCT": [
    "SCT CNV",
    "SCT RNA"
  ],
  "SDCBPP2": [
    "SDCBPP2 CNV",
    "SDCBPP2 RNA"
  ],
  "KPNA2P1": [
    "KPNA2P1 CNV",
    "KPNA2P1 RNA"
  ],
  "TRPA1": [
    "TRPA1 CNV",
    "TRPA1 RNA"
  ],
  "ACSM1": [
    "ACSM1 CNV",
    "ACSM1 RNA"
  ],
  "NOP14": [
    "NOP14 CNV",
    "NOP14 RNA",
    "NOP14 Proteo"
  ],
  "RBMXL2": [
    "RBMXL2 CNV",
    "RBMXL2 RNA",
    "RBMXL2 Proteo"
  ],
  "CCNDBP1": [
    "CCNDBP1 CNV",
    "CCNDBP1 RNA",
    "CCNDBP1 Proteo"
  ],
  "RANBP2": [
    "RANBP2 CNV",
    "RANBP2 RNA",
    "RANBP2 Proteo"
  ],
  "FFAR2": [
    "FFAR2 CNV",
    "FFAR2 RNA"
  ],
  "COL4A4": [
    "COL4A4 CNV",
    "COL4A4 RNA"
  ],
  "RPL7P21": [
    "RPL7P21 CNV",
    "RPL7P21 RNA"
  ],
  "PNMA6A": [
    "PNMA6A CNV",
    "PNMA6A RNA"
  ],
  "TTC21A": [
    "TTC21A CNV",
    "TTC21A RNA"
  ],
  "FCF1P6": [
    "FCF1P6 CNV",
    "FCF1P6 RNA"
  ],
  "TRMT10BP1": [
    "TRMT10BP1 CNV",
    "TRMT10BP1 RNA"
  ],
  "NCOA4P2": [
    "NCOA4P2 CNV",
    "NCOA4P2 RNA"
  ],
  "SF3B5": [
    "SF3B5 CNV",
    "SF3B5 RNA",
    "SF3B5 Proteo"
  ],
  "COILP1": [
    "COILP1 CNV",
    "COILP1 RNA"
  ],
  "DNAJB5": [
    "DNAJB5 CNV",
    "DNAJB5 RNA",
    "DNAJB5 Proteo"
  ],
  "R3HDM2P2": [
    "R3HDM2P2 CNV",
    "R3HDM2P2 RNA"
  ],
  "FSD1": [
    "FSD1 CNV",
    "FSD1 RNA",
    "FSD1 Proteo"
  ],
  "TUBB8P11": [
    "TUBB8P11 CNV",
    "TUBB8P11 RNA"
  ],
  "RNF103": [
    "RNF103 CNV",
    "RNF103 RNA"
  ],
  "ELOA3P": [
    "ELOA3P CNV",
    "ELOA3P RNA"
  ],
  "CECR7": [
    "CECR7 CNV",
    "CECR7 RNA"
  ],
  "OR5K4": [
    "OR5K4 CNV",
    "OR5K4 RNA"
  ],
  "RANP4": [
    "RANP4 CNV",
    "RANP4 RNA"
  ],
  "WIF1": [
    "WIF1 CNV",
    "WIF1 RNA"
  ],
  "APOBEC3H": [
    "APOBEC3H CNV",
    "APOBEC3H RNA"
  ],
  "MT1M": [
    "MT1M CNV",
    "MT1M RNA"
  ],
  "H1-8": [
    "H1-8 CNV",
    "H1-8 RNA"
  ],
  "CFTRP1": [
    "CFTRP1 CNV",
    "CFTRP1 RNA"
  ],
  "BORCS5": [
    "BORCS5 CNV",
    "BORCS5 RNA",
    "BORCS5 Proteo"
  ],
  "PLCXD3": [
    "PLCXD3 CNV",
    "PLCXD3 RNA",
    "PLCXD3 Proteo"
  ],
  "H3P40": [
    "H3P40 CNV",
    "H3P40 RNA"
  ],
  "ATP6V1F": [
    "ATP6V1F CNV",
    "ATP6V1F RNA",
    "ATP6V1F Proteo"
  ],
  "NDN": [
    "NDN CNV",
    "NDN RNA",
    "NDN Proteo"
  ],
  "ELOVL5": [
    "ELOVL5 CNV",
    "ELOVL5 RNA",
    "ELOVL5 Proteo"
  ],
  "MAFG": [
    "MAFG CNV",
    "MAFG RNA",
    "MAFG Proteo"
  ],
  "CAMK2A": [
    "CAMK2A CNV",
    "CAMK2A RNA"
  ],
  "RPL7L1P4": [
    "RPL7L1P4 CNV",
    "RPL7L1P4 RNA"
  ],
  "TMEM229B": [
    "TMEM229B CNV",
    "TMEM229B RNA"
  ],
  "RNA5SP97": [
    "RNA5SP97 CNV",
    "RNA5SP97 RNA"
  ],
  "RPL36A": [
    "RPL36A CNV",
    "RPL36A RNA",
    "RPL36A Proteo"
  ],
  "ETNK1": [
    "ETNK1 CNV",
    "ETNK1 RNA",
    "ETNK1 Proteo"
  ],
  "PRR18": [
    "PRR18 CNV",
    "PRR18 RNA"
  ],
  "RPL7P26": [
    "RPL7P26 CNV",
    "RPL7P26 RNA"
  ],
  "SPG7": [
    "SPG7 CNV",
    "SPG7 RNA",
    "SPG7 Proteo"
  ],
  "RPS3": [
    "RPS3 CNV",
    "RPS3 RNA",
    "RPS3 Proteo"
  ],
  "RPP40P2": [
    "RPP40P2 CNV",
    "RPP40P2 RNA"
  ],
  "VN1R110P": [
    "VN1R110P CNV",
    "VN1R110P RNA"
  ],
  "SEPTIN7P8": [
    "SEPTIN7P8 CNV",
    "SEPTIN7P8 RNA"
  ],
  "UNC93B1": [
    "UNC93B1 CNV",
    "UNC93B1 RNA",
    "UNC93B1 Proteo"
  ],
  "RNA5SP447": [
    "RNA5SP447 CNV",
    "RNA5SP447 RNA"
  ],
  "DIAPH1": [
    "DIAPH1 CNV",
    "DIAPH1 RNA",
    "DIAPH1 Proteo"
  ],
  "TNIK": [
    "TNIK CNV",
    "TNIK RNA",
    "TNIK Proteo"
  ],
  "RACGAP1P1": [
    "RACGAP1P1 CNV",
    "RACGAP1P1 RNA"
  ],
  "KRT18P47": [
    "KRT18P47 CNV",
    "KRT18P47 RNA"
  ],
  "USP37P1": [
    "USP37P1 CNV",
    "USP37P1 RNA"
  ],
  "RPL21P2": [
    "RPL21P2 CNV",
    "RPL21P2 RNA"
  ],
  "IGHE": [
    "IGHE Proteo"
  ],
  "TCEAL5": [
    "TCEAL5 CNV",
    "TCEAL5 RNA"
  ],
  "TAAR7P": [
    "TAAR7P CNV",
    "TAAR7P RNA"
  ],
  "POM121L10P": [
    "POM121L10P CNV",
    "POM121L10P RNA"
  ],
  "RPL7AP69": [
    "RPL7AP69 CNV",
    "RPL7AP69 RNA"
  ],
  "PRAMEF29P": [
    "PRAMEF29P CNV",
    "PRAMEF29P RNA"
  ],
  "EIF4EBP2": [
    "EIF4EBP2 CNV",
    "EIF4EBP2 RNA",
    "EIF4EBP2 Proteo"
  ],
  "MTCYBP24": [
    "MTCYBP24 CNV",
    "MTCYBP24 RNA"
  ],
  "PFN1P2": [
    "PFN1P2 CNV",
    "PFN1P2 RNA"
  ],
  "BRI3P1": [
    "BRI3P1 CNV",
    "BRI3P1 RNA"
  ],
  "MTND6P29": [
    "MTND6P29 CNV",
    "MTND6P29 RNA"
  ],
  "SFXN4": [
    "SFXN4 CNV",
    "SFXN4 RNA",
    "SFXN4 Proteo"
  ],
  "LLCFC1": [
    "LLCFC1 CNV",
    "LLCFC1 RNA"
  ],
  "PGAM5": [
    "PGAM5 CNV",
    "PGAM5 RNA",
    "PGAM5 Proteo"
  ],
  "BRS3": [
    "BRS3 CNV",
    "BRS3 RNA"
  ],
  "RPS3AP31": [
    "RPS3AP31 CNV",
    "RPS3AP31 RNA"
  ],
  "ARRB2": [
    "ARRB2 CNV",
    "ARRB2 RNA",
    "ARRB2 Proteo"
  ],
  "SINHCAF": [
    "SINHCAF CNV",
    "SINHCAF RNA",
    "SINHCAF Proteo"
  ],
  "NFKBIZ": [
    "NFKBIZ CNV",
    "NFKBIZ RNA"
  ],
  "TBX15": [
    "TBX15 CNV",
    "TBX15 RNA"
  ],
  "SEPTIN14": [
    "SEPTIN14 CNV",
    "SEPTIN14 RNA"
  ],
  "PPIAP55": [
    "PPIAP55 CNV",
    "PPIAP55 RNA"
  ],
  "ECHDC2": [
    "ECHDC2 CNV",
    "ECHDC2 RNA",
    "ECHDC2 Proteo"
  ],
  "DSC1": [
    "DSC1 CNV",
    "DSC1 RNA",
    "DSC1 Proteo"
  ],
  "STAG3L3": [
    "STAG3L3 CNV",
    "STAG3L3 RNA"
  ],
  "PPIAP74": [
    "PPIAP74 CNV",
    "PPIAP74 RNA"
  ],
  "QRSL1P3": [
    "QRSL1P3 CNV",
    "QRSL1P3 RNA"
  ],
  "SNAPC4": [
    "SNAPC4 CNV",
    "SNAPC4 RNA",
    "SNAPC4 Proteo"
  ],
  "CCDC85A": [
    "CCDC85A CNV",
    "CCDC85A RNA",
    "CCDC85A Proteo"
  ],
  "OR2A25": [
    "OR2A25 CNV",
    "OR2A25 RNA"
  ],
  "SPECC1P1": [
    "SPECC1P1 CNV",
    "SPECC1P1 RNA"
  ],
  "ZNF813": [
    "ZNF813 CNV",
    "ZNF813 RNA"
  ],
  "FAAH": [
    "FAAH CNV",
    "FAAH RNA",
    "FAAH Proteo"
  ],
  "ZNF859P": [
    "ZNF859P CNV",
    "ZNF859P RNA"
  ],
  "STX1B": [
    "STX1B CNV",
    "STX1B RNA"
  ],
  "TRIM77": [
    "TRIM77 CNV",
    "TRIM77 RNA"
  ],
  "TNFRSF21": [
    "TNFRSF21 CNV",
    "TNFRSF21 RNA",
    "TNFRSF21 Proteo"
  ],
  "C1orf56": [
    "C1orf56 CNV",
    "C1orf56 RNA",
    "C1orf56 Proteo"
  ],
  "GSTM3": [
    "GSTM3 CNV",
    "GSTM3 RNA",
    "GSTM3 Proteo"
  ],
  "CASP3": [
    "CASP3 CNV",
    "CASP3 RNA",
    "CASP3 Proteo"
  ],
  "DEFB103A": [
    "DEFB103A CNV",
    "DEFB103A RNA",
    "DEFB103A Proteo"
  ],
  "RAB40AL": [
    "RAB40AL CNV",
    "RAB40AL RNA"
  ],
  "LRBA": [
    "LRBA CNV",
    "LRBA RNA",
    "LRBA Proteo"
  ],
  "OTOGL": [
    "OTOGL CNV",
    "OTOGL RNA"
  ],
  "TMEM204": [
    "TMEM204 CNV",
    "TMEM204 RNA"
  ],
  "ELOBP1": [
    "ELOBP1 CNV",
    "ELOBP1 RNA"
  ],
  "LTBP2": [
    "LTBP2 CNV",
    "LTBP2 RNA",
    "LTBP2 Proteo"
  ],
  "PSPC1": [
    "PSPC1 CNV",
    "PSPC1 RNA",
    "PSPC1 Proteo"
  ],
  "OR4C7P": [
    "OR4C7P CNV",
    "OR4C7P RNA"
  ],
  "SIMC1": [
    "SIMC1 CNV",
    "SIMC1 RNA",
    "SIMC1 Proteo"
  ],
  "GPC4": [
    "GPC4 CNV",
    "GPC4 RNA",
    "GPC4 Proteo"
  ],
  "MTMR9LP": [
    "MTMR9LP CNV",
    "MTMR9LP RNA"
  ],
  "SUB1": [
    "SUB1 CNV",
    "SUB1 RNA",
    "SUB1 Proteo"
  ],
  "WDR19": [
    "WDR19 CNV",
    "WDR19 RNA",
    "WDR19 Proteo"
  ],
  "OR5H5P": [
    "OR5H5P CNV",
    "OR5H5P RNA"
  ],
  "GLYATL1B": [
    "GLYATL1B CNV",
    "GLYATL1B RNA"
  ],
  "EXT1": [
    "EXT1 CNV",
    "EXT1 RNA",
    "EXT1 Proteo"
  ],
  "RCHY1": [
    "RCHY1 CNV",
    "RCHY1 RNA",
    "RCHY1 Proteo"
  ],
  "COPS5P2": [
    "COPS5P2 CNV",
    "COPS5P2 RNA"
  ],
  "H2BC12L": [
    "H2BC12L CNV",
    "H2BC12L RNA"
  ],
  "ANGEL2": [
    "ANGEL2 CNV",
    "ANGEL2 RNA",
    "ANGEL2 Proteo"
  ],
  "ESAM": [
    "ESAM CNV",
    "ESAM RNA",
    "ESAM Proteo"
  ],
  "RPL30P3": [
    "RPL30P3 CNV",
    "RPL30P3 RNA"
  ],
  "GRB2": [
    "GRB2 CNV",
    "GRB2 RNA",
    "GRB2 Proteo"
  ],
  "CCDC3": [
    "CCDC3 CNV",
    "CCDC3 RNA"
  ],
  "VPS72": [
    "VPS72 CNV",
    "VPS72 RNA",
    "VPS72 Proteo"
  ],
  "MCM8": [
    "MCM8 CNV",
    "MCM8 RNA",
    "MCM8 Proteo"
  ],
  "HNRNPA1P50": [
    "HNRNPA1P50 CNV",
    "HNRNPA1P50 RNA"
  ],
  "NDUFAF8": [
    "NDUFAF8 CNV",
    "NDUFAF8 RNA",
    "NDUFAF8 Proteo"
  ],
  "FSTL4": [
    "FSTL4 CNV",
    "FSTL4 RNA"
  ],
  "DPPA5P1": [
    "DPPA5P1 CNV",
    "DPPA5P1 RNA"
  ],
  "MAP4K5": [
    "MAP4K5 CNV",
    "MAP4K5 RNA",
    "MAP4K5 Proteo"
  ],
  "ACTL6A": [
    "ACTL6A CNV",
    "ACTL6A RNA",
    "ACTL6A Proteo"
  ],
  "TACSTD2": [
    "TACSTD2 CNV",
    "TACSTD2 RNA",
    "TACSTD2 Proteo"
  ],
  "RNF168": [
    "RNF168 CNV",
    "RNF168 RNA",
    "RNF168 Proteo"
  ],
  "SLC6A4": [
    "SLC6A4 CNV",
    "SLC6A4 RNA"
  ],
  "RPL31P53": [
    "RPL31P53 CNV",
    "RPL31P53 RNA"
  ],
  "FCHO2": [
    "FCHO2 CNV",
    "FCHO2 RNA",
    "FCHO2 Proteo"
  ],
  "MTATP6P18": [
    "MTATP6P18 CNV",
    "MTATP6P18 RNA"
  ],
  "CPSF4": [
    "CPSF4 CNV",
    "CPSF4 RNA",
    "CPSF4 Proteo"
  ],
  "LDLRAD2": [
    "LDLRAD2 CNV",
    "LDLRAD2 RNA"
  ],
  "STARD7": [
    "STARD7 CNV",
    "STARD7 RNA",
    "STARD7 Proteo"
  ],
  "RAB43": [
    "RAB43 CNV",
    "RAB43 RNA",
    "RAB43 Proteo"
  ],
  "VPS39": [
    "VPS39 CNV",
    "VPS39 RNA",
    "VPS39 Proteo"
  ],
  "ASS1P9": [
    "ASS1P9 CNV",
    "ASS1P9 RNA"
  ],
  "PDP1": [
    "PDP1 CNV",
    "PDP1 RNA",
    "PDP1 Proteo"
  ],
  "DOC2A": [
    "DOC2A CNV",
    "DOC2A RNA"
  ],
  "RNA5SP54": [
    "RNA5SP54 CNV",
    "RNA5SP54 RNA"
  ],
  "RNA5SP342": [
    "RNA5SP342 CNV",
    "RNA5SP342 RNA"
  ],
  "CCK": [
    "CCK CNV",
    "CCK RNA",
    "CCK Proteo"
  ],
  "LPAL2": [
    "LPAL2 CNV",
    "LPAL2 RNA"
  ],
  "MSN": [
    "MSN CNV",
    "MSN RNA",
    "MSN Proteo"
  ],
  "DHRS12": [
    "DHRS12 CNV",
    "DHRS12 RNA"
  ],
  "COPG2": [
    "COPG2 CNV",
    "COPG2 RNA",
    "COPG2 Proteo"
  ],
  "FAM86JP": [
    "FAM86JP CNV",
    "FAM86JP RNA"
  ],
  "PIGPP3": [
    "PIGPP3 CNV",
    "PIGPP3 RNA"
  ],
  "NLK": [
    "NLK CNV",
    "NLK RNA",
    "NLK Proteo"
  ],
  "NXPE3": [
    "NXPE3 CNV",
    "NXPE3 RNA"
  ],
  "SHQ1": [
    "SHQ1 CNV",
    "SHQ1 RNA",
    "SHQ1 Proteo"
  ],
  "ARL2BPP8": [
    "ARL2BPP8 CNV",
    "ARL2BPP8 RNA"
  ],
  "SAMD12": [
    "SAMD12 CNV",
    "SAMD12 RNA"
  ],
  "SLC16A9": [
    "SLC16A9 CNV",
    "SLC16A9 RNA"
  ],
  "DGKZP1": [
    "DGKZP1 CNV",
    "DGKZP1 RNA"
  ],
  "GRIN2A": [
    "GRIN2A CNV",
    "GRIN2A RNA"
  ],
  "BCRP9": [
    "BCRP9 CNV",
    "BCRP9 RNA"
  ],
  "ITGB6": [
    "ITGB6 CNV",
    "ITGB6 RNA",
    "ITGB6 Proteo"
  ],
  "RPL34P21": [
    "RPL34P21 CNV",
    "RPL34P21 RNA"
  ],
  "TTC39CP1": [
    "TTC39CP1 CNV",
    "TTC39CP1 RNA"
  ],
  "IL36B": [
    "IL36B CNV",
    "IL36B RNA"
  ],
  "FAM110D": [
    "FAM110D CNV",
    "FAM110D RNA"
  ],
  "NONO": [
    "NONO CNV",
    "NONO RNA",
    "NONO Proteo"
  ],
  "LONRF2P1": [
    "LONRF2P1 CNV",
    "LONRF2P1 RNA"
  ],
  "OMA1": [
    "OMA1 CNV",
    "OMA1 RNA",
    "OMA1 Proteo"
  ],
  "TET3": [
    "TET3 CNV",
    "TET3 RNA",
    "TET3 Proteo"
  ],
  "SENP6": [
    "SENP6 CNV",
    "SENP6 RNA",
    "SENP6 Proteo"
  ],
  "RALY": [
    "RALY CNV",
    "RALY RNA",
    "RALY Proteo"
  ],
  "RHEB": [
    "RHEB CNV",
    "RHEB RNA",
    "RHEB Proteo"
  ],
  "TEX261": [
    "TEX261 CNV",
    "TEX261 RNA"
  ],
  "SLC66A2P1": [
    "SLC66A2P1 CNV",
    "SLC66A2P1 RNA"
  ],
  "ADAT1": [
    "ADAT1 CNV",
    "ADAT1 RNA",
    "ADAT1 Proteo"
  ],
  "YBX1P3": [
    "YBX1P3 CNV",
    "YBX1P3 RNA"
  ],
  "RLIMP1": [
    "RLIMP1 CNV",
    "RLIMP1 RNA"
  ],
  "YWHAQP4": [
    "YWHAQP4 CNV",
    "YWHAQP4 RNA"
  ],
  "ADAMTS9": [
    "ADAMTS9 CNV",
    "ADAMTS9 RNA"
  ],
  "RPS2P52": [
    "RPS2P52 CNV",
    "RPS2P52 RNA"
  ],
  "FAM162A": [
    "FAM162A CNV",
    "FAM162A RNA",
    "FAM162A Proteo"
  ],
  "TMEM184B": [
    "TMEM184B CNV",
    "TMEM184B RNA",
    "TMEM184B Proteo"
  ],
  "CDK5": [
    "CDK5 CNV",
    "CDK5 RNA",
    "CDK5 Proteo"
  ],
  "STEAP2": [
    "STEAP2 CNV",
    "STEAP2 RNA",
    "STEAP2 Proteo"
  ],
  "CHP1P1": [
    "CHP1P1 CNV",
    "CHP1P1 RNA"
  ],
  "TIPIN": [
    "TIPIN CNV",
    "TIPIN RNA",
    "TIPIN Proteo"
  ],
  "KMT5B": [
    "KMT5B CNV",
    "KMT5B RNA"
  ],
  "CFAP53P1": [
    "CFAP53P1 CNV",
    "CFAP53P1 RNA"
  ],
  "OPLAH": [
    "OPLAH CNV",
    "OPLAH RNA",
    "OPLAH Proteo"
  ],
  "OFD1": [
    "OFD1 CNV",
    "OFD1 RNA",
    "OFD1 Proteo"
  ],
  "ERAL1": [
    "ERAL1 CNV",
    "ERAL1 RNA",
    "ERAL1 Proteo"
  ],
  "OR2L3": [
    "OR2L3 CNV",
    "OR2L3 RNA"
  ],
  "OPN1SW": [
    "OPN1SW CNV",
    "OPN1SW RNA"
  ],
  "RCAN3": [
    "RCAN3 CNV",
    "RCAN3 RNA",
    "RCAN3 Proteo"
  ],
  "TRIM60P19": [
    "TRIM60P19 CNV",
    "TRIM60P19 RNA"
  ],
  "RPL19P20": [
    "RPL19P20 CNV",
    "RPL19P20 RNA"
  ],
  "ZNF573": [
    "ZNF573 CNV",
    "ZNF573 RNA"
  ],
  "OR2A2": [
    "OR2A2 CNV",
    "OR2A2 RNA"
  ],
  "ICA1L": [
    "ICA1L CNV",
    "ICA1L RNA"
  ],
  "CST9": [
    "CST9 CNV",
    "CST9 RNA"
  ],
  "DEFB1": [
    "DEFB1 CNV",
    "DEFB1 RNA"
  ],
  "ACY1": [
    "ACY1 CNV",
    "ACY1 RNA",
    "ACY1 Proteo"
  ],
  "BCAP31P2": [
    "BCAP31P2 CNV",
    "BCAP31P2 RNA"
  ],
  "VDAC2P5": [
    "VDAC2P5 CNV",
    "VDAC2P5 RNA"
  ],
  "H2BP8": [
    "H2BP8 CNV",
    "H2BP8 RNA"
  ],
  "SPINT4": [
    "SPINT4 CNV",
    "SPINT4 RNA"
  ],
  "ACOT1": [
    "ACOT1 CNV",
    "ACOT1 RNA",
    "ACOT1 Proteo"
  ],
  "TRMT44": [
    "TRMT44 CNV",
    "TRMT44 RNA",
    "TRMT44 Proteo"
  ],
  "OOSP2": [
    "OOSP2 CNV",
    "OOSP2 RNA"
  ],
  "SDHDP1": [
    "SDHDP1 CNV",
    "SDHDP1 RNA"
  ],
  "QRICH2": [
    "QRICH2 CNV",
    "QRICH2 RNA"
  ],
  "PSMA6P4": [
    "PSMA6P4 CNV",
    "PSMA6P4 RNA"
  ],
  "RPL23AP93": [
    "RPL23AP93 CNV",
    "RPL23AP93 RNA"
  ],
  "CYCSP40": [
    "CYCSP40 CNV",
    "CYCSP40 RNA"
  ],
  "MTHFSD": [
    "MTHFSD CNV",
    "MTHFSD RNA",
    "MTHFSD Proteo"
  ],
  "OR5AP2": [
    "OR5AP2 CNV",
    "OR5AP2 RNA"
  ],
  "ZAR1L": [
    "ZAR1L CNV",
    "ZAR1L RNA"
  ],
  "NENFP3": [
    "NENFP3 CNV",
    "NENFP3 RNA"
  ],
  "CHEK2P3": [
    "CHEK2P3 CNV",
    "CHEK2P3 RNA"
  ],
  "AGGF1P3": [
    "AGGF1P3 CNV",
    "AGGF1P3 RNA"
  ],
  "NLRP7": [
    "NLRP7 CNV",
    "NLRP7 RNA"
  ],
  "MTND3P1": [
    "MTND3P1 CNV",
    "MTND3P1 RNA"
  ],
  "CRIP1": [
    "CRIP1 CNV",
    "CRIP1 RNA",
    "CRIP1 Proteo"
  ],
  "NECAB3": [
    "NECAB3 CNV",
    "NECAB3 RNA"
  ],
  "VPS29": [
    "VPS29 CNV",
    "VPS29 RNA",
    "VPS29 Proteo"
  ],
  "RPL7P20": [
    "RPL7P20 CNV",
    "RPL7P20 RNA"
  ],
  "OSTCP6": [
    "OSTCP6 CNV",
    "OSTCP6 RNA"
  ],
  "CUL4A": [
    "CUL4A CNV",
    "CUL4A RNA",
    "CUL4A Proteo"
  ],
  "PPIAP15": [
    "PPIAP15 CNV",
    "PPIAP15 RNA"
  ],
  "GOLGA8DP": [
    "GOLGA8DP CNV",
    "GOLGA8DP RNA"
  ],
  "RPL30P14": [
    "RPL30P14 CNV",
    "RPL30P14 RNA"
  ],
  "CPAMD8": [
    "CPAMD8 CNV",
    "CPAMD8 RNA"
  ],
  "HERC5": [
    "HERC5 CNV",
    "HERC5 RNA",
    "HERC5 Proteo"
  ],
  "C18orf32": [
    "C18orf32 CNV",
    "C18orf32 RNA",
    "C18orf32 Proteo"
  ],
  "GFI1": [
    "GFI1 CNV",
    "GFI1 RNA"
  ],
  "U2AF1L4": [
    "U2AF1L4 CNV",
    "U2AF1L4 RNA"
  ],
  "BAK1P2": [
    "BAK1P2 CNV",
    "BAK1P2 RNA"
  ],
  "PDZRN3": [
    "PDZRN3 CNV",
    "PDZRN3 RNA",
    "PDZRN3 Proteo"
  ],
  "SCN2B": [
    "SCN2B CNV",
    "SCN2B RNA"
  ],
  "BEX1": [
    "BEX1 CNV",
    "BEX1 RNA"
  ],
  "HASPIN": [
    "HASPIN CNV",
    "HASPIN RNA",
    "HASPIN Proteo"
  ],
  "TSNAX": [
    "TSNAX CNV",
    "TSNAX RNA",
    "TSNAX Proteo"
  ],
  "FMO10P": [
    "FMO10P CNV",
    "FMO10P RNA"
  ],
  "TSPAN19": [
    "TSPAN19 CNV",
    "TSPAN19 RNA"
  ],
  "USP4": [
    "USP4 CNV",
    "USP4 RNA",
    "USP4 Proteo"
  ],
  "CGB3": [
    "CGB3 CNV",
    "CGB3 RNA"
  ],
  "NAT10": [
    "NAT10 CNV",
    "NAT10 RNA",
    "NAT10 Proteo"
  ],
  "OR2H1": [
    "OR2H1 CNV",
    "OR2H1 RNA"
  ],
  "FLYWCH1P1": [
    "FLYWCH1P1 CNV",
    "FLYWCH1P1 RNA"
  ],
  "PTMAP15": [
    "PTMAP15 CNV",
    "PTMAP15 RNA"
  ],
  "TERB1": [
    "TERB1 CNV",
    "TERB1 RNA"
  ],
  "NME8": [
    "NME8 CNV",
    "NME8 RNA"
  ],
  "SLC17A8": [
    "SLC17A8 CNV",
    "SLC17A8 RNA"
  ],
  "PRSS36": [
    "PRSS36 CNV",
    "PRSS36 RNA"
  ],
  "FOXA1": [
    "FOXA1 CNV",
    "FOXA1 RNA",
    "FOXA1 Proteo"
  ],
  "RBX1P1": [
    "RBX1P1 CNV",
    "RBX1P1 RNA"
  ],
  "FAM197Y2": [
    "FAM197Y2 CNV",
    "FAM197Y2 RNA"
  ],
  "COG8": [
    "COG8 CNV",
    "COG8 RNA",
    "COG8 Proteo"
  ],
  "ELOCP18": [
    "ELOCP18 CNV",
    "ELOCP18 RNA"
  ],
  "SNAPC1": [
    "SNAPC1 CNV",
    "SNAPC1 RNA",
    "SNAPC1 Proteo"
  ],
  "OR7E104P": [
    "OR7E104P CNV",
    "OR7E104P RNA"
  ],
  "DNTTIP1": [
    "DNTTIP1 CNV",
    "DNTTIP1 RNA",
    "DNTTIP1 Proteo"
  ],
  "FOXC2": [
    "FOXC2 CNV",
    "FOXC2 RNA"
  ],
  "ORC5": [
    "ORC5 CNV",
    "ORC5 RNA",
    "ORC5 Proteo"
  ],
  "DUSP19": [
    "DUSP19 CNV",
    "DUSP19 RNA",
    "DUSP19 Proteo"
  ],
  "PPP1R37": [
    "PPP1R37 CNV",
    "PPP1R37 RNA",
    "PPP1R37 Proteo"
  ],
  "ULK1": [
    "ULK1 CNV",
    "ULK1 RNA",
    "ULK1 Proteo"
  ],
  "SLC22A6": [
    "SLC22A6 CNV",
    "SLC22A6 RNA"
  ],
  "KLK12": [
    "KLK12 CNV",
    "KLK12 RNA"
  ],
  "CDC42SE1": [
    "CDC42SE1 CNV",
    "CDC42SE1 RNA",
    "CDC42SE1 Proteo"
  ],
  "ACSL1": [
    "ACSL1 CNV",
    "ACSL1 RNA",
    "ACSL1 Proteo"
  ],
  "LYPD3": [
    "LYPD3 CNV",
    "LYPD3 RNA",
    "LYPD3 Proteo"
  ],
  "HLA-V": [
    "HLA-V CNV",
    "HLA-V RNA"
  ],
  "RPL6P31": [
    "RPL6P31 CNV",
    "RPL6P31 RNA"
  ],
  "GPAA1": [
    "GPAA1 CNV",
    "GPAA1 RNA",
    "GPAA1 Proteo"
  ],
  "GLRX3P2": [
    "GLRX3P2 CNV",
    "GLRX3P2 RNA"
  ],
  "BNIP3P24": [
    "BNIP3P24 CNV",
    "BNIP3P24 RNA"
  ],
  "RMDN1": [
    "RMDN1 CNV",
    "RMDN1 RNA",
    "RMDN1 Proteo"
  ],
  "OR4K2": [
    "OR4K2 CNV",
    "OR4K2 RNA"
  ],
  "H3P27": [
    "H3P27 CNV",
    "H3P27 RNA"
  ],
  "TBC1D23": [
    "TBC1D23 CNV",
    "TBC1D23 RNA",
    "TBC1D23 Proteo"
  ],
  "CCDC59": [
    "CCDC59 CNV",
    "CCDC59 RNA",
    "CCDC59 Proteo"
  ],
  "MAP2K4P1": [
    "MAP2K4P1 CNV",
    "MAP2K4P1 RNA"
  ],
  "IGHV5-10-1": [
    "IGHV5-10-1 Proteo"
  ],
  "TUFM": [
    "TUFM CNV",
    "TUFM RNA",
    "TUFM Proteo"
  ],
  "UPK3A": [
    "UPK3A CNV",
    "UPK3A RNA"
  ],
  "GAPDHP34": [
    "GAPDHP34 CNV",
    "GAPDHP34 RNA"
  ],
  "RNA5SP271": [
    "RNA5SP271 CNV",
    "RNA5SP271 RNA"
  ],
  "OR1L4": [
    "OR1L4 CNV",
    "OR1L4 RNA"
  ],
  "GIMAP1": [
    "GIMAP1 CNV",
    "GIMAP1 RNA",
    "GIMAP1 Proteo"
  ],
  "WDR33": [
    "WDR33 CNV",
    "WDR33 RNA",
    "WDR33 Proteo"
  ],
  "DHX16": [
    "DHX16 CNV",
    "DHX16 RNA",
    "DHX16 Proteo"
  ],
  "PDZK1": [
    "PDZK1 CNV",
    "PDZK1 RNA",
    "PDZK1 Proteo"
  ],
  "OR4L1": [
    "OR4L1 CNV",
    "OR4L1 RNA"
  ],
  "KLF1": [
    "KLF1 CNV",
    "KLF1 RNA"
  ],
  "DPP8": [
    "DPP8 CNV",
    "DPP8 RNA",
    "DPP8 Proteo"
  ],
  "RHOV": [
    "RHOV CNV",
    "RHOV RNA"
  ],
  "FILIP1L": [
    "FILIP1L CNV",
    "FILIP1L RNA",
    "FILIP1L Proteo"
  ],
  "OR5S1P": [
    "OR5S1P CNV",
    "OR5S1P RNA"
  ],
  "SLC46A2": [
    "SLC46A2 CNV",
    "SLC46A2 RNA"
  ],
  "CABYRP1": [
    "CABYRP1 CNV",
    "CABYRP1 RNA"
  ],
  "DKK1": [
    "DKK1 CNV",
    "DKK1 RNA"
  ],
  "TENT2": [
    "TENT2 CNV",
    "TENT2 RNA",
    "TENT2 Proteo"
  ],
  "OR8B2": [
    "OR8B2 CNV",
    "OR8B2 RNA"
  ],
  "OR51A4": [
    "OR51A4 CNV",
    "OR51A4 RNA"
  ],
  "HLA-DQB2": [
    "HLA-DQB2 CNV",
    "HLA-DQB2 RNA",
    "HLA-DQB2 Proteo"
  ],
  "SCGB1D5P": [
    "SCGB1D5P CNV",
    "SCGB1D5P RNA"
  ],
  "UFSP2": [
    "UFSP2 CNV",
    "UFSP2 RNA",
    "UFSP2 Proteo"
  ],
  "CGB5": [
    "CGB5 CNV",
    "CGB5 RNA"
  ],
  "LHFPL1": [
    "LHFPL1 CNV",
    "LHFPL1 RNA"
  ],
  "RPL18": [
    "RPL18 CNV",
    "RPL18 RNA",
    "RPL18 Proteo"
  ],
  "PFKM": [
    "PFKM CNV",
    "PFKM RNA",
    "PFKM Proteo"
  ],
  "B3GALT4": [
    "B3GALT4 CNV",
    "B3GALT4 RNA"
  ],
  "AKAP7": [
    "AKAP7 CNV",
    "AKAP7 RNA",
    "AKAP7 Proteo"
  ],
  "ZNRD2": [
    "ZNRD2 CNV",
    "ZNRD2 RNA",
    "ZNRD2 Proteo"
  ],
  "MTCO3P18": [
    "MTCO3P18 CNV",
    "MTCO3P18 RNA"
  ],
  "TUFT1": [
    "TUFT1 CNV",
    "TUFT1 RNA",
    "TUFT1 Proteo"
  ],
  "LIPT1P1": [
    "LIPT1P1 CNV",
    "LIPT1P1 RNA"
  ],
  "DDX43": [
    "DDX43 CNV",
    "DDX43 RNA",
    "DDX43 Proteo"
  ],
  "KRT89P": [
    "KRT89P CNV",
    "KRT89P RNA"
  ],
  "EPHX4": [
    "EPHX4 CNV",
    "EPHX4 RNA",
    "EPHX4 Proteo"
  ],
  "RPS6": [
    "RPS6 CNV",
    "RPS6 RNA",
    "RPS6 Proteo"
  ],
  "TSHB": [
    "TSHB CNV",
    "TSHB RNA"
  ],
  "EFL1": [
    "EFL1 CNV",
    "EFL1 RNA",
    "EFL1 Proteo"
  ],
  "PMS2P2": [
    "PMS2P2 CNV",
    "PMS2P2 RNA"
  ],
  "CRB3P1": [
    "CRB3P1 CNV",
    "CRB3P1 RNA"
  ],
  "SPICE1": [
    "SPICE1 CNV",
    "SPICE1 RNA",
    "SPICE1 Proteo"
  ],
  "OR5D13": [
    "OR5D13 CNV",
    "OR5D13 RNA"
  ],
  "COX6CP16": [
    "COX6CP16 CNV",
    "COX6CP16 RNA"
  ],
  "ZFP91": [
    "ZFP91 CNV",
    "ZFP91 RNA",
    "ZFP91 Proteo"
  ],
  "RPL7AP13": [
    "RPL7AP13 CNV",
    "RPL7AP13 RNA"
  ],
  "ITGAL": [
    "ITGAL CNV",
    "ITGAL RNA",
    "ITGAL Proteo"
  ],
  "PPM1B": [
    "PPM1B CNV",
    "PPM1B RNA",
    "PPM1B Proteo"
  ],
  "CCDC105": [
    "CCDC105 CNV",
    "CCDC105 RNA"
  ],
  "RNFT1P3": [
    "RNFT1P3 CNV",
    "RNFT1P3 RNA"
  ],
  "RNASE6": [
    "RNASE6 CNV",
    "RNASE6 RNA",
    "RNASE6 Proteo"
  ],
  "TARBP2": [
    "TARBP2 CNV",
    "TARBP2 RNA",
    "TARBP2 Proteo"
  ],
  "HSPA8P9": [
    "HSPA8P9 CNV",
    "HSPA8P9 RNA"
  ],
  "LCMT1": [
    "LCMT1 CNV",
    "LCMT1 RNA",
    "LCMT1 Proteo"
  ],
  "XRN1": [
    "XRN1 CNV",
    "XRN1 RNA",
    "XRN1 Proteo"
  ],
  "FAM83C": [
    "FAM83C CNV",
    "FAM83C RNA",
    "FAM83C Proteo"
  ],
  "SLC30A1": [
    "SLC30A1 CNV",
    "SLC30A1 RNA",
    "SLC30A1 Proteo"
  ],
  "SGIP1": [
    "SGIP1 CNV",
    "SGIP1 RNA"
  ],
  "UBE2V1P12": [
    "UBE2V1P12 CNV",
    "UBE2V1P12 RNA"
  ],
  "SHE": [
    "SHE CNV",
    "SHE RNA"
  ],
  "HK2P1": [
    "HK2P1 CNV",
    "HK2P1 RNA"
  ],
  "ADAMTS3": [
    "ADAMTS3 CNV",
    "ADAMTS3 RNA"
  ],
  "STK17B": [
    "STK17B CNV",
    "STK17B RNA",
    "STK17B Proteo"
  ],
  "LAMTOR2": [
    "LAMTOR2 CNV",
    "LAMTOR2 RNA",
    "LAMTOR2 Proteo"
  ],
  "TRERF1": [
    "TRERF1 CNV",
    "TRERF1 RNA",
    "TRERF1 Proteo"
  ],
  "PCED1A": [
    "PCED1A CNV",
    "PCED1A RNA"
  ],
  "RPS27P5": [
    "RPS27P5 CNV",
    "RPS27P5 RNA"
  ],
  "HIGD1AP2": [
    "HIGD1AP2 CNV",
    "HIGD1AP2 RNA"
  ],
  "RPL17P50": [
    "RPL17P50 CNV",
    "RPL17P50 RNA"
  ],
  "TMEM254": [
    "TMEM254 CNV",
    "TMEM254 RNA",
    "TMEM254 Proteo"
  ],
  "CHL1": [
    "CHL1 CNV",
    "CHL1 RNA",
    "CHL1 Proteo"
  ],
  "PPP2R5B": [
    "PPP2R5B CNV",
    "PPP2R5B RNA",
    "PPP2R5B Proteo"
  ],
  "RPL12P46": [
    "RPL12P46 CNV",
    "RPL12P46 RNA"
  ],
  "BMPR2": [
    "BMPR2 CNV",
    "BMPR2 RNA",
    "BMPR2 Proteo"
  ],
  "MYT1": [
    "MYT1 CNV",
    "MYT1 RNA"
  ],
  "EAF2": [
    "EAF2 CNV",
    "EAF2 RNA",
    "EAF2 Proteo"
  ],
  "GSTA10P": [
    "GSTA10P CNV",
    "GSTA10P RNA"
  ],
  "RBM8B": [
    "RBM8B CNV",
    "RBM8B RNA"
  ],
  "CYP2E1": [
    "CYP2E1 CNV",
    "CYP2E1 RNA"
  ],
  "KLK14": [
    "KLK14 CNV",
    "KLK14 RNA"
  ],
  "SPEF1": [
    "SPEF1 CNV",
    "SPEF1 RNA"
  ],
  "SHOX2": [
    "SHOX2 CNV",
    "SHOX2 RNA"
  ],
  "PPP3CA": [
    "PPP3CA CNV",
    "PPP3CA RNA",
    "PPP3CA Proteo"
  ],
  "NAIF1": [
    "NAIF1 CNV",
    "NAIF1 RNA",
    "NAIF1 Proteo"
  ],
  "CD80": [
    "CD80 CNV",
    "CD80 RNA"
  ],
  "CDHR5": [
    "CDHR5 CNV",
    "CDHR5 RNA"
  ],
  "IGLV3-17": [
    "IGLV3-17 CNV",
    "IGLV3-17 RNA"
  ],
  "RFESDP1": [
    "RFESDP1 CNV",
    "RFESDP1 RNA"
  ],
  "ANKRD60": [
    "ANKRD60 CNV",
    "ANKRD60 RNA"
  ],
  "COPS9": [
    "COPS9 CNV",
    "COPS9 RNA",
    "COPS9 Proteo"
  ],
  "TCP11": [
    "TCP11 CNV",
    "TCP11 RNA"
  ],
  "ACTR3P2": [
    "ACTR3P2 CNV",
    "ACTR3P2 RNA"
  ],
  "FRYL": [
    "FRYL CNV",
    "FRYL RNA",
    "FRYL Proteo"
  ],
  "MEIS3": [
    "MEIS3 CNV",
    "MEIS3 RNA"
  ],
  "PDE1B": [
    "PDE1B CNV",
    "PDE1B RNA",
    "PDE1B Proteo"
  ],
  "TMEM217B": [
    "TMEM217B CNV",
    "TMEM217B RNA"
  ],
  "SRGAP3": [
    "SRGAP3 CNV",
    "SRGAP3 RNA",
    "SRGAP3 Proteo"
  ],
  "RPL7AP61": [
    "RPL7AP61 CNV",
    "RPL7AP61 RNA"
  ],
  "FRG2FP": [
    "FRG2FP CNV",
    "FRG2FP RNA"
  ],
  "FOXL1": [
    "FOXL1 CNV",
    "FOXL1 RNA"
  ],
  "ULBP1": [
    "ULBP1 CNV",
    "ULBP1 RNA"
  ],
  "TRIM51G": [
    "TRIM51G CNV",
    "TRIM51G RNA"
  ],
  "RIMKLBP1": [
    "RIMKLBP1 CNV",
    "RIMKLBP1 RNA"
  ],
  "TECPR2": [
    "TECPR2 CNV",
    "TECPR2 RNA",
    "TECPR2 Proteo"
  ],
  "ETDC": [
    "ETDC CNV",
    "ETDC RNA"
  ],
  "KLHDC8A": [
    "KLHDC8A CNV",
    "KLHDC8A RNA"
  ],
  "ALDH1A3": [
    "ALDH1A3 CNV",
    "ALDH1A3 RNA",
    "ALDH1A3 Proteo"
  ],
  "ESRP2": [
    "ESRP2 CNV",
    "ESRP2 RNA",
    "ESRP2 Proteo"
  ],
  "RPL12P48": [
    "RPL12P48 CNV",
    "RPL12P48 RNA"
  ],
  "SVIL2P": [
    "SVIL2P CNV",
    "SVIL2P RNA"
  ],
  "ATP11B": [
    "ATP11B CNV",
    "ATP11B RNA",
    "ATP11B Proteo"
  ],
  "GNG13": [
    "GNG13 CNV",
    "GNG13 RNA"
  ],
  "TAS2R19": [
    "TAS2R19 CNV",
    "TAS2R19 RNA"
  ],
  "RPL34": [
    "RPL34 CNV",
    "RPL34 RNA",
    "RPL34 Proteo"
  ],
  "ZNF385B": [
    "ZNF385B CNV",
    "ZNF385B RNA"
  ],
  "MED14P1": [
    "MED14P1 CNV",
    "MED14P1 RNA"
  ],
  "RBMY1F": [
    "RBMY1F CNV",
    "RBMY1F RNA"
  ],
  "SLC26A5": [
    "SLC26A5 CNV",
    "SLC26A5 RNA"
  ],
  "ZNF613": [
    "ZNF613 CNV",
    "ZNF613 RNA",
    "ZNF613 Proteo"
  ],
  "FOXE1": [
    "FOXE1 CNV",
    "FOXE1 RNA"
  ],
  "PPIAP32": [
    "PPIAP32 CNV",
    "PPIAP32 RNA"
  ],
  "B4GALT6": [
    "B4GALT6 CNV",
    "B4GALT6 RNA",
    "B4GALT6 Proteo"
  ],
  "AURKBP1": [
    "AURKBP1 CNV",
    "AURKBP1 RNA"
  ],
  "HMGB1P46": [
    "HMGB1P46 CNV",
    "HMGB1P46 RNA"
  ],
  "GAMTP2": [
    "GAMTP2 CNV",
    "GAMTP2 RNA"
  ],
  "NCALD": [
    "NCALD CNV",
    "NCALD RNA",
    "NCALD Proteo"
  ],
  "NBPF9": [
    "NBPF9 CNV",
    "NBPF9 RNA"
  ],
  "GXYLT1P1": [
    "GXYLT1P1 CNV",
    "GXYLT1P1 RNA"
  ],
  "ZNF367": [
    "ZNF367 CNV",
    "ZNF367 RNA"
  ],
  "DDX11L2": [
    "DDX11L2 CNV",
    "DDX11L2 RNA"
  ],
  "SRRM1P2": [
    "SRRM1P2 CNV",
    "SRRM1P2 RNA"
  ],
  "PCDHGB3": [
    "PCDHGB3 CNV",
    "PCDHGB3 RNA"
  ],
  "ZACNP1": [
    "ZACNP1 CNV",
    "ZACNP1 RNA"
  ],
  "RAP1B": [
    "RAP1B CNV",
    "RAP1B RNA",
    "RAP1B Proteo"
  ],
  "GCSH": [
    "GCSH CNV",
    "GCSH RNA",
    "GCSH Proteo"
  ],
  "IL2RB": [
    "IL2RB CNV",
    "IL2RB RNA",
    "IL2RB Proteo"
  ],
  "DUX4L7": [
    "DUX4L7 CNV",
    "DUX4L7 RNA"
  ],
  "GRP": [
    "GRP CNV",
    "GRP RNA"
  ],
  "REEP2": [
    "REEP2 CNV",
    "REEP2 RNA"
  ],
  "FZD2": [
    "FZD2 CNV",
    "FZD2 RNA"
  ],
  "CLDN4": [
    "CLDN4 CNV",
    "CLDN4 RNA"
  ],
  "GSC2": [
    "GSC2 CNV",
    "GSC2 RNA"
  ],
  "REEP4": [
    "REEP4 CNV",
    "REEP4 RNA",
    "REEP4 Proteo"
  ],
  "CAPZA2": [
    "CAPZA2 CNV",
    "CAPZA2 RNA",
    "CAPZA2 Proteo"
  ],
  "MRPL21": [
    "MRPL21 CNV",
    "MRPL21 RNA",
    "MRPL21 Proteo"
  ],
  "TOMM22P5": [
    "TOMM22P5 CNV",
    "TOMM22P5 RNA"
  ],
  "ZC3H4": [
    "ZC3H4 CNV",
    "ZC3H4 RNA",
    "ZC3H4 Proteo"
  ],
  "VN1R83P": [
    "VN1R83P CNV",
    "VN1R83P RNA"
  ],
  "SCAMP1": [
    "SCAMP1 CNV",
    "SCAMP1 RNA",
    "SCAMP1 Proteo"
  ],
  "IQGAP3": [
    "IQGAP3 CNV",
    "IQGAP3 RNA",
    "IQGAP3 Proteo"
  ],
  "MTATP6P14": [
    "MTATP6P14 CNV",
    "MTATP6P14 RNA"
  ],
  "FBXO28": [
    "FBXO28 CNV",
    "FBXO28 RNA",
    "FBXO28 Proteo"
  ],
  "PABPC1P11": [
    "PABPC1P11 CNV",
    "PABPC1P11 RNA"
  ],
  "CXorf66": [
    "CXorf66 CNV",
    "CXorf66 RNA"
  ],
  "BCAP31": [
    "BCAP31 CNV",
    "BCAP31 RNA",
    "BCAP31 Proteo"
  ],
  "ZYX": [
    "ZYX CNV",
    "ZYX RNA",
    "ZYX Proteo"
  ],
  "MANEAL": [
    "MANEAL CNV",
    "MANEAL RNA",
    "MANEAL Proteo"
  ],
  "COPS8": [
    "COPS8 CNV",
    "COPS8 RNA",
    "COPS8 Proteo"
  ],
  "RGPD2": [
    "RGPD2 CNV",
    "RGPD2 RNA"
  ],
  "KNG1": [
    "KNG1 CNV",
    "KNG1 RNA",
    "KNG1 Proteo"
  ],
  "PPP2R3A": [
    "PPP2R3A CNV",
    "PPP2R3A RNA",
    "PPP2R3A Proteo"
  ],
  "KRTAP1-4": [
    "KRTAP1-4 CNV",
    "KRTAP1-4 RNA"
  ],
  "ARMH4": [
    "ARMH4 CNV",
    "ARMH4 RNA"
  ],
  "DUTP5": [
    "DUTP5 CNV",
    "DUTP5 RNA"
  ],
  "PARVA": [
    "PARVA CNV",
    "PARVA RNA",
    "PARVA Proteo"
  ],
  "CCDC93": [
    "CCDC93 CNV",
    "CCDC93 RNA",
    "CCDC93 Proteo"
  ],
  "LRRC37BP1": [
    "LRRC37BP1 CNV",
    "LRRC37BP1 RNA"
  ],
  "C8orf82": [
    "C8orf82 CNV",
    "C8orf82 RNA",
    "C8orf82 Proteo"
  ],
  "UFM1P1": [
    "UFM1P1 CNV",
    "UFM1P1 RNA"
  ],
  "GEMIN8P4": [
    "GEMIN8P4 CNV",
    "GEMIN8P4 RNA"
  ],
  "GIPC3": [
    "GIPC3 CNV",
    "GIPC3 RNA",
    "GIPC3 Proteo"
  ],
  "PKN1": [
    "PKN1 CNV",
    "PKN1 RNA",
    "PKN1 Proteo"
  ],
  "FRAT1": [
    "FRAT1 CNV",
    "FRAT1 RNA"
  ],
  "TP53I3": [
    "TP53I3 CNV",
    "TP53I3 RNA",
    "TP53I3 Proteo"
  ],
  "INSL5": [
    "INSL5 CNV",
    "INSL5 RNA"
  ],
  "CASS4": [
    "CASS4 CNV",
    "CASS4 RNA",
    "CASS4 Proteo"
  ],
  "NSD2": [
    "NSD2 CNV",
    "NSD2 RNA",
    "NSD2 Proteo"
  ],
  "LCE6A": [
    "LCE6A CNV",
    "LCE6A RNA"
  ],
  "HLA-DRA": [
    "HLA-DRA CNV",
    "HLA-DRA RNA",
    "HLA-DRA Proteo"
  ],
  "SKIV2L": [
    "SKIV2L CNV",
    "SKIV2L RNA",
    "SKIV2L Proteo"
  ],
  "FIGLA": [
    "FIGLA CNV",
    "FIGLA RNA"
  ],
  "AADAT": [
    "AADAT CNV",
    "AADAT RNA",
    "AADAT Proteo"
  ],
  "MAF": [
    "MAF CNV",
    "MAF RNA",
    "MAF Proteo"
  ],
  "OR2T35": [
    "OR2T35 CNV",
    "OR2T35 RNA"
  ],
  "PLAAT4": [
    "PLAAT4 CNV",
    "PLAAT4 RNA"
  ],
  "TENT4B": [
    "TENT4B CNV",
    "TENT4B RNA",
    "TENT4B Proteo"
  ],
  "NOTCH2P1": [
    "NOTCH2P1 CNV",
    "NOTCH2P1 RNA"
  ],
  "RGS1": [
    "RGS1 CNV",
    "RGS1 RNA",
    "RGS1 Proteo"
  ],
  "ADH1A": [
    "ADH1A CNV",
    "ADH1A RNA",
    "ADH1A Proteo"
  ],
  "SIAH1": [
    "SIAH1 CNV",
    "SIAH1 RNA",
    "SIAH1 Proteo"
  ],
  "RPS26P24": [
    "RPS26P24 CNV",
    "RPS26P24 RNA"
  ],
  "PPP2R2D": [
    "PPP2R2D CNV",
    "PPP2R2D RNA",
    "PPP2R2D Proteo"
  ],
  "TXNDC8": [
    "TXNDC8 CNV",
    "TXNDC8 RNA"
  ],
  "UBE2SP1": [
    "UBE2SP1 CNV",
    "UBE2SP1 RNA"
  ],
  "MMP8": [
    "MMP8 CNV",
    "MMP8 RNA",
    "MMP8 Proteo"
  ],
  "BECN2": [
    "BECN2 CNV",
    "BECN2 RNA"
  ],
  "ZNF296": [
    "ZNF296 CNV",
    "ZNF296 RNA",
    "ZNF296 Proteo"
  ],
  "ZBED6": [
    "ZBED6 CNV",
    "ZBED6 RNA",
    "ZBED6 Proteo"
  ],
  "SMARCE1P3": [
    "SMARCE1P3 CNV",
    "SMARCE1P3 RNA"
  ],
  "BEND7P1": [
    "BEND7P1 CNV",
    "BEND7P1 RNA"
  ],
  "AOC4P": [
    "AOC4P CNV",
    "AOC4P RNA"
  ],
  "PFN1P4": [
    "PFN1P4 CNV",
    "PFN1P4 RNA"
  ],
  "RDM1P5": [
    "RDM1P5 CNV",
    "RDM1P5 RNA"
  ],
  "NPM3": [
    "NPM3 CNV",
    "NPM3 RNA",
    "NPM3 Proteo"
  ],
  "TUBAP14": [
    "TUBAP14 CNV",
    "TUBAP14 RNA"
  ],
  "ANKRD36BP1": [
    "ANKRD36BP1 CNV",
    "ANKRD36BP1 RNA"
  ],
  "FOXM1": [
    "FOXM1 CNV",
    "FOXM1 RNA",
    "FOXM1 Proteo"
  ],
  "RPL21P71": [
    "RPL21P71 CNV",
    "RPL21P71 RNA"
  ],
  "RNA5SP401": [
    "RNA5SP401 CNV",
    "RNA5SP401 RNA"
  ],
  "OR7G3": [
    "OR7G3 CNV",
    "OR7G3 RNA"
  ],
  "UBL5": [
    "UBL5 CNV",
    "UBL5 RNA",
    "UBL5 Proteo"
  ],
  "PARP6": [
    "PARP6 CNV",
    "PARP6 RNA"
  ],
  "ZBTB4": [
    "ZBTB4 CNV",
    "ZBTB4 RNA",
    "ZBTB4 Proteo"
  ],
  "UGT2B4": [
    "UGT2B4 CNV",
    "UGT2B4 RNA"
  ],
  "RABL2B": [
    "RABL2B CNV",
    "RABL2B RNA",
    "RABL2B Proteo"
  ],
  "BNIP3P42": [
    "BNIP3P42 CNV",
    "BNIP3P42 RNA"
  ],
  "PBOV1": [
    "PBOV1 CNV",
    "PBOV1 RNA"
  ],
  "B3GALT2": [
    "B3GALT2 CNV",
    "B3GALT2 RNA"
  ],
  "SLC10A6": [
    "SLC10A6 CNV",
    "SLC10A6 RNA"
  ],
  "FEM1AP2": [
    "FEM1AP2 CNV",
    "FEM1AP2 RNA"
  ],
  "GK": [
    "GK CNV",
    "GK RNA",
    "GK Proteo"
  ],
  "MAP3K11": [
    "MAP3K11 CNV",
    "MAP3K11 RNA",
    "MAP3K11 Proteo"
  ],
  "LIMD1": [
    "LIMD1 CNV",
    "LIMD1 RNA",
    "LIMD1 Proteo"
  ],
  "PDX1": [
    "PDX1 CNV",
    "PDX1 RNA"
  ],
  "FAM72A": [
    "FAM72A CNV",
    "FAM72A RNA"
  ],
  "CNIH1": [
    "CNIH1 CNV",
    "CNIH1 RNA"
  ],
  "CAPN8": [
    "CAPN8 CNV",
    "CAPN8 RNA"
  ],
  "CIDEB": [
    "CIDEB CNV",
    "CIDEB RNA"
  ],
  "AGGF1P6": [
    "AGGF1P6 CNV",
    "AGGF1P6 RNA"
  ],
  "EPHA10": [
    "EPHA10 CNV",
    "EPHA10 RNA"
  ],
  "EIF3LP1": [
    "EIF3LP1 CNV",
    "EIF3LP1 RNA"
  ],
  "HRURF": [
    "HRURF CNV",
    "HRURF RNA"
  ],
  "STSP1": [
    "STSP1 CNV",
    "STSP1 RNA"
  ],
  "RPS3AP53": [
    "RPS3AP53 CNV",
    "RPS3AP53 RNA"
  ],
  "MPO": [
    "MPO CNV",
    "MPO RNA",
    "MPO Proteo"
  ],
  "DOCK5": [
    "DOCK5 CNV",
    "DOCK5 RNA",
    "DOCK5 Proteo"
  ],
  "MTCP1": [
    "MTCP1 CNV",
    "MTCP1 RNA"
  ],
  "CLCC1": [
    "CLCC1 CNV",
    "CLCC1 RNA",
    "CLCC1 Proteo"
  ],
  "ACNATP": [
    "ACNATP CNV",
    "ACNATP RNA"
  ],
  "RPS3AP1": [
    "RPS3AP1 CNV",
    "RPS3AP1 RNA"
  ],
  "OSTF1": [
    "OSTF1 CNV",
    "OSTF1 RNA",
    "OSTF1 Proteo"
  ],
  "TADA3": [
    "TADA3 CNV",
    "TADA3 RNA",
    "TADA3 Proteo"
  ],
  "RPL12P17": [
    "RPL12P17 CNV",
    "RPL12P17 RNA"
  ],
  "TAF7L": [
    "TAF7L CNV",
    "TAF7L RNA"
  ],
  "IFNGR2": [
    "IFNGR2 CNV",
    "IFNGR2 RNA"
  ],
  "CEP135": [
    "CEP135 CNV",
    "CEP135 RNA",
    "CEP135 Proteo"
  ],
  "CTBP2": [
    "CTBP2 CNV",
    "CTBP2 RNA",
    "CTBP2 Proteo"
  ],
  "ISOC1": [
    "ISOC1 CNV",
    "ISOC1 RNA",
    "ISOC1 Proteo"
  ],
  "MC4R": [
    "MC4R CNV",
    "MC4R RNA"
  ],
  "FSCN3": [
    "FSCN3 CNV",
    "FSCN3 RNA"
  ],
  "C1GALT1P2": [
    "C1GALT1P2 CNV",
    "C1GALT1P2 RNA"
  ],
  "VEZF1P1": [
    "VEZF1P1 CNV",
    "VEZF1P1 RNA"
  ],
  "KREMEN1": [
    "KREMEN1 CNV",
    "KREMEN1 RNA"
  ],
  "RLIMP2": [
    "RLIMP2 CNV",
    "RLIMP2 RNA"
  ],
  "NUDT19": [
    "NUDT19 CNV",
    "NUDT19 RNA",
    "NUDT19 Proteo"
  ],
  "SUPT16HP1": [
    "SUPT16HP1 CNV",
    "SUPT16HP1 RNA"
  ],
  "GAS2L1": [
    "GAS2L1 CNV",
    "GAS2L1 RNA",
    "GAS2L1 Proteo"
  ],
  "PNRC1": [
    "PNRC1 CNV",
    "PNRC1 RNA",
    "PNRC1 Proteo"
  ],
  "OR2T3": [
    "OR2T3 CNV",
    "OR2T3 RNA"
  ],
  "CCDC81": [
    "CCDC81 CNV",
    "CCDC81 RNA"
  ],
  "LRSAM1": [
    "LRSAM1 CNV",
    "LRSAM1 RNA",
    "LRSAM1 Proteo"
  ],
  "TRIM25": [
    "TRIM25 CNV",
    "TRIM25 RNA",
    "TRIM25 Proteo"
  ],
  "TRIM6-TRIM34": [
    "TRIM6-TRIM34 Proteo"
  ],
  "PFDN5": [
    "PFDN5 CNV",
    "PFDN5 RNA",
    "PFDN5 Proteo"
  ],
  "SF3A2": [
    "SF3A2 CNV",
    "SF3A2 RNA",
    "SF3A2 Proteo"
  ],
  "ACCS": [
    "ACCS CNV",
    "ACCS RNA",
    "ACCS Proteo"
  ],
  "FBRSL1": [
    "FBRSL1 CNV",
    "FBRSL1 RNA",
    "FBRSL1 Proteo"
  ],
  "SMIM44": [
    "SMIM44 CNV",
    "SMIM44 RNA"
  ],
  "FAM47B": [
    "FAM47B CNV",
    "FAM47B RNA"
  ],
  "SLC5A4P1": [
    "SLC5A4P1 CNV",
    "SLC5A4P1 RNA"
  ],
  "PPP1R3D": [
    "PPP1R3D CNV",
    "PPP1R3D RNA",
    "PPP1R3D Proteo"
  ],
  "PNKD": [
    "PNKD CNV",
    "PNKD RNA",
    "PNKD Proteo"
  ],
  "CEP76": [
    "CEP76 CNV",
    "CEP76 RNA",
    "CEP76 Proteo"
  ],
  "SDHB": [
    "SDHB CNV",
    "SDHB RNA",
    "SDHB Proteo"
  ],
  "ZBED1": [
    "ZBED1 CNV",
    "ZBED1 RNA",
    "ZBED1 Proteo"
  ],
  "EPB42": [
    "EPB42 CNV",
    "EPB42 RNA",
    "EPB42 Proteo"
  ],
  "XPNPEP1": [
    "XPNPEP1 CNV",
    "XPNPEP1 RNA",
    "XPNPEP1 Proteo"
  ],
  "DDX46": [
    "DDX46 CNV",
    "DDX46 RNA",
    "DDX46 Proteo"
  ],
  "MTND6P15": [
    "MTND6P15 CNV",
    "MTND6P15 RNA"
  ],
  "ABLIM1": [
    "ABLIM1 CNV",
    "ABLIM1 RNA",
    "ABLIM1 Proteo"
  ],
  "TOMM40": [
    "TOMM40 CNV",
    "TOMM40 RNA",
    "TOMM40 Proteo"
  ],
  "APEX2": [
    "APEX2 CNV",
    "APEX2 RNA",
    "APEX2 Proteo"
  ],
  "TSPY12P": [
    "TSPY12P CNV",
    "TSPY12P RNA"
  ],
  "BRD9": [
    "BRD9 CNV",
    "BRD9 RNA",
    "BRD9 Proteo"
  ],
  "NBPF4": [
    "NBPF4 CNV",
    "NBPF4 RNA"
  ],
  "LGALS2": [
    "LGALS2 CNV",
    "LGALS2 RNA",
    "LGALS2 Proteo"
  ],
  "RPL32P28": [
    "RPL32P28 CNV",
    "RPL32P28 RNA"
  ],
  "ADGRA3": [
    "ADGRA3 CNV",
    "ADGRA3 RNA",
    "ADGRA3 Proteo"
  ],
  "LINC00680": [
    "LINC00680 CNV",
    "LINC00680 RNA"
  ],
  "MECP2": [
    "MECP2 CNV",
    "MECP2 RNA",
    "MECP2 Proteo"
  ],
  "UBE2U": [
    "UBE2U CNV",
    "UBE2U RNA"
  ],
  "ZCCHC8": [
    "ZCCHC8 CNV",
    "ZCCHC8 RNA",
    "ZCCHC8 Proteo"
  ],
  "GID8": [
    "GID8 CNV",
    "GID8 RNA",
    "GID8 Proteo"
  ],
  "TUSC2P2": [
    "TUSC2P2 CNV",
    "TUSC2P2 RNA"
  ],
  "ZNF707": [
    "ZNF707 CNV",
    "ZNF707 RNA"
  ],
  "PIGR": [
    "PIGR CNV",
    "PIGR RNA",
    "PIGR Proteo"
  ],
  "WEE1": [
    "WEE1 CNV",
    "WEE1 RNA",
    "WEE1 Proteo"
  ],
  "FFAR4": [
    "FFAR4 CNV",
    "FFAR4 RNA"
  ],
  "LINC01085": [
    "LINC01085 CNV",
    "LINC01085 RNA"
  ],
  "SALL3": [
    "SALL3 CNV",
    "SALL3 RNA"
  ],
  "EML1": [
    "EML1 CNV",
    "EML1 RNA",
    "EML1 Proteo"
  ],
  "AKR1B1P5": [
    "AKR1B1P5 CNV",
    "AKR1B1P5 RNA"
  ],
  "DOCK1": [
    "DOCK1 CNV",
    "DOCK1 RNA",
    "DOCK1 Proteo"
  ],
  "ITPR3": [
    "ITPR3 CNV",
    "ITPR3 RNA",
    "ITPR3 Proteo"
  ],
  "RPL34P34": [
    "RPL34P34 CNV",
    "RPL34P34 RNA"
  ],
  "ACTG1P22": [
    "ACTG1P22 CNV",
    "ACTG1P22 RNA"
  ],
  "PIK3C2G": [
    "PIK3C2G CNV",
    "PIK3C2G RNA"
  ],
  "LTA": [
    "LTA CNV",
    "LTA RNA"
  ],
  "RNA5SP94": [
    "RNA5SP94 CNV",
    "RNA5SP94 RNA"
  ],
  "RHBDD2": [
    "RHBDD2 CNV",
    "RHBDD2 RNA",
    "RHBDD2 Proteo"
  ],
  "PABPC5": [
    "PABPC5 CNV",
    "PABPC5 RNA",
    "PABPC5 Proteo"
  ],
  "SLFN11": [
    "SLFN11 CNV",
    "SLFN11 RNA",
    "SLFN11 Proteo"
  ],
  "IL1RAP": [
    "IL1RAP CNV",
    "IL1RAP RNA",
    "IL1RAP Proteo"
  ],
  "COX11": [
    "COX11 CNV",
    "COX11 RNA",
    "COX11 Proteo"
  ],
  "PDK2": [
    "PDK2 CNV",
    "PDK2 RNA",
    "PDK2 Proteo"
  ],
  "TYRL": [
    "TYRL CNV",
    "TYRL RNA"
  ],
  "IGHV5-78": [
    "IGHV5-78 CNV",
    "IGHV5-78 RNA"
  ],
  "TRIM31": [
    "TRIM31 CNV",
    "TRIM31 RNA"
  ],
  "TCEA1P3": [
    "TCEA1P3 CNV",
    "TCEA1P3 RNA"
  ],
  "FAM78B": [
    "FAM78B CNV",
    "FAM78B RNA"
  ],
  "TUBB4AP1": [
    "TUBB4AP1 CNV",
    "TUBB4AP1 RNA"
  ],
  "RBM10": [
    "RBM10 CNV",
    "RBM10 RNA",
    "RBM10 Proteo"
  ],
  "RAB9AP4": [
    "RAB9AP4 CNV",
    "RAB9AP4 RNA"
  ],
  "PRDX1P1": [
    "PRDX1P1 CNV",
    "PRDX1P1 RNA"
  ],
  "OR3A4P": [
    "OR3A4P CNV",
    "OR3A4P RNA"
  ],
  "USP12PX": [
    "USP12PX CNV",
    "USP12PX RNA"
  ],
  "VN1R2": [
    "VN1R2 CNV",
    "VN1R2 RNA"
  ],
  "ZNF860": [
    "ZNF860 CNV",
    "ZNF860 RNA"
  ],
  "ATF7": [
    "ATF7 CNV",
    "ATF7 RNA",
    "ATF7 Proteo"
  ],
  "NPM1P39": [
    "NPM1P39 CNV",
    "NPM1P39 RNA"
  ],
  "PDXDC1": [
    "PDXDC1 CNV",
    "PDXDC1 RNA",
    "PDXDC1 Proteo"
  ],
  "DND1P1": [
    "DND1P1 CNV",
    "DND1P1 RNA"
  ],
  "TTLL9": [
    "TTLL9 CNV",
    "TTLL9 RNA"
  ],
  "AP2S1": [
    "AP2S1 CNV",
    "AP2S1 RNA",
    "AP2S1 Proteo"
  ],
  "RPL36AP52": [
    "RPL36AP52 CNV",
    "RPL36AP52 RNA"
  ],
  "FAM90A10": [
    "FAM90A10 CNV",
    "FAM90A10 RNA"
  ],
  "SPDYE6": [
    "SPDYE6 CNV",
    "SPDYE6 RNA"
  ],
  "PIK3R5": [
    "PIK3R5 CNV",
    "PIK3R5 RNA",
    "PIK3R5 Proteo"
  ],
  "MTHFD2P1": [
    "MTHFD2P1 CNV",
    "MTHFD2P1 RNA"
  ],
  "CXCR2P1": [
    "CXCR2P1 CNV",
    "CXCR2P1 RNA"
  ],
  "SDAD1": [
    "SDAD1 CNV",
    "SDAD1 RNA",
    "SDAD1 Proteo"
  ],
  "OR2N1P": [
    "OR2N1P CNV",
    "OR2N1P RNA"
  ],
  "PPY": [
    "PPY CNV",
    "PPY RNA"
  ],
  "PAGE3": [
    "PAGE3 CNV",
    "PAGE3 RNA"
  ],
  "ADSS1": [
    "ADSS1 CNV",
    "ADSS1 RNA",
    "ADSS1 Proteo"
  ],
  "APOOP1": [
    "APOOP1 CNV",
    "APOOP1 RNA"
  ],
  "ACO1": [
    "ACO1 CNV",
    "ACO1 RNA",
    "ACO1 Proteo"
  ],
  "KCTD9": [
    "KCTD9 CNV",
    "KCTD9 RNA",
    "KCTD9 Proteo"
  ],
  "SMURF2": [
    "SMURF2 CNV",
    "SMURF2 RNA",
    "SMURF2 Proteo"
  ],
  "OR5A2": [
    "OR5A2 CNV",
    "OR5A2 RNA"
  ],
  "NF1P11": [
    "NF1P11 CNV",
    "NF1P11 RNA"
  ],
  "CELSR3": [
    "CELSR3 CNV",
    "CELSR3 RNA"
  ],
  "OLFML2B": [
    "OLFML2B CNV",
    "OLFML2B RNA",
    "OLFML2B Proteo"
  ],
  "EFL1P2": [
    "EFL1P2 CNV",
    "EFL1P2 RNA"
  ],
  "POLR2J2": [
    "POLR2J2 CNV",
    "POLR2J2 RNA"
  ],
  "GPR62": [
    "GPR62 CNV",
    "GPR62 RNA"
  ],
  "MRPS21P6": [
    "MRPS21P6 CNV",
    "MRPS21P6 RNA"
  ],
  "C6orf52": [
    "C6orf52 CNV",
    "C6orf52 RNA"
  ],
  "AKAP8L": [
    "AKAP8L CNV",
    "AKAP8L RNA",
    "AKAP8L Proteo"
  ],
  "LIN54": [
    "LIN54 CNV",
    "LIN54 RNA",
    "LIN54 Proteo"
  ],
  "SNURFL": [
    "SNURFL CNV",
    "SNURFL RNA"
  ],
  "HLA-DPB1": [
    "HLA-DPB1 CNV",
    "HLA-DPB1 RNA",
    "HLA-DPB1 Proteo"
  ],
  "TIFAB": [
    "TIFAB CNV",
    "TIFAB RNA"
  ],
  "EEF1A1P33": [
    "EEF1A1P33 CNV",
    "EEF1A1P33 RNA"
  ],
  "MTCO2P10": [
    "MTCO2P10 CNV",
    "MTCO2P10 RNA"
  ],
  "TP53TG3B": [
    "TP53TG3B CNV",
    "TP53TG3B RNA"
  ],
  "GRTP1": [
    "GRTP1 CNV",
    "GRTP1 RNA"
  ],
  "PLXNB3": [
    "PLXNB3 CNV",
    "PLXNB3 RNA",
    "PLXNB3 Proteo"
  ],
  "SLC47A1P2": [
    "SLC47A1P2 CNV",
    "SLC47A1P2 RNA"
  ],
  "APOM": [
    "APOM CNV",
    "APOM RNA",
    "APOM Proteo"
  ],
  "SPRYD7": [
    "SPRYD7 CNV",
    "SPRYD7 RNA",
    "SPRYD7 Proteo"
  ],
  "OR6M1": [
    "OR6M1 CNV",
    "OR6M1 RNA"
  ],
  "TASOR2": [
    "TASOR2 CNV",
    "TASOR2 RNA",
    "TASOR2 Proteo"
  ],
  "DCDC2": [
    "DCDC2 CNV",
    "DCDC2 RNA"
  ],
  "AIDAP2": [
    "AIDAP2 CNV",
    "AIDAP2 RNA"
  ],
  "PHAX": [
    "PHAX CNV",
    "PHAX RNA",
    "PHAX Proteo"
  ],
  "STAG3L5P": [
    "STAG3L5P CNV",
    "STAG3L5P RNA"
  ],
  "TREML3P": [
    "TREML3P CNV",
    "TREML3P RNA"
  ],
  "UPK2": [
    "UPK2 CNV",
    "UPK2 RNA"
  ],
  "GAPDHP57": [
    "GAPDHP57 CNV",
    "GAPDHP57 RNA"
  ],
  "BPNT2P1": [
    "BPNT2P1 CNV",
    "BPNT2P1 RNA"
  ],
  "ZNF253": [
    "ZNF253 CNV",
    "ZNF253 RNA"
  ],
  "ESM1": [
    "ESM1 CNV",
    "ESM1 RNA"
  ],
  "ST6GAL2": [
    "ST6GAL2 CNV",
    "ST6GAL2 RNA"
  ],
  "ZNF830": [
    "ZNF830 CNV",
    "ZNF830 RNA",
    "ZNF830 Proteo"
  ],
  "GLTPP1": [
    "GLTPP1 CNV",
    "GLTPP1 RNA"
  ],
  "RNA5SP136": [
    "RNA5SP136 CNV",
    "RNA5SP136 RNA"
  ],
  "GAK": [
    "GAK CNV",
    "GAK RNA",
    "GAK Proteo"
  ],
  "RPS4XP11": [
    "RPS4XP11 CNV",
    "RPS4XP11 RNA"
  ],
  "RNA5SP216": [
    "RNA5SP216 CNV",
    "RNA5SP216 RNA"
  ],
  "APOBEC1": [
    "APOBEC1 CNV",
    "APOBEC1 RNA"
  ],
  "SMIM7": [
    "SMIM7 CNV",
    "SMIM7 RNA",
    "SMIM7 Proteo"
  ],
  "TAX1BP1": [
    "TAX1BP1 CNV",
    "TAX1BP1 RNA",
    "TAX1BP1 Proteo"
  ],
  "HNRNPA1P14": [
    "HNRNPA1P14 CNV",
    "HNRNPA1P14 RNA"
  ],
  "PPP1R2P10": [
    "PPP1R2P10 CNV",
    "PPP1R2P10 RNA"
  ],
  "RNF7": [
    "RNF7 CNV",
    "RNF7 RNA",
    "RNF7 Proteo"
  ],
  "OR4K15": [
    "OR4K15 CNV",
    "OR4K15 RNA"
  ],
  "FAM171A2": [
    "FAM171A2 CNV",
    "FAM171A2 RNA",
    "FAM171A2 Proteo"
  ],
  "RPSAP46": [
    "RPSAP46 CNV",
    "RPSAP46 RNA"
  ],
  "CYBA": [
    "CYBA CNV",
    "CYBA RNA",
    "CYBA Proteo"
  ],
  "BHLHA9": [
    "BHLHA9 CNV",
    "BHLHA9 RNA"
  ],
  "TMED5": [
    "TMED5 CNV",
    "TMED5 RNA",
    "TMED5 Proteo"
  ],
  "MED27": [
    "MED27 CNV",
    "MED27 RNA",
    "MED27 Proteo"
  ],
  "FGD6": [
    "FGD6 CNV",
    "FGD6 RNA",
    "FGD6 Proteo"
  ],
  "SCYL3": [
    "SCYL3 CNV",
    "SCYL3 RNA",
    "SCYL3 Proteo"
  ],
  "DBF4P2": [
    "DBF4P2 CNV",
    "DBF4P2 RNA"
  ],
  "SOWAHA": [
    "SOWAHA CNV",
    "SOWAHA RNA",
    "SOWAHA Proteo"
  ],
  "HSPA12A": [
    "HSPA12A CNV",
    "HSPA12A RNA",
    "HSPA12A Proteo"
  ],
  "IER2": [
    "IER2 CNV",
    "IER2 RNA",
    "IER2 Proteo"
  ],
  "RPL34P19": [
    "RPL34P19 CNV",
    "RPL34P19 RNA"
  ],
  "HGS": [
    "HGS CNV",
    "HGS RNA",
    "HGS Proteo"
  ],
  "TCF12": [
    "TCF12 CNV",
    "TCF12 RNA",
    "TCF12 Proteo"
  ],
  "TBC1D14": [
    "TBC1D14 CNV",
    "TBC1D14 RNA",
    "TBC1D14 Proteo"
  ],
  "KIR3DL2": [
    "KIR3DL2 CNV",
    "KIR3DL2 RNA",
    "KIR3DL2 Proteo"
  ],
  "PLA2G1B": [
    "PLA2G1B CNV",
    "PLA2G1B RNA"
  ],
  "TMPO": [
    "TMPO CNV",
    "TMPO RNA",
    "TMPO Proteo"
  ],
  "C2orf81": [
    "C2orf81 CNV",
    "C2orf81 RNA"
  ],
  "FKBP15": [
    "FKBP15 CNV",
    "FKBP15 RNA",
    "FKBP15 Proteo"
  ],
  "MPHOSPH10P5": [
    "MPHOSPH10P5 CNV",
    "MPHOSPH10P5 RNA"
  ],
  "RLIM": [
    "RLIM CNV",
    "RLIM RNA",
    "RLIM Proteo"
  ],
  "EFCAB6": [
    "EFCAB6 CNV",
    "EFCAB6 RNA"
  ],
  "HCN1": [
    "HCN1 CNV",
    "HCN1 RNA",
    "HCN1 Proteo"
  ],
  "IRF2": [
    "IRF2 CNV",
    "IRF2 RNA",
    "IRF2 Proteo"
  ],
  "RWDD4P2": [
    "RWDD4P2 CNV",
    "RWDD4P2 RNA"
  ],
  "TUBB8P9": [
    "TUBB8P9 CNV",
    "TUBB8P9 RNA"
  ],
  "APOOL": [
    "APOOL CNV",
    "APOOL RNA",
    "APOOL Proteo"
  ],
  "BRDT": [
    "BRDT CNV",
    "BRDT RNA"
  ],
  "BMS1P10": [
    "BMS1P10 CNV",
    "BMS1P10 RNA"
  ],
  "RPS29P2": [
    "RPS29P2 CNV",
    "RPS29P2 RNA"
  ],
  "RPA2P2": [
    "RPA2P2 CNV",
    "RPA2P2 RNA"
  ],
  "ETNPPL": [
    "ETNPPL CNV",
    "ETNPPL RNA"
  ],
  "HNRNPA1P41": [
    "HNRNPA1P41 CNV",
    "HNRNPA1P41 RNA"
  ],
  "GPR25": [
    "GPR25 CNV",
    "GPR25 RNA"
  ],
  "PRKCI": [
    "PRKCI CNV",
    "PRKCI RNA",
    "PRKCI Proteo"
  ],
  "PDHA2": [
    "PDHA2 CNV",
    "PDHA2 RNA"
  ],
  "RASD2": [
    "RASD2 CNV",
    "RASD2 RNA"
  ],
  "PRDM15": [
    "PRDM15 CNV",
    "PRDM15 RNA",
    "PRDM15 Proteo"
  ],
  "CD28": [
    "CD28 CNV",
    "CD28 RNA"
  ],
  "WDSUB1": [
    "WDSUB1 CNV",
    "WDSUB1 RNA",
    "WDSUB1 Proteo"
  ],
  "CLEC4GP1": [
    "CLEC4GP1 CNV",
    "CLEC4GP1 RNA"
  ],
  "RPL17P49": [
    "RPL17P49 CNV",
    "RPL17P49 RNA"
  ],
  "RIC1": [
    "RIC1 CNV",
    "RIC1 RNA",
    "RIC1 Proteo"
  ],
  "OR4B1": [
    "OR4B1 CNV",
    "OR4B1 RNA"
  ],
  "TARDBP": [
    "TARDBP CNV",
    "TARDBP RNA",
    "TARDBP Proteo"
  ],
  "SLC30A7": [
    "SLC30A7 CNV",
    "SLC30A7 RNA",
    "SLC30A7 Proteo"
  ],
  "VN2R19P": [
    "VN2R19P CNV",
    "VN2R19P RNA"
  ],
  "GORAB": [
    "GORAB CNV",
    "GORAB RNA",
    "GORAB Proteo"
  ],
  "PBX1": [
    "PBX1 CNV",
    "PBX1 RNA",
    "PBX1 Proteo"
  ],
  "TAF10": [
    "TAF10 CNV",
    "TAF10 RNA",
    "TAF10 Proteo"
  ],
  "MCM7": [
    "MCM7 CNV",
    "MCM7 RNA",
    "MCM7 Proteo"
  ],
  "RABGGTA": [
    "RABGGTA CNV",
    "RABGGTA RNA",
    "RABGGTA Proteo"
  ],
  "NOS1": [
    "NOS1 CNV",
    "NOS1 RNA",
    "NOS1 Proteo"
  ],
  "RNF8": [
    "RNF8 CNV",
    "RNF8 RNA",
    "RNF8 Proteo"
  ],
  "TSPYL4": [
    "TSPYL4 CNV",
    "TSPYL4 RNA",
    "TSPYL4 Proteo"
  ],
  "AKR1B1P3": [
    "AKR1B1P3 CNV",
    "AKR1B1P3 RNA"
  ],
  "RBM45": [
    "RBM45 CNV",
    "RBM45 RNA",
    "RBM45 Proteo"
  ],
  "DGKA": [
    "DGKA CNV",
    "DGKA RNA",
    "DGKA Proteo"
  ],
  "RPL35AP34": [
    "RPL35AP34 CNV",
    "RPL35AP34 RNA"
  ],
  "GSTT2B": [
    "GSTT2B CNV",
    "GSTT2B RNA",
    "GSTT2B Proteo"
  ],
  "LAX1": [
    "LAX1 CNV",
    "LAX1 RNA",
    "LAX1 Proteo"
  ],
  "LTBP1": [
    "LTBP1 CNV",
    "LTBP1 RNA",
    "LTBP1 Proteo"
  ],
  "MEGF8": [
    "MEGF8 CNV",
    "MEGF8 RNA",
    "MEGF8 Proteo"
  ],
  "KLHL25": [
    "KLHL25 CNV",
    "KLHL25 RNA",
    "KLHL25 Proteo"
  ],
  "EIF3LP3": [
    "EIF3LP3 CNV",
    "EIF3LP3 RNA"
  ],
  "COPS2": [
    "COPS2 CNV",
    "COPS2 RNA",
    "COPS2 Proteo"
  ],
  "CASP9": [
    "CASP9 CNV",
    "CASP9 RNA",
    "CASP9 Proteo"
  ],
  "VSX1": [
    "VSX1 CNV",
    "VSX1 RNA"
  ],
  "NUDT19P6": [
    "NUDT19P6 CNV",
    "NUDT19P6 RNA"
  ],
  "AGTPBP1": [
    "AGTPBP1 CNV",
    "AGTPBP1 RNA",
    "AGTPBP1 Proteo"
  ],
  "OR10A3": [
    "OR10A3 CNV",
    "OR10A3 RNA"
  ],
  "AQP11": [
    "AQP11 CNV",
    "AQP11 RNA"
  ],
  "ANKRD44": [
    "ANKRD44 CNV",
    "ANKRD44 RNA",
    "ANKRD44 Proteo"
  ],
  "FAM168A": [
    "FAM168A CNV",
    "FAM168A RNA",
    "FAM168A Proteo"
  ],
  "VWA8P1": [
    "VWA8P1 CNV",
    "VWA8P1 RNA"
  ],
  "KLF3": [
    "KLF3 CNV",
    "KLF3 RNA",
    "KLF3 Proteo"
  ],
  "CPNE5": [
    "CPNE5 CNV",
    "CPNE5 RNA",
    "CPNE5 Proteo"
  ],
  "SEMA3E": [
    "SEMA3E CNV",
    "SEMA3E RNA"
  ],
  "LAYN": [
    "LAYN CNV",
    "LAYN RNA"
  ],
  "BEST1": [
    "BEST1 CNV",
    "BEST1 RNA"
  ],
  "PRRT1B": [
    "PRRT1B CNV",
    "PRRT1B RNA"
  ],
  "DCAF8": [
    "DCAF8 CNV",
    "DCAF8 RNA",
    "DCAF8 Proteo"
  ],
  "SOWAHB": [
    "SOWAHB CNV",
    "SOWAHB RNA"
  ],
  "INO80D": [
    "INO80D CNV",
    "INO80D RNA",
    "INO80D Proteo"
  ],
  "EGFR": [
    "EGFR CNV",
    "EGFR RNA",
    "EGFR Proteo"
  ],
  "ENPP7P15": [
    "ENPP7P15 CNV",
    "ENPP7P15 RNA"
  ],
  "ADAM21P1": [
    "ADAM21P1 CNV",
    "ADAM21P1 RNA"
  ],
  "ZNF180": [
    "ZNF180 CNV",
    "ZNF180 RNA"
  ],
  "SLC25A14": [
    "SLC25A14 CNV",
    "SLC25A14 RNA",
    "SLC25A14 Proteo"
  ],
  "OR7E18P": [
    "OR7E18P CNV",
    "OR7E18P RNA"
  ],
  "GPR176": [
    "GPR176 CNV",
    "GPR176 RNA"
  ],
  "CACNG6": [
    "CACNG6 CNV",
    "CACNG6 RNA",
    "CACNG6 Proteo"
  ],
  "TECRL": [
    "TECRL CNV",
    "TECRL RNA"
  ],
  "ABCB10P1": [
    "ABCB10P1 CNV",
    "ABCB10P1 RNA"
  ],
  "PRYP4": [
    "PRYP4 CNV",
    "PRYP4 RNA"
  ],
  "GIPC2": [
    "GIPC2 CNV",
    "GIPC2 RNA",
    "GIPC2 Proteo"
  ],
  "POC1B-GALNT4": [
    "POC1B-GALNT4 Proteo"
  ],
  "LAIR2": [
    "LAIR2 CNV",
    "LAIR2 RNA"
  ],
  "LSM12P1": [
    "LSM12P1 CNV",
    "LSM12P1 RNA"
  ],
  "MORN2": [
    "MORN2 CNV",
    "MORN2 RNA"
  ],
  "ST6GALNAC2P1": [
    "ST6GALNAC2P1 CNV",
    "ST6GALNAC2P1 RNA"
  ],
  "ADAM12": [
    "ADAM12 CNV",
    "ADAM12 RNA",
    "ADAM12 Proteo"
  ],
  "SPOCK2": [
    "SPOCK2 CNV",
    "SPOCK2 RNA",
    "SPOCK2 Proteo"
  ],
  "ELOB": [
    "ELOB CNV",
    "ELOB RNA",
    "ELOB Proteo"
  ],
  "FAM83E": [
    "FAM83E CNV",
    "FAM83E RNA"
  ],
  "TBC1D9B": [
    "TBC1D9B CNV",
    "TBC1D9B RNA",
    "TBC1D9B Proteo"
  ],
  "NUTM2F": [
    "NUTM2F CNV",
    "NUTM2F RNA"
  ],
  "APBB3": [
    "APBB3 CNV",
    "APBB3 RNA"
  ],
  "RYKP1": [
    "RYKP1 CNV",
    "RYKP1 RNA"
  ],
  "CELSR1": [
    "CELSR1 CNV",
    "CELSR1 RNA",
    "CELSR1 Proteo"
  ],
  "GAGE12C": [
    "GAGE12C CNV",
    "GAGE12C RNA"
  ],
  "DMRT2": [
    "DMRT2 CNV",
    "DMRT2 RNA"
  ],
  "BNIP3P16": [
    "BNIP3P16 CNV",
    "BNIP3P16 RNA"
  ],
  "SLC2A4": [
    "SLC2A4 CNV",
    "SLC2A4 RNA",
    "SLC2A4 Proteo"
  ],
  "FMNL1": [
    "FMNL1 CNV",
    "FMNL1 RNA",
    "FMNL1 Proteo"
  ],
  "ARC": [
    "ARC CNV",
    "ARC RNA"
  ],
  "FDPSP2": [
    "FDPSP2 CNV",
    "FDPSP2 RNA"
  ],
  "PSMC2P1": [
    "PSMC2P1 CNV",
    "PSMC2P1 RNA"
  ],
  "NTF6B": [
    "NTF6B CNV",
    "NTF6B RNA"
  ],
  "SMIM17": [
    "SMIM17 CNV",
    "SMIM17 RNA"
  ],
  "DNASE2B": [
    "DNASE2B CNV",
    "DNASE2B RNA"
  ],
  "SUSD3": [
    "SUSD3 CNV",
    "SUSD3 RNA",
    "SUSD3 Proteo"
  ],
  "HNRNPA3P2": [
    "HNRNPA3P2 CNV",
    "HNRNPA3P2 RNA"
  ],
  "BANF1P5": [
    "BANF1P5 CNV",
    "BANF1P5 RNA"
  ],
  "ECE1": [
    "ECE1 CNV",
    "ECE1 RNA",
    "ECE1 Proteo"
  ],
  "EPGN": [
    "EPGN CNV",
    "EPGN RNA"
  ],
  "RPL3P9": [
    "RPL3P9 CNV",
    "RPL3P9 RNA"
  ],
  "PPIAP56": [
    "PPIAP56 CNV",
    "PPIAP56 RNA"
  ],
  "CHAMP1": [
    "CHAMP1 CNV",
    "CHAMP1 RNA",
    "CHAMP1 Proteo"
  ],
  "TGOLN2": [
    "TGOLN2 CNV",
    "TGOLN2 RNA",
    "TGOLN2 Proteo"
  ],
  "TRIM64EP": [
    "TRIM64EP CNV",
    "TRIM64EP RNA"
  ],
  "RHOBTB1": [
    "RHOBTB1 CNV",
    "RHOBTB1 RNA"
  ],
  "CALML6": [
    "CALML6 CNV",
    "CALML6 RNA"
  ],
  "ESRRAP2": [
    "ESRRAP2 CNV",
    "ESRRAP2 RNA"
  ],
  "GCKR": [
    "GCKR CNV",
    "GCKR RNA"
  ],
  "DPP3P2": [
    "DPP3P2 CNV",
    "DPP3P2 RNA"
  ],
  "TBX10": [
    "TBX10 CNV",
    "TBX10 RNA"
  ],
  "GAS2": [
    "GAS2 CNV",
    "GAS2 RNA",
    "GAS2 Proteo"
  ],
  "ELL2P1": [
    "ELL2P1 CNV",
    "ELL2P1 RNA"
  ],
  "CCNC": [
    "CCNC CNV",
    "CCNC RNA",
    "CCNC Proteo"
  ],
  "TOMT": [
    "TOMT CNV",
    "TOMT RNA"
  ],
  "SUGT1P4": [
    "SUGT1P4 CNV",
    "SUGT1P4 RNA"
  ],
  "FABP9": [
    "FABP9 CNV",
    "FABP9 RNA",
    "FABP9 Proteo"
  ],
  "AKR7A2": [
    "AKR7A2 CNV",
    "AKR7A2 RNA",
    "AKR7A2 Proteo"
  ],
  "PGBD2": [
    "PGBD2 CNV",
    "PGBD2 RNA"
  ],
  "NEURL4": [
    "NEURL4 CNV",
    "NEURL4 RNA",
    "NEURL4 Proteo"
  ],
  "ADCY6": [
    "ADCY6 CNV",
    "ADCY6 RNA",
    "ADCY6 Proteo"
  ],
  "IQCC": [
    "IQCC CNV",
    "IQCC RNA",
    "IQCC Proteo"
  ],
  "FXYD6P3": [
    "FXYD6P3 CNV",
    "FXYD6P3 RNA"
  ],
  "TSPY4": [
    "TSPY4 CNV",
    "TSPY4 RNA"
  ],
  "MYL12BP3": [
    "MYL12BP3 CNV",
    "MYL12BP3 RNA"
  ],
  "SMOC1": [
    "SMOC1 CNV",
    "SMOC1 RNA",
    "SMOC1 Proteo"
  ],
  "UQCRC1": [
    "UQCRC1 CNV",
    "UQCRC1 RNA",
    "UQCRC1 Proteo"
  ],
  "LRIT2": [
    "LRIT2 CNV",
    "LRIT2 RNA"
  ],
  "TUBB8": [
    "TUBB8 CNV",
    "TUBB8 RNA",
    "TUBB8 Proteo"
  ],
  "RPL12P31": [
    "RPL12P31 CNV",
    "RPL12P31 RNA"
  ],
  "CHP1P3": [
    "CHP1P3 CNV",
    "CHP1P3 RNA"
  ],
  "CEND1P1": [
    "CEND1P1 CNV",
    "CEND1P1 RNA"
  ],
  "RPSAP25": [
    "RPSAP25 CNV",
    "RPSAP25 RNA"
  ],
  "IGKV2OR2-1": [
    "IGKV2OR2-1 CNV",
    "IGKV2OR2-1 RNA"
  ],
  "HSPA13": [
    "HSPA13 CNV",
    "HSPA13 RNA",
    "HSPA13 Proteo"
  ],
  "RPL31P9": [
    "RPL31P9 CNV",
    "RPL31P9 RNA"
  ],
  "TGFBR2": [
    "TGFBR2 CNV",
    "TGFBR2 RNA",
    "TGFBR2 Proteo"
  ],
  "KANK3": [
    "KANK3 CNV",
    "KANK3 RNA",
    "KANK3 Proteo"
  ],
  "GPR182": [
    "GPR182 CNV",
    "GPR182 RNA"
  ],
  "H4C1": [
    "H4C1 CNV",
    "H4C1 RNA"
  ],
  "PDCL3P3": [
    "PDCL3P3 CNV",
    "PDCL3P3 RNA"
  ],
  "RPL32P17": [
    "RPL32P17 CNV",
    "RPL32P17 RNA"
  ],
  "CLPSL1": [
    "CLPSL1 CNV",
    "CLPSL1 RNA"
  ],
  "METTL21A": [
    "METTL21A CNV",
    "METTL21A RNA",
    "METTL21A Proteo"
  ],
  "TEX14": [
    "TEX14 CNV",
    "TEX14 RNA"
  ],
  "ME3": [
    "ME3 CNV",
    "ME3 RNA",
    "ME3 Proteo"
  ],
  "USP12PY": [
    "USP12PY CNV",
    "USP12PY RNA"
  ],
  "TIGAR": [
    "TIGAR CNV",
    "TIGAR RNA",
    "TIGAR Proteo"
  ],
  "PRPF4B": [
    "PRPF4B CNV",
    "PRPF4B RNA",
    "PRPF4B Proteo"
  ],
  "TBC1D13": [
    "TBC1D13 CNV",
    "TBC1D13 RNA",
    "TBC1D13 Proteo"
  ],
  "PSMC3": [
    "PSMC3 CNV",
    "PSMC3 RNA",
    "PSMC3 Proteo"
  ],
  "GLRX3": [
    "GLRX3 CNV",
    "GLRX3 RNA",
    "GLRX3 Proteo"
  ],
  "DCC": [
    "DCC CNV",
    "DCC RNA"
  ],
  "ITIH5": [
    "ITIH5 CNV",
    "ITIH5 RNA",
    "ITIH5 Proteo"
  ],
  "ANKRD13D": [
    "ANKRD13D CNV",
    "ANKRD13D RNA",
    "ANKRD13D Proteo"
  ],
  "PPIAP22": [
    "PPIAP22 CNV",
    "PPIAP22 RNA"
  ],
  "BTG1P1": [
    "BTG1P1 CNV",
    "BTG1P1 RNA"
  ],
  "ASCL3": [
    "ASCL3 CNV",
    "ASCL3 RNA"
  ],
  "SIK3": [
    "SIK3 CNV",
    "SIK3 RNA",
    "SIK3 Proteo"
  ],
  "NIPA2": [
    "NIPA2 CNV",
    "NIPA2 RNA",
    "NIPA2 Proteo"
  ],
  "SAG": [
    "SAG CNV",
    "SAG RNA"
  ],
  "GCNT1": [
    "GCNT1 CNV",
    "GCNT1 RNA"
  ],
  "RPL23AP15": [
    "RPL23AP15 CNV",
    "RPL23AP15 RNA"
  ],
  "RPL7P54": [
    "RPL7P54 CNV",
    "RPL7P54 RNA"
  ],
  "PLAUR": [
    "PLAUR CNV",
    "PLAUR RNA",
    "PLAUR Proteo"
  ],
  "SLC25A1P1": [
    "SLC25A1P1 CNV",
    "SLC25A1P1 RNA"
  ],
  "PZP": [
    "PZP CNV",
    "PZP RNA",
    "PZP Proteo"
  ],
  "RPL13AP25": [
    "RPL13AP25 CNV",
    "RPL13AP25 RNA"
  ],
  "ZBTB7C": [
    "ZBTB7C CNV",
    "ZBTB7C RNA"
  ],
  "GPR173": [
    "GPR173 CNV",
    "GPR173 RNA"
  ],
  "RAB35": [
    "RAB35 CNV",
    "RAB35 RNA",
    "RAB35 Proteo"
  ],
  "GPNMB": [
    "GPNMB CNV",
    "GPNMB RNA",
    "GPNMB Proteo"
  ],
  "SMIM28": [
    "SMIM28 CNV",
    "SMIM28 RNA"
  ],
  "NLRP3": [
    "NLRP3 CNV",
    "NLRP3 RNA",
    "NLRP3 Proteo"
  ],
  "CYP2C23P": [
    "CYP2C23P CNV",
    "CYP2C23P RNA"
  ],
  "TUBB8P3": [
    "TUBB8P3 CNV",
    "TUBB8P3 RNA"
  ],
  "SRRT": [
    "SRRT CNV",
    "SRRT RNA",
    "SRRT Proteo"
  ],
  "WHAMMP1": [
    "WHAMMP1 CNV",
    "WHAMMP1 RNA"
  ],
  "TCEA1": [
    "TCEA1 CNV",
    "TCEA1 RNA",
    "TCEA1 Proteo"
  ],
  "TNNI3": [
    "TNNI3 CNV",
    "TNNI3 RNA"
  ],
  "FAF2P1": [
    "FAF2P1 CNV",
    "FAF2P1 RNA"
  ],
  "NDUFA5P6": [
    "NDUFA5P6 CNV",
    "NDUFA5P6 RNA"
  ],
  "FKBP4P8": [
    "FKBP4P8 CNV",
    "FKBP4P8 RNA"
  ],
  "CRYAA": [
    "CRYAA CNV",
    "CRYAA RNA"
  ],
  "MRPS6P2": [
    "MRPS6P2 CNV",
    "MRPS6P2 RNA"
  ],
  "PTTG2": [
    "PTTG2 CNV",
    "PTTG2 RNA"
  ],
  "RPL31P60": [
    "RPL31P60 CNV",
    "RPL31P60 RNA"
  ],
  "TXNP4": [
    "TXNP4 CNV",
    "TXNP4 RNA"
  ],
  "SAPCD2P4": [
    "SAPCD2P4 CNV",
    "SAPCD2P4 RNA"
  ],
  "RPL36AP18": [
    "RPL36AP18 CNV",
    "RPL36AP18 RNA"
  ],
  "OR51T1": [
    "OR51T1 CNV",
    "OR51T1 RNA"
  ],
  "PLEKHG4": [
    "PLEKHG4 CNV",
    "PLEKHG4 RNA",
    "PLEKHG4 Proteo"
  ],
  "NMS": [
    "NMS CNV",
    "NMS RNA"
  ],
  "MYH4": [
    "MYH4 CNV",
    "MYH4 RNA",
    "MYH4 Proteo"
  ],
  "TECPR1": [
    "TECPR1 CNV",
    "TECPR1 RNA",
    "TECPR1 Proteo"
  ],
  "ANP32BP3": [
    "ANP32BP3 CNV",
    "ANP32BP3 RNA"
  ],
  "CDC37": [
    "CDC37 CNV",
    "CDC37 RNA",
    "CDC37 Proteo"
  ],
  "PRDM16": [
    "PRDM16 CNV",
    "PRDM16 RNA",
    "PRDM16 Proteo"
  ],
  "SRD5A3P1": [
    "SRD5A3P1 CNV",
    "SRD5A3P1 RNA"
  ],
  "BRD1": [
    "BRD1 CNV",
    "BRD1 RNA",
    "BRD1 Proteo"
  ],
  "TTTY25P": [
    "TTTY25P CNV",
    "TTTY25P RNA"
  ],
  "RAB5A": [
    "RAB5A CNV",
    "RAB5A RNA",
    "RAB5A Proteo"
  ],
  "GRIA4": [
    "GRIA4 CNV",
    "GRIA4 RNA",
    "GRIA4 Proteo"
  ],
  "CNOT4P1": [
    "CNOT4P1 CNV",
    "CNOT4P1 RNA"
  ],
  "RPS4Y2": [
    "RPS4Y2 CNV",
    "RPS4Y2 RNA",
    "RPS4Y2 Proteo"
  ],
  "MXD3": [
    "MXD3 CNV",
    "MXD3 RNA"
  ],
  "TMEM200B": [
    "TMEM200B CNV",
    "TMEM200B RNA"
  ],
  "METTL15P3": [
    "METTL15P3 CNV",
    "METTL15P3 RNA"
  ],
  "BCORL1": [
    "BCORL1 CNV",
    "BCORL1 RNA",
    "BCORL1 Proteo"
  ],
  "CMC2": [
    "CMC2 CNV",
    "CMC2 RNA",
    "CMC2 Proteo"
  ],
  "RPS26P58": [
    "RPS26P58 CNV",
    "RPS26P58 RNA"
  ],
  "HSPB1P1": [
    "HSPB1P1 CNV",
    "HSPB1P1 RNA"
  ],
  "TRIM34": [
    "TRIM34 CNV",
    "TRIM34 RNA"
  ],
  "CCDC15": [
    "CCDC15 CNV",
    "CCDC15 RNA",
    "CCDC15 Proteo"
  ],
  "MTND6P25": [
    "MTND6P25 CNV",
    "MTND6P25 RNA"
  ],
  "RNA5SP462": [
    "RNA5SP462 CNV",
    "RNA5SP462 RNA"
  ],
  "TACC2": [
    "TACC2 CNV",
    "TACC2 RNA",
    "TACC2 Proteo"
  ],
  "HJV": [
    "HJV CNV",
    "HJV RNA"
  ],
  "PSME2": [
    "PSME2 CNV",
    "PSME2 RNA",
    "PSME2 Proteo"
  ],
  "ARL8B": [
    "ARL8B CNV",
    "ARL8B RNA",
    "ARL8B Proteo"
  ],
  "H2BP6": [
    "H2BP6 CNV",
    "H2BP6 RNA"
  ],
  "ABHD17AP6": [
    "ABHD17AP6 CNV",
    "ABHD17AP6 RNA"
  ],
  "SLC4A3": [
    "SLC4A3 CNV",
    "SLC4A3 RNA"
  ],
  "ELOCP36": [
    "ELOCP36 CNV",
    "ELOCP36 RNA"
  ],
  "FTLP6": [
    "FTLP6 CNV",
    "FTLP6 RNA"
  ],
  "CAMKK1": [
    "CAMKK1 CNV",
    "CAMKK1 RNA",
    "CAMKK1 Proteo"
  ],
  "GRHPR": [
    "GRHPR CNV",
    "GRHPR RNA",
    "GRHPR Proteo"
  ],
  "STYX": [
    "STYX CNV",
    "STYX RNA",
    "STYX Proteo"
  ],
  "PPIAP79": [
    "PPIAP79 CNV",
    "PPIAP79 RNA"
  ],
  "FOXC1": [
    "FOXC1 CNV",
    "FOXC1 RNA"
  ],
  "CALML3": [
    "CALML3 CNV",
    "CALML3 RNA",
    "CALML3 Proteo"
  ],
  "MCRS1": [
    "MCRS1 CNV",
    "MCRS1 RNA",
    "MCRS1 Proteo"
  ],
  "BIN3": [
    "BIN3 CNV",
    "BIN3 RNA",
    "BIN3 Proteo"
  ],
  "FCRLA": [
    "FCRLA CNV",
    "FCRLA RNA",
    "FCRLA Proteo"
  ],
  "OR56A1": [
    "OR56A1 CNV",
    "OR56A1 RNA"
  ],
  "TRIM22": [
    "TRIM22 CNV",
    "TRIM22 RNA",
    "TRIM22 Proteo"
  ],
  "PNMA3": [
    "PNMA3 CNV",
    "PNMA3 RNA",
    "PNMA3 Proteo"
  ],
  "RPL11P5": [
    "RPL11P5 CNV",
    "RPL11P5 RNA"
  ],
  "FOLR1": [
    "FOLR1 CNV",
    "FOLR1 RNA",
    "FOLR1 Proteo"
  ],
  "SETP9": [
    "SETP9 CNV",
    "SETP9 RNA"
  ],
  "MEIS2": [
    "MEIS2 CNV",
    "MEIS2 RNA",
    "MEIS2 Proteo"
  ],
  "NDUFS5": [
    "NDUFS5 CNV",
    "NDUFS5 RNA",
    "NDUFS5 Proteo"
  ],
  "APOBEC4": [
    "APOBEC4 CNV",
    "APOBEC4 RNA"
  ],
  "ARHGAP42P4": [
    "ARHGAP42P4 CNV",
    "ARHGAP42P4 RNA"
  ],
  "RPL22P6": [
    "RPL22P6 CNV",
    "RPL22P6 RNA"
  ],
  "OR6N1": [
    "OR6N1 CNV",
    "OR6N1 RNA"
  ],
  "GUSBP13": [
    "GUSBP13 CNV",
    "GUSBP13 RNA"
  ],
  "MPPE1P1": [
    "MPPE1P1 CNV",
    "MPPE1P1 RNA"
  ],
  "CYCSP20": [
    "CYCSP20 CNV",
    "CYCSP20 RNA"
  ],
  "FRG1DP": [
    "FRG1DP CNV",
    "FRG1DP RNA"
  ],
  "ADRB1": [
    "ADRB1 CNV",
    "ADRB1 RNA"
  ],
  "NR6A1": [
    "NR6A1 CNV",
    "NR6A1 RNA"
  ],
  "ZNF621": [
    "ZNF621 CNV",
    "ZNF621 RNA"
  ],
  "PCYT1B": [
    "PCYT1B CNV",
    "PCYT1B RNA"
  ],
  "OR7E94P": [
    "OR7E94P CNV",
    "OR7E94P RNA"
  ],
  "SLCO2B1": [
    "SLCO2B1 CNV",
    "SLCO2B1 RNA",
    "SLCO2B1 Proteo"
  ],
  "FGFR3P6": [
    "FGFR3P6 CNV",
    "FGFR3P6 RNA"
  ],
  "NEK3": [
    "NEK3 CNV",
    "NEK3 RNA",
    "NEK3 Proteo"
  ],
  "DMAP1": [
    "DMAP1 CNV",
    "DMAP1 RNA",
    "DMAP1 Proteo"
  ],
  "NUDT16": [
    "NUDT16 CNV",
    "NUDT16 RNA",
    "NUDT16 Proteo"
  ],
  "RPL6P24": [
    "RPL6P24 CNV",
    "RPL6P24 RNA"
  ],
  "ERBB3": [
    "ERBB3 CNV",
    "ERBB3 RNA",
    "ERBB3 Proteo"
  ],
  "PALS2": [
    "PALS2 CNV",
    "PALS2 RNA",
    "PALS2 Proteo"
  ],
  "IGKV2D-36": [
    "IGKV2D-36 CNV",
    "IGKV2D-36 RNA"
  ],
  "RNA5SP449": [
    "RNA5SP449 CNV",
    "RNA5SP449 RNA"
  ],
  "CRISP2": [
    "CRISP2 CNV",
    "CRISP2 RNA"
  ],
  "RPL8P2": [
    "RPL8P2 CNV",
    "RPL8P2 RNA"
  ],
  "OR10D4P": [
    "OR10D4P CNV",
    "OR10D4P RNA"
  ],
  "CD164": [
    "CD164 CNV",
    "CD164 RNA"
  ],
  "ZNF711": [
    "ZNF711 CNV",
    "ZNF711 RNA"
  ],
  "PLA2G4B": [
    "PLA2G4B CNV",
    "PLA2G4B RNA"
  ],
  "KIF18BP1": [
    "KIF18BP1 CNV",
    "KIF18BP1 RNA"
  ],
  "LCE3A": [
    "LCE3A CNV",
    "LCE3A RNA"
  ],
  "BTG3P1": [
    "BTG3P1 CNV",
    "BTG3P1 RNA"
  ],
  "TBPL1": [
    "TBPL1 CNV",
    "TBPL1 RNA",
    "TBPL1 Proteo"
  ],
  "PTPRH": [
    "PTPRH CNV",
    "PTPRH RNA"
  ],
  "RNA5SP226": [
    "RNA5SP226 CNV",
    "RNA5SP226 RNA"
  ],
  "ATP1B3": [
    "ATP1B3 CNV",
    "ATP1B3 RNA",
    "ATP1B3 Proteo"
  ],
  "TM9SF3": [
    "TM9SF3 CNV",
    "TM9SF3 RNA",
    "TM9SF3 Proteo"
  ],
  "DEFA1": [
    "DEFA1 CNV",
    "DEFA1 RNA",
    "DEFA1 Proteo"
  ],
  "LINC00475": [
    "LINC00475 CNV",
    "LINC00475 RNA"
  ],
  "ZC3H7B": [
    "ZC3H7B CNV",
    "ZC3H7B RNA",
    "ZC3H7B Proteo"
  ],
  "FARSA": [
    "FARSA CNV",
    "FARSA RNA",
    "FARSA Proteo"
  ],
  "BTF3L4P1": [
    "BTF3L4P1 CNV",
    "BTF3L4P1 RNA"
  ],
  "ABHD15": [
    "ABHD15 CNV",
    "ABHD15 RNA",
    "ABHD15 Proteo"
  ],
  "LCLAT1": [
    "LCLAT1 CNV",
    "LCLAT1 RNA",
    "LCLAT1 Proteo"
  ],
  "FBXW10B": [
    "FBXW10B CNV",
    "FBXW10B RNA"
  ],
  "RAB36": [
    "RAB36 CNV",
    "RAB36 RNA",
    "RAB36 Proteo"
  ],
  "XKRYP6": [
    "XKRYP6 CNV",
    "XKRYP6 RNA"
  ],
  "BCL6": [
    "BCL6 CNV",
    "BCL6 RNA",
    "BCL6 Proteo"
  ],
  "ANKS6": [
    "ANKS6 CNV",
    "ANKS6 RNA",
    "ANKS6 Proteo"
  ],
  "CDY2B": [
    "CDY2B CNV",
    "CDY2B RNA"
  ],
  "RPGRIP1": [
    "RPGRIP1 CNV",
    "RPGRIP1 RNA"
  ],
  "ZNF577": [
    "ZNF577 CNV",
    "ZNF577 RNA"
  ],
  "BCL3": [
    "BCL3 CNV",
    "BCL3 RNA",
    "BCL3 Proteo"
  ],
  "MAGEC1": [
    "MAGEC1 CNV",
    "MAGEC1 RNA",
    "MAGEC1 Proteo"
  ],
  "PRXL2A": [
    "PRXL2A CNV",
    "PRXL2A RNA",
    "PRXL2A Proteo"
  ],
  "CTSLP8": [
    "CTSLP8 CNV",
    "CTSLP8 RNA"
  ],
  "UBE2L5": [
    "UBE2L5 CNV",
    "UBE2L5 RNA",
    "UBE2L5 Proteo"
  ],
  "NPAS4": [
    "NPAS4 CNV",
    "NPAS4 RNA"
  ],
  "ZXDC": [
    "ZXDC CNV",
    "ZXDC RNA",
    "ZXDC Proteo"
  ],
  "CCAR1": [
    "CCAR1 CNV",
    "CCAR1 RNA",
    "CCAR1 Proteo"
  ],
  "SPINT5P": [
    "SPINT5P CNV",
    "SPINT5P RNA"
  ],
  "TAFA2": [
    "TAFA2 CNV",
    "TAFA2 RNA"
  ],
  "HBEGF": [
    "HBEGF CNV",
    "HBEGF RNA"
  ],
  "LMAN1L": [
    "LMAN1L CNV",
    "LMAN1L RNA"
  ],
  "BCR": [
    "BCR CNV",
    "BCR RNA",
    "BCR Proteo"
  ],
  "SPCS1": [
    "SPCS1 CNV",
    "SPCS1 RNA",
    "SPCS1 Proteo"
  ],
  "CFL1P8": [
    "CFL1P8 CNV",
    "CFL1P8 RNA"
  ],
  "RPL37P21": [
    "RPL37P21 CNV",
    "RPL37P21 RNA"
  ],
  "NAA40": [
    "NAA40 CNV",
    "NAA40 RNA",
    "NAA40 Proteo"
  ],
  "SHISA2": [
    "SHISA2 CNV",
    "SHISA2 RNA"
  ],
  "LILRA4": [
    "LILRA4 CNV",
    "LILRA4 RNA"
  ],
  "GPSM2": [
    "GPSM2 CNV",
    "GPSM2 RNA",
    "GPSM2 Proteo"
  ],
  "PAGE1": [
    "PAGE1 CNV",
    "PAGE1 RNA"
  ],
  "TMCO6": [
    "TMCO6 CNV",
    "TMCO6 RNA",
    "TMCO6 Proteo"
  ],
  "FOXD4L4": [
    "FOXD4L4 CNV",
    "FOXD4L4 RNA"
  ],
  "CHRM5": [
    "CHRM5 CNV",
    "CHRM5 RNA"
  ],
  "OR52D1": [
    "OR52D1 CNV",
    "OR52D1 RNA"
  ],
  "RPL38P5": [
    "RPL38P5 CNV",
    "RPL38P5 RNA"
  ],
  "ID4": [
    "ID4 CNV",
    "ID4 RNA",
    "ID4 Proteo"
  ],
  "QSOX2": [
    "QSOX2 CNV",
    "QSOX2 RNA",
    "QSOX2 Proteo"
  ],
  "NACAP6": [
    "NACAP6 CNV",
    "NACAP6 RNA"
  ],
  "HNRNPH3": [
    "HNRNPH3 CNV",
    "HNRNPH3 RNA",
    "HNRNPH3 Proteo"
  ],
  "KCNC4": [
    "KCNC4 CNV",
    "KCNC4 RNA"
  ],
  "MYO1H": [
    "MYO1H CNV",
    "MYO1H RNA"
  ],
  "CYP4F9P": [
    "CYP4F9P CNV",
    "CYP4F9P RNA"
  ],
  "HAL": [
    "HAL CNV",
    "HAL RNA",
    "HAL Proteo"
  ],
  "RPS29P23": [
    "RPS29P23 CNV",
    "RPS29P23 RNA"
  ],
  "EARS2": [
    "EARS2 CNV",
    "EARS2 RNA",
    "EARS2 Proteo"
  ],
  "OR52B5P": [
    "OR52B5P CNV",
    "OR52B5P RNA"
  ],
  "SOX15": [
    "SOX15 CNV",
    "SOX15 RNA"
  ],
  "SHISA5P2": [
    "SHISA5P2 CNV",
    "SHISA5P2 RNA"
  ],
  "NRGN": [
    "NRGN CNV",
    "NRGN RNA",
    "NRGN Proteo"
  ],
  "MIDEAS": [
    "MIDEAS CNV",
    "MIDEAS RNA",
    "MIDEAS Proteo"
  ],
  "CSRP2": [
    "CSRP2 CNV",
    "CSRP2 RNA",
    "CSRP2 Proteo"
  ],
  "OLIG2": [
    "OLIG2 CNV",
    "OLIG2 RNA"
  ],
  "EEF1B2P6": [
    "EEF1B2P6 CNV",
    "EEF1B2P6 RNA"
  ],
  "RPL36AP32": [
    "RPL36AP32 CNV",
    "RPL36AP32 RNA"
  ],
  "LFNG": [
    "LFNG CNV",
    "LFNG RNA",
    "LFNG Proteo"
  ],
  "PYCR2": [
    "PYCR2 CNV",
    "PYCR2 RNA",
    "PYCR2 Proteo"
  ],
  "IDI1P3": [
    "IDI1P3 CNV",
    "IDI1P3 RNA"
  ],
  "FURIN": [
    "FURIN CNV",
    "FURIN RNA",
    "FURIN Proteo"
  ],
  "SLC9A8": [
    "SLC9A8 CNV",
    "SLC9A8 RNA",
    "SLC9A8 Proteo"
  ],
  "STPG1": [
    "STPG1 CNV",
    "STPG1 RNA"
  ],
  "TRAF3": [
    "TRAF3 CNV",
    "TRAF3 RNA",
    "TRAF3 Proteo"
  ],
  "SPRED1": [
    "SPRED1 CNV",
    "SPRED1 RNA",
    "SPRED1 Proteo"
  ],
  "SKI": [
    "SKI CNV",
    "SKI RNA",
    "SKI Proteo"
  ],
  "CSRP1": [
    "CSRP1 CNV",
    "CSRP1 RNA",
    "CSRP1 Proteo"
  ],
  "LCAT": [
    "LCAT CNV",
    "LCAT RNA",
    "LCAT Proteo"
  ],
  "GP9": [
    "GP9 CNV",
    "GP9 RNA",
    "GP9 Proteo"
  ],
  "MTND4LP3": [
    "MTND4LP3 CNV",
    "MTND4LP3 RNA"
  ],
  "KIF18A": [
    "KIF18A CNV",
    "KIF18A RNA",
    "KIF18A Proteo"
  ],
  "RAB11AP2": [
    "RAB11AP2 CNV",
    "RAB11AP2 RNA"
  ],
  "IFT172": [
    "IFT172 CNV",
    "IFT172 RNA",
    "IFT172 Proteo"
  ],
  "VPS52": [
    "VPS52 CNV",
    "VPS52 RNA",
    "VPS52 Proteo"
  ],
  "SMIM27": [
    "SMIM27 CNV",
    "SMIM27 RNA"
  ],
  "AGO1": [
    "AGO1 CNV",
    "AGO1 RNA",
    "AGO1 Proteo"
  ],
  "GPT": [
    "GPT CNV",
    "GPT RNA",
    "GPT Proteo"
  ],
  "RPL6P21": [
    "RPL6P21 CNV",
    "RPL6P21 RNA"
  ],
  "SPATS1": [
    "SPATS1 CNV",
    "SPATS1 RNA"
  ],
  "SDR42E1P4": [
    "SDR42E1P4 CNV",
    "SDR42E1P4 RNA"
  ],
  "AXIN1": [
    "AXIN1 CNV",
    "AXIN1 RNA",
    "AXIN1 Proteo"
  ],
  "ANKRD12": [
    "ANKRD12 CNV",
    "ANKRD12 RNA",
    "ANKRD12 Proteo"
  ],
  "RABGEF1": [
    "RABGEF1 CNV",
    "RABGEF1 RNA",
    "RABGEF1 Proteo"
  ],
  "ADGRF5": [
    "ADGRF5 CNV",
    "ADGRF5 RNA",
    "ADGRF5 Proteo"
  ],
  "IL6RP1": [
    "IL6RP1 CNV",
    "IL6RP1 RNA"
  ],
  "DNAH12": [
    "DNAH12 CNV",
    "DNAH12 RNA",
    "DNAH12 Proteo"
  ],
  "OR2A4": [
    "OR2A4 CNV",
    "OR2A4 RNA"
  ],
  "RPSAP4": [
    "RPSAP4 CNV",
    "RPSAP4 RNA"
  ],
  "IGHV3-75": [
    "IGHV3-75 CNV",
    "IGHV3-75 RNA"
  ],
  "RNASEH2A": [
    "RNASEH2A CNV",
    "RNASEH2A RNA",
    "RNASEH2A Proteo"
  ],
  "NDUFB1": [
    "NDUFB1 CNV",
    "NDUFB1 RNA",
    "NDUFB1 Proteo"
  ],
  "GXYLT1P3": [
    "GXYLT1P3 CNV",
    "GXYLT1P3 RNA"
  ],
  "MTMR14": [
    "MTMR14 CNV",
    "MTMR14 RNA",
    "MTMR14 Proteo"
  ],
  "CORO7-PAM16": [
    "CORO7-PAM16 Proteo"
  ],
  "BCO2": [
    "BCO2 CNV",
    "BCO2 RNA"
  ],
  "TBCAP2": [
    "TBCAP2 CNV",
    "TBCAP2 RNA"
  ],
  "TRMT61B": [
    "TRMT61B CNV",
    "TRMT61B RNA",
    "TRMT61B Proteo"
  ],
  "NCAM1": [
    "NCAM1 CNV",
    "NCAM1 RNA",
    "NCAM1 Proteo"
  ],
  "GLMN": [
    "GLMN CNV",
    "GLMN RNA",
    "GLMN Proteo"
  ],
  "SQSTM1P1": [
    "SQSTM1P1 CNV",
    "SQSTM1P1 RNA"
  ],
  "RBP1": [
    "RBP1 CNV",
    "RBP1 RNA",
    "RBP1 Proteo"
  ],
  "MSNP1": [
    "MSNP1 CNV",
    "MSNP1 RNA"
  ],
  "PCDHA4": [
    "PCDHA4 CNV",
    "PCDHA4 RNA"
  ],
  "YIPF3": [
    "YIPF3 CNV",
    "YIPF3 RNA",
    "YIPF3 Proteo"
  ],
  "ISM2": [
    "ISM2 CNV",
    "ISM2 RNA"
  ],
  "STAT5A": [
    "STAT5A CNV",
    "STAT5A RNA",
    "STAT5A Proteo"
  ],
  "GCFC2": [
    "GCFC2 CNV",
    "GCFC2 RNA",
    "GCFC2 Proteo"
  ],
  "GSE1": [
    "GSE1 CNV",
    "GSE1 RNA",
    "GSE1 Proteo"
  ],
  "ATP5MFP5": [
    "ATP5MFP5 CNV",
    "ATP5MFP5 RNA"
  ],
  "KCTD6": [
    "KCTD6 CNV",
    "KCTD6 RNA"
  ],
  "PTTG3P": [
    "PTTG3P CNV",
    "PTTG3P RNA"
  ],
  "ENTPD2": [
    "ENTPD2 CNV",
    "ENTPD2 RNA",
    "ENTPD2 Proteo"
  ],
  "SVIP": [
    "SVIP CNV",
    "SVIP RNA",
    "SVIP Proteo"
  ],
  "RNA5SP493": [
    "RNA5SP493 CNV",
    "RNA5SP493 RNA"
  ],
  "OR7E31P": [
    "OR7E31P CNV",
    "OR7E31P RNA"
  ],
  "RPS4XP3": [
    "RPS4XP3 CNV",
    "RPS4XP3 RNA"
  ],
  "ID1": [
    "ID1 CNV",
    "ID1 RNA",
    "ID1 Proteo"
  ],
  "DEGS1": [
    "DEGS1 CNV",
    "DEGS1 RNA",
    "DEGS1 Proteo"
  ],
  "MTND4P12": [
    "MTND4P12 CNV",
    "MTND4P12 RNA"
  ],
  "ATP5PBP7": [
    "ATP5PBP7 CNV",
    "ATP5PBP7 RNA"
  ],
  "PSMB10": [
    "PSMB10 CNV",
    "PSMB10 RNA",
    "PSMB10 Proteo"
  ],
  "SYNGR1": [
    "SYNGR1 CNV",
    "SYNGR1 RNA",
    "SYNGR1 Proteo"
  ],
  "KRTAP20-2": [
    "KRTAP20-2 CNV",
    "KRTAP20-2 RNA"
  ],
  "C16orf54": [
    "C16orf54 CNV",
    "C16orf54 RNA",
    "C16orf54 Proteo"
  ],
  "RPS19P1": [
    "RPS19P1 CNV",
    "RPS19P1 RNA"
  ],
  "RIMKLB": [
    "RIMKLB CNV",
    "RIMKLB RNA",
    "RIMKLB Proteo"
  ],
  "FAM32DP": [
    "FAM32DP CNV",
    "FAM32DP RNA"
  ],
  "RCAN2": [
    "RCAN2 CNV",
    "RCAN2 RNA"
  ],
  "RPL34P29": [
    "RPL34P29 CNV",
    "RPL34P29 RNA"
  ],
  "HLA-DPA3": [
    "HLA-DPA3 CNV",
    "HLA-DPA3 RNA"
  ],
  "PDCD4": [
    "PDCD4 CNV",
    "PDCD4 RNA",
    "PDCD4 Proteo"
  ],
  "LIMS4": [
    "LIMS4 CNV",
    "LIMS4 RNA"
  ],
  "TCP1": [
    "TCP1 CNV",
    "TCP1 RNA",
    "TCP1 Proteo"
  ],
  "TMEM269": [
    "TMEM269 CNV",
    "TMEM269 RNA"
  ],
  "ADIPOR2": [
    "ADIPOR2 CNV",
    "ADIPOR2 RNA"
  ],
  "CLCNKB": [
    "CLCNKB CNV",
    "CLCNKB RNA"
  ],
  "HAO1": [
    "HAO1 CNV",
    "HAO1 RNA"
  ],
  "MINDY1": [
    "MINDY1 CNV",
    "MINDY1 RNA",
    "MINDY1 Proteo"
  ],
  "PHF7": [
    "PHF7 CNV",
    "PHF7 RNA"
  ],
  "TARBP1": [
    "TARBP1 CNV",
    "TARBP1 RNA",
    "TARBP1 Proteo"
  ],
  "OLIG1": [
    "OLIG1 CNV",
    "OLIG1 RNA"
  ],
  "FBP2": [
    "FBP2 CNV",
    "FBP2 RNA",
    "FBP2 Proteo"
  ],
  "RPSAP31": [
    "RPSAP31 CNV",
    "RPSAP31 RNA"
  ],
  "RPS26P3": [
    "RPS26P3 CNV",
    "RPS26P3 RNA"
  ],
  "CDK2AP2P2": [
    "CDK2AP2P2 CNV",
    "CDK2AP2P2 RNA"
  ],
  "RPL7AP17": [
    "RPL7AP17 CNV",
    "RPL7AP17 RNA"
  ],
  "RPL23AP57": [
    "RPL23AP57 CNV",
    "RPL23AP57 RNA"
  ],
  "CYP7B1": [
    "CYP7B1 CNV",
    "CYP7B1 RNA",
    "CYP7B1 Proteo"
  ],
  "EIF2B5": [
    "EIF2B5 CNV",
    "EIF2B5 RNA",
    "EIF2B5 Proteo"
  ],
  "ARHGEF15": [
    "ARHGEF15 CNV",
    "ARHGEF15 RNA",
    "ARHGEF15 Proteo"
  ],
  "STYXL1": [
    "STYXL1 CNV",
    "STYXL1 RNA"
  ],
  "DCAF11": [
    "DCAF11 CNV",
    "DCAF11 RNA",
    "DCAF11 Proteo"
  ],
  "ACTR3P3": [
    "ACTR3P3 CNV",
    "ACTR3P3 RNA"
  ],
  "PGAM2": [
    "PGAM2 CNV",
    "PGAM2 RNA",
    "PGAM2 Proteo"
  ],
  "ACD": [
    "ACD CNV",
    "ACD RNA",
    "ACD Proteo"
  ],
  "PIGBOS1": [
    "PIGBOS1 CNV",
    "PIGBOS1 RNA",
    "PIGBOS1 Proteo"
  ],
  "HMGXB3": [
    "HMGXB3 CNV",
    "HMGXB3 RNA",
    "HMGXB3 Proteo"
  ],
  "NEXMIF": [
    "NEXMIF CNV",
    "NEXMIF RNA"
  ],
  "ACTG1P15": [
    "ACTG1P15 CNV",
    "ACTG1P15 RNA"
  ],
  "ADGRG7": [
    "ADGRG7 CNV",
    "ADGRG7 RNA"
  ],
  "S100G": [
    "S100G CNV",
    "S100G RNA"
  ],
  "OR8D2": [
    "OR8D2 CNV",
    "OR8D2 RNA"
  ],
  "CAB39": [
    "CAB39 CNV",
    "CAB39 RNA",
    "CAB39 Proteo"
  ],
  "PI15": [
    "PI15 CNV",
    "PI15 RNA",
    "PI15 Proteo"
  ],
  "DIO2": [
    "DIO2 CNV",
    "DIO2 RNA"
  ],
  "IGHV2-70D": [
    "IGHV2-70D Proteo"
  ],
  "MCRIP2P2": [
    "MCRIP2P2 CNV",
    "MCRIP2P2 RNA"
  ],
  "GNAZ": [
    "GNAZ CNV",
    "GNAZ RNA",
    "GNAZ Proteo"
  ],
  "GNRHR": [
    "GNRHR CNV",
    "GNRHR RNA"
  ],
  "GTF2H5": [
    "GTF2H5 CNV",
    "GTF2H5 RNA",
    "GTF2H5 Proteo"
  ],
  "S100A11P9": [
    "S100A11P9 CNV",
    "S100A11P9 RNA"
  ],
  "FAM161B": [
    "FAM161B CNV",
    "FAM161B RNA"
  ],
  "ZDHHC22": [
    "ZDHHC22 CNV",
    "ZDHHC22 RNA"
  ],
  "TBCEL": [
    "TBCEL CNV",
    "TBCEL RNA",
    "TBCEL Proteo"
  ],
  "KIRREL3": [
    "KIRREL3 CNV",
    "KIRREL3 RNA",
    "KIRREL3 Proteo"
  ],
  "RPL23AP91": [
    "RPL23AP91 CNV",
    "RPL23AP91 RNA"
  ],
  "OR4A49P": [
    "OR4A49P CNV",
    "OR4A49P RNA"
  ],
  "ZBTB8OSP1": [
    "ZBTB8OSP1 CNV",
    "ZBTB8OSP1 RNA"
  ],
  "CPHL1P": [
    "CPHL1P CNV",
    "CPHL1P RNA"
  ],
  "TRIM27": [
    "TRIM27 CNV",
    "TRIM27 RNA",
    "TRIM27 Proteo"
  ],
  "HAPLN1": [
    "HAPLN1 CNV",
    "HAPLN1 RNA",
    "HAPLN1 Proteo"
  ],
  "RPS4X": [
    "RPS4X CNV",
    "RPS4X RNA",
    "RPS4X Proteo"
  ],
  "DNAH9": [
    "DNAH9 CNV",
    "DNAH9 RNA"
  ],
  "SLC39A4": [
    "SLC39A4 CNV",
    "SLC39A4 RNA"
  ],
  "OSTCP4": [
    "OSTCP4 CNV",
    "OSTCP4 RNA"
  ],
  "PLS1P1": [
    "PLS1P1 CNV",
    "PLS1P1 RNA"
  ],
  "GAPDHP2": [
    "GAPDHP2 CNV",
    "GAPDHP2 RNA"
  ],
  "SUCLG2P4": [
    "SUCLG2P4 CNV",
    "SUCLG2P4 RNA"
  ],
  "NUDT13": [
    "NUDT13 CNV",
    "NUDT13 RNA"
  ],
  "SPAG5": [
    "SPAG5 CNV",
    "SPAG5 RNA",
    "SPAG5 Proteo"
  ],
  "M1AP": [
    "M1AP CNV",
    "M1AP RNA"
  ],
  "OR7E149P": [
    "OR7E149P CNV",
    "OR7E149P RNA"
  ],
  "HNRNPA3P1": [
    "HNRNPA3P1 CNV",
    "HNRNPA3P1 RNA"
  ],
  "MEF2A": [
    "MEF2A CNV",
    "MEF2A RNA",
    "MEF2A Proteo"
  ],
  "MPP4": [
    "MPP4 CNV",
    "MPP4 RNA"
  ],
  "STARD3NL": [
    "STARD3NL CNV",
    "STARD3NL RNA",
    "STARD3NL Proteo"
  ],
  "USF3": [
    "USF3 CNV",
    "USF3 RNA",
    "USF3 Proteo"
  ],
  "DRC3": [
    "DRC3 CNV",
    "DRC3 RNA"
  ],
  "RPP38": [
    "RPP38 CNV",
    "RPP38 RNA",
    "RPP38 Proteo"
  ],
  "HAUS6": [
    "HAUS6 CNV",
    "HAUS6 RNA",
    "HAUS6 Proteo"
  ],
  "AVEN": [
    "AVEN CNV",
    "AVEN RNA",
    "AVEN Proteo"
  ],
  "RPL32P20": [
    "RPL32P20 CNV",
    "RPL32P20 RNA"
  ],
  "GPR156": [
    "GPR156 CNV",
    "GPR156 RNA"
  ],
  "SGCZ": [
    "SGCZ CNV",
    "SGCZ RNA"
  ],
  "IGHVII-43-1": [
    "IGHVII-43-1 CNV",
    "IGHVII-43-1 RNA"
  ],
  "SST": [
    "SST CNV",
    "SST RNA"
  ],
  "TCP11X1": [
    "TCP11X1 CNV",
    "TCP11X1 RNA"
  ],
  "CLP1": [
    "CLP1 CNV",
    "CLP1 RNA",
    "CLP1 Proteo"
  ],
  "RBBP8NL": [
    "RBBP8NL CNV",
    "RBBP8NL RNA",
    "RBBP8NL Proteo"
  ],
  "CLASP2": [
    "CLASP2 CNV",
    "CLASP2 RNA",
    "CLASP2 Proteo"
  ],
  "HSPD1P7": [
    "HSPD1P7 CNV",
    "HSPD1P7 RNA"
  ],
  "EPB41L3": [
    "EPB41L3 CNV",
    "EPB41L3 RNA",
    "EPB41L3 Proteo"
  ],
  "MTCO2P27": [
    "MTCO2P27 CNV",
    "MTCO2P27 RNA"
  ],
  "PRELID3BP2": [
    "PRELID3BP2 CNV",
    "PRELID3BP2 RNA"
  ],
  "MFSD6": [
    "MFSD6 CNV",
    "MFSD6 RNA",
    "MFSD6 Proteo"
  ],
  "OR7E105P": [
    "OR7E105P CNV",
    "OR7E105P RNA"
  ],
  "ARPC4": [
    "ARPC4 CNV",
    "ARPC4 RNA",
    "ARPC4 Proteo"
  ],
  "PLK3": [
    "PLK3 CNV",
    "PLK3 RNA"
  ],
  "RPL36P16": [
    "RPL36P16 CNV",
    "RPL36P16 RNA"
  ],
  "RPL6P27": [
    "RPL6P27 CNV",
    "RPL6P27 RNA"
  ],
  "BCAP29": [
    "BCAP29 CNV",
    "BCAP29 RNA"
  ],
  "RBM38": [
    "RBM38 CNV",
    "RBM38 RNA",
    "RBM38 Proteo"
  ],
  "TMEM247": [
    "TMEM247 CNV",
    "TMEM247 RNA"
  ],
  "F5": [
    "F5 CNV",
    "F5 RNA",
    "F5 Proteo"
  ],
  "PDE4DIPP9": [
    "PDE4DIPP9 CNV",
    "PDE4DIPP9 RNA"
  ],
  "MKRN4P": [
    "MKRN4P CNV",
    "MKRN4P RNA"
  ],
  "RPL36P17": [
    "RPL36P17 CNV",
    "RPL36P17 RNA"
  ],
  "EIF4A2P3": [
    "EIF4A2P3 CNV",
    "EIF4A2P3 RNA"
  ],
  "GLRX2": [
    "GLRX2 CNV",
    "GLRX2 RNA",
    "GLRX2 Proteo"
  ],
  "NDUFAF6": [
    "NDUFAF6 CNV",
    "NDUFAF6 RNA",
    "NDUFAF6 Proteo"
  ],
  "WDFY4": [
    "WDFY4 CNV",
    "WDFY4 RNA",
    "WDFY4 Proteo"
  ],
  "MTCO1P47": [
    "MTCO1P47 CNV",
    "MTCO1P47 RNA"
  ],
  "KANK1": [
    "KANK1 CNV",
    "KANK1 RNA",
    "KANK1 Proteo"
  ],
  "TSPY21P": [
    "TSPY21P CNV",
    "TSPY21P RNA"
  ],
  "FOXD4L6": [
    "FOXD4L6 CNV",
    "FOXD4L6 RNA"
  ],
  "ECEL1P2": [
    "ECEL1P2 CNV",
    "ECEL1P2 RNA"
  ],
  "ZNF513": [
    "ZNF513 CNV",
    "ZNF513 RNA",
    "ZNF513 Proteo"
  ],
  "OR5D16": [
    "OR5D16 CNV",
    "OR5D16 RNA"
  ],
  "USP28": [
    "USP28 CNV",
    "USP28 RNA",
    "USP28 Proteo"
  ],
  "MYL6BP1": [
    "MYL6BP1 CNV",
    "MYL6BP1 RNA"
  ],
  "CEP72": [
    "CEP72 CNV",
    "CEP72 RNA"
  ],
  "BAZ2B": [
    "BAZ2B CNV",
    "BAZ2B RNA",
    "BAZ2B Proteo"
  ],
  "HSPB3": [
    "HSPB3 CNV",
    "HSPB3 RNA",
    "HSPB3 Proteo"
  ],
  "GRK2": [
    "GRK2 CNV",
    "GRK2 RNA",
    "GRK2 Proteo"
  ],
  "GTF2F2": [
    "GTF2F2 CNV",
    "GTF2F2 RNA",
    "GTF2F2 Proteo"
  ],
  "AIM2": [
    "AIM2 CNV",
    "AIM2 RNA",
    "AIM2 Proteo"
  ],
  "RNA5SP30": [
    "RNA5SP30 CNV",
    "RNA5SP30 RNA"
  ],
  "RPL12P13": [
    "RPL12P13 CNV",
    "RPL12P13 RNA"
  ],
  "PCNPP3": [
    "PCNPP3 CNV",
    "PCNPP3 RNA"
  ],
  "ANXA13": [
    "ANXA13 CNV",
    "ANXA13 RNA",
    "ANXA13 Proteo"
  ],
  "UQCRHP2": [
    "UQCRHP2 CNV",
    "UQCRHP2 RNA"
  ],
  "MUSTN1": [
    "MUSTN1 CNV",
    "MUSTN1 RNA",
    "MUSTN1 Proteo"
  ],
  "DUX4L26": [
    "DUX4L26 CNV",
    "DUX4L26 RNA"
  ],
  "EIF4A2P4": [
    "EIF4A2P4 CNV",
    "EIF4A2P4 RNA"
  ],
  "DUX4L47": [
    "DUX4L47 CNV",
    "DUX4L47 RNA"
  ],
  "RASGRP4": [
    "RASGRP4 CNV",
    "RASGRP4 RNA",
    "RASGRP4 Proteo"
  ],
  "MRPL20": [
    "MRPL20 CNV",
    "MRPL20 RNA",
    "MRPL20 Proteo"
  ],
  "MGARP": [
    "MGARP CNV",
    "MGARP RNA"
  ],
  "RSPRY1": [
    "RSPRY1 CNV",
    "RSPRY1 RNA",
    "RSPRY1 Proteo"
  ],
  "ALKBH6": [
    "ALKBH6 CNV",
    "ALKBH6 RNA",
    "ALKBH6 Proteo"
  ],
  "PKNOX1": [
    "PKNOX1 CNV",
    "PKNOX1 RNA",
    "PKNOX1 Proteo"
  ],
  "FAM221B": [
    "FAM221B CNV",
    "FAM221B RNA"
  ],
  "LIN28AP2": [
    "LIN28AP2 CNV",
    "LIN28AP2 RNA"
  ],
  "HTR3C2P": [
    "HTR3C2P CNV",
    "HTR3C2P RNA"
  ],
  "NRN1": [
    "NRN1 CNV",
    "NRN1 RNA"
  ],
  "H4C3": [
    "H4C3 CNV",
    "H4C3 RNA"
  ],
  "SINHCAFP1": [
    "SINHCAFP1 CNV",
    "SINHCAFP1 RNA"
  ],
  "WDR27": [
    "WDR27 CNV",
    "WDR27 RNA"
  ],
  "MASP2": [
    "MASP2 CNV",
    "MASP2 RNA",
    "MASP2 Proteo"
  ],
  "FAM50B": [
    "FAM50B CNV",
    "FAM50B RNA",
    "FAM50B Proteo"
  ],
  "AJAP1": [
    "AJAP1 CNV",
    "AJAP1 RNA"
  ],
  "TNPO1P3": [
    "TNPO1P3 CNV",
    "TNPO1P3 RNA"
  ],
  "SLC35E2B": [
    "SLC35E2B CNV",
    "SLC35E2B RNA",
    "SLC35E2B Proteo"
  ],
  "TMEM52": [
    "TMEM52 CNV",
    "TMEM52 RNA"
  ],
  "MTURN": [
    "MTURN CNV",
    "MTURN RNA",
    "MTURN Proteo"
  ],
  "NBEAP1": [
    "NBEAP1 CNV",
    "NBEAP1 RNA"
  ],
  "KCTD18": [
    "KCTD18 CNV",
    "KCTD18 RNA",
    "KCTD18 Proteo"
  ],
  "NUP50": [
    "NUP50 CNV",
    "NUP50 RNA",
    "NUP50 Proteo"
  ],
  "CPA6": [
    "CPA6 CNV",
    "CPA6 RNA"
  ],
  "MARK2P5": [
    "MARK2P5 CNV",
    "MARK2P5 RNA"
  ],
  "LIPK": [
    "LIPK CNV",
    "LIPK RNA"
  ],
  "MARCKSL1P2": [
    "MARCKSL1P2 CNV",
    "MARCKSL1P2 RNA"
  ],
  "BCAS2P3": [
    "BCAS2P3 CNV",
    "BCAS2P3 RNA"
  ],
  "BTBD16": [
    "BTBD16 CNV",
    "BTBD16 RNA"
  ],
  "FAM86MP": [
    "FAM86MP CNV",
    "FAM86MP RNA"
  ],
  "CSTF2T": [
    "CSTF2T CNV",
    "CSTF2T RNA",
    "CSTF2T Proteo"
  ],
  "GPR22": [
    "GPR22 CNV",
    "GPR22 RNA"
  ],
  "EFNA1": [
    "EFNA1 CNV",
    "EFNA1 RNA",
    "EFNA1 Proteo"
  ],
  "AHCTF1P1": [
    "AHCTF1P1 CNV",
    "AHCTF1P1 RNA"
  ],
  "KRT41P": [
    "KRT41P CNV",
    "KRT41P RNA"
  ],
  "MTCYBP41": [
    "MTCYBP41 CNV",
    "MTCYBP41 RNA"
  ],
  "APOC1P1": [
    "APOC1P1 CNV",
    "APOC1P1 RNA"
  ],
  "SLC19A3": [
    "SLC19A3 CNV",
    "SLC19A3 RNA"
  ],
  "GHSR": [
    "GHSR CNV",
    "GHSR RNA"
  ],
  "SPRYD3": [
    "SPRYD3 CNV",
    "SPRYD3 RNA",
    "SPRYD3 Proteo"
  ],
  "PLN": [
    "PLN CNV",
    "PLN RNA",
    "PLN Proteo"
  ],
  "POMT2": [
    "POMT2 CNV",
    "POMT2 RNA",
    "POMT2 Proteo"
  ],
  "CEP20": [
    "CEP20 CNV",
    "CEP20 RNA",
    "CEP20 Proteo"
  ],
  "STARD3": [
    "STARD3 CNV",
    "STARD3 RNA",
    "STARD3 Proteo"
  ],
  "ACTBP1": [
    "ACTBP1 CNV",
    "ACTBP1 RNA"
  ],
  "ANKRD36B": [
    "ANKRD36B CNV",
    "ANKRD36B RNA",
    "ANKRD36B Proteo"
  ],
  "NAIP": [
    "NAIP CNV",
    "NAIP RNA",
    "NAIP Proteo"
  ],
  "CHMP7": [
    "CHMP7 CNV",
    "CHMP7 RNA",
    "CHMP7 Proteo"
  ],
  "RHPN2": [
    "RHPN2 CNV",
    "RHPN2 RNA",
    "RHPN2 Proteo"
  ],
  "TOB2P1": [
    "TOB2P1 CNV",
    "TOB2P1 RNA"
  ],
  "ALDH18A1": [
    "ALDH18A1 CNV",
    "ALDH18A1 RNA",
    "ALDH18A1 Proteo"
  ],
  "CFTRP3": [
    "CFTRP3 CNV",
    "CFTRP3 RNA"
  ],
  "FGFBP2": [
    "FGFBP2 CNV",
    "FGFBP2 RNA"
  ],
  "PAPPA": [
    "PAPPA CNV",
    "PAPPA RNA",
    "PAPPA Proteo"
  ],
  "WNK1": [
    "WNK1 CNV",
    "WNK1 RNA",
    "WNK1 Proteo"
  ],
  "SCML2P1": [
    "SCML2P1 CNV",
    "SCML2P1 RNA"
  ],
  "PPP4R4": [
    "PPP4R4 CNV",
    "PPP4R4 RNA",
    "PPP4R4 Proteo"
  ],
  "MTATP6P16": [
    "MTATP6P16 CNV",
    "MTATP6P16 RNA"
  ],
  "ZNF106": [
    "ZNF106 CNV",
    "ZNF106 RNA",
    "ZNF106 Proteo"
  ],
  "CYP2A6": [
    "CYP2A6 CNV",
    "CYP2A6 RNA"
  ],
  "NAP1L5": [
    "NAP1L5 CNV",
    "NAP1L5 RNA",
    "NAP1L5 Proteo"
  ],
  "SPIN1": [
    "SPIN1 CNV",
    "SPIN1 RNA",
    "SPIN1 Proteo"
  ],
  "NHLRC4": [
    "NHLRC4 CNV",
    "NHLRC4 RNA"
  ],
  "C1QTNF9B": [
    "C1QTNF9B CNV",
    "C1QTNF9B RNA"
  ],
  "OR52B1P": [
    "OR52B1P CNV",
    "OR52B1P RNA"
  ],
  "HSPD1P10": [
    "HSPD1P10 CNV",
    "HSPD1P10 RNA"
  ],
  "FAAP100": [
    "FAAP100 CNV",
    "FAAP100 RNA",
    "FAAP100 Proteo"
  ],
  "PSMB1": [
    "PSMB1 CNV",
    "PSMB1 RNA",
    "PSMB1 Proteo"
  ],
  "SNRPCP20": [
    "SNRPCP20 CNV",
    "SNRPCP20 RNA"
  ],
  "CPD": [
    "CPD CNV",
    "CPD RNA",
    "CPD Proteo"
  ],
  "RPL35P8": [
    "RPL35P8 CNV",
    "RPL35P8 RNA"
  ],
  "GOLIM4": [
    "GOLIM4 CNV",
    "GOLIM4 RNA",
    "GOLIM4 Proteo"
  ],
  "RPL7L1P1": [
    "RPL7L1P1 CNV",
    "RPL7L1P1 RNA"
  ],
  "CEP350": [
    "CEP350 CNV",
    "CEP350 RNA",
    "CEP350 Proteo"
  ],
  "KRT19P2": [
    "KRT19P2 CNV",
    "KRT19P2 RNA"
  ],
  "RPS14P5": [
    "RPS14P5 CNV",
    "RPS14P5 RNA"
  ],
  "SLC2A2": [
    "SLC2A2 CNV",
    "SLC2A2 RNA"
  ],
  "IMPDH1P10": [
    "IMPDH1P10 CNV",
    "IMPDH1P10 RNA"
  ],
  "FANCA": [
    "FANCA CNV",
    "FANCA RNA",
    "FANCA Proteo"
  ],
  "HAUS4": [
    "HAUS4 CNV",
    "HAUS4 RNA",
    "HAUS4 Proteo"
  ],
  "TOMM20P3": [
    "TOMM20P3 CNV",
    "TOMM20P3 RNA"
  ],
  "SLC9A6": [
    "SLC9A6 CNV",
    "SLC9A6 RNA",
    "SLC9A6 Proteo"
  ],
  "RFX3": [
    "RFX3 CNV",
    "RFX3 RNA",
    "RFX3 Proteo"
  ],
  "IQGAP1": [
    "IQGAP1 CNV",
    "IQGAP1 RNA",
    "IQGAP1 Proteo"
  ],
  "EFCAB15P": [
    "EFCAB15P CNV",
    "EFCAB15P RNA"
  ],
  "RPL7P53": [
    "RPL7P53 CNV",
    "RPL7P53 RNA"
  ],
  "TRMU": [
    "TRMU CNV",
    "TRMU RNA",
    "TRMU Proteo"
  ],
  "OR52E8": [
    "OR52E8 CNV",
    "OR52E8 RNA"
  ],
  "CROCCP1": [
    "CROCCP1 CNV",
    "CROCCP1 RNA"
  ],
  "SOCS6P1": [
    "SOCS6P1 CNV",
    "SOCS6P1 RNA"
  ],
  "PRR20G": [
    "PRR20G CNV",
    "PRR20G RNA"
  ],
  "RNA5SP242": [
    "RNA5SP242 CNV",
    "RNA5SP242 RNA"
  ],
  "ZNF72P": [
    "ZNF72P CNV",
    "ZNF72P RNA"
  ],
  "THBS3": [
    "THBS3 CNV",
    "THBS3 RNA",
    "THBS3 Proteo"
  ],
  "RNA5SP482": [
    "RNA5SP482 CNV",
    "RNA5SP482 RNA"
  ],
  "LMBR1": [
    "LMBR1 CNV",
    "LMBR1 RNA",
    "LMBR1 Proteo"
  ],
  "RPL7P17": [
    "RPL7P17 CNV",
    "RPL7P17 RNA"
  ],
  "CEP192": [
    "CEP192 CNV",
    "CEP192 RNA",
    "CEP192 Proteo"
  ],
  "ZBED5": [
    "ZBED5 CNV",
    "ZBED5 RNA",
    "ZBED5 Proteo"
  ],
  "MBOAT2": [
    "MBOAT2 CNV",
    "MBOAT2 RNA",
    "MBOAT2 Proteo"
  ],
  "FBXO46": [
    "FBXO46 CNV",
    "FBXO46 RNA",
    "FBXO46 Proteo"
  ],
  "KIAA1671": [
    "KIAA1671 CNV",
    "KIAA1671 RNA",
    "KIAA1671 Proteo"
  ],
  "TLR10": [
    "TLR10 CNV",
    "TLR10 RNA"
  ],
  "GNG5P5": [
    "GNG5P5 CNV",
    "GNG5P5 RNA"
  ],
  "CHEK2P1": [
    "CHEK2P1 CNV",
    "CHEK2P1 RNA"
  ],
  "FKBP4P6": [
    "FKBP4P6 CNV",
    "FKBP4P6 RNA"
  ],
  "SLC2A14": [
    "SLC2A14 CNV",
    "SLC2A14 RNA"
  ],
  "RPL7P32": [
    "RPL7P32 CNV",
    "RPL7P32 RNA"
  ],
  "TRAPPC4": [
    "TRAPPC4 CNV",
    "TRAPPC4 RNA",
    "TRAPPC4 Proteo"
  ],
  "CHST13": [
    "CHST13 CNV",
    "CHST13 RNA",
    "CHST13 Proteo"
  ],
  "CFD": [
    "CFD CNV",
    "CFD RNA",
    "CFD Proteo"
  ],
  "MFSD2B": [
    "MFSD2B CNV",
    "MFSD2B RNA",
    "MFSD2B Proteo"
  ],
  "SIGLEC22P": [
    "SIGLEC22P CNV",
    "SIGLEC22P RNA"
  ],
  "PDE3A": [
    "PDE3A CNV",
    "PDE3A RNA",
    "PDE3A Proteo"
  ],
  "SNRPGP13": [
    "SNRPGP13 CNV",
    "SNRPGP13 RNA"
  ],
  "ZNF197": [
    "ZNF197 CNV",
    "ZNF197 RNA"
  ],
  "NPR2": [
    "NPR2 CNV",
    "NPR2 RNA",
    "NPR2 Proteo"
  ],
  "FOXP3": [
    "FOXP3 CNV",
    "FOXP3 RNA",
    "FOXP3 Proteo"
  ],
  "GCNT2": [
    "GCNT2 CNV",
    "GCNT2 RNA",
    "GCNT2 Proteo"
  ],
  "WASHC3": [
    "WASHC3 CNV",
    "WASHC3 RNA",
    "WASHC3 Proteo"
  ],
  "BRI3": [
    "BRI3 CNV",
    "BRI3 RNA",
    "BRI3 Proteo"
  ],
  "PDXDC2P": [
    "PDXDC2P CNV",
    "PDXDC2P RNA"
  ],
  "PPIAP14": [
    "PPIAP14 CNV",
    "PPIAP14 RNA"
  ],
  "IQCE": [
    "IQCE CNV",
    "IQCE RNA",
    "IQCE Proteo"
  ],
  "RAPGEF1": [
    "RAPGEF1 CNV",
    "RAPGEF1 RNA",
    "RAPGEF1 Proteo"
  ],
  "DGAT2L7P": [
    "DGAT2L7P CNV",
    "DGAT2L7P RNA"
  ],
  "FEZ2": [
    "FEZ2 CNV",
    "FEZ2 RNA",
    "FEZ2 Proteo"
  ],
  "GCNAP1": [
    "GCNAP1 CNV",
    "GCNAP1 RNA"
  ],
  "SMYD5": [
    "SMYD5 CNV",
    "SMYD5 RNA",
    "SMYD5 Proteo"
  ],
  "CCT5": [
    "CCT5 CNV",
    "CCT5 RNA",
    "CCT5 Proteo"
  ],
  "EBF4": [
    "EBF4 CNV",
    "EBF4 RNA"
  ],
  "ANKRD40": [
    "ANKRD40 CNV",
    "ANKRD40 RNA",
    "ANKRD40 Proteo"
  ],
  "TNNI1": [
    "TNNI1 CNV",
    "TNNI1 RNA",
    "TNNI1 Proteo"
  ],
  "TRAPPC2P3": [
    "TRAPPC2P3 CNV",
    "TRAPPC2P3 RNA"
  ],
  "TRMT1P1": [
    "TRMT1P1 CNV",
    "TRMT1P1 RNA"
  ],
  "GOLGA8H": [
    "GOLGA8H CNV",
    "GOLGA8H RNA"
  ],
  "LRP1B": [
    "LRP1B CNV",
    "LRP1B RNA",
    "LRP1B Proteo"
  ],
  "PRPF38AP2": [
    "PRPF38AP2 CNV",
    "PRPF38AP2 RNA"
  ],
  "RPS26P2": [
    "RPS26P2 CNV",
    "RPS26P2 RNA"
  ],
  "OR7E128P": [
    "OR7E128P CNV",
    "OR7E128P RNA"
  ],
  "SNRPEP4": [
    "SNRPEP4 CNV",
    "SNRPEP4 RNA"
  ],
  "DNAJC24": [
    "DNAJC24 CNV",
    "DNAJC24 RNA",
    "DNAJC24 Proteo"
  ],
  "RPL5P26": [
    "RPL5P26 CNV",
    "RPL5P26 RNA"
  ],
  "OR6L2P": [
    "OR6L2P CNV",
    "OR6L2P RNA"
  ],
  "METTL15": [
    "METTL15 CNV",
    "METTL15 RNA",
    "METTL15 Proteo"
  ],
  "MUC5AC": [
    "MUC5AC CNV",
    "MUC5AC RNA",
    "MUC5AC Proteo"
  ],
  "ZNF299P": [
    "ZNF299P CNV",
    "ZNF299P RNA"
  ],
  "NDUFB4": [
    "NDUFB4 CNV",
    "NDUFB4 RNA",
    "NDUFB4 Proteo"
  ],
  "RPS3AP32": [
    "RPS3AP32 CNV",
    "RPS3AP32 RNA"
  ],
  "HSD11B2": [
    "HSD11B2 CNV",
    "HSD11B2 RNA",
    "HSD11B2 Proteo"
  ],
  "BRD7": [
    "BRD7 CNV",
    "BRD7 RNA",
    "BRD7 Proteo"
  ],
  "RASSF2": [
    "RASSF2 CNV",
    "RASSF2 RNA",
    "RASSF2 Proteo"
  ],
  "TIGD5": [
    "TIGD5 CNV",
    "TIGD5 RNA",
    "TIGD5 Proteo"
  ],
  "SPDYE3": [
    "SPDYE3 CNV",
    "SPDYE3 RNA"
  ],
  "MTX1": [
    "MTX1 CNV",
    "MTX1 RNA",
    "MTX1 Proteo"
  ],
  "OR5BD1P": [
    "OR5BD1P CNV",
    "OR5BD1P RNA"
  ],
  "CDK10": [
    "CDK10 CNV",
    "CDK10 RNA",
    "CDK10 Proteo"
  ],
  "EI24P3": [
    "EI24P3 CNV",
    "EI24P3 RNA"
  ],
  "WWC3": [
    "WWC3 CNV",
    "WWC3 RNA",
    "WWC3 Proteo"
  ],
  "LMO2": [
    "LMO2 CNV",
    "LMO2 RNA"
  ],
  "RNASE13": [
    "RNASE13 CNV",
    "RNASE13 RNA"
  ],
  "RBMY2AP": [
    "RBMY2AP CNV",
    "RBMY2AP RNA"
  ],
  "LY6D": [
    "LY6D CNV",
    "LY6D RNA",
    "LY6D Proteo"
  ],
  "PKHD1L1": [
    "PKHD1L1 CNV",
    "PKHD1L1 RNA"
  ],
  "HPRT1": [
    "HPRT1 CNV",
    "HPRT1 RNA",
    "HPRT1 Proteo"
  ],
  "PRR13P4": [
    "PRR13P4 CNV",
    "PRR13P4 RNA"
  ],
  "EPOR": [
    "EPOR CNV",
    "EPOR RNA"
  ],
  "NHS": [
    "NHS CNV",
    "NHS RNA",
    "NHS Proteo"
  ],
  "STIP1": [
    "STIP1 CNV",
    "STIP1 RNA",
    "STIP1 Proteo"
  ],
  "TLR5": [
    "TLR5 CNV",
    "TLR5 RNA",
    "TLR5 Proteo"
  ],
  "EIF4EBP2P2": [
    "EIF4EBP2P2 CNV",
    "EIF4EBP2P2 RNA"
  ],
  "S100A11P10": [
    "S100A11P10 CNV",
    "S100A11P10 RNA"
  ],
  "SOCS5P3": [
    "SOCS5P3 CNV",
    "SOCS5P3 RNA"
  ],
  "CDRT15P3": [
    "CDRT15P3 CNV",
    "CDRT15P3 RNA"
  ],
  "GPX1P2": [
    "GPX1P2 CNV",
    "GPX1P2 RNA"
  ],
  "SLC23A1": [
    "SLC23A1 CNV",
    "SLC23A1 RNA"
  ],
  "EVA1A": [
    "EVA1A CNV",
    "EVA1A RNA",
    "EVA1A Proteo"
  ],
  "ATRN": [
    "ATRN CNV",
    "ATRN RNA",
    "ATRN Proteo"
  ],
  "LRRC37A11P": [
    "LRRC37A11P CNV",
    "LRRC37A11P RNA"
  ],
  "ANKRD49": [
    "ANKRD49 CNV",
    "ANKRD49 RNA",
    "ANKRD49 Proteo"
  ],
  "PSME2P6": [
    "PSME2P6 CNV",
    "PSME2P6 RNA"
  ],
  "MOCOS": [
    "MOCOS CNV",
    "MOCOS RNA",
    "MOCOS Proteo"
  ],
  "SMG1P5": [
    "SMG1P5 CNV",
    "SMG1P5 RNA"
  ],
  "TAF13P2": [
    "TAF13P2 CNV",
    "TAF13P2 RNA"
  ],
  "FAM189B": [
    "FAM189B CNV",
    "FAM189B RNA"
  ],
  "PEX6": [
    "PEX6 CNV",
    "PEX6 RNA",
    "PEX6 Proteo"
  ],
  "NXNP1": [
    "NXNP1 CNV",
    "NXNP1 RNA"
  ],
  "ZMYND19": [
    "ZMYND19 CNV",
    "ZMYND19 RNA"
  ],
  "P2RY4": [
    "P2RY4 CNV",
    "P2RY4 RNA"
  ],
  "IGSF9": [
    "IGSF9 CNV",
    "IGSF9 RNA"
  ],
  "MAGEB10": [
    "MAGEB10 CNV",
    "MAGEB10 RNA"
  ],
  "PSMA2P2": [
    "PSMA2P2 CNV",
    "PSMA2P2 RNA"
  ],
  "LRP10": [
    "LRP10 CNV",
    "LRP10 RNA",
    "LRP10 Proteo"
  ],
  "HAPLN3": [
    "HAPLN3 CNV",
    "HAPLN3 RNA",
    "HAPLN3 Proteo"
  ],
  "MTATP6P4": [
    "MTATP6P4 CNV",
    "MTATP6P4 RNA"
  ],
  "SAR1AP3": [
    "SAR1AP3 CNV",
    "SAR1AP3 RNA"
  ],
  "THSD1P1": [
    "THSD1P1 CNV",
    "THSD1P1 RNA"
  ],
  "IZUMO1R": [
    "IZUMO1R CNV",
    "IZUMO1R RNA"
  ],
  "CD99": [
    "CD99 CNV",
    "CD99 RNA",
    "CD99 Proteo"
  ],
  "USP8P1": [
    "USP8P1 CNV",
    "USP8P1 RNA"
  ],
  "LRP3": [
    "LRP3 CNV",
    "LRP3 RNA",
    "LRP3 Proteo"
  ],
  "LCE2D": [
    "LCE2D CNV",
    "LCE2D RNA"
  ],
  "RPL30P5": [
    "RPL30P5 CNV",
    "RPL30P5 RNA"
  ],
  "C1QTNF5": [
    "C1QTNF5 CNV",
    "C1QTNF5 RNA",
    "C1QTNF5 Proteo"
  ],
  "OR51F1": [
    "OR51F1 CNV",
    "OR51F1 RNA"
  ],
  "NR2E1": [
    "NR2E1 CNV",
    "NR2E1 RNA"
  ],
  "NOC2L": [
    "NOC2L CNV",
    "NOC2L RNA",
    "NOC2L Proteo"
  ],
  "SEC13": [
    "SEC13 CNV",
    "SEC13 RNA",
    "SEC13 Proteo"
  ],
  "SPATA1": [
    "SPATA1 CNV",
    "SPATA1 RNA"
  ],
  "SKAP2": [
    "SKAP2 CNV",
    "SKAP2 RNA",
    "SKAP2 Proteo"
  ],
  "CHGA": [
    "CHGA CNV",
    "CHGA RNA"
  ],
  "PRAMEF8": [
    "PRAMEF8 CNV",
    "PRAMEF8 RNA"
  ],
  "MMP7": [
    "MMP7 CNV",
    "MMP7 RNA"
  ],
  "ADAD1P2": [
    "ADAD1P2 CNV",
    "ADAD1P2 RNA"
  ],
  "PRDM14": [
    "PRDM14 CNV",
    "PRDM14 RNA"
  ],
  "RPL7P9": [
    "RPL7P9 CNV",
    "RPL7P9 RNA"
  ],
  "KRTAP7-1": [
    "KRTAP7-1 CNV",
    "KRTAP7-1 RNA"
  ],
  "LIPF": [
    "LIPF CNV",
    "LIPF RNA"
  ],
  "KRT8P19": [
    "KRT8P19 CNV",
    "KRT8P19 RNA"
  ],
  "ZNF473": [
    "ZNF473 CNV",
    "ZNF473 RNA"
  ],
  "GPRC5A": [
    "GPRC5A CNV",
    "GPRC5A RNA",
    "GPRC5A Proteo"
  ],
  "RNF121": [
    "RNF121 CNV",
    "RNF121 RNA",
    "RNF121 Proteo"
  ],
  "FLT1": [
    "FLT1 CNV",
    "FLT1 RNA",
    "FLT1 Proteo"
  ],
  "FRG2LP": [
    "FRG2LP CNV",
    "FRG2LP RNA"
  ],
  "RPL10P9": [
    "RPL10P9 CNV",
    "RPL10P9 RNA"
  ],
  "AKR1B10P1": [
    "AKR1B10P1 CNV",
    "AKR1B10P1 RNA"
  ],
  "MTCO3P41": [
    "MTCO3P41 CNV",
    "MTCO3P41 RNA"
  ],
  "DCAF8L1": [
    "DCAF8L1 CNV",
    "DCAF8L1 RNA",
    "DCAF8L1 Proteo"
  ],
  "PSMC1P10": [
    "PSMC1P10 CNV",
    "PSMC1P10 RNA"
  ],
  "OR4N5": [
    "OR4N5 CNV",
    "OR4N5 RNA"
  ],
  "ABCD1P3": [
    "ABCD1P3 CNV",
    "ABCD1P3 RNA"
  ],
  "CYP2C61P": [
    "CYP2C61P CNV",
    "CYP2C61P RNA"
  ],
  "GH1": [
    "GH1 CNV",
    "GH1 RNA"
  ],
  "SNRNP200": [
    "SNRNP200 CNV",
    "SNRNP200 RNA",
    "SNRNP200 Proteo"
  ],
  "RPS15AP1": [
    "RPS15AP1 CNV",
    "RPS15AP1 RNA"
  ],
  "MED1": [
    "MED1 CNV",
    "MED1 RNA",
    "MED1 Proteo"
  ],
  "WWP1P1": [
    "WWP1P1 CNV",
    "WWP1P1 RNA"
  ],
  "PLAAT2": [
    "PLAAT2 CNV",
    "PLAAT2 RNA"
  ],
  "GIT2": [
    "GIT2 CNV",
    "GIT2 RNA",
    "GIT2 Proteo"
  ],
  "KANK2": [
    "KANK2 CNV",
    "KANK2 RNA",
    "KANK2 Proteo"
  ],
  "CDPF1P1": [
    "CDPF1P1 CNV",
    "CDPF1P1 RNA"
  ],
  "RNA5SP96": [
    "RNA5SP96 CNV",
    "RNA5SP96 RNA"
  ],
  "ZNF732": [
    "ZNF732 CNV",
    "ZNF732 RNA",
    "ZNF732 Proteo"
  ],
  "GNRH2": [
    "GNRH2 CNV",
    "GNRH2 RNA"
  ],
  "RAB40A": [
    "RAB40A CNV",
    "RAB40A RNA"
  ],
  "LIMD2": [
    "LIMD2 CNV",
    "LIMD2 RNA",
    "LIMD2 Proteo"
  ],
  "MAB21L3": [
    "MAB21L3 CNV",
    "MAB21L3 RNA"
  ],
  "MACF1": [
    "MACF1 CNV",
    "MACF1 RNA",
    "MACF1 Proteo"
  ],
  "SLC25A44": [
    "SLC25A44 CNV",
    "SLC25A44 RNA",
    "SLC25A44 Proteo"
  ],
  "TAS2R14": [
    "TAS2R14 CNV",
    "TAS2R14 RNA"
  ],
  "OR13K1P": [
    "OR13K1P CNV",
    "OR13K1P RNA"
  ],
  "CHSY1": [
    "CHSY1 CNV",
    "CHSY1 RNA",
    "CHSY1 Proteo"
  ],
  "POTEC": [
    "POTEC CNV",
    "POTEC RNA"
  ],
  "HMGB1P20": [
    "HMGB1P20 CNV",
    "HMGB1P20 RNA"
  ],
  "MTCO1P15": [
    "MTCO1P15 CNV",
    "MTCO1P15 RNA"
  ],
  "LSP1P3": [
    "LSP1P3 CNV",
    "LSP1P3 RNA"
  ],
  "HMGB1P18": [
    "HMGB1P18 CNV",
    "HMGB1P18 RNA"
  ],
  "SOAT1": [
    "SOAT1 CNV",
    "SOAT1 RNA",
    "SOAT1 Proteo"
  ],
  "GARIN3P1": [
    "GARIN3P1 CNV",
    "GARIN3P1 RNA"
  ],
  "TMPRSS11BNL": [
    "TMPRSS11BNL CNV",
    "TMPRSS11BNL RNA"
  ],
  "COL8A1": [
    "COL8A1 CNV",
    "COL8A1 RNA",
    "COL8A1 Proteo"
  ],
  "GOLGA6L1": [
    "GOLGA6L1 CNV",
    "GOLGA6L1 RNA"
  ],
  "NOP16": [
    "NOP16 CNV",
    "NOP16 RNA",
    "NOP16 Proteo"
  ],
  "PTGR3": [
    "PTGR3 CNV",
    "PTGR3 RNA",
    "PTGR3 Proteo"
  ],
  "CACYBP": [
    "CACYBP CNV",
    "CACYBP RNA",
    "CACYBP Proteo"
  ],
  "CYP3A7": [
    "CYP3A7 CNV",
    "CYP3A7 RNA"
  ],
  "TRMT2B": [
    "TRMT2B CNV",
    "TRMT2B RNA",
    "TRMT2B Proteo"
  ],
  "SAMD13": [
    "SAMD13 CNV",
    "SAMD13 RNA"
  ],
  "ABHD6": [
    "ABHD6 CNV",
    "ABHD6 RNA",
    "ABHD6 Proteo"
  ],
  "CHSY3": [
    "CHSY3 CNV",
    "CHSY3 RNA",
    "CHSY3 Proteo"
  ],
  "HMGN2P40": [
    "HMGN2P40 CNV",
    "HMGN2P40 RNA"
  ],
  "ANKRD16": [
    "ANKRD16 CNV",
    "ANKRD16 RNA",
    "ANKRD16 Proteo"
  ],
  "MTCO3P19": [
    "MTCO3P19 CNV",
    "MTCO3P19 RNA"
  ],
  "SNX19P2": [
    "SNX19P2 CNV",
    "SNX19P2 RNA"
  ],
  "C1orf94": [
    "C1orf94 CNV",
    "C1orf94 RNA"
  ],
  "TMPRSS11CP": [
    "TMPRSS11CP CNV",
    "TMPRSS11CP RNA"
  ],
  "LAIR1": [
    "LAIR1 CNV",
    "LAIR1 RNA",
    "LAIR1 Proteo"
  ],
  "NSMCE1": [
    "NSMCE1 CNV",
    "NSMCE1 RNA",
    "NSMCE1 Proteo"
  ],
  "RPLP0P4": [
    "RPLP0P4 CNV",
    "RPLP0P4 RNA"
  ],
  "DSP": [
    "DSP CNV",
    "DSP RNA",
    "DSP Proteo"
  ],
  "SNRPCP8": [
    "SNRPCP8 CNV",
    "SNRPCP8 RNA"
  ],
  "PCDHA2": [
    "PCDHA2 CNV",
    "PCDHA2 RNA"
  ],
  "FCER1A": [
    "FCER1A CNV",
    "FCER1A RNA"
  ],
  "RNA5SP459": [
    "RNA5SP459 CNV",
    "RNA5SP459 RNA"
  ],
  "HTT": [
    "HTT CNV",
    "HTT RNA",
    "HTT Proteo"
  ],
  "OR9Q1": [
    "OR9Q1 CNV",
    "OR9Q1 RNA"
  ],
  "STAT6": [
    "STAT6 CNV",
    "STAT6 RNA",
    "STAT6 Proteo"
  ],
  "OR7E117P": [
    "OR7E117P CNV",
    "OR7E117P RNA"
  ],
  "WDR11": [
    "WDR11 CNV",
    "WDR11 RNA",
    "WDR11 Proteo"
  ],
  "SPAG9": [
    "SPAG9 CNV",
    "SPAG9 RNA",
    "SPAG9 Proteo"
  ],
  "USP9YP16": [
    "USP9YP16 CNV",
    "USP9YP16 RNA"
  ],
  "OR51E1": [
    "OR51E1 CNV",
    "OR51E1 RNA"
  ],
  "PTPN11": [
    "PTPN11 CNV",
    "PTPN11 RNA",
    "PTPN11 Proteo"
  ],
  "TAF1L": [
    "TAF1L CNV",
    "TAF1L RNA"
  ],
  "NPPB": [
    "NPPB CNV",
    "NPPB RNA"
  ],
  "KARS1P3": [
    "KARS1P3 CNV",
    "KARS1P3 RNA"
  ],
  "HSPD1P2": [
    "HSPD1P2 CNV",
    "HSPD1P2 RNA"
  ],
  "ATP5MC3": [
    "ATP5MC3 CNV",
    "ATP5MC3 RNA",
    "ATP5MC3 Proteo"
  ],
  "BPHL": [
    "BPHL CNV",
    "BPHL RNA",
    "BPHL Proteo"
  ],
  "OR51D1": [
    "OR51D1 CNV",
    "OR51D1 RNA"
  ],
  "FAXDC2": [
    "FAXDC2 CNV",
    "FAXDC2 RNA"
  ],
  "GASK1B": [
    "GASK1B CNV",
    "GASK1B RNA",
    "GASK1B Proteo"
  ],
  "KPNA2": [
    "KPNA2 CNV",
    "KPNA2 RNA",
    "KPNA2 Proteo"
  ],
  "BPY2DP": [
    "BPY2DP CNV",
    "BPY2DP RNA"
  ],
  "TAS2R62P": [
    "TAS2R62P CNV",
    "TAS2R62P RNA"
  ],
  "MYO9A": [
    "MYO9A CNV",
    "MYO9A RNA",
    "MYO9A Proteo"
  ],
  "RPS4XP10": [
    "RPS4XP10 CNV",
    "RPS4XP10 RNA"
  ],
  "RNA5SP233": [
    "RNA5SP233 CNV",
    "RNA5SP233 RNA"
  ],
  "SMIM24": [
    "SMIM24 CNV",
    "SMIM24 RNA",
    "SMIM24 Proteo"
  ],
  "DEFB103B": [
    "DEFB103B CNV",
    "DEFB103B RNA"
  ],
  "SETD6P1": [
    "SETD6P1 CNV",
    "SETD6P1 RNA"
  ],
  "SVIL": [
    "SVIL CNV",
    "SVIL RNA",
    "SVIL Proteo"
  ],
  "AIPL1": [
    "AIPL1 CNV",
    "AIPL1 RNA"
  ],
  "DPT": [
    "DPT CNV",
    "DPT RNA",
    "DPT Proteo"
  ],
  "RAP1BP3": [
    "RAP1BP3 CNV",
    "RAP1BP3 RNA"
  ],
  "S100A7A": [
    "S100A7A CNV",
    "S100A7A RNA",
    "S100A7A Proteo"
  ],
  "TMEM138": [
    "TMEM138 CNV",
    "TMEM138 RNA",
    "TMEM138 Proteo"
  ],
  "MFSD14C": [
    "MFSD14C CNV",
    "MFSD14C RNA"
  ],
  "TCERG1L": [
    "TCERG1L CNV",
    "TCERG1L RNA"
  ],
  "REG1A": [
    "REG1A CNV",
    "REG1A RNA"
  ],
  "MMP10": [
    "MMP10 CNV",
    "MMP10 RNA"
  ],
  "MKLN1": [
    "MKLN1 CNV",
    "MKLN1 RNA",
    "MKLN1 Proteo"
  ],
  "LARP1BP3": [
    "LARP1BP3 CNV",
    "LARP1BP3 RNA"
  ],
  "IGHV3-6": [
    "IGHV3-6 CNV",
    "IGHV3-6 RNA"
  ],
  "UBE2D3P2": [
    "UBE2D3P2 CNV",
    "UBE2D3P2 RNA"
  ],
  "DPP4": [
    "DPP4 CNV",
    "DPP4 RNA",
    "DPP4 Proteo"
  ],
  "TMEM154": [
    "TMEM154 CNV",
    "TMEM154 RNA"
  ],
  "YJEFN3": [
    "YJEFN3 CNV",
    "YJEFN3 RNA"
  ],
  "MAP4K3": [
    "MAP4K3 CNV",
    "MAP4K3 RNA",
    "MAP4K3 Proteo"
  ],
  "CFAP91": [
    "CFAP91 CNV",
    "CFAP91 RNA"
  ],
  "RNA5SP377": [
    "RNA5SP377 CNV",
    "RNA5SP377 RNA"
  ],
  "MOSPD2": [
    "MOSPD2 CNV",
    "MOSPD2 RNA",
    "MOSPD2 Proteo"
  ],
  "HMGN4": [
    "HMGN4 CNV",
    "HMGN4 RNA",
    "HMGN4 Proteo"
  ],
  "AMER3": [
    "AMER3 CNV",
    "AMER3 RNA"
  ],
  "CEACAM20": [
    "CEACAM20 CNV",
    "CEACAM20 RNA"
  ],
  "CST13P": [
    "CST13P CNV",
    "CST13P RNA"
  ],
  "GUSBP6": [
    "GUSBP6 CNV",
    "GUSBP6 RNA"
  ],
  "SYNPO2": [
    "SYNPO2 CNV",
    "SYNPO2 RNA",
    "SYNPO2 Proteo"
  ],
  "RNA5SP494": [
    "RNA5SP494 CNV",
    "RNA5SP494 RNA"
  ],
  "RPSAP64": [
    "RPSAP64 CNV",
    "RPSAP64 RNA"
  ],
  "LRP5L": [
    "LRP5L CNV",
    "LRP5L RNA"
  ],
  "OR13C5": [
    "OR13C5 CNV",
    "OR13C5 RNA"
  ],
  "APPBP2": [
    "APPBP2 CNV",
    "APPBP2 RNA",
    "APPBP2 Proteo"
  ],
  "HMGB1P37": [
    "HMGB1P37 CNV",
    "HMGB1P37 RNA"
  ],
  "RPL23AP78": [
    "RPL23AP78 CNV",
    "RPL23AP78 RNA"
  ],
  "ARSK": [
    "ARSK CNV",
    "ARSK RNA",
    "ARSK Proteo"
  ],
  "NPM1P13": [
    "NPM1P13 CNV",
    "NPM1P13 RNA"
  ],
  "EZH2": [
    "EZH2 CNV",
    "EZH2 RNA",
    "EZH2 Proteo"
  ],
  "BAHD1": [
    "BAHD1 CNV",
    "BAHD1 RNA",
    "BAHD1 Proteo"
  ],
  "OR8S21P": [
    "OR8S21P CNV",
    "OR8S21P RNA"
  ],
  "TMC8": [
    "TMC8 CNV",
    "TMC8 RNA",
    "TMC8 Proteo"
  ],
  "MTND2P38": [
    "MTND2P38 CNV",
    "MTND2P38 RNA"
  ],
  "C1orf210": [
    "C1orf210 CNV",
    "C1orf210 RNA"
  ],
  "MYLK2": [
    "MYLK2 CNV",
    "MYLK2 RNA"
  ],
  "MAB21L4": [
    "MAB21L4 CNV",
    "MAB21L4 RNA",
    "MAB21L4 Proteo"
  ],
  "PLEKHG4B": [
    "PLEKHG4B CNV",
    "PLEKHG4B RNA",
    "PLEKHG4B Proteo"
  ],
  "CRLS1": [
    "CRLS1 CNV",
    "CRLS1 RNA"
  ],
  "HSPB8": [
    "HSPB8 CNV",
    "HSPB8 RNA",
    "HSPB8 Proteo"
  ],
  "MED7": [
    "MED7 CNV",
    "MED7 RNA",
    "MED7 Proteo"
  ],
  "ZNF595": [
    "ZNF595 CNV",
    "ZNF595 RNA",
    "ZNF595 Proteo"
  ],
  "DYNAPP3": [
    "DYNAPP3 CNV",
    "DYNAPP3 RNA"
  ],
  "USP9YP21": [
    "USP9YP21 CNV",
    "USP9YP21 RNA"
  ],
  "GM2AP1": [
    "GM2AP1 CNV",
    "GM2AP1 RNA"
  ],
  "TDRP": [
    "TDRP CNV",
    "TDRP RNA",
    "TDRP Proteo"
  ],
  "ZNF24": [
    "ZNF24 CNV",
    "ZNF24 RNA",
    "ZNF24 Proteo"
  ],
  "XYLT1": [
    "XYLT1 CNV",
    "XYLT1 RNA",
    "XYLT1 Proteo"
  ],
  "RPL7L1P7": [
    "RPL7L1P7 CNV",
    "RPL7L1P7 RNA"
  ],
  "NPRL3": [
    "NPRL3 CNV",
    "NPRL3 RNA",
    "NPRL3 Proteo"
  ],
  "ZHX1": [
    "ZHX1 CNV",
    "ZHX1 RNA",
    "ZHX1 Proteo"
  ],
  "SNORC": [
    "SNORC CNV",
    "SNORC RNA"
  ],
  "MRGPRX3": [
    "MRGPRX3 CNV",
    "MRGPRX3 RNA"
  ],
  "PSMA3P1": [
    "PSMA3P1 CNV",
    "PSMA3P1 RNA"
  ],
  "ZNF516": [
    "ZNF516 CNV",
    "ZNF516 RNA",
    "ZNF516 Proteo"
  ],
  "MTND1P7": [
    "MTND1P7 CNV",
    "MTND1P7 RNA"
  ],
  "NDUFB4P11": [
    "NDUFB4P11 CNV",
    "NDUFB4P11 RNA"
  ],
  "PPP1R9A": [
    "PPP1R9A CNV",
    "PPP1R9A RNA",
    "PPP1R9A Proteo"
  ],
  "CYP3A4": [
    "CYP3A4 CNV",
    "CYP3A4 RNA"
  ],
  "HNRNPCP9": [
    "HNRNPCP9 CNV",
    "HNRNPCP9 RNA"
  ],
  "MAGOH3P": [
    "MAGOH3P CNV",
    "MAGOH3P RNA"
  ],
  "FCRL3": [
    "FCRL3 CNV",
    "FCRL3 RNA"
  ],
  "PDPK2P": [
    "PDPK2P CNV",
    "PDPK2P RNA"
  ],
  "CNPPD1": [
    "CNPPD1 CNV",
    "CNPPD1 RNA"
  ],
  "SLIRPP1": [
    "SLIRPP1 CNV",
    "SLIRPP1 RNA"
  ],
  "MRE11P1": [
    "MRE11P1 CNV",
    "MRE11P1 RNA"
  ],
  "MTND4LP5": [
    "MTND4LP5 CNV",
    "MTND4LP5 RNA"
  ],
  "ANKRD20A5P": [
    "ANKRD20A5P CNV",
    "ANKRD20A5P RNA"
  ],
  "LPCAT2": [
    "LPCAT2 CNV",
    "LPCAT2 RNA",
    "LPCAT2 Proteo"
  ],
  "SIN3A": [
    "SIN3A CNV",
    "SIN3A RNA",
    "SIN3A Proteo"
  ],
  "OR3A1": [
    "OR3A1 CNV",
    "OR3A1 RNA"
  ],
  "BHLHA15": [
    "BHLHA15 CNV",
    "BHLHA15 RNA",
    "BHLHA15 Proteo"
  ],
  "GAPDHP39": [
    "GAPDHP39 CNV",
    "GAPDHP39 RNA"
  ],
  "NKX2-4": [
    "NKX2-4 CNV",
    "NKX2-4 RNA",
    "NKX2-4 Proteo"
  ],
  "ATP5MGP5": [
    "ATP5MGP5 CNV",
    "ATP5MGP5 RNA"
  ],
  "MT1X": [
    "MT1X CNV",
    "MT1X RNA",
    "MT1X Proteo"
  ],
  "MISP": [
    "MISP CNV",
    "MISP RNA",
    "MISP Proteo"
  ],
  "CSKMT": [
    "CSKMT CNV",
    "CSKMT RNA"
  ],
  "HNRNPCP8": [
    "HNRNPCP8 CNV",
    "HNRNPCP8 RNA"
  ],
  "HAUS5": [
    "HAUS5 CNV",
    "HAUS5 RNA",
    "HAUS5 Proteo"
  ],
  "RPL23AP38": [
    "RPL23AP38 CNV",
    "RPL23AP38 RNA"
  ],
  "TTTY23B": [
    "TTTY23B CNV",
    "TTTY23B RNA"
  ],
  "CCAR2": [
    "CCAR2 CNV",
    "CCAR2 RNA",
    "CCAR2 Proteo"
  ],
  "HPRT1P1": [
    "HPRT1P1 CNV",
    "HPRT1P1 RNA"
  ],
  "NUAK2": [
    "NUAK2 CNV",
    "NUAK2 RNA",
    "NUAK2 Proteo"
  ],
  "CHCHD2P11": [
    "CHCHD2P11 CNV",
    "CHCHD2P11 RNA"
  ],
  "ATCAY": [
    "ATCAY CNV",
    "ATCAY RNA"
  ],
  "CNNM2": [
    "CNNM2 CNV",
    "CNNM2 RNA",
    "CNNM2 Proteo"
  ],
  "MTND5P22": [
    "MTND5P22 CNV",
    "MTND5P22 RNA"
  ],
  "SRMP1": [
    "SRMP1 CNV",
    "SRMP1 RNA"
  ],
  "STX3": [
    "STX3 CNV",
    "STX3 RNA",
    "STX3 Proteo"
  ],
  "LIPC": [
    "LIPC CNV",
    "LIPC RNA"
  ],
  "PIP4P2": [
    "PIP4P2 CNV",
    "PIP4P2 RNA",
    "PIP4P2 Proteo"
  ],
  "COX8C": [
    "COX8C CNV",
    "COX8C RNA"
  ],
  "SMIM41": [
    "SMIM41 CNV",
    "SMIM41 RNA"
  ],
  "ZNF91": [
    "ZNF91 CNV",
    "ZNF91 RNA",
    "ZNF91 Proteo"
  ],
  "H3C15": [
    "H3C15 CNV",
    "H3C15 RNA"
  ],
  "NRG3": [
    "NRG3 CNV",
    "NRG3 RNA"
  ],
  "OR2T29": [
    "OR2T29 CNV",
    "OR2T29 RNA"
  ],
  "GGCTP3": [
    "GGCTP3 CNV",
    "GGCTP3 RNA"
  ],
  "ZFAND2A": [
    "ZFAND2A CNV",
    "ZFAND2A RNA"
  ],
  "NANOS1": [
    "NANOS1 CNV",
    "NANOS1 RNA",
    "NANOS1 Proteo"
  ],
  "MAN2A1": [
    "MAN2A1 CNV",
    "MAN2A1 RNA",
    "MAN2A1 Proteo"
  ],
  "CYP2C59P": [
    "CYP2C59P CNV",
    "CYP2C59P RNA"
  ],
  "MUPP": [
    "MUPP CNV",
    "MUPP RNA"
  ],
  "PPP1R12A": [
    "PPP1R12A CNV",
    "PPP1R12A RNA",
    "PPP1R12A Proteo"
  ],
  "NPHP1": [
    "NPHP1 CNV",
    "NPHP1 RNA",
    "NPHP1 Proteo"
  ],
  "ARSA": [
    "ARSA CNV",
    "ARSA RNA",
    "ARSA Proteo"
  ],
  "CYB5R4": [
    "CYB5R4 CNV",
    "CYB5R4 RNA",
    "CYB5R4 Proteo"
  ],
  "RPS3AP54": [
    "RPS3AP54 CNV",
    "RPS3AP54 RNA"
  ],
  "CASP1": [
    "CASP1 CNV",
    "CASP1 RNA",
    "CASP1 Proteo"
  ],
  "DEPDC4": [
    "DEPDC4 CNV",
    "DEPDC4 RNA"
  ],
  "NOC2LP1": [
    "NOC2LP1 CNV",
    "NOC2LP1 RNA"
  ],
  "RPL14P1": [
    "RPL14P1 CNV",
    "RPL14P1 RNA"
  ],
  "PGLS": [
    "PGLS CNV",
    "PGLS RNA",
    "PGLS Proteo"
  ],
  "LRRC2P1": [
    "LRRC2P1 CNV",
    "LRRC2P1 RNA"
  ],
  "RNA5SP215": [
    "RNA5SP215 CNV",
    "RNA5SP215 RNA"
  ],
  "TTK": [
    "TTK CNV",
    "TTK RNA",
    "TTK Proteo"
  ],
  "ARHGAP25": [
    "ARHGAP25 CNV",
    "ARHGAP25 RNA",
    "ARHGAP25 Proteo"
  ],
  "PRKAB2": [
    "PRKAB2 CNV",
    "PRKAB2 RNA",
    "PRKAB2 Proteo"
  ],
  "ATF2": [
    "ATF2 CNV",
    "ATF2 RNA",
    "ATF2 Proteo"
  ],
  "ANKRD46": [
    "ANKRD46 CNV",
    "ANKRD46 RNA",
    "ANKRD46 Proteo"
  ],
  "DCAF13P1": [
    "DCAF13P1 CNV",
    "DCAF13P1 RNA"
  ],
  "DUSP28": [
    "DUSP28 CNV",
    "DUSP28 RNA",
    "DUSP28 Proteo"
  ],
  "MTCYBP43": [
    "MTCYBP43 CNV",
    "MTCYBP43 RNA"
  ],
  "ANKRD26": [
    "ANKRD26 CNV",
    "ANKRD26 RNA",
    "ANKRD26 Proteo"
  ],
  "HNRNPH1": [
    "HNRNPH1 CNV",
    "HNRNPH1 RNA",
    "HNRNPH1 Proteo"
  ],
  "AKR1C8": [
    "AKR1C8 CNV",
    "AKR1C8 RNA"
  ],
  "PPP2R2B": [
    "PPP2R2B CNV",
    "PPP2R2B RNA"
  ],
  "BEND7": [
    "BEND7 CNV",
    "BEND7 RNA"
  ],
  "OR10H5": [
    "OR10H5 CNV",
    "OR10H5 RNA"
  ],
  "GABRB3": [
    "GABRB3 CNV",
    "GABRB3 RNA"
  ],
  "DUSP3": [
    "DUSP3 CNV",
    "DUSP3 RNA",
    "DUSP3 Proteo"
  ],
  "PF4": [
    "PF4 CNV",
    "PF4 RNA"
  ],
  "GPRASP1": [
    "GPRASP1 CNV",
    "GPRASP1 RNA"
  ],
  "FAM210A": [
    "FAM210A CNV",
    "FAM210A RNA",
    "FAM210A Proteo"
  ],
  "STXBP1": [
    "STXBP1 CNV",
    "STXBP1 RNA",
    "STXBP1 Proteo"
  ],
  "RPL34P6": [
    "RPL34P6 CNV",
    "RPL34P6 RNA"
  ],
  "ATF1": [
    "ATF1 CNV",
    "ATF1 RNA",
    "ATF1 Proteo"
  ],
  "ILF2": [
    "ILF2 CNV",
    "ILF2 RNA",
    "ILF2 Proteo"
  ],
  "NR4A1": [
    "NR4A1 CNV",
    "NR4A1 RNA",
    "NR4A1 Proteo"
  ],
  "RAB24": [
    "RAB24 CNV",
    "RAB24 RNA",
    "RAB24 Proteo"
  ],
  "PRDM7": [
    "PRDM7 CNV",
    "PRDM7 RNA"
  ],
  "EXOC6B": [
    "EXOC6B CNV",
    "EXOC6B RNA",
    "EXOC6B Proteo"
  ],
  "TEX53": [
    "TEX53 CNV",
    "TEX53 RNA"
  ],
  "STMND1": [
    "STMND1 CNV",
    "STMND1 RNA"
  ],
  "CNTN3": [
    "CNTN3 CNV",
    "CNTN3 RNA",
    "CNTN3 Proteo"
  ],
  "GAPT": [
    "GAPT CNV",
    "GAPT RNA",
    "GAPT Proteo"
  ],
  "LRP1": [
    "LRP1 CNV",
    "LRP1 RNA",
    "LRP1 Proteo"
  ],
  "RFPL4AP3": [
    "RFPL4AP3 CNV",
    "RFPL4AP3 RNA"
  ],
  "HTR2C": [
    "HTR2C CNV",
    "HTR2C RNA"
  ],
  "TUBAP8": [
    "TUBAP8 CNV",
    "TUBAP8 RNA"
  ],
  "ITM2A": [
    "ITM2A CNV",
    "ITM2A RNA",
    "ITM2A Proteo"
  ],
  "LTBR": [
    "LTBR CNV",
    "LTBR RNA",
    "LTBR Proteo"
  ],
  "RPS29P6": [
    "RPS29P6 CNV",
    "RPS29P6 RNA"
  ],
  "ZNF863P": [
    "ZNF863P CNV",
    "ZNF863P RNA"
  ],
  "SP140L": [
    "SP140L CNV",
    "SP140L RNA",
    "SP140L Proteo"
  ],
  "PRXL2AP2": [
    "PRXL2AP2 CNV",
    "PRXL2AP2 RNA"
  ],
  "ESRP1": [
    "ESRP1 CNV",
    "ESRP1 RNA",
    "ESRP1 Proteo"
  ],
  "GGH": [
    "GGH CNV",
    "GGH RNA",
    "GGH Proteo"
  ],
  "HNRNPA1P28": [
    "HNRNPA1P28 CNV",
    "HNRNPA1P28 RNA"
  ],
  "HBA2": [
    "HBA2 CNV",
    "HBA2 RNA",
    "HBA2 Proteo"
  ],
  "GPATCH11P1": [
    "GPATCH11P1 CNV",
    "GPATCH11P1 RNA"
  ],
  "GJC3": [
    "GJC3 CNV",
    "GJC3 RNA"
  ],
  "PRSS21": [
    "PRSS21 CNV",
    "PRSS21 RNA"
  ],
  "GGNBP1": [
    "GGNBP1 CNV",
    "GGNBP1 RNA"
  ],
  "ARL5A": [
    "ARL5A CNV",
    "ARL5A RNA",
    "ARL5A Proteo"
  ],
  "FCHO1": [
    "FCHO1 CNV",
    "FCHO1 RNA",
    "FCHO1 Proteo"
  ],
  "EIF2S3B": [
    "EIF2S3B CNV",
    "EIF2S3B RNA"
  ],
  "C11orf42": [
    "C11orf42 CNV",
    "C11orf42 RNA"
  ],
  "TRAK1": [
    "TRAK1 CNV",
    "TRAK1 RNA",
    "TRAK1 Proteo"
  ],
  "LONRF2": [
    "LONRF2 CNV",
    "LONRF2 RNA",
    "LONRF2 Proteo"
  ],
  "KRTAP10-4": [
    "KRTAP10-4 CNV",
    "KRTAP10-4 RNA"
  ],
  "IL22RA1": [
    "IL22RA1 CNV",
    "IL22RA1 RNA"
  ],
  "ISL2": [
    "ISL2 CNV",
    "ISL2 RNA"
  ],
  "MSTO1": [
    "MSTO1 CNV",
    "MSTO1 RNA",
    "MSTO1 Proteo"
  ],
  "BBLN": [
    "BBLN CNV",
    "BBLN RNA",
    "BBLN Proteo"
  ],
  "PHB1P20": [
    "PHB1P20 CNV",
    "PHB1P20 RNA"
  ],
  "ZFYVE28": [
    "ZFYVE28 CNV",
    "ZFYVE28 RNA",
    "ZFYVE28 Proteo"
  ],
  "COQ10BP2": [
    "COQ10BP2 CNV",
    "COQ10BP2 RNA"
  ],
  "TPRKBP1": [
    "TPRKBP1 CNV",
    "TPRKBP1 RNA"
  ],
  "SETP7": [
    "SETP7 CNV",
    "SETP7 RNA"
  ],
  "WDR59": [
    "WDR59 CNV",
    "WDR59 RNA",
    "WDR59 Proteo"
  ],
  "MBD1": [
    "MBD1 CNV",
    "MBD1 RNA",
    "MBD1 Proteo"
  ],
  "CFL1P6": [
    "CFL1P6 CNV",
    "CFL1P6 RNA"
  ],
  "HINFP": [
    "HINFP CNV",
    "HINFP RNA"
  ],
  "EEF1A1P21": [
    "EEF1A1P21 CNV",
    "EEF1A1P21 RNA"
  ],
  "FBLL1": [
    "FBLL1 CNV",
    "FBLL1 RNA",
    "FBLL1 Proteo"
  ],
  "OR5B1P": [
    "OR5B1P CNV",
    "OR5B1P RNA"
  ],
  "EBP": [
    "EBP CNV",
    "EBP RNA",
    "EBP Proteo"
  ],
  "KCTD9P5": [
    "KCTD9P5 CNV",
    "KCTD9P5 RNA"
  ],
  "NTAQ1": [
    "NTAQ1 CNV",
    "NTAQ1 RNA",
    "NTAQ1 Proteo"
  ],
  "DERL3": [
    "DERL3 CNV",
    "DERL3 RNA",
    "DERL3 Proteo"
  ],
  "PPP1R26P3": [
    "PPP1R26P3 CNV",
    "PPP1R26P3 RNA"
  ],
  "MPP1": [
    "MPP1 CNV",
    "MPP1 RNA",
    "MPP1 Proteo"
  ],
  "TAF2": [
    "TAF2 CNV",
    "TAF2 RNA",
    "TAF2 Proteo"
  ],
  "PSCA": [
    "PSCA CNV",
    "PSCA RNA",
    "PSCA Proteo"
  ],
  "ADCYAP1": [
    "ADCYAP1 CNV",
    "ADCYAP1 RNA"
  ],
  "GXYLT1P7": [
    "GXYLT1P7 CNV",
    "GXYLT1P7 RNA"
  ],
  "EEF1A1P18": [
    "EEF1A1P18 CNV",
    "EEF1A1P18 RNA"
  ],
  "PICALM": [
    "PICALM CNV",
    "PICALM RNA",
    "PICALM Proteo"
  ],
  "C12orf60": [
    "C12orf60 CNV",
    "C12orf60 RNA"
  ],
  "PYGO2": [
    "PYGO2 CNV",
    "PYGO2 RNA",
    "PYGO2 Proteo"
  ],
  "TPT1P1": [
    "TPT1P1 CNV",
    "TPT1P1 RNA"
  ],
  "AMBRA1": [
    "AMBRA1 CNV",
    "AMBRA1 RNA",
    "AMBRA1 Proteo"
  ],
  "OR4G4P": [
    "OR4G4P CNV",
    "OR4G4P RNA"
  ],
  "CC2D2A": [
    "CC2D2A CNV",
    "CC2D2A RNA",
    "CC2D2A Proteo"
  ],
  "SCO1": [
    "SCO1 CNV",
    "SCO1 RNA",
    "SCO1 Proteo"
  ],
  "ZG16": [
    "ZG16 CNV",
    "ZG16 RNA"
  ],
  "KIAA2013": [
    "KIAA2013 CNV",
    "KIAA2013 RNA",
    "KIAA2013 Proteo"
  ],
  "GNB1L": [
    "GNB1L CNV",
    "GNB1L RNA",
    "GNB1L Proteo"
  ],
  "LINC01145": [
    "LINC01145 CNV",
    "LINC01145 RNA"
  ],
  "CST5": [
    "CST5 CNV",
    "CST5 RNA",
    "CST5 Proteo"
  ],
  "RPL27A": [
    "RPL27A CNV",
    "RPL27A RNA",
    "RPL27A Proteo"
  ],
  "RBM20": [
    "RBM20 CNV",
    "RBM20 RNA",
    "RBM20 Proteo"
  ],
  "NBPF8": [
    "NBPF8 CNV",
    "NBPF8 RNA"
  ],
  "SH3GLB2": [
    "SH3GLB2 CNV",
    "SH3GLB2 RNA",
    "SH3GLB2 Proteo"
  ],
  "RFWD3": [
    "RFWD3 CNV",
    "RFWD3 RNA",
    "RFWD3 Proteo"
  ],
  "MTND1P28": [
    "MTND1P28 CNV",
    "MTND1P28 RNA"
  ],
  "UBA2": [
    "UBA2 CNV",
    "UBA2 RNA",
    "UBA2 Proteo"
  ],
  "ZFAND6": [
    "ZFAND6 CNV",
    "ZFAND6 RNA",
    "ZFAND6 Proteo"
  ],
  "TBC1D30": [
    "TBC1D30 CNV",
    "TBC1D30 RNA"
  ],
  "EXOSC10": [
    "EXOSC10 CNV",
    "EXOSC10 RNA",
    "EXOSC10 Proteo"
  ],
  "OFD1P3Y": [
    "OFD1P3Y CNV",
    "OFD1P3Y RNA"
  ],
  "MRPL20P1": [
    "MRPL20P1 CNV",
    "MRPL20P1 RNA"
  ],
  "LINC03028": [
    "LINC03028 CNV",
    "LINC03028 RNA"
  ],
  "EIF4E": [
    "EIF4E CNV",
    "EIF4E RNA",
    "EIF4E Proteo"
  ],
  "VDAC1P9": [
    "VDAC1P9 CNV",
    "VDAC1P9 RNA"
  ],
  "SMARCE1P5": [
    "SMARCE1P5 CNV",
    "SMARCE1P5 RNA"
  ],
  "NPW": [
    "NPW CNV",
    "NPW RNA"
  ],
  "TET1P1": [
    "TET1P1 CNV",
    "TET1P1 RNA"
  ],
  "ZC3H11B": [
    "ZC3H11B CNV",
    "ZC3H11B RNA"
  ],
  "BRK1P1": [
    "BRK1P1 CNV",
    "BRK1P1 RNA"
  ],
  "ZNF877P": [
    "ZNF877P CNV",
    "ZNF877P RNA"
  ],
  "SLC32A1": [
    "SLC32A1 CNV",
    "SLC32A1 RNA"
  ],
  "CCDC136": [
    "CCDC136 CNV",
    "CCDC136 RNA"
  ],
  "ISCA1P2": [
    "ISCA1P2 CNV",
    "ISCA1P2 RNA"
  ],
  "CYP2T1P": [
    "CYP2T1P CNV",
    "CYP2T1P RNA"
  ],
  "ZNF92P2": [
    "ZNF92P2 CNV",
    "ZNF92P2 RNA"
  ],
  "MAT2A": [
    "MAT2A CNV",
    "MAT2A RNA",
    "MAT2A Proteo"
  ],
  "SBF1P1": [
    "SBF1P1 CNV",
    "SBF1P1 RNA"
  ],
  "PSD3": [
    "PSD3 CNV",
    "PSD3 RNA",
    "PSD3 Proteo"
  ],
  "H3P42": [
    "H3P42 CNV",
    "H3P42 RNA"
  ],
  "DBX1": [
    "DBX1 CNV",
    "DBX1 RNA"
  ],
  "CLK4": [
    "CLK4 CNV",
    "CLK4 RNA",
    "CLK4 Proteo"
  ],
  "SREK1": [
    "SREK1 CNV",
    "SREK1 RNA",
    "SREK1 Proteo"
  ],
  "OR2F2": [
    "OR2F2 CNV",
    "OR2F2 RNA"
  ],
  "USP9YP34": [
    "USP9YP34 CNV",
    "USP9YP34 RNA"
  ],
  "PTGER4P3": [
    "PTGER4P3 CNV",
    "PTGER4P3 RNA"
  ],
  "WEE1P2": [
    "WEE1P2 CNV",
    "WEE1P2 RNA"
  ],
  "RPSAP63": [
    "RPSAP63 CNV",
    "RPSAP63 RNA"
  ],
  "LHPP": [
    "LHPP CNV",
    "LHPP RNA",
    "LHPP Proteo"
  ],
  "RTN3": [
    "RTN3 CNV",
    "RTN3 RNA",
    "RTN3 Proteo"
  ],
  "MAGEB2": [
    "MAGEB2 CNV",
    "MAGEB2 RNA",
    "MAGEB2 Proteo"
  ],
  "ATG101": [
    "ATG101 CNV",
    "ATG101 RNA",
    "ATG101 Proteo"
  ],
  "CDRT15P1": [
    "CDRT15P1 CNV",
    "CDRT15P1 RNA"
  ],
  "DRG1": [
    "DRG1 CNV",
    "DRG1 RNA",
    "DRG1 Proteo"
  ],
  "DNAJC16": [
    "DNAJC16 CNV",
    "DNAJC16 RNA",
    "DNAJC16 Proteo"
  ],
  "B3GNT3": [
    "B3GNT3 CNV",
    "B3GNT3 RNA",
    "B3GNT3 Proteo"
  ],
  "DHFRP3": [
    "DHFRP3 CNV",
    "DHFRP3 RNA"
  ],
  "RETREG3": [
    "RETREG3 CNV",
    "RETREG3 RNA",
    "RETREG3 Proteo"
  ],
  "FOXI3": [
    "FOXI3 CNV",
    "FOXI3 RNA"
  ],
  "FABP7": [
    "FABP7 CNV",
    "FABP7 RNA",
    "FABP7 Proteo"
  ],
  "DAZ2": [
    "DAZ2 CNV",
    "DAZ2 RNA"
  ],
  "CDCA7L": [
    "CDCA7L CNV",
    "CDCA7L RNA",
    "CDCA7L Proteo"
  ],
  "ZNF886P": [
    "ZNF886P CNV",
    "ZNF886P RNA"
  ],
  "KIF3A": [
    "KIF3A CNV",
    "KIF3A RNA",
    "KIF3A Proteo"
  ],
  "NRG4": [
    "NRG4 CNV",
    "NRG4 RNA"
  ],
  "ACTA2": [
    "ACTA2 CNV",
    "ACTA2 RNA",
    "ACTA2 Proteo"
  ],
  "ZSCAN12": [
    "ZSCAN12 CNV",
    "ZSCAN12 RNA"
  ],
  "MTND2P12": [
    "MTND2P12 CNV",
    "MTND2P12 RNA"
  ],
  "TNF": [
    "TNF CNV",
    "TNF RNA"
  ],
  "STK10": [
    "STK10 CNV",
    "STK10 RNA",
    "STK10 Proteo"
  ],
  "MRPS22": [
    "MRPS22 CNV",
    "MRPS22 RNA",
    "MRPS22 Proteo"
  ],
  "RPS29P11": [
    "RPS29P11 CNV",
    "RPS29P11 RNA"
  ],
  "NPHP4": [
    "NPHP4 CNV",
    "NPHP4 RNA",
    "NPHP4 Proteo"
  ],
  "CERS4": [
    "CERS4 CNV",
    "CERS4 RNA",
    "CERS4 Proteo"
  ],
  "KLHL12": [
    "KLHL12 CNV",
    "KLHL12 RNA",
    "KLHL12 Proteo"
  ],
  "LGALS9C": [
    "LGALS9C CNV",
    "LGALS9C RNA"
  ],
  "FBXL3": [
    "FBXL3 CNV",
    "FBXL3 RNA",
    "FBXL3 Proteo"
  ],
  "OR11L1": [
    "OR11L1 CNV",
    "OR11L1 RNA"
  ],
  "VN1R46P": [
    "VN1R46P CNV",
    "VN1R46P RNA"
  ],
  "RNA5SP121": [
    "RNA5SP121 CNV",
    "RNA5SP121 RNA"
  ],
  "VEGFC": [
    "VEGFC CNV",
    "VEGFC RNA"
  ],
  "AMD1P1": [
    "AMD1P1 CNV",
    "AMD1P1 RNA"
  ],
  "KIF21B": [
    "KIF21B CNV",
    "KIF21B RNA",
    "KIF21B Proteo"
  ],
  "TMEM187": [
    "TMEM187 CNV",
    "TMEM187 RNA"
  ],
  "BBS10": [
    "BBS10 CNV",
    "BBS10 RNA",
    "BBS10 Proteo"
  ],
  "UBE2Q2P8": [
    "UBE2Q2P8 CNV",
    "UBE2Q2P8 RNA"
  ],
  "RPL31P2": [
    "RPL31P2 CNV",
    "RPL31P2 RNA"
  ],
  "NRXN1": [
    "NRXN1 CNV",
    "NRXN1 RNA"
  ],
  "DISC1": [
    "DISC1 CNV",
    "DISC1 RNA",
    "DISC1 Proteo"
  ],
  "UBE2L4": [
    "UBE2L4 CNV",
    "UBE2L4 RNA"
  ],
  "SPTLC1P4": [
    "SPTLC1P4 CNV",
    "SPTLC1P4 RNA"
  ],
  "CGRRF1": [
    "CGRRF1 CNV",
    "CGRRF1 RNA"
  ],
  "PRCC": [
    "PRCC CNV",
    "PRCC RNA",
    "PRCC Proteo"
  ],
  "PLXNC1": [
    "PLXNC1 CNV",
    "PLXNC1 RNA",
    "PLXNC1 Proteo"
  ],
  "KRT18P17": [
    "KRT18P17 CNV",
    "KRT18P17 RNA"
  ],
  "RSPH3": [
    "RSPH3 CNV",
    "RSPH3 RNA"
  ],
  "RPA3P2": [
    "RPA3P2 CNV",
    "RPA3P2 RNA"
  ],
  "H3P20": [
    "H3P20 CNV",
    "H3P20 RNA"
  ],
  "KRTAP26-1": [
    "KRTAP26-1 CNV",
    "KRTAP26-1 RNA"
  ],
  "C16orf89": [
    "C16orf89 CNV",
    "C16orf89 RNA",
    "C16orf89 Proteo"
  ],
  "FOSL2": [
    "FOSL2 CNV",
    "FOSL2 RNA",
    "FOSL2 Proteo"
  ],
  "STKLD1": [
    "STKLD1 CNV",
    "STKLD1 RNA"
  ],
  "DTX1": [
    "DTX1 CNV",
    "DTX1 RNA"
  ],
  "MARS1": [
    "MARS1 CNV",
    "MARS1 RNA",
    "MARS1 Proteo"
  ],
  "ABCC6": [
    "ABCC6 CNV",
    "ABCC6 RNA",
    "ABCC6 Proteo"
  ],
  "S100A1": [
    "S100A1 CNV",
    "S100A1 RNA",
    "S100A1 Proteo"
  ],
  "MCRIP1": [
    "MCRIP1 CNV",
    "MCRIP1 RNA",
    "MCRIP1 Proteo"
  ],
  "GOLGA8CP": [
    "GOLGA8CP CNV",
    "GOLGA8CP RNA"
  ],
  "C2orf16": [
    "C2orf16 CNV",
    "C2orf16 RNA"
  ],
  "DUX4L4": [
    "DUX4L4 CNV",
    "DUX4L4 RNA"
  ],
  "PRPF39": [
    "PRPF39 CNV",
    "PRPF39 RNA",
    "PRPF39 Proteo"
  ],
  "ALOX5": [
    "ALOX5 CNV",
    "ALOX5 RNA",
    "ALOX5 Proteo"
  ],
  "RPL31P17": [
    "RPL31P17 CNV",
    "RPL31P17 RNA"
  ],
  "RPS3AP30": [
    "RPS3AP30 CNV",
    "RPS3AP30 RNA"
  ],
  "ARHGEF7": [
    "ARHGEF7 CNV",
    "ARHGEF7 RNA",
    "ARHGEF7 Proteo"
  ],
  "ITIH3": [
    "ITIH3 CNV",
    "ITIH3 RNA",
    "ITIH3 Proteo"
  ],
  "PIK3CG": [
    "PIK3CG CNV",
    "PIK3CG RNA",
    "PIK3CG Proteo"
  ],
  "PLPP1": [
    "PLPP1 CNV",
    "PLPP1 RNA",
    "PLPP1 Proteo"
  ],
  "LBX1": [
    "LBX1 CNV",
    "LBX1 RNA"
  ],
  "RABL2A": [
    "RABL2A CNV",
    "RABL2A RNA",
    "RABL2A Proteo"
  ],
  "CEMIP": [
    "CEMIP CNV",
    "CEMIP RNA",
    "CEMIP Proteo"
  ],
  "PPP2R5C": [
    "PPP2R5C CNV",
    "PPP2R5C RNA",
    "PPP2R5C Proteo"
  ],
  "TRPC6P2": [
    "TRPC6P2 CNV",
    "TRPC6P2 RNA"
  ],
  "COX7A1": [
    "COX7A1 CNV",
    "COX7A1 RNA",
    "COX7A1 Proteo"
  ],
  "AKAP3": [
    "AKAP3 CNV",
    "AKAP3 RNA"
  ],
  "PRPF18": [
    "PRPF18 CNV",
    "PRPF18 RNA",
    "PRPF18 Proteo"
  ],
  "PITHD1": [
    "PITHD1 CNV",
    "PITHD1 RNA",
    "PITHD1 Proteo"
  ],
  "HNRNPA3P8": [
    "HNRNPA3P8 CNV",
    "HNRNPA3P8 RNA"
  ],
  "LACTB": [
    "LACTB CNV",
    "LACTB RNA",
    "LACTB Proteo"
  ],
  "SUDS3": [
    "SUDS3 CNV",
    "SUDS3 RNA",
    "SUDS3 Proteo"
  ],
  "TSSK6": [
    "TSSK6 CNV",
    "TSSK6 RNA"
  ],
  "KLHL10": [
    "KLHL10 CNV",
    "KLHL10 RNA"
  ],
  "IL31RA": [
    "IL31RA CNV",
    "IL31RA RNA"
  ],
  "ANKRD19P": [
    "ANKRD19P CNV",
    "ANKRD19P RNA"
  ],
  "HCRT": [
    "HCRT CNV",
    "HCRT RNA"
  ],
  "ATRNL1": [
    "ATRNL1 CNV",
    "ATRNL1 RNA"
  ],
  "MTG1": [
    "MTG1 CNV",
    "MTG1 RNA",
    "MTG1 Proteo"
  ],
  "PPIAP25": [
    "PPIAP25 CNV",
    "PPIAP25 RNA"
  ],
  "ZNF355P": [
    "ZNF355P CNV",
    "ZNF355P RNA"
  ],
  "MCUB": [
    "MCUB CNV",
    "MCUB RNA",
    "MCUB Proteo"
  ],
  "RPL17P26": [
    "RPL17P26 CNV",
    "RPL17P26 RNA"
  ],
  "LMAN2": [
    "LMAN2 CNV",
    "LMAN2 RNA",
    "LMAN2 Proteo"
  ],
  "SLC39A11": [
    "SLC39A11 CNV",
    "SLC39A11 RNA",
    "SLC39A11 Proteo"
  ],
  "PDCD6IP": [
    "PDCD6IP CNV",
    "PDCD6IP RNA",
    "PDCD6IP Proteo"
  ],
  "SMTNL1": [
    "SMTNL1 CNV",
    "SMTNL1 RNA"
  ],
  "TBC1D3JP": [
    "TBC1D3JP CNV",
    "TBC1D3JP RNA"
  ],
  "TSPAN16": [
    "TSPAN16 CNV",
    "TSPAN16 RNA"
  ],
  "OR4C48P": [
    "OR4C48P CNV",
    "OR4C48P RNA"
  ],
  "CAPNS1P1": [
    "CAPNS1P1 CNV",
    "CAPNS1P1 RNA"
  ],
  "RSAD2": [
    "RSAD2 CNV",
    "RSAD2 RNA"
  ],
  "TBC1D3F": [
    "TBC1D3F CNV",
    "TBC1D3F RNA"
  ],
  "CD68": [
    "CD68 CNV",
    "CD68 RNA",
    "CD68 Proteo"
  ],
  "C4BPB": [
    "C4BPB CNV",
    "C4BPB RNA",
    "C4BPB Proteo"
  ],
  "YWHAEP1": [
    "YWHAEP1 CNV",
    "YWHAEP1 RNA"
  ],
  "LURAP1L": [
    "LURAP1L CNV",
    "LURAP1L RNA",
    "LURAP1L Proteo"
  ],
  "PMS2P1": [
    "PMS2P1 CNV",
    "PMS2P1 RNA"
  ],
  "C1QTNF12": [
    "C1QTNF12 CNV",
    "C1QTNF12 RNA"
  ],
  "EIF4BP8": [
    "EIF4BP8 CNV",
    "EIF4BP8 RNA"
  ],
  "KRTAP17-1": [
    "KRTAP17-1 CNV",
    "KRTAP17-1 RNA"
  ],
  "DUXAP5": [
    "DUXAP5 CNV",
    "DUXAP5 RNA"
  ],
  "OPN1MW": [
    "OPN1MW CNV",
    "OPN1MW RNA"
  ],
  "COPS4": [
    "COPS4 CNV",
    "COPS4 RNA",
    "COPS4 Proteo"
  ],
  "RPS25P9": [
    "RPS25P9 CNV",
    "RPS25P9 RNA"
  ],
  "RD3": [
    "RD3 CNV",
    "RD3 RNA"
  ],
  "GPATCH2": [
    "GPATCH2 CNV",
    "GPATCH2 RNA",
    "GPATCH2 Proteo"
  ],
  "ETFBKMT": [
    "ETFBKMT CNV",
    "ETFBKMT RNA",
    "ETFBKMT Proteo"
  ],
  "KRT5": [
    "KRT5 CNV",
    "KRT5 RNA",
    "KRT5 Proteo"
  ],
  "BIN1": [
    "BIN1 CNV",
    "BIN1 RNA",
    "BIN1 Proteo"
  ],
  "MTCO3P28": [
    "MTCO3P28 CNV",
    "MTCO3P28 RNA"
  ],
  "ODCP": [
    "ODCP CNV",
    "ODCP RNA"
  ],
  "DCD": [
    "DCD CNV",
    "DCD RNA",
    "DCD Proteo"
  ],
  "CLMP": [
    "CLMP CNV",
    "CLMP RNA",
    "CLMP Proteo"
  ],
  "LCORL": [
    "LCORL CNV",
    "LCORL RNA",
    "LCORL Proteo"
  ],
  "CTAGE12P": [
    "CTAGE12P CNV",
    "CTAGE12P RNA"
  ],
  "MRS2P2": [
    "MRS2P2 CNV",
    "MRS2P2 RNA"
  ],
  "ABCD1P4": [
    "ABCD1P4 CNV",
    "ABCD1P4 RNA"
  ],
  "KRTAP21-3": [
    "KRTAP21-3 CNV",
    "KRTAP21-3 RNA"
  ],
  "RPL26P6": [
    "RPL26P6 CNV",
    "RPL26P6 RNA"
  ],
  "ZFTA": [
    "ZFTA CNV",
    "ZFTA RNA"
  ],
  "INSL3": [
    "INSL3 CNV",
    "INSL3 RNA"
  ],
  "RPL7P12": [
    "RPL7P12 CNV",
    "RPL7P12 RNA"
  ],
  "ZNF79": [
    "ZNF79 CNV",
    "ZNF79 RNA"
  ],
  "MTND4LP24": [
    "MTND4LP24 CNV",
    "MTND4LP24 RNA"
  ],
  "SOS1": [
    "SOS1 CNV",
    "SOS1 RNA",
    "SOS1 Proteo"
  ],
  "HIBADH": [
    "HIBADH CNV",
    "HIBADH RNA",
    "HIBADH Proteo"
  ],
  "H2AC14": [
    "H2AC14 CNV",
    "H2AC14 RNA"
  ],
  "CNGB3": [
    "CNGB3 CNV",
    "CNGB3 RNA"
  ],
  "IDI1": [
    "IDI1 CNV",
    "IDI1 RNA",
    "IDI1 Proteo"
  ],
  "SEMA4A": [
    "SEMA4A CNV",
    "SEMA4A RNA",
    "SEMA4A Proteo"
  ],
  "NDST4": [
    "NDST4 CNV",
    "NDST4 RNA"
  ],
  "ANOS2P": [
    "ANOS2P CNV",
    "ANOS2P RNA"
  ],
  "RNF4": [
    "RNF4 CNV",
    "RNF4 RNA"
  ],
  "ARHGAP23": [
    "ARHGAP23 CNV",
    "ARHGAP23 RNA",
    "ARHGAP23 Proteo"
  ],
  "EFCAB7": [
    "EFCAB7 CNV",
    "EFCAB7 RNA",
    "EFCAB7 Proteo"
  ],
  "LSM6P2": [
    "LSM6P2 CNV",
    "LSM6P2 RNA"
  ],
  "EGFLAM": [
    "EGFLAM CNV",
    "EGFLAM RNA",
    "EGFLAM Proteo"
  ],
  "OVOL1": [
    "OVOL1 CNV",
    "OVOL1 RNA"
  ],
  "CCDC200": [
    "CCDC200 CNV",
    "CCDC200 RNA"
  ],
  "MLH3": [
    "MLH3 CNV",
    "MLH3 RNA",
    "MLH3 Proteo"
  ],
  "MYO18A": [
    "MYO18A CNV",
    "MYO18A RNA",
    "MYO18A Proteo"
  ],
  "NBPF12": [
    "NBPF12 CNV",
    "NBPF12 RNA"
  ],
  "RNA5SP303": [
    "RNA5SP303 CNV",
    "RNA5SP303 RNA"
  ],
  "RPL22P21": [
    "RPL22P21 CNV",
    "RPL22P21 RNA"
  ],
  "IQCB1": [
    "IQCB1 CNV",
    "IQCB1 RNA",
    "IQCB1 Proteo"
  ],
  "CPLANE2": [
    "CPLANE2 CNV",
    "CPLANE2 RNA"
  ],
  "MRPS31": [
    "MRPS31 CNV",
    "MRPS31 RNA",
    "MRPS31 Proteo"
  ],
  "METTL18": [
    "METTL18 CNV",
    "METTL18 RNA",
    "METTL18 Proteo"
  ],
  "SYBU": [
    "SYBU CNV",
    "SYBU RNA",
    "SYBU Proteo"
  ],
  "DEFA7P": [
    "DEFA7P CNV",
    "DEFA7P RNA"
  ],
  "SLCO4C1": [
    "SLCO4C1 CNV",
    "SLCO4C1 RNA"
  ],
  "PIPOX": [
    "PIPOX CNV",
    "PIPOX RNA"
  ],
  "RNF114": [
    "RNF114 CNV",
    "RNF114 RNA",
    "RNF114 Proteo"
  ],
  "SEMG1": [
    "SEMG1 CNV",
    "SEMG1 RNA"
  ],
  "LAPTM4A": [
    "LAPTM4A CNV",
    "LAPTM4A RNA",
    "LAPTM4A Proteo"
  ],
  "CAPN11": [
    "CAPN11 CNV",
    "CAPN11 RNA"
  ],
  "LCE3C": [
    "LCE3C CNV",
    "LCE3C RNA"
  ],
  "EBF1": [
    "EBF1 CNV",
    "EBF1 RNA",
    "EBF1 Proteo"
  ],
  "ROCK1P1": [
    "ROCK1P1 CNV",
    "ROCK1P1 RNA"
  ],
  "RNF31": [
    "RNF31 CNV",
    "RNF31 RNA",
    "RNF31 Proteo"
  ],
  "MPP2": [
    "MPP2 CNV",
    "MPP2 RNA",
    "MPP2 Proteo"
  ],
  "MTND2P9": [
    "MTND2P9 CNV",
    "MTND2P9 RNA"
  ],
  "PPP1R15B": [
    "PPP1R15B CNV",
    "PPP1R15B RNA",
    "PPP1R15B Proteo"
  ],
  "PAEP": [
    "PAEP CNV",
    "PAEP RNA",
    "PAEP Proteo"
  ],
  "RPL5P23": [
    "RPL5P23 CNV",
    "RPL5P23 RNA"
  ],
  "KRT17P1": [
    "KRT17P1 CNV",
    "KRT17P1 RNA"
  ],
  "EIF4A1P7": [
    "EIF4A1P7 CNV",
    "EIF4A1P7 RNA"
  ],
  "POLR2DP1": [
    "POLR2DP1 CNV",
    "POLR2DP1 RNA"
  ],
  "ZNF689": [
    "ZNF689 CNV",
    "ZNF689 RNA",
    "ZNF689 Proteo"
  ],
  "ACSS2": [
    "ACSS2 CNV",
    "ACSS2 RNA",
    "ACSS2 Proteo"
  ],
  "RPL6P17": [
    "RPL6P17 CNV",
    "RPL6P17 RNA"
  ],
  "TUBB8P10": [
    "TUBB8P10 CNV",
    "TUBB8P10 RNA"
  ],
  "ERICH2": [
    "ERICH2 CNV",
    "ERICH2 RNA"
  ],
  "KANSL2": [
    "KANSL2 CNV",
    "KANSL2 RNA",
    "KANSL2 Proteo"
  ],
  "PSMD10P3": [
    "PSMD10P3 CNV",
    "PSMD10P3 RNA"
  ],
  "UGT2B17": [
    "UGT2B17 CNV",
    "UGT2B17 RNA"
  ],
  "SEPTIN12": [
    "SEPTIN12 CNV",
    "SEPTIN12 RNA"
  ],
  "SMIM2": [
    "SMIM2 CNV",
    "SMIM2 RNA"
  ],
  "CRADD": [
    "CRADD CNV",
    "CRADD RNA",
    "CRADD Proteo"
  ],
  "ASB9": [
    "ASB9 CNV",
    "ASB9 RNA",
    "ASB9 Proteo"
  ],
  "SDR42E2": [
    "SDR42E2 CNV",
    "SDR42E2 RNA"
  ],
  "NCMAP": [
    "NCMAP CNV",
    "NCMAP RNA"
  ],
  "PNPT1P1": [
    "PNPT1P1 CNV",
    "PNPT1P1 RNA"
  ],
  "TRBV8-1": [
    "TRBV8-1 CNV",
    "TRBV8-1 RNA"
  ],
  "COX16": [
    "COX16 CNV",
    "COX16 RNA"
  ],
  "OIP5": [
    "OIP5 CNV",
    "OIP5 RNA",
    "OIP5 Proteo"
  ],
  "NKAIN1P1": [
    "NKAIN1P1 CNV",
    "NKAIN1P1 RNA"
  ],
  "PTCHD3P1": [
    "PTCHD3P1 CNV",
    "PTCHD3P1 RNA"
  ],
  "ZSCAN22": [
    "ZSCAN22 CNV",
    "ZSCAN22 RNA"
  ],
  "BHLHE22": [
    "BHLHE22 CNV",
    "BHLHE22 RNA"
  ],
  "TPRG1": [
    "TPRG1 CNV",
    "TPRG1 RNA"
  ],
  "MMP17": [
    "MMP17 CNV",
    "MMP17 RNA"
  ],
  "PC": [
    "PC CNV",
    "PC RNA",
    "PC Proteo"
  ],
  "KRI1": [
    "KRI1 CNV",
    "KRI1 RNA",
    "KRI1 Proteo"
  ],
  "ASS1P8": [
    "ASS1P8 CNV",
    "ASS1P8 RNA"
  ],
  "RNA5SP160": [
    "RNA5SP160 CNV",
    "RNA5SP160 RNA"
  ],
  "TTC27": [
    "TTC27 CNV",
    "TTC27 RNA",
    "TTC27 Proteo"
  ],
  "BLOC1S2": [
    "BLOC1S2 CNV",
    "BLOC1S2 RNA",
    "BLOC1S2 Proteo"
  ],
  "DDX52": [
    "DDX52 CNV",
    "DDX52 RNA",
    "DDX52 Proteo"
  ],
  "TYMP": [
    "TYMP CNV",
    "TYMP RNA",
    "TYMP Proteo"
  ],
  "STEEP1": [
    "STEEP1 CNV",
    "STEEP1 RNA",
    "STEEP1 Proteo"
  ],
  "RNF115": [
    "RNF115 CNV",
    "RNF115 RNA",
    "RNF115 Proteo"
  ],
  "GRAMD4": [
    "GRAMD4 CNV",
    "GRAMD4 RNA",
    "GRAMD4 Proteo"
  ],
  "LHX4": [
    "LHX4 CNV",
    "LHX4 RNA"
  ],
  "MADD": [
    "MADD CNV",
    "MADD RNA",
    "MADD Proteo"
  ],
  "PIK3CA": [
    "PIK3CA CNV",
    "PIK3CA RNA",
    "PIK3CA Proteo"
  ],
  "KLHL20": [
    "KLHL20 CNV",
    "KLHL20 RNA",
    "KLHL20 Proteo"
  ],
  "ABCB11": [
    "ABCB11 CNV",
    "ABCB11 RNA"
  ],
  "SYS1": [
    "SYS1 CNV",
    "SYS1 RNA",
    "SYS1 Proteo"
  ],
  "EML6": [
    "EML6 CNV",
    "EML6 RNA"
  ],
  "CCDC126": [
    "CCDC126 CNV",
    "CCDC126 RNA",
    "CCDC126 Proteo"
  ],
  "SULF1": [
    "SULF1 CNV",
    "SULF1 RNA",
    "SULF1 Proteo"
  ],
  "MYH11": [
    "MYH11 CNV",
    "MYH11 RNA",
    "MYH11 Proteo"
  ],
  "TMEM82": [
    "TMEM82 CNV",
    "TMEM82 RNA"
  ],
  "RACK1": [
    "RACK1 CNV",
    "RACK1 RNA",
    "RACK1 Proteo"
  ],
  "CALHM4": [
    "CALHM4 CNV",
    "CALHM4 RNA"
  ],
  "COX4I1P1": [
    "COX4I1P1 CNV",
    "COX4I1P1 RNA"
  ],
  "CASKP1": [
    "CASKP1 CNV",
    "CASKP1 RNA"
  ],
  "MRPS16P1": [
    "MRPS16P1 CNV",
    "MRPS16P1 RNA"
  ],
  "ST8SIA2": [
    "ST8SIA2 CNV",
    "ST8SIA2 RNA"
  ],
  "TPD52L1": [
    "TPD52L1 CNV",
    "TPD52L1 RNA",
    "TPD52L1 Proteo"
  ],
  "SLC5A12": [
    "SLC5A12 CNV",
    "SLC5A12 RNA"
  ],
  "FAM227A": [
    "FAM227A CNV",
    "FAM227A RNA"
  ],
  "FAM151A": [
    "FAM151A CNV",
    "FAM151A RNA",
    "FAM151A Proteo"
  ],
  "KRT18P1": [
    "KRT18P1 CNV",
    "KRT18P1 RNA"
  ],
  "IGLVI-68": [
    "IGLVI-68 CNV",
    "IGLVI-68 RNA"
  ],
  "EDRF1": [
    "EDRF1 CNV",
    "EDRF1 RNA",
    "EDRF1 Proteo"
  ],
  "SPECC1L": [
    "SPECC1L CNV",
    "SPECC1L RNA",
    "SPECC1L Proteo"
  ],
  "AFAP1L2": [
    "AFAP1L2 CNV",
    "AFAP1L2 RNA",
    "AFAP1L2 Proteo"
  ],
  "CHCHD5": [
    "CHCHD5 CNV",
    "CHCHD5 RNA",
    "CHCHD5 Proteo"
  ],
  "SLX1B": [
    "SLX1B CNV",
    "SLX1B RNA"
  ],
  "RPS29": [
    "RPS29 CNV",
    "RPS29 RNA",
    "RPS29 Proteo"
  ],
  "SRIP1": [
    "SRIP1 CNV",
    "SRIP1 RNA"
  ],
  "TAS2R10": [
    "TAS2R10 CNV",
    "TAS2R10 RNA"
  ],
  "COL10A1": [
    "COL10A1 CNV",
    "COL10A1 RNA"
  ],
  "GPR142": [
    "GPR142 CNV",
    "GPR142 RNA"
  ],
  "IL12B": [
    "IL12B CNV",
    "IL12B RNA"
  ],
  "ZNF385C": [
    "ZNF385C CNV",
    "ZNF385C RNA"
  ],
  "IGKV6D-21": [
    "IGKV6D-21 Proteo"
  ],
  "CLUHP3": [
    "CLUHP3 CNV",
    "CLUHP3 RNA"
  ],
  "TIMM23B": [
    "TIMM23B CNV",
    "TIMM23B RNA"
  ],
  "SPATA31C2": [
    "SPATA31C2 CNV",
    "SPATA31C2 RNA"
  ],
  "TMX2P1": [
    "TMX2P1 CNV",
    "TMX2P1 RNA"
  ],
  "HMGA1P7": [
    "HMGA1P7 CNV",
    "HMGA1P7 RNA"
  ],
  "IGLV10-67": [
    "IGLV10-67 CNV",
    "IGLV10-67 RNA"
  ],
  "C16orf90": [
    "C16orf90 CNV",
    "C16orf90 RNA"
  ],
  "SRSF1": [
    "SRSF1 CNV",
    "SRSF1 RNA",
    "SRSF1 Proteo"
  ],
  "HTR1F": [
    "HTR1F CNV",
    "HTR1F RNA"
  ],
  "API5P1": [
    "API5P1 CNV",
    "API5P1 RNA"
  ],
  "STK38L": [
    "STK38L CNV",
    "STK38L RNA",
    "STK38L Proteo"
  ],
  "TMEM14DP": [
    "TMEM14DP CNV",
    "TMEM14DP RNA"
  ],
  "PRRT3": [
    "PRRT3 CNV",
    "PRRT3 RNA",
    "PRRT3 Proteo"
  ],
  "MRPL18": [
    "MRPL18 CNV",
    "MRPL18 RNA",
    "MRPL18 Proteo"
  ],
  "PTH2R": [
    "PTH2R CNV",
    "PTH2R RNA"
  ],
  "SLC6A8": [
    "SLC6A8 CNV",
    "SLC6A8 RNA",
    "SLC6A8 Proteo"
  ],
  "CRH": [
    "CRH CNV",
    "CRH RNA"
  ],
  "RPS27P12": [
    "RPS27P12 CNV",
    "RPS27P12 RNA"
  ],
  "N6AMT1": [
    "N6AMT1 CNV",
    "N6AMT1 RNA",
    "N6AMT1 Proteo"
  ],
  "MLECP1": [
    "MLECP1 CNV",
    "MLECP1 RNA"
  ],
  "OFCC1": [
    "OFCC1 CNV",
    "OFCC1 RNA"
  ],
  "PRR35": [
    "PRR35 CNV",
    "PRR35 RNA"
  ],
  "PTGES3": [
    "PTGES3 CNV",
    "PTGES3 RNA",
    "PTGES3 Proteo"
  ],
  "SLC25A43": [
    "SLC25A43 CNV",
    "SLC25A43 RNA"
  ],
  "NID2": [
    "NID2 CNV",
    "NID2 RNA",
    "NID2 Proteo"
  ],
  "MTND5P23": [
    "MTND5P23 CNV",
    "MTND5P23 RNA"
  ],
  "PHKG1P3": [
    "PHKG1P3 CNV",
    "PHKG1P3 RNA"
  ],
  "LRRFIP1": [
    "LRRFIP1 CNV",
    "LRRFIP1 RNA",
    "LRRFIP1 Proteo"
  ],
  "TRBV25OR9-2": [
    "TRBV25OR9-2 CNV",
    "TRBV25OR9-2 RNA"
  ],
  "KRTAP19-3": [
    "KRTAP19-3 CNV",
    "KRTAP19-3 RNA"
  ],
  "NXPH1": [
    "NXPH1 CNV",
    "NXPH1 RNA"
  ],
  "ZNF891": [
    "ZNF891 CNV",
    "ZNF891 RNA"
  ],
  "KNTC1": [
    "KNTC1 CNV",
    "KNTC1 RNA",
    "KNTC1 Proteo"
  ],
  "HSD17B7": [
    "HSD17B7 CNV",
    "HSD17B7 RNA",
    "HSD17B7 Proteo"
  ],
  "SIRPB3P": [
    "SIRPB3P CNV",
    "SIRPB3P RNA"
  ],
  "NFS1": [
    "NFS1 CNV",
    "NFS1 RNA",
    "NFS1 Proteo"
  ],
  "KCNE2": [
    "KCNE2 CNV",
    "KCNE2 RNA"
  ],
  "CCDC88A": [
    "CCDC88A CNV",
    "CCDC88A RNA",
    "CCDC88A Proteo"
  ],
  "PRPSAP1": [
    "PRPSAP1 CNV",
    "PRPSAP1 RNA",
    "PRPSAP1 Proteo"
  ],
  "RNA5SP331": [
    "RNA5SP331 CNV",
    "RNA5SP331 RNA"
  ],
  "NUDT2": [
    "NUDT2 CNV",
    "NUDT2 RNA",
    "NUDT2 Proteo"
  ],
  "CBLN1": [
    "CBLN1 CNV",
    "CBLN1 RNA"
  ],
  "CST9LP1": [
    "CST9LP1 CNV",
    "CST9LP1 RNA"
  ],
  "CDKN1B": [
    "CDKN1B CNV",
    "CDKN1B RNA",
    "CDKN1B Proteo"
  ],
  "AP1S1": [
    "AP1S1 CNV",
    "AP1S1 RNA",
    "AP1S1 Proteo"
  ],
  "SEPTIN14P17": [
    "SEPTIN14P17 CNV",
    "SEPTIN14P17 RNA"
  ],
  "CYP4A44P": [
    "CYP4A44P CNV",
    "CYP4A44P RNA"
  ],
  "KRT17P3": [
    "KRT17P3 CNV",
    "KRT17P3 RNA"
  ],
  "WSCD1": [
    "WSCD1 CNV",
    "WSCD1 RNA"
  ],
  "MAP7D2": [
    "MAP7D2 CNV",
    "MAP7D2 RNA",
    "MAP7D2 Proteo"
  ],
  "ADGRG6": [
    "ADGRG6 CNV",
    "ADGRG6 RNA",
    "ADGRG6 Proteo"
  ],
  "POLR1F": [
    "POLR1F CNV",
    "POLR1F RNA",
    "POLR1F Proteo"
  ],
  "RPS12P15": [
    "RPS12P15 CNV",
    "RPS12P15 RNA"
  ],
  "WFDC9": [
    "WFDC9 CNV",
    "WFDC9 RNA"
  ],
  "STIL": [
    "STIL CNV",
    "STIL RNA",
    "STIL Proteo"
  ],
  "OR6L1P": [
    "OR6L1P CNV",
    "OR6L1P RNA"
  ],
  "KLHL7": [
    "KLHL7 CNV",
    "KLHL7 RNA",
    "KLHL7 Proteo"
  ],
  "SH2D7": [
    "SH2D7 CNV",
    "SH2D7 RNA"
  ],
  "DCAF12": [
    "DCAF12 CNV",
    "DCAF12 RNA",
    "DCAF12 Proteo"
  ],
  "DUTP4": [
    "DUTP4 CNV",
    "DUTP4 RNA"
  ],
  "USP29": [
    "USP29 CNV",
    "USP29 RNA"
  ],
  "CSMD3": [
    "CSMD3 CNV",
    "CSMD3 RNA"
  ],
  "RPUSD3": [
    "RPUSD3 CNV",
    "RPUSD3 RNA",
    "RPUSD3 Proteo"
  ],
  "CD2AP": [
    "CD2AP CNV",
    "CD2AP RNA",
    "CD2AP Proteo"
  ],
  "NEUROD6": [
    "NEUROD6 CNV",
    "NEUROD6 RNA"
  ],
  "SPACDR": [
    "SPACDR CNV",
    "SPACDR RNA"
  ],
  "RPL12P12": [
    "RPL12P12 CNV",
    "RPL12P12 RNA"
  ],
  "RPL7AP19": [
    "RPL7AP19 CNV",
    "RPL7AP19 RNA"
  ],
  "CAPZA1P1": [
    "CAPZA1P1 CNV",
    "CAPZA1P1 RNA"
  ],
  "BRPF1": [
    "BRPF1 CNV",
    "BRPF1 RNA",
    "BRPF1 Proteo"
  ],
  "DIPK1B": [
    "DIPK1B CNV",
    "DIPK1B RNA",
    "DIPK1B Proteo"
  ],
  "SETBP1": [
    "SETBP1 CNV",
    "SETBP1 RNA"
  ],
  "RPL23AP73": [
    "RPL23AP73 CNV",
    "RPL23AP73 RNA"
  ],
  "ERC2": [
    "ERC2 CNV",
    "ERC2 RNA"
  ],
  "FBXO16": [
    "FBXO16 CNV",
    "FBXO16 RNA"
  ],
  "ARMH1": [
    "ARMH1 CNV",
    "ARMH1 RNA"
  ],
  "ERMN": [
    "ERMN CNV",
    "ERMN RNA"
  ],
  "ORMDL3": [
    "ORMDL3 CNV",
    "ORMDL3 RNA",
    "ORMDL3 Proteo"
  ],
  "CYCSP33": [
    "CYCSP33 CNV",
    "CYCSP33 RNA"
  ],
  "NPM1P20": [
    "NPM1P20 CNV",
    "NPM1P20 RNA"
  ],
  "CROCCP3": [
    "CROCCP3 CNV",
    "CROCCP3 RNA"
  ],
  "RARRES2P4": [
    "RARRES2P4 CNV",
    "RARRES2P4 RNA"
  ],
  "WFDC2": [
    "WFDC2 CNV",
    "WFDC2 RNA",
    "WFDC2 Proteo"
  ],
  "LRRC42": [
    "LRRC42 CNV",
    "LRRC42 RNA",
    "LRRC42 Proteo"
  ],
  "TAS2R1": [
    "TAS2R1 CNV",
    "TAS2R1 RNA"
  ],
  "RPL17P12": [
    "RPL17P12 CNV",
    "RPL17P12 RNA"
  ],
  "KCNK16": [
    "KCNK16 CNV",
    "KCNK16 RNA"
  ],
  "TAB3P1": [
    "TAB3P1 CNV",
    "TAB3P1 RNA"
  ],
  "AGMAT": [
    "AGMAT CNV",
    "AGMAT RNA",
    "AGMAT Proteo"
  ],
  "VSTM2L": [
    "VSTM2L CNV",
    "VSTM2L RNA",
    "VSTM2L Proteo"
  ],
  "PJVK": [
    "PJVK CNV",
    "PJVK RNA"
  ],
  "ZKSCAN4": [
    "ZKSCAN4 CNV",
    "ZKSCAN4 RNA",
    "ZKSCAN4 Proteo"
  ],
  "DBP": [
    "DBP CNV",
    "DBP RNA",
    "DBP Proteo"
  ],
  "NAV1": [
    "NAV1 CNV",
    "NAV1 RNA",
    "NAV1 Proteo"
  ],
  "ZNF490": [
    "ZNF490 CNV",
    "ZNF490 RNA"
  ],
  "TGM1": [
    "TGM1 CNV",
    "TGM1 RNA",
    "TGM1 Proteo"
  ],
  "MOB4P2": [
    "MOB4P2 CNV",
    "MOB4P2 RNA"
  ],
  "MSRB2": [
    "MSRB2 CNV",
    "MSRB2 RNA",
    "MSRB2 Proteo"
  ],
  "CTNNBL1": [
    "CTNNBL1 CNV",
    "CTNNBL1 RNA",
    "CTNNBL1 Proteo"
  ],
  "MEMO1P3": [
    "MEMO1P3 CNV",
    "MEMO1P3 RNA"
  ],
  "PRKCE": [
    "PRKCE CNV",
    "PRKCE RNA",
    "PRKCE Proteo"
  ],
  "AGAP12P": [
    "AGAP12P CNV",
    "AGAP12P RNA"
  ],
  "BCLAF1P2": [
    "BCLAF1P2 CNV",
    "BCLAF1P2 RNA"
  ],
  "ADRM1": [
    "ADRM1 CNV",
    "ADRM1 RNA",
    "ADRM1 Proteo"
  ],
  "ZNF304": [
    "ZNF304 CNV",
    "ZNF304 RNA"
  ],
  "CSNKA2IP": [
    "CSNKA2IP CNV",
    "CSNKA2IP RNA"
  ],
  "ZNF541": [
    "ZNF541 CNV",
    "ZNF541 RNA"
  ],
  "SPATA20P1": [
    "SPATA20P1 CNV",
    "SPATA20P1 RNA"
  ],
  "CSNK1A1L": [
    "CSNK1A1L CNV",
    "CSNK1A1L RNA"
  ],
  "CREB3L4": [
    "CREB3L4 CNV",
    "CREB3L4 RNA",
    "CREB3L4 Proteo"
  ],
  "SLC25A24P2": [
    "SLC25A24P2 CNV",
    "SLC25A24P2 RNA"
  ],
  "CMTR1": [
    "CMTR1 CNV",
    "CMTR1 RNA",
    "CMTR1 Proteo"
  ],
  "MRGPRX8P": [
    "MRGPRX8P CNV",
    "MRGPRX8P RNA"
  ],
  "UGT1A10": [
    "UGT1A10 CNV",
    "UGT1A10 RNA",
    "UGT1A10 Proteo"
  ],
  "RNA5SP295": [
    "RNA5SP295 CNV",
    "RNA5SP295 RNA"
  ],
  "ADGRF5P1": [
    "ADGRF5P1 CNV",
    "ADGRF5P1 RNA"
  ],
  "TNNC2": [
    "TNNC2 CNV",
    "TNNC2 RNA",
    "TNNC2 Proteo"
  ],
  "TXNDC16": [
    "TXNDC16 CNV",
    "TXNDC16 RNA",
    "TXNDC16 Proteo"
  ],
  "ASPA": [
    "ASPA CNV",
    "ASPA RNA",
    "ASPA Proteo"
  ],
  "IPO8": [
    "IPO8 CNV",
    "IPO8 RNA",
    "IPO8 Proteo"
  ],
  "TCOF1": [
    "TCOF1 CNV",
    "TCOF1 RNA",
    "TCOF1 Proteo"
  ],
  "VDAC1P11": [
    "VDAC1P11 CNV",
    "VDAC1P11 RNA"
  ],
  "USP17L5": [
    "USP17L5 CNV",
    "USP17L5 RNA"
  ],
  "YBX3P1": [
    "YBX3P1 CNV",
    "YBX3P1 RNA"
  ],
  "FSCB": [
    "FSCB CNV",
    "FSCB RNA"
  ],
  "ROCK1": [
    "ROCK1 CNV",
    "ROCK1 RNA",
    "ROCK1 Proteo"
  ],
  "OR2C1": [
    "OR2C1 CNV",
    "OR2C1 RNA"
  ],
  "SERPINA7": [
    "SERPINA7 CNV",
    "SERPINA7 RNA",
    "SERPINA7 Proteo"
  ],
  "RPLP0P7": [
    "RPLP0P7 CNV",
    "RPLP0P7 RNA"
  ],
  "HNRNPA1P13": [
    "HNRNPA1P13 CNV",
    "HNRNPA1P13 RNA"
  ],
  "RBM17P2": [
    "RBM17P2 CNV",
    "RBM17P2 RNA"
  ],
  "ZDHHC15": [
    "ZDHHC15 CNV",
    "ZDHHC15 RNA"
  ],
  "HNRNPH1P3": [
    "HNRNPH1P3 CNV",
    "HNRNPH1P3 RNA"
  ],
  "INPP5B": [
    "INPP5B CNV",
    "INPP5B RNA",
    "INPP5B Proteo"
  ],
  "RPLP0P11": [
    "RPLP0P11 CNV",
    "RPLP0P11 RNA"
  ],
  "HMGN2P4": [
    "HMGN2P4 CNV",
    "HMGN2P4 RNA"
  ],
  "RNF169": [
    "RNF169 CNV",
    "RNF169 RNA",
    "RNF169 Proteo"
  ],
  "SULT1C4": [
    "SULT1C4 CNV",
    "SULT1C4 RNA"
  ],
  "TEX101P1": [
    "TEX101P1 CNV",
    "TEX101P1 RNA"
  ],
  "CDH10": [
    "CDH10 CNV",
    "CDH10 RNA"
  ],
  "PSMC1": [
    "PSMC1 CNV",
    "PSMC1 RNA",
    "PSMC1 Proteo"
  ],
  "DPCD": [
    "DPCD CNV",
    "DPCD RNA",
    "DPCD Proteo"
  ],
  "GAPDHP58": [
    "GAPDHP58 CNV",
    "GAPDHP58 RNA"
  ],
  "MSMP": [
    "MSMP CNV",
    "MSMP RNA"
  ],
  "STAP1": [
    "STAP1 CNV",
    "STAP1 RNA",
    "STAP1 Proteo"
  ],
  "MRPS17P9": [
    "MRPS17P9 CNV",
    "MRPS17P9 RNA"
  ],
  "CFAP95": [
    "CFAP95 CNV",
    "CFAP95 RNA"
  ],
  "SPATA32": [
    "SPATA32 CNV",
    "SPATA32 RNA"
  ],
  "FNIP2": [
    "FNIP2 CNV",
    "FNIP2 RNA",
    "FNIP2 Proteo"
  ],
  "GANC": [
    "GANC CNV",
    "GANC RNA",
    "GANC Proteo"
  ],
  "PMS2CL": [
    "PMS2CL CNV",
    "PMS2CL RNA"
  ],
  "OR7E11P": [
    "OR7E11P CNV",
    "OR7E11P RNA"
  ],
  "C1orf21": [
    "C1orf21 CNV",
    "C1orf21 RNA",
    "C1orf21 Proteo"
  ],
  "QRICH1": [
    "QRICH1 CNV",
    "QRICH1 RNA",
    "QRICH1 Proteo"
  ],
  "USP9YP28": [
    "USP9YP28 CNV",
    "USP9YP28 RNA"
  ],
  "PARS2": [
    "PARS2 CNV",
    "PARS2 RNA",
    "PARS2 Proteo"
  ],
  "CYP1A2": [
    "CYP1A2 CNV",
    "CYP1A2 RNA"
  ],
  "CYB561D1": [
    "CYB561D1 CNV",
    "CYB561D1 RNA"
  ],
  "TEKT4P2": [
    "TEKT4P2 CNV",
    "TEKT4P2 RNA"
  ],
  "CTDP1": [
    "CTDP1 CNV",
    "CTDP1 RNA",
    "CTDP1 Proteo"
  ],
  "SCARB2": [
    "SCARB2 CNV",
    "SCARB2 RNA",
    "SCARB2 Proteo"
  ],
  "PYGM": [
    "PYGM CNV",
    "PYGM RNA",
    "PYGM Proteo"
  ],
  "FDXACB1": [
    "FDXACB1 CNV",
    "FDXACB1 RNA"
  ],
  "TCP11X3P": [
    "TCP11X3P CNV",
    "TCP11X3P RNA"
  ],
  "RPS6P22": [
    "RPS6P22 CNV",
    "RPS6P22 RNA"
  ],
  "MOGAT3": [
    "MOGAT3 CNV",
    "MOGAT3 RNA"
  ],
  "CPSF3": [
    "CPSF3 CNV",
    "CPSF3 RNA",
    "CPSF3 Proteo"
  ],
  "SGPP1": [
    "SGPP1 CNV",
    "SGPP1 RNA",
    "SGPP1 Proteo"
  ],
  "SURF4": [
    "SURF4 CNV",
    "SURF4 RNA",
    "SURF4 Proteo"
  ],
  "HIRIP3": [
    "HIRIP3 CNV",
    "HIRIP3 RNA",
    "HIRIP3 Proteo"
  ],
  "TMEM185B": [
    "TMEM185B CNV",
    "TMEM185B RNA",
    "TMEM185B Proteo"
  ],
  "TARDBPP2": [
    "TARDBPP2 CNV",
    "TARDBPP2 RNA"
  ],
  "POLR3B": [
    "POLR3B CNV",
    "POLR3B RNA",
    "POLR3B Proteo"
  ],
  "KIAA1109": [
    "KIAA1109 CNV",
    "KIAA1109 RNA",
    "KIAA1109 Proteo"
  ],
  "NDUFAF1": [
    "NDUFAF1 CNV",
    "NDUFAF1 RNA",
    "NDUFAF1 Proteo"
  ],
  "C16orf82": [
    "C16orf82 CNV",
    "C16orf82 RNA"
  ],
  "PIEZO1P2": [
    "PIEZO1P2 CNV",
    "PIEZO1P2 RNA"
  ],
  "RALGDS": [
    "RALGDS CNV",
    "RALGDS RNA",
    "RALGDS Proteo"
  ],
  "HMGB3P15": [
    "HMGB3P15 CNV",
    "HMGB3P15 RNA"
  ],
  "HPGD": [
    "HPGD CNV",
    "HPGD RNA",
    "HPGD Proteo"
  ],
  "CBWD5": [
    "CBWD5 CNV",
    "CBWD5 RNA"
  ],
  "SLC4A11": [
    "SLC4A11 CNV",
    "SLC4A11 RNA",
    "SLC4A11 Proteo"
  ],
  "ZNF85": [
    "ZNF85 CNV",
    "ZNF85 RNA"
  ],
  "HACD2": [
    "HACD2 CNV",
    "HACD2 RNA",
    "HACD2 Proteo"
  ],
  "VMP1": [
    "VMP1 CNV",
    "VMP1 RNA",
    "VMP1 Proteo"
  ],
  "OR7E157P": [
    "OR7E157P CNV",
    "OR7E157P RNA"
  ],
  "FAAH2": [
    "FAAH2 CNV",
    "FAAH2 RNA"
  ],
  "MTDHP2": [
    "MTDHP2 CNV",
    "MTDHP2 RNA"
  ],
  "MRPL49P1": [
    "MRPL49P1 CNV",
    "MRPL49P1 RNA"
  ],
  "SNRPN": [
    "SNRPN CNV",
    "SNRPN RNA"
  ],
  "UGT1A12P": [
    "UGT1A12P CNV",
    "UGT1A12P RNA"
  ],
  "RPL35AP12": [
    "RPL35AP12 CNV",
    "RPL35AP12 RNA"
  ],
  "IDE": [
    "IDE CNV",
    "IDE RNA",
    "IDE Proteo"
  ],
  "CDC26": [
    "CDC26 CNV",
    "CDC26 RNA",
    "CDC26 Proteo"
  ],
  "AMBN": [
    "AMBN CNV",
    "AMBN RNA"
  ],
  "FAM74A3": [
    "FAM74A3 CNV",
    "FAM74A3 RNA"
  ],
  "ANGPT2": [
    "ANGPT2 CNV",
    "ANGPT2 RNA",
    "ANGPT2 Proteo"
  ],
  "SLC25A5P6": [
    "SLC25A5P6 CNV",
    "SLC25A5P6 RNA"
  ],
  "NDUFA5P9": [
    "NDUFA5P9 CNV",
    "NDUFA5P9 RNA"
  ],
  "RNF19B": [
    "RNF19B CNV",
    "RNF19B RNA"
  ],
  "RPL36AP39": [
    "RPL36AP39 CNV",
    "RPL36AP39 RNA"
  ],
  "RPL35P1": [
    "RPL35P1 CNV",
    "RPL35P1 RNA"
  ],
  "XIAP": [
    "XIAP CNV",
    "XIAP RNA",
    "XIAP Proteo"
  ],
  "PPP1R12B": [
    "PPP1R12B CNV",
    "PPP1R12B RNA",
    "PPP1R12B Proteo"
  ],
  "GNAQ": [
    "GNAQ CNV",
    "GNAQ RNA",
    "GNAQ Proteo"
  ],
  "METTL25": [
    "METTL25 CNV",
    "METTL25 RNA",
    "METTL25 Proteo"
  ],
  "CAPRIN2": [
    "CAPRIN2 CNV",
    "CAPRIN2 RNA"
  ],
  "SLAMF1": [
    "SLAMF1 CNV",
    "SLAMF1 RNA",
    "SLAMF1 Proteo"
  ],
  "IGFBP6": [
    "IGFBP6 CNV",
    "IGFBP6 RNA",
    "IGFBP6 Proteo"
  ],
  "C1QL4": [
    "C1QL4 CNV",
    "C1QL4 RNA"
  ],
  "OACYLP": [
    "OACYLP CNV",
    "OACYLP RNA"
  ],
  "OR52X1P": [
    "OR52X1P CNV",
    "OR52X1P RNA"
  ],
  "RPL6P10": [
    "RPL6P10 CNV",
    "RPL6P10 RNA"
  ],
  "MXRA8": [
    "MXRA8 CNV",
    "MXRA8 RNA",
    "MXRA8 Proteo"
  ],
  "UBL3": [
    "UBL3 CNV",
    "UBL3 RNA",
    "UBL3 Proteo"
  ],
  "LRRC66": [
    "LRRC66 CNV",
    "LRRC66 RNA"
  ],
  "RPS15AP40": [
    "RPS15AP40 CNV",
    "RPS15AP40 RNA"
  ],
  "GHDC": [
    "GHDC CNV",
    "GHDC RNA",
    "GHDC Proteo"
  ],
  "SULT1C2P1": [
    "SULT1C2P1 CNV",
    "SULT1C2P1 RNA"
  ],
  "EIF3D": [
    "EIF3D CNV",
    "EIF3D RNA",
    "EIF3D Proteo"
  ],
  "TTC33": [
    "TTC33 CNV",
    "TTC33 RNA",
    "TTC33 Proteo"
  ],
  "RNA5SP283": [
    "RNA5SP283 CNV",
    "RNA5SP283 RNA"
  ],
  "PPIAP68": [
    "PPIAP68 CNV",
    "PPIAP68 RNA"
  ],
  "RNA5SP67": [
    "RNA5SP67 CNV",
    "RNA5SP67 RNA"
  ],
  "MID2": [
    "MID2 CNV",
    "MID2 RNA",
    "MID2 Proteo"
  ],
  "ZNF311": [
    "ZNF311 CNV",
    "ZNF311 RNA"
  ],
  "MAP1LC3A": [
    "MAP1LC3A CNV",
    "MAP1LC3A RNA",
    "MAP1LC3A Proteo"
  ],
  "ZNF93": [
    "ZNF93 CNV",
    "ZNF93 RNA",
    "ZNF93 Proteo"
  ],
  "AKR1C5P": [
    "AKR1C5P CNV",
    "AKR1C5P RNA"
  ],
  "SLC66A3": [
    "SLC66A3 CNV",
    "SLC66A3 RNA",
    "SLC66A3 Proteo"
  ],
  "TMEM198": [
    "TMEM198 CNV",
    "TMEM198 RNA"
  ],
  "RPS26P31": [
    "RPS26P31 CNV",
    "RPS26P31 RNA"
  ],
  "S1PR4": [
    "S1PR4 CNV",
    "S1PR4 RNA"
  ],
  "RPL26P34": [
    "RPL26P34 CNV",
    "RPL26P34 RNA"
  ],
  "TMEFF1": [
    "TMEFF1 CNV",
    "TMEFF1 RNA"
  ],
  "EML5": [
    "EML5 CNV",
    "EML5 RNA"
  ],
  "TASL": [
    "TASL CNV",
    "TASL RNA",
    "TASL Proteo"
  ],
  "OR4G3P": [
    "OR4G3P CNV",
    "OR4G3P RNA"
  ],
  "TRGV5P": [
    "TRGV5P CNV",
    "TRGV5P RNA"
  ],
  "SYCP3": [
    "SYCP3 CNV",
    "SYCP3 RNA"
  ],
  "TMOD1": [
    "TMOD1 CNV",
    "TMOD1 RNA",
    "TMOD1 Proteo"
  ],
  "UBE2V1": [
    "UBE2V1 CNV",
    "UBE2V1 RNA",
    "UBE2V1 Proteo"
  ],
  "RNA5SP189": [
    "RNA5SP189 CNV",
    "RNA5SP189 RNA"
  ],
  "WWP1": [
    "WWP1 CNV",
    "WWP1 RNA",
    "WWP1 Proteo"
  ],
  "ADAM32": [
    "ADAM32 CNV",
    "ADAM32 RNA"
  ],
  "CENPVL1": [
    "CENPVL1 CNV",
    "CENPVL1 RNA"
  ],
  "GNL3L": [
    "GNL3L CNV",
    "GNL3L RNA",
    "GNL3L Proteo"
  ],
  "CARHSP1": [
    "CARHSP1 CNV",
    "CARHSP1 RNA",
    "CARHSP1 Proteo"
  ],
  "KRTAP4-11": [
    "KRTAP4-11 CNV",
    "KRTAP4-11 RNA"
  ],
  "C1orf35": [
    "C1orf35 CNV",
    "C1orf35 RNA",
    "C1orf35 Proteo"
  ],
  "MDH2": [
    "MDH2 CNV",
    "MDH2 RNA",
    "MDH2 Proteo"
  ],
  "NFYCP1": [
    "NFYCP1 CNV",
    "NFYCP1 RNA"
  ],
  "RAB11A": [
    "RAB11A CNV",
    "RAB11A RNA",
    "RAB11A Proteo"
  ],
  "RPL17P11": [
    "RPL17P11 CNV",
    "RPL17P11 RNA"
  ],
  "LDHBP2": [
    "LDHBP2 CNV",
    "LDHBP2 RNA"
  ],
  "MID1": [
    "MID1 CNV",
    "MID1 RNA",
    "MID1 Proteo"
  ],
  "WRAP53": [
    "WRAP53 CNV",
    "WRAP53 RNA",
    "WRAP53 Proteo"
  ],
  "GPI": [
    "GPI CNV",
    "GPI RNA",
    "GPI Proteo"
  ],
  "MAP4": [
    "MAP4 CNV",
    "MAP4 RNA",
    "MAP4 Proteo"
  ],
  "ESPL1": [
    "ESPL1 CNV",
    "ESPL1 RNA",
    "ESPL1 Proteo"
  ],
  "FGF7P1": [
    "FGF7P1 CNV",
    "FGF7P1 RNA"
  ],
  "CARS1": [
    "CARS1 CNV",
    "CARS1 RNA",
    "CARS1 Proteo"
  ],
  "RPL7AP41": [
    "RPL7AP41 CNV",
    "RPL7AP41 RNA"
  ],
  "ACTR3BP7": [
    "ACTR3BP7 CNV",
    "ACTR3BP7 RNA"
  ],
  "RPL31P47": [
    "RPL31P47 CNV",
    "RPL31P47 RNA"
  ],
  "RNA5SP239": [
    "RNA5SP239 CNV",
    "RNA5SP239 RNA"
  ],
  "EXOG": [
    "EXOG CNV",
    "EXOG RNA",
    "EXOG Proteo"
  ],
  "USP43": [
    "USP43 CNV",
    "USP43 RNA",
    "USP43 Proteo"
  ],
  "MPI": [
    "MPI CNV",
    "MPI RNA",
    "MPI Proteo"
  ],
  "CDIPT": [
    "CDIPT CNV",
    "CDIPT RNA",
    "CDIPT Proteo"
  ],
  "PTCH2": [
    "PTCH2 CNV",
    "PTCH2 RNA"
  ],
  "EXD1": [
    "EXD1 CNV",
    "EXD1 RNA"
  ],
  "MOCS1": [
    "MOCS1 CNV",
    "MOCS1 RNA",
    "MOCS1 Proteo"
  ],
  "TUBB4BP5": [
    "TUBB4BP5 CNV",
    "TUBB4BP5 RNA"
  ],
  "ORAI1": [
    "ORAI1 CNV",
    "ORAI1 RNA",
    "ORAI1 Proteo"
  ],
  "UBE2E4P": [
    "UBE2E4P CNV",
    "UBE2E4P RNA"
  ],
  "OPRK1": [
    "OPRK1 CNV",
    "OPRK1 RNA"
  ],
  "RPS23P3": [
    "RPS23P3 CNV",
    "RPS23P3 RNA"
  ],
  "MYH10": [
    "MYH10 CNV",
    "MYH10 RNA",
    "MYH10 Proteo"
  ],
  "FRG2C": [
    "FRG2C CNV",
    "FRG2C RNA"
  ],
  "PARP14": [
    "PARP14 CNV",
    "PARP14 RNA",
    "PARP14 Proteo"
  ],
  "VENTXP2": [
    "VENTXP2 CNV",
    "VENTXP2 RNA"
  ],
  "DUX4L13": [
    "DUX4L13 CNV",
    "DUX4L13 RNA"
  ],
  "ASPSCR1": [
    "ASPSCR1 CNV",
    "ASPSCR1 RNA",
    "ASPSCR1 Proteo"
  ],
  "IGHV1OR15-4": [
    "IGHV1OR15-4 CNV",
    "IGHV1OR15-4 RNA"
  ],
  "SH3BP5L": [
    "SH3BP5L CNV",
    "SH3BP5L RNA",
    "SH3BP5L Proteo"
  ],
  "RFKP2": [
    "RFKP2 CNV",
    "RFKP2 RNA"
  ],
  "SEPSECS": [
    "SEPSECS CNV",
    "SEPSECS RNA",
    "SEPSECS Proteo"
  ],
  "BLID": [
    "BLID CNV",
    "BLID RNA"
  ],
  "OR2M5": [
    "OR2M5 CNV",
    "OR2M5 RNA"
  ],
  "DSCAM": [
    "DSCAM CNV",
    "DSCAM RNA"
  ],
  "TMEM167AP1": [
    "TMEM167AP1 CNV",
    "TMEM167AP1 RNA"
  ],
  "UBE2D3": [
    "UBE2D3 CNV",
    "UBE2D3 RNA"
  ],
  "TIMP4": [
    "TIMP4 CNV",
    "TIMP4 RNA"
  ],
  "RNA5SP446": [
    "RNA5SP446 CNV",
    "RNA5SP446 RNA"
  ],
  "C19orf38": [
    "C19orf38 CNV",
    "C19orf38 RNA",
    "C19orf38 Proteo"
  ],
  "DRG1P1": [
    "DRG1P1 CNV",
    "DRG1P1 RNA"
  ],
  "ALOXE3P1": [
    "ALOXE3P1 CNV",
    "ALOXE3P1 RNA"
  ],
  "CMAHP": [
    "CMAHP CNV",
    "CMAHP RNA"
  ],
  "UBE2V1P3": [
    "UBE2V1P3 CNV",
    "UBE2V1P3 RNA"
  ],
  "PRR23D1": [
    "PRR23D1 CNV",
    "PRR23D1 RNA"
  ],
  "IL27RA": [
    "IL27RA CNV",
    "IL27RA RNA"
  ],
  "MS4A12": [
    "MS4A12 CNV",
    "MS4A12 RNA"
  ],
  "CDK9": [
    "CDK9 CNV",
    "CDK9 RNA",
    "CDK9 Proteo"
  ],
  "ZKSCAN2": [
    "ZKSCAN2 CNV",
    "ZKSCAN2 RNA"
  ],
  "G3BP2": [
    "G3BP2 CNV",
    "G3BP2 RNA",
    "G3BP2 Proteo"
  ],
  "DOHH": [
    "DOHH CNV",
    "DOHH RNA",
    "DOHH Proteo"
  ],
  "BLOC1S5": [
    "BLOC1S5 CNV",
    "BLOC1S5 RNA",
    "BLOC1S5 Proteo"
  ],
  "GLB1": [
    "GLB1 CNV",
    "GLB1 RNA",
    "GLB1 Proteo"
  ],
  "OBP2A": [
    "OBP2A CNV",
    "OBP2A RNA"
  ],
  "UGP2": [
    "UGP2 CNV",
    "UGP2 RNA",
    "UGP2 Proteo"
  ],
  "POLQ": [
    "POLQ CNV",
    "POLQ RNA",
    "POLQ Proteo"
  ],
  "RNA5SP192": [
    "RNA5SP192 CNV",
    "RNA5SP192 RNA"
  ],
  "URAD": [
    "URAD CNV",
    "URAD RNA"
  ],
  "NT5M": [
    "NT5M CNV",
    "NT5M RNA"
  ],
  "IL24": [
    "IL24 CNV",
    "IL24 RNA"
  ],
  "CFAP410": [
    "CFAP410 CNV",
    "CFAP410 RNA",
    "CFAP410 Proteo"
  ],
  "USP51": [
    "USP51 CNV",
    "USP51 RNA",
    "USP51 Proteo"
  ],
  "RPL36P12": [
    "RPL36P12 CNV",
    "RPL36P12 RNA"
  ],
  "LMO3": [
    "LMO3 CNV",
    "LMO3 RNA"
  ],
  "CISD1P1": [
    "CISD1P1 CNV",
    "CISD1P1 RNA"
  ],
  "MTND1P3": [
    "MTND1P3 CNV",
    "MTND1P3 RNA"
  ],
  "ATXN7L2": [
    "ATXN7L2 CNV",
    "ATXN7L2 RNA"
  ],
  "RELN": [
    "RELN CNV",
    "RELN RNA",
    "RELN Proteo"
  ],
  "WDFY3": [
    "WDFY3 CNV",
    "WDFY3 RNA",
    "WDFY3 Proteo"
  ],
  "LSM1": [
    "LSM1 CNV",
    "LSM1 RNA",
    "LSM1 Proteo"
  ],
  "COX5BP2": [
    "COX5BP2 CNV",
    "COX5BP2 RNA"
  ],
  "GSTM3P1": [
    "GSTM3P1 CNV",
    "GSTM3P1 RNA"
  ],
  "NHLH1": [
    "NHLH1 CNV",
    "NHLH1 RNA"
  ],
  "TMDD1": [
    "TMDD1 CNV",
    "TMDD1 RNA"
  ],
  "ADGRF4": [
    "ADGRF4 CNV",
    "ADGRF4 RNA"
  ],
  "CERS2": [
    "CERS2 CNV",
    "CERS2 RNA",
    "CERS2 Proteo"
  ],
  "SYTL2": [
    "SYTL2 CNV",
    "SYTL2 RNA",
    "SYTL2 Proteo"
  ],
  "GRM3": [
    "GRM3 CNV",
    "GRM3 RNA"
  ],
  "STPG4": [
    "STPG4 CNV",
    "STPG4 RNA"
  ],
  "MYH1": [
    "MYH1 CNV",
    "MYH1 RNA",
    "MYH1 Proteo"
  ],
  "GBE1": [
    "GBE1 CNV",
    "GBE1 RNA",
    "GBE1 Proteo"
  ],
  "RNA5SP207": [
    "RNA5SP207 CNV",
    "RNA5SP207 RNA"
  ],
  "ZP3P2": [
    "ZP3P2 CNV",
    "ZP3P2 RNA"
  ],
  "TCIM": [
    "TCIM CNV",
    "TCIM RNA"
  ],
  "DCAF6": [
    "DCAF6 CNV",
    "DCAF6 RNA",
    "DCAF6 Proteo"
  ],
  "VAMP8": [
    "VAMP8 CNV",
    "VAMP8 RNA",
    "VAMP8 Proteo"
  ],
  "KL": [
    "KL CNV",
    "KL RNA"
  ],
  "DPF2": [
    "DPF2 CNV",
    "DPF2 RNA",
    "DPF2 Proteo"
  ],
  "H3P13": [
    "H3P13 CNV",
    "H3P13 RNA"
  ],
  "MYO5B": [
    "MYO5B CNV",
    "MYO5B RNA",
    "MYO5B Proteo"
  ],
  "EEF1A1P11": [
    "EEF1A1P11 CNV",
    "EEF1A1P11 RNA"
  ],
  "CAB39P1": [
    "CAB39P1 CNV",
    "CAB39P1 RNA"
  ],
  "SLC25A20P1": [
    "SLC25A20P1 CNV",
    "SLC25A20P1 RNA"
  ],
  "TCF19": [
    "TCF19 CNV",
    "TCF19 RNA"
  ],
  "CLK1": [
    "CLK1 CNV",
    "CLK1 RNA",
    "CLK1 Proteo"
  ],
  "COA3": [
    "COA3 CNV",
    "COA3 RNA",
    "COA3 Proteo"
  ],
  "GAPDHP63": [
    "GAPDHP63 CNV",
    "GAPDHP63 RNA"
  ],
  "PSMA1P1": [
    "PSMA1P1 CNV",
    "PSMA1P1 RNA"
  ],
  "WHRN": [
    "WHRN CNV",
    "WHRN RNA",
    "WHRN Proteo"
  ],
  "ZIK1P1": [
    "ZIK1P1 CNV",
    "ZIK1P1 RNA"
  ],
  "VPS28": [
    "VPS28 CNV",
    "VPS28 RNA",
    "VPS28 Proteo"
  ],
  "LRRC37A16P": [
    "LRRC37A16P CNV",
    "LRRC37A16P RNA"
  ],
  "GP1BB": [
    "GP1BB CNV",
    "GP1BB RNA",
    "GP1BB Proteo"
  ],
  "FABP5P10": [
    "FABP5P10 CNV",
    "FABP5P10 RNA"
  ],
  "ZNF596": [
    "ZNF596 CNV",
    "ZNF596 RNA"
  ],
  "GYG2": [
    "GYG2 CNV",
    "GYG2 RNA",
    "GYG2 Proteo"
  ],
  "TMEM260": [
    "TMEM260 CNV",
    "TMEM260 RNA",
    "TMEM260 Proteo"
  ],
  "DUSP8": [
    "DUSP8 CNV",
    "DUSP8 RNA"
  ],
  "ZRSR2": [
    "ZRSR2 CNV",
    "ZRSR2 RNA",
    "ZRSR2 Proteo"
  ],
  "MORF4L1P5": [
    "MORF4L1P5 CNV",
    "MORF4L1P5 RNA"
  ],
  "ACTG1P9": [
    "ACTG1P9 CNV",
    "ACTG1P9 RNA"
  ],
  "ST6GALNAC4P1": [
    "ST6GALNAC4P1 CNV",
    "ST6GALNAC4P1 RNA"
  ],
  "SMIM10L2A": [
    "SMIM10L2A CNV",
    "SMIM10L2A RNA"
  ],
  "NDUFA3P4": [
    "NDUFA3P4 CNV",
    "NDUFA3P4 RNA"
  ],
  "CDC27P1": [
    "CDC27P1 CNV",
    "CDC27P1 RNA"
  ],
  "SECTM1": [
    "SECTM1 CNV",
    "SECTM1 RNA",
    "SECTM1 Proteo"
  ],
  "SIPA1L1": [
    "SIPA1L1 CNV",
    "SIPA1L1 RNA",
    "SIPA1L1 Proteo"
  ],
  "MTCYBP36": [
    "MTCYBP36 CNV",
    "MTCYBP36 RNA"
  ],
  "RNGTT": [
    "RNGTT CNV",
    "RNGTT RNA",
    "RNGTT Proteo"
  ],
  "DEFB105B": [
    "DEFB105B CNV",
    "DEFB105B RNA"
  ],
  "THRAP3P1": [
    "THRAP3P1 CNV",
    "THRAP3P1 RNA"
  ],
  "ERRFI1": [
    "ERRFI1 CNV",
    "ERRFI1 RNA",
    "ERRFI1 Proteo"
  ],
  "ALKBH4": [
    "ALKBH4 CNV",
    "ALKBH4 RNA",
    "ALKBH4 Proteo"
  ],
  "C16orf46": [
    "C16orf46 CNV",
    "C16orf46 RNA"
  ],
  "RNA5SP225": [
    "RNA5SP225 CNV",
    "RNA5SP225 RNA"
  ],
  "INA": [
    "INA CNV",
    "INA RNA",
    "INA Proteo"
  ],
  "METTL8": [
    "METTL8 CNV",
    "METTL8 RNA",
    "METTL8 Proteo"
  ],
  "GLCE": [
    "GLCE CNV",
    "GLCE RNA",
    "GLCE Proteo"
  ],
  "RPL36AP27": [
    "RPL36AP27 CNV",
    "RPL36AP27 RNA"
  ],
  "TMIGD3": [
    "TMIGD3 CNV",
    "TMIGD3 RNA"
  ],
  "CYLD": [
    "CYLD CNV",
    "CYLD RNA",
    "CYLD Proteo"
  ],
  "CATSPER2": [
    "CATSPER2 CNV",
    "CATSPER2 RNA"
  ],
  "TSGA10": [
    "TSGA10 CNV",
    "TSGA10 RNA"
  ],
  "MRPL50": [
    "MRPL50 CNV",
    "MRPL50 RNA",
    "MRPL50 Proteo"
  ],
  "MTND4P9": [
    "MTND4P9 CNV",
    "MTND4P9 RNA"
  ],
  "H1-2": [
    "H1-2 CNV",
    "H1-2 RNA",
    "H1-2 Proteo"
  ],
  "RABEPKP1": [
    "RABEPKP1 CNV",
    "RABEPKP1 RNA"
  ],
  "ADGRF5P2": [
    "ADGRF5P2 CNV",
    "ADGRF5P2 RNA"
  ],
  "MBLAC2": [
    "MBLAC2 CNV",
    "MBLAC2 RNA",
    "MBLAC2 Proteo"
  ],
  "PKD2": [
    "PKD2 CNV",
    "PKD2 RNA",
    "PKD2 Proteo"
  ],
  "THAP5P1": [
    "THAP5P1 CNV",
    "THAP5P1 RNA"
  ],
  "BRD4": [
    "BRD4 CNV",
    "BRD4 RNA",
    "BRD4 Proteo"
  ],
  "SOX5": [
    "SOX5 CNV",
    "SOX5 RNA",
    "SOX5 Proteo"
  ],
  "FKBP4P2": [
    "FKBP4P2 CNV",
    "FKBP4P2 RNA"
  ],
  "NF1P8": [
    "NF1P8 CNV",
    "NF1P8 RNA"
  ],
  "ATG4A": [
    "ATG4A CNV",
    "ATG4A RNA",
    "ATG4A Proteo"
  ],
  "DHODH": [
    "DHODH CNV",
    "DHODH RNA",
    "DHODH Proteo"
  ],
  "XPNPEP3": [
    "XPNPEP3 CNV",
    "XPNPEP3 RNA",
    "XPNPEP3 Proteo"
  ],
  "UBAP1": [
    "UBAP1 CNV",
    "UBAP1 RNA",
    "UBAP1 Proteo"
  ],
  "KLF12": [
    "KLF12 CNV",
    "KLF12 RNA",
    "KLF12 Proteo"
  ],
  "UBP1": [
    "UBP1 CNV",
    "UBP1 RNA",
    "UBP1 Proteo"
  ],
  "PRDM2": [
    "PRDM2 CNV",
    "PRDM2 RNA",
    "PRDM2 Proteo"
  ],
  "STAT3": [
    "STAT3 CNV",
    "STAT3 RNA",
    "STAT3 Proteo"
  ],
  "PIGHP1": [
    "PIGHP1 CNV",
    "PIGHP1 RNA"
  ],
  "SLC39A8": [
    "SLC39A8 CNV",
    "SLC39A8 RNA",
    "SLC39A8 Proteo"
  ],
  "ELK1": [
    "ELK1 CNV",
    "ELK1 RNA",
    "ELK1 Proteo"
  ],
  "PRPS1P2": [
    "PRPS1P2 CNV",
    "PRPS1P2 RNA"
  ],
  "TNNC1": [
    "TNNC1 CNV",
    "TNNC1 RNA",
    "TNNC1 Proteo"
  ],
  "TUBB3P2": [
    "TUBB3P2 CNV",
    "TUBB3P2 RNA"
  ],
  "CDRT4": [
    "CDRT4 CNV",
    "CDRT4 RNA"
  ],
  "CTTN": [
    "CTTN CNV",
    "CTTN RNA",
    "CTTN Proteo"
  ],
  "H4C8": [
    "H4C8 CNV",
    "H4C8 RNA"
  ],
  "PAIP2B": [
    "PAIP2B CNV",
    "PAIP2B RNA",
    "PAIP2B Proteo"
  ],
  "FAM83D": [
    "FAM83D CNV",
    "FAM83D RNA",
    "FAM83D Proteo"
  ],
  "SRRD": [
    "SRRD CNV",
    "SRRD RNA",
    "SRRD Proteo"
  ],
  "TMUB1": [
    "TMUB1 CNV",
    "TMUB1 RNA",
    "TMUB1 Proteo"
  ],
  "RPSAP2": [
    "RPSAP2 CNV",
    "RPSAP2 RNA"
  ],
  "ARMH3": [
    "ARMH3 CNV",
    "ARMH3 RNA",
    "ARMH3 Proteo"
  ],
  "ANGPTL2": [
    "ANGPTL2 CNV",
    "ANGPTL2 RNA",
    "ANGPTL2 Proteo"
  ],
  "SPATA31B1P": [
    "SPATA31B1P CNV",
    "SPATA31B1P RNA"
  ],
  "ATP5F1AP7": [
    "ATP5F1AP7 CNV",
    "ATP5F1AP7 RNA"
  ],
  "OR5B10P": [
    "OR5B10P CNV",
    "OR5B10P RNA"
  ],
  "GTPBP1": [
    "GTPBP1 CNV",
    "GTPBP1 RNA",
    "GTPBP1 Proteo"
  ],
  "RNASEH2B": [
    "RNASEH2B CNV",
    "RNASEH2B RNA",
    "RNASEH2B Proteo"
  ],
  "APOBR": [
    "APOBR CNV",
    "APOBR RNA",
    "APOBR Proteo"
  ],
  "TSGA10IP": [
    "TSGA10IP CNV",
    "TSGA10IP RNA"
  ],
  "ALG11": [
    "ALG11 CNV",
    "ALG11 RNA",
    "ALG11 Proteo"
  ],
  "HSPE1P16": [
    "HSPE1P16 CNV",
    "HSPE1P16 RNA"
  ],
  "BCRP8": [
    "BCRP8 CNV",
    "BCRP8 RNA"
  ],
  "ATG14": [
    "ATG14 CNV",
    "ATG14 RNA",
    "ATG14 Proteo"
  ],
  "TM2D1": [
    "TM2D1 CNV",
    "TM2D1 RNA",
    "TM2D1 Proteo"
  ],
  "PDGFRA": [
    "PDGFRA CNV",
    "PDGFRA RNA",
    "PDGFRA Proteo"
  ],
  "MTATP6P7": [
    "MTATP6P7 CNV",
    "MTATP6P7 RNA"
  ],
  "BTC": [
    "BTC CNV",
    "BTC RNA"
  ],
  "H1-0": [
    "H1-0 CNV",
    "H1-0 RNA",
    "H1-0 Proteo"
  ],
  "UXT": [
    "UXT CNV",
    "UXT RNA",
    "UXT Proteo"
  ],
  "TRNP1": [
    "TRNP1 CNV",
    "TRNP1 RNA",
    "TRNP1 Proteo"
  ],
  "ALDH6A1": [
    "ALDH6A1 CNV",
    "ALDH6A1 RNA",
    "ALDH6A1 Proteo"
  ],
  "SDK2": [
    "SDK2 CNV",
    "SDK2 RNA",
    "SDK2 Proteo"
  ],
  "MTATP6P5": [
    "MTATP6P5 CNV",
    "MTATP6P5 RNA"
  ],
  "RNA5SP178": [
    "RNA5SP178 CNV",
    "RNA5SP178 RNA"
  ],
  "ATG9B": [
    "ATG9B CNV",
    "ATG9B RNA"
  ],
  "BCL2": [
    "BCL2 CNV",
    "BCL2 RNA",
    "BCL2 Proteo"
  ],
  "ARRDC2": [
    "ARRDC2 CNV",
    "ARRDC2 RNA",
    "ARRDC2 Proteo"
  ],
  "GSDMD": [
    "GSDMD CNV",
    "GSDMD RNA",
    "GSDMD Proteo"
  ],
  "TERT": [
    "TERT CNV",
    "TERT RNA"
  ],
  "GPRC5C": [
    "GPRC5C CNV",
    "GPRC5C RNA",
    "GPRC5C Proteo"
  ],
  "HOXA1": [
    "HOXA1 CNV",
    "HOXA1 RNA"
  ],
  "CLN8": [
    "CLN8 CNV",
    "CLN8 RNA",
    "CLN8 Proteo"
  ],
  "RPS27AP7": [
    "RPS27AP7 CNV",
    "RPS27AP7 RNA"
  ],
  "RHEBP2": [
    "RHEBP2 CNV",
    "RHEBP2 RNA"
  ],
  "PDGFRL2P": [
    "PDGFRL2P CNV",
    "PDGFRL2P RNA"
  ],
  "LPCAT3": [
    "LPCAT3 CNV",
    "LPCAT3 RNA",
    "LPCAT3 Proteo"
  ],
  "CLBA1": [
    "CLBA1 CNV",
    "CLBA1 RNA"
  ],
  "CLEC7A": [
    "CLEC7A CNV",
    "CLEC7A RNA"
  ],
  "SLC10A5P1": [
    "SLC10A5P1 CNV",
    "SLC10A5P1 RNA"
  ],
  "PSPC1P2": [
    "PSPC1P2 CNV",
    "PSPC1P2 RNA"
  ],
  "RECQL": [
    "RECQL CNV",
    "RECQL RNA",
    "RECQL Proteo"
  ],
  "OSBP": [
    "OSBP CNV",
    "OSBP RNA",
    "OSBP Proteo"
  ],
  "ASL": [
    "ASL CNV",
    "ASL RNA",
    "ASL Proteo"
  ],
  "ARMCX3": [
    "ARMCX3 CNV",
    "ARMCX3 RNA",
    "ARMCX3 Proteo"
  ],
  "CLRN2": [
    "CLRN2 CNV",
    "CLRN2 RNA"
  ],
  "MTCYBP12": [
    "MTCYBP12 CNV",
    "MTCYBP12 RNA"
  ],
  "IGHV1OR15-9": [
    "IGHV1OR15-9 Proteo"
  ],
  "CAVIN4": [
    "CAVIN4 CNV",
    "CAVIN4 RNA"
  ],
  "PAPOLA": [
    "PAPOLA CNV",
    "PAPOLA RNA",
    "PAPOLA Proteo"
  ],
  "PLCB3": [
    "PLCB3 CNV",
    "PLCB3 RNA",
    "PLCB3 Proteo"
  ],
  "STS": [
    "STS CNV",
    "STS RNA",
    "STS Proteo"
  ],
  "MYL6": [
    "MYL6 CNV",
    "MYL6 RNA",
    "MYL6 Proteo"
  ],
  "HUS1": [
    "HUS1 CNV",
    "HUS1 RNA",
    "HUS1 Proteo"
  ],
  "ZRANB1": [
    "ZRANB1 CNV",
    "ZRANB1 RNA"
  ],
  "TDH": [
    "TDH CNV",
    "TDH RNA"
  ],
  "RPL35AP23": [
    "RPL35AP23 CNV",
    "RPL35AP23 RNA"
  ],
  "DPP3": [
    "DPP3 CNV",
    "DPP3 RNA",
    "DPP3 Proteo"
  ],
  "AP1S3": [
    "AP1S3 CNV",
    "AP1S3 RNA",
    "AP1S3 Proteo"
  ],
  "SCAF8": [
    "SCAF8 CNV",
    "SCAF8 RNA",
    "SCAF8 Proteo"
  ],
  "RNA5SP127": [
    "RNA5SP127 CNV",
    "RNA5SP127 RNA"
  ],
  "IGLV1-51": [
    "IGLV1-51 Proteo"
  ],
  "PDXP": [
    "PDXP CNV",
    "PDXP RNA",
    "PDXP Proteo"
  ],
  "SUCLA2P1": [
    "SUCLA2P1 CNV",
    "SUCLA2P1 RNA"
  ],
  "TPX2": [
    "TPX2 CNV",
    "TPX2 RNA",
    "TPX2 Proteo"
  ],
  "HOXB5": [
    "HOXB5 CNV",
    "HOXB5 RNA"
  ],
  "MAP7D3": [
    "MAP7D3 CNV",
    "MAP7D3 RNA",
    "MAP7D3 Proteo"
  ],
  "KIRREL2": [
    "KIRREL2 CNV",
    "KIRREL2 RNA"
  ],
  "DZIP1L": [
    "DZIP1L CNV",
    "DZIP1L RNA"
  ],
  "VDAC1P6": [
    "VDAC1P6 CNV",
    "VDAC1P6 RNA"
  ],
  "STARD9": [
    "STARD9 CNV",
    "STARD9 RNA"
  ],
  "UBTF": [
    "UBTF CNV",
    "UBTF RNA",
    "UBTF Proteo"
  ],
  "ZNF263": [
    "ZNF263 CNV",
    "ZNF263 RNA",
    "ZNF263 Proteo"
  ],
  "JMJD4": [
    "JMJD4 CNV",
    "JMJD4 RNA",
    "JMJD4 Proteo"
  ],
  "METTL22": [
    "METTL22 CNV",
    "METTL22 RNA",
    "METTL22 Proteo"
  ],
  "DUX4L21": [
    "DUX4L21 CNV",
    "DUX4L21 RNA"
  ],
  "AP2B1": [
    "AP2B1 CNV",
    "AP2B1 RNA",
    "AP2B1 Proteo"
  ],
  "PDCD2L": [
    "PDCD2L CNV",
    "PDCD2L RNA",
    "PDCD2L Proteo"
  ],
  "CDIP1": [
    "CDIP1 CNV",
    "CDIP1 RNA",
    "CDIP1 Proteo"
  ],
  "WBP2NL": [
    "WBP2NL CNV",
    "WBP2NL RNA"
  ],
  "PLEKHA3": [
    "PLEKHA3 CNV",
    "PLEKHA3 RNA",
    "PLEKHA3 Proteo"
  ],
  "NCDN": [
    "NCDN CNV",
    "NCDN RNA",
    "NCDN Proteo"
  ],
  "LAT2": [
    "LAT2 CNV",
    "LAT2 RNA",
    "LAT2 Proteo"
  ],
  "PPP1R3F": [
    "PPP1R3F CNV",
    "PPP1R3F RNA",
    "PPP1R3F Proteo"
  ],
  "BNIP3P25": [
    "BNIP3P25 CNV",
    "BNIP3P25 RNA"
  ],
  "MED10": [
    "MED10 CNV",
    "MED10 RNA",
    "MED10 Proteo"
  ],
  "FAM90A17": [
    "FAM90A17 CNV",
    "FAM90A17 RNA"
  ],
  "PPP2R3C": [
    "PPP2R3C CNV",
    "PPP2R3C RNA",
    "PPP2R3C Proteo"
  ],
  "H2AC16": [
    "H2AC16 CNV",
    "H2AC16 RNA"
  ],
  "RPL36AP5": [
    "RPL36AP5 CNV",
    "RPL36AP5 RNA"
  ],
  "RPLP0P2": [
    "RPLP0P2 CNV",
    "RPLP0P2 RNA"
  ],
  "MIR3171HG": [
    "MIR3171HG CNV",
    "MIR3171HG RNA"
  ],
  "NDUFB5P1": [
    "NDUFB5P1 CNV",
    "NDUFB5P1 RNA"
  ],
  "OR7E25P": [
    "OR7E25P CNV",
    "OR7E25P RNA"
  ],
  "RNA5SP520": [
    "RNA5SP520 CNV",
    "RNA5SP520 RNA"
  ],
  "ACTRT1": [
    "ACTRT1 CNV",
    "ACTRT1 RNA"
  ],
  "MTCO2P5": [
    "MTCO2P5 CNV",
    "MTCO2P5 RNA"
  ],
  "RRP8": [
    "RRP8 CNV",
    "RRP8 RNA",
    "RRP8 Proteo"
  ],
  "FAM219A": [
    "FAM219A CNV",
    "FAM219A RNA",
    "FAM219A Proteo"
  ],
  "MIX23P1": [
    "MIX23P1 CNV",
    "MIX23P1 RNA"
  ],
  "GPAT4": [
    "GPAT4 CNV",
    "GPAT4 RNA",
    "GPAT4 Proteo"
  ],
  "UGGT2": [
    "UGGT2 CNV",
    "UGGT2 RNA",
    "UGGT2 Proteo"
  ],
  "C12orf73": [
    "C12orf73 CNV",
    "C12orf73 RNA",
    "C12orf73 Proteo"
  ],
  "RPL7P33": [
    "RPL7P33 CNV",
    "RPL7P33 RNA"
  ],
  "RNA5SP73": [
    "RNA5SP73 CNV",
    "RNA5SP73 RNA"
  ],
  "RPS24P12": [
    "RPS24P12 CNV",
    "RPS24P12 RNA"
  ],
  "SOCS1": [
    "SOCS1 CNV",
    "SOCS1 RNA"
  ],
  "RPL19P21": [
    "RPL19P21 CNV",
    "RPL19P21 RNA"
  ],
  "EEF1A1P36": [
    "EEF1A1P36 CNV",
    "EEF1A1P36 RNA"
  ],
  "CTXND2": [
    "CTXND2 CNV",
    "CTXND2 RNA"
  ],
  "LZTS1": [
    "LZTS1 CNV",
    "LZTS1 RNA",
    "LZTS1 Proteo"
  ],
  "NEUROG1": [
    "NEUROG1 CNV",
    "NEUROG1 RNA"
  ],
  "NR4A2": [
    "NR4A2 CNV",
    "NR4A2 RNA"
  ],
  "OR52J1P": [
    "OR52J1P CNV",
    "OR52J1P RNA"
  ],
  "RPL39P6": [
    "RPL39P6 CNV",
    "RPL39P6 RNA"
  ],
  "CCNY": [
    "CCNY CNV",
    "CCNY RNA",
    "CCNY Proteo"
  ],
  "OR10J9P": [
    "OR10J9P CNV",
    "OR10J9P RNA"
  ],
  "OR2AP1": [
    "OR2AP1 CNV",
    "OR2AP1 RNA"
  ],
  "DTX4": [
    "DTX4 CNV",
    "DTX4 RNA"
  ],
  "OR8B7P": [
    "OR8B7P CNV",
    "OR8B7P RNA"
  ],
  "SOD1P1": [
    "SOD1P1 CNV",
    "SOD1P1 RNA"
  ],
  "IPP": [
    "IPP CNV",
    "IPP RNA",
    "IPP Proteo"
  ],
  "GJB1": [
    "GJB1 CNV",
    "GJB1 RNA",
    "GJB1 Proteo"
  ],
  "NK_Cells": [
    "NK_Cells Cell_type"
  ],
  "FGF14": [
    "FGF14 CNV",
    "FGF14 RNA"
  ],
  "MBD6": [
    "MBD6 CNV",
    "MBD6 RNA"
  ],
  "CD2BP2": [
    "CD2BP2 CNV",
    "CD2BP2 RNA",
    "CD2BP2 Proteo"
  ],
  "RPS29P24": [
    "RPS29P24 CNV",
    "RPS29P24 RNA"
  ],
  "GLYCTK": [
    "GLYCTK CNV",
    "GLYCTK RNA",
    "GLYCTK Proteo"
  ],
  "MBD3L4": [
    "MBD3L4 CNV",
    "MBD3L4 RNA"
  ],
  "CLCP1": [
    "CLCP1 CNV",
    "CLCP1 RNA"
  ],
  "GLTP": [
    "GLTP CNV",
    "GLTP RNA",
    "GLTP Proteo"
  ],
  "POGLUT2": [
    "POGLUT2 CNV",
    "POGLUT2 RNA",
    "POGLUT2 Proteo"
  ],
  "CDK5R1": [
    "CDK5R1 CNV",
    "CDK5R1 RNA"
  ],
  "KRT8P6": [
    "KRT8P6 CNV",
    "KRT8P6 RNA"
  ],
  "ADCY10": [
    "ADCY10 CNV",
    "ADCY10 RNA"
  ],
  "FKBP10": [
    "FKBP10 CNV",
    "FKBP10 RNA",
    "FKBP10 Proteo"
  ],
  "LOXL2": [
    "LOXL2 CNV",
    "LOXL2 RNA",
    "LOXL2 Proteo"
  ],
  "SLC66A1": [
    "SLC66A1 CNV",
    "SLC66A1 RNA",
    "SLC66A1 Proteo"
  ],
  "RNA5SP102": [
    "RNA5SP102 CNV",
    "RNA5SP102 RNA"
  ],
  "FOXO6": [
    "FOXO6 CNV",
    "FOXO6 RNA"
  ],
  "SNRPCP2": [
    "SNRPCP2 CNV",
    "SNRPCP2 RNA"
  ],
  "RBMX2P5": [
    "RBMX2P5 CNV",
    "RBMX2P5 RNA"
  ],
  "RBP3": [
    "RBP3 CNV",
    "RBP3 RNA"
  ],
  "ZNF722": [
    "ZNF722 CNV",
    "ZNF722 RNA"
  ],
  "TTN": [
    "TTN CNV",
    "TTN RNA",
    "TTN Proteo"
  ],
  "SPAAR": [
    "SPAAR CNV",
    "SPAAR RNA"
  ],
  "PRKD3": [
    "PRKD3 CNV",
    "PRKD3 RNA",
    "PRKD3 Proteo"
  ],
  "TBX20": [
    "TBX20 CNV",
    "TBX20 RNA"
  ],
  "MTND1P2": [
    "MTND1P2 CNV",
    "MTND1P2 RNA"
  ],
  "SYF2P1": [
    "SYF2P1 CNV",
    "SYF2P1 RNA"
  ],
  "SLC46A1": [
    "SLC46A1 CNV",
    "SLC46A1 RNA",
    "SLC46A1 Proteo"
  ],
  "KLF7": [
    "KLF7 CNV",
    "KLF7 RNA"
  ],
  "RPS24P8": [
    "RPS24P8 CNV",
    "RPS24P8 RNA"
  ],
  "RPL21P132": [
    "RPL21P132 CNV",
    "RPL21P132 RNA"
  ],
  "DACH1": [
    "DACH1 CNV",
    "DACH1 RNA"
  ],
  "PLEKHG6": [
    "PLEKHG6 CNV",
    "PLEKHG6 RNA"
  ],
  "COL24A1": [
    "COL24A1 CNV",
    "COL24A1 RNA"
  ],
  "TKFC": [
    "TKFC CNV",
    "TKFC RNA",
    "TKFC Proteo"
  ],
  "HPRT1P3": [
    "HPRT1P3 CNV",
    "HPRT1P3 RNA"
  ],
  "HNRNPA1P35": [
    "HNRNPA1P35 CNV",
    "HNRNPA1P35 RNA"
  ],
  "RXFP1": [
    "RXFP1 CNV",
    "RXFP1 RNA"
  ],
  "RNA5SP146": [
    "RNA5SP146 CNV",
    "RNA5SP146 RNA"
  ],
  "LRRFIP2P1": [
    "LRRFIP2P1 CNV",
    "LRRFIP2P1 RNA"
  ],
  "TPTE2P3": [
    "TPTE2P3 CNV",
    "TPTE2P3 RNA"
  ],
  "HSFY4P": [
    "HSFY4P CNV",
    "HSFY4P RNA"
  ],
  "WHSC1L2P": [
    "WHSC1L2P CNV",
    "WHSC1L2P RNA"
  ],
  "TAF5L": [
    "TAF5L CNV",
    "TAF5L RNA",
    "TAF5L Proteo"
  ],
  "KRT33A": [
    "KRT33A CNV",
    "KRT33A RNA",
    "KRT33A Proteo"
  ],
  "FBXO7": [
    "FBXO7 CNV",
    "FBXO7 RNA",
    "FBXO7 Proteo"
  ],
  "ATXN1": [
    "ATXN1 CNV",
    "ATXN1 RNA",
    "ATXN1 Proteo"
  ],
  "BDKRB2": [
    "BDKRB2 CNV",
    "BDKRB2 RNA"
  ],
  "ZNF114P1": [
    "ZNF114P1 CNV",
    "ZNF114P1 RNA"
  ],
  "MAPK6P2": [
    "MAPK6P2 CNV",
    "MAPK6P2 RNA"
  ],
  "ZNF593OS": [
    "ZNF593OS CNV",
    "ZNF593OS RNA"
  ],
  "LONRF2P3": [
    "LONRF2P3 CNV",
    "LONRF2P3 RNA"
  ],
  "SNRPGP18": [
    "SNRPGP18 CNV",
    "SNRPGP18 RNA"
  ],
  "CRYBG3": [
    "CRYBG3 CNV",
    "CRYBG3 RNA",
    "CRYBG3 Proteo"
  ],
  "CHTOP": [
    "CHTOP CNV",
    "CHTOP RNA",
    "CHTOP Proteo"
  ],
  "HTRA4": [
    "HTRA4 CNV",
    "HTRA4 RNA"
  ],
  "TULP3": [
    "TULP3 CNV",
    "TULP3 RNA",
    "TULP3 Proteo"
  ],
  "CCL20": [
    "CCL20 CNV",
    "CCL20 RNA"
  ],
  "YLPM1": [
    "YLPM1 CNV",
    "YLPM1 RNA",
    "YLPM1 Proteo"
  ],
  "KPRP": [
    "KPRP CNV",
    "KPRP RNA",
    "KPRP Proteo"
  ],
  "GRM1": [
    "GRM1 CNV",
    "GRM1 RNA"
  ],
  "POLR2A": [
    "POLR2A CNV",
    "POLR2A RNA",
    "POLR2A Proteo"
  ],
  "RPL35P4": [
    "RPL35P4 CNV",
    "RPL35P4 RNA"
  ],
  "APOL6": [
    "APOL6 CNV",
    "APOL6 RNA",
    "APOL6 Proteo"
  ],
  "MFSD1": [
    "MFSD1 CNV",
    "MFSD1 RNA",
    "MFSD1 Proteo"
  ],
  "ANKRD23": [
    "ANKRD23 CNV",
    "ANKRD23 RNA"
  ],
  "TP73-AS1": [
    "TP73-AS1 CNV",
    "TP73-AS1 RNA"
  ],
  "NANOGNB": [
    "NANOGNB CNV",
    "NANOGNB RNA"
  ],
  "C4orf51": [
    "C4orf51 CNV",
    "C4orf51 RNA"
  ],
  "ABCG2": [
    "ABCG2 CNV",
    "ABCG2 RNA",
    "ABCG2 Proteo"
  ],
  "OR5H14": [
    "OR5H14 CNV",
    "OR5H14 RNA"
  ],
  "CDH6": [
    "CDH6 CNV",
    "CDH6 RNA",
    "CDH6 Proteo"
  ],
  "CNDP2": [
    "CNDP2 CNV",
    "CNDP2 RNA",
    "CNDP2 Proteo"
  ],
  "MFFP1": [
    "MFFP1 CNV",
    "MFFP1 RNA"
  ],
  "H3P2": [
    "H3P2 CNV",
    "H3P2 RNA"
  ],
  "FGFBP1": [
    "FGFBP1 CNV",
    "FGFBP1 RNA"
  ],
  "OR4X2": [
    "OR4X2 CNV",
    "OR4X2 RNA"
  ],
  "HIF3A": [
    "HIF3A CNV",
    "HIF3A RNA"
  ],
  "POLR2J3_ENSG00000168255": [
    "POLR2J3_ENSG00000168255 RNA",
    "POLR2J3_ENSG00000168255 Proteo"
  ],
  "Eosinophils": [
    "Eosinophils Cell_type"
  ],
  "CEACAM16": [
    "CEACAM16 CNV",
    "CEACAM16 RNA"
  ],
  "CDKN3": [
    "CDKN3 CNV",
    "CDKN3 RNA",
    "CDKN3 Proteo"
  ],
  "PACS2": [
    "PACS2 CNV",
    "PACS2 RNA",
    "PACS2 Proteo"
  ],
  "STK25": [
    "STK25 CNV",
    "STK25 RNA",
    "STK25 Proteo"
  ],
  "HPCA": [
    "HPCA CNV",
    "HPCA RNA"
  ],
  "RPLP0P5": [
    "RPLP0P5 CNV",
    "RPLP0P5 RNA"
  ],
  "GLRA2": [
    "GLRA2 CNV",
    "GLRA2 RNA"
  ],
  "EIF4A1P6": [
    "EIF4A1P6 CNV",
    "EIF4A1P6 RNA"
  ],
  "RNA5SP489": [
    "RNA5SP489 CNV",
    "RNA5SP489 RNA"
  ],
  "ZNF70": [
    "ZNF70 CNV",
    "ZNF70 RNA",
    "ZNF70 Proteo"
  ],
  "PLAA": [
    "PLAA CNV",
    "PLAA RNA",
    "PLAA Proteo"
  ],
  "OR1L1": [
    "OR1L1 CNV",
    "OR1L1 RNA"
  ],
  "RSAD1": [
    "RSAD1 CNV",
    "RSAD1 RNA",
    "RSAD1 Proteo"
  ],
  "NALF2": [
    "NALF2 CNV",
    "NALF2 RNA"
  ],
  "IL3RA": [
    "IL3RA CNV",
    "IL3RA RNA",
    "IL3RA Proteo"
  ],
  "RSPH14": [
    "RSPH14 CNV",
    "RSPH14 RNA"
  ],
  "RPL17P10": [
    "RPL17P10 CNV",
    "RPL17P10 RNA"
  ],
  "COX6B2": [
    "COX6B2 CNV",
    "COX6B2 RNA"
  ],
  "ATP6AP1L": [
    "ATP6AP1L CNV",
    "ATP6AP1L RNA"
  ],
  "CCNH": [
    "CCNH CNV",
    "CCNH RNA",
    "CCNH Proteo"
  ],
  "GSTM3P2": [
    "GSTM3P2 CNV",
    "GSTM3P2 RNA"
  ],
  "RAD18": [
    "RAD18 CNV",
    "RAD18 RNA",
    "RAD18 Proteo"
  ],
  "TMEM238L": [
    "TMEM238L CNV",
    "TMEM238L RNA"
  ],
  "CKS1B": [
    "CKS1B CNV",
    "CKS1B RNA",
    "CKS1B Proteo"
  ],
  "TFDP2": [
    "TFDP2 CNV",
    "TFDP2 RNA",
    "TFDP2 Proteo"
  ],
  "PRADC1": [
    "PRADC1 CNV",
    "PRADC1 RNA",
    "PRADC1 Proteo"
  ],
  "MCEE": [
    "MCEE CNV",
    "MCEE RNA",
    "MCEE Proteo"
  ],
  "ATP1B1": [
    "ATP1B1 CNV",
    "ATP1B1 RNA",
    "ATP1B1 Proteo"
  ],
  "MIPEPP2": [
    "MIPEPP2 CNV",
    "MIPEPP2 RNA"
  ],
  "YWHAZP3": [
    "YWHAZP3 CNV",
    "YWHAZP3 RNA"
  ],
  "MTND5P26": [
    "MTND5P26 CNV",
    "MTND5P26 RNA"
  ],
  "PRELID3BP5": [
    "PRELID3BP5 CNV",
    "PRELID3BP5 RNA"
  ],
  "GLIS2": [
    "GLIS2 CNV",
    "GLIS2 RNA",
    "GLIS2 Proteo"
  ],
  "DNHD1": [
    "DNHD1 CNV",
    "DNHD1 RNA"
  ],
  "DEFB109F": [
    "DEFB109F CNV",
    "DEFB109F RNA"
  ],
  "PLIN3": [
    "PLIN3 CNV",
    "PLIN3 RNA",
    "PLIN3 Proteo"
  ],
  "DDX54": [
    "DDX54 CNV",
    "DDX54 RNA",
    "DDX54 Proteo"
  ],
  "MTCYBP21": [
    "MTCYBP21 CNV",
    "MTCYBP21 RNA"
  ],
  "FSD1L": [
    "FSD1L CNV",
    "FSD1L RNA",
    "FSD1L Proteo"
  ],
  "HIGD1AP13": [
    "HIGD1AP13 CNV",
    "HIGD1AP13 RNA"
  ],
  "ATP5IF1": [
    "ATP5IF1 CNV",
    "ATP5IF1 RNA",
    "ATP5IF1 Proteo"
  ],
  "TSC22D1": [
    "TSC22D1 CNV",
    "TSC22D1 RNA",
    "TSC22D1 Proteo"
  ],
  "MKKS_ENSG00000285723": [
    "MKKS_ENSG00000285723 RNA",
    "MKKS_ENSG00000285723 Proteo"
  ],
  "GTF3A": [
    "GTF3A CNV",
    "GTF3A RNA",
    "GTF3A Proteo"
  ],
  "PHTF1": [
    "PHTF1 CNV",
    "PHTF1 RNA"
  ],
  "ZNF320": [
    "ZNF320 CNV",
    "ZNF320 RNA"
  ],
  "CPVL": [
    "CPVL CNV",
    "CPVL RNA",
    "CPVL Proteo"
  ],
  "ACY3": [
    "ACY3 CNV",
    "ACY3 RNA",
    "ACY3 Proteo"
  ],
  "PODXL": [
    "PODXL CNV",
    "PODXL RNA",
    "PODXL Proteo"
  ],
  "QTRT2": [
    "QTRT2 CNV",
    "QTRT2 RNA",
    "QTRT2 Proteo"
  ],
  "RPS3AP51": [
    "RPS3AP51 CNV",
    "RPS3AP51 RNA"
  ],
  "NUDT16L2P": [
    "NUDT16L2P CNV",
    "NUDT16L2P RNA"
  ],
  "CAAP1": [
    "CAAP1 CNV",
    "CAAP1 RNA",
    "CAAP1 Proteo"
  ],
  "NACAP5": [
    "NACAP5 CNV",
    "NACAP5 RNA"
  ],
  "ZNF302": [
    "ZNF302 CNV",
    "ZNF302 RNA"
  ],
  "ATAT1": [
    "ATAT1 CNV",
    "ATAT1 RNA",
    "ATAT1 Proteo"
  ],
  "RPL7AP3": [
    "RPL7AP3 CNV",
    "RPL7AP3 RNA"
  ],
  "CPO": [
    "CPO CNV",
    "CPO RNA"
  ],
  "OR5M10": [
    "OR5M10 CNV",
    "OR5M10 RNA"
  ],
  "B4GALNT4": [
    "B4GALNT4 CNV",
    "B4GALNT4 RNA"
  ],
  "C4orf33": [
    "C4orf33 CNV",
    "C4orf33 RNA",
    "C4orf33 Proteo"
  ],
  "ECRG4": [
    "ECRG4 CNV",
    "ECRG4 RNA"
  ],
  "RNA5SP124": [
    "RNA5SP124 CNV",
    "RNA5SP124 RNA"
  ],
  "ZNF843": [
    "ZNF843 CNV",
    "ZNF843 RNA"
  ],
  "RBBP8P1": [
    "RBBP8P1 CNV",
    "RBBP8P1 RNA"
  ],
  "RPS15AP12": [
    "RPS15AP12 CNV",
    "RPS15AP12 RNA"
  ],
  "TAF3": [
    "TAF3 CNV",
    "TAF3 RNA",
    "TAF3 Proteo"
  ],
  "RELL1": [
    "RELL1 CNV",
    "RELL1 RNA",
    "RELL1 Proteo"
  ],
  "ZBTB48": [
    "ZBTB48 CNV",
    "ZBTB48 RNA",
    "ZBTB48 Proteo"
  ],
  "SMARCE1P2": [
    "SMARCE1P2 CNV",
    "SMARCE1P2 RNA"
  ],
  "MGAT4FP": [
    "MGAT4FP CNV",
    "MGAT4FP RNA"
  ],
  "AQP2": [
    "AQP2 CNV",
    "AQP2 RNA"
  ],
  "GGTA1": [
    "GGTA1 CNV",
    "GGTA1 RNA"
  ],
  "CCDC172": [
    "CCDC172 CNV",
    "CCDC172 RNA"
  ],
  "HPD": [
    "HPD CNV",
    "HPD RNA"
  ],
  "UCP3": [
    "UCP3 CNV",
    "UCP3 RNA"
  ],
  "UBE2K": [
    "UBE2K CNV",
    "UBE2K RNA",
    "UBE2K Proteo"
  ],
  "WDR4P2": [
    "WDR4P2 CNV",
    "WDR4P2 RNA"
  ],
  "ATG12P2": [
    "ATG12P2 CNV",
    "ATG12P2 RNA"
  ],
  "VN1R96P": [
    "VN1R96P CNV",
    "VN1R96P RNA"
  ],
  "HNRNPLL": [
    "HNRNPLL CNV",
    "HNRNPLL RNA",
    "HNRNPLL Proteo"
  ],
  "DUSP10": [
    "DUSP10 CNV",
    "DUSP10 RNA"
  ],
  "ARFGEF3": [
    "ARFGEF3 CNV",
    "ARFGEF3 RNA",
    "ARFGEF3 Proteo"
  ],
  "PTGER2": [
    "PTGER2 CNV",
    "PTGER2 RNA"
  ],
  "NGF": [
    "NGF CNV",
    "NGF RNA"
  ],
  "PARP1": [
    "PARP1 CNV",
    "PARP1 RNA",
    "PARP1 Proteo"
  ],
  "HMGN2P46": [
    "HMGN2P46 CNV",
    "HMGN2P46 RNA"
  ],
  "FBLIM1": [
    "FBLIM1 CNV",
    "FBLIM1 RNA",
    "FBLIM1 Proteo"
  ],
  "PIP5K1P2": [
    "PIP5K1P2 CNV",
    "PIP5K1P2 RNA"
  ],
  "SLC34A2": [
    "SLC34A2 CNV",
    "SLC34A2 RNA"
  ],
  "LYPD8": [
    "LYPD8 CNV",
    "LYPD8 RNA"
  ],
  "ENC1": [
    "ENC1 CNV",
    "ENC1 RNA",
    "ENC1 Proteo"
  ],
  "CENPW": [
    "CENPW CNV",
    "CENPW RNA",
    "CENPW Proteo"
  ],
  "MRPL36P1": [
    "MRPL36P1 CNV",
    "MRPL36P1 RNA"
  ],
  "HOGA1": [
    "HOGA1 CNV",
    "HOGA1 RNA",
    "HOGA1 Proteo"
  ],
  "SLC25A5P9": [
    "SLC25A5P9 CNV",
    "SLC25A5P9 RNA"
  ],
  "MFSD9": [
    "MFSD9 CNV",
    "MFSD9 RNA",
    "MFSD9 Proteo"
  ],
  "SLC43A3": [
    "SLC43A3 CNV",
    "SLC43A3 RNA",
    "SLC43A3 Proteo"
  ],
  "CIAO2AP1": [
    "CIAO2AP1 CNV",
    "CIAO2AP1 RNA"
  ],
  "PSMC1P3": [
    "PSMC1P3 CNV",
    "PSMC1P3 RNA"
  ],
  "HNRNPU": [
    "HNRNPU CNV",
    "HNRNPU RNA",
    "HNRNPU Proteo"
  ],
  "RHOC": [
    "RHOC CNV",
    "RHOC RNA",
    "RHOC Proteo"
  ],
  "ARF5": [
    "ARF5 CNV",
    "ARF5 RNA",
    "ARF5 Proteo"
  ],
  "CCDC77": [
    "CCDC77 CNV",
    "CCDC77 RNA",
    "CCDC77 Proteo"
  ],
  "NCOR1P1": [
    "NCOR1P1 CNV",
    "NCOR1P1 RNA"
  ],
  "DNASE1L1": [
    "DNASE1L1 CNV",
    "DNASE1L1 RNA",
    "DNASE1L1 Proteo"
  ],
  "HNRNPMP1": [
    "HNRNPMP1 CNV",
    "HNRNPMP1 RNA"
  ],
  "HSPA8P20": [
    "HSPA8P20 CNV",
    "HSPA8P20 RNA"
  ],
  "XYLB": [
    "XYLB CNV",
    "XYLB RNA",
    "XYLB Proteo"
  ],
  "MTND5P6": [
    "MTND5P6 CNV",
    "MTND5P6 RNA"
  ],
  "ANKDD1B": [
    "ANKDD1B CNV",
    "ANKDD1B RNA"
  ],
  "NBEAP3": [
    "NBEAP3 CNV",
    "NBEAP3 RNA"
  ],
  "N4BP2L2": [
    "N4BP2L2 CNV",
    "N4BP2L2 RNA",
    "N4BP2L2 Proteo"
  ],
  "PGR": [
    "PGR CNV",
    "PGR RNA",
    "PGR Proteo"
  ],
  "TIGD7": [
    "TIGD7 CNV",
    "TIGD7 RNA",
    "TIGD7 Proteo"
  ],
  "IGKV2-24": [
    "IGKV2-24 Proteo"
  ],
  "RAB28": [
    "RAB28 CNV",
    "RAB28 RNA",
    "RAB28 Proteo"
  ],
  "CHD9": [
    "CHD9 CNV",
    "CHD9 RNA",
    "CHD9 Proteo"
  ],
  "HIVEP2": [
    "HIVEP2 CNV",
    "HIVEP2 RNA",
    "HIVEP2 Proteo"
  ],
  "FIGN": [
    "FIGN CNV",
    "FIGN RNA"
  ],
  "CT45A10": [
    "CT45A10 CNV",
    "CT45A10 RNA",
    "CT45A10 Proteo"
  ],
  "CACNG2": [
    "CACNG2 CNV",
    "CACNG2 RNA"
  ],
  "RBX1P2": [
    "RBX1P2 CNV",
    "RBX1P2 RNA"
  ],
  "SEMA4C": [
    "SEMA4C CNV",
    "SEMA4C RNA",
    "SEMA4C Proteo"
  ],
  "LMBRD1": [
    "LMBRD1 CNV",
    "LMBRD1 RNA",
    "LMBRD1 Proteo"
  ],
  "CAPN15": [
    "CAPN15 CNV",
    "CAPN15 RNA",
    "CAPN15 Proteo"
  ],
  "SMSP1": [
    "SMSP1 CNV",
    "SMSP1 RNA"
  ],
  "SYNDIG1": [
    "SYNDIG1 CNV",
    "SYNDIG1 RNA"
  ],
  "RPL7P58": [
    "RPL7P58 CNV",
    "RPL7P58 RNA"
  ],
  "DUSP13": [
    "DUSP13 CNV",
    "DUSP13 RNA"
  ],
  "AMPD2": [
    "AMPD2 CNV",
    "AMPD2 RNA",
    "AMPD2 Proteo"
  ],
  "NLRP13": [
    "NLRP13 CNV",
    "NLRP13 RNA"
  ],
  "ASNSP3": [
    "ASNSP3 CNV",
    "ASNSP3 RNA"
  ],
  "CUL3": [
    "CUL3 CNV",
    "CUL3 RNA",
    "CUL3 Proteo"
  ],
  "CES3": [
    "CES3 CNV",
    "CES3 RNA"
  ],
  "GPR84": [
    "GPR84 CNV",
    "GPR84 RNA",
    "GPR84 Proteo"
  ],
  "TNRC18P3": [
    "TNRC18P3 CNV",
    "TNRC18P3 RNA"
  ],
  "GATD3": [
    "GATD3 CNV",
    "GATD3 RNA",
    "GATD3 Proteo"
  ],
  "GLT8D2": [
    "GLT8D2 CNV",
    "GLT8D2 RNA",
    "GLT8D2 Proteo"
  ],
  "ZNF45": [
    "ZNF45 CNV",
    "ZNF45 RNA"
  ],
  "RNA5SP410": [
    "RNA5SP410 CNV",
    "RNA5SP410 RNA"
  ],
  "FBXW11": [
    "FBXW11 CNV",
    "FBXW11 RNA",
    "FBXW11 Proteo"
  ],
  "ERCC1": [
    "ERCC1 CNV",
    "ERCC1 RNA",
    "ERCC1 Proteo"
  ],
  "DYNC1I2": [
    "DYNC1I2 CNV",
    "DYNC1I2 RNA",
    "DYNC1I2 Proteo"
  ],
  "PLS3": [
    "PLS3 CNV",
    "PLS3 RNA",
    "PLS3 Proteo"
  ],
  "GSTZ1": [
    "GSTZ1 CNV",
    "GSTZ1 RNA",
    "GSTZ1 Proteo"
  ],
  "PA2G4P6": [
    "PA2G4P6 CNV",
    "PA2G4P6 RNA"
  ],
  "CCDC47": [
    "CCDC47 CNV",
    "CCDC47 RNA",
    "CCDC47 Proteo"
  ],
  "ADGRG4": [
    "ADGRG4 CNV",
    "ADGRG4 RNA"
  ],
  "MIPEPP1": [
    "MIPEPP1 CNV",
    "MIPEPP1 RNA"
  ],
  "RAB11FIP2": [
    "RAB11FIP2 CNV",
    "RAB11FIP2 RNA",
    "RAB11FIP2 Proteo"
  ],
  "HCG9P5": [
    "HCG9P5 CNV",
    "HCG9P5 RNA"
  ],
  "ELOCP24": [
    "ELOCP24 CNV",
    "ELOCP24 RNA"
  ],
  "BPIFB9P": [
    "BPIFB9P CNV",
    "BPIFB9P RNA"
  ],
  "CRKL": [
    "CRKL CNV",
    "CRKL RNA",
    "CRKL Proteo"
  ],
  "SPG21": [
    "SPG21 CNV",
    "SPG21 RNA",
    "SPG21 Proteo"
  ],
  "E2F5": [
    "E2F5 CNV",
    "E2F5 RNA",
    "E2F5 Proteo"
  ],
  "GPR180": [
    "GPR180 CNV",
    "GPR180 RNA",
    "GPR180 Proteo"
  ],
  "CAVIN2": [
    "CAVIN2 CNV",
    "CAVIN2 RNA",
    "CAVIN2 Proteo"
  ],
  "DDX11L17": [
    "DDX11L17 CNV",
    "DDX11L17 RNA"
  ],
  "EHMT2": [
    "EHMT2 CNV",
    "EHMT2 RNA",
    "EHMT2 Proteo"
  ],
  "USH1G": [
    "USH1G CNV",
    "USH1G RNA"
  ],
  "MXRA5": [
    "MXRA5 CNV",
    "MXRA5 RNA",
    "MXRA5 Proteo"
  ],
  "SLC25A20": [
    "SLC25A20 CNV",
    "SLC25A20 RNA",
    "SLC25A20 Proteo"
  ],
  "FBXW10": [
    "FBXW10 CNV",
    "FBXW10 RNA"
  ],
  "MTDH": [
    "MTDH CNV",
    "MTDH RNA",
    "MTDH Proteo"
  ],
  "SLC28A1": [
    "SLC28A1 CNV",
    "SLC28A1 RNA"
  ],
  "MTARC2": [
    "MTARC2 CNV",
    "MTARC2 RNA",
    "MTARC2 Proteo"
  ],
  "JPT2": [
    "JPT2 CNV",
    "JPT2 RNA",
    "JPT2 Proteo"
  ],
  "ACTG1P1": [
    "ACTG1P1 CNV",
    "ACTG1P1 RNA"
  ],
  "SNRPCP18": [
    "SNRPCP18 CNV",
    "SNRPCP18 RNA"
  ],
  "GOLGA6L23P": [
    "GOLGA6L23P CNV",
    "GOLGA6L23P RNA"
  ],
  "POLK": [
    "POLK CNV",
    "POLK RNA",
    "POLK Proteo"
  ],
  "MTNR1B": [
    "MTNR1B CNV",
    "MTNR1B RNA"
  ],
  "CCDC65": [
    "CCDC65 CNV",
    "CCDC65 RNA"
  ],
  "CLDND1": [
    "CLDND1 CNV",
    "CLDND1 RNA",
    "CLDND1 Proteo"
  ],
  "CT47A11": [
    "CT47A11 CNV",
    "CT47A11 RNA"
  ],
  "ACTC1": [
    "ACTC1 CNV",
    "ACTC1 RNA",
    "ACTC1 Proteo"
  ],
  "SSXP5": [
    "SSXP5 CNV",
    "SSXP5 RNA"
  ],
  "OR4Q1P": [
    "OR4Q1P CNV",
    "OR4Q1P RNA"
  ],
  "PCP4": [
    "PCP4 CNV",
    "PCP4 RNA",
    "PCP4 Proteo"
  ],
  "KSR2": [
    "KSR2 CNV",
    "KSR2 RNA"
  ],
  "ANAPC7": [
    "ANAPC7 CNV",
    "ANAPC7 RNA",
    "ANAPC7 Proteo"
  ],
  "KRT18P45": [
    "KRT18P45 CNV",
    "KRT18P45 RNA"
  ],
  "CPHXL": [
    "CPHXL CNV",
    "CPHXL RNA"
  ],
  "REXO1L3P": [
    "REXO1L3P CNV",
    "REXO1L3P RNA"
  ],
  "CYP1D1P": [
    "CYP1D1P CNV",
    "CYP1D1P RNA"
  ],
  "NCLN": [
    "NCLN CNV",
    "NCLN RNA",
    "NCLN Proteo"
  ],
  "RNF135": [
    "RNF135 CNV",
    "RNF135 RNA",
    "RNF135 Proteo"
  ],
  "RBBP7": [
    "RBBP7 CNV",
    "RBBP7 RNA",
    "RBBP7 Proteo"
  ],
  "LDHD": [
    "LDHD CNV",
    "LDHD RNA",
    "LDHD Proteo"
  ],
  "BLVRB": [
    "BLVRB CNV",
    "BLVRB RNA",
    "BLVRB Proteo"
  ],
  "ZBTB7A": [
    "ZBTB7A CNV",
    "ZBTB7A RNA",
    "ZBTB7A Proteo"
  ],
  "GYG1P3": [
    "GYG1P3 CNV",
    "GYG1P3 RNA"
  ],
  "MTND3P24": [
    "MTND3P24 CNV",
    "MTND3P24 RNA"
  ],
  "WDR35": [
    "WDR35 CNV",
    "WDR35 RNA",
    "WDR35 Proteo"
  ],
  "GAGE1": [
    "GAGE1 CNV",
    "GAGE1 RNA",
    "GAGE1 Proteo"
  ],
  "VDAC2P2": [
    "VDAC2P2 CNV",
    "VDAC2P2 RNA"
  ],
  "CXorf38": [
    "CXorf38 CNV",
    "CXorf38 RNA",
    "CXorf38 Proteo"
  ],
  "DDX10": [
    "DDX10 CNV",
    "DDX10 RNA",
    "DDX10 Proteo"
  ],
  "CEP112": [
    "CEP112 CNV",
    "CEP112 RNA",
    "CEP112 Proteo"
  ],
  "SMIM20": [
    "SMIM20 CNV",
    "SMIM20 RNA",
    "SMIM20 Proteo"
  ],
  "HNRNPA1P34": [
    "HNRNPA1P34 CNV",
    "HNRNPA1P34 RNA"
  ],
  "CYB5AP4": [
    "CYB5AP4 CNV",
    "CYB5AP4 RNA"
  ],
  "UPK3BL2": [
    "UPK3BL2 CNV",
    "UPK3BL2 RNA"
  ],
  "ATP7BP1": [
    "ATP7BP1 CNV",
    "ATP7BP1 RNA"
  ],
  "SMG1P2": [
    "SMG1P2 CNV",
    "SMG1P2 RNA"
  ],
  "M6PR": [
    "M6PR CNV",
    "M6PR RNA",
    "M6PR Proteo"
  ],
  "NR0B1": [
    "NR0B1 CNV",
    "NR0B1 RNA",
    "NR0B1 Proteo"
  ],
  "TNFSF8": [
    "TNFSF8 CNV",
    "TNFSF8 RNA"
  ],
  "LY75-CD302": [
    "LY75-CD302 Proteo"
  ],
  "ME1": [
    "ME1 CNV",
    "ME1 RNA",
    "ME1 Proteo"
  ],
  "C2orf42": [
    "C2orf42 CNV",
    "C2orf42 RNA"
  ],
  "MKRN6P": [
    "MKRN6P CNV",
    "MKRN6P RNA"
  ],
  "SNX3": [
    "SNX3 CNV",
    "SNX3 RNA",
    "SNX3 Proteo"
  ],
  "SLC25A15P4": [
    "SLC25A15P4 CNV",
    "SLC25A15P4 RNA"
  ],
  "BTBD10": [
    "BTBD10 CNV",
    "BTBD10 RNA",
    "BTBD10 Proteo"
  ],
  "LIN37": [
    "LIN37 CNV",
    "LIN37 RNA",
    "LIN37 Proteo"
  ],
  "OR2W2P": [
    "OR2W2P CNV",
    "OR2W2P RNA"
  ],
  "TSSK1A": [
    "TSSK1A CNV",
    "TSSK1A RNA"
  ],
  "RALA": [
    "RALA CNV",
    "RALA RNA",
    "RALA Proteo"
  ],
  "TFAP2A": [
    "TFAP2A CNV",
    "TFAP2A RNA",
    "TFAP2A Proteo"
  ],
  "SPDYE18": [
    "SPDYE18 CNV",
    "SPDYE18 RNA"
  ],
  "RAB44": [
    "RAB44 CNV",
    "RAB44 RNA",
    "RAB44 Proteo"
  ],
  "NDFIP1P1": [
    "NDFIP1P1 CNV",
    "NDFIP1P1 RNA"
  ],
  "E2F6P1": [
    "E2F6P1 CNV",
    "E2F6P1 RNA"
  ],
  "ATP5MG": [
    "ATP5MG CNV",
    "ATP5MG RNA",
    "ATP5MG Proteo"
  ],
  "ANKRD39": [
    "ANKRD39 CNV",
    "ANKRD39 RNA",
    "ANKRD39 Proteo"
  ],
  "SAMD4A": [
    "SAMD4A CNV",
    "SAMD4A RNA",
    "SAMD4A Proteo"
  ],
  "TDGF1": [
    "TDGF1 CNV",
    "TDGF1 RNA"
  ],
  "UNK": [
    "UNK CNV",
    "UNK RNA",
    "UNK Proteo"
  ],
  "ZFHX3": [
    "ZFHX3 CNV",
    "ZFHX3 RNA",
    "ZFHX3 Proteo"
  ],
  "RPL31P49": [
    "RPL31P49 CNV",
    "RPL31P49 RNA"
  ],
  "DNAH5": [
    "DNAH5 CNV",
    "DNAH5 RNA",
    "DNAH5 Proteo"
  ],
  "PDIA3P1": [
    "PDIA3P1 CNV",
    "PDIA3P1 RNA"
  ],
  "KRT18P24": [
    "KRT18P24 CNV",
    "KRT18P24 RNA"
  ],
  "UNC93B6": [
    "UNC93B6 CNV",
    "UNC93B6 RNA"
  ],
  "MRPS18B": [
    "MRPS18B CNV",
    "MRPS18B RNA",
    "MRPS18B Proteo"
  ],
  "UBE2NP1": [
    "UBE2NP1 CNV",
    "UBE2NP1 RNA"
  ],
  "LINC03006": [
    "LINC03006 CNV",
    "LINC03006 RNA"
  ],
  "ASB4": [
    "ASB4 CNV",
    "ASB4 RNA"
  ],
  "KRT8P24": [
    "KRT8P24 CNV",
    "KRT8P24 RNA"
  ],
  "NKAPL": [
    "NKAPL CNV",
    "NKAPL RNA"
  ],
  "PPP4C": [
    "PPP4C CNV",
    "PPP4C RNA",
    "PPP4C Proteo"
  ],
  "G6PC2": [
    "G6PC2 CNV",
    "G6PC2 RNA"
  ],
  "PCGF2": [
    "PCGF2 CNV",
    "PCGF2 RNA",
    "PCGF2 Proteo"
  ],
  "SUSD1": [
    "SUSD1 CNV",
    "SUSD1 RNA"
  ],
  "FDPSP5": [
    "FDPSP5 CNV",
    "FDPSP5 RNA"
  ],
  "MTND2P15": [
    "MTND2P15 CNV",
    "MTND2P15 RNA"
  ],
  "CD40LG": [
    "CD40LG CNV",
    "CD40LG RNA"
  ],
  "IGKV1D-35": [
    "IGKV1D-35 CNV",
    "IGKV1D-35 RNA"
  ],
  "MRPL57P6": [
    "MRPL57P6 CNV",
    "MRPL57P6 RNA"
  ],
  "ATE1": [
    "ATE1 CNV",
    "ATE1 RNA",
    "ATE1 Proteo"
  ],
  "C19orf18": [
    "C19orf18 CNV",
    "C19orf18 RNA"
  ],
  "NRADDP": [
    "NRADDP CNV",
    "NRADDP RNA"
  ],
  "ZNF440": [
    "ZNF440 CNV",
    "ZNF440 RNA"
  ],
  "LUC7L3": [
    "LUC7L3 CNV",
    "LUC7L3 RNA",
    "LUC7L3 Proteo"
  ],
  "HNRNPA1P21": [
    "HNRNPA1P21 CNV",
    "HNRNPA1P21 RNA"
  ],
  "BATF2": [
    "BATF2 CNV",
    "BATF2 RNA"
  ],
  "SNRPE": [
    "SNRPE CNV",
    "SNRPE RNA",
    "SNRPE Proteo"
  ],
  "EEF1A1P22": [
    "EEF1A1P22 CNV",
    "EEF1A1P22 RNA"
  ],
  "HRCT1": [
    "HRCT1 CNV",
    "HRCT1 RNA"
  ],
  "UBQLN4P2": [
    "UBQLN4P2 CNV",
    "UBQLN4P2 RNA"
  ],
  "TUBBP5": [
    "TUBBP5 CNV",
    "TUBBP5 RNA"
  ],
  "TRIM15": [
    "TRIM15 CNV",
    "TRIM15 RNA"
  ],
  "KCTD13": [
    "KCTD13 CNV",
    "KCTD13 RNA",
    "KCTD13 Proteo"
  ],
  "CD300C": [
    "CD300C CNV",
    "CD300C RNA"
  ],
  "ASMT": [
    "ASMT CNV",
    "ASMT RNA"
  ],
  "RPL7AP58": [
    "RPL7AP58 CNV",
    "RPL7AP58 RNA"
  ],
  "RPL21P47": [
    "RPL21P47 CNV",
    "RPL21P47 RNA"
  ],
  "IL17B": [
    "IL17B CNV",
    "IL17B RNA"
  ],
  "NCOR1P2": [
    "NCOR1P2 CNV",
    "NCOR1P2 RNA"
  ],
  "DPY19L2P3": [
    "DPY19L2P3 CNV",
    "DPY19L2P3 RNA"
  ],
  "TAS1R2": [
    "TAS1R2 CNV",
    "TAS1R2 RNA"
  ],
  "TJP1": [
    "TJP1 CNV",
    "TJP1 RNA",
    "TJP1 Proteo"
  ],
  "CLTRN": [
    "CLTRN CNV",
    "CLTRN RNA"
  ],
  "RFTN2": [
    "RFTN2 CNV",
    "RFTN2 RNA",
    "RFTN2 Proteo"
  ],
  "GPS2": [
    "GPS2 CNV",
    "GPS2 RNA",
    "GPS2 Proteo"
  ],
  "FAM204CP": [
    "FAM204CP CNV",
    "FAM204CP RNA"
  ],
  "AQP7P3": [
    "AQP7P3 CNV",
    "AQP7P3 RNA"
  ],
  "IMP3": [
    "IMP3 CNV",
    "IMP3 RNA",
    "IMP3 Proteo"
  ],
  "ZFP14": [
    "ZFP14 CNV",
    "ZFP14 RNA"
  ],
  "SLC16A3": [
    "SLC16A3 CNV",
    "SLC16A3 RNA",
    "SLC16A3 Proteo"
  ],
  "NAPG": [
    "NAPG CNV",
    "NAPG RNA",
    "NAPG Proteo"
  ],
  "RIIAD1": [
    "RIIAD1 CNV",
    "RIIAD1 RNA"
  ],
  "PCDHB13": [
    "PCDHB13 CNV",
    "PCDHB13 RNA"
  ],
  "ODAPH": [
    "ODAPH CNV",
    "ODAPH RNA"
  ],
  "RETSAT": [
    "RETSAT CNV",
    "RETSAT RNA",
    "RETSAT Proteo"
  ],
  "SEPTIN1": [
    "SEPTIN1 CNV",
    "SEPTIN1 RNA",
    "SEPTIN1 Proteo"
  ],
  "DZIP3": [
    "DZIP3 CNV",
    "DZIP3 RNA",
    "DZIP3 Proteo"
  ],
  "DDR2": [
    "DDR2 CNV",
    "DDR2 RNA",
    "DDR2 Proteo"
  ],
  "PSMC1P2": [
    "PSMC1P2 CNV",
    "PSMC1P2 RNA"
  ],
  "NEU3": [
    "NEU3 CNV",
    "NEU3 RNA",
    "NEU3 Proteo"
  ],
  "GJB4": [
    "GJB4 CNV",
    "GJB4 RNA"
  ],
  "VEPH1": [
    "VEPH1 CNV",
    "VEPH1 RNA",
    "VEPH1 Proteo"
  ],
  "BNIP3P20": [
    "BNIP3P20 CNV",
    "BNIP3P20 RNA"
  ],
  "MIB2": [
    "MIB2 CNV",
    "MIB2 RNA",
    "MIB2 Proteo"
  ],
  "PRDX2": [
    "PRDX2 CNV",
    "PRDX2 RNA",
    "PRDX2 Proteo"
  ],
  "TRIP6": [
    "TRIP6 CNV",
    "TRIP6 RNA",
    "TRIP6 Proteo"
  ],
  "LRRC70": [
    "LRRC70 CNV",
    "LRRC70 RNA"
  ],
  "DISP1": [
    "DISP1 CNV",
    "DISP1 RNA",
    "DISP1 Proteo"
  ],
  "YWHAZ": [
    "YWHAZ CNV",
    "YWHAZ RNA",
    "YWHAZ Proteo"
  ],
  "PROC": [
    "PROC CNV",
    "PROC RNA",
    "PROC Proteo"
  ],
  "HS2ST1": [
    "HS2ST1 CNV",
    "HS2ST1 RNA",
    "HS2ST1 Proteo"
  ],
  "GALNT8": [
    "GALNT8 CNV",
    "GALNT8 RNA"
  ],
  "KIRREL1": [
    "KIRREL1 CNV",
    "KIRREL1 RNA",
    "KIRREL1 Proteo"
  ],
  "FTH1P11": [
    "FTH1P11 CNV",
    "FTH1P11 RNA"
  ],
  "ESRRA": [
    "ESRRA CNV",
    "ESRRA RNA",
    "ESRRA Proteo"
  ],
  "CTNNA2": [
    "CTNNA2 CNV",
    "CTNNA2 RNA",
    "CTNNA2 Proteo"
  ],
  "CD274": [
    "CD274 CNV",
    "CD274 RNA",
    "CD274 Proteo"
  ],
  "STX18": [
    "STX18 CNV",
    "STX18 RNA",
    "STX18 Proteo"
  ],
  "LYRM9": [
    "LYRM9 CNV",
    "LYRM9 RNA",
    "LYRM9 Proteo"
  ],
  "IGLCOR22-1": [
    "IGLCOR22-1 CNV",
    "IGLCOR22-1 RNA"
  ],
  "CBX3P2": [
    "CBX3P2 CNV",
    "CBX3P2 RNA"
  ],
  "CSPG4BP": [
    "CSPG4BP CNV",
    "CSPG4BP RNA"
  ],
  "MFSD1P1": [
    "MFSD1P1 CNV",
    "MFSD1P1 RNA"
  ],
  "OR4R2P": [
    "OR4R2P CNV",
    "OR4R2P RNA"
  ],
  "MAGEB4": [
    "MAGEB4 CNV",
    "MAGEB4 RNA"
  ],
  "CRISP1": [
    "CRISP1 CNV",
    "CRISP1 RNA"
  ],
  "HSFY2": [
    "HSFY2 CNV",
    "HSFY2 RNA"
  ],
  "ATG10": [
    "ATG10 CNV",
    "ATG10 RNA",
    "ATG10 Proteo"
  ],
  "ZNF670": [
    "ZNF670 CNV",
    "ZNF670 RNA",
    "ZNF670 Proteo"
  ],
  "FOXR1": [
    "FOXR1 CNV",
    "FOXR1 RNA"
  ],
  "COL6A6": [
    "COL6A6 CNV",
    "COL6A6 RNA",
    "COL6A6 Proteo"
  ],
  "SCGB1D4": [
    "SCGB1D4 CNV",
    "SCGB1D4 RNA"
  ],
  "TRAT1": [
    "TRAT1 CNV",
    "TRAT1 RNA"
  ],
  "CCDC51": [
    "CCDC51 CNV",
    "CCDC51 RNA",
    "CCDC51 Proteo"
  ],
  "EXT2": [
    "EXT2 CNV",
    "EXT2 RNA",
    "EXT2 Proteo"
  ],
  "BOLA2P1": [
    "BOLA2P1 CNV",
    "BOLA2P1 RNA"
  ],
  "ZDHHC20P1": [
    "ZDHHC20P1 CNV",
    "ZDHHC20P1 RNA"
  ],
  "KLK4": [
    "KLK4 CNV",
    "KLK4 RNA"
  ],
  "EIF2B2": [
    "EIF2B2 CNV",
    "EIF2B2 RNA",
    "EIF2B2 Proteo"
  ],
  "CABCOCO1": [
    "CABCOCO1 CNV",
    "CABCOCO1 RNA"
  ],
  "RGPD1": [
    "RGPD1 CNV",
    "RGPD1 RNA",
    "RGPD1 Proteo"
  ],
  "FAHD2P1": [
    "FAHD2P1 CNV",
    "FAHD2P1 RNA"
  ],
  "MIER3": [
    "MIER3 CNV",
    "MIER3 RNA",
    "MIER3 Proteo"
  ],
  "PIGZ": [
    "PIGZ CNV",
    "PIGZ RNA"
  ],
  "KRTAP10-8": [
    "KRTAP10-8 CNV",
    "KRTAP10-8 RNA"
  ],
  "PARG": [
    "PARG CNV",
    "PARG RNA",
    "PARG Proteo"
  ],
  "ZBBX": [
    "ZBBX CNV",
    "ZBBX RNA"
  ],
  "ASB7": [
    "ASB7 CNV",
    "ASB7 RNA",
    "ASB7 Proteo"
  ],
  "RNA5SP309": [
    "RNA5SP309 CNV",
    "RNA5SP309 RNA"
  ],
  "RNA5SP75": [
    "RNA5SP75 CNV",
    "RNA5SP75 RNA"
  ],
  "FAM183DP": [
    "FAM183DP CNV",
    "FAM183DP RNA"
  ],
  "MTCO3P31": [
    "MTCO3P31 CNV",
    "MTCO3P31 RNA"
  ],
  "MTCYBP8": [
    "MTCYBP8 CNV",
    "MTCYBP8 RNA"
  ],
  "RPS4XP18": [
    "RPS4XP18 CNV",
    "RPS4XP18 RNA"
  ],
  "ANKRD10": [
    "ANKRD10 CNV",
    "ANKRD10 RNA",
    "ANKRD10 Proteo"
  ],
  "ELMO1": [
    "ELMO1 CNV",
    "ELMO1 RNA",
    "ELMO1 Proteo"
  ],
  "BAAT": [
    "BAAT CNV",
    "BAAT RNA",
    "BAAT Proteo"
  ],
  "DUSP1": [
    "DUSP1 CNV",
    "DUSP1 RNA",
    "DUSP1 Proteo"
  ],
  "COX5AP1": [
    "COX5AP1 CNV",
    "COX5AP1 RNA"
  ],
  "ZNF90P1": [
    "ZNF90P1 CNV",
    "ZNF90P1 RNA"
  ],
  "RNA5SP374": [
    "RNA5SP374 CNV",
    "RNA5SP374 RNA"
  ],
  "TRAPPC13P1": [
    "TRAPPC13P1 CNV",
    "TRAPPC13P1 RNA"
  ],
  "PYDC2": [
    "PYDC2 CNV",
    "PYDC2 RNA"
  ],
  "SH3BGRL3": [
    "SH3BGRL3 CNV",
    "SH3BGRL3 RNA",
    "SH3BGRL3 Proteo"
  ],
  "CHCHD2P8": [
    "CHCHD2P8 CNV",
    "CHCHD2P8 RNA"
  ],
  "UPP2": [
    "UPP2 CNV",
    "UPP2 RNA"
  ],
  "NUP50P1": [
    "NUP50P1 CNV",
    "NUP50P1 RNA"
  ],
  "SF3A1": [
    "SF3A1 CNV",
    "SF3A1 RNA",
    "SF3A1 Proteo"
  ],
  "CENPM": [
    "CENPM CNV",
    "CENPM RNA",
    "CENPM Proteo"
  ],
  "UGT1A1": [
    "UGT1A1 CNV",
    "UGT1A1 RNA"
  ],
  "CFB": [
    "CFB CNV",
    "CFB RNA"
  ],
  "MVD": [
    "MVD CNV",
    "MVD RNA",
    "MVD Proteo"
  ],
  "RAF1": [
    "RAF1 CNV",
    "RAF1 RNA",
    "RAF1 Proteo"
  ],
  "PCK1": [
    "PCK1 CNV",
    "PCK1 RNA",
    "PCK1 Proteo"
  ],
  "NSA2P2": [
    "NSA2P2 CNV",
    "NSA2P2 RNA"
  ],
  "NET1": [
    "NET1 CNV",
    "NET1 RNA",
    "NET1 Proteo"
  ],
  "CDCP1": [
    "CDCP1 CNV",
    "CDCP1 RNA",
    "CDCP1 Proteo"
  ],
  "ABCC9": [
    "ABCC9 CNV",
    "ABCC9 RNA",
    "ABCC9 Proteo"
  ],
  "INO80C": [
    "INO80C CNV",
    "INO80C RNA",
    "INO80C Proteo"
  ],
  "CEP295NL": [
    "CEP295NL CNV",
    "CEP295NL RNA"
  ],
  "EXOC7": [
    "EXOC7 CNV",
    "EXOC7 RNA",
    "EXOC7 Proteo"
  ],
  "CYCSP12": [
    "CYCSP12 CNV",
    "CYCSP12 RNA"
  ],
  "MTND3P13": [
    "MTND3P13 CNV",
    "MTND3P13 RNA"
  ],
  "ASRGL1": [
    "ASRGL1 CNV",
    "ASRGL1 RNA",
    "ASRGL1 Proteo"
  ],
  "AK6": [
    "AK6 CNV",
    "AK6 RNA",
    "AK6 Proteo"
  ],
  "SMPD5": [
    "SMPD5 CNV",
    "SMPD5 RNA"
  ],
  "LYN": [
    "LYN CNV",
    "LYN RNA",
    "LYN Proteo"
  ],
  "ZHX2": [
    "ZHX2 CNV",
    "ZHX2 RNA",
    "ZHX2 Proteo"
  ],
  "HEATR5B": [
    "HEATR5B CNV",
    "HEATR5B RNA",
    "HEATR5B Proteo"
  ],
  "MMD2": [
    "MMD2 CNV",
    "MMD2 RNA"
  ],
  "FAM86DP": [
    "FAM86DP CNV",
    "FAM86DP RNA"
  ],
  "CICP26": [
    "CICP26 CNV",
    "CICP26 RNA"
  ],
  "GTF2IRD2B": [
    "GTF2IRD2B CNV",
    "GTF2IRD2B RNA"
  ],
  "CYB5R3": [
    "CYB5R3 CNV",
    "CYB5R3 RNA",
    "CYB5R3 Proteo"
  ],
  "COQ10B": [
    "COQ10B CNV",
    "COQ10B RNA",
    "COQ10B Proteo"
  ],
  "COIL": [
    "COIL CNV",
    "COIL RNA",
    "COIL Proteo"
  ],
  "CYRIB": [
    "CYRIB CNV",
    "CYRIB RNA",
    "CYRIB Proteo"
  ],
  "UIMC1": [
    "UIMC1 CNV",
    "UIMC1 RNA",
    "UIMC1 Proteo"
  ],
  "TIMM8AP1": [
    "TIMM8AP1 CNV",
    "TIMM8AP1 RNA"
  ],
  "KATNBL1P4": [
    "KATNBL1P4 CNV",
    "KATNBL1P4 RNA"
  ],
  "HMGN2P5": [
    "HMGN2P5 CNV",
    "HMGN2P5 RNA"
  ],
  "LDAH": [
    "LDAH CNV",
    "LDAH RNA",
    "LDAH Proteo"
  ],
  "OR10J5": [
    "OR10J5 CNV",
    "OR10J5 RNA"
  ],
  "TDRD10": [
    "TDRD10 CNV",
    "TDRD10 RNA"
  ],
  "ZSWIM9": [
    "ZSWIM9 CNV",
    "ZSWIM9 RNA",
    "ZSWIM9 Proteo"
  ],
  "ENTR1P2": [
    "ENTR1P2 CNV",
    "ENTR1P2 RNA"
  ],
  "ANTXRL": [
    "ANTXRL CNV",
    "ANTXRL RNA"
  ],
  "OR9G1": [
    "OR9G1 CNV",
    "OR9G1 RNA"
  ],
  "RPS2P15": [
    "RPS2P15 CNV",
    "RPS2P15 RNA"
  ],
  "TEX13C": [
    "TEX13C CNV",
    "TEX13C RNA"
  ],
  "KCNS1": [
    "KCNS1 CNV",
    "KCNS1 RNA"
  ],
  "CCNYL7": [
    "CCNYL7 CNV",
    "CCNYL7 RNA"
  ],
  "ANKRD33": [
    "ANKRD33 CNV",
    "ANKRD33 RNA"
  ],
  "DUSP16": [
    "DUSP16 CNV",
    "DUSP16 RNA",
    "DUSP16 Proteo"
  ],
  "GCK": [
    "GCK CNV",
    "GCK RNA"
  ],
  "NEUROG2": [
    "NEUROG2 CNV",
    "NEUROG2 RNA"
  ],
  "CYP4B1": [
    "CYP4B1 CNV",
    "CYP4B1 RNA"
  ],
  "GALNT6": [
    "GALNT6 CNV",
    "GALNT6 RNA",
    "GALNT6 Proteo"
  ],
  "KRTAP4-5": [
    "KRTAP4-5 CNV",
    "KRTAP4-5 RNA"
  ],
  "FAM187A": [
    "FAM187A CNV",
    "FAM187A RNA"
  ],
  "BTG2": [
    "BTG2 CNV",
    "BTG2 RNA"
  ],
  "RPS24P13": [
    "RPS24P13 CNV",
    "RPS24P13 RNA"
  ],
  "ZNF75D": [
    "ZNF75D CNV",
    "ZNF75D RNA"
  ],
  "WTAPP1": [
    "WTAPP1 CNV",
    "WTAPP1 RNA"
  ],
  "LAMC2": [
    "LAMC2 CNV",
    "LAMC2 RNA",
    "LAMC2 Proteo"
  ],
  "FHOD3": [
    "FHOD3 CNV",
    "FHOD3 RNA",
    "FHOD3 Proteo"
  ],
  "GAPDHP22": [
    "GAPDHP22 CNV",
    "GAPDHP22 RNA"
  ],
  "SH3PXD2A": [
    "SH3PXD2A CNV",
    "SH3PXD2A RNA",
    "SH3PXD2A Proteo"
  ],
  "HP1BP3": [
    "HP1BP3 CNV",
    "HP1BP3 RNA",
    "HP1BP3 Proteo"
  ],
  "RNA5SP477": [
    "RNA5SP477 CNV",
    "RNA5SP477 RNA"
  ],
  "PPP1R26P4": [
    "PPP1R26P4 CNV",
    "PPP1R26P4 RNA"
  ],
  "CDV3P1": [
    "CDV3P1 CNV",
    "CDV3P1 RNA"
  ],
  "PROS2P": [
    "PROS2P CNV",
    "PROS2P RNA"
  ],
  "CEBPG": [
    "CEBPG CNV",
    "CEBPG RNA",
    "CEBPG Proteo"
  ],
  "SLC25A5P2": [
    "SLC25A5P2 CNV",
    "SLC25A5P2 RNA"
  ],
  "C8orf88": [
    "C8orf88 CNV",
    "C8orf88 RNA",
    "C8orf88 Proteo"
  ],
  "PLD2": [
    "PLD2 CNV",
    "PLD2 RNA",
    "PLD2 Proteo"
  ],
  "PITPNA": [
    "PITPNA CNV",
    "PITPNA RNA",
    "PITPNA Proteo"
  ],
  "TLE7": [
    "TLE7 CNV",
    "TLE7 RNA"
  ],
  "GYG1": [
    "GYG1 CNV",
    "GYG1 RNA",
    "GYG1 Proteo"
  ],
  "HSPA8P14": [
    "HSPA8P14 CNV",
    "HSPA8P14 RNA"
  ],
  "COL9A2": [
    "COL9A2 CNV",
    "COL9A2 RNA",
    "COL9A2 Proteo"
  ],
  "MINDY4B": [
    "MINDY4B CNV",
    "MINDY4B RNA"
  ],
  "HCCS": [
    "HCCS CNV",
    "HCCS RNA",
    "HCCS Proteo"
  ],
  "ARPC5L": [
    "ARPC5L CNV",
    "ARPC5L RNA",
    "ARPC5L Proteo"
  ],
  "SULT1C2": [
    "SULT1C2 CNV",
    "SULT1C2 RNA",
    "SULT1C2 Proteo"
  ],
  "DUTP7": [
    "DUTP7 CNV",
    "DUTP7 RNA"
  ],
  "UQCRFS1P3": [
    "UQCRFS1P3 CNV",
    "UQCRFS1P3 RNA"
  ],
  "ELANE": [
    "ELANE CNV",
    "ELANE RNA",
    "ELANE Proteo"
  ],
  "TALDO1": [
    "TALDO1 CNV",
    "TALDO1 RNA",
    "TALDO1 Proteo"
  ],
  "SGSM3": [
    "SGSM3 CNV",
    "SGSM3 RNA",
    "SGSM3 Proteo"
  ],
  "IFITM3P4": [
    "IFITM3P4 CNV",
    "IFITM3P4 RNA"
  ],
  "CTAGE14P": [
    "CTAGE14P CNV",
    "CTAGE14P RNA"
  ],
  "PAGE5": [
    "PAGE5 CNV",
    "PAGE5 RNA",
    "PAGE5 Proteo"
  ],
  "SHARPIN": [
    "SHARPIN CNV",
    "SHARPIN RNA",
    "SHARPIN Proteo"
  ],
  "MAGEA13P": [
    "MAGEA13P CNV",
    "MAGEA13P RNA"
  ],
  "TUSC2": [
    "TUSC2 CNV",
    "TUSC2 RNA",
    "TUSC2 Proteo"
  ],
  "TTC3": [
    "TTC3 CNV",
    "TTC3 RNA",
    "TTC3 Proteo"
  ],
  "BRI3BP": [
    "BRI3BP CNV",
    "BRI3BP RNA",
    "BRI3BP Proteo"
  ],
  "MRFAP1L1": [
    "MRFAP1L1 CNV",
    "MRFAP1L1 RNA"
  ],
  "XYLT2": [
    "XYLT2 CNV",
    "XYLT2 RNA",
    "XYLT2 Proteo"
  ],
  "LMBR1L": [
    "LMBR1L CNV",
    "LMBR1L RNA"
  ],
  "RMND5B": [
    "RMND5B CNV",
    "RMND5B RNA",
    "RMND5B Proteo"
  ],
  "ZDHHC12": [
    "ZDHHC12 CNV",
    "ZDHHC12 RNA",
    "ZDHHC12 Proteo"
  ],
  "PFN1P3": [
    "PFN1P3 CNV",
    "PFN1P3 RNA"
  ],
  "DDRGK1": [
    "DDRGK1 CNV",
    "DDRGK1 RNA",
    "DDRGK1 Proteo"
  ],
  "HESX1": [
    "HESX1 CNV",
    "HESX1 RNA"
  ],
  "SNRPCP9": [
    "SNRPCP9 CNV",
    "SNRPCP9 RNA"
  ],
  "RPL5P33": [
    "RPL5P33 CNV",
    "RPL5P33 RNA"
  ],
  "PSMG3": [
    "PSMG3 CNV",
    "PSMG3 RNA",
    "PSMG3 Proteo"
  ],
  "ZMYND8": [
    "ZMYND8 CNV",
    "ZMYND8 RNA",
    "ZMYND8 Proteo"
  ],
  "EYA1": [
    "EYA1 CNV",
    "EYA1 RNA",
    "EYA1 Proteo"
  ],
  "DNAJC3": [
    "DNAJC3 CNV",
    "DNAJC3 RNA",
    "DNAJC3 Proteo"
  ],
  "MCCC2": [
    "MCCC2 CNV",
    "MCCC2 RNA",
    "MCCC2 Proteo"
  ],
  "CFAP58": [
    "CFAP58 CNV",
    "CFAP58 RNA"
  ],
  "LRRTM4": [
    "LRRTM4 CNV",
    "LRRTM4 RNA",
    "LRRTM4 Proteo"
  ],
  "RPS5P2": [
    "RPS5P2 CNV",
    "RPS5P2 RNA"
  ],
  "GAPDHP27": [
    "GAPDHP27 CNV",
    "GAPDHP27 RNA"
  ],
  "TCEAL4P1": [
    "TCEAL4P1 CNV",
    "TCEAL4P1 RNA"
  ],
  "INTS11": [
    "INTS11 CNV",
    "INTS11 RNA",
    "INTS11 Proteo"
  ],
  "USP17L21": [
    "USP17L21 CNV",
    "USP17L21 RNA"
  ],
  "TENT5D": [
    "TENT5D CNV",
    "TENT5D RNA"
  ],
  "RBMY2WP": [
    "RBMY2WP CNV",
    "RBMY2WP RNA"
  ],
  "GFER": [
    "GFER CNV",
    "GFER RNA",
    "GFER Proteo"
  ],
  "MED28P5": [
    "MED28P5 CNV",
    "MED28P5 RNA"
  ],
  "SH3GL1P2": [
    "SH3GL1P2 CNV",
    "SH3GL1P2 RNA"
  ],
  "ISCA1P3": [
    "ISCA1P3 CNV",
    "ISCA1P3 RNA"
  ],
  "RPL35AP11": [
    "RPL35AP11 CNV",
    "RPL35AP11 RNA"
  ],
  "IMPG2": [
    "IMPG2 CNV",
    "IMPG2 RNA"
  ],
  "SCP2": [
    "SCP2 CNV",
    "SCP2 RNA",
    "SCP2 Proteo"
  ],
  "PRRG2": [
    "PRRG2 CNV",
    "PRRG2 RNA"
  ],
  "WDR83OS": [
    "WDR83OS CNV",
    "WDR83OS RNA"
  ],
  "MYG1P1": [
    "MYG1P1 CNV",
    "MYG1P1 RNA"
  ],
  "E2F4": [
    "E2F4 CNV",
    "E2F4 RNA",
    "E2F4 Proteo"
  ],
  "MTATP6P10": [
    "MTATP6P10 CNV",
    "MTATP6P10 RNA"
  ],
  "GLCCI1": [
    "GLCCI1 CNV",
    "GLCCI1 RNA",
    "GLCCI1 Proteo"
  ],
  "OR2W1": [
    "OR2W1 CNV",
    "OR2W1 RNA"
  ],
  "DDX41": [
    "DDX41 CNV",
    "DDX41 RNA",
    "DDX41 Proteo"
  ],
  "DDX10P2": [
    "DDX10P2 CNV",
    "DDX10P2 RNA"
  ],
  "MLN": [
    "MLN CNV",
    "MLN RNA"
  ],
  "RPL7AP80": [
    "RPL7AP80 CNV",
    "RPL7AP80 RNA"
  ],
  "TRIOBP": [
    "TRIOBP CNV",
    "TRIOBP RNA",
    "TRIOBP Proteo"
  ],
  "CD58": [
    "CD58 CNV",
    "CD58 RNA",
    "CD58 Proteo"
  ],
  "SNN": [
    "SNN CNV",
    "SNN RNA"
  ],
  "RBM22P3": [
    "RBM22P3 CNV",
    "RBM22P3 RNA"
  ],
  "DOLPP1": [
    "DOLPP1 CNV",
    "DOLPP1 RNA",
    "DOLPP1 Proteo"
  ],
  "ZNF274": [
    "ZNF274 CNV",
    "ZNF274 RNA",
    "ZNF274 Proteo"
  ],
  "CHRNA1": [
    "CHRNA1 CNV",
    "CHRNA1 RNA"
  ],
  "TDP2": [
    "TDP2 CNV",
    "TDP2 RNA",
    "TDP2 Proteo"
  ],
  "HAPLN4": [
    "HAPLN4 CNV",
    "HAPLN4 RNA"
  ],
  "MTMR3": [
    "MTMR3 CNV",
    "MTMR3 RNA",
    "MTMR3 Proteo"
  ],
  "PRAF2": [
    "PRAF2 CNV",
    "PRAF2 RNA",
    "PRAF2 Proteo"
  ],
  "RBM41": [
    "RBM41 CNV",
    "RBM41 RNA",
    "RBM41 Proteo"
  ],
  "OR7L1P": [
    "OR7L1P CNV",
    "OR7L1P RNA"
  ],
  "WFDC11": [
    "WFDC11 CNV",
    "WFDC11 RNA"
  ],
  "ZNF518A": [
    "ZNF518A CNV",
    "ZNF518A RNA",
    "ZNF518A Proteo"
  ],
  "PTH2": [
    "PTH2 CNV",
    "PTH2 RNA"
  ],
  "VWA5B2": [
    "VWA5B2 CNV",
    "VWA5B2 RNA"
  ],
  "NIPAL4": [
    "NIPAL4 CNV",
    "NIPAL4 RNA"
  ],
  "RPS18P12": [
    "RPS18P12 CNV",
    "RPS18P12 RNA"
  ],
  "RBM7": [
    "RBM7 CNV",
    "RBM7 RNA",
    "RBM7 Proteo"
  ],
  "RPL10P12": [
    "RPL10P12 CNV",
    "RPL10P12 RNA"
  ],
  "RWDD4P1": [
    "RWDD4P1 CNV",
    "RWDD4P1 RNA"
  ],
  "BEX2": [
    "BEX2 CNV",
    "BEX2 RNA"
  ],
  "MYO7B": [
    "MYO7B CNV",
    "MYO7B RNA"
  ],
  "NOL3": [
    "NOL3 CNV",
    "NOL3 RNA",
    "NOL3 Proteo"
  ],
  "ENGASE": [
    "ENGASE CNV",
    "ENGASE RNA",
    "ENGASE Proteo"
  ],
  "CEACAM18": [
    "CEACAM18 CNV",
    "CEACAM18 RNA"
  ],
  "MSANTD1": [
    "MSANTD1 CNV",
    "MSANTD1 RNA",
    "MSANTD1 Proteo"
  ],
  "IGHVII-46-1": [
    "IGHVII-46-1 CNV",
    "IGHVII-46-1 RNA"
  ],
  "MTND2P13": [
    "MTND2P13 CNV",
    "MTND2P13 RNA"
  ],
  "KRTAP5-2": [
    "KRTAP5-2 CNV",
    "KRTAP5-2 RNA"
  ],
  "RPL23AP44": [
    "RPL23AP44 CNV",
    "RPL23AP44 RNA"
  ],
  "DNAJB6P6": [
    "DNAJB6P6 CNV",
    "DNAJB6P6 RNA"
  ],
  "STON2": [
    "STON2 CNV",
    "STON2 RNA",
    "STON2 Proteo"
  ],
  "PI3": [
    "PI3 CNV",
    "PI3 RNA",
    "PI3 Proteo"
  ],
  "TMEM230": [
    "TMEM230 CNV",
    "TMEM230 RNA",
    "TMEM230 Proteo"
  ],
  "FAM184A": [
    "FAM184A CNV",
    "FAM184A RNA"
  ],
  "RASA4DP": [
    "RASA4DP CNV",
    "RASA4DP RNA"
  ],
  "NTAN1": [
    "NTAN1 CNV",
    "NTAN1 RNA",
    "NTAN1 Proteo"
  ],
  "PFDN2": [
    "PFDN2 CNV",
    "PFDN2 RNA",
    "PFDN2 Proteo"
  ],
  "CDKL2": [
    "CDKL2 CNV",
    "CDKL2 RNA"
  ],
  "BGLAP": [
    "BGLAP CNV",
    "BGLAP RNA"
  ],
  "HSPB2": [
    "HSPB2 CNV",
    "HSPB2 RNA",
    "HSPB2 Proteo"
  ],
  "XIAPP2": [
    "XIAPP2 CNV",
    "XIAPP2 RNA"
  ],
  "ELOCP29": [
    "ELOCP29 CNV",
    "ELOCP29 RNA"
  ],
  "S100A2": [
    "S100A2 CNV",
    "S100A2 RNA",
    "S100A2 Proteo"
  ],
  "LCE3B": [
    "LCE3B CNV",
    "LCE3B RNA"
  ],
  "NOL8P1": [
    "NOL8P1 CNV",
    "NOL8P1 RNA"
  ],
  "H2AC4": [
    "H2AC4 CNV",
    "H2AC4 RNA"
  ],
  "MZT1": [
    "MZT1 CNV",
    "MZT1 RNA",
    "MZT1 Proteo"
  ],
  "ARMCX7P": [
    "ARMCX7P CNV",
    "ARMCX7P RNA"
  ],
  "RPL7AP66": [
    "RPL7AP66 CNV",
    "RPL7AP66 RNA"
  ],
  "PATE4": [
    "PATE4 CNV",
    "PATE4 RNA"
  ],
  "ONECUT1": [
    "ONECUT1 CNV",
    "ONECUT1 RNA"
  ],
  "VENTXP3": [
    "VENTXP3 CNV",
    "VENTXP3 RNA"
  ],
  "SSC4D": [
    "SSC4D CNV",
    "SSC4D RNA"
  ],
  "CST4": [
    "CST4 CNV",
    "CST4 RNA"
  ],
  "FAM205BP": [
    "FAM205BP CNV",
    "FAM205BP RNA"
  ],
  "APOOP2": [
    "APOOP2 CNV",
    "APOOP2 RNA"
  ],
  "DPF1": [
    "DPF1 CNV",
    "DPF1 RNA",
    "DPF1 Proteo"
  ],
  "OR6B3": [
    "OR6B3 CNV",
    "OR6B3 RNA"
  ],
  "TRIM51JP": [
    "TRIM51JP CNV",
    "TRIM51JP RNA"
  ],
  "DEK": [
    "DEK CNV",
    "DEK RNA",
    "DEK Proteo"
  ],
  "GUCY2EP": [
    "GUCY2EP CNV",
    "GUCY2EP RNA"
  ],
  "FCGR2B": [
    "FCGR2B CNV",
    "FCGR2B RNA",
    "FCGR2B Proteo"
  ],
  "TRPC6": [
    "TRPC6 CNV",
    "TRPC6 RNA"
  ],
  "OPCML": [
    "OPCML CNV",
    "OPCML RNA"
  ],
  "PLXDC2": [
    "PLXDC2 CNV",
    "PLXDC2 RNA",
    "PLXDC2 Proteo"
  ],
  "ISYNA1": [
    "ISYNA1 CNV",
    "ISYNA1 RNA",
    "ISYNA1 Proteo"
  ],
  "PIAS4": [
    "PIAS4 CNV",
    "PIAS4 RNA",
    "PIAS4 Proteo"
  ],
  "SERPINB13": [
    "SERPINB13 CNV",
    "SERPINB13 RNA",
    "SERPINB13 Proteo"
  ],
  "SCAMP3": [
    "SCAMP3 CNV",
    "SCAMP3 RNA",
    "SCAMP3 Proteo"
  ],
  "PRMT7": [
    "PRMT7 CNV",
    "PRMT7 RNA",
    "PRMT7 Proteo"
  ],
  "FERD3L": [
    "FERD3L CNV",
    "FERD3L RNA"
  ],
  "PSMB11": [
    "PSMB11 CNV",
    "PSMB11 RNA",
    "PSMB11 Proteo"
  ],
  "STAT2": [
    "STAT2 CNV",
    "STAT2 RNA",
    "STAT2 Proteo"
  ],
  "RPL31P20": [
    "RPL31P20 CNV",
    "RPL31P20 RNA"
  ],
  "B3GNT5": [
    "B3GNT5 CNV",
    "B3GNT5 RNA"
  ],
  "LINC00643": [
    "LINC00643 CNV",
    "LINC00643 RNA"
  ],
  "CYP11B1": [
    "CYP11B1 CNV",
    "CYP11B1 RNA",
    "CYP11B1 Proteo"
  ],
  "YWHAEP5": [
    "YWHAEP5 CNV",
    "YWHAEP5 RNA"
  ],
  "HMGB1P26": [
    "HMGB1P26 CNV",
    "HMGB1P26 RNA"
  ],
  "PLAGL1": [
    "PLAGL1 CNV",
    "PLAGL1 RNA"
  ],
  "ST13P6": [
    "ST13P6 CNV",
    "ST13P6 RNA"
  ],
  "RPS17P5": [
    "RPS17P5 CNV",
    "RPS17P5 RNA"
  ],
  "MEF2B": [
    "MEF2B CNV",
    "MEF2B RNA"
  ],
  "PPP1R3C": [
    "PPP1R3C CNV",
    "PPP1R3C RNA"
  ],
  "R3HCC1L": [
    "R3HCC1L CNV",
    "R3HCC1L RNA",
    "R3HCC1L Proteo"
  ],
  "HIBCH": [
    "HIBCH CNV",
    "HIBCH RNA",
    "HIBCH Proteo"
  ],
  "PHB1P7": [
    "PHB1P7 CNV",
    "PHB1P7 RNA"
  ],
  "CALM2P3": [
    "CALM2P3 CNV",
    "CALM2P3 RNA"
  ],
  "TRIM60P17": [
    "TRIM60P17 CNV",
    "TRIM60P17 RNA"
  ],
  "BAG6": [
    "BAG6 CNV",
    "BAG6 RNA",
    "BAG6 Proteo"
  ],
  "TINCR": [
    "TINCR CNV",
    "TINCR RNA"
  ],
  "RPS15AP11": [
    "RPS15AP11 CNV",
    "RPS15AP11 RNA"
  ],
  "ANKMY2": [
    "ANKMY2 CNV",
    "ANKMY2 RNA",
    "ANKMY2 Proteo"
  ],
  "PTGIS": [
    "PTGIS CNV",
    "PTGIS RNA",
    "PTGIS Proteo"
  ],
  "APEH": [
    "APEH CNV",
    "APEH RNA",
    "APEH Proteo"
  ],
  "OR5AC2": [
    "OR5AC2 CNV",
    "OR5AC2 RNA"
  ],
  "HCFC1R1": [
    "HCFC1R1 CNV",
    "HCFC1R1 RNA"
  ],
  "MYO1A": [
    "MYO1A CNV",
    "MYO1A RNA",
    "MYO1A Proteo"
  ],
  "PANK1": [
    "PANK1 CNV",
    "PANK1 RNA"
  ],
  "ZNF354A": [
    "ZNF354A CNV",
    "ZNF354A RNA",
    "ZNF354A Proteo"
  ],
  "ELP5": [
    "ELP5 CNV",
    "ELP5 RNA",
    "ELP5 Proteo"
  ],
  "SPATA3": [
    "SPATA3 CNV",
    "SPATA3 RNA"
  ],
  "TPSG1": [
    "TPSG1 CNV",
    "TPSG1 RNA"
  ],
  "FYB1": [
    "FYB1 CNV",
    "FYB1 RNA",
    "FYB1 Proteo"
  ],
  "ALOX15P2": [
    "ALOX15P2 CNV",
    "ALOX15P2 RNA"
  ],
  "H2BP5": [
    "H2BP5 CNV",
    "H2BP5 RNA"
  ],
  "LRRC58-DT": [
    "LRRC58-DT CNV",
    "LRRC58-DT RNA"
  ],
  "TMEM101": [
    "TMEM101 CNV",
    "TMEM101 RNA",
    "TMEM101 Proteo"
  ],
  "MRS2P1": [
    "MRS2P1 CNV",
    "MRS2P1 RNA"
  ],
  "ISL1": [
    "ISL1 CNV",
    "ISL1 RNA"
  ],
  "CHRNG": [
    "CHRNG CNV",
    "CHRNG RNA"
  ],
  "BANP": [
    "BANP CNV",
    "BANP RNA",
    "BANP Proteo"
  ],
  "TBRG4": [
    "TBRG4 CNV",
    "TBRG4 RNA",
    "TBRG4 Proteo"
  ],
  "RBMS1": [
    "RBMS1 CNV",
    "RBMS1 RNA",
    "RBMS1 Proteo"
  ],
  "PGGT1BP1": [
    "PGGT1BP1 CNV",
    "PGGT1BP1 RNA"
  ],
  "TBX6": [
    "TBX6 CNV",
    "TBX6 RNA"
  ],
  "OR7A18P": [
    "OR7A18P CNV",
    "OR7A18P RNA"
  ],
  "PSMB4": [
    "PSMB4 CNV",
    "PSMB4 RNA",
    "PSMB4 Proteo"
  ],
  "TCTE1": [
    "TCTE1 CNV",
    "TCTE1 RNA"
  ],
  "TEX38": [
    "TEX38 CNV",
    "TEX38 RNA"
  ],
  "MACROD1": [
    "MACROD1 CNV",
    "MACROD1 RNA",
    "MACROD1 Proteo"
  ],
  "RPL35AP": [
    "RPL35AP CNV",
    "RPL35AP RNA"
  ],
  "PPP1R26P1": [
    "PPP1R26P1 CNV",
    "PPP1R26P1 RNA"
  ],
  "OR2BH1P": [
    "OR2BH1P CNV",
    "OR2BH1P RNA"
  ],
  "ST18": [
    "ST18 CNV",
    "ST18 RNA"
  ],
  "RPL7P35": [
    "RPL7P35 CNV",
    "RPL7P35 RNA"
  ],
  "ASB15": [
    "ASB15 CNV",
    "ASB15 RNA"
  ],
  "BPIFB6": [
    "BPIFB6 CNV",
    "BPIFB6 RNA"
  ],
  "ARPP21": [
    "ARPP21 CNV",
    "ARPP21 RNA"
  ],
  "H3P29": [
    "H3P29 CNV",
    "H3P29 RNA"
  ],
  "UBE3C": [
    "UBE3C CNV",
    "UBE3C RNA",
    "UBE3C Proteo"
  ],
  "EXOC3": [
    "EXOC3 CNV",
    "EXOC3 RNA",
    "EXOC3 Proteo"
  ],
  "AK6P2": [
    "AK6P2 CNV",
    "AK6P2 RNA"
  ],
  "SIGLEC27P": [
    "SIGLEC27P CNV",
    "SIGLEC27P RNA"
  ],
  "NR5A2": [
    "NR5A2 CNV",
    "NR5A2 RNA"
  ],
  "RPL7AP52": [
    "RPL7AP52 CNV",
    "RPL7AP52 RNA"
  ],
  "RNA5SP476": [
    "RNA5SP476 CNV",
    "RNA5SP476 RNA"
  ],
  "TGFBR3L": [
    "TGFBR3L CNV",
    "TGFBR3L RNA"
  ],
  "PLA2G4E": [
    "PLA2G4E CNV",
    "PLA2G4E RNA"
  ],
  "FAM222B": [
    "FAM222B CNV",
    "FAM222B RNA",
    "FAM222B Proteo"
  ],
  "AGGF1P8": [
    "AGGF1P8 CNV",
    "AGGF1P8 RNA"
  ],
  "LMO7": [
    "LMO7 CNV",
    "LMO7 RNA",
    "LMO7 Proteo"
  ],
  "LAD1": [
    "LAD1 CNV",
    "LAD1 RNA",
    "LAD1 Proteo"
  ],
  "RNA5SP37": [
    "RNA5SP37 CNV",
    "RNA5SP37 RNA"
  ],
  "RNA5SP29": [
    "RNA5SP29 CNV",
    "RNA5SP29 RNA"
  ],
  "OSTCP1": [
    "OSTCP1 CNV",
    "OSTCP1 RNA"
  ],
  "PLCG2": [
    "PLCG2 CNV",
    "PLCG2 RNA",
    "PLCG2 Proteo"
  ],
  "C1orf105": [
    "C1orf105 CNV",
    "C1orf105 RNA"
  ],
  "HERC2P4": [
    "HERC2P4 CNV",
    "HERC2P4 RNA"
  ],
  "HIRAP1": [
    "HIRAP1 CNV",
    "HIRAP1 RNA"
  ],
  "EFCAB9": [
    "EFCAB9 CNV",
    "EFCAB9 RNA"
  ],
  "KHDRBS1": [
    "KHDRBS1 CNV",
    "KHDRBS1 RNA",
    "KHDRBS1 Proteo"
  ],
  "LARP1B": [
    "LARP1B CNV",
    "LARP1B RNA",
    "LARP1B Proteo"
  ],
  "MFSD4A": [
    "MFSD4A CNV",
    "MFSD4A RNA"
  ],
  "POTEB3": [
    "POTEB3 CNV",
    "POTEB3 RNA"
  ],
  "APCDD1": [
    "APCDD1 CNV",
    "APCDD1 RNA",
    "APCDD1 Proteo"
  ],
  "CES4A": [
    "CES4A CNV",
    "CES4A RNA"
  ],
  "ANKRD20A4P": [
    "ANKRD20A4P CNV",
    "ANKRD20A4P RNA"
  ],
  "ANKS3": [
    "ANKS3 CNV",
    "ANKS3 RNA",
    "ANKS3 Proteo"
  ],
  "CSPG4P4Y": [
    "CSPG4P4Y CNV",
    "CSPG4P4Y RNA"
  ],
  "KRT18P67": [
    "KRT18P67 CNV",
    "KRT18P67 RNA"
  ],
  "HBA1": [
    "HBA1 CNV",
    "HBA1 RNA",
    "HBA1 Proteo"
  ],
  "ZPLD1": [
    "ZPLD1 CNV",
    "ZPLD1 RNA"
  ],
  "RPL23AP70": [
    "RPL23AP70 CNV",
    "RPL23AP70 RNA"
  ],
  "ZNF268": [
    "ZNF268 CNV",
    "ZNF268 RNA",
    "ZNF268 Proteo"
  ],
  "MLXP1": [
    "MLXP1 CNV",
    "MLXP1 RNA"
  ],
  "LRRC37A12P": [
    "LRRC37A12P CNV",
    "LRRC37A12P RNA"
  ],
  "UBA6": [
    "UBA6 CNV",
    "UBA6 RNA",
    "UBA6 Proteo"
  ],
  "OR14I1": [
    "OR14I1 CNV",
    "OR14I1 RNA"
  ],
  "MCCD1P2": [
    "MCCD1P2 CNV",
    "MCCD1P2 RNA"
  ],
  "OAZ3": [
    "OAZ3 CNV",
    "OAZ3 RNA"
  ],
  "RNA5SP498": [
    "RNA5SP498 CNV",
    "RNA5SP498 RNA"
  ],
  "PPIE": [
    "PPIE CNV",
    "PPIE RNA",
    "PPIE Proteo"
  ],
  "RTN4": [
    "RTN4 CNV",
    "RTN4 RNA",
    "RTN4 Proteo"
  ],
  "FYN": [
    "FYN CNV",
    "FYN RNA",
    "FYN Proteo"
  ],
  "SAA3P": [
    "SAA3P CNV",
    "SAA3P RNA"
  ],
  "MOV10": [
    "MOV10 CNV",
    "MOV10 RNA",
    "MOV10 Proteo"
  ],
  "DDHD2": [
    "DDHD2 CNV",
    "DDHD2 RNA",
    "DDHD2 Proteo"
  ],
  "TRPC4AP": [
    "TRPC4AP CNV",
    "TRPC4AP RNA",
    "TRPC4AP Proteo"
  ],
  "TIMM9P2": [
    "TIMM9P2 CNV",
    "TIMM9P2 RNA"
  ],
  "OR5AK1P": [
    "OR5AK1P CNV",
    "OR5AK1P RNA"
  ],
  "KHSRPP1": [
    "KHSRPP1 CNV",
    "KHSRPP1 RNA"
  ],
  "C2orf66": [
    "C2orf66 CNV",
    "C2orf66 RNA"
  ],
  "OMG": [
    "OMG CNV",
    "OMG RNA",
    "OMG Proteo"
  ],
  "RPL17P33": [
    "RPL17P33 CNV",
    "RPL17P33 RNA"
  ],
  "RPS26P54": [
    "RPS26P54 CNV",
    "RPS26P54 RNA"
  ],
  "RNF19BPX": [
    "RNF19BPX CNV",
    "RNF19BPX RNA"
  ],
  "SLC22A10": [
    "SLC22A10 CNV",
    "SLC22A10 RNA"
  ],
  "DHFRP5": [
    "DHFRP5 CNV",
    "DHFRP5 RNA"
  ],
  "SDCBPP1": [
    "SDCBPP1 CNV",
    "SDCBPP1 RNA"
  ],
  "MAN1A2P1": [
    "MAN1A2P1 CNV",
    "MAN1A2P1 RNA"
  ],
  "OR7E106P": [
    "OR7E106P CNV",
    "OR7E106P RNA"
  ],
  "FASTKD3": [
    "FASTKD3 CNV",
    "FASTKD3 RNA",
    "FASTKD3 Proteo"
  ],
  "PHF10P1": [
    "PHF10P1 CNV",
    "PHF10P1 RNA"
  ],
  "SNUPN": [
    "SNUPN CNV",
    "SNUPN RNA",
    "SNUPN Proteo"
  ],
  "HNRNPA1P9": [
    "HNRNPA1P9 CNV",
    "HNRNPA1P9 RNA"
  ],
  "LAMTOR1": [
    "LAMTOR1 CNV",
    "LAMTOR1 RNA",
    "LAMTOR1 Proteo"
  ],
  "HLTF": [
    "HLTF CNV",
    "HLTF RNA",
    "HLTF Proteo"
  ],
  "IGKV1D-27": [
    "IGKV1D-27 CNV",
    "IGKV1D-27 RNA"
  ],
  "SCYGR8": [
    "SCYGR8 CNV",
    "SCYGR8 RNA"
  ],
  "AHCYL1": [
    "AHCYL1 CNV",
    "AHCYL1 RNA",
    "AHCYL1 Proteo"
  ],
  "SRY": [
    "SRY CNV",
    "SRY RNA"
  ],
  "OSGIN1": [
    "OSGIN1 CNV",
    "OSGIN1 RNA"
  ],
  "MTCO3P16": [
    "MTCO3P16 CNV",
    "MTCO3P16 RNA"
  ],
  "KPTN": [
    "KPTN CNV",
    "KPTN RNA",
    "KPTN Proteo"
  ],
  "HDAC7": [
    "HDAC7 CNV",
    "HDAC7 RNA",
    "HDAC7 Proteo"
  ],
  "LY6G5C": [
    "LY6G5C CNV",
    "LY6G5C RNA"
  ],
  "DENND1A": [
    "DENND1A CNV",
    "DENND1A RNA",
    "DENND1A Proteo"
  ],
  "C16orf78": [
    "C16orf78 CNV",
    "C16orf78 RNA"
  ],
  "POM121L8P": [
    "POM121L8P CNV",
    "POM121L8P RNA"
  ],
  "GNPDA1": [
    "GNPDA1 CNV",
    "GNPDA1 RNA",
    "GNPDA1 Proteo"
  ],
  "UBQLN4P1": [
    "UBQLN4P1 CNV",
    "UBQLN4P1 RNA"
  ],
  "TMPRSS7": [
    "TMPRSS7 CNV",
    "TMPRSS7 RNA"
  ],
  "SNRPCP1": [
    "SNRPCP1 CNV",
    "SNRPCP1 RNA"
  ],
  "PSMD10P1": [
    "PSMD10P1 CNV",
    "PSMD10P1 RNA"
  ],
  "CABYR": [
    "CABYR CNV",
    "CABYR RNA"
  ],
  "NPM2": [
    "NPM2 CNV",
    "NPM2 RNA",
    "NPM2 Proteo"
  ],
  "RPS2P35": [
    "RPS2P35 CNV",
    "RPS2P35 RNA"
  ],
  "DRAXINP1": [
    "DRAXINP1 CNV",
    "DRAXINP1 RNA"
  ],
  "SNX2P2": [
    "SNX2P2 CNV",
    "SNX2P2 RNA"
  ],
  "PPP2R5E": [
    "PPP2R5E CNV",
    "PPP2R5E RNA",
    "PPP2R5E Proteo"
  ],
  "CLK3": [
    "CLK3 CNV",
    "CLK3 RNA",
    "CLK3 Proteo"
  ],
  "ZNF23": [
    "ZNF23 CNV",
    "ZNF23 RNA"
  ],
  "ZNF568": [
    "ZNF568 CNV",
    "ZNF568 RNA"
  ],
  "PRAMEF13": [
    "PRAMEF13 CNV",
    "PRAMEF13 RNA"
  ],
  "MGAT4B": [
    "MGAT4B CNV",
    "MGAT4B RNA",
    "MGAT4B Proteo"
  ],
  "VEGFA": [
    "VEGFA CNV",
    "VEGFA RNA",
    "VEGFA Proteo"
  ],
  "GIMAP2": [
    "GIMAP2 CNV",
    "GIMAP2 RNA",
    "GIMAP2 Proteo"
  ],
  "CTCF": [
    "CTCF CNV",
    "CTCF RNA",
    "CTCF Proteo"
  ],
  "SOAT2": [
    "SOAT2 CNV",
    "SOAT2 RNA"
  ],
  "RPL12P39": [
    "RPL12P39 CNV",
    "RPL12P39 RNA"
  ],
  "UBOX5": [
    "UBOX5 CNV",
    "UBOX5 RNA",
    "UBOX5 Proteo"
  ],
  "SRMS": [
    "SRMS CNV",
    "SRMS RNA"
  ],
  "PA2G4P1": [
    "PA2G4P1 CNV",
    "PA2G4P1 RNA"
  ],
  "KCNK3": [
    "KCNK3 CNV",
    "KCNK3 RNA"
  ],
  "RPL7AP2": [
    "RPL7AP2 CNV",
    "RPL7AP2 RNA"
  ],
  "RPS27AP15": [
    "RPS27AP15 CNV",
    "RPS27AP15 RNA"
  ],
  "SMC5": [
    "SMC5 CNV",
    "SMC5 RNA",
    "SMC5 Proteo"
  ],
  "IRAG2": [
    "IRAG2 CNV",
    "IRAG2 RNA",
    "IRAG2 Proteo"
  ],
  "CAPN10": [
    "CAPN10 CNV",
    "CAPN10 RNA"
  ],
  "SLC1A5": [
    "SLC1A5 CNV",
    "SLC1A5 RNA",
    "SLC1A5 Proteo"
  ],
  "KLF8": [
    "KLF8 CNV",
    "KLF8 RNA"
  ],
  "FXYD6P2": [
    "FXYD6P2 CNV",
    "FXYD6P2 RNA"
  ],
  "RASSF4": [
    "RASSF4 CNV",
    "RASSF4 RNA",
    "RASSF4 Proteo"
  ],
  "SAMM50": [
    "SAMM50 CNV",
    "SAMM50 RNA",
    "SAMM50 Proteo"
  ],
  "RPL23AP24": [
    "RPL23AP24 CNV",
    "RPL23AP24 RNA"
  ],
  "IFITM3P2": [
    "IFITM3P2 CNV",
    "IFITM3P2 RNA"
  ],
  "LGALS3BP": [
    "LGALS3BP CNV",
    "LGALS3BP RNA",
    "LGALS3BP Proteo"
  ],
  "TUBA4B": [
    "TUBA4B CNV",
    "TUBA4B RNA"
  ],
  "OSBPL9P1": [
    "OSBPL9P1 CNV",
    "OSBPL9P1 RNA"
  ],
  "RPL37P6": [
    "RPL37P6 CNV",
    "RPL37P6 RNA"
  ],
  "LPAR5": [
    "LPAR5 CNV",
    "LPAR5 RNA"
  ],
  "C1orf174": [
    "C1orf174 CNV",
    "C1orf174 RNA",
    "C1orf174 Proteo"
  ],
  "CYP2F2P": [
    "CYP2F2P CNV",
    "CYP2F2P RNA"
  ],
  "MTMR1": [
    "MTMR1 CNV",
    "MTMR1 RNA",
    "MTMR1 Proteo"
  ],
  "OIT3": [
    "OIT3 CNV",
    "OIT3 RNA"
  ],
  "BEX4": [
    "BEX4 CNV",
    "BEX4 RNA"
  ],
  "RPL34P8": [
    "RPL34P8 CNV",
    "RPL34P8 RNA"
  ],
  "CPSF1": [
    "CPSF1 CNV",
    "CPSF1 RNA",
    "CPSF1 Proteo"
  ],
  "SCGN": [
    "SCGN CNV",
    "SCGN RNA"
  ],
  "YIPF5": [
    "YIPF5 CNV",
    "YIPF5 RNA",
    "YIPF5 Proteo"
  ],
  "ANKRD31": [
    "ANKRD31 CNV",
    "ANKRD31 RNA"
  ],
  "RPL7P55": [
    "RPL7P55 CNV",
    "RPL7P55 RNA"
  ],
  "RPS6P3": [
    "RPS6P3 CNV",
    "RPS6P3 RNA"
  ],
  "HEY1": [
    "HEY1 CNV",
    "HEY1 RNA"
  ],
  "ARPP19P2": [
    "ARPP19P2 CNV",
    "ARPP19P2 RNA"
  ],
  "RPL32P6": [
    "RPL32P6 CNV",
    "RPL32P6 RNA"
  ],
  "CLSTN3": [
    "CLSTN3 CNV",
    "CLSTN3 RNA"
  ],
  "TSPAN5": [
    "TSPAN5 CNV",
    "TSPAN5 RNA"
  ],
  "RILPL2": [
    "RILPL2 CNV",
    "RILPL2 RNA",
    "RILPL2 Proteo"
  ],
  "P2RY6": [
    "P2RY6 CNV",
    "P2RY6 RNA"
  ],
  "UBALD1": [
    "UBALD1 CNV",
    "UBALD1 RNA"
  ],
  "IFIT1B": [
    "IFIT1B CNV",
    "IFIT1B RNA"
  ],
  "EMC1": [
    "EMC1 CNV",
    "EMC1 RNA",
    "EMC1 Proteo"
  ],
  "TMEM231P1": [
    "TMEM231P1 CNV",
    "TMEM231P1 RNA"
  ],
  "KRT90P": [
    "KRT90P CNV",
    "KRT90P RNA"
  ],
  "LPXN": [
    "LPXN CNV",
    "LPXN RNA",
    "LPXN Proteo"
  ],
  "SMOX": [
    "SMOX CNV",
    "SMOX RNA",
    "SMOX Proteo"
  ],
  "LARP7P3": [
    "LARP7P3 CNV",
    "LARP7P3 RNA"
  ],
  "TM4SF5": [
    "TM4SF5 CNV",
    "TM4SF5 RNA"
  ],
  "SCX": [
    "SCX CNV",
    "SCX RNA"
  ],
  "FGF1": [
    "FGF1 CNV",
    "FGF1 RNA",
    "FGF1 Proteo"
  ],
  "LPIN2": [
    "LPIN2 CNV",
    "LPIN2 RNA",
    "LPIN2 Proteo"
  ],
  "ZGLP1": [
    "ZGLP1 CNV",
    "ZGLP1 RNA"
  ],
  "KRT18P28": [
    "KRT18P28 CNV",
    "KRT18P28 RNA"
  ],
  "ARL17B": [
    "ARL17B CNV",
    "ARL17B RNA"
  ],
  "USP36": [
    "USP36 CNV",
    "USP36 RNA",
    "USP36 Proteo"
  ],
  "TCAM1P": [
    "TCAM1P CNV",
    "TCAM1P RNA"
  ],
  "ATP5PDP2": [
    "ATP5PDP2 CNV",
    "ATP5PDP2 RNA"
  ],
  "TMEM241": [
    "TMEM241 CNV",
    "TMEM241 RNA"
  ],
  "F13A1": [
    "F13A1 CNV",
    "F13A1 RNA",
    "F13A1 Proteo"
  ],
  "SLC25A52": [
    "SLC25A52 CNV",
    "SLC25A52 RNA"
  ],
  "RPP21": [
    "RPP21 CNV",
    "RPP21 RNA",
    "RPP21 Proteo"
  ],
  "MTCO1P3": [
    "MTCO1P3 CNV",
    "MTCO1P3 RNA"
  ],
  "VDAC1P12": [
    "VDAC1P12 CNV",
    "VDAC1P12 RNA"
  ],
  "TRIML2": [
    "TRIML2 CNV",
    "TRIML2 RNA"
  ],
  "TBC1D10A": [
    "TBC1D10A CNV",
    "TBC1D10A RNA",
    "TBC1D10A Proteo"
  ],
  "TRMT10B": [
    "TRMT10B CNV",
    "TRMT10B RNA"
  ],
  "INTS3": [
    "INTS3 CNV",
    "INTS3 RNA",
    "INTS3 Proteo"
  ],
  "CACNA1B": [
    "CACNA1B CNV",
    "CACNA1B RNA"
  ],
  "MS4A8": [
    "MS4A8 CNV",
    "MS4A8 RNA"
  ],
  "OR52P2P": [
    "OR52P2P CNV",
    "OR52P2P RNA"
  ],
  "ALX3": [
    "ALX3 CNV",
    "ALX3 RNA"
  ],
  "GTF3AP2": [
    "GTF3AP2 CNV",
    "GTF3AP2 RNA"
  ],
  "PCBP2": [
    "PCBP2 CNV",
    "PCBP2 RNA",
    "PCBP2 Proteo"
  ],
  "MAK16": [
    "MAK16 CNV",
    "MAK16 RNA",
    "MAK16 Proteo"
  ],
  "LTC4S": [
    "LTC4S CNV",
    "LTC4S RNA",
    "LTC4S Proteo"
  ],
  "FLCN": [
    "FLCN CNV",
    "FLCN RNA",
    "FLCN Proteo"
  ],
  "SNIP1": [
    "SNIP1 CNV",
    "SNIP1 RNA",
    "SNIP1 Proteo"
  ],
  "CELSR2": [
    "CELSR2 CNV",
    "CELSR2 RNA",
    "CELSR2 Proteo"
  ],
  "OR2A12": [
    "OR2A12 CNV",
    "OR2A12 RNA"
  ],
  "MAGIX": [
    "MAGIX CNV",
    "MAGIX RNA"
  ],
  "ADAMTS16": [
    "ADAMTS16 CNV",
    "ADAMTS16 RNA"
  ],
  "ADGRG5": [
    "ADGRG5 CNV",
    "ADGRG5 RNA"
  ],
  "NPL": [
    "NPL CNV",
    "NPL RNA",
    "NPL Proteo"
  ],
  "OFD1P8Y": [
    "OFD1P8Y CNV",
    "OFD1P8Y RNA"
  ],
  "ARGFXP1": [
    "ARGFXP1 CNV",
    "ARGFXP1 RNA"
  ],
  "HIGD1AP11": [
    "HIGD1AP11 CNV",
    "HIGD1AP11 RNA"
  ],
  "FRRS1": [
    "FRRS1 CNV",
    "FRRS1 RNA",
    "FRRS1 Proteo"
  ],
  "RPS4XP7": [
    "RPS4XP7 CNV",
    "RPS4XP7 RNA"
  ],
  "CD36": [
    "CD36 CNV",
    "CD36 RNA",
    "CD36 Proteo"
  ],
  "AOX2P": [
    "AOX2P CNV",
    "AOX2P RNA"
  ],
  "SPRING1P1": [
    "SPRING1P1 CNV",
    "SPRING1P1 RNA"
  ],
  "VPS37A": [
    "VPS37A CNV",
    "VPS37A RNA",
    "VPS37A Proteo"
  ],
  "RNF139": [
    "RNF139 CNV",
    "RNF139 RNA",
    "RNF139 Proteo"
  ],
  "RPS27AP9": [
    "RPS27AP9 CNV",
    "RPS27AP9 RNA"
  ],
  "GTF2IP11": [
    "GTF2IP11 CNV",
    "GTF2IP11 RNA"
  ],
  "CHCHD2P9": [
    "CHCHD2P9 CNV",
    "CHCHD2P9 RNA"
  ],
  "PCNAP3": [
    "PCNAP3 CNV",
    "PCNAP3 RNA"
  ],
  "CSN3": [
    "CSN3 CNV",
    "CSN3 RNA"
  ],
  "KCNA4": [
    "KCNA4 CNV",
    "KCNA4 RNA"
  ],
  "SFTA2": [
    "SFTA2 CNV",
    "SFTA2 RNA"
  ],
  "TUBB4BP3": [
    "TUBB4BP3 CNV",
    "TUBB4BP3 RNA"
  ],
  "PDC": [
    "PDC CNV",
    "PDC RNA"
  ],
  "NMTRQ-TTG12-1": [
    "NMTRQ-TTG12-1 CNV",
    "NMTRQ-TTG12-1 RNA"
  ],
  "KMT5C": [
    "KMT5C CNV",
    "KMT5C RNA",
    "KMT5C Proteo"
  ],
  "DYNLT3": [
    "DYNLT3 CNV",
    "DYNLT3 RNA",
    "DYNLT3 Proteo"
  ],
  "ZNF282": [
    "ZNF282 CNV",
    "ZNF282 RNA",
    "ZNF282 Proteo"
  ],
  "LIN9": [
    "LIN9 CNV",
    "LIN9 RNA",
    "LIN9 Proteo"
  ],
  "DOP1B": [
    "DOP1B CNV",
    "DOP1B RNA",
    "DOP1B Proteo"
  ],
  "ZCCHC3": [
    "ZCCHC3 CNV",
    "ZCCHC3 RNA",
    "ZCCHC3 Proteo"
  ],
  "ZNF135": [
    "ZNF135 CNV",
    "ZNF135 RNA",
    "ZNF135 Proteo"
  ],
  "PTPRD": [
    "PTPRD CNV",
    "PTPRD RNA"
  ],
  "PANO1": [
    "PANO1 CNV",
    "PANO1 RNA"
  ],
  "CALB1": [
    "CALB1 CNV",
    "CALB1 RNA"
  ],
  "MSANTD4": [
    "MSANTD4 CNV",
    "MSANTD4 RNA",
    "MSANTD4 Proteo"
  ],
  "NKD1": [
    "NKD1 CNV",
    "NKD1 RNA"
  ],
  "CYB5B": [
    "CYB5B CNV",
    "CYB5B RNA",
    "CYB5B Proteo"
  ],
  "TOPBP1": [
    "TOPBP1 CNV",
    "TOPBP1 RNA",
    "TOPBP1 Proteo"
  ],
  "SLC16A2": [
    "SLC16A2 CNV",
    "SLC16A2 RNA",
    "SLC16A2 Proteo"
  ],
  "RHOXF2B": [
    "RHOXF2B CNV",
    "RHOXF2B RNA"
  ],
  "C3orf56": [
    "C3orf56 CNV",
    "C3orf56 RNA"
  ],
  "POSTN": [
    "POSTN CNV",
    "POSTN RNA",
    "POSTN Proteo"
  ],
  "GUSBP16": [
    "GUSBP16 CNV",
    "GUSBP16 RNA"
  ],
  "H2AJ": [
    "H2AJ CNV",
    "H2AJ RNA",
    "H2AJ Proteo"
  ],
  "CYSRT1": [
    "CYSRT1 CNV",
    "CYSRT1 RNA"
  ],
  "VAMP4": [
    "VAMP4 CNV",
    "VAMP4 RNA",
    "VAMP4 Proteo"
  ],
  "KLHL29": [
    "KLHL29 CNV",
    "KLHL29 RNA",
    "KLHL29 Proteo"
  ],
  "CCR9": [
    "CCR9 CNV",
    "CCR9 RNA"
  ],
  "RNA5SP205": [
    "RNA5SP205 CNV",
    "RNA5SP205 RNA"
  ],
  "SALL4P6": [
    "SALL4P6 CNV",
    "SALL4P6 RNA"
  ],
  "BPI": [
    "BPI CNV",
    "BPI RNA",
    "BPI Proteo"
  ],
  "GDPD3": [
    "GDPD3 CNV",
    "GDPD3 RNA",
    "GDPD3 Proteo"
  ],
  "RPL31P13": [
    "RPL31P13 CNV",
    "RPL31P13 RNA"
  ],
  "OR5AZ1P": [
    "OR5AZ1P CNV",
    "OR5AZ1P RNA"
  ],
  "WNT4": [
    "WNT4 CNV",
    "WNT4 RNA"
  ],
  "DEFB112": [
    "DEFB112 CNV",
    "DEFB112 RNA"
  ],
  "ADAMTSL3": [
    "ADAMTSL3 CNV",
    "ADAMTSL3 RNA"
  ],
  "ZC3H12A": [
    "ZC3H12A CNV",
    "ZC3H12A RNA",
    "ZC3H12A Proteo"
  ],
  "PTMAP4": [
    "PTMAP4 CNV",
    "PTMAP4 RNA"
  ],
  "OR13E1P": [
    "OR13E1P CNV",
    "OR13E1P RNA"
  ],
  "OGT": [
    "OGT CNV",
    "OGT RNA",
    "OGT Proteo"
  ],
  "RFPL4AP7": [
    "RFPL4AP7 CNV",
    "RFPL4AP7 RNA"
  ],
  "PKHD1": [
    "PKHD1 CNV",
    "PKHD1 RNA"
  ],
  "HPR": [
    "HPR CNV",
    "HPR RNA",
    "HPR Proteo"
  ],
  "FUCA2": [
    "FUCA2 CNV",
    "FUCA2 RNA",
    "FUCA2 Proteo"
  ],
  "RBP7": [
    "RBP7 CNV",
    "RBP7 RNA",
    "RBP7 Proteo"
  ],
  "EIF1AXP2": [
    "EIF1AXP2 CNV",
    "EIF1AXP2 RNA"
  ],
  "NDP": [
    "NDP CNV",
    "NDP RNA"
  ],
  "PDGFRL": [
    "PDGFRL CNV",
    "PDGFRL RNA",
    "PDGFRL Proteo"
  ],
  "MKRN7P": [
    "MKRN7P CNV",
    "MKRN7P RNA"
  ],
  "NFIA": [
    "NFIA CNV",
    "NFIA RNA",
    "NFIA Proteo"
  ],
  "PRSS40B": [
    "PRSS40B CNV",
    "PRSS40B RNA"
  ],
  "FAM3C2P": [
    "FAM3C2P CNV",
    "FAM3C2P RNA"
  ],
  "CCT6P2": [
    "CCT6P2 CNV",
    "CCT6P2 RNA"
  ],
  "TANC2": [
    "TANC2 CNV",
    "TANC2 RNA",
    "TANC2 Proteo"
  ],
  "BAP1": [
    "BAP1 CNV",
    "BAP1 RNA",
    "BAP1 Proteo"
  ],
  "NKAIN3": [
    "NKAIN3 CNV",
    "NKAIN3 RNA"
  ],
  "SHC1P1": [
    "SHC1P1 CNV",
    "SHC1P1 RNA"
  ],
  "MALSU1": [
    "MALSU1 CNV",
    "MALSU1 RNA",
    "MALSU1 Proteo"
  ],
  "AMHR2": [
    "AMHR2 CNV",
    "AMHR2 RNA"
  ],
  "PPP2R1A": [
    "PPP2R1A CNV",
    "PPP2R1A RNA",
    "PPP2R1A Proteo"
  ],
  "RASGRF1": [
    "RASGRF1 CNV",
    "RASGRF1 RNA"
  ],
  "HMGA2": [
    "HMGA2 CNV",
    "HMGA2 RNA",
    "HMGA2 Proteo"
  ],
  "RNF14P1": [
    "RNF14P1 CNV",
    "RNF14P1 RNA"
  ],
  "GREB1L": [
    "GREB1L CNV",
    "GREB1L RNA",
    "GREB1L Proteo"
  ],
  "SUPT6H": [
    "SUPT6H CNV",
    "SUPT6H RNA",
    "SUPT6H Proteo"
  ],
  "PDIA3P2": [
    "PDIA3P2 CNV",
    "PDIA3P2 RNA"
  ],
  "NDRG2": [
    "NDRG2 CNV",
    "NDRG2 RNA",
    "NDRG2 Proteo"
  ],
  "ARL13B": [
    "ARL13B CNV",
    "ARL13B RNA",
    "ARL13B Proteo"
  ],
  "EIF4EP1": [
    "EIF4EP1 CNV",
    "EIF4EP1 RNA"
  ],
  "MTCYBP35": [
    "MTCYBP35 CNV",
    "MTCYBP35 RNA"
  ],
  "BLZF1": [
    "BLZF1 CNV",
    "BLZF1 RNA",
    "BLZF1 Proteo"
  ],
  "CDKL5": [
    "CDKL5 CNV",
    "CDKL5 RNA",
    "CDKL5 Proteo"
  ],
  "OR4C14P": [
    "OR4C14P CNV",
    "OR4C14P RNA"
  ],
  "ATP5PBP6": [
    "ATP5PBP6 CNV",
    "ATP5PBP6 RNA"
  ],
  "CENPIP1": [
    "CENPIP1 CNV",
    "CENPIP1 RNA"
  ],
  "COMT": [
    "COMT CNV",
    "COMT RNA",
    "COMT Proteo"
  ],
  "CFAP61": [
    "CFAP61 CNV",
    "CFAP61 RNA"
  ],
  "DENND5B": [
    "DENND5B CNV",
    "DENND5B RNA",
    "DENND5B Proteo"
  ],
  "HAS3": [
    "HAS3 CNV",
    "HAS3 RNA"
  ],
  "HIP1R": [
    "HIP1R CNV",
    "HIP1R RNA",
    "HIP1R Proteo"
  ],
  "KRT18P19": [
    "KRT18P19 CNV",
    "KRT18P19 RNA"
  ],
  "DNAJB6P1": [
    "DNAJB6P1 CNV",
    "DNAJB6P1 RNA"
  ],
  "TMEM178B": [
    "TMEM178B CNV",
    "TMEM178B RNA"
  ],
  "CADPS": [
    "CADPS CNV",
    "CADPS RNA",
    "CADPS Proteo"
  ],
  "ACADM": [
    "ACADM CNV",
    "ACADM RNA",
    "ACADM Proteo"
  ],
  "MARK2P4": [
    "MARK2P4 CNV",
    "MARK2P4 RNA"
  ],
  "RPS6P7": [
    "RPS6P7 CNV",
    "RPS6P7 RNA"
  ],
  "FAM207BP": [
    "FAM207BP CNV",
    "FAM207BP RNA"
  ],
  "FOXK1": [
    "FOXK1 CNV",
    "FOXK1 RNA",
    "FOXK1 Proteo"
  ],
  "ELOCP17": [
    "ELOCP17 CNV",
    "ELOCP17 RNA"
  ],
  "NPIPP1": [
    "NPIPP1 CNV",
    "NPIPP1 RNA"
  ],
  "VEZT": [
    "VEZT CNV",
    "VEZT RNA",
    "VEZT Proteo"
  ],
  "NPIPB3": [
    "NPIPB3 CNV",
    "NPIPB3 RNA"
  ],
  "FBXL19": [
    "FBXL19 CNV",
    "FBXL19 RNA",
    "FBXL19 Proteo"
  ],
  "CNGB1": [
    "CNGB1 CNV",
    "CNGB1 RNA"
  ],
  "OTUD1": [
    "OTUD1 CNV",
    "OTUD1 RNA",
    "OTUD1 Proteo"
  ],
  "RPL5P8": [
    "RPL5P8 CNV",
    "RPL5P8 RNA"
  ],
  "GLULP3": [
    "GLULP3 CNV",
    "GLULP3 RNA"
  ],
  "UNC5D": [
    "UNC5D CNV",
    "UNC5D RNA"
  ],
  "FAM83B": [
    "FAM83B CNV",
    "FAM83B RNA",
    "FAM83B Proteo"
  ],
  "MIXL1": [
    "MIXL1 CNV",
    "MIXL1 RNA"
  ],
  "PFKFB2": [
    "PFKFB2 CNV",
    "PFKFB2 RNA",
    "PFKFB2 Proteo"
  ],
  "IGHV2-70": [
    "IGHV2-70 Proteo"
  ],
  "CYCSP1": [
    "CYCSP1 CNV",
    "CYCSP1 RNA"
  ],
  "PDE6G": [
    "PDE6G CNV",
    "PDE6G RNA"
  ],
  "HSPD1P18": [
    "HSPD1P18 CNV",
    "HSPD1P18 RNA"
  ],
  "CHERP": [
    "CHERP CNV",
    "CHERP RNA",
    "CHERP Proteo"
  ],
  "CCNB1": [
    "CCNB1 CNV",
    "CCNB1 RNA",
    "CCNB1 Proteo"
  ],
  "COX20P2": [
    "COX20P2 CNV",
    "COX20P2 RNA"
  ],
  "DDX24": [
    "DDX24 CNV",
    "DDX24 RNA",
    "DDX24 Proteo"
  ],
  "CFAP206": [
    "CFAP206 CNV",
    "CFAP206 RNA"
  ],
  "HSPBAP1": [
    "HSPBAP1 CNV",
    "HSPBAP1 RNA",
    "HSPBAP1 Proteo"
  ],
  "HSPA8P17": [
    "HSPA8P17 CNV",
    "HSPA8P17 RNA"
  ],
  "SSTR4": [
    "SSTR4 CNV",
    "SSTR4 RNA"
  ],
  "SEC14L1": [
    "SEC14L1 CNV",
    "SEC14L1 RNA",
    "SEC14L1 Proteo"
  ],
  "MX1": [
    "MX1 CNV",
    "MX1 RNA",
    "MX1 Proteo"
  ],
  "RPL21P17": [
    "RPL21P17 CNV",
    "RPL21P17 RNA"
  ],
  "OR4M2B": [
    "OR4M2B CNV",
    "OR4M2B RNA"
  ],
  "YWHAB": [
    "YWHAB CNV",
    "YWHAB RNA",
    "YWHAB Proteo"
  ],
  "GAS2L3": [
    "GAS2L3 CNV",
    "GAS2L3 RNA",
    "GAS2L3 Proteo"
  ],
  "CRYGC": [
    "CRYGC CNV",
    "CRYGC RNA"
  ],
  "DIABLO": [
    "DIABLO CNV",
    "DIABLO RNA",
    "DIABLO Proteo"
  ],
  "CCT8": [
    "CCT8 CNV",
    "CCT8 RNA",
    "CCT8 Proteo"
  ],
  "CUX2": [
    "CUX2 CNV",
    "CUX2 RNA",
    "CUX2 Proteo"
  ],
  "TUBBP1": [
    "TUBBP1 CNV",
    "TUBBP1 RNA"
  ],
  "INHCAP": [
    "INHCAP CNV",
    "INHCAP RNA"
  ],
  "RARA": [
    "RARA CNV",
    "RARA RNA",
    "RARA Proteo"
  ],
  "FOSB": [
    "FOSB CNV",
    "FOSB RNA",
    "FOSB Proteo"
  ],
  "DENND6B": [
    "DENND6B CNV",
    "DENND6B RNA"
  ],
  "CYP2C60P": [
    "CYP2C60P CNV",
    "CYP2C60P RNA"
  ],
  "AARS2": [
    "AARS2 CNV",
    "AARS2 RNA",
    "AARS2 Proteo"
  ],
  "HMGN3P1": [
    "HMGN3P1 CNV",
    "HMGN3P1 RNA"
  ],
  "MICG": [
    "MICG CNV",
    "MICG RNA"
  ],
  "IFT88": [
    "IFT88 CNV",
    "IFT88 RNA",
    "IFT88 Proteo"
  ],
  "FTSJ1": [
    "FTSJ1 CNV",
    "FTSJ1 RNA",
    "FTSJ1 Proteo"
  ],
  "CDH3": [
    "CDH3 CNV",
    "CDH3 RNA",
    "CDH3 Proteo"
  ],
  "NFIC": [
    "NFIC CNV",
    "NFIC RNA",
    "NFIC Proteo"
  ],
  "PTBP1": [
    "PTBP1 CNV",
    "PTBP1 RNA",
    "PTBP1 Proteo"
  ],
  "OR7A17": [
    "OR7A17 CNV",
    "OR7A17 RNA"
  ],
  "H3C9P": [
    "H3C9P CNV",
    "H3C9P RNA"
  ],
  "MTRF1": [
    "MTRF1 CNV",
    "MTRF1 RNA",
    "MTRF1 Proteo"
  ],
  "ALG14": [
    "ALG14 CNV",
    "ALG14 RNA",
    "ALG14 Proteo"
  ],
  "PPP1R26P5": [
    "PPP1R26P5 CNV",
    "PPP1R26P5 RNA"
  ],
  "OR5M12P": [
    "OR5M12P CNV",
    "OR5M12P RNA"
  ],
  "NPM1P51": [
    "NPM1P51 CNV",
    "NPM1P51 RNA"
  ],
  "GOLT1B": [
    "GOLT1B CNV",
    "GOLT1B RNA",
    "GOLT1B Proteo"
  ],
  "RNA5SP234": [
    "RNA5SP234 CNV",
    "RNA5SP234 RNA"
  ],
  "RAMP1": [
    "RAMP1 CNV",
    "RAMP1 RNA"
  ],
  "PPIP5K2": [
    "PPIP5K2 CNV",
    "PPIP5K2 RNA",
    "PPIP5K2 Proteo"
  ],
  "RERG": [
    "RERG CNV",
    "RERG RNA"
  ],
  "MRPS21P8": [
    "MRPS21P8 CNV",
    "MRPS21P8 RNA"
  ],
  "PPIAP45": [
    "PPIAP45 CNV",
    "PPIAP45 RNA"
  ],
  "MED25": [
    "MED25 CNV",
    "MED25 RNA",
    "MED25 Proteo"
  ],
  "BORA": [
    "BORA CNV",
    "BORA RNA"
  ],
  "C11orf80": [
    "C11orf80 CNV",
    "C11orf80 RNA"
  ],
  "HBZP1": [
    "HBZP1 CNV",
    "HBZP1 RNA"
  ],
  "PRELID3BP6": [
    "PRELID3BP6 CNV",
    "PRELID3BP6 RNA"
  ],
  "LTV1P1": [
    "LTV1P1 CNV",
    "LTV1P1 RNA"
  ],
  "GPATCH4": [
    "GPATCH4 Proteo"
  ],
  "BANF2": [
    "BANF2 CNV",
    "BANF2 RNA"
  ],
  "DYNLL1P4": [
    "DYNLL1P4 CNV",
    "DYNLL1P4 RNA"
  ],
  "REXO5": [
    "REXO5 CNV",
    "REXO5 RNA",
    "REXO5 Proteo"
  ],
  "HLA-DPA2": [
    "HLA-DPA2 CNV",
    "HLA-DPA2 RNA"
  ],
  "IGKV2-19": [
    "IGKV2-19 CNV",
    "IGKV2-19 RNA"
  ],
  "SMAD6": [
    "SMAD6 CNV",
    "SMAD6 RNA"
  ],
  "DMRTB1": [
    "DMRTB1 CNV",
    "DMRTB1 RNA"
  ],
  "APLP1": [
    "APLP1 CNV",
    "APLP1 RNA"
  ],
  "RPL7P61": [
    "RPL7P61 CNV",
    "RPL7P61 RNA"
  ],
  "TMED3": [
    "TMED3 CNV",
    "TMED3 RNA",
    "TMED3 Proteo"
  ],
  "AP5M1": [
    "AP5M1 CNV",
    "AP5M1 RNA",
    "AP5M1 Proteo"
  ],
  "UHRF1BP1": [
    "UHRF1BP1 CNV",
    "UHRF1BP1 RNA",
    "UHRF1BP1 Proteo"
  ],
  "HNRNPA1P71": [
    "HNRNPA1P71 CNV",
    "HNRNPA1P71 RNA"
  ],
  "RPS26P43": [
    "RPS26P43 CNV",
    "RPS26P43 RNA"
  ],
  "RELT": [
    "RELT CNV",
    "RELT RNA",
    "RELT Proteo"
  ],
  "ATP1B4": [
    "ATP1B4 CNV",
    "ATP1B4 RNA"
  ],
  "SLC17A2": [
    "SLC17A2 CNV",
    "SLC17A2 RNA"
  ],
  "ESS2": [
    "ESS2 CNV",
    "ESS2 RNA",
    "ESS2 Proteo"
  ],
  "CCDC150": [
    "CCDC150 CNV",
    "CCDC150 RNA"
  ],
  "FAM43A": [
    "FAM43A CNV",
    "FAM43A RNA",
    "FAM43A Proteo"
  ],
  "FEN1": [
    "FEN1 CNV",
    "FEN1 RNA",
    "FEN1 Proteo"
  ],
  "NKAP": [
    "NKAP CNV",
    "NKAP RNA",
    "NKAP Proteo"
  ],
  "KRT8P44": [
    "KRT8P44 CNV",
    "KRT8P44 RNA"
  ],
  "NRIP2": [
    "NRIP2 CNV",
    "NRIP2 RNA",
    "NRIP2 Proteo"
  ],
  "OR56A3": [
    "OR56A3 CNV",
    "OR56A3 RNA"
  ],
  "FRS3": [
    "FRS3 CNV",
    "FRS3 RNA"
  ],
  "CAMK2B": [
    "CAMK2B CNV",
    "CAMK2B RNA",
    "CAMK2B Proteo"
  ],
  "SLC6A14": [
    "SLC6A14 CNV",
    "SLC6A14 RNA"
  ],
  "B3GNT6": [
    "B3GNT6 CNV",
    "B3GNT6 RNA"
  ],
  "FNDC10": [
    "FNDC10 CNV",
    "FNDC10 RNA"
  ],
  "NSDHL": [
    "NSDHL CNV",
    "NSDHL RNA",
    "NSDHL Proteo"
  ],
  "TBC1D4": [
    "TBC1D4 CNV",
    "TBC1D4 RNA",
    "TBC1D4 Proteo"
  ],
  "RRN3P4": [
    "RRN3P4 CNV",
    "RRN3P4 RNA"
  ],
  "LTO1": [
    "LTO1 CNV",
    "LTO1 RNA",
    "LTO1 Proteo"
  ],
  "SYNRG": [
    "SYNRG CNV",
    "SYNRG RNA",
    "SYNRG Proteo"
  ],
  "GAL3ST3": [
    "GAL3ST3 CNV",
    "GAL3ST3 RNA"
  ],
  "IL9RP1": [
    "IL9RP1 CNV",
    "IL9RP1 RNA"
  ],
  "TRA2B": [
    "TRA2B CNV",
    "TRA2B RNA",
    "TRA2B Proteo"
  ],
  "VWC2": [
    "VWC2 CNV",
    "VWC2 RNA"
  ],
  "CSNK2A3": [
    "CSNK2A3 CNV",
    "CSNK2A3 RNA"
  ],
  "AHCY": [
    "AHCY CNV",
    "AHCY RNA",
    "AHCY Proteo"
  ],
  "ZNF37A": [
    "ZNF37A CNV",
    "ZNF37A RNA"
  ],
  "FOXN3": [
    "FOXN3 CNV",
    "FOXN3 RNA",
    "FOXN3 Proteo"
  ],
  "KIF20B": [
    "KIF20B CNV",
    "KIF20B RNA",
    "KIF20B Proteo"
  ],
  "IGLJCOR18": [
    "IGLJCOR18 CNV",
    "IGLJCOR18 RNA"
  ],
  "DNAAF6": [
    "DNAAF6 CNV",
    "DNAAF6 RNA"
  ],
  "SRD5A1": [
    "SRD5A1 CNV",
    "SRD5A1 RNA",
    "SRD5A1 Proteo"
  ],
  "LINC03003": [
    "LINC03003 CNV",
    "LINC03003 RNA"
  ],
  "CCT6P4": [
    "CCT6P4 CNV",
    "CCT6P4 RNA"
  ],
  "HOXD11": [
    "HOXD11 CNV",
    "HOXD11 RNA"
  ],
  "SPDYE15": [
    "SPDYE15 CNV",
    "SPDYE15 RNA"
  ],
  "ATPAF2": [
    "ATPAF2 CNV",
    "ATPAF2 RNA",
    "ATPAF2 Proteo"
  ],
  "GEMIN5": [
    "GEMIN5 CNV",
    "GEMIN5 RNA",
    "GEMIN5 Proteo"
  ],
  "MRGPRX4": [
    "MRGPRX4 CNV",
    "MRGPRX4 RNA"
  ],
  "SH2D4A": [
    "SH2D4A CNV",
    "SH2D4A RNA",
    "SH2D4A Proteo"
  ],
  "PSG7": [
    "PSG7 CNV",
    "PSG7 RNA"
  ],
  "KIAA0513": [
    "KIAA0513 CNV",
    "KIAA0513 RNA",
    "KIAA0513 Proteo"
  ],
  "PGBD4P4": [
    "PGBD4P4 CNV",
    "PGBD4P4 RNA"
  ],
  "RAP2A": [
    "RAP2A CNV",
    "RAP2A RNA",
    "RAP2A Proteo"
  ],
  "KYAT3": [
    "KYAT3 CNV",
    "KYAT3 RNA",
    "KYAT3 Proteo"
  ],
  "LRRC57P1": [
    "LRRC57P1 CNV",
    "LRRC57P1 RNA"
  ],
  "SCG3": [
    "SCG3 CNV",
    "SCG3 RNA"
  ],
  "PPIAP21": [
    "PPIAP21 CNV",
    "PPIAP21 RNA"
  ],
  "KRTAP16-1": [
    "KRTAP16-1 CNV",
    "KRTAP16-1 RNA"
  ],
  "OR5BK1P": [
    "OR5BK1P CNV",
    "OR5BK1P RNA"
  ],
  "IFT57": [
    "IFT57 CNV",
    "IFT57 RNA",
    "IFT57 Proteo"
  ],
  "MARCHF3": [
    "MARCHF3 CNV",
    "MARCHF3 RNA"
  ],
  "CICP3": [
    "CICP3 CNV",
    "CICP3 RNA"
  ],
  "DOCK8": [
    "DOCK8 CNV",
    "DOCK8 RNA",
    "DOCK8 Proteo"
  ],
  "ZNF705B": [
    "ZNF705B CNV",
    "ZNF705B RNA"
  ],
  "CCL16": [
    "CCL16 CNV",
    "CCL16 RNA"
  ],
  "MAP2K2": [
    "MAP2K2 CNV",
    "MAP2K2 RNA",
    "MAP2K2 Proteo"
  ],
  "TP53TG3F": [
    "TP53TG3F CNV",
    "TP53TG3F RNA"
  ],
  "MCEMP1": [
    "MCEMP1 CNV",
    "MCEMP1 RNA",
    "MCEMP1 Proteo"
  ],
  "ATP2B1": [
    "ATP2B1 CNV",
    "ATP2B1 RNA",
    "ATP2B1 Proteo"
  ],
  "COL3A1": [
    "COL3A1 CNV",
    "COL3A1 RNA",
    "COL3A1 Proteo"
  ],
  "DNAH17": [
    "DNAH17 CNV",
    "DNAH17 RNA",
    "DNAH17 Proteo"
  ],
  "SYNPR": [
    "SYNPR CNV",
    "SYNPR RNA",
    "SYNPR Proteo"
  ],
  "RNA5SP86": [
    "RNA5SP86 CNV",
    "RNA5SP86 RNA"
  ],
  "PHB1P1": [
    "PHB1P1 CNV",
    "PHB1P1 RNA"
  ],
  "DCAF10": [
    "DCAF10 CNV",
    "DCAF10 RNA",
    "DCAF10 Proteo"
  ],
  "ZNF717": [
    "ZNF717 CNV",
    "ZNF717 RNA"
  ],
  "GALNT2": [
    "GALNT2 CNV",
    "GALNT2 RNA",
    "GALNT2 Proteo"
  ],
  "MYH15": [
    "MYH15 CNV",
    "MYH15 RNA"
  ],
  "RPS27AP13": [
    "RPS27AP13 CNV",
    "RPS27AP13 RNA"
  ],
  "KATNAL2": [
    "KATNAL2 CNV",
    "KATNAL2 RNA"
  ],
  "NPM1P50": [
    "NPM1P50 CNV",
    "NPM1P50 RNA"
  ],
  "MRPS18C": [
    "MRPS18C CNV",
    "MRPS18C RNA",
    "MRPS18C Proteo"
  ],
  "HAND2": [
    "HAND2 CNV",
    "HAND2 RNA"
  ],
  "PLEKHA6": [
    "PLEKHA6 CNV",
    "PLEKHA6 RNA",
    "PLEKHA6 Proteo"
  ],
  "YPEL2": [
    "YPEL2 CNV",
    "YPEL2 RNA",
    "YPEL2 Proteo"
  ],
  "MT2P1": [
    "MT2P1 CNV",
    "MT2P1 RNA"
  ],
  "DIXDC1": [
    "DIXDC1 CNV",
    "DIXDC1 RNA",
    "DIXDC1 Proteo"
  ],
  "BRWD1P3": [
    "BRWD1P3 CNV",
    "BRWD1P3 RNA"
  ],
  "ZBTB8B": [
    "ZBTB8B CNV",
    "ZBTB8B RNA"
  ],
  "COX6B1P7": [
    "COX6B1P7 CNV",
    "COX6B1P7 RNA"
  ],
  "SNRPFP2": [
    "SNRPFP2 CNV",
    "SNRPFP2 RNA"
  ],
  "TMEM117": [
    "TMEM117 CNV",
    "TMEM117 RNA",
    "TMEM117 Proteo"
  ],
  "RTL3": [
    "RTL3 CNV",
    "RTL3 RNA"
  ],
  "ZFP92": [
    "ZFP92 CNV",
    "ZFP92 RNA",
    "ZFP92 Proteo"
  ],
  "BRD7P3": [
    "BRD7P3 CNV",
    "BRD7P3 RNA"
  ],
  "TMEM100": [
    "TMEM100 CNV",
    "TMEM100 RNA"
  ],
  "ERP29": [
    "ERP29 CNV",
    "ERP29 RNA",
    "ERP29 Proteo"
  ],
  "TMF1": [
    "TMF1 CNV",
    "TMF1 RNA",
    "TMF1 Proteo"
  ],
  "INPP1": [
    "INPP1 CNV",
    "INPP1 RNA",
    "INPP1 Proteo"
  ],
  "RPS4XP8": [
    "RPS4XP8 CNV",
    "RPS4XP8 RNA"
  ],
  "RNA5SP56": [
    "RNA5SP56 CNV",
    "RNA5SP56 RNA"
  ],
  "CCDC88B": [
    "CCDC88B CNV",
    "CCDC88B RNA",
    "CCDC88B Proteo"
  ],
  "MAGEA9B": [
    "MAGEA9B CNV",
    "MAGEA9B RNA"
  ],
  "GOLGA6L3": [
    "GOLGA6L3 CNV",
    "GOLGA6L3 RNA"
  ],
  "VN1R11P": [
    "VN1R11P CNV",
    "VN1R11P RNA"
  ],
  "PMP2": [
    "PMP2 CNV",
    "PMP2 RNA",
    "PMP2 Proteo"
  ],
  "COL7A1": [
    "COL7A1 CNV",
    "COL7A1 RNA",
    "COL7A1 Proteo"
  ],
  "ATG4B": [
    "ATG4B CNV",
    "ATG4B RNA",
    "ATG4B Proteo"
  ],
  "BRME1": [
    "BRME1 CNV",
    "BRME1 RNA"
  ],
  "FAM163B": [
    "FAM163B CNV",
    "FAM163B RNA"
  ],
  "ZNF688": [
    "ZNF688 CNV",
    "ZNF688 RNA",
    "ZNF688 Proteo"
  ],
  "ADGB": [
    "ADGB CNV",
    "ADGB RNA"
  ],
  "C1orf100": [
    "C1orf100 CNV",
    "C1orf100 RNA"
  ],
  "OR10X1": [
    "OR10X1 CNV",
    "OR10X1 RNA"
  ],
  "GUSBP5": [
    "GUSBP5 CNV",
    "GUSBP5 RNA"
  ],
  "TMC5": [
    "TMC5 CNV",
    "TMC5 RNA",
    "TMC5 Proteo"
  ],
  "PGD": [
    "PGD CNV",
    "PGD RNA",
    "PGD Proteo"
  ],
  "RPL35A": [
    "RPL35A CNV",
    "RPL35A RNA",
    "RPL35A Proteo"
  ],
  "CFAP99": [
    "CFAP99 CNV",
    "CFAP99 RNA"
  ],
  "XRRA1": [
    "XRRA1 CNV",
    "XRRA1 RNA"
  ],
  "EEF1E1": [
    "EEF1E1 CNV",
    "EEF1E1 RNA",
    "EEF1E1 Proteo"
  ],
  "GPR179": [
    "GPR179 CNV",
    "GPR179 RNA",
    "GPR179 Proteo"
  ],
  "CNST": [
    "CNST CNV",
    "CNST RNA",
    "CNST Proteo"
  ],
  "TACR2": [
    "TACR2 CNV",
    "TACR2 RNA"
  ],
  "SUMO1P2": [
    "SUMO1P2 CNV",
    "SUMO1P2 RNA"
  ],
  "GVINP2": [
    "GVINP2 CNV",
    "GVINP2 RNA"
  ],
  "IGHV3-47": [
    "IGHV3-47 CNV",
    "IGHV3-47 RNA"
  ],
  "HTR3E": [
    "HTR3E CNV",
    "HTR3E RNA"
  ],
  "TNFRSF4": [
    "TNFRSF4 CNV",
    "TNFRSF4 RNA"
  ],
  "PELO": [
    "PELO CNV",
    "PELO RNA",
    "PELO Proteo"
  ],
  "OR6V1": [
    "OR6V1 CNV",
    "OR6V1 RNA"
  ],
  "UNC13C": [
    "UNC13C CNV",
    "UNC13C RNA"
  ],
  "ROBO4": [
    "ROBO4 CNV",
    "ROBO4 RNA"
  ],
  "CDK5P1": [
    "CDK5P1 CNV",
    "CDK5P1 RNA"
  ],
  "SYTL4": [
    "SYTL4 CNV",
    "SYTL4 RNA",
    "SYTL4 Proteo"
  ],
  "SLC7A5P2": [
    "SLC7A5P2 CNV",
    "SLC7A5P2 RNA"
  ],
  "MGAT5B": [
    "MGAT5B CNV",
    "MGAT5B RNA",
    "MGAT5B Proteo"
  ],
  "TAS2R41": [
    "TAS2R41 CNV",
    "TAS2R41 RNA"
  ],
  "PPP1R11": [
    "PPP1R11 CNV",
    "PPP1R11 RNA",
    "PPP1R11 Proteo"
  ],
  "PACRG": [
    "PACRG CNV",
    "PACRG RNA"
  ],
  "GPR79": [
    "GPR79 CNV",
    "GPR79 RNA"
  ],
  "CYP4F10P": [
    "CYP4F10P CNV",
    "CYP4F10P RNA"
  ],
  "MRPL28": [
    "MRPL28 CNV",
    "MRPL28 RNA",
    "MRPL28 Proteo"
  ],
  "GUSBP2": [
    "GUSBP2 CNV",
    "GUSBP2 RNA"
  ],
  "ZNF138": [
    "ZNF138 CNV",
    "ZNF138 RNA"
  ],
  "GRXCR1": [
    "GRXCR1 CNV",
    "GRXCR1 RNA"
  ],
  "SAPCD2": [
    "SAPCD2 CNV",
    "SAPCD2 RNA",
    "SAPCD2 Proteo"
  ],
  "OR52E7P": [
    "OR52E7P CNV",
    "OR52E7P RNA"
  ],
  "CEP95": [
    "CEP95 CNV",
    "CEP95 RNA",
    "CEP95 Proteo"
  ],
  "MRPL9": [
    "MRPL9 CNV",
    "MRPL9 RNA",
    "MRPL9 Proteo"
  ],
  "MTND2P21": [
    "MTND2P21 CNV",
    "MTND2P21 RNA"
  ],
  "CEACAM6": [
    "CEACAM6 CNV",
    "CEACAM6 RNA",
    "CEACAM6 Proteo"
  ],
  "LNP1": [
    "LNP1 CNV",
    "LNP1 RNA"
  ],
  "LAT": [
    "LAT CNV",
    "LAT RNA",
    "LAT Proteo"
  ],
  "VN1R38P": [
    "VN1R38P CNV",
    "VN1R38P RNA"
  ],
  "PRKG2": [
    "PRKG2 CNV",
    "PRKG2 RNA",
    "PRKG2 Proteo"
  ],
  "GIMAP3P": [
    "GIMAP3P CNV",
    "GIMAP3P RNA"
  ],
  "VAMP3": [
    "VAMP3 CNV",
    "VAMP3 RNA",
    "VAMP3 Proteo"
  ],
  "TIGD2": [
    "TIGD2 CNV",
    "TIGD2 RNA",
    "TIGD2 Proteo"
  ],
  "ETV2": [
    "ETV2 CNV",
    "ETV2 RNA"
  ],
  "NOCT": [
    "NOCT CNV",
    "NOCT RNA",
    "NOCT Proteo"
  ],
  "TRBV24OR9-2": [
    "TRBV24OR9-2 CNV",
    "TRBV24OR9-2 RNA"
  ],
  "H3P43": [
    "H3P43 CNV",
    "H3P43 RNA"
  ],
  "ARHGEF34P": [
    "ARHGEF34P CNV",
    "ARHGEF34P RNA"
  ],
  "MEMO1": [
    "MEMO1 CNV",
    "MEMO1 RNA",
    "MEMO1 Proteo"
  ],
  "MLX": [
    "MLX CNV",
    "MLX RNA",
    "MLX Proteo"
  ],
  "HNRNPA3P15": [
    "HNRNPA3P15 CNV",
    "HNRNPA3P15 RNA"
  ],
  "TM6SF2": [
    "TM6SF2 CNV",
    "TM6SF2 RNA"
  ],
  "POMK": [
    "POMK CNV",
    "POMK RNA",
    "POMK Proteo"
  ],
  "SGCE": [
    "SGCE CNV",
    "SGCE RNA",
    "SGCE Proteo"
  ],
  "OR7E103P": [
    "OR7E103P CNV",
    "OR7E103P RNA"
  ],
  "OR4K13": [
    "OR4K13 CNV",
    "OR4K13 RNA"
  ],
  "FBLN5": [
    "FBLN5 CNV",
    "FBLN5 RNA",
    "FBLN5 Proteo"
  ],
  "RNA5SP397": [
    "RNA5SP397 CNV",
    "RNA5SP397 RNA"
  ],
  "LRRFIP2": [
    "LRRFIP2 CNV",
    "LRRFIP2 RNA",
    "LRRFIP2 Proteo"
  ],
  "EOLA2": [
    "EOLA2 CNV",
    "EOLA2 RNA"
  ],
  "CIAPIN1P": [
    "CIAPIN1P CNV",
    "CIAPIN1P RNA"
  ],
  "TACO1": [
    "TACO1 CNV",
    "TACO1 RNA",
    "TACO1 Proteo"
  ],
  "MTMR4": [
    "MTMR4 CNV",
    "MTMR4 RNA",
    "MTMR4 Proteo"
  ],
  "WIZP1": [
    "WIZP1 CNV",
    "WIZP1 RNA"
  ],
  "C22orf46": [
    "C22orf46 CNV",
    "C22orf46 RNA"
  ],
  "EPDR1": [
    "EPDR1 CNV",
    "EPDR1 RNA",
    "EPDR1 Proteo"
  ],
  "RPS7P14": [
    "RPS7P14 CNV",
    "RPS7P14 RNA"
  ],
  "TMEM87B": [
    "TMEM87B CNV",
    "TMEM87B RNA",
    "TMEM87B Proteo"
  ],
  "FDPSP7": [
    "FDPSP7 CNV",
    "FDPSP7 RNA"
  ],
  "RPUSD2": [
    "RPUSD2 CNV",
    "RPUSD2 RNA",
    "RPUSD2 Proteo"
  ],
  "CICP5": [
    "CICP5 CNV",
    "CICP5 RNA"
  ],
  "SFXN5": [
    "SFXN5 CNV",
    "SFXN5 RNA",
    "SFXN5 Proteo"
  ],
  "GML": [
    "GML CNV",
    "GML RNA"
  ],
  "RBM24": [
    "RBM24 CNV",
    "RBM24 RNA"
  ],
  "CCDC137": [
    "CCDC137 CNV",
    "CCDC137 RNA",
    "CCDC137 Proteo"
  ],
  "RORC": [
    "RORC CNV",
    "RORC RNA"
  ],
  "CHST9": [
    "CHST9 CNV",
    "CHST9 RNA",
    "CHST9 Proteo"
  ],
  "ADAMTS14": [
    "ADAMTS14 CNV",
    "ADAMTS14 RNA"
  ],
  "TMEM167AP2": [
    "TMEM167AP2 CNV",
    "TMEM167AP2 RNA"
  ],
  "LRP5": [
    "LRP5 CNV",
    "LRP5 RNA",
    "LRP5 Proteo"
  ],
  "LPAR4": [
    "LPAR4 CNV",
    "LPAR4 RNA"
  ],
  "ACSL6": [
    "ACSL6 CNV",
    "ACSL6 RNA",
    "ACSL6 Proteo"
  ],
  "PWWP3B": [
    "PWWP3B CNV",
    "PWWP3B RNA"
  ],
  "SLK": [
    "SLK CNV",
    "SLK RNA",
    "SLK Proteo"
  ],
  "BASP1": [
    "BASP1 CNV",
    "BASP1 RNA",
    "BASP1 Proteo"
  ],
  "LINC01869": [
    "LINC01869 CNV",
    "LINC01869 RNA"
  ],
  "TPPP": [
    "TPPP CNV",
    "TPPP RNA",
    "TPPP Proteo"
  ],
  "FAM124B": [
    "FAM124B CNV",
    "FAM124B RNA"
  ],
  "ZCRB1": [
    "ZCRB1 CNV",
    "ZCRB1 RNA",
    "ZCRB1 Proteo"
  ],
  "UBQLN4": [
    "UBQLN4 CNV",
    "UBQLN4 RNA",
    "UBQLN4 Proteo"
  ],
  "SPATA46": [
    "SPATA46 CNV",
    "SPATA46 RNA"
  ],
  "NDUFV2P1": [
    "NDUFV2P1 CNV",
    "NDUFV2P1 RNA"
  ],
  "DYRK2": [
    "DYRK2 CNV",
    "DYRK2 RNA",
    "DYRK2 Proteo"
  ],
  "SDSL": [
    "SDSL CNV",
    "SDSL RNA",
    "SDSL Proteo"
  ],
  "AMOT": [
    "AMOT CNV",
    "AMOT RNA",
    "AMOT Proteo"
  ],
  "SSR3": [
    "SSR3 CNV",
    "SSR3 RNA",
    "SSR3 Proteo"
  ],
  "ZNF66": [
    "ZNF66 CNV",
    "ZNF66 RNA"
  ],
  "DCUN1D2": [
    "DCUN1D2 CNV",
    "DCUN1D2 RNA"
  ],
  "CRYGD": [
    "CRYGD CNV",
    "CRYGD RNA"
  ],
  "TOGARAM1": [
    "TOGARAM1 CNV",
    "TOGARAM1 RNA",
    "TOGARAM1 Proteo"
  ],
  "ANXA11": [
    "ANXA11 CNV",
    "ANXA11 RNA",
    "ANXA11 Proteo"
  ],
  "TEX49": [
    "TEX49 CNV",
    "TEX49 RNA"
  ],
  "BAG3": [
    "BAG3 CNV",
    "BAG3 RNA",
    "BAG3 Proteo"
  ],
  "GYPC": [
    "GYPC CNV",
    "GYPC RNA",
    "GYPC Proteo"
  ],
  "H3P11": [
    "H3P11 CNV",
    "H3P11 RNA"
  ],
  "IGLV6-57": [
    "IGLV6-57 Proteo"
  ],
  "PPFIA1P1": [
    "PPFIA1P1 CNV",
    "PPFIA1P1 RNA"
  ],
  "SLC25A17": [
    "SLC25A17 CNV",
    "SLC25A17 RNA",
    "SLC25A17 Proteo"
  ],
  "LYZ": [
    "LYZ CNV",
    "LYZ RNA",
    "LYZ Proteo"
  ],
  "ALMS1P1": [
    "ALMS1P1 CNV",
    "ALMS1P1 RNA"
  ],
  "MANEALP1": [
    "MANEALP1 CNV",
    "MANEALP1 RNA"
  ],
  "DLD": [
    "DLD CNV",
    "DLD RNA",
    "DLD Proteo"
  ],
  "PADI1": [
    "PADI1 CNV",
    "PADI1 RNA",
    "PADI1 Proteo"
  ],
  "PKMP4": [
    "PKMP4 CNV",
    "PKMP4 RNA"
  ],
  "HNRNPA1P62": [
    "HNRNPA1P62 CNV",
    "HNRNPA1P62 RNA"
  ],
  "KRT32": [
    "KRT32 CNV",
    "KRT32 RNA"
  ],
  "KCNF1": [
    "KCNF1 CNV",
    "KCNF1 RNA"
  ],
  "MRPL1": [
    "MRPL1 CNV",
    "MRPL1 RNA",
    "MRPL1 Proteo"
  ],
  "STAC3": [
    "STAC3 CNV",
    "STAC3 RNA"
  ],
  "ZNF735": [
    "ZNF735 CNV",
    "ZNF735 RNA"
  ],
  "GPR162": [
    "GPR162 CNV",
    "GPR162 RNA"
  ],
  "IGKV1D-39": [
    "IGKV1D-39 Proteo"
  ],
  "H2BC1": [
    "H2BC1 CNV",
    "H2BC1 RNA",
    "H2BC1 Proteo"
  ],
  "PTPDC1": [
    "PTPDC1 CNV",
    "PTPDC1 RNA",
    "PTPDC1 Proteo"
  ],
  "ZNF845": [
    "ZNF845 CNV",
    "ZNF845 RNA",
    "ZNF845 Proteo"
  ],
  "GRIN3A": [
    "GRIN3A CNV",
    "GRIN3A RNA"
  ],
  "RNA5SP371": [
    "RNA5SP371 CNV",
    "RNA5SP371 RNA"
  ],
  "ARPC3P4": [
    "ARPC3P4 CNV",
    "ARPC3P4 RNA"
  ],
  "RABIF": [
    "RABIF CNV",
    "RABIF RNA",
    "RABIF Proteo"
  ],
  "MMAA": [
    "MMAA CNV",
    "MMAA RNA",
    "MMAA Proteo"
  ],
  "TUBAP6": [
    "TUBAP6 CNV",
    "TUBAP6 RNA"
  ],
  "LRRIQ4": [
    "LRRIQ4 CNV",
    "LRRIQ4 RNA"
  ],
  "GOLGA8N": [
    "GOLGA8N CNV",
    "GOLGA8N RNA"
  ],
  "RFTN1": [
    "RFTN1 CNV",
    "RFTN1 RNA",
    "RFTN1 Proteo"
  ],
  "TEPSIN": [
    "TEPSIN CNV",
    "TEPSIN RNA",
    "TEPSIN Proteo"
  ],
  "LMO4": [
    "LMO4 CNV",
    "LMO4 RNA",
    "LMO4 Proteo"
  ],
  "SEC14L4": [
    "SEC14L4 CNV",
    "SEC14L4 RNA",
    "SEC14L4 Proteo"
  ],
  "XKR6": [
    "XKR6 CNV",
    "XKR6 RNA"
  ],
  "INAFM1": [
    "INAFM1 CNV",
    "INAFM1 RNA"
  ],
  "NTF6G": [
    "NTF6G CNV",
    "NTF6G RNA"
  ],
  "IGLON5": [
    "IGLON5 CNV",
    "IGLON5 RNA"
  ],
  "MPDU1": [
    "MPDU1 CNV",
    "MPDU1 RNA",
    "MPDU1 Proteo"
  ],
  "LRWD1": [
    "LRWD1 CNV",
    "LRWD1 RNA",
    "LRWD1 Proteo"
  ],
  "ENY2": [
    "ENY2 CNV",
    "ENY2 RNA",
    "ENY2 Proteo"
  ],
  "RAD9A": [
    "RAD9A CNV",
    "RAD9A RNA",
    "RAD9A Proteo"
  ],
  "SLC44A5": [
    "SLC44A5 CNV",
    "SLC44A5 RNA"
  ],
  "RPL10P7": [
    "RPL10P7 CNV",
    "RPL10P7 RNA"
  ],
  "TEN1": [
    "TEN1 CNV",
    "TEN1 RNA"
  ],
  "ATP10A": [
    "ATP10A CNV",
    "ATP10A RNA",
    "ATP10A Proteo"
  ],
  "RPL29P19": [
    "RPL29P19 CNV",
    "RPL29P19 RNA"
  ],
  "TAS2R8": [
    "TAS2R8 CNV",
    "TAS2R8 RNA"
  ],
  "RPL22P23": [
    "RPL22P23 CNV",
    "RPL22P23 RNA"
  ],
  "ARNTL2": [
    "ARNTL2 CNV",
    "ARNTL2 RNA"
  ],
  "RERGL": [
    "RERGL CNV",
    "RERGL RNA"
  ],
  "BTNL9": [
    "BTNL9 CNV",
    "BTNL9 RNA",
    "BTNL9 Proteo"
  ],
  "FUZ": [
    "FUZ CNV",
    "FUZ RNA",
    "FUZ Proteo"
  ],
  "IL9RP3": [
    "IL9RP3 CNV",
    "IL9RP3 RNA"
  ],
  "SRD5A1P1": [
    "SRD5A1P1 CNV",
    "SRD5A1P1 RNA"
  ],
  "KRTAP5-1": [
    "KRTAP5-1 CNV",
    "KRTAP5-1 RNA"
  ],
  "DERA": [
    "DERA CNV",
    "DERA RNA",
    "DERA Proteo"
  ],
  "GPR63": [
    "GPR63 CNV",
    "GPR63 RNA"
  ],
  "NUP107": [
    "NUP107 CNV",
    "NUP107 RNA",
    "NUP107 Proteo"
  ],
  "DDI2": [
    "DDI2 CNV",
    "DDI2 RNA",
    "DDI2 Proteo"
  ],
  "IGHV3-15": [
    "IGHV3-15 Proteo"
  ],
  "ACRBP": [
    "ACRBP CNV",
    "ACRBP RNA",
    "ACRBP Proteo"
  ],
  "NPM1P1": [
    "NPM1P1 CNV",
    "NPM1P1 RNA"
  ],
  "RPL7P22": [
    "RPL7P22 CNV",
    "RPL7P22 RNA"
  ],
  "BMP2KL": [
    "BMP2KL CNV",
    "BMP2KL RNA"
  ],
  "TEAD3": [
    "TEAD3 CNV",
    "TEAD3 RNA",
    "TEAD3 Proteo"
  ],
  "TAC4": [
    "TAC4 CNV",
    "TAC4 RNA"
  ],
  "EEF1AKMT2": [
    "EEF1AKMT2 CNV",
    "EEF1AKMT2 RNA",
    "EEF1AKMT2 Proteo"
  ],
  "RPL3P8": [
    "RPL3P8 CNV",
    "RPL3P8 RNA"
  ],
  "RHEBP3": [
    "RHEBP3 CNV",
    "RHEBP3 RNA"
  ],
  "RNA5SP105": [
    "RNA5SP105 CNV",
    "RNA5SP105 RNA"
  ],
  "FGF10": [
    "FGF10 CNV",
    "FGF10 RNA"
  ],
  "IGKV1-8": [
    "IGKV1-8 Proteo"
  ],
  "THEG": [
    "THEG CNV",
    "THEG RNA"
  ],
  "UNKL": [
    "UNKL CNV",
    "UNKL RNA",
    "UNKL Proteo"
  ],
  "RSL24D1": [
    "RSL24D1 CNV",
    "RSL24D1 RNA",
    "RSL24D1 Proteo"
  ],
  "ABO": [
    "ABO CNV",
    "ABO RNA"
  ],
  "OR1A1": [
    "OR1A1 CNV",
    "OR1A1 RNA"
  ],
  "PEF1": [
    "PEF1 CNV",
    "PEF1 RNA",
    "PEF1 Proteo"
  ],
  "VCP": [
    "VCP CNV",
    "VCP RNA",
    "VCP Proteo"
  ],
  "FAM133EP": [
    "FAM133EP CNV",
    "FAM133EP RNA"
  ],
  "DDX56": [
    "DDX56 CNV",
    "DDX56 RNA",
    "DDX56 Proteo"
  ],
  "HNRNPA3P12": [
    "HNRNPA3P12 CNV",
    "HNRNPA3P12 RNA"
  ],
  "CELF6": [
    "CELF6 CNV",
    "CELF6 RNA"
  ],
  "CCT3P1": [
    "CCT3P1 CNV",
    "CCT3P1 RNA"
  ],
  "ORC3": [
    "ORC3 CNV",
    "ORC3 RNA",
    "ORC3 Proteo"
  ],
  "SH3GLB1": [
    "SH3GLB1 CNV",
    "SH3GLB1 RNA",
    "SH3GLB1 Proteo"
  ],
  "HMCN2": [
    "HMCN2 CNV",
    "HMCN2 RNA",
    "HMCN2 Proteo"
  ],
  "TRIL": [
    "TRIL CNV",
    "TRIL RNA",
    "TRIL Proteo"
  ],
  "OR4N4": [
    "OR4N4 CNV",
    "OR4N4 RNA"
  ],
  "MGMT": [
    "MGMT CNV",
    "MGMT RNA",
    "MGMT Proteo"
  ],
  "IL1RL2": [
    "IL1RL2 CNV",
    "IL1RL2 RNA"
  ],
  "MYADM": [
    "MYADM CNV",
    "MYADM RNA",
    "MYADM Proteo"
  ],
  "SSU72": [
    "SSU72 CNV",
    "SSU72 RNA",
    "SSU72 Proteo"
  ],
  "TRPC6P8": [
    "TRPC6P8 CNV",
    "TRPC6P8 RNA"
  ],
  "AMD1P4": [
    "AMD1P4 CNV",
    "AMD1P4 RNA"
  ],
  "RPS23P1": [
    "RPS23P1 CNV",
    "RPS23P1 RNA"
  ],
  "RTL5": [
    "RTL5 CNV",
    "RTL5 RNA"
  ],
  "SMYD1": [
    "SMYD1 CNV",
    "SMYD1 RNA",
    "SMYD1 Proteo"
  ],
  "APOC4-APOC2": [
    "APOC4-APOC2 Proteo"
  ],
  "VN1R40P": [
    "VN1R40P CNV",
    "VN1R40P RNA"
  ],
  "DCHS2": [
    "DCHS2 CNV",
    "DCHS2 RNA"
  ],
  "SLC25A6": [
    "SLC25A6 CNV",
    "SLC25A6 RNA",
    "SLC25A6 Proteo"
  ],
  "CUBNP2": [
    "CUBNP2 CNV",
    "CUBNP2 RNA"
  ],
  "IGHVII-22-1": [
    "IGHVII-22-1 CNV",
    "IGHVII-22-1 RNA"
  ],
  "KLK8": [
    "KLK8 CNV",
    "KLK8 RNA",
    "KLK8 Proteo"
  ],
  "MTCO1P10": [
    "MTCO1P10 CNV",
    "MTCO1P10 RNA"
  ],
  "TMEM252": [
    "TMEM252 CNV",
    "TMEM252 RNA"
  ],
  "CWC22": [
    "CWC22 CNV",
    "CWC22 RNA",
    "CWC22 Proteo"
  ],
  "VN1R93P": [
    "VN1R93P CNV",
    "VN1R93P RNA"
  ],
  "IL2RA": [
    "IL2RA CNV",
    "IL2RA RNA"
  ],
  "C15orf40": [
    "C15orf40 CNV",
    "C15orf40 RNA",
    "C15orf40 Proteo"
  ],
  "FBXO40": [
    "FBXO40 CNV",
    "FBXO40 RNA"
  ],
  "PRDM5": [
    "PRDM5 CNV",
    "PRDM5 RNA"
  ],
  "MDGA2": [
    "MDGA2 CNV",
    "MDGA2 RNA"
  ],
  "ALOX12P1": [
    "ALOX12P1 CNV",
    "ALOX12P1 RNA"
  ],
  "TMEM30B": [
    "TMEM30B CNV",
    "TMEM30B RNA",
    "TMEM30B Proteo"
  ],
  "RPL7P23": [
    "RPL7P23 CNV",
    "RPL7P23 RNA"
  ],
  "NPIPB4": [
    "NPIPB4 CNV",
    "NPIPB4 RNA"
  ],
  "MAL2": [
    "MAL2 CNV",
    "MAL2 RNA",
    "MAL2 Proteo"
  ],
  "DNTT": [
    "DNTT CNV",
    "DNTT RNA",
    "DNTT Proteo"
  ],
  "CEP55": [
    "CEP55 CNV",
    "CEP55 RNA",
    "CEP55 Proteo"
  ],
  "XIAPP3": [
    "XIAPP3 CNV",
    "XIAPP3 RNA"
  ],
  "RPL13AP": [
    "RPL13AP CNV",
    "RPL13AP RNA"
  ],
  "CCDC188": [
    "CCDC188 CNV",
    "CCDC188 RNA"
  ],
  "GNG8": [
    "GNG8 CNV",
    "GNG8 RNA"
  ],
  "FTH1P26": [
    "FTH1P26 CNV",
    "FTH1P26 RNA"
  ],
  "UBE2H": [
    "UBE2H CNV",
    "UBE2H RNA",
    "UBE2H Proteo"
  ],
  "RGS7": [
    "RGS7 CNV",
    "RGS7 RNA"
  ],
  "FGF7P6": [
    "FGF7P6 CNV",
    "FGF7P6 RNA"
  ],
  "SLC25A1P4": [
    "SLC25A1P4 CNV",
    "SLC25A1P4 RNA"
  ],
  "TAF1": [
    "TAF1 CNV",
    "TAF1 RNA",
    "TAF1 Proteo"
  ],
  "RXRA": [
    "RXRA CNV",
    "RXRA RNA",
    "RXRA Proteo"
  ],
  "DHFR": [
    "DHFR CNV",
    "DHFR RNA",
    "DHFR Proteo"
  ],
  "AQP3": [
    "AQP3 CNV",
    "AQP3 RNA",
    "AQP3 Proteo"
  ],
  "MTND3P7": [
    "MTND3P7 CNV",
    "MTND3P7 RNA"
  ],
  "UROD": [
    "UROD CNV",
    "UROD RNA",
    "UROD Proteo"
  ],
  "CLPB": [
    "CLPB CNV",
    "CLPB RNA",
    "CLPB Proteo"
  ],
  "FGF7P2": [
    "FGF7P2 CNV",
    "FGF7P2 RNA"
  ],
  "H2ACP1": [
    "H2ACP1 CNV",
    "H2ACP1 RNA"
  ],
  "ERCC3": [
    "ERCC3 CNV",
    "ERCC3 RNA",
    "ERCC3 Proteo"
  ],
  "CCL27": [
    "CCL27 CNV",
    "CCL27 RNA"
  ],
  "CDKN2AIP": [
    "CDKN2AIP CNV",
    "CDKN2AIP RNA",
    "CDKN2AIP Proteo"
  ],
  "AHDC1": [
    "AHDC1 CNV",
    "AHDC1 RNA",
    "AHDC1 Proteo"
  ],
  "KRT8P32": [
    "KRT8P32 CNV",
    "KRT8P32 RNA"
  ],
  "SLC7A13": [
    "SLC7A13 CNV",
    "SLC7A13 RNA"
  ],
  "GRIN1": [
    "GRIN1 CNV",
    "GRIN1 RNA"
  ],
  "DPY19L4": [
    "DPY19L4 CNV",
    "DPY19L4 RNA",
    "DPY19L4 Proteo"
  ],
  "H3C4": [
    "H3C4 CNV",
    "H3C4 RNA"
  ],
  "RFX5": [
    "RFX5 CNV",
    "RFX5 RNA",
    "RFX5 Proteo"
  ],
  "ZBTB45P1": [
    "ZBTB45P1 CNV",
    "ZBTB45P1 RNA"
  ],
  "TBCCD1": [
    "TBCCD1 CNV",
    "TBCCD1 RNA"
  ],
  "TCEANC": [
    "TCEANC CNV",
    "TCEANC RNA"
  ],
  "PCDH17": [
    "PCDH17 CNV",
    "PCDH17 RNA",
    "PCDH17 Proteo"
  ],
  "TDGF1P5": [
    "TDGF1P5 CNV",
    "TDGF1P5 RNA"
  ],
  "TERF1P7": [
    "TERF1P7 CNV",
    "TERF1P7 RNA"
  ],
  "ZNF92P1Y": [
    "ZNF92P1Y CNV",
    "ZNF92P1Y RNA"
  ],
  "MOB1B": [
    "MOB1B CNV",
    "MOB1B RNA",
    "MOB1B Proteo"
  ],
  "COQ2": [
    "COQ2 CNV",
    "COQ2 RNA"
  ],
  "MED13P1": [
    "MED13P1 CNV",
    "MED13P1 RNA"
  ],
  "MARK3": [
    "MARK3 CNV",
    "MARK3 RNA",
    "MARK3 Proteo"
  ],
  "LRRC72": [
    "LRRC72 CNV",
    "LRRC72 RNA"
  ],
  "RIPPLY2": [
    "RIPPLY2 CNV",
    "RIPPLY2 RNA"
  ],
  "PIKFYVE": [
    "PIKFYVE CNV",
    "PIKFYVE RNA",
    "PIKFYVE Proteo"
  ],
  "RPS4XP13": [
    "RPS4XP13 CNV",
    "RPS4XP13 RNA"
  ],
  "USP5": [
    "USP5 CNV",
    "USP5 RNA",
    "USP5 Proteo"
  ],
  "LURAP1": [
    "LURAP1 CNV",
    "LURAP1 RNA",
    "LURAP1 Proteo"
  ],
  "HAUS6P1": [
    "HAUS6P1 CNV",
    "HAUS6P1 RNA"
  ],
  "PRKDC": [
    "PRKDC CNV",
    "PRKDC RNA",
    "PRKDC Proteo"
  ],
  "RAB41": [
    "RAB41 CNV",
    "RAB41 RNA"
  ],
  "IGFL4": [
    "IGFL4 CNV",
    "IGFL4 RNA"
  ],
  "TACC1": [
    "TACC1 CNV",
    "TACC1 RNA",
    "TACC1 Proteo"
  ],
  "ANK2": [
    "ANK2 CNV",
    "ANK2 RNA",
    "ANK2 Proteo"
  ],
  "RNA5SP48": [
    "RNA5SP48 CNV",
    "RNA5SP48 RNA"
  ],
  "EIF5AL1": [
    "EIF5AL1 CNV",
    "EIF5AL1 RNA"
  ],
  "PHKBP2": [
    "PHKBP2 CNV",
    "PHKBP2 RNA"
  ],
  "SHOC2": [
    "SHOC2 CNV",
    "SHOC2 RNA",
    "SHOC2 Proteo"
  ],
  "ACTN4P2": [
    "ACTN4P2 CNV",
    "ACTN4P2 RNA"
  ],
  "SCGB1C2": [
    "SCGB1C2 CNV",
    "SCGB1C2 RNA"
  ],
  "DBF4": [
    "DBF4 CNV",
    "DBF4 RNA",
    "DBF4 Proteo"
  ],
  "ZNF696": [
    "ZNF696 CNV",
    "ZNF696 RNA",
    "ZNF696 Proteo"
  ],
  "HSF2": [
    "HSF2 CNV",
    "HSF2 RNA",
    "HSF2 Proteo"
  ],
  "PIGCP2": [
    "PIGCP2 CNV",
    "PIGCP2 RNA"
  ],
  "TGFB2": [
    "TGFB2 CNV",
    "TGFB2 RNA",
    "TGFB2 Proteo"
  ],
  "TCP11L2": [
    "TCP11L2 CNV",
    "TCP11L2 RNA",
    "TCP11L2 Proteo"
  ],
  "THAP12P5": [
    "THAP12P5 CNV",
    "THAP12P5 RNA"
  ],
  "DHRS11": [
    "DHRS11 CNV",
    "DHRS11 RNA",
    "DHRS11 Proteo"
  ],
  "PRR11": [
    "PRR11 CNV",
    "PRR11 RNA",
    "PRR11 Proteo"
  ],
  "SLC5A3": [
    "SLC5A3 CNV",
    "SLC5A3 RNA",
    "SLC5A3 Proteo"
  ],
  "SAR1AP1": [
    "SAR1AP1 CNV",
    "SAR1AP1 RNA"
  ],
  "IGHV1-3": [
    "IGHV1-3 Proteo"
  ],
  "RSPH10B2": [
    "RSPH10B2 CNV",
    "RSPH10B2 RNA"
  ],
  "DENND4A": [
    "DENND4A CNV",
    "DENND4A RNA",
    "DENND4A Proteo"
  ],
  "TUBA5P": [
    "TUBA5P CNV",
    "TUBA5P RNA"
  ],
  "NBPF10": [
    "NBPF10 CNV",
    "NBPF10 RNA"
  ],
  "POLR2F": [
    "POLR2F CNV",
    "POLR2F RNA",
    "POLR2F Proteo"
  ],
  "HIGD1AP10": [
    "HIGD1AP10 CNV",
    "HIGD1AP10 RNA"
  ],
  "BAG2": [
    "BAG2 CNV",
    "BAG2 RNA",
    "BAG2 Proteo"
  ],
  "TUBAP1": [
    "TUBAP1 CNV",
    "TUBAP1 RNA"
  ],
  "TPTE2P4": [
    "TPTE2P4 CNV",
    "TPTE2P4 RNA"
  ],
  "ZNF136": [
    "ZNF136 CNV",
    "ZNF136 RNA",
    "ZNF136 Proteo"
  ],
  "MTA3P1": [
    "MTA3P1 CNV",
    "MTA3P1 RNA"
  ],
  "AQP12B": [
    "AQP12B CNV",
    "AQP12B RNA"
  ],
  "NME2": [
    "NME2 CNV",
    "NME2 RNA",
    "NME2 Proteo"
  ],
  "GTF3C6P2": [
    "GTF3C6P2 CNV",
    "GTF3C6P2 RNA"
  ],
  "ZNF593": [
    "ZNF593 CNV",
    "ZNF593 RNA",
    "ZNF593 Proteo"
  ],
  "DNAJC19P4": [
    "DNAJC19P4 CNV",
    "DNAJC19P4 RNA"
  ],
  "SNTG2": [
    "SNTG2 CNV",
    "SNTG2 RNA"
  ],
  "DCAF15": [
    "DCAF15 CNV",
    "DCAF15 RNA",
    "DCAF15 Proteo"
  ],
  "EME2": [
    "EME2 CNV",
    "EME2 RNA"
  ],
  "FAM27B": [
    "FAM27B CNV",
    "FAM27B RNA"
  ],
  "ASB13": [
    "ASB13 CNV",
    "ASB13 RNA"
  ],
  "MLXIPL": [
    "MLXIPL CNV",
    "MLXIPL RNA",
    "MLXIPL Proteo"
  ],
  "CMA1": [
    "CMA1 CNV",
    "CMA1 RNA",
    "CMA1 Proteo"
  ],
  "KCNK1": [
    "KCNK1 CNV",
    "KCNK1 RNA",
    "KCNK1 Proteo"
  ],
  "EPM2A": [
    "EPM2A CNV",
    "EPM2A RNA",
    "EPM2A Proteo"
  ],
  "SCARF2": [
    "SCARF2 CNV",
    "SCARF2 RNA",
    "SCARF2 Proteo"
  ],
  "RNF41": [
    "RNF41 CNV",
    "RNF41 RNA",
    "RNF41 Proteo"
  ],
  "USP17L6P": [
    "USP17L6P CNV",
    "USP17L6P RNA"
  ],
  "PPM1A": [
    "PPM1A CNV",
    "PPM1A RNA",
    "PPM1A Proteo"
  ],
  "YTHDF1P1": [
    "YTHDF1P1 CNV",
    "YTHDF1P1 RNA"
  ],
  "MLEC": [
    "MLEC CNV",
    "MLEC RNA",
    "MLEC Proteo"
  ],
  "TMIGD2": [
    "TMIGD2 CNV",
    "TMIGD2 RNA"
  ],
  "OR8X1P": [
    "OR8X1P CNV",
    "OR8X1P RNA"
  ],
  "CHRDL2": [
    "CHRDL2 CNV",
    "CHRDL2 RNA"
  ],
  "ENPP7P5": [
    "ENPP7P5 CNV",
    "ENPP7P5 RNA"
  ],
  "TRIM3": [
    "TRIM3 CNV",
    "TRIM3 RNA",
    "TRIM3 Proteo"
  ],
  "IL13RA2": [
    "IL13RA2 CNV",
    "IL13RA2 RNA",
    "IL13RA2 Proteo"
  ],
  "KRTCAP3": [
    "KRTCAP3 CNV",
    "KRTCAP3 RNA"
  ],
  "UBTFL11": [
    "UBTFL11 CNV",
    "UBTFL11 RNA"
  ],
  "INSR": [
    "INSR CNV",
    "INSR RNA",
    "INSR Proteo"
  ],
  "SLC25A53": [
    "SLC25A53 CNV",
    "SLC25A53 RNA"
  ],
  "FAM170A": [
    "FAM170A CNV",
    "FAM170A RNA"
  ],
  "PDE6D": [
    "PDE6D CNV",
    "PDE6D RNA",
    "PDE6D Proteo"
  ],
  "IQANK1": [
    "IQANK1 CNV",
    "IQANK1 RNA"
  ],
  "BEND3P1": [
    "BEND3P1 CNV",
    "BEND3P1 RNA"
  ],
  "CNFN": [
    "CNFN CNV",
    "CNFN RNA"
  ],
  "MORF4": [
    "MORF4 CNV",
    "MORF4 RNA"
  ],
  "KRT86": [
    "KRT86 CNV",
    "KRT86 RNA",
    "KRT86 Proteo"
  ],
  "PIM3": [
    "PIM3 CNV",
    "PIM3 RNA"
  ],
  "CC2D1A": [
    "CC2D1A CNV",
    "CC2D1A RNA",
    "CC2D1A Proteo"
  ],
  "SMARCA1": [
    "SMARCA1 CNV",
    "SMARCA1 RNA",
    "SMARCA1 Proteo"
  ],
  "GRK6P1": [
    "GRK6P1 CNV",
    "GRK6P1 RNA"
  ],
  "DACT3": [
    "DACT3 CNV",
    "DACT3 RNA",
    "DACT3 Proteo"
  ],
  "SLC7A7": [
    "SLC7A7 CNV",
    "SLC7A7 RNA",
    "SLC7A7 Proteo"
  ],
  "COX6CP2": [
    "COX6CP2 CNV",
    "COX6CP2 RNA"
  ],
  "OR2AO1P": [
    "OR2AO1P CNV",
    "OR2AO1P RNA"
  ],
  "CYP3A137P": [
    "CYP3A137P CNV",
    "CYP3A137P RNA"
  ],
  "MYL6P3": [
    "MYL6P3 CNV",
    "MYL6P3 RNA"
  ],
  "NUDT4B": [
    "NUDT4B CNV",
    "NUDT4B RNA"
  ],
  "GFRA2": [
    "GFRA2 CNV",
    "GFRA2 RNA",
    "GFRA2 Proteo"
  ],
  "DYNLRB1": [
    "DYNLRB1 CNV",
    "DYNLRB1 RNA",
    "DYNLRB1 Proteo"
  ],
  "NDUFS5P4": [
    "NDUFS5P4 CNV",
    "NDUFS5P4 RNA"
  ],
  "C12orf42": [
    "C12orf42 CNV",
    "C12orf42 RNA"
  ],
  "WBP11": [
    "WBP11 CNV",
    "WBP11 RNA",
    "WBP11 Proteo"
  ],
  "AZGP1": [
    "AZGP1 CNV",
    "AZGP1 RNA",
    "AZGP1 Proteo"
  ],
  "AMPH": [
    "AMPH CNV",
    "AMPH RNA",
    "AMPH Proteo"
  ],
  "MFN1P1": [
    "MFN1P1 CNV",
    "MFN1P1 RNA"
  ],
  "OR13C1P": [
    "OR13C1P CNV",
    "OR13C1P RNA"
  ],
  "CLEC2L": [
    "CLEC2L CNV",
    "CLEC2L RNA"
  ],
  "IGHV3-19": [
    "IGHV3-19 CNV",
    "IGHV3-19 RNA"
  ],
  "ZNF318": [
    "ZNF318 CNV",
    "ZNF318 RNA",
    "ZNF318 Proteo"
  ],
  "FTOP1": [
    "FTOP1 CNV",
    "FTOP1 RNA"
  ],
  "OR7E85P": [
    "OR7E85P CNV",
    "OR7E85P RNA"
  ],
  "TFAP2C": [
    "TFAP2C CNV",
    "TFAP2C RNA",
    "TFAP2C Proteo"
  ],
  "NKX2-1": [
    "NKX2-1 CNV",
    "NKX2-1 RNA",
    "NKX2-1 Proteo"
  ],
  "ST3GAL1P1": [
    "ST3GAL1P1 CNV",
    "ST3GAL1P1 RNA"
  ],
  "TBC1D3P5": [
    "TBC1D3P5 CNV",
    "TBC1D3P5 RNA"
  ],
  "OR7E53P": [
    "OR7E53P CNV",
    "OR7E53P RNA"
  ],
  "PRAMEF9": [
    "PRAMEF9 CNV",
    "PRAMEF9 RNA"
  ],
  "TSPAN10": [
    "TSPAN10 CNV",
    "TSPAN10 RNA",
    "TSPAN10 Proteo"
  ],
  "RPL6P4": [
    "RPL6P4 CNV",
    "RPL6P4 RNA"
  ],
  "TSPY22P": [
    "TSPY22P CNV",
    "TSPY22P RNA"
  ],
  "SUMO2P15": [
    "SUMO2P15 CNV",
    "SUMO2P15 RNA"
  ],
  "SRMP2": [
    "SRMP2 CNV",
    "SRMP2 RNA"
  ],
  "CDK7P1": [
    "CDK7P1 CNV",
    "CDK7P1 RNA"
  ],
  "TBRG1": [
    "TBRG1 CNV",
    "TBRG1 RNA"
  ],
  "NQO1": [
    "NQO1 CNV",
    "NQO1 RNA",
    "NQO1 Proteo"
  ],
  "RASGEF1A": [
    "RASGEF1A CNV",
    "RASGEF1A RNA"
  ],
  "MVP": [
    "MVP CNV",
    "MVP RNA",
    "MVP Proteo"
  ],
  "GREB1": [
    "GREB1 CNV",
    "GREB1 RNA",
    "GREB1 Proteo"
  ],
  "AK2P2": [
    "AK2P2 CNV",
    "AK2P2 RNA"
  ],
  "SPATA18": [
    "SPATA18 CNV",
    "SPATA18 RNA",
    "SPATA18 Proteo"
  ],
  "TMEM169": [
    "TMEM169 CNV",
    "TMEM169 RNA",
    "TMEM169 Proteo"
  ],
  "PCDHGC5": [
    "PCDHGC5 CNV",
    "PCDHGC5 RNA",
    "PCDHGC5 Proteo"
  ],
  "FAM90A19": [
    "FAM90A19 CNV",
    "FAM90A19 RNA"
  ],
  "ARFGAP3": [
    "ARFGAP3 CNV",
    "ARFGAP3 RNA",
    "ARFGAP3 Proteo"
  ],
  "GTF2IP6": [
    "GTF2IP6 CNV",
    "GTF2IP6 RNA"
  ],
  "IQUB": [
    "IQUB CNV",
    "IQUB RNA"
  ],
  "OR1F2P": [
    "OR1F2P CNV",
    "OR1F2P RNA"
  ],
  "PRR3": [
    "PRR3 CNV",
    "PRR3 RNA",
    "PRR3 Proteo"
  ],
  "S1PR5": [
    "S1PR5 CNV",
    "S1PR5 RNA"
  ],
  "UCKL1": [
    "UCKL1 CNV",
    "UCKL1 RNA",
    "UCKL1 Proteo"
  ],
  "CDCA5": [
    "CDCA5 CNV",
    "CDCA5 RNA",
    "CDCA5 Proteo"
  ],
  "ZNF831": [
    "ZNF831 CNV",
    "ZNF831 RNA"
  ],
  "TRIB3": [
    "TRIB3 CNV",
    "TRIB3 RNA"
  ],
  "ARHGAP29": [
    "ARHGAP29 CNV",
    "ARHGAP29 RNA",
    "ARHGAP29 Proteo"
  ],
  "SRPK3": [
    "SRPK3 CNV",
    "SRPK3 RNA"
  ],
  "FCRL6": [
    "FCRL6 CNV",
    "FCRL6 RNA"
  ],
  "DUX4L3": [
    "DUX4L3 CNV",
    "DUX4L3 RNA"
  ],
  "DIO1": [
    "DIO1 CNV",
    "DIO1 RNA"
  ],
  "UNGP1": [
    "UNGP1 CNV",
    "UNGP1 RNA"
  ],
  "GLI2": [
    "GLI2 CNV",
    "GLI2 RNA",
    "GLI2 Proteo"
  ],
  "RPL5P22": [
    "RPL5P22 CNV",
    "RPL5P22 RNA"
  ],
  "DDTP1": [
    "DDTP1 CNV",
    "DDTP1 RNA"
  ],
  "PDCL3P7": [
    "PDCL3P7 CNV",
    "PDCL3P7 RNA"
  ],
  "PHF21B": [
    "PHF21B CNV",
    "PHF21B RNA"
  ],
  "OR4A15": [
    "OR4A15 CNV",
    "OR4A15 RNA"
  ],
  "TMEM250": [
    "TMEM250 CNV",
    "TMEM250 RNA"
  ],
  "CRX": [
    "CRX CNV",
    "CRX RNA"
  ],
  "FRMD4B": [
    "FRMD4B CNV",
    "FRMD4B RNA",
    "FRMD4B Proteo"
  ],
  "CCDC137P": [
    "CCDC137P CNV",
    "CCDC137P RNA"
  ],
  "EIF3I": [
    "EIF3I CNV",
    "EIF3I RNA",
    "EIF3I Proteo"
  ],
  "ILRUNP1": [
    "ILRUNP1 CNV",
    "ILRUNP1 RNA"
  ],
  "IFITM3P3": [
    "IFITM3P3 CNV",
    "IFITM3P3 RNA"
  ],
  "WDR82P1": [
    "WDR82P1 CNV",
    "WDR82P1 RNA"
  ],
  "SLC24A5": [
    "SLC24A5 CNV",
    "SLC24A5 RNA",
    "SLC24A5 Proteo"
  ],
  "TMEM144": [
    "TMEM144 CNV",
    "TMEM144 RNA"
  ],
  "RPL36P7": [
    "RPL36P7 CNV",
    "RPL36P7 RNA"
  ],
  "PGAM1P12": [
    "PGAM1P12 CNV",
    "PGAM1P12 RNA"
  ],
  "RBMY2NP": [
    "RBMY2NP CNV",
    "RBMY2NP RNA"
  ],
  "MRPL51P2": [
    "MRPL51P2 CNV",
    "MRPL51P2 RNA"
  ],
  "GK4P": [
    "GK4P CNV",
    "GK4P RNA"
  ],
  "BBIP1P1": [
    "BBIP1P1 CNV",
    "BBIP1P1 RNA"
  ],
  "PHACTR1": [
    "PHACTR1 CNV",
    "PHACTR1 RNA",
    "PHACTR1 Proteo"
  ],
  "RNF149": [
    "RNF149 CNV",
    "RNF149 RNA",
    "RNF149 Proteo"
  ],
  "SEC23B": [
    "SEC23B CNV",
    "SEC23B RNA",
    "SEC23B Proteo"
  ],
  "CMYA5": [
    "CMYA5 CNV",
    "CMYA5 RNA"
  ],
  "GPR107": [
    "GPR107 CNV",
    "GPR107 RNA",
    "GPR107 Proteo"
  ],
  "HNRNPA1L2": [
    "HNRNPA1L2 CNV",
    "HNRNPA1L2 RNA",
    "HNRNPA1L2 Proteo"
  ],
  "ZSCAN21": [
    "ZSCAN21 CNV",
    "ZSCAN21 RNA",
    "ZSCAN21 Proteo"
  ],
  "RNA5SP76": [
    "RNA5SP76 CNV",
    "RNA5SP76 RNA"
  ],
  "REXO1L12P": [
    "REXO1L12P CNV",
    "REXO1L12P RNA"
  ],
  "MTDHP5": [
    "MTDHP5 CNV",
    "MTDHP5 RNA"
  ],
  "EPC2": [
    "EPC2 CNV",
    "EPC2 RNA",
    "EPC2 Proteo"
  ],
  "ARL5AP1": [
    "ARL5AP1 CNV",
    "ARL5AP1 RNA"
  ],
  "PPIL3": [
    "PPIL3 CNV",
    "PPIL3 RNA",
    "PPIL3 Proteo"
  ],
  "CUBN": [
    "CUBN CNV",
    "CUBN RNA"
  ],
  "AOAH": [
    "AOAH CNV",
    "AOAH RNA",
    "AOAH Proteo"
  ],
  "CCDC163": [
    "CCDC163 CNV",
    "CCDC163 RNA"
  ],
  "ZBTB39": [
    "ZBTB39 CNV",
    "ZBTB39 RNA"
  ],
  "KIDINS220": [
    "KIDINS220 CNV",
    "KIDINS220 RNA",
    "KIDINS220 Proteo"
  ],
  "NMNAT3": [
    "NMNAT3 CNV",
    "NMNAT3 RNA",
    "NMNAT3 Proteo"
  ],
  "KRTAP10-10": [
    "KRTAP10-10 CNV",
    "KRTAP10-10 RNA"
  ],
  "CYCSP4": [
    "CYCSP4 CNV",
    "CYCSP4 RNA"
  ],
  "USP9YP13": [
    "USP9YP13 CNV",
    "USP9YP13 RNA"
  ],
  "AADAC": [
    "AADAC CNV",
    "AADAC RNA",
    "AADAC Proteo"
  ],
  "GIMAP6": [
    "GIMAP6 CNV",
    "GIMAP6 RNA",
    "GIMAP6 Proteo"
  ],
  "N4BP2": [
    "N4BP2 CNV",
    "N4BP2 RNA",
    "N4BP2 Proteo"
  ],
  "CD244": [
    "CD244 CNV",
    "CD244 RNA"
  ],
  "PINLYP": [
    "PINLYP CNV",
    "PINLYP RNA"
  ],
  "YOD1": [
    "YOD1 CNV",
    "YOD1 RNA",
    "YOD1 Proteo"
  ],
  "EIF2AK4": [
    "EIF2AK4 CNV",
    "EIF2AK4 RNA",
    "EIF2AK4 Proteo"
  ],
  "TGM4": [
    "TGM4 CNV",
    "TGM4 RNA"
  ],
  "MYO3B": [
    "MYO3B CNV",
    "MYO3B RNA"
  ],
  "SAMD7": [
    "SAMD7 CNV",
    "SAMD7 RNA"
  ],
  "LAP3P2": [
    "LAP3P2 CNV",
    "LAP3P2 RNA"
  ],
  "PP2D1": [
    "PP2D1 CNV",
    "PP2D1 RNA"
  ],
  "STK35": [
    "STK35 CNV",
    "STK35 RNA",
    "STK35 Proteo"
  ],
  "PRR20E": [
    "PRR20E CNV",
    "PRR20E RNA"
  ],
  "FOXI1": [
    "FOXI1 CNV",
    "FOXI1 RNA"
  ],
  "FCF1": [
    "FCF1 CNV",
    "FCF1 RNA",
    "FCF1 Proteo"
  ],
  "MGLL": [
    "MGLL CNV",
    "MGLL RNA",
    "MGLL Proteo"
  ],
  "CDC42": [
    "CDC42 CNV",
    "CDC42 RNA",
    "CDC42 Proteo"
  ],
  "KCNS3": [
    "KCNS3 CNV",
    "KCNS3 RNA"
  ],
  "MOB1AP1": [
    "MOB1AP1 CNV",
    "MOB1AP1 RNA"
  ],
  "RNA5SP166": [
    "RNA5SP166 CNV",
    "RNA5SP166 RNA"
  ],
  "GYPE": [
    "GYPE CNV",
    "GYPE RNA"
  ],
  "IRF5P1": [
    "IRF5P1 CNV",
    "IRF5P1 RNA"
  ],
  "ENSA": [
    "ENSA CNV",
    "ENSA RNA",
    "ENSA Proteo"
  ],
  "KXD1": [
    "KXD1 CNV",
    "KXD1 RNA",
    "KXD1 Proteo"
  ],
  "STXBP3": [
    "STXBP3 CNV",
    "STXBP3 RNA",
    "STXBP3 Proteo"
  ],
  "STRBP": [
    "STRBP CNV",
    "STRBP RNA",
    "STRBP Proteo"
  ],
  "RPSAP49": [
    "RPSAP49 CNV",
    "RPSAP49 RNA"
  ],
  "GAS2L2": [
    "GAS2L2 CNV",
    "GAS2L2 RNA"
  ],
  "ACAP1": [
    "ACAP1 CNV",
    "ACAP1 RNA",
    "ACAP1 Proteo"
  ],
  "BMF": [
    "BMF CNV",
    "BMF RNA"
  ],
  "IGKV1OR2-11": [
    "IGKV1OR2-11 CNV",
    "IGKV1OR2-11 RNA"
  ],
  "B3GNT2": [
    "B3GNT2 CNV",
    "B3GNT2 RNA",
    "B3GNT2 Proteo"
  ],
  "OXCT1": [
    "OXCT1 CNV",
    "OXCT1 RNA",
    "OXCT1 Proteo"
  ],
  "RPL34P22": [
    "RPL34P22 CNV",
    "RPL34P22 RNA"
  ],
  "P2RY8": [
    "P2RY8 CNV",
    "P2RY8 RNA",
    "P2RY8 Proteo"
  ],
  "SLC25A1": [
    "SLC25A1 CNV",
    "SLC25A1 RNA",
    "SLC25A1 Proteo"
  ],
  "GNS": [
    "GNS CNV",
    "GNS RNA",
    "GNS Proteo"
  ],
  "SUSD6": [
    "SUSD6 CNV",
    "SUSD6 RNA"
  ],
  "RNA5SP253": [
    "RNA5SP253 CNV",
    "RNA5SP253 RNA"
  ],
  "HLA-T": [
    "HLA-T CNV",
    "HLA-T RNA"
  ],
  "OR4A6P": [
    "OR4A6P CNV",
    "OR4A6P RNA"
  ],
  "TMEM190": [
    "TMEM190 CNV",
    "TMEM190 RNA"
  ],
  "DHCR24": [
    "DHCR24 CNV",
    "DHCR24 RNA",
    "DHCR24 Proteo"
  ],
  "MDH1P1": [
    "MDH1P1 CNV",
    "MDH1P1 RNA"
  ],
  "TCAF2P1": [
    "TCAF2P1 CNV",
    "TCAF2P1 RNA"
  ],
  "LBX2": [
    "LBX2 CNV",
    "LBX2 RNA"
  ],
  "C1orf198": [
    "C1orf198 CNV",
    "C1orf198 RNA",
    "C1orf198 Proteo"
  ],
  "ZBTB42": [
    "ZBTB42 CNV",
    "ZBTB42 RNA"
  ],
  "AGAP7P": [
    "AGAP7P CNV",
    "AGAP7P RNA"
  ],
  "ZNF878": [
    "ZNF878 CNV",
    "ZNF878 RNA"
  ],
  "TSEN2P1": [
    "TSEN2P1 CNV",
    "TSEN2P1 RNA"
  ],
  "PLPPR4": [
    "PLPPR4 CNV",
    "PLPPR4 RNA",
    "PLPPR4 Proteo"
  ],
  "TP53BP2": [
    "TP53BP2 CNV",
    "TP53BP2 RNA",
    "TP53BP2 Proteo"
  ],
  "RBFOX1": [
    "RBFOX1 CNV",
    "RBFOX1 RNA"
  ],
  "OR5T1": [
    "OR5T1 CNV",
    "OR5T1 RNA"
  ],
  "SERPING1": [
    "SERPING1 CNV",
    "SERPING1 RNA",
    "SERPING1 Proteo"
  ],
  "RPS2P1": [
    "RPS2P1 CNV",
    "RPS2P1 RNA"
  ],
  "FAM131A": [
    "FAM131A CNV",
    "FAM131A RNA"
  ],
  "RNA5SP329": [
    "RNA5SP329 CNV",
    "RNA5SP329 RNA"
  ],
  "HMGB1P4": [
    "HMGB1P4 CNV",
    "HMGB1P4 RNA"
  ],
  "IDS": [
    "IDS CNV",
    "IDS RNA",
    "IDS Proteo"
  ],
  "GRIA1": [
    "GRIA1 CNV",
    "GRIA1 RNA"
  ],
  "RBMY2GP": [
    "RBMY2GP CNV",
    "RBMY2GP RNA"
  ],
  "VCAM1": [
    "VCAM1 CNV",
    "VCAM1 RNA",
    "VCAM1 Proteo"
  ],
  "C19orf73": [
    "C19orf73 CNV",
    "C19orf73 RNA"
  ],
  "RPS15P9": [
    "RPS15P9 CNV",
    "RPS15P9 RNA"
  ],
  "CD99P1": [
    "CD99P1 CNV",
    "CD99P1 RNA"
  ],
  "SAGE2P": [
    "SAGE2P CNV",
    "SAGE2P RNA"
  ],
  "RPS7": [
    "RPS7 CNV",
    "RPS7 RNA",
    "RPS7 Proteo"
  ],
  "WSB1": [
    "WSB1 CNV",
    "WSB1 RNA",
    "WSB1 Proteo"
  ],
  "MEP1B": [
    "MEP1B CNV",
    "MEP1B RNA"
  ],
  "ATP8A2": [
    "ATP8A2 CNV",
    "ATP8A2 RNA"
  ],
  "HSPB1P2": [
    "HSPB1P2 CNV",
    "HSPB1P2 RNA"
  ],
  "GUCA1A": [
    "GUCA1A CNV",
    "GUCA1A RNA"
  ],
  "HNRNPMP2": [
    "HNRNPMP2 CNV",
    "HNRNPMP2 RNA"
  ],
  "CENPUP2": [
    "CENPUP2 CNV",
    "CENPUP2 RNA"
  ],
  "ALOX12": [
    "ALOX12 CNV",
    "ALOX12 RNA",
    "ALOX12 Proteo"
  ],
  "FXN": [
    "FXN CNV",
    "FXN RNA",
    "FXN Proteo"
  ],
  "AOX3P": [
    "AOX3P CNV",
    "AOX3P RNA"
  ],
  "IGHV3-36": [
    "IGHV3-36 CNV",
    "IGHV3-36 RNA"
  ],
  "FRG1CP": [
    "FRG1CP CNV",
    "FRG1CP RNA"
  ],
  "ZNF165": [
    "ZNF165 CNV",
    "ZNF165 RNA"
  ],
  "GP6": [
    "GP6 CNV",
    "GP6 RNA"
  ],
  "PLD4": [
    "PLD4 CNV",
    "PLD4 RNA",
    "PLD4 Proteo"
  ],
  "CYP21A1P": [
    "CYP21A1P CNV",
    "CYP21A1P RNA"
  ],
  "SERBP1P1": [
    "SERBP1P1 CNV",
    "SERBP1P1 RNA"
  ],
  "VWA8": [
    "VWA8 CNV",
    "VWA8 RNA",
    "VWA8 Proteo"
  ],
  "SNRNP48": [
    "SNRNP48 CNV",
    "SNRNP48 RNA",
    "SNRNP48 Proteo"
  ],
  "TUBB8P8": [
    "TUBB8P8 CNV",
    "TUBB8P8 RNA"
  ],
  "HMGN2P35": [
    "HMGN2P35 CNV",
    "HMGN2P35 RNA"
  ],
  "FOXE3": [
    "FOXE3 CNV",
    "FOXE3 RNA"
  ],
  "IGHV2-5": [
    "IGHV2-5 Proteo"
  ],
  "PPIAP43": [
    "PPIAP43 CNV",
    "PPIAP43 RNA"
  ],
  "CDK1": [
    "CDK1 CNV",
    "CDK1 RNA",
    "CDK1 Proteo"
  ],
  "RAB42P1": [
    "RAB42P1 CNV",
    "RAB42P1 RNA"
  ],
  "RPL35AP22": [
    "RPL35AP22 CNV",
    "RPL35AP22 RNA"
  ],
  "POM121B": [
    "POM121B CNV",
    "POM121B RNA"
  ],
  "IGHVII-60-1": [
    "IGHVII-60-1 CNV",
    "IGHVII-60-1 RNA"
  ],
  "RBMY1KP": [
    "RBMY1KP CNV",
    "RBMY1KP RNA"
  ],
  "NME5": [
    "NME5 CNV",
    "NME5 RNA",
    "NME5 Proteo"
  ],
  "RPL35AP19": [
    "RPL35AP19 CNV",
    "RPL35AP19 RNA"
  ],
  "CEP120": [
    "CEP120 CNV",
    "CEP120 RNA",
    "CEP120 Proteo"
  ],
  "FAM90A12P": [
    "FAM90A12P CNV",
    "FAM90A12P RNA"
  ],
  "LY6G6D": [
    "LY6G6D CNV",
    "LY6G6D RNA"
  ],
  "ASS1P6": [
    "ASS1P6 CNV",
    "ASS1P6 RNA"
  ],
  "RPL35AP31": [
    "RPL35AP31 CNV",
    "RPL35AP31 RNA"
  ],
  "TUBB2B": [
    "TUBB2B CNV",
    "TUBB2B RNA",
    "TUBB2B Proteo"
  ],
  "ZCWPW2": [
    "ZCWPW2 CNV",
    "ZCWPW2 RNA"
  ],
  "DEFB109B": [
    "DEFB109B CNV",
    "DEFB109B RNA"
  ],
  "C1orf109": [
    "C1orf109 CNV",
    "C1orf109 RNA",
    "C1orf109 Proteo"
  ],
  "MRPS25": [
    "MRPS25 CNV",
    "MRPS25 RNA",
    "MRPS25 Proteo"
  ],
  "MEIS3P1": [
    "MEIS3P1 CNV",
    "MEIS3P1 RNA"
  ],
  "RPL36AP38": [
    "RPL36AP38 CNV",
    "RPL36AP38 RNA"
  ],
  "CAND1": [
    "CAND1 CNV",
    "CAND1 RNA",
    "CAND1 Proteo"
  ],
  "GCA": [
    "GCA CNV",
    "GCA RNA",
    "GCA Proteo"
  ],
  "CBR3": [
    "CBR3 CNV",
    "CBR3 RNA",
    "CBR3 Proteo"
  ],
  "DNM1P51": [
    "DNM1P51 CNV",
    "DNM1P51 RNA"
  ],
  "TMEM184C": [
    "TMEM184C CNV",
    "TMEM184C RNA",
    "TMEM184C Proteo"
  ],
  "CENPP": [
    "CENPP CNV",
    "CENPP RNA",
    "CENPP Proteo"
  ],
  "CIPC": [
    "CIPC CNV",
    "CIPC RNA"
  ],
  "HSPD1P4": [
    "HSPD1P4 CNV",
    "HSPD1P4 RNA"
  ],
  "OR6S1": [
    "OR6S1 CNV",
    "OR6S1 RNA"
  ],
  "SLFN14": [
    "SLFN14 CNV",
    "SLFN14 RNA"
  ],
  "CPDP1": [
    "CPDP1 CNV",
    "CPDP1 RNA"
  ],
  "GCM2": [
    "GCM2 CNV",
    "GCM2 RNA"
  ],
  "NPAS1": [
    "NPAS1 CNV",
    "NPAS1 RNA"
  ],
  "KRTAP5-7": [
    "KRTAP5-7 CNV",
    "KRTAP5-7 RNA"
  ],
  "INTS6L": [
    "INTS6L CNV",
    "INTS6L RNA",
    "INTS6L Proteo"
  ],
  "CCNB2P1": [
    "CCNB2P1 CNV",
    "CCNB2P1 RNA"
  ],
  "LRRIQ1": [
    "LRRIQ1 CNV",
    "LRRIQ1 RNA"
  ],
  "RHPN1": [
    "RHPN1 CNV",
    "RHPN1 RNA"
  ],
  "CDCA7": [
    "CDCA7 CNV",
    "CDCA7 RNA",
    "CDCA7 Proteo"
  ],
  "UBE2MP1": [
    "UBE2MP1 CNV",
    "UBE2MP1 RNA"
  ],
  "KRT18P50": [
    "KRT18P50 CNV",
    "KRT18P50 RNA"
  ],
  "ZNF43": [
    "ZNF43 CNV",
    "ZNF43 RNA"
  ],
  "APTX": [
    "APTX CNV",
    "APTX RNA",
    "APTX Proteo"
  ],
  "COL19A1": [
    "COL19A1 CNV",
    "COL19A1 RNA",
    "COL19A1 Proteo"
  ],
  "GTF3C6": [
    "GTF3C6 CNV",
    "GTF3C6 RNA",
    "GTF3C6 Proteo"
  ],
  "HCFC1": [
    "HCFC1 CNV",
    "HCFC1 RNA",
    "HCFC1 Proteo"
  ],
  "GSTA3": [
    "GSTA3 CNV",
    "GSTA3 RNA"
  ],
  "MTND3P2": [
    "MTND3P2 CNV",
    "MTND3P2 RNA"
  ],
  "KIF16B": [
    "KIF16B CNV",
    "KIF16B RNA",
    "KIF16B Proteo"
  ],
  "DPPA5": [
    "DPPA5 CNV",
    "DPPA5 RNA"
  ],
  "REV1": [
    "REV1 CNV",
    "REV1 RNA",
    "REV1 Proteo"
  ],
  "DSTNP4": [
    "DSTNP4 CNV",
    "DSTNP4 RNA"
  ],
  "TGM5": [
    "TGM5 CNV",
    "TGM5 RNA"
  ],
  "ASCL5": [
    "ASCL5 CNV",
    "ASCL5 RNA"
  ],
  "NOL11": [
    "NOL11 CNV",
    "NOL11 RNA",
    "NOL11 Proteo"
  ],
  "SLC2A3": [
    "SLC2A3 CNV",
    "SLC2A3 RNA",
    "SLC2A3 Proteo"
  ],
  "FCER1G": [
    "FCER1G CNV",
    "FCER1G RNA",
    "FCER1G Proteo"
  ],
  "SLC25A21": [
    "SLC25A21 CNV",
    "SLC25A21 RNA",
    "SLC25A21 Proteo"
  ],
  "SLC12A4": [
    "SLC12A4 CNV",
    "SLC12A4 RNA",
    "SLC12A4 Proteo"
  ],
  "KIN": [
    "KIN CNV",
    "KIN RNA",
    "KIN Proteo"
  ],
  "CEP128": [
    "CEP128 CNV",
    "CEP128 RNA",
    "CEP128 Proteo"
  ],
  "SYNDIG1L": [
    "SYNDIG1L CNV",
    "SYNDIG1L RNA"
  ],
  "IL4": [
    "IL4 CNV",
    "IL4 RNA"
  ],
  "KPNA1": [
    "KPNA1 CNV",
    "KPNA1 RNA",
    "KPNA1 Proteo"
  ],
  "DELE1": [
    "DELE1 CNV",
    "DELE1 RNA",
    "DELE1 Proteo"
  ],
  "CLDN19": [
    "CLDN19 CNV",
    "CLDN19 RNA"
  ],
  "ADGRD2": [
    "ADGRD2 CNV",
    "ADGRD2 RNA"
  ],
  "HYI": [
    "HYI CNV",
    "HYI RNA",
    "HYI Proteo"
  ],
  "TRGV7": [
    "TRGV7 CNV",
    "TRGV7 RNA"
  ],
  "INTS5": [
    "INTS5 CNV",
    "INTS5 RNA",
    "INTS5 Proteo"
  ],
  "PSEN2": [
    "PSEN2 CNV",
    "PSEN2 RNA",
    "PSEN2 Proteo"
  ],
  "OR8S1": [
    "OR8S1 CNV",
    "OR8S1 RNA"
  ],
  "MYL6B": [
    "MYL6B CNV",
    "MYL6B RNA",
    "MYL6B Proteo"
  ],
  "WDPCP": [
    "WDPCP CNV",
    "WDPCP RNA"
  ],
  "IFI44L": [
    "IFI44L CNV",
    "IFI44L RNA",
    "IFI44L Proteo"
  ],
  "SRP68P2": [
    "SRP68P2 CNV",
    "SRP68P2 RNA"
  ],
  "TAS2R40": [
    "TAS2R40 CNV",
    "TAS2R40 RNA"
  ],
  "KEL": [
    "KEL CNV",
    "KEL RNA",
    "KEL Proteo"
  ],
  "BRWD1P1": [
    "BRWD1P1 CNV",
    "BRWD1P1 RNA"
  ],
  "SIGMAR1": [
    "SIGMAR1 CNV",
    "SIGMAR1 RNA",
    "SIGMAR1 Proteo"
  ],
  "IZUMO1": [
    "IZUMO1 CNV",
    "IZUMO1 RNA"
  ],
  "DRD5P1": [
    "DRD5P1 CNV",
    "DRD5P1 RNA"
  ],
  "RPL4P2": [
    "RPL4P2 CNV",
    "RPL4P2 RNA"
  ],
  "LSM5": [
    "LSM5 CNV",
    "LSM5 RNA",
    "LSM5 Proteo"
  ],
  "PQBP1": [
    "PQBP1 CNV",
    "PQBP1 RNA",
    "PQBP1 Proteo"
  ],
  "OR7E126P": [
    "OR7E126P CNV",
    "OR7E126P RNA"
  ],
  "DOC2GP": [
    "DOC2GP CNV",
    "DOC2GP RNA"
  ],
  "RNA5SP143": [
    "RNA5SP143 CNV",
    "RNA5SP143 RNA"
  ],
  "POLG2": [
    "POLG2 CNV",
    "POLG2 RNA",
    "POLG2 Proteo"
  ],
  "MRPL58": [
    "MRPL58 CNV",
    "MRPL58 RNA",
    "MRPL58 Proteo"
  ],
  "OR7E22P": [
    "OR7E22P CNV",
    "OR7E22P RNA"
  ],
  "PCDHB10": [
    "PCDHB10 CNV",
    "PCDHB10 RNA"
  ],
  "TTYH2": [
    "TTYH2 CNV",
    "TTYH2 RNA",
    "TTYH2 Proteo"
  ],
  "PABPC4L": [
    "PABPC4L CNV",
    "PABPC4L RNA",
    "PABPC4L Proteo"
  ],
  "DSCAML1": [
    "DSCAML1 CNV",
    "DSCAML1 RNA"
  ],
  "ATP7B": [
    "ATP7B CNV",
    "ATP7B RNA",
    "ATP7B Proteo"
  ],
  "MED13": [
    "MED13 CNV",
    "MED13 RNA",
    "MED13 Proteo"
  ],
  "RNA5SP480": [
    "RNA5SP480 CNV",
    "RNA5SP480 RNA"
  ],
  "BHLHE40": [
    "BHLHE40 CNV",
    "BHLHE40 RNA",
    "BHLHE40 Proteo"
  ],
  "MMUT": [
    "MMUT CNV",
    "MMUT RNA",
    "MMUT Proteo"
  ],
  "MRPL3": [
    "MRPL3 CNV",
    "MRPL3 RNA",
    "MRPL3 Proteo"
  ],
  "PPAN-P2RY11": [
    "PPAN-P2RY11 Proteo"
  ],
  "C12orf76": [
    "C12orf76 CNV",
    "C12orf76 RNA"
  ],
  "STK3": [
    "STK3 CNV",
    "STK3 RNA",
    "STK3 Proteo"
  ],
  "KHDRBS2": [
    "KHDRBS2 CNV",
    "KHDRBS2 RNA",
    "KHDRBS2 Proteo"
  ],
  "PCDH12": [
    "PCDH12 CNV",
    "PCDH12 RNA"
  ],
  "PPP2R5A": [
    "PPP2R5A CNV",
    "PPP2R5A RNA",
    "PPP2R5A Proteo"
  ],
  "RPL39P40": [
    "RPL39P40 CNV",
    "RPL39P40 RNA"
  ],
  "RPS26P45": [
    "RPS26P45 CNV",
    "RPS26P45 RNA"
  ],
  "TFDP1P3": [
    "TFDP1P3 CNV",
    "TFDP1P3 RNA"
  ],
  "PRDX2P4": [
    "PRDX2P4 CNV",
    "PRDX2P4 RNA"
  ],
  "KDM5B": [
    "KDM5B CNV",
    "KDM5B RNA",
    "KDM5B Proteo"
  ],
  "NFIL3": [
    "NFIL3 CNV",
    "NFIL3 RNA",
    "NFIL3 Proteo"
  ],
  "PPIAP89": [
    "PPIAP89 CNV",
    "PPIAP89 RNA"
  ],
  "OR10R3P": [
    "OR10R3P CNV",
    "OR10R3P RNA"
  ],
  "TAGLN": [
    "TAGLN CNV",
    "TAGLN RNA",
    "TAGLN Proteo"
  ],
  "TET2": [
    "TET2 CNV",
    "TET2 RNA",
    "TET2 Proteo"
  ],
  "RPL7P56": [
    "RPL7P56 CNV",
    "RPL7P56 RNA"
  ],
  "RPL18AP7": [
    "RPL18AP7 CNV",
    "RPL18AP7 RNA"
  ],
  "UQCC1": [
    "UQCC1 CNV",
    "UQCC1 RNA",
    "UQCC1 Proteo"
  ],
  "BCAR1P2": [
    "BCAR1P2 CNV",
    "BCAR1P2 RNA"
  ],
  "FZR1": [
    "FZR1 CNV",
    "FZR1 RNA",
    "FZR1 Proteo"
  ],
  "C11orf98P1": [
    "C11orf98P1 CNV",
    "C11orf98P1 RNA"
  ],
  "RNA5SP241": [
    "RNA5SP241 CNV",
    "RNA5SP241 RNA"
  ],
  "MAGEF1": [
    "MAGEF1 CNV",
    "MAGEF1 RNA"
  ],
  "SVOPL": [
    "SVOPL CNV",
    "SVOPL RNA"
  ],
  "OTOF": [
    "OTOF CNV",
    "OTOF RNA"
  ],
  "MYD88": [
    "MYD88 CNV",
    "MYD88 RNA",
    "MYD88 Proteo"
  ],
  "RPL32P22": [
    "RPL32P22 CNV",
    "RPL32P22 RNA"
  ],
  "PRAM1": [
    "PRAM1 CNV",
    "PRAM1 RNA",
    "PRAM1 Proteo"
  ],
  "UGT2B26P": [
    "UGT2B26P CNV",
    "UGT2B26P RNA"
  ],
  "PRDX3": [
    "PRDX3 CNV",
    "PRDX3 RNA",
    "PRDX3 Proteo"
  ],
  "SON": [
    "SON CNV",
    "SON RNA",
    "SON Proteo"
  ],
  "CENPT": [
    "CENPT CNV",
    "CENPT RNA",
    "CENPT Proteo"
  ],
  "ZC2HC1C": [
    "ZC2HC1C CNV",
    "ZC2HC1C RNA"
  ],
  "SERPINA6": [
    "SERPINA6 CNV",
    "SERPINA6 RNA",
    "SERPINA6 Proteo"
  ],
  "SPA17": [
    "SPA17 CNV",
    "SPA17 RNA",
    "SPA17 Proteo"
  ],
  "ECT2L": [
    "ECT2L CNV",
    "ECT2L RNA"
  ],
  "PLA2G3": [
    "PLA2G3 CNV",
    "PLA2G3 RNA"
  ],
  "IGKV3D-7": [
    "IGKV3D-7 Proteo"
  ],
  "PEX1": [
    "PEX1 CNV",
    "PEX1 RNA",
    "PEX1 Proteo"
  ],
  "XKRYP4": [
    "XKRYP4 CNV",
    "XKRYP4 RNA"
  ],
  "IGKV2-10": [
    "IGKV2-10 CNV",
    "IGKV2-10 RNA"
  ],
  "MTND5P18": [
    "MTND5P18 CNV",
    "MTND5P18 RNA"
  ],
  "TPD52": [
    "TPD52 CNV",
    "TPD52 RNA",
    "TPD52 Proteo"
  ],
  "CEP19": [
    "CEP19 CNV",
    "CEP19 RNA"
  ],
  "HELZ2": [
    "HELZ2 CNV",
    "HELZ2 RNA",
    "HELZ2 Proteo"
  ],
  "PFN1P6": [
    "PFN1P6 CNV",
    "PFN1P6 RNA"
  ],
  "MRPL4": [
    "MRPL4 CNV",
    "MRPL4 RNA",
    "MRPL4 Proteo"
  ],
  "PTGES": [
    "PTGES CNV",
    "PTGES RNA",
    "PTGES Proteo"
  ],
  "RHBDF2": [
    "RHBDF2 CNV",
    "RHBDF2 RNA",
    "RHBDF2 Proteo"
  ],
  "KRT18P8": [
    "KRT18P8 CNV",
    "KRT18P8 RNA"
  ],
  "KY": [
    "KY CNV",
    "KY RNA"
  ],
  "BANF1P1": [
    "BANF1P1 CNV",
    "BANF1P1 RNA"
  ],
  "TLR3": [
    "TLR3 CNV",
    "TLR3 RNA",
    "TLR3 Proteo"
  ],
  "TAP1": [
    "TAP1 CNV",
    "TAP1 RNA",
    "TAP1 Proteo"
  ],
  "CSNK1G1": [
    "CSNK1G1 CNV",
    "CSNK1G1 RNA",
    "CSNK1G1 Proteo"
  ],
  "FTSJ3": [
    "FTSJ3 CNV",
    "FTSJ3 RNA",
    "FTSJ3 Proteo"
  ],
  "PDE12": [
    "PDE12 CNV",
    "PDE12 RNA",
    "PDE12 Proteo"
  ],
  "NRK": [
    "NRK CNV",
    "NRK RNA"
  ],
  "HSP90AA4P": [
    "HSP90AA4P CNV",
    "HSP90AA4P RNA"
  ],
  "NXPH4": [
    "NXPH4 CNV",
    "NXPH4 RNA",
    "NXPH4 Proteo"
  ],
  "FUS": [
    "FUS CNV",
    "FUS RNA",
    "FUS Proteo"
  ],
  "CIART": [
    "CIART CNV",
    "CIART RNA"
  ],
  "TYW1": [
    "TYW1 CNV",
    "TYW1 RNA",
    "TYW1 Proteo"
  ],
  "NCOA4P3": [
    "NCOA4P3 CNV",
    "NCOA4P3 RNA"
  ],
  "IGHV1-12": [
    "IGHV1-12 CNV",
    "IGHV1-12 RNA"
  ],
  "RBM25": [
    "RBM25 CNV",
    "RBM25 RNA",
    "RBM25 Proteo"
  ],
  "DDX31": [
    "DDX31 CNV",
    "DDX31 RNA",
    "DDX31 Proteo"
  ],
  "CNDP1": [
    "CNDP1 CNV",
    "CNDP1 RNA",
    "CNDP1 Proteo"
  ],
  "NDUFB4P6": [
    "NDUFB4P6 CNV",
    "NDUFB4P6 RNA"
  ],
  "LRRC8A": [
    "LRRC8A CNV",
    "LRRC8A RNA",
    "LRRC8A Proteo"
  ],
  "RPS17P1": [
    "RPS17P1 CNV",
    "RPS17P1 RNA"
  ],
  "DNAJA1": [
    "DNAJA1 CNV",
    "DNAJA1 RNA",
    "DNAJA1 Proteo"
  ],
  "KIAA0895": [
    "KIAA0895 CNV",
    "KIAA0895 RNA"
  ],
  "SHISAL2A": [
    "SHISAL2A CNV",
    "SHISAL2A RNA"
  ],
  "TRIM39": [
    "TRIM39 CNV",
    "TRIM39 RNA"
  ],
  "CCL25": [
    "CCL25 CNV",
    "CCL25 RNA"
  ],
  "ZNF154": [
    "ZNF154 CNV",
    "ZNF154 RNA"
  ],
  "ADGRL2": [
    "ADGRL2 CNV",
    "ADGRL2 RNA",
    "ADGRL2 Proteo"
  ],
  "ACRV1": [
    "ACRV1 CNV",
    "ACRV1 RNA"
  ],
  "TRARG1": [
    "TRARG1 CNV",
    "TRARG1 RNA",
    "TRARG1 Proteo"
  ],
  "CCL22": [
    "CCL22 CNV",
    "CCL22 RNA"
  ],
  "TNFAIP8L3": [
    "TNFAIP8L3 CNV",
    "TNFAIP8L3 RNA",
    "TNFAIP8L3 Proteo"
  ],
  "RPS15AP15": [
    "RPS15AP15 CNV",
    "RPS15AP15 RNA"
  ],
  "KMT5A": [
    "KMT5A CNV",
    "KMT5A RNA",
    "KMT5A Proteo"
  ],
  "SIGLEC15": [
    "SIGLEC15 CNV",
    "SIGLEC15 RNA"
  ],
  "RALBP1P2": [
    "RALBP1P2 CNV",
    "RALBP1P2 RNA"
  ],
  "KRTAP4-1": [
    "KRTAP4-1 CNV",
    "KRTAP4-1 RNA"
  ],
  "H2BC11": [
    "H2BC11 CNV",
    "H2BC11 RNA",
    "H2BC11 Proteo"
  ],
  "HMGB1P6": [
    "HMGB1P6 CNV",
    "HMGB1P6 RNA"
  ],
  "EEF1A1P41": [
    "EEF1A1P41 CNV",
    "EEF1A1P41 RNA"
  ],
  "HAO2": [
    "HAO2 CNV",
    "HAO2 RNA",
    "HAO2 Proteo"
  ],
  "GP2": [
    "GP2 CNV",
    "GP2 RNA",
    "GP2 Proteo"
  ],
  "SPRY4": [
    "SPRY4 CNV",
    "SPRY4 RNA",
    "SPRY4 Proteo"
  ],
  "TCF20": [
    "TCF20 CNV",
    "TCF20 RNA",
    "TCF20 Proteo"
  ],
  "ACTR3BP4": [
    "ACTR3BP4 CNV",
    "ACTR3BP4 RNA"
  ],
  "ZNF29P": [
    "ZNF29P CNV",
    "ZNF29P RNA"
  ],
  "CBX3P3": [
    "CBX3P3 CNV",
    "CBX3P3 RNA"
  ],
  "KRTAP10-5": [
    "KRTAP10-5 CNV",
    "KRTAP10-5 RNA"
  ],
  "LAMP3": [
    "LAMP3 CNV",
    "LAMP3 RNA",
    "LAMP3 Proteo"
  ],
  "GZMAP1": [
    "GZMAP1 CNV",
    "GZMAP1 RNA"
  ],
  "TTLL6": [
    "TTLL6 CNV",
    "TTLL6 RNA"
  ],
  "GNB4": [
    "GNB4 CNV",
    "GNB4 RNA",
    "GNB4 Proteo"
  ],
  "DOLK": [
    "DOLK CNV",
    "DOLK RNA",
    "DOLK Proteo"
  ],
  "RPS2P32": [
    "RPS2P32 CNV",
    "RPS2P32 RNA"
  ],
  "KRTAP12-2": [
    "KRTAP12-2 CNV",
    "KRTAP12-2 RNA"
  ],
  "SUMO2P2": [
    "SUMO2P2 CNV",
    "SUMO2P2 RNA"
  ],
  "ERG": [
    "ERG CNV",
    "ERG RNA",
    "ERG Proteo"
  ],
  "PTOV1": [
    "PTOV1 CNV",
    "PTOV1 RNA",
    "PTOV1 Proteo"
  ],
  "PUDPP1": [
    "PUDPP1 CNV",
    "PUDPP1 RNA"
  ],
  "SPTBN4": [
    "SPTBN4 CNV",
    "SPTBN4 RNA",
    "SPTBN4 Proteo"
  ],
  "DYNAPP1": [
    "DYNAPP1 CNV",
    "DYNAPP1 RNA"
  ],
  "SMIM3": [
    "SMIM3 CNV",
    "SMIM3 RNA"
  ],
  "CCR12P": [
    "CCR12P CNV",
    "CCR12P RNA"
  ],
  "SLC35G6": [
    "SLC35G6 CNV",
    "SLC35G6 RNA"
  ],
  "ENO1": [
    "ENO1 CNV",
    "ENO1 RNA",
    "ENO1 Proteo"
  ],
  "ZCCHC24": [
    "ZCCHC24 CNV",
    "ZCCHC24 RNA",
    "ZCCHC24 Proteo"
  ],
  "CNN2P2": [
    "CNN2P2 CNV",
    "CNN2P2 RNA"
  ],
  "HAGH": [
    "HAGH CNV",
    "HAGH RNA",
    "HAGH Proteo"
  ],
  "TSSK4": [
    "TSSK4 CNV",
    "TSSK4 RNA"
  ],
  "RAD23BP2": [
    "RAD23BP2 CNV",
    "RAD23BP2 RNA"
  ],
  "GAB1": [
    "GAB1 CNV",
    "GAB1 RNA",
    "GAB1 Proteo"
  ],
  "EEF1A1P32": [
    "EEF1A1P32 CNV",
    "EEF1A1P32 RNA"
  ],
  "UQCRHP4": [
    "UQCRHP4 CNV",
    "UQCRHP4 RNA"
  ],
  "SAMD11": [
    "SAMD11 CNV",
    "SAMD11 RNA"
  ],
  "MTATP6P9": [
    "MTATP6P9 CNV",
    "MTATP6P9 RNA"
  ],
  "TUBBP8": [
    "TUBBP8 CNV",
    "TUBBP8 RNA"
  ],
  "LGALS7B": [
    "LGALS7B CNV",
    "LGALS7B RNA",
    "LGALS7B Proteo"
  ],
  "FCHSD2": [
    "FCHSD2 CNV",
    "FCHSD2 RNA",
    "FCHSD2 Proteo"
  ],
  "PCYT1A": [
    "PCYT1A CNV",
    "PCYT1A RNA",
    "PCYT1A Proteo"
  ],
  "AFG3L1P": [
    "AFG3L1P CNV",
    "AFG3L1P RNA"
  ],
  "OR5BR1P": [
    "OR5BR1P CNV",
    "OR5BR1P RNA"
  ],
  "FAM207CP": [
    "FAM207CP CNV",
    "FAM207CP RNA"
  ],
  "NAP1L1P1": [
    "NAP1L1P1 CNV",
    "NAP1L1P1 RNA"
  ],
  "TRMT2A": [
    "TRMT2A CNV",
    "TRMT2A RNA",
    "TRMT2A Proteo"
  ],
  "MMP28": [
    "MMP28 CNV",
    "MMP28 RNA"
  ],
  "RAB11FIP5": [
    "RAB11FIP5 CNV",
    "RAB11FIP5 RNA",
    "RAB11FIP5 Proteo"
  ],
  "CLPSL2": [
    "CLPSL2 CNV",
    "CLPSL2 RNA"
  ],
  "JAM2": [
    "JAM2 CNV",
    "JAM2 RNA"
  ],
  "OR1K1": [
    "OR1K1 CNV",
    "OR1K1 RNA"
  ],
  "ADAM18": [
    "ADAM18 CNV",
    "ADAM18 RNA"
  ],
  "HMGB3P14": [
    "HMGB3P14 CNV",
    "HMGB3P14 RNA"
  ],
  "PLXNA2": [
    "PLXNA2 CNV",
    "PLXNA2 RNA",
    "PLXNA2 Proteo"
  ],
  "TMEM251": [
    "TMEM251 CNV",
    "TMEM251 RNA",
    "TMEM251 Proteo"
  ],
  "MTCO2P21": [
    "MTCO2P21 CNV",
    "MTCO2P21 RNA"
  ],
  "RNA5SP352": [
    "RNA5SP352 CNV",
    "RNA5SP352 RNA"
  ],
  "UBD": [
    "UBD CNV",
    "UBD RNA"
  ],
  "GRN": [
    "GRN CNV",
    "GRN RNA",
    "GRN Proteo"
  ],
  "PROX1": [
    "PROX1 CNV",
    "PROX1 RNA",
    "PROX1 Proteo"
  ],
  "OLA1P1": [
    "OLA1P1 CNV",
    "OLA1P1 RNA"
  ],
  "DDX20": [
    "DDX20 CNV",
    "DDX20 RNA",
    "DDX20 Proteo"
  ],
  "NPAP1P3": [
    "NPAP1P3 CNV",
    "NPAP1P3 RNA"
  ],
  "SSBP1": [
    "SSBP1 CNV",
    "SSBP1 RNA",
    "SSBP1 Proteo"
  ],
  "CCZ1P1": [
    "CCZ1P1 CNV",
    "CCZ1P1 RNA"
  ],
  "RPS27AP1": [
    "RPS27AP1 CNV",
    "RPS27AP1 RNA"
  ],
  "POLN": [
    "POLN CNV",
    "POLN RNA"
  ],
  "WRNIP1": [
    "WRNIP1 CNV",
    "WRNIP1 RNA",
    "WRNIP1 Proteo"
  ],
  "PPP1R21": [
    "PPP1R21 CNV",
    "PPP1R21 RNA",
    "PPP1R21 Proteo"
  ],
  "ODF3L1": [
    "ODF3L1 CNV",
    "ODF3L1 RNA"
  ],
  "R3HDML": [
    "R3HDML CNV",
    "R3HDML RNA"
  ],
  "AAMP": [
    "AAMP CNV",
    "AAMP RNA",
    "AAMP Proteo"
  ],
  "UBB": [
    "UBB CNV",
    "UBB RNA"
  ],
  "KDELR2": [
    "KDELR2 CNV",
    "KDELR2 RNA"
  ],
  "C20orf96": [
    "C20orf96 CNV",
    "C20orf96 RNA"
  ],
  "SUCLA2P3": [
    "SUCLA2P3 CNV",
    "SUCLA2P3 RNA"
  ],
  "FGFR3": [
    "FGFR3 CNV",
    "FGFR3 RNA"
  ],
  "HNRNPA3": [
    "HNRNPA3 CNV",
    "HNRNPA3 RNA",
    "HNRNPA3 Proteo"
  ],
  "ZNF578": [
    "ZNF578 CNV",
    "ZNF578 RNA"
  ],
  "ACVRL1": [
    "ACVRL1 CNV",
    "ACVRL1 RNA",
    "ACVRL1 Proteo"
  ],
  "MED28P8": [
    "MED28P8 CNV",
    "MED28P8 RNA"
  ],
  "MTHFD2P4": [
    "MTHFD2P4 CNV",
    "MTHFD2P4 RNA"
  ],
  "PPARG": [
    "PPARG CNV",
    "PPARG RNA"
  ],
  "BCL2L10": [
    "BCL2L10 CNV",
    "BCL2L10 RNA"
  ],
  "PHF8": [
    "PHF8 CNV",
    "PHF8 RNA",
    "PHF8 Proteo"
  ],
  "TRAV33": [
    "TRAV33 CNV",
    "TRAV33 RNA"
  ],
  "HMGB3P27": [
    "HMGB3P27 CNV",
    "HMGB3P27 RNA"
  ],
  "PPBPP1": [
    "PPBPP1 CNV",
    "PPBPP1 RNA"
  ],
  "PRPF40A": [
    "PRPF40A CNV",
    "PRPF40A RNA",
    "PRPF40A Proteo"
  ],
  "IGHV1-18": [
    "IGHV1-18 Proteo"
  ],
  "OR10G3": [
    "OR10G3 CNV",
    "OR10G3 RNA"
  ],
  "SACS": [
    "SACS CNV",
    "SACS RNA",
    "SACS Proteo"
  ],
  "PRELID2": [
    "PRELID2 CNV",
    "PRELID2 RNA"
  ],
  "TBX2": [
    "TBX2 CNV",
    "TBX2 RNA",
    "TBX2 Proteo"
  ],
  "MTCO1P54": [
    "MTCO1P54 CNV",
    "MTCO1P54 RNA"
  ],
  "YAP1P2": [
    "YAP1P2 CNV",
    "YAP1P2 RNA"
  ],
  "XDH": [
    "XDH CNV",
    "XDH RNA",
    "XDH Proteo"
  ],
  "ARMC10": [
    "ARMC10 CNV",
    "ARMC10 RNA",
    "ARMC10 Proteo"
  ],
  "EIF4A3P1": [
    "EIF4A3P1 CNV",
    "EIF4A3P1 RNA"
  ],
  "CCNYL3": [
    "CCNYL3 CNV",
    "CCNYL3 RNA"
  ],
  "OOSP4A": [
    "OOSP4A CNV",
    "OOSP4A RNA"
  ],
  "ADGRA2": [
    "ADGRA2 CNV",
    "ADGRA2 RNA",
    "ADGRA2 Proteo"
  ],
  "KCNJ18": [
    "KCNJ18 CNV",
    "KCNJ18 RNA"
  ],
  "ODAD2": [
    "ODAD2 CNV",
    "ODAD2 RNA"
  ],
  "DHX15": [
    "DHX15 CNV",
    "DHX15 RNA",
    "DHX15 Proteo"
  ],
  "OLFM5P": [
    "OLFM5P CNV",
    "OLFM5P RNA"
  ],
  "CFL2": [
    "CFL2 CNV",
    "CFL2 RNA",
    "CFL2 Proteo"
  ],
  "SCIMP": [
    "SCIMP CNV",
    "SCIMP RNA"
  ],
  "C1QL2": [
    "C1QL2 CNV",
    "C1QL2 RNA"
  ],
  "MAP3K19": [
    "MAP3K19 CNV",
    "MAP3K19 RNA"
  ],
  "RBMS3": [
    "RBMS3 CNV",
    "RBMS3 RNA",
    "RBMS3 Proteo"
  ],
  "FOXD4L5": [
    "FOXD4L5 CNV",
    "FOXD4L5 RNA"
  ],
  "ZCRB1P1": [
    "ZCRB1P1 CNV",
    "ZCRB1P1 RNA"
  ],
  "FKBP9P1": [
    "FKBP9P1 CNV",
    "FKBP9P1 RNA"
  ],
  "PTPN9": [
    "PTPN9 CNV",
    "PTPN9 RNA",
    "PTPN9 Proteo"
  ],
  "PCP2": [
    "PCP2 CNV",
    "PCP2 RNA"
  ],
  "YWHAQP8": [
    "YWHAQP8 CNV",
    "YWHAQP8 RNA"
  ],
  "CAMSAP2": [
    "CAMSAP2 CNV",
    "CAMSAP2 RNA",
    "CAMSAP2 Proteo"
  ],
  "NEO1": [
    "NEO1 CNV",
    "NEO1 RNA",
    "NEO1 Proteo"
  ],
  "RAI2": [
    "RAI2 CNV",
    "RAI2 RNA"
  ],
  "CLDN14": [
    "CLDN14 CNV",
    "CLDN14 RNA"
  ],
  "ANXA2": [
    "ANXA2 CNV",
    "ANXA2 RNA",
    "ANXA2 Proteo"
  ],
  "ALDH9A1": [
    "ALDH9A1 CNV",
    "ALDH9A1 RNA",
    "ALDH9A1 Proteo"
  ],
  "TMEM199": [
    "TMEM199 CNV",
    "TMEM199 RNA",
    "TMEM199 Proteo"
  ],
  "C1orf226": [
    "C1orf226 CNV",
    "C1orf226 RNA",
    "C1orf226 Proteo"
  ],
  "MED24": [
    "MED24 CNV",
    "MED24 RNA",
    "MED24 Proteo"
  ],
  "ST3GAL2": [
    "ST3GAL2 CNV",
    "ST3GAL2 RNA",
    "ST3GAL2 Proteo"
  ],
  "RPS20P2": [
    "RPS20P2 CNV",
    "RPS20P2 RNA"
  ],
  "RPL29P23": [
    "RPL29P23 CNV",
    "RPL29P23 RNA"
  ],
  "UBR7": [
    "UBR7 CNV",
    "UBR7 RNA",
    "UBR7 Proteo"
  ],
  "ATP5MGP7": [
    "ATP5MGP7 CNV",
    "ATP5MGP7 RNA"
  ],
  "AKAP13": [
    "AKAP13 CNV",
    "AKAP13 RNA",
    "AKAP13 Proteo"
  ],
  "PRUNEP1": [
    "PRUNEP1 CNV",
    "PRUNEP1 RNA"
  ],
  "RNPEP": [
    "RNPEP CNV",
    "RNPEP RNA",
    "RNPEP Proteo"
  ],
  "SDR16C6P": [
    "SDR16C6P CNV",
    "SDR16C6P RNA"
  ],
  "ZC3HAV1L": [
    "ZC3HAV1L CNV",
    "ZC3HAV1L RNA",
    "ZC3HAV1L Proteo"
  ],
  "NTAN1P1": [
    "NTAN1P1 CNV",
    "NTAN1P1 RNA"
  ],
  "ADGRD1": [
    "ADGRD1 CNV",
    "ADGRD1 RNA"
  ],
  "DPPA3": [
    "DPPA3 CNV",
    "DPPA3 RNA"
  ],
  "LCN15": [
    "LCN15 CNV",
    "LCN15 RNA"
  ],
  "HOXC12": [
    "HOXC12 CNV",
    "HOXC12 RNA"
  ],
  "TRIM47": [
    "TRIM47 CNV",
    "TRIM47 RNA",
    "TRIM47 Proteo"
  ],
  "GPR78": [
    "GPR78 CNV",
    "GPR78 RNA"
  ],
  "GMCL1": [
    "GMCL1 CNV",
    "GMCL1 RNA",
    "GMCL1 Proteo"
  ],
  "PAK6": [
    "PAK6 CNV",
    "PAK6 RNA"
  ],
  "CENPBD1P": [
    "CENPBD1P CNV",
    "CENPBD1P RNA"
  ],
  "RSL24D1P5": [
    "RSL24D1P5 CNV",
    "RSL24D1P5 RNA"
  ],
  "PFKFB4": [
    "PFKFB4 CNV",
    "PFKFB4 RNA",
    "PFKFB4 Proteo"
  ],
  "TLX2": [
    "TLX2 CNV",
    "TLX2 RNA"
  ],
  "HBG2": [
    "HBG2 CNV",
    "HBG2 RNA",
    "HBG2 Proteo"
  ],
  "TRBV8-2": [
    "TRBV8-2 CNV",
    "TRBV8-2 RNA"
  ],
  "NACA": [
    "NACA CNV",
    "NACA RNA",
    "NACA Proteo"
  ],
  "GARIN1B": [
    "GARIN1B CNV",
    "GARIN1B RNA"
  ],
  "CDR2L": [
    "CDR2L CNV",
    "CDR2L RNA",
    "CDR2L Proteo"
  ],
  "TSPO2": [
    "TSPO2 CNV",
    "TSPO2 RNA"
  ],
  "OR10R1P": [
    "OR10R1P CNV",
    "OR10R1P RNA"
  ],
  "ERVH48-1": [
    "ERVH48-1 CNV",
    "ERVH48-1 RNA"
  ],
  "NCOA2": [
    "NCOA2 CNV",
    "NCOA2 RNA",
    "NCOA2 Proteo"
  ],
  "NKX2-5": [
    "NKX2-5 CNV",
    "NKX2-5 RNA"
  ],
  "YRDC": [
    "YRDC CNV",
    "YRDC RNA",
    "YRDC Proteo"
  ],
  "VTN": [
    "VTN CNV",
    "VTN RNA",
    "VTN Proteo"
  ],
  "FXR1": [
    "FXR1 CNV",
    "FXR1 RNA",
    "FXR1 Proteo"
  ],
  "XKRYP5": [
    "XKRYP5 CNV",
    "XKRYP5 RNA"
  ],
  "RAB14": [
    "RAB14 CNV",
    "RAB14 RNA",
    "RAB14 Proteo"
  ],
  "FCRL1": [
    "FCRL1 CNV",
    "FCRL1 RNA"
  ],
  "ELMOD2": [
    "ELMOD2 CNV",
    "ELMOD2 RNA",
    "ELMOD2 Proteo"
  ],
  "SIGLEC8": [
    "SIGLEC8 CNV",
    "SIGLEC8 RNA",
    "SIGLEC8 Proteo"
  ],
  "NTAN1P3": [
    "NTAN1P3 CNV",
    "NTAN1P3 RNA"
  ],
  "BCAT2": [
    "BCAT2 CNV",
    "BCAT2 RNA",
    "BCAT2 Proteo"
  ],
  "RPS4XP14": [
    "RPS4XP14 CNV",
    "RPS4XP14 RNA"
  ],
  "GUSBP3": [
    "GUSBP3 CNV",
    "GUSBP3 RNA"
  ],
  "TRPM3": [
    "TRPM3 CNV",
    "TRPM3 RNA"
  ],
  "WASH2P": [
    "WASH2P CNV",
    "WASH2P RNA"
  ],
  "PNMT": [
    "PNMT CNV",
    "PNMT RNA"
  ],
  "NSMCE3": [
    "NSMCE3 CNV",
    "NSMCE3 RNA",
    "NSMCE3 Proteo"
  ],
  "ELK2AP": [
    "ELK2AP CNV",
    "ELK2AP RNA"
  ],
  "FAM21FP": [
    "FAM21FP CNV",
    "FAM21FP RNA"
  ],
  "OR8D1": [
    "OR8D1 CNV",
    "OR8D1 RNA"
  ],
  "DNAJB6P3": [
    "DNAJB6P3 CNV",
    "DNAJB6P3 RNA"
  ],
  "CTNND1": [
    "CTNND1 CNV",
    "CTNND1 RNA",
    "CTNND1 Proteo"
  ],
  "RFC1": [
    "RFC1 CNV",
    "RFC1 RNA",
    "RFC1 Proteo"
  ],
  "RAB21": [
    "RAB21 CNV",
    "RAB21 RNA",
    "RAB21 Proteo"
  ],
  "FAM90A25P": [
    "FAM90A25P CNV",
    "FAM90A25P RNA"
  ],
  "RPL23AP59": [
    "RPL23AP59 CNV",
    "RPL23AP59 RNA"
  ],
  "RAB39A": [
    "RAB39A CNV",
    "RAB39A RNA",
    "RAB39A Proteo"
  ],
  "DTNBP1": [
    "DTNBP1 CNV",
    "DTNBP1 RNA",
    "DTNBP1 Proteo"
  ],
  "CHRNA7": [
    "CHRNA7 CNV",
    "CHRNA7 RNA"
  ],
  "PCDH11Y": [
    "PCDH11Y CNV",
    "PCDH11Y RNA"
  ],
  "IGKV1OR9-1": [
    "IGKV1OR9-1 CNV",
    "IGKV1OR9-1 RNA"
  ],
  "ZNF251": [
    "ZNF251 CNV",
    "ZNF251 RNA",
    "ZNF251 Proteo"
  ],
  "IL1RAPL2": [
    "IL1RAPL2 CNV",
    "IL1RAPL2 RNA"
  ],
  "SPESP1": [
    "SPESP1 CNV",
    "SPESP1 RNA"
  ],
  "RRM2P4": [
    "RRM2P4 CNV",
    "RRM2P4 RNA"
  ],
  "ABHD11-AS1": [
    "ABHD11-AS1 CNV",
    "ABHD11-AS1 RNA"
  ],
  "PMM1": [
    "PMM1 CNV",
    "PMM1 RNA",
    "PMM1 Proteo"
  ],
  "IRX5": [
    "IRX5 CNV",
    "IRX5 RNA",
    "IRX5 Proteo"
  ],
  "PRLHR": [
    "PRLHR CNV",
    "PRLHR RNA"
  ],
  "PTEN": [
    "PTEN CNV",
    "PTEN RNA",
    "PTEN Proteo"
  ],
  "CALCOCO1": [
    "CALCOCO1 CNV",
    "CALCOCO1 RNA",
    "CALCOCO1 Proteo"
  ],
  "GOLGA8UP": [
    "GOLGA8UP CNV",
    "GOLGA8UP RNA"
  ],
  "ISCA1P4": [
    "ISCA1P4 CNV",
    "ISCA1P4 RNA"
  ],
  "POU5F1P3": [
    "POU5F1P3 CNV",
    "POU5F1P3 RNA"
  ],
  "SLC25A1P2": [
    "SLC25A1P2 CNV",
    "SLC25A1P2 RNA"
  ],
  "CSF2": [
    "CSF2 CNV",
    "CSF2 RNA"
  ],
  "KLRG1": [
    "KLRG1 CNV",
    "KLRG1 RNA"
  ],
  "INSM1": [
    "INSM1 CNV",
    "INSM1 RNA"
  ],
  "SLC25A48": [
    "SLC25A48 CNV",
    "SLC25A48 RNA"
  ],
  "PRELID1P2": [
    "PRELID1P2 CNV",
    "PRELID1P2 RNA"
  ],
  "RANBP1P1": [
    "RANBP1P1 CNV",
    "RANBP1P1 RNA"
  ],
  "BAD": [
    "BAD CNV",
    "BAD RNA",
    "BAD Proteo"
  ],
  "DNMT3L": [
    "DNMT3L CNV",
    "DNMT3L RNA"
  ],
  "FOXP2": [
    "FOXP2 CNV",
    "FOXP2 RNA"
  ],
  "SLC6A11": [
    "SLC6A11 CNV",
    "SLC6A11 RNA"
  ],
  "MRPL32P1": [
    "MRPL32P1 CNV",
    "MRPL32P1 RNA"
  ],
  "CCDC124": [
    "CCDC124 CNV",
    "CCDC124 RNA",
    "CCDC124 Proteo"
  ],
  "UBA52P7": [
    "UBA52P7 CNV",
    "UBA52P7 RNA"
  ],
  "ACTG1P25": [
    "ACTG1P25 CNV",
    "ACTG1P25 RNA"
  ],
  "CLPTM1LP1": [
    "CLPTM1LP1 CNV",
    "CLPTM1LP1 RNA"
  ],
  "ATP6V0D1": [
    "ATP6V0D1 CNV",
    "ATP6V0D1 RNA",
    "ATP6V0D1 Proteo"
  ],
  "HSD17B1": [
    "HSD17B1 CNV",
    "HSD17B1 RNA",
    "HSD17B1 Proteo"
  ],
  "BIRC6-AS2": [
    "BIRC6-AS2 CNV",
    "BIRC6-AS2 RNA"
  ],
  "ILDR1": [
    "ILDR1 CNV",
    "ILDR1 RNA",
    "ILDR1 Proteo"
  ],
  "MCRIP2P1": [
    "MCRIP2P1 CNV",
    "MCRIP2P1 RNA"
  ],
  "MTCYBP37": [
    "MTCYBP37 CNV",
    "MTCYBP37 RNA"
  ],
  "MARK3P3": [
    "MARK3P3 CNV",
    "MARK3P3 RNA"
  ],
  "KCNS2": [
    "KCNS2 CNV",
    "KCNS2 RNA"
  ],
  "VN1R68P": [
    "VN1R68P CNV",
    "VN1R68P RNA"
  ],
  "ARHGAP9": [
    "ARHGAP9 CNV",
    "ARHGAP9 RNA",
    "ARHGAP9 Proteo"
  ],
  "SPATA22": [
    "SPATA22 CNV",
    "SPATA22 RNA"
  ],
  "CLDN25": [
    "CLDN25 CNV",
    "CLDN25 RNA"
  ],
  "CLEC4M": [
    "CLEC4M CNV",
    "CLEC4M RNA",
    "CLEC4M Proteo"
  ],
  "CCDC117": [
    "CCDC117 CNV",
    "CCDC117 RNA",
    "CCDC117 Proteo"
  ],
  "CNTRL": [
    "CNTRL CNV",
    "CNTRL RNA",
    "CNTRL Proteo"
  ],
  "CEP78": [
    "CEP78 CNV",
    "CEP78 RNA",
    "CEP78 Proteo"
  ],
  "INAFM2": [
    "INAFM2 CNV",
    "INAFM2 RNA"
  ],
  "ZNF799": [
    "ZNF799 CNV",
    "ZNF799 RNA"
  ],
  "SLC25A15P5": [
    "SLC25A15P5 CNV",
    "SLC25A15P5 RNA"
  ],
  "HLA-Z": [
    "HLA-Z CNV",
    "HLA-Z RNA"
  ],
  "NRM": [
    "NRM CNV",
    "NRM RNA",
    "NRM Proteo"
  ],
  "BOLA1": [
    "BOLA1 CNV",
    "BOLA1 RNA",
    "BOLA1 Proteo"
  ],
  "SPIN2A": [
    "SPIN2A CNV",
    "SPIN2A RNA"
  ],
  "CLEC4G": [
    "CLEC4G CNV",
    "CLEC4G RNA",
    "CLEC4G Proteo"
  ],
  "ARHGEF19": [
    "ARHGEF19 CNV",
    "ARHGEF19 RNA"
  ],
  "CTSA": [
    "CTSA CNV",
    "CTSA RNA",
    "CTSA Proteo"
  ],
  "HADHB": [
    "HADHB CNV",
    "HADHB RNA",
    "HADHB Proteo"
  ],
  "PCDHGA9": [
    "PCDHGA9 CNV",
    "PCDHGA9 RNA"
  ],
  "SV2A": [
    "SV2A CNV",
    "SV2A RNA",
    "SV2A Proteo"
  ],
  "CRAT": [
    "CRAT CNV",
    "CRAT RNA",
    "CRAT Proteo"
  ],
  "METRN": [
    "METRN CNV",
    "METRN RNA",
    "METRN Proteo"
  ],
  "ERCC2": [
    "ERCC2 CNV",
    "ERCC2 RNA",
    "ERCC2 Proteo"
  ],
  "SLC6A6": [
    "SLC6A6 CNV",
    "SLC6A6 RNA",
    "SLC6A6 Proteo"
  ],
  "TLK1P1": [
    "TLK1P1 CNV",
    "TLK1P1 RNA"
  ],
  "GCATP1": [
    "GCATP1 CNV",
    "GCATP1 RNA"
  ],
  "CP": [
    "CP CNV",
    "CP RNA",
    "CP Proteo"
  ],
  "MAPRE1": [
    "MAPRE1 CNV",
    "MAPRE1 RNA",
    "MAPRE1 Proteo"
  ],
  "VLDLR": [
    "VLDLR CNV",
    "VLDLR RNA",
    "VLDLR Proteo"
  ],
  "WLS": [
    "WLS CNV",
    "WLS RNA",
    "WLS Proteo"
  ],
  "TAAR1": [
    "TAAR1 CNV",
    "TAAR1 RNA"
  ],
  "CCDC154": [
    "CCDC154 CNV",
    "CCDC154 RNA"
  ],
  "GRIN2C": [
    "GRIN2C CNV",
    "GRIN2C RNA"
  ],
  "UNC5CL": [
    "UNC5CL CNV",
    "UNC5CL RNA"
  ],
  "ZMYM2": [
    "ZMYM2 CNV",
    "ZMYM2 RNA",
    "ZMYM2 Proteo"
  ],
  "DDX47": [
    "DDX47 CNV",
    "DDX47 RNA",
    "DDX47 Proteo"
  ],
  "C9orf131": [
    "C9orf131 CNV",
    "C9orf131 RNA"
  ],
  "ZNF821": [
    "ZNF821 CNV",
    "ZNF821 RNA"
  ],
  "GDF2": [
    "GDF2 CNV",
    "GDF2 RNA"
  ],
  "OR2AT4": [
    "OR2AT4 CNV",
    "OR2AT4 RNA"
  ],
  "GJD4": [
    "GJD4 CNV",
    "GJD4 RNA"
  ],
  "RANBP17": [
    "RANBP17 CNV",
    "RANBP17 RNA",
    "RANBP17 Proteo"
  ],
  "WDR70": [
    "WDR70 CNV",
    "WDR70 RNA",
    "WDR70 Proteo"
  ],
  "POLRMTP1": [
    "POLRMTP1 CNV",
    "POLRMTP1 RNA"
  ],
  "KIF1A": [
    "KIF1A CNV",
    "KIF1A RNA",
    "KIF1A Proteo"
  ],
  "WDR44": [
    "WDR44 CNV",
    "WDR44 RNA",
    "WDR44 Proteo"
  ],
  "ZNF519P3": [
    "ZNF519P3 CNV",
    "ZNF519P3 RNA"
  ],
  "MORC1": [
    "MORC1 CNV",
    "MORC1 RNA"
  ],
  "MAST1": [
    "MAST1 CNV",
    "MAST1 RNA"
  ],
  "KDM3AP1": [
    "KDM3AP1 CNV",
    "KDM3AP1 RNA"
  ],
  "RPL11P4": [
    "RPL11P4 CNV",
    "RPL11P4 RNA"
  ],
  "MRC1": [
    "MRC1 CNV",
    "MRC1 RNA",
    "MRC1 Proteo"
  ],
  "HOMER1": [
    "HOMER1 CNV",
    "HOMER1 RNA",
    "HOMER1 Proteo"
  ],
  "LRRN4CL": [
    "LRRN4CL CNV",
    "LRRN4CL RNA",
    "LRRN4CL Proteo"
  ],
  "TXK": [
    "TXK CNV",
    "TXK RNA"
  ],
  "SFPQ": [
    "SFPQ CNV",
    "SFPQ RNA",
    "SFPQ Proteo"
  ],
  "CDS1": [
    "CDS1 CNV",
    "CDS1 RNA",
    "CDS1 Proteo"
  ],
  "JMY": [
    "JMY CNV",
    "JMY RNA",
    "JMY Proteo"
  ],
  "AGO4": [
    "AGO4 CNV",
    "AGO4 RNA"
  ],
  "PTTG1IP2": [
    "PTTG1IP2 CNV",
    "PTTG1IP2 RNA"
  ],
  "MESP2": [
    "MESP2 CNV",
    "MESP2 RNA"
  ],
  "ALKBH3": [
    "ALKBH3 CNV",
    "ALKBH3 RNA",
    "ALKBH3 Proteo"
  ],
  "FREM3": [
    "FREM3 CNV",
    "FREM3 RNA"
  ],
  "DROSHA": [
    "DROSHA CNV",
    "DROSHA RNA",
    "DROSHA Proteo"
  ],
  "UBBP2": [
    "UBBP2 CNV",
    "UBBP2 RNA"
  ],
  "PGBD4P2": [
    "PGBD4P2 CNV",
    "PGBD4P2 RNA"
  ],
  "GPRASP2": [
    "GPRASP2 CNV",
    "GPRASP2 RNA",
    "GPRASP2 Proteo"
  ],
  "GJB3": [
    "GJB3 CNV",
    "GJB3 RNA"
  ],
  "GAP43": [
    "GAP43 CNV",
    "GAP43 RNA",
    "GAP43 Proteo"
  ],
  "SEPHS1P1": [
    "SEPHS1P1 CNV",
    "SEPHS1P1 RNA"
  ],
  "CALM1P2": [
    "CALM1P2 CNV",
    "CALM1P2 RNA"
  ],
  "HCFC2": [
    "HCFC2 CNV",
    "HCFC2 RNA",
    "HCFC2 Proteo"
  ],
  "PSMD13": [
    "PSMD13 CNV",
    "PSMD13 RNA",
    "PSMD13 Proteo"
  ],
  "OR8G7P": [
    "OR8G7P CNV",
    "OR8G7P RNA"
  ],
  "MARK4": [
    "MARK4 CNV",
    "MARK4 RNA",
    "MARK4 Proteo"
  ],
  "IGLV3-21": [
    "IGLV3-21 Proteo"
  ],
  "CLEC2D": [
    "CLEC2D CNV",
    "CLEC2D RNA"
  ],
  "RC3H1": [
    "RC3H1 CNV",
    "RC3H1 RNA",
    "RC3H1 Proteo"
  ],
  "DCUN1D1": [
    "DCUN1D1 CNV",
    "DCUN1D1 RNA",
    "DCUN1D1 Proteo"
  ],
  "NIPA2P5": [
    "NIPA2P5 CNV",
    "NIPA2P5 RNA"
  ],
  "C1GALT1C1L": [
    "C1GALT1C1L CNV",
    "C1GALT1C1L RNA"
  ],
  "IGHVIII-26-1": [
    "IGHVIII-26-1 CNV",
    "IGHVIII-26-1 RNA"
  ],
  "GBP3": [
    "GBP3 CNV",
    "GBP3 RNA",
    "GBP3 Proteo"
  ],
  "TGFA": [
    "TGFA CNV",
    "TGFA RNA"
  ],
  "WDR45": [
    "WDR45 CNV",
    "WDR45 RNA",
    "WDR45 Proteo"
  ],
  "SSNA1": [
    "SSNA1 CNV",
    "SSNA1 RNA",
    "SSNA1 Proteo"
  ],
  "HACD4": [
    "HACD4 CNV",
    "HACD4 RNA",
    "HACD4 Proteo"
  ],
  "BRD7P5": [
    "BRD7P5 CNV",
    "BRD7P5 RNA"
  ],
  "PDE6B": [
    "PDE6B CNV",
    "PDE6B RNA"
  ],
  "MAP3K20": [
    "MAP3K20 CNV",
    "MAP3K20 RNA",
    "MAP3K20 Proteo"
  ],
  "KIAA0930": [
    "KIAA0930 CNV",
    "KIAA0930 RNA",
    "KIAA0930 Proteo"
  ],
  "IGHA2": [
    "IGHA2 Proteo"
  ],
  "ATG3P1": [
    "ATG3P1 CNV",
    "ATG3P1 RNA"
  ],
  "RNASE1": [
    "RNASE1 CNV",
    "RNASE1 RNA",
    "RNASE1 Proteo"
  ],
  "GPC1": [
    "GPC1 CNV",
    "GPC1 RNA",
    "GPC1 Proteo"
  ],
  "MOB3A": [
    "MOB3A CNV",
    "MOB3A RNA",
    "MOB3A Proteo"
  ],
  "PLEC": [
    "PLEC CNV",
    "PLEC RNA",
    "PLEC Proteo"
  ],
  "IGHV3-60": [
    "IGHV3-60 CNV",
    "IGHV3-60 RNA"
  ],
  "ZNF667": [
    "ZNF667 CNV",
    "ZNF667 RNA",
    "ZNF667 Proteo"
  ],
  "MTND1P37": [
    "MTND1P37 CNV",
    "MTND1P37 RNA"
  ],
  "ABHD18": [
    "ABHD18 CNV",
    "ABHD18 RNA",
    "ABHD18 Proteo"
  ],
  "PTGES3P2": [
    "PTGES3P2 CNV",
    "PTGES3P2 RNA"
  ],
  "TBL2": [
    "TBL2 CNV",
    "TBL2 RNA",
    "TBL2 Proteo"
  ],
  "ST8SIA4": [
    "ST8SIA4 CNV",
    "ST8SIA4 RNA"
  ],
  "PROKR2": [
    "PROKR2 CNV",
    "PROKR2 RNA"
  ],
  "MTND4P22": [
    "MTND4P22 CNV",
    "MTND4P22 RNA"
  ],
  "GALNT1": [
    "GALNT1 CNV",
    "GALNT1 RNA",
    "GALNT1 Proteo"
  ],
  "FBXL16": [
    "FBXL16 CNV",
    "FBXL16 RNA"
  ],
  "S100A4": [
    "S100A4 CNV",
    "S100A4 RNA",
    "S100A4 Proteo"
  ],
  "DNTTIP2": [
    "DNTTIP2 CNV",
    "DNTTIP2 RNA",
    "DNTTIP2 Proteo"
  ],
  "DSG1": [
    "DSG1 CNV",
    "DSG1 RNA",
    "DSG1 Proteo"
  ],
  "KLHL15": [
    "KLHL15 CNV",
    "KLHL15 RNA",
    "KLHL15 Proteo"
  ],
  "TPM3P8": [
    "TPM3P8 CNV",
    "TPM3P8 RNA"
  ],
  "SLC35F1": [
    "SLC35F1 CNV",
    "SLC35F1 RNA"
  ],
  "TNFAIP1": [
    "TNFAIP1 CNV",
    "TNFAIP1 RNA",
    "TNFAIP1 Proteo"
  ],
  "CDH26": [
    "CDH26 CNV",
    "CDH26 RNA"
  ],
  "LANCL2": [
    "LANCL2 CNV",
    "LANCL2 RNA",
    "LANCL2 Proteo"
  ],
  "REREP1Y": [
    "REREP1Y CNV",
    "REREP1Y RNA"
  ],
  "DEFA10P": [
    "DEFA10P CNV",
    "DEFA10P RNA"
  ],
  "LDAF1": [
    "LDAF1 CNV",
    "LDAF1 RNA",
    "LDAF1 Proteo"
  ],
  "POTEB2": [
    "POTEB2 CNV",
    "POTEB2 RNA"
  ],
  "CCNB3P1": [
    "CCNB3P1 CNV",
    "CCNB3P1 RNA"
  ],
  "SYT11": [
    "SYT11 CNV",
    "SYT11 RNA",
    "SYT11 Proteo"
  ],
  "SATB1": [
    "SATB1 CNV",
    "SATB1 RNA",
    "SATB1 Proteo"
  ],
  "SERPINB6": [
    "SERPINB6 CNV",
    "SERPINB6 RNA",
    "SERPINB6 Proteo"
  ],
  "PNKDP1": [
    "PNKDP1 CNV",
    "PNKDP1 RNA"
  ],
  "PPARGC1B": [
    "PPARGC1B CNV",
    "PPARGC1B RNA"
  ],
  "ZFP64P1": [
    "ZFP64P1 CNV",
    "ZFP64P1 RNA"
  ],
  "GALR2": [
    "GALR2 CNV",
    "GALR2 RNA"
  ],
  "PAICSP5": [
    "PAICSP5 CNV",
    "PAICSP5 RNA"
  ],
  "TPTE2P6": [
    "TPTE2P6 CNV",
    "TPTE2P6 RNA"
  ],
  "GRINA": [
    "GRINA CNV",
    "GRINA RNA"
  ],
  "ATAD3B": [
    "ATAD3B CNV",
    "ATAD3B RNA",
    "ATAD3B Proteo"
  ],
  "MIX23P2": [
    "MIX23P2 CNV",
    "MIX23P2 RNA"
  ],
  "MIX23P5": [
    "MIX23P5 CNV",
    "MIX23P5 RNA"
  ],
  "CYYR1": [
    "CYYR1 CNV",
    "CYYR1 RNA"
  ],
  "TRABD2B": [
    "TRABD2B CNV",
    "TRABD2B RNA"
  ],
  "KRT9": [
    "KRT9 CNV",
    "KRT9 RNA",
    "KRT9 Proteo"
  ],
  "EHF": [
    "EHF CNV",
    "EHF RNA"
  ],
  "SIGLEC9": [
    "SIGLEC9 CNV",
    "SIGLEC9 RNA",
    "SIGLEC9 Proteo"
  ],
  "FRK": [
    "FRK CNV",
    "FRK RNA",
    "FRK Proteo"
  ],
  "TIPRL": [
    "TIPRL CNV",
    "TIPRL RNA",
    "TIPRL Proteo"
  ],
  "PIAS1": [
    "PIAS1 CNV",
    "PIAS1 RNA",
    "PIAS1 Proteo"
  ],
  "NCAPD2P1": [
    "NCAPD2P1 CNV",
    "NCAPD2P1 RNA"
  ],
  "MTND2P19": [
    "MTND2P19 CNV",
    "MTND2P19 RNA"
  ],
  "JAM3": [
    "JAM3 CNV",
    "JAM3 RNA",
    "JAM3 Proteo"
  ],
  "PRELID1P1": [
    "PRELID1P1 CNV",
    "PRELID1P1 RNA"
  ],
  "KRT8P27": [
    "KRT8P27 CNV",
    "KRT8P27 RNA"
  ],
  "FNBP1": [
    "FNBP1 CNV",
    "FNBP1 RNA",
    "FNBP1 Proteo"
  ],
  "RAB6C": [
    "RAB6C CNV",
    "RAB6C RNA",
    "RAB6C Proteo"
  ],
  "IGKV1OR-3": [
    "IGKV1OR-3 CNV",
    "IGKV1OR-3 RNA"
  ],
  "WASF2": [
    "WASF2 CNV",
    "WASF2 RNA",
    "WASF2 Proteo"
  ],
  "MT-ND6": [
    "MT-ND6 RNA",
    "MT-ND6 Proteo"
  ],
  "OR2L2": [
    "OR2L2 CNV",
    "OR2L2 RNA"
  ],
  "WEE2P1": [
    "WEE2P1 CNV",
    "WEE2P1 RNA"
  ],
  "ZNF697": [
    "ZNF697 CNV",
    "ZNF697 RNA",
    "ZNF697 Proteo"
  ],
  "MARCKSL1P1": [
    "MARCKSL1P1 CNV",
    "MARCKSL1P1 RNA"
  ],
  "SNTN": [
    "SNTN CNV",
    "SNTN RNA"
  ],
  "GADD45B": [
    "GADD45B CNV",
    "GADD45B RNA"
  ],
  "ITPKA": [
    "ITPKA CNV",
    "ITPKA RNA",
    "ITPKA Proteo"
  ],
  "MRPL34": [
    "MRPL34 CNV",
    "MRPL34 RNA",
    "MRPL34 Proteo"
  ],
  "KIAA0408": [
    "KIAA0408 CNV",
    "KIAA0408 RNA"
  ],
  "FXR2": [
    "FXR2 CNV",
    "FXR2 RNA",
    "FXR2 Proteo"
  ],
  "LYPD5": [
    "LYPD5 CNV",
    "LYPD5 RNA",
    "LYPD5 Proteo"
  ],
  "ABHD16A": [
    "ABHD16A CNV",
    "ABHD16A RNA",
    "ABHD16A Proteo"
  ],
  "BAIAP3": [
    "BAIAP3 CNV",
    "BAIAP3 RNA"
  ],
  "OR56A4": [
    "OR56A4 CNV",
    "OR56A4 RNA"
  ],
  "OR51A6P": [
    "OR51A6P CNV",
    "OR51A6P RNA"
  ],
  "RFFL": [
    "RFFL CNV",
    "RFFL RNA",
    "RFFL Proteo"
  ],
  "RSPH6A": [
    "RSPH6A CNV",
    "RSPH6A RNA"
  ],
  "AMN1": [
    "AMN1 CNV",
    "AMN1 RNA",
    "AMN1 Proteo"
  ],
  "THSD1": [
    "THSD1 CNV",
    "THSD1 RNA"
  ],
  "MAP3K14": [
    "MAP3K14 CNV",
    "MAP3K14 RNA"
  ],
  "DNAAF9": [
    "DNAAF9 CNV",
    "DNAAF9 RNA",
    "DNAAF9 Proteo"
  ],
  "ZNF41": [
    "ZNF41 CNV",
    "ZNF41 RNA"
  ],
  "PCNT": [
    "PCNT CNV",
    "PCNT RNA",
    "PCNT Proteo"
  ],
  "GPR157": [
    "GPR157 CNV",
    "GPR157 RNA"
  ],
  "OXER1": [
    "OXER1 CNV",
    "OXER1 RNA"
  ],
  "SSBL5P": [
    "SSBL5P CNV",
    "SSBL5P RNA"
  ],
  "NEK4": [
    "NEK4 CNV",
    "NEK4 RNA",
    "NEK4 Proteo"
  ],
  "SNX33": [
    "SNX33 CNV",
    "SNX33 RNA",
    "SNX33 Proteo"
  ],
  "CHD2": [
    "CHD2 CNV",
    "CHD2 RNA",
    "CHD2 Proteo"
  ],
  "RPL23AP68": [
    "RPL23AP68 CNV",
    "RPL23AP68 RNA"
  ],
  "GPX3": [
    "GPX3 CNV",
    "GPX3 RNA",
    "GPX3 Proteo"
  ],
  "NOB1": [
    "NOB1 CNV",
    "NOB1 RNA",
    "NOB1 Proteo"
  ],
  "NUDT15": [
    "NUDT15 CNV",
    "NUDT15 RNA",
    "NUDT15 Proteo"
  ],
  "NPIPA9_ENSG00000233024": [
    "NPIPA9_ENSG00000233024 RNA"
  ],
  "NEUROD2": [
    "NEUROD2 CNV",
    "NEUROD2 RNA"
  ],
  "PCDHGA6": [
    "PCDHGA6 CNV",
    "PCDHGA6 RNA",
    "PCDHGA6 Proteo"
  ],
  "ZNF749": [
    "ZNF749 CNV",
    "ZNF749 RNA",
    "ZNF749 Proteo"
  ],
  "FAR2P2": [
    "FAR2P2 CNV",
    "FAR2P2 RNA"
  ],
  "MXRA5Y": [
    "MXRA5Y CNV",
    "MXRA5Y RNA"
  ],
  "SNCA": [
    "SNCA CNV",
    "SNCA RNA",
    "SNCA Proteo"
  ],
  "PYROXD1": [
    "PYROXD1 CNV",
    "PYROXD1 RNA",
    "PYROXD1 Proteo"
  ],
  "KAT7P1": [
    "KAT7P1 CNV",
    "KAT7P1 RNA"
  ],
  "CALN1": [
    "CALN1 CNV",
    "CALN1 RNA"
  ],
  "TUBBP3": [
    "TUBBP3 CNV",
    "TUBBP3 RNA"
  ],
  "WBP1LP7": [
    "WBP1LP7 CNV",
    "WBP1LP7 RNA"
  ],
  "NFKB2": [
    "NFKB2 CNV",
    "NFKB2 RNA",
    "NFKB2 Proteo"
  ],
  "SMIM29": [
    "SMIM29 CNV",
    "SMIM29 RNA"
  ],
  "EHHADH": [
    "EHHADH CNV",
    "EHHADH RNA",
    "EHHADH Proteo"
  ],
  "SERTAD2": [
    "SERTAD2 CNV",
    "SERTAD2 RNA"
  ],
  "CICP8": [
    "CICP8 CNV",
    "CICP8 RNA"
  ],
  "OR52B3P": [
    "OR52B3P CNV",
    "OR52B3P RNA"
  ],
  "FAM220A": [
    "FAM220A CNV",
    "FAM220A RNA"
  ],
  "SRP72P2": [
    "SRP72P2 CNV",
    "SRP72P2 RNA"
  ],
  "ZNF100": [
    "ZNF100 CNV",
    "ZNF100 RNA"
  ],
  "AGGF1P2": [
    "AGGF1P2 CNV",
    "AGGF1P2 RNA"
  ],
  "OR7E1P": [
    "OR7E1P CNV",
    "OR7E1P RNA"
  ],
  "EXTL2": [
    "EXTL2 CNV",
    "EXTL2 RNA",
    "EXTL2 Proteo"
  ],
  "PHYHIPL": [
    "PHYHIPL CNV",
    "PHYHIPL RNA"
  ],
  "NUP62CL": [
    "NUP62CL CNV",
    "NUP62CL RNA"
  ],
  "WDR24": [
    "WDR24 CNV",
    "WDR24 RNA",
    "WDR24 Proteo"
  ],
  "PDCD2": [
    "PDCD2 CNV",
    "PDCD2 RNA",
    "PDCD2 Proteo"
  ],
  "SEPTIN7P3": [
    "SEPTIN7P3 CNV",
    "SEPTIN7P3 RNA"
  ],
  "ENPP7P9": [
    "ENPP7P9 CNV",
    "ENPP7P9 RNA"
  ],
  "MAN2C1": [
    "MAN2C1 CNV",
    "MAN2C1 RNA",
    "MAN2C1 Proteo"
  ],
  "RAB27B": [
    "RAB27B CNV",
    "RAB27B RNA",
    "RAB27B Proteo"
  ],
  "CATSPERD": [
    "CATSPERD CNV",
    "CATSPERD RNA"
  ],
  "SEC62": [
    "SEC62 CNV",
    "SEC62 RNA",
    "SEC62 Proteo"
  ],
  "CHCHD2P1": [
    "CHCHD2P1 CNV",
    "CHCHD2P1 RNA"
  ],
  "SSH3": [
    "SSH3 CNV",
    "SSH3 RNA",
    "SSH3 Proteo"
  ],
  "HLA-H": [
    "HLA-H CNV",
    "HLA-H RNA"
  ],
  "CRYBB1": [
    "CRYBB1 CNV",
    "CRYBB1 RNA",
    "CRYBB1 Proteo"
  ],
  "VCX3B": [
    "VCX3B CNV",
    "VCX3B RNA"
  ],
  "DDIT4": [
    "DDIT4 CNV",
    "DDIT4 RNA",
    "DDIT4 Proteo"
  ],
  "DYDC2": [
    "DYDC2 CNV",
    "DYDC2 RNA"
  ],
  "FDFT1": [
    "FDFT1 CNV",
    "FDFT1 RNA",
    "FDFT1 Proteo"
  ],
  "MTND3P5": [
    "MTND3P5 CNV",
    "MTND3P5 RNA"
  ],
  "IPO5": [
    "IPO5 CNV",
    "IPO5 RNA",
    "IPO5 Proteo"
  ],
  "MAP4K2": [
    "MAP4K2 CNV",
    "MAP4K2 RNA",
    "MAP4K2 Proteo"
  ],
  "SYDE2": [
    "SYDE2 CNV",
    "SYDE2 RNA"
  ],
  "LGALS13": [
    "LGALS13 CNV",
    "LGALS13 RNA"
  ],
  "SEC22B3P": [
    "SEC22B3P CNV",
    "SEC22B3P RNA"
  ],
  "FTHL17": [
    "FTHL17 CNV",
    "FTHL17 RNA"
  ],
  "ARHGAP42P1": [
    "ARHGAP42P1 CNV",
    "ARHGAP42P1 RNA"
  ],
  "RPL17P1": [
    "RPL17P1 CNV",
    "RPL17P1 RNA"
  ],
  "TAGAP": [
    "TAGAP CNV",
    "TAGAP RNA"
  ],
  "OR4N3P": [
    "OR4N3P CNV",
    "OR4N3P RNA"
  ],
  "VN1R31P": [
    "VN1R31P CNV",
    "VN1R31P RNA"
  ],
  "PPP4R1": [
    "PPP4R1 CNV",
    "PPP4R1 RNA",
    "PPP4R1 Proteo"
  ],
  "DYNLL1P1": [
    "DYNLL1P1 CNV",
    "DYNLL1P1 RNA"
  ],
  "LSM6": [
    "LSM6 CNV",
    "LSM6 RNA",
    "LSM6 Proteo"
  ],
  "MTND4P1": [
    "MTND4P1 CNV",
    "MTND4P1 RNA"
  ],
  "CICP17": [
    "CICP17 CNV",
    "CICP17 RNA"
  ],
  "ABCB10": [
    "ABCB10 CNV",
    "ABCB10 RNA",
    "ABCB10 Proteo"
  ],
  "FABP3P2": [
    "FABP3P2 CNV",
    "FABP3P2 RNA"
  ],
  "FAM98B": [
    "FAM98B CNV",
    "FAM98B RNA",
    "FAM98B Proteo"
  ],
  "GPR151": [
    "GPR151 CNV",
    "GPR151 RNA"
  ],
  "RPL21P6": [
    "RPL21P6 CNV",
    "RPL21P6 RNA"
  ],
  "RNASE9": [
    "RNASE9 CNV",
    "RNASE9 RNA"
  ],
  "MEI4": [
    "MEI4 CNV",
    "MEI4 RNA"
  ],
  "ABCA13": [
    "ABCA13 CNV",
    "ABCA13 RNA"
  ],
  "MTERF4": [
    "MTERF4 CNV",
    "MTERF4 RNA",
    "MTERF4 Proteo"
  ],
  "NCAPH2": [
    "NCAPH2 CNV",
    "NCAPH2 RNA",
    "NCAPH2 Proteo"
  ],
  "PEBP1P2": [
    "PEBP1P2 CNV",
    "PEBP1P2 RNA"
  ],
  "QRSL1": [
    "QRSL1 CNV",
    "QRSL1 RNA",
    "QRSL1 Proteo"
  ],
  "PIEZO2": [
    "PIEZO2 CNV",
    "PIEZO2 RNA"
  ],
  "HMGCL": [
    "HMGCL CNV",
    "HMGCL RNA",
    "HMGCL Proteo"
  ],
  "ARMCX6": [
    "ARMCX6 CNV",
    "ARMCX6 RNA"
  ],
  "SCYGR9": [
    "SCYGR9 CNV",
    "SCYGR9 RNA"
  ],
  "CISD2": [
    "CISD2 CNV",
    "CISD2 RNA",
    "CISD2 Proteo"
  ],
  "MARCHF8": [
    "MARCHF8 CNV",
    "MARCHF8 RNA"
  ],
  "USP35": [
    "USP35 CNV",
    "USP35 RNA",
    "USP35 Proteo"
  ],
  "RPS15AP34": [
    "RPS15AP34 CNV",
    "RPS15AP34 RNA"
  ],
  "MAIP1": [
    "MAIP1 CNV",
    "MAIP1 RNA",
    "MAIP1 Proteo"
  ],
  "FRG2GP": [
    "FRG2GP CNV",
    "FRG2GP RNA"
  ],
  "CBLN3": [
    "CBLN3 CNV",
    "CBLN3 RNA"
  ],
  "TBR1": [
    "TBR1 CNV",
    "TBR1 RNA"
  ],
  "CHCHD2P3": [
    "CHCHD2P3 CNV",
    "CHCHD2P3 RNA"
  ],
  "ZEB1": [
    "ZEB1 CNV",
    "ZEB1 RNA",
    "ZEB1 Proteo"
  ],
  "ZNF850": [
    "ZNF850 CNV",
    "ZNF850 RNA",
    "ZNF850 Proteo"
  ],
  "PSAP": [
    "PSAP CNV",
    "PSAP RNA",
    "PSAP Proteo"
  ],
  "SV2B": [
    "SV2B CNV",
    "SV2B RNA"
  ],
  "SLC17A9": [
    "SLC17A9 CNV",
    "SLC17A9 RNA"
  ],
  "RPL22P11": [
    "RPL22P11 CNV",
    "RPL22P11 RNA"
  ],
  "C1orf68": [
    "C1orf68 CNV",
    "C1orf68 RNA",
    "C1orf68 Proteo"
  ],
  "ZC3H13": [
    "ZC3H13 CNV",
    "ZC3H13 RNA",
    "ZC3H13 Proteo"
  ],
  "OR4Q3": [
    "OR4Q3 CNV",
    "OR4Q3 RNA"
  ],
  "SLFN12L": [
    "SLFN12L CNV",
    "SLFN12L RNA"
  ],
  "DLEC1P1": [
    "DLEC1P1 CNV",
    "DLEC1P1 RNA"
  ],
  "GNPTG": [
    "GNPTG CNV",
    "GNPTG RNA",
    "GNPTG Proteo"
  ],
  "ZNF765": [
    "ZNF765 CNV",
    "ZNF765 RNA"
  ],
  "DONSON": [
    "DONSON CNV",
    "DONSON RNA",
    "DONSON Proteo"
  ],
  "KNSTRN": [
    "KNSTRN CNV",
    "KNSTRN RNA",
    "KNSTRN Proteo"
  ],
  "ALDOAP1": [
    "ALDOAP1 CNV",
    "ALDOAP1 RNA"
  ],
  "HINT2": [
    "HINT2 CNV",
    "HINT2 RNA",
    "HINT2 Proteo"
  ],
  "TUBB1P1": [
    "TUBB1P1 CNV",
    "TUBB1P1 RNA"
  ],
  "FABP5": [
    "FABP5 CNV",
    "FABP5 RNA",
    "FABP5 Proteo"
  ],
  "RNA5SP153": [
    "RNA5SP153 CNV",
    "RNA5SP153 RNA"
  ],
  "ST13P4": [
    "ST13P4 CNV",
    "ST13P4 RNA"
  ],
  "ELF2P4": [
    "ELF2P4 CNV",
    "ELF2P4 RNA"
  ],
  "ZNF702P": [
    "ZNF702P CNV",
    "ZNF702P RNA"
  ],
  "SAR1A": [
    "SAR1A CNV",
    "SAR1A RNA",
    "SAR1A Proteo"
  ],
  "EVPL": [
    "EVPL CNV",
    "EVPL RNA",
    "EVPL Proteo"
  ],
  "NAGLU": [
    "NAGLU CNV",
    "NAGLU RNA",
    "NAGLU Proteo"
  ],
  "BUD13P1": [
    "BUD13P1 CNV",
    "BUD13P1 RNA"
  ],
  "SP9": [
    "SP9 CNV",
    "SP9 RNA"
  ],
  "GGTLC4P": [
    "GGTLC4P CNV",
    "GGTLC4P RNA"
  ],
  "TMEM213": [
    "TMEM213 CNV",
    "TMEM213 RNA"
  ],
  "KIF13B": [
    "KIF13B CNV",
    "KIF13B RNA",
    "KIF13B Proteo"
  ],
  "ATP6V0CP3": [
    "ATP6V0CP3 CNV",
    "ATP6V0CP3 RNA"
  ],
  "MYO1G": [
    "MYO1G CNV",
    "MYO1G RNA",
    "MYO1G Proteo"
  ],
  "GTF2IRD2": [
    "GTF2IRD2 CNV",
    "GTF2IRD2 RNA",
    "GTF2IRD2 Proteo"
  ],
  "TPK1": [
    "TPK1 CNV",
    "TPK1 RNA",
    "TPK1 Proteo"
  ],
  "HEG1": [
    "HEG1 CNV",
    "HEG1 RNA",
    "HEG1 Proteo"
  ],
  "AGTRAP": [
    "AGTRAP CNV",
    "AGTRAP RNA",
    "AGTRAP Proteo"
  ],
  "KLK6": [
    "KLK6 CNV",
    "KLK6 RNA",
    "KLK6 Proteo"
  ],
  "LRRC37A14P": [
    "LRRC37A14P CNV",
    "LRRC37A14P RNA"
  ],
  "POU3F2": [
    "POU3F2 CNV",
    "POU3F2 RNA"
  ],
  "HADHAP2": [
    "HADHAP2 CNV",
    "HADHAP2 RNA"
  ],
  "DYNLL1P7": [
    "DYNLL1P7 CNV",
    "DYNLL1P7 RNA"
  ],
  "MTCO3P38": [
    "MTCO3P38 CNV",
    "MTCO3P38 RNA"
  ],
  "MTCYBP29": [
    "MTCYBP29 CNV",
    "MTCYBP29 RNA"
  ],
  "CASP5": [
    "CASP5 CNV",
    "CASP5 RNA",
    "CASP5 Proteo"
  ],
  "TRIM72": [
    "TRIM72 CNV",
    "TRIM72 RNA",
    "TRIM72 Proteo"
  ],
  "RHEX": [
    "RHEX CNV",
    "RHEX RNA"
  ],
  "SPRR2B": [
    "SPRR2B CNV",
    "SPRR2B RNA"
  ],
  "KATNBL1": [
    "KATNBL1 CNV",
    "KATNBL1 RNA",
    "KATNBL1 Proteo"
  ],
  "TMEM128": [
    "TMEM128 CNV",
    "TMEM128 RNA",
    "TMEM128 Proteo"
  ],
  "NXF2": [
    "NXF2 CNV",
    "NXF2 RNA"
  ],
  "JTB": [
    "JTB CNV",
    "JTB RNA",
    "JTB Proteo"
  ],
  "RGS20": [
    "RGS20 CNV",
    "RGS20 RNA",
    "RGS20 Proteo"
  ],
  "CNN2P6": [
    "CNN2P6 CNV",
    "CNN2P6 RNA"
  ],
  "ANKRD11P1": [
    "ANKRD11P1 CNV",
    "ANKRD11P1 RNA"
  ],
  "PSMB7P1": [
    "PSMB7P1 CNV",
    "PSMB7P1 RNA"
  ],
  "PABIR3": [
    "PABIR3 CNV",
    "PABIR3 RNA"
  ],
  "SH3D19": [
    "SH3D19 CNV",
    "SH3D19 RNA",
    "SH3D19 Proteo"
  ],
  "ZNF676": [
    "ZNF676 CNV",
    "ZNF676 RNA"
  ],
  "FAM172BP": [
    "FAM172BP CNV",
    "FAM172BP RNA"
  ],
  "EIF3KP2": [
    "EIF3KP2 CNV",
    "EIF3KP2 RNA"
  ],
  "RAB8B": [
    "RAB8B CNV",
    "RAB8B RNA",
    "RAB8B Proteo"
  ],
  "TMEM102": [
    "TMEM102 CNV",
    "TMEM102 RNA",
    "TMEM102 Proteo"
  ],
  "CYFIP2": [
    "CYFIP2 CNV",
    "CYFIP2 RNA",
    "CYFIP2 Proteo"
  ],
  "RPL23AP82": [
    "RPL23AP82 CNV",
    "RPL23AP82 RNA"
  ],
  "IGKV1D-32": [
    "IGKV1D-32 CNV",
    "IGKV1D-32 RNA"
  ],
  "OR5BE1P": [
    "OR5BE1P CNV",
    "OR5BE1P RNA"
  ],
  "RIN2": [
    "RIN2 CNV",
    "RIN2 RNA",
    "RIN2 Proteo"
  ],
  "C1orf159": [
    "C1orf159 CNV",
    "C1orf159 RNA"
  ],
  "CLN6": [
    "CLN6 CNV",
    "CLN6 RNA",
    "CLN6 Proteo"
  ],
  "MIA2": [
    "MIA2 CNV",
    "MIA2 RNA",
    "MIA2 Proteo"
  ],
  "OR2L5": [
    "OR2L5 CNV",
    "OR2L5 RNA"
  ],
  "PHTF2": [
    "PHTF2 CNV",
    "PHTF2 RNA",
    "PHTF2 Proteo"
  ],
  "PELP1": [
    "PELP1 CNV",
    "PELP1 RNA",
    "PELP1 Proteo"
  ],
  "ICA1": [
    "ICA1 CNV",
    "ICA1 RNA",
    "ICA1 Proteo"
  ],
  "DNM1P50": [
    "DNM1P50 CNV",
    "DNM1P50 RNA"
  ],
  "IGHV3-62": [
    "IGHV3-62 CNV",
    "IGHV3-62 RNA"
  ],
  "GPAT2P2": [
    "GPAT2P2 CNV",
    "GPAT2P2 RNA"
  ],
  "KRTAP13-1": [
    "KRTAP13-1 CNV",
    "KRTAP13-1 RNA"
  ],
  "OR51J1": [
    "OR51J1 CNV",
    "OR51J1 RNA"
  ],
  "PAPLN": [
    "PAPLN CNV",
    "PAPLN RNA",
    "PAPLN Proteo"
  ],
  "YBX3": [
    "YBX3 CNV",
    "YBX3 RNA",
    "YBX3 Proteo"
  ],
  "UBBP3": [
    "UBBP3 CNV",
    "UBBP3 RNA"
  ],
  "RPL9P29": [
    "RPL9P29 CNV",
    "RPL9P29 RNA"
  ],
  "KASH5": [
    "KASH5 CNV",
    "KASH5 RNA"
  ],
  "GRAPL": [
    "GRAPL CNV",
    "GRAPL RNA"
  ],
  "C1orf52": [
    "C1orf52 CNV",
    "C1orf52 RNA",
    "C1orf52 Proteo"
  ],
  "SSC5D": [
    "SSC5D CNV",
    "SSC5D RNA",
    "SSC5D Proteo"
  ],
  "CDC25B": [
    "CDC25B CNV",
    "CDC25B RNA",
    "CDC25B Proteo"
  ],
  "PTPRE": [
    "PTPRE CNV",
    "PTPRE RNA",
    "PTPRE Proteo"
  ],
  "RPS29P15": [
    "RPS29P15 CNV",
    "RPS29P15 RNA"
  ],
  "APH1B": [
    "APH1B CNV",
    "APH1B RNA",
    "APH1B Proteo"
  ],
  "PMP22": [
    "PMP22 CNV",
    "PMP22 RNA"
  ],
  "ZNF510": [
    "ZNF510 CNV",
    "ZNF510 RNA"
  ],
  "CALB2": [
    "CALB2 CNV",
    "CALB2 RNA",
    "CALB2 Proteo"
  ],
  "DUX4L34": [
    "DUX4L34 CNV",
    "DUX4L34 RNA"
  ],
  "GTPBP2": [
    "GTPBP2 CNV",
    "GTPBP2 RNA",
    "GTPBP2 Proteo"
  ],
  "RBPJP5": [
    "RBPJP5 CNV",
    "RBPJP5 RNA"
  ],
  "COX5BP4": [
    "COX5BP4 CNV",
    "COX5BP4 RNA"
  ],
  "TLL2": [
    "TLL2 CNV",
    "TLL2 RNA"
  ],
  "KRTAP5-10": [
    "KRTAP5-10 CNV",
    "KRTAP5-10 RNA"
  ],
  "ABHD5": [
    "ABHD5 CNV",
    "ABHD5 RNA",
    "ABHD5 Proteo"
  ],
  "COX5BP3": [
    "COX5BP3 CNV",
    "COX5BP3 RNA"
  ],
  "DHX58": [
    "DHX58 CNV",
    "DHX58 RNA",
    "DHX58 Proteo"
  ],
  "OR7G1": [
    "OR7G1 CNV",
    "OR7G1 RNA"
  ],
  "CPXM1": [
    "CPXM1 CNV",
    "CPXM1 RNA",
    "CPXM1 Proteo"
  ],
  "OMP": [
    "OMP CNV",
    "OMP RNA"
  ],
  "UBE2Q2P2": [
    "UBE2Q2P2 CNV",
    "UBE2Q2P2 RNA"
  ],
  "ART2P": [
    "ART2P CNV",
    "ART2P RNA"
  ],
  "ERGIC1": [
    "ERGIC1 CNV",
    "ERGIC1 RNA",
    "ERGIC1 Proteo"
  ],
  "CDRT15P10": [
    "CDRT15P10 CNV",
    "CDRT15P10 RNA"
  ],
  "UBA1": [
    "UBA1 CNV",
    "UBA1 RNA",
    "UBA1 Proteo"
  ],
  "METTL14": [
    "METTL14 CNV",
    "METTL14 RNA",
    "METTL14 Proteo"
  ],
  "RNF213": [
    "RNF213 CNV",
    "RNF213 RNA",
    "RNF213 Proteo"
  ],
  "TDO2": [
    "TDO2 CNV",
    "TDO2 RNA"
  ],
  "GLG1": [
    "GLG1 CNV",
    "GLG1 RNA",
    "GLG1 Proteo"
  ],
  "NLRC5": [
    "NLRC5 CNV",
    "NLRC5 RNA",
    "NLRC5 Proteo"
  ],
  "RPL23P10": [
    "RPL23P10 CNV",
    "RPL23P10 RNA"
  ],
  "RAB9BP1": [
    "RAB9BP1 CNV",
    "RAB9BP1 RNA"
  ],
  "CPT2": [
    "CPT2 CNV",
    "CPT2 RNA",
    "CPT2 Proteo"
  ],
  "PPP3R2": [
    "PPP3R2 CNV",
    "PPP3R2 RNA"
  ],
  "FBP1": [
    "FBP1 CNV",
    "FBP1 RNA",
    "FBP1 Proteo"
  ],
  "CXXC4": [
    "CXXC4 CNV",
    "CXXC4 RNA"
  ],
  "L3MBTL2": [
    "L3MBTL2 CNV",
    "L3MBTL2 RNA",
    "L3MBTL2 Proteo"
  ],
  "SFN": [
    "SFN CNV",
    "SFN RNA",
    "SFN Proteo"
  ],
  "CARD14": [
    "CARD14 CNV",
    "CARD14 RNA"
  ],
  "SPACA7BP": [
    "SPACA7BP CNV",
    "SPACA7BP RNA"
  ],
  "PRR23A": [
    "PRR23A CNV",
    "PRR23A RNA"
  ],
  "CYCSP49": [
    "CYCSP49 CNV",
    "CYCSP49 RNA"
  ],
  "SRP68P3": [
    "SRP68P3 CNV",
    "SRP68P3 RNA"
  ],
  "NKPD1": [
    "NKPD1 CNV",
    "NKPD1 RNA"
  ],
  "RPL7P38": [
    "RPL7P38 CNV",
    "RPL7P38 RNA"
  ],
  "SPN": [
    "SPN CNV",
    "SPN RNA",
    "SPN Proteo"
  ],
  "LRCH2": [
    "LRCH2 CNV",
    "LRCH2 RNA",
    "LRCH2 Proteo"
  ],
  "INPP5F": [
    "INPP5F CNV",
    "INPP5F RNA",
    "INPP5F Proteo"
  ],
  "SLC44A3P1": [
    "SLC44A3P1 CNV",
    "SLC44A3P1 RNA"
  ],
  "TNFSF14": [
    "TNFSF14 CNV",
    "TNFSF14 RNA"
  ],
  "IFNA21": [
    "IFNA21 CNV",
    "IFNA21 RNA"
  ],
  "RPL22P8": [
    "RPL22P8 CNV",
    "RPL22P8 RNA"
  ],
  "ANKRD13C": [
    "ANKRD13C CNV",
    "ANKRD13C RNA",
    "ANKRD13C Proteo"
  ],
  "MED30": [
    "MED30 CNV",
    "MED30 RNA",
    "MED30 Proteo"
  ],
  "CTDNEP1": [
    "CTDNEP1 CNV",
    "CTDNEP1 RNA",
    "CTDNEP1 Proteo"
  ],
  "RPL26P15": [
    "RPL26P15 CNV",
    "RPL26P15 RNA"
  ],
  "IMPDH1P7": [
    "IMPDH1P7 CNV",
    "IMPDH1P7 RNA"
  ],
  "HINT1P1": [
    "HINT1P1 CNV",
    "HINT1P1 RNA"
  ],
  "CHCHD4": [
    "CHCHD4 CNV",
    "CHCHD4 RNA",
    "CHCHD4 Proteo"
  ],
  "PRSS33": [
    "PRSS33 CNV",
    "PRSS33 RNA",
    "PRSS33 Proteo"
  ],
  "IRF2BP2": [
    "IRF2BP2 CNV",
    "IRF2BP2 RNA",
    "IRF2BP2 Proteo"
  ],
  "RNA5SP297": [
    "RNA5SP297 CNV",
    "RNA5SP297 RNA"
  ],
  "CTSLP6": [
    "CTSLP6 CNV",
    "CTSLP6 RNA"
  ],
  "MTCO2P22": [
    "MTCO2P22 CNV",
    "MTCO2P22 RNA"
  ],
  "ARL2BP": [
    "ARL2BP CNV",
    "ARL2BP RNA",
    "ARL2BP Proteo"
  ],
  "SLC12A9": [
    "SLC12A9 CNV",
    "SLC12A9 RNA",
    "SLC12A9 Proteo"
  ],
  "FBXO36": [
    "FBXO36 CNV",
    "FBXO36 RNA",
    "FBXO36 Proteo"
  ],
  "PPP1R3A": [
    "PPP1R3A CNV",
    "PPP1R3A RNA"
  ],
  "FZD1": [
    "FZD1 CNV",
    "FZD1 RNA",
    "FZD1 Proteo"
  ],
  "MYL12A": [
    "MYL12A CNV",
    "MYL12A RNA",
    "MYL12A Proteo"
  ],
  "BROX": [
    "BROX CNV",
    "BROX RNA",
    "BROX Proteo"
  ],
  "SLBP": [
    "SLBP CNV",
    "SLBP RNA",
    "SLBP Proteo"
  ],
  "ERVK3-1": [
    "ERVK3-1 CNV",
    "ERVK3-1 RNA",
    "ERVK3-1 Proteo"
  ],
  "RP1": [
    "RP1 CNV",
    "RP1 RNA"
  ],
  "COL13A1": [
    "COL13A1 CNV",
    "COL13A1 RNA",
    "COL13A1 Proteo"
  ],
  "OR6J1": [
    "OR6J1 CNV",
    "OR6J1 RNA"
  ],
  "RHEBL1": [
    "RHEBL1 CNV",
    "RHEBL1 RNA"
  ],
  "CYP4F3": [
    "CYP4F3 CNV",
    "CYP4F3 RNA",
    "CYP4F3 Proteo"
  ],
  "CSPG4P12": [
    "CSPG4P12 CNV",
    "CSPG4P12 RNA"
  ],
  "WDR73": [
    "WDR73 CNV",
    "WDR73 RNA",
    "WDR73 Proteo"
  ],
  "SLC9A7": [
    "SLC9A7 CNV",
    "SLC9A7 RNA",
    "SLC9A7 Proteo"
  ],
  "TOMM20P4": [
    "TOMM20P4 CNV",
    "TOMM20P4 RNA"
  ],
  "SLC39A7": [
    "SLC39A7 CNV",
    "SLC39A7 RNA",
    "SLC39A7 Proteo"
  ],
  "HERC2P6": [
    "HERC2P6 CNV",
    "HERC2P6 RNA"
  ],
  "CFAP45": [
    "CFAP45 CNV",
    "CFAP45 RNA"
  ],
  "FGFR3P1": [
    "FGFR3P1 CNV",
    "FGFR3P1 RNA"
  ],
  "FZD5": [
    "FZD5 CNV",
    "FZD5 RNA"
  ],
  "SRP14P2": [
    "SRP14P2 CNV",
    "SRP14P2 RNA"
  ],
  "TREX2": [
    "TREX2 CNV",
    "TREX2 RNA",
    "TREX2 Proteo"
  ],
  "OR5M14P": [
    "OR5M14P CNV",
    "OR5M14P RNA"
  ],
  "C13orf42": [
    "C13orf42 CNV",
    "C13orf42 RNA"
  ],
  "POLA2": [
    "POLA2 CNV",
    "POLA2 RNA",
    "POLA2 Proteo"
  ],
  "CARMIL2": [
    "CARMIL2 CNV",
    "CARMIL2 RNA",
    "CARMIL2 Proteo"
  ],
  "OR11K2P": [
    "OR11K2P CNV",
    "OR11K2P RNA"
  ],
  "RPLP0": [
    "RPLP0 CNV",
    "RPLP0 RNA",
    "RPLP0 Proteo"
  ],
  "FBRS": [
    "FBRS CNV",
    "FBRS RNA",
    "FBRS Proteo"
  ],
  "KRT33B": [
    "KRT33B CNV",
    "KRT33B RNA"
  ],
  "RPL23AP19": [
    "RPL23AP19 CNV",
    "RPL23AP19 RNA"
  ],
  "PGBD4P6": [
    "PGBD4P6 CNV",
    "PGBD4P6 RNA"
  ],
  "DUX4L33": [
    "DUX4L33 CNV",
    "DUX4L33 RNA"
  ],
  "TUBAP10": [
    "TUBAP10 CNV",
    "TUBAP10 RNA"
  ],
  "OXCT2": [
    "OXCT2 CNV",
    "OXCT2 RNA",
    "OXCT2 Proteo"
  ],
  "H3P35": [
    "H3P35 CNV",
    "H3P35 RNA"
  ],
  "RAB11AP1": [
    "RAB11AP1 CNV",
    "RAB11AP1 RNA"
  ],
  "RPL23AP62": [
    "RPL23AP62 CNV",
    "RPL23AP62 RNA"
  ],
  "ARL5AP5": [
    "ARL5AP5 CNV",
    "ARL5AP5 RNA"
  ],
  "TSEN15": [
    "TSEN15 CNV",
    "TSEN15 RNA",
    "TSEN15 Proteo"
  ],
  "CASP6": [
    "CASP6 CNV",
    "CASP6 RNA",
    "CASP6 Proteo"
  ],
  "NDUFA5P4": [
    "NDUFA5P4 CNV",
    "NDUFA5P4 RNA"
  ],
  "SEPTIN3": [
    "SEPTIN3 CNV",
    "SEPTIN3 RNA",
    "SEPTIN3 Proteo"
  ],
  "PMS2P13": [
    "PMS2P13 CNV",
    "PMS2P13 RNA"
  ],
  "CXADRP3": [
    "CXADRP3 CNV",
    "CXADRP3 RNA"
  ],
  "PRDM11": [
    "PRDM11 CNV",
    "PRDM11 RNA",
    "PRDM11 Proteo"
  ],
  "RBMY1J": [
    "RBMY1J CNV",
    "RBMY1J RNA"
  ],
  "SMBD1P": [
    "SMBD1P CNV",
    "SMBD1P RNA"
  ],
  "NPY4R": [
    "NPY4R CNV",
    "NPY4R RNA"
  ],
  "FAM25G": [
    "FAM25G CNV",
    "FAM25G RNA"
  ],
  "LRRC37A13P": [
    "LRRC37A13P CNV",
    "LRRC37A13P RNA"
  ],
  "KIAA0232": [
    "KIAA0232 CNV",
    "KIAA0232 RNA",
    "KIAA0232 Proteo"
  ],
  "WDFY2": [
    "WDFY2 CNV",
    "WDFY2 RNA",
    "WDFY2 Proteo"
  ],
  "HNRNPKP3": [
    "HNRNPKP3 CNV",
    "HNRNPKP3 RNA"
  ],
  "SPC24": [
    "SPC24 CNV",
    "SPC24 RNA",
    "SPC24 Proteo"
  ],
  "OR2B7P": [
    "OR2B7P CNV",
    "OR2B7P RNA"
  ],
  "PLEKHG1": [
    "PLEKHG1 CNV",
    "PLEKHG1 RNA",
    "PLEKHG1 Proteo"
  ],
  "GSK3A": [
    "GSK3A CNV",
    "GSK3A RNA",
    "GSK3A Proteo"
  ],
  "AKIRIN1": [
    "AKIRIN1 CNV",
    "AKIRIN1 RNA"
  ],
  "RPL12P35": [
    "RPL12P35 CNV",
    "RPL12P35 RNA"
  ],
  "ALMS1": [
    "ALMS1 CNV",
    "ALMS1 RNA",
    "ALMS1 Proteo"
  ],
  "S100A14": [
    "S100A14 CNV",
    "S100A14 RNA",
    "S100A14 Proteo"
  ],
  "SLC39A12": [
    "SLC39A12 CNV",
    "SLC39A12 RNA"
  ],
  "IL17RB": [
    "IL17RB CNV",
    "IL17RB RNA"
  ],
  "CDC14A": [
    "CDC14A CNV",
    "CDC14A RNA"
  ],
  "ARL10": [
    "ARL10 CNV",
    "ARL10 RNA",
    "ARL10 Proteo"
  ],
  "AQP4": [
    "AQP4 CNV",
    "AQP4 RNA"
  ],
  "ST13P5": [
    "ST13P5 CNV",
    "ST13P5 RNA"
  ],
  "PRORSD1P": [
    "PRORSD1P CNV",
    "PRORSD1P RNA"
  ],
  "ADPRH": [
    "ADPRH CNV",
    "ADPRH RNA",
    "ADPRH Proteo"
  ],
  "MTCYBP5": [
    "MTCYBP5 CNV",
    "MTCYBP5 RNA"
  ],
  "GREM2": [
    "GREM2 CNV",
    "GREM2 RNA"
  ],
  "PSD2": [
    "PSD2 CNV",
    "PSD2 RNA"
  ],
  "MTND6P1": [
    "MTND6P1 CNV",
    "MTND6P1 RNA"
  ],
  "RASSF8": [
    "RASSF8 CNV",
    "RASSF8 RNA",
    "RASSF8 Proteo"
  ],
  "PRSS16": [
    "PRSS16 CNV",
    "PRSS16 RNA"
  ],
  "RPL31P54": [
    "RPL31P54 CNV",
    "RPL31P54 RNA"
  ],
  "DEFB121": [
    "DEFB121 CNV",
    "DEFB121 RNA"
  ],
  "IGLVIVOR22-1": [
    "IGLVIVOR22-1 CNV",
    "IGLVIVOR22-1 RNA"
  ],
  "SLC25A15P2": [
    "SLC25A15P2 CNV",
    "SLC25A15P2 RNA"
  ],
  "ZBTB12": [
    "ZBTB12 CNV",
    "ZBTB12 RNA",
    "ZBTB12 Proteo"
  ],
  "H3P24": [
    "H3P24 CNV",
    "H3P24 RNA"
  ],
  "FAM166C": [
    "FAM166C CNV",
    "FAM166C RNA"
  ],
  "GRIA2": [
    "GRIA2 CNV",
    "GRIA2 RNA"
  ],
  "RPL27AP8": [
    "RPL27AP8 CNV",
    "RPL27AP8 RNA"
  ],
  "NCBP3": [
    "NCBP3 CNV",
    "NCBP3 RNA",
    "NCBP3 Proteo"
  ],
  "UBFD1P1": [
    "UBFD1P1 CNV",
    "UBFD1P1 RNA"
  ],
  "TLK1": [
    "TLK1 CNV",
    "TLK1 RNA",
    "TLK1 Proteo"
  ],
  "BPIFA2": [
    "BPIFA2 CNV",
    "BPIFA2 RNA",
    "BPIFA2 Proteo"
  ],
  "C10orf67": [
    "C10orf67 CNV",
    "C10orf67 RNA"
  ],
  "PIK3C2A": [
    "PIK3C2A CNV",
    "PIK3C2A RNA",
    "PIK3C2A Proteo"
  ],
  "ASCL1": [
    "ASCL1 CNV",
    "ASCL1 RNA"
  ],
  "FTLP17": [
    "FTLP17 CNV",
    "FTLP17 RNA"
  ],
  "WHAMMP4": [
    "WHAMMP4 CNV",
    "WHAMMP4 RNA"
  ],
  "TMEM201": [
    "TMEM201 CNV",
    "TMEM201 RNA",
    "TMEM201 Proteo"
  ],
  "NAV3": [
    "NAV3 CNV",
    "NAV3 RNA",
    "NAV3 Proteo"
  ],
  "OR6C66P": [
    "OR6C66P CNV",
    "OR6C66P RNA"
  ],
  "IFNA4": [
    "IFNA4 CNV",
    "IFNA4 RNA"
  ],
  "RND3": [
    "RND3 CNV",
    "RND3 RNA",
    "RND3 Proteo"
  ],
  "SORBS1": [
    "SORBS1 CNV",
    "SORBS1 RNA",
    "SORBS1 Proteo"
  ],
  "USP34": [
    "USP34 CNV",
    "USP34 RNA",
    "USP34 Proteo"
  ],
  "ATP5PBP2": [
    "ATP5PBP2 CNV",
    "ATP5PBP2 RNA"
  ],
  "TTC41P": [
    "TTC41P CNV",
    "TTC41P RNA"
  ],
  "IL15RA": [
    "IL15RA CNV",
    "IL15RA RNA"
  ],
  "NRN1L": [
    "NRN1L CNV",
    "NRN1L RNA"
  ],
  "SIRT6": [
    "SIRT6 CNV",
    "SIRT6 RNA",
    "SIRT6 Proteo"
  ],
  "DCN": [
    "DCN CNV",
    "DCN RNA",
    "DCN Proteo"
  ],
  "OR7E122P": [
    "OR7E122P CNV",
    "OR7E122P RNA"
  ],
  "WAS": [
    "WAS CNV",
    "WAS RNA",
    "WAS Proteo"
  ],
  "CDY10P": [
    "CDY10P CNV",
    "CDY10P RNA"
  ],
  "DNAH10": [
    "DNAH10 CNV",
    "DNAH10 RNA"
  ],
  "ZNF382": [
    "ZNF382 CNV",
    "ZNF382 RNA"
  ],
  "ACP1": [
    "ACP1 CNV",
    "ACP1 RNA",
    "ACP1 Proteo"
  ],
  "TRPV1": [
    "TRPV1 CNV",
    "TRPV1 RNA"
  ],
  "FOXN3P2": [
    "FOXN3P2 CNV",
    "FOXN3P2 RNA"
  ],
  "RIMS3": [
    "RIMS3 CNV",
    "RIMS3 RNA"
  ],
  "C9orf64": [
    "C9orf64 CNV",
    "C9orf64 RNA",
    "C9orf64 Proteo"
  ],
  "PID1": [
    "PID1 CNV",
    "PID1 RNA"
  ],
  "CYP2C56P": [
    "CYP2C56P CNV",
    "CYP2C56P RNA"
  ],
  "RPUSD4": [
    "RPUSD4 CNV",
    "RPUSD4 RNA",
    "RPUSD4 Proteo"
  ],
  "HEXB": [
    "HEXB CNV",
    "HEXB RNA",
    "HEXB Proteo"
  ],
  "DNAJB6P5": [
    "DNAJB6P5 CNV",
    "DNAJB6P5 RNA"
  ],
  "NOSTRIN": [
    "NOSTRIN CNV",
    "NOSTRIN RNA",
    "NOSTRIN Proteo"
  ],
  "PHKBP1": [
    "PHKBP1 CNV",
    "PHKBP1 RNA"
  ],
  "CCDC89": [
    "CCDC89 CNV",
    "CCDC89 RNA"
  ],
  "SUDS3P1": [
    "SUDS3P1 CNV",
    "SUDS3P1 RNA"
  ],
  "MTND4P8": [
    "MTND4P8 CNV",
    "MTND4P8 RNA"
  ],
  "CENPL": [
    "CENPL CNV",
    "CENPL RNA",
    "CENPL Proteo"
  ],
  "FBXO9": [
    "FBXO9 CNV",
    "FBXO9 RNA",
    "FBXO9 Proteo"
  ],
  "EEF1A1P39": [
    "EEF1A1P39 CNV",
    "EEF1A1P39 RNA"
  ],
  "GTF3C3": [
    "GTF3C3 CNV",
    "GTF3C3 RNA",
    "GTF3C3 Proteo"
  ],
  "NOP53": [
    "NOP53 CNV",
    "NOP53 RNA",
    "NOP53 Proteo"
  ],
  "SPACA9": [
    "SPACA9 CNV",
    "SPACA9 RNA"
  ],
  "FNTA": [
    "FNTA CNV",
    "FNTA RNA",
    "FNTA Proteo"
  ],
  "CIDEC": [
    "CIDEC CNV",
    "CIDEC RNA"
  ],
  "SEMA5A": [
    "SEMA5A CNV",
    "SEMA5A RNA",
    "SEMA5A Proteo"
  ],
  "CDH2": [
    "CDH2 CNV",
    "CDH2 RNA",
    "CDH2 Proteo"
  ],
  "SELENON": [
    "SELENON CNV",
    "SELENON RNA",
    "SELENON Proteo"
  ],
  "PTGES3P3": [
    "PTGES3P3 CNV",
    "PTGES3P3 RNA"
  ],
  "VPS50": [
    "VPS50 CNV",
    "VPS50 RNA",
    "VPS50 Proteo"
  ],
  "RASGRF2": [
    "RASGRF2 CNV",
    "RASGRF2 RNA",
    "RASGRF2 Proteo"
  ],
  "NUP98": [
    "NUP98 CNV",
    "NUP98 RNA",
    "NUP98 Proteo"
  ],
  "ZNF98": [
    "ZNF98 CNV",
    "ZNF98 RNA"
  ],
  "OR5BA1P": [
    "OR5BA1P CNV",
    "OR5BA1P RNA"
  ],
  "ABHD12B": [
    "ABHD12B CNV",
    "ABHD12B RNA"
  ],
  "RPL21P42": [
    "RPL21P42 CNV",
    "RPL21P42 RNA"
  ],
  "TBCD": [
    "TBCD CNV",
    "TBCD RNA",
    "TBCD Proteo"
  ],
  "IGHV5-51": [
    "IGHV5-51 Proteo"
  ],
  "IFITM3P6": [
    "IFITM3P6 CNV",
    "IFITM3P6 RNA"
  ],
  "ADM5": [
    "ADM5 CNV",
    "ADM5 RNA"
  ],
  "CASK": [
    "CASK CNV",
    "CASK RNA",
    "CASK Proteo"
  ],
  "HMGN2P36": [
    "HMGN2P36 CNV",
    "HMGN2P36 RNA"
  ],
  "BPIFB3": [
    "BPIFB3 CNV",
    "BPIFB3 RNA"
  ],
  "GRIP1": [
    "GRIP1 CNV",
    "GRIP1 RNA",
    "GRIP1 Proteo"
  ],
  "ITGB1BP1": [
    "ITGB1BP1 CNV",
    "ITGB1BP1 RNA",
    "ITGB1BP1 Proteo"
  ],
  "TRIR": [
    "TRIR CNV",
    "TRIR RNA",
    "TRIR Proteo"
  ],
  "CBX8": [
    "CBX8 CNV",
    "CBX8 RNA",
    "CBX8 Proteo"
  ],
  "USP9YP6": [
    "USP9YP6 CNV",
    "USP9YP6 RNA"
  ],
  "PDCL3": [
    "PDCL3 CNV",
    "PDCL3 RNA",
    "PDCL3 Proteo"
  ],
  "PKN3": [
    "PKN3 CNV",
    "PKN3 RNA"
  ],
  "KLHL22": [
    "KLHL22 CNV",
    "KLHL22 RNA",
    "KLHL22 Proteo"
  ],
  "SETDB1": [
    "SETDB1 CNV",
    "SETDB1 RNA",
    "SETDB1 Proteo"
  ],
  "MRPS21P2": [
    "MRPS21P2 CNV",
    "MRPS21P2 RNA"
  ],
  "PDHB": [
    "PDHB CNV",
    "PDHB RNA",
    "PDHB Proteo"
  ],
  "C3": [
    "C3 CNV",
    "C3 RNA",
    "C3 Proteo"
  ],
  "CEP19P1": [
    "CEP19P1 CNV",
    "CEP19P1 RNA"
  ],
  "NOC3L": [
    "NOC3L CNV",
    "NOC3L RNA",
    "NOC3L Proteo"
  ],
  "RINT1": [
    "RINT1 CNV",
    "RINT1 RNA",
    "RINT1 Proteo"
  ],
  "PKIB": [
    "PKIB CNV",
    "PKIB RNA"
  ],
  "DISP3": [
    "DISP3 CNV",
    "DISP3 RNA"
  ],
  "RPL26P29": [
    "RPL26P29 CNV",
    "RPL26P29 RNA"
  ],
  "TNFRSF10B": [
    "TNFRSF10B CNV",
    "TNFRSF10B RNA",
    "TNFRSF10B Proteo"
  ],
  "DUSP12P1": [
    "DUSP12P1 CNV",
    "DUSP12P1 RNA"
  ],
  "SH3RF2": [
    "SH3RF2 CNV",
    "SH3RF2 RNA"
  ],
  "VN1R80P": [
    "VN1R80P CNV",
    "VN1R80P RNA"
  ],
  "TRIM55": [
    "TRIM55 CNV",
    "TRIM55 RNA"
  ],
  "LSMEM1": [
    "LSMEM1 CNV",
    "LSMEM1 RNA"
  ],
  "COA8": [
    "COA8 CNV",
    "COA8 RNA"
  ],
  "ERAP1": [
    "ERAP1 CNV",
    "ERAP1 RNA",
    "ERAP1 Proteo"
  ],
  "OR1M4P": [
    "OR1M4P CNV",
    "OR1M4P RNA"
  ],
  "PPIAP85": [
    "PPIAP85 CNV",
    "PPIAP85 RNA"
  ],
  "FAM90A6P": [
    "FAM90A6P CNV",
    "FAM90A6P RNA"
  ],
  "RBMY2TP": [
    "RBMY2TP CNV",
    "RBMY2TP RNA"
  ],
  "NFU1": [
    "NFU1 CNV",
    "NFU1 RNA",
    "NFU1 Proteo"
  ],
  "FFAR1": [
    "FFAR1 CNV",
    "FFAR1 RNA"
  ],
  "TEK": [
    "TEK CNV",
    "TEK RNA"
  ],
  "SOX8": [
    "SOX8 CNV",
    "SOX8 RNA",
    "SOX8 Proteo"
  ],
  "RPL37P4": [
    "RPL37P4 CNV",
    "RPL37P4 RNA"
  ],
  "GALNT3": [
    "GALNT3 CNV",
    "GALNT3 RNA",
    "GALNT3 Proteo"
  ],
  "DGKG": [
    "DGKG CNV",
    "DGKG RNA"
  ],
  "CEP57": [
    "CEP57 CNV",
    "CEP57 RNA",
    "CEP57 Proteo"
  ],
  "NDUFA3": [
    "NDUFA3 CNV",
    "NDUFA3 RNA",
    "NDUFA3 Proteo"
  ],
  "SDAD1P3": [
    "SDAD1P3 CNV",
    "SDAD1P3 RNA"
  ],
  "ZMIZ1": [
    "ZMIZ1 CNV",
    "ZMIZ1 RNA",
    "ZMIZ1 Proteo"
  ],
  "RPS20P5": [
    "RPS20P5 CNV",
    "RPS20P5 RNA"
  ],
  "HSPD1P5": [
    "HSPD1P5 CNV",
    "HSPD1P5 RNA"
  ],
  "CNKSR2": [
    "CNKSR2 CNV",
    "CNKSR2 RNA",
    "CNKSR2 Proteo"
  ],
  "IGLV3-1": [
    "IGLV3-1 Proteo"
  ],
  "SLC25A15P3": [
    "SLC25A15P3 CNV",
    "SLC25A15P3 RNA"
  ],
  "SRSF6P1": [
    "SRSF6P1 CNV",
    "SRSF6P1 RNA"
  ],
  "UPB1": [
    "UPB1 CNV",
    "UPB1 RNA",
    "UPB1 Proteo"
  ],
  "PDPR2P": [
    "PDPR2P CNV",
    "PDPR2P RNA"
  ],
  "NR2F6": [
    "NR2F6 CNV",
    "NR2F6 RNA",
    "NR2F6 Proteo"
  ],
  "SSXP3": [
    "SSXP3 CNV",
    "SSXP3 RNA"
  ],
  "GABRB1": [
    "GABRB1 CNV",
    "GABRB1 RNA"
  ],
  "MAP3K15": [
    "MAP3K15 CNV",
    "MAP3K15 RNA"
  ],
  "LRRC25": [
    "LRRC25 CNV",
    "LRRC25 RNA",
    "LRRC25 Proteo"
  ],
  "MTHFD1P1": [
    "MTHFD1P1 CNV",
    "MTHFD1P1 RNA"
  ],
  "PMS2P4": [
    "PMS2P4 CNV",
    "PMS2P4 RNA"
  ],
  "ATAD5": [
    "ATAD5 CNV",
    "ATAD5 RNA",
    "ATAD5 Proteo"
  ],
  "TNFRSF18": [
    "TNFRSF18 CNV",
    "TNFRSF18 RNA",
    "TNFRSF18 Proteo"
  ],
  "ATP5PB": [
    "ATP5PB CNV",
    "ATP5PB RNA",
    "ATP5PB Proteo"
  ],
  "BASP1P1": [
    "BASP1P1 CNV",
    "BASP1P1 RNA"
  ],
  "ZRANB3": [
    "ZRANB3 CNV",
    "ZRANB3 RNA",
    "ZRANB3 Proteo"
  ],
  "GTPBP8": [
    "GTPBP8 CNV",
    "GTPBP8 RNA",
    "GTPBP8 Proteo"
  ],
  "UROC1": [
    "UROC1 CNV",
    "UROC1 RNA"
  ],
  "IFNA14": [
    "IFNA14 CNV",
    "IFNA14 RNA"
  ],
  "ICAM4": [
    "ICAM4 CNV",
    "ICAM4 RNA"
  ],
  "FECHP1": [
    "FECHP1 CNV",
    "FECHP1 RNA"
  ],
  "PAICSP6": [
    "PAICSP6 CNV",
    "PAICSP6 RNA"
  ],
  "IGHV3-38": [
    "IGHV3-38 Proteo"
  ],
  "OGFOD2": [
    "OGFOD2 CNV",
    "OGFOD2 RNA",
    "OGFOD2 Proteo"
  ],
  "CDKAL1": [
    "CDKAL1 CNV",
    "CDKAL1 RNA",
    "CDKAL1 Proteo"
  ],
  "GAD3P": [
    "GAD3P CNV",
    "GAD3P RNA"
  ],
  "KMT2CP1": [
    "KMT2CP1 CNV",
    "KMT2CP1 RNA"
  ],
  "CLXN": [
    "CLXN CNV",
    "CLXN RNA"
  ],
  "BLZF2P": [
    "BLZF2P CNV",
    "BLZF2P RNA"
  ],
  "CCL21": [
    "CCL21 CNV",
    "CCL21 RNA",
    "CCL21 Proteo"
  ],
  "GRIN3B": [
    "GRIN3B CNV",
    "GRIN3B RNA"
  ],
  "GARIN6": [
    "GARIN6 CNV",
    "GARIN6 RNA"
  ],
  "ATP1A3": [
    "ATP1A3 CNV",
    "ATP1A3 RNA",
    "ATP1A3 Proteo"
  ],
  "PLA2G10": [
    "PLA2G10 CNV",
    "PLA2G10 RNA"
  ],
  "ABCC3": [
    "ABCC3 CNV",
    "ABCC3 RNA",
    "ABCC3 Proteo"
  ],
  "HMGB1P1": [
    "HMGB1P1 CNV",
    "HMGB1P1 RNA"
  ],
  "PCDHB4": [
    "PCDHB4 CNV",
    "PCDHB4 RNA"
  ],
  "GZMA": [
    "GZMA CNV",
    "GZMA RNA",
    "GZMA Proteo"
  ],
  "SRP19": [
    "SRP19 CNV",
    "SRP19 RNA",
    "SRP19 Proteo"
  ],
  "RPL13AP5": [
    "RPL13AP5 CNV",
    "RPL13AP5 RNA"
  ],
  "THAP9": [
    "THAP9 CNV",
    "THAP9 RNA",
    "THAP9 Proteo"
  ],
  "ING3": [
    "ING3 CNV",
    "ING3 RNA",
    "ING3 Proteo"
  ],
  "C20orf27": [
    "C20orf27 CNV",
    "C20orf27 RNA",
    "C20orf27 Proteo"
  ],
  "NBDY": [
    "NBDY CNV",
    "NBDY RNA",
    "NBDY Proteo"
  ],
  "LINGO1": [
    "LINGO1 CNV",
    "LINGO1 RNA",
    "LINGO1 Proteo"
  ],
  "GPD2": [
    "GPD2 CNV",
    "GPD2 RNA",
    "GPD2 Proteo"
  ],
  "GFPT2": [
    "GFPT2 CNV",
    "GFPT2 RNA",
    "GFPT2 Proteo"
  ],
  "NHP2P1": [
    "NHP2P1 CNV",
    "NHP2P1 RNA"
  ],
  "FAM234A": [
    "FAM234A CNV",
    "FAM234A RNA",
    "FAM234A Proteo"
  ],
  "ANKRD34C": [
    "ANKRD34C CNV",
    "ANKRD34C RNA"
  ],
  "GTF2H2": [
    "GTF2H2 CNV",
    "GTF2H2 RNA",
    "GTF2H2 Proteo"
  ],
  "GPBP1L1": [
    "GPBP1L1 CNV",
    "GPBP1L1 RNA",
    "GPBP1L1 Proteo"
  ],
  "SEC61A2": [
    "SEC61A2 CNV",
    "SEC61A2 RNA",
    "SEC61A2 Proteo"
  ],
  "TOMM22P6": [
    "TOMM22P6 CNV",
    "TOMM22P6 RNA"
  ],
  "PKDREJ": [
    "PKDREJ CNV",
    "PKDREJ RNA"
  ],
  "CFAP20": [
    "CFAP20 CNV",
    "CFAP20 RNA",
    "CFAP20 Proteo"
  ],
  "FRG2IP": [
    "FRG2IP CNV",
    "FRG2IP RNA"
  ],
  "WDR81": [
    "WDR81 CNV",
    "WDR81 RNA",
    "WDR81 Proteo"
  ],
  "AP1B1P2": [
    "AP1B1P2 CNV",
    "AP1B1P2 RNA"
  ],
  "MGAT2": [
    "MGAT2 CNV",
    "MGAT2 RNA",
    "MGAT2 Proteo"
  ],
  "HMGN1P7": [
    "HMGN1P7 CNV",
    "HMGN1P7 RNA"
  ],
  "SUPT5H": [
    "SUPT5H CNV",
    "SUPT5H RNA",
    "SUPT5H Proteo"
  ],
  "ROBO1": [
    "ROBO1 CNV",
    "ROBO1 RNA",
    "ROBO1 Proteo"
  ],
  "THEGL": [
    "THEGL CNV",
    "THEGL RNA"
  ],
  "CYP2D6": [
    "CYP2D6 CNV",
    "CYP2D6 RNA"
  ],
  "SMIM14": [
    "SMIM14 CNV",
    "SMIM14 RNA"
  ],
  "ADAMTS6": [
    "ADAMTS6 CNV",
    "ADAMTS6 RNA"
  ],
  "ANKRD49P4": [
    "ANKRD49P4 CNV",
    "ANKRD49P4 RNA"
  ],
  "DUXB": [
    "DUXB CNV",
    "DUXB RNA"
  ],
  "TMCO2": [
    "TMCO2 CNV",
    "TMCO2 RNA"
  ],
  "RPL17P14": [
    "RPL17P14 CNV",
    "RPL17P14 RNA"
  ],
  "RBMY2YP": [
    "RBMY2YP CNV",
    "RBMY2YP RNA"
  ],
  "MMP20": [
    "MMP20 CNV",
    "MMP20 RNA"
  ],
  "OR2C3": [
    "OR2C3 CNV",
    "OR2C3 RNA"
  ],
  "UTP6": [
    "UTP6 CNV",
    "UTP6 RNA",
    "UTP6 Proteo"
  ],
  "MYO1C": [
    "MYO1C CNV",
    "MYO1C RNA",
    "MYO1C Proteo"
  ],
  "SNRPGP5": [
    "SNRPGP5 CNV",
    "SNRPGP5 RNA"
  ],
  "MTND4LP1": [
    "MTND4LP1 CNV",
    "MTND4LP1 RNA"
  ],
  "H2BC19P": [
    "H2BC19P CNV",
    "H2BC19P RNA"
  ],
  "BOLA3P2": [
    "BOLA3P2 CNV",
    "BOLA3P2 RNA"
  ],
  "SMARCD3": [
    "SMARCD3 CNV",
    "SMARCD3 RNA",
    "SMARCD3 Proteo"
  ],
  "PTCRA": [
    "PTCRA CNV",
    "PTCRA RNA"
  ],
  "DCAF5": [
    "DCAF5 CNV",
    "DCAF5 RNA",
    "DCAF5 Proteo"
  ],
  "ALOX12P2": [
    "ALOX12P2 CNV",
    "ALOX12P2 RNA"
  ],
  "TMEM52B": [
    "TMEM52B CNV",
    "TMEM52B RNA"
  ],
  "TPSD1": [
    "TPSD1 CNV",
    "TPSD1 RNA"
  ],
  "METTL7B": [
    "METTL7B CNV",
    "METTL7B RNA",
    "METTL7B Proteo"
  ],
  "CCDC71": [
    "CCDC71 CNV",
    "CCDC71 RNA",
    "CCDC71 Proteo"
  ],
  "BTBD9": [
    "BTBD9 CNV",
    "BTBD9 RNA",
    "BTBD9 Proteo"
  ],
  "SLC25A18P1": [
    "SLC25A18P1 CNV",
    "SLC25A18P1 RNA"
  ],
  "RPL7AP37": [
    "RPL7AP37 CNV",
    "RPL7AP37 RNA"
  ],
  "IGFL1P1": [
    "IGFL1P1 CNV",
    "IGFL1P1 RNA"
  ],
  "OSBPL6": [
    "OSBPL6 CNV",
    "OSBPL6 RNA",
    "OSBPL6 Proteo"
  ],
  "CTPS2": [
    "CTPS2 CNV",
    "CTPS2 RNA",
    "CTPS2 Proteo"
  ],
  "ANGPTL5": [
    "ANGPTL5 CNV",
    "ANGPTL5 RNA",
    "ANGPTL5 Proteo"
  ],
  "CSPG4P13": [
    "CSPG4P13 CNV",
    "CSPG4P13 RNA"
  ],
  "ATP6V0E1P3": [
    "ATP6V0E1P3 CNV",
    "ATP6V0E1P3 RNA"
  ],
  "RANBP9": [
    "RANBP9 CNV",
    "RANBP9 RNA",
    "RANBP9 Proteo"
  ],
  "TXNRD1": [
    "TXNRD1 CNV",
    "TXNRD1 RNA",
    "TXNRD1 Proteo"
  ],
  "UFM1P2": [
    "UFM1P2 CNV",
    "UFM1P2 RNA"
  ],
  "C11orf58": [
    "C11orf58 CNV",
    "C11orf58 RNA",
    "C11orf58 Proteo"
  ],
  "CT83": [
    "CT83 CNV",
    "CT83 RNA",
    "CT83 Proteo"
  ],
  "FBXO30": [
    "FBXO30 CNV",
    "FBXO30 RNA",
    "FBXO30 Proteo"
  ],
  "OST4": [
    "OST4 CNV",
    "OST4 RNA"
  ],
  "MX2": [
    "MX2 CNV",
    "MX2 RNA",
    "MX2 Proteo"
  ],
  "SLC2A13P1": [
    "SLC2A13P1 CNV",
    "SLC2A13P1 RNA"
  ],
  "LIF": [
    "LIF CNV",
    "LIF RNA"
  ],
  "OR1J4": [
    "OR1J4 CNV",
    "OR1J4 RNA"
  ],
  "PDGFB": [
    "PDGFB CNV",
    "PDGFB RNA",
    "PDGFB Proteo"
  ],
  "EPAS1": [
    "EPAS1 CNV",
    "EPAS1 RNA"
  ],
  "ASPN": [
    "ASPN CNV",
    "ASPN RNA",
    "ASPN Proteo"
  ],
  "POU5F1P4": [
    "POU5F1P4 CNV",
    "POU5F1P4 RNA"
  ],
  "EPB41": [
    "EPB41 CNV",
    "EPB41 RNA",
    "EPB41 Proteo"
  ],
  "CHAC1": [
    "CHAC1 CNV",
    "CHAC1 RNA"
  ],
  "KLK2": [
    "KLK2 CNV",
    "KLK2 RNA"
  ],
  "HSPE1": [
    "HSPE1 CNV",
    "HSPE1 RNA",
    "HSPE1 Proteo"
  ],
  "ZNF736P7Y": [
    "ZNF736P7Y CNV",
    "ZNF736P7Y RNA"
  ],
  "RPL23AP96": [
    "RPL23AP96 CNV",
    "RPL23AP96 RNA"
  ],
  "SLC39A2": [
    "SLC39A2 CNV",
    "SLC39A2 RNA"
  ],
  "MTND1P34": [
    "MTND1P34 CNV",
    "MTND1P34 RNA"
  ],
  "SDR42E1P2": [
    "SDR42E1P2 CNV",
    "SDR42E1P2 RNA"
  ],
  "BCKDHA": [
    "BCKDHA CNV",
    "BCKDHA RNA",
    "BCKDHA Proteo"
  ],
  "STK19B": [
    "STK19B CNV",
    "STK19B RNA"
  ],
  "CYSLTR2": [
    "CYSLTR2 CNV",
    "CYSLTR2 RNA"
  ],
  "RNA5SP43": [
    "RNA5SP43 CNV",
    "RNA5SP43 RNA"
  ],
  "IVD": [
    "IVD CNV",
    "IVD RNA",
    "IVD Proteo"
  ],
  "HAT1": [
    "HAT1 CNV",
    "HAT1 RNA",
    "HAT1 Proteo"
  ],
  "PTPRS": [
    "PTPRS CNV",
    "PTPRS RNA",
    "PTPRS Proteo"
  ],
  "ABCC13": [
    "ABCC13 CNV",
    "ABCC13 RNA"
  ],
  "NKAIN2": [
    "NKAIN2 CNV",
    "NKAIN2 RNA"
  ],
  "ILKAP": [
    "ILKAP CNV",
    "ILKAP RNA",
    "ILKAP Proteo"
  ],
  "GOLGA8B": [
    "GOLGA8B CNV",
    "GOLGA8B RNA",
    "GOLGA8B Proteo"
  ],
  "HEY2": [
    "HEY2 CNV",
    "HEY2 RNA"
  ],
  "RABEP1": [
    "RABEP1 CNV",
    "RABEP1 RNA",
    "RABEP1 Proteo"
  ],
  "RPS10P18": [
    "RPS10P18 CNV",
    "RPS10P18 RNA"
  ],
  "GAMT": [
    "GAMT CNV",
    "GAMT RNA",
    "GAMT Proteo"
  ],
  "ZFP3": [
    "ZFP3 CNV",
    "ZFP3 RNA",
    "ZFP3 Proteo"
  ],
  "FANCL": [
    "FANCL CNV",
    "FANCL RNA",
    "FANCL Proteo"
  ],
  "ASMTL": [
    "ASMTL CNV",
    "ASMTL RNA",
    "ASMTL Proteo"
  ],
  "CLUHP4": [
    "CLUHP4 CNV",
    "CLUHP4 RNA"
  ],
  "NMNAT2": [
    "NMNAT2 CNV",
    "NMNAT2 RNA"
  ],
  "ALLC": [
    "ALLC CNV",
    "ALLC RNA"
  ],
  "GNPNAT1": [
    "GNPNAT1 CNV",
    "GNPNAT1 RNA",
    "GNPNAT1 Proteo"
  ],
  "GTF3AP5": [
    "GTF3AP5 CNV",
    "GTF3AP5 RNA"
  ],
  "RSC1A1": [
    "RSC1A1 CNV",
    "RSC1A1 RNA"
  ],
  "MTHFR": [
    "MTHFR CNV",
    "MTHFR RNA",
    "MTHFR Proteo"
  ],
  "RPL28P2": [
    "RPL28P2 CNV",
    "RPL28P2 RNA"
  ],
  "CCM2": [
    "CCM2 CNV",
    "CCM2 RNA",
    "CCM2 Proteo"
  ],
  "AGAP9": [
    "AGAP9 CNV",
    "AGAP9 RNA"
  ],
  "PGBD4P1": [
    "PGBD4P1 CNV",
    "PGBD4P1 RNA"
  ],
  "UOX": [
    "UOX CNV",
    "UOX RNA"
  ],
  "CFP": [
    "CFP CNV",
    "CFP RNA",
    "CFP Proteo"
  ],
  "ARID5A": [
    "ARID5A CNV",
    "ARID5A RNA",
    "ARID5A Proteo"
  ],
  "IDH3A": [
    "IDH3A CNV",
    "IDH3A RNA",
    "IDH3A Proteo"
  ],
  "SPANXN1": [
    "SPANXN1 CNV",
    "SPANXN1 RNA"
  ],
  "PTMAP3": [
    "PTMAP3 CNV",
    "PTMAP3 RNA"
  ],
  "GPR31": [
    "GPR31 CNV",
    "GPR31 RNA"
  ],
  "ERVV-1": [
    "ERVV-1 CNV",
    "ERVV-1 RNA"
  ],
  "HMGB1P9": [
    "HMGB1P9 CNV",
    "HMGB1P9 RNA"
  ],
  "TP53INP1": [
    "TP53INP1 CNV",
    "TP53INP1 RNA"
  ],
  "IGLV3-15": [
    "IGLV3-15 CNV",
    "IGLV3-15 RNA"
  ],
  "DKK4": [
    "DKK4 CNV",
    "DKK4 RNA"
  ],
  "RPS27": [
    "RPS27 CNV",
    "RPS27 RNA",
    "RPS27 Proteo"
  ],
  "CEP63": [
    "CEP63 CNV",
    "CEP63 RNA",
    "CEP63 Proteo"
  ],
  "LMOD2": [
    "LMOD2 CNV",
    "LMOD2 RNA"
  ],
  "KRT80": [
    "KRT80 CNV",
    "KRT80 RNA",
    "KRT80 Proteo"
  ],
  "WDR13": [
    "WDR13 CNV",
    "WDR13 RNA",
    "WDR13 Proteo"
  ],
  "DEFB131C": [
    "DEFB131C CNV",
    "DEFB131C RNA"
  ],
  "RRM2B": [
    "RRM2B CNV",
    "RRM2B RNA",
    "RRM2B Proteo"
  ],
  "ZNF285BP": [
    "ZNF285BP CNV",
    "ZNF285BP RNA"
  ],
  "RPL36AP17": [
    "RPL36AP17 CNV",
    "RPL36AP17 RNA"
  ],
  "CNTNAP3P5": [
    "CNTNAP3P5 CNV",
    "CNTNAP3P5 RNA"
  ],
  "RPS26P30": [
    "RPS26P30 CNV",
    "RPS26P30 RNA"
  ],
  "PFKFB3": [
    "PFKFB3 CNV",
    "PFKFB3 RNA",
    "PFKFB3 Proteo"
  ],
  "AACS": [
    "AACS CNV",
    "AACS RNA",
    "AACS Proteo"
  ],
  "IGFBP7": [
    "IGFBP7 CNV",
    "IGFBP7 RNA",
    "IGFBP7 Proteo"
  ],
  "OR5H3P": [
    "OR5H3P CNV",
    "OR5H3P RNA"
  ],
  "EEF1A1P28": [
    "EEF1A1P28 CNV",
    "EEF1A1P28 RNA"
  ],
  "IRS3P": [
    "IRS3P CNV",
    "IRS3P RNA"
  ],
  "RPL6P9": [
    "RPL6P9 CNV",
    "RPL6P9 RNA"
  ],
  "CTH": [
    "CTH CNV",
    "CTH RNA",
    "CTH Proteo"
  ],
  "ANGPT1": [
    "ANGPT1 CNV",
    "ANGPT1 RNA",
    "ANGPT1 Proteo"
  ],
  "TRAPPC10": [
    "TRAPPC10 CNV",
    "TRAPPC10 RNA",
    "TRAPPC10 Proteo"
  ],
  "PRMT5P1": [
    "PRMT5P1 CNV",
    "PRMT5P1 RNA"
  ],
  "DNM1P46": [
    "DNM1P46 CNV",
    "DNM1P46 RNA"
  ],
  "RPL5P34": [
    "RPL5P34 CNV",
    "RPL5P34 RNA"
  ],
  "STAU1": [
    "STAU1 CNV",
    "STAU1 RNA",
    "STAU1 Proteo"
  ],
  "DUXAP11": [
    "DUXAP11 CNV",
    "DUXAP11 RNA"
  ],
  "PKM": [
    "PKM CNV",
    "PKM RNA",
    "PKM Proteo"
  ],
  "GCDH": [
    "GCDH CNV",
    "GCDH RNA",
    "GCDH Proteo"
  ],
  "CRLF3P2": [
    "CRLF3P2 CNV",
    "CRLF3P2 RNA"
  ],
  "OR7E158P": [
    "OR7E158P CNV",
    "OR7E158P RNA"
  ],
  "SEMA4G": [
    "SEMA4G CNV",
    "SEMA4G RNA"
  ],
  "NIPA1": [
    "NIPA1 CNV",
    "NIPA1 RNA",
    "NIPA1 Proteo"
  ],
  "PSME2P4": [
    "PSME2P4 CNV",
    "PSME2P4 RNA"
  ],
  "TEAD2": [
    "TEAD2 CNV",
    "TEAD2 RNA",
    "TEAD2 Proteo"
  ],
  "PNRC2": [
    "PNRC2 CNV",
    "PNRC2 RNA"
  ],
  "RIMOC1": [
    "RIMOC1 CNV",
    "RIMOC1 RNA",
    "RIMOC1 Proteo"
  ],
  "CLDN12": [
    "CLDN12 CNV",
    "CLDN12 RNA",
    "CLDN12 Proteo"
  ],
  "SAMSN1": [
    "SAMSN1 CNV",
    "SAMSN1 RNA",
    "SAMSN1 Proteo"
  ],
  "BHLHE41": [
    "BHLHE41 CNV",
    "BHLHE41 RNA",
    "BHLHE41 Proteo"
  ],
  "SLC6A20": [
    "SLC6A20 CNV",
    "SLC6A20 RNA"
  ],
  "HSFY6P": [
    "HSFY6P CNV",
    "HSFY6P RNA"
  ],
  "MTND3P20": [
    "MTND3P20 CNV",
    "MTND3P20 RNA"
  ],
  "RPL5P32": [
    "RPL5P32 CNV",
    "RPL5P32 RNA"
  ],
  "XPR1": [
    "XPR1 CNV",
    "XPR1 RNA",
    "XPR1 Proteo"
  ],
  "NPIPA1": [
    "NPIPA1 CNV",
    "NPIPA1 RNA"
  ],
  "ACTA1": [
    "ACTA1 CNV",
    "ACTA1 RNA",
    "ACTA1 Proteo"
  ],
  "BMP4": [
    "BMP4 CNV",
    "BMP4 RNA"
  ],
  "ZBTB12BP": [
    "ZBTB12BP CNV",
    "ZBTB12BP RNA"
  ],
  "AR": [
    "AR CNV",
    "AR RNA"
  ],
  "STAR": [
    "STAR CNV",
    "STAR RNA"
  ],
  "HDAC10": [
    "HDAC10 CNV",
    "HDAC10 RNA",
    "HDAC10 Proteo"
  ],
  "SSH1": [
    "SSH1 CNV",
    "SSH1 RNA",
    "SSH1 Proteo"
  ],
  "KLC3": [
    "KLC3 CNV",
    "KLC3 RNA",
    "KLC3 Proteo"
  ],
  "PEX13": [
    "PEX13 CNV",
    "PEX13 RNA",
    "PEX13 Proteo"
  ],
  "TSPY24P": [
    "TSPY24P CNV",
    "TSPY24P RNA"
  ],
  "ARMC8": [
    "ARMC8 CNV",
    "ARMC8 RNA",
    "ARMC8 Proteo"
  ],
  "ABCD1P2": [
    "ABCD1P2 CNV",
    "ABCD1P2 RNA"
  ],
  "RNA5SP390": [
    "RNA5SP390 CNV",
    "RNA5SP390 RNA"
  ],
  "RBM22P7": [
    "RBM22P7 CNV",
    "RBM22P7 RNA"
  ],
  "KRT8P49": [
    "KRT8P49 CNV",
    "KRT8P49 RNA"
  ],
  "CSF2RBP1": [
    "CSF2RBP1 CNV",
    "CSF2RBP1 RNA"
  ],
  "AGGF1P1": [
    "AGGF1P1 CNV",
    "AGGF1P1 RNA"
  ],
  "RPL12P22": [
    "RPL12P22 CNV",
    "RPL12P22 RNA"
  ],
  "METTL6": [
    "METTL6 CNV",
    "METTL6 RNA",
    "METTL6 Proteo"
  ],
  "CYB5RL": [
    "CYB5RL CNV",
    "CYB5RL RNA"
  ],
  "BMP2": [
    "BMP2 CNV",
    "BMP2 RNA"
  ],
  "CSTPP1": [
    "CSTPP1 CNV",
    "CSTPP1 RNA"
  ],
  "NACAP10": [
    "NACAP10 CNV",
    "NACAP10 RNA"
  ],
  "PFKL": [
    "PFKL CNV",
    "PFKL RNA",
    "PFKL Proteo"
  ],
  "POLG": [
    "POLG CNV",
    "POLG RNA",
    "POLG Proteo"
  ],
  "VPS26C": [
    "VPS26C CNV",
    "VPS26C RNA",
    "VPS26C Proteo"
  ],
  "FRS2": [
    "FRS2 CNV",
    "FRS2 RNA",
    "FRS2 Proteo"
  ],
  "PAEPP1": [
    "PAEPP1 CNV",
    "PAEPP1 RNA"
  ],
  "GPR65": [
    "GPR65 CNV",
    "GPR65 RNA"
  ],
  "ANKRD13B": [
    "ANKRD13B CNV",
    "ANKRD13B RNA",
    "ANKRD13B Proteo"
  ],
  "PERP": [
    "PERP CNV",
    "PERP RNA",
    "PERP Proteo"
  ],
  "PPP1R8": [
    "PPP1R8 CNV",
    "PPP1R8 RNA",
    "PPP1R8 Proteo"
  ],
  "RNA5SP286": [
    "RNA5SP286 CNV",
    "RNA5SP286 RNA"
  ],
  "CHORDC1": [
    "CHORDC1 CNV",
    "CHORDC1 RNA",
    "CHORDC1 Proteo"
  ],
  "SEC11B": [
    "SEC11B CNV",
    "SEC11B RNA"
  ],
  "CCNQ": [
    "CCNQ CNV",
    "CCNQ RNA",
    "CCNQ Proteo"
  ],
  "DHRS13": [
    "DHRS13 CNV",
    "DHRS13 RNA",
    "DHRS13 Proteo"
  ],
  "HNRNPA1P2": [
    "HNRNPA1P2 CNV",
    "HNRNPA1P2 RNA"
  ],
  "SAC3D1": [
    "SAC3D1 CNV",
    "SAC3D1 RNA",
    "SAC3D1 Proteo"
  ],
  "AKR1B15": [
    "AKR1B15 CNV",
    "AKR1B15 RNA"
  ],
  "PHLDA3": [
    "PHLDA3 CNV",
    "PHLDA3 RNA",
    "PHLDA3 Proteo"
  ],
  "RNA5SP458": [
    "RNA5SP458 CNV",
    "RNA5SP458 RNA"
  ],
  "KRT8P4": [
    "KRT8P4 CNV",
    "KRT8P4 RNA"
  ],
  "RAPSN": [
    "RAPSN CNV",
    "RAPSN RNA"
  ],
  "PSMB3P1": [
    "PSMB3P1 CNV",
    "PSMB3P1 RNA"
  ],
  "CD8B": [
    "CD8B CNV",
    "CD8B RNA",
    "CD8B Proteo"
  ],
  "FUNDC2P2": [
    "FUNDC2P2 CNV",
    "FUNDC2P2 RNA"
  ],
  "AOC2": [
    "AOC2 CNV",
    "AOC2 RNA"
  ],
  "CCDC88C": [
    "CCDC88C CNV",
    "CCDC88C RNA",
    "CCDC88C Proteo"
  ],
  "SLTM": [
    "SLTM CNV",
    "SLTM RNA",
    "SLTM Proteo"
  ],
  "TCEAL8": [
    "TCEAL8 CNV",
    "TCEAL8 RNA",
    "TCEAL8 Proteo"
  ],
  "PDE4DIPP7": [
    "PDE4DIPP7 CNV",
    "PDE4DIPP7 RNA"
  ],
  "CDYL2": [
    "CDYL2 CNV",
    "CDYL2 RNA",
    "CDYL2 Proteo"
  ],
  "CDY18P": [
    "CDY18P CNV",
    "CDY18P RNA"
  ],
  "FAM133B": [
    "FAM133B CNV",
    "FAM133B RNA",
    "FAM133B Proteo"
  ],
  "PA2G4P3": [
    "PA2G4P3 CNV",
    "PA2G4P3 RNA"
  ],
  "NIPBL": [
    "NIPBL CNV",
    "NIPBL RNA",
    "NIPBL Proteo"
  ],
  "OR7E21P": [
    "OR7E21P CNV",
    "OR7E21P RNA"
  ],
  "PTPRU": [
    "PTPRU CNV",
    "PTPRU RNA",
    "PTPRU Proteo"
  ],
  "FGB": [
    "FGB CNV",
    "FGB RNA",
    "FGB Proteo"
  ],
  "OR5M8": [
    "OR5M8 CNV",
    "OR5M8 RNA"
  ],
  "SLC6A6P1": [
    "SLC6A6P1 CNV",
    "SLC6A6P1 RNA"
  ],
  "CNTNAP3P1": [
    "CNTNAP3P1 CNV",
    "CNTNAP3P1 RNA"
  ],
  "IL17F": [
    "IL17F CNV",
    "IL17F RNA"
  ],
  "EOLA1": [
    "EOLA1 CNV",
    "EOLA1 RNA",
    "EOLA1 Proteo"
  ],
  "RAB5B": [
    "RAB5B CNV",
    "RAB5B RNA",
    "RAB5B Proteo"
  ],
  "SCAMP2": [
    "SCAMP2 CNV",
    "SCAMP2 RNA",
    "SCAMP2 Proteo"
  ],
  "CPT1A": [
    "CPT1A CNV",
    "CPT1A RNA",
    "CPT1A Proteo"
  ],
  "TPT1P4": [
    "TPT1P4 CNV",
    "TPT1P4 RNA"
  ],
  "DPM1": [
    "DPM1 CNV",
    "DPM1 RNA",
    "DPM1 Proteo"
  ],
  "BICD1": [
    "BICD1 CNV",
    "BICD1 RNA",
    "BICD1 Proteo"
  ],
  "B_Cells": [
    "B_Cells Cell_type"
  ],
  "WNT5B": [
    "WNT5B CNV",
    "WNT5B RNA"
  ],
  "PSG11": [
    "PSG11 CNV",
    "PSG11 RNA"
  ],
  "METTL26": [
    "METTL26 CNV",
    "METTL26 RNA",
    "METTL26 Proteo"
  ],
  "KLHL23": [
    "KLHL23 CNV",
    "KLHL23 RNA"
  ],
  "SERBP1P6": [
    "SERBP1P6 CNV",
    "SERBP1P6 RNA"
  ],
  "EIF4A1P3": [
    "EIF4A1P3 CNV",
    "EIF4A1P3 RNA"
  ],
  "CD52": [
    "CD52 CNV",
    "CD52 RNA"
  ],
  "CCZ1": [
    "CCZ1 CNV",
    "CCZ1 RNA"
  ],
  "ASF1A": [
    "ASF1A CNV",
    "ASF1A RNA",
    "ASF1A Proteo"
  ],
  "THBS4": [
    "THBS4 CNV",
    "THBS4 RNA",
    "THBS4 Proteo"
  ],
  "GAS6": [
    "GAS6 CNV",
    "GAS6 RNA",
    "GAS6 Proteo"
  ],
  "KCNQ3": [
    "KCNQ3 CNV",
    "KCNQ3 RNA"
  ],
  "AVPR1B": [
    "AVPR1B CNV",
    "AVPR1B RNA"
  ],
  "ICOSLG": [
    "ICOSLG CNV",
    "ICOSLG RNA",
    "ICOSLG Proteo"
  ],
  "CA8": [
    "CA8 CNV",
    "CA8 RNA",
    "CA8 Proteo"
  ],
  "CBR4": [
    "CBR4 CNV",
    "CBR4 RNA",
    "CBR4 Proteo"
  ],
  "POMPP1": [
    "POMPP1 CNV",
    "POMPP1 RNA"
  ],
  "CENPNP2": [
    "CENPNP2 CNV",
    "CENPNP2 RNA"
  ],
  "PARP15": [
    "PARP15 CNV",
    "PARP15 RNA"
  ],
  "NOP58": [
    "NOP58 CNV",
    "NOP58 RNA",
    "NOP58 Proteo"
  ],
  "TMEM89": [
    "TMEM89 CNV",
    "TMEM89 RNA"
  ],
  "RPL12P19": [
    "RPL12P19 CNV",
    "RPL12P19 RNA"
  ],
  "NPPC": [
    "NPPC CNV",
    "NPPC RNA"
  ],
  "CDK2AP1": [
    "CDK2AP1 CNV",
    "CDK2AP1 RNA",
    "CDK2AP1 Proteo"
  ],
  "PSMB2": [
    "PSMB2 CNV",
    "PSMB2 RNA",
    "PSMB2 Proteo"
  ],
  "CIBAR1P2": [
    "CIBAR1P2 CNV",
    "CIBAR1P2 RNA"
  ],
  "NDUFA8P1": [
    "NDUFA8P1 CNV",
    "NDUFA8P1 RNA"
  ],
  "SSU72P3": [
    "SSU72P3 CNV",
    "SSU72P3 RNA"
  ],
  "CHMP1B2P": [
    "CHMP1B2P CNV",
    "CHMP1B2P RNA"
  ],
  "TBC1D8B": [
    "TBC1D8B CNV",
    "TBC1D8B RNA",
    "TBC1D8B Proteo"
  ],
  "RPS27P29": [
    "RPS27P29 CNV",
    "RPS27P29 RNA"
  ],
  "ADGRF3": [
    "ADGRF3 CNV",
    "ADGRF3 RNA"
  ],
  "SDHAF4": [
    "SDHAF4 CNV",
    "SDHAF4 RNA",
    "SDHAF4 Proteo"
  ],
  "FAM20B": [
    "FAM20B CNV",
    "FAM20B RNA",
    "FAM20B Proteo"
  ],
  "NF1P7": [
    "NF1P7 CNV",
    "NF1P7 RNA"
  ],
  "AADACP1": [
    "AADACP1 CNV",
    "AADACP1 RNA"
  ],
  "CDK20": [
    "CDK20 CNV",
    "CDK20 RNA",
    "CDK20 Proteo"
  ],
  "PPIAP84": [
    "PPIAP84 CNV",
    "PPIAP84 RNA"
  ],
  "E2F8": [
    "E2F8 CNV",
    "E2F8 RNA",
    "E2F8 Proteo"
  ],
  "GCNT4": [
    "GCNT4 CNV",
    "GCNT4 RNA"
  ],
  "FOXK2": [
    "FOXK2 CNV",
    "FOXK2 RNA",
    "FOXK2 Proteo"
  ],
  "YJU2": [
    "YJU2 CNV",
    "YJU2 RNA",
    "YJU2 Proteo"
  ],
  "MACIR": [
    "MACIR CNV",
    "MACIR RNA",
    "MACIR Proteo"
  ],
  "RPS5": [
    "RPS5 CNV",
    "RPS5 RNA",
    "RPS5 Proteo"
  ],
  "OAT": [
    "OAT CNV",
    "OAT RNA",
    "OAT Proteo"
  ],
  "RNPS1": [
    "RNPS1 CNV",
    "RNPS1 RNA",
    "RNPS1 Proteo"
  ],
  "ZMAT3": [
    "ZMAT3 CNV",
    "ZMAT3 RNA",
    "ZMAT3 Proteo"
  ],
  "TATDN2": [
    "TATDN2 CNV",
    "TATDN2 RNA",
    "TATDN2 Proteo"
  ],
  "TMEM191A": [
    "TMEM191A CNV",
    "TMEM191A RNA"
  ],
  "KDM2A": [
    "KDM2A CNV",
    "KDM2A RNA",
    "KDM2A Proteo"
  ],
  "RAD51B": [
    "RAD51B CNV",
    "RAD51B RNA",
    "RAD51B Proteo"
  ],
  "OR2AJ1": [
    "OR2AJ1 CNV",
    "OR2AJ1 RNA"
  ],
  "HDAC1": [
    "HDAC1 CNV",
    "HDAC1 RNA",
    "HDAC1 Proteo"
  ],
  "CBY2": [
    "CBY2 CNV",
    "CBY2 RNA"
  ],
  "LCE2C": [
    "LCE2C CNV",
    "LCE2C RNA"
  ],
  "RPS15AP9": [
    "RPS15AP9 CNV",
    "RPS15AP9 RNA"
  ],
  "MAP2K3": [
    "MAP2K3 CNV",
    "MAP2K3 RNA",
    "MAP2K3 Proteo"
  ],
  "CYP20A1": [
    "CYP20A1 CNV",
    "CYP20A1 RNA",
    "CYP20A1 Proteo"
  ],
  "TUBB1": [
    "TUBB1 CNV",
    "TUBB1 RNA",
    "TUBB1 Proteo"
  ],
  "UGT1A9": [
    "UGT1A9 CNV",
    "UGT1A9 RNA"
  ],
  "DGAT1": [
    "DGAT1 CNV",
    "DGAT1 RNA",
    "DGAT1 Proteo"
  ],
  "ADAMTS7P4": [
    "ADAMTS7P4 CNV",
    "ADAMTS7P4 RNA"
  ],
  "BNIP3P35": [
    "BNIP3P35 CNV",
    "BNIP3P35 RNA"
  ],
  "SEMA3G": [
    "SEMA3G CNV",
    "SEMA3G RNA"
  ],
  "CCDC12": [
    "CCDC12 CNV",
    "CCDC12 RNA",
    "CCDC12 Proteo"
  ],
  "SNRPD2P1": [
    "SNRPD2P1 CNV",
    "SNRPD2P1 RNA"
  ],
  "SH3BGRL2": [
    "SH3BGRL2 CNV",
    "SH3BGRL2 RNA",
    "SH3BGRL2 Proteo"
  ],
  "NDUFA1": [
    "NDUFA1 CNV",
    "NDUFA1 RNA"
  ],
  "IFNA16": [
    "IFNA16 CNV",
    "IFNA16 RNA"
  ],
  "PCDHB15": [
    "PCDHB15 CNV",
    "PCDHB15 RNA",
    "PCDHB15 Proteo"
  ],
  "FGF23": [
    "FGF23 CNV",
    "FGF23 RNA"
  ],
  "ACOX2": [
    "ACOX2 CNV",
    "ACOX2 RNA",
    "ACOX2 Proteo"
  ],
  "FASLG": [
    "FASLG CNV",
    "FASLG RNA"
  ],
  "DUX4L10": [
    "DUX4L10 CNV",
    "DUX4L10 RNA"
  ],
  "SFMBT2": [
    "SFMBT2 CNV",
    "SFMBT2 RNA",
    "SFMBT2 Proteo"
  ],
  "MROH3P": [
    "MROH3P CNV",
    "MROH3P RNA"
  ],
  "Keratinocytes": [
    "Keratinocytes Cell_type"
  ],
  "GPANK1": [
    "GPANK1 CNV",
    "GPANK1 RNA",
    "GPANK1 Proteo"
  ],
  "DEFB113": [
    "DEFB113 CNV",
    "DEFB113 RNA"
  ],
  "EIF2AP4": [
    "EIF2AP4 CNV",
    "EIF2AP4 RNA"
  ],
  "IGHVII-26-2": [
    "IGHVII-26-2 CNV",
    "IGHVII-26-2 RNA"
  ],
  "RPL37P1": [
    "RPL37P1 CNV",
    "RPL37P1 RNA"
  ],
  "MAP1LC3B": [
    "MAP1LC3B CNV",
    "MAP1LC3B RNA",
    "MAP1LC3B Proteo"
  ],
  "CBWD4P": [
    "CBWD4P CNV",
    "CBWD4P RNA"
  ],
  "GPS2P2": [
    "GPS2P2 CNV",
    "GPS2P2 RNA"
  ],
  "MTBP": [
    "MTBP CNV",
    "MTBP RNA",
    "MTBP Proteo"
  ],
  "ZBTB40": [
    "ZBTB40 CNV",
    "ZBTB40 RNA",
    "ZBTB40 Proteo"
  ],
  "TCHHL1": [
    "TCHHL1 CNV",
    "TCHHL1 RNA"
  ],
  "OR52Q1P": [
    "OR52Q1P CNV",
    "OR52Q1P RNA"
  ],
  "OR4C50P": [
    "OR4C50P CNV",
    "OR4C50P RNA"
  ],
  "MED31": [
    "MED31 CNV",
    "MED31 RNA",
    "MED31 Proteo"
  ],
  "MTHFD2P7": [
    "MTHFD2P7 CNV",
    "MTHFD2P7 RNA"
  ],
  "NOX3": [
    "NOX3 CNV",
    "NOX3 RNA"
  ],
  "TRANK1": [
    "TRANK1 CNV",
    "TRANK1 RNA",
    "TRANK1 Proteo"
  ],
  "IGLVIV-59": [
    "IGLVIV-59 CNV",
    "IGLVIV-59 RNA"
  ],
  "H3C12": [
    "H3C12 CNV",
    "H3C12 RNA",
    "H3C12 Proteo"
  ],
  "TULP4": [
    "TULP4 CNV",
    "TULP4 RNA",
    "TULP4 Proteo"
  ],
  "PCDHGA12": [
    "PCDHGA12 CNV",
    "PCDHGA12 RNA",
    "PCDHGA12 Proteo"
  ],
  "TREM2": [
    "TREM2 CNV",
    "TREM2 RNA",
    "TREM2 Proteo"
  ],
  "RNA5SP509": [
    "RNA5SP509 CNV",
    "RNA5SP509 RNA"
  ],
  "FKBP14": [
    "FKBP14 CNV",
    "FKBP14 RNA",
    "FKBP14 Proteo"
  ],
  "NRBF2P1": [
    "NRBF2P1 CNV",
    "NRBF2P1 RNA"
  ],
  "FAM124A": [
    "FAM124A CNV",
    "FAM124A RNA"
  ],
  "CHEK2P5": [
    "CHEK2P5 CNV",
    "CHEK2P5 RNA"
  ],
  "NME3": [
    "NME3 CNV",
    "NME3 RNA",
    "NME3 Proteo"
  ],
  "RWDD1": [
    "RWDD1 CNV",
    "RWDD1 RNA",
    "RWDD1 Proteo"
  ],
  "UPK3BL3P": [
    "UPK3BL3P CNV",
    "UPK3BL3P RNA"
  ],
  "SH2B1": [
    "SH2B1 CNV",
    "SH2B1 RNA",
    "SH2B1 Proteo"
  ],
  "NOVA2": [
    "NOVA2 CNV",
    "NOVA2 RNA",
    "NOVA2 Proteo"
  ],
  "SPTLC2": [
    "SPTLC2 CNV",
    "SPTLC2 RNA",
    "SPTLC2 Proteo"
  ],
  "TNNI2": [
    "TNNI2 CNV",
    "TNNI2 RNA",
    "TNNI2 Proteo"
  ],
  "HERC3_ENSG00000287542": [
    "HERC3_ENSG00000287542 RNA"
  ],
  "RBBP4P2": [
    "RBBP4P2 CNV",
    "RBBP4P2 RNA"
  ],
  "KRT73": [
    "KRT73 CNV",
    "KRT73 RNA",
    "KRT73 Proteo"
  ],
  "SRSF6P2": [
    "SRSF6P2 CNV",
    "SRSF6P2 RNA"
  ],
  "RPS24P1": [
    "RPS24P1 CNV",
    "RPS24P1 RNA"
  ],
  "SPATS2": [
    "SPATS2 CNV",
    "SPATS2 RNA",
    "SPATS2 Proteo"
  ],
  "DVL3": [
    "DVL3 CNV",
    "DVL3 RNA",
    "DVL3 Proteo"
  ],
  "PPFIA1": [
    "PPFIA1 CNV",
    "PPFIA1 RNA",
    "PPFIA1 Proteo"
  ],
  "PCGF7P": [
    "PCGF7P CNV",
    "PCGF7P RNA"
  ],
  "TMEM267": [
    "TMEM267 CNV",
    "TMEM267 RNA",
    "TMEM267 Proteo"
  ],
  "DDX17": [
    "DDX17 CNV",
    "DDX17 RNA",
    "DDX17 Proteo"
  ],
  "CAPN14": [
    "CAPN14 CNV",
    "CAPN14 RNA"
  ],
  "RPL13AP3": [
    "RPL13AP3 CNV",
    "RPL13AP3 RNA"
  ],
  "FAM216A": [
    "FAM216A CNV",
    "FAM216A RNA"
  ],
  "GDI1": [
    "GDI1 CNV",
    "GDI1 RNA",
    "GDI1 Proteo"
  ],
  "TMSB4Y": [
    "TMSB4Y CNV",
    "TMSB4Y RNA",
    "TMSB4Y Proteo"
  ],
  "HMGN1P26": [
    "HMGN1P26 CNV",
    "HMGN1P26 RNA"
  ],
  "DCK": [
    "DCK CNV",
    "DCK RNA",
    "DCK Proteo"
  ],
  "FTH1P1": [
    "FTH1P1 CNV",
    "FTH1P1 RNA"
  ],
  "IL4R": [
    "IL4R CNV",
    "IL4R RNA",
    "IL4R Proteo"
  ],
  "TCL1A": [
    "TCL1A CNV",
    "TCL1A RNA",
    "TCL1A Proteo"
  ],
  "FAM91A1": [
    "FAM91A1 CNV",
    "FAM91A1 RNA",
    "FAM91A1 Proteo"
  ],
  "MTND2P7": [
    "MTND2P7 CNV",
    "MTND2P7 RNA"
  ],
  "KCNH5": [
    "KCNH5 CNV",
    "KCNH5 RNA"
  ],
  "CGB2": [
    "CGB2 CNV",
    "CGB2 RNA"
  ],
  "RAD23BP3": [
    "RAD23BP3 CNV",
    "RAD23BP3 RNA"
  ],
  "ANKRD63": [
    "ANKRD63 CNV",
    "ANKRD63 RNA"
  ],
  "COL28A1": [
    "COL28A1 CNV",
    "COL28A1 RNA",
    "COL28A1 Proteo"
  ],
  "RARRES2P5": [
    "RARRES2P5 CNV",
    "RARRES2P5 RNA"
  ],
  "RPL35AP10": [
    "RPL35AP10 CNV",
    "RPL35AP10 RNA"
  ],
  "THAP12P4": [
    "THAP12P4 CNV",
    "THAP12P4 RNA"
  ],
  "GTF2IP5": [
    "GTF2IP5 CNV",
    "GTF2IP5 RNA"
  ],
  "MRPS21P7": [
    "MRPS21P7 CNV",
    "MRPS21P7 RNA"
  ],
  "CCDC38": [
    "CCDC38 CNV",
    "CCDC38 RNA"
  ],
  "OR4A45P": [
    "OR4A45P CNV",
    "OR4A45P RNA"
  ],
  "TJP3": [
    "TJP3 CNV",
    "TJP3 RNA",
    "TJP3 Proteo"
  ],
  "SRSF4": [
    "SRSF4 CNV",
    "SRSF4 RNA",
    "SRSF4 Proteo"
  ],
  "TMPRSS13": [
    "TMPRSS13 CNV",
    "TMPRSS13 RNA",
    "TMPRSS13 Proteo"
  ],
  "MMP13": [
    "MMP13 CNV",
    "MMP13 RNA"
  ],
  "RNA5SP502": [
    "RNA5SP502 CNV",
    "RNA5SP502 RNA"
  ],
  "OR2AM1P": [
    "OR2AM1P CNV",
    "OR2AM1P RNA"
  ],
  "FLVCR2": [
    "FLVCR2 CNV",
    "FLVCR2 RNA",
    "FLVCR2 Proteo"
  ],
  "GAPDHP56": [
    "GAPDHP56 CNV",
    "GAPDHP56 RNA"
  ],
  "RPL36AP4": [
    "RPL36AP4 CNV",
    "RPL36AP4 RNA"
  ],
  "KCNAB1": [
    "KCNAB1 CNV",
    "KCNAB1 RNA"
  ],
  "CCDC71L": [
    "CCDC71L CNV",
    "CCDC71L RNA",
    "CCDC71L Proteo"
  ],
  "MYBPC2": [
    "MYBPC2 CNV",
    "MYBPC2 RNA",
    "MYBPC2 Proteo"
  ],
  "RNA5SP515": [
    "RNA5SP515 CNV",
    "RNA5SP515 RNA"
  ],
  "ARIH1": [
    "ARIH1 CNV",
    "ARIH1 RNA",
    "ARIH1 Proteo"
  ],
  "HMGN2P39": [
    "HMGN2P39 CNV",
    "HMGN2P39 RNA"
  ],
  "SUMF2": [
    "SUMF2 CNV",
    "SUMF2 RNA",
    "SUMF2 Proteo"
  ],
  "ABCB9": [
    "ABCB9 CNV",
    "ABCB9 RNA",
    "ABCB9 Proteo"
  ],
  "SLA2": [
    "SLA2 CNV",
    "SLA2 RNA"
  ],
  "RPL5P35": [
    "RPL5P35 CNV",
    "RPL5P35 RNA"
  ],
  "RPL23AP28": [
    "RPL23AP28 CNV",
    "RPL23AP28 RNA"
  ],
  "RPL13P4": [
    "RPL13P4 CNV",
    "RPL13P4 RNA"
  ],
  "NR3C2": [
    "NR3C2 CNV",
    "NR3C2 RNA"
  ],
  "MTATP6P29": [
    "MTATP6P29 CNV",
    "MTATP6P29 RNA"
  ],
  "SPPL2B": [
    "SPPL2B CNV",
    "SPPL2B RNA",
    "SPPL2B Proteo"
  ],
  "RPL35AP4": [
    "RPL35AP4 CNV",
    "RPL35AP4 RNA"
  ],
  "RPL12P4": [
    "RPL12P4 CNV",
    "RPL12P4 RNA"
  ],
  "CEACAMP6": [
    "CEACAMP6 CNV",
    "CEACAMP6 RNA"
  ],
  "LRRC27": [
    "LRRC27 CNV",
    "LRRC27 RNA"
  ],
  "FTH1P5": [
    "FTH1P5 CNV",
    "FTH1P5 RNA"
  ],
  "RBMXP4": [
    "RBMXP4 CNV",
    "RBMXP4 RNA"
  ],
  "EIF2S2P1": [
    "EIF2S2P1 CNV",
    "EIF2S2P1 RNA"
  ],
  "PPIAP93": [
    "PPIAP93 CNV",
    "PPIAP93 RNA"
  ],
  "CUX1": [
    "CUX1 CNV",
    "CUX1 RNA",
    "CUX1 Proteo"
  ],
  "LYSMD3": [
    "LYSMD3 CNV",
    "LYSMD3 RNA",
    "LYSMD3 Proteo"
  ],
  "CMAS": [
    "CMAS CNV",
    "CMAS RNA",
    "CMAS Proteo"
  ],
  "CD109": [
    "CD109 CNV",
    "CD109 RNA",
    "CD109 Proteo"
  ],
  "PMIS2": [
    "PMIS2 CNV",
    "PMIS2 RNA"
  ],
  "CLEC11A": [
    "CLEC11A CNV",
    "CLEC11A RNA",
    "CLEC11A Proteo"
  ],
  "COX10": [
    "COX10 CNV",
    "COX10 RNA"
  ],
  "OR2AI1P": [
    "OR2AI1P CNV",
    "OR2AI1P RNA"
  ],
  "STAU2P1": [
    "STAU2P1 CNV",
    "STAU2P1 RNA"
  ],
  "LINC00672": [
    "LINC00672 CNV",
    "LINC00672 RNA"
  ],
  "PCDHB17P": [
    "PCDHB17P CNV",
    "PCDHB17P RNA"
  ],
  "CDY2A": [
    "CDY2A CNV",
    "CDY2A RNA"
  ],
  "TNMD": [
    "TNMD CNV",
    "TNMD RNA",
    "TNMD Proteo"
  ],
  "CLTCL1": [
    "CLTCL1 CNV",
    "CLTCL1 RNA",
    "CLTCL1 Proteo"
  ],
  "TEX51": [
    "TEX51 CNV",
    "TEX51 RNA"
  ],
  "PCGF3": [
    "PCGF3 CNV",
    "PCGF3 RNA",
    "PCGF3 Proteo"
  ],
  "IBTK": [
    "IBTK CNV",
    "IBTK RNA",
    "IBTK Proteo"
  ],
  "PIF1": [
    "PIF1 CNV",
    "PIF1 RNA"
  ],
  "DPRXP6": [
    "DPRXP6 CNV",
    "DPRXP6 RNA"
  ],
  "GAPDHP51": [
    "GAPDHP51 CNV",
    "GAPDHP51 RNA"
  ],
  "GRPEL2P3": [
    "GRPEL2P3 CNV",
    "GRPEL2P3 RNA"
  ],
  "RNA5SP421": [
    "RNA5SP421 CNV",
    "RNA5SP421 RNA"
  ],
  "CYCSP42": [
    "CYCSP42 CNV",
    "CYCSP42 RNA"
  ],
  "AMD1P2": [
    "AMD1P2 CNV",
    "AMD1P2 RNA"
  ],
  "FAM74A6": [
    "FAM74A6 CNV",
    "FAM74A6 RNA"
  ],
  "KRT18P3": [
    "KRT18P3 CNV",
    "KRT18P3 RNA"
  ],
  "SIRT1": [
    "SIRT1 CNV",
    "SIRT1 RNA",
    "SIRT1 Proteo"
  ],
  "ASB11": [
    "ASB11 CNV",
    "ASB11 RNA",
    "ASB11 Proteo"
  ],
  "FTL": [
    "FTL CNV",
    "FTL RNA",
    "FTL Proteo"
  ],
  "NOTCH2NLA": [
    "NOTCH2NLA CNV",
    "NOTCH2NLA RNA"
  ],
  "PALB2": [
    "PALB2 CNV",
    "PALB2 RNA",
    "PALB2 Proteo"
  ],
  "RPL12P38": [
    "RPL12P38 CNV",
    "RPL12P38 RNA"
  ],
  "PDCL": [
    "PDCL CNV",
    "PDCL RNA",
    "PDCL Proteo"
  ],
  "GRPR": [
    "GRPR CNV",
    "GRPR RNA"
  ],
  "C8A": [
    "C8A CNV",
    "C8A RNA",
    "C8A Proteo"
  ],
  "SEPTIN10P1": [
    "SEPTIN10P1 CNV",
    "SEPTIN10P1 RNA"
  ],
  "RHD": [
    "RHD CNV",
    "RHD RNA"
  ],
  "ARL6": [
    "ARL6 CNV",
    "ARL6 RNA",
    "ARL6 Proteo"
  ],
  "BET1P1": [
    "BET1P1 CNV",
    "BET1P1 RNA"
  ],
  "SP100": [
    "SP100 CNV",
    "SP100 RNA",
    "SP100 Proteo"
  ],
  "DDX39A": [
    "DDX39A CNV",
    "DDX39A RNA",
    "DDX39A Proteo"
  ],
  "RCOR2": [
    "RCOR2 CNV",
    "RCOR2 RNA",
    "RCOR2 Proteo"
  ],
  "KRT75": [
    "KRT75 CNV",
    "KRT75 RNA",
    "KRT75 Proteo"
  ],
  "C8orf58": [
    "C8orf58 CNV",
    "C8orf58 RNA"
  ],
  "DRP2": [
    "DRP2 CNV",
    "DRP2 RNA"
  ],
  "TMIGD1": [
    "TMIGD1 CNV",
    "TMIGD1 RNA"
  ],
  "SPOP": [
    "SPOP CNV",
    "SPOP RNA"
  ],
  "JAK1": [
    "JAK1 CNV",
    "JAK1 RNA",
    "JAK1 Proteo"
  ],
  "LETM1": [
    "LETM1 CNV",
    "LETM1 RNA",
    "LETM1 Proteo"
  ],
  "KDM3B": [
    "KDM3B CNV",
    "KDM3B RNA",
    "KDM3B Proteo"
  ],
  "OR7E96P": [
    "OR7E96P CNV",
    "OR7E96P RNA"
  ],
  "ZSCAN9": [
    "ZSCAN9 CNV",
    "ZSCAN9 RNA"
  ],
  "ZNF143": [
    "ZNF143 CNV",
    "ZNF143 RNA",
    "ZNF143 Proteo"
  ],
  "OR51B6": [
    "OR51B6 CNV",
    "OR51B6 RNA"
  ],
  "TNFRSF14": [
    "TNFRSF14 CNV",
    "TNFRSF14 RNA",
    "TNFRSF14 Proteo"
  ],
  "ETF1P1": [
    "ETF1P1 CNV",
    "ETF1P1 RNA"
  ],
  "RORB": [
    "RORB CNV",
    "RORB RNA"
  ],
  "NASP": [
    "NASP CNV",
    "NASP RNA",
    "NASP Proteo"
  ],
  "FHIP2B": [
    "FHIP2B CNV",
    "FHIP2B RNA",
    "FHIP2B Proteo"
  ],
  "TMEM242": [
    "TMEM242 CNV",
    "TMEM242 RNA"
  ],
  "SCYGR5": [
    "SCYGR5 CNV",
    "SCYGR5 RNA"
  ],
  "FXYD1": [
    "FXYD1 CNV",
    "FXYD1 RNA",
    "FXYD1 Proteo"
  ],
  "TIA1": [
    "TIA1 CNV",
    "TIA1 RNA",
    "TIA1 Proteo"
  ],
  "DEFA11P": [
    "DEFA11P CNV",
    "DEFA11P RNA"
  ],
  "TRPC6P6": [
    "TRPC6P6 CNV",
    "TRPC6P6 RNA"
  ],
  "H2AC11": [
    "H2AC11 CNV",
    "H2AC11 RNA"
  ],
  "ATP8A2P3": [
    "ATP8A2P3 CNV",
    "ATP8A2P3 RNA"
  ],
  "MAPKAPK2": [
    "MAPKAPK2 CNV",
    "MAPKAPK2 RNA",
    "MAPKAPK2 Proteo"
  ],
  "PRAMEF1": [
    "PRAMEF1 CNV",
    "PRAMEF1 RNA"
  ],
  "KRTAP5-9": [
    "KRTAP5-9 CNV",
    "KRTAP5-9 RNA"
  ],
  "MYH16": [
    "MYH16 CNV",
    "MYH16 RNA"
  ],
  "FRMD8P1": [
    "FRMD8P1 CNV",
    "FRMD8P1 RNA"
  ],
  "SUCLG2P2": [
    "SUCLG2P2 CNV",
    "SUCLG2P2 RNA"
  ],
  "NUDCD1": [
    "NUDCD1 CNV",
    "NUDCD1 RNA",
    "NUDCD1 Proteo"
  ],
  "MCL1": [
    "MCL1 CNV",
    "MCL1 RNA",
    "MCL1 Proteo"
  ],
  "NRIP3": [
    "NRIP3 CNV",
    "NRIP3 RNA",
    "NRIP3 Proteo"
  ],
  "CABP7": [
    "CABP7 CNV",
    "CABP7 RNA"
  ],
  "ZNF449": [
    "ZNF449 CNV",
    "ZNF449 RNA",
    "ZNF449 Proteo"
  ],
  "DBIL5P": [
    "DBIL5P CNV",
    "DBIL5P RNA"
  ],
  "AEBP2": [
    "AEBP2 CNV",
    "AEBP2 RNA",
    "AEBP2 Proteo"
  ],
  "RBM47": [
    "RBM47 CNV",
    "RBM47 RNA",
    "RBM47 Proteo"
  ],
  "RANBP10": [
    "RANBP10 CNV",
    "RANBP10 RNA",
    "RANBP10 Proteo"
  ],
  "NME2P3": [
    "NME2P3 CNV",
    "NME2P3 RNA"
  ],
  "SAPCD2P3": [
    "SAPCD2P3 CNV",
    "SAPCD2P3 RNA"
  ],
  "WASF5P": [
    "WASF5P CNV",
    "WASF5P RNA"
  ],
  "PRKD2": [
    "PRKD2 CNV",
    "PRKD2 RNA",
    "PRKD2 Proteo"
  ],
  "OGDH": [
    "OGDH CNV",
    "OGDH RNA",
    "OGDH Proteo"
  ],
  "FTLP16": [
    "FTLP16 CNV",
    "FTLP16 RNA"
  ],
  "PGBD4P3": [
    "PGBD4P3 CNV",
    "PGBD4P3 RNA"
  ],
  "RNA5SP254": [
    "RNA5SP254 CNV",
    "RNA5SP254 RNA"
  ],
  "ZNF784": [
    "ZNF784 CNV",
    "ZNF784 RNA",
    "ZNF784 Proteo"
  ],
  "CHPF": [
    "CHPF CNV",
    "CHPF RNA",
    "CHPF Proteo"
  ],
  "CDYLP1": [
    "CDYLP1 CNV",
    "CDYLP1 RNA"
  ],
  "TARS1": [
    "TARS1 CNV",
    "TARS1 RNA",
    "TARS1 Proteo"
  ],
  "ARL3": [
    "ARL3 CNV",
    "ARL3 RNA",
    "ARL3 Proteo"
  ],
  "UBTFL3": [
    "UBTFL3 CNV",
    "UBTFL3 RNA"
  ],
  "RPS15AP39": [
    "RPS15AP39 CNV",
    "RPS15AP39 RNA"
  ],
  "GAPDHP28": [
    "GAPDHP28 CNV",
    "GAPDHP28 RNA"
  ],
  "KRTAP4-4": [
    "KRTAP4-4 CNV",
    "KRTAP4-4 RNA"
  ],
  "BICDL1": [
    "BICDL1 CNV",
    "BICDL1 RNA"
  ],
  "ENOX2": [
    "ENOX2 CNV",
    "ENOX2 RNA",
    "ENOX2 Proteo"
  ],
  "ZNF583": [
    "ZNF583 CNV",
    "ZNF583 RNA"
  ],
  "CORO2A": [
    "CORO2A CNV",
    "CORO2A RNA",
    "CORO2A Proteo"
  ],
  "PEG10": [
    "PEG10 CNV",
    "PEG10 RNA",
    "PEG10 Proteo"
  ],
  "ENPP7P3": [
    "ENPP7P3 CNV",
    "ENPP7P3 RNA"
  ],
  "SUMO2P17": [
    "SUMO2P17 CNV",
    "SUMO2P17 RNA"
  ],
  "MAN2B2": [
    "MAN2B2 CNV",
    "MAN2B2 RNA",
    "MAN2B2 Proteo"
  ],
  "DNAJC18": [
    "DNAJC18 CNV",
    "DNAJC18 RNA"
  ],
  "ZSCAN4": [
    "ZSCAN4 CNV",
    "ZSCAN4 RNA"
  ],
  "ASIC3": [
    "ASIC3 CNV",
    "ASIC3 RNA"
  ],
  "VPS13D": [
    "VPS13D CNV",
    "VPS13D RNA",
    "VPS13D Proteo"
  ],
  "KLHL17": [
    "KLHL17 CNV",
    "KLHL17 RNA",
    "KLHL17 Proteo"
  ],
  "UQCRHP1": [
    "UQCRHP1 CNV",
    "UQCRHP1 RNA"
  ],
  "RPL14P3": [
    "RPL14P3 CNV",
    "RPL14P3 RNA"
  ],
  "CDHR2": [
    "CDHR2 CNV",
    "CDHR2 RNA"
  ],
  "KCND3": [
    "KCND3 CNV",
    "KCND3 RNA"
  ],
  "AKR1C6P": [
    "AKR1C6P CNV",
    "AKR1C6P RNA"
  ],
  "CMTM1": [
    "CMTM1 CNV",
    "CMTM1 RNA"
  ],
  "CYP2T3P": [
    "CYP2T3P CNV",
    "CYP2T3P RNA"
  ],
  "LSM10": [
    "LSM10 CNV",
    "LSM10 RNA",
    "LSM10 Proteo"
  ],
  "FKBP7": [
    "FKBP7 CNV",
    "FKBP7 RNA",
    "FKBP7 Proteo"
  ],
  "ZNF766": [
    "ZNF766 CNV",
    "ZNF766 RNA"
  ],
  "SLC6A14P1": [
    "SLC6A14P1 CNV",
    "SLC6A14P1 RNA"
  ],
  "ZNF222": [
    "ZNF222 CNV",
    "ZNF222 RNA"
  ],
  "ARPC1A": [
    "ARPC1A CNV",
    "ARPC1A RNA",
    "ARPC1A Proteo"
  ],
  "CNN2P7": [
    "CNN2P7 CNV",
    "CNN2P7 RNA"
  ],
  "ADAM10": [
    "ADAM10 CNV",
    "ADAM10 RNA",
    "ADAM10 Proteo"
  ],
  "SLC6A21P": [
    "SLC6A21P CNV",
    "SLC6A21P RNA"
  ],
  "NFATC1": [
    "NFATC1 CNV",
    "NFATC1 RNA",
    "NFATC1 Proteo"
  ],
  "CHI3L1": [
    "CHI3L1 CNV",
    "CHI3L1 RNA",
    "CHI3L1 Proteo"
  ],
  "TSHZ1": [
    "TSHZ1 CNV",
    "TSHZ1 RNA",
    "TSHZ1 Proteo"
  ],
  "COX5BP7": [
    "COX5BP7 CNV",
    "COX5BP7 RNA"
  ],
  "TOR4A": [
    "TOR4A CNV",
    "TOR4A RNA",
    "TOR4A Proteo"
  ],
  "TPD52L3": [
    "TPD52L3 CNV",
    "TPD52L3 RNA"
  ],
  "RNA5SP109": [
    "RNA5SP109 CNV",
    "RNA5SP109 RNA"
  ],
  "NEURL1B": [
    "NEURL1B CNV",
    "NEURL1B RNA",
    "NEURL1B Proteo"
  ],
  "SNX32": [
    "SNX32 CNV",
    "SNX32 RNA",
    "SNX32 Proteo"
  ],
  "KRT26": [
    "KRT26 CNV",
    "KRT26 RNA"
  ],
  "RPL29P12": [
    "RPL29P12 CNV",
    "RPL29P12 RNA"
  ],
  "FDXR": [
    "FDXR CNV",
    "FDXR RNA",
    "FDXR Proteo"
  ],
  "ATG2A": [
    "ATG2A CNV",
    "ATG2A RNA",
    "ATG2A Proteo"
  ],
  "PARP16": [
    "PARP16 CNV",
    "PARP16 RNA",
    "PARP16 Proteo"
  ],
  "TC2N": [
    "TC2N CNV",
    "TC2N RNA",
    "TC2N Proteo"
  ],
  "MSI1": [
    "MSI1 CNV",
    "MSI1 RNA",
    "MSI1 Proteo"
  ],
  "RPS4XP22": [
    "RPS4XP22 CNV",
    "RPS4XP22 RNA"
  ],
  "DUSP8P1": [
    "DUSP8P1 CNV",
    "DUSP8P1 RNA"
  ],
  "CCDC157": [
    "CCDC157 CNV",
    "CCDC157 RNA"
  ],
  "ANAPC2": [
    "ANAPC2 CNV",
    "ANAPC2 RNA",
    "ANAPC2 Proteo"
  ],
  "OTX2P2": [
    "OTX2P2 CNV",
    "OTX2P2 RNA"
  ],
  "POTEB": [
    "POTEB CNV",
    "POTEB RNA"
  ],
  "RBIS": [
    "RBIS CNV",
    "RBIS RNA",
    "RBIS Proteo"
  ],
  "FGF7P4": [
    "FGF7P4 CNV",
    "FGF7P4 RNA"
  ],
  "TFG": [
    "TFG CNV",
    "TFG RNA",
    "TFG Proteo"
  ],
  "TMEM176B": [
    "TMEM176B CNV",
    "TMEM176B RNA",
    "TMEM176B Proteo"
  ],
  "YAP1": [
    "YAP1 CNV",
    "YAP1 RNA",
    "YAP1 Proteo"
  ],
  "ARMC9": [
    "ARMC9 CNV",
    "ARMC9 RNA",
    "ARMC9 Proteo"
  ],
  "SLC4A2": [
    "SLC4A2 CNV",
    "SLC4A2 RNA",
    "SLC4A2 Proteo"
  ],
  "ZFP36L1": [
    "ZFP36L1 CNV",
    "ZFP36L1 RNA",
    "ZFP36L1 Proteo"
  ],
  "MPC1L": [
    "MPC1L CNV",
    "MPC1L RNA"
  ],
  "TIMM17B": [
    "TIMM17B CNV",
    "TIMM17B RNA",
    "TIMM17B Proteo"
  ],
  "MRPS16P3": [
    "MRPS16P3 CNV",
    "MRPS16P3 RNA"
  ],
  "KRR1P1": [
    "KRR1P1 CNV",
    "KRR1P1 RNA"
  ],
  "TMBIM1": [
    "TMBIM1 CNV",
    "TMBIM1 RNA",
    "TMBIM1 Proteo"
  ],
  "ITK": [
    "ITK CNV",
    "ITK RNA",
    "ITK Proteo"
  ],
  "MTND4LP12": [
    "MTND4LP12 CNV",
    "MTND4LP12 RNA"
  ],
  "AIFM3": [
    "AIFM3 CNV",
    "AIFM3 RNA"
  ],
  "GSG1L2": [
    "GSG1L2 CNV",
    "GSG1L2 RNA"
  ],
  "TPI1": [
    "TPI1 CNV",
    "TPI1 RNA",
    "TPI1 Proteo"
  ],
  "HHIP": [
    "HHIP CNV",
    "HHIP RNA"
  ],
  "ATL1": [
    "ATL1 CNV",
    "ATL1 RNA",
    "ATL1 Proteo"
  ],
  "NMD3P2": [
    "NMD3P2 CNV",
    "NMD3P2 RNA"
  ],
  "SCMH1": [
    "SCMH1 CNV",
    "SCMH1 RNA",
    "SCMH1 Proteo"
  ],
  "RARRES2P7": [
    "RARRES2P7 CNV",
    "RARRES2P7 RNA"
  ],
  "TCEAL1": [
    "TCEAL1 CNV",
    "TCEAL1 RNA",
    "TCEAL1 Proteo"
  ],
  "MTCO1P46": [
    "MTCO1P46 CNV",
    "MTCO1P46 RNA"
  ],
  "BCL2A1": [
    "BCL2A1 CNV",
    "BCL2A1 RNA",
    "BCL2A1 Proteo"
  ],
  "SNRPEP8": [
    "SNRPEP8 CNV",
    "SNRPEP8 RNA"
  ],
  "KCTD4": [
    "KCTD4 CNV",
    "KCTD4 RNA"
  ],
  "PLBD1": [
    "PLBD1 CNV",
    "PLBD1 RNA",
    "PLBD1 Proteo"
  ],
  "CIZ1": [
    "CIZ1 CNV",
    "CIZ1 RNA",
    "CIZ1 Proteo"
  ],
  "SQLE": [
    "SQLE CNV",
    "SQLE RNA",
    "SQLE Proteo"
  ],
  "C6orf132": [
    "C6orf132 CNV",
    "C6orf132 RNA",
    "C6orf132 Proteo"
  ],
  "TENT5C": [
    "TENT5C CNV",
    "TENT5C RNA",
    "TENT5C Proteo"
  ],
  "SMPD1": [
    "SMPD1 CNV",
    "SMPD1 RNA",
    "SMPD1 Proteo"
  ],
  "FUT8": [
    "FUT8 CNV",
    "FUT8 RNA",
    "FUT8 Proteo"
  ],
  "ETHE1": [
    "ETHE1 CNV",
    "ETHE1 RNA",
    "ETHE1 Proteo"
  ],
  "DSG2": [
    "DSG2 CNV",
    "DSG2 RNA",
    "DSG2 Proteo"
  ],
  "KRT81": [
    "KRT81 CNV",
    "KRT81 RNA",
    "KRT81 Proteo"
  ],
  "CATIP": [
    "CATIP CNV",
    "CATIP RNA"
  ],
  "IL18RAP": [
    "IL18RAP CNV",
    "IL18RAP RNA"
  ],
  "COL22A1": [
    "COL22A1 CNV",
    "COL22A1 RNA",
    "COL22A1 Proteo"
  ],
  "FAM47DP": [
    "FAM47DP CNV",
    "FAM47DP RNA"
  ],
  "DIRAS2": [
    "DIRAS2 CNV",
    "DIRAS2 RNA",
    "DIRAS2 Proteo"
  ],
  "GCN1": [
    "GCN1 CNV",
    "GCN1 RNA",
    "GCN1 Proteo"
  ],
  "ZSCAN18": [
    "ZSCAN18 CNV",
    "ZSCAN18 RNA",
    "ZSCAN18 Proteo"
  ],
  "RPL5P3": [
    "RPL5P3 CNV",
    "RPL5P3 RNA"
  ],
  "DRD5P2": [
    "DRD5P2 CNV",
    "DRD5P2 RNA"
  ],
  "ADAMTS12": [
    "ADAMTS12 CNV",
    "ADAMTS12 RNA"
  ],
  "L2HGDH": [
    "L2HGDH CNV",
    "L2HGDH RNA",
    "L2HGDH Proteo"
  ],
  "SLC25A36": [
    "SLC25A36 CNV",
    "SLC25A36 RNA",
    "SLC25A36 Proteo"
  ],
  "CDC23": [
    "CDC23 CNV",
    "CDC23 RNA",
    "CDC23 Proteo"
  ],
  "MRPL32P2": [
    "MRPL32P2 CNV",
    "MRPL32P2 RNA"
  ],
  "TMLHEP1": [
    "TMLHEP1 CNV",
    "TMLHEP1 RNA"
  ],
  "TRIM10": [
    "TRIM10 CNV",
    "TRIM10 RNA"
  ],
  "TRAV35": [
    "TRAV35 CNV",
    "TRAV35 RNA"
  ],
  "SLC25A19": [
    "SLC25A19 CNV",
    "SLC25A19 RNA",
    "SLC25A19 Proteo"
  ],
  "THTPA": [
    "THTPA CNV",
    "THTPA RNA",
    "THTPA Proteo"
  ],
  "KRT16P6": [
    "KRT16P6 CNV",
    "KRT16P6 RNA"
  ],
  "TMCC3": [
    "TMCC3 CNV",
    "TMCC3 RNA",
    "TMCC3 Proteo"
  ],
  "AFF1": [
    "AFF1 CNV",
    "AFF1 RNA",
    "AFF1 Proteo"
  ],
  "MDK": [
    "MDK CNV",
    "MDK RNA",
    "MDK Proteo"
  ],
  "OR4K7P": [
    "OR4K7P CNV",
    "OR4K7P RNA"
  ],
  "DRD1": [
    "DRD1 CNV",
    "DRD1 RNA"
  ],
  "APOA2": [
    "APOA2 CNV",
    "APOA2 RNA",
    "APOA2 Proteo"
  ],
  "DCSTAMP": [
    "DCSTAMP CNV",
    "DCSTAMP RNA"
  ],
  "H3P15": [
    "H3P15 CNV",
    "H3P15 RNA"
  ],
  "SERPIND1": [
    "SERPIND1 CNV",
    "SERPIND1 RNA",
    "SERPIND1 Proteo"
  ],
  "TRIM16L": [
    "TRIM16L CNV",
    "TRIM16L RNA"
  ],
  "COL2A1": [
    "COL2A1 CNV",
    "COL2A1 RNA",
    "COL2A1 Proteo"
  ],
  "FAM229B": [
    "FAM229B CNV",
    "FAM229B RNA"
  ],
  "OR51C1P": [
    "OR51C1P CNV",
    "OR51C1P RNA"
  ],
  "COA4": [
    "COA4 CNV",
    "COA4 RNA",
    "COA4 Proteo"
  ],
  "KRTAP3-2": [
    "KRTAP3-2 CNV",
    "KRTAP3-2 RNA"
  ],
  "RNA5SP521": [
    "RNA5SP521 CNV",
    "RNA5SP521 RNA"
  ],
  "PLEKHM2": [
    "PLEKHM2 CNV",
    "PLEKHM2 RNA",
    "PLEKHM2 Proteo"
  ],
  "RPL35AP7": [
    "RPL35AP7 CNV",
    "RPL35AP7 RNA"
  ],
  "BNIP3P13": [
    "BNIP3P13 CNV",
    "BNIP3P13 RNA"
  ],
  "FLG": [
    "FLG CNV",
    "FLG RNA",
    "FLG Proteo"
  ],
  "RPS26P40": [
    "RPS26P40 CNV",
    "RPS26P40 RNA"
  ],
  "OR6C1": [
    "OR6C1 CNV",
    "OR6C1 RNA"
  ],
  "LCE2A": [
    "LCE2A CNV",
    "LCE2A RNA"
  ],
  "LRP6": [
    "LRP6 CNV",
    "LRP6 RNA",
    "LRP6 Proteo"
  ],
  "HOXB13": [
    "HOXB13 CNV",
    "HOXB13 RNA",
    "HOXB13 Proteo"
  ],
  "SERPINB12": [
    "SERPINB12 CNV",
    "SERPINB12 RNA",
    "SERPINB12 Proteo"
  ],
  "DPY19L2": [
    "DPY19L2 CNV",
    "DPY19L2 RNA"
  ],
  "POLR2H": [
    "POLR2H CNV",
    "POLR2H RNA",
    "POLR2H Proteo"
  ],
  "TAAR9": [
    "TAAR9 CNV",
    "TAAR9 RNA"
  ],
  "C1QTNF6": [
    "C1QTNF6 CNV",
    "C1QTNF6 RNA",
    "C1QTNF6 Proteo"
  ],
  "MOB1A": [
    "MOB1A CNV",
    "MOB1A RNA",
    "MOB1A Proteo"
  ],
  "ALKAL1": [
    "ALKAL1 CNV",
    "ALKAL1 RNA"
  ],
  "PREPL": [
    "PREPL CNV",
    "PREPL RNA",
    "PREPL Proteo"
  ],
  "UGT2A2": [
    "UGT2A2 CNV",
    "UGT2A2 RNA"
  ],
  "OR51F3P": [
    "OR51F3P CNV",
    "OR51F3P RNA"
  ],
  "ARHGAP24": [
    "ARHGAP24 CNV",
    "ARHGAP24 RNA",
    "ARHGAP24 Proteo"
  ],
  "PNOC": [
    "PNOC CNV",
    "PNOC RNA"
  ],
  "CYTH1": [
    "CYTH1 CNV",
    "CYTH1 RNA",
    "CYTH1 Proteo"
  ],
  "HIPK2": [
    "HIPK2 CNV",
    "HIPK2 RNA",
    "HIPK2 Proteo"
  ],
  "PDK1P2": [
    "PDK1P2 CNV",
    "PDK1P2 RNA"
  ],
  "REEP5": [
    "REEP5 CNV",
    "REEP5 RNA",
    "REEP5 Proteo"
  ],
  "HSFY8P": [
    "HSFY8P CNV",
    "HSFY8P RNA"
  ],
  "MAP3K7": [
    "MAP3K7 CNV",
    "MAP3K7 RNA",
    "MAP3K7 Proteo"
  ],
  "SEPTIN14P3": [
    "SEPTIN14P3 CNV",
    "SEPTIN14P3 RNA"
  ],
  "ELK2BP": [
    "ELK2BP CNV",
    "ELK2BP RNA"
  ],
  "HARBI1": [
    "HARBI1 CNV",
    "HARBI1 RNA"
  ],
  "SHMT1": [
    "SHMT1 CNV",
    "SHMT1 RNA",
    "SHMT1 Proteo"
  ],
  "SMIM5": [
    "SMIM5 CNV",
    "SMIM5 RNA"
  ],
  "CCL24": [
    "CCL24 CNV",
    "CCL24 RNA",
    "CCL24 Proteo"
  ],
  "HNRNPDP1": [
    "HNRNPDP1 CNV",
    "HNRNPDP1 RNA"
  ],
  "RNF11P1": [
    "RNF11P1 CNV",
    "RNF11P1 RNA"
  ],
  "SCN4B": [
    "SCN4B CNV",
    "SCN4B RNA"
  ],
  "SMIM34": [
    "SMIM34 CNV",
    "SMIM34 RNA"
  ],
  "LAMC1": [
    "LAMC1 CNV",
    "LAMC1 RNA",
    "LAMC1 Proteo"
  ],
  "LINC00328-2P": [
    "LINC00328-2P CNV",
    "LINC00328-2P RNA"
  ],
  "SLC15A3": [
    "SLC15A3 CNV",
    "SLC15A3 RNA",
    "SLC15A3 Proteo"
  ],
  "BRD7P1": [
    "BRD7P1 CNV",
    "BRD7P1 RNA"
  ],
  "KCNK5": [
    "KCNK5 CNV",
    "KCNK5 RNA",
    "KCNK5 Proteo"
  ],
  "GGA2": [
    "GGA2 CNV",
    "GGA2 RNA",
    "GGA2 Proteo"
  ],
  "JUND": [
    "JUND CNV",
    "JUND RNA",
    "JUND Proteo"
  ],
  "FXYD6": [
    "FXYD6 CNV",
    "FXYD6 RNA"
  ],
  "ERH": [
    "ERH CNV",
    "ERH RNA",
    "ERH Proteo"
  ],
  "SLC15A1": [
    "SLC15A1 CNV",
    "SLC15A1 RNA"
  ],
  "MTCYBP15": [
    "MTCYBP15 CNV",
    "MTCYBP15 RNA"
  ],
  "RPS3AP15": [
    "RPS3AP15 CNV",
    "RPS3AP15 RNA"
  ],
  "RPL41": [
    "RPL41 CNV",
    "RPL41 RNA"
  ],
  "IGLV3-24": [
    "IGLV3-24 CNV",
    "IGLV3-24 RNA"
  ],
  "ZNF101": [
    "ZNF101 CNV",
    "ZNF101 RNA",
    "ZNF101 Proteo"
  ],
  "MTATP6P19": [
    "MTATP6P19 CNV",
    "MTATP6P19 RNA"
  ],
  "NDUFB4P3": [
    "NDUFB4P3 CNV",
    "NDUFB4P3 RNA"
  ],
  "TAF12": [
    "TAF12 CNV",
    "TAF12 RNA",
    "TAF12 Proteo"
  ],
  "FUOM": [
    "FUOM CNV",
    "FUOM RNA",
    "FUOM Proteo"
  ],
  "OR4C11": [
    "OR4C11 CNV",
    "OR4C11 RNA"
  ],
  "ZNF556": [
    "ZNF556 CNV",
    "ZNF556 RNA"
  ],
  "PPIAP39": [
    "PPIAP39 CNV",
    "PPIAP39 RNA"
  ],
  "CRYGA": [
    "CRYGA CNV",
    "CRYGA RNA"
  ],
  "SLC25A31": [
    "SLC25A31 CNV",
    "SLC25A31 RNA"
  ],
  "UCP1": [
    "UCP1 CNV",
    "UCP1 RNA"
  ],
  "TERF1": [
    "TERF1 CNV",
    "TERF1 RNA",
    "TERF1 Proteo"
  ],
  "PTH1R": [
    "PTH1R CNV",
    "PTH1R RNA"
  ],
  "USP9YP2": [
    "USP9YP2 CNV",
    "USP9YP2 RNA"
  ],
  "ACTG1P13": [
    "ACTG1P13 CNV",
    "ACTG1P13 RNA"
  ],
  "TMPRSS3": [
    "TMPRSS3 CNV",
    "TMPRSS3 RNA"
  ],
  "SRIP3": [
    "SRIP3 CNV",
    "SRIP3 RNA"
  ],
  "IGKV1OR2-118": [
    "IGKV1OR2-118 CNV",
    "IGKV1OR2-118 RNA"
  ],
  "STARD4": [
    "STARD4 CNV",
    "STARD4 RNA"
  ],
  "SUN1": [
    "SUN1 CNV",
    "SUN1 RNA",
    "SUN1 Proteo"
  ],
  "LEFTY1": [
    "LEFTY1 CNV",
    "LEFTY1 RNA"
  ],
  "KRT8P29": [
    "KRT8P29 CNV",
    "KRT8P29 RNA"
  ],
  "ELOCP8": [
    "ELOCP8 CNV",
    "ELOCP8 RNA"
  ],
  "RPS4XP5": [
    "RPS4XP5 CNV",
    "RPS4XP5 RNA"
  ],
  "FAM240A": [
    "FAM240A CNV",
    "FAM240A RNA"
  ],
  "KIF19BP": [
    "KIF19BP CNV",
    "KIF19BP RNA"
  ],
  "GTPBP6": [
    "GTPBP6 CNV",
    "GTPBP6 RNA",
    "GTPBP6 Proteo"
  ],
  "FOXO3": [
    "FOXO3 CNV",
    "FOXO3 RNA",
    "FOXO3 Proteo"
  ],
  "SLC9A4": [
    "SLC9A4 CNV",
    "SLC9A4 RNA"
  ],
  "KRTAP4-16": [
    "KRTAP4-16 CNV",
    "KRTAP4-16 RNA"
  ],
  "DPPA3P3": [
    "DPPA3P3 CNV",
    "DPPA3P3 RNA"
  ],
  "RNF175": [
    "RNF175 CNV",
    "RNF175 RNA"
  ],
  "HTR3A": [
    "HTR3A CNV",
    "HTR3A RNA"
  ],
  "HMGA1P3": [
    "HMGA1P3 CNV",
    "HMGA1P3 RNA"
  ],
  "MROH1": [
    "MROH1 CNV",
    "MROH1 RNA",
    "MROH1 Proteo"
  ],
  "RPL23A": [
    "RPL23A CNV",
    "RPL23A RNA",
    "RPL23A Proteo"
  ],
  "RNA5SP87": [
    "RNA5SP87 CNV",
    "RNA5SP87 RNA"
  ],
  "ZNF528": [
    "ZNF528 CNV",
    "ZNF528 RNA"
  ],
  "SLC52A1": [
    "SLC52A1 CNV",
    "SLC52A1 RNA"
  ],
  "TFAMP2": [
    "TFAMP2 CNV",
    "TFAMP2 RNA"
  ],
  "SRXN1": [
    "SRXN1 CNV",
    "SRXN1 RNA",
    "SRXN1 Proteo"
  ],
  "WWTR1": [
    "WWTR1 CNV",
    "WWTR1 RNA",
    "WWTR1 Proteo"
  ],
  "PYM1": [
    "PYM1 CNV",
    "PYM1 RNA",
    "PYM1 Proteo"
  ],
  "FAM32CP": [
    "FAM32CP CNV",
    "FAM32CP RNA"
  ],
  "MTMR11": [
    "MTMR11 CNV",
    "MTMR11 RNA",
    "MTMR11 Proteo"
  ],
  "GLE1": [
    "GLE1 CNV",
    "GLE1 RNA",
    "GLE1 Proteo"
  ],
  "HNRNPFP1": [
    "HNRNPFP1 CNV",
    "HNRNPFP1 RNA"
  ],
  "GUSBP14": [
    "GUSBP14 CNV",
    "GUSBP14 RNA"
  ],
  "PCDHGB2": [
    "PCDHGB2 CNV",
    "PCDHGB2 RNA"
  ],
  "ZBTB1": [
    "ZBTB1 CNV",
    "ZBTB1 RNA",
    "ZBTB1 Proteo"
  ],
  "SIPA1L2": [
    "SIPA1L2 CNV",
    "SIPA1L2 RNA",
    "SIPA1L2 Proteo"
  ],
  "PTX3": [
    "PTX3 CNV",
    "PTX3 RNA",
    "PTX3 Proteo"
  ],
  "ADGRL4": [
    "ADGRL4 CNV",
    "ADGRL4 RNA",
    "ADGRL4 Proteo"
  ],
  "KRT8P40": [
    "KRT8P40 CNV",
    "KRT8P40 RNA"
  ],
  "SEPTIN7P13": [
    "SEPTIN7P13 CNV",
    "SEPTIN7P13 RNA"
  ],
  "FAM90A13P": [
    "FAM90A13P CNV",
    "FAM90A13P RNA"
  ],
  "EXOSC9": [
    "EXOSC9 CNV",
    "EXOSC9 RNA",
    "EXOSC9 Proteo"
  ],
  "PLEK2": [
    "PLEK2 CNV",
    "PLEK2 RNA",
    "PLEK2 Proteo"
  ],
  "NIFKP3": [
    "NIFKP3 CNV",
    "NIFKP3 RNA"
  ],
  "TLE4": [
    "TLE4 CNV",
    "TLE4 RNA",
    "TLE4 Proteo"
  ],
  "ENTPD4": [
    "ENTPD4 CNV",
    "ENTPD4 RNA",
    "ENTPD4 Proteo"
  ],
  "ATF3": [
    "ATF3 CNV",
    "ATF3 RNA",
    "ATF3 Proteo"
  ],
  "TSN": [
    "TSN CNV",
    "TSN RNA",
    "TSN Proteo"
  ],
  "ITGA5": [
    "ITGA5 CNV",
    "ITGA5 RNA",
    "ITGA5 Proteo"
  ],
  "RPL21P41": [
    "RPL21P41 CNV",
    "RPL21P41 RNA"
  ],
  "RNA5SP141": [
    "RNA5SP141 CNV",
    "RNA5SP141 RNA"
  ],
  "MOCS2": [
    "MOCS2 CNV",
    "MOCS2 RNA",
    "MOCS2 Proteo"
  ],
  "METAP1": [
    "METAP1 CNV",
    "METAP1 RNA",
    "METAP1 Proteo"
  ],
  "RPS20P20": [
    "RPS20P20 CNV",
    "RPS20P20 RNA"
  ],
  "NME9": [
    "NME9 CNV",
    "NME9 RNA"
  ],
  "LAPTM5": [
    "LAPTM5 CNV",
    "LAPTM5 RNA",
    "LAPTM5 Proteo"
  ],
  "CDRT15P2": [
    "CDRT15P2 CNV",
    "CDRT15P2 RNA"
  ],
  "OR7A5": [
    "OR7A5 CNV",
    "OR7A5 RNA"
  ],
  "ELAVL4": [
    "ELAVL4 CNV",
    "ELAVL4 RNA",
    "ELAVL4 Proteo"
  ],
  "BDNF": [
    "BDNF CNV",
    "BDNF RNA"
  ],
  "CKMT1B": [
    "CKMT1B CNV",
    "CKMT1B RNA",
    "CKMT1B Proteo"
  ],
  "ELOAP1": [
    "ELOAP1 CNV",
    "ELOAP1 RNA"
  ],
  "GPR150": [
    "GPR150 CNV",
    "GPR150 RNA"
  ],
  "CYP2W1": [
    "CYP2W1 CNV",
    "CYP2W1 RNA"
  ],
  "SAMHD1": [
    "SAMHD1 CNV",
    "SAMHD1 RNA",
    "SAMHD1 Proteo"
  ],
  "SMIM15P1": [
    "SMIM15P1 CNV",
    "SMIM15P1 RNA"
  ],
  "OR4F2P": [
    "OR4F2P CNV",
    "OR4F2P RNA"
  ],
  "KIF5A": [
    "KIF5A CNV",
    "KIF5A RNA",
    "KIF5A Proteo"
  ],
  "HEATR5A": [
    "HEATR5A CNV",
    "HEATR5A RNA",
    "HEATR5A Proteo"
  ],
  "OR7E130P": [
    "OR7E130P CNV",
    "OR7E130P RNA"
  ],
  "OR8H2": [
    "OR8H2 CNV",
    "OR8H2 RNA"
  ],
  "RPLP0P12": [
    "RPLP0P12 CNV",
    "RPLP0P12 RNA"
  ],
  "PRR5": [
    "PRR5 CNV",
    "PRR5 RNA",
    "PRR5 Proteo"
  ],
  "SLC35C2": [
    "SLC35C2 CNV",
    "SLC35C2 RNA",
    "SLC35C2 Proteo"
  ],
  "RPL7L1P10": [
    "RPL7L1P10 CNV",
    "RPL7L1P10 RNA"
  ],
  "LY6K": [
    "LY6K CNV",
    "LY6K RNA"
  ],
  "PLGLB2": [
    "PLGLB2 CNV",
    "PLGLB2 RNA"
  ],
  "ATP13A3": [
    "ATP13A3 CNV",
    "ATP13A3 RNA",
    "ATP13A3 Proteo"
  ],
  "GBP2": [
    "GBP2 CNV",
    "GBP2 RNA",
    "GBP2 Proteo"
  ],
  "EFCAB3P1": [
    "EFCAB3P1 CNV",
    "EFCAB3P1 RNA"
  ],
  "HNRNPR": [
    "HNRNPR CNV",
    "HNRNPR RNA",
    "HNRNPR Proteo"
  ],
  "HNRNPA1P11": [
    "HNRNPA1P11 CNV",
    "HNRNPA1P11 RNA"
  ],
  "RAB9B": [
    "RAB9B CNV",
    "RAB9B RNA",
    "RAB9B Proteo"
  ],
  "RAC2": [
    "RAC2 CNV",
    "RAC2 RNA",
    "RAC2 Proteo"
  ],
  "DLX6": [
    "DLX6 CNV",
    "DLX6 RNA"
  ],
  "COL6A1": [
    "COL6A1 CNV",
    "COL6A1 RNA",
    "COL6A1 Proteo"
  ],
  "SSPOP": [
    "SSPOP CNV",
    "SSPOP RNA"
  ],
  "ELP1": [
    "ELP1 CNV",
    "ELP1 RNA",
    "ELP1 Proteo"
  ],
  "TSPAN2": [
    "TSPAN2 CNV",
    "TSPAN2 RNA"
  ],
  "OSTCP2": [
    "OSTCP2 CNV",
    "OSTCP2 RNA"
  ],
  "C3orf22": [
    "C3orf22 CNV",
    "C3orf22 RNA"
  ],
  "RPL10A": [
    "RPL10A CNV",
    "RPL10A RNA",
    "RPL10A Proteo"
  ],
  "IL23R": [
    "IL23R CNV",
    "IL23R RNA"
  ],
  "PPP1CC": [
    "PPP1CC CNV",
    "PPP1CC RNA",
    "PPP1CC Proteo"
  ],
  "PCSK7": [
    "PCSK7 CNV",
    "PCSK7 RNA",
    "PCSK7 Proteo"
  ],
  "RPSAP75": [
    "RPSAP75 CNV",
    "RPSAP75 RNA"
  ],
  "PDE6C": [
    "PDE6C CNV",
    "PDE6C RNA"
  ],
  "ASB14": [
    "ASB14 CNV",
    "ASB14 RNA"
  ],
  "ZSCAN20": [
    "ZSCAN20 CNV",
    "ZSCAN20 RNA",
    "ZSCAN20 Proteo"
  ],
  "RNA5SP88": [
    "RNA5SP88 CNV",
    "RNA5SP88 RNA"
  ],
  "CXCL5": [
    "CXCL5 CNV",
    "CXCL5 RNA"
  ],
  "SPACA1": [
    "SPACA1 CNV",
    "SPACA1 RNA"
  ],
  "UBN1": [
    "UBN1 CNV",
    "UBN1 RNA",
    "UBN1 Proteo"
  ],
  "PAGR1": [
    "PAGR1 CNV",
    "PAGR1 RNA",
    "PAGR1 Proteo"
  ],
  "DEFA1B": [
    "DEFA1B CNV",
    "DEFA1B RNA"
  ],
  "HNMT": [
    "HNMT CNV",
    "HNMT RNA",
    "HNMT Proteo"
  ],
  "SEMA3C": [
    "SEMA3C CNV",
    "SEMA3C RNA",
    "SEMA3C Proteo"
  ],
  "APOC2": [
    "APOC2 CNV",
    "APOC2 RNA"
  ],
  "HERC1": [
    "HERC1 CNV",
    "HERC1 RNA",
    "HERC1 Proteo"
  ],
  "ZNF330": [
    "ZNF330 CNV",
    "ZNF330 RNA",
    "ZNF330 Proteo"
  ],
  "MCHR1": [
    "MCHR1 CNV",
    "MCHR1 RNA"
  ],
  "TMEM70": [
    "TMEM70 CNV",
    "TMEM70 RNA",
    "TMEM70 Proteo"
  ],
  "TRMT61A": [
    "TRMT61A CNV",
    "TRMT61A RNA",
    "TRMT61A Proteo"
  ],
  "CFAP97": [
    "CFAP97 CNV",
    "CFAP97 RNA",
    "CFAP97 Proteo"
  ],
  "SERP2": [
    "SERP2 CNV",
    "SERP2 RNA"
  ],
  "CAPN1": [
    "CAPN1 CNV",
    "CAPN1 RNA",
    "CAPN1 Proteo"
  ],
  "BTNL10": [
    "BTNL10 CNV",
    "BTNL10 RNA"
  ],
  "TPTEP1": [
    "TPTEP1 CNV",
    "TPTEP1 RNA"
  ],
  "TMEM151A": [
    "TMEM151A CNV",
    "TMEM151A RNA"
  ],
  "PDRG1": [
    "PDRG1 CNV",
    "PDRG1 RNA",
    "PDRG1 Proteo"
  ],
  "MEAF6P1": [
    "MEAF6P1 CNV",
    "MEAF6P1 RNA"
  ],
  "PLPP7": [
    "PLPP7 CNV",
    "PLPP7 RNA",
    "PLPP7 Proteo"
  ],
  "PRR14L": [
    "PRR14L CNV",
    "PRR14L RNA",
    "PRR14L Proteo"
  ],
  "KRT18P34": [
    "KRT18P34 CNV",
    "KRT18P34 RNA"
  ],
  "BRCA1": [
    "BRCA1 CNV",
    "BRCA1 RNA",
    "BRCA1 Proteo"
  ],
  "CDC42BPB": [
    "CDC42BPB CNV",
    "CDC42BPB RNA",
    "CDC42BPB Proteo"
  ],
  "NADSYN1": [
    "NADSYN1 CNV",
    "NADSYN1 RNA",
    "NADSYN1 Proteo"
  ],
  "HOXD4": [
    "HOXD4 CNV",
    "HOXD4 RNA"
  ],
  "BRIX1P1": [
    "BRIX1P1 CNV",
    "BRIX1P1 RNA"
  ],
  "SIVA1": [
    "SIVA1 CNV",
    "SIVA1 RNA",
    "SIVA1 Proteo"
  ],
  "CLPS": [
    "CLPS CNV",
    "CLPS RNA"
  ],
  "SGPL1": [
    "SGPL1 CNV",
    "SGPL1 RNA",
    "SGPL1 Proteo"
  ],
  "CUL7": [
    "CUL7 CNV",
    "CUL7 RNA",
    "CUL7 Proteo"
  ],
  "SCRN2": [
    "SCRN2 CNV",
    "SCRN2 RNA",
    "SCRN2 Proteo"
  ],
  "METTL7AP1": [
    "METTL7AP1 CNV",
    "METTL7AP1 RNA"
  ],
  "KITLG": [
    "KITLG CNV",
    "KITLG RNA",
    "KITLG Proteo"
  ],
  "PRG3": [
    "PRG3 CNV",
    "PRG3 RNA",
    "PRG3 Proteo"
  ],
  "LYZL4": [
    "LYZL4 CNV",
    "LYZL4 RNA"
  ],
  "RNA5SP187": [
    "RNA5SP187 CNV",
    "RNA5SP187 RNA"
  ],
  "SUPT4H1": [
    "SUPT4H1 CNV",
    "SUPT4H1 RNA",
    "SUPT4H1 Proteo"
  ],
  "COASY": [
    "COASY CNV",
    "COASY RNA",
    "COASY Proteo"
  ],
  "TSEN15P2": [
    "TSEN15P2 CNV",
    "TSEN15P2 RNA"
  ],
  "GUCY2F": [
    "GUCY2F CNV",
    "GUCY2F RNA"
  ],
  "TIMM8BP1": [
    "TIMM8BP1 CNV",
    "TIMM8BP1 RNA"
  ],
  "RNA5SP369": [
    "RNA5SP369 CNV",
    "RNA5SP369 RNA"
  ],
  "SDAD1P1": [
    "SDAD1P1 CNV",
    "SDAD1P1 RNA"
  ],
  "LYPLA1P2": [
    "LYPLA1P2 CNV",
    "LYPLA1P2 RNA"
  ],
  "VAMP1": [
    "VAMP1 CNV",
    "VAMP1 RNA",
    "VAMP1 Proteo"
  ],
  "SCIN": [
    "SCIN CNV",
    "SCIN RNA",
    "SCIN Proteo"
  ],
  "PCSK1": [
    "PCSK1 CNV",
    "PCSK1 RNA",
    "PCSK1 Proteo"
  ],
  "RPL23AP12": [
    "RPL23AP12 CNV",
    "RPL23AP12 RNA"
  ],
  "MGST1": [
    "MGST1 CNV",
    "MGST1 RNA",
    "MGST1 Proteo"
  ],
  "MICAL1": [
    "MICAL1 CNV",
    "MICAL1 RNA",
    "MICAL1 Proteo"
  ],
  "H3P41": [
    "H3P41 CNV",
    "H3P41 RNA"
  ],
  "DNAJC19P3": [
    "DNAJC19P3 CNV",
    "DNAJC19P3 RNA"
  ],
  "MAN2B1": [
    "MAN2B1 CNV",
    "MAN2B1 RNA",
    "MAN2B1 Proteo"
  ],
  "POLDIP3": [
    "POLDIP3 CNV",
    "POLDIP3 RNA",
    "POLDIP3 Proteo"
  ],
  "POLH": [
    "POLH CNV",
    "POLH RNA",
    "POLH Proteo"
  ],
  "EPX": [
    "EPX CNV",
    "EPX RNA",
    "EPX Proteo"
  ],
  "GABBR1": [
    "GABBR1 CNV",
    "GABBR1 RNA"
  ],
  "MED28P7": [
    "MED28P7 CNV",
    "MED28P7 RNA"
  ],
  "TSPYL5": [
    "TSPYL5 CNV",
    "TSPYL5 RNA",
    "TSPYL5 Proteo"
  ],
  "OR5D17P": [
    "OR5D17P CNV",
    "OR5D17P RNA"
  ],
  "TTLL4": [
    "TTLL4 CNV",
    "TTLL4 RNA",
    "TTLL4 Proteo"
  ],
  "AVIL": [
    "AVIL CNV",
    "AVIL RNA"
  ],
  "RRAGB": [
    "RRAGB CNV",
    "RRAGB RNA",
    "RRAGB Proteo"
  ],
  "SUPT16H": [
    "SUPT16H CNV",
    "SUPT16H RNA",
    "SUPT16H Proteo"
  ],
  "CLVS2": [
    "CLVS2 CNV",
    "CLVS2 RNA"
  ],
  "CARNS1": [
    "CARNS1 CNV",
    "CARNS1 RNA",
    "CARNS1 Proteo"
  ],
  "HIGD2AP2": [
    "HIGD2AP2 CNV",
    "HIGD2AP2 RNA"
  ],
  "EDARADD": [
    "EDARADD CNV",
    "EDARADD RNA"
  ],
  "SH3GL1": [
    "SH3GL1 CNV",
    "SH3GL1 RNA",
    "SH3GL1 Proteo"
  ],
  "HSPA8P13": [
    "HSPA8P13 CNV",
    "HSPA8P13 RNA"
  ],
  "GOT2": [
    "GOT2 CNV",
    "GOT2 RNA",
    "GOT2 Proteo"
  ],
  "TCP11L1": [
    "TCP11L1 CNV",
    "TCP11L1 RNA",
    "TCP11L1 Proteo"
  ],
  "BRCC3": [
    "BRCC3 CNV",
    "BRCC3 RNA",
    "BRCC3 Proteo"
  ],
  "TMSB15B_ENSG00000269226": [
    "TMSB15B_ENSG00000269226 RNA"
  ],
  "CICP4": [
    "CICP4 CNV",
    "CICP4 RNA"
  ],
  "FKBP2": [
    "FKBP2 CNV",
    "FKBP2 RNA",
    "FKBP2 Proteo"
  ],
  "BICRAL": [
    "BICRAL CNV",
    "BICRAL RNA",
    "BICRAL Proteo"
  ],
  "GOLGA1": [
    "GOLGA1 CNV",
    "GOLGA1 RNA",
    "GOLGA1 Proteo"
  ],
  "CD8B2": [
    "CD8B2 CNV",
    "CD8B2 RNA"
  ],
  "SLC12A8": [
    "SLC12A8 CNV",
    "SLC12A8 RNA"
  ],
  "OR2W3": [
    "OR2W3 CNV",
    "OR2W3 RNA"
  ],
  "FBXO8": [
    "FBXO8 CNV",
    "FBXO8 RNA"
  ],
  "THOC5": [
    "THOC5 CNV",
    "THOC5 RNA",
    "THOC5 Proteo"
  ],
  "FAM110A": [
    "FAM110A CNV",
    "FAM110A RNA",
    "FAM110A Proteo"
  ],
  "SLC37A2": [
    "SLC37A2 CNV",
    "SLC37A2 RNA",
    "SLC37A2 Proteo"
  ],
  "ZBTB44": [
    "ZBTB44 CNV",
    "ZBTB44 RNA",
    "ZBTB44 Proteo"
  ],
  "OR6M2P": [
    "OR6M2P CNV",
    "OR6M2P RNA"
  ],
  "MAP2K7": [
    "MAP2K7 CNV",
    "MAP2K7 RNA",
    "MAP2K7 Proteo"
  ],
  "SOD1P2": [
    "SOD1P2 CNV",
    "SOD1P2 RNA"
  ],
  "PIP4P1": [
    "PIP4P1 CNV",
    "PIP4P1 RNA",
    "PIP4P1 Proteo"
  ],
  "MYO1F": [
    "MYO1F CNV",
    "MYO1F RNA",
    "MYO1F Proteo"
  ],
  "RNA5SP167": [
    "RNA5SP167 CNV",
    "RNA5SP167 RNA"
  ],
  "SCRN1": [
    "SCRN1 CNV",
    "SCRN1 RNA",
    "SCRN1 Proteo"
  ],
  "TMEM121": [
    "TMEM121 CNV",
    "TMEM121 RNA"
  ],
  "TMEM140": [
    "TMEM140 CNV",
    "TMEM140 RNA"
  ],
  "CLUHP1": [
    "CLUHP1 CNV",
    "CLUHP1 RNA"
  ],
  "CLDND2": [
    "CLDND2 CNV",
    "CLDND2 RNA"
  ],
  "ADAMTS7P1": [
    "ADAMTS7P1 CNV",
    "ADAMTS7P1 RNA"
  ],
  "RXRB": [
    "RXRB CNV",
    "RXRB RNA",
    "RXRB Proteo"
  ],
  "MRPL35": [
    "MRPL35 CNV",
    "MRPL35 RNA",
    "MRPL35 Proteo"
  ],
  "UBQLN3": [
    "UBQLN3 CNV",
    "UBQLN3 RNA",
    "UBQLN3 Proteo"
  ],
  "IFNG": [
    "IFNG CNV",
    "IFNG RNA"
  ],
  "PLK2": [
    "PLK2 CNV",
    "PLK2 RNA",
    "PLK2 Proteo"
  ],
  "NAT8": [
    "NAT8 CNV",
    "NAT8 RNA"
  ],
  "CHRDL1": [
    "CHRDL1 CNV",
    "CHRDL1 RNA"
  ],
  "KCNK15": [
    "KCNK15 CNV",
    "KCNK15 RNA"
  ],
  "AQP12A": [
    "AQP12A CNV",
    "AQP12A RNA"
  ],
  "SLC29A4": [
    "SLC29A4 CNV",
    "SLC29A4 RNA"
  ],
  "MERTK": [
    "MERTK CNV",
    "MERTK RNA",
    "MERTK Proteo"
  ],
  "LELP1": [
    "LELP1 CNV",
    "LELP1 RNA"
  ],
  "MFN2": [
    "MFN2 CNV",
    "MFN2 RNA",
    "MFN2 Proteo"
  ],
  "MCM9": [
    "MCM9 CNV",
    "MCM9 RNA",
    "MCM9 Proteo"
  ],
  "SNX17": [
    "SNX17 CNV",
    "SNX17 RNA",
    "SNX17 Proteo"
  ],
  "ZFAND1": [
    "ZFAND1 CNV",
    "ZFAND1 RNA",
    "ZFAND1 Proteo"
  ],
  "CRP": [
    "CRP CNV",
    "CRP RNA",
    "CRP Proteo"
  ],
  "RAD23B": [
    "RAD23B CNV",
    "RAD23B RNA",
    "RAD23B Proteo"
  ],
  "IPO7P2": [
    "IPO7P2 CNV",
    "IPO7P2 RNA"
  ],
  "SS18L1": [
    "SS18L1 CNV",
    "SS18L1 RNA",
    "SS18L1 Proteo"
  ],
  "POLR1C": [
    "POLR1C CNV",
    "POLR1C RNA",
    "POLR1C Proteo"
  ],
  "BATF3": [
    "BATF3 CNV",
    "BATF3 RNA"
  ],
  "NXN": [
    "NXN CNV",
    "NXN RNA",
    "NXN Proteo"
  ],
  "ASNS": [
    "ASNS CNV",
    "ASNS RNA",
    "ASNS Proteo"
  ],
  "SPTLC1P2": [
    "SPTLC1P2 CNV",
    "SPTLC1P2 RNA"
  ],
  "GJA1P1": [
    "GJA1P1 CNV",
    "GJA1P1 RNA"
  ],
  "RPL41P1": [
    "RPL41P1 CNV",
    "RPL41P1 RNA"
  ],
  "GLRXP3": [
    "GLRXP3 CNV",
    "GLRXP3 RNA"
  ],
  "GRAMD1C": [
    "GRAMD1C CNV",
    "GRAMD1C RNA",
    "GRAMD1C Proteo"
  ],
  "ZNF331": [
    "ZNF331 CNV",
    "ZNF331 RNA",
    "ZNF331 Proteo"
  ],
  "FAM181B": [
    "FAM181B CNV",
    "FAM181B RNA"
  ],
  "MTCH2": [
    "MTCH2 CNV",
    "MTCH2 RNA",
    "MTCH2 Proteo"
  ],
  "SNRPGP2": [
    "SNRPGP2 CNV",
    "SNRPGP2 RNA"
  ],
  "APELA": [
    "APELA CNV",
    "APELA RNA"
  ],
  "PRR23D2": [
    "PRR23D2 CNV",
    "PRR23D2 RNA"
  ],
  "TSPAN13": [
    "TSPAN13 CNV",
    "TSPAN13 RNA",
    "TSPAN13 Proteo"
  ],
  "SFRP4": [
    "SFRP4 CNV",
    "SFRP4 RNA",
    "SFRP4 Proteo"
  ],
  "FAM171A1": [
    "FAM171A1 CNV",
    "FAM171A1 RNA",
    "FAM171A1 Proteo"
  ],
  "RPL36AP26": [
    "RPL36AP26 CNV",
    "RPL36AP26 RNA"
  ],
  "FSHB": [
    "FSHB CNV",
    "FSHB RNA"
  ],
  "MRPL57P3": [
    "MRPL57P3 CNV",
    "MRPL57P3 RNA"
  ],
  "IFITM8P": [
    "IFITM8P CNV",
    "IFITM8P RNA"
  ],
  "NEK1": [
    "NEK1 CNV",
    "NEK1 RNA",
    "NEK1 Proteo"
  ],
  "ADGRF1": [
    "ADGRF1 CNV",
    "ADGRF1 RNA"
  ],
  "ALPP": [
    "ALPP CNV",
    "ALPP RNA"
  ],
  "RPL17P22": [
    "RPL17P22 CNV",
    "RPL17P22 RNA"
  ],
  "ENPP7P6": [
    "ENPP7P6 CNV",
    "ENPP7P6 RNA"
  ],
  "OR10H4": [
    "OR10H4 CNV",
    "OR10H4 RNA"
  ],
  "RASGEF1B": [
    "RASGEF1B CNV",
    "RASGEF1B RNA"
  ],
  "TRIM58": [
    "TRIM58 CNV",
    "TRIM58 RNA",
    "TRIM58 Proteo"
  ],
  "TGFBR3": [
    "TGFBR3 CNV",
    "TGFBR3 RNA",
    "TGFBR3 Proteo"
  ],
  "FCHSD1": [
    "FCHSD1 CNV",
    "FCHSD1 RNA",
    "FCHSD1 Proteo"
  ],
  "OPN5": [
    "OPN5 CNV",
    "OPN5 RNA"
  ],
  "RPS13P4": [
    "RPS13P4 CNV",
    "RPS13P4 RNA"
  ],
  "BLOC1S6P1": [
    "BLOC1S6P1 CNV",
    "BLOC1S6P1 RNA"
  ],
  "RPL7AP79": [
    "RPL7AP79 CNV",
    "RPL7AP79 RNA"
  ],
  "TMEM74B": [
    "TMEM74B CNV",
    "TMEM74B RNA"
  ],
  "OR8H1": [
    "OR8H1 CNV",
    "OR8H1 RNA"
  ],
  "SSR1P2": [
    "SSR1P2 CNV",
    "SSR1P2 RNA"
  ],
  "CDRT15P5": [
    "CDRT15P5 CNV",
    "CDRT15P5 RNA"
  ],
  "MEST": [
    "MEST CNV",
    "MEST RNA",
    "MEST Proteo"
  ],
  "APOD": [
    "APOD CNV",
    "APOD RNA",
    "APOD Proteo"
  ],
  "FAM89A": [
    "FAM89A CNV",
    "FAM89A RNA",
    "FAM89A Proteo"
  ],
  "NAA15": [
    "NAA15 CNV",
    "NAA15 RNA",
    "NAA15 Proteo"
  ],
  "IPO7": [
    "IPO7 CNV",
    "IPO7 RNA",
    "IPO7 Proteo"
  ],
  "GARNL3": [
    "GARNL3 CNV",
    "GARNL3 RNA",
    "GARNL3 Proteo"
  ],
  "CDADC1": [
    "CDADC1 CNV",
    "CDADC1 RNA"
  ],
  "PDGFRB": [
    "PDGFRB CNV",
    "PDGFRB RNA",
    "PDGFRB Proteo"
  ],
  "OGG1": [
    "OGG1 CNV",
    "OGG1 RNA",
    "OGG1 Proteo"
  ],
  "SCRIB": [
    "SCRIB CNV",
    "SCRIB RNA",
    "SCRIB Proteo"
  ],
  "ALG1L15P": [
    "ALG1L15P CNV",
    "ALG1L15P RNA"
  ],
  "ARGLU1": [
    "ARGLU1 CNV",
    "ARGLU1 RNA",
    "ARGLU1 Proteo"
  ],
  "DMPK": [
    "DMPK CNV",
    "DMPK RNA"
  ],
  "PMCHL1": [
    "PMCHL1 CNV",
    "PMCHL1 RNA"
  ],
  "ZSCAN5A": [
    "ZSCAN5A CNV",
    "ZSCAN5A RNA",
    "ZSCAN5A Proteo"
  ],
  "TRAF4": [
    "TRAF4 CNV",
    "TRAF4 RNA",
    "TRAF4 Proteo"
  ],
  "SALL4": [
    "SALL4 CNV",
    "SALL4 RNA",
    "SALL4 Proteo"
  ],
  "DNAJC7": [
    "DNAJC7 CNV",
    "DNAJC7 RNA",
    "DNAJC7 Proteo"
  ],
  "SPRY2": [
    "SPRY2 CNV",
    "SPRY2 RNA",
    "SPRY2 Proteo"
  ],
  "WNT9A": [
    "WNT9A CNV",
    "WNT9A RNA"
  ],
  "RADIL": [
    "RADIL CNV",
    "RADIL RNA"
  ],
  "VMAC": [
    "VMAC CNV",
    "VMAC RNA",
    "VMAC Proteo"
  ],
  "GSTP1P1": [
    "GSTP1P1 CNV",
    "GSTP1P1 RNA"
  ],
  "COA6": [
    "COA6 CNV",
    "COA6 RNA",
    "COA6 Proteo"
  ],
  "RNA5SP473": [
    "RNA5SP473 CNV",
    "RNA5SP473 RNA"
  ],
  "TSC22D4": [
    "TSC22D4 CNV",
    "TSC22D4 RNA",
    "TSC22D4 Proteo"
  ],
  "MTND4P28": [
    "MTND4P28 CNV",
    "MTND4P28 RNA"
  ],
  "CTNNA1": [
    "CTNNA1 CNV",
    "CTNNA1 RNA",
    "CTNNA1 Proteo"
  ],
  "SERP1": [
    "SERP1 CNV",
    "SERP1 RNA"
  ],
  "PRKACG": [
    "PRKACG CNV",
    "PRKACG RNA"
  ],
  "H2AC7": [
    "H2AC7 CNV",
    "H2AC7 RNA"
  ],
  "RPS20P15": [
    "RPS20P15 CNV",
    "RPS20P15 RNA"
  ],
  "HSPE1P20": [
    "HSPE1P20 CNV",
    "HSPE1P20 RNA"
  ],
  "BMPR1B": [
    "BMPR1B CNV",
    "BMPR1B RNA"
  ],
  "CDKN2AIPNLP2": [
    "CDKN2AIPNLP2 CNV",
    "CDKN2AIPNLP2 RNA"
  ],
  "GPR75": [
    "GPR75 CNV",
    "GPR75 RNA"
  ],
  "FGD5P1": [
    "FGD5P1 CNV",
    "FGD5P1 RNA"
  ],
  "SDHAP4": [
    "SDHAP4 CNV",
    "SDHAP4 RNA"
  ],
  "OR52N2": [
    "OR52N2 CNV",
    "OR52N2 RNA"
  ],
  "C15orf61": [
    "C15orf61 CNV",
    "C15orf61 RNA",
    "C15orf61 Proteo"
  ],
  "ADAMTS1": [
    "ADAMTS1 CNV",
    "ADAMTS1 RNA",
    "ADAMTS1 Proteo"
  ],
  "RAB3IL1": [
    "RAB3IL1 CNV",
    "RAB3IL1 RNA",
    "RAB3IL1 Proteo"
  ],
  "ELOA": [
    "ELOA CNV",
    "ELOA RNA",
    "ELOA Proteo"
  ],
  "CDRT15": [
    "CDRT15 CNV",
    "CDRT15 RNA"
  ],
  "MDC1": [
    "MDC1 CNV",
    "MDC1 RNA",
    "MDC1 Proteo"
  ],
  "ABCE1": [
    "ABCE1 CNV",
    "ABCE1 RNA",
    "ABCE1 Proteo"
  ],
  "ARL15": [
    "ARL15 CNV",
    "ARL15 RNA",
    "ARL15 Proteo"
  ],
  "PPP1R11P2": [
    "PPP1R11P2 CNV",
    "PPP1R11P2 RNA"
  ],
  "GAGE12H": [
    "GAGE12H CNV",
    "GAGE12H RNA"
  ],
  "RPL13P12": [
    "RPL13P12 CNV",
    "RPL13P12 RNA"
  ],
  "SPATA4": [
    "SPATA4 CNV",
    "SPATA4 RNA"
  ],
  "ASIC1": [
    "ASIC1 CNV",
    "ASIC1 RNA"
  ],
  "PLA2G12B": [
    "PLA2G12B CNV",
    "PLA2G12B RNA"
  ],
  "NOD2": [
    "NOD2 CNV",
    "NOD2 RNA"
  ],
  "RPL10P14": [
    "RPL10P14 CNV",
    "RPL10P14 RNA"
  ],
  "TOMM40L": [
    "TOMM40L CNV",
    "TOMM40L RNA",
    "TOMM40L Proteo"
  ],
  "RPS29P3": [
    "RPS29P3 CNV",
    "RPS29P3 RNA"
  ],
  "GUCY1B2": [
    "GUCY1B2 CNV",
    "GUCY1B2 RNA"
  ],
  "KIF25": [
    "KIF25 CNV",
    "KIF25 RNA"
  ],
  "RPL7AP49": [
    "RPL7AP49 CNV",
    "RPL7AP49 RNA"
  ],
  "HCAR1": [
    "HCAR1 CNV",
    "HCAR1 RNA"
  ],
  "IL25": [
    "IL25 CNV",
    "IL25 RNA"
  ],
  "PATJ": [
    "PATJ CNV",
    "PATJ RNA",
    "PATJ Proteo"
  ],
  "RDH10": [
    "RDH10 CNV",
    "RDH10 RNA",
    "RDH10 Proteo"
  ],
  "SYPL1": [
    "SYPL1 CNV",
    "SYPL1 RNA",
    "SYPL1 Proteo"
  ],
  "FAM90A2P": [
    "FAM90A2P CNV",
    "FAM90A2P RNA"
  ],
  "IGLVIVOR22-2": [
    "IGLVIVOR22-2 CNV",
    "IGLVIVOR22-2 RNA"
  ],
  "C1orf167": [
    "C1orf167 CNV",
    "C1orf167 RNA",
    "C1orf167 Proteo"
  ],
  "OAS3": [
    "OAS3 CNV",
    "OAS3 RNA",
    "OAS3 Proteo"
  ],
  "HOOK1": [
    "HOOK1 CNV",
    "HOOK1 RNA",
    "HOOK1 Proteo"
  ],
  "HNRNPUL2": [
    "HNRNPUL2 CNV",
    "HNRNPUL2 RNA",
    "HNRNPUL2 Proteo"
  ],
  "EIF4A1P12": [
    "EIF4A1P12 CNV",
    "EIF4A1P12 RNA"
  ],
  "MRGPRX5P": [
    "MRGPRX5P CNV",
    "MRGPRX5P RNA"
  ],
  "RESF1": [
    "RESF1 CNV",
    "RESF1 RNA",
    "RESF1 Proteo"
  ],
  "ART5": [
    "ART5 CNV",
    "ART5 RNA"
  ],
  "OR3A2": [
    "OR3A2 CNV",
    "OR3A2 RNA"
  ],
  "TDRD3": [
    "TDRD3 CNV",
    "TDRD3 RNA",
    "TDRD3 Proteo"
  ],
  "APOA4": [
    "APOA4 CNV",
    "APOA4 RNA",
    "APOA4 Proteo"
  ],
  "RPS4XP4": [
    "RPS4XP4 CNV",
    "RPS4XP4 RNA"
  ],
  "PDGFC": [
    "PDGFC CNV",
    "PDGFC RNA",
    "PDGFC Proteo"
  ],
  "HLA-U": [
    "HLA-U CNV",
    "HLA-U RNA"
  ],
  "C16orf74": [
    "C16orf74 CNV",
    "C16orf74 RNA"
  ],
  "STEAP1": [
    "STEAP1 CNV",
    "STEAP1 RNA"
  ],
  "C17orf113": [
    "C17orf113 CNV",
    "C17orf113 RNA"
  ],
  "TWF1": [
    "TWF1 CNV",
    "TWF1 RNA",
    "TWF1 Proteo"
  ],
  "TBC1D21": [
    "TBC1D21 CNV",
    "TBC1D21 RNA"
  ],
  "MTATP6P30": [
    "MTATP6P30 CNV",
    "MTATP6P30 RNA"
  ],
  "SRPK2P": [
    "SRPK2P CNV",
    "SRPK2P RNA"
  ],
  "WIPI2": [
    "WIPI2 CNV",
    "WIPI2 RNA",
    "WIPI2 Proteo"
  ],
  "DYNAPP2": [
    "DYNAPP2 CNV",
    "DYNAPP2 RNA"
  ],
  "NDUFA9": [
    "NDUFA9 CNV",
    "NDUFA9 RNA",
    "NDUFA9 Proteo"
  ],
  "CICP13": [
    "CICP13 CNV",
    "CICP13 RNA"
  ],
  "IGSF10": [
    "IGSF10 CNV",
    "IGSF10 RNA",
    "IGSF10 Proteo"
  ],
  "BRAT1": [
    "BRAT1 CNV",
    "BRAT1 RNA",
    "BRAT1 Proteo"
  ],
  "GPR139": [
    "GPR139 CNV",
    "GPR139 RNA"
  ],
  "OR1L6": [
    "OR1L6 CNV",
    "OR1L6 RNA"
  ],
  "BCL11A": [
    "BCL11A CNV",
    "BCL11A RNA",
    "BCL11A Proteo"
  ],
  "MRGPRX6P": [
    "MRGPRX6P CNV",
    "MRGPRX6P RNA"
  ],
  "GP5": [
    "GP5 CNV",
    "GP5 RNA",
    "GP5 Proteo"
  ],
  "MRPL35P2": [
    "MRPL35P2 CNV",
    "MRPL35P2 RNA"
  ],
  "IGLV2-14": [
    "IGLV2-14 Proteo"
  ],
  "CSRNP2": [
    "CSRNP2 CNV",
    "CSRNP2 RNA"
  ],
  "RPS12P23": [
    "RPS12P23 CNV",
    "RPS12P23 RNA"
  ],
  "TSPYL6": [
    "TSPYL6 CNV",
    "TSPYL6 RNA"
  ],
  "CRNN": [
    "CRNN CNV",
    "CRNN RNA"
  ],
  "PIGQ": [
    "PIGQ CNV",
    "PIGQ RNA",
    "PIGQ Proteo"
  ],
  "OR5BJ1P": [
    "OR5BJ1P CNV",
    "OR5BJ1P RNA"
  ],
  "RPL6P3": [
    "RPL6P3 CNV",
    "RPL6P3 RNA"
  ],
  "CLDN3": [
    "CLDN3 CNV",
    "CLDN3 RNA",
    "CLDN3 Proteo"
  ],
  "PIH1D1": [
    "PIH1D1 CNV",
    "PIH1D1 RNA",
    "PIH1D1 Proteo"
  ],
  "GPR87": [
    "GPR87 CNV",
    "GPR87 RNA"
  ],
  "PHKG1P4": [
    "PHKG1P4 CNV",
    "PHKG1P4 RNA"
  ],
  "FRG1GP": [
    "FRG1GP CNV",
    "FRG1GP RNA"
  ],
  "TMEFF2": [
    "TMEFF2 CNV",
    "TMEFF2 RNA"
  ],
  "GSDME": [
    "GSDME CNV",
    "GSDME RNA",
    "GSDME Proteo"
  ],
  "CCDC102A": [
    "CCDC102A CNV",
    "CCDC102A RNA",
    "CCDC102A Proteo"
  ],
  "LCOR": [
    "LCOR CNV",
    "LCOR RNA",
    "LCOR Proteo"
  ],
  "ATP5F1D": [
    "ATP5F1D CNV",
    "ATP5F1D RNA",
    "ATP5F1D Proteo"
  ],
  "VSTM2A": [
    "VSTM2A CNV",
    "VSTM2A RNA"
  ],
  "MCAT": [
    "MCAT CNV",
    "MCAT RNA",
    "MCAT Proteo"
  ],
  "SLC36A2": [
    "SLC36A2 CNV",
    "SLC36A2 RNA"
  ],
  "PRSS48": [
    "PRSS48 CNV",
    "PRSS48 RNA"
  ],
  "STRC": [
    "STRC CNV",
    "STRC RNA"
  ],
  "LAMTOR3P2": [
    "LAMTOR3P2 CNV",
    "LAMTOR3P2 RNA"
  ],
  "EIF2S2": [
    "EIF2S2 CNV",
    "EIF2S2 RNA",
    "EIF2S2 Proteo"
  ],
  "MYH2": [
    "MYH2 CNV",
    "MYH2 RNA",
    "MYH2 Proteo"
  ],
  "GK5": [
    "GK5 CNV",
    "GK5 RNA",
    "GK5 Proteo"
  ],
  "C5orf63": [
    "C5orf63 CNV",
    "C5orf63 RNA",
    "C5orf63 Proteo"
  ],
  "BTRC": [
    "BTRC CNV",
    "BTRC RNA",
    "BTRC Proteo"
  ],
  "COL6A4P2": [
    "COL6A4P2 CNV",
    "COL6A4P2 RNA"
  ],
  "LRRC41": [
    "LRRC41 CNV",
    "LRRC41 RNA",
    "LRRC41 Proteo"
  ],
  "GIGYF2": [
    "GIGYF2 CNV",
    "GIGYF2 RNA",
    "GIGYF2 Proteo"
  ],
  "MTCO1P22": [
    "MTCO1P22 CNV",
    "MTCO1P22 RNA"
  ],
  "TBC1D19": [
    "TBC1D19 CNV",
    "TBC1D19 RNA"
  ],
  "RTCA": [
    "RTCA CNV",
    "RTCA RNA",
    "RTCA Proteo"
  ],
  "LCE1B": [
    "LCE1B CNV",
    "LCE1B RNA"
  ],
  "FCGBP": [
    "FCGBP CNV",
    "FCGBP RNA",
    "FCGBP Proteo"
  ],
  "PPP5C": [
    "PPP5C CNV",
    "PPP5C RNA",
    "PPP5C Proteo"
  ],
  "LPGAT1": [
    "LPGAT1 CNV",
    "LPGAT1 RNA",
    "LPGAT1 Proteo"
  ],
  "RPS3AP22": [
    "RPS3AP22 CNV",
    "RPS3AP22 RNA"
  ],
  "ARSG": [
    "ARSG CNV",
    "ARSG RNA",
    "ARSG Proteo"
  ],
  "TBX19": [
    "TBX19 CNV",
    "TBX19 RNA"
  ],
  "HDDC3": [
    "HDDC3 CNV",
    "HDDC3 RNA",
    "HDDC3 Proteo"
  ],
  "CA7": [
    "CA7 CNV",
    "CA7 RNA"
  ],
  "RBM42": [
    "RBM42 CNV",
    "RBM42 RNA",
    "RBM42 Proteo"
  ],
  "CREBBP": [
    "CREBBP CNV",
    "CREBBP RNA",
    "CREBBP Proteo"
  ],
  "KLC1": [
    "KLC1 CNV",
    "KLC1 RNA",
    "KLC1 Proteo"
  ],
  "IGKV2-29": [
    "IGKV2-29 CNV",
    "IGKV2-29 RNA"
  ],
  "RPL23AP25": [
    "RPL23AP25 CNV",
    "RPL23AP25 RNA"
  ],
  "OR7E155P": [
    "OR7E155P CNV",
    "OR7E155P RNA"
  ],
  "GZMH": [
    "GZMH CNV",
    "GZMH RNA",
    "GZMH Proteo"
  ],
  "DUSP5P2": [
    "DUSP5P2 CNV",
    "DUSP5P2 RNA"
  ],
  "CNN2P12": [
    "CNN2P12 CNV",
    "CNN2P12 RNA"
  ],
  "PRKCB": [
    "PRKCB CNV",
    "PRKCB RNA",
    "PRKCB Proteo"
  ],
  "GSG1": [
    "GSG1 CNV",
    "GSG1 RNA"
  ],
  "IGLV8OR8-1": [
    "IGLV8OR8-1 CNV",
    "IGLV8OR8-1 RNA"
  ],
  "VPS37B": [
    "VPS37B CNV",
    "VPS37B RNA",
    "VPS37B Proteo"
  ],
  "IGHG2": [
    "IGHG2 Proteo"
  ],
  "ACP3": [
    "ACP3 CNV",
    "ACP3 RNA",
    "ACP3 Proteo"
  ],
  "NLGN3": [
    "NLGN3 CNV",
    "NLGN3 RNA"
  ],
  "GFOD2": [
    "GFOD2 CNV",
    "GFOD2 RNA",
    "GFOD2 Proteo"
  ],
  "TPM1": [
    "TPM1 CNV",
    "TPM1 RNA",
    "TPM1 Proteo"
  ],
  "DNM1P32": [
    "DNM1P32 CNV",
    "DNM1P32 RNA"
  ],
  "OR5V1": [
    "OR5V1 CNV",
    "OR5V1 RNA"
  ],
  "OR7E140P": [
    "OR7E140P CNV",
    "OR7E140P RNA"
  ],
  "CXorf65": [
    "CXorf65 CNV",
    "CXorf65 RNA"
  ],
  "USP9YP10": [
    "USP9YP10 CNV",
    "USP9YP10 RNA"
  ],
  "YPEL1": [
    "YPEL1 CNV",
    "YPEL1 RNA"
  ],
  "TEX47": [
    "TEX47 CNV",
    "TEX47 RNA"
  ],
  "ZFP37": [
    "ZFP37 CNV",
    "ZFP37 RNA",
    "ZFP37 Proteo"
  ],
  "GOLGA6EP": [
    "GOLGA6EP CNV",
    "GOLGA6EP RNA"
  ],
  "STK32A": [
    "STK32A CNV",
    "STK32A RNA",
    "STK32A Proteo"
  ],
  "MAPK4": [
    "MAPK4 CNV",
    "MAPK4 RNA",
    "MAPK4 Proteo"
  ],
  "NCOA5LP": [
    "NCOA5LP CNV",
    "NCOA5LP RNA"
  ],
  "EIF1P3": [
    "EIF1P3 CNV",
    "EIF1P3 RNA"
  ],
  "SLC35A2": [
    "SLC35A2 CNV",
    "SLC35A2 RNA",
    "SLC35A2 Proteo"
  ],
  "DCLK1": [
    "DCLK1 CNV",
    "DCLK1 RNA",
    "DCLK1 Proteo"
  ],
  "GOLT1A": [
    "GOLT1A CNV",
    "GOLT1A RNA"
  ],
  "MAEA": [
    "MAEA CNV",
    "MAEA RNA",
    "MAEA Proteo"
  ],
  "CUL4AP1": [
    "CUL4AP1 CNV",
    "CUL4AP1 RNA"
  ],
  "DSTNP3": [
    "DSTNP3 CNV",
    "DSTNP3 RNA"
  ],
  "CSMD2": [
    "CSMD2 CNV",
    "CSMD2 RNA"
  ],
  "HSPE1P24": [
    "HSPE1P24 CNV",
    "HSPE1P24 RNA"
  ],
  "CRACR2A": [
    "CRACR2A CNV",
    "CRACR2A RNA",
    "CRACR2A Proteo"
  ],
  "RNF208": [
    "RNF208 CNV",
    "RNF208 RNA"
  ],
  "EDA2R": [
    "EDA2R CNV",
    "EDA2R RNA"
  ],
  "LARP6": [
    "LARP6 CNV",
    "LARP6 RNA",
    "LARP6 Proteo"
  ],
  "SCARA5": [
    "SCARA5 CNV",
    "SCARA5 RNA",
    "SCARA5 Proteo"
  ],
  "RNA5SP119": [
    "RNA5SP119 CNV",
    "RNA5SP119 RNA"
  ],
  "FGFR1OP2P1": [
    "FGFR1OP2P1 CNV",
    "FGFR1OP2P1 RNA"
  ],
  "SEC31A": [
    "SEC31A CNV",
    "SEC31A RNA",
    "SEC31A Proteo"
  ],
  "TRAF6P1": [
    "TRAF6P1 CNV",
    "TRAF6P1 RNA"
  ],
  "C3orf80": [
    "C3orf80 CNV",
    "C3orf80 RNA"
  ],
  "ABCB1": [
    "ABCB1 CNV",
    "ABCB1 RNA",
    "ABCB1 Proteo"
  ],
  "CDC42P2": [
    "CDC42P2 CNV",
    "CDC42P2 RNA"
  ],
  "CTBP2P4": [
    "CTBP2P4 CNV",
    "CTBP2P4 RNA"
  ],
  "GLI3": [
    "GLI3 CNV",
    "GLI3 RNA",
    "GLI3 Proteo"
  ],
  "YIPF6": [
    "YIPF6 CNV",
    "YIPF6 RNA",
    "YIPF6 Proteo"
  ],
  "SH2D3A": [
    "SH2D3A CNV",
    "SH2D3A RNA"
  ],
  "UQCC3": [
    "UQCC3 CNV",
    "UQCC3 RNA",
    "UQCC3 Proteo"
  ],
  "PDE4D": [
    "PDE4D CNV",
    "PDE4D RNA",
    "PDE4D Proteo"
  ],
  "UNC5A": [
    "UNC5A CNV",
    "UNC5A RNA"
  ],
  "RSL24D1P6": [
    "RSL24D1P6 CNV",
    "RSL24D1P6 RNA"
  ],
  "COX6CP13": [
    "COX6CP13 CNV",
    "COX6CP13 RNA"
  ],
  "CHST10": [
    "CHST10 CNV",
    "CHST10 RNA",
    "CHST10 Proteo"
  ],
  "SH3TC2": [
    "SH3TC2 CNV",
    "SH3TC2 RNA",
    "SH3TC2 Proteo"
  ],
  "MAX": [
    "MAX CNV",
    "MAX RNA",
    "MAX Proteo"
  ],
  "REC8": [
    "REC8 CNV",
    "REC8 RNA"
  ],
  "NRDC": [
    "NRDC CNV",
    "NRDC RNA",
    "NRDC Proteo"
  ],
  "F10": [
    "F10 CNV",
    "F10 RNA",
    "F10 Proteo"
  ],
  "HUNK": [
    "HUNK CNV",
    "HUNK RNA"
  ],
  "CNTD1": [
    "CNTD1 CNV",
    "CNTD1 RNA"
  ],
  "NPTXR": [
    "NPTXR CNV",
    "NPTXR RNA",
    "NPTXR Proteo"
  ],
  "CYB5AP2": [
    "CYB5AP2 CNV",
    "CYB5AP2 RNA"
  ],
  "GABRD": [
    "GABRD CNV",
    "GABRD RNA"
  ],
  "FOXO3B": [
    "FOXO3B CNV",
    "FOXO3B RNA",
    "FOXO3B Proteo"
  ],
  "KRT8P7": [
    "KRT8P7 CNV",
    "KRT8P7 RNA"
  ],
  "ATG9A": [
    "ATG9A CNV",
    "ATG9A RNA",
    "ATG9A Proteo"
  ],
  "MUC4": [
    "MUC4 CNV",
    "MUC4 RNA"
  ],
  "RPS4XP16": [
    "RPS4XP16 CNV",
    "RPS4XP16 RNA"
  ],
  "WT1": [
    "WT1 CNV",
    "WT1 RNA"
  ],
  "RPSAP15": [
    "RPSAP15 CNV",
    "RPSAP15 RNA"
  ],
  "SLC22A11": [
    "SLC22A11 CNV",
    "SLC22A11 RNA"
  ],
  "PTAFR": [
    "PTAFR CNV",
    "PTAFR RNA"
  ],
  "RBM12B": [
    "RBM12B CNV",
    "RBM12B RNA",
    "RBM12B Proteo"
  ],
  "PCNPP5": [
    "PCNPP5 CNV",
    "PCNPP5 RNA"
  ],
  "TFB1M": [
    "TFB1M CNV",
    "TFB1M RNA",
    "TFB1M Proteo"
  ],
  "KDM1A": [
    "KDM1A CNV",
    "KDM1A RNA",
    "KDM1A Proteo"
  ],
  "IFITM3": [
    "IFITM3 CNV",
    "IFITM3 RNA",
    "IFITM3 Proteo"
  ],
  "NT5DC1": [
    "NT5DC1 CNV",
    "NT5DC1 RNA",
    "NT5DC1 Proteo"
  ],
  "RPS2P7": [
    "RPS2P7 CNV",
    "RPS2P7 RNA"
  ],
  "HNRNPDLP1": [
    "HNRNPDLP1 CNV",
    "HNRNPDLP1 RNA"
  ],
  "DUX4L45": [
    "DUX4L45 CNV",
    "DUX4L45 RNA"
  ],
  "PLEKHG2": [
    "PLEKHG2 CNV",
    "PLEKHG2 RNA",
    "PLEKHG2 Proteo"
  ],
  "NF1P1": [
    "NF1P1 CNV",
    "NF1P1 RNA"
  ],
  "TGFBRAP1": [
    "TGFBRAP1 CNV",
    "TGFBRAP1 RNA",
    "TGFBRAP1 Proteo"
  ],
  "RBM5": [
    "RBM5 CNV",
    "RBM5 RNA",
    "RBM5 Proteo"
  ],
  "SPATA31D4": [
    "SPATA31D4 CNV",
    "SPATA31D4 RNA"
  ],
  "P4HTM": [
    "P4HTM CNV",
    "P4HTM RNA",
    "P4HTM Proteo"
  ],
  "THOC7": [
    "THOC7 CNV",
    "THOC7 RNA",
    "THOC7 Proteo"
  ],
  "BACH2": [
    "BACH2 CNV",
    "BACH2 RNA"
  ],
  "MTATP6P22": [
    "MTATP6P22 CNV",
    "MTATP6P22 RNA"
  ],
  "EIF5P1": [
    "EIF5P1 CNV",
    "EIF5P1 RNA"
  ],
  "EHD2": [
    "EHD2 CNV",
    "EHD2 RNA",
    "EHD2 Proteo"
  ],
  "U2AF2": [
    "U2AF2 CNV",
    "U2AF2 RNA",
    "U2AF2 Proteo"
  ],
  "SIPA1L3": [
    "SIPA1L3 CNV",
    "SIPA1L3 RNA",
    "SIPA1L3 Proteo"
  ],
  "FGF16": [
    "FGF16 CNV",
    "FGF16 RNA"
  ],
  "USP9YP4": [
    "USP9YP4 CNV",
    "USP9YP4 RNA"
  ],
  "PTGDR": [
    "PTGDR CNV",
    "PTGDR RNA"
  ],
  "SSX9P": [
    "SSX9P CNV",
    "SSX9P RNA"
  ],
  "DDB1": [
    "DDB1 CNV",
    "DDB1 RNA",
    "DDB1 Proteo"
  ],
  "GRK4": [
    "GRK4 CNV",
    "GRK4 RNA"
  ],
  "GAPDHP38": [
    "GAPDHP38 CNV",
    "GAPDHP38 RNA"
  ],
  "SEC61A1": [
    "SEC61A1 CNV",
    "SEC61A1 RNA",
    "SEC61A1 Proteo"
  ],
  "H3P14": [
    "H3P14 CNV",
    "H3P14 RNA"
  ],
  "NKIRAS2": [
    "NKIRAS2 CNV",
    "NKIRAS2 RNA",
    "NKIRAS2 Proteo"
  ],
  "NANOGNBP3": [
    "NANOGNBP3 CNV",
    "NANOGNBP3 RNA"
  ],
  "KRTAP12-1": [
    "KRTAP12-1 CNV",
    "KRTAP12-1 RNA"
  ],
  "GADL1": [
    "GADL1 CNV",
    "GADL1 RNA"
  ],
  "SCYGR1": [
    "SCYGR1 CNV",
    "SCYGR1 RNA"
  ],
  "MTCO3P45": [
    "MTCO3P45 CNV",
    "MTCO3P45 RNA"
  ],
  "CADM1": [
    "CADM1 CNV",
    "CADM1 RNA",
    "CADM1 Proteo"
  ],
  "FAM236A": [
    "FAM236A CNV",
    "FAM236A RNA"
  ],
  "ZNF233": [
    "ZNF233 CNV",
    "ZNF233 RNA"
  ],
  "PCDHB1": [
    "PCDHB1 CNV",
    "PCDHB1 RNA"
  ],
  "GSTCD": [
    "GSTCD CNV",
    "GSTCD RNA",
    "GSTCD Proteo"
  ],
  "NUPR2": [
    "NUPR2 CNV",
    "NUPR2 RNA"
  ],
  "MAFA": [
    "MAFA CNV",
    "MAFA RNA"
  ],
  "CT55": [
    "CT55 CNV",
    "CT55 RNA"
  ],
  "PLPPR1": [
    "PLPPR1 CNV",
    "PLPPR1 RNA"
  ],
  "RRN3P1": [
    "RRN3P1 CNV",
    "RRN3P1 RNA"
  ],
  "NEK7": [
    "NEK7 CNV",
    "NEK7 RNA",
    "NEK7 Proteo"
  ],
  "SNX18P9": [
    "SNX18P9 CNV",
    "SNX18P9 RNA"
  ],
  "B3GNT2P1": [
    "B3GNT2P1 CNV",
    "B3GNT2P1 RNA"
  ],
  "TMEM91": [
    "TMEM91 CNV",
    "TMEM91 RNA"
  ],
  "IGHA1": [
    "IGHA1 Proteo"
  ],
  "FMNL3": [
    "FMNL3 CNV",
    "FMNL3 RNA",
    "FMNL3 Proteo"
  ],
  "CYTIP": [
    "CYTIP CNV",
    "CYTIP RNA",
    "CYTIP Proteo"
  ],
  "TEX50": [
    "TEX50 CNV",
    "TEX50 RNA"
  ],
  "B3GNTL1": [
    "B3GNTL1 CNV",
    "B3GNTL1 RNA",
    "B3GNTL1 Proteo"
  ],
  "TMEM245": [
    "TMEM245 CNV",
    "TMEM245 RNA",
    "TMEM245 Proteo"
  ],
  "PARD6G": [
    "PARD6G CNV",
    "PARD6G RNA",
    "PARD6G Proteo"
  ],
  "XRCC4": [
    "XRCC4 CNV",
    "XRCC4 RNA",
    "XRCC4 Proteo"
  ],
  "RBBP4P3": [
    "RBBP4P3 CNV",
    "RBBP4P3 RNA"
  ],
  "FSTL5": [
    "FSTL5 CNV",
    "FSTL5 RNA"
  ],
  "RTL8B": [
    "RTL8B CNV",
    "RTL8B RNA",
    "RTL8B Proteo"
  ],
  "LYZL1": [
    "LYZL1 CNV",
    "LYZL1 RNA"
  ],
  "SLC7A14": [
    "SLC7A14 CNV",
    "SLC7A14 RNA"
  ],
  "OR13J1": [
    "OR13J1 CNV",
    "OR13J1 RNA"
  ],
  "PRL": [
    "PRL CNV",
    "PRL RNA"
  ],
  "ZNF25": [
    "ZNF25 CNV",
    "ZNF25 RNA",
    "ZNF25 Proteo"
  ],
  "ACCSL": [
    "ACCSL CNV",
    "ACCSL RNA"
  ],
  "RAB2A": [
    "RAB2A CNV",
    "RAB2A RNA",
    "RAB2A Proteo"
  ],
  "Endothelial": [
    "Endothelial Cell_type"
  ],
  "RPS23P10": [
    "RPS23P10 CNV",
    "RPS23P10 RNA"
  ],
  "GUCA1B": [
    "GUCA1B CNV",
    "GUCA1B RNA"
  ],
  "CYP46A1": [
    "CYP46A1 CNV",
    "CYP46A1 RNA",
    "CYP46A1 Proteo"
  ],
  "TMEM220": [
    "TMEM220 CNV",
    "TMEM220 RNA"
  ],
  "FKBP1A": [
    "FKBP1A CNV",
    "FKBP1A RNA",
    "FKBP1A Proteo"
  ],
  "ARHGEF33": [
    "ARHGEF33 CNV",
    "ARHGEF33 RNA"
  ],
  "BSNDP2": [
    "BSNDP2 CNV",
    "BSNDP2 RNA"
  ],
  "SNTB1": [
    "SNTB1 CNV",
    "SNTB1 RNA",
    "SNTB1 Proteo"
  ],
  "RPL36P20": [
    "RPL36P20 CNV",
    "RPL36P20 RNA"
  ],
  "GFRA4": [
    "GFRA4 CNV",
    "GFRA4 RNA"
  ],
  "SMARCA4": [
    "SMARCA4 CNV",
    "SMARCA4 RNA",
    "SMARCA4 Proteo"
  ],
  "CBX3": [
    "CBX3 CNV",
    "CBX3 RNA",
    "CBX3 Proteo"
  ],
  "ZYXP1": [
    "ZYXP1 CNV",
    "ZYXP1 RNA"
  ],
  "CHP2": [
    "CHP2 CNV",
    "CHP2 RNA"
  ],
  "XPO7": [
    "XPO7 CNV",
    "XPO7 RNA",
    "XPO7 Proteo"
  ],
  "UMPS": [
    "UMPS CNV",
    "UMPS RNA",
    "UMPS Proteo"
  ],
  "LRP4": [
    "LRP4 CNV",
    "LRP4 RNA",
    "LRP4 Proteo"
  ],
  "LCE3D": [
    "LCE3D CNV",
    "LCE3D RNA"
  ],
  "C14orf119": [
    "C14orf119 CNV",
    "C14orf119 RNA",
    "C14orf119 Proteo"
  ],
  "RBM17P4": [
    "RBM17P4 CNV",
    "RBM17P4 RNA"
  ],
  "BOD1L2": [
    "BOD1L2 CNV",
    "BOD1L2 RNA"
  ],
  "TNFAIP2": [
    "TNFAIP2 CNV",
    "TNFAIP2 RNA",
    "TNFAIP2 Proteo"
  ],
  "SRPK1": [
    "SRPK1 CNV",
    "SRPK1 RNA",
    "SRPK1 Proteo"
  ],
  "VTA1P2": [
    "VTA1P2 CNV",
    "VTA1P2 RNA"
  ],
  "KCNJ13": [
    "KCNJ13 CNV",
    "KCNJ13 RNA",
    "KCNJ13 Proteo"
  ],
  "EIF4ENIF1": [
    "EIF4ENIF1 CNV",
    "EIF4ENIF1 RNA",
    "EIF4ENIF1 Proteo"
  ],
  "UGT1A7": [
    "UGT1A7 CNV",
    "UGT1A7 RNA"
  ],
  "FDX1": [
    "FDX1 CNV",
    "FDX1 RNA",
    "FDX1 Proteo"
  ],
  "IGHV3-64D": [
    "IGHV3-64D Proteo"
  ],
  "UBE2Q2P12": [
    "UBE2Q2P12 CNV",
    "UBE2Q2P12 RNA"
  ],
  "ZFY": [
    "ZFY CNV",
    "ZFY RNA"
  ],
  "TAF11L14": [
    "TAF11L14 CNV",
    "TAF11L14 RNA"
  ],
  "DEPDC1": [
    "DEPDC1 CNV",
    "DEPDC1 RNA",
    "DEPDC1 Proteo"
  ],
  "TRIM41": [
    "TRIM41 CNV",
    "TRIM41 RNA",
    "TRIM41 Proteo"
  ],
  "TMEM221": [
    "TMEM221 CNV",
    "TMEM221 RNA"
  ],
  "JMJD7": [
    "JMJD7 CNV",
    "JMJD7 RNA",
    "JMJD7 Proteo"
  ],
  "MYLIP": [
    "MYLIP CNV",
    "MYLIP RNA"
  ],
  "DNASE1L2": [
    "DNASE1L2 CNV",
    "DNASE1L2 RNA"
  ],
  "TAOK1": [
    "TAOK1 CNV",
    "TAOK1 RNA",
    "TAOK1 Proteo"
  ],
  "AMIGO1": [
    "AMIGO1 CNV",
    "AMIGO1 RNA"
  ],
  "ZNF736P11Y": [
    "ZNF736P11Y CNV",
    "ZNF736P11Y RNA"
  ],
  "NPAP1P7": [
    "NPAP1P7 CNV",
    "NPAP1P7 RNA"
  ],
  "THAP10": [
    "THAP10 CNV",
    "THAP10 RNA"
  ],
  "CACNG8": [
    "CACNG8 CNV",
    "CACNG8 RNA"
  ],
  "AHSP": [
    "AHSP CNV",
    "AHSP RNA",
    "AHSP Proteo"
  ],
  "BNIP3P40": [
    "BNIP3P40 CNV",
    "BNIP3P40 RNA"
  ],
  "PKN2": [
    "PKN2 CNV",
    "PKN2 RNA",
    "PKN2 Proteo"
  ],
  "PTPRO": [
    "PTPRO CNV",
    "PTPRO RNA",
    "PTPRO Proteo"
  ],
  "TSPY26P": [
    "TSPY26P CNV",
    "TSPY26P RNA"
  ],
  "RPL7AP73": [
    "RPL7AP73 CNV",
    "RPL7AP73 RNA"
  ],
  "KNCN": [
    "KNCN CNV",
    "KNCN RNA"
  ],
  "ZBTB49": [
    "ZBTB49 CNV",
    "ZBTB49 RNA"
  ],
  "LOX": [
    "LOX CNV",
    "LOX RNA",
    "LOX Proteo"
  ],
  "RPLP0P10": [
    "RPLP0P10 CNV",
    "RPLP0P10 RNA"
  ],
  "PANK3": [
    "PANK3 CNV",
    "PANK3 RNA",
    "PANK3 Proteo"
  ],
  "TECRP1": [
    "TECRP1 CNV",
    "TECRP1 RNA"
  ],
  "ZDHHC13": [
    "ZDHHC13 CNV",
    "ZDHHC13 RNA",
    "ZDHHC13 Proteo"
  ],
  "SPAG16": [
    "SPAG16 CNV",
    "SPAG16 RNA"
  ],
  "ZFP42": [
    "ZFP42 CNV",
    "ZFP42 RNA"
  ],
  "OCRL": [
    "OCRL CNV",
    "OCRL RNA",
    "OCRL Proteo"
  ],
  "PRR15L": [
    "PRR15L CNV",
    "PRR15L RNA"
  ],
  "RBMY2EP": [
    "RBMY2EP CNV",
    "RBMY2EP RNA"
  ],
  "THOC1": [
    "THOC1 CNV",
    "THOC1 RNA",
    "THOC1 Proteo"
  ],
  "ROM1": [
    "ROM1 CNV",
    "ROM1 RNA"
  ],
  "AIDA": [
    "AIDA CNV",
    "AIDA RNA",
    "AIDA Proteo"
  ],
  "DKKL1": [
    "DKKL1 CNV",
    "DKKL1 RNA"
  ],
  "ADGRB1": [
    "ADGRB1 CNV",
    "ADGRB1 RNA",
    "ADGRB1 Proteo"
  ],
  "NSG2": [
    "NSG2 CNV",
    "NSG2 RNA"
  ],
  "BAG5": [
    "BAG5 CNV",
    "BAG5 RNA",
    "BAG5 Proteo"
  ],
  "SAR1AP4": [
    "SAR1AP4 CNV",
    "SAR1AP4 RNA"
  ],
  "RPS3AP25": [
    "RPS3AP25 CNV",
    "RPS3AP25 RNA"
  ],
  "PPFIA3": [
    "PPFIA3 CNV",
    "PPFIA3 RNA",
    "PPFIA3 Proteo"
  ],
  "PNPP1": [
    "PNPP1 CNV",
    "PNPP1 RNA"
  ],
  "OR9I1": [
    "OR9I1 CNV",
    "OR9I1 RNA"
  ],
  "TMEM72": [
    "TMEM72 CNV",
    "TMEM72 RNA"
  ],
  "RPL9P32": [
    "RPL9P32 CNV",
    "RPL9P32 RNA"
  ],
  "CALY": [
    "CALY CNV",
    "CALY RNA"
  ],
  "VDAC1": [
    "VDAC1 CNV",
    "VDAC1 RNA",
    "VDAC1 Proteo"
  ],
  "DDX49": [
    "DDX49 CNV",
    "DDX49 RNA",
    "DDX49 Proteo"
  ],
  "EMC3": [
    "EMC3 CNV",
    "EMC3 RNA",
    "EMC3 Proteo"
  ],
  "BPIFA1": [
    "BPIFA1 CNV",
    "BPIFA1 RNA"
  ],
  "RFPL4AP6": [
    "RFPL4AP6 CNV",
    "RFPL4AP6 RNA"
  ],
  "IGHV3OR16-9": [
    "IGHV3OR16-9 Proteo"
  ],
  "SRC": [
    "SRC CNV",
    "SRC RNA",
    "SRC Proteo"
  ],
  "AMPD1": [
    "AMPD1 CNV",
    "AMPD1 RNA"
  ],
  "SSX4": [
    "SSX4 CNV",
    "SSX4 RNA"
  ],
  "H4C12": [
    "H4C12 CNV",
    "H4C12 RNA"
  ],
  "WDR62": [
    "WDR62 CNV",
    "WDR62 RNA",
    "WDR62 Proteo"
  ],
  "MTND4P2": [
    "MTND4P2 CNV",
    "MTND4P2 RNA"
  ],
  "RAB6C-AS1": [
    "RAB6C-AS1 CNV",
    "RAB6C-AS1 RNA"
  ],
  "USP9YP7": [
    "USP9YP7 CNV",
    "USP9YP7 RNA"
  ],
  "ZNF70P1": [
    "ZNF70P1 CNV",
    "ZNF70P1 RNA"
  ],
  "ZNF705G": [
    "ZNF705G CNV",
    "ZNF705G RNA"
  ],
  "COL11A2": [
    "COL11A2 CNV",
    "COL11A2 RNA",
    "COL11A2 Proteo"
  ],
  "OR7E24": [
    "OR7E24 CNV",
    "OR7E24 RNA"
  ],
  "RPL7AP34": [
    "RPL7AP34 CNV",
    "RPL7AP34 RNA"
  ],
  "ZNF532": [
    "ZNF532 CNV",
    "ZNF532 RNA",
    "ZNF532 Proteo"
  ],
  "RASSF7": [
    "RASSF7 CNV",
    "RASSF7 RNA",
    "RASSF7 Proteo"
  ],
  "ATAD3A": [
    "ATAD3A CNV",
    "ATAD3A RNA",
    "ATAD3A Proteo"
  ],
  "L3MBTL3": [
    "L3MBTL3 CNV",
    "L3MBTL3 RNA",
    "L3MBTL3 Proteo"
  ],
  "TTPA": [
    "TTPA CNV",
    "TTPA RNA",
    "TTPA Proteo"
  ],
  "EFHC1": [
    "EFHC1 CNV",
    "EFHC1 RNA"
  ],
  "OR8F1P": [
    "OR8F1P CNV",
    "OR8F1P RNA"
  ],
  "KCNQ4": [
    "KCNQ4 CNV",
    "KCNQ4 RNA"
  ],
  "KCNMB3": [
    "KCNMB3 CNV",
    "KCNMB3 RNA"
  ],
  "RPS3AP41": [
    "RPS3AP41 CNV",
    "RPS3AP41 RNA"
  ],
  "ATP5F1B": [
    "ATP5F1B CNV",
    "ATP5F1B RNA",
    "ATP5F1B Proteo"
  ],
  "RPL35AP14": [
    "RPL35AP14 CNV",
    "RPL35AP14 RNA"
  ],
  "HMGB3P2": [
    "HMGB3P2 CNV",
    "HMGB3P2 RNA"
  ],
  "LGALSL": [
    "LGALSL CNV",
    "LGALSL RNA",
    "LGALSL Proteo"
  ],
  "DGKZ": [
    "DGKZ CNV",
    "DGKZ RNA",
    "DGKZ Proteo"
  ],
  "RPL7AP5": [
    "RPL7AP5 CNV",
    "RPL7AP5 RNA"
  ],
  "XPC": [
    "XPC CNV",
    "XPC RNA",
    "XPC Proteo"
  ],
  "REL": [
    "REL CNV",
    "REL RNA",
    "REL Proteo"
  ],
  "SHPK": [
    "SHPK CNV",
    "SHPK RNA",
    "SHPK Proteo"
  ],
  "TBKBP1": [
    "TBKBP1 CNV",
    "TBKBP1 RNA",
    "TBKBP1 Proteo"
  ],
  "AKAP11": [
    "AKAP11 CNV",
    "AKAP11 RNA",
    "AKAP11 Proteo"
  ],
  "BNIP3P11": [
    "BNIP3P11 CNV",
    "BNIP3P11 RNA"
  ],
  "FAM98A": [
    "FAM98A CNV",
    "FAM98A RNA",
    "FAM98A Proteo"
  ],
  "MEDAG": [
    "MEDAG CNV",
    "MEDAG RNA",
    "MEDAG Proteo"
  ],
  "IGLV10-54": [
    "IGLV10-54 Proteo"
  ],
  "CLUH": [
    "CLUH CNV",
    "CLUH RNA",
    "CLUH Proteo"
  ],
  "SEBOX": [
    "SEBOX CNV",
    "SEBOX RNA"
  ],
  "GPX1": [
    "GPX1 CNV",
    "GPX1 RNA",
    "GPX1 Proteo"
  ],
  "TAF7": [
    "TAF7 CNV",
    "TAF7 RNA",
    "TAF7 Proteo"
  ],
  "EMCN": [
    "EMCN CNV",
    "EMCN RNA",
    "EMCN Proteo"
  ],
  "RNA5SP274": [
    "RNA5SP274 CNV",
    "RNA5SP274 RNA"
  ],
  "RUFY3": [
    "RUFY3 CNV",
    "RUFY3 RNA",
    "RUFY3 Proteo"
  ],
  "EEF1DP4": [
    "EEF1DP4 CNV",
    "EEF1DP4 RNA"
  ],
  "RPS27AP20": [
    "RPS27AP20 CNV",
    "RPS27AP20 RNA"
  ],
  "MFSD12": [
    "MFSD12 CNV",
    "MFSD12 RNA",
    "MFSD12 Proteo"
  ],
  "MFFP3": [
    "MFFP3 CNV",
    "MFFP3 RNA"
  ],
  "ADD1": [
    "ADD1 CNV",
    "ADD1 RNA",
    "ADD1 Proteo"
  ],
  "NAA16": [
    "NAA16 CNV",
    "NAA16 RNA",
    "NAA16 Proteo"
  ],
  "GALNT16": [
    "GALNT16 CNV",
    "GALNT16 RNA",
    "GALNT16 Proteo"
  ],
  "VPS36": [
    "VPS36 CNV",
    "VPS36 RNA",
    "VPS36 Proteo"
  ],
  "FAM228B": [
    "FAM228B CNV",
    "FAM228B RNA"
  ],
  "RPE": [
    "RPE CNV",
    "RPE RNA",
    "RPE Proteo"
  ],
  "COX6CP8": [
    "COX6CP8 CNV",
    "COX6CP8 RNA"
  ],
  "H3P8": [
    "H3P8 CNV",
    "H3P8 RNA"
  ],
  "ELMOD3": [
    "ELMOD3 CNV",
    "ELMOD3 RNA",
    "ELMOD3 Proteo"
  ],
  "PRKXP1": [
    "PRKXP1 CNV",
    "PRKXP1 RNA"
  ],
  "ZSWIM6": [
    "ZSWIM6 CNV",
    "ZSWIM6 RNA"
  ],
  "TAS1R3": [
    "TAS1R3 CNV",
    "TAS1R3 RNA"
  ],
  "DNAJB13": [
    "DNAJB13 CNV",
    "DNAJB13 RNA"
  ],
  "SLC23A3": [
    "SLC23A3 CNV",
    "SLC23A3 RNA"
  ],
  "BCO1": [
    "BCO1 CNV",
    "BCO1 RNA"
  ],
  "REXO1L1P": [
    "REXO1L1P CNV",
    "REXO1L1P RNA"
  ],
  "H3C11": [
    "H3C11 CNV",
    "H3C11 RNA"
  ],
  "EEF1GP6": [
    "EEF1GP6 CNV",
    "EEF1GP6 RNA"
  ],
  "HSD17B3": [
    "HSD17B3 CNV",
    "HSD17B3 RNA"
  ],
  "ZSCAN2": [
    "ZSCAN2 CNV",
    "ZSCAN2 RNA",
    "ZSCAN2 Proteo"
  ],
  "ARHGEF37": [
    "ARHGEF37 CNV",
    "ARHGEF37 RNA",
    "ARHGEF37 Proteo"
  ],
  "G6PC1": [
    "G6PC1 CNV",
    "G6PC1 RNA"
  ],
  "NACA3P": [
    "NACA3P CNV",
    "NACA3P RNA"
  ],
  "HSPE1P22": [
    "HSPE1P22 CNV",
    "HSPE1P22 RNA"
  ],
  "FAHD2A": [
    "FAHD2A CNV",
    "FAHD2A RNA",
    "FAHD2A Proteo"
  ],
  "ULBP2": [
    "ULBP2 CNV",
    "ULBP2 RNA",
    "ULBP2 Proteo"
  ],
  "ACSBG1": [
    "ACSBG1 CNV",
    "ACSBG1 RNA",
    "ACSBG1 Proteo"
  ],
  "C14orf132": [
    "C14orf132 CNV",
    "C14orf132 RNA"
  ],
  "TXNL1P1": [
    "TXNL1P1 CNV",
    "TXNL1P1 RNA"
  ],
  "CDK3": [
    "CDK3 CNV",
    "CDK3 RNA",
    "CDK3 Proteo"
  ],
  "USP17L13": [
    "USP17L13 CNV",
    "USP17L13 RNA",
    "USP17L13 Proteo"
  ],
  "TPTEP2": [
    "TPTEP2 CNV",
    "TPTEP2 RNA"
  ],
  "CCDC74B": [
    "CCDC74B CNV",
    "CCDC74B RNA"
  ],
  "CTBP2P5": [
    "CTBP2P5 CNV",
    "CTBP2P5 RNA"
  ],
  "IQCG": [
    "IQCG CNV",
    "IQCG RNA"
  ],
  "HMGB1P10": [
    "HMGB1P10 CNV",
    "HMGB1P10 RNA"
  ],
  "IGFBP2": [
    "IGFBP2 CNV",
    "IGFBP2 RNA",
    "IGFBP2 Proteo"
  ],
  "TSHR": [
    "TSHR CNV",
    "TSHR RNA"
  ],
  "ANKRD2": [
    "ANKRD2 CNV",
    "ANKRD2 RNA",
    "ANKRD2 Proteo"
  ],
  "IGKV4-1": [
    "IGKV4-1 Proteo"
  ],
  "MDH1P2": [
    "MDH1P2 CNV",
    "MDH1P2 RNA"
  ],
  "AIDAP1": [
    "AIDAP1 CNV",
    "AIDAP1 RNA"
  ],
  "OR2A7": [
    "OR2A7 CNV",
    "OR2A7 RNA"
  ],
  "GPLD1": [
    "GPLD1 CNV",
    "GPLD1 RNA",
    "GPLD1 Proteo"
  ],
  "ACTR3BP2": [
    "ACTR3BP2 CNV",
    "ACTR3BP2 RNA"
  ],
  "BAMBI": [
    "BAMBI CNV",
    "BAMBI RNA"
  ],
  "MTND1P26": [
    "MTND1P26 CNV",
    "MTND1P26 RNA"
  ],
  "DKC1": [
    "DKC1 CNV",
    "DKC1 RNA",
    "DKC1 Proteo"
  ],
  "PCED1B": [
    "PCED1B CNV",
    "PCED1B RNA",
    "PCED1B Proteo"
  ],
  "TP53AIP1": [
    "TP53AIP1 CNV",
    "TP53AIP1 RNA"
  ],
  "TCAF1P1": [
    "TCAF1P1 CNV",
    "TCAF1P1 RNA"
  ],
  "WBP1": [
    "WBP1 CNV",
    "WBP1 RNA"
  ],
  "CHORDC1P5": [
    "CHORDC1P5 CNV",
    "CHORDC1P5 RNA"
  ],
  "SELENOV": [
    "SELENOV CNV",
    "SELENOV RNA"
  ],
  "CEACAMP4": [
    "CEACAMP4 CNV",
    "CEACAMP4 RNA"
  ],
  "UBE4A": [
    "UBE4A CNV",
    "UBE4A RNA",
    "UBE4A Proteo"
  ],
  "GLRX5": [
    "GLRX5 CNV",
    "GLRX5 RNA",
    "GLRX5 Proteo"
  ],
  "RPS6KA5": [
    "RPS6KA5 CNV",
    "RPS6KA5 RNA",
    "RPS6KA5 Proteo"
  ],
  "ANKEF1": [
    "ANKEF1 CNV",
    "ANKEF1 RNA"
  ],
  "NOS2P4": [
    "NOS2P4 CNV",
    "NOS2P4 RNA"
  ],
  "H3P5": [
    "H3P5 CNV",
    "H3P5 RNA"
  ],
  "SIT1": [
    "SIT1 CNV",
    "SIT1 RNA",
    "SIT1 Proteo"
  ],
  "DMC1": [
    "DMC1 CNV",
    "DMC1 RNA"
  ],
  "EGR1": [
    "EGR1 CNV",
    "EGR1 RNA",
    "EGR1 Proteo"
  ],
  "KDR": [
    "KDR CNV",
    "KDR RNA"
  ],
  "USP8P2": [
    "USP8P2 CNV",
    "USP8P2 RNA"
  ],
  "NICN2P": [
    "NICN2P CNV",
    "NICN2P RNA"
  ],
  "AXDND1": [
    "AXDND1 CNV",
    "AXDND1 RNA"
  ],
  "SLC2A5": [
    "SLC2A5 CNV",
    "SLC2A5 RNA",
    "SLC2A5 Proteo"
  ],
  "IPO11": [
    "IPO11 CNV",
    "IPO11 RNA",
    "IPO11 Proteo"
  ],
  "CROCC2": [
    "CROCC2 CNV",
    "CROCC2 RNA"
  ],
  "IKBKG": [
    "IKBKG CNV",
    "IKBKG RNA",
    "IKBKG Proteo"
  ],
  "SDHAF3": [
    "SDHAF3 CNV",
    "SDHAF3 RNA",
    "SDHAF3 Proteo"
  ],
  "OR5BQ1P": [
    "OR5BQ1P CNV",
    "OR5BQ1P RNA"
  ],
  "MAP1B": [
    "MAP1B CNV",
    "MAP1B RNA",
    "MAP1B Proteo"
  ],
  "CCT8L1P": [
    "CCT8L1P CNV",
    "CCT8L1P RNA"
  ],
  "RPS2P24": [
    "RPS2P24 CNV",
    "RPS2P24 RNA"
  ],
  "OSBPL2": [
    "OSBPL2 CNV",
    "OSBPL2 RNA",
    "OSBPL2 Proteo"
  ],
  "CYP2B6": [
    "CYP2B6 CNV",
    "CYP2B6 RNA"
  ],
  "SARS2": [
    "SARS2 CNV",
    "SARS2 RNA",
    "SARS2 Proteo"
  ],
  "NDUFC2": [
    "NDUFC2 CNV",
    "NDUFC2 RNA",
    "NDUFC2 Proteo"
  ],
  "LDHAL6A": [
    "LDHAL6A CNV",
    "LDHAL6A RNA",
    "LDHAL6A Proteo"
  ],
  "STRADBP1": [
    "STRADBP1 CNV",
    "STRADBP1 RNA"
  ],
  "KIF28P": [
    "KIF28P CNV",
    "KIF28P RNA"
  ],
  "FAM157A": [
    "FAM157A CNV",
    "FAM157A RNA"
  ],
  "RPS20P12": [
    "RPS20P12 CNV",
    "RPS20P12 RNA"
  ],
  "PHF2": [
    "PHF2 CNV",
    "PHF2 RNA",
    "PHF2 Proteo"
  ],
  "SELENOF": [
    "SELENOF CNV",
    "SELENOF RNA",
    "SELENOF Proteo"
  ],
  "ZBTB21": [
    "ZBTB21 CNV",
    "ZBTB21 RNA",
    "ZBTB21 Proteo"
  ],
  "NODAL": [
    "NODAL CNV",
    "NODAL RNA"
  ],
  "EML3": [
    "EML3 CNV",
    "EML3 RNA",
    "EML3 Proteo"
  ],
  "TRAF1": [
    "TRAF1 CNV",
    "TRAF1 RNA",
    "TRAF1 Proteo"
  ],
  "NCOA1": [
    "NCOA1 CNV",
    "NCOA1 RNA",
    "NCOA1 Proteo"
  ],
  "AADACL3": [
    "AADACL3 CNV",
    "AADACL3 RNA"
  ],
  "ZNF865": [
    "ZNF865 CNV",
    "ZNF865 RNA",
    "ZNF865 Proteo"
  ],
  "EPHB2": [
    "EPHB2 CNV",
    "EPHB2 RNA",
    "EPHB2 Proteo"
  ],
  "EVX2": [
    "EVX2 CNV",
    "EVX2 RNA"
  ],
  "UCMA": [
    "UCMA CNV",
    "UCMA RNA"
  ],
  "FLT4": [
    "FLT4 CNV",
    "FLT4 RNA",
    "FLT4 Proteo"
  ],
  "RPL39P28": [
    "RPL39P28 CNV",
    "RPL39P28 RNA"
  ],
  "C2orf92": [
    "C2orf92 CNV",
    "C2orf92 RNA"
  ],
  "SEPTIN14P19": [
    "SEPTIN14P19 CNV",
    "SEPTIN14P19 RNA"
  ],
  "SESTD1": [
    "SESTD1 CNV",
    "SESTD1 RNA",
    "SESTD1 Proteo"
  ],
  "PDE4DIPP8": [
    "PDE4DIPP8 CNV",
    "PDE4DIPP8 RNA"
  ],
  "RGS12": [
    "RGS12 CNV",
    "RGS12 RNA",
    "RGS12 Proteo"
  ],
  "SPATA16": [
    "SPATA16 CNV",
    "SPATA16 RNA"
  ],
  "POLR2I": [
    "POLR2I CNV",
    "POLR2I RNA",
    "POLR2I Proteo"
  ],
  "RPL10P10": [
    "RPL10P10 CNV",
    "RPL10P10 RNA"
  ],
  "MT-CO3": [
    "MT-CO3 RNA",
    "MT-CO3 Proteo"
  ],
  "CDK17": [
    "CDK17 CNV",
    "CDK17 RNA",
    "CDK17 Proteo"
  ],
  "PTP4A2P2": [
    "PTP4A2P2 CNV",
    "PTP4A2P2 RNA"
  ],
  "NUS1P2": [
    "NUS1P2 CNV",
    "NUS1P2 RNA"
  ],
  "TAF11L2": [
    "TAF11L2 CNV",
    "TAF11L2 RNA"
  ],
  "GATA2": [
    "GATA2 CNV",
    "GATA2 RNA"
  ],
  "RPL7P47": [
    "RPL7P47 CNV",
    "RPL7P47 RNA"
  ],
  "RNF215": [
    "RNF215 CNV",
    "RNF215 RNA"
  ],
  "PDCD6IPP2": [
    "PDCD6IPP2 CNV",
    "PDCD6IPP2 RNA"
  ],
  "PPIAP91": [
    "PPIAP91 CNV",
    "PPIAP91 RNA"
  ],
  "CCDC120": [
    "CCDC120 CNV",
    "CCDC120 RNA",
    "CCDC120 Proteo"
  ],
  "IFNWP5": [
    "IFNWP5 CNV",
    "IFNWP5 RNA"
  ],
  "RPS3AP19": [
    "RPS3AP19 CNV",
    "RPS3AP19 RNA"
  ],
  "TMEM156": [
    "TMEM156 CNV",
    "TMEM156 RNA"
  ],
  "SLC38A8": [
    "SLC38A8 CNV",
    "SLC38A8 RNA"
  ],
  "GLS": [
    "GLS CNV",
    "GLS RNA",
    "GLS Proteo"
  ],
  "C1QL1": [
    "C1QL1 CNV",
    "C1QL1 RNA"
  ],
  "USP54": [
    "USP54 CNV",
    "USP54 RNA",
    "USP54 Proteo"
  ],
  "CTAGE7P": [
    "CTAGE7P CNV",
    "CTAGE7P RNA"
  ],
  "OR10V1": [
    "OR10V1 CNV",
    "OR10V1 RNA"
  ],
  "APONP": [
    "APONP CNV",
    "APONP RNA"
  ],
  "KRTAP5-5": [
    "KRTAP5-5 CNV",
    "KRTAP5-5 RNA"
  ],
  "SOBP": [
    "SOBP CNV",
    "SOBP RNA"
  ],
  "RPL23AP52": [
    "RPL23AP52 CNV",
    "RPL23AP52 RNA"
  ],
  "SLC22A5": [
    "SLC22A5 CNV",
    "SLC22A5 RNA",
    "SLC22A5 Proteo"
  ],
  "CNNM4": [
    "CNNM4 CNV",
    "CNNM4 RNA",
    "CNNM4 Proteo"
  ],
  "DNAL1": [
    "DNAL1 CNV",
    "DNAL1 RNA",
    "DNAL1 Proteo"
  ],
  "HBP1": [
    "HBP1 CNV",
    "HBP1 RNA",
    "HBP1 Proteo"
  ],
  "PIGPP2": [
    "PIGPP2 CNV",
    "PIGPP2 RNA"
  ],
  "SHC2": [
    "SHC2 CNV",
    "SHC2 RNA",
    "SHC2 Proteo"
  ],
  "IGHVII-49-1": [
    "IGHVII-49-1 CNV",
    "IGHVII-49-1 RNA"
  ],
  "PPIHP2": [
    "PPIHP2 CNV",
    "PPIHP2 RNA"
  ],
  "EMC10": [
    "EMC10 CNV",
    "EMC10 RNA",
    "EMC10 Proteo"
  ],
  "TP63": [
    "TP63 CNV",
    "TP63 RNA",
    "TP63 Proteo"
  ],
  "ERICH3": [
    "ERICH3 CNV",
    "ERICH3 RNA"
  ],
  "IPO7P1": [
    "IPO7P1 CNV",
    "IPO7P1 RNA"
  ],
  "SERPINA5": [
    "SERPINA5 CNV",
    "SERPINA5 RNA",
    "SERPINA5 Proteo"
  ],
  "REXO4": [
    "REXO4 CNV",
    "REXO4 RNA",
    "REXO4 Proteo"
  ],
  "DEPDC7": [
    "DEPDC7 CNV",
    "DEPDC7 RNA",
    "DEPDC7 Proteo"
  ],
  "NCF1B": [
    "NCF1B CNV",
    "NCF1B RNA"
  ],
  "SNRPD1": [
    "SNRPD1 CNV",
    "SNRPD1 RNA",
    "SNRPD1 Proteo"
  ],
  "SLC9B1P4": [
    "SLC9B1P4 CNV",
    "SLC9B1P4 RNA"
  ],
  "CSF2RA": [
    "CSF2RA CNV",
    "CSF2RA RNA",
    "CSF2RA Proteo"
  ],
  "MINAR2": [
    "MINAR2 CNV",
    "MINAR2 RNA"
  ],
  "TNNT2": [
    "TNNT2 CNV",
    "TNNT2 RNA"
  ],
  "ALOX5AP": [
    "ALOX5AP CNV",
    "ALOX5AP RNA",
    "ALOX5AP Proteo"
  ],
  "MPHOSPH9": [
    "MPHOSPH9 CNV",
    "MPHOSPH9 RNA",
    "MPHOSPH9 Proteo"
  ],
  "SLC17A6": [
    "SLC17A6 CNV",
    "SLC17A6 RNA"
  ],
  "SPEM2": [
    "SPEM2 CNV",
    "SPEM2 RNA"
  ],
  "PSMD3": [
    "PSMD3 CNV",
    "PSMD3 RNA",
    "PSMD3 Proteo"
  ],
  "HMGB3P26": [
    "HMGB3P26 CNV",
    "HMGB3P26 RNA"
  ],
  "FTH1P14": [
    "FTH1P14 CNV",
    "FTH1P14 RNA"
  ],
  "ADIPOR1": [
    "ADIPOR1 CNV",
    "ADIPOR1 RNA",
    "ADIPOR1 Proteo"
  ],
  "ZNF250": [
    "ZNF250 CNV",
    "ZNF250 RNA",
    "ZNF250 Proteo"
  ],
  "OR2T2": [
    "OR2T2 CNV",
    "OR2T2 RNA"
  ],
  "PLEKHA2": [
    "PLEKHA2 CNV",
    "PLEKHA2 RNA",
    "PLEKHA2 Proteo"
  ],
  "VARS2": [
    "VARS2 CNV",
    "VARS2 RNA",
    "VARS2 Proteo"
  ],
  "PLEKHA8P1": [
    "PLEKHA8P1 CNV",
    "PLEKHA8P1 RNA"
  ],
  "CC2D2B": [
    "CC2D2B CNV",
    "CC2D2B RNA"
  ],
  "OPRD1": [
    "OPRD1 CNV",
    "OPRD1 RNA"
  ],
  "ACAD11": [
    "ACAD11 CNV",
    "ACAD11 RNA",
    "ACAD11 Proteo"
  ],
  "HMGA1P1": [
    "HMGA1P1 CNV",
    "HMGA1P1 RNA"
  ],
  "BNIP3P31": [
    "BNIP3P31 CNV",
    "BNIP3P31 RNA"
  ],
  "KCNJ10": [
    "KCNJ10 CNV",
    "KCNJ10 RNA",
    "KCNJ10 Proteo"
  ],
  "LHX2": [
    "LHX2 CNV",
    "LHX2 RNA"
  ],
  "DDIT3": [
    "DDIT3 CNV",
    "DDIT3 RNA"
  ],
  "ANKRD20A10P": [
    "ANKRD20A10P CNV",
    "ANKRD20A10P RNA"
  ],
  "ZKSCAN8P1": [
    "ZKSCAN8P1 CNV",
    "ZKSCAN8P1 RNA"
  ],
  "HTR2B": [
    "HTR2B CNV",
    "HTR2B RNA"
  ],
  "ABLIM3": [
    "ABLIM3 CNV",
    "ABLIM3 RNA",
    "ABLIM3 Proteo"
  ],
  "TMEM270": [
    "TMEM270 CNV",
    "TMEM270 RNA"
  ],
  "HSP90B3P": [
    "HSP90B3P CNV",
    "HSP90B3P RNA"
  ],
  "ALKBH5": [
    "ALKBH5 CNV",
    "ALKBH5 RNA",
    "ALKBH5 Proteo"
  ],
  "RPS28P7": [
    "RPS28P7 CNV",
    "RPS28P7 RNA"
  ],
  "NAT1": [
    "NAT1 CNV",
    "NAT1 RNA",
    "NAT1 Proteo"
  ],
  "HSPA9P1": [
    "HSPA9P1 CNV",
    "HSPA9P1 RNA"
  ],
  "SPDYE19P": [
    "SPDYE19P CNV",
    "SPDYE19P RNA"
  ],
  "RGS18": [
    "RGS18 CNV",
    "RGS18 RNA",
    "RGS18 Proteo"
  ],
  "YARS2": [
    "YARS2 CNV",
    "YARS2 RNA",
    "YARS2 Proteo"
  ],
  "KIR2DL4": [
    "KIR2DL4 CNV",
    "KIR2DL4 RNA"
  ],
  "RPL12P50": [
    "RPL12P50 CNV",
    "RPL12P50 RNA"
  ],
  "UNC45B": [
    "UNC45B CNV",
    "UNC45B RNA",
    "UNC45B Proteo"
  ],
  "SERBP1P3": [
    "SERBP1P3 CNV",
    "SERBP1P3 RNA"
  ],
  "MXI1": [
    "MXI1 CNV",
    "MXI1 RNA",
    "MXI1 Proteo"
  ],
  "MEPCE": [
    "MEPCE CNV",
    "MEPCE RNA",
    "MEPCE Proteo"
  ],
  "OTOS": [
    "OTOS CNV",
    "OTOS RNA"
  ],
  "CXCL10": [
    "CXCL10 CNV",
    "CXCL10 RNA",
    "CXCL10 Proteo"
  ],
  "KRBOX5": [
    "KRBOX5 CNV",
    "KRBOX5 RNA"
  ],
  "NECAP1P1": [
    "NECAP1P1 CNV",
    "NECAP1P1 RNA"
  ],
  "PLAC1": [
    "PLAC1 CNV",
    "PLAC1 RNA"
  ],
  "KRBOX5P1": [
    "KRBOX5P1 CNV",
    "KRBOX5P1 RNA"
  ],
  "ZBTB37": [
    "ZBTB37 CNV",
    "ZBTB37 RNA",
    "ZBTB37 Proteo"
  ],
  "RPL36P14": [
    "RPL36P14 CNV",
    "RPL36P14 RNA"
  ],
  "EXOC3L4": [
    "EXOC3L4 CNV",
    "EXOC3L4 RNA",
    "EXOC3L4 Proteo"
  ],
  "MBNL1": [
    "MBNL1 CNV",
    "MBNL1 RNA",
    "MBNL1 Proteo"
  ],
  "KMT2CP5": [
    "KMT2CP5 CNV",
    "KMT2CP5 RNA"
  ],
  "AUNIP": [
    "AUNIP CNV",
    "AUNIP RNA"
  ],
  "LRRC24": [
    "LRRC24 CNV",
    "LRRC24 RNA"
  ],
  "H2BC4": [
    "H2BC4 CNV",
    "H2BC4 RNA"
  ],
  "CCDC181": [
    "CCDC181 CNV",
    "CCDC181 RNA"
  ],
  "THBS2": [
    "THBS2 CNV",
    "THBS2 RNA",
    "THBS2 Proteo"
  ],
  "VCX3A": [
    "VCX3A CNV",
    "VCX3A RNA"
  ],
  "TRGV6": [
    "TRGV6 CNV",
    "TRGV6 RNA"
  ],
  "ACYP2": [
    "ACYP2 CNV",
    "ACYP2 RNA",
    "ACYP2 Proteo"
  ],
  "P2RY10": [
    "P2RY10 CNV",
    "P2RY10 RNA"
  ],
  "SLC16A12": [
    "SLC16A12 CNV",
    "SLC16A12 RNA"
  ],
  "PPIAP73": [
    "PPIAP73 CNV",
    "PPIAP73 RNA"
  ],
  "EFR3B": [
    "EFR3B CNV",
    "EFR3B RNA",
    "EFR3B Proteo"
  ],
  "GRIK3": [
    "GRIK3 CNV",
    "GRIK3 RNA",
    "GRIK3 Proteo"
  ],
  "HMGB1P36": [
    "HMGB1P36 CNV",
    "HMGB1P36 RNA"
  ],
  "RPL21P111": [
    "RPL21P111 CNV",
    "RPL21P111 RNA"
  ],
  "BMS1P15": [
    "BMS1P15 CNV",
    "BMS1P15 RNA"
  ],
  "CYCSP5": [
    "CYCSP5 CNV",
    "CYCSP5 RNA"
  ],
  "CAMK2N2": [
    "CAMK2N2 CNV",
    "CAMK2N2 RNA"
  ],
  "SLC25A33": [
    "SLC25A33 CNV",
    "SLC25A33 RNA",
    "SLC25A33 Proteo"
  ],
  "CEP85L": [
    "CEP85L CNV",
    "CEP85L RNA",
    "CEP85L Proteo"
  ],
  "RPL22P10": [
    "RPL22P10 CNV",
    "RPL22P10 RNA"
  ],
  "ABCA1": [
    "ABCA1 CNV",
    "ABCA1 RNA",
    "ABCA1 Proteo"
  ],
  "NRBF2": [
    "NRBF2 CNV",
    "NRBF2 RNA",
    "NRBF2 Proteo"
  ],
  "OR4F16": [
    "OR4F16 CNV",
    "OR4F16 RNA"
  ],
  "C1GALT1P1": [
    "C1GALT1P1 CNV",
    "C1GALT1P1 RNA"
  ],
  "SURF2": [
    "SURF2 CNV",
    "SURF2 RNA",
    "SURF2 Proteo"
  ],
  "OR4K5": [
    "OR4K5 CNV",
    "OR4K5 RNA"
  ],
  "ORC6": [
    "ORC6 CNV",
    "ORC6 RNA",
    "ORC6 Proteo"
  ],
  "H4C5": [
    "H4C5 CNV",
    "H4C5 RNA"
  ],
  "MTND4P27": [
    "MTND4P27 CNV",
    "MTND4P27 RNA"
  ],
  "ADH5P4": [
    "ADH5P4 CNV",
    "ADH5P4 RNA"
  ],
  "OR4K16P": [
    "OR4K16P CNV",
    "OR4K16P RNA"
  ],
  "ZFP41": [
    "ZFP41 CNV",
    "ZFP41 RNA",
    "ZFP41 Proteo"
  ],
  "TMEM126A": [
    "TMEM126A CNV",
    "TMEM126A RNA",
    "TMEM126A Proteo"
  ],
  "MT1HL1": [
    "MT1HL1 CNV",
    "MT1HL1 RNA",
    "MT1HL1 Proteo"
  ],
  "SLC6A2": [
    "SLC6A2 CNV",
    "SLC6A2 RNA"
  ],
  "CCL7": [
    "CCL7 CNV",
    "CCL7 RNA"
  ],
  "SH3PXD2B": [
    "SH3PXD2B CNV",
    "SH3PXD2B RNA",
    "SH3PXD2B Proteo"
  ],
  "TNFRSF1B": [
    "TNFRSF1B CNV",
    "TNFRSF1B RNA",
    "TNFRSF1B Proteo"
  ],
  "IZUMO4": [
    "IZUMO4 CNV",
    "IZUMO4 RNA"
  ],
  "SCAMP5": [
    "SCAMP5 CNV",
    "SCAMP5 RNA"
  ],
  "BTNL2": [
    "BTNL2 CNV",
    "BTNL2 RNA"
  ],
  "TTC22": [
    "TTC22 CNV",
    "TTC22 RNA"
  ],
  "HNRNPF": [
    "HNRNPF CNV",
    "HNRNPF RNA",
    "HNRNPF Proteo"
  ],
  "PDXK": [
    "PDXK CNV",
    "PDXK RNA",
    "PDXK Proteo"
  ],
  "DBNDD1": [
    "DBNDD1 CNV",
    "DBNDD1 RNA",
    "DBNDD1 Proteo"
  ],
  "ERMARD": [
    "ERMARD CNV",
    "ERMARD RNA"
  ],
  "UGT2B28": [
    "UGT2B28 CNV",
    "UGT2B28 RNA"
  ],
  "ZNF674": [
    "ZNF674 CNV",
    "ZNF674 RNA"
  ],
  "COX7A2P2": [
    "COX7A2P2 CNV",
    "COX7A2P2 RNA"
  ],
  "IL9R": [
    "IL9R CNV",
    "IL9R RNA"
  ],
  "SLC25A39P2": [
    "SLC25A39P2 CNV",
    "SLC25A39P2 RNA"
  ],
  "RLBP1": [
    "RLBP1 CNV",
    "RLBP1 RNA",
    "RLBP1 Proteo"
  ],
  "REXO1": [
    "REXO1 CNV",
    "REXO1 RNA",
    "REXO1 Proteo"
  ],
  "PGAM1": [
    "PGAM1 CNV",
    "PGAM1 RNA",
    "PGAM1 Proteo"
  ],
  "GLIPR1L2": [
    "GLIPR1L2 CNV",
    "GLIPR1L2 RNA"
  ],
  "LIPE": [
    "LIPE CNV",
    "LIPE RNA",
    "LIPE Proteo"
  ],
  "OR8I1P": [
    "OR8I1P CNV",
    "OR8I1P RNA"
  ],
  "KRT18P29": [
    "KRT18P29 CNV",
    "KRT18P29 RNA"
  ],
  "RNA5SP245": [
    "RNA5SP245 CNV",
    "RNA5SP245 RNA"
  ],
  "NAP1L4": [
    "NAP1L4 CNV",
    "NAP1L4 RNA",
    "NAP1L4 Proteo"
  ],
  "LARP7": [
    "LARP7 CNV",
    "LARP7 RNA",
    "LARP7 Proteo"
  ],
  "MRPL33": [
    "MRPL33 CNV",
    "MRPL33 RNA",
    "MRPL33 Proteo"
  ],
  "EGFEM1P": [
    "EGFEM1P CNV",
    "EGFEM1P RNA"
  ],
  "PCMTD1P2": [
    "PCMTD1P2 CNV",
    "PCMTD1P2 RNA"
  ],
  "COX8A": [
    "COX8A CNV",
    "COX8A RNA"
  ],
  "LLGL1": [
    "LLGL1 CNV",
    "LLGL1 RNA",
    "LLGL1 Proteo"
  ],
  "SFXN3": [
    "SFXN3 CNV",
    "SFXN3 RNA",
    "SFXN3 Proteo"
  ],
  "UGT1A11P": [
    "UGT1A11P CNV",
    "UGT1A11P RNA"
  ],
  "RAD21": [
    "RAD21 CNV",
    "RAD21 RNA",
    "RAD21 Proteo"
  ],
  "MYF5": [
    "MYF5 CNV",
    "MYF5 RNA"
  ],
  "NPFFR2": [
    "NPFFR2 CNV",
    "NPFFR2 RNA"
  ],
  "PRR5L": [
    "PRR5L CNV",
    "PRR5L RNA",
    "PRR5L Proteo"
  ],
  "AK3": [
    "AK3 CNV",
    "AK3 RNA",
    "AK3 Proteo"
  ],
  "ARMH2": [
    "ARMH2 CNV",
    "ARMH2 RNA"
  ],
  "ZNF605": [
    "ZNF605 CNV",
    "ZNF605 RNA"
  ],
  "ZSWIM2": [
    "ZSWIM2 CNV",
    "ZSWIM2 RNA"
  ],
  "NEBL": [
    "NEBL CNV",
    "NEBL RNA",
    "NEBL Proteo"
  ],
  "SPRR2D": [
    "SPRR2D CNV",
    "SPRR2D RNA",
    "SPRR2D Proteo"
  ],
  "OR2AT2P": [
    "OR2AT2P CNV",
    "OR2AT2P RNA"
  ],
  "GINM1": [
    "GINM1 CNV",
    "GINM1 RNA",
    "GINM1 Proteo"
  ],
  "ALDH8A1": [
    "ALDH8A1 CNV",
    "ALDH8A1 RNA"
  ],
  "ZDHHC11": [
    "ZDHHC11 CNV",
    "ZDHHC11 RNA"
  ],
  "FZD3": [
    "FZD3 CNV",
    "FZD3 RNA"
  ],
  "CNN2P4": [
    "CNN2P4 CNV",
    "CNN2P4 RNA"
  ],
  "SETD6": [
    "SETD6 CNV",
    "SETD6 RNA",
    "SETD6 Proteo"
  ],
  "IGF1": [
    "IGF1 CNV",
    "IGF1 RNA"
  ],
  "CNN2P10": [
    "CNN2P10 CNV",
    "CNN2P10 RNA"
  ],
  "TIMM17BP1": [
    "TIMM17BP1 CNV",
    "TIMM17BP1 RNA"
  ],
  "ZNF736P5Y": [
    "ZNF736P5Y CNV",
    "ZNF736P5Y RNA"
  ],
  "TNRC18": [
    "TNRC18 CNV",
    "TNRC18 RNA",
    "TNRC18 Proteo"
  ],
  "ADH5P2": [
    "ADH5P2 CNV",
    "ADH5P2 RNA"
  ],
  "PCMTD1P7": [
    "PCMTD1P7 CNV",
    "PCMTD1P7 RNA"
  ],
  "RPSAP47": [
    "RPSAP47 CNV",
    "RPSAP47 RNA"
  ],
  "STX8P1": [
    "STX8P1 CNV",
    "STX8P1 RNA"
  ],
  "SLC22A15": [
    "SLC22A15 CNV",
    "SLC22A15 RNA"
  ],
  "C20orf173": [
    "C20orf173 CNV",
    "C20orf173 RNA"
  ],
  "NAT14": [
    "NAT14 CNV",
    "NAT14 RNA",
    "NAT14 Proteo"
  ],
  "ZMYND15": [
    "ZMYND15 CNV",
    "ZMYND15 RNA"
  ],
  "NEK10": [
    "NEK10 CNV",
    "NEK10 RNA"
  ],
  "CBWD1": [
    "CBWD1 CNV",
    "CBWD1 RNA",
    "CBWD1 Proteo"
  ],
  "TASP1": [
    "TASP1 CNV",
    "TASP1 RNA",
    "TASP1 Proteo"
  ],
  "OR1R1P": [
    "OR1R1P CNV",
    "OR1R1P RNA"
  ],
  "WASH7P": [
    "WASH7P CNV",
    "WASH7P RNA"
  ],
  "MESP1": [
    "MESP1 CNV",
    "MESP1 RNA"
  ],
  "GLUD1P2": [
    "GLUD1P2 CNV",
    "GLUD1P2 RNA"
  ],
  "EI24P4": [
    "EI24P4 CNV",
    "EI24P4 RNA"
  ],
  "COX19": [
    "COX19 CNV",
    "COX19 RNA",
    "COX19 Proteo"
  ],
  "ELAC2": [
    "ELAC2 CNV",
    "ELAC2 RNA",
    "ELAC2 Proteo"
  ],
  "KCNB2": [
    "KCNB2 CNV",
    "KCNB2 RNA"
  ],
  "C17orf50": [
    "C17orf50 CNV",
    "C17orf50 RNA"
  ],
  "HECTD4": [
    "HECTD4 CNV",
    "HECTD4 RNA",
    "HECTD4 Proteo"
  ],
  "ROPN1L": [
    "ROPN1L CNV",
    "ROPN1L RNA"
  ],
  "DEFB127": [
    "DEFB127 CNV",
    "DEFB127 RNA"
  ],
  "DNAAF1": [
    "DNAAF1 CNV",
    "DNAAF1 RNA",
    "DNAAF1 Proteo"
  ],
  "RBM12": [
    "RBM12 CNV",
    "RBM12 RNA",
    "RBM12 Proteo"
  ],
  "RFX8": [
    "RFX8 CNV",
    "RFX8 RNA"
  ],
  "CENPVL3": [
    "CENPVL3 CNV",
    "CENPVL3 RNA"
  ],
  "MRGPRX11P": [
    "MRGPRX11P CNV",
    "MRGPRX11P RNA"
  ],
  "TMEM30A": [
    "TMEM30A CNV",
    "TMEM30A RNA",
    "TMEM30A Proteo"
  ],
  "OR5E1P": [
    "OR5E1P CNV",
    "OR5E1P RNA"
  ],
  "ZNF663P": [
    "ZNF663P CNV",
    "ZNF663P RNA"
  ],
  "CYP3A52P": [
    "CYP3A52P CNV",
    "CYP3A52P RNA"
  ],
  "GAST": [
    "GAST CNV",
    "GAST RNA"
  ],
  "NANOG": [
    "NANOG CNV",
    "NANOG RNA"
  ],
  "HMGN1P10": [
    "HMGN1P10 CNV",
    "HMGN1P10 RNA"
  ],
  "IQCA1": [
    "IQCA1 CNV",
    "IQCA1 RNA"
  ],
  "FEV": [
    "FEV CNV",
    "FEV RNA"
  ],
  "OR7E13P": [
    "OR7E13P CNV",
    "OR7E13P RNA"
  ],
  "CKMT2": [
    "CKMT2 CNV",
    "CKMT2 RNA",
    "CKMT2 Proteo"
  ],
  "CANX": [
    "CANX CNV",
    "CANX RNA",
    "CANX Proteo"
  ],
  "GPR83": [
    "GPR83 CNV",
    "GPR83 RNA"
  ],
  "MTRF1L": [
    "MTRF1L CNV",
    "MTRF1L RNA",
    "MTRF1L Proteo"
  ],
  "OR6D1P": [
    "OR6D1P CNV",
    "OR6D1P RNA"
  ],
  "DEFB128": [
    "DEFB128 CNV",
    "DEFB128 RNA"
  ],
  "CD226": [
    "CD226 CNV",
    "CD226 RNA"
  ],
  "PPP1R14C": [
    "PPP1R14C CNV",
    "PPP1R14C RNA"
  ],
  "KRT43P": [
    "KRT43P CNV",
    "KRT43P RNA"
  ],
  "FOS": [
    "FOS CNV",
    "FOS RNA",
    "FOS Proteo"
  ],
  "OR8T1P": [
    "OR8T1P CNV",
    "OR8T1P RNA"
  ],
  "MICALL2": [
    "MICALL2 CNV",
    "MICALL2 RNA",
    "MICALL2 Proteo"
  ],
  "UTP23": [
    "UTP23 CNV",
    "UTP23 RNA",
    "UTP23 Proteo"
  ],
  "LARP4B": [
    "LARP4B CNV",
    "LARP4B RNA",
    "LARP4B Proteo"
  ],
  "TUSC2P1": [
    "TUSC2P1 CNV",
    "TUSC2P1 RNA"
  ],
  "NIPA2P1": [
    "NIPA2P1 CNV",
    "NIPA2P1 RNA"
  ],
  "NHP2": [
    "NHP2 CNV",
    "NHP2 RNA",
    "NHP2 Proteo"
  ],
  "C5AR2": [
    "C5AR2 CNV",
    "C5AR2 RNA"
  ],
  "SLC31A2": [
    "SLC31A2 CNV",
    "SLC31A2 RNA",
    "SLC31A2 Proteo"
  ],
  "SLC18B1": [
    "SLC18B1 CNV",
    "SLC18B1 RNA",
    "SLC18B1 Proteo"
  ],
  "FAM83A": [
    "FAM83A CNV",
    "FAM83A RNA"
  ],
  "PPP1R2P1": [
    "PPP1R2P1 CNV",
    "PPP1R2P1 RNA"
  ],
  "DBNDD2": [
    "DBNDD2 CNV",
    "DBNDD2 RNA"
  ],
  "HFE": [
    "HFE CNV",
    "HFE RNA",
    "HFE Proteo"
  ],
  "CEBPD": [
    "CEBPD CNV",
    "CEBPD RNA",
    "CEBPD Proteo"
  ],
  "MAD2L1": [
    "MAD2L1 CNV",
    "MAD2L1 RNA",
    "MAD2L1 Proteo"
  ],
  "ATMIN": [
    "ATMIN CNV",
    "ATMIN RNA"
  ],
  "ZNF333": [
    "ZNF333 CNV",
    "ZNF333 RNA"
  ],
  "RPL36AP55": [
    "RPL36AP55 CNV",
    "RPL36AP55 RNA"
  ],
  "SF3A3P1": [
    "SF3A3P1 CNV",
    "SF3A3P1 RNA"
  ],
  "MIEF1": [
    "MIEF1 CNV",
    "MIEF1 RNA",
    "MIEF1 Proteo"
  ],
  "ZNF586": [
    "ZNF586 CNV",
    "ZNF586 RNA"
  ],
  "CROCC": [
    "CROCC CNV",
    "CROCC RNA",
    "CROCC Proteo"
  ],
  "PDCD10": [
    "PDCD10 CNV",
    "PDCD10 RNA",
    "PDCD10 Proteo"
  ],
  "EFNB3": [
    "EFNB3 CNV",
    "EFNB3 RNA"
  ],
  "ARHGAP44": [
    "ARHGAP44 CNV",
    "ARHGAP44 RNA",
    "ARHGAP44 Proteo"
  ],
  "TBC1D8": [
    "TBC1D8 CNV",
    "TBC1D8 RNA",
    "TBC1D8 Proteo"
  ],
  "CCND3P2": [
    "CCND3P2 CNV",
    "CCND3P2 RNA"
  ],
  "KCNE3": [
    "KCNE3 CNV",
    "KCNE3 RNA"
  ],
  "PRRC2B": [
    "PRRC2B CNV",
    "PRRC2B RNA",
    "PRRC2B Proteo"
  ],
  "CHORDC1P3": [
    "CHORDC1P3 CNV",
    "CHORDC1P3 RNA"
  ],
  "RPL17P17": [
    "RPL17P17 CNV",
    "RPL17P17 RNA"
  ],
  "MAFK": [
    "MAFK CNV",
    "MAFK RNA",
    "MAFK Proteo"
  ],
  "MDM1": [
    "MDM1 CNV",
    "MDM1 RNA",
    "MDM1 Proteo"
  ],
  "RNA5SP240": [
    "RNA5SP240 CNV",
    "RNA5SP240 RNA"
  ],
  "ATG3": [
    "ATG3 CNV",
    "ATG3 RNA",
    "ATG3 Proteo"
  ],
  "VTI1BP1": [
    "VTI1BP1 CNV",
    "VTI1BP1 RNA"
  ],
  "BCL7A": [
    "BCL7A CNV",
    "BCL7A RNA",
    "BCL7A Proteo"
  ],
  "APIP": [
    "APIP CNV",
    "APIP RNA",
    "APIP Proteo"
  ],
  "PTPRJ": [
    "PTPRJ CNV",
    "PTPRJ RNA",
    "PTPRJ Proteo"
  ],
  "NEUROD4": [
    "NEUROD4 CNV",
    "NEUROD4 RNA"
  ],
  "CFL1P2": [
    "CFL1P2 CNV",
    "CFL1P2 RNA"
  ],
  "GAPDHP48": [
    "GAPDHP48 CNV",
    "GAPDHP48 RNA"
  ],
  "OR4C1P": [
    "OR4C1P CNV",
    "OR4C1P RNA"
  ],
  "RTN4RL2": [
    "RTN4RL2 CNV",
    "RTN4RL2 RNA",
    "RTN4RL2 Proteo"
  ],
  "GDF15": [
    "GDF15 CNV",
    "GDF15 RNA",
    "GDF15 Proteo"
  ],
  "ADAM29": [
    "ADAM29 CNV",
    "ADAM29 RNA"
  ],
  "NAA60": [
    "NAA60 CNV",
    "NAA60 RNA",
    "NAA60 Proteo"
  ],
  "CSF1R": [
    "CSF1R CNV",
    "CSF1R RNA",
    "CSF1R Proteo"
  ],
  "RPL7AP62": [
    "RPL7AP62 CNV",
    "RPL7AP62 RNA"
  ],
  "RARS1": [
    "RARS1 CNV",
    "RARS1 RNA",
    "RARS1 Proteo"
  ],
  "OR4K8P": [
    "OR4K8P CNV",
    "OR4K8P RNA"
  ],
  "GNB5": [
    "GNB5 CNV",
    "GNB5 RNA",
    "GNB5 Proteo"
  ],
  "YJU2B": [
    "YJU2B CNV",
    "YJU2B RNA",
    "YJU2B Proteo"
  ],
  "UBE2WP1": [
    "UBE2WP1 CNV",
    "UBE2WP1 RNA"
  ],
  "SNRPF": [
    "SNRPF CNV",
    "SNRPF RNA",
    "SNRPF Proteo"
  ],
  "BRD3": [
    "BRD3 CNV",
    "BRD3 RNA",
    "BRD3 Proteo"
  ],
  "RPL36AP41": [
    "RPL36AP41 CNV",
    "RPL36AP41 RNA"
  ],
  "NTN3": [
    "NTN3 CNV",
    "NTN3 RNA"
  ],
  "NPY1R": [
    "NPY1R CNV",
    "NPY1R RNA"
  ],
  "RPL7AP70": [
    "RPL7AP70 CNV",
    "RPL7AP70 RNA"
  ],
  "BPTFP1": [
    "BPTFP1 CNV",
    "BPTFP1 RNA"
  ],
  "SSXP9": [
    "SSXP9 CNV",
    "SSXP9 RNA"
  ],
  "DEFB122": [
    "DEFB122 CNV",
    "DEFB122 RNA"
  ],
  "OR6C71P": [
    "OR6C71P CNV",
    "OR6C71P RNA"
  ],
  "IGLC4": [
    "IGLC4 CNV",
    "IGLC4 RNA"
  ],
  "RAPGEF4": [
    "RAPGEF4 CNV",
    "RAPGEF4 RNA",
    "RAPGEF4 Proteo"
  ],
  "NPAP1L": [
    "NPAP1L CNV",
    "NPAP1L RNA"
  ],
  "SENP5": [
    "SENP5 CNV",
    "SENP5 RNA",
    "SENP5 Proteo"
  ],
  "BTD": [
    "BTD CNV",
    "BTD RNA",
    "BTD Proteo"
  ],
  "ARL2BPP4": [
    "ARL2BPP4 CNV",
    "ARL2BPP4 RNA"
  ],
  "IGKC": [
    "IGKC Proteo"
  ],
  "RNA5SP409": [
    "RNA5SP409 CNV",
    "RNA5SP409 RNA"
  ],
  "RTN4IP1": [
    "RTN4IP1 CNV",
    "RTN4IP1 RNA",
    "RTN4IP1 Proteo"
  ],
  "LRRN4": [
    "LRRN4 CNV",
    "LRRN4 RNA",
    "LRRN4 Proteo"
  ],
  "NPR3": [
    "NPR3 CNV",
    "NPR3 RNA"
  ],
  "PLEKHO2": [
    "PLEKHO2 CNV",
    "PLEKHO2 RNA",
    "PLEKHO2 Proteo"
  ],
  "ASTL": [
    "ASTL CNV",
    "ASTL RNA"
  ],
  "CFHR5": [
    "CFHR5 CNV",
    "CFHR5 RNA",
    "CFHR5 Proteo"
  ],
  "MSRA": [
    "MSRA CNV",
    "MSRA RNA",
    "MSRA Proteo"
  ],
  "BTF3P9": [
    "BTF3P9 CNV",
    "BTF3P9 RNA"
  ],
  "TOR2A": [
    "TOR2A CNV",
    "TOR2A RNA",
    "TOR2A Proteo"
  ],
  "NCKAP1P1": [
    "NCKAP1P1 CNV",
    "NCKAP1P1 RNA"
  ],
  "TARDBPP4": [
    "TARDBPP4 CNV",
    "TARDBPP4 RNA"
  ],
  "VEGFB": [
    "VEGFB CNV",
    "VEGFB RNA"
  ],
  "SLC25A6P4": [
    "SLC25A6P4 CNV",
    "SLC25A6P4 RNA"
  ],
  "UBR3": [
    "UBR3 CNV",
    "UBR3 RNA",
    "UBR3 Proteo"
  ],
  "MTND2P17": [
    "MTND2P17 CNV",
    "MTND2P17 RNA"
  ],
  "PCDHGA10": [
    "PCDHGA10 CNV",
    "PCDHGA10 RNA"
  ],
  "RIOK2": [
    "RIOK2 CNV",
    "RIOK2 RNA",
    "RIOK2 Proteo"
  ],
  "SMCO2": [
    "SMCO2 CNV",
    "SMCO2 RNA"
  ],
  "DPEP3": [
    "DPEP3 CNV",
    "DPEP3 RNA"
  ],
  "PPHLN1": [
    "PPHLN1 CNV",
    "PPHLN1 RNA",
    "PPHLN1 Proteo"
  ],
  "TEPP": [
    "TEPP CNV",
    "TEPP RNA"
  ],
  "PAXIP1": [
    "PAXIP1 CNV",
    "PAXIP1 RNA",
    "PAXIP1 Proteo"
  ],
  "YWHAQP6": [
    "YWHAQP6 CNV",
    "YWHAQP6 RNA"
  ],
  "CAPN13": [
    "CAPN13 CNV",
    "CAPN13 RNA"
  ],
  "ADCY2": [
    "ADCY2 CNV",
    "ADCY2 RNA"
  ],
  "NDEL1": [
    "NDEL1 CNV",
    "NDEL1 RNA",
    "NDEL1 Proteo"
  ],
  "MLLT10": [
    "MLLT10 CNV",
    "MLLT10 RNA",
    "MLLT10 Proteo"
  ],
  "HEMGN": [
    "HEMGN CNV",
    "HEMGN RNA"
  ],
  "PPIAP4": [
    "PPIAP4 CNV",
    "PPIAP4 RNA"
  ],
  "BEND3": [
    "BEND3 CNV",
    "BEND3 RNA",
    "BEND3 Proteo"
  ],
  "PRAMEF11": [
    "PRAMEF11 CNV",
    "PRAMEF11 RNA"
  ],
  "SUPT7L": [
    "SUPT7L CNV",
    "SUPT7L RNA",
    "SUPT7L Proteo"
  ],
  "RIT2": [
    "RIT2 CNV",
    "RIT2 RNA"
  ],
  "UBE2DNL": [
    "UBE2DNL CNV",
    "UBE2DNL RNA"
  ],
  "GRK6": [
    "GRK6 CNV",
    "GRK6 RNA",
    "GRK6 Proteo"
  ],
  "DCBLD1": [
    "DCBLD1 CNV",
    "DCBLD1 RNA",
    "DCBLD1 Proteo"
  ],
  "NPIPB11": [
    "NPIPB11 CNV",
    "NPIPB11 RNA"
  ],
  "FOXD4": [
    "FOXD4 CNV",
    "FOXD4 RNA"
  ],
  "ZNF890P": [
    "ZNF890P CNV",
    "ZNF890P RNA"
  ],
  "ZNF716": [
    "ZNF716 CNV",
    "ZNF716 RNA"
  ],
  "GIGYF1": [
    "GIGYF1 CNV",
    "GIGYF1 RNA",
    "GIGYF1 Proteo"
  ],
  "RPL23AP43": [
    "RPL23AP43 CNV",
    "RPL23AP43 RNA"
  ],
  "OTOP1": [
    "OTOP1 CNV",
    "OTOP1 RNA"
  ],
  "KRT16P3": [
    "KRT16P3 CNV",
    "KRT16P3 RNA"
  ],
  "GIT1": [
    "GIT1 CNV",
    "GIT1 RNA",
    "GIT1 Proteo"
  ],
  "CMSS1": [
    "CMSS1 CNV",
    "CMSS1 RNA",
    "CMSS1 Proteo"
  ],
  "ZNF460": [
    "ZNF460 CNV",
    "ZNF460 RNA",
    "ZNF460 Proteo"
  ],
  "EEDP1": [
    "EEDP1 CNV",
    "EEDP1 RNA"
  ],
  "MIS18BP1": [
    "MIS18BP1 CNV",
    "MIS18BP1 RNA",
    "MIS18BP1 Proteo"
  ],
  "DEFB131A": [
    "DEFB131A CNV",
    "DEFB131A RNA"
  ],
  "SHANK2": [
    "SHANK2 CNV",
    "SHANK2 RNA",
    "SHANK2 Proteo"
  ],
  "MED23": [
    "MED23 CNV",
    "MED23 RNA",
    "MED23 Proteo"
  ],
  "NIFKP1": [
    "NIFKP1 CNV",
    "NIFKP1 RNA"
  ],
  "OR10A2": [
    "OR10A2 CNV",
    "OR10A2 RNA"
  ],
  "PRKAB1": [
    "PRKAB1 CNV",
    "PRKAB1 RNA",
    "PRKAB1 Proteo"
  ],
  "KHDC1P1": [
    "KHDC1P1 CNV",
    "KHDC1P1 RNA"
  ],
  "EML4": [
    "EML4 CNV",
    "EML4 RNA",
    "EML4 Proteo"
  ],
  "ACYP1": [
    "ACYP1 CNV",
    "ACYP1 RNA",
    "ACYP1 Proteo"
  ],
  "RPL39P": [
    "RPL39P CNV",
    "RPL39P RNA"
  ],
  "ALG1L5P": [
    "ALG1L5P CNV",
    "ALG1L5P RNA"
  ],
  "AGPAT2": [
    "AGPAT2 CNV",
    "AGPAT2 RNA",
    "AGPAT2 Proteo"
  ],
  "RGPD3": [
    "RGPD3 CNV",
    "RGPD3 RNA"
  ],
  "B4GALT4": [
    "B4GALT4 CNV",
    "B4GALT4 RNA",
    "B4GALT4 Proteo"
  ],
  "FOXS1": [
    "FOXS1 CNV",
    "FOXS1 RNA"
  ],
  "LCEP4": [
    "LCEP4 CNV",
    "LCEP4 RNA"
  ],
  "MRPL16": [
    "MRPL16 CNV",
    "MRPL16 RNA",
    "MRPL16 Proteo"
  ],
  "CA15P1": [
    "CA15P1 CNV",
    "CA15P1 RNA"
  ],
  "MAP3K4": [
    "MAP3K4 CNV",
    "MAP3K4 RNA",
    "MAP3K4 Proteo"
  ],
  "PI4K2B": [
    "PI4K2B CNV",
    "PI4K2B RNA",
    "PI4K2B Proteo"
  ],
  "OR1E1": [
    "OR1E1 CNV",
    "OR1E1 RNA"
  ],
  "ZNF419": [
    "ZNF419 CNV",
    "ZNF419 RNA"
  ],
  "SPDYE1": [
    "SPDYE1 CNV",
    "SPDYE1 RNA"
  ],
  "FAM156A": [
    "FAM156A CNV",
    "FAM156A RNA"
  ],
  "PAICSP7": [
    "PAICSP7 CNV",
    "PAICSP7 RNA"
  ],
  "RPL22P3": [
    "RPL22P3 CNV",
    "RPL22P3 RNA"
  ],
  "LEPROT": [
    "LEPROT CNV",
    "LEPROT RNA",
    "LEPROT Proteo"
  ],
  "GSTM1": [
    "GSTM1 CNV",
    "GSTM1 RNA",
    "GSTM1 Proteo"
  ],
  "TMEM14B": [
    "TMEM14B CNV",
    "TMEM14B RNA"
  ],
  "ABCB5": [
    "ABCB5 CNV",
    "ABCB5 RNA",
    "ABCB5 Proteo"
  ],
  "TSR2": [
    "TSR2 CNV",
    "TSR2 RNA",
    "TSR2 Proteo"
  ],
  "NDUFA12": [
    "NDUFA12 CNV",
    "NDUFA12 RNA",
    "NDUFA12 Proteo"
  ],
  "OR5BB1P": [
    "OR5BB1P CNV",
    "OR5BB1P RNA"
  ],
  "SLC16A1P1": [
    "SLC16A1P1 CNV",
    "SLC16A1P1 RNA"
  ],
  "DMAC1P1": [
    "DMAC1P1 CNV",
    "DMAC1P1 RNA"
  ],
  "H1-1": [
    "H1-1 CNV",
    "H1-1 RNA",
    "H1-1 Proteo"
  ],
  "AFF4": [
    "AFF4 CNV",
    "AFF4 RNA",
    "AFF4 Proteo"
  ],
  "PPBP": [
    "PPBP CNV",
    "PPBP RNA",
    "PPBP Proteo"
  ],
  "LZTS3": [
    "LZTS3 CNV",
    "LZTS3 RNA"
  ],
  "EPHA1": [
    "EPHA1 CNV",
    "EPHA1 RNA"
  ],
  "SCN11A": [
    "SCN11A CNV",
    "SCN11A RNA"
  ],
  "OSMR": [
    "OSMR CNV",
    "OSMR RNA",
    "OSMR Proteo"
  ],
  "EIF2B1": [
    "EIF2B1 CNV",
    "EIF2B1 RNA",
    "EIF2B1 Proteo"
  ],
  "ABI3BP": [
    "ABI3BP CNV",
    "ABI3BP RNA",
    "ABI3BP Proteo"
  ],
  "CD3D": [
    "CD3D CNV",
    "CD3D RNA",
    "CD3D Proteo"
  ],
  "MRPL37": [
    "MRPL37 CNV",
    "MRPL37 RNA",
    "MRPL37 Proteo"
  ],
  "SEPTIN7P15": [
    "SEPTIN7P15 CNV",
    "SEPTIN7P15 RNA"
  ],
  "CENPE": [
    "CENPE CNV",
    "CENPE RNA",
    "CENPE Proteo"
  ],
  "BTF3P12": [
    "BTF3P12 CNV",
    "BTF3P12 RNA"
  ],
  "MTATP6P23": [
    "MTATP6P23 CNV",
    "MTATP6P23 RNA"
  ],
  "FHIP1B": [
    "FHIP1B CNV",
    "FHIP1B RNA",
    "FHIP1B Proteo"
  ],
  "LCE1E": [
    "LCE1E CNV",
    "LCE1E RNA"
  ],
  "ODF2": [
    "ODF2 CNV",
    "ODF2 RNA",
    "ODF2 Proteo"
  ],
  "KRTAP10-13P": [
    "KRTAP10-13P CNV",
    "KRTAP10-13P RNA"
  ],
  "TMED7-TICAM2": [
    "TMED7-TICAM2 Proteo"
  ],
  "RMDN2": [
    "RMDN2 CNV",
    "RMDN2 RNA",
    "RMDN2 Proteo"
  ],
  "SIX5": [
    "SIX5 CNV",
    "SIX5 RNA",
    "SIX5 Proteo"
  ],
  "TRHDE": [
    "TRHDE CNV",
    "TRHDE RNA"
  ],
  "TOMM20L": [
    "TOMM20L CNV",
    "TOMM20L RNA"
  ],
  "CLEC4F": [
    "CLEC4F CNV",
    "CLEC4F RNA"
  ],
  "DESI1": [
    "DESI1 CNV",
    "DESI1 RNA",
    "DESI1 Proteo"
  ],
  "POLR2DP2": [
    "POLR2DP2 CNV",
    "POLR2DP2 RNA"
  ],
  "EME1": [
    "EME1 CNV",
    "EME1 RNA",
    "EME1 Proteo"
  ],
  "DHX8": [
    "DHX8 CNV",
    "DHX8 RNA",
    "DHX8 Proteo"
  ],
  "GLB1L3": [
    "GLB1L3 CNV",
    "GLB1L3 RNA"
  ],
  "HORMAD2": [
    "HORMAD2 CNV",
    "HORMAD2 RNA"
  ],
  "TMEM158": [
    "TMEM158 CNV",
    "TMEM158 RNA"
  ],
  "VPS13B": [
    "VPS13B CNV",
    "VPS13B RNA",
    "VPS13B Proteo"
  ],
  "PCNX3": [
    "PCNX3 CNV",
    "PCNX3 RNA",
    "PCNX3 Proteo"
  ],
  "MTUS1": [
    "MTUS1 CNV",
    "MTUS1 RNA",
    "MTUS1 Proteo"
  ],
  "CXCL3": [
    "CXCL3 CNV",
    "CXCL3 RNA"
  ],
  "RPS3AP28": [
    "RPS3AP28 CNV",
    "RPS3AP28 RNA"
  ],
  "ZNF699": [
    "ZNF699 CNV",
    "ZNF699 RNA"
  ],
  "PET100": [
    "PET100 CNV",
    "PET100 RNA",
    "PET100 Proteo"
  ],
  "MALLP1": [
    "MALLP1 CNV",
    "MALLP1 RNA"
  ],
  "FAM136FP": [
    "FAM136FP CNV",
    "FAM136FP RNA"
  ],
  "SUCNR1": [
    "SUCNR1 CNV",
    "SUCNR1 RNA"
  ],
  "NPNT": [
    "NPNT CNV",
    "NPNT RNA",
    "NPNT Proteo"
  ],
  "CPPED1": [
    "CPPED1 CNV",
    "CPPED1 RNA",
    "CPPED1 Proteo"
  ],
  "ZNF524": [
    "ZNF524 CNV",
    "ZNF524 RNA",
    "ZNF524 Proteo"
  ],
  "PRR27": [
    "PRR27 CNV",
    "PRR27 RNA",
    "PRR27 Proteo"
  ],
  "EIF2A": [
    "EIF2A CNV",
    "EIF2A RNA",
    "EIF2A Proteo"
  ],
  "HNRNPA1P10": [
    "HNRNPA1P10 CNV",
    "HNRNPA1P10 RNA"
  ],
  "TTC4": [
    "TTC4 CNV",
    "TTC4 RNA",
    "TTC4 Proteo"
  ],
  "SMPD3": [
    "SMPD3 CNV",
    "SMPD3 RNA",
    "SMPD3 Proteo"
  ],
  "ATP5F1AP2": [
    "ATP5F1AP2 CNV",
    "ATP5F1AP2 RNA"
  ],
  "FGD3": [
    "FGD3 CNV",
    "FGD3 RNA",
    "FGD3 Proteo"
  ],
  "FILIP1": [
    "FILIP1 CNV",
    "FILIP1 RNA",
    "FILIP1 Proteo"
  ],
  "VASP": [
    "VASP CNV",
    "VASP RNA",
    "VASP Proteo"
  ],
  "HTR1D": [
    "HTR1D CNV",
    "HTR1D RNA"
  ],
  "FCGR1CP": [
    "FCGR1CP CNV",
    "FCGR1CP RNA"
  ],
  "SERPINB9": [
    "SERPINB9 CNV",
    "SERPINB9 RNA",
    "SERPINB9 Proteo"
  ],
  "HERC2P3": [
    "HERC2P3 CNV",
    "HERC2P3 RNA"
  ],
  "URAHP": [
    "URAHP CNV",
    "URAHP RNA"
  ],
  "FTH1P22": [
    "FTH1P22 CNV",
    "FTH1P22 RNA"
  ],
  "TMEM202": [
    "TMEM202 CNV",
    "TMEM202 RNA"
  ],
  "RPL30P11": [
    "RPL30P11 CNV",
    "RPL30P11 RNA"
  ],
  "NEURL1": [
    "NEURL1 CNV",
    "NEURL1 RNA"
  ],
  "RNA5SP265": [
    "RNA5SP265 CNV",
    "RNA5SP265 RNA"
  ],
  "LXN": [
    "LXN CNV",
    "LXN RNA",
    "LXN Proteo"
  ],
  "DYNLL1": [
    "DYNLL1 CNV",
    "DYNLL1 RNA",
    "DYNLL1 Proteo"
  ],
  "C19orf44": [
    "C19orf44 CNV",
    "C19orf44 RNA"
  ],
  "HLA-K": [
    "HLA-K CNV",
    "HLA-K RNA"
  ],
  "RPL36AP30": [
    "RPL36AP30 CNV",
    "RPL36AP30 RNA"
  ],
  "MRPL57": [
    "MRPL57 CNV",
    "MRPL57 RNA",
    "MRPL57 Proteo"
  ],
  "H3C7": [
    "H3C7 CNV",
    "H3C7 RNA"
  ],
  "SEMA3B": [
    "SEMA3B CNV",
    "SEMA3B RNA",
    "SEMA3B Proteo"
  ],
  "IGHV3OR16-17": [
    "IGHV3OR16-17 CNV",
    "IGHV3OR16-17 RNA"
  ],
  "TMEM236": [
    "TMEM236 CNV",
    "TMEM236 RNA"
  ],
  "TAAR4P": [
    "TAAR4P CNV",
    "TAAR4P RNA"
  ],
  "ZNF544": [
    "ZNF544 CNV",
    "ZNF544 RNA"
  ],
  "WDR3": [
    "WDR3 CNV",
    "WDR3 RNA",
    "WDR3 Proteo"
  ],
  "GAPDHP77": [
    "GAPDHP77 CNV",
    "GAPDHP77 RNA"
  ],
  "GINS1": [
    "GINS1 CNV",
    "GINS1 RNA",
    "GINS1 Proteo"
  ],
  "MAGEA4": [
    "MAGEA4 CNV",
    "MAGEA4 RNA",
    "MAGEA4 Proteo"
  ],
  "MB": [
    "MB CNV",
    "MB RNA",
    "MB Proteo"
  ],
  "AK4P6": [
    "AK4P6 CNV",
    "AK4P6 RNA"
  ],
  "RPL7AP74": [
    "RPL7AP74 CNV",
    "RPL7AP74 RNA"
  ],
  "ASNSP4": [
    "ASNSP4 CNV",
    "ASNSP4 RNA"
  ],
  "KCNK17": [
    "KCNK17 CNV",
    "KCNK17 RNA"
  ],
  "CNN2": [
    "CNN2 CNV",
    "CNN2 RNA",
    "CNN2 Proteo"
  ],
  "USP17L14P": [
    "USP17L14P CNV",
    "USP17L14P RNA"
  ],
  "MTCO2P32": [
    "MTCO2P32 CNV",
    "MTCO2P32 RNA"
  ],
  "DNM1P5": [
    "DNM1P5 CNV",
    "DNM1P5 RNA"
  ],
  "PGRMC2": [
    "PGRMC2 CNV",
    "PGRMC2 RNA",
    "PGRMC2 Proteo"
  ],
  "HMGN1": [
    "HMGN1 CNV",
    "HMGN1 RNA",
    "HMGN1 Proteo"
  ],
  "BANF1P3": [
    "BANF1P3 CNV",
    "BANF1P3 RNA"
  ],
  "CFAP97D1": [
    "CFAP97D1 CNV",
    "CFAP97D1 RNA"
  ],
  "PLCH1": [
    "PLCH1 CNV",
    "PLCH1 RNA",
    "PLCH1 Proteo"
  ],
  "ALKBH7": [
    "ALKBH7 CNV",
    "ALKBH7 RNA",
    "ALKBH7 Proteo"
  ],
  "MSTN": [
    "MSTN CNV",
    "MSTN RNA"
  ],
  "MTND6P19": [
    "MTND6P19 CNV",
    "MTND6P19 RNA"
  ],
  "DLL4": [
    "DLL4 CNV",
    "DLL4 RNA"
  ],
  "SLC22A8": [
    "SLC22A8 CNV",
    "SLC22A8 RNA",
    "SLC22A8 Proteo"
  ],
  "KRTAP2-1": [
    "KRTAP2-1 CNV",
    "KRTAP2-1 RNA"
  ],
  "RPL37P23": [
    "RPL37P23 CNV",
    "RPL37P23 RNA"
  ],
  "NHLRC1": [
    "NHLRC1 CNV",
    "NHLRC1 RNA",
    "NHLRC1 Proteo"
  ],
  "NEK4P2": [
    "NEK4P2 CNV",
    "NEK4P2 RNA"
  ],
  "GINS4": [
    "GINS4 CNV",
    "GINS4 RNA",
    "GINS4 Proteo"
  ],
  "SCML2P2": [
    "SCML2P2 CNV",
    "SCML2P2 RNA"
  ],
  "NUTM1": [
    "NUTM1 CNV",
    "NUTM1 RNA"
  ],
  "CDC40": [
    "CDC40 CNV",
    "CDC40 RNA",
    "CDC40 Proteo"
  ],
  "ENG": [
    "ENG CNV",
    "ENG RNA",
    "ENG Proteo"
  ],
  "RPL17P41": [
    "RPL17P41 CNV",
    "RPL17P41 RNA"
  ],
  "TRAPPC2LP1": [
    "TRAPPC2LP1 CNV",
    "TRAPPC2LP1 RNA"
  ],
  "NCS1": [
    "NCS1 CNV",
    "NCS1 RNA",
    "NCS1 Proteo"
  ],
  "OR2A42": [
    "OR2A42 CNV",
    "OR2A42 RNA"
  ],
  "RPSAP58": [
    "RPSAP58 CNV",
    "RPSAP58 RNA",
    "RPSAP58 Proteo"
  ],
  "MEOX2": [
    "MEOX2 CNV",
    "MEOX2 RNA",
    "MEOX2 Proteo"
  ],
  "RNA5SP365": [
    "RNA5SP365 CNV",
    "RNA5SP365 RNA"
  ],
  "GMFB": [
    "GMFB CNV",
    "GMFB RNA",
    "GMFB Proteo"
  ],
  "NEDD8P1": [
    "NEDD8P1 CNV",
    "NEDD8P1 RNA"
  ],
  "CUBNP3": [
    "CUBNP3 CNV",
    "CUBNP3 RNA"
  ],
  "HHIPL2": [
    "HHIPL2 CNV",
    "HHIPL2 RNA"
  ],
  "EIF4BP1": [
    "EIF4BP1 CNV",
    "EIF4BP1 RNA"
  ],
  "YWHAEP2": [
    "YWHAEP2 CNV",
    "YWHAEP2 RNA"
  ],
  "RSL24D1P3": [
    "RSL24D1P3 CNV",
    "RSL24D1P3 RNA"
  ],
  "TOPAZ1": [
    "TOPAZ1 CNV",
    "TOPAZ1 RNA"
  ],
  "NXPE2": [
    "NXPE2 CNV",
    "NXPE2 RNA"
  ],
  "EFHB": [
    "EFHB CNV",
    "EFHB RNA"
  ],
  "SLC39A6": [
    "SLC39A6 CNV",
    "SLC39A6 RNA",
    "SLC39A6 Proteo"
  ],
  "OR4N3BP": [
    "OR4N3BP CNV",
    "OR4N3BP RNA"
  ],
  "POU2F1": [
    "POU2F1 CNV",
    "POU2F1 RNA",
    "POU2F1 Proteo"
  ],
  "ATG4AP1": [
    "ATG4AP1 CNV",
    "ATG4AP1 RNA"
  ],
  "KCNJ12": [
    "KCNJ12 CNV",
    "KCNJ12 RNA"
  ],
  "GAPDH": [
    "GAPDH CNV",
    "GAPDH RNA",
    "GAPDH Proteo"
  ],
  "CTNNA3": [
    "CTNNA3 CNV",
    "CTNNA3 RNA"
  ],
  "NBEA": [
    "NBEA CNV",
    "NBEA RNA",
    "NBEA Proteo"
  ],
  "NPM1P36": [
    "NPM1P36 CNV",
    "NPM1P36 RNA"
  ],
  "SCNM1": [
    "SCNM1 CNV",
    "SCNM1 RNA",
    "SCNM1 Proteo"
  ],
  "CAMK1D": [
    "CAMK1D CNV",
    "CAMK1D RNA",
    "CAMK1D Proteo"
  ],
  "SDCCAG8": [
    "SDCCAG8 CNV",
    "SDCCAG8 RNA",
    "SDCCAG8 Proteo"
  ],
  "BZW1": [
    "BZW1 CNV",
    "BZW1 RNA",
    "BZW1 Proteo"
  ],
  "C10orf120": [
    "C10orf120 CNV",
    "C10orf120 RNA"
  ],
  "GATA3": [
    "GATA3 CNV",
    "GATA3 RNA",
    "GATA3 Proteo"
  ],
  "MTCO1P56": [
    "MTCO1P56 CNV",
    "MTCO1P56 RNA"
  ],
  "DNAI7": [
    "DNAI7 CNV",
    "DNAI7 RNA"
  ],
  "RPS23": [
    "RPS23 CNV",
    "RPS23 RNA",
    "RPS23 Proteo"
  ],
  "MPPED1": [
    "MPPED1 CNV",
    "MPPED1 RNA"
  ],
  "TM4SF20": [
    "TM4SF20 CNV",
    "TM4SF20 RNA",
    "TM4SF20 Proteo"
  ],
  "TFDP1P2": [
    "TFDP1P2 CNV",
    "TFDP1P2 RNA"
  ],
  "ANAPC13": [
    "ANAPC13 CNV",
    "ANAPC13 RNA",
    "ANAPC13 Proteo"
  ],
  "CGN": [
    "CGN CNV",
    "CGN RNA",
    "CGN Proteo"
  ],
  "ACSM2B": [
    "ACSM2B CNV",
    "ACSM2B RNA"
  ],
  "RTP4": [
    "RTP4 CNV",
    "RTP4 RNA",
    "RTP4 Proteo"
  ],
  "GOLGA8A": [
    "GOLGA8A CNV",
    "GOLGA8A RNA"
  ],
  "OR6C7P": [
    "OR6C7P CNV",
    "OR6C7P RNA"
  ],
  "PRR20C": [
    "PRR20C CNV",
    "PRR20C RNA"
  ],
  "ZNF204P": [
    "ZNF204P CNV",
    "ZNF204P RNA"
  ],
  "SSX4B": [
    "SSX4B CNV",
    "SSX4B RNA"
  ],
  "SRD5A2": [
    "SRD5A2 CNV",
    "SRD5A2 RNA"
  ],
  "RHBDF1": [
    "RHBDF1 CNV",
    "RHBDF1 RNA",
    "RHBDF1 Proteo"
  ],
  "RPL7P59": [
    "RPL7P59 CNV",
    "RPL7P59 RNA"
  ],
  "RFC5P1": [
    "RFC5P1 CNV",
    "RFC5P1 RNA"
  ],
  "JPT1P1": [
    "JPT1P1 CNV",
    "JPT1P1 RNA"
  ],
  "CDX2": [
    "CDX2 CNV",
    "CDX2 RNA"
  ],
  "SH3RF3": [
    "SH3RF3 CNV",
    "SH3RF3 RNA",
    "SH3RF3 Proteo"
  ],
  "NEFHP1": [
    "NEFHP1 CNV",
    "NEFHP1 RNA"
  ],
  "OR2AG2": [
    "OR2AG2 CNV",
    "OR2AG2 RNA"
  ],
  "INO80E": [
    "INO80E CNV",
    "INO80E RNA",
    "INO80E Proteo"
  ],
  "CYP7A1": [
    "CYP7A1 CNV",
    "CYP7A1 RNA"
  ],
  "PRIM1": [
    "PRIM1 CNV",
    "PRIM1 RNA",
    "PRIM1 Proteo"
  ],
  "TNFRSF9": [
    "TNFRSF9 CNV",
    "TNFRSF9 RNA"
  ],
  "OR7E101P": [
    "OR7E101P CNV",
    "OR7E101P RNA"
  ],
  "HSDL1": [
    "HSDL1 CNV",
    "HSDL1 RNA",
    "HSDL1 Proteo"
  ],
  "HMGA1P2": [
    "HMGA1P2 CNV",
    "HMGA1P2 RNA"
  ],
  "DDX58": [
    "DDX58 CNV",
    "DDX58 RNA",
    "DDX58 Proteo"
  ],
  "NEK8": [
    "NEK8 CNV",
    "NEK8 RNA",
    "NEK8 Proteo"
  ],
  "A1BG": [
    "A1BG CNV",
    "A1BG RNA",
    "A1BG Proteo"
  ],
  "SIRT3": [
    "SIRT3 CNV",
    "SIRT3 RNA",
    "SIRT3 Proteo"
  ],
  "NSUN3": [
    "NSUN3 CNV",
    "NSUN3 RNA",
    "NSUN3 Proteo"
  ],
  "TP53TG5": [
    "TP53TG5 CNV",
    "TP53TG5 RNA"
  ],
  "RAD9B": [
    "RAD9B CNV",
    "RAD9B RNA"
  ],
  "OR10AE1P": [
    "OR10AE1P CNV",
    "OR10AE1P RNA"
  ],
  "PIWIL2": [
    "PIWIL2 CNV",
    "PIWIL2 RNA"
  ],
  "IFFO2": [
    "IFFO2 CNV",
    "IFFO2 RNA",
    "IFFO2 Proteo"
  ],
  "MAP3K1": [
    "MAP3K1 CNV",
    "MAP3K1 RNA",
    "MAP3K1 Proteo"
  ],
  "SULT6B1": [
    "SULT6B1 CNV",
    "SULT6B1 RNA"
  ],
  "TMEM205": [
    "TMEM205 CNV",
    "TMEM205 RNA",
    "TMEM205 Proteo"
  ],
  "GPC2": [
    "GPC2 CNV",
    "GPC2 RNA"
  ],
  "ALDH1B1": [
    "ALDH1B1 CNV",
    "ALDH1B1 RNA",
    "ALDH1B1 Proteo"
  ],
  "MFN1": [
    "MFN1 CNV",
    "MFN1 RNA",
    "MFN1 Proteo"
  ],
  "FABP12": [
    "FABP12 CNV",
    "FABP12 RNA"
  ],
  "CTRB1": [
    "CTRB1 CNV",
    "CTRB1 RNA"
  ],
  "DOCK7": [
    "DOCK7 CNV",
    "DOCK7 RNA",
    "DOCK7 Proteo"
  ],
  "DHCR7": [
    "DHCR7 CNV",
    "DHCR7 RNA",
    "DHCR7 Proteo"
  ],
  "LAMP1": [
    "LAMP1 CNV",
    "LAMP1 RNA",
    "LAMP1 Proteo"
  ],
  "OR4F3": [
    "OR4F3 CNV",
    "OR4F3 RNA"
  ],
  "HSPE1P19": [
    "HSPE1P19 CNV",
    "HSPE1P19 RNA"
  ],
  "NICN1": [
    "NICN1 CNV",
    "NICN1 RNA"
  ],
  "KLHL30": [
    "KLHL30 CNV",
    "KLHL30 RNA"
  ],
  "CHIC2": [
    "CHIC2 CNV",
    "CHIC2 RNA",
    "CHIC2 Proteo"
  ],
  "LRRN1": [
    "LRRN1 CNV",
    "LRRN1 RNA"
  ],
  "CCDC90B": [
    "CCDC90B CNV",
    "CCDC90B RNA",
    "CCDC90B Proteo"
  ],
  "NR1I3": [
    "NR1I3 CNV",
    "NR1I3 RNA"
  ],
  "UQCR10": [
    "UQCR10 CNV",
    "UQCR10 RNA",
    "UQCR10 Proteo"
  ],
  "RAD21P1": [
    "RAD21P1 CNV",
    "RAD21P1 RNA"
  ],
  "OR7E102P": [
    "OR7E102P CNV",
    "OR7E102P RNA"
  ],
  "NKX1-1": [
    "NKX1-1 CNV",
    "NKX1-1 RNA"
  ],
  "CCDC91": [
    "CCDC91 CNV",
    "CCDC91 RNA",
    "CCDC91 Proteo"
  ],
  "ERVFRD-1": [
    "ERVFRD-1 CNV",
    "ERVFRD-1 RNA"
  ],
  "FHIP2A": [
    "FHIP2A CNV",
    "FHIP2A RNA",
    "FHIP2A Proteo"
  ],
  "BTBD2": [
    "BTBD2 CNV",
    "BTBD2 RNA",
    "BTBD2 Proteo"
  ],
  "CLEC18B": [
    "CLEC18B CNV",
    "CLEC18B RNA"
  ],
  "GABARAPL3": [
    "GABARAPL3 CNV",
    "GABARAPL3 RNA"
  ],
  "PPIAP49": [
    "PPIAP49 CNV",
    "PPIAP49 RNA"
  ],
  "SPATA31A5": [
    "SPATA31A5 CNV",
    "SPATA31A5 RNA"
  ],
  "RPS7P8": [
    "RPS7P8 CNV",
    "RPS7P8 RNA"
  ],
  "TRIM74": [
    "TRIM74 CNV",
    "TRIM74 RNA"
  ],
  "RIMBP3C": [
    "RIMBP3C CNV",
    "RIMBP3C RNA"
  ],
  "SNRPBP1": [
    "SNRPBP1 CNV",
    "SNRPBP1 RNA"
  ],
  "POLA1": [
    "POLA1 CNV",
    "POLA1 RNA",
    "POLA1 Proteo"
  ],
  "TRIM28": [
    "TRIM28 CNV",
    "TRIM28 RNA",
    "TRIM28 Proteo"
  ],
  "ARHGAP12": [
    "ARHGAP12 CNV",
    "ARHGAP12 RNA",
    "ARHGAP12 Proteo"
  ],
  "RPL7L1P11": [
    "RPL7L1P11 CNV",
    "RPL7L1P11 RNA"
  ],
  "HTATSF1": [
    "HTATSF1 CNV",
    "HTATSF1 RNA",
    "HTATSF1 Proteo"
  ],
  "P2RX3": [
    "P2RX3 CNV",
    "P2RX3 RNA"
  ],
  "PABPC1P5": [
    "PABPC1P5 CNV",
    "PABPC1P5 RNA"
  ],
  "PPIAP53": [
    "PPIAP53 CNV",
    "PPIAP53 RNA"
  ],
  "CD200R1L": [
    "CD200R1L CNV",
    "CD200R1L RNA"
  ],
  "SAMD14": [
    "SAMD14 CNV",
    "SAMD14 RNA",
    "SAMD14 Proteo"
  ],
  "SORD2P": [
    "SORD2P CNV",
    "SORD2P RNA"
  ],
  "ATXN7L3": [
    "ATXN7L3 CNV",
    "ATXN7L3 RNA",
    "ATXN7L3 Proteo"
  ],
  "IGLV3-30": [
    "IGLV3-30 CNV",
    "IGLV3-30 RNA"
  ],
  "LDHAP3": [
    "LDHAP3 CNV",
    "LDHAP3 RNA"
  ],
  "C6orf201": [
    "C6orf201 CNV",
    "C6orf201 RNA"
  ],
  "POLR2J3": [
    "POLR2J3 CNV",
    "POLR2J3 RNA"
  ],
  "TRIM62": [
    "TRIM62 CNV",
    "TRIM62 RNA",
    "TRIM62 Proteo"
  ],
  "EPS15P1": [
    "EPS15P1 CNV",
    "EPS15P1 RNA"
  ],
  "RDH12": [
    "RDH12 CNV",
    "RDH12 RNA",
    "RDH12 Proteo"
  ],
  "BTLA": [
    "BTLA CNV",
    "BTLA RNA",
    "BTLA Proteo"
  ],
  "BMS1P17": [
    "BMS1P17 CNV",
    "BMS1P17 RNA"
  ],
  "POLD4": [
    "POLD4 CNV",
    "POLD4 RNA",
    "POLD4 Proteo"
  ],
  "CASP3P1": [
    "CASP3P1 CNV",
    "CASP3P1 RNA"
  ],
  "CRYGFP": [
    "CRYGFP CNV",
    "CRYGFP RNA"
  ],
  "DDX11L9": [
    "DDX11L9 CNV",
    "DDX11L9 RNA"
  ],
  "RPL36P3": [
    "RPL36P3 CNV",
    "RPL36P3 RNA"
  ],
  "IGKV2D-24": [
    "IGKV2D-24 Proteo"
  ],
  "ZNF669": [
    "ZNF669 CNV",
    "ZNF669 RNA",
    "ZNF669 Proteo"
  ],
  "ART2BP": [
    "ART2BP CNV",
    "ART2BP RNA"
  ],
  "FAM86EP": [
    "FAM86EP CNV",
    "FAM86EP RNA"
  ],
  "DEFB131D": [
    "DEFB131D CNV",
    "DEFB131D RNA"
  ],
  "DIRAS1": [
    "DIRAS1 CNV",
    "DIRAS1 RNA",
    "DIRAS1 Proteo"
  ],
  "IRF1": [
    "IRF1 CNV",
    "IRF1 RNA",
    "IRF1 Proteo"
  ],
  "NFIB": [
    "NFIB CNV",
    "NFIB RNA",
    "NFIB Proteo"
  ],
  "RCOR1": [
    "RCOR1 CNV",
    "RCOR1 RNA",
    "RCOR1 Proteo"
  ],
  "ZNF284": [
    "ZNF284 CNV",
    "ZNF284 RNA"
  ],
  "TUBA8": [
    "TUBA8 CNV",
    "TUBA8 RNA",
    "TUBA8 Proteo"
  ],
  "BOLA3P1": [
    "BOLA3P1 CNV",
    "BOLA3P1 RNA"
  ],
  "DEFB133": [
    "DEFB133 CNV",
    "DEFB133 RNA"
  ],
  "HNRNPKP1": [
    "HNRNPKP1 CNV",
    "HNRNPKP1 RNA"
  ],
  "OVOL2": [
    "OVOL2 CNV",
    "OVOL2 RNA"
  ],
  "NUDCD2": [
    "NUDCD2 CNV",
    "NUDCD2 RNA",
    "NUDCD2 Proteo"
  ],
  "FCRL2": [
    "FCRL2 CNV",
    "FCRL2 RNA"
  ],
  "TNFRSF19": [
    "TNFRSF19 CNV",
    "TNFRSF19 RNA",
    "TNFRSF19 Proteo"
  ],
  "USP27X": [
    "USP27X CNV",
    "USP27X RNA",
    "USP27X Proteo"
  ],
  "ALG10B": [
    "ALG10B CNV",
    "ALG10B RNA"
  ],
  "MTND1P29": [
    "MTND1P29 CNV",
    "MTND1P29 RNA"
  ],
  "ARMC6": [
    "ARMC6 CNV",
    "ARMC6 RNA",
    "ARMC6 Proteo"
  ],
  "TRPC3": [
    "TRPC3 CNV",
    "TRPC3 RNA"
  ],
  "SLC31A1P1": [
    "SLC31A1P1 CNV",
    "SLC31A1P1 RNA"
  ],
  "SULT1D1P": [
    "SULT1D1P CNV",
    "SULT1D1P RNA"
  ],
  "FAM149A": [
    "FAM149A CNV",
    "FAM149A RNA"
  ],
  "UTF1": [
    "UTF1 CNV",
    "UTF1 RNA"
  ],
  "PNMA8B": [
    "PNMA8B CNV",
    "PNMA8B RNA"
  ],
  "RPL34P1": [
    "RPL34P1 CNV",
    "RPL34P1 RNA"
  ],
  "SLC25A3": [
    "SLC25A3 CNV",
    "SLC25A3 RNA",
    "SLC25A3 Proteo"
  ],
  "CD93": [
    "CD93 CNV",
    "CD93 RNA",
    "CD93 Proteo"
  ],
  "RABAC1": [
    "RABAC1 CNV",
    "RABAC1 RNA",
    "RABAC1 Proteo"
  ],
  "AGGF1P10": [
    "AGGF1P10 CNV",
    "AGGF1P10 RNA"
  ],
  "PHF14": [
    "PHF14 CNV",
    "PHF14 RNA",
    "PHF14 Proteo"
  ],
  "TRIM67": [
    "TRIM67 CNV",
    "TRIM67 RNA"
  ],
  "LRRTM2": [
    "LRRTM2 CNV",
    "LRRTM2 RNA"
  ],
  "ARHGDIA": [
    "ARHGDIA CNV",
    "ARHGDIA RNA",
    "ARHGDIA Proteo"
  ],
  "TTLL13": [
    "TTLL13 CNV",
    "TTLL13 RNA"
  ],
  "MTND2P6": [
    "MTND2P6 CNV",
    "MTND2P6 RNA"
  ],
  "NFKBIL1": [
    "NFKBIL1 CNV",
    "NFKBIL1 RNA",
    "NFKBIL1 Proteo"
  ],
  "RNA5SP505": [
    "RNA5SP505 CNV",
    "RNA5SP505 RNA"
  ],
  "SGO1": [
    "SGO1 CNV",
    "SGO1 RNA",
    "SGO1 Proteo"
  ],
  "GPR53P": [
    "GPR53P CNV",
    "GPR53P RNA"
  ],
  "TAS2R13": [
    "TAS2R13 CNV",
    "TAS2R13 RNA"
  ],
  "SFT2D2": [
    "SFT2D2 CNV",
    "SFT2D2 RNA",
    "SFT2D2 Proteo"
  ],
  "TACR1": [
    "TACR1 CNV",
    "TACR1 RNA"
  ],
  "FEZF2": [
    "FEZF2 CNV",
    "FEZF2 RNA"
  ],
  "GZMM": [
    "GZMM CNV",
    "GZMM RNA",
    "GZMM Proteo"
  ],
  "CACNA1E": [
    "CACNA1E CNV",
    "CACNA1E RNA"
  ],
  "MIIP": [
    "MIIP CNV",
    "MIIP RNA",
    "MIIP Proteo"
  ],
  "ZNF576": [
    "ZNF576 CNV",
    "ZNF576 RNA"
  ],
  "SLC1A4": [
    "SLC1A4 CNV",
    "SLC1A4 RNA",
    "SLC1A4 Proteo"
  ],
  "OR8C1P": [
    "OR8C1P CNV",
    "OR8C1P RNA"
  ],
  "H2AC18": [
    "H2AC18 CNV",
    "H2AC18 RNA",
    "H2AC18 Proteo"
  ],
  "PAX4": [
    "PAX4 CNV",
    "PAX4 RNA"
  ],
  "RNF223": [
    "RNF223 CNV",
    "RNF223 RNA"
  ],
  "MTCO1P40": [
    "MTCO1P40 CNV",
    "MTCO1P40 RNA"
  ],
  "CLCA3P": [
    "CLCA3P CNV",
    "CLCA3P RNA"
  ],
  "NDUFS5P3": [
    "NDUFS5P3 CNV",
    "NDUFS5P3 RNA"
  ],
  "CALHM3": [
    "CALHM3 CNV",
    "CALHM3 RNA"
  ],
  "RPS8P3": [
    "RPS8P3 CNV",
    "RPS8P3 RNA"
  ],
  "SUFU": [
    "SUFU CNV",
    "SUFU RNA",
    "SUFU Proteo"
  ],
  "RAC1P1": [
    "RAC1P1 CNV",
    "RAC1P1 RNA"
  ],
  "MTMR12P1": [
    "MTMR12P1 CNV",
    "MTMR12P1 RNA"
  ],
  "IGKV6-21": [
    "IGKV6-21 Proteo"
  ],
  "IFT22": [
    "IFT22 CNV",
    "IFT22 RNA",
    "IFT22 Proteo"
  ],
  "ACLY": [
    "ACLY CNV",
    "ACLY RNA",
    "ACLY Proteo"
  ],
  "EMC2": [
    "EMC2 CNV",
    "EMC2 RNA",
    "EMC2 Proteo"
  ],
  "RNPEPL1": [
    "RNPEPL1 CNV",
    "RNPEPL1 RNA",
    "RNPEPL1 Proteo"
  ],
  "IQCN": [
    "IQCN CNV",
    "IQCN RNA"
  ],
  "FAM236D": [
    "FAM236D CNV",
    "FAM236D RNA"
  ],
  "GABPB2": [
    "GABPB2 CNV",
    "GABPB2 RNA",
    "GABPB2 Proteo"
  ],
  "CATSPERZ": [
    "CATSPERZ CNV",
    "CATSPERZ RNA"
  ],
  "GCLM": [
    "GCLM CNV",
    "GCLM RNA",
    "GCLM Proteo"
  ],
  "RNA5SP174": [
    "RNA5SP174 CNV",
    "RNA5SP174 RNA"
  ],
  "RPL26P9": [
    "RPL26P9 CNV",
    "RPL26P9 RNA"
  ],
  "USP15": [
    "USP15 CNV",
    "USP15 RNA",
    "USP15 Proteo"
  ],
  "VDAC1P10": [
    "VDAC1P10 CNV",
    "VDAC1P10 RNA"
  ],
  "AMY1B": [
    "AMY1B CNV",
    "AMY1B RNA",
    "AMY1B Proteo"
  ],
  "CASTOR3": [
    "CASTOR3 CNV",
    "CASTOR3 RNA"
  ],
  "FAM222A": [
    "FAM222A CNV",
    "FAM222A RNA"
  ],
  "CNOT6L": [
    "CNOT6L CNV",
    "CNOT6L RNA",
    "CNOT6L Proteo"
  ],
  "BUD31": [
    "BUD31 CNV",
    "BUD31 RNA",
    "BUD31 Proteo"
  ],
  "OLR1": [
    "OLR1 CNV",
    "OLR1 RNA",
    "OLR1 Proteo"
  ],
  "TRMT112P2": [
    "TRMT112P2 CNV",
    "TRMT112P2 RNA"
  ],
  "LUZP4P1": [
    "LUZP4P1 CNV",
    "LUZP4P1 RNA"
  ],
  "SLC20A2": [
    "SLC20A2 CNV",
    "SLC20A2 RNA",
    "SLC20A2 Proteo"
  ],
  "IGHV3-72": [
    "IGHV3-72 Proteo"
  ],
  "MIEN1": [
    "MIEN1 CNV",
    "MIEN1 RNA",
    "MIEN1 Proteo"
  ],
  "OR1L8": [
    "OR1L8 CNV",
    "OR1L8 RNA"
  ],
  "TSNAXIP1": [
    "TSNAXIP1 CNV",
    "TSNAXIP1 RNA"
  ],
  "MEGF9": [
    "MEGF9 CNV",
    "MEGF9 RNA",
    "MEGF9 Proteo"
  ],
  "TNRC6C": [
    "TNRC6C CNV",
    "TNRC6C RNA",
    "TNRC6C Proteo"
  ],
  "PPM1J": [
    "PPM1J CNV",
    "PPM1J RNA",
    "PPM1J Proteo"
  ],
  "NTRK3": [
    "NTRK3 CNV",
    "NTRK3 RNA"
  ],
  "PCNAP1": [
    "PCNAP1 CNV",
    "PCNAP1 RNA"
  ],
  "CCT6P3": [
    "CCT6P3 CNV",
    "CCT6P3 RNA"
  ],
  "RNA5SP243": [
    "RNA5SP243 CNV",
    "RNA5SP243 RNA"
  ],
  "HES4": [
    "HES4 CNV",
    "HES4 RNA"
  ],
  "RNF14": [
    "RNF14 CNV",
    "RNF14 RNA",
    "RNF14 Proteo"
  ],
  "UBE2Q2P13": [
    "UBE2Q2P13 CNV",
    "UBE2Q2P13 RNA"
  ],
  "CSNK1A1P1": [
    "CSNK1A1P1 CNV",
    "CSNK1A1P1 RNA"
  ],
  "TRIM48": [
    "TRIM48 CNV",
    "TRIM48 RNA"
  ],
  "BAG1": [
    "BAG1 CNV",
    "BAG1 RNA",
    "BAG1 Proteo"
  ],
  "SCLY": [
    "SCLY CNV",
    "SCLY RNA",
    "SCLY Proteo"
  ],
  "MRPL46": [
    "MRPL46 CNV",
    "MRPL46 RNA",
    "MRPL46 Proteo"
  ],
  "HOXD10": [
    "HOXD10 CNV",
    "HOXD10 RNA"
  ],
  "SERPINA13P": [
    "SERPINA13P CNV",
    "SERPINA13P RNA"
  ],
  "GKN3P": [
    "GKN3P CNV",
    "GKN3P RNA"
  ],
  "LYSMD2": [
    "LYSMD2 CNV",
    "LYSMD2 RNA",
    "LYSMD2 Proteo"
  ],
  "CTPS1": [
    "CTPS1 CNV",
    "CTPS1 RNA",
    "CTPS1 Proteo"
  ],
  "TNS3": [
    "TNS3 CNV",
    "TNS3 RNA",
    "TNS3 Proteo"
  ],
  "MUCL1": [
    "MUCL1 CNV",
    "MUCL1 RNA",
    "MUCL1 Proteo"
  ],
  "RNA5SP428": [
    "RNA5SP428 CNV",
    "RNA5SP428 RNA"
  ],
  "UTP11": [
    "UTP11 CNV",
    "UTP11 RNA",
    "UTP11 Proteo"
  ],
  "HTR4": [
    "HTR4 CNV",
    "HTR4 RNA"
  ],
  "RPS11P7": [
    "RPS11P7 CNV",
    "RPS11P7 RNA"
  ],
  "XRCC1": [
    "XRCC1 CNV",
    "XRCC1 RNA",
    "XRCC1 Proteo"
  ],
  "NMUR2": [
    "NMUR2 CNV",
    "NMUR2 RNA"
  ],
  "PTPN12": [
    "PTPN12 CNV",
    "PTPN12 RNA",
    "PTPN12 Proteo"
  ],
  "XKRYP1": [
    "XKRYP1 CNV",
    "XKRYP1 RNA"
  ],
  "MGP": [
    "MGP CNV",
    "MGP RNA",
    "MGP Proteo"
  ],
  "ARHGAP21": [
    "ARHGAP21 CNV",
    "ARHGAP21 RNA",
    "ARHGAP21 Proteo"
  ],
  "OR7A8P": [
    "OR7A8P CNV",
    "OR7A8P RNA"
  ],
  "SFRP1": [
    "SFRP1 CNV",
    "SFRP1 RNA",
    "SFRP1 Proteo"
  ],
  "PPP1R1B": [
    "PPP1R1B CNV",
    "PPP1R1B RNA",
    "PPP1R1B Proteo"
  ],
  "MED22": [
    "MED22 CNV",
    "MED22 RNA",
    "MED22 Proteo"
  ],
  "APOBEC3C": [
    "APOBEC3C CNV",
    "APOBEC3C RNA",
    "APOBEC3C Proteo"
  ],
  "TK1": [
    "TK1 CNV",
    "TK1 RNA",
    "TK1 Proteo"
  ],
  "RPL36P2": [
    "RPL36P2 CNV",
    "RPL36P2 RNA"
  ],
  "IDI1P2": [
    "IDI1P2 CNV",
    "IDI1P2 RNA"
  ],
  "CCL17": [
    "CCL17 CNV",
    "CCL17 RNA"
  ],
  "PECR": [
    "PECR CNV",
    "PECR RNA",
    "PECR Proteo"
  ],
  "SULT2B1": [
    "SULT2B1 CNV",
    "SULT2B1 RNA",
    "SULT2B1 Proteo"
  ],
  "CELF4": [
    "CELF4 CNV",
    "CELF4 RNA"
  ],
  "C5orf49": [
    "C5orf49 CNV",
    "C5orf49 RNA"
  ],
  "SLC39A14": [
    "SLC39A14 CNV",
    "SLC39A14 RNA",
    "SLC39A14 Proteo"
  ],
  "C3AR1": [
    "C3AR1 CNV",
    "C3AR1 RNA",
    "C3AR1 Proteo"
  ],
  "SLC1A6": [
    "SLC1A6 CNV",
    "SLC1A6 RNA"
  ],
  "LCMT2": [
    "LCMT2 CNV",
    "LCMT2 RNA",
    "LCMT2 Proteo"
  ],
  "ZNF432": [
    "ZNF432 CNV",
    "ZNF432 RNA"
  ],
  "MRGPRE": [
    "MRGPRE CNV",
    "MRGPRE RNA"
  ],
  "HSFY7P": [
    "HSFY7P CNV",
    "HSFY7P RNA"
  ],
  "FOXO1B": [
    "FOXO1B CNV",
    "FOXO1B RNA"
  ],
  "REXO1L8P": [
    "REXO1L8P CNV",
    "REXO1L8P RNA"
  ],
  "DENND10": [
    "DENND10 CNV",
    "DENND10 RNA",
    "DENND10 Proteo"
  ],
  "PABPC1P1": [
    "PABPC1P1 CNV",
    "PABPC1P1 RNA"
  ],
  "H2BC9": [
    "H2BC9 CNV",
    "H2BC9 RNA"
  ],
  "SPRN": [
    "SPRN CNV",
    "SPRN RNA"
  ],
  "CCNYL4": [
    "CCNYL4 CNV",
    "CCNYL4 RNA"
  ],
  "ZNF232": [
    "ZNF232 CNV",
    "ZNF232 RNA"
  ],
  "INSIG1": [
    "INSIG1 CNV",
    "INSIG1 RNA"
  ],
  "NCKAP1L": [
    "NCKAP1L CNV",
    "NCKAP1L RNA",
    "NCKAP1L Proteo"
  ],
  "NPY2R": [
    "NPY2R CNV",
    "NPY2R RNA"
  ],
  "CRCP": [
    "CRCP CNV",
    "CRCP RNA",
    "CRCP Proteo"
  ],
  "BTBD7": [
    "BTBD7 CNV",
    "BTBD7 RNA",
    "BTBD7 Proteo"
  ],
  "ATP6AP1": [
    "ATP6AP1 CNV",
    "ATP6AP1 RNA",
    "ATP6AP1 Proteo"
  ],
  "ZNF846": [
    "ZNF846 CNV",
    "ZNF846 RNA"
  ],
  "PCDHA5": [
    "PCDHA5 CNV",
    "PCDHA5 RNA"
  ],
  "CDC42EP3": [
    "CDC42EP3 CNV",
    "CDC42EP3 RNA",
    "CDC42EP3 Proteo"
  ],
  "POU3F4": [
    "POU3F4 CNV",
    "POU3F4 RNA"
  ],
  "MTCO1P6": [
    "MTCO1P6 CNV",
    "MTCO1P6 RNA"
  ],
  "TMSB10": [
    "TMSB10 CNV",
    "TMSB10 RNA",
    "TMSB10 Proteo"
  ],
  "LRRC63": [
    "LRRC63 CNV",
    "LRRC63 RNA"
  ],
  "ASCL4": [
    "ASCL4 CNV",
    "ASCL4 RNA"
  ],
  "AVL9": [
    "AVL9 CNV",
    "AVL9 RNA",
    "AVL9 Proteo"
  ],
  "SPACA7": [
    "SPACA7 CNV",
    "SPACA7 RNA"
  ],
  "SLX9": [
    "SLX9 CNV",
    "SLX9 RNA",
    "SLX9 Proteo"
  ],
  "KCTD5": [
    "KCTD5 CNV",
    "KCTD5 RNA",
    "KCTD5 Proteo"
  ],
  "SRPX2": [
    "SRPX2 CNV",
    "SRPX2 RNA",
    "SRPX2 Proteo"
  ],
  "GLA": [
    "GLA CNV",
    "GLA RNA",
    "GLA Proteo"
  ],
  "SUN3": [
    "SUN3 CNV",
    "SUN3 RNA"
  ],
  "VWFP1": [
    "VWFP1 CNV",
    "VWFP1 RNA"
  ],
  "DDX11L10": [
    "DDX11L10 CNV",
    "DDX11L10 RNA"
  ],
  "Dendritic": [
    "Dendritic Cell_type"
  ],
  "RNA5SP411": [
    "RNA5SP411 CNV",
    "RNA5SP411 RNA"
  ],
  "HKDC1": [
    "HKDC1 CNV",
    "HKDC1 RNA",
    "HKDC1 Proteo"
  ],
  "PMS2P12": [
    "PMS2P12 CNV",
    "PMS2P12 RNA"
  ],
  "LARS1": [
    "LARS1 CNV",
    "LARS1 RNA",
    "LARS1 Proteo"
  ],
  "SLC9A3P2": [
    "SLC9A3P2 CNV",
    "SLC9A3P2 RNA"
  ],
  "HNRNPA1P55": [
    "HNRNPA1P55 CNV",
    "HNRNPA1P55 RNA"
  ],
  "RNA5SP182": [
    "RNA5SP182 CNV",
    "RNA5SP182 RNA"
  ],
  "GOLGA2P4": [
    "GOLGA2P4 CNV",
    "GOLGA2P4 RNA"
  ],
  "PRR30": [
    "PRR30 CNV",
    "PRR30 RNA"
  ],
  "KRTAP13-2": [
    "KRTAP13-2 CNV",
    "KRTAP13-2 RNA"
  ],
  "TCEAL2": [
    "TCEAL2 CNV",
    "TCEAL2 RNA"
  ],
  "DAZAP2P1": [
    "DAZAP2P1 CNV",
    "DAZAP2P1 RNA"
  ],
  "RPL36AP14": [
    "RPL36AP14 CNV",
    "RPL36AP14 RNA"
  ],
  "MIA3": [
    "MIA3 CNV",
    "MIA3 RNA",
    "MIA3 Proteo"
  ],
  "GNA14": [
    "GNA14 CNV",
    "GNA14 RNA",
    "GNA14 Proteo"
  ],
  "FAM247A": [
    "FAM247A CNV",
    "FAM247A RNA"
  ],
  "PITPNM1": [
    "PITPNM1 CNV",
    "PITPNM1 RNA",
    "PITPNM1 Proteo"
  ],
  "OASL": [
    "OASL CNV",
    "OASL RNA",
    "OASL Proteo"
  ],
  "MTX2": [
    "MTX2 CNV",
    "MTX2 RNA",
    "MTX2 Proteo"
  ],
  "FRG2EP": [
    "FRG2EP CNV",
    "FRG2EP RNA"
  ],
  "C6orf58": [
    "C6orf58 CNV",
    "C6orf58 RNA"
  ],
  "ATP6V1C2": [
    "ATP6V1C2 CNV",
    "ATP6V1C2 RNA"
  ],
  "CCDC121": [
    "CCDC121 CNV",
    "CCDC121 RNA"
  ],
  "MAZ": [
    "MAZ CNV",
    "MAZ RNA",
    "MAZ Proteo"
  ],
  "CTAGE6": [
    "CTAGE6 CNV",
    "CTAGE6 RNA",
    "CTAGE6 Proteo"
  ],
  "UQCRBP3": [
    "UQCRBP3 CNV",
    "UQCRBP3 RNA"
  ],
  "EPB41L1": [
    "EPB41L1 CNV",
    "EPB41L1 RNA",
    "EPB41L1 Proteo"
  ],
  "STATH": [
    "STATH CNV",
    "STATH RNA",
    "STATH Proteo"
  ],
  "HMGN1P32": [
    "HMGN1P32 CNV",
    "HMGN1P32 RNA"
  ],
  "NR1H3": [
    "NR1H3 CNV",
    "NR1H3 RNA"
  ],
  "PSMA8": [
    "PSMA8 CNV",
    "PSMA8 RNA"
  ],
  "SORBS3": [
    "SORBS3 CNV",
    "SORBS3 RNA",
    "SORBS3 Proteo"
  ],
  "HGF": [
    "HGF CNV",
    "HGF RNA",
    "HGF Proteo"
  ],
  "GPATCH3": [
    "GPATCH3 CNV",
    "GPATCH3 RNA",
    "GPATCH3 Proteo"
  ],
  "GRAMD2A": [
    "GRAMD2A CNV",
    "GRAMD2A RNA"
  ],
  "PARVG": [
    "PARVG CNV",
    "PARVG RNA",
    "PARVG Proteo"
  ],
  "GAPDHP72": [
    "GAPDHP72 CNV",
    "GAPDHP72 RNA"
  ],
  "BNIP2": [
    "BNIP2 CNV",
    "BNIP2 RNA",
    "BNIP2 Proteo"
  ],
  "KCNMA1": [
    "KCNMA1 CNV",
    "KCNMA1 RNA",
    "KCNMA1 Proteo"
  ],
  "UQCRHL": [
    "UQCRHL CNV",
    "UQCRHL RNA"
  ],
  "CNTN6": [
    "CNTN6 CNV",
    "CNTN6 RNA"
  ],
  "ZDHHC23": [
    "ZDHHC23 CNV",
    "ZDHHC23 RNA"
  ],
  "ATP5MGP3": [
    "ATP5MGP3 CNV",
    "ATP5MGP3 RNA"
  ],
  "BOLL": [
    "BOLL CNV",
    "BOLL RNA"
  ],
  "SYT13": [
    "SYT13 CNV",
    "SYT13 RNA"
  ],
  "FAM83G": [
    "FAM83G CNV",
    "FAM83G RNA",
    "FAM83G Proteo"
  ],
  "UBE2CP4": [
    "UBE2CP4 CNV",
    "UBE2CP4 RNA"
  ],
  "SEC22A": [
    "SEC22A CNV",
    "SEC22A RNA",
    "SEC22A Proteo"
  ],
  "SRSF7": [
    "SRSF7 CNV",
    "SRSF7 RNA",
    "SRSF7 Proteo"
  ],
  "STRADB": [
    "STRADB CNV",
    "STRADB RNA",
    "STRADB Proteo"
  ],
  "ANP32D": [
    "ANP32D CNV",
    "ANP32D RNA",
    "ANP32D Proteo"
  ],
  "TAS2R42": [
    "TAS2R42 CNV",
    "TAS2R42 RNA"
  ],
  "GALP": [
    "GALP CNV",
    "GALP RNA"
  ],
  "H4C9": [
    "H4C9 CNV",
    "H4C9 RNA"
  ],
  "SSR1P1": [
    "SSR1P1 CNV",
    "SSR1P1 RNA"
  ],
  "CYB5A": [
    "CYB5A CNV",
    "CYB5A RNA",
    "CYB5A Proteo"
  ],
  "DGCR2": [
    "DGCR2 CNV",
    "DGCR2 RNA",
    "DGCR2 Proteo"
  ],
  "HSFY1P1": [
    "HSFY1P1 CNV",
    "HSFY1P1 RNA"
  ],
  "TMEM106C": [
    "TMEM106C CNV",
    "TMEM106C RNA",
    "TMEM106C Proteo"
  ],
  "OR6R1P": [
    "OR6R1P CNV",
    "OR6R1P RNA"
  ],
  "KNL1": [
    "KNL1 CNV",
    "KNL1 RNA",
    "KNL1 Proteo"
  ],
  "CRIP1P1": [
    "CRIP1P1 CNV",
    "CRIP1P1 RNA"
  ],
  "UBTFL10": [
    "UBTFL10 CNV",
    "UBTFL10 RNA"
  ],
  "IGKV1D-8": [
    "IGKV1D-8 Proteo"
  ],
  "ATG5": [
    "ATG5 CNV",
    "ATG5 RNA",
    "ATG5 Proteo"
  ],
  "ETS2P1": [
    "ETS2P1 CNV",
    "ETS2P1 RNA"
  ],
  "SLAMF7": [
    "SLAMF7 CNV",
    "SLAMF7 RNA",
    "SLAMF7 Proteo"
  ],
  "ST6GALNAC6": [
    "ST6GALNAC6 CNV",
    "ST6GALNAC6 RNA"
  ],
  "JHY": [
    "JHY CNV",
    "JHY RNA"
  ],
  "ELOCP28": [
    "ELOCP28 CNV",
    "ELOCP28 RNA"
  ],
  "PABPC1P13": [
    "PABPC1P13 CNV",
    "PABPC1P13 RNA"
  ],
  "RPS24P19": [
    "RPS24P19 CNV",
    "RPS24P19 RNA"
  ],
  "BCAR1P1": [
    "BCAR1P1 CNV",
    "BCAR1P1 RNA"
  ],
  "PLEKHA8": [
    "PLEKHA8 CNV",
    "PLEKHA8 RNA",
    "PLEKHA8 Proteo"
  ],
  "EIF5AP4": [
    "EIF5AP4 CNV",
    "EIF5AP4 RNA"
  ],
  "DCLRE1C": [
    "DCLRE1C CNV",
    "DCLRE1C RNA",
    "DCLRE1C Proteo"
  ],
  "NDUFA5P10": [
    "NDUFA5P10 CNV",
    "NDUFA5P10 RNA"
  ],
  "RAP2CP1": [
    "RAP2CP1 CNV",
    "RAP2CP1 RNA"
  ],
  "KLHL34": [
    "KLHL34 CNV",
    "KLHL34 RNA"
  ],
  "IFNWP2": [
    "IFNWP2 CNV",
    "IFNWP2 RNA"
  ],
  "FSIP1": [
    "FSIP1 CNV",
    "FSIP1 RNA"
  ],
  "CCN4": [
    "CCN4 CNV",
    "CCN4 RNA"
  ],
  "MTCO1P39": [
    "MTCO1P39 CNV",
    "MTCO1P39 RNA"
  ],
  "PRTFDC1": [
    "PRTFDC1 CNV",
    "PRTFDC1 RNA",
    "PRTFDC1 Proteo"
  ],
  "RPS15AP36": [
    "RPS15AP36 CNV",
    "RPS15AP36 RNA"
  ],
  "CLEC16A": [
    "CLEC16A CNV",
    "CLEC16A RNA",
    "CLEC16A Proteo"
  ],
  "PLSCR5": [
    "PLSCR5 CNV",
    "PLSCR5 RNA"
  ],
  "MYCL": [
    "MYCL CNV",
    "MYCL RNA"
  ],
  "SLC30A6P1": [
    "SLC30A6P1 CNV",
    "SLC30A6P1 RNA"
  ],
  "HSCB": [
    "HSCB CNV",
    "HSCB RNA",
    "HSCB Proteo"
  ],
  "ELFN2": [
    "ELFN2 CNV",
    "ELFN2 RNA"
  ],
  "UGGT1": [
    "UGGT1 CNV",
    "UGGT1 RNA",
    "UGGT1 Proteo"
  ],
  "KRT8P18": [
    "KRT8P18 CNV",
    "KRT8P18 RNA"
  ],
  "GUSBP19": [
    "GUSBP19 CNV",
    "GUSBP19 RNA"
  ],
  "TEX13B": [
    "TEX13B CNV",
    "TEX13B RNA"
  ],
  "ZNF441": [
    "ZNF441 CNV",
    "ZNF441 RNA"
  ],
  "CCDC167": [
    "CCDC167 CNV",
    "CCDC167 RNA",
    "CCDC167 Proteo"
  ],
  "CLEC5A": [
    "CLEC5A CNV",
    "CLEC5A RNA",
    "CLEC5A Proteo"
  ],
  "CBR1": [
    "CBR1 CNV",
    "CBR1 RNA",
    "CBR1 Proteo"
  ],
  "FBXO44": [
    "FBXO44 CNV",
    "FBXO44 RNA",
    "FBXO44 Proteo"
  ],
  "WNK3": [
    "WNK3 CNV",
    "WNK3 RNA",
    "WNK3 Proteo"
  ],
  "DMKN": [
    "DMKN CNV",
    "DMKN RNA",
    "DMKN Proteo"
  ],
  "NANOGNBP2": [
    "NANOGNBP2 CNV",
    "NANOGNBP2 RNA"
  ],
  "SULT2A1": [
    "SULT2A1 CNV",
    "SULT2A1 RNA"
  ],
  "DUSP9": [
    "DUSP9 CNV",
    "DUSP9 RNA",
    "DUSP9 Proteo"
  ],
  "COPA": [
    "COPA CNV",
    "COPA RNA",
    "COPA Proteo"
  ],
  "KRTAP13-4": [
    "KRTAP13-4 CNV",
    "KRTAP13-4 RNA"
  ],
  "RARRES2P2": [
    "RARRES2P2 CNV",
    "RARRES2P2 RNA"
  ],
  "PRCD": [
    "PRCD CNV",
    "PRCD RNA"
  ],
  "TSSC4": [
    "TSSC4 CNV",
    "TSSC4 RNA",
    "TSSC4 Proteo"
  ],
  "TMSB4XP2": [
    "TMSB4XP2 CNV",
    "TMSB4XP2 RNA"
  ],
  "ZNF256": [
    "ZNF256 CNV",
    "ZNF256 RNA"
  ],
  "GOLGA4": [
    "GOLGA4 CNV",
    "GOLGA4 RNA",
    "GOLGA4 Proteo"
  ],
  "ZNF584": [
    "ZNF584 CNV",
    "ZNF584 RNA"
  ],
  "UBE2Q2P5Y": [
    "UBE2Q2P5Y CNV",
    "UBE2Q2P5Y RNA"
  ],
  "RPAP1": [
    "RPAP1 CNV",
    "RPAP1 RNA",
    "RPAP1 Proteo"
  ],
  "EIF3L": [
    "EIF3L CNV",
    "EIF3L RNA",
    "EIF3L Proteo"
  ],
  "LRPPRC": [
    "LRPPRC CNV",
    "LRPPRC RNA",
    "LRPPRC Proteo"
  ],
  "CCM2L": [
    "CCM2L CNV",
    "CCM2L RNA"
  ],
  "UBE2V1P13": [
    "UBE2V1P13 CNV",
    "UBE2V1P13 RNA"
  ],
  "OR52Y1P": [
    "OR52Y1P CNV",
    "OR52Y1P RNA"
  ],
  "TRIM37": [
    "TRIM37 CNV",
    "TRIM37 RNA",
    "TRIM37 Proteo"
  ],
  "MDP1": [
    "MDP1 CNV",
    "MDP1 RNA",
    "MDP1 Proteo"
  ],
  "SCPEP1": [
    "SCPEP1 CNV",
    "SCPEP1 RNA",
    "SCPEP1 Proteo"
  ],
  "JKAMPP1": [
    "JKAMPP1 CNV",
    "JKAMPP1 RNA"
  ],
  "MTND5P31": [
    "MTND5P31 CNV",
    "MTND5P31 RNA"
  ],
  "ATF7IP": [
    "ATF7IP CNV",
    "ATF7IP RNA",
    "ATF7IP Proteo"
  ],
  "ZNF283": [
    "ZNF283 CNV",
    "ZNF283 RNA"
  ],
  "RAD52P1": [
    "RAD52P1 CNV",
    "RAD52P1 RNA"
  ],
  "CD300A": [
    "CD300A CNV",
    "CD300A RNA",
    "CD300A Proteo"
  ],
  "FABP5P12": [
    "FABP5P12 CNV",
    "FABP5P12 RNA"
  ],
  "ABRACL": [
    "ABRACL CNV",
    "ABRACL RNA",
    "ABRACL Proteo"
  ],
  "GET4": [
    "GET4 CNV",
    "GET4 RNA",
    "GET4 Proteo"
  ],
  "ELOCP5": [
    "ELOCP5 CNV",
    "ELOCP5 RNA"
  ],
  "KMT5AP2": [
    "KMT5AP2 CNV",
    "KMT5AP2 RNA"
  ],
  "BNIP3P4": [
    "BNIP3P4 CNV",
    "BNIP3P4 RNA"
  ],
  "ZNF790": [
    "ZNF790 CNV",
    "ZNF790 RNA"
  ],
  "EIF2S3": [
    "EIF2S3 CNV",
    "EIF2S3 RNA",
    "EIF2S3 Proteo"
  ],
  "ZP1": [
    "ZP1 CNV",
    "ZP1 RNA"
  ],
  "NMNAT1P5": [
    "NMNAT1P5 CNV",
    "NMNAT1P5 RNA"
  ],
  "GDF1": [
    "GDF1 CNV",
    "GDF1 RNA"
  ],
  "ARL13A": [
    "ARL13A CNV",
    "ARL13A RNA"
  ],
  "EPCAM": [
    "EPCAM CNV",
    "EPCAM RNA",
    "EPCAM Proteo"
  ],
  "TRIM61": [
    "TRIM61 CNV",
    "TRIM61 RNA"
  ],
  "FRAS1": [
    "FRAS1 CNV",
    "FRAS1 RNA",
    "FRAS1 Proteo"
  ],
  "TPT1P2": [
    "TPT1P2 CNV",
    "TPT1P2 RNA"
  ],
  "TPSAB1": [
    "TPSAB1 CNV",
    "TPSAB1 RNA",
    "TPSAB1 Proteo"
  ],
  "ARSDP1": [
    "ARSDP1 CNV",
    "ARSDP1 RNA"
  ],
  "RARRES2P11": [
    "RARRES2P11 CNV",
    "RARRES2P11 RNA"
  ],
  "FEM1AP4": [
    "FEM1AP4 CNV",
    "FEM1AP4 RNA"
  ],
  "PINK1": [
    "PINK1 CNV",
    "PINK1 RNA"
  ],
  "IGLVI-42": [
    "IGLVI-42 CNV",
    "IGLVI-42 RNA"
  ],
  "FCRLB": [
    "FCRLB CNV",
    "FCRLB RNA"
  ],
  "GXYLT2": [
    "GXYLT2 CNV",
    "GXYLT2 RNA",
    "GXYLT2 Proteo"
  ],
  "COL5A2": [
    "COL5A2 CNV",
    "COL5A2 RNA",
    "COL5A2 Proteo"
  ],
  "BTF3P2": [
    "BTF3P2 CNV",
    "BTF3P2 RNA"
  ],
  "ZNF646P1": [
    "ZNF646P1 CNV",
    "ZNF646P1 RNA"
  ],
  "TSPEAR": [
    "TSPEAR CNV",
    "TSPEAR RNA"
  ],
  "RPL31P12": [
    "RPL31P12 CNV",
    "RPL31P12 RNA"
  ],
  "HEXD": [
    "HEXD CNV",
    "HEXD RNA",
    "HEXD Proteo"
  ],
  "LRR1": [
    "LRR1 CNV",
    "LRR1 RNA",
    "LRR1 Proteo"
  ],
  "POM121": [
    "POM121 CNV",
    "POM121 RNA",
    "POM121 Proteo"
  ],
  "LRFN5": [
    "LRFN5 CNV",
    "LRFN5 RNA"
  ],
  "PPP1R1C": [
    "PPP1R1C CNV",
    "PPP1R1C RNA"
  ],
  "ZNF209P": [
    "ZNF209P CNV",
    "ZNF209P RNA"
  ],
  "ACSL4": [
    "ACSL4 CNV",
    "ACSL4 RNA",
    "ACSL4 Proteo"
  ],
  "IGKV2-38": [
    "IGKV2-38 CNV",
    "IGKV2-38 RNA"
  ],
  "RABEP2": [
    "RABEP2 CNV",
    "RABEP2 RNA",
    "RABEP2 Proteo"
  ],
  "DUSP8P5": [
    "DUSP8P5 CNV",
    "DUSP8P5 RNA"
  ],
  "SLCO4A1": [
    "SLCO4A1 CNV",
    "SLCO4A1 RNA",
    "SLCO4A1 Proteo"
  ],
  "ADAMTS7": [
    "ADAMTS7 CNV",
    "ADAMTS7 RNA",
    "ADAMTS7 Proteo"
  ],
  "FASN": [
    "FASN CNV",
    "FASN RNA",
    "FASN Proteo"
  ],
  "OR1E2": [
    "OR1E2 CNV",
    "OR1E2 RNA"
  ],
  "H2BW2": [
    "H2BW2 CNV",
    "H2BW2 RNA"
  ],
  "RNA5SP523": [
    "RNA5SP523 CNV",
    "RNA5SP523 RNA"
  ],
  "MYF6": [
    "MYF6 CNV",
    "MYF6 RNA"
  ],
  "MAN1B1": [
    "MAN1B1 CNV",
    "MAN1B1 RNA",
    "MAN1B1 Proteo"
  ],
  "PRKCQ": [
    "PRKCQ CNV",
    "PRKCQ RNA",
    "PRKCQ Proteo"
  ],
  "SUMO2P12": [
    "SUMO2P12 CNV",
    "SUMO2P12 RNA"
  ],
  "PGDP1": [
    "PGDP1 CNV",
    "PGDP1 RNA"
  ],
  "IFNA11P": [
    "IFNA11P CNV",
    "IFNA11P RNA"
  ],
  "MSMO1": [
    "MSMO1 CNV",
    "MSMO1 RNA",
    "MSMO1 Proteo"
  ],
  "TRIM51CP": [
    "TRIM51CP CNV",
    "TRIM51CP RNA"
  ],
  "CYP4F8": [
    "CYP4F8 CNV",
    "CYP4F8 RNA"
  ],
  "EEF1A1P44": [
    "EEF1A1P44 CNV",
    "EEF1A1P44 RNA"
  ],
  "RPL31P41": [
    "RPL31P41 CNV",
    "RPL31P41 RNA"
  ],
  "ANKMY1": [
    "ANKMY1 CNV",
    "ANKMY1 RNA"
  ],
  "CNGA1": [
    "CNGA1 CNV",
    "CNGA1 RNA"
  ],
  "RAD23A": [
    "RAD23A CNV",
    "RAD23A RNA",
    "RAD23A Proteo"
  ],
  "DEDD2": [
    "DEDD2 CNV",
    "DEDD2 RNA"
  ],
  "ACMSD": [
    "ACMSD CNV",
    "ACMSD RNA"
  ],
  "MTND6P7": [
    "MTND6P7 CNV",
    "MTND6P7 RNA"
  ],
  "MRPL42": [
    "MRPL42 CNV",
    "MRPL42 RNA",
    "MRPL42 Proteo"
  ],
  "MT1F": [
    "MT1F CNV",
    "MT1F RNA",
    "MT1F Proteo"
  ],
  "SLC34A1": [
    "SLC34A1 CNV",
    "SLC34A1 RNA"
  ],
  "CKS1BP6": [
    "CKS1BP6 CNV",
    "CKS1BP6 RNA"
  ],
  "OSGIN2": [
    "OSGIN2 CNV",
    "OSGIN2 RNA"
  ],
  "MANBAL": [
    "MANBAL CNV",
    "MANBAL RNA",
    "MANBAL Proteo"
  ],
  "VNN2": [
    "VNN2 CNV",
    "VNN2 RNA",
    "VNN2 Proteo"
  ],
  "NSUN6": [
    "NSUN6 CNV",
    "NSUN6 RNA",
    "NSUN6 Proteo"
  ],
  "KRTAP9-3": [
    "KRTAP9-3 CNV",
    "KRTAP9-3 RNA"
  ],
  "RHOD": [
    "RHOD CNV",
    "RHOD RNA",
    "RHOD Proteo"
  ],
  "KARS1": [
    "KARS1 CNV",
    "KARS1 RNA",
    "KARS1 Proteo"
  ],
  "KRTAP2-5P": [
    "KRTAP2-5P CNV",
    "KRTAP2-5P RNA"
  ],
  "AKAP1": [
    "AKAP1 CNV",
    "AKAP1 RNA",
    "AKAP1 Proteo"
  ],
  "DPRXP5": [
    "DPRXP5 CNV",
    "DPRXP5 RNA"
  ],
  "TUNAR": [
    "TUNAR CNV",
    "TUNAR RNA"
  ],
  "RPL27P6": [
    "RPL27P6 CNV",
    "RPL27P6 RNA"
  ],
  "RWDD2B": [
    "RWDD2B CNV",
    "RWDD2B RNA",
    "RWDD2B Proteo"
  ],
  "FTH1P8": [
    "FTH1P8 CNV",
    "FTH1P8 RNA"
  ],
  "CD19": [
    "CD19 CNV",
    "CD19 RNA",
    "CD19 Proteo"
  ],
  "HSD3BP2": [
    "HSD3BP2 CNV",
    "HSD3BP2 RNA"
  ],
  "TMEM225B": [
    "TMEM225B CNV",
    "TMEM225B RNA"
  ],
  "SMAD5": [
    "SMAD5 CNV",
    "SMAD5 RNA",
    "SMAD5 Proteo"
  ],
  "NBEAP5": [
    "NBEAP5 CNV",
    "NBEAP5 RNA"
  ],
  "DEFA9P": [
    "DEFA9P CNV",
    "DEFA9P RNA"
  ],
  "PPIAL4F": [
    "PPIAL4F CNV",
    "PPIAL4F RNA"
  ],
  "ALDH3B2": [
    "ALDH3B2 CNV",
    "ALDH3B2 RNA"
  ],
  "OR5AO1P": [
    "OR5AO1P CNV",
    "OR5AO1P RNA"
  ],
  "RFESD": [
    "RFESD CNV",
    "RFESD RNA",
    "RFESD Proteo"
  ],
  "RNA5SP487": [
    "RNA5SP487 CNV",
    "RNA5SP487 RNA"
  ],
  "TRPM2": [
    "TRPM2 CNV",
    "TRPM2 RNA",
    "TRPM2 Proteo"
  ],
  "C2orf78": [
    "C2orf78 CNV",
    "C2orf78 RNA"
  ],
  "P2RY12": [
    "P2RY12 CNV",
    "P2RY12 RNA",
    "P2RY12 Proteo"
  ],
  "ABCB10P3": [
    "ABCB10P3 CNV",
    "ABCB10P3 RNA"
  ],
  "KHNYN": [
    "KHNYN CNV",
    "KHNYN RNA",
    "KHNYN Proteo"
  ],
  "MC2R": [
    "MC2R CNV",
    "MC2R RNA"
  ],
  "IGKV1OR2-1": [
    "IGKV1OR2-1 CNV",
    "IGKV1OR2-1 RNA"
  ],
  "NEB": [
    "NEB CNV",
    "NEB RNA",
    "NEB Proteo"
  ],
  "RAD51D": [
    "RAD51D CNV",
    "RAD51D RNA",
    "RAD51D Proteo"
  ],
  "OR8U1": [
    "OR8U1 CNV",
    "OR8U1 RNA"
  ],
  "BBOX1": [
    "BBOX1 CNV",
    "BBOX1 RNA",
    "BBOX1 Proteo"
  ],
  "NR1H2": [
    "NR1H2 CNV",
    "NR1H2 RNA",
    "NR1H2 Proteo"
  ],
  "B3GALT6": [
    "B3GALT6 CNV",
    "B3GALT6 RNA",
    "B3GALT6 Proteo"
  ],
  "ZSCAN29": [
    "ZSCAN29 CNV",
    "ZSCAN29 RNA",
    "ZSCAN29 Proteo"
  ],
  "CWF19L2": [
    "CWF19L2 CNV",
    "CWF19L2 RNA",
    "CWF19L2 Proteo"
  ],
  "FDX1P1": [
    "FDX1P1 CNV",
    "FDX1P1 RNA"
  ],
  "MRPS18CP4": [
    "MRPS18CP4 CNV",
    "MRPS18CP4 RNA"
  ],
  "CICP7": [
    "CICP7 CNV",
    "CICP7 RNA"
  ],
  "ZNF398": [
    "ZNF398 CNV",
    "ZNF398 RNA"
  ],
  "IGKV1OR22-5": [
    "IGKV1OR22-5 CNV",
    "IGKV1OR22-5 RNA"
  ],
  "OR1Q1": [
    "OR1Q1 CNV",
    "OR1Q1 RNA"
  ],
  "AKR7A3": [
    "AKR7A3 CNV",
    "AKR7A3 RNA",
    "AKR7A3 Proteo"
  ],
  "PTCHD1": [
    "PTCHD1 CNV",
    "PTCHD1 RNA"
  ],
  "SLC35G4": [
    "SLC35G4 CNV",
    "SLC35G4 RNA"
  ],
  "MRPS31P5": [
    "MRPS31P5 CNV",
    "MRPS31P5 RNA"
  ],
  "DRD3": [
    "DRD3 CNV",
    "DRD3 RNA"
  ],
  "MTCO2P12": [
    "MTCO2P12 CNV",
    "MTCO2P12 RNA"
  ],
  "HARS1": [
    "HARS1 CNV",
    "HARS1 RNA",
    "HARS1 Proteo"
  ],
  "NIFKP9": [
    "NIFKP9 CNV",
    "NIFKP9 RNA"
  ],
  "PRRG4": [
    "PRRG4 CNV",
    "PRRG4 RNA"
  ],
  "HSPE1P10": [
    "HSPE1P10 CNV",
    "HSPE1P10 RNA"
  ],
  "ZNF793": [
    "ZNF793 CNV",
    "ZNF793 RNA"
  ],
  "SSBL4P": [
    "SSBL4P CNV",
    "SSBL4P RNA"
  ],
  "RPL5P6": [
    "RPL5P6 CNV",
    "RPL5P6 RNA"
  ],
  "SRFBP1": [
    "SRFBP1 CNV",
    "SRFBP1 RNA",
    "SRFBP1 Proteo"
  ],
  "POLM": [
    "POLM CNV",
    "POLM RNA",
    "POLM Proteo"
  ],
  "CYP4F27P": [
    "CYP4F27P CNV",
    "CYP4F27P RNA"
  ],
  "MUC15": [
    "MUC15 CNV",
    "MUC15 RNA",
    "MUC15 Proteo"
  ],
  "VPS25P1": [
    "VPS25P1 CNV",
    "VPS25P1 RNA"
  ],
  "DUXA": [
    "DUXA CNV",
    "DUXA RNA"
  ],
  "F11R": [
    "F11R CNV",
    "F11R RNA",
    "F11R Proteo"
  ],
  "LIPI": [
    "LIPI CNV",
    "LIPI RNA"
  ],
  "ENTR1P1": [
    "ENTR1P1 CNV",
    "ENTR1P1 RNA"
  ],
  "KIF2C": [
    "KIF2C CNV",
    "KIF2C RNA",
    "KIF2C Proteo"
  ],
  "CELF2": [
    "CELF2 CNV",
    "CELF2 RNA",
    "CELF2 Proteo"
  ],
  "KLHDC1": [
    "KLHDC1 CNV",
    "KLHDC1 RNA"
  ],
  "RRM1": [
    "RRM1 CNV",
    "RRM1 RNA",
    "RRM1 Proteo"
  ],
  "CCDC33": [
    "CCDC33 CNV",
    "CCDC33 RNA"
  ],
  "TBC1D2": [
    "TBC1D2 CNV",
    "TBC1D2 RNA",
    "TBC1D2 Proteo"
  ],
  "CTNNAL1": [
    "CTNNAL1 CNV",
    "CTNNAL1 RNA",
    "CTNNAL1 Proteo"
  ],
  "KCNA3": [
    "KCNA3 CNV",
    "KCNA3 RNA",
    "KCNA3 Proteo"
  ],
  "FXNP1": [
    "FXNP1 CNV",
    "FXNP1 RNA"
  ],
  "SUB1P3": [
    "SUB1P3 CNV",
    "SUB1P3 RNA"
  ],
  "BNIP3P30": [
    "BNIP3P30 CNV",
    "BNIP3P30 RNA"
  ],
  "CIAO3": [
    "CIAO3 CNV",
    "CIAO3 RNA",
    "CIAO3 Proteo"
  ],
  "TMEM183A": [
    "TMEM183A CNV",
    "TMEM183A RNA",
    "TMEM183A Proteo"
  ],
  "DENND11": [
    "DENND11 CNV",
    "DENND11 RNA",
    "DENND11 Proteo"
  ],
  "RPL17P35": [
    "RPL17P35 CNV",
    "RPL17P35 RNA"
  ],
  "DHX9": [
    "DHX9 CNV",
    "DHX9 RNA",
    "DHX9 Proteo"
  ],
  "GAPDHP65": [
    "GAPDHP65 CNV",
    "GAPDHP65 RNA"
  ],
  "SCRN3": [
    "SCRN3 CNV",
    "SCRN3 RNA",
    "SCRN3 Proteo"
  ],
  "SLC10A4": [
    "SLC10A4 CNV",
    "SLC10A4 RNA"
  ],
  "LDB2": [
    "LDB2 CNV",
    "LDB2 RNA"
  ],
  "IFITM1": [
    "IFITM1 CNV",
    "IFITM1 RNA",
    "IFITM1 Proteo"
  ],
  "YAE1": [
    "YAE1 CNV",
    "YAE1 RNA",
    "YAE1 Proteo"
  ],
  "HOATZ": [
    "HOATZ CNV",
    "HOATZ RNA"
  ],
  "MRNIP": [
    "MRNIP CNV",
    "MRNIP RNA",
    "MRNIP Proteo"
  ],
  "RPL21P104": [
    "RPL21P104 CNV",
    "RPL21P104 RNA"
  ],
  "ERLEC1": [
    "ERLEC1 CNV",
    "ERLEC1 RNA",
    "ERLEC1 Proteo"
  ],
  "NTMT1": [
    "NTMT1 CNV",
    "NTMT1 RNA",
    "NTMT1 Proteo"
  ],
  "KRT18P64": [
    "KRT18P64 CNV",
    "KRT18P64 RNA"
  ],
  "ADI1": [
    "ADI1 CNV",
    "ADI1 RNA",
    "ADI1 Proteo"
  ],
  "TOMM20": [
    "TOMM20 CNV",
    "TOMM20 RNA",
    "TOMM20 Proteo"
  ],
  "SLC25A14P1": [
    "SLC25A14P1 CNV",
    "SLC25A14P1 RNA"
  ],
  "PCYT2": [
    "PCYT2 CNV",
    "PCYT2 RNA",
    "PCYT2 Proteo"
  ],
  "R3HDM4": [
    "R3HDM4 CNV",
    "R3HDM4 RNA",
    "R3HDM4 Proteo"
  ],
  "ITGA3": [
    "ITGA3 CNV",
    "ITGA3 RNA",
    "ITGA3 Proteo"
  ],
  "RD3L": [
    "RD3L CNV",
    "RD3L RNA"
  ],
  "EEF1A1P23": [
    "EEF1A1P23 CNV",
    "EEF1A1P23 RNA"
  ],
  "RBL1": [
    "RBL1 CNV",
    "RBL1 RNA",
    "RBL1 Proteo"
  ],
  "RPL13": [
    "RPL13 CNV",
    "RPL13 RNA",
    "RPL13 Proteo"
  ],
  "SEC22C": [
    "SEC22C CNV",
    "SEC22C RNA"
  ],
  "GPR19": [
    "GPR19 CNV",
    "GPR19 RNA"
  ],
  "ZNRF1": [
    "ZNRF1 CNV",
    "ZNRF1 RNA",
    "ZNRF1 Proteo"
  ],
  "DTYMK": [
    "DTYMK CNV",
    "DTYMK RNA",
    "DTYMK Proteo"
  ],
  "RIDA": [
    "RIDA CNV",
    "RIDA RNA",
    "RIDA Proteo"
  ],
  "DEFB129": [
    "DEFB129 CNV",
    "DEFB129 RNA"
  ],
  "MTFR2": [
    "MTFR2 CNV",
    "MTFR2 RNA",
    "MTFR2 Proteo"
  ],
  "ANAPC15P2": [
    "ANAPC15P2 CNV",
    "ANAPC15P2 RNA"
  ],
  "PGF": [
    "PGF CNV",
    "PGF RNA"
  ],
  "TIMM44": [
    "TIMM44 CNV",
    "TIMM44 RNA",
    "TIMM44 Proteo"
  ],
  "GUK1": [
    "GUK1 CNV",
    "GUK1 RNA",
    "GUK1 Proteo"
  ],
  "PANX2": [
    "PANX2 CNV",
    "PANX2 RNA"
  ],
  "CGAS": [
    "CGAS CNV",
    "CGAS RNA",
    "CGAS Proteo"
  ],
  "MAP2K1P1": [
    "MAP2K1P1 CNV",
    "MAP2K1P1 RNA"
  ],
  "NUP210L": [
    "NUP210L CNV",
    "NUP210L RNA",
    "NUP210L Proteo"
  ],
  "MRPS27": [
    "MRPS27 CNV",
    "MRPS27 RNA",
    "MRPS27 Proteo"
  ],
  "CD40": [
    "CD40 CNV",
    "CD40 RNA",
    "CD40 Proteo"
  ],
  "SMIM43": [
    "SMIM43 CNV",
    "SMIM43 RNA"
  ],
  "CERS5": [
    "CERS5 CNV",
    "CERS5 RNA",
    "CERS5 Proteo"
  ],
  "PPP1R12C": [
    "PPP1R12C CNV",
    "PPP1R12C RNA",
    "PPP1R12C Proteo"
  ],
  "NOL8": [
    "NOL8 CNV",
    "NOL8 RNA",
    "NOL8 Proteo"
  ],
  "ZNF652P1": [
    "ZNF652P1 CNV",
    "ZNF652P1 RNA"
  ],
  "ARL2BPP3": [
    "ARL2BPP3 CNV",
    "ARL2BPP3 RNA"
  ],
  "RPL7P40": [
    "RPL7P40 CNV",
    "RPL7P40 RNA"
  ],
  "APLF": [
    "APLF CNV",
    "APLF RNA",
    "APLF Proteo"
  ],
  "RBM48P1": [
    "RBM48P1 CNV",
    "RBM48P1 RNA"
  ],
  "PLCG1": [
    "PLCG1 CNV",
    "PLCG1 RNA",
    "PLCG1 Proteo"
  ],
  "EXTL3": [
    "EXTL3 CNV",
    "EXTL3 RNA",
    "EXTL3 Proteo"
  ],
  "NRP1": [
    "NRP1 CNV",
    "NRP1 RNA",
    "NRP1 Proteo"
  ],
  "KRT74": [
    "KRT74 CNV",
    "KRT74 RNA",
    "KRT74 Proteo"
  ],
  "IBSP": [
    "IBSP CNV",
    "IBSP RNA"
  ],
  "SSU72P1": [
    "SSU72P1 CNV",
    "SSU72P1 RNA"
  ],
  "APOB": [
    "APOB CNV",
    "APOB RNA",
    "APOB Proteo"
  ],
  "CDH23": [
    "CDH23 CNV",
    "CDH23 RNA"
  ],
  "PALS1": [
    "PALS1 CNV",
    "PALS1 RNA",
    "PALS1 Proteo"
  ],
  "OR2T10": [
    "OR2T10 CNV",
    "OR2T10 RNA"
  ],
  "PLEKHG5": [
    "PLEKHG5 CNV",
    "PLEKHG5 RNA",
    "PLEKHG5 Proteo"
  ],
  "TAS2R4": [
    "TAS2R4 CNV",
    "TAS2R4 RNA"
  ],
  "TJAP1P1": [
    "TJAP1P1 CNV",
    "TJAP1P1 RNA"
  ],
  "MLST8": [
    "MLST8 CNV",
    "MLST8 RNA",
    "MLST8 Proteo"
  ],
  "METAP1D": [
    "METAP1D CNV",
    "METAP1D RNA",
    "METAP1D Proteo"
  ],
  "C6orf163": [
    "C6orf163 CNV",
    "C6orf163 RNA"
  ],
  "NACA2": [
    "NACA2 CNV",
    "NACA2 RNA",
    "NACA2 Proteo"
  ],
  "PDE4DIPP2": [
    "PDE4DIPP2 CNV",
    "PDE4DIPP2 RNA"
  ],
  "GPRC6A": [
    "GPRC6A CNV",
    "GPRC6A RNA"
  ],
  "TYK2": [
    "TYK2 CNV",
    "TYK2 RNA",
    "TYK2 Proteo"
  ],
  "PIFO": [
    "PIFO CNV",
    "PIFO RNA"
  ],
  "GARIN5A": [
    "GARIN5A CNV",
    "GARIN5A RNA"
  ],
  "NTF3": [
    "NTF3 CNV",
    "NTF3 RNA"
  ],
  "HMGB1P27": [
    "HMGB1P27 CNV",
    "HMGB1P27 RNA"
  ],
  "NDE1P2": [
    "NDE1P2 CNV",
    "NDE1P2 RNA"
  ],
  "ARF1": [
    "ARF1 CNV",
    "ARF1 RNA",
    "ARF1 Proteo"
  ],
  "WFDC1": [
    "WFDC1 CNV",
    "WFDC1 RNA"
  ],
  "AP3S2": [
    "AP3S2 CNV",
    "AP3S2 RNA",
    "AP3S2 Proteo"
  ],
  "AMER1": [
    "AMER1 CNV",
    "AMER1 RNA"
  ],
  "PIK3CB": [
    "PIK3CB CNV",
    "PIK3CB RNA",
    "PIK3CB Proteo"
  ],
  "GLDN": [
    "GLDN CNV",
    "GLDN RNA"
  ],
  "GM2A": [
    "GM2A CNV",
    "GM2A RNA",
    "GM2A Proteo"
  ],
  "CELP": [
    "CELP CNV",
    "CELP RNA"
  ],
  "TMPRSS11D": [
    "TMPRSS11D CNV",
    "TMPRSS11D RNA"
  ],
  "NRBF2P2": [
    "NRBF2P2 CNV",
    "NRBF2P2 RNA"
  ],
  "CUTA": [
    "CUTA CNV",
    "CUTA RNA",
    "CUTA Proteo"
  ],
  "HSPA1L": [
    "HSPA1L CNV",
    "HSPA1L RNA",
    "HSPA1L Proteo"
  ],
  "FAM25C": [
    "FAM25C CNV",
    "FAM25C RNA"
  ],
  "DPYSL5": [
    "DPYSL5 CNV",
    "DPYSL5 RNA",
    "DPYSL5 Proteo"
  ],
  "OR4R3P": [
    "OR4R3P CNV",
    "OR4R3P RNA"
  ],
  "H3P12": [
    "H3P12 CNV",
    "H3P12 RNA"
  ],
  "SLC25A29": [
    "SLC25A29 CNV",
    "SLC25A29 RNA",
    "SLC25A29 Proteo"
  ],
  "IGLV3-4": [
    "IGLV3-4 CNV",
    "IGLV3-4 RNA"
  ],
  "SASH3": [
    "SASH3 CNV",
    "SASH3 RNA",
    "SASH3 Proteo"
  ],
  "UBA52P8": [
    "UBA52P8 CNV",
    "UBA52P8 RNA"
  ],
  "RPL36AP40": [
    "RPL36AP40 CNV",
    "RPL36AP40 RNA"
  ],
  "CCT3": [
    "CCT3 CNV",
    "CCT3 RNA",
    "CCT3 Proteo"
  ],
  "PRDX4": [
    "PRDX4 CNV",
    "PRDX4 RNA",
    "PRDX4 Proteo"
  ],
  "ASPM": [
    "ASPM CNV",
    "ASPM RNA",
    "ASPM Proteo"
  ],
  "USP9X": [
    "USP9X CNV",
    "USP9X RNA",
    "USP9X Proteo"
  ],
  "KRT8P35": [
    "KRT8P35 CNV",
    "KRT8P35 RNA"
  ],
  "METTL2A": [
    "METTL2A CNV",
    "METTL2A RNA",
    "METTL2A Proteo"
  ],
  "USP9YP11": [
    "USP9YP11 CNV",
    "USP9YP11 RNA"
  ],
  "SCUBE3": [
    "SCUBE3 CNV",
    "SCUBE3 RNA"
  ],
  "RAB7A": [
    "RAB7A CNV",
    "RAB7A RNA",
    "RAB7A Proteo"
  ],
  "PITX2": [
    "PITX2 CNV",
    "PITX2 RNA"
  ],
  "ATP5F1AP3": [
    "ATP5F1AP3 CNV",
    "ATP5F1AP3 RNA"
  ],
  "ZNF557": [
    "ZNF557 CNV",
    "ZNF557 RNA",
    "ZNF557 Proteo"
  ],
  "OTOA": [
    "OTOA CNV",
    "OTOA RNA",
    "OTOA Proteo"
  ],
  "SP8": [
    "SP8 CNV",
    "SP8 RNA"
  ],
  "MNX1": [
    "MNX1 CNV",
    "MNX1 RNA",
    "MNX1 Proteo"
  ],
  "KRT17P5": [
    "KRT17P5 CNV",
    "KRT17P5 RNA"
  ],
  "RPL7P50": [
    "RPL7P50 CNV",
    "RPL7P50 RNA"
  ],
  "NUDT19P2": [
    "NUDT19P2 CNV",
    "NUDT19P2 RNA"
  ],
  "GOLPH3": [
    "GOLPH3 CNV",
    "GOLPH3 RNA",
    "GOLPH3 Proteo"
  ],
  "SLC9A5": [
    "SLC9A5 CNV",
    "SLC9A5 RNA"
  ],
  "MTND3P23": [
    "MTND3P23 CNV",
    "MTND3P23 RNA"
  ],
  "H3P16": [
    "H3P16 CNV",
    "H3P16 RNA"
  ],
  "SPIN2B": [
    "SPIN2B CNV",
    "SPIN2B RNA",
    "SPIN2B Proteo"
  ],
  "MTCO3P17": [
    "MTCO3P17 CNV",
    "MTCO3P17 RNA"
  ],
  "RNA5SP370": [
    "RNA5SP370 CNV",
    "RNA5SP370 RNA"
  ],
  "HMGN2P38": [
    "HMGN2P38 CNV",
    "HMGN2P38 RNA"
  ],
  "MTND6P33": [
    "MTND6P33 CNV",
    "MTND6P33 RNA"
  ],
  "ATXN10": [
    "ATXN10 CNV",
    "ATXN10 RNA",
    "ATXN10 Proteo"
  ],
  "PEAK3": [
    "PEAK3 CNV",
    "PEAK3 RNA",
    "PEAK3 Proteo"
  ],
  "ZNF285CP": [
    "ZNF285CP CNV",
    "ZNF285CP RNA"
  ],
  "IGLV3-9": [
    "IGLV3-9 Proteo"
  ],
  "CDH24": [
    "CDH24 CNV",
    "CDH24 RNA"
  ],
  "SDHA": [
    "SDHA CNV",
    "SDHA RNA",
    "SDHA Proteo"
  ],
  "ZMYM1": [
    "ZMYM1 CNV",
    "ZMYM1 RNA",
    "ZMYM1 Proteo"
  ],
  "GLIPR1": [
    "GLIPR1 CNV",
    "GLIPR1 RNA",
    "GLIPR1 Proteo"
  ],
  "RNF182": [
    "RNF182 CNV",
    "RNF182 RNA"
  ],
  "SMIM1": [
    "SMIM1 CNV",
    "SMIM1 RNA",
    "SMIM1 Proteo"
  ],
  "NOMO2": [
    "NOMO2 CNV",
    "NOMO2 RNA",
    "NOMO2 Proteo"
  ],
  "HMGB3P17": [
    "HMGB3P17 CNV",
    "HMGB3P17 RNA"
  ],
  "AMY2A": [
    "AMY2A CNV",
    "AMY2A RNA"
  ],
  "ANO1": [
    "ANO1 CNV",
    "ANO1 RNA",
    "ANO1 Proteo"
  ],
  "GIMAP1-GIMAP5": [
    "GIMAP1-GIMAP5 Proteo"
  ],
  "WDR87": [
    "WDR87 CNV",
    "WDR87 RNA"
  ],
  "AQP10": [
    "AQP10 CNV",
    "AQP10 RNA"
  ],
  "TUT7": [
    "TUT7 CNV",
    "TUT7 RNA",
    "TUT7 Proteo"
  ],
  "ZNF444": [
    "ZNF444 CNV",
    "ZNF444 RNA",
    "ZNF444 Proteo"
  ],
  "SH2B3": [
    "SH2B3 CNV",
    "SH2B3 RNA",
    "SH2B3 Proteo"
  ],
  "TSEN15P1": [
    "TSEN15P1 CNV",
    "TSEN15P1 RNA"
  ],
  "HSPA8P8": [
    "HSPA8P8 CNV",
    "HSPA8P8 RNA"
  ],
  "FBLIM1P2": [
    "FBLIM1P2 CNV",
    "FBLIM1P2 RNA"
  ],
  "ZC3H18": [
    "ZC3H18 CNV",
    "ZC3H18 RNA",
    "ZC3H18 Proteo"
  ],
  "USP17L27": [
    "USP17L27 CNV",
    "USP17L27 RNA"
  ],
  "C9orf72": [
    "C9orf72 CNV",
    "C9orf72 RNA",
    "C9orf72 Proteo"
  ],
  "ANKRD7": [
    "ANKRD7 CNV",
    "ANKRD7 RNA"
  ],
  "LGI1": [
    "LGI1 CNV",
    "LGI1 RNA"
  ],
  "CPNE2": [
    "CPNE2 CNV",
    "CPNE2 RNA",
    "CPNE2 Proteo"
  ],
  "BMP8A": [
    "BMP8A CNV",
    "BMP8A RNA",
    "BMP8A Proteo"
  ],
  "IGFBP5": [
    "IGFBP5 CNV",
    "IGFBP5 RNA",
    "IGFBP5 Proteo"
  ],
  "IARS2P1": [
    "IARS2P1 CNV",
    "IARS2P1 RNA"
  ],
  "SPRR2G": [
    "SPRR2G CNV",
    "SPRR2G RNA"
  ],
  "MPIG6B": [
    "MPIG6B CNV",
    "MPIG6B RNA",
    "MPIG6B Proteo"
  ],
  "STAMBP": [
    "STAMBP CNV",
    "STAMBP RNA",
    "STAMBP Proteo"
  ],
  "TARS2": [
    "TARS2 CNV",
    "TARS2 RNA",
    "TARS2 Proteo"
  ],
  "ADAL": [
    "ADAL CNV",
    "ADAL RNA",
    "ADAL Proteo"
  ],
  "MARK2P17": [
    "MARK2P17 CNV",
    "MARK2P17 RNA"
  ],
  "AP1G2": [
    "AP1G2 CNV",
    "AP1G2 RNA",
    "AP1G2 Proteo"
  ],
  "IGHV3OR16-13": [
    "IGHV3OR16-13 Proteo"
  ],
  "RIPK4": [
    "RIPK4 CNV",
    "RIPK4 RNA",
    "RIPK4 Proteo"
  ],
  "MAST4": [
    "MAST4 CNV",
    "MAST4 RNA",
    "MAST4 Proteo"
  ],
  "TXNL1": [
    "TXNL1 CNV",
    "TXNL1 RNA",
    "TXNL1 Proteo"
  ],
  "UVRAG": [
    "UVRAG CNV",
    "UVRAG RNA",
    "UVRAG Proteo"
  ],
  "NSRP1": [
    "NSRP1 CNV",
    "NSRP1 RNA",
    "NSRP1 Proteo"
  ],
  "ACER1": [
    "ACER1 CNV",
    "ACER1 RNA"
  ],
  "OR9I3P": [
    "OR9I3P CNV",
    "OR9I3P RNA"
  ],
  "MSRB1": [
    "MSRB1 CNV",
    "MSRB1 RNA"
  ],
  "MB21D2": [
    "MB21D2 CNV",
    "MB21D2 RNA",
    "MB21D2 Proteo"
  ],
  "ITPR1": [
    "ITPR1 CNV",
    "ITPR1 RNA",
    "ITPR1 Proteo"
  ],
  "RPL36AP28": [
    "RPL36AP28 CNV",
    "RPL36AP28 RNA"
  ],
  "KCNH8": [
    "KCNH8 CNV",
    "KCNH8 RNA"
  ],
  "RPL23AP27": [
    "RPL23AP27 CNV",
    "RPL23AP27 RNA"
  ],
  "MRPS15": [
    "MRPS15 CNV",
    "MRPS15 RNA",
    "MRPS15 Proteo"
  ],
  "GRM5P1": [
    "GRM5P1 CNV",
    "GRM5P1 RNA"
  ],
  "PRKAR1B": [
    "PRKAR1B CNV",
    "PRKAR1B RNA",
    "PRKAR1B Proteo"
  ],
  "KANK1P1": [
    "KANK1P1 CNV",
    "KANK1P1 RNA"
  ],
  "SPDYA": [
    "SPDYA CNV",
    "SPDYA RNA"
  ],
  "PRRT1": [
    "PRRT1 CNV",
    "PRRT1 RNA"
  ],
  "C3orf70": [
    "C3orf70 CNV",
    "C3orf70 RNA"
  ],
  "DGCR6": [
    "DGCR6 CNV",
    "DGCR6 RNA"
  ],
  "ALDOA": [
    "ALDOA CNV",
    "ALDOA RNA",
    "ALDOA Proteo"
  ],
  "GZMK": [
    "GZMK CNV",
    "GZMK RNA",
    "GZMK Proteo"
  ],
  "SLC40A1": [
    "SLC40A1 CNV",
    "SLC40A1 RNA",
    "SLC40A1 Proteo"
  ],
  "TVP23B": [
    "TVP23B CNV",
    "TVP23B RNA"
  ],
  "MYO9B": [
    "MYO9B CNV",
    "MYO9B RNA",
    "MYO9B Proteo"
  ],
  "ZNF571": [
    "ZNF571 CNV",
    "ZNF571 RNA"
  ],
  "RASSF10": [
    "RASSF10 CNV",
    "RASSF10 RNA"
  ],
  "AKAP17BP": [
    "AKAP17BP CNV",
    "AKAP17BP RNA"
  ],
  "C2orf15": [
    "C2orf15 CNV",
    "C2orf15 RNA"
  ],
  "KAZALD1": [
    "KAZALD1 CNV",
    "KAZALD1 RNA"
  ],
  "ACAD10": [
    "ACAD10 CNV",
    "ACAD10 RNA",
    "ACAD10 Proteo"
  ],
  "ARHGAP11B": [
    "ARHGAP11B CNV",
    "ARHGAP11B RNA"
  ],
  "TAF8": [
    "TAF8 CNV",
    "TAF8 RNA",
    "TAF8 Proteo"
  ],
  "IGHVII-28-1": [
    "IGHVII-28-1 CNV",
    "IGHVII-28-1 RNA"
  ],
  "MORC2": [
    "MORC2 CNV",
    "MORC2 RNA",
    "MORC2 Proteo"
  ],
  "CCDC87": [
    "CCDC87 CNV",
    "CCDC87 RNA"
  ],
  "FOXL3": [
    "FOXL3 CNV",
    "FOXL3 RNA"
  ],
  "NR2F1": [
    "NR2F1 CNV",
    "NR2F1 RNA",
    "NR2F1 Proteo"
  ],
  "EEF1A1P42": [
    "EEF1A1P42 CNV",
    "EEF1A1P42 RNA"
  ],
  "RGS21": [
    "RGS21 CNV",
    "RGS21 RNA"
  ],
  "GALR3": [
    "GALR3 CNV",
    "GALR3 RNA"
  ],
  "EHD4": [
    "EHD4 CNV",
    "EHD4 RNA",
    "EHD4 Proteo"
  ],
  "NOTCH1": [
    "NOTCH1 CNV",
    "NOTCH1 RNA",
    "NOTCH1 Proteo"
  ],
  "CFAP69": [
    "CFAP69 CNV",
    "CFAP69 RNA"
  ],
  "ASPHD2": [
    "ASPHD2 CNV",
    "ASPHD2 RNA",
    "ASPHD2 Proteo"
  ],
  "ARHGAP42P5": [
    "ARHGAP42P5 CNV",
    "ARHGAP42P5 RNA"
  ],
  "CPNE6": [
    "CPNE6 CNV",
    "CPNE6 RNA"
  ],
  "SLC14A2": [
    "SLC14A2 CNV",
    "SLC14A2 RNA"
  ],
  "VPS41": [
    "VPS41 CNV",
    "VPS41 RNA",
    "VPS41 Proteo"
  ],
  "EPOP": [
    "EPOP CNV",
    "EPOP RNA"
  ],
  "N4BP2L1": [
    "N4BP2L1 CNV",
    "N4BP2L1 RNA",
    "N4BP2L1 Proteo"
  ],
  "PRKAG2": [
    "PRKAG2 CNV",
    "PRKAG2 RNA",
    "PRKAG2 Proteo"
  ],
  "TMEM120A": [
    "TMEM120A CNV",
    "TMEM120A RNA",
    "TMEM120A Proteo"
  ],
  "IGLV3-13": [
    "IGLV3-13 CNV",
    "IGLV3-13 RNA"
  ],
  "ME2P1": [
    "ME2P1 CNV",
    "ME2P1 RNA"
  ],
  "TTI2": [
    "TTI2 CNV",
    "TTI2 RNA",
    "TTI2 Proteo"
  ],
  "FAM193B": [
    "FAM193B CNV",
    "FAM193B RNA",
    "FAM193B Proteo"
  ],
  "RPL28": [
    "RPL28 CNV",
    "RPL28 RNA",
    "RPL28 Proteo"
  ],
  "SPHK2": [
    "SPHK2 CNV",
    "SPHK2 RNA",
    "SPHK2 Proteo"
  ],
  "ZMIZ2": [
    "ZMIZ2 CNV",
    "ZMIZ2 RNA",
    "ZMIZ2 Proteo"
  ],
  "TAS2R38": [
    "TAS2R38 CNV",
    "TAS2R38 RNA"
  ],
  "OR2J3": [
    "OR2J3 CNV",
    "OR2J3 RNA"
  ],
  "MARCHF6": [
    "MARCHF6 CNV",
    "MARCHF6 RNA",
    "MARCHF6 Proteo"
  ],
  "LRRC39": [
    "LRRC39 CNV",
    "LRRC39 RNA"
  ],
  "NDUFB4P8": [
    "NDUFB4P8 CNV",
    "NDUFB4P8 RNA"
  ],
  "CTXN3": [
    "CTXN3 CNV",
    "CTXN3 RNA"
  ],
  "NPIPA3": [
    "NPIPA3 CNV",
    "NPIPA3 RNA"
  ],
  "HMGN2P47": [
    "HMGN2P47 CNV",
    "HMGN2P47 RNA"
  ],
  "COX4I1P2": [
    "COX4I1P2 CNV",
    "COX4I1P2 RNA"
  ],
  "CSRNP1": [
    "CSRNP1 CNV",
    "CSRNP1 RNA"
  ],
  "NOP2": [
    "NOP2 CNV",
    "NOP2 RNA",
    "NOP2 Proteo"
  ],
  "ARHGEF25": [
    "ARHGEF25 CNV",
    "ARHGEF25 RNA"
  ],
  "TRAC": [
    "TRAC Proteo"
  ],
  "GRWD1": [
    "GRWD1 CNV",
    "GRWD1 RNA",
    "GRWD1 Proteo"
  ],
  "CDK19": [
    "CDK19 CNV",
    "CDK19 RNA",
    "CDK19 Proteo"
  ],
  "PDSS1P2": [
    "PDSS1P2 CNV",
    "PDSS1P2 RNA"
  ],
  "IGSF1": [
    "IGSF1 CNV",
    "IGSF1 RNA"
  ],
  "CNN3": [
    "CNN3 CNV",
    "CNN3 RNA",
    "CNN3 Proteo"
  ],
  "BZW1P1": [
    "BZW1P1 CNV",
    "BZW1P1 RNA"
  ],
  "SOSTDC1": [
    "SOSTDC1 CNV",
    "SOSTDC1 RNA",
    "SOSTDC1 Proteo"
  ],
  "LRRC37A": [
    "LRRC37A CNV",
    "LRRC37A RNA"
  ],
  "CEP170B": [
    "CEP170B CNV",
    "CEP170B RNA",
    "CEP170B Proteo"
  ],
  "GLRX5P2": [
    "GLRX5P2 CNV",
    "GLRX5P2 RNA"
  ],
  "RPL27P8": [
    "RPL27P8 CNV",
    "RPL27P8 RNA"
  ],
  "RPL36AP44": [
    "RPL36AP44 CNV",
    "RPL36AP44 RNA"
  ],
  "VN1R85P": [
    "VN1R85P CNV",
    "VN1R85P RNA"
  ],
  "CARNMT1": [
    "CARNMT1 CNV",
    "CARNMT1 RNA",
    "CARNMT1 Proteo"
  ],
  "CCL19": [
    "CCL19 CNV",
    "CCL19 RNA"
  ],
  "FAM187B2P": [
    "FAM187B2P CNV",
    "FAM187B2P RNA"
  ],
  "FYCO1": [
    "FYCO1 CNV",
    "FYCO1 RNA",
    "FYCO1 Proteo"
  ],
  "PEX11A": [
    "PEX11A CNV",
    "PEX11A RNA",
    "PEX11A Proteo"
  ],
  "ZNF771": [
    "ZNF771 CNV",
    "ZNF771 RNA",
    "ZNF771 Proteo"
  ],
  "TRPC7": [
    "TRPC7 CNV",
    "TRPC7 RNA"
  ],
  "API5": [
    "API5 CNV",
    "API5 RNA",
    "API5 Proteo"
  ],
  "ADORA3": [
    "ADORA3 CNV",
    "ADORA3 RNA"
  ],
  "CXCR3": [
    "CXCR3 CNV",
    "CXCR3 RNA"
  ],
  "PLEKHJ1": [
    "PLEKHJ1 CNV",
    "PLEKHJ1 RNA",
    "PLEKHJ1 Proteo"
  ],
  "CLCA4": [
    "CLCA4 CNV",
    "CLCA4 RNA",
    "CLCA4 Proteo"
  ],
  "TSNARE1": [
    "TSNARE1 CNV",
    "TSNARE1 RNA",
    "TSNARE1 Proteo"
  ],
  "ATP5MK": [
    "ATP5MK CNV",
    "ATP5MK RNA",
    "ATP5MK Proteo"
  ],
  "SIX4": [
    "SIX4 CNV",
    "SIX4 RNA",
    "SIX4 Proteo"
  ],
  "PCDHB9": [
    "PCDHB9 CNV",
    "PCDHB9 RNA"
  ],
  "SERPINB11": [
    "SERPINB11 CNV",
    "SERPINB11 RNA",
    "SERPINB11 Proteo"
  ],
  "RHBDD1": [
    "RHBDD1 CNV",
    "RHBDD1 RNA",
    "RHBDD1 Proteo"
  ],
  "GTF2H1": [
    "GTF2H1 CNV",
    "GTF2H1 RNA",
    "GTF2H1 Proteo"
  ],
  "NDST1": [
    "NDST1 CNV",
    "NDST1 RNA",
    "NDST1 Proteo"
  ],
  "FUNDC2": [
    "FUNDC2 CNV",
    "FUNDC2 RNA",
    "FUNDC2 Proteo"
  ],
  "IMP4": [
    "IMP4 CNV",
    "IMP4 RNA",
    "IMP4 Proteo"
  ],
  "TUBB4BP6": [
    "TUBB4BP6 CNV",
    "TUBB4BP6 RNA"
  ],
  "TBC1D3D": [
    "TBC1D3D CNV",
    "TBC1D3D RNA"
  ],
  "KCNG1": [
    "KCNG1 CNV",
    "KCNG1 RNA"
  ],
  "LRRC37A3": [
    "LRRC37A3 CNV",
    "LRRC37A3 RNA"
  ],
  "INTU": [
    "INTU CNV",
    "INTU RNA",
    "INTU Proteo"
  ],
  "TRIM36": [
    "TRIM36 CNV",
    "TRIM36 RNA",
    "TRIM36 Proteo"
  ],
  "CD1A": [
    "CD1A CNV",
    "CD1A RNA"
  ],
  "CCL15": [
    "CCL15 CNV",
    "CCL15 RNA"
  ],
  "TSPY17P": [
    "TSPY17P CNV",
    "TSPY17P RNA"
  ],
  "CRY1": [
    "CRY1 CNV",
    "CRY1 RNA",
    "CRY1 Proteo"
  ],
  "NIPAL2": [
    "NIPAL2 CNV",
    "NIPAL2 RNA",
    "NIPAL2 Proteo"
  ],
  "UTS2B": [
    "UTS2B CNV",
    "UTS2B RNA"
  ],
  "KNOP1": [
    "KNOP1 CNV",
    "KNOP1 RNA",
    "KNOP1 Proteo"
  ],
  "SLC49A4": [
    "SLC49A4 CNV",
    "SLC49A4 RNA",
    "SLC49A4 Proteo"
  ],
  "PRKCIP1": [
    "PRKCIP1 CNV",
    "PRKCIP1 RNA"
  ],
  "RAB22A": [
    "RAB22A CNV",
    "RAB22A RNA",
    "RAB22A Proteo"
  ],
  "HAUS7": [
    "HAUS7 CNV",
    "HAUS7 RNA",
    "HAUS7 Proteo"
  ],
  "EEF1GP1": [
    "EEF1GP1 CNV",
    "EEF1GP1 RNA"
  ],
  "SLC9C1": [
    "SLC9C1 CNV",
    "SLC9C1 RNA"
  ],
  "AGAP6": [
    "AGAP6 CNV",
    "AGAP6 RNA"
  ],
  "NOXO1": [
    "NOXO1 CNV",
    "NOXO1 RNA",
    "NOXO1 Proteo"
  ],
  "AKIP1": [
    "AKIP1 CNV",
    "AKIP1 RNA"
  ],
  "OR8K5": [
    "OR8K5 CNV",
    "OR8K5 RNA"
  ],
  "OR52H1": [
    "OR52H1 CNV",
    "OR52H1 RNA"
  ],
  "CASKIN2": [
    "CASKIN2 CNV",
    "CASKIN2 RNA",
    "CASKIN2 Proteo"
  ],
  "UBE2W": [
    "UBE2W CNV",
    "UBE2W RNA"
  ],
  "MTND5P8": [
    "MTND5P8 CNV",
    "MTND5P8 RNA"
  ],
  "RPL31P44": [
    "RPL31P44 CNV",
    "RPL31P44 RNA"
  ],
  "TEX28": [
    "TEX28 CNV",
    "TEX28 RNA"
  ],
  "DDX6P2": [
    "DDX6P2 CNV",
    "DDX6P2 RNA"
  ],
  "VN1R17P": [
    "VN1R17P CNV",
    "VN1R17P RNA"
  ],
  "PCNPP2": [
    "PCNPP2 CNV",
    "PCNPP2 RNA"
  ],
  "AP1AR": [
    "AP1AR CNV",
    "AP1AR RNA",
    "AP1AR Proteo"
  ],
  "MAPK8IP3": [
    "MAPK8IP3 CNV",
    "MAPK8IP3 RNA",
    "MAPK8IP3 Proteo"
  ],
  "CKS2": [
    "CKS2 CNV",
    "CKS2 RNA",
    "CKS2 Proteo"
  ],
  "RNA5SP414": [
    "RNA5SP414 CNV",
    "RNA5SP414 RNA"
  ],
  "RRAS2P1": [
    "RRAS2P1 CNV",
    "RRAS2P1 RNA"
  ],
  "MPST": [
    "MPST CNV",
    "MPST RNA",
    "MPST Proteo"
  ],
  "CYP4A27P": [
    "CYP4A27P CNV",
    "CYP4A27P RNA"
  ],
  "RAET1M": [
    "RAET1M CNV",
    "RAET1M RNA"
  ],
  "DPRX": [
    "DPRX CNV",
    "DPRX RNA"
  ],
  "FGF5": [
    "FGF5 CNV",
    "FGF5 RNA"
  ],
  "PPP1R3B": [
    "PPP1R3B CNV",
    "PPP1R3B RNA"
  ],
  "GOSR1": [
    "GOSR1 CNV",
    "GOSR1 RNA",
    "GOSR1 Proteo"
  ],
  "RNA5SP50": [
    "RNA5SP50 CNV",
    "RNA5SP50 RNA"
  ],
  "CGNL1": [
    "CGNL1 CNV",
    "CGNL1 RNA",
    "CGNL1 Proteo"
  ],
  "GPM6B": [
    "GPM6B CNV",
    "GPM6B RNA",
    "GPM6B Proteo"
  ],
  "CBX5": [
    "CBX5 CNV",
    "CBX5 RNA",
    "CBX5 Proteo"
  ],
  "PUDPP2": [
    "PUDPP2 CNV",
    "PUDPP2 RNA"
  ],
  "KRTCAP2P1": [
    "KRTCAP2P1 CNV",
    "KRTCAP2P1 RNA"
  ],
  "CCT7P2": [
    "CCT7P2 CNV",
    "CCT7P2 RNA"
  ],
  "RABL3": [
    "RABL3 CNV",
    "RABL3 RNA",
    "RABL3 Proteo"
  ],
  "GM2AP2": [
    "GM2AP2 CNV",
    "GM2AP2 RNA"
  ],
  "FABP4": [
    "FABP4 CNV",
    "FABP4 RNA",
    "FABP4 Proteo"
  ],
  "GAPDHP44": [
    "GAPDHP44 CNV",
    "GAPDHP44 RNA"
  ],
  "TDRD12": [
    "TDRD12 CNV",
    "TDRD12 RNA"
  ],
  "ZNF812P": [
    "ZNF812P CNV",
    "ZNF812P RNA"
  ],
  "RNA5SP23": [
    "RNA5SP23 CNV",
    "RNA5SP23 RNA"
  ],
  "SNAPC3": [
    "SNAPC3 CNV",
    "SNAPC3 RNA",
    "SNAPC3 Proteo"
  ],
  "PGAM5P1": [
    "PGAM5P1 CNV",
    "PGAM5P1 RNA"
  ],
  "MTCO2P30": [
    "MTCO2P30 CNV",
    "MTCO2P30 RNA"
  ],
  "SLC4A1AP": [
    "SLC4A1AP CNV",
    "SLC4A1AP RNA",
    "SLC4A1AP Proteo"
  ],
  "RPL35AP29": [
    "RPL35AP29 CNV",
    "RPL35AP29 RNA"
  ],
  "TOMM6": [
    "TOMM6 CNV",
    "TOMM6 RNA",
    "TOMM6 Proteo"
  ],
  "CEACAM5": [
    "CEACAM5 CNV",
    "CEACAM5 RNA"
  ],
  "PRDX3P3": [
    "PRDX3P3 CNV",
    "PRDX3P3 RNA"
  ],
  "KIF1C": [
    "KIF1C CNV",
    "KIF1C RNA",
    "KIF1C Proteo"
  ],
  "TRAPPC12": [
    "TRAPPC12 CNV",
    "TRAPPC12 RNA",
    "TRAPPC12 Proteo"
  ],
  "PGAM4P1": [
    "PGAM4P1 CNV",
    "PGAM4P1 RNA"
  ],
  "ADAMDEC1": [
    "ADAMDEC1 CNV",
    "ADAMDEC1 RNA"
  ],
  "PPP1R1AP1": [
    "PPP1R1AP1 CNV",
    "PPP1R1AP1 RNA"
  ],
  "CLDN17": [
    "CLDN17 CNV",
    "CLDN17 RNA"
  ],
  "TIAM2": [
    "TIAM2 CNV",
    "TIAM2 RNA",
    "TIAM2 Proteo"
  ],
  "GPAT2": [
    "GPAT2 CNV",
    "GPAT2 RNA"
  ],
  "ARL1": [
    "ARL1 CNV",
    "ARL1 RNA",
    "ARL1 Proteo"
  ],
  "TRPV2": [
    "TRPV2 CNV",
    "TRPV2 RNA",
    "TRPV2 Proteo"
  ],
  "USP17L8": [
    "USP17L8 CNV",
    "USP17L8 RNA"
  ],
  "WDR45BP1": [
    "WDR45BP1 CNV",
    "WDR45BP1 RNA"
  ],
  "PRKCSH": [
    "PRKCSH CNV",
    "PRKCSH RNA",
    "PRKCSH Proteo"
  ],
  "PMS1": [
    "PMS1 CNV",
    "PMS1 RNA",
    "PMS1 Proteo"
  ],
  "TCF21": [
    "TCF21 CNV",
    "TCF21 RNA"
  ],
  "CACNA1H": [
    "CACNA1H CNV",
    "CACNA1H RNA"
  ],
  "TBC1D12": [
    "TBC1D12 CNV",
    "TBC1D12 RNA",
    "TBC1D12 Proteo"
  ],
  "PTP4A1P2": [
    "PTP4A1P2 CNV",
    "PTP4A1P2 RNA"
  ],
  "ASTN2": [
    "ASTN2 CNV",
    "ASTN2 RNA",
    "ASTN2 Proteo"
  ],
  "MRPS5P4": [
    "MRPS5P4 CNV",
    "MRPS5P4 RNA"
  ],
  "MRPS9": [
    "MRPS9 CNV",
    "MRPS9 RNA",
    "MRPS9 Proteo"
  ],
  "TMEM147": [
    "TMEM147 CNV",
    "TMEM147 RNA",
    "TMEM147 Proteo"
  ],
  "RPL21P3": [
    "RPL21P3 CNV",
    "RPL21P3 RNA"
  ],
  "DHX29": [
    "DHX29 CNV",
    "DHX29 RNA",
    "DHX29 Proteo"
  ],
  "RTL10": [
    "RTL10 CNV",
    "RTL10 RNA"
  ],
  "MTSS2": [
    "MTSS2 CNV",
    "MTSS2 RNA",
    "MTSS2 Proteo"
  ],
  "ELOCP3": [
    "ELOCP3 CNV",
    "ELOCP3 RNA"
  ],
  "RPSAP8": [
    "RPSAP8 CNV",
    "RPSAP8 RNA"
  ],
  "EMP2": [
    "EMP2 CNV",
    "EMP2 RNA"
  ],
  "GSAP": [
    "GSAP CNV",
    "GSAP RNA",
    "GSAP Proteo"
  ],
  "ZC3HAV1": [
    "ZC3HAV1 CNV",
    "ZC3HAV1 RNA",
    "ZC3HAV1 Proteo"
  ],
  "ZBED9": [
    "ZBED9 CNV",
    "ZBED9 RNA"
  ],
  "ZNF616": [
    "ZNF616 CNV",
    "ZNF616 RNA",
    "ZNF616 Proteo"
  ],
  "CRBN": [
    "CRBN CNV",
    "CRBN RNA",
    "CRBN Proteo"
  ],
  "SLC66A1L": [
    "SLC66A1L CNV",
    "SLC66A1L RNA"
  ],
  "PCDHA13": [
    "PCDHA13 CNV",
    "PCDHA13 RNA"
  ],
  "PPIAP76": [
    "PPIAP76 CNV",
    "PPIAP76 RNA"
  ],
  "ZNF417": [
    "ZNF417 CNV",
    "ZNF417 RNA",
    "ZNF417 Proteo"
  ],
  "RPL21P13": [
    "RPL21P13 CNV",
    "RPL21P13 RNA"
  ],
  "EMBP1": [
    "EMBP1 CNV",
    "EMBP1 RNA"
  ],
  "QARS1": [
    "QARS1 CNV",
    "QARS1 RNA",
    "QARS1 Proteo"
  ],
  "TPPP3": [
    "TPPP3 CNV",
    "TPPP3 RNA",
    "TPPP3 Proteo"
  ],
  "VTI1BP3": [
    "VTI1BP3 CNV",
    "VTI1BP3 RNA"
  ],
  "TNFAIP6": [
    "TNFAIP6 CNV",
    "TNFAIP6 RNA",
    "TNFAIP6 Proteo"
  ],
  "IGHV4-80": [
    "IGHV4-80 CNV",
    "IGHV4-80 RNA"
  ],
  "CST6": [
    "CST6 CNV",
    "CST6 RNA",
    "CST6 Proteo"
  ],
  "USP24P1": [
    "USP24P1 CNV",
    "USP24P1 RNA"
  ],
  "DNMBP": [
    "DNMBP CNV",
    "DNMBP RNA",
    "DNMBP Proteo"
  ],
  "STARD8": [
    "STARD8 CNV",
    "STARD8 RNA",
    "STARD8 Proteo"
  ],
  "KRT18P41": [
    "KRT18P41 CNV",
    "KRT18P41 RNA"
  ],
  "SUB1P4": [
    "SUB1P4 CNV",
    "SUB1P4 RNA"
  ],
  "MCPH1": [
    "MCPH1 CNV",
    "MCPH1 RNA"
  ],
  "PARP10": [
    "PARP10 CNV",
    "PARP10 RNA",
    "PARP10 Proteo"
  ],
  "HAAO": [
    "HAAO CNV",
    "HAAO RNA",
    "HAAO Proteo"
  ],
  "MSL1": [
    "MSL1 CNV",
    "MSL1 RNA",
    "MSL1 Proteo"
  ],
  "NHSL1": [
    "NHSL1 CNV",
    "NHSL1 RNA",
    "NHSL1 Proteo"
  ],
  "MED15P8": [
    "MED15P8 CNV",
    "MED15P8 RNA"
  ],
  "AFM": [
    "AFM CNV",
    "AFM RNA",
    "AFM Proteo"
  ],
  "TECRP2": [
    "TECRP2 CNV",
    "TECRP2 RNA"
  ],
  "APOC3": [
    "APOC3 CNV",
    "APOC3 RNA",
    "APOC3 Proteo"
  ],
  "ACSM2A": [
    "ACSM2A CNV",
    "ACSM2A RNA"
  ],
  "SLC25A51P2": [
    "SLC25A51P2 CNV",
    "SLC25A51P2 RNA"
  ],
  "TFE3": [
    "TFE3 CNV",
    "TFE3 RNA",
    "TFE3 Proteo"
  ],
  "PCBD2": [
    "PCBD2 CNV",
    "PCBD2 RNA",
    "PCBD2 Proteo"
  ],
  "LMX1B": [
    "LMX1B CNV",
    "LMX1B RNA"
  ],
  "RNA5SP500": [
    "RNA5SP500 CNV",
    "RNA5SP500 RNA"
  ],
  "ASCL2": [
    "ASCL2 CNV",
    "ASCL2 RNA"
  ],
  "PTBP3": [
    "PTBP3 CNV",
    "PTBP3 RNA",
    "PTBP3 Proteo"
  ],
  "TAPBP": [
    "TAPBP CNV",
    "TAPBP RNA",
    "TAPBP Proteo"
  ],
  "RPL21P40": [
    "RPL21P40 CNV",
    "RPL21P40 RNA"
  ],
  "HES5": [
    "HES5 CNV",
    "HES5 RNA"
  ],
  "SWI5": [
    "SWI5 CNV",
    "SWI5 RNA"
  ],
  "LTF": [
    "LTF CNV",
    "LTF RNA",
    "LTF Proteo"
  ],
  "ZNF124": [
    "ZNF124 CNV",
    "ZNF124 RNA"
  ],
  "HOXD1": [
    "HOXD1 CNV",
    "HOXD1 RNA"
  ],
  "ZNF767P": [
    "ZNF767P CNV",
    "ZNF767P RNA"
  ],
  "STOX2": [
    "STOX2 CNV",
    "STOX2 RNA"
  ],
  "TMEM120B": [
    "TMEM120B CNV",
    "TMEM120B RNA",
    "TMEM120B Proteo"
  ],
  "PPP1R1A": [
    "PPP1R1A CNV",
    "PPP1R1A RNA",
    "PPP1R1A Proteo"
  ],
  "RNA5SP347": [
    "RNA5SP347 CNV",
    "RNA5SP347 RNA"
  ],
  "CD27": [
    "CD27 CNV",
    "CD27 RNA"
  ],
  "ARF4": [
    "ARF4 CNV",
    "ARF4 RNA",
    "ARF4 Proteo"
  ],
  "CNPY2": [
    "CNPY2 CNV",
    "CNPY2 RNA",
    "CNPY2 Proteo"
  ],
  "C5": [
    "C5 CNV",
    "C5 RNA",
    "C5 Proteo"
  ],
  "RPS3AP33": [
    "RPS3AP33 CNV",
    "RPS3AP33 RNA"
  ],
  "ITGB4": [
    "ITGB4 CNV",
    "ITGB4 RNA",
    "ITGB4 Proteo"
  ],
  "CFAP77": [
    "CFAP77 CNV",
    "CFAP77 RNA"
  ],
  "ZNF778": [
    "ZNF778 CNV",
    "ZNF778 RNA"
  ],
  "HSPA2": [
    "HSPA2 CNV",
    "HSPA2 RNA",
    "HSPA2 Proteo"
  ],
  "SDR9C7": [
    "SDR9C7 CNV",
    "SDR9C7 RNA",
    "SDR9C7 Proteo"
  ],
  "ACAN": [
    "ACAN CNV",
    "ACAN RNA",
    "ACAN Proteo"
  ],
  "KRT18P36": [
    "KRT18P36 CNV",
    "KRT18P36 RNA"
  ],
  "COPS3": [
    "COPS3 CNV",
    "COPS3 RNA",
    "COPS3 Proteo"
  ],
  "DDX59": [
    "DDX59 CNV",
    "DDX59 RNA",
    "DDX59 Proteo"
  ],
  "ZNF337": [
    "ZNF337 CNV",
    "ZNF337 RNA",
    "ZNF337 Proteo"
  ],
  "BUB3P1": [
    "BUB3P1 CNV",
    "BUB3P1 RNA"
  ],
  "EIF4BP7": [
    "EIF4BP7 CNV",
    "EIF4BP7 RNA"
  ],
  "TIGD6": [
    "TIGD6 CNV",
    "TIGD6 RNA"
  ],
  "BCL2L12": [
    "BCL2L12 CNV",
    "BCL2L12 RNA",
    "BCL2L12 Proteo"
  ],
  "HMGN2P23": [
    "HMGN2P23 CNV",
    "HMGN2P23 RNA"
  ],
  "IGHV1OR15-6": [
    "IGHV1OR15-6 CNV",
    "IGHV1OR15-6 RNA"
  ],
  "LY6G6E": [
    "LY6G6E CNV",
    "LY6G6E RNA"
  ],
  "OR13C2": [
    "OR13C2 CNV",
    "OR13C2 RNA"
  ],
  "MAPKAPK5P1": [
    "MAPKAPK5P1 CNV",
    "MAPKAPK5P1 RNA"
  ],
  "ETV7": [
    "ETV7 CNV",
    "ETV7 RNA"
  ],
  "FLT1P1": [
    "FLT1P1 CNV",
    "FLT1P1 RNA"
  ],
  "CTHRC1P1": [
    "CTHRC1P1 CNV",
    "CTHRC1P1 RNA"
  ],
  "ZNF227": [
    "ZNF227 CNV",
    "ZNF227 RNA",
    "ZNF227 Proteo"
  ],
  "DHX40P1": [
    "DHX40P1 CNV",
    "DHX40P1 RNA"
  ],
  "LSM12": [
    "LSM12 CNV",
    "LSM12 RNA",
    "LSM12 Proteo"
  ],
  "HMGN2P7": [
    "HMGN2P7 CNV",
    "HMGN2P7 RNA"
  ],
  "TNNT3": [
    "TNNT3 CNV",
    "TNNT3 RNA",
    "TNNT3 Proteo"
  ],
  "RPLP1P5": [
    "RPLP1P5 CNV",
    "RPLP1P5 RNA"
  ],
  "B3GNTL1P2": [
    "B3GNTL1P2 CNV",
    "B3GNTL1P2 RNA"
  ],
  "OR1S1": [
    "OR1S1 CNV",
    "OR1S1 RNA"
  ],
  "GRIK4": [
    "GRIK4 CNV",
    "GRIK4 RNA"
  ],
  "GAPDHP64": [
    "GAPDHP64 CNV",
    "GAPDHP64 RNA"
  ],
  "INSC": [
    "INSC CNV",
    "INSC RNA",
    "INSC Proteo"
  ],
  "POP5": [
    "POP5 CNV",
    "POP5 RNA",
    "POP5 Proteo"
  ],
  "EEF1A1P15": [
    "EEF1A1P15 CNV",
    "EEF1A1P15 RNA"
  ],
  "MTTP": [
    "MTTP CNV",
    "MTTP RNA",
    "MTTP Proteo"
  ],
  "RPL12P37": [
    "RPL12P37 CNV",
    "RPL12P37 RNA"
  ],
  "TESMIN": [
    "TESMIN CNV",
    "TESMIN RNA"
  ],
  "INTS4": [
    "INTS4 CNV",
    "INTS4 RNA",
    "INTS4 Proteo"
  ],
  "MUC1": [
    "MUC1 CNV",
    "MUC1 RNA",
    "MUC1 Proteo"
  ],
  "TARS2P1": [
    "TARS2P1 CNV",
    "TARS2P1 RNA"
  ],
  "GPM6BP3": [
    "GPM6BP3 CNV",
    "GPM6BP3 RNA"
  ],
  "RPL32P34": [
    "RPL32P34 CNV",
    "RPL32P34 RNA"
  ],
  "RBM28": [
    "RBM28 CNV",
    "RBM28 RNA",
    "RBM28 Proteo"
  ],
  "AVPR1A": [
    "AVPR1A CNV",
    "AVPR1A RNA"
  ],
  "GLT6D1": [
    "GLT6D1 CNV",
    "GLT6D1 RNA"
  ],
  "PRR15": [
    "PRR15 CNV",
    "PRR15 RNA"
  ],
  "IFITM3P5": [
    "IFITM3P5 CNV",
    "IFITM3P5 RNA"
  ],
  "RPSAP35": [
    "RPSAP35 CNV",
    "RPSAP35 RNA"
  ],
  "TNS1": [
    "TNS1 CNV",
    "TNS1 RNA",
    "TNS1 Proteo"
  ],
  "RXFP4": [
    "RXFP4 CNV",
    "RXFP4 RNA"
  ],
  "TUBBP2": [
    "TUBBP2 CNV",
    "TUBBP2 RNA"
  ],
  "DTD1": [
    "DTD1 CNV",
    "DTD1 RNA",
    "DTD1 Proteo"
  ],
  "MTCO1P8": [
    "MTCO1P8 CNV",
    "MTCO1P8 RNA"
  ],
  "GABRG3": [
    "GABRG3 CNV",
    "GABRG3 RNA"
  ],
  "CEACAMP1": [
    "CEACAMP1 CNV",
    "CEACAMP1 RNA"
  ],
  "C1QBP": [
    "C1QBP CNV",
    "C1QBP RNA",
    "C1QBP Proteo"
  ],
  "GALNT11": [
    "GALNT11 CNV",
    "GALNT11 RNA",
    "GALNT11 Proteo"
  ],
  "ZNF725P": [
    "ZNF725P CNV",
    "ZNF725P RNA"
  ],
  "FNDC3A": [
    "FNDC3A CNV",
    "FNDC3A RNA",
    "FNDC3A Proteo"
  ],
  "TGIF1P1": [
    "TGIF1P1 CNV",
    "TGIF1P1 RNA"
  ],
  "HS6ST1": [
    "HS6ST1 CNV",
    "HS6ST1 RNA",
    "HS6ST1 Proteo"
  ],
  "CA5B": [
    "CA5B CNV",
    "CA5B RNA",
    "CA5B Proteo"
  ],
  "ABTB1": [
    "ABTB1 CNV",
    "ABTB1 RNA",
    "ABTB1 Proteo"
  ],
  "TMEM79": [
    "TMEM79 CNV",
    "TMEM79 RNA"
  ],
  "TRIM60P10Y": [
    "TRIM60P10Y CNV",
    "TRIM60P10Y RNA"
  ],
  "CDRT15P14": [
    "CDRT15P14 CNV",
    "CDRT15P14 RNA"
  ],
  "MRPL57P8": [
    "MRPL57P8 CNV",
    "MRPL57P8 RNA"
  ],
  "SDE2": [
    "SDE2 CNV",
    "SDE2 RNA",
    "SDE2 Proteo"
  ],
  "PCBP4": [
    "PCBP4 CNV",
    "PCBP4 RNA",
    "PCBP4 Proteo"
  ],
  "TEKT4P3": [
    "TEKT4P3 CNV",
    "TEKT4P3 RNA"
  ],
  "FAM131C2P": [
    "FAM131C2P CNV",
    "FAM131C2P RNA"
  ],
  "DNAJB3": [
    "DNAJB3 CNV",
    "DNAJB3 RNA"
  ],
  "RPL21P35": [
    "RPL21P35 CNV",
    "RPL21P35 RNA"
  ],
  "RPL7L1P13": [
    "RPL7L1P13 CNV",
    "RPL7L1P13 RNA"
  ],
  "RPL7P57": [
    "RPL7P57 CNV",
    "RPL7P57 RNA"
  ],
  "CYP2U1": [
    "CYP2U1 CNV",
    "CYP2U1 RNA",
    "CYP2U1 Proteo"
  ],
  "DAZL": [
    "DAZL CNV",
    "DAZL RNA"
  ],
  "ACTG1P24": [
    "ACTG1P24 CNV",
    "ACTG1P24 RNA"
  ],
  "ZNF775": [
    "ZNF775 CNV",
    "ZNF775 RNA"
  ],
  "SCYL2": [
    "SCYL2 CNV",
    "SCYL2 RNA",
    "SCYL2 Proteo"
  ],
  "SNRPCP15": [
    "SNRPCP15 CNV",
    "SNRPCP15 RNA"
  ],
  "HERC2P7": [
    "HERC2P7 CNV",
    "HERC2P7 RNA"
  ],
  "TSPY16P": [
    "TSPY16P CNV",
    "TSPY16P RNA"
  ],
  "VENTXP5": [
    "VENTXP5 CNV",
    "VENTXP5 RNA"
  ],
  "HCRTR1": [
    "HCRTR1 CNV",
    "HCRTR1 RNA"
  ],
  "BCLAF3": [
    "BCLAF3 CNV",
    "BCLAF3 RNA",
    "BCLAF3 Proteo"
  ],
  "C1QTNF4": [
    "C1QTNF4 CNV",
    "C1QTNF4 RNA"
  ],
  "PPIAP35": [
    "PPIAP35 CNV",
    "PPIAP35 RNA"
  ],
  "COL4A3": [
    "COL4A3 CNV",
    "COL4A3 RNA"
  ],
  "IGLV3-25": [
    "IGLV3-25 Proteo"
  ],
  "PHF20L1": [
    "PHF20L1 CNV",
    "PHF20L1 RNA",
    "PHF20L1 Proteo"
  ],
  "NME7": [
    "NME7 CNV",
    "NME7 RNA",
    "NME7 Proteo"
  ],
  "BSPH1": [
    "BSPH1 CNV",
    "BSPH1 RNA"
  ],
  "RNA5SP262": [
    "RNA5SP262 CNV",
    "RNA5SP262 RNA"
  ],
  "RBM22P13": [
    "RBM22P13 CNV",
    "RBM22P13 RNA"
  ],
  "CCDC30": [
    "CCDC30 CNV",
    "CCDC30 RNA"
  ],
  "TRIM49D1": [
    "TRIM49D1 CNV",
    "TRIM49D1 RNA"
  ],
  "UBIAD1": [
    "UBIAD1 CNV",
    "UBIAD1 RNA",
    "UBIAD1 Proteo"
  ],
  "CDK8": [
    "CDK8 CNV",
    "CDK8 RNA",
    "CDK8 Proteo"
  ],
  "TRIM33": [
    "TRIM33 CNV",
    "TRIM33 RNA",
    "TRIM33 Proteo"
  ],
  "PBLD": [
    "PBLD CNV",
    "PBLD RNA",
    "PBLD Proteo"
  ],
  "EGR2": [
    "EGR2 CNV",
    "EGR2 RNA",
    "EGR2 Proteo"
  ],
  "OR5B17": [
    "OR5B17 CNV",
    "OR5B17 RNA"
  ],
  "FCGR1A": [
    "FCGR1A CNV",
    "FCGR1A RNA",
    "FCGR1A Proteo"
  ],
  "OR51I2": [
    "OR51I2 CNV",
    "OR51I2 RNA"
  ],
  "FOXH1": [
    "FOXH1 CNV",
    "FOXH1 RNA"
  ],
  "GARIN1A": [
    "GARIN1A CNV",
    "GARIN1A RNA"
  ],
  "RPL7L1P8": [
    "RPL7L1P8 CNV",
    "RPL7L1P8 RNA"
  ],
  "RPL5P16": [
    "RPL5P16 CNV",
    "RPL5P16 RNA"
  ],
  "H3P18": [
    "H3P18 CNV",
    "H3P18 RNA"
  ],
  "ABCC6P2": [
    "ABCC6P2 CNV",
    "ABCC6P2 RNA"
  ],
  "TRIAP1P1": [
    "TRIAP1P1 CNV",
    "TRIAP1P1 RNA"
  ],
  "RUNX3": [
    "RUNX3 CNV",
    "RUNX3 RNA",
    "RUNX3 Proteo"
  ],
  "RHOQP3": [
    "RHOQP3 CNV",
    "RHOQP3 RNA"
  ],
  "SETP2": [
    "SETP2 CNV",
    "SETP2 RNA"
  ],
  "EMID1": [
    "EMID1 CNV",
    "EMID1 RNA"
  ],
  "RPS15AP16": [
    "RPS15AP16 CNV",
    "RPS15AP16 RNA"
  ],
  "MMP26": [
    "MMP26 CNV",
    "MMP26 RNA"
  ],
  "GRM7": [
    "GRM7 CNV",
    "GRM7 RNA"
  ],
  "RPL36P5": [
    "RPL36P5 CNV",
    "RPL36P5 RNA"
  ],
  "KLK1": [
    "KLK1 CNV",
    "KLK1 RNA"
  ],
  "RNA5SP356": [
    "RNA5SP356 CNV",
    "RNA5SP356 RNA"
  ],
  "FBXO5": [
    "FBXO5 CNV",
    "FBXO5 RNA",
    "FBXO5 Proteo"
  ],
  "TAS2R39": [
    "TAS2R39 CNV",
    "TAS2R39 RNA"
  ],
  "CRK": [
    "CRK CNV",
    "CRK RNA",
    "CRK Proteo"
  ],
  "PXDNL": [
    "PXDNL CNV",
    "PXDNL RNA"
  ],
  "RPS27AP14": [
    "RPS27AP14 CNV",
    "RPS27AP14 RNA"
  ],
  "SDS": [
    "SDS CNV",
    "SDS RNA",
    "SDS Proteo"
  ],
  "FAM197Y1": [
    "FAM197Y1 CNV",
    "FAM197Y1 RNA"
  ],
  "CLEC3A": [
    "CLEC3A CNV",
    "CLEC3A RNA"
  ],
  "MRPL49P2": [
    "MRPL49P2 CNV",
    "MRPL49P2 RNA"
  ],
  "BEND6": [
    "BEND6 CNV",
    "BEND6 RNA"
  ],
  "CERS3": [
    "CERS3 CNV",
    "CERS3 RNA"
  ],
  "ZPR1": [
    "ZPR1 CNV",
    "ZPR1 RNA",
    "ZPR1 Proteo"
  ],
  "MATN4": [
    "MATN4 CNV",
    "MATN4 RNA",
    "MATN4 Proteo"
  ],
  "LRRC37A5P": [
    "LRRC37A5P CNV",
    "LRRC37A5P RNA"
  ],
  "OR7E16P": [
    "OR7E16P CNV",
    "OR7E16P RNA"
  ],
  "GLOD4": [
    "GLOD4 CNV",
    "GLOD4 RNA",
    "GLOD4 Proteo"
  ],
  "LGALS12": [
    "LGALS12 CNV",
    "LGALS12 RNA"
  ],
  "BCL7B": [
    "BCL7B CNV",
    "BCL7B RNA",
    "BCL7B Proteo"
  ],
  "SLC7A3": [
    "SLC7A3 CNV",
    "SLC7A3 RNA"
  ],
  "GCSAM": [
    "GCSAM CNV",
    "GCSAM RNA",
    "GCSAM Proteo"
  ],
  "TRAPPC6A": [
    "TRAPPC6A CNV",
    "TRAPPC6A RNA",
    "TRAPPC6A Proteo"
  ],
  "SNRPEP11": [
    "SNRPEP11 CNV",
    "SNRPEP11 RNA"
  ],
  "NDUFA5P2": [
    "NDUFA5P2 CNV",
    "NDUFA5P2 RNA"
  ],
  "ALDOB": [
    "ALDOB CNV",
    "ALDOB RNA"
  ],
  "RNA5SP25": [
    "RNA5SP25 CNV",
    "RNA5SP25 RNA"
  ],
  "TFPT": [
    "TFPT CNV",
    "TFPT RNA",
    "TFPT Proteo"
  ],
  "MTCYBP19": [
    "MTCYBP19 CNV",
    "MTCYBP19 RNA"
  ],
  "LEPR": [
    "LEPR CNV",
    "LEPR RNA"
  ],
  "CRB2": [
    "CRB2 CNV",
    "CRB2 RNA",
    "CRB2 Proteo"
  ],
  "VN1R69P": [
    "VN1R69P CNV",
    "VN1R69P RNA"
  ],
  "LIG1": [
    "LIG1 CNV",
    "LIG1 RNA",
    "LIG1 Proteo"
  ],
  "MTND5P9": [
    "MTND5P9 CNV",
    "MTND5P9 RNA"
  ],
  "MADCAM1": [
    "MADCAM1 CNV",
    "MADCAM1 RNA"
  ],
  "MON1B": [
    "MON1B CNV",
    "MON1B RNA",
    "MON1B Proteo"
  ],
  "TMCC2": [
    "TMCC2 CNV",
    "TMCC2 RNA",
    "TMCC2 Proteo"
  ],
  "BMS1P8": [
    "BMS1P8 CNV",
    "BMS1P8 RNA"
  ],
  "VSTM2B": [
    "VSTM2B CNV",
    "VSTM2B RNA"
  ],
  "ZNF549": [
    "ZNF549 CNV",
    "ZNF549 RNA"
  ],
  "RPL21P67": [
    "RPL21P67 CNV",
    "RPL21P67 RNA"
  ],
  "UBL5P3": [
    "UBL5P3 CNV",
    "UBL5P3 RNA"
  ],
  "LGR6": [
    "LGR6 CNV",
    "LGR6 RNA"
  ],
  "GAPDHP53": [
    "GAPDHP53 CNV",
    "GAPDHP53 RNA"
  ],
  "EPHA8": [
    "EPHA8 CNV",
    "EPHA8 RNA"
  ],
  "IGLV3-22": [
    "IGLV3-22 Proteo"
  ],
  "HSH2D": [
    "HSH2D CNV",
    "HSH2D RNA",
    "HSH2D Proteo"
  ],
  "RBM22P4": [
    "RBM22P4 CNV",
    "RBM22P4 RNA"
  ],
  "FNDC9": [
    "FNDC9 CNV",
    "FNDC9 RNA"
  ],
  "PLA2G12AP2": [
    "PLA2G12AP2 CNV",
    "PLA2G12AP2 RNA"
  ],
  "LMCD1": [
    "LMCD1 CNV",
    "LMCD1 RNA",
    "LMCD1 Proteo"
  ],
  "SLC25A37": [
    "SLC25A37 CNV",
    "SLC25A37 RNA"
  ],
  "OR7E148P": [
    "OR7E148P CNV",
    "OR7E148P RNA"
  ],
  "GALNT12": [
    "GALNT12 CNV",
    "GALNT12 RNA",
    "GALNT12 Proteo"
  ],
  "OR8H3": [
    "OR8H3 CNV",
    "OR8H3 RNA"
  ],
  "CBX3P5": [
    "CBX3P5 CNV",
    "CBX3P5 RNA"
  ],
  "CNBD2": [
    "CNBD2 CNV",
    "CNBD2 RNA"
  ],
  "SMARCC1": [
    "SMARCC1 CNV",
    "SMARCC1 RNA",
    "SMARCC1 Proteo"
  ],
  "MROH7": [
    "MROH7 CNV",
    "MROH7 RNA"
  ],
  "SPOCK3": [
    "SPOCK3 CNV",
    "SPOCK3 RNA"
  ],
  "RPL21P109": [
    "RPL21P109 CNV",
    "RPL21P109 RNA"
  ],
  "KCNE1": [
    "KCNE1 CNV",
    "KCNE1 RNA"
  ],
  "NDUFB4P12": [
    "NDUFB4P12 CNV",
    "NDUFB4P12 RNA"
  ],
  "PRELID3BP8": [
    "PRELID3BP8 CNV",
    "PRELID3BP8 RNA"
  ],
  "GMPR2": [
    "GMPR2 CNV",
    "GMPR2 RNA",
    "GMPR2 Proteo"
  ],
  "ETV6": [
    "ETV6 CNV",
    "ETV6 RNA",
    "ETV6 Proteo"
  ],
  "ARPC1BP1": [
    "ARPC1BP1 CNV",
    "ARPC1BP1 RNA"
  ],
  "CSDE1": [
    "CSDE1 CNV",
    "CSDE1 RNA",
    "CSDE1 Proteo"
  ],
  "RFC3P1": [
    "RFC3P1 CNV",
    "RFC3P1 RNA"
  ],
  "SUMO2P13": [
    "SUMO2P13 CNV",
    "SUMO2P13 RNA"
  ],
  "TRAF5": [
    "TRAF5 CNV",
    "TRAF5 RNA",
    "TRAF5 Proteo"
  ],
  "FCSK": [
    "FCSK CNV",
    "FCSK RNA",
    "FCSK Proteo"
  ],
  "MTCO2P20": [
    "MTCO2P20 CNV",
    "MTCO2P20 RNA"
  ],
  "THAP2": [
    "THAP2 CNV",
    "THAP2 RNA"
  ],
  "OR6Q1": [
    "OR6Q1 CNV",
    "OR6Q1 RNA"
  ],
  "ATG16L1": [
    "ATG16L1 CNV",
    "ATG16L1 RNA",
    "ATG16L1 Proteo"
  ],
  "TUBA3E": [
    "TUBA3E CNV",
    "TUBA3E RNA",
    "TUBA3E Proteo"
  ],
  "TBC1D3P4": [
    "TBC1D3P4 CNV",
    "TBC1D3P4 RNA"
  ],
  "DUX4L20": [
    "DUX4L20 CNV",
    "DUX4L20 RNA"
  ],
  "FAM32A": [
    "FAM32A CNV",
    "FAM32A RNA",
    "FAM32A Proteo"
  ],
  "CTRC": [
    "CTRC CNV",
    "CTRC RNA"
  ],
  "IGHVII-67-1": [
    "IGHVII-67-1 CNV",
    "IGHVII-67-1 RNA"
  ],
  "KDM5C": [
    "KDM5C CNV",
    "KDM5C RNA",
    "KDM5C Proteo"
  ],
  "RGS6": [
    "RGS6 CNV",
    "RGS6 RNA"
  ],
  "MCM4": [
    "MCM4 CNV",
    "MCM4 RNA",
    "MCM4 Proteo"
  ],
  "MRPL19": [
    "MRPL19 CNV",
    "MRPL19 RNA",
    "MRPL19 Proteo"
  ],
  "KIAA1191": [
    "KIAA1191 CNV",
    "KIAA1191 RNA",
    "KIAA1191 Proteo"
  ],
  "GATAD2B": [
    "GATAD2B CNV",
    "GATAD2B RNA",
    "GATAD2B Proteo"
  ],
  "RNA5SP57": [
    "RNA5SP57 CNV",
    "RNA5SP57 RNA"
  ],
  "AGO3": [
    "AGO3 CNV",
    "AGO3 RNA",
    "AGO3 Proteo"
  ],
  "TMEM168": [
    "TMEM168 CNV",
    "TMEM168 RNA",
    "TMEM168 Proteo"
  ],
  "MTCO3P13": [
    "MTCO3P13 CNV",
    "MTCO3P13 RNA"
  ],
  "FMO1": [
    "FMO1 CNV",
    "FMO1 RNA",
    "FMO1 Proteo"
  ],
  "RPL22P7": [
    "RPL22P7 CNV",
    "RPL22P7 RNA"
  ],
  "KRT18P68": [
    "KRT18P68 CNV",
    "KRT18P68 RNA"
  ],
  "MYCT1": [
    "MYCT1 CNV",
    "MYCT1 RNA",
    "MYCT1 Proteo"
  ],
  "SESN3": [
    "SESN3 CNV",
    "SESN3 RNA",
    "SESN3 Proteo"
  ],
  "DNAJA3": [
    "DNAJA3 CNV",
    "DNAJA3 RNA",
    "DNAJA3 Proteo"
  ],
  "ERICH1": [
    "ERICH1 CNV",
    "ERICH1 RNA",
    "ERICH1 Proteo"
  ],
  "ALKAL2": [
    "ALKAL2 CNV",
    "ALKAL2 RNA"
  ],
  "BCL2L11": [
    "BCL2L11 CNV",
    "BCL2L11 RNA"
  ],
  "NOP9": [
    "NOP9 CNV",
    "NOP9 RNA",
    "NOP9 Proteo"
  ],
  "RARRES2P3": [
    "RARRES2P3 CNV",
    "RARRES2P3 RNA"
  ],
  "DNAJB11": [
    "DNAJB11 CNV",
    "DNAJB11 RNA",
    "DNAJB11 Proteo"
  ],
  "RPL9P33": [
    "RPL9P33 CNV",
    "RPL9P33 RNA"
  ],
  "ZFAND5": [
    "ZFAND5 CNV",
    "ZFAND5 RNA",
    "ZFAND5 Proteo"
  ],
  "FABP1": [
    "FABP1 CNV",
    "FABP1 RNA",
    "FABP1 Proteo"
  ],
  "UPF3B": [
    "UPF3B CNV",
    "UPF3B RNA",
    "UPF3B Proteo"
  ],
  "OCM": [
    "OCM CNV",
    "OCM RNA"
  ],
  "MMACHC": [
    "MMACHC CNV",
    "MMACHC RNA",
    "MMACHC Proteo"
  ],
  "RPSAP54": [
    "RPSAP54 CNV",
    "RPSAP54 RNA"
  ],
  "SRP14P4": [
    "SRP14P4 CNV",
    "SRP14P4 RNA"
  ],
  "VEZTP1": [
    "VEZTP1 CNV",
    "VEZTP1 RNA"
  ],
  "REXO1L11P": [
    "REXO1L11P CNV",
    "REXO1L11P RNA"
  ],
  "WHAMM": [
    "WHAMM CNV",
    "WHAMM RNA",
    "WHAMM Proteo"
  ],
  "GRSF1": [
    "GRSF1 CNV",
    "GRSF1 RNA",
    "GRSF1 Proteo"
  ],
  "FHDC1": [
    "FHDC1 CNV",
    "FHDC1 RNA",
    "FHDC1 Proteo"
  ],
  "CYCSP55": [
    "CYCSP55 CNV",
    "CYCSP55 RNA"
  ],
  "C14orf180": [
    "C14orf180 CNV",
    "C14orf180 RNA"
  ],
  "OR4C15": [
    "OR4C15 CNV",
    "OR4C15 RNA"
  ],
  "RPL21P43": [
    "RPL21P43 CNV",
    "RPL21P43 RNA"
  ],
  "DAP": [
    "DAP CNV",
    "DAP RNA",
    "DAP Proteo"
  ],
  "ATP5PO": [
    "ATP5PO CNV",
    "ATP5PO RNA",
    "ATP5PO Proteo"
  ],
  "ZNF629": [
    "ZNF629 CNV",
    "ZNF629 RNA",
    "ZNF629 Proteo"
  ],
  "SCNN1B": [
    "SCNN1B CNV",
    "SCNN1B RNA"
  ],
  "FAM86LP": [
    "FAM86LP CNV",
    "FAM86LP RNA"
  ],
  "CA1": [
    "CA1 CNV",
    "CA1 RNA",
    "CA1 Proteo"
  ],
  "SCART1": [
    "SCART1 CNV",
    "SCART1 RNA"
  ],
  "RFPL4AP5": [
    "RFPL4AP5 CNV",
    "RFPL4AP5 RNA"
  ],
  "LARS2": [
    "LARS2 CNV",
    "LARS2 RNA",
    "LARS2 Proteo"
  ],
  "NFYA": [
    "NFYA CNV",
    "NFYA RNA",
    "NFYA Proteo"
  ],
  "ELOCP27": [
    "ELOCP27 CNV",
    "ELOCP27 RNA"
  ],
  "HAX1P1": [
    "HAX1P1 CNV",
    "HAX1P1 RNA"
  ],
  "RPL12P14": [
    "RPL12P14 CNV",
    "RPL12P14 RNA"
  ],
  "P2RX6": [
    "P2RX6 CNV",
    "P2RX6 RNA"
  ],
  "MARCHF10": [
    "MARCHF10 CNV",
    "MARCHF10 RNA"
  ],
  "SEPTIN7P2": [
    "SEPTIN7P2 CNV",
    "SEPTIN7P2 RNA"
  ],
  "HMGN2P28": [
    "HMGN2P28 CNV",
    "HMGN2P28 RNA"
  ],
  "OFD1P7Y": [
    "OFD1P7Y CNV",
    "OFD1P7Y RNA"
  ],
  "RDM1": [
    "RDM1 CNV",
    "RDM1 RNA"
  ],
  "TRIM69": [
    "TRIM69 CNV",
    "TRIM69 RNA"
  ],
  "CCN3": [
    "CCN3 CNV",
    "CCN3 RNA",
    "CCN3 Proteo"
  ],
  "ZDHHC4P1": [
    "ZDHHC4P1 CNV",
    "ZDHHC4P1 RNA"
  ],
  "BMP2K": [
    "BMP2K CNV",
    "BMP2K RNA",
    "BMP2K Proteo"
  ],
  "FGFRL1": [
    "FGFRL1 CNV",
    "FGFRL1 RNA",
    "FGFRL1 Proteo"
  ],
  "NR5A1": [
    "NR5A1 CNV",
    "NR5A1 RNA"
  ],
  "CALCRL": [
    "CALCRL CNV",
    "CALCRL RNA",
    "CALCRL Proteo"
  ],
  "RPEL1": [
    "RPEL1 CNV",
    "RPEL1 RNA"
  ],
  "MICOS10": [
    "MICOS10 CNV",
    "MICOS10 RNA",
    "MICOS10 Proteo"
  ],
  "SPEGNB": [
    "SPEGNB CNV",
    "SPEGNB RNA"
  ],
  "MT-CO1": [
    "MT-CO1 RNA",
    "MT-CO1 Proteo"
  ],
  "SPCS2": [
    "SPCS2 CNV",
    "SPCS2 RNA",
    "SPCS2 Proteo"
  ],
  "SPOCD1": [
    "SPOCD1 CNV",
    "SPOCD1 RNA",
    "SPOCD1 Proteo"
  ],
  "ZNF589": [
    "ZNF589 CNV",
    "ZNF589 RNA",
    "ZNF589 Proteo"
  ],
  "JTBP1": [
    "JTBP1 CNV",
    "JTBP1 RNA"
  ],
  "FTH1P24": [
    "FTH1P24 CNV",
    "FTH1P24 RNA"
  ],
  "CHKA": [
    "CHKA CNV",
    "CHKA RNA",
    "CHKA Proteo"
  ],
  "NELFE": [
    "NELFE CNV",
    "NELFE RNA",
    "NELFE Proteo"
  ],
  "RNA5SP320": [
    "RNA5SP320 CNV",
    "RNA5SP320 RNA"
  ],
  "ROS1": [
    "ROS1 CNV",
    "ROS1 RNA"
  ],
  "IGKV2-36": [
    "IGKV2-36 CNV",
    "IGKV2-36 RNA"
  ],
  "LSAMP": [
    "LSAMP CNV",
    "LSAMP RNA",
    "LSAMP Proteo"
  ],
  "RNA5SP455": [
    "RNA5SP455 CNV",
    "RNA5SP455 RNA"
  ],
  "PKMP3": [
    "PKMP3 CNV",
    "PKMP3 RNA"
  ],
  "RSL24D1P8": [
    "RSL24D1P8 CNV",
    "RSL24D1P8 RNA"
  ],
  "KMT2A": [
    "KMT2A CNV",
    "KMT2A RNA",
    "KMT2A Proteo"
  ],
  "KRT3": [
    "KRT3 CNV",
    "KRT3 RNA",
    "KRT3 Proteo"
  ],
  "CHAD": [
    "CHAD CNV",
    "CHAD RNA",
    "CHAD Proteo"
  ],
  "MED13L": [
    "MED13L CNV",
    "MED13L RNA",
    "MED13L Proteo"
  ],
  "ZNF471": [
    "ZNF471 CNV",
    "ZNF471 RNA"
  ],
  "SLC25A6P2": [
    "SLC25A6P2 CNV",
    "SLC25A6P2 RNA"
  ],
  "ZNRF4": [
    "ZNRF4 CNV",
    "ZNRF4 RNA"
  ],
  "ADAM20P3": [
    "ADAM20P3 CNV",
    "ADAM20P3 RNA"
  ],
  "CCNQP3": [
    "CCNQP3 CNV",
    "CCNQP3 RNA"
  ],
  "CT45A9": [
    "CT45A9 CNV",
    "CT45A9 RNA"
  ],
  "TNP1": [
    "TNP1 CNV",
    "TNP1 RNA"
  ],
  "PTPRZ1": [
    "PTPRZ1 CNV",
    "PTPRZ1 RNA",
    "PTPRZ1 Proteo"
  ],
  "AACSP1": [
    "AACSP1 CNV",
    "AACSP1 RNA"
  ],
  "UPK3BL1": [
    "UPK3BL1 CNV",
    "UPK3BL1 RNA"
  ],
  "H2AX": [
    "H2AX CNV",
    "H2AX RNA",
    "H2AX Proteo"
  ],
  "ADHFE1": [
    "ADHFE1 CNV",
    "ADHFE1 RNA",
    "ADHFE1 Proteo"
  ],
  "GASK1A": [
    "GASK1A CNV",
    "GASK1A RNA"
  ],
  "LDOC1": [
    "LDOC1 CNV",
    "LDOC1 RNA"
  ],
  "ACTR3C": [
    "ACTR3C CNV",
    "ACTR3C RNA"
  ],
  "RAB3D": [
    "RAB3D CNV",
    "RAB3D RNA",
    "RAB3D Proteo"
  ],
  "CS": [
    "CS CNV",
    "CS RNA",
    "CS Proteo"
  ],
  "EMC3-AS1": [
    "EMC3-AS1 CNV",
    "EMC3-AS1 RNA"
  ],
  "GRAMD4P2": [
    "GRAMD4P2 CNV",
    "GRAMD4P2 RNA"
  ],
  "C1D": [
    "C1D CNV",
    "C1D RNA",
    "C1D Proteo"
  ],
  "LY86": [
    "LY86 CNV",
    "LY86 RNA"
  ],
  "ZNF668": [
    "ZNF668 CNV",
    "ZNF668 RNA",
    "ZNF668 Proteo"
  ],
  "PGAM3P": [
    "PGAM3P CNV",
    "PGAM3P RNA"
  ],
  "CFDP1": [
    "CFDP1 CNV",
    "CFDP1 RNA",
    "CFDP1 Proteo"
  ],
  "AKR1D1": [
    "AKR1D1 CNV",
    "AKR1D1 RNA"
  ],
  "NGRN": [
    "NGRN CNV",
    "NGRN RNA",
    "NGRN Proteo"
  ],
  "STIM2": [
    "STIM2 CNV",
    "STIM2 RNA",
    "STIM2 Proteo"
  ],
  "DYNC2LI1": [
    "DYNC2LI1 CNV",
    "DYNC2LI1 RNA",
    "DYNC2LI1 Proteo"
  ],
  "VAMP9P": [
    "VAMP9P CNV",
    "VAMP9P RNA"
  ],
  "FGA": [
    "FGA CNV",
    "FGA RNA",
    "FGA Proteo"
  ],
  "TRAJ8": [
    "TRAJ8 CNV",
    "TRAJ8 RNA"
  ],
  "SAMD9L": [
    "SAMD9L CNV",
    "SAMD9L RNA",
    "SAMD9L Proteo"
  ],
  "NCAPG": [
    "NCAPG CNV",
    "NCAPG RNA",
    "NCAPG Proteo"
  ],
  "CAV3": [
    "CAV3 CNV",
    "CAV3 RNA"
  ],
  "HOXB4": [
    "HOXB4 CNV",
    "HOXB4 RNA",
    "HOXB4 Proteo"
  ],
  "PEX26": [
    "PEX26 CNV",
    "PEX26 RNA",
    "PEX26 Proteo"
  ],
  "POLR2B": [
    "POLR2B CNV",
    "POLR2B RNA",
    "POLR2B Proteo"
  ],
  "CLIC2": [
    "CLIC2 CNV",
    "CLIC2 RNA",
    "CLIC2 Proteo"
  ],
  "PPP1R14B": [
    "PPP1R14B CNV",
    "PPP1R14B RNA",
    "PPP1R14B Proteo"
  ],
  "SCN3B": [
    "SCN3B CNV",
    "SCN3B RNA"
  ],
  "IGKV1-37": [
    "IGKV1-37 Proteo"
  ],
  "CHADL": [
    "CHADL CNV",
    "CHADL RNA",
    "CHADL Proteo"
  ],
  "RPL10P16": [
    "RPL10P16 CNV",
    "RPL10P16 RNA"
  ],
  "ASB5": [
    "ASB5 CNV",
    "ASB5 RNA"
  ],
  "PRR20A": [
    "PRR20A CNV",
    "PRR20A RNA"
  ],
  "NTRK2": [
    "NTRK2 CNV",
    "NTRK2 RNA"
  ],
  "NANOGP10": [
    "NANOGP10 CNV",
    "NANOGP10 RNA"
  ],
  "VN1R74P": [
    "VN1R74P CNV",
    "VN1R74P RNA"
  ],
  "TES": [
    "TES CNV",
    "TES RNA",
    "TES Proteo"
  ],
  "ABCC2": [
    "ABCC2 CNV",
    "ABCC2 RNA",
    "ABCC2 Proteo"
  ],
  "OR52N3P": [
    "OR52N3P CNV",
    "OR52N3P RNA"
  ],
  "RPL35P9": [
    "RPL35P9 CNV",
    "RPL35P9 RNA"
  ],
  "CLIC3": [
    "CLIC3 CNV",
    "CLIC3 RNA",
    "CLIC3 Proteo"
  ],
  "SPANXN3": [
    "SPANXN3 CNV",
    "SPANXN3 RNA"
  ],
  "XPOTP1": [
    "XPOTP1 CNV",
    "XPOTP1 RNA"
  ],
  "TRIM53CP": [
    "TRIM53CP CNV",
    "TRIM53CP RNA"
  ],
  "PRIM2BP": [
    "PRIM2BP CNV",
    "PRIM2BP RNA"
  ],
  "NT5C1B": [
    "NT5C1B CNV",
    "NT5C1B RNA"
  ],
  "NCOR1": [
    "NCOR1 CNV",
    "NCOR1 RNA",
    "NCOR1 Proteo"
  ],
  "C11orf98": [
    "C11orf98 CNV",
    "C11orf98 RNA",
    "C11orf98 Proteo"
  ],
  "NBPF14": [
    "NBPF14 CNV",
    "NBPF14 RNA"
  ],
  "FIBCD1": [
    "FIBCD1 CNV",
    "FIBCD1 RNA"
  ],
  "MORC4": [
    "MORC4 CNV",
    "MORC4 RNA",
    "MORC4 Proteo"
  ],
  "CCDC112": [
    "CCDC112 CNV",
    "CCDC112 RNA"
  ],
  "PTPN23": [
    "PTPN23 CNV",
    "PTPN23 RNA",
    "PTPN23 Proteo"
  ],
  "PCK2": [
    "PCK2 CNV",
    "PCK2 RNA",
    "PCK2 Proteo"
  ],
  "QRSL1P1": [
    "QRSL1P1 CNV",
    "QRSL1P1 RNA"
  ],
  "COX17": [
    "COX17 CNV",
    "COX17 RNA",
    "COX17 Proteo"
  ],
  "FAP": [
    "FAP CNV",
    "FAP RNA",
    "FAP Proteo"
  ],
  "OR2G1P": [
    "OR2G1P CNV",
    "OR2G1P RNA"
  ],
  "SCO2": [
    "SCO2 CNV",
    "SCO2 RNA",
    "SCO2 Proteo"
  ],
  "ARHGAP19": [
    "ARHGAP19 CNV",
    "ARHGAP19 RNA",
    "ARHGAP19 Proteo"
  ],
  "RNA5SP64": [
    "RNA5SP64 CNV",
    "RNA5SP64 RNA"
  ],
  "PRMT1P1": [
    "PRMT1P1 CNV",
    "PRMT1P1 RNA"
  ],
  "MS4A13": [
    "MS4A13 CNV",
    "MS4A13 RNA"
  ],
  "TMED11P": [
    "TMED11P CNV",
    "TMED11P RNA"
  ],
  "RPS10P9": [
    "RPS10P9 CNV",
    "RPS10P9 RNA"
  ],
  "FICD": [
    "FICD CNV",
    "FICD RNA",
    "FICD Proteo"
  ],
  "RPL10P18": [
    "RPL10P18 CNV",
    "RPL10P18 RNA"
  ],
  "HNRNPA1P60": [
    "HNRNPA1P60 CNV",
    "HNRNPA1P60 RNA"
  ],
  "NOL12": [
    "NOL12 CNV",
    "NOL12 RNA",
    "NOL12 Proteo"
  ],
  "MEX3A": [
    "MEX3A CNV",
    "MEX3A RNA",
    "MEX3A Proteo"
  ],
  "SYT15B": [
    "SYT15B CNV",
    "SYT15B RNA"
  ],
  "CPSF1P2": [
    "CPSF1P2 CNV",
    "CPSF1P2 RNA"
  ],
  "MRPL45": [
    "MRPL45 CNV",
    "MRPL45 RNA",
    "MRPL45 Proteo"
  ],
  "RNA5SP247": [
    "RNA5SP247 CNV",
    "RNA5SP247 RNA"
  ],
  "ACTRT2": [
    "ACTRT2 CNV",
    "ACTRT2 RNA"
  ],
  "CRABP2": [
    "CRABP2 CNV",
    "CRABP2 RNA",
    "CRABP2 Proteo"
  ],
  "HMGN2P27": [
    "HMGN2P27 CNV",
    "HMGN2P27 RNA"
  ],
  "SIX6": [
    "SIX6 CNV",
    "SIX6 RNA"
  ],
  "HSPE1P12": [
    "HSPE1P12 CNV",
    "HSPE1P12 RNA"
  ],
  "NPM1P40": [
    "NPM1P40 CNV",
    "NPM1P40 RNA"
  ],
  "RAB3GAP2": [
    "RAB3GAP2 CNV",
    "RAB3GAP2 RNA",
    "RAB3GAP2 Proteo"
  ],
  "RAD51C": [
    "RAD51C CNV",
    "RAD51C RNA",
    "RAD51C Proteo"
  ],
  "ZNF731P": [
    "ZNF731P CNV",
    "ZNF731P RNA"
  ],
  "DCAF4": [
    "DCAF4 CNV",
    "DCAF4 RNA",
    "DCAF4 Proteo"
  ],
  "PSIP1": [
    "PSIP1 CNV",
    "PSIP1 RNA",
    "PSIP1 Proteo"
  ],
  "CES1": [
    "CES1 CNV",
    "CES1 RNA",
    "CES1 Proteo"
  ],
  "EEF1GP5": [
    "EEF1GP5 CNV",
    "EEF1GP5 RNA"
  ],
  "LSM4": [
    "LSM4 CNV",
    "LSM4 RNA",
    "LSM4 Proteo"
  ],
  "COPS6": [
    "COPS6 CNV",
    "COPS6 RNA",
    "COPS6 Proteo"
  ],
  "THUMPD2": [
    "THUMPD2 CNV",
    "THUMPD2 RNA",
    "THUMPD2 Proteo"
  ],
  "OR1B1": [
    "OR1B1 CNV",
    "OR1B1 RNA"
  ],
  "CR1": [
    "CR1 CNV",
    "CR1 RNA",
    "CR1 Proteo"
  ],
  "GJA3": [
    "GJA3 CNV",
    "GJA3 RNA"
  ],
  "CCDC40": [
    "CCDC40 CNV",
    "CCDC40 RNA",
    "CCDC40 Proteo"
  ],
  "MS4A3": [
    "MS4A3 CNV",
    "MS4A3 RNA"
  ],
  "RPL31P56": [
    "RPL31P56 CNV",
    "RPL31P56 RNA"
  ],
  "RARRES2P6": [
    "RARRES2P6 CNV",
    "RARRES2P6 RNA"
  ],
  "SPAG8": [
    "SPAG8 CNV",
    "SPAG8 RNA"
  ],
  "MOB4": [
    "MOB4 CNV",
    "MOB4 RNA",
    "MOB4 Proteo"
  ],
  "MCM10": [
    "MCM10 CNV",
    "MCM10 RNA",
    "MCM10 Proteo"
  ],
  "BNIP3P34": [
    "BNIP3P34 CNV",
    "BNIP3P34 RNA"
  ],
  "AOC3": [
    "AOC3 CNV",
    "AOC3 RNA",
    "AOC3 Proteo"
  ],
  "OR8K3": [
    "OR8K3 CNV",
    "OR8K3 RNA"
  ],
  "ANKDD1A": [
    "ANKDD1A CNV",
    "ANKDD1A RNA",
    "ANKDD1A Proteo"
  ],
  "FBXL6": [
    "FBXL6 CNV",
    "FBXL6 RNA",
    "FBXL6 Proteo"
  ],
  "OR6B1": [
    "OR6B1 CNV",
    "OR6B1 RNA"
  ],
  "ZNF517": [
    "ZNF517 CNV",
    "ZNF517 RNA"
  ],
  "DUX4L50": [
    "DUX4L50 CNV",
    "DUX4L50 RNA"
  ],
  "MAGEE2": [
    "MAGEE2 CNV",
    "MAGEE2 RNA"
  ],
  "ITIH2": [
    "ITIH2 CNV",
    "ITIH2 RNA",
    "ITIH2 Proteo"
  ],
  "BMS1P16": [
    "BMS1P16 CNV",
    "BMS1P16 RNA"
  ],
  "RPL11": [
    "RPL11 CNV",
    "RPL11 RNA",
    "RPL11 Proteo"
  ],
  "HMGN1P36": [
    "HMGN1P36 CNV",
    "HMGN1P36 RNA"
  ],
  "XIAPP1": [
    "XIAPP1 CNV",
    "XIAPP1 RNA"
  ],
  "RNA5SP63": [
    "RNA5SP63 CNV",
    "RNA5SP63 RNA"
  ],
  "MTND4P4": [
    "MTND4P4 CNV",
    "MTND4P4 RNA"
  ],
  "SOWAHCP2": [
    "SOWAHCP2 CNV",
    "SOWAHCP2 RNA"
  ],
  "MPHOSPH6": [
    "MPHOSPH6 CNV",
    "MPHOSPH6 RNA",
    "MPHOSPH6 Proteo"
  ],
  "IGHV3-41": [
    "IGHV3-41 CNV",
    "IGHV3-41 RNA"
  ],
  "OR4A19P": [
    "OR4A19P CNV",
    "OR4A19P RNA"
  ],
  "SCAND1": [
    "SCAND1 CNV",
    "SCAND1 RNA",
    "SCAND1 Proteo"
  ],
  "ATP5MJ": [
    "ATP5MJ CNV",
    "ATP5MJ RNA",
    "ATP5MJ Proteo"
  ],
  "RPS10P28": [
    "RPS10P28 CNV",
    "RPS10P28 RNA"
  ],
  "CTXND1": [
    "CTXND1 CNV",
    "CTXND1 RNA"
  ],
  "SULT1A4": [
    "SULT1A4 CNV",
    "SULT1A4 RNA"
  ],
  "UCK2": [
    "UCK2 CNV",
    "UCK2 RNA",
    "UCK2 Proteo"
  ],
  "CAND2": [
    "CAND2 CNV",
    "CAND2 RNA",
    "CAND2 Proteo"
  ],
  "MINK1": [
    "MINK1 CNV",
    "MINK1 RNA",
    "MINK1 Proteo"
  ],
  "CEP162": [
    "CEP162 CNV",
    "CEP162 RNA"
  ],
  "IL1R1": [
    "IL1R1 CNV",
    "IL1R1 RNA",
    "IL1R1 Proteo"
  ],
  "RGCC": [
    "RGCC CNV",
    "RGCC RNA",
    "RGCC Proteo"
  ],
  "ZNF823": [
    "ZNF823 CNV",
    "ZNF823 RNA"
  ],
  "OR51B2": [
    "OR51B2 CNV",
    "OR51B2 RNA"
  ],
  "ERFL": [
    "ERFL CNV",
    "ERFL RNA"
  ],
  "SPEN": [
    "SPEN CNV",
    "SPEN RNA",
    "SPEN Proteo"
  ],
  "GPRC5D": [
    "GPRC5D CNV",
    "GPRC5D RNA"
  ],
  "PBX2": [
    "PBX2 CNV",
    "PBX2 RNA",
    "PBX2 Proteo"
  ],
  "HNRNPKP4": [
    "HNRNPKP4 CNV",
    "HNRNPKP4 RNA"
  ],
  "SOS2": [
    "SOS2 CNV",
    "SOS2 RNA",
    "SOS2 Proteo"
  ],
  "IGKV1D-22": [
    "IGKV1D-22 CNV",
    "IGKV1D-22 RNA"
  ],
  "DESI2": [
    "DESI2 CNV",
    "DESI2 RNA",
    "DESI2 Proteo"
  ],
  "RPL36P9": [
    "RPL36P9 CNV",
    "RPL36P9 RNA"
  ],
  "TLR4": [
    "TLR4 CNV",
    "TLR4 RNA",
    "TLR4 Proteo"
  ],
  "CA14": [
    "CA14 CNV",
    "CA14 RNA",
    "CA14 Proteo"
  ],
  "PPP6R1": [
    "PPP6R1 CNV",
    "PPP6R1 RNA",
    "PPP6R1 Proteo"
  ],
  "AARSD1": [
    "AARSD1 CNV",
    "AARSD1 RNA",
    "AARSD1 Proteo"
  ],
  "CRYGS": [
    "CRYGS CNV",
    "CRYGS RNA"
  ],
  "UBASH3A": [
    "UBASH3A CNV",
    "UBASH3A RNA",
    "UBASH3A Proteo"
  ],
  "OOSP3": [
    "OOSP3 CNV",
    "OOSP3 RNA"
  ],
  "GSTA11P": [
    "GSTA11P CNV",
    "GSTA11P RNA"
  ],
  "TPM4": [
    "TPM4 CNV",
    "TPM4 RNA",
    "TPM4 Proteo"
  ],
  "RETNLB": [
    "RETNLB CNV",
    "RETNLB RNA"
  ],
  "KCNH4": [
    "KCNH4 CNV",
    "KCNH4 RNA"
  ],
  "CEACAMP11": [
    "CEACAMP11 CNV",
    "CEACAMP11 RNA"
  ],
  "CHAF1A": [
    "CHAF1A CNV",
    "CHAF1A RNA",
    "CHAF1A Proteo"
  ],
  "OR5D18": [
    "OR5D18 CNV",
    "OR5D18 RNA"
  ],
  "TBC1D7": [
    "TBC1D7 CNV",
    "TBC1D7 RNA",
    "TBC1D7 Proteo"
  ],
  "MTHFD1L": [
    "MTHFD1L CNV",
    "MTHFD1L RNA",
    "MTHFD1L Proteo"
  ],
  "SUGT1P1": [
    "SUGT1P1 CNV",
    "SUGT1P1 RNA"
  ],
  "PNPLA4": [
    "PNPLA4 CNV",
    "PNPLA4 RNA",
    "PNPLA4 Proteo"
  ],
  "FAM76A": [
    "FAM76A CNV",
    "FAM76A RNA",
    "FAM76A Proteo"
  ],
  "AP5S1": [
    "AP5S1 CNV",
    "AP5S1 RNA",
    "AP5S1 Proteo"
  ],
  "GNAT1": [
    "GNAT1 CNV",
    "GNAT1 RNA"
  ],
  "WARS1P1": [
    "WARS1P1 CNV",
    "WARS1P1 RNA"
  ],
  "PGM5P2": [
    "PGM5P2 CNV",
    "PGM5P2 RNA"
  ],
  "CHEK2P4": [
    "CHEK2P4 CNV",
    "CHEK2P4 RNA"
  ],
  "EIF3CL": [
    "EIF3CL CNV",
    "EIF3CL RNA"
  ],
  "ZNF708": [
    "ZNF708 CNV",
    "ZNF708 RNA"
  ],
  "ARHGAP32": [
    "ARHGAP32 CNV",
    "ARHGAP32 RNA",
    "ARHGAP32 Proteo"
  ],
  "MAGEA1": [
    "MAGEA1 CNV",
    "MAGEA1 RNA",
    "MAGEA1 Proteo"
  ],
  "SLC44A4": [
    "SLC44A4 CNV",
    "SLC44A4 RNA"
  ],
  "OR4F8P": [
    "OR4F8P CNV",
    "OR4F8P RNA"
  ],
  "PURB": [
    "PURB CNV",
    "PURB RNA",
    "PURB Proteo"
  ],
  "JAGN1": [
    "JAGN1 CNV",
    "JAGN1 RNA",
    "JAGN1 Proteo"
  ],
  "ZNF736P10Y": [
    "ZNF736P10Y CNV",
    "ZNF736P10Y RNA"
  ],
  "CAMK2N1": [
    "CAMK2N1 CNV",
    "CAMK2N1 RNA"
  ],
  "THNSL1": [
    "THNSL1 CNV",
    "THNSL1 RNA",
    "THNSL1 Proteo"
  ],
  "PGAM1P1": [
    "PGAM1P1 CNV",
    "PGAM1P1 RNA"
  ],
  "DOK5": [
    "DOK5 CNV",
    "DOK5 RNA"
  ],
  "NEFMP1": [
    "NEFMP1 CNV",
    "NEFMP1 RNA"
  ],
  "NUF2": [
    "NUF2 CNV",
    "NUF2 RNA",
    "NUF2 Proteo"
  ],
  "ARL4C": [
    "ARL4C CNV",
    "ARL4C RNA",
    "ARL4C Proteo"
  ],
  "LYAR": [
    "LYAR CNV",
    "LYAR RNA",
    "LYAR Proteo"
  ],
  "TPP2": [
    "TPP2 CNV",
    "TPP2 RNA",
    "TPP2 Proteo"
  ],
  "HLA-DQB3": [
    "HLA-DQB3 CNV",
    "HLA-DQB3 RNA"
  ],
  "PSAPL1": [
    "PSAPL1 CNV",
    "PSAPL1 RNA",
    "PSAPL1 Proteo"
  ],
  "KRTAP25-1": [
    "KRTAP25-1 CNV",
    "KRTAP25-1 RNA"
  ],
  "FAM197Y8": [
    "FAM197Y8 CNV",
    "FAM197Y8 RNA"
  ],
  "CIAPIN1": [
    "CIAPIN1 CNV",
    "CIAPIN1 RNA",
    "CIAPIN1 Proteo"
  ],
  "OR10AB1P": [
    "OR10AB1P CNV",
    "OR10AB1P RNA"
  ],
  "HOXA11": [
    "HOXA11 CNV",
    "HOXA11 RNA"
  ],
  "ALG3P1": [
    "ALG3P1 CNV",
    "ALG3P1 RNA"
  ],
  "PNMA6B": [
    "PNMA6B CNV",
    "PNMA6B RNA"
  ],
  "RPL22P20": [
    "RPL22P20 CNV",
    "RPL22P20 RNA"
  ],
  "XXYLT1": [
    "XXYLT1 CNV",
    "XXYLT1 RNA",
    "XXYLT1 Proteo"
  ],
  "RXYLT1": [
    "RXYLT1 CNV",
    "RXYLT1 RNA",
    "RXYLT1 Proteo"
  ],
  "RPL32": [
    "RPL32 CNV",
    "RPL32 RNA",
    "RPL32 Proteo"
  ],
  "OR5P1P": [
    "OR5P1P CNV",
    "OR5P1P RNA"
  ],
  "SPATA31E2P": [
    "SPATA31E2P CNV",
    "SPATA31E2P RNA"
  ],
  "PPP1R12BP2": [
    "PPP1R12BP2 CNV",
    "PPP1R12BP2 RNA"
  ],
  "TBC1D16": [
    "TBC1D16 CNV",
    "TBC1D16 RNA",
    "TBC1D16 Proteo"
  ],
  "GAS1": [
    "GAS1 CNV",
    "GAS1 RNA",
    "GAS1 Proteo"
  ],
  "RPA1": [
    "RPA1 CNV",
    "RPA1 RNA",
    "RPA1 Proteo"
  ],
  "SYPL1P1": [
    "SYPL1P1 CNV",
    "SYPL1P1 RNA"
  ],
  "NCSTNP1": [
    "NCSTNP1 CNV",
    "NCSTNP1 RNA"
  ],
  "RNA5SP486": [
    "RNA5SP486 CNV",
    "RNA5SP486 RNA"
  ],
  "ABT1": [
    "ABT1 CNV",
    "ABT1 RNA",
    "ABT1 Proteo"
  ],
  "ARL6IP5": [
    "ARL6IP5 CNV",
    "ARL6IP5 RNA",
    "ARL6IP5 Proteo"
  ],
  "CCN5": [
    "CCN5 CNV",
    "CCN5 RNA",
    "CCN5 Proteo"
  ],
  "SLC35F4": [
    "SLC35F4 CNV",
    "SLC35F4 RNA"
  ],
  "PTBP1P": [
    "PTBP1P CNV",
    "PTBP1P RNA"
  ],
  "IGLL3P": [
    "IGLL3P CNV",
    "IGLL3P RNA"
  ],
  "KRT71": [
    "KRT71 CNV",
    "KRT71 RNA",
    "KRT71 Proteo"
  ],
  "PRSS2": [
    "PRSS2 CNV",
    "PRSS2 RNA",
    "PRSS2 Proteo"
  ],
  "KIAA0319L": [
    "KIAA0319L CNV",
    "KIAA0319L RNA",
    "KIAA0319L Proteo"
  ],
  "FOXP4": [
    "FOXP4 CNV",
    "FOXP4 RNA",
    "FOXP4 Proteo"
  ],
  "RNA5SP430": [
    "RNA5SP430 CNV",
    "RNA5SP430 RNA"
  ],
  "FHP1": [
    "FHP1 CNV",
    "FHP1 RNA"
  ],
  "DDT": [
    "DDT CNV",
    "DDT RNA",
    "DDT Proteo"
  ],
  "OR2T8": [
    "OR2T8 CNV",
    "OR2T8 RNA"
  ],
  "DYM": [
    "DYM CNV",
    "DYM RNA",
    "DYM Proteo"
  ],
  "IRF8": [
    "IRF8 CNV",
    "IRF8 RNA",
    "IRF8 Proteo"
  ],
  "CCNA1": [
    "CCNA1 CNV",
    "CCNA1 RNA"
  ],
  "HBG1": [
    "HBG1 CNV",
    "HBG1 RNA",
    "HBG1 Proteo"
  ],
  "NIFKP8": [
    "NIFKP8 CNV",
    "NIFKP8 RNA"
  ],
  "VDAC2P1": [
    "VDAC2P1 CNV",
    "VDAC2P1 RNA"
  ],
  "GFUS": [
    "GFUS CNV",
    "GFUS RNA",
    "GFUS Proteo"
  ],
  "SPDEF": [
    "SPDEF CNV",
    "SPDEF RNA"
  ],
  "MRPS18A": [
    "MRPS18A CNV",
    "MRPS18A RNA",
    "MRPS18A Proteo"
  ],
  "KRTAP3-4P": [
    "KRTAP3-4P CNV",
    "KRTAP3-4P RNA"
  ],
  "MTCO1P52": [
    "MTCO1P52 CNV",
    "MTCO1P52 RNA"
  ],
  "RPS21P2": [
    "RPS21P2 CNV",
    "RPS21P2 RNA"
  ],
  "VN1R54P": [
    "VN1R54P CNV",
    "VN1R54P RNA"
  ],
  "RPS4XP2": [
    "RPS4XP2 CNV",
    "RPS4XP2 RNA"
  ],
  "FAM111B": [
    "FAM111B CNV",
    "FAM111B RNA",
    "FAM111B Proteo"
  ],
  "DNAJC5": [
    "DNAJC5 CNV",
    "DNAJC5 RNA",
    "DNAJC5 Proteo"
  ],
  "MED8": [
    "MED8 CNV",
    "MED8 RNA",
    "MED8 Proteo"
  ],
  "PSMC1P4": [
    "PSMC1P4 CNV",
    "PSMC1P4 RNA"
  ],
  "TNFSF10": [
    "TNFSF10 CNV",
    "TNFSF10 RNA",
    "TNFSF10 Proteo"
  ],
  "SKP1P1": [
    "SKP1P1 CNV",
    "SKP1P1 RNA"
  ],
  "CCDC27": [
    "CCDC27 CNV",
    "CCDC27 RNA"
  ],
  "OR9G4": [
    "OR9G4 CNV",
    "OR9G4 RNA"
  ],
  "RPL30P1": [
    "RPL30P1 CNV",
    "RPL30P1 RNA"
  ],
  "HOXA2": [
    "HOXA2 CNV",
    "HOXA2 RNA"
  ],
  "ZNF214": [
    "ZNF214 CNV",
    "ZNF214 RNA"
  ],
  "RPL32P21": [
    "RPL32P21 CNV",
    "RPL32P21 RNA"
  ],
  "TBATA": [
    "TBATA CNV",
    "TBATA RNA"
  ],
  "CICP10": [
    "CICP10 CNV",
    "CICP10 RNA"
  ],
  "RDXP3": [
    "RDXP3 CNV",
    "RDXP3 RNA"
  ],
  "MED6": [
    "MED6 CNV",
    "MED6 RNA",
    "MED6 Proteo"
  ],
  "GARIN5B": [
    "GARIN5B CNV",
    "GARIN5B RNA"
  ],
  "NCR1": [
    "NCR1 CNV",
    "NCR1 RNA"
  ],
  "FAM246B": [
    "FAM246B CNV",
    "FAM246B RNA"
  ],
  "EBLN1": [
    "EBLN1 CNV",
    "EBLN1 RNA"
  ],
  "ATP2B2": [
    "ATP2B2 CNV",
    "ATP2B2 RNA"
  ],
  "MOB3B": [
    "MOB3B CNV",
    "MOB3B RNA",
    "MOB3B Proteo"
  ],
  "TLR2": [
    "TLR2 CNV",
    "TLR2 RNA",
    "TLR2 Proteo"
  ],
  "ANKRD53": [
    "ANKRD53 CNV",
    "ANKRD53 RNA"
  ],
  "TSSC2": [
    "TSSC2 CNV",
    "TSSC2 RNA"
  ],
  "MTND4P16": [
    "MTND4P16 CNV",
    "MTND4P16 RNA"
  ],
  "SERPINI1": [
    "SERPINI1 CNV",
    "SERPINI1 RNA",
    "SERPINI1 Proteo"
  ],
  "VPS33B": [
    "VPS33B CNV",
    "VPS33B RNA",
    "VPS33B Proteo"
  ],
  "TBC1D3E": [
    "TBC1D3E CNV",
    "TBC1D3E RNA"
  ],
  "HMGB1P50": [
    "HMGB1P50 CNV",
    "HMGB1P50 RNA"
  ],
  "POLR2D": [
    "POLR2D CNV",
    "POLR2D RNA",
    "POLR2D Proteo"
  ],
  "WDR36": [
    "WDR36 CNV",
    "WDR36 RNA",
    "WDR36 Proteo"
  ],
  "EGFL7": [
    "EGFL7 CNV",
    "EGFL7 RNA",
    "EGFL7 Proteo"
  ],
  "RNA5SP276": [
    "RNA5SP276 CNV",
    "RNA5SP276 RNA"
  ],
  "CLEC2A": [
    "CLEC2A CNV",
    "CLEC2A RNA"
  ],
  "CFHR3": [
    "CFHR3 CNV",
    "CFHR3 RNA"
  ],
  "ANKRD20A7P": [
    "ANKRD20A7P CNV",
    "ANKRD20A7P RNA"
  ],
  "NUMBL": [
    "NUMBL CNV",
    "NUMBL RNA",
    "NUMBL Proteo"
  ],
  "RPS20P24": [
    "RPS20P24 CNV",
    "RPS20P24 RNA"
  ],
  "PNISR": [
    "PNISR CNV",
    "PNISR RNA",
    "PNISR Proteo"
  ],
  "KCNE4": [
    "KCNE4 CNV",
    "KCNE4 RNA"
  ],
  "CD1D": [
    "CD1D CNV",
    "CD1D RNA",
    "CD1D Proteo"
  ],
  "CCDC153": [
    "CCDC153 CNV",
    "CCDC153 RNA"
  ],
  "FOXD2": [
    "FOXD2 CNV",
    "FOXD2 RNA",
    "FOXD2 Proteo"
  ],
  "SPANXD": [
    "SPANXD CNV",
    "SPANXD RNA"
  ],
  "CRACDL": [
    "CRACDL CNV",
    "CRACDL RNA",
    "CRACDL Proteo"
  ],
  "RPS6P23": [
    "RPS6P23 CNV",
    "RPS6P23 RNA"
  ],
  "ZNF683": [
    "ZNF683 CNV",
    "ZNF683 RNA"
  ],
  "ACTG1P19": [
    "ACTG1P19 CNV",
    "ACTG1P19 RNA"
  ],
  "SZT2": [
    "SZT2 CNV",
    "SZT2 RNA",
    "SZT2 Proteo"
  ],
  "MTCO1P38": [
    "MTCO1P38 CNV",
    "MTCO1P38 RNA"
  ],
  "ENHO": [
    "ENHO CNV",
    "ENHO RNA"
  ],
  "CBFB": [
    "CBFB CNV",
    "CBFB RNA",
    "CBFB Proteo"
  ],
  "RFPL4AL1": [
    "RFPL4AL1 CNV",
    "RFPL4AL1 RNA"
  ],
  "HMGN1P12": [
    "HMGN1P12 CNV",
    "HMGN1P12 RNA"
  ],
  "IQCF5": [
    "IQCF5 CNV",
    "IQCF5 RNA"
  ],
  "EEF1A1P20": [
    "EEF1A1P20 CNV",
    "EEF1A1P20 RNA"
  ],
  "PIGF": [
    "PIGF CNV",
    "PIGF RNA"
  ],
  "IGLV2-8": [
    "IGLV2-8 Proteo"
  ],
  "RPL31P46": [
    "RPL31P46 CNV",
    "RPL31P46 RNA"
  ],
  "PRELID3BP11": [
    "PRELID3BP11 CNV",
    "PRELID3BP11 RNA"
  ],
  "EHMT1": [
    "EHMT1 CNV",
    "EHMT1 RNA",
    "EHMT1 Proteo"
  ],
  "FAM76B": [
    "FAM76B CNV",
    "FAM76B RNA",
    "FAM76B Proteo"
  ],
  "EIF4A1P2": [
    "EIF4A1P2 CNV",
    "EIF4A1P2 RNA"
  ],
  "PMFBP1": [
    "PMFBP1 CNV",
    "PMFBP1 RNA",
    "PMFBP1 Proteo"
  ],
  "CASQ1": [
    "CASQ1 CNV",
    "CASQ1 RNA",
    "CASQ1 Proteo"
  ],
  "ZDHHC20P2": [
    "ZDHHC20P2 CNV",
    "ZDHHC20P2 RNA"
  ],
  "C15orf39": [
    "C15orf39 CNV",
    "C15orf39 RNA",
    "C15orf39 Proteo"
  ],
  "NCOA6": [
    "NCOA6 CNV",
    "NCOA6 RNA",
    "NCOA6 Proteo"
  ],
  "CMTM7": [
    "CMTM7 CNV",
    "CMTM7 RNA",
    "CMTM7 Proteo"
  ],
  "BFAR": [
    "BFAR CNV",
    "BFAR RNA",
    "BFAR Proteo"
  ],
  "TRAV28": [
    "TRAV28 CNV",
    "TRAV28 RNA"
  ],
  "RC3H2": [
    "RC3H2 CNV",
    "RC3H2 RNA",
    "RC3H2 Proteo"
  ],
  "AKIRIN2": [
    "AKIRIN2 CNV",
    "AKIRIN2 RNA",
    "AKIRIN2 Proteo"
  ],
  "TRIM71": [
    "TRIM71 CNV",
    "TRIM71 RNA"
  ],
  "TMC1": [
    "TMC1 CNV",
    "TMC1 RNA"
  ],
  "CHN1": [
    "CHN1 CNV",
    "CHN1 RNA",
    "CHN1 Proteo"
  ],
  "MTND6P10": [
    "MTND6P10 CNV",
    "MTND6P10 RNA"
  ],
  "RPL14P5": [
    "RPL14P5 CNV",
    "RPL14P5 RNA"
  ],
  "OR14A16": [
    "OR14A16 CNV",
    "OR14A16 RNA"
  ],
  "SYT3": [
    "SYT3 CNV",
    "SYT3 RNA"
  ],
  "IGHVII-65-1": [
    "IGHVII-65-1 CNV",
    "IGHVII-65-1 RNA"
  ],
  "TLCD3A": [
    "TLCD3A CNV",
    "TLCD3A RNA",
    "TLCD3A Proteo"
  ],
  "ITPRIPL1": [
    "ITPRIPL1 CNV",
    "ITPRIPL1 RNA"
  ],
  "ZNF264": [
    "ZNF264 CNV",
    "ZNF264 RNA",
    "ZNF264 Proteo"
  ],
  "DCBLD2": [
    "DCBLD2 CNV",
    "DCBLD2 RNA",
    "DCBLD2 Proteo"
  ],
  "MCFD2": [
    "MCFD2 CNV",
    "MCFD2 RNA",
    "MCFD2 Proteo"
  ],
  "KRT13": [
    "KRT13 CNV",
    "KRT13 RNA",
    "KRT13 Proteo"
  ],
  "CAPZBP1": [
    "CAPZBP1 CNV",
    "CAPZBP1 RNA"
  ],
  "HADHAP1": [
    "HADHAP1 CNV",
    "HADHAP1 RNA"
  ],
  "RGMB": [
    "RGMB CNV",
    "RGMB RNA",
    "RGMB Proteo"
  ],
  "TMBIM4": [
    "TMBIM4 CNV",
    "TMBIM4 RNA"
  ],
  "RHEBP1": [
    "RHEBP1 CNV",
    "RHEBP1 RNA"
  ],
  "CHML": [
    "CHML CNV",
    "CHML RNA",
    "CHML Proteo"
  ],
  "PMS2P11": [
    "PMS2P11 CNV",
    "PMS2P11 RNA"
  ],
  "ALDH7A1P2": [
    "ALDH7A1P2 CNV",
    "ALDH7A1P2 RNA"
  ],
  "ADAM3A": [
    "ADAM3A CNV",
    "ADAM3A RNA"
  ],
  "BACH1": [
    "BACH1 CNV",
    "BACH1 RNA",
    "BACH1 Proteo"
  ],
  "RRM2P2": [
    "RRM2P2 CNV",
    "RRM2P2 RNA"
  ],
  "USP13": [
    "USP13 CNV",
    "USP13 RNA",
    "USP13 Proteo"
  ],
  "ZNF569": [
    "ZNF569 CNV",
    "ZNF569 RNA"
  ],
  "ZFAND2B": [
    "ZFAND2B CNV",
    "ZFAND2B RNA",
    "ZFAND2B Proteo"
  ],
  "ABCA17P": [
    "ABCA17P CNV",
    "ABCA17P RNA"
  ],
  "HIGD2B": [
    "HIGD2B CNV",
    "HIGD2B RNA"
  ],
  "ZNF558": [
    "ZNF558 CNV",
    "ZNF558 RNA"
  ],
  "CAMSAP3": [
    "CAMSAP3 CNV",
    "CAMSAP3 RNA",
    "CAMSAP3 Proteo"
  ],
  "CYP27A1": [
    "CYP27A1 CNV",
    "CYP27A1 RNA",
    "CYP27A1 Proteo"
  ],
  "PSMD8": [
    "PSMD8 CNV",
    "PSMD8 RNA",
    "PSMD8 Proteo"
  ],
  "VWA2": [
    "VWA2 CNV",
    "VWA2 RNA"
  ],
  "CT47A4": [
    "CT47A4 CNV",
    "CT47A4 RNA",
    "CT47A4 Proteo"
  ],
  "PDIA4": [
    "PDIA4 CNV",
    "PDIA4 RNA",
    "PDIA4 Proteo"
  ],
  "STARD10": [
    "STARD10 CNV",
    "STARD10 RNA",
    "STARD10 Proteo"
  ],
  "EFR3A": [
    "EFR3A CNV",
    "EFR3A RNA",
    "EFR3A Proteo"
  ],
  "HSPE1P8": [
    "HSPE1P8 CNV",
    "HSPE1P8 RNA"
  ],
  "RPL7AP67": [
    "RPL7AP67 CNV",
    "RPL7AP67 RNA"
  ],
  "CLOCK": [
    "CLOCK CNV",
    "CLOCK RNA",
    "CLOCK Proteo"
  ],
  "GPN2": [
    "GPN2 CNV",
    "GPN2 RNA",
    "GPN2 Proteo"
  ],
  "IGHVIII-67-4": [
    "IGHVIII-67-4 CNV",
    "IGHVIII-67-4 RNA"
  ],
  "RNA5SP285": [
    "RNA5SP285 CNV",
    "RNA5SP285 RNA"
  ],
  "OR9A2": [
    "OR9A2 CNV",
    "OR9A2 RNA"
  ],
  "LDB1": [
    "LDB1 CNV",
    "LDB1 RNA",
    "LDB1 Proteo"
  ],
  "MRPL51": [
    "MRPL51 CNV",
    "MRPL51 RNA",
    "MRPL51 Proteo"
  ],
  "NDUFB9P2": [
    "NDUFB9P2 CNV",
    "NDUFB9P2 RNA"
  ],
  "SESN2": [
    "SESN2 CNV",
    "SESN2 RNA",
    "SESN2 Proteo"
  ],
  "PPT2": [
    "PPT2 CNV",
    "PPT2 RNA",
    "PPT2 Proteo"
  ],
  "EIF1AY": [
    "EIF1AY CNV",
    "EIF1AY RNA",
    "EIF1AY Proteo"
  ],
  "GTF2F2P2": [
    "GTF2F2P2 CNV",
    "GTF2F2P2 RNA"
  ],
  "TTC29": [
    "TTC29 CNV",
    "TTC29 RNA"
  ],
  "OR7E97P": [
    "OR7E97P CNV",
    "OR7E97P RNA"
  ],
  "KCNK7": [
    "KCNK7 CNV",
    "KCNK7 RNA"
  ],
  "SDR39U1": [
    "SDR39U1 CNV",
    "SDR39U1 RNA",
    "SDR39U1 Proteo"
  ],
  "CYP2J2": [
    "CYP2J2 CNV",
    "CYP2J2 RNA",
    "CYP2J2 Proteo"
  ],
  "ZNF787": [
    "ZNF787 CNV",
    "ZNF787 RNA",
    "ZNF787 Proteo"
  ],
  "WDR90": [
    "WDR90 CNV",
    "WDR90 RNA",
    "WDR90 Proteo"
  ],
  "TRIM32": [
    "TRIM32 CNV",
    "TRIM32 RNA",
    "TRIM32 Proteo"
  ],
  "H3C14": [
    "H3C14 CNV",
    "H3C14 RNA"
  ],
  "COMMD1": [
    "COMMD1 CNV",
    "COMMD1 RNA",
    "COMMD1 Proteo"
  ],
  "L3MBTL4": [
    "L3MBTL4 CNV",
    "L3MBTL4 RNA"
  ],
  "MYH7": [
    "MYH7 CNV",
    "MYH7 RNA",
    "MYH7 Proteo"
  ],
  "C4BPAP2": [
    "C4BPAP2 CNV",
    "C4BPAP2 RNA"
  ],
  "KRT10": [
    "KRT10 CNV",
    "KRT10 RNA",
    "KRT10 Proteo"
  ],
  "EXO5": [
    "EXO5 CNV",
    "EXO5 RNA"
  ],
  "P2RX6P": [
    "P2RX6P CNV",
    "P2RX6P RNA"
  ],
  "TMEM222": [
    "TMEM222 CNV",
    "TMEM222 RNA",
    "TMEM222 Proteo"
  ],
  "NDRG4": [
    "NDRG4 CNV",
    "NDRG4 RNA",
    "NDRG4 Proteo"
  ],
  "RPL21": [
    "RPL21 CNV",
    "RPL21 RNA",
    "RPL21 Proteo"
  ],
  "COL11A1": [
    "COL11A1 CNV",
    "COL11A1 RNA",
    "COL11A1 Proteo"
  ],
  "CST9LP2": [
    "CST9LP2 CNV",
    "CST9LP2 RNA"
  ],
  "DLGAP5P1": [
    "DLGAP5P1 CNV",
    "DLGAP5P1 RNA"
  ],
  "ZBTB9": [
    "ZBTB9 CNV",
    "ZBTB9 RNA",
    "ZBTB9 Proteo"
  ],
  "SSX5": [
    "SSX5 CNV",
    "SSX5 RNA"
  ],
  "KLHL35": [
    "KLHL35 CNV",
    "KLHL35 RNA"
  ],
  "ANKRD26P1": [
    "ANKRD26P1 CNV",
    "ANKRD26P1 RNA"
  ],
  "C3orf18": [
    "C3orf18 CNV",
    "C3orf18 RNA"
  ],
  "ST3GAL6": [
    "ST3GAL6 CNV",
    "ST3GAL6 RNA",
    "ST3GAL6 Proteo"
  ],
  "ZNF664": [
    "ZNF664 CNV",
    "ZNF664 RNA"
  ],
  "CASTOR1": [
    "CASTOR1 CNV",
    "CASTOR1 RNA",
    "CASTOR1 Proteo"
  ],
  "ARPP19": [
    "ARPP19 CNV",
    "ARPP19 RNA",
    "ARPP19 Proteo"
  ],
  "RECQL5": [
    "RECQL5 CNV",
    "RECQL5 RNA",
    "RECQL5 Proteo"
  ],
  "TTC31": [
    "TTC31 CNV",
    "TTC31 RNA",
    "TTC31 Proteo"
  ],
  "ARL4A": [
    "ARL4A CNV",
    "ARL4A RNA"
  ],
  "C3orf14": [
    "C3orf14 CNV",
    "C3orf14 RNA"
  ],
  "TUBB8P4": [
    "TUBB8P4 CNV",
    "TUBB8P4 RNA"
  ],
  "CCL5": [
    "CCL5 CNV",
    "CCL5 RNA",
    "CCL5 Proteo"
  ],
  "LITAFD": [
    "LITAFD CNV",
    "LITAFD RNA"
  ],
  "PTGER4P2": [
    "PTGER4P2 CNV",
    "PTGER4P2 RNA"
  ],
  "SLC2A3P4": [
    "SLC2A3P4 CNV",
    "SLC2A3P4 RNA"
  ],
  "MCTS1": [
    "MCTS1 CNV",
    "MCTS1 RNA",
    "MCTS1 Proteo"
  ],
  "APOL1": [
    "APOL1 CNV",
    "APOL1 RNA",
    "APOL1 Proteo"
  ],
  "CLECL1": [
    "CLECL1 CNV",
    "CLECL1 RNA"
  ],
  "OR51F2": [
    "OR51F2 CNV",
    "OR51F2 RNA"
  ],
  "WBP1P2": [
    "WBP1P2 CNV",
    "WBP1P2 RNA"
  ],
  "CBFA2T2": [
    "CBFA2T2 CNV",
    "CBFA2T2 RNA",
    "CBFA2T2 Proteo"
  ],
  "VSIG4": [
    "VSIG4 CNV",
    "VSIG4 RNA",
    "VSIG4 Proteo"
  ],
  "MTCO3P15": [
    "MTCO3P15 CNV",
    "MTCO3P15 RNA"
  ],
  "NAP1L1": [
    "NAP1L1 CNV",
    "NAP1L1 RNA",
    "NAP1L1 Proteo"
  ],
  "PKD2L2": [
    "PKD2L2 CNV",
    "PKD2L2 RNA"
  ],
  "STEAP1B": [
    "STEAP1B CNV",
    "STEAP1B RNA"
  ],
  "PPCS": [
    "PPCS CNV",
    "PPCS RNA",
    "PPCS Proteo"
  ],
  "CXXC1P1": [
    "CXXC1P1 CNV",
    "CXXC1P1 RNA"
  ],
  "CYB561D2": [
    "CYB561D2 CNV",
    "CYB561D2 RNA",
    "CYB561D2 Proteo"
  ],
  "EFCAB11": [
    "EFCAB11 CNV",
    "EFCAB11 RNA",
    "EFCAB11 Proteo"
  ],
  "PRRG3": [
    "PRRG3 CNV",
    "PRRG3 RNA"
  ],
  "HERC2P9": [
    "HERC2P9 CNV",
    "HERC2P9 RNA"
  ],
  "OGFOD1": [
    "OGFOD1 CNV",
    "OGFOD1 RNA",
    "OGFOD1 Proteo"
  ],
  "DTD2": [
    "DTD2 CNV",
    "DTD2 RNA",
    "DTD2 Proteo"
  ],
  "NACAP8": [
    "NACAP8 CNV",
    "NACAP8 RNA"
  ],
  "RPL36P19": [
    "RPL36P19 CNV",
    "RPL36P19 RNA"
  ],
  "RPL38": [
    "RPL38 CNV",
    "RPL38 RNA",
    "RPL38 Proteo"
  ],
  "RPL32P23": [
    "RPL32P23 CNV",
    "RPL32P23 RNA"
  ],
  "EEF1A1P1": [
    "EEF1A1P1 CNV",
    "EEF1A1P1 RNA"
  ],
  "COMMD5": [
    "COMMD5 CNV",
    "COMMD5 RNA",
    "COMMD5 Proteo"
  ],
  "TRIM59": [
    "TRIM59 CNV",
    "TRIM59 RNA"
  ],
  "SLCO1B1": [
    "SLCO1B1 CNV",
    "SLCO1B1 RNA"
  ],
  "ABHD17C": [
    "ABHD17C CNV",
    "ABHD17C RNA",
    "ABHD17C Proteo"
  ],
  "LRP8": [
    "LRP8 CNV",
    "LRP8 RNA",
    "LRP8 Proteo"
  ],
  "PHF5FP": [
    "PHF5FP CNV",
    "PHF5FP RNA"
  ],
  "CCDC116": [
    "CCDC116 CNV",
    "CCDC116 RNA"
  ],
  "THAP4": [
    "THAP4 CNV",
    "THAP4 RNA",
    "THAP4 Proteo"
  ],
  "SLC12A2": [
    "SLC12A2 CNV",
    "SLC12A2 RNA",
    "SLC12A2 Proteo"
  ],
  "ATF4P1": [
    "ATF4P1 CNV",
    "ATF4P1 RNA"
  ],
  "MMP23A": [
    "MMP23A CNV",
    "MMP23A RNA"
  ],
  "USF1": [
    "USF1 CNV",
    "USF1 RNA",
    "USF1 Proteo"
  ],
  "PI16": [
    "PI16 CNV",
    "PI16 RNA",
    "PI16 Proteo"
  ],
  "STRA6LP": [
    "STRA6LP CNV",
    "STRA6LP RNA"
  ],
  "PER3": [
    "PER3 CNV",
    "PER3 RNA",
    "PER3 Proteo"
  ],
  "SDHAP2": [
    "SDHAP2 CNV",
    "SDHAP2 RNA"
  ],
  "OR7H1P": [
    "OR7H1P CNV",
    "OR7H1P RNA"
  ],
  "RIC8B": [
    "RIC8B CNV",
    "RIC8B RNA",
    "RIC8B Proteo"
  ],
  "ACTL8": [
    "ACTL8 CNV",
    "ACTL8 RNA",
    "ACTL8 Proteo"
  ],
  "FIG4": [
    "FIG4 CNV",
    "FIG4 RNA",
    "FIG4 Proteo"
  ],
  "HPRT1P2": [
    "HPRT1P2 CNV",
    "HPRT1P2 RNA"
  ],
  "PARP12": [
    "PARP12 CNV",
    "PARP12 RNA",
    "PARP12 Proteo"
  ],
  "PDPN": [
    "PDPN CNV",
    "PDPN RNA",
    "PDPN Proteo"
  ],
  "ZNF350": [
    "ZNF350 CNV",
    "ZNF350 RNA"
  ],
  "FER": [
    "FER CNV",
    "FER RNA",
    "FER Proteo"
  ],
  "OR11G2": [
    "OR11G2 CNV",
    "OR11G2 RNA"
  ],
  "LRIG1": [
    "LRIG1 CNV",
    "LRIG1 RNA",
    "LRIG1 Proteo"
  ],
  "HIGD1AP18": [
    "HIGD1AP18 CNV",
    "HIGD1AP18 RNA"
  ],
  "TKT": [
    "TKT CNV",
    "TKT RNA",
    "TKT Proteo"
  ],
  "SERINC2": [
    "SERINC2 CNV",
    "SERINC2 RNA"
  ],
  "UBE2A": [
    "UBE2A CNV",
    "UBE2A RNA",
    "UBE2A Proteo"
  ],
  "EEF1A1P24": [
    "EEF1A1P24 CNV",
    "EEF1A1P24 RNA"
  ],
  "USP9YP30": [
    "USP9YP30 CNV",
    "USP9YP30 RNA"
  ],
  "GPR141": [
    "GPR141 CNV",
    "GPR141 RNA"
  ],
  "SIRPG": [
    "SIRPG CNV",
    "SIRPG RNA",
    "SIRPG Proteo"
  ],
  "CCNB1IP1P3": [
    "CCNB1IP1P3 CNV",
    "CCNB1IP1P3 RNA"
  ],
  "MTND4P33": [
    "MTND4P33 CNV",
    "MTND4P33 RNA"
  ],
  "RPL35": [
    "RPL35 CNV",
    "RPL35 RNA",
    "RPL35 Proteo"
  ],
  "TNKS": [
    "TNKS CNV",
    "TNKS RNA",
    "TNKS Proteo"
  ],
  "ASS1P12": [
    "ASS1P12 CNV",
    "ASS1P12 RNA"
  ],
  "CASKIN1": [
    "CASKIN1 CNV",
    "CASKIN1 RNA",
    "CASKIN1 Proteo"
  ],
  "SLC25A6P6": [
    "SLC25A6P6 CNV",
    "SLC25A6P6 RNA"
  ],
  "GEMIN2": [
    "GEMIN2 CNV",
    "GEMIN2 RNA",
    "GEMIN2 Proteo"
  ],
  "RPLP0P1": [
    "RPLP0P1 CNV",
    "RPLP0P1 RNA"
  ],
  "ACTG1": [
    "ACTG1 CNV",
    "ACTG1 RNA",
    "ACTG1 Proteo"
  ],
  "ITFG1": [
    "ITFG1 CNV",
    "ITFG1 RNA",
    "ITFG1 Proteo"
  ],
  "SLC11A2": [
    "SLC11A2 CNV",
    "SLC11A2 RNA",
    "SLC11A2 Proteo"
  ],
  "RPS27AP11": [
    "RPS27AP11 CNV",
    "RPS27AP11 RNA"
  ],
  "SDCBPP3": [
    "SDCBPP3 CNV",
    "SDCBPP3 RNA"
  ],
  "NHSL2": [
    "NHSL2 CNV",
    "NHSL2 RNA",
    "NHSL2 Proteo"
  ],
  "RIPOR1": [
    "RIPOR1 CNV",
    "RIPOR1 RNA",
    "RIPOR1 Proteo"
  ],
  "RAB19": [
    "RAB19 CNV",
    "RAB19 RNA",
    "RAB19 Proteo"
  ],
  "TBCE_ENSG00000285053": [
    "TBCE_ENSG00000285053 RNA"
  ],
  "SHISAL1": [
    "SHISAL1 CNV",
    "SHISAL1 RNA"
  ],
  "FEZ1": [
    "FEZ1 CNV",
    "FEZ1 RNA",
    "FEZ1 Proteo"
  ],
  "ADAM23": [
    "ADAM23 CNV",
    "ADAM23 RNA",
    "ADAM23 Proteo"
  ],
  "APOA1": [
    "APOA1 CNV",
    "APOA1 RNA",
    "APOA1 Proteo"
  ],
  "DYNLL1P2": [
    "DYNLL1P2 CNV",
    "DYNLL1P2 RNA"
  ],
  "ERBB2": [
    "ERBB2 CNV",
    "ERBB2 RNA",
    "ERBB2 Proteo"
  ],
  "NUDC": [
    "NUDC CNV",
    "NUDC RNA",
    "NUDC Proteo"
  ],
  "DCDC2B": [
    "DCDC2B CNV",
    "DCDC2B RNA"
  ],
  "EIF3KP3": [
    "EIF3KP3 CNV",
    "EIF3KP3 RNA"
  ],
  "PDE4DIPP3": [
    "PDE4DIPP3 CNV",
    "PDE4DIPP3 RNA"
  ],
  "DIS3L2": [
    "DIS3L2 CNV",
    "DIS3L2 RNA",
    "DIS3L2 Proteo"
  ],
  "CTSLP1": [
    "CTSLP1 CNV",
    "CTSLP1 RNA"
  ],
  "KRT224P": [
    "KRT224P CNV",
    "KRT224P RNA"
  ],
  "THADA": [
    "THADA CNV",
    "THADA RNA",
    "THADA Proteo"
  ],
  "H2BC12": [
    "H2BC12 CNV",
    "H2BC12 RNA"
  ],
  "TRIM60P5Y": [
    "TRIM60P5Y CNV",
    "TRIM60P5Y RNA"
  ],
  "ZNF195": [
    "ZNF195 CNV",
    "ZNF195 RNA",
    "ZNF195 Proteo"
  ],
  "IGKV3D-20": [
    "IGKV3D-20 Proteo"
  ],
  "MAB21L2": [
    "MAB21L2 CNV",
    "MAB21L2 RNA"
  ],
  "RPL36": [
    "RPL36 CNV",
    "RPL36 RNA",
    "RPL36 Proteo"
  ],
  "LTO1P1": [
    "LTO1P1 CNV",
    "LTO1P1 RNA"
  ],
  "GSS": [
    "GSS CNV",
    "GSS RNA",
    "GSS Proteo"
  ],
  "GMPS": [
    "GMPS CNV",
    "GMPS RNA",
    "GMPS Proteo"
  ],
  "BRIX1": [
    "BRIX1 CNV",
    "BRIX1 RNA",
    "BRIX1 Proteo"
  ],
  "UQCRBP2": [
    "UQCRBP2 CNV",
    "UQCRBP2 RNA"
  ],
  "OLFM4": [
    "OLFM4 CNV",
    "OLFM4 RNA",
    "OLFM4 Proteo"
  ],
  "GYPA": [
    "GYPA CNV",
    "GYPA RNA",
    "GYPA Proteo"
  ],
  "DEFB107A": [
    "DEFB107A CNV",
    "DEFB107A RNA"
  ],
  "OTOG": [
    "OTOG CNV",
    "OTOG RNA"
  ],
  "NIP7P2": [
    "NIP7P2 CNV",
    "NIP7P2 RNA"
  ],
  "FSCN1": [
    "FSCN1 CNV",
    "FSCN1 RNA",
    "FSCN1 Proteo"
  ],
  "GNAI2P1": [
    "GNAI2P1 CNV",
    "GNAI2P1 RNA"
  ],
  "POLE": [
    "POLE CNV",
    "POLE RNA",
    "POLE Proteo"
  ],
  "PPP4R3A": [
    "PPP4R3A CNV",
    "PPP4R3A RNA",
    "PPP4R3A Proteo"
  ],
  "PBX3": [
    "PBX3 CNV",
    "PBX3 RNA"
  ],
  "RPL3L": [
    "RPL3L CNV",
    "RPL3L RNA",
    "RPL3L Proteo"
  ],
  "SBDSP1": [
    "SBDSP1 CNV",
    "SBDSP1 RNA"
  ],
  "RNF214": [
    "RNF214 CNV",
    "RNF214 RNA",
    "RNF214 Proteo"
  ],
  "UNC93B2": [
    "UNC93B2 CNV",
    "UNC93B2 RNA"
  ],
  "IFITM10": [
    "IFITM10 CNV",
    "IFITM10 RNA"
  ],
  "SERINC1": [
    "SERINC1 CNV",
    "SERINC1 RNA",
    "SERINC1 Proteo"
  ],
  "ME2": [
    "ME2 CNV",
    "ME2 RNA",
    "ME2 Proteo"
  ],
  "DENND4C": [
    "DENND4C CNV",
    "DENND4C RNA",
    "DENND4C Proteo"
  ],
  "PSMC1P9": [
    "PSMC1P9 CNV",
    "PSMC1P9 RNA"
  ],
  "PRB2": [
    "PRB2 CNV",
    "PRB2 RNA",
    "PRB2 Proteo"
  ],
  "KYNUP2": [
    "KYNUP2 CNV",
    "KYNUP2 RNA"
  ],
  "FAH": [
    "FAH CNV",
    "FAH RNA",
    "FAH Proteo"
  ],
  "PRIMA1": [
    "PRIMA1 CNV",
    "PRIMA1 RNA"
  ],
  "FAM214BP1": [
    "FAM214BP1 CNV",
    "FAM214BP1 RNA"
  ],
  "KRT17P6": [
    "KRT17P6 CNV",
    "KRT17P6 RNA"
  ],
  "PATE2": [
    "PATE2 CNV",
    "PATE2 RNA"
  ],
  "PRSS57": [
    "PRSS57 CNV",
    "PRSS57 RNA",
    "PRSS57 Proteo"
  ],
  "ECE2": [
    "ECE2 CNV",
    "ECE2 RNA"
  ],
  "RNA5SP221": [
    "RNA5SP221 CNV",
    "RNA5SP221 RNA"
  ],
  "CCDC160": [
    "CCDC160 CNV",
    "CCDC160 RNA"
  ],
  "RPSAP28": [
    "RPSAP28 CNV",
    "RPSAP28 RNA"
  ],
  "BOLA2B": [
    "BOLA2B CNV",
    "BOLA2B RNA"
  ],
  "PDE1C": [
    "PDE1C CNV",
    "PDE1C RNA",
    "PDE1C Proteo"
  ],
  "MYO15A": [
    "MYO15A CNV",
    "MYO15A RNA"
  ],
  "IGLV3-19": [
    "IGLV3-19 Proteo"
  ],
  "FAM30B": [
    "FAM30B CNV",
    "FAM30B RNA"
  ],
  "RBPMS2": [
    "RBPMS2 CNV",
    "RBPMS2 RNA",
    "RBPMS2 Proteo"
  ],
  "CSK": [
    "CSK CNV",
    "CSK RNA",
    "CSK Proteo"
  ],
  "FKBP1B": [
    "FKBP1B CNV",
    "FKBP1B RNA",
    "FKBP1B Proteo"
  ],
  "TIMM9P1": [
    "TIMM9P1 CNV",
    "TIMM9P1 RNA"
  ],
  "RNF19BPY": [
    "RNF19BPY CNV",
    "RNF19BPY RNA"
  ],
  "LSM14B": [
    "LSM14B CNV",
    "LSM14B RNA",
    "LSM14B Proteo"
  ],
  "OR10A5": [
    "OR10A5 CNV",
    "OR10A5 RNA"
  ],
  "SIGIRR": [
    "SIGIRR CNV",
    "SIGIRR RNA",
    "SIGIRR Proteo"
  ],
  "ZDBF2": [
    "ZDBF2 CNV",
    "ZDBF2 RNA"
  ],
  "BOD1": [
    "BOD1 CNV",
    "BOD1 RNA",
    "BOD1 Proteo"
  ],
  "RPL26P26": [
    "RPL26P26 CNV",
    "RPL26P26 RNA"
  ],
  "EVA1CP5": [
    "EVA1CP5 CNV",
    "EVA1CP5 RNA"
  ],
  "MTCO2P16": [
    "MTCO2P16 CNV",
    "MTCO2P16 RNA"
  ],
  "ZNF826P": [
    "ZNF826P CNV",
    "ZNF826P RNA"
  ],
  "TMEM183AP1": [
    "TMEM183AP1 CNV",
    "TMEM183AP1 RNA"
  ],
  "TBC1D3P1": [
    "TBC1D3P1 CNV",
    "TBC1D3P1 RNA"
  ],
  "VAC14": [
    "VAC14 CNV",
    "VAC14 RNA",
    "VAC14 Proteo"
  ],
  "KAT5": [
    "KAT5 CNV",
    "KAT5 RNA",
    "KAT5 Proteo"
  ],
  "NT5CP1": [
    "NT5CP1 CNV",
    "NT5CP1 RNA"
  ],
  "MKI67": [
    "MKI67 CNV",
    "MKI67 RNA",
    "MKI67 Proteo"
  ],
  "CPN2": [
    "CPN2 CNV",
    "CPN2 RNA",
    "CPN2 Proteo"
  ],
  "TFDP3": [
    "TFDP3 CNV",
    "TFDP3 RNA"
  ],
  "SNX16": [
    "SNX16 CNV",
    "SNX16 RNA",
    "SNX16 Proteo"
  ],
  "TAF1C": [
    "TAF1C CNV",
    "TAF1C RNA",
    "TAF1C Proteo"
  ],
  "GPR148": [
    "GPR148 CNV",
    "GPR148 RNA"
  ],
  "LOXL1": [
    "LOXL1 CNV",
    "LOXL1 RNA",
    "LOXL1 Proteo"
  ],
  "ZNF80": [
    "ZNF80 CNV",
    "ZNF80 RNA"
  ],
  "DMBT1": [
    "DMBT1 CNV",
    "DMBT1 RNA",
    "DMBT1 Proteo"
  ],
  "IFT74": [
    "IFT74 CNV",
    "IFT74 RNA",
    "IFT74 Proteo"
  ],
  "SPDYE11": [
    "SPDYE11 CNV",
    "SPDYE11 RNA"
  ],
  "HSD3B2": [
    "HSD3B2 CNV",
    "HSD3B2 RNA"
  ],
  "FMOD": [
    "FMOD CNV",
    "FMOD RNA",
    "FMOD Proteo"
  ],
  "PCGF5": [
    "PCGF5 CNV",
    "PCGF5 RNA",
    "PCGF5 Proteo"
  ],
  "ATP13A1": [
    "ATP13A1 CNV",
    "ATP13A1 RNA",
    "ATP13A1 Proteo"
  ],
  "MIER1": [
    "MIER1 CNV",
    "MIER1 RNA",
    "MIER1 Proteo"
  ],
  "SERBP1P5": [
    "SERBP1P5 CNV",
    "SERBP1P5 RNA"
  ],
  "APOH": [
    "APOH CNV",
    "APOH RNA",
    "APOH Proteo"
  ],
  "KLK10": [
    "KLK10 CNV",
    "KLK10 RNA",
    "KLK10 Proteo"
  ],
  "SWSAP1": [
    "SWSAP1 CNV",
    "SWSAP1 RNA"
  ],
  "PEX3": [
    "PEX3 CNV",
    "PEX3 RNA",
    "PEX3 Proteo"
  ],
  "SMPX": [
    "SMPX CNV",
    "SMPX RNA"
  ],
  "PRPF19": [
    "PRPF19 CNV",
    "PRPF19 RNA",
    "PRPF19 Proteo"
  ],
  "SLC47A1": [
    "SLC47A1 CNV",
    "SLC47A1 RNA",
    "SLC47A1 Proteo"
  ],
  "SLC5A4": [
    "SLC5A4 CNV",
    "SLC5A4 RNA"
  ],
  "NCLP1": [
    "NCLP1 CNV",
    "NCLP1 RNA"
  ],
  "DUSP14": [
    "DUSP14 CNV",
    "DUSP14 RNA",
    "DUSP14 Proteo"
  ],
  "EEF1DP1": [
    "EEF1DP1 CNV",
    "EEF1DP1 RNA"
  ],
  "BRI3BPP1": [
    "BRI3BPP1 CNV",
    "BRI3BPP1 RNA"
  ],
  "LYVE1": [
    "LYVE1 CNV",
    "LYVE1 RNA",
    "LYVE1 Proteo"
  ],
  "DNASE1": [
    "DNASE1 CNV",
    "DNASE1 RNA"
  ],
  "URGCP": [
    "URGCP CNV",
    "URGCP RNA",
    "URGCP Proteo"
  ],
  "BORCS8P1": [
    "BORCS8P1 CNV",
    "BORCS8P1 RNA"
  ],
  "SNF8": [
    "SNF8 CNV",
    "SNF8 RNA",
    "SNF8 Proteo"
  ],
  "LRRC55": [
    "LRRC55 CNV",
    "LRRC55 RNA"
  ],
  "PES1P1": [
    "PES1P1 CNV",
    "PES1P1 RNA"
  ],
  "MYOM2": [
    "MYOM2 CNV",
    "MYOM2 RNA",
    "MYOM2 Proteo"
  ],
  "FAM89B": [
    "FAM89B CNV",
    "FAM89B RNA",
    "FAM89B Proteo"
  ],
  "TRIM43CP": [
    "TRIM43CP CNV",
    "TRIM43CP RNA"
  ],
  "IBA57": [
    "IBA57 CNV",
    "IBA57 RNA",
    "IBA57 Proteo"
  ],
  "GPR34": [
    "GPR34 CNV",
    "GPR34 RNA",
    "GPR34 Proteo"
  ],
  "SLC1A7": [
    "SLC1A7 CNV",
    "SLC1A7 RNA"
  ],
  "CIR1P1": [
    "CIR1P1 CNV",
    "CIR1P1 RNA"
  ],
  "COX4I2": [
    "COX4I2 CNV",
    "COX4I2 RNA"
  ],
  "NCOR1P4": [
    "NCOR1P4 CNV",
    "NCOR1P4 RNA"
  ],
  "LSM11": [
    "LSM11 CNV",
    "LSM11 RNA",
    "LSM11 Proteo"
  ],
  "TEX52": [
    "TEX52 CNV",
    "TEX52 RNA"
  ],
  "CENPJ": [
    "CENPJ CNV",
    "CENPJ RNA",
    "CENPJ Proteo"
  ],
  "WDR82": [
    "WDR82 CNV",
    "WDR82 RNA",
    "WDR82 Proteo"
  ],
  "RPL15": [
    "RPL15 CNV",
    "RPL15 RNA",
    "RPL15 Proteo"
  ],
  "CCDC85B": [
    "CCDC85B CNV",
    "CCDC85B RNA",
    "CCDC85B Proteo"
  ],
  "DCTN2": [
    "DCTN2 CNV",
    "DCTN2 RNA",
    "DCTN2 Proteo"
  ],
  "BTBD8": [
    "BTBD8 CNV",
    "BTBD8 RNA",
    "BTBD8 Proteo"
  ],
  "VHL": [
    "VHL CNV",
    "VHL RNA",
    "VHL Proteo"
  ],
  "DUSP11": [
    "DUSP11 CNV",
    "DUSP11 RNA",
    "DUSP11 Proteo"
  ],
  "ENSAP1": [
    "ENSAP1 CNV",
    "ENSAP1 RNA"
  ],
  "SNRPC": [
    "SNRPC CNV",
    "SNRPC RNA",
    "SNRPC Proteo"
  ],
  "YBX1P10": [
    "YBX1P10 CNV",
    "YBX1P10 RNA"
  ],
  "G0S2": [
    "G0S2 CNV",
    "G0S2 RNA"
  ],
  "CAMKK2": [
    "CAMKK2 CNV",
    "CAMKK2 RNA",
    "CAMKK2 Proteo"
  ],
  "NSMF": [
    "NSMF CNV",
    "NSMF RNA",
    "NSMF Proteo"
  ],
  "BCAS2": [
    "BCAS2 CNV",
    "BCAS2 RNA",
    "BCAS2 Proteo"
  ],
  "HLCS": [
    "HLCS CNV",
    "HLCS RNA",
    "HLCS Proteo"
  ],
  "HAVCR2": [
    "HAVCR2 CNV",
    "HAVCR2 RNA",
    "HAVCR2 Proteo"
  ],
  "DCTN6": [
    "DCTN6 CNV",
    "DCTN6 RNA",
    "DCTN6 Proteo"
  ],
  "OR1N2": [
    "OR1N2 CNV",
    "OR1N2 RNA"
  ],
  "RMI2": [
    "RMI2 CNV",
    "RMI2 RNA",
    "RMI2 Proteo"
  ],
  "THAP11": [
    "THAP11 CNV",
    "THAP11 RNA",
    "THAP11 Proteo"
  ],
  "ANKRD35": [
    "ANKRD35 CNV",
    "ANKRD35 RNA",
    "ANKRD35 Proteo"
  ],
  "RNA5SP170": [
    "RNA5SP170 CNV",
    "RNA5SP170 RNA"
  ],
  "KRTAP10-7": [
    "KRTAP10-7 CNV",
    "KRTAP10-7 RNA"
  ],
  "ZNF511": [
    "ZNF511 CNV",
    "ZNF511 RNA",
    "ZNF511 Proteo"
  ],
  "SNX29": [
    "SNX29 CNV",
    "SNX29 RNA",
    "SNX29 Proteo"
  ],
  "PPP1R16B": [
    "PPP1R16B CNV",
    "PPP1R16B RNA",
    "PPP1R16B Proteo"
  ],
  "TRPC6P4": [
    "TRPC6P4 CNV",
    "TRPC6P4 RNA"
  ],
  "OR2K2": [
    "OR2K2 CNV",
    "OR2K2 RNA"
  ],
  "GNRHR2": [
    "GNRHR2 CNV",
    "GNRHR2 RNA"
  ],
  "MTMR6": [
    "MTMR6 CNV",
    "MTMR6 RNA",
    "MTMR6 Proteo"
  ],
  "MKRN1": [
    "MKRN1 CNV",
    "MKRN1 RNA",
    "MKRN1 Proteo"
  ],
  "CBLN4": [
    "CBLN4 CNV",
    "CBLN4 RNA"
  ],
  "TEX33": [
    "TEX33 CNV",
    "TEX33 RNA"
  ],
  "USP20": [
    "USP20 CNV",
    "USP20 RNA",
    "USP20 Proteo"
  ],
  "TTC9": [
    "TTC9 CNV",
    "TTC9 RNA",
    "TTC9 Proteo"
  ],
  "COL14A1": [
    "COL14A1 CNV",
    "COL14A1 RNA",
    "COL14A1 Proteo"
  ],
  "TRAF7": [
    "TRAF7 CNV",
    "TRAF7 RNA",
    "TRAF7 Proteo"
  ],
  "ALG9": [
    "ALG9 CNV",
    "ALG9 RNA"
  ],
  "IL17RE": [
    "IL17RE CNV",
    "IL17RE RNA"
  ],
  "ZNF609": [
    "ZNF609 CNV",
    "ZNF609 RNA",
    "ZNF609 Proteo"
  ],
  "CEP43": [
    "CEP43 CNV",
    "CEP43 RNA",
    "CEP43 Proteo"
  ],
  "AGPAT4": [
    "AGPAT4 CNV",
    "AGPAT4 RNA",
    "AGPAT4 Proteo"
  ],
  "WIPF2": [
    "WIPF2 CNV",
    "WIPF2 RNA",
    "WIPF2 Proteo"
  ],
  "SRP54-AS1": [
    "SRP54-AS1 CNV",
    "SRP54-AS1 RNA"
  ],
  "E2F6P4": [
    "E2F6P4 CNV",
    "E2F6P4 RNA"
  ],
  "CPNE4": [
    "CPNE4 CNV",
    "CPNE4 RNA"
  ],
  "RNA5SP42": [
    "RNA5SP42 CNV",
    "RNA5SP42 RNA"
  ],
  "GEMIN2P2": [
    "GEMIN2P2 CNV",
    "GEMIN2P2 RNA"
  ],
  "OBP2B": [
    "OBP2B CNV",
    "OBP2B RNA"
  ],
  "PER3P1": [
    "PER3P1 CNV",
    "PER3P1 RNA"
  ],
  "OSBPL1A": [
    "OSBPL1A CNV",
    "OSBPL1A RNA",
    "OSBPL1A Proteo"
  ],
  "MPP3": [
    "MPP3 CNV",
    "MPP3 RNA"
  ],
  "IMMP1LP3": [
    "IMMP1LP3 CNV",
    "IMMP1LP3 RNA"
  ],
  "TACR3": [
    "TACR3 CNV",
    "TACR3 RNA"
  ],
  "POGLUT1": [
    "POGLUT1 CNV",
    "POGLUT1 RNA",
    "POGLUT1 Proteo"
  ],
  "ZNF519P1": [
    "ZNF519P1 CNV",
    "ZNF519P1 RNA"
  ],
  "CA5A": [
    "CA5A CNV",
    "CA5A RNA"
  ],
  "SNX33P1": [
    "SNX33P1 CNV",
    "SNX33P1 RNA"
  ],
  "DLX4": [
    "DLX4 CNV",
    "DLX4 RNA"
  ],
  "FUT10": [
    "FUT10 CNV",
    "FUT10 RNA",
    "FUT10 Proteo"
  ],
  "RPL35AP33": [
    "RPL35AP33 CNV",
    "RPL35AP33 RNA"
  ],
  "H3-4": [
    "H3-4 CNV",
    "H3-4 RNA",
    "H3-4 Proteo"
  ],
  "FAIM": [
    "FAIM CNV",
    "FAIM RNA",
    "FAIM Proteo"
  ],
  "CMPK2": [
    "CMPK2 CNV",
    "CMPK2 RNA",
    "CMPK2 Proteo"
  ],
  "CNMD": [
    "CNMD CNV",
    "CNMD RNA"
  ],
  "FREM1": [
    "FREM1 CNV",
    "FREM1 RNA",
    "FREM1 Proteo"
  ],
  "RPL32P30": [
    "RPL32P30 CNV",
    "RPL32P30 RNA"
  ],
  "MTERF1": [
    "MTERF1 CNV",
    "MTERF1 RNA",
    "MTERF1 Proteo"
  ],
  "PLRG1": [
    "PLRG1 CNV",
    "PLRG1 RNA",
    "PLRG1 Proteo"
  ],
  "TNR": [
    "TNR CNV",
    "TNR RNA"
  ],
  "DMAC1": [
    "DMAC1 CNV",
    "DMAC1 RNA",
    "DMAC1 Proteo"
  ],
  "NT5DC1P1": [
    "NT5DC1P1 CNV",
    "NT5DC1P1 RNA"
  ],
  "SNRPCP6": [
    "SNRPCP6 CNV",
    "SNRPCP6 RNA"
  ],
  "CRHR1": [
    "CRHR1 CNV",
    "CRHR1 RNA"
  ],
  "RPSAP29": [
    "RPSAP29 CNV",
    "RPSAP29 RNA"
  ],
  "SSBP4": [
    "SSBP4 CNV",
    "SSBP4 RNA",
    "SSBP4 Proteo"
  ],
  "ANAPC1": [
    "ANAPC1 CNV",
    "ANAPC1 RNA",
    "ANAPC1 Proteo"
  ],
  "ANKRD9": [
    "ANKRD9 CNV",
    "ANKRD9 RNA",
    "ANKRD9 Proteo"
  ],
  "HSP90AB2P": [
    "HSP90AB2P CNV",
    "HSP90AB2P RNA"
  ],
  "USF2": [
    "USF2 CNV",
    "USF2 RNA",
    "USF2 Proteo"
  ],
  "GTF2IP3": [
    "GTF2IP3 CNV",
    "GTF2IP3 RNA"
  ],
  "OR10AF1P": [
    "OR10AF1P CNV",
    "OR10AF1P RNA"
  ],
  "HES7": [
    "HES7 CNV",
    "HES7 RNA"
  ],
  "IMMP1LP1": [
    "IMMP1LP1 CNV",
    "IMMP1LP1 RNA"
  ],
  "GPR50": [
    "GPR50 CNV",
    "GPR50 RNA"
  ],
  "PRIM2": [
    "PRIM2 CNV",
    "PRIM2 RNA",
    "PRIM2 Proteo"
  ],
  "FGF12": [
    "FGF12 CNV",
    "FGF12 RNA"
  ],
  "HLFP1": [
    "HLFP1 CNV",
    "HLFP1 RNA"
  ],
  "MKNK1": [
    "MKNK1 CNV",
    "MKNK1 RNA",
    "MKNK1 Proteo"
  ],
  "PAN3": [
    "PAN3 CNV",
    "PAN3 RNA",
    "PAN3 Proteo"
  ],
  "SDCBP2P1": [
    "SDCBP2P1 CNV",
    "SDCBP2P1 RNA"
  ],
  "REP15": [
    "REP15 CNV",
    "REP15 RNA"
  ],
  "NUP35": [
    "NUP35 CNV",
    "NUP35 RNA",
    "NUP35 Proteo"
  ],
  "STRIP1": [
    "STRIP1 CNV",
    "STRIP1 RNA",
    "STRIP1 Proteo"
  ],
  "SLC9A3R1": [
    "SLC9A3R1 CNV",
    "SLC9A3R1 RNA",
    "SLC9A3R1 Proteo"
  ],
  "SHISA5P1": [
    "SHISA5P1 CNV",
    "SHISA5P1 RNA"
  ],
  "ACOT11": [
    "ACOT11 CNV",
    "ACOT11 RNA",
    "ACOT11 Proteo"
  ],
  "TEX37": [
    "TEX37 CNV",
    "TEX37 RNA"
  ],
  "ALKBH2": [
    "ALKBH2 CNV",
    "ALKBH2 RNA",
    "ALKBH2 Proteo"
  ],
  "MPHOSPH10P7": [
    "MPHOSPH10P7 CNV",
    "MPHOSPH10P7 RNA"
  ],
  "MIA": [
    "MIA CNV",
    "MIA RNA",
    "MIA Proteo"
  ],
  "C17orf49": [
    "C17orf49 CNV",
    "C17orf49 RNA",
    "C17orf49 Proteo"
  ],
  "RAG1": [
    "RAG1 CNV",
    "RAG1 RNA"
  ],
  "PRB3": [
    "PRB3 CNV",
    "PRB3 RNA",
    "PRB3 Proteo"
  ],
  "SAPCD2P1": [
    "SAPCD2P1 CNV",
    "SAPCD2P1 RNA"
  ],
  "EGF": [
    "EGF CNV",
    "EGF RNA"
  ],
  "SNX31": [
    "SNX31 CNV",
    "SNX31 RNA"
  ],
  "KIF21A": [
    "KIF21A CNV",
    "KIF21A RNA",
    "KIF21A Proteo"
  ],
  "TMEM234": [
    "TMEM234 CNV",
    "TMEM234 RNA"
  ],
  "FBXO11": [
    "FBXO11 CNV",
    "FBXO11 RNA",
    "FBXO11 Proteo"
  ],
  "ZNF681": [
    "ZNF681 CNV",
    "ZNF681 RNA"
  ],
  "NUTF2P3": [
    "NUTF2P3 CNV",
    "NUTF2P3 RNA"
  ],
  "GRPEL2": [
    "GRPEL2 CNV",
    "GRPEL2 RNA",
    "GRPEL2 Proteo"
  ],
  "SELENOWP1": [
    "SELENOWP1 CNV",
    "SELENOWP1 RNA"
  ],
  "NAF1": [
    "NAF1 CNV",
    "NAF1 RNA",
    "NAF1 Proteo"
  ],
  "CXCR6": [
    "CXCR6 CNV",
    "CXCR6 RNA"
  ],
  "FKBPL": [
    "FKBPL CNV",
    "FKBPL RNA",
    "FKBPL Proteo"
  ],
  "GNRHR2P1": [
    "GNRHR2P1 CNV",
    "GNRHR2P1 RNA"
  ],
  "RNA5SP522": [
    "RNA5SP522 CNV",
    "RNA5SP522 RNA"
  ],
  "MTND2P2": [
    "MTND2P2 CNV",
    "MTND2P2 RNA"
  ],
  "HNRNPA1P17": [
    "HNRNPA1P17 CNV",
    "HNRNPA1P17 RNA"
  ],
  "ATP5F1AP10": [
    "ATP5F1AP10 CNV",
    "ATP5F1AP10 RNA"
  ],
  "RPL21P103": [
    "RPL21P103 CNV",
    "RPL21P103 RNA"
  ],
  "SLC25A15P1": [
    "SLC25A15P1 CNV",
    "SLC25A15P1 RNA"
  ],
  "ELOA3CP": [
    "ELOA3CP CNV",
    "ELOA3CP RNA"
  ],
  "LMNTD2": [
    "LMNTD2 CNV",
    "LMNTD2 RNA"
  ],
  "HTR7P1": [
    "HTR7P1 CNV",
    "HTR7P1 RNA"
  ],
  "INSIG2": [
    "INSIG2 CNV",
    "INSIG2 RNA",
    "INSIG2 Proteo"
  ],
  "FOSL1": [
    "FOSL1 CNV",
    "FOSL1 RNA",
    "FOSL1 Proteo"
  ],
  "TTC21B": [
    "TTC21B CNV",
    "TTC21B RNA",
    "TTC21B Proteo"
  ],
  "HSD11B1": [
    "HSD11B1 CNV",
    "HSD11B1 RNA",
    "HSD11B1 Proteo"
  ],
  "CORO6": [
    "CORO6 CNV",
    "CORO6 RNA",
    "CORO6 Proteo"
  ],
  "NKX2-2": [
    "NKX2-2 CNV",
    "NKX2-2 RNA"
  ],
  "RPL24P2": [
    "RPL24P2 CNV",
    "RPL24P2 RNA"
  ],
  "MTDHP3": [
    "MTDHP3 CNV",
    "MTDHP3 RNA"
  ],
  "HNRNPA1P44": [
    "HNRNPA1P44 CNV",
    "HNRNPA1P44 RNA"
  ],
  "ZNF329": [
    "ZNF329 CNV",
    "ZNF329 RNA",
    "ZNF329 Proteo"
  ],
  "ZNF496": [
    "ZNF496 CNV",
    "ZNF496 RNA",
    "ZNF496 Proteo"
  ],
  "SIGLECL1": [
    "SIGLECL1 CNV",
    "SIGLECL1 RNA"
  ],
  "B3GAT3": [
    "B3GAT3 CNV",
    "B3GAT3 RNA",
    "B3GAT3 Proteo"
  ],
  "NOG": [
    "NOG CNV",
    "NOG RNA"
  ],
  "OR5AN2P": [
    "OR5AN2P CNV",
    "OR5AN2P RNA"
  ],
  "TSHZ3": [
    "TSHZ3 CNV",
    "TSHZ3 RNA",
    "TSHZ3 Proteo"
  ],
  "SANBR": [
    "SANBR CNV",
    "SANBR RNA"
  ],
  "CRYL1": [
    "CRYL1 CNV",
    "CRYL1 RNA",
    "CRYL1 Proteo"
  ],
  "TMEM92": [
    "TMEM92 CNV",
    "TMEM92 RNA"
  ],
  "MAPK13": [
    "MAPK13 CNV",
    "MAPK13 RNA",
    "MAPK13 Proteo"
  ],
  "PNPLA6": [
    "PNPLA6 CNV",
    "PNPLA6 RNA",
    "PNPLA6 Proteo"
  ],
  "NBPF6": [
    "NBPF6 CNV",
    "NBPF6 RNA"
  ],
  "VN1R48P": [
    "VN1R48P CNV",
    "VN1R48P RNA"
  ],
  "GEM": [
    "GEM CNV",
    "GEM RNA",
    "GEM Proteo"
  ],
  "TMEM225": [
    "TMEM225 CNV",
    "TMEM225 RNA"
  ],
  "FAM3B": [
    "FAM3B CNV",
    "FAM3B RNA",
    "FAM3B Proteo"
  ],
  "OR52T1P": [
    "OR52T1P CNV",
    "OR52T1P RNA"
  ],
  "TRAJ60": [
    "TRAJ60 CNV",
    "TRAJ60 RNA"
  ],
  "NRF1": [
    "NRF1 CNV",
    "NRF1 RNA",
    "NRF1 Proteo"
  ],
  "CETN2": [
    "CETN2 CNV",
    "CETN2 RNA",
    "CETN2 Proteo"
  ],
  "ADCY3": [
    "ADCY3 CNV",
    "ADCY3 RNA",
    "ADCY3 Proteo"
  ],
  "CTSC": [
    "CTSC CNV",
    "CTSC RNA",
    "CTSC Proteo"
  ],
  "ILF2P2": [
    "ILF2P2 CNV",
    "ILF2P2 RNA"
  ],
  "NMRK2": [
    "NMRK2 CNV",
    "NMRK2 RNA"
  ],
  "JAG1": [
    "JAG1 CNV",
    "JAG1 RNA",
    "JAG1 Proteo"
  ],
  "ELP4": [
    "ELP4 CNV",
    "ELP4 RNA",
    "ELP4 Proteo"
  ],
  "RPSAP50": [
    "RPSAP50 CNV",
    "RPSAP50 RNA"
  ],
  "H3P44": [
    "H3P44 CNV",
    "H3P44 RNA"
  ],
  "ROR2": [
    "ROR2 CNV",
    "ROR2 RNA",
    "ROR2 Proteo"
  ],
  "PADI2": [
    "PADI2 CNV",
    "PADI2 RNA",
    "PADI2 Proteo"
  ],
  "HEYL": [
    "HEYL CNV",
    "HEYL RNA"
  ],
  "EIF4A1P9": [
    "EIF4A1P9 CNV",
    "EIF4A1P9 RNA"
  ],
  "TNKS2": [
    "TNKS2 CNV",
    "TNKS2 RNA",
    "TNKS2 Proteo"
  ],
  "TYRO3": [
    "TYRO3 CNV",
    "TYRO3 RNA",
    "TYRO3 Proteo"
  ],
  "PIGCP1": [
    "PIGCP1 CNV",
    "PIGCP1 RNA"
  ],
  "RPL36AP25": [
    "RPL36AP25 CNV",
    "RPL36AP25 RNA"
  ],
  "CDC42P3": [
    "CDC42P3 CNV",
    "CDC42P3 RNA"
  ],
  "IGKV3OR22-2": [
    "IGKV3OR22-2 CNV",
    "IGKV3OR22-2 RNA"
  ],
  "EIF3F": [
    "EIF3F CNV",
    "EIF3F RNA",
    "EIF3F Proteo"
  ],
  "ZSWIM5P3": [
    "ZSWIM5P3 CNV",
    "ZSWIM5P3 RNA"
  ],
  "SNRNP27": [
    "SNRNP27 CNV",
    "SNRNP27 RNA",
    "SNRNP27 Proteo"
  ],
  "CXorf49B": [
    "CXorf49B CNV",
    "CXorf49B RNA"
  ],
  "MRPL9P1": [
    "MRPL9P1 CNV",
    "MRPL9P1 RNA"
  ],
  "MRPS18BP2": [
    "MRPS18BP2 CNV",
    "MRPS18BP2 RNA"
  ],
  "KLHL26": [
    "KLHL26 CNV",
    "KLHL26 RNA",
    "KLHL26 Proteo"
  ],
  "CLCF1": [
    "CLCF1 CNV",
    "CLCF1 RNA"
  ],
  "HMX2": [
    "HMX2 CNV",
    "HMX2 RNA"
  ],
  "NAPB": [
    "NAPB CNV",
    "NAPB RNA",
    "NAPB Proteo"
  ],
  "NFYC": [
    "NFYC CNV",
    "NFYC RNA",
    "NFYC Proteo"
  ],
  "CD5": [
    "CD5 CNV",
    "CD5 RNA",
    "CD5 Proteo"
  ],
  "MTDHP1": [
    "MTDHP1 CNV",
    "MTDHP1 RNA"
  ],
  "ZNF733P": [
    "ZNF733P CNV",
    "ZNF733P RNA"
  ],
  "OR7E136P": [
    "OR7E136P CNV",
    "OR7E136P RNA"
  ],
  "CKMT1A": [
    "CKMT1A CNV",
    "CKMT1A RNA"
  ],
  "ULK2": [
    "ULK2 CNV",
    "ULK2 RNA",
    "ULK2 Proteo"
  ],
  "MAML2": [
    "MAML2 CNV",
    "MAML2 RNA",
    "MAML2 Proteo"
  ],
  "CTDSPL2": [
    "CTDSPL2 CNV",
    "CTDSPL2 RNA",
    "CTDSPL2 Proteo"
  ],
  "SKP1P2": [
    "SKP1P2 CNV",
    "SKP1P2 RNA"
  ],
  "IMMT": [
    "IMMT CNV",
    "IMMT RNA",
    "IMMT Proteo"
  ],
  "RPL29P29": [
    "RPL29P29 CNV",
    "RPL29P29 RNA"
  ],
  "ANKRD36BP2": [
    "ANKRD36BP2 CNV",
    "ANKRD36BP2 RNA"
  ],
  "HYDIN2": [
    "HYDIN2 CNV",
    "HYDIN2 RNA"
  ],
  "NENF": [
    "NENF CNV",
    "NENF RNA",
    "NENF Proteo"
  ],
  "TMEM186": [
    "TMEM186 CNV",
    "TMEM186 RNA",
    "TMEM186 Proteo"
  ],
  "CYP17A1": [
    "CYP17A1 CNV",
    "CYP17A1 RNA"
  ],
  "WDR7": [
    "WDR7 CNV",
    "WDR7 RNA",
    "WDR7 Proteo"
  ],
  "FUT4": [
    "FUT4 CNV",
    "FUT4 RNA",
    "FUT4 Proteo"
  ],
  "OR7M1P": [
    "OR7M1P CNV",
    "OR7M1P RNA"
  ],
  "TRBV22-1": [
    "TRBV22-1 CNV",
    "TRBV22-1 RNA"
  ],
  "Monocytes": [
    "Monocytes Cell_type"
  ],
  "RPL35AP6": [
    "RPL35AP6 CNV",
    "RPL35AP6 RNA"
  ],
  "GFOD1": [
    "GFOD1 CNV",
    "GFOD1 RNA",
    "GFOD1 Proteo"
  ],
  "KRT8P45": [
    "KRT8P45 CNV",
    "KRT8P45 RNA"
  ],
  "KCNJ9": [
    "KCNJ9 CNV",
    "KCNJ9 RNA"
  ],
  "RPL23AP10": [
    "RPL23AP10 CNV",
    "RPL23AP10 RNA"
  ],
  "ZNF20": [
    "ZNF20 CNV",
    "ZNF20 RNA"
  ],
  "RPL23AP1": [
    "RPL23AP1 CNV",
    "RPL23AP1 RNA"
  ],
  "MKRN3": [
    "MKRN3 CNV",
    "MKRN3 RNA"
  ],
  "CACNB1": [
    "CACNB1 CNV",
    "CACNB1 RNA"
  ],
  "HPCAL4": [
    "HPCAL4 CNV",
    "HPCAL4 RNA",
    "HPCAL4 Proteo"
  ],
  "RPL6P20": [
    "RPL6P20 CNV",
    "RPL6P20 RNA"
  ],
  "RPL32P9": [
    "RPL32P9 CNV",
    "RPL32P9 RNA"
  ],
  "P3H3": [
    "P3H3 CNV",
    "P3H3 RNA",
    "P3H3 Proteo"
  ],
  "EIF4H": [
    "EIF4H CNV",
    "EIF4H RNA",
    "EIF4H Proteo"
  ],
  "ADGRF2": [
    "ADGRF2 CNV",
    "ADGRF2 RNA"
  ],
  "LY6G6F": [
    "LY6G6F CNV",
    "LY6G6F RNA"
  ],
  "POM121L1P": [
    "POM121L1P CNV",
    "POM121L1P RNA"
  ],
  "MAPK1": [
    "MAPK1 CNV",
    "MAPK1 RNA",
    "MAPK1 Proteo"
  ],
  "RNA5SP279": [
    "RNA5SP279 CNV",
    "RNA5SP279 RNA"
  ],
  "OR51G1": [
    "OR51G1 CNV",
    "OR51G1 RNA"
  ],
  "FAM20C": [
    "FAM20C CNV",
    "FAM20C RNA",
    "FAM20C Proteo"
  ],
  "ADAM1B": [
    "ADAM1B CNV",
    "ADAM1B RNA"
  ],
  "ARPC1B": [
    "ARPC1B CNV",
    "ARPC1B RNA",
    "ARPC1B Proteo"
  ],
  "HEPHL1": [
    "HEPHL1 CNV",
    "HEPHL1 RNA",
    "HEPHL1 Proteo"
  ],
  "KRT87P": [
    "KRT87P CNV",
    "KRT87P RNA"
  ],
  "IFT43": [
    "IFT43 CNV",
    "IFT43 RNA",
    "IFT43 Proteo"
  ],
  "BMPER": [
    "BMPER CNV",
    "BMPER RNA"
  ],
  "NUDT9": [
    "NUDT9 CNV",
    "NUDT9 RNA",
    "NUDT9 Proteo"
  ],
  "TMEM54": [
    "TMEM54 CNV",
    "TMEM54 RNA"
  ],
  "H2AP": [
    "H2AP CNV",
    "H2AP RNA"
  ],
  "PKLR": [
    "PKLR CNV",
    "PKLR RNA",
    "PKLR Proteo"
  ],
  "UGDH": [
    "UGDH CNV",
    "UGDH RNA",
    "UGDH Proteo"
  ],
  "ZMYND11": [
    "ZMYND11 CNV",
    "ZMYND11 RNA",
    "ZMYND11 Proteo"
  ],
  "CUL1": [
    "CUL1 CNV",
    "CUL1 RNA",
    "CUL1 Proteo"
  ],
  "CCL18": [
    "CCL18 CNV",
    "CCL18 RNA",
    "CCL18 Proteo"
  ],
  "OR4F15": [
    "OR4F15 CNV",
    "OR4F15 RNA"
  ],
  "BPIFB5P": [
    "BPIFB5P CNV",
    "BPIFB5P RNA"
  ],
  "TENM1": [
    "TENM1 CNV",
    "TENM1 RNA"
  ],
  "RNA5SP412": [
    "RNA5SP412 CNV",
    "RNA5SP412 RNA"
  ],
  "SNPH": [
    "SNPH CNV",
    "SNPH RNA"
  ],
  "SYT10": [
    "SYT10 CNV",
    "SYT10 RNA"
  ],
  "TMEM150A": [
    "TMEM150A CNV",
    "TMEM150A RNA"
  ],
  "TAL1": [
    "TAL1 CNV",
    "TAL1 RNA"
  ],
  "DPM3": [
    "DPM3 CNV",
    "DPM3 RNA",
    "DPM3 Proteo"
  ],
  "DOCK9": [
    "DOCK9 CNV",
    "DOCK9 RNA",
    "DOCK9 Proteo"
  ],
  "PTGDR2": [
    "PTGDR2 CNV",
    "PTGDR2 RNA"
  ],
  "RPL23": [
    "RPL23 CNV",
    "RPL23 RNA",
    "RPL23 Proteo"
  ],
  "NUGGC": [
    "NUGGC CNV",
    "NUGGC RNA"
  ],
  "FRG2DP": [
    "FRG2DP CNV",
    "FRG2DP RNA"
  ],
  "KCNIP1": [
    "KCNIP1 CNV",
    "KCNIP1 RNA"
  ],
  "CNPY4": [
    "CNPY4 CNV",
    "CNPY4 RNA",
    "CNPY4 Proteo"
  ],
  "DNAJA4": [
    "DNAJA4 CNV",
    "DNAJA4 RNA",
    "DNAJA4 Proteo"
  ],
  "MTND6P20": [
    "MTND6P20 CNV",
    "MTND6P20 RNA"
  ],
  "RNA5SP19": [
    "RNA5SP19 CNV",
    "RNA5SP19 RNA"
  ],
  "IL2RG": [
    "IL2RG CNV",
    "IL2RG RNA",
    "IL2RG Proteo"
  ],
  "SETP10": [
    "SETP10 CNV",
    "SETP10 RNA"
  ],
  "FAUP1": [
    "FAUP1 CNV",
    "FAUP1 RNA"
  ],
  "CCDC42": [
    "CCDC42 CNV",
    "CCDC42 RNA"
  ],
  "SAMD9": [
    "SAMD9 CNV",
    "SAMD9 RNA",
    "SAMD9 Proteo"
  ],
  "CYREN": [
    "CYREN CNV",
    "CYREN RNA",
    "CYREN Proteo"
  ],
  "ZNF580": [
    "ZNF580 CNV",
    "ZNF580 RNA",
    "ZNF580 Proteo"
  ],
  "PDHA1": [
    "PDHA1 CNV",
    "PDHA1 RNA",
    "PDHA1 Proteo"
  ],
  "GYG1P2": [
    "GYG1P2 CNV",
    "GYG1P2 RNA"
  ],
  "MTARC1": [
    "MTARC1 CNV",
    "MTARC1 RNA",
    "MTARC1 Proteo"
  ],
  "PABPC1P8": [
    "PABPC1P8 CNV",
    "PABPC1P8 RNA"
  ],
  "LEMD2": [
    "LEMD2 CNV",
    "LEMD2 RNA",
    "LEMD2 Proteo"
  ],
  "PKD1P6": [
    "PKD1P6 CNV",
    "PKD1P6 RNA"
  ],
  "MTCO3P24": [
    "MTCO3P24 CNV",
    "MTCO3P24 RNA"
  ],
  "DDX53": [
    "DDX53 CNV",
    "DDX53 RNA"
  ],
  "SAMD10": [
    "SAMD10 CNV",
    "SAMD10 RNA"
  ],
  "CAPS2": [
    "CAPS2 CNV",
    "CAPS2 RNA"
  ],
  "RPL23AP95": [
    "RPL23AP95 CNV",
    "RPL23AP95 RNA"
  ],
  "ATP1A1": [
    "ATP1A1 CNV",
    "ATP1A1 RNA",
    "ATP1A1 Proteo"
  ],
  "MED15P9": [
    "MED15P9 CNV",
    "MED15P9 RNA"
  ],
  "CXADR": [
    "CXADR CNV",
    "CXADR RNA",
    "CXADR Proteo"
  ],
  "LSM3P3": [
    "LSM3P3 CNV",
    "LSM3P3 RNA"
  ],
  "PRAMEF12": [
    "PRAMEF12 CNV",
    "PRAMEF12 RNA"
  ],
  "RPL21P134": [
    "RPL21P134 CNV",
    "RPL21P134 RNA"
  ],
  "RLN2": [
    "RLN2 CNV",
    "RLN2 RNA"
  ],
  "KPNA2P3": [
    "KPNA2P3 CNV",
    "KPNA2P3 RNA"
  ],
  "HSP90B1": [
    "HSP90B1 CNV",
    "HSP90B1 RNA",
    "HSP90B1 Proteo"
  ],
  "RPS27P25": [
    "RPS27P25 CNV",
    "RPS27P25 RNA"
  ],
  "RPL23AP3": [
    "RPL23AP3 CNV",
    "RPL23AP3 RNA"
  ],
  "PADI6": [
    "PADI6 CNV",
    "PADI6 RNA"
  ],
  "PRDM10": [
    "PRDM10 CNV",
    "PRDM10 RNA",
    "PRDM10 Proteo"
  ],
  "NIBAN2": [
    "NIBAN2 CNV",
    "NIBAN2 RNA",
    "NIBAN2 Proteo"
  ],
  "OR5AN1": [
    "OR5AN1 CNV",
    "OR5AN1 RNA"
  ],
  "TMEM145": [
    "TMEM145 CNV",
    "TMEM145 RNA"
  ],
  "KRT17": [
    "KRT17 CNV",
    "KRT17 RNA",
    "KRT17 Proteo"
  ],
  "SLC25A47": [
    "SLC25A47 CNV",
    "SLC25A47 RNA"
  ],
  "FNDC11": [
    "FNDC11 CNV",
    "FNDC11 RNA"
  ],
  "ENPP7P12": [
    "ENPP7P12 CNV",
    "ENPP7P12 RNA"
  ],
  "ALDH4A1": [
    "ALDH4A1 CNV",
    "ALDH4A1 RNA",
    "ALDH4A1 Proteo"
  ],
  "PRSS42P": [
    "PRSS42P CNV",
    "PRSS42P RNA"
  ],
  "ATP8B5P": [
    "ATP8B5P CNV",
    "ATP8B5P RNA"
  ],
  "RAB40B": [
    "RAB40B CNV",
    "RAB40B RNA"
  ],
  "MTCYBP42": [
    "MTCYBP42 CNV",
    "MTCYBP42 RNA"
  ],
  "GDPD4": [
    "GDPD4 CNV",
    "GDPD4 RNA"
  ],
  "CDC42SE2": [
    "CDC42SE2 CNV",
    "CDC42SE2 RNA",
    "CDC42SE2 Proteo"
  ],
  "MTCO1P28": [
    "MTCO1P28 CNV",
    "MTCO1P28 RNA"
  ],
  "LLPHP2": [
    "LLPHP2 CNV",
    "LLPHP2 RNA"
  ],
  "ACOT2": [
    "ACOT2 CNV",
    "ACOT2 RNA",
    "ACOT2 Proteo"
  ],
  "PLEKHM1": [
    "PLEKHM1 CNV",
    "PLEKHM1 RNA",
    "PLEKHM1 Proteo"
  ],
  "H4C14": [
    "H4C14 CNV",
    "H4C14 RNA"
  ],
  "FMO5": [
    "FMO5 CNV",
    "FMO5 RNA",
    "FMO5 Proteo"
  ],
  "METTL5": [
    "METTL5 CNV",
    "METTL5 RNA",
    "METTL5 Proteo"
  ],
  "CHCHD3P1": [
    "CHCHD3P1 CNV",
    "CHCHD3P1 RNA"
  ],
  "ELOF1": [
    "ELOF1 CNV",
    "ELOF1 RNA",
    "ELOF1 Proteo"
  ],
  "BANF1": [
    "BANF1 CNV",
    "BANF1 RNA",
    "BANF1 Proteo"
  ],
  "HLA-G": [
    "HLA-G CNV",
    "HLA-G RNA",
    "HLA-G Proteo"
  ],
  "CDH1": [
    "CDH1 CNV",
    "CDH1 RNA",
    "CDH1 Proteo"
  ],
  "CD300LF": [
    "CD300LF CNV",
    "CD300LF RNA",
    "CD300LF Proteo"
  ],
  "PTPRN": [
    "PTPRN CNV",
    "PTPRN RNA"
  ],
  "TLNRD1": [
    "TLNRD1 CNV",
    "TLNRD1 RNA",
    "TLNRD1 Proteo"
  ],
  "XG": [
    "XG CNV",
    "XG RNA"
  ],
  "XAGE1B": [
    "XAGE1B CNV",
    "XAGE1B RNA"
  ],
  "CATSPER3": [
    "CATSPER3 CNV",
    "CATSPER3 RNA"
  ],
  "ABCB8": [
    "ABCB8 CNV",
    "ABCB8 RNA",
    "ABCB8 Proteo"
  ],
  "FTHL18P": [
    "FTHL18P CNV",
    "FTHL18P RNA"
  ],
  "BCL2L14": [
    "BCL2L14 CNV",
    "BCL2L14 RNA"
  ],
  "RPL32P10": [
    "RPL32P10 CNV",
    "RPL32P10 RNA"
  ],
  "BRD7P4": [
    "BRD7P4 CNV",
    "BRD7P4 RNA"
  ],
  "TAPT1": [
    "TAPT1 CNV",
    "TAPT1 RNA",
    "TAPT1 Proteo"
  ],
  "CLDN6": [
    "CLDN6 CNV",
    "CLDN6 RNA"
  ],
  "CHRNA3": [
    "CHRNA3 CNV",
    "CHRNA3 RNA"
  ],
  "TMEM125": [
    "TMEM125 CNV",
    "TMEM125 RNA"
  ],
  "CD151": [
    "CD151 CNV",
    "CD151 RNA",
    "CD151 Proteo"
  ],
  "ARHGEF12": [
    "ARHGEF12 CNV",
    "ARHGEF12 RNA",
    "ARHGEF12 Proteo"
  ],
  "RNA5SP251": [
    "RNA5SP251 CNV",
    "RNA5SP251 RNA"
  ],
  "CBLN2": [
    "CBLN2 CNV",
    "CBLN2 RNA"
  ],
  "RPS2P46": [
    "RPS2P46 CNV",
    "RPS2P46 RNA"
  ],
  "TSR3": [
    "TSR3 CNV",
    "TSR3 RNA",
    "TSR3 Proteo"
  ],
  "KIAA1328": [
    "KIAA1328 CNV",
    "KIAA1328 RNA",
    "KIAA1328 Proteo"
  ],
  "REXO1L10P": [
    "REXO1L10P CNV",
    "REXO1L10P RNA"
  ],
  "GCLC": [
    "GCLC CNV",
    "GCLC RNA",
    "GCLC Proteo"
  ],
  "DUS4L-BCAP29": [
    "DUS4L-BCAP29 Proteo"
  ],
  "CCND3": [
    "CCND3 CNV",
    "CCND3 RNA",
    "CCND3 Proteo"
  ],
  "TRMT112": [
    "TRMT112 CNV",
    "TRMT112 RNA",
    "TRMT112 Proteo"
  ],
  "RPL6P8": [
    "RPL6P8 CNV",
    "RPL6P8 RNA"
  ],
  "SCYGR3": [
    "SCYGR3 CNV",
    "SCYGR3 RNA"
  ],
  "TTC30B": [
    "TTC30B CNV",
    "TTC30B RNA",
    "TTC30B Proteo"
  ],
  "DMBX1": [
    "DMBX1 CNV",
    "DMBX1 RNA"
  ],
  "SMIM11P1": [
    "SMIM11P1 CNV",
    "SMIM11P1 RNA"
  ],
  "GAREM1": [
    "GAREM1 CNV",
    "GAREM1 RNA",
    "GAREM1 Proteo"
  ],
  "TRADD": [
    "TRADD CNV",
    "TRADD RNA",
    "TRADD Proteo"
  ],
  "MUTYH": [
    "MUTYH CNV",
    "MUTYH RNA",
    "MUTYH Proteo"
  ],
  "GOLGA6A": [
    "GOLGA6A CNV",
    "GOLGA6A RNA"
  ],
  "RPSAP67": [
    "RPSAP67 CNV",
    "RPSAP67 RNA"
  ],
  "PLA2G4A": [
    "PLA2G4A CNV",
    "PLA2G4A RNA",
    "PLA2G4A Proteo"
  ],
  "ZZEF1": [
    "ZZEF1 CNV",
    "ZZEF1 RNA",
    "ZZEF1 Proteo"
  ],
  "H3P9": [
    "H3P9 CNV",
    "H3P9 RNA"
  ],
  "DYNLT1": [
    "DYNLT1 CNV",
    "DYNLT1 RNA",
    "DYNLT1 Proteo"
  ],
  "PCIF1": [
    "PCIF1 CNV",
    "PCIF1 RNA",
    "PCIF1 Proteo"
  ],
  "NTSR2": [
    "NTSR2 CNV",
    "NTSR2 RNA"
  ],
  "HCK": [
    "HCK CNV",
    "HCK RNA",
    "HCK Proteo"
  ],
  "SPRING1P2": [
    "SPRING1P2 CNV",
    "SPRING1P2 RNA"
  ],
  "FSBP": [
    "FSBP CNV",
    "FSBP RNA"
  ],
  "H3P10": [
    "H3P10 CNV",
    "H3P10 RNA"
  ],
  "PRELID1": [
    "PRELID1 CNV",
    "PRELID1 RNA",
    "PRELID1 Proteo"
  ],
  "FAM167B": [
    "FAM167B CNV",
    "FAM167B RNA",
    "FAM167B Proteo"
  ],
  "F8A3": [
    "F8A3 CNV",
    "F8A3 RNA"
  ],
  "FAM90A4P": [
    "FAM90A4P CNV",
    "FAM90A4P RNA"
  ],
  "SMCHD1": [
    "SMCHD1 CNV",
    "SMCHD1 RNA",
    "SMCHD1 Proteo"
  ],
  "GSC": [
    "GSC CNV",
    "GSC RNA"
  ],
  "H2AZP2": [
    "H2AZP2 CNV",
    "H2AZP2 RNA"
  ],
  "DNAJC5B": [
    "DNAJC5B CNV",
    "DNAJC5B RNA"
  ],
  "TMEM132D": [
    "TMEM132D CNV",
    "TMEM132D RNA"
  ],
  "UBE2D3P1": [
    "UBE2D3P1 CNV",
    "UBE2D3P1 RNA"
  ],
  "RDH5": [
    "RDH5 CNV",
    "RDH5 RNA",
    "RDH5 Proteo"
  ],
  "TSFM": [
    "TSFM CNV",
    "TSFM RNA",
    "TSFM Proteo"
  ],
  "AKR1C1": [
    "AKR1C1 CNV",
    "AKR1C1 RNA",
    "AKR1C1 Proteo"
  ],
  "PPIAP77": [
    "PPIAP77 CNV",
    "PPIAP77 RNA"
  ],
  "HNRNPA1P47": [
    "HNRNPA1P47 CNV",
    "HNRNPA1P47 RNA"
  ],
  "IRS2": [
    "IRS2 CNV",
    "IRS2 RNA",
    "IRS2 Proteo"
  ],
  "DPYSL3": [
    "DPYSL3 CNV",
    "DPYSL3 RNA",
    "DPYSL3 Proteo"
  ],
  "TAF5": [
    "TAF5 CNV",
    "TAF5 RNA",
    "TAF5 Proteo"
  ],
  "NMNAT1P2": [
    "NMNAT1P2 CNV",
    "NMNAT1P2 RNA"
  ],
  "ARHGAP40": [
    "ARHGAP40 CNV",
    "ARHGAP40 RNA"
  ],
  "CDCA2": [
    "CDCA2 CNV",
    "CDCA2 RNA",
    "CDCA2 Proteo"
  ],
  "KRT8P2": [
    "KRT8P2 CNV",
    "KRT8P2 RNA"
  ],
  "TENM3": [
    "TENM3 CNV",
    "TENM3 RNA",
    "TENM3 Proteo"
  ],
  "CTSLP3": [
    "CTSLP3 CNV",
    "CTSLP3 RNA"
  ],
  "SATB2": [
    "SATB2 CNV",
    "SATB2 RNA",
    "SATB2 Proteo"
  ],
  "BNIP3L": [
    "BNIP3L CNV",
    "BNIP3L RNA",
    "BNIP3L Proteo"
  ],
  "CDON": [
    "CDON CNV",
    "CDON RNA"
  ],
  "SEL1L3": [
    "SEL1L3 CNV",
    "SEL1L3 RNA",
    "SEL1L3 Proteo"
  ],
  "TVP23BP1": [
    "TVP23BP1 CNV",
    "TVP23BP1 RNA"
  ],
  "RPS21P8": [
    "RPS21P8 CNV",
    "RPS21P8 RNA"
  ],
  "EXOSC2": [
    "EXOSC2 CNV",
    "EXOSC2 RNA",
    "EXOSC2 Proteo"
  ],
  "FABP5P6": [
    "FABP5P6 CNV",
    "FABP5P6 RNA"
  ],
  "TRAJ17": [
    "TRAJ17 Proteo"
  ],
  "NCF4": [
    "NCF4 CNV",
    "NCF4 RNA",
    "NCF4 Proteo"
  ],
  "VN1R90P": [
    "VN1R90P CNV",
    "VN1R90P RNA"
  ],
  "DEFB131B": [
    "DEFB131B CNV",
    "DEFB131B RNA"
  ],
  "BCL2L13": [
    "BCL2L13 CNV",
    "BCL2L13 RNA",
    "BCL2L13 Proteo"
  ],
  "POTEI": [
    "POTEI CNV",
    "POTEI RNA",
    "POTEI Proteo"
  ],
  "PPP1R7": [
    "PPP1R7 CNV",
    "PPP1R7 RNA",
    "PPP1R7 Proteo"
  ],
  "RAPGEF5": [
    "RAPGEF5 CNV",
    "RAPGEF5 RNA",
    "RAPGEF5 Proteo"
  ],
  "ANKRD11": [
    "ANKRD11 CNV",
    "ANKRD11 RNA",
    "ANKRD11 Proteo"
  ],
  "GAPDHP68": [
    "GAPDHP68 CNV",
    "GAPDHP68 RNA"
  ],
  "RNA5SP179": [
    "RNA5SP179 CNV",
    "RNA5SP179 RNA"
  ],
  "CALML4": [
    "CALML4 CNV",
    "CALML4 RNA",
    "CALML4 Proteo"
  ],
  "DGCR6L": [
    "DGCR6L CNV",
    "DGCR6L RNA",
    "DGCR6L Proteo"
  ],
  "RPL21P107": [
    "RPL21P107 CNV",
    "RPL21P107 RNA"
  ],
  "H3C3": [
    "H3C3 CNV",
    "H3C3 RNA"
  ],
  "ZNF692": [
    "ZNF692 CNV",
    "ZNF692 RNA",
    "ZNF692 Proteo"
  ],
  "SEC11C": [
    "SEC11C CNV",
    "SEC11C RNA",
    "SEC11C Proteo"
  ],
  "ASAP2": [
    "ASAP2 CNV",
    "ASAP2 RNA",
    "ASAP2 Proteo"
  ],
  "LLPHP3": [
    "LLPHP3 CNV",
    "LLPHP3 RNA"
  ],
  "NPAP1P4": [
    "NPAP1P4 CNV",
    "NPAP1P4 RNA"
  ],
  "NOD1": [
    "NOD1 CNV",
    "NOD1 RNA",
    "NOD1 Proteo"
  ],
  "IGFL3": [
    "IGFL3 CNV",
    "IGFL3 RNA"
  ],
  "CHEK2": [
    "CHEK2 CNV",
    "CHEK2 RNA",
    "CHEK2 Proteo"
  ],
  "KRTDAP": [
    "KRTDAP CNV",
    "KRTDAP RNA",
    "KRTDAP Proteo"
  ],
  "ORAI3": [
    "ORAI3 CNV",
    "ORAI3 RNA",
    "ORAI3 Proteo"
  ],
  "BACE1": [
    "BACE1 CNV",
    "BACE1 RNA",
    "BACE1 Proteo"
  ],
  "GTF2I": [
    "GTF2I CNV",
    "GTF2I RNA",
    "GTF2I Proteo"
  ],
  "TYMS": [
    "TYMS CNV",
    "TYMS RNA",
    "TYMS Proteo"
  ],
  "KIR2DP1": [
    "KIR2DP1 CNV",
    "KIR2DP1 RNA"
  ],
  "SYT14": [
    "SYT14 CNV",
    "SYT14 RNA"
  ],
  "WBP1LP1": [
    "WBP1LP1 CNV",
    "WBP1LP1 RNA"
  ],
  "RCN2": [
    "RCN2 CNV",
    "RCN2 RNA",
    "RCN2 Proteo"
  ],
  "RPL37P11": [
    "RPL37P11 CNV",
    "RPL37P11 RNA"
  ],
  "ATP5MC2P4": [
    "ATP5MC2P4 CNV",
    "ATP5MC2P4 RNA"
  ],
  "LARP7P4": [
    "LARP7P4 CNV",
    "LARP7P4 RNA"
  ],
  "C21orf62": [
    "C21orf62 CNV",
    "C21orf62 RNA"
  ],
  "LYPD2": [
    "LYPD2 CNV",
    "LYPD2 RNA"
  ],
  "MTFP1": [
    "MTFP1 CNV",
    "MTFP1 RNA",
    "MTFP1 Proteo"
  ],
  "HNRNPH3P1": [
    "HNRNPH3P1 CNV",
    "HNRNPH3P1 RNA"
  ],
  "PPP3CC": [
    "PPP3CC CNV",
    "PPP3CC RNA",
    "PPP3CC Proteo"
  ],
  "EP300": [
    "EP300 CNV",
    "EP300 RNA",
    "EP300 Proteo"
  ],
  "CLUAP1": [
    "CLUAP1 CNV",
    "CLUAP1 RNA",
    "CLUAP1 Proteo"
  ],
  "CSPG5": [
    "CSPG5 CNV",
    "CSPG5 RNA"
  ],
  "ADD2": [
    "ADD2 CNV",
    "ADD2 RNA",
    "ADD2 Proteo"
  ],
  "NRAP": [
    "NRAP CNV",
    "NRAP RNA",
    "NRAP Proteo"
  ],
  "RNA5SP460": [
    "RNA5SP460 CNV",
    "RNA5SP460 RNA"
  ],
  "TONSL": [
    "TONSL CNV",
    "TONSL RNA",
    "TONSL Proteo"
  ],
  "ANP32B": [
    "ANP32B CNV",
    "ANP32B RNA",
    "ANP32B Proteo"
  ],
  "RPL35AP18": [
    "RPL35AP18 CNV",
    "RPL35AP18 RNA"
  ],
  "FABP5P14": [
    "FABP5P14 CNV",
    "FABP5P14 RNA"
  ],
  "WDR38": [
    "WDR38 CNV",
    "WDR38 RNA"
  ],
  "CCDC152": [
    "CCDC152 CNV",
    "CCDC152 RNA",
    "CCDC152 Proteo"
  ],
  "ITGA1": [
    "ITGA1 CNV",
    "ITGA1 RNA",
    "ITGA1 Proteo"
  ],
  "RPL7P48": [
    "RPL7P48 CNV",
    "RPL7P48 RNA"
  ],
  "GKN1": [
    "GKN1 CNV",
    "GKN1 RNA"
  ],
  "VENTXP6": [
    "VENTXP6 CNV",
    "VENTXP6 RNA"
  ],
  "MAPK15": [
    "MAPK15 CNV",
    "MAPK15 RNA"
  ],
  "RPS29P13": [
    "RPS29P13 CNV",
    "RPS29P13 RNA"
  ],
  "EDN2": [
    "EDN2 CNV",
    "EDN2 RNA"
  ],
  "SLC25A5P7": [
    "SLC25A5P7 CNV",
    "SLC25A5P7 RNA"
  ],
  "IGHG3": [
    "IGHG3 Proteo"
  ],
  "CRPPA": [
    "CRPPA CNV",
    "CRPPA RNA",
    "CRPPA Proteo"
  ],
  "EIF4A1P5": [
    "EIF4A1P5 CNV",
    "EIF4A1P5 RNA"
  ],
  "GGPS1": [
    "GGPS1 CNV",
    "GGPS1 RNA",
    "GGPS1 Proteo"
  ],
  "KCTD9P3": [
    "KCTD9P3 CNV",
    "KCTD9P3 RNA"
  ],
  "AGR2": [
    "AGR2 CNV",
    "AGR2 RNA",
    "AGR2 Proteo"
  ],
  "RCC2P7": [
    "RCC2P7 CNV",
    "RCC2P7 RNA"
  ],
  "PRDM12": [
    "PRDM12 CNV",
    "PRDM12 RNA"
  ],
  "TOLLIP": [
    "TOLLIP CNV",
    "TOLLIP RNA",
    "TOLLIP Proteo"
  ],
  "ZKSCAN7": [
    "ZKSCAN7 CNV",
    "ZKSCAN7 RNA"
  ],
  "TMEM127": [
    "TMEM127 CNV",
    "TMEM127 RNA",
    "TMEM127 Proteo"
  ],
  "SUPT20HL2": [
    "SUPT20HL2 CNV",
    "SUPT20HL2 RNA"
  ],
  "CPOX": [
    "CPOX CNV",
    "CPOX RNA",
    "CPOX Proteo"
  ],
  "PAX5": [
    "PAX5 CNV",
    "PAX5 RNA",
    "PAX5 Proteo"
  ],
  "AP3S1": [
    "AP3S1 CNV",
    "AP3S1 RNA",
    "AP3S1 Proteo"
  ],
  "MBD3": [
    "MBD3 CNV",
    "MBD3 RNA",
    "MBD3 Proteo"
  ],
  "WDR75": [
    "WDR75 CNV",
    "WDR75 RNA",
    "WDR75 Proteo"
  ],
  "ZNF276": [
    "ZNF276 CNV",
    "ZNF276 RNA",
    "ZNF276 Proteo"
  ],
  "C6orf120": [
    "C6orf120 CNV",
    "C6orf120 RNA",
    "C6orf120 Proteo"
  ],
  "TRIP4": [
    "TRIP4 CNV",
    "TRIP4 RNA",
    "TRIP4 Proteo"
  ],
  "DNAH2": [
    "DNAH2 CNV",
    "DNAH2 RNA"
  ],
  "WASF4P": [
    "WASF4P CNV",
    "WASF4P RNA"
  ],
  "TXN": [
    "TXN CNV",
    "TXN RNA",
    "TXN Proteo"
  ],
  "SELP": [
    "SELP CNV",
    "SELP RNA",
    "SELP Proteo"
  ],
  "GAGE12G": [
    "GAGE12G CNV",
    "GAGE12G RNA"
  ],
  "TAF11L6": [
    "TAF11L6 CNV",
    "TAF11L6 RNA"
  ],
  "FASTKD5": [
    "FASTKD5 CNV",
    "FASTKD5 RNA",
    "FASTKD5 Proteo"
  ],
  "SERTM2": [
    "SERTM2 CNV",
    "SERTM2 RNA"
  ],
  "UCHL3": [
    "UCHL3 CNV",
    "UCHL3 RNA",
    "UCHL3 Proteo"
  ],
  "HLA-DQA2": [
    "HLA-DQA2 CNV",
    "HLA-DQA2 RNA"
  ],
  "KTI12": [
    "KTI12 CNV",
    "KTI12 RNA",
    "KTI12 Proteo"
  ],
  "MAGEA11": [
    "MAGEA11 CNV",
    "MAGEA11 RNA"
  ],
  "MTCO1P31": [
    "MTCO1P31 CNV",
    "MTCO1P31 RNA"
  ],
  "PA2G4P2": [
    "PA2G4P2 CNV",
    "PA2G4P2 RNA"
  ],
  "FUT1": [
    "FUT1 CNV",
    "FUT1 RNA"
  ],
  "PRRC2A": [
    "PRRC2A CNV",
    "PRRC2A RNA",
    "PRRC2A Proteo"
  ],
  "NUP133": [
    "NUP133 CNV",
    "NUP133 RNA",
    "NUP133 Proteo"
  ],
  "CD83": [
    "CD83 CNV",
    "CD83 RNA",
    "CD83 Proteo"
  ],
  "TGIF2P1": [
    "TGIF2P1 CNV",
    "TGIF2P1 RNA"
  ],
  "NDUFS6P1": [
    "NDUFS6P1 CNV",
    "NDUFS6P1 RNA"
  ],
  "MTND4LP22": [
    "MTND4LP22 CNV",
    "MTND4LP22 RNA"
  ],
  "SCAND2P": [
    "SCAND2P CNV",
    "SCAND2P RNA"
  ],
  "C10orf88": [
    "C10orf88 CNV",
    "C10orf88 RNA",
    "C10orf88 Proteo"
  ],
  "HNF1B": [
    "HNF1B CNV",
    "HNF1B RNA"
  ],
  "CTAGE8": [
    "CTAGE8 CNV",
    "CTAGE8 RNA"
  ],
  "MYMX": [
    "MYMX CNV",
    "MYMX RNA",
    "MYMX Proteo"
  ],
  "DBN1": [
    "DBN1 CNV",
    "DBN1 RNA",
    "DBN1 Proteo"
  ],
  "DTL": [
    "DTL CNV",
    "DTL RNA",
    "DTL Proteo"
  ],
  "C6orf136": [
    "C6orf136 CNV",
    "C6orf136 RNA",
    "C6orf136 Proteo"
  ],
  "SLC35F2": [
    "SLC35F2 CNV",
    "SLC35F2 RNA",
    "SLC35F2 Proteo"
  ],
  "FAU": [
    "FAU CNV",
    "FAU RNA",
    "FAU Proteo"
  ],
  "MRPS6": [
    "MRPS6 CNV",
    "MRPS6 RNA",
    "MRPS6 Proteo"
  ],
  "EID2B": [
    "EID2B CNV",
    "EID2B RNA"
  ],
  "OR5AH1P": [
    "OR5AH1P CNV",
    "OR5AH1P RNA"
  ],
  "RBM4B": [
    "RBM4B CNV",
    "RBM4B RNA",
    "RBM4B Proteo"
  ],
  "POLR2K": [
    "POLR2K CNV",
    "POLR2K RNA",
    "POLR2K Proteo"
  ],
  "MAP7": [
    "MAP7 CNV",
    "MAP7 RNA",
    "MAP7 Proteo"
  ],
  "CARS1P1": [
    "CARS1P1 CNV",
    "CARS1P1 RNA"
  ],
  "IDH1": [
    "IDH1 CNV",
    "IDH1 RNA",
    "IDH1 Proteo"
  ],
  "SLC26A10": [
    "SLC26A10 CNV",
    "SLC26A10 RNA"
  ],
  "ZNF425": [
    "ZNF425 CNV",
    "ZNF425 RNA"
  ],
  "OFD1P17": [
    "OFD1P17 CNV",
    "OFD1P17 RNA"
  ],
  "EGFL8": [
    "EGFL8 CNV",
    "EGFL8 RNA",
    "EGFL8 Proteo"
  ],
  "BTNL3": [
    "BTNL3 CNV",
    "BTNL3 RNA"
  ],
  "ZNF257": [
    "ZNF257 CNV",
    "ZNF257 RNA"
  ],
  "ANO2": [
    "ANO2 CNV",
    "ANO2 RNA"
  ],
  "PALLD": [
    "PALLD CNV",
    "PALLD RNA",
    "PALLD Proteo"
  ],
  "ARAF": [
    "ARAF CNV",
    "ARAF RNA",
    "ARAF Proteo"
  ],
  "ETV3L": [
    "ETV3L CNV",
    "ETV3L RNA"
  ],
  "N4BP3": [
    "N4BP3 CNV",
    "N4BP3 RNA",
    "N4BP3 Proteo"
  ],
  "CCDC113": [
    "CCDC113 CNV",
    "CCDC113 RNA"
  ],
  "IGKV2OR22-4": [
    "IGKV2OR22-4 CNV",
    "IGKV2OR22-4 RNA"
  ],
  "LRTOMT": [
    "LRTOMT CNV",
    "LRTOMT RNA"
  ],
  "NFAT5": [
    "NFAT5 CNV",
    "NFAT5 RNA",
    "NFAT5 Proteo"
  ],
  "GSR": [
    "GSR CNV",
    "GSR RNA",
    "GSR Proteo"
  ],
  "TOR1AIP2": [
    "TOR1AIP2 CNV",
    "TOR1AIP2 RNA",
    "TOR1AIP2 Proteo"
  ],
  "RPS15AP13": [
    "RPS15AP13 CNV",
    "RPS15AP13 RNA"
  ],
  "ADGRA3P1": [
    "ADGRA3P1 CNV",
    "ADGRA3P1 RNA"
  ],
  "RNF26": [
    "RNF26 CNV",
    "RNF26 RNA",
    "RNF26 Proteo"
  ],
  "RBPJP2": [
    "RBPJP2 CNV",
    "RBPJP2 RNA"
  ],
  "EIF3KP1": [
    "EIF3KP1 CNV",
    "EIF3KP1 RNA"
  ],
  "SLC25A32": [
    "SLC25A32 CNV",
    "SLC25A32 RNA",
    "SLC25A32 Proteo"
  ],
  "CPEB3": [
    "CPEB3 CNV",
    "CPEB3 RNA"
  ],
  "IGBP1P3": [
    "IGBP1P3 CNV",
    "IGBP1P3 RNA"
  ],
  "TULP2": [
    "TULP2 CNV",
    "TULP2 RNA"
  ],
  "FAM209B": [
    "FAM209B CNV",
    "FAM209B RNA"
  ],
  "RXFP3": [
    "RXFP3 CNV",
    "RXFP3 RNA"
  ],
  "SHISA4": [
    "SHISA4 CNV",
    "SHISA4 RNA",
    "SHISA4 Proteo"
  ],
  "TMEM35A": [
    "TMEM35A CNV",
    "TMEM35A RNA"
  ],
  "OR4D6": [
    "OR4D6 CNV",
    "OR4D6 RNA"
  ],
  "ANGPTL6": [
    "ANGPTL6 CNV",
    "ANGPTL6 RNA"
  ],
  "RPL15P3": [
    "RPL15P3 CNV",
    "RPL15P3 RNA"
  ],
  "LTV1": [
    "LTV1 CNV",
    "LTV1 RNA",
    "LTV1 Proteo"
  ],
  "ZNF2": [
    "ZNF2 CNV",
    "ZNF2 RNA"
  ],
  "RPS15A": [
    "RPS15A CNV",
    "RPS15A RNA",
    "RPS15A Proteo"
  ],
  "OR2E1P": [
    "OR2E1P CNV",
    "OR2E1P RNA"
  ],
  "ACAD9": [
    "ACAD9 CNV",
    "ACAD9 RNA",
    "ACAD9 Proteo"
  ],
  "ABCB10P4": [
    "ABCB10P4 CNV",
    "ABCB10P4 RNA"
  ],
  "BRF2": [
    "BRF2 CNV",
    "BRF2 RNA",
    "BRF2 Proteo"
  ],
  "CEP44": [
    "CEP44 CNV",
    "CEP44 RNA",
    "CEP44 Proteo"
  ],
  "IMP3P2": [
    "IMP3P2 CNV",
    "IMP3P2 RNA"
  ],
  "ALG1L7P": [
    "ALG1L7P CNV",
    "ALG1L7P RNA"
  ],
  "TCFL5": [
    "TCFL5 CNV",
    "TCFL5 RNA",
    "TCFL5 Proteo"
  ],
  "LINC00674": [
    "LINC00674 CNV",
    "LINC00674 RNA"
  ],
  "MTERF2": [
    "MTERF2 CNV",
    "MTERF2 RNA"
  ],
  "RIN3": [
    "RIN3 CNV",
    "RIN3 RNA",
    "RIN3 Proteo"
  ],
  "IQCF1": [
    "IQCF1 CNV",
    "IQCF1 RNA"
  ],
  "ADA2": [
    "ADA2 CNV",
    "ADA2 RNA",
    "ADA2 Proteo"
  ],
  "PRSS59P": [
    "PRSS59P CNV",
    "PRSS59P RNA"
  ],
  "BMP6P1": [
    "BMP6P1 CNV",
    "BMP6P1 RNA"
  ],
  "FDCSP": [
    "FDCSP CNV",
    "FDCSP RNA"
  ],
  "OR1M1": [
    "OR1M1 CNV",
    "OR1M1 RNA"
  ],
  "MRPS10P1": [
    "MRPS10P1 CNV",
    "MRPS10P1 RNA"
  ],
  "FAR1": [
    "FAR1 CNV",
    "FAR1 RNA",
    "FAR1 Proteo"
  ],
  "IFNA6": [
    "IFNA6 CNV",
    "IFNA6 RNA"
  ],
  "CCNJ": [
    "CCNJ CNV",
    "CCNJ RNA"
  ],
  "RAD1": [
    "RAD1 CNV",
    "RAD1 RNA",
    "RAD1 Proteo"
  ],
  "OR4A4P": [
    "OR4A4P CNV",
    "OR4A4P RNA"
  ],
  "CUZD1": [
    "CUZD1 CNV",
    "CUZD1 RNA"
  ],
  "ATP6V1A": [
    "ATP6V1A CNV",
    "ATP6V1A RNA",
    "ATP6V1A Proteo"
  ],
  "RPS7P12": [
    "RPS7P12 CNV",
    "RPS7P12 RNA"
  ],
  "RNF150": [
    "RNF150 CNV",
    "RNF150 RNA"
  ],
  "RPL31P57": [
    "RPL31P57 CNV",
    "RPL31P57 RNA"
  ],
  "ITGB1": [
    "ITGB1 CNV",
    "ITGB1 RNA",
    "ITGB1 Proteo"
  ],
  "H3P25": [
    "H3P25 CNV",
    "H3P25 RNA"
  ],
  "GPX1P1": [
    "GPX1P1 CNV",
    "GPX1P1 RNA"
  ],
  "MYBPH": [
    "MYBPH CNV",
    "MYBPH RNA"
  ],
  "SH3D21": [
    "SH3D21 CNV",
    "SH3D21 RNA"
  ],
  "EEF1E1P1": [
    "EEF1E1P1 CNV",
    "EEF1E1P1 RNA"
  ],
  "PRELID3BP7": [
    "PRELID3BP7 CNV",
    "PRELID3BP7 RNA"
  ],
  "FAM90A16": [
    "FAM90A16 CNV",
    "FAM90A16 RNA"
  ],
  "CALM2P4": [
    "CALM2P4 CNV",
    "CALM2P4 RNA"
  ],
  "NXPH2": [
    "NXPH2 CNV",
    "NXPH2 RNA"
  ],
  "ZNF644": [
    "ZNF644 CNV",
    "ZNF644 RNA",
    "ZNF644 Proteo"
  ],
  "MTND1P8": [
    "MTND1P8 CNV",
    "MTND1P8 RNA"
  ],
  "FAM20A": [
    "FAM20A CNV",
    "FAM20A RNA",
    "FAM20A Proteo"
  ],
  "ELOA2": [
    "ELOA2 CNV",
    "ELOA2 RNA"
  ],
  "GOLGA6L24P": [
    "GOLGA6L24P CNV",
    "GOLGA6L24P RNA"
  ],
  "ESPNP": [
    "ESPNP CNV",
    "ESPNP RNA"
  ],
  "PRSS35": [
    "PRSS35 CNV",
    "PRSS35 RNA"
  ],
  "TBC1D32": [
    "TBC1D32 CNV",
    "TBC1D32 RNA",
    "TBC1D32 Proteo"
  ],
  "MYLK": [
    "MYLK CNV",
    "MYLK RNA",
    "MYLK Proteo"
  ],
  "VDAC1P8": [
    "VDAC1P8 CNV",
    "VDAC1P8 RNA"
  ],
  "SYNM": [
    "SYNM CNV",
    "SYNM RNA",
    "SYNM Proteo"
  ],
  "MBL3P": [
    "MBL3P CNV",
    "MBL3P RNA"
  ],
  "ZNF140": [
    "ZNF140 CNV",
    "ZNF140 RNA"
  ],
  "SUCLG1": [
    "SUCLG1 CNV",
    "SUCLG1 RNA",
    "SUCLG1 Proteo"
  ],
  "CHEK2P7": [
    "CHEK2P7 CNV",
    "CHEK2P7 RNA"
  ],
  "OR2B2": [
    "OR2B2 CNV",
    "OR2B2 RNA"
  ],
  "SNRPCP11": [
    "SNRPCP11 CNV",
    "SNRPCP11 RNA"
  ],
  "PLPP2": [
    "PLPP2 CNV",
    "PLPP2 RNA",
    "PLPP2 Proteo"
  ],
  "DPRXP1": [
    "DPRXP1 CNV",
    "DPRXP1 RNA"
  ],
  "FDPSP6": [
    "FDPSP6 CNV",
    "FDPSP6 RNA"
  ],
  "DNAJA1P5": [
    "DNAJA1P5 CNV",
    "DNAJA1P5 RNA"
  ],
  "LRRC3C": [
    "LRRC3C CNV",
    "LRRC3C RNA"
  ],
  "ADAM2": [
    "ADAM2 CNV",
    "ADAM2 RNA"
  ],
  "GNE": [
    "GNE CNV",
    "GNE RNA",
    "GNE Proteo"
  ],
  "NXT1": [
    "NXT1 CNV",
    "NXT1 RNA",
    "NXT1 Proteo"
  ],
  "MRPL24": [
    "MRPL24 CNV",
    "MRPL24 RNA",
    "MRPL24 Proteo"
  ],
  "GTF2F1": [
    "GTF2F1 CNV",
    "GTF2F1 RNA",
    "GTF2F1 Proteo"
  ],
  "COTL1": [
    "COTL1 CNV",
    "COTL1 RNA",
    "COTL1 Proteo"
  ],
  "ASB6": [
    "ASB6 CNV",
    "ASB6 RNA",
    "ASB6 Proteo"
  ],
  "ATP5PBP3": [
    "ATP5PBP3 CNV",
    "ATP5PBP3 RNA"
  ],
  "EIF3LP2": [
    "EIF3LP2 CNV",
    "EIF3LP2 RNA"
  ],
  "MCM2": [
    "MCM2 CNV",
    "MCM2 RNA",
    "MCM2 Proteo"
  ],
  "SRP14P1": [
    "SRP14P1 CNV",
    "SRP14P1 RNA"
  ],
  "SFR1P2": [
    "SFR1P2 CNV",
    "SFR1P2 RNA"
  ],
  "WBP1LP11": [
    "WBP1LP11 CNV",
    "WBP1LP11 RNA"
  ],
  "RNA5SP203": [
    "RNA5SP203 CNV",
    "RNA5SP203 RNA"
  ],
  "CACNA1G": [
    "CACNA1G CNV",
    "CACNA1G RNA"
  ],
  "PAWRP1": [
    "PAWRP1 CNV",
    "PAWRP1 RNA"
  ],
  "RAB34": [
    "RAB34 CNV",
    "RAB34 RNA",
    "RAB34 Proteo"
  ],
  "RPS28": [
    "RPS28 CNV",
    "RPS28 RNA",
    "RPS28 Proteo"
  ],
  "MAPT": [
    "MAPT CNV",
    "MAPT RNA",
    "MAPT Proteo"
  ],
  "OR7E111FP": [
    "OR7E111FP CNV",
    "OR7E111FP RNA"
  ],
  "RASL10A": [
    "RASL10A CNV",
    "RASL10A RNA"
  ],
  "SERPINE1": [
    "SERPINE1 CNV",
    "SERPINE1 RNA",
    "SERPINE1 Proteo"
  ],
  "SLC8A1": [
    "SLC8A1 CNV",
    "SLC8A1 RNA",
    "SLC8A1 Proteo"
  ],
  "OR6C76": [
    "OR6C76 CNV",
    "OR6C76 RNA"
  ],
  "TMX4": [
    "TMX4 CNV",
    "TMX4 RNA",
    "TMX4 Proteo"
  ],
  "KIR2DL1": [
    "KIR2DL1 CNV",
    "KIR2DL1 RNA"
  ],
  "PRUNE1": [
    "PRUNE1 CNV",
    "PRUNE1 RNA",
    "PRUNE1 Proteo"
  ],
  "BMI1P1": [
    "BMI1P1 CNV",
    "BMI1P1 RNA"
  ],
  "HES2": [
    "HES2 CNV",
    "HES2 RNA"
  ],
  "PREB": [
    "PREB CNV",
    "PREB RNA",
    "PREB Proteo"
  ],
  "UCP2": [
    "UCP2 CNV",
    "UCP2 RNA"
  ],
  "ZNF572": [
    "ZNF572 CNV",
    "ZNF572 RNA"
  ],
  "BABAM1": [
    "BABAM1 CNV",
    "BABAM1 RNA",
    "BABAM1 Proteo"
  ],
  "ARL4AP1": [
    "ARL4AP1 CNV",
    "ARL4AP1 RNA"
  ],
  "SH2D2A": [
    "SH2D2A CNV",
    "SH2D2A RNA",
    "SH2D2A Proteo"
  ],
  "CAMKV": [
    "CAMKV CNV",
    "CAMKV RNA"
  ],
  "RPS18P13": [
    "RPS18P13 CNV",
    "RPS18P13 RNA"
  ],
  "ZNF837": [
    "ZNF837 CNV",
    "ZNF837 RNA"
  ],
  "OR2W5P": [
    "OR2W5P CNV",
    "OR2W5P RNA"
  ],
  "PKP3": [
    "PKP3 CNV",
    "PKP3 RNA",
    "PKP3 Proteo"
  ],
  "PLA2G4F": [
    "PLA2G4F CNV",
    "PLA2G4F RNA",
    "PLA2G4F Proteo"
  ],
  "BRPF3": [
    "BRPF3 CNV",
    "BRPF3 RNA",
    "BRPF3 Proteo"
  ],
  "RNA5SP323": [
    "RNA5SP323 CNV",
    "RNA5SP323 RNA"
  ],
  "MLKL": [
    "MLKL CNV",
    "MLKL RNA",
    "MLKL Proteo"
  ],
  "SLC25A5P5": [
    "SLC25A5P5 CNV",
    "SLC25A5P5 RNA"
  ],
  "C10orf105": [
    "C10orf105 CNV",
    "C10orf105 RNA"
  ],
  "EMC8": [
    "EMC8 CNV",
    "EMC8 RNA",
    "EMC8 Proteo"
  ],
  "VTCN1": [
    "VTCN1 CNV",
    "VTCN1 RNA",
    "VTCN1 Proteo"
  ],
  "MORC3": [
    "MORC3 CNV",
    "MORC3 RNA",
    "MORC3 Proteo"
  ],
  "CLHC1": [
    "CLHC1 CNV",
    "CLHC1 RNA"
  ],
  "SMIM4": [
    "SMIM4 CNV",
    "SMIM4 RNA",
    "SMIM4 Proteo"
  ],
  "MTFMT": [
    "MTFMT CNV",
    "MTFMT RNA",
    "MTFMT Proteo"
  ],
  "PDF": [
    "PDF CNV",
    "PDF RNA",
    "PDF Proteo"
  ],
  "HMGN1P16": [
    "HMGN1P16 CNV",
    "HMGN1P16 RNA"
  ],
  "EMP1": [
    "EMP1 CNV",
    "EMP1 RNA"
  ],
  "IGLV2-34": [
    "IGLV2-34 CNV",
    "IGLV2-34 RNA"
  ],
  "FLOT1": [
    "FLOT1 CNV",
    "FLOT1 RNA",
    "FLOT1 Proteo"
  ],
  "MYADML": [
    "MYADML CNV",
    "MYADML RNA"
  ],
  "RAB10": [
    "RAB10 CNV",
    "RAB10 RNA",
    "RAB10 Proteo"
  ],
  "PAX9": [
    "PAX9 CNV",
    "PAX9 RNA"
  ],
  "COG4": [
    "COG4 CNV",
    "COG4 RNA",
    "COG4 Proteo"
  ],
  "MMP11": [
    "MMP11 CNV",
    "MMP11 RNA",
    "MMP11 Proteo"
  ],
  "ZAN": [
    "ZAN CNV",
    "ZAN RNA"
  ],
  "ABCD1": [
    "ABCD1 CNV",
    "ABCD1 RNA",
    "ABCD1 Proteo"
  ],
  "PLEKHB1": [
    "PLEKHB1 CNV",
    "PLEKHB1 RNA",
    "PLEKHB1 Proteo"
  ],
  "RHOXF1": [
    "RHOXF1 CNV",
    "RHOXF1 RNA"
  ],
  "THAP5": [
    "THAP5 CNV",
    "THAP5 RNA",
    "THAP5 Proteo"
  ],
  "MYH14": [
    "MYH14 CNV",
    "MYH14 RNA",
    "MYH14 Proteo"
  ],
  "MBTPS2": [
    "MBTPS2 CNV",
    "MBTPS2 RNA",
    "MBTPS2 Proteo"
  ],
  "RPSAP52": [
    "RPSAP52 CNV",
    "RPSAP52 RNA"
  ],
  "LSM1P2": [
    "LSM1P2 CNV",
    "LSM1P2 RNA"
  ],
  "TEP1": [
    "TEP1 CNV",
    "TEP1 RNA",
    "TEP1 Proteo"
  ],
  "RNF25": [
    "RNF25 CNV",
    "RNF25 RNA",
    "RNF25 Proteo"
  ],
  "VDR": [
    "VDR CNV",
    "VDR RNA",
    "VDR Proteo"
  ],
  "IFRD1": [
    "IFRD1 CNV",
    "IFRD1 RNA",
    "IFRD1 Proteo"
  ],
  "MROH8": [
    "MROH8 CNV",
    "MROH8 RNA"
  ],
  "NOP56": [
    "NOP56 CNV",
    "NOP56 RNA",
    "NOP56 Proteo"
  ],
  "SIM1": [
    "SIM1 CNV",
    "SIM1 RNA"
  ],
  "E2F6P3": [
    "E2F6P3 CNV",
    "E2F6P3 RNA"
  ],
  "POTEM": [
    "POTEM CNV",
    "POTEM RNA"
  ],
  "CSNK1D": [
    "CSNK1D CNV",
    "CSNK1D RNA",
    "CSNK1D Proteo"
  ],
  "PFDN1": [
    "PFDN1 CNV",
    "PFDN1 RNA",
    "PFDN1 Proteo"
  ],
  "EEF1A1P27": [
    "EEF1A1P27 CNV",
    "EEF1A1P27 RNA"
  ],
  "ASAP3": [
    "ASAP3 CNV",
    "ASAP3 RNA",
    "ASAP3 Proteo"
  ],
  "IGLV2-11": [
    "IGLV2-11 Proteo"
  ],
  "WDR31": [
    "WDR31 CNV",
    "WDR31 RNA"
  ],
  "PBX2P1": [
    "PBX2P1 CNV",
    "PBX2P1 RNA"
  ],
  "CAPN2": [
    "CAPN2 CNV",
    "CAPN2 RNA",
    "CAPN2 Proteo"
  ],
  "SDC4P": [
    "SDC4P CNV",
    "SDC4P RNA"
  ],
  "DEFB115": [
    "DEFB115 CNV",
    "DEFB115 RNA"
  ],
  "SLC4A1APP1": [
    "SLC4A1APP1 CNV",
    "SLC4A1APP1 RNA"
  ],
  "CCDC24": [
    "CCDC24 CNV",
    "CCDC24 RNA"
  ],
  "UBXN8": [
    "UBXN8 CNV",
    "UBXN8 RNA",
    "UBXN8 Proteo"
  ],
  "FAS": [
    "FAS CNV",
    "FAS RNA",
    "FAS Proteo"
  ],
  "ILK": [
    "ILK CNV",
    "ILK RNA",
    "ILK Proteo"
  ],
  "SMCO3": [
    "SMCO3 CNV",
    "SMCO3 RNA",
    "SMCO3 Proteo"
  ],
  "FRMD3": [
    "FRMD3 CNV",
    "FRMD3 RNA",
    "FRMD3 Proteo"
  ],
  "H2AZP4": [
    "H2AZP4 CNV",
    "H2AZP4 RNA"
  ],
  "DUSP15": [
    "DUSP15 CNV",
    "DUSP15 RNA"
  ],
  "CCDC110": [
    "CCDC110 CNV",
    "CCDC110 RNA"
  ],
  "XPO5": [
    "XPO5 CNV",
    "XPO5 RNA",
    "XPO5 Proteo"
  ],
  "PDK1": [
    "PDK1 CNV",
    "PDK1 RNA",
    "PDK1 Proteo"
  ],
  "TXNRD3": [
    "TXNRD3 CNV",
    "TXNRD3 RNA",
    "TXNRD3 Proteo"
  ],
  "H3-5": [
    "H3-5 CNV",
    "H3-5 RNA"
  ],
  "PPIAP80": [
    "PPIAP80 CNV",
    "PPIAP80 RNA"
  ],
  "ZNF90": [
    "ZNF90 CNV",
    "ZNF90 RNA"
  ],
  "RPL31P63": [
    "RPL31P63 CNV",
    "RPL31P63 RNA"
  ],
  "ESF1": [
    "ESF1 CNV",
    "ESF1 RNA",
    "ESF1 Proteo"
  ],
  "FAM217A": [
    "FAM217A CNV",
    "FAM217A RNA"
  ],
  "NXPH3": [
    "NXPH3 CNV",
    "NXPH3 RNA"
  ],
  "IFITM3P7": [
    "IFITM3P7 CNV",
    "IFITM3P7 RNA"
  ],
  "EIF5A2": [
    "EIF5A2 CNV",
    "EIF5A2 RNA",
    "EIF5A2 Proteo"
  ],
  "MRO": [
    "MRO CNV",
    "MRO RNA"
  ],
  "LRRK2": [
    "LRRK2 CNV",
    "LRRK2 RNA",
    "LRRK2 Proteo"
  ],
  "SEPTIN7P11": [
    "SEPTIN7P11 CNV",
    "SEPTIN7P11 RNA"
  ],
  "WDR55": [
    "WDR55 CNV",
    "WDR55 RNA",
    "WDR55 Proteo"
  ],
  "CACNG4": [
    "CACNG4 CNV",
    "CACNG4 RNA"
  ],
  "SEZ6": [
    "SEZ6 CNV",
    "SEZ6 RNA"
  ],
  "TSSK5P": [
    "TSSK5P CNV",
    "TSSK5P RNA"
  ],
  "RPS6P2": [
    "RPS6P2 CNV",
    "RPS6P2 RNA"
  ],
  "MFAP1": [
    "MFAP1 CNV",
    "MFAP1 RNA",
    "MFAP1 Proteo"
  ],
  "GNA12": [
    "GNA12 CNV",
    "GNA12 RNA",
    "GNA12 Proteo"
  ],
  "CBX7": [
    "CBX7 CNV",
    "CBX7 RNA",
    "CBX7 Proteo"
  ],
  "ZBTB2": [
    "ZBTB2 CNV",
    "ZBTB2 RNA",
    "ZBTB2 Proteo"
  ],
  "PGA5": [
    "PGA5 CNV",
    "PGA5 RNA"
  ],
  "BEX5": [
    "BEX5 CNV",
    "BEX5 RNA"
  ],
  "ZNF286A": [
    "ZNF286A CNV",
    "ZNF286A RNA"
  ],
  "PMS2P8": [
    "PMS2P8 CNV",
    "PMS2P8 RNA"
  ],
  "LENG8": [
    "LENG8 CNV",
    "LENG8 RNA",
    "LENG8 Proteo"
  ],
  "MARCHF9": [
    "MARCHF9 CNV",
    "MARCHF9 RNA"
  ],
  "SNX19P4": [
    "SNX19P4 CNV",
    "SNX19P4 RNA"
  ],
  "KRT18P20": [
    "KRT18P20 CNV",
    "KRT18P20 RNA"
  ],
  "PPDPF": [
    "PPDPF CNV",
    "PPDPF RNA",
    "PPDPF Proteo"
  ],
  "HMGN2P21": [
    "HMGN2P21 CNV",
    "HMGN2P21 RNA"
  ],
  "SAGE1": [
    "SAGE1 CNV",
    "SAGE1 RNA"
  ],
  "RPL13AP7": [
    "RPL13AP7 CNV",
    "RPL13AP7 RNA"
  ],
  "IFNWP18": [
    "IFNWP18 CNV",
    "IFNWP18 RNA"
  ],
  "OR4A11P": [
    "OR4A11P CNV",
    "OR4A11P RNA"
  ],
  "SIDT2": [
    "SIDT2 CNV",
    "SIDT2 RNA",
    "SIDT2 Proteo"
  ],
  "GARIN3": [
    "GARIN3 CNV",
    "GARIN3 RNA"
  ],
  "FN3KRP": [
    "FN3KRP CNV",
    "FN3KRP RNA",
    "FN3KRP Proteo"
  ],
  "EHBP1": [
    "EHBP1 CNV",
    "EHBP1 RNA",
    "EHBP1 Proteo"
  ],
  "ADIPOQ": [
    "ADIPOQ CNV",
    "ADIPOQ RNA",
    "ADIPOQ Proteo"
  ],
  "SLC25A1P5": [
    "SLC25A1P5 CNV",
    "SLC25A1P5 RNA"
  ],
  "BARHL2": [
    "BARHL2 CNV",
    "BARHL2 RNA"
  ],
  "GRIP2": [
    "GRIP2 CNV",
    "GRIP2 RNA"
  ],
  "IGF2R": [
    "IGF2R CNV",
    "IGF2R RNA",
    "IGF2R Proteo"
  ],
  "ST8SIA3": [
    "ST8SIA3 CNV",
    "ST8SIA3 RNA"
  ],
  "C4orf46P1": [
    "C4orf46P1 CNV",
    "C4orf46P1 RNA"
  ],
  "VWA5A": [
    "VWA5A CNV",
    "VWA5A RNA",
    "VWA5A Proteo"
  ],
  "ADCY4": [
    "ADCY4 CNV",
    "ADCY4 RNA"
  ],
  "PDZD11": [
    "PDZD11 CNV",
    "PDZD11 RNA",
    "PDZD11 Proteo"
  ],
  "MANSC4": [
    "MANSC4 CNV",
    "MANSC4 RNA"
  ],
  "LILRA6": [
    "LILRA6 CNV",
    "LILRA6 RNA",
    "LILRA6 Proteo"
  ],
  "PAAF1": [
    "PAAF1 CNV",
    "PAAF1 RNA",
    "PAAF1 Proteo"
  ],
  "RPL35P2": [
    "RPL35P2 CNV",
    "RPL35P2 RNA"
  ],
  "CYP4A43P": [
    "CYP4A43P CNV",
    "CYP4A43P RNA"
  ],
  "BTN1A1P1": [
    "BTN1A1P1 CNV",
    "BTN1A1P1 RNA"
  ],
  "SPINK13": [
    "SPINK13 CNV",
    "SPINK13 RNA"
  ],
  "NSF": [
    "NSF CNV",
    "NSF RNA",
    "NSF Proteo"
  ],
  "C1QL3": [
    "C1QL3 CNV",
    "C1QL3 RNA"
  ],
  "BNIP3P28": [
    "BNIP3P28 CNV",
    "BNIP3P28 RNA"
  ],
  "ODR4": [
    "ODR4 CNV",
    "ODR4 RNA",
    "ODR4 Proteo"
  ],
  "NDUFB11": [
    "NDUFB11 CNV",
    "NDUFB11 RNA",
    "NDUFB11 Proteo"
  ],
  "MEMO1P1": [
    "MEMO1P1 CNV",
    "MEMO1P1 RNA"
  ],
  "ATP13A2": [
    "ATP13A2 CNV",
    "ATP13A2 RNA",
    "ATP13A2 Proteo"
  ],
  "LRRC37A9P": [
    "LRRC37A9P CNV",
    "LRRC37A9P RNA"
  ],
  "LIAS": [
    "LIAS CNV",
    "LIAS RNA",
    "LIAS Proteo"
  ],
  "MTCO2P3": [
    "MTCO2P3 CNV",
    "MTCO2P3 RNA"
  ],
  "OR13C4": [
    "OR13C4 CNV",
    "OR13C4 RNA"
  ],
  "PTCHD3P2": [
    "PTCHD3P2 CNV",
    "PTCHD3P2 RNA"
  ],
  "GOT1": [
    "GOT1 CNV",
    "GOT1 RNA",
    "GOT1 Proteo"
  ],
  "CTBP2P2": [
    "CTBP2P2 CNV",
    "CTBP2P2 RNA"
  ],
  "NPM1P5": [
    "NPM1P5 CNV",
    "NPM1P5 RNA"
  ],
  "IGKV2-4": [
    "IGKV2-4 CNV",
    "IGKV2-4 RNA"
  ],
  "G3BP1": [
    "G3BP1 CNV",
    "G3BP1 RNA",
    "G3BP1 Proteo"
  ],
  "RPL15P14": [
    "RPL15P14 CNV",
    "RPL15P14 RNA"
  ],
  "MTND1P20": [
    "MTND1P20 CNV",
    "MTND1P20 RNA"
  ],
  "C1QB": [
    "C1QB CNV",
    "C1QB RNA",
    "C1QB Proteo"
  ],
  "PHF12": [
    "PHF12 CNV",
    "PHF12 RNA",
    "PHF12 Proteo"
  ],
  "CIB4": [
    "CIB4 CNV",
    "CIB4 RNA"
  ],
  "ZNHIT2": [
    "ZNHIT2 CNV",
    "ZNHIT2 RNA",
    "ZNHIT2 Proteo"
  ],
  "RPL7A": [
    "RPL7A CNV",
    "RPL7A RNA",
    "RPL7A Proteo"
  ],
  "LRRC75A": [
    "LRRC75A CNV",
    "LRRC75A RNA",
    "LRRC75A Proteo"
  ],
  "ELOCP34": [
    "ELOCP34 CNV",
    "ELOCP34 RNA"
  ],
  "BUB1": [
    "BUB1 CNV",
    "BUB1 RNA",
    "BUB1 Proteo"
  ],
  "GRB10": [
    "GRB10 CNV",
    "GRB10 RNA",
    "GRB10 Proteo"
  ],
  "LYZL2": [
    "LYZL2 CNV",
    "LYZL2 RNA"
  ],
  "ASGR2": [
    "ASGR2 CNV",
    "ASGR2 RNA"
  ],
  "AVPR2": [
    "AVPR2 CNV",
    "AVPR2 RNA"
  ],
  "MOSMO": [
    "MOSMO CNV",
    "MOSMO RNA"
  ],
  "IFNLR1": [
    "IFNLR1 CNV",
    "IFNLR1 RNA"
  ],
  "NPC1L1": [
    "NPC1L1 CNV",
    "NPC1L1 RNA"
  ],
  "CARM1P1": [
    "CARM1P1 CNV",
    "CARM1P1 RNA"
  ],
  "PHB1P3": [
    "PHB1P3 CNV",
    "PHB1P3 RNA"
  ],
  "OR11H6": [
    "OR11H6 CNV",
    "OR11H6 RNA"
  ],
  "PTPRR": [
    "PTPRR CNV",
    "PTPRR RNA"
  ],
  "TSSK3": [
    "TSSK3 CNV",
    "TSSK3 RNA"
  ],
  "TINF2": [
    "TINF2 CNV",
    "TINF2 RNA",
    "TINF2 Proteo"
  ],
  "RPL32P25": [
    "RPL32P25 CNV",
    "RPL32P25 RNA"
  ],
  "TCAF2": [
    "TCAF2 CNV",
    "TCAF2 RNA",
    "TCAF2 Proteo"
  ],
  "KRT17P7": [
    "KRT17P7 CNV",
    "KRT17P7 RNA"
  ],
  "PGP": [
    "PGP CNV",
    "PGP RNA",
    "PGP Proteo"
  ],
  "TMEM161A": [
    "TMEM161A CNV",
    "TMEM161A RNA",
    "TMEM161A Proteo"
  ],
  "NDUFA5": [
    "NDUFA5 CNV",
    "NDUFA5 RNA",
    "NDUFA5 Proteo"
  ],
  "COMMD3": [
    "COMMD3 CNV",
    "COMMD3 RNA",
    "COMMD3 Proteo"
  ],
  "RGS22": [
    "RGS22 CNV",
    "RGS22 RNA"
  ],
  "TRIM40": [
    "TRIM40 CNV",
    "TRIM40 RNA"
  ],
  "ZMYM4": [
    "ZMYM4 CNV",
    "ZMYM4 RNA",
    "ZMYM4 Proteo"
  ],
  "LRRC14B": [
    "LRRC14B CNV",
    "LRRC14B RNA"
  ],
  "CT75": [
    "CT75 CNV",
    "CT75 RNA"
  ],
  "SIM2": [
    "SIM2 CNV",
    "SIM2 RNA"
  ],
  "TPTE2P1": [
    "TPTE2P1 CNV",
    "TPTE2P1 RNA"
  ],
  "NIT2": [
    "NIT2 CNV",
    "NIT2 RNA",
    "NIT2 Proteo"
  ],
  "IMPDH1P6": [
    "IMPDH1P6 CNV",
    "IMPDH1P6 RNA"
  ],
  "OVCH1": [
    "OVCH1 CNV",
    "OVCH1 RNA"
  ],
  "TYRP1": [
    "TYRP1 CNV",
    "TYRP1 RNA",
    "TYRP1 Proteo"
  ],
  "SNX3P1Y": [
    "SNX3P1Y CNV",
    "SNX3P1Y RNA"
  ],
  "CLDN2": [
    "CLDN2 CNV",
    "CLDN2 RNA"
  ],
  "ARFGAP1": [
    "ARFGAP1 CNV",
    "ARFGAP1 RNA",
    "ARFGAP1 Proteo"
  ],
  "GPR32": [
    "GPR32 CNV",
    "GPR32 RNA"
  ],
  "OR10K1": [
    "OR10K1 CNV",
    "OR10K1 RNA"
  ],
  "DTX2P1": [
    "DTX2P1 CNV",
    "DTX2P1 RNA"
  ],
  "ZNF785": [
    "ZNF785 CNV",
    "ZNF785 RNA",
    "ZNF785 Proteo"
  ],
  "HMGN1P17": [
    "HMGN1P17 CNV",
    "HMGN1P17 RNA"
  ],
  "STRAP": [
    "STRAP CNV",
    "STRAP RNA",
    "STRAP Proteo"
  ],
  "SUPV3L1": [
    "SUPV3L1 CNV",
    "SUPV3L1 RNA",
    "SUPV3L1 Proteo"
  ],
  "PCED1CP": [
    "PCED1CP CNV",
    "PCED1CP RNA"
  ],
  "SCN7A": [
    "SCN7A CNV",
    "SCN7A RNA",
    "SCN7A Proteo"
  ],
  "PSMC1P5": [
    "PSMC1P5 CNV",
    "PSMC1P5 RNA"
  ],
  "PEX16": [
    "PEX16 CNV",
    "PEX16 RNA",
    "PEX16 Proteo"
  ],
  "METTL16": [
    "METTL16 CNV",
    "METTL16 RNA",
    "METTL16 Proteo"
  ],
  "WBP11P1": [
    "WBP11P1 CNV",
    "WBP11P1 RNA"
  ],
  "PKD2L1": [
    "PKD2L1 CNV",
    "PKD2L1 RNA"
  ],
  "MARCKSL1": [
    "MARCKSL1 CNV",
    "MARCKSL1 RNA",
    "MARCKSL1 Proteo"
  ],
  "ZFYVE9P1": [
    "ZFYVE9P1 CNV",
    "ZFYVE9P1 RNA"
  ],
  "CYP3A5": [
    "CYP3A5 CNV",
    "CYP3A5 RNA"
  ],
  "RSRC2": [
    "RSRC2 CNV",
    "RSRC2 RNA",
    "RSRC2 Proteo"
  ],
  "ETF1": [
    "ETF1 CNV",
    "ETF1 RNA",
    "ETF1 Proteo"
  ],
  "SV2C": [
    "SV2C CNV",
    "SV2C RNA"
  ],
  "ADRA2A": [
    "ADRA2A CNV",
    "ADRA2A RNA",
    "ADRA2A Proteo"
  ],
  "KIZ": [
    "KIZ CNV",
    "KIZ RNA",
    "KIZ Proteo"
  ],
  "NF1P2": [
    "NF1P2 CNV",
    "NF1P2 RNA"
  ],
  "SPANXA2": [
    "SPANXA2 CNV",
    "SPANXA2 RNA"
  ],
  "RPL17-C18orf32": [
    "RPL17-C18orf32 Proteo"
  ],
  "RPL7AP56": [
    "RPL7AP56 CNV",
    "RPL7AP56 RNA"
  ],
  "ZCCHC12": [
    "ZCCHC12 CNV",
    "ZCCHC12 RNA"
  ],
  "TCN1": [
    "TCN1 CNV",
    "TCN1 RNA",
    "TCN1 Proteo"
  ],
  "HPX": [
    "HPX CNV",
    "HPX RNA",
    "HPX Proteo"
  ],
  "DHRS9": [
    "DHRS9 CNV",
    "DHRS9 RNA",
    "DHRS9 Proteo"
  ],
  "PDCD11": [
    "PDCD11 CNV",
    "PDCD11 RNA",
    "PDCD11 Proteo"
  ],
  "ORC2": [
    "ORC2 CNV",
    "ORC2 RNA",
    "ORC2 Proteo"
  ],
  "NTS": [
    "NTS CNV",
    "NTS RNA"
  ],
  "ZNF142": [
    "ZNF142 CNV",
    "ZNF142 RNA"
  ],
  "PARN": [
    "PARN CNV",
    "PARN RNA",
    "PARN Proteo"
  ],
  "PENK": [
    "PENK CNV",
    "PENK RNA"
  ],
  "RPS23P5": [
    "RPS23P5 CNV",
    "RPS23P5 RNA"
  ],
  "ZKSCAN8": [
    "ZKSCAN8 CNV",
    "ZKSCAN8 RNA",
    "ZKSCAN8 Proteo"
  ],
  "DNAJA1P2": [
    "DNAJA1P2 CNV",
    "DNAJA1P2 RNA"
  ],
  "BTF3P10": [
    "BTF3P10 CNV",
    "BTF3P10 RNA"
  ],
  "ISCA1P1": [
    "ISCA1P1 CNV",
    "ISCA1P1 RNA"
  ],
  "OXSM": [
    "OXSM CNV",
    "OXSM RNA",
    "OXSM Proteo"
  ],
  "SYNGR2": [
    "SYNGR2 CNV",
    "SYNGR2 RNA",
    "SYNGR2 Proteo"
  ],
  "MINAR1": [
    "MINAR1 CNV",
    "MINAR1 RNA"
  ],
  "RPS12P3": [
    "RPS12P3 CNV",
    "RPS12P3 RNA"
  ],
  "PPM1K": [
    "PPM1K CNV",
    "PPM1K RNA",
    "PPM1K Proteo"
  ],
  "HDGFL1": [
    "HDGFL1 CNV",
    "HDGFL1 RNA"
  ],
  "NSMAF": [
    "NSMAF CNV",
    "NSMAF RNA",
    "NSMAF Proteo"
  ],
  "NFU1P1": [
    "NFU1P1 CNV",
    "NFU1P1 RNA"
  ],
  "C2CD4B": [
    "C2CD4B CNV",
    "C2CD4B RNA"
  ],
  "HSBP1L1": [
    "HSBP1L1 CNV",
    "HSBP1L1 RNA"
  ],
  "SNX18P14": [
    "SNX18P14 CNV",
    "SNX18P14 RNA"
  ],
  "LRCH1": [
    "LRCH1 CNV",
    "LRCH1 RNA",
    "LRCH1 Proteo"
  ],
  "SLC25A3P1": [
    "SLC25A3P1 CNV",
    "SLC25A3P1 RNA"
  ],
  "IGHVII-51-2": [
    "IGHVII-51-2 CNV",
    "IGHVII-51-2 RNA"
  ],
  "SRSF11": [
    "SRSF11 CNV",
    "SRSF11 RNA",
    "SRSF11 Proteo"
  ],
  "ZNF721": [
    "ZNF721 CNV",
    "ZNF721 RNA"
  ],
  "MPG": [
    "MPG CNV",
    "MPG RNA",
    "MPG Proteo"
  ],
  "MLLT3": [
    "MLLT3 CNV",
    "MLLT3 RNA",
    "MLLT3 Proteo"
  ],
  "CIC": [
    "CIC CNV",
    "CIC RNA",
    "CIC Proteo"
  ],
  "EDEM2": [
    "EDEM2 CNV",
    "EDEM2 RNA",
    "EDEM2 Proteo"
  ],
  "G6PC3": [
    "G6PC3 CNV",
    "G6PC3 RNA",
    "G6PC3 Proteo"
  ],
  "CRYBB2P1": [
    "CRYBB2P1 CNV",
    "CRYBB2P1 RNA"
  ],
  "CINP": [
    "CINP CNV",
    "CINP RNA",
    "CINP Proteo"
  ],
  "SLC25A5P4": [
    "SLC25A5P4 CNV",
    "SLC25A5P4 RNA"
  ],
  "EVL": [
    "EVL CNV",
    "EVL RNA",
    "EVL Proteo"
  ],
  "MRPL41": [
    "MRPL41 CNV",
    "MRPL41 RNA",
    "MRPL41 Proteo"
  ],
  "OR2S2": [
    "OR2S2 CNV",
    "OR2S2 RNA"
  ],
  "RPL23AP72": [
    "RPL23AP72 CNV",
    "RPL23AP72 RNA"
  ],
  "INSYN2B": [
    "INSYN2B CNV",
    "INSYN2B RNA"
  ],
  "TLDC2": [
    "TLDC2 CNV",
    "TLDC2 RNA"
  ],
  "FBXO3": [
    "FBXO3 CNV",
    "FBXO3 RNA",
    "FBXO3 Proteo"
  ],
  "DNM1P48": [
    "DNM1P48 CNV",
    "DNM1P48 RNA"
  ],
  "UTS2": [
    "UTS2 CNV",
    "UTS2 RNA"
  ],
  "FAM107A": [
    "FAM107A CNV",
    "FAM107A RNA"
  ],
  "PSTPIP1": [
    "PSTPIP1 CNV",
    "PSTPIP1 RNA",
    "PSTPIP1 Proteo"
  ],
  "RPL7AP7": [
    "RPL7AP7 CNV",
    "RPL7AP7 RNA"
  ],
  "CLIC1": [
    "CLIC1 CNV",
    "CLIC1 RNA",
    "CLIC1 Proteo"
  ],
  "TUBAP2": [
    "TUBAP2 CNV",
    "TUBAP2 RNA"
  ],
  "GAGE2E": [
    "GAGE2E CNV",
    "GAGE2E RNA"
  ],
  "TSPOAP1": [
    "TSPOAP1 CNV",
    "TSPOAP1 RNA",
    "TSPOAP1 Proteo"
  ],
  "FARP1": [
    "FARP1 CNV",
    "FARP1 RNA",
    "FARP1 Proteo"
  ],
  "CHI3L2": [
    "CHI3L2 CNV",
    "CHI3L2 RNA",
    "CHI3L2 Proteo"
  ],
  "PPIAP29": [
    "PPIAP29 CNV",
    "PPIAP29 RNA"
  ],
  "RCN1P1": [
    "RCN1P1 CNV",
    "RCN1P1 RNA"
  ],
  "OLA1": [
    "OLA1 CNV",
    "OLA1 RNA",
    "OLA1 Proteo"
  ],
  "HMGB1P44": [
    "HMGB1P44 CNV",
    "HMGB1P44 RNA"
  ],
  "ZNF746": [
    "ZNF746 CNV",
    "ZNF746 RNA",
    "ZNF746 Proteo"
  ],
  "MT-ND1": [
    "MT-ND1 RNA",
    "MT-ND1 Proteo"
  ],
  "CCNQP2": [
    "CCNQP2 CNV",
    "CCNQP2 RNA"
  ],
  "SLC18A2": [
    "SLC18A2 CNV",
    "SLC18A2 RNA"
  ],
  "ADCK2": [
    "ADCK2 CNV",
    "ADCK2 RNA",
    "ADCK2 Proteo"
  ],
  "CTDSPL2P1": [
    "CTDSPL2P1 CNV",
    "CTDSPL2P1 RNA"
  ],
  "GNGT2": [
    "GNGT2 CNV",
    "GNGT2 RNA",
    "GNGT2 Proteo"
  ],
  "CLN3": [
    "CLN3 CNV",
    "CLN3 RNA",
    "CLN3 Proteo"
  ],
  "METTL13": [
    "METTL13 CNV",
    "METTL13 RNA",
    "METTL13 Proteo"
  ],
  "ARFIP1": [
    "ARFIP1 CNV",
    "ARFIP1 RNA",
    "ARFIP1 Proteo"
  ],
  "GPR137": [
    "GPR137 CNV",
    "GPR137 RNA"
  ],
  "C1DP3": [
    "C1DP3 CNV",
    "C1DP3 RNA"
  ],
  "HECW2": [
    "HECW2 CNV",
    "HECW2 RNA",
    "HECW2 Proteo"
  ],
  "MAP7D1": [
    "MAP7D1 CNV",
    "MAP7D1 RNA",
    "MAP7D1 Proteo"
  ],
  "ECHS1": [
    "ECHS1 CNV",
    "ECHS1 RNA",
    "ECHS1 Proteo"
  ],
  "TMEM230P2": [
    "TMEM230P2 CNV",
    "TMEM230P2 RNA"
  ],
  "TWSG1": [
    "TWSG1 CNV",
    "TWSG1 RNA",
    "TWSG1 Proteo"
  ],
  "SPINK6": [
    "SPINK6 CNV",
    "SPINK6 RNA"
  ],
  "GSTA1": [
    "GSTA1 CNV",
    "GSTA1 RNA",
    "GSTA1 Proteo"
  ],
  "IGKV2-26": [
    "IGKV2-26 CNV",
    "IGKV2-26 RNA"
  ],
  "RPL7AP45": [
    "RPL7AP45 CNV",
    "RPL7AP45 RNA"
  ],
  "C4orf46P3": [
    "C4orf46P3 CNV",
    "C4orf46P3 RNA"
  ],
  "DLG1": [
    "DLG1 CNV",
    "DLG1 RNA",
    "DLG1 Proteo"
  ],
  "KLHDC7A": [
    "KLHDC7A CNV",
    "KLHDC7A RNA"
  ],
  "GOLGA2": [
    "GOLGA2 CNV",
    "GOLGA2 RNA",
    "GOLGA2 Proteo"
  ],
  "PIMREG": [
    "PIMREG CNV",
    "PIMREG RNA",
    "PIMREG Proteo"
  ],
  "DEFA8P": [
    "DEFA8P CNV",
    "DEFA8P RNA"
  ],
  "RPS29P33": [
    "RPS29P33 CNV",
    "RPS29P33 RNA"
  ],
  "KIAA1217": [
    "KIAA1217 CNV",
    "KIAA1217 RNA",
    "KIAA1217 Proteo"
  ],
  "CHCHD4P2": [
    "CHCHD4P2 CNV",
    "CHCHD4P2 RNA"
  ],
  "RPL6P19": [
    "RPL6P19 CNV",
    "RPL6P19 RNA"
  ],
  "TBC1D3": [
    "TBC1D3 CNV",
    "TBC1D3 RNA"
  ],
  "HIPK4": [
    "HIPK4 CNV",
    "HIPK4 RNA"
  ],
  "EIF4BP4": [
    "EIF4BP4 CNV",
    "EIF4BP4 RNA"
  ],
  "BRD9P1": [
    "BRD9P1 CNV",
    "BRD9P1 RNA"
  ],
  "KRT85": [
    "KRT85 CNV",
    "KRT85 RNA",
    "KRT85 Proteo"
  ],
  "GLMP": [
    "GLMP CNV",
    "GLMP RNA",
    "GLMP Proteo"
  ],
  "KIAA2012": [
    "KIAA2012 CNV",
    "KIAA2012 RNA"
  ],
  "RNA5SP20": [
    "RNA5SP20 CNV",
    "RNA5SP20 RNA"
  ],
  "AKR1C4": [
    "AKR1C4 CNV",
    "AKR1C4 RNA",
    "AKR1C4 Proteo"
  ],
  "ZDHHC14": [
    "ZDHHC14 CNV",
    "ZDHHC14 RNA",
    "ZDHHC14 Proteo"
  ],
  "LUZP4": [
    "LUZP4 CNV",
    "LUZP4 RNA"
  ],
  "CNN3P1": [
    "CNN3P1 CNV",
    "CNN3P1 RNA"
  ],
  "CRYZL2P": [
    "CRYZL2P CNV",
    "CRYZL2P RNA"
  ],
  "PAX8": [
    "PAX8 CNV",
    "PAX8 RNA"
  ],
  "RPS12P18": [
    "RPS12P18 CNV",
    "RPS12P18 RNA"
  ],
  "DIS3": [
    "DIS3 CNV",
    "DIS3 RNA",
    "DIS3 Proteo"
  ],
  "HRH4": [
    "HRH4 CNV",
    "HRH4 RNA"
  ],
  "RPL7P25": [
    "RPL7P25 CNV",
    "RPL7P25 RNA"
  ],
  "IGHVIII-82": [
    "IGHVIII-82 CNV",
    "IGHVIII-82 RNA"
  ],
  "CPLANE1": [
    "CPLANE1 CNV",
    "CPLANE1 RNA",
    "CPLANE1 Proteo"
  ],
  "TAFA4": [
    "TAFA4 CNV",
    "TAFA4 RNA"
  ],
  "SLC8A2": [
    "SLC8A2 CNV",
    "SLC8A2 RNA"
  ],
  "OR5J2": [
    "OR5J2 CNV",
    "OR5J2 RNA"
  ],
  "DMXL2": [
    "DMXL2 CNV",
    "DMXL2 RNA",
    "DMXL2 Proteo"
  ],
  "TMEM196": [
    "TMEM196 CNV",
    "TMEM196 RNA"
  ],
  "PNPLA3": [
    "PNPLA3 CNV",
    "PNPLA3 RNA",
    "PNPLA3 Proteo"
  ],
  "CLTC": [
    "CLTC CNV",
    "CLTC RNA",
    "CLTC Proteo"
  ],
  "R3HCC1": [
    "R3HCC1 CNV",
    "R3HCC1 RNA",
    "R3HCC1 Proteo"
  ],
  "ATAD3C": [
    "ATAD3C CNV",
    "ATAD3C RNA",
    "ATAD3C Proteo"
  ],
  "GUCA1ANB": [
    "GUCA1ANB CNV",
    "GUCA1ANB RNA"
  ],
  "KRT18P43": [
    "KRT18P43 CNV",
    "KRT18P43 RNA"
  ],
  "RNA5SP359": [
    "RNA5SP359 CNV",
    "RNA5SP359 RNA"
  ],
  "HDHD2": [
    "HDHD2 CNV",
    "HDHD2 RNA",
    "HDHD2 Proteo"
  ],
  "ISCA2P1": [
    "ISCA2P1 CNV",
    "ISCA2P1 RNA"
  ],
  "HBAP1": [
    "HBAP1 CNV",
    "HBAP1 RNA"
  ],
  "SLC6A7": [
    "SLC6A7 CNV",
    "SLC6A7 RNA"
  ],
  "BOLA2P3": [
    "BOLA2P3 CNV",
    "BOLA2P3 RNA"
  ],
  "MOB3C": [
    "MOB3C CNV",
    "MOB3C RNA",
    "MOB3C Proteo"
  ],
  "SCGB1A1": [
    "SCGB1A1 CNV",
    "SCGB1A1 RNA",
    "SCGB1A1 Proteo"
  ],
  "MAOA": [
    "MAOA CNV",
    "MAOA RNA",
    "MAOA Proteo"
  ],
  "RPL6P2": [
    "RPL6P2 CNV",
    "RPL6P2 RNA"
  ],
  "RABGAP1L": [
    "RABGAP1L CNV",
    "RABGAP1L RNA",
    "RABGAP1L Proteo"
  ],
  "OR10G9": [
    "OR10G9 CNV",
    "OR10G9 RNA"
  ],
  "MTND4LP18": [
    "MTND4LP18 CNV",
    "MTND4LP18 RNA"
  ],
  "TTC3P1": [
    "TTC3P1 CNV",
    "TTC3P1 RNA"
  ],
  "SHLD3": [
    "SHLD3 CNV",
    "SHLD3 RNA"
  ],
  "CFAP97P1": [
    "CFAP97P1 CNV",
    "CFAP97P1 RNA"
  ],
  "VPS18": [
    "VPS18 CNV",
    "VPS18 RNA",
    "VPS18 Proteo"
  ],
  "UBTD1": [
    "UBTD1 CNV",
    "UBTD1 RNA",
    "UBTD1 Proteo"
  ],
  "HMGN1P5": [
    "HMGN1P5 CNV",
    "HMGN1P5 RNA"
  ],
  "EED": [
    "EED CNV",
    "EED RNA",
    "EED Proteo"
  ],
  "KBTBD3": [
    "KBTBD3 CNV",
    "KBTBD3 RNA"
  ],
  "FHL5": [
    "FHL5 CNV",
    "FHL5 RNA"
  ],
  "PHPT1": [
    "PHPT1 CNV",
    "PHPT1 RNA",
    "PHPT1 Proteo"
  ],
  "CFAP36": [
    "CFAP36 CNV",
    "CFAP36 RNA",
    "CFAP36 Proteo"
  ],
  "CA10": [
    "CA10 CNV",
    "CA10 RNA"
  ],
  "MTATP8P2": [
    "MTATP8P2 CNV",
    "MTATP8P2 RNA"
  ],
  "ZBTB45P2": [
    "ZBTB45P2 CNV",
    "ZBTB45P2 RNA"
  ],
  "UBE2V1P9": [
    "UBE2V1P9 CNV",
    "UBE2V1P9 RNA"
  ],
  "NEK5": [
    "NEK5 CNV",
    "NEK5 RNA"
  ],
  "TTC23L": [
    "TTC23L CNV",
    "TTC23L RNA"
  ],
  "GGCT": [
    "GGCT CNV",
    "GGCT RNA",
    "GGCT Proteo"
  ],
  "MPV17L": [
    "MPV17L CNV",
    "MPV17L RNA"
  ],
  "TMPRSS6": [
    "TMPRSS6 CNV",
    "TMPRSS6 RNA"
  ],
  "CRTC1P1": [
    "CRTC1P1 CNV",
    "CRTC1P1 RNA"
  ],
  "RPL7P44": [
    "RPL7P44 CNV",
    "RPL7P44 RNA"
  ],
  "SULT1A3": [
    "SULT1A3 CNV",
    "SULT1A3 RNA",
    "SULT1A3 Proteo"
  ],
  "CD300LD": [
    "CD300LD CNV",
    "CD300LD RNA"
  ],
  "S100P": [
    "S100P CNV",
    "S100P RNA",
    "S100P Proteo"
  ],
  "SNX18P4": [
    "SNX18P4 CNV",
    "SNX18P4 RNA"
  ],
  "CENPBD2P": [
    "CENPBD2P CNV",
    "CENPBD2P RNA"
  ],
  "ANAPC1P6": [
    "ANAPC1P6 CNV",
    "ANAPC1P6 RNA"
  ],
  "CCDC166": [
    "CCDC166 CNV",
    "CCDC166 RNA"
  ],
  "FAM153A": [
    "FAM153A CNV",
    "FAM153A RNA"
  ],
  "UBAP2": [
    "UBAP2 CNV",
    "UBAP2 RNA",
    "UBAP2 Proteo"
  ],
  "HSFX3": [
    "HSFX3 CNV",
    "HSFX3 RNA"
  ],
  "FKBP5": [
    "FKBP5 CNV",
    "FKBP5 RNA",
    "FKBP5 Proteo"
  ],
  "MTND4P26": [
    "MTND4P26 CNV",
    "MTND4P26 RNA"
  ],
  "GPR88": [
    "GPR88 CNV",
    "GPR88 RNA"
  ],
  "RPL32P35": [
    "RPL32P35 CNV",
    "RPL32P35 RNA"
  ],
  "ZNF404": [
    "ZNF404 CNV",
    "ZNF404 RNA"
  ],
  "OR2S1P": [
    "OR2S1P CNV",
    "OR2S1P RNA"
  ],
  "IGHV1-14": [
    "IGHV1-14 CNV",
    "IGHV1-14 RNA"
  ],
  "ZNF7": [
    "ZNF7 CNV",
    "ZNF7 RNA",
    "ZNF7 Proteo"
  ],
  "B4GALT2": [
    "B4GALT2 CNV",
    "B4GALT2 RNA"
  ],
  "PAWR": [
    "PAWR CNV",
    "PAWR RNA",
    "PAWR Proteo"
  ],
  "SGK2": [
    "SGK2 CNV",
    "SGK2 RNA",
    "SGK2 Proteo"
  ],
  "RETREG1": [
    "RETREG1 CNV",
    "RETREG1 RNA",
    "RETREG1 Proteo"
  ],
  "TTC39A": [
    "TTC39A CNV",
    "TTC39A RNA",
    "TTC39A Proteo"
  ],
  "HIGD1AP12": [
    "HIGD1AP12 CNV",
    "HIGD1AP12 RNA"
  ],
  "ATP11A": [
    "ATP11A CNV",
    "ATP11A RNA",
    "ATP11A Proteo"
  ],
  "HOXD8": [
    "HOXD8 CNV",
    "HOXD8 RNA",
    "HOXD8 Proteo"
  ],
  "CLDN9": [
    "CLDN9 CNV",
    "CLDN9 RNA"
  ],
  "E2F1": [
    "E2F1 CNV",
    "E2F1 RNA"
  ],
  "VSIR": [
    "VSIR CNV",
    "VSIR RNA",
    "VSIR Proteo"
  ],
  "RPL7AP21": [
    "RPL7AP21 CNV",
    "RPL7AP21 RNA"
  ],
  "HEATR3": [
    "HEATR3 CNV",
    "HEATR3 RNA",
    "HEATR3 Proteo"
  ],
  "OR7E83P": [
    "OR7E83P CNV",
    "OR7E83P RNA"
  ],
  "TTC30A": [
    "TTC30A CNV",
    "TTC30A RNA",
    "TTC30A Proteo"
  ],
  "ST13P10": [
    "ST13P10 CNV",
    "ST13P10 RNA"
  ],
  "MAP2": [
    "MAP2 CNV",
    "MAP2 RNA",
    "MAP2 Proteo"
  ],
  "TCAF1": [
    "TCAF1 CNV",
    "TCAF1 RNA",
    "TCAF1 Proteo"
  ],
  "FBXL21P": [
    "FBXL21P CNV",
    "FBXL21P RNA"
  ],
  "MTND2P25": [
    "MTND2P25 CNV",
    "MTND2P25 RNA"
  ],
  "ATF4P4": [
    "ATF4P4 CNV",
    "ATF4P4 RNA"
  ],
  "NPAT": [
    "NPAT CNV",
    "NPAT RNA",
    "NPAT Proteo"
  ],
  "EEPD1": [
    "EEPD1 CNV",
    "EEPD1 RNA",
    "EEPD1 Proteo"
  ],
  "KRCC1": [
    "KRCC1 CNV",
    "KRCC1 RNA"
  ],
  "ARAFP3": [
    "ARAFP3 CNV",
    "ARAFP3 RNA"
  ],
  "NF1P12": [
    "NF1P12 CNV",
    "NF1P12 RNA"
  ],
  "H3C8": [
    "H3C8 CNV",
    "H3C8 RNA"
  ],
  "MSANTD2P1": [
    "MSANTD2P1 CNV",
    "MSANTD2P1 RNA"
  ],
  "DNM1P17": [
    "DNM1P17 CNV",
    "DNM1P17 RNA"
  ],
  "TBC1D3C": [
    "TBC1D3C CNV",
    "TBC1D3C RNA"
  ],
  "HNRNPUP1": [
    "HNRNPUP1 CNV",
    "HNRNPUP1 RNA"
  ],
  "POLR1D": [
    "POLR1D CNV",
    "POLR1D RNA",
    "POLR1D Proteo"
  ],
  "ZBTB6": [
    "ZBTB6 CNV",
    "ZBTB6 RNA"
  ],
  "OFD1P12Y": [
    "OFD1P12Y CNV",
    "OFD1P12Y RNA"
  ],
  "MAG": [
    "MAG CNV",
    "MAG RNA",
    "MAG Proteo"
  ],
  "MRM1": [
    "MRM1 CNV",
    "MRM1 RNA",
    "MRM1 Proteo"
  ],
  "PCARE": [
    "PCARE CNV",
    "PCARE RNA"
  ],
  "FGD5": [
    "FGD5 CNV",
    "FGD5 RNA",
    "FGD5 Proteo"
  ],
  "KHDRBS3": [
    "KHDRBS3 CNV",
    "KHDRBS3 RNA",
    "KHDRBS3 Proteo"
  ],
  "IP6K3": [
    "IP6K3 CNV",
    "IP6K3 RNA"
  ],
  "PTPN21": [
    "PTPN21 CNV",
    "PTPN21 RNA",
    "PTPN21 Proteo"
  ],
  "PRAMEF4": [
    "PRAMEF4 CNV",
    "PRAMEF4 RNA"
  ],
  "UPF3AP2": [
    "UPF3AP2 CNV",
    "UPF3AP2 RNA"
  ],
  "JAK3": [
    "JAK3 CNV",
    "JAK3 RNA",
    "JAK3 Proteo"
  ],
  "ADAMTS18": [
    "ADAMTS18 CNV",
    "ADAMTS18 RNA"
  ],
  "SRPRB": [
    "SRPRB CNV",
    "SRPRB RNA",
    "SRPRB Proteo"
  ],
  "RAB4B": [
    "RAB4B CNV",
    "RAB4B RNA",
    "RAB4B Proteo"
  ],
  "GHRH": [
    "GHRH CNV",
    "GHRH RNA"
  ],
  "CLU": [
    "CLU CNV",
    "CLU RNA",
    "CLU Proteo"
  ],
  "HMX3": [
    "HMX3 CNV",
    "HMX3 RNA"
  ],
  "GAGE12F": [
    "GAGE12F CNV",
    "GAGE12F RNA"
  ],
  "LY75": [
    "LY75 CNV",
    "LY75 RNA"
  ],
  "RPL23AP7": [
    "RPL23AP7 CNV",
    "RPL23AP7 RNA"
  ],
  "GPR183": [
    "GPR183 CNV",
    "GPR183 RNA",
    "GPR183 Proteo"
  ],
  "MMADHCP1": [
    "MMADHCP1 CNV",
    "MMADHCP1 RNA"
  ],
  "OR7E36P": [
    "OR7E36P CNV",
    "OR7E36P RNA"
  ],
  "FOXA3": [
    "FOXA3 CNV",
    "FOXA3 RNA"
  ],
  "SPRED3": [
    "SPRED3 CNV",
    "SPRED3 RNA"
  ],
  "CHRND": [
    "CHRND CNV",
    "CHRND RNA"
  ],
  "TM9SF4": [
    "TM9SF4 CNV",
    "TM9SF4 RNA",
    "TM9SF4 Proteo"
  ],
  "SOX7": [
    "SOX7 CNV",
    "SOX7 RNA"
  ],
  "PTGES2": [
    "PTGES2 CNV",
    "PTGES2 RNA",
    "PTGES2 Proteo"
  ],
  "SGSM2": [
    "SGSM2 CNV",
    "SGSM2 RNA"
  ],
  "CPXM2": [
    "CPXM2 CNV",
    "CPXM2 RNA",
    "CPXM2 Proteo"
  ],
  "PGAM1P8": [
    "PGAM1P8 CNV",
    "PGAM1P8 RNA"
  ],
  "HCAR3": [
    "HCAR3 CNV",
    "HCAR3 RNA"
  ],
  "PHLDB2": [
    "PHLDB2 CNV",
    "PHLDB2 RNA",
    "PHLDB2 Proteo"
  ],
  "AHSA1": [
    "AHSA1 CNV",
    "AHSA1 RNA",
    "AHSA1 Proteo"
  ],
  "RANP6": [
    "RANP6 CNV",
    "RANP6 RNA"
  ],
  "MTCYBP32": [
    "MTCYBP32 CNV",
    "MTCYBP32 RNA"
  ],
  "NPHP3": [
    "NPHP3 CNV",
    "NPHP3 RNA",
    "NPHP3 Proteo"
  ],
  "HLA-N": [
    "HLA-N CNV",
    "HLA-N RNA"
  ],
  "BAX": [
    "BAX CNV",
    "BAX RNA",
    "BAX Proteo"
  ],
  "GRAMD4P4": [
    "GRAMD4P4 CNV",
    "GRAMD4P4 RNA"
  ],
  "FAM9C": [
    "FAM9C CNV",
    "FAM9C RNA",
    "FAM9C Proteo"
  ],
  "PDE4DIPP5": [
    "PDE4DIPP5 CNV",
    "PDE4DIPP5 RNA"
  ],
  "AKR1B10P2": [
    "AKR1B10P2 CNV",
    "AKR1B10P2 RNA"
  ],
  "CCT6A": [
    "CCT6A CNV",
    "CCT6A RNA",
    "CCT6A Proteo"
  ],
  "BACE2": [
    "BACE2 CNV",
    "BACE2 RNA",
    "BACE2 Proteo"
  ],
  "RPL12P11": [
    "RPL12P11 CNV",
    "RPL12P11 RNA"
  ],
  "ZNF211": [
    "ZNF211 CNV",
    "ZNF211 RNA"
  ],
  "DTHD1": [
    "DTHD1 CNV",
    "DTHD1 RNA",
    "DTHD1 Proteo"
  ],
  "RPL36AP12": [
    "RPL36AP12 CNV",
    "RPL36AP12 RNA"
  ],
  "CYP21A2": [
    "CYP21A2 CNV",
    "CYP21A2 RNA"
  ],
  "FAM110C": [
    "FAM110C CNV",
    "FAM110C RNA"
  ],
  "FAM81B": [
    "FAM81B CNV",
    "FAM81B RNA"
  ],
  "MRPL30P1": [
    "MRPL30P1 CNV",
    "MRPL30P1 RNA"
  ],
  "FAM201B": [
    "FAM201B CNV",
    "FAM201B RNA"
  ],
  "RTN3P1": [
    "RTN3P1 CNV",
    "RTN3P1 RNA"
  ],
  "CFL1P4": [
    "CFL1P4 CNV",
    "CFL1P4 RNA"
  ],
  "SDR42E1P1": [
    "SDR42E1P1 CNV",
    "SDR42E1P1 RNA"
  ],
  "IGKV3-7": [
    "IGKV3-7 Proteo"
  ],
  "CSGALNACT1": [
    "CSGALNACT1 CNV",
    "CSGALNACT1 RNA",
    "CSGALNACT1 Proteo"
  ],
  "MMAB": [
    "MMAB CNV",
    "MMAB RNA",
    "MMAB Proteo"
  ],
  "GPR160": [
    "GPR160 CNV",
    "GPR160 RNA"
  ],
  "CALM1P1": [
    "CALM1P1 CNV",
    "CALM1P1 RNA"
  ],
  "PRPF6": [
    "PRPF6 CNV",
    "PRPF6 RNA",
    "PRPF6 Proteo"
  ],
  "NPM1P4": [
    "NPM1P4 CNV",
    "NPM1P4 RNA"
  ],
  "ZFP36": [
    "ZFP36 CNV",
    "ZFP36 RNA",
    "ZFP36 Proteo"
  ],
  "PEX5": [
    "PEX5 CNV",
    "PEX5 RNA",
    "PEX5 Proteo"
  ],
  "CST7": [
    "CST7 CNV",
    "CST7 RNA",
    "CST7 Proteo"
  ],
  "CACNA1C": [
    "CACNA1C CNV",
    "CACNA1C RNA"
  ],
  "GZMB": [
    "GZMB CNV",
    "GZMB RNA",
    "GZMB Proteo"
  ],
  "RAB28P2": [
    "RAB28P2 CNV",
    "RAB28P2 RNA"
  ],
  "DCP2": [
    "DCP2 CNV",
    "DCP2 RNA",
    "DCP2 Proteo"
  ],
  "TPRX1P1": [
    "TPRX1P1 CNV",
    "TPRX1P1 RNA"
  ],
  "CAMTA1": [
    "CAMTA1 CNV",
    "CAMTA1 RNA"
  ],
  "MAPK6P6": [
    "MAPK6P6 CNV",
    "MAPK6P6 RNA"
  ],
  "PSMC1P8": [
    "PSMC1P8 CNV",
    "PSMC1P8 RNA"
  ],
  "TMEM39B": [
    "TMEM39B CNV",
    "TMEM39B RNA",
    "TMEM39B Proteo"
  ],
  "CEACAM21": [
    "CEACAM21 CNV",
    "CEACAM21 RNA"
  ],
  "GPR15": [
    "GPR15 CNV",
    "GPR15 RNA"
  ],
  "CRACR2B": [
    "CRACR2B CNV",
    "CRACR2B RNA",
    "CRACR2B Proteo"
  ],
  "TIMP1": [
    "TIMP1 CNV",
    "TIMP1 RNA",
    "TIMP1 Proteo"
  ],
  "AQR": [
    "AQR CNV",
    "AQR RNA",
    "AQR Proteo"
  ],
  "APBB1": [
    "APBB1 CNV",
    "APBB1 RNA",
    "APBB1 Proteo"
  ],
  "C9orf152": [
    "C9orf152 CNV",
    "C9orf152 RNA"
  ],
  "ANKUB1": [
    "ANKUB1 CNV",
    "ANKUB1 RNA"
  ],
  "RPL17P40": [
    "RPL17P40 CNV",
    "RPL17P40 RNA"
  ],
  "LRIT1": [
    "LRIT1 CNV",
    "LRIT1 RNA"
  ],
  "ZNF44": [
    "ZNF44 CNV",
    "ZNF44 RNA"
  ],
  "PRKAR2B": [
    "PRKAR2B CNV",
    "PRKAR2B RNA",
    "PRKAR2B Proteo"
  ],
  "TLR9": [
    "TLR9 CNV",
    "TLR9 RNA"
  ],
  "OR6C4": [
    "OR6C4 CNV",
    "OR6C4 RNA"
  ],
  "TIMP2": [
    "TIMP2 CNV",
    "TIMP2 RNA",
    "TIMP2 Proteo"
  ],
  "VAX2": [
    "VAX2 CNV",
    "VAX2 RNA"
  ],
  "RPS27P21": [
    "RPS27P21 CNV",
    "RPS27P21 RNA"
  ],
  "PRR9": [
    "PRR9 CNV",
    "PRR9 RNA",
    "PRR9 Proteo"
  ],
  "SNX18P5": [
    "SNX18P5 CNV",
    "SNX18P5 RNA"
  ],
  "PODXL2": [
    "PODXL2 CNV",
    "PODXL2 RNA",
    "PODXL2 Proteo"
  ],
  "ALDH7A1P3": [
    "ALDH7A1P3 CNV",
    "ALDH7A1P3 RNA"
  ],
  "ACAA1": [
    "ACAA1 CNV",
    "ACAA1 RNA",
    "ACAA1 Proteo"
  ],
  "IL9RP4": [
    "IL9RP4 CNV",
    "IL9RP4 RNA"
  ],
  "NR1D2": [
    "NR1D2 CNV",
    "NR1D2 RNA",
    "NR1D2 Proteo"
  ],
  "TLN1": [
    "TLN1 CNV",
    "TLN1 RNA",
    "TLN1 Proteo"
  ],
  "RHPN2P1": [
    "RHPN2P1 CNV",
    "RHPN2P1 RNA"
  ],
  "SLC10A3": [
    "SLC10A3 CNV",
    "SLC10A3 RNA"
  ],
  "HNRNPA1": [
    "HNRNPA1 CNV",
    "HNRNPA1 RNA",
    "HNRNPA1 Proteo"
  ],
  "RPL7P37": [
    "RPL7P37 CNV",
    "RPL7P37 RNA"
  ],
  "CDK2AP2P1": [
    "CDK2AP2P1 CNV",
    "CDK2AP2P1 RNA"
  ],
  "OR3D1P": [
    "OR3D1P CNV",
    "OR3D1P RNA"
  ],
  "PHF23": [
    "PHF23 CNV",
    "PHF23 RNA",
    "PHF23 Proteo"
  ],
  "ATP4B": [
    "ATP4B CNV",
    "ATP4B RNA"
  ],
  "TIMP3": [
    "TIMP3 CNV",
    "TIMP3 RNA",
    "TIMP3 Proteo"
  ],
  "HMGB3P16": [
    "HMGB3P16 CNV",
    "HMGB3P16 RNA"
  ],
  "HSF4": [
    "HSF4 CNV",
    "HSF4 RNA"
  ],
  "STMN3": [
    "STMN3 CNV",
    "STMN3 RNA",
    "STMN3 Proteo"
  ],
  "CTSS": [
    "CTSS CNV",
    "CTSS RNA",
    "CTSS Proteo"
  ],
  "IGKV1OR2-9": [
    "IGKV1OR2-9 CNV",
    "IGKV1OR2-9 RNA"
  ],
  "NCAPD2": [
    "NCAPD2 CNV",
    "NCAPD2 RNA",
    "NCAPD2 Proteo"
  ],
  "ABI2": [
    "ABI2 CNV",
    "ABI2 RNA",
    "ABI2 Proteo"
  ],
  "NPIPB7": [
    "NPIPB7 CNV",
    "NPIPB7 RNA"
  ],
  "OR11H1": [
    "OR11H1 CNV",
    "OR11H1 RNA"
  ],
  "CSAG4": [
    "CSAG4 CNV",
    "CSAG4 RNA"
  ],
  "KRTAP19-1": [
    "KRTAP19-1 CNV",
    "KRTAP19-1 RNA"
  ],
  "PHKB": [
    "PHKB CNV",
    "PHKB RNA",
    "PHKB Proteo"
  ],
  "TUBBP11": [
    "TUBBP11 CNV",
    "TUBBP11 RNA"
  ],
  "COG5": [
    "COG5 CNV",
    "COG5 RNA",
    "COG5 Proteo"
  ],
  "DGKQ": [
    "DGKQ CNV",
    "DGKQ RNA",
    "DGKQ Proteo"
  ],
  "GCNT3": [
    "GCNT3 CNV",
    "GCNT3 RNA",
    "GCNT3 Proteo"
  ],
  "CISD3": [
    "CISD3 CNV",
    "CISD3 RNA",
    "CISD3 Proteo"
  ],
  "NFKBIA": [
    "NFKBIA CNV",
    "NFKBIA RNA",
    "NFKBIA Proteo"
  ],
  "SHANK3": [
    "SHANK3 CNV",
    "SHANK3 RNA",
    "SHANK3 Proteo"
  ],
  "PRR19": [
    "PRR19 CNV",
    "PRR19 RNA"
  ],
  "ANKRD30A": [
    "ANKRD30A CNV",
    "ANKRD30A RNA"
  ],
  "LRRCC1": [
    "LRRCC1 CNV",
    "LRRCC1 RNA",
    "LRRCC1 Proteo"
  ],
  "AMBP": [
    "AMBP CNV",
    "AMBP RNA",
    "AMBP Proteo"
  ],
  "CDS2": [
    "CDS2 CNV",
    "CDS2 RNA",
    "CDS2 Proteo"
  ],
  "SOX5P1": [
    "SOX5P1 CNV",
    "SOX5P1 RNA"
  ],
  "SLC17A1": [
    "SLC17A1 CNV",
    "SLC17A1 RNA"
  ],
  "GRAMD4P6": [
    "GRAMD4P6 CNV",
    "GRAMD4P6 RNA"
  ],
  "CD3E": [
    "CD3E CNV",
    "CD3E RNA",
    "CD3E Proteo"
  ],
  "MAGEB1": [
    "MAGEB1 CNV",
    "MAGEB1 RNA",
    "MAGEB1 Proteo"
  ],
  "PLET1": [
    "PLET1 CNV",
    "PLET1 RNA"
  ],
  "RIC3": [
    "RIC3 CNV",
    "RIC3 RNA"
  ],
  "PCSK9": [
    "PCSK9 CNV",
    "PCSK9 RNA",
    "PCSK9 Proteo"
  ],
  "C17orf78": [
    "C17orf78 CNV",
    "C17orf78 RNA"
  ],
  "STIP1P3": [
    "STIP1P3 CNV",
    "STIP1P3 RNA"
  ],
  "H2AC6": [
    "H2AC6 CNV",
    "H2AC6 RNA"
  ],
  "RACK1P3": [
    "RACK1P3 CNV",
    "RACK1P3 RNA"
  ],
  "NPM1P28": [
    "NPM1P28 CNV",
    "NPM1P28 RNA"
  ],
  "RPS2P4": [
    "RPS2P4 CNV",
    "RPS2P4 RNA"
  ],
  "CROCCP4": [
    "CROCCP4 CNV",
    "CROCCP4 RNA"
  ],
  "VPS9D1": [
    "VPS9D1 CNV",
    "VPS9D1 RNA",
    "VPS9D1 Proteo"
  ],
  "DRAXIN": [
    "DRAXIN CNV",
    "DRAXIN RNA"
  ],
  "NME1P1": [
    "NME1P1 CNV",
    "NME1P1 RNA"
  ],
  "RPL30P4": [
    "RPL30P4 CNV",
    "RPL30P4 RNA"
  ],
  "ESCO2": [
    "ESCO2 CNV",
    "ESCO2 RNA",
    "ESCO2 Proteo"
  ],
  "MAPK1IP1L": [
    "MAPK1IP1L CNV",
    "MAPK1IP1L RNA",
    "MAPK1IP1L Proteo"
  ],
  "TAGLN2": [
    "TAGLN2 CNV",
    "TAGLN2 RNA",
    "TAGLN2 Proteo"
  ],
  "LILRB5": [
    "LILRB5 CNV",
    "LILRB5 RNA",
    "LILRB5 Proteo"
  ],
  "AMYP1": [
    "AMYP1 CNV",
    "AMYP1 RNA"
  ],
  "EIF2AK2": [
    "EIF2AK2 CNV",
    "EIF2AK2 RNA",
    "EIF2AK2 Proteo"
  ],
  "TMEM116": [
    "TMEM116 CNV",
    "TMEM116 RNA"
  ],
  "MBL1P": [
    "MBL1P CNV",
    "MBL1P RNA"
  ],
  "CXCL12": [
    "CXCL12 CNV",
    "CXCL12 RNA",
    "CXCL12 Proteo"
  ],
  "CD69": [
    "CD69 CNV",
    "CD69 RNA"
  ],
  "FZD7": [
    "FZD7 CNV",
    "FZD7 RNA",
    "FZD7 Proteo"
  ],
  "DLK1": [
    "DLK1 CNV",
    "DLK1 RNA"
  ],
  "C4A": [
    "C4A CNV",
    "C4A RNA",
    "C4A Proteo"
  ],
  "RNA5SP491": [
    "RNA5SP491 CNV",
    "RNA5SP491 RNA"
  ],
  "KCTD11": [
    "KCTD11 CNV",
    "KCTD11 RNA"
  ],
  "CD9": [
    "CD9 CNV",
    "CD9 RNA",
    "CD9 Proteo"
  ],
  "ARMCX1": [
    "ARMCX1 CNV",
    "ARMCX1 RNA",
    "ARMCX1 Proteo"
  ],
  "CFAP251": [
    "CFAP251 CNV",
    "CFAP251 RNA"
  ],
  "RPS12P4": [
    "RPS12P4 CNV",
    "RPS12P4 RNA"
  ],
  "NIFK": [
    "NIFK CNV",
    "NIFK RNA",
    "NIFK Proteo"
  ],
  "AQP1": [
    "AQP1 CNV",
    "AQP1 RNA",
    "AQP1 Proteo"
  ],
  "RPS15AP38": [
    "RPS15AP38 CNV",
    "RPS15AP38 RNA"
  ],
  "ATP11C": [
    "ATP11C CNV",
    "ATP11C RNA",
    "ATP11C Proteo"
  ],
  "SMCR8": [
    "SMCR8 CNV",
    "SMCR8 RNA",
    "SMCR8 Proteo"
  ],
  "MTND2P22": [
    "MTND2P22 CNV",
    "MTND2P22 RNA"
  ],
  "KRT35": [
    "KRT35 CNV",
    "KRT35 RNA",
    "KRT35 Proteo"
  ],
  "EVX1": [
    "EVX1 CNV",
    "EVX1 RNA"
  ],
  "PSG6": [
    "PSG6 CNV",
    "PSG6 RNA"
  ],
  "NUP210": [
    "NUP210 CNV",
    "NUP210 RNA",
    "NUP210 Proteo"
  ],
  "SHLD2P1": [
    "SHLD2P1 CNV",
    "SHLD2P1 RNA"
  ],
  "MTATP6P17": [
    "MTATP6P17 CNV",
    "MTATP6P17 RNA"
  ],
  "LPCAT2BP": [
    "LPCAT2BP CNV",
    "LPCAT2BP RNA"
  ],
  "PFN1P11": [
    "PFN1P11 CNV",
    "PFN1P11 RNA"
  ],
  "ZNF555": [
    "ZNF555 CNV",
    "ZNF555 RNA"
  ],
  "THAP12P9": [
    "THAP12P9 CNV",
    "THAP12P9 RNA"
  ],
  "ATP5PDP4": [
    "ATP5PDP4 CNV",
    "ATP5PDP4 RNA"
  ],
  "PPP1R3E": [
    "PPP1R3E CNV",
    "PPP1R3E RNA",
    "PPP1R3E Proteo"
  ],
  "CCNYL2": [
    "CCNYL2 CNV",
    "CCNYL2 RNA"
  ],
  "FH": [
    "FH CNV",
    "FH RNA",
    "FH Proteo"
  ],
  "FANCD2OS": [
    "FANCD2OS CNV",
    "FANCD2OS RNA"
  ],
  "CRABP1": [
    "CRABP1 CNV",
    "CRABP1 RNA",
    "CRABP1 Proteo"
  ],
  "TNFSF12": [
    "TNFSF12 CNV",
    "TNFSF12 RNA"
  ],
  "SLC29A4P2": [
    "SLC29A4P2 CNV",
    "SLC29A4P2 RNA"
  ],
  "SPNS1": [
    "SPNS1 CNV",
    "SPNS1 RNA",
    "SPNS1 Proteo"
  ],
  "ALAS2": [
    "ALAS2 CNV",
    "ALAS2 RNA"
  ],
  "CTIF": [
    "CTIF CNV",
    "CTIF RNA",
    "CTIF Proteo"
  ],
  "METTL17": [
    "METTL17 CNV",
    "METTL17 RNA",
    "METTL17 Proteo"
  ],
  "TAAR6": [
    "TAAR6 CNV",
    "TAAR6 RNA"
  ],
  "GCSHP4": [
    "GCSHP4 CNV",
    "GCSHP4 RNA"
  ],
  "RARB": [
    "RARB CNV",
    "RARB RNA"
  ],
  "ADAMTS13": [
    "ADAMTS13 CNV",
    "ADAMTS13 RNA"
  ],
  "ACTN4P1": [
    "ACTN4P1 CNV",
    "ACTN4P1 RNA"
  ],
  "ZFP36L2": [
    "ZFP36L2 CNV",
    "ZFP36L2 RNA",
    "ZFP36L2 Proteo"
  ],
  "AEN": [
    "AEN CNV",
    "AEN RNA",
    "AEN Proteo"
  ],
  "FER1L6": [
    "FER1L6 CNV",
    "FER1L6 RNA"
  ],
  "PPFIBP1": [
    "PPFIBP1 CNV",
    "PPFIBP1 RNA",
    "PPFIBP1 Proteo"
  ],
  "RBAK": [
    "RBAK CNV",
    "RBAK RNA",
    "RBAK Proteo"
  ],
  "RBPJP6": [
    "RBPJP6 CNV",
    "RBPJP6 RNA"
  ],
  "YPEL5P2": [
    "YPEL5P2 CNV",
    "YPEL5P2 RNA"
  ],
  "SEPTIN7": [
    "SEPTIN7 CNV",
    "SEPTIN7 RNA",
    "SEPTIN7 Proteo"
  ],
  "SLC37A1": [
    "SLC37A1 CNV",
    "SLC37A1 RNA"
  ],
  "GSTA2": [
    "GSTA2 CNV",
    "GSTA2 RNA"
  ],
  "PSPH": [
    "PSPH CNV",
    "PSPH RNA",
    "PSPH Proteo"
  ],
  "RHAG": [
    "RHAG CNV",
    "RHAG RNA",
    "RHAG Proteo"
  ],
  "ZIC2": [
    "ZIC2 CNV",
    "ZIC2 RNA"
  ],
  "NFAM1": [
    "NFAM1 CNV",
    "NFAM1 RNA",
    "NFAM1 Proteo"
  ],
  "RPL37AP1": [
    "RPL37AP1 CNV",
    "RPL37AP1 RNA"
  ],
  "WBP1P1": [
    "WBP1P1 CNV",
    "WBP1P1 RNA"
  ],
  "RNA5SP169": [
    "RNA5SP169 CNV",
    "RNA5SP169 RNA"
  ],
  "USP17L24": [
    "USP17L24 CNV",
    "USP17L24 RNA"
  ],
  "IGKV2OR2-7": [
    "IGKV2OR2-7 CNV",
    "IGKV2OR2-7 RNA"
  ],
  "RPS29P30": [
    "RPS29P30 CNV",
    "RPS29P30 RNA"
  ],
  "RNASE8": [
    "RNASE8 CNV",
    "RNASE8 RNA"
  ],
  "WDR83": [
    "WDR83 CNV",
    "WDR83 RNA",
    "WDR83 Proteo"
  ],
  "POM121L9P": [
    "POM121L9P CNV",
    "POM121L9P RNA"
  ],
  "DUSP29": [
    "DUSP29 CNV",
    "DUSP29 RNA"
  ],
  "RAD54L": [
    "RAD54L CNV",
    "RAD54L RNA",
    "RAD54L Proteo"
  ],
  "CLCN1": [
    "CLCN1 CNV",
    "CLCN1 RNA"
  ],
  "FGR": [
    "FGR CNV",
    "FGR RNA",
    "FGR Proteo"
  ],
  "CCNJL": [
    "CCNJL CNV",
    "CCNJL RNA"
  ],
  "HSPA14": [
    "HSPA14 CNV",
    "HSPA14 RNA",
    "HSPA14 Proteo"
  ],
  "PTRH1": [
    "PTRH1 CNV",
    "PTRH1 RNA",
    "PTRH1 Proteo"
  ],
  "CH25H": [
    "CH25H CNV",
    "CH25H RNA"
  ],
  "DR1": [
    "DR1 CNV",
    "DR1 RNA",
    "DR1 Proteo"
  ],
  "KCNG2": [
    "KCNG2 CNV",
    "KCNG2 RNA"
  ],
  "NFKBIB": [
    "NFKBIB CNV",
    "NFKBIB RNA",
    "NFKBIB Proteo"
  ],
  "GYG1P1": [
    "GYG1P1 CNV",
    "GYG1P1 RNA"
  ],
  "GANAB": [
    "GANAB CNV",
    "GANAB RNA",
    "GANAB Proteo"
  ],
  "SLC38A7": [
    "SLC38A7 CNV",
    "SLC38A7 RNA",
    "SLC38A7 Proteo"
  ],
  "SUMO2P19": [
    "SUMO2P19 CNV",
    "SUMO2P19 RNA"
  ],
  "PRKCD": [
    "PRKCD CNV",
    "PRKCD RNA",
    "PRKCD Proteo"
  ],
  "XCL1": [
    "XCL1 CNV",
    "XCL1 RNA",
    "XCL1 Proteo"
  ],
  "FAM178B": [
    "FAM178B CNV",
    "FAM178B RNA",
    "FAM178B Proteo"
  ],
  "SERF1A": [
    "SERF1A CNV",
    "SERF1A RNA"
  ],
  "OR8J3": [
    "OR8J3 CNV",
    "OR8J3 RNA"
  ],
  "KLK3": [
    "KLK3 CNV",
    "KLK3 RNA"
  ],
  "SFTPA3P": [
    "SFTPA3P CNV",
    "SFTPA3P RNA"
  ],
  "RAB13": [
    "RAB13 CNV",
    "RAB13 RNA",
    "RAB13 Proteo"
  ],
  "RPL23AP85": [
    "RPL23AP85 CNV",
    "RPL23AP85 RNA"
  ],
  "C14orf93": [
    "C14orf93 CNV",
    "C14orf93 RNA",
    "C14orf93 Proteo"
  ],
  "EPB41L4B": [
    "EPB41L4B CNV",
    "EPB41L4B RNA",
    "EPB41L4B Proteo"
  ],
  "ANKRD20A18P": [
    "ANKRD20A18P CNV",
    "ANKRD20A18P RNA"
  ],
  "WFDC13": [
    "WFDC13 CNV",
    "WFDC13 RNA"
  ],
  "MYL11": [
    "MYL11 CNV",
    "MYL11 RNA",
    "MYL11 Proteo"
  ],
  "YBX1P7": [
    "YBX1P7 CNV",
    "YBX1P7 RNA"
  ],
  "VN1R1": [
    "VN1R1 CNV",
    "VN1R1 RNA"
  ],
  "HLA-J": [
    "HLA-J CNV",
    "HLA-J RNA"
  ],
  "METTL9": [
    "METTL9 CNV",
    "METTL9 RNA",
    "METTL9 Proteo"
  ],
  "MSMB": [
    "MSMB CNV",
    "MSMB RNA"
  ],
  "CMTM3": [
    "CMTM3 CNV",
    "CMTM3 RNA",
    "CMTM3 Proteo"
  ],
  "PUDPP3": [
    "PUDPP3 CNV",
    "PUDPP3 RNA"
  ],
  "TBX4": [
    "TBX4 CNV",
    "TBX4 RNA"
  ],
  "CLCN3P1": [
    "CLCN3P1 CNV",
    "CLCN3P1 RNA"
  ],
  "RSPO1": [
    "RSPO1 CNV",
    "RSPO1 RNA"
  ],
  "TDG": [
    "TDG CNV",
    "TDG RNA",
    "TDG Proteo"
  ],
  "IL17D": [
    "IL17D CNV",
    "IL17D RNA",
    "IL17D Proteo"
  ],
  "ST13P21": [
    "ST13P21 CNV",
    "ST13P21 RNA"
  ],
  "TMX1": [
    "TMX1 CNV",
    "TMX1 RNA",
    "TMX1 Proteo"
  ],
  "GPR132": [
    "GPR132 CNV",
    "GPR132 RNA"
  ],
  "PIMREGP2": [
    "PIMREGP2 CNV",
    "PIMREGP2 RNA"
  ],
  "ABHD14A-ACY1": [
    "ABHD14A-ACY1 Proteo"
  ],
  "PATL2": [
    "PATL2 CNV",
    "PATL2 RNA"
  ],
  "RPEP2": [
    "RPEP2 CNV",
    "RPEP2 RNA"
  ],
  "DYTN": [
    "DYTN CNV",
    "DYTN RNA"
  ],
  "ZSCAN12P1": [
    "ZSCAN12P1 CNV",
    "ZSCAN12P1 RNA"
  ],
  "ECM1": [
    "ECM1 CNV",
    "ECM1 RNA",
    "ECM1 Proteo"
  ],
  "KRTAP9-7": [
    "KRTAP9-7 CNV",
    "KRTAP9-7 RNA"
  ],
  "MCCC1": [
    "MCCC1 CNV",
    "MCCC1 RNA",
    "MCCC1 Proteo"
  ],
  "C19orf33": [
    "C19orf33 CNV",
    "C19orf33 RNA",
    "C19orf33 Proteo"
  ],
  "GMFG": [
    "GMFG CNV",
    "GMFG RNA",
    "GMFG Proteo"
  ],
  "S100A5": [
    "S100A5 CNV",
    "S100A5 RNA"
  ],
  "LYPD6": [
    "LYPD6 CNV",
    "LYPD6 RNA"
  ],
  "SETP1": [
    "SETP1 CNV",
    "SETP1 RNA"
  ],
  "CMC4": [
    "CMC4 CNV",
    "CMC4 RNA",
    "CMC4 Proteo"
  ],
  "KBTBD4": [
    "KBTBD4 CNV",
    "KBTBD4 RNA",
    "KBTBD4 Proteo"
  ],
  "APLN": [
    "APLN CNV",
    "APLN RNA"
  ],
  "EFCAB13": [
    "EFCAB13 CNV",
    "EFCAB13 RNA"
  ],
  "RPL7AP4": [
    "RPL7AP4 CNV",
    "RPL7AP4 RNA"
  ],
  "HMGN2P22": [
    "HMGN2P22 CNV",
    "HMGN2P22 RNA"
  ],
  "SPATA2L": [
    "SPATA2L CNV",
    "SPATA2L RNA",
    "SPATA2L Proteo"
  ],
  "RPS18P1": [
    "RPS18P1 CNV",
    "RPS18P1 RNA"
  ],
  "TM9SF1": [
    "TM9SF1 CNV",
    "TM9SF1 RNA",
    "TM9SF1 Proteo"
  ],
  "CABLES2": [
    "CABLES2 CNV",
    "CABLES2 RNA"
  ],
  "EVC": [
    "EVC CNV",
    "EVC RNA",
    "EVC Proteo"
  ],
  "VTI1B": [
    "VTI1B CNV",
    "VTI1B RNA",
    "VTI1B Proteo"
  ],
  "RPSAP44": [
    "RPSAP44 CNV",
    "RPSAP44 RNA"
  ],
  "LMAN2L": [
    "LMAN2L CNV",
    "LMAN2L RNA",
    "LMAN2L Proteo"
  ],
  "GBP7": [
    "GBP7 CNV",
    "GBP7 RNA",
    "GBP7 Proteo"
  ],
  "PIGQP1": [
    "PIGQP1 CNV",
    "PIGQP1 RNA"
  ],
  "RHOXF1P2": [
    "RHOXF1P2 CNV",
    "RHOXF1P2 RNA"
  ],
  "ARHGEF40": [
    "ARHGEF40 CNV",
    "ARHGEF40 RNA",
    "ARHGEF40 Proteo"
  ],
  "MCIDAS": [
    "MCIDAS CNV",
    "MCIDAS RNA"
  ],
  "ZDHHC5": [
    "ZDHHC5 CNV",
    "ZDHHC5 RNA",
    "ZDHHC5 Proteo"
  ],
  "SOX11": [
    "SOX11 CNV",
    "SOX11 RNA",
    "SOX11 Proteo"
  ],
  "TUBA3GP": [
    "TUBA3GP CNV",
    "TUBA3GP RNA"
  ],
  "SEMA4F": [
    "SEMA4F CNV",
    "SEMA4F RNA"
  ],
  "SPANXC": [
    "SPANXC CNV",
    "SPANXC RNA"
  ],
  "MTND4P30": [
    "MTND4P30 CNV",
    "MTND4P30 RNA"
  ],
  "TEC": [
    "TEC CNV",
    "TEC RNA",
    "TEC Proteo"
  ],
  "HRAS": [
    "HRAS CNV",
    "HRAS RNA",
    "HRAS Proteo"
  ],
  "CCL8": [
    "CCL8 CNV",
    "CCL8 RNA"
  ],
  "HS1BP3": [
    "HS1BP3 CNV",
    "HS1BP3 RNA",
    "HS1BP3 Proteo"
  ],
  "DDX18": [
    "DDX18 CNV",
    "DDX18 RNA",
    "DDX18 Proteo"
  ],
  "GET1": [
    "GET1 CNV",
    "GET1 RNA",
    "GET1 Proteo"
  ],
  "KDM4D": [
    "KDM4D CNV",
    "KDM4D RNA",
    "KDM4D Proteo"
  ],
  "IGHV1-67": [
    "IGHV1-67 CNV",
    "IGHV1-67 RNA"
  ],
  "TRPC2": [
    "TRPC2 CNV",
    "TRPC2 RNA"
  ],
  "TBCAP1": [
    "TBCAP1 CNV",
    "TBCAP1 RNA"
  ],
  "EPHA5": [
    "EPHA5 CNV",
    "EPHA5 RNA"
  ],
  "PIGS": [
    "PIGS CNV",
    "PIGS RNA",
    "PIGS Proteo"
  ],
  "NTN5": [
    "NTN5 CNV",
    "NTN5 RNA"
  ],
  "MYOZ1": [
    "MYOZ1 CNV",
    "MYOZ1 RNA",
    "MYOZ1 Proteo"
  ],
  "NANOS2": [
    "NANOS2 CNV",
    "NANOS2 RNA"
  ],
  "ACTL10": [
    "ACTL10 CNV",
    "ACTL10 RNA"
  ],
  "CYCSP46": [
    "CYCSP46 CNV",
    "CYCSP46 RNA"
  ],
  "GLB1L2": [
    "GLB1L2 CNV",
    "GLB1L2 RNA",
    "GLB1L2 Proteo"
  ],
  "FAM8A3P": [
    "FAM8A3P CNV",
    "FAM8A3P RNA"
  ],
  "RBSN": [
    "RBSN CNV",
    "RBSN RNA",
    "RBSN Proteo"
  ],
  "TMEM185A": [
    "TMEM185A CNV",
    "TMEM185A RNA"
  ],
  "C3orf49P1": [
    "C3orf49P1 CNV",
    "C3orf49P1 RNA"
  ],
  "CCDC57": [
    "CCDC57 CNV",
    "CCDC57 RNA"
  ],
  "RNA5SP257": [
    "RNA5SP257 CNV",
    "RNA5SP257 RNA"
  ],
  "SUV39H2": [
    "SUV39H2 CNV",
    "SUV39H2 RNA",
    "SUV39H2 Proteo"
  ],
  "USP19": [
    "USP19 CNV",
    "USP19 RNA",
    "USP19 Proteo"
  ],
  "TUBB8P6": [
    "TUBB8P6 CNV",
    "TUBB8P6 RNA"
  ],
  "S100Z": [
    "S100Z CNV",
    "S100Z RNA"
  ],
  "STK11": [
    "STK11 CNV",
    "STK11 RNA",
    "STK11 Proteo"
  ],
  "FAM166A": [
    "FAM166A CNV",
    "FAM166A RNA"
  ],
  "BRDTP1": [
    "BRDTP1 CNV",
    "BRDTP1 RNA"
  ],
  "MTND5P42": [
    "MTND5P42 CNV",
    "MTND5P42 RNA"
  ],
  "ROGDI": [
    "ROGDI CNV",
    "ROGDI RNA",
    "ROGDI Proteo"
  ],
  "DHX32": [
    "DHX32 CNV",
    "DHX32 RNA",
    "DHX32 Proteo"
  ],
  "RNA5SP238": [
    "RNA5SP238 CNV",
    "RNA5SP238 RNA"
  ],
  "TSG101": [
    "TSG101 CNV",
    "TSG101 RNA",
    "TSG101 Proteo"
  ],
  "MTND2P30": [
    "MTND2P30 CNV",
    "MTND2P30 RNA"
  ],
  "STBD1": [
    "STBD1 CNV",
    "STBD1 RNA",
    "STBD1 Proteo"
  ],
  "CACNB2": [
    "CACNB2 CNV",
    "CACNB2 RNA"
  ],
  "MFAP5": [
    "MFAP5 CNV",
    "MFAP5 RNA",
    "MFAP5 Proteo"
  ],
  "TFAMP1": [
    "TFAMP1 CNV",
    "TFAMP1 RNA"
  ],
  "HNF4A": [
    "HNF4A CNV",
    "HNF4A RNA",
    "HNF4A Proteo"
  ],
  "IFNAR2": [
    "IFNAR2 CNV",
    "IFNAR2 RNA"
  ],
  "CPB2": [
    "CPB2 CNV",
    "CPB2 RNA",
    "CPB2 Proteo"
  ],
  "COX6A1P2": [
    "COX6A1P2 CNV",
    "COX6A1P2 RNA"
  ],
  "LUC7L2": [
    "LUC7L2 CNV",
    "LUC7L2 RNA",
    "LUC7L2 Proteo"
  ],
  "CBFA2T3": [
    "CBFA2T3 CNV",
    "CBFA2T3 RNA"
  ],
  "CFAP107": [
    "CFAP107 CNV",
    "CFAP107 RNA"
  ],
  "SLC25A22": [
    "SLC25A22 CNV",
    "SLC25A22 RNA",
    "SLC25A22 Proteo"
  ],
  "MCM6": [
    "MCM6 CNV",
    "MCM6 RNA",
    "MCM6 Proteo"
  ],
  "RBBP8": [
    "RBBP8 CNV",
    "RBBP8 RNA",
    "RBBP8 Proteo"
  ],
  "ATP5MC2P1": [
    "ATP5MC2P1 CNV",
    "ATP5MC2P1 RNA"
  ],
  "SEPTIN9": [
    "SEPTIN9 CNV",
    "SEPTIN9 RNA",
    "SEPTIN9 Proteo"
  ],
  "COL4A1": [
    "COL4A1 CNV",
    "COL4A1 RNA",
    "COL4A1 Proteo"
  ],
  "RNA5SP49": [
    "RNA5SP49 CNV",
    "RNA5SP49 RNA"
  ],
  "KRTAP2-4": [
    "KRTAP2-4 CNV",
    "KRTAP2-4 RNA"
  ],
  "TIAL1": [
    "TIAL1 CNV",
    "TIAL1 RNA",
    "TIAL1 Proteo"
  ],
  "RPL38P6": [
    "RPL38P6 CNV",
    "RPL38P6 RNA"
  ],
  "BNC2": [
    "BNC2 CNV",
    "BNC2 RNA",
    "BNC2 Proteo"
  ],
  "HSPA8P19": [
    "HSPA8P19 CNV",
    "HSPA8P19 RNA"
  ],
  "RBMY3AP": [
    "RBMY3AP CNV",
    "RBMY3AP RNA"
  ],
  "TCF7L2": [
    "TCF7L2 CNV",
    "TCF7L2 RNA",
    "TCF7L2 Proteo"
  ],
  "JMJD8": [
    "JMJD8 CNV",
    "JMJD8 RNA",
    "JMJD8 Proteo"
  ],
  "AFG1L": [
    "AFG1L CNV",
    "AFG1L RNA",
    "AFG1L Proteo"
  ],
  "PNPT1": [
    "PNPT1 CNV",
    "PNPT1 RNA",
    "PNPT1 Proteo"
  ],
  "FUT7": [
    "FUT7 CNV",
    "FUT7 RNA"
  ],
  "STYXL2": [
    "STYXL2 CNV",
    "STYXL2 RNA",
    "STYXL2 Proteo"
  ],
  "MZT1P2": [
    "MZT1P2 CNV",
    "MZT1P2 RNA"
  ],
  "ZNF430": [
    "ZNF430 CNV",
    "ZNF430 RNA"
  ],
  "AQP7": [
    "AQP7 CNV",
    "AQP7 RNA"
  ],
  "ADNP2": [
    "ADNP2 CNV",
    "ADNP2 RNA",
    "ADNP2 Proteo"
  ],
  "LDLR": [
    "LDLR CNV",
    "LDLR RNA",
    "LDLR Proteo"
  ],
  "SNX18P27": [
    "SNX18P27 CNV",
    "SNX18P27 RNA"
  ],
  "FIGNL2": [
    "FIGNL2 CNV",
    "FIGNL2 RNA"
  ],
  "PHKA1P1": [
    "PHKA1P1 CNV",
    "PHKA1P1 RNA"
  ],
  "DUTP2": [
    "DUTP2 CNV",
    "DUTP2 RNA"
  ],
  "ZNF671": [
    "ZNF671 CNV",
    "ZNF671 RNA"
  ],
  "VAT1": [
    "VAT1 CNV",
    "VAT1 RNA",
    "VAT1 Proteo"
  ],
  "NPM1P26": [
    "NPM1P26 CNV",
    "NPM1P26 RNA"
  ],
  "APOBEC3A": [
    "APOBEC3A CNV",
    "APOBEC3A RNA",
    "APOBEC3A Proteo"
  ],
  "MTCL1": [
    "MTCL1 CNV",
    "MTCL1 RNA",
    "MTCL1 Proteo"
  ],
  "C10orf82": [
    "C10orf82 CNV",
    "C10orf82 RNA"
  ],
  "CA2": [
    "CA2 CNV",
    "CA2 RNA",
    "CA2 Proteo"
  ],
  "IFITM3P8": [
    "IFITM3P8 CNV",
    "IFITM3P8 RNA"
  ],
  "UBE2CP1": [
    "UBE2CP1 CNV",
    "UBE2CP1 RNA"
  ],
  "BDKRB1": [
    "BDKRB1 CNV",
    "BDKRB1 RNA"
  ],
  "GTF3C5": [
    "GTF3C5 CNV",
    "GTF3C5 RNA",
    "GTF3C5 Proteo"
  ],
  "MAML1": [
    "MAML1 CNV",
    "MAML1 RNA",
    "MAML1 Proteo"
  ],
  "SPATA21": [
    "SPATA21 CNV",
    "SPATA21 RNA"
  ],
  "TOMM22P1": [
    "TOMM22P1 CNV",
    "TOMM22P1 RNA"
  ],
  "SNRPEP6": [
    "SNRPEP6 CNV",
    "SNRPEP6 RNA"
  ],
  "KLHDC9": [
    "KLHDC9 CNV",
    "KLHDC9 RNA"
  ],
  "E2F6P2": [
    "E2F6P2 CNV",
    "E2F6P2 RNA"
  ],
  "ATOH8": [
    "ATOH8 CNV",
    "ATOH8 RNA"
  ],
  "AXL": [
    "AXL CNV",
    "AXL RNA",
    "AXL Proteo"
  ],
  "CYP8B1": [
    "CYP8B1 CNV",
    "CYP8B1 RNA"
  ],
  "RNA5SP36": [
    "RNA5SP36 CNV",
    "RNA5SP36 RNA"
  ],
  "SLC4A9": [
    "SLC4A9 CNV",
    "SLC4A9 RNA"
  ],
  "L3MBTL1": [
    "L3MBTL1 CNV",
    "L3MBTL1 RNA"
  ],
  "ANXA10": [
    "ANXA10 CNV",
    "ANXA10 RNA",
    "ANXA10 Proteo"
  ],
  "PCDH18": [
    "PCDH18 CNV",
    "PCDH18 RNA",
    "PCDH18 Proteo"
  ],
  "ZNF321P": [
    "ZNF321P CNV",
    "ZNF321P RNA"
  ],
  "OR52Z1P": [
    "OR52Z1P CNV",
    "OR52Z1P RNA"
  ],
  "SETD7": [
    "SETD7 CNV",
    "SETD7 RNA",
    "SETD7 Proteo"
  ],
  "CPNE3": [
    "CPNE3 CNV",
    "CPNE3 RNA",
    "CPNE3 Proteo"
  ],
  "RCN1": [
    "RCN1 CNV",
    "RCN1 RNA",
    "RCN1 Proteo"
  ],
  "PHKA1": [
    "PHKA1 CNV",
    "PHKA1 RNA",
    "PHKA1 Proteo"
  ],
  "TLE5": [
    "TLE5 CNV",
    "TLE5 RNA",
    "TLE5 Proteo"
  ],
  "SHPRH": [
    "SHPRH CNV",
    "SHPRH RNA",
    "SHPRH Proteo"
  ],
  "MRPL3P1": [
    "MRPL3P1 CNV",
    "MRPL3P1 RNA"
  ],
  "CLDN20": [
    "CLDN20 CNV",
    "CLDN20 RNA"
  ],
  "FEM1B": [
    "FEM1B CNV",
    "FEM1B RNA",
    "FEM1B Proteo"
  ],
  "MRPS33P2": [
    "MRPS33P2 CNV",
    "MRPS33P2 RNA"
  ],
  "HSP90AA6P": [
    "HSP90AA6P CNV",
    "HSP90AA6P RNA"
  ],
  "PSMA5P1": [
    "PSMA5P1 CNV",
    "PSMA5P1 RNA"
  ],
  "BTN1A1": [
    "BTN1A1 CNV",
    "BTN1A1 RNA"
  ],
  "SLC22A18": [
    "SLC22A18 CNV",
    "SLC22A18 RNA",
    "SLC22A18 Proteo"
  ],
  "SEMA6D": [
    "SEMA6D CNV",
    "SEMA6D RNA"
  ],
  "SYT7": [
    "SYT7 CNV",
    "SYT7 RNA",
    "SYT7 Proteo"
  ],
  "FLRT1": [
    "FLRT1 CNV",
    "FLRT1 RNA",
    "FLRT1 Proteo"
  ],
  "IGHVIII-25-1": [
    "IGHVIII-25-1 CNV",
    "IGHVIII-25-1 RNA"
  ],
  "SIGLEC17P": [
    "SIGLEC17P CNV",
    "SIGLEC17P RNA"
  ],
  "FAM169B": [
    "FAM169B CNV",
    "FAM169B RNA"
  ],
  "ZNF226": [
    "ZNF226 CNV",
    "ZNF226 RNA"
  ],
  "MAS1LP1": [
    "MAS1LP1 CNV",
    "MAS1LP1 RNA"
  ],
  "NACAP2": [
    "NACAP2 CNV",
    "NACAP2 RNA"
  ],
  "PGAP6": [
    "PGAP6 CNV",
    "PGAP6 RNA",
    "PGAP6 Proteo"
  ],
  "MAPK12": [
    "MAPK12 CNV",
    "MAPK12 RNA",
    "MAPK12 Proteo"
  ],
  "NAALADL1": [
    "NAALADL1 CNV",
    "NAALADL1 RNA"
  ],
  "EEF1A1P40": [
    "EEF1A1P40 CNV",
    "EEF1A1P40 RNA"
  ],
  "NTM": [
    "NTM CNV",
    "NTM RNA",
    "NTM Proteo"
  ],
  "TRIM60P16": [
    "TRIM60P16 CNV",
    "TRIM60P16 RNA"
  ],
  "RNA5SP440": [
    "RNA5SP440 CNV",
    "RNA5SP440 RNA"
  ],
  "ASLP1": [
    "ASLP1 CNV",
    "ASLP1 RNA"
  ],
  "SOCS7": [
    "SOCS7 CNV",
    "SOCS7 RNA"
  ],
  "ZNRF2": [
    "ZNRF2 CNV",
    "ZNRF2 RNA",
    "ZNRF2 Proteo"
  ],
  "CMBL": [
    "CMBL CNV",
    "CMBL RNA",
    "CMBL Proteo"
  ],
  "ATAD2B": [
    "ATAD2B CNV",
    "ATAD2B RNA",
    "ATAD2B Proteo"
  ],
  "GSTM2": [
    "GSTM2 CNV",
    "GSTM2 RNA",
    "GSTM2 Proteo"
  ],
  "KRT18P2": [
    "KRT18P2 CNV",
    "KRT18P2 RNA"
  ],
  "FAM50A": [
    "FAM50A CNV",
    "FAM50A RNA",
    "FAM50A Proteo"
  ],
  "NAP1L2": [
    "NAP1L2 CNV",
    "NAP1L2 RNA"
  ],
  "CAPN5": [
    "CAPN5 CNV",
    "CAPN5 RNA",
    "CAPN5 Proteo"
  ],
  "RSBN1L": [
    "RSBN1L CNV",
    "RSBN1L RNA",
    "RSBN1L Proteo"
  ],
  "DEFB130B": [
    "DEFB130B CNV",
    "DEFB130B RNA"
  ],
  "CNTNAP4": [
    "CNTNAP4 CNV",
    "CNTNAP4 RNA",
    "CNTNAP4 Proteo"
  ],
  "AKAP4": [
    "AKAP4 CNV",
    "AKAP4 RNA",
    "AKAP4 Proteo"
  ],
  "KRT12": [
    "KRT12 CNV",
    "KRT12 RNA",
    "KRT12 Proteo"
  ],
  "EXTL1": [
    "EXTL1 CNV",
    "EXTL1 RNA",
    "EXTL1 Proteo"
  ],
  "RPL21P120": [
    "RPL21P120 CNV",
    "RPL21P120 RNA"
  ],
  "RUNDC3A": [
    "RUNDC3A CNV",
    "RUNDC3A RNA"
  ],
  "CDKN2D": [
    "CDKN2D CNV",
    "CDKN2D RNA"
  ],
  "NKX1-2": [
    "NKX1-2 CNV",
    "NKX1-2 RNA"
  ],
  "OR6N2": [
    "OR6N2 CNV",
    "OR6N2 RNA"
  ],
  "RPL23AP2": [
    "RPL23AP2 CNV",
    "RPL23AP2 RNA"
  ],
  "ZNF507": [
    "ZNF507 CNV",
    "ZNF507 RNA",
    "ZNF507 Proteo"
  ],
  "SNX27": [
    "SNX27 CNV",
    "SNX27 RNA",
    "SNX27 Proteo"
  ],
  "IFNGR1": [
    "IFNGR1 CNV",
    "IFNGR1 RNA",
    "IFNGR1 Proteo"
  ],
  "MTATP6P20": [
    "MTATP6P20 CNV",
    "MTATP6P20 RNA"
  ],
  "RHOT1P3": [
    "RHOT1P3 CNV",
    "RHOT1P3 RNA"
  ],
  "NPIPB8": [
    "NPIPB8 CNV",
    "NPIPB8 RNA"
  ],
  "TRAM2": [
    "TRAM2 CNV",
    "TRAM2 RNA",
    "TRAM2 Proteo"
  ],
  "WNT3A": [
    "WNT3A CNV",
    "WNT3A RNA"
  ],
  "RRAS2P2": [
    "RRAS2P2 CNV",
    "RRAS2P2 RNA"
  ],
  "RNF6": [
    "RNF6 CNV",
    "RNF6 RNA",
    "RNF6 Proteo"
  ],
  "LIN7C": [
    "LIN7C CNV",
    "LIN7C RNA",
    "LIN7C Proteo"
  ],
  "ENPP7P11": [
    "ENPP7P11 CNV",
    "ENPP7P11 RNA"
  ],
  "ATP5POP1": [
    "ATP5POP1 CNV",
    "ATP5POP1 RNA"
  ],
  "RPL7AP30": [
    "RPL7AP30 CNV",
    "RPL7AP30 RNA"
  ],
  "RPS3AP2": [
    "RPS3AP2 CNV",
    "RPS3AP2 RNA"
  ],
  "FAM53C": [
    "FAM53C CNV",
    "FAM53C RNA",
    "FAM53C Proteo"
  ],
  "OR7E159P": [
    "OR7E159P CNV",
    "OR7E159P RNA"
  ],
  "CDH12P4": [
    "CDH12P4 CNV",
    "CDH12P4 RNA"
  ],
  "UBE2E1": [
    "UBE2E1 CNV",
    "UBE2E1 RNA",
    "UBE2E1 Proteo"
  ],
  "CUL4B": [
    "CUL4B CNV",
    "CUL4B RNA",
    "CUL4B Proteo"
  ],
  "POLD2": [
    "POLD2 CNV",
    "POLD2 RNA",
    "POLD2 Proteo"
  ],
  "CYCSP19": [
    "CYCSP19 CNV",
    "CYCSP19 RNA"
  ],
  "USP22": [
    "USP22 CNV",
    "USP22 RNA",
    "USP22 Proteo"
  ],
  "OR5A1": [
    "OR5A1 CNV",
    "OR5A1 RNA"
  ],
  "RNA5SP336": [
    "RNA5SP336 CNV",
    "RNA5SP336 RNA"
  ],
  "C1DP4": [
    "C1DP4 CNV",
    "C1DP4 RNA"
  ],
  "SRR": [
    "SRR CNV",
    "SRR RNA",
    "SRR Proteo"
  ],
  "OR5B21": [
    "OR5B21 CNV",
    "OR5B21 RNA"
  ],
  "NECAP1P2": [
    "NECAP1P2 CNV",
    "NECAP1P2 RNA"
  ],
  "PSAT1P4": [
    "PSAT1P4 CNV",
    "PSAT1P4 RNA"
  ],
  "NPIPB9": [
    "NPIPB9 CNV",
    "NPIPB9 RNA"
  ],
  "RIPOR3": [
    "RIPOR3 CNV",
    "RIPOR3 RNA"
  ],
  "DNAJB6": [
    "DNAJB6 CNV",
    "DNAJB6 RNA",
    "DNAJB6 Proteo"
  ],
  "KRT76": [
    "KRT76 CNV",
    "KRT76 RNA"
  ],
  "TMEM86A": [
    "TMEM86A CNV",
    "TMEM86A RNA",
    "TMEM86A Proteo"
  ],
  "NBPF17P": [
    "NBPF17P CNV",
    "NBPF17P RNA"
  ],
  "KRTAP10-12": [
    "KRTAP10-12 CNV",
    "KRTAP10-12 RNA"
  ],
  "ANKRD24": [
    "ANKRD24 CNV",
    "ANKRD24 RNA"
  ],
  "CD44": [
    "CD44 CNV",
    "CD44 RNA",
    "CD44 Proteo"
  ],
  "ABL2": [
    "ABL2 CNV",
    "ABL2 RNA",
    "ABL2 Proteo"
  ],
  "PRAMENP": [
    "PRAMENP CNV",
    "PRAMENP RNA"
  ],
  "LILRA1": [
    "LILRA1 CNV",
    "LILRA1 RNA"
  ],
  "SDR42E1P5": [
    "SDR42E1P5 CNV",
    "SDR42E1P5 RNA"
  ],
  "RASGEF1C": [
    "RASGEF1C CNV",
    "RASGEF1C RNA"
  ],
  "PSMA1": [
    "PSMA1 CNV",
    "PSMA1 RNA",
    "PSMA1 Proteo"
  ],
  "KRTAP1-1": [
    "KRTAP1-1 CNV",
    "KRTAP1-1 RNA"
  ],
  "PMS2P6": [
    "PMS2P6 CNV",
    "PMS2P6 RNA"
  ],
  "HHEX": [
    "HHEX CNV",
    "HHEX RNA"
  ],
  "RWDD4": [
    "RWDD4 CNV",
    "RWDD4 RNA",
    "RWDD4 Proteo"
  ],
  "KRT8P25": [
    "KRT8P25 CNV",
    "KRT8P25 RNA"
  ],
  "PTRH2": [
    "PTRH2 CNV",
    "PTRH2 RNA",
    "PTRH2 Proteo"
  ],
  "FABP5P4": [
    "FABP5P4 CNV",
    "FABP5P4 RNA"
  ],
  "CCDC85C": [
    "CCDC85C CNV",
    "CCDC85C RNA",
    "CCDC85C Proteo"
  ],
  "LLPHP1": [
    "LLPHP1 CNV",
    "LLPHP1 RNA"
  ],
  "CCDC6": [
    "CCDC6 CNV",
    "CCDC6 RNA",
    "CCDC6 Proteo"
  ],
  "HERPUD2": [
    "HERPUD2 CNV",
    "HERPUD2 RNA",
    "HERPUD2 Proteo"
  ],
  "CATSPERG": [
    "CATSPERG CNV",
    "CATSPERG RNA"
  ],
  "ARHGEF1": [
    "ARHGEF1 CNV",
    "ARHGEF1 RNA",
    "ARHGEF1 Proteo"
  ],
  "ADH5": [
    "ADH5 CNV",
    "ADH5 RNA",
    "ADH5 Proteo"
  ],
  "TMEM59L": [
    "TMEM59L CNV",
    "TMEM59L RNA"
  ],
  "H2BK1": [
    "H2BK1 CNV",
    "H2BK1 RNA"
  ],
  "NBPF25P": [
    "NBPF25P CNV",
    "NBPF25P RNA"
  ],
  "WDR4P1": [
    "WDR4P1 CNV",
    "WDR4P1 RNA"
  ],
  "DUXAP10": [
    "DUXAP10 CNV",
    "DUXAP10 RNA"
  ],
  "LBH": [
    "LBH CNV",
    "LBH RNA",
    "LBH Proteo"
  ],
  "BRF1": [
    "BRF1 CNV",
    "BRF1 RNA",
    "BRF1 Proteo"
  ],
  "OR4A44P": [
    "OR4A44P CNV",
    "OR4A44P RNA"
  ],
  "XAB2": [
    "XAB2 CNV",
    "XAB2 RNA",
    "XAB2 Proteo"
  ],
  "NIT1": [
    "NIT1 CNV",
    "NIT1 RNA",
    "NIT1 Proteo"
  ],
  "ESRRB": [
    "ESRRB CNV",
    "ESRRB RNA"
  ],
  "TSPY20P": [
    "TSPY20P CNV",
    "TSPY20P RNA"
  ],
  "IMPA2": [
    "IMPA2 CNV",
    "IMPA2 RNA",
    "IMPA2 Proteo"
  ],
  "CDNF": [
    "CDNF CNV",
    "CDNF RNA",
    "CDNF Proteo"
  ],
  "FRG2MP": [
    "FRG2MP CNV",
    "FRG2MP RNA"
  ],
  "NTNG2": [
    "NTNG2 CNV",
    "NTNG2 RNA"
  ],
  "TRMT112P6": [
    "TRMT112P6 CNV",
    "TRMT112P6 RNA"
  ],
  "CERS6": [
    "CERS6 CNV",
    "CERS6 RNA",
    "CERS6 Proteo"
  ],
  "LEXM": [
    "LEXM CNV",
    "LEXM RNA"
  ],
  "DRG2": [
    "DRG2 CNV",
    "DRG2 RNA",
    "DRG2 Proteo"
  ],
  "HTR3B": [
    "HTR3B CNV",
    "HTR3B RNA"
  ],
  "ARL14EPP1": [
    "ARL14EPP1 CNV",
    "ARL14EPP1 RNA"
  ],
  "PCDHB2": [
    "PCDHB2 CNV",
    "PCDHB2 RNA"
  ],
  "STOML1": [
    "STOML1 CNV",
    "STOML1 RNA",
    "STOML1 Proteo"
  ],
  "RPS10": [
    "RPS10 CNV",
    "RPS10 RNA",
    "RPS10 Proteo"
  ],
  "ADRB2": [
    "ADRB2 CNV",
    "ADRB2 RNA"
  ],
  "JOSD2": [
    "JOSD2 CNV",
    "JOSD2 RNA",
    "JOSD2 Proteo"
  ],
  "PHB1P15": [
    "PHB1P15 CNV",
    "PHB1P15 RNA"
  ],
  "AKAIN1": [
    "AKAIN1 CNV",
    "AKAIN1 RNA"
  ],
  "RBMX": [
    "RBMX CNV",
    "RBMX RNA",
    "RBMX Proteo"
  ],
  "CORO1C": [
    "CORO1C CNV",
    "CORO1C RNA",
    "CORO1C Proteo"
  ],
  "OR7E5P": [
    "OR7E5P CNV",
    "OR7E5P RNA"
  ],
  "MTATP6P25": [
    "MTATP6P25 CNV",
    "MTATP6P25 RNA"
  ],
  "RPL19": [
    "RPL19 CNV",
    "RPL19 RNA",
    "RPL19 Proteo"
  ],
  "CLCN3": [
    "CLCN3 CNV",
    "CLCN3 RNA",
    "CLCN3 Proteo"
  ],
  "MED20": [
    "MED20 CNV",
    "MED20 RNA",
    "MED20 Proteo"
  ],
  "BMT2": [
    "BMT2 CNV",
    "BMT2 RNA",
    "BMT2 Proteo"
  ],
  "APBB1IP": [
    "APBB1IP CNV",
    "APBB1IP RNA",
    "APBB1IP Proteo"
  ],
  "RPIA": [
    "RPIA CNV",
    "RPIA RNA",
    "RPIA Proteo"
  ],
  "MTND1P35": [
    "MTND1P35 CNV",
    "MTND1P35 RNA"
  ],
  "NAA80": [
    "NAA80 CNV",
    "NAA80 RNA",
    "NAA80 Proteo"
  ],
  "GNA13": [
    "GNA13 CNV",
    "GNA13 RNA",
    "GNA13 Proteo"
  ],
  "SULT1E1": [
    "SULT1E1 CNV",
    "SULT1E1 RNA"
  ],
  "PPIAP24": [
    "PPIAP24 CNV",
    "PPIAP24 RNA"
  ],
  "TRMT11": [
    "TRMT11 CNV",
    "TRMT11 RNA",
    "TRMT11 Proteo"
  ],
  "NOA1": [
    "NOA1 CNV",
    "NOA1 RNA",
    "NOA1 Proteo"
  ],
  "B3GALNT2P1": [
    "B3GALNT2P1 CNV",
    "B3GALNT2P1 RNA"
  ],
  "MTND6P2": [
    "MTND6P2 CNV",
    "MTND6P2 RNA"
  ],
  "IGHVII-78-1": [
    "IGHVII-78-1 CNV",
    "IGHVII-78-1 RNA"
  ],
  "SERINC4": [
    "SERINC4 CNV",
    "SERINC4 RNA"
  ],
  "CDX1": [
    "CDX1 CNV",
    "CDX1 RNA"
  ],
  "SEPHS2P1": [
    "SEPHS2P1 CNV",
    "SEPHS2P1 RNA"
  ],
  "SPRYD7P1": [
    "SPRYD7P1 CNV",
    "SPRYD7P1 RNA"
  ],
  "CCL4L2": [
    "CCL4L2 CNV",
    "CCL4L2 RNA"
  ],
  "LARP7P1": [
    "LARP7P1 CNV",
    "LARP7P1 RNA"
  ],
  "SEC22B": [
    "SEC22B CNV",
    "SEC22B RNA",
    "SEC22B Proteo"
  ],
  "CYP26C1": [
    "CYP26C1 CNV",
    "CYP26C1 RNA"
  ],
  "CHRNE": [
    "CHRNE CNV",
    "CHRNE RNA"
  ],
  "TMEM184CP1": [
    "TMEM184CP1 CNV",
    "TMEM184CP1 RNA"
  ],
  "TBL1Y": [
    "TBL1Y CNV",
    "TBL1Y RNA"
  ],
  "AATK": [
    "AATK CNV",
    "AATK RNA"
  ],
  "RALBP1P1": [
    "RALBP1P1 CNV",
    "RALBP1P1 RNA"
  ],
  "CYSLTR1": [
    "CYSLTR1 CNV",
    "CYSLTR1 RNA"
  ],
  "FAM238C": [
    "FAM238C CNV",
    "FAM238C RNA"
  ],
  "C10orf99": [
    "C10orf99 CNV",
    "C10orf99 RNA"
  ],
  "OBSL1": [
    "OBSL1 CNV",
    "OBSL1 RNA",
    "OBSL1 Proteo"
  ],
  "RNF180": [
    "RNF180 CNV",
    "RNF180 RNA"
  ],
  "DRAP1": [
    "DRAP1 CNV",
    "DRAP1 RNA",
    "DRAP1 Proteo"
  ],
  "SLC25A10": [
    "SLC25A10 CNV",
    "SLC25A10 RNA",
    "SLC25A10 Proteo"
  ],
  "EDF1": [
    "EDF1 CNV",
    "EDF1 RNA",
    "EDF1 Proteo"
  ],
  "FES": [
    "FES CNV",
    "FES RNA",
    "FES Proteo"
  ],
  "TEX43": [
    "TEX43 CNV",
    "TEX43 RNA"
  ],
  "RAB11FIP4": [
    "RAB11FIP4 CNV",
    "RAB11FIP4 RNA",
    "RAB11FIP4 Proteo"
  ],
  "PPIAP36": [
    "PPIAP36 CNV",
    "PPIAP36 RNA"
  ],
  "LTB4R2": [
    "LTB4R2 CNV",
    "LTB4R2 RNA"
  ],
  "IGSF23": [
    "IGSF23 CNV",
    "IGSF23 RNA"
  ],
  "MEIOSIN": [
    "MEIOSIN CNV",
    "MEIOSIN RNA"
  ],
  "FCMR": [
    "FCMR CNV",
    "FCMR RNA",
    "FCMR Proteo"
  ],
  "PPM1AP1": [
    "PPM1AP1 CNV",
    "PPM1AP1 RNA"
  ],
  "CCND2": [
    "CCND2 CNV",
    "CCND2 RNA",
    "CCND2 Proteo"
  ],
  "PNPT1P2": [
    "PNPT1P2 CNV",
    "PNPT1P2 RNA"
  ],
  "TNFSF11": [
    "TNFSF11 CNV",
    "TNFSF11 RNA"
  ],
  "CFH": [
    "CFH CNV",
    "CFH RNA",
    "CFH Proteo"
  ],
  "SEC23IP": [
    "SEC23IP CNV",
    "SEC23IP RNA",
    "SEC23IP Proteo"
  ],
  "PDP2": [
    "PDP2 CNV",
    "PDP2 RNA",
    "PDP2 Proteo"
  ],
  "ANKRD66": [
    "ANKRD66 CNV",
    "ANKRD66 RNA"
  ],
  "VASH1": [
    "VASH1 CNV",
    "VASH1 RNA",
    "VASH1 Proteo"
  ],
  "ZNF641": [
    "ZNF641 CNV",
    "ZNF641 RNA"
  ],
  "HSPD1P6": [
    "HSPD1P6 CNV",
    "HSPD1P6 RNA"
  ],
  "ZNF675": [
    "ZNF675 CNV",
    "ZNF675 RNA"
  ],
  "KRTAP5-4": [
    "KRTAP5-4 CNV",
    "KRTAP5-4 RNA"
  ],
  "RPS20P4": [
    "RPS20P4 CNV",
    "RPS20P4 RNA"
  ],
  "PLEKHA1": [
    "PLEKHA1 CNV",
    "PLEKHA1 RNA",
    "PLEKHA1 Proteo"
  ],
  "ZNF385A": [
    "ZNF385A CNV",
    "ZNF385A RNA",
    "ZNF385A Proteo"
  ],
  "PIP5K1C": [
    "PIP5K1C CNV",
    "PIP5K1C RNA",
    "PIP5K1C Proteo"
  ],
  "SPIN3": [
    "SPIN3 CNV",
    "SPIN3 RNA",
    "SPIN3 Proteo"
  ],
  "IGLV4-60": [
    "IGLV4-60 Proteo"
  ],
  "VN1R8P": [
    "VN1R8P CNV",
    "VN1R8P RNA"
  ],
  "SCN1A": [
    "SCN1A CNV",
    "SCN1A RNA"
  ],
  "AQP7P4": [
    "AQP7P4 CNV",
    "AQP7P4 RNA"
  ],
  "TMSB15B": [
    "TMSB15B CNV",
    "TMSB15B RNA"
  ],
  "MEGF6": [
    "MEGF6 CNV",
    "MEGF6 RNA",
    "MEGF6 Proteo"
  ],
  "RDXP2": [
    "RDXP2 CNV",
    "RDXP2 RNA"
  ],
  "LEPROTL1": [
    "LEPROTL1 CNV",
    "LEPROTL1 RNA",
    "LEPROTL1 Proteo"
  ],
  "ZEB2": [
    "ZEB2 CNV",
    "ZEB2 RNA",
    "ZEB2 Proteo"
  ],
  "RPL38P3": [
    "RPL38P3 CNV",
    "RPL38P3 RNA"
  ],
  "AGPAT1": [
    "AGPAT1 CNV",
    "AGPAT1 RNA",
    "AGPAT1 Proteo"
  ],
  "SUSD2": [
    "SUSD2 CNV",
    "SUSD2 RNA",
    "SUSD2 Proteo"
  ],
  "BAGE2": [
    "BAGE2 CNV",
    "BAGE2 RNA"
  ],
  "USP31": [
    "USP31 CNV",
    "USP31 RNA",
    "USP31 Proteo"
  ],
  "PIR": [
    "PIR CNV",
    "PIR RNA",
    "PIR Proteo"
  ],
  "P2RY1": [
    "P2RY1 CNV",
    "P2RY1 RNA"
  ],
  "EPHX2": [
    "EPHX2 CNV",
    "EPHX2 RNA",
    "EPHX2 Proteo"
  ],
  "UBE2M": [
    "UBE2M CNV",
    "UBE2M RNA",
    "UBE2M Proteo"
  ],
  "SCGB2A2": [
    "SCGB2A2 CNV",
    "SCGB2A2 RNA",
    "SCGB2A2 Proteo"
  ],
  "MRPS23": [
    "MRPS23 CNV",
    "MRPS23 RNA",
    "MRPS23 Proteo"
  ],
  "AK2": [
    "AK2 CNV",
    "AK2 RNA",
    "AK2 Proteo"
  ],
  "SYCP1": [
    "SYCP1 CNV",
    "SYCP1 RNA"
  ],
  "ROR1": [
    "ROR1 CNV",
    "ROR1 RNA",
    "ROR1 Proteo"
  ],
  "APLNR": [
    "APLNR CNV",
    "APLNR RNA"
  ],
  "SNRNP25": [
    "SNRNP25 CNV",
    "SNRNP25 RNA",
    "SNRNP25 Proteo"
  ],
  "TRIM7": [
    "TRIM7 CNV",
    "TRIM7 RNA",
    "TRIM7 Proteo"
  ],
  "BAIAP2L1": [
    "BAIAP2L1 CNV",
    "BAIAP2L1 RNA",
    "BAIAP2L1 Proteo"
  ],
  "IGKV2OR22-3": [
    "IGKV2OR22-3 CNV",
    "IGKV2OR22-3 RNA"
  ],
  "TCEAL3": [
    "TCEAL3 CNV",
    "TCEAL3 RNA",
    "TCEAL3 Proteo"
  ],
  "TTC39C": [
    "TTC39C CNV",
    "TTC39C RNA",
    "TTC39C Proteo"
  ],
  "VBP1": [
    "VBP1 CNV",
    "VBP1 RNA",
    "VBP1 Proteo"
  ],
  "GPER1": [
    "GPER1 CNV",
    "GPER1 RNA"
  ],
  "NDUFA12P1": [
    "NDUFA12P1 CNV",
    "NDUFA12P1 RNA"
  ],
  "EGR3": [
    "EGR3 CNV",
    "EGR3 RNA"
  ],
  "RRBP1P1": [
    "RRBP1P1 CNV",
    "RRBP1P1 RNA"
  ],
  "SCARB1": [
    "SCARB1 CNV",
    "SCARB1 RNA",
    "SCARB1 Proteo"
  ],
  "FRY": [
    "FRY CNV",
    "FRY RNA",
    "FRY Proteo"
  ],
  "TMEM176A": [
    "TMEM176A CNV",
    "TMEM176A RNA"
  ],
  "SNRPGP7": [
    "SNRPGP7 CNV",
    "SNRPGP7 RNA"
  ],
  "NUP210P3": [
    "NUP210P3 CNV",
    "NUP210P3 RNA"
  ],
  "DDX3P2": [
    "DDX3P2 CNV",
    "DDX3P2 RNA"
  ],
  "TRIM21": [
    "TRIM21 CNV",
    "TRIM21 RNA",
    "TRIM21 Proteo"
  ],
  "IL13": [
    "IL13 CNV",
    "IL13 RNA"
  ],
  "DHX30": [
    "DHX30 CNV",
    "DHX30 RNA",
    "DHX30 Proteo"
  ],
  "BRD7P2": [
    "BRD7P2 CNV",
    "BRD7P2 RNA"
  ],
  "OR14J1": [
    "OR14J1 CNV",
    "OR14J1 RNA"
  ],
  "ACTR3BP6": [
    "ACTR3BP6 CNV",
    "ACTR3BP6 RNA"
  ],
  "RPL7AP25": [
    "RPL7AP25 CNV",
    "RPL7AP25 RNA"
  ],
  "SPZ1": [
    "SPZ1 CNV",
    "SPZ1 RNA"
  ],
  "DUX4L15": [
    "DUX4L15 CNV",
    "DUX4L15 RNA"
  ],
  "TAS2R20": [
    "TAS2R20 CNV",
    "TAS2R20 RNA"
  ],
  "INSYN2A": [
    "INSYN2A CNV",
    "INSYN2A RNA"
  ],
  "OR51S1": [
    "OR51S1 CNV",
    "OR51S1 RNA"
  ],
  "XK": [
    "XK CNV",
    "XK RNA"
  ],
  "ANKRD22": [
    "ANKRD22 CNV",
    "ANKRD22 RNA",
    "ANKRD22 Proteo"
  ],
  "CICP9": [
    "CICP9 CNV",
    "CICP9 RNA"
  ],
  "NPBWR2": [
    "NPBWR2 CNV",
    "NPBWR2 RNA"
  ],
  "RPTOR": [
    "RPTOR CNV",
    "RPTOR RNA",
    "RPTOR Proteo"
  ],
  "SLC22A12": [
    "SLC22A12 CNV",
    "SLC22A12 RNA"
  ],
  "PHB1P11": [
    "PHB1P11 CNV",
    "PHB1P11 RNA"
  ],
  "SLC10A1": [
    "SLC10A1 CNV",
    "SLC10A1 RNA"
  ],
  "GRAP2": [
    "GRAP2 CNV",
    "GRAP2 RNA",
    "GRAP2 Proteo"
  ],
  "SLITRK2": [
    "SLITRK2 CNV",
    "SLITRK2 RNA"
  ],
  "CFHR4": [
    "CFHR4 CNV",
    "CFHR4 RNA"
  ],
  "DYNC1I2P1": [
    "DYNC1I2P1 CNV",
    "DYNC1I2P1 RNA"
  ],
  "RPL22P24": [
    "RPL22P24 CNV",
    "RPL22P24 RNA"
  ],
  "DUXAP7": [
    "DUXAP7 CNV",
    "DUXAP7 RNA"
  ],
  "LINC02203": [
    "LINC02203 CNV",
    "LINC02203 RNA"
  ],
  "PRPS1L1": [
    "PRPS1L1 CNV",
    "PRPS1L1 RNA",
    "PRPS1L1 Proteo"
  ],
  "AKR7A2P1": [
    "AKR7A2P1 CNV",
    "AKR7A2P1 RNA"
  ],
  "SOX1": [
    "SOX1 CNV",
    "SOX1 RNA"
  ],
  "TERF2": [
    "TERF2 CNV",
    "TERF2 RNA",
    "TERF2 Proteo"
  ],
  "ZNF761": [
    "ZNF761 CNV",
    "ZNF761 RNA",
    "ZNF761 Proteo"
  ],
  "STAG3L4": [
    "STAG3L4 CNV",
    "STAG3L4 RNA"
  ],
  "ELOCP7": [
    "ELOCP7 CNV",
    "ELOCP7 RNA"
  ],
  "RPS18": [
    "RPS18 CNV",
    "RPS18 RNA",
    "RPS18 Proteo"
  ],
  "TGIF2": [
    "TGIF2 CNV",
    "TGIF2 RNA",
    "TGIF2 Proteo"
  ],
  "FGF20": [
    "FGF20 CNV",
    "FGF20 RNA"
  ],
  "MTCH1P2": [
    "MTCH1P2 CNV",
    "MTCH1P2 RNA"
  ],
  "PRTN3": [
    "PRTN3 CNV",
    "PRTN3 RNA",
    "PRTN3 Proteo"
  ],
  "COL4A5": [
    "COL4A5 CNV",
    "COL4A5 RNA"
  ],
  "PRRT2": [
    "PRRT2 CNV",
    "PRRT2 RNA"
  ],
  "MINDY4": [
    "MINDY4 CNV",
    "MINDY4 RNA",
    "MINDY4 Proteo"
  ],
  "ST3GAL5": [
    "ST3GAL5 CNV",
    "ST3GAL5 RNA",
    "ST3GAL5 Proteo"
  ],
  "PAPOLG": [
    "PAPOLG CNV",
    "PAPOLG RNA",
    "PAPOLG Proteo"
  ],
  "BIN2P2": [
    "BIN2P2 CNV",
    "BIN2P2 RNA"
  ],
  "R3HDM2": [
    "R3HDM2 CNV",
    "R3HDM2 RNA",
    "R3HDM2 Proteo"
  ],
  "OR4C2P": [
    "OR4C2P CNV",
    "OR4C2P RNA"
  ],
  "MRGPRF": [
    "MRGPRF CNV",
    "MRGPRF RNA"
  ],
  "TUBA4A": [
    "TUBA4A CNV",
    "TUBA4A RNA",
    "TUBA4A Proteo"
  ],
  "ITGB2": [
    "ITGB2 CNV",
    "ITGB2 RNA",
    "ITGB2 Proteo"
  ],
  "CLC": [
    "CLC CNV",
    "CLC RNA",
    "CLC Proteo"
  ],
  "P4HA2": [
    "P4HA2 CNV",
    "P4HA2 RNA",
    "P4HA2 Proteo"
  ],
  "SRGAP2": [
    "SRGAP2 CNV",
    "SRGAP2 RNA",
    "SRGAP2 Proteo"
  ],
  "NAA10": [
    "NAA10 CNV",
    "NAA10 RNA",
    "NAA10 Proteo"
  ],
  "TAF6L": [
    "TAF6L CNV",
    "TAF6L RNA",
    "TAF6L Proteo"
  ],
  "INTS4P2": [
    "INTS4P2 CNV",
    "INTS4P2 RNA"
  ],
  "FUT11": [
    "FUT11 CNV",
    "FUT11 RNA",
    "FUT11 Proteo"
  ],
  "COX4I1": [
    "COX4I1 CNV",
    "COX4I1 RNA",
    "COX4I1 Proteo"
  ],
  "BTF3P11": [
    "BTF3P11 CNV",
    "BTF3P11 RNA"
  ],
  "NANOGP3": [
    "NANOGP3 CNV",
    "NANOGP3 RNA"
  ],
  "ACKR2": [
    "ACKR2 CNV",
    "ACKR2 RNA"
  ],
  "CAPN7": [
    "CAPN7 CNV",
    "CAPN7 RNA",
    "CAPN7 Proteo"
  ],
  "RNA5SP319": [
    "RNA5SP319 CNV",
    "RNA5SP319 RNA"
  ],
  "HMGN2P11": [
    "HMGN2P11 CNV",
    "HMGN2P11 RNA"
  ],
  "H2AZP6": [
    "H2AZP6 CNV",
    "H2AZP6 RNA"
  ],
  "UTP20": [
    "UTP20 CNV",
    "UTP20 RNA",
    "UTP20 Proteo"
  ],
  "RPL23AP71": [
    "RPL23AP71 CNV",
    "RPL23AP71 RNA"
  ],
  "DENND6A": [
    "DENND6A CNV",
    "DENND6A RNA",
    "DENND6A Proteo"
  ],
  "PMS2P3": [
    "PMS2P3 CNV",
    "PMS2P3 RNA"
  ],
  "POU1F1": [
    "POU1F1 CNV",
    "POU1F1 RNA"
  ],
  "HLX": [
    "HLX CNV",
    "HLX RNA",
    "HLX Proteo"
  ],
  "CCT7": [
    "CCT7 CNV",
    "CCT7 RNA",
    "CCT7 Proteo"
  ],
  "FER1L4": [
    "FER1L4 CNV",
    "FER1L4 RNA"
  ],
  "ABCD2": [
    "ABCD2 CNV",
    "ABCD2 RNA"
  ],
  "FUT3": [
    "FUT3 CNV",
    "FUT3 RNA",
    "FUT3 Proteo"
  ],
  "OR2AH1P": [
    "OR2AH1P CNV",
    "OR2AH1P RNA"
  ],
  "CDC42BPG": [
    "CDC42BPG CNV",
    "CDC42BPG RNA",
    "CDC42BPG Proteo"
  ],
  "ENPP7P4": [
    "ENPP7P4 CNV",
    "ENPP7P4 RNA"
  ],
  "OPA1": [
    "OPA1 CNV",
    "OPA1 RNA",
    "OPA1 Proteo"
  ],
  "COX6CP10": [
    "COX6CP10 CNV",
    "COX6CP10 RNA"
  ],
  "RPL13AP6": [
    "RPL13AP6 CNV",
    "RPL13AP6 RNA"
  ],
  "TUBGCP3": [
    "TUBGCP3 CNV",
    "TUBGCP3 RNA",
    "TUBGCP3 Proteo"
  ],
  "CYCSP52": [
    "CYCSP52 CNV",
    "CYCSP52 RNA"
  ],
  "CDCA8": [
    "CDCA8 CNV",
    "CDCA8 RNA",
    "CDCA8 Proteo"
  ],
  "BTF3L4": [
    "BTF3L4 CNV",
    "BTF3L4 RNA",
    "BTF3L4 Proteo"
  ],
  "PTTG4P": [
    "PTTG4P CNV",
    "PTTG4P RNA"
  ],
  "SLC25A5P8": [
    "SLC25A5P8 CNV",
    "SLC25A5P8 RNA"
  ],
  "TMEM108": [
    "TMEM108 CNV",
    "TMEM108 RNA"
  ],
  "EIF4EP5": [
    "EIF4EP5 CNV",
    "EIF4EP5 RNA"
  ],
  "COX6CP6": [
    "COX6CP6 CNV",
    "COX6CP6 RNA"
  ],
  "TEX28P3": [
    "TEX28P3 CNV",
    "TEX28P3 RNA"
  ],
  "RNASE12": [
    "RNASE12 CNV",
    "RNASE12 RNA"
  ],
  "MPDZ": [
    "MPDZ CNV",
    "MPDZ RNA",
    "MPDZ Proteo"
  ],
  "GJB7": [
    "GJB7 CNV",
    "GJB7 RNA"
  ],
  "MTND2P26": [
    "MTND2P26 CNV",
    "MTND2P26 RNA"
  ],
  "RYR2": [
    "RYR2 CNV",
    "RYR2 RNA",
    "RYR2 Proteo"
  ],
  "SCLT1": [
    "SCLT1 CNV",
    "SCLT1 RNA",
    "SCLT1 Proteo"
  ],
  "TRIM26BP": [
    "TRIM26BP CNV",
    "TRIM26BP RNA"
  ],
  "CERT1": [
    "CERT1 CNV",
    "CERT1 RNA",
    "CERT1 Proteo"
  ],
  "ADH6": [
    "ADH6 CNV",
    "ADH6 RNA"
  ],
  "PAPPA2": [
    "PAPPA2 CNV",
    "PAPPA2 RNA"
  ],
  "ALG1L8P": [
    "ALG1L8P CNV",
    "ALG1L8P RNA"
  ],
  "RNA5SP416": [
    "RNA5SP416 CNV",
    "RNA5SP416 RNA"
  ],
  "HNRNPA1P27": [
    "HNRNPA1P27 CNV",
    "HNRNPA1P27 RNA"
  ],
  "KRTAP6-1": [
    "KRTAP6-1 CNV",
    "KRTAP6-1 RNA"
  ],
  "OSTM1": [
    "OSTM1 CNV",
    "OSTM1 RNA",
    "OSTM1 Proteo"
  ],
  "NRDE2": [
    "NRDE2 CNV",
    "NRDE2 RNA",
    "NRDE2 Proteo"
  ],
  "SLC24A2": [
    "SLC24A2 CNV",
    "SLC24A2 RNA"
  ],
  "RPL23AP87": [
    "RPL23AP87 CNV",
    "RPL23AP87 RNA"
  ],
  "HNRNPA3P13": [
    "HNRNPA3P13 CNV",
    "HNRNPA3P13 RNA"
  ],
  "RPL7": [
    "RPL7 CNV",
    "RPL7 RNA",
    "RPL7 Proteo"
  ],
  "ZSWIM4": [
    "ZSWIM4 CNV",
    "ZSWIM4 RNA"
  ],
  "H3P32": [
    "H3P32 CNV",
    "H3P32 RNA"
  ],
  "MTCO3P30": [
    "MTCO3P30 CNV",
    "MTCO3P30 RNA"
  ],
  "FOXJ2": [
    "FOXJ2 CNV",
    "FOXJ2 RNA",
    "FOXJ2 Proteo"
  ],
  "HYAL4": [
    "HYAL4 CNV",
    "HYAL4 RNA"
  ],
  "ANG": [
    "ANG CNV",
    "ANG RNA",
    "ANG Proteo"
  ],
  "TPCN1": [
    "TPCN1 CNV",
    "TPCN1 RNA",
    "TPCN1 Proteo"
  ],
  "TAAR3P": [
    "TAAR3P CNV",
    "TAAR3P RNA"
  ],
  "NDUFS6": [
    "NDUFS6 CNV",
    "NDUFS6 RNA",
    "NDUFS6 Proteo"
  ],
  "REX1BD": [
    "REX1BD CNV",
    "REX1BD RNA",
    "REX1BD Proteo"
  ],
  "FAM72D": [
    "FAM72D CNV",
    "FAM72D RNA"
  ],
  "RPL35P5": [
    "RPL35P5 CNV",
    "RPL35P5 RNA"
  ],
  "CHEK1": [
    "CHEK1 CNV",
    "CHEK1 RNA",
    "CHEK1 Proteo"
  ],
  "FANCC": [
    "FANCC CNV",
    "FANCC RNA"
  ],
  "RPL4": [
    "RPL4 CNV",
    "RPL4 RNA",
    "RPL4 Proteo"
  ],
  "RBM43": [
    "RBM43 CNV",
    "RBM43 RNA",
    "RBM43 Proteo"
  ],
  "SRSF8CP": [
    "SRSF8CP CNV",
    "SRSF8CP RNA"
  ],
  "CICP19": [
    "CICP19 CNV",
    "CICP19 RNA"
  ],
  "LYPLA1P1": [
    "LYPLA1P1 CNV",
    "LYPLA1P1 RNA"
  ],
  "DPEP2": [
    "DPEP2 CNV",
    "DPEP2 RNA"
  ],
  "CSRNP3": [
    "CSRNP3 CNV",
    "CSRNP3 RNA",
    "CSRNP3 Proteo"
  ],
  "NOMO3": [
    "NOMO3 CNV",
    "NOMO3 RNA",
    "NOMO3 Proteo"
  ],
  "ATP5F1AP4": [
    "ATP5F1AP4 CNV",
    "ATP5F1AP4 RNA"
  ],
  "RNA5SP275": [
    "RNA5SP275 CNV",
    "RNA5SP275 RNA"
  ],
  "ITPKB": [
    "ITPKB CNV",
    "ITPKB RNA",
    "ITPKB Proteo"
  ],
  "TTLL7": [
    "TTLL7 CNV",
    "TTLL7 RNA"
  ],
  "OR1S2": [
    "OR1S2 CNV",
    "OR1S2 RNA"
  ],
  "SLC10A2": [
    "SLC10A2 CNV",
    "SLC10A2 RNA"
  ],
  "ZNF776": [
    "ZNF776 CNV",
    "ZNF776 RNA"
  ],
  "RPL23AP26": [
    "RPL23AP26 CNV",
    "RPL23AP26 RNA"
  ],
  "KIF11": [
    "KIF11 CNV",
    "KIF11 RNA",
    "KIF11 Proteo"
  ],
  "C3orf49": [
    "C3orf49 CNV",
    "C3orf49 RNA"
  ],
  "ABCG1": [
    "ABCG1 CNV",
    "ABCG1 RNA",
    "ABCG1 Proteo"
  ],
  "RER1": [
    "RER1 CNV",
    "RER1 RNA",
    "RER1 Proteo"
  ],
  "CHD6": [
    "CHD6 CNV",
    "CHD6 RNA",
    "CHD6 Proteo"
  ],
  "SLC22A17": [
    "SLC22A17 CNV",
    "SLC22A17 RNA",
    "SLC22A17 Proteo"
  ],
  "SYTL1": [
    "SYTL1 CNV",
    "SYTL1 RNA",
    "SYTL1 Proteo"
  ],
  "H2AB2": [
    "H2AB2 CNV",
    "H2AB2 RNA"
  ],
  "USP21P1": [
    "USP21P1 CNV",
    "USP21P1 RNA"
  ],
  "TSPAN11": [
    "TSPAN11 CNV",
    "TSPAN11 RNA"
  ],
  "PGAM4": [
    "PGAM4 CNV",
    "PGAM4 RNA",
    "PGAM4 Proteo"
  ],
  "OFD1P4Y": [
    "OFD1P4Y CNV",
    "OFD1P4Y RNA"
  ],
  "PRELID3A": [
    "PRELID3A CNV",
    "PRELID3A RNA"
  ],
  "RPS3AP46": [
    "RPS3AP46 CNV",
    "RPS3AP46 RNA"
  ],
  "TAF4B": [
    "TAF4B CNV",
    "TAF4B RNA",
    "TAF4B Proteo"
  ],
  "OR2D2": [
    "OR2D2 CNV",
    "OR2D2 RNA"
  ],
  "YWHABP1": [
    "YWHABP1 CNV",
    "YWHABP1 RNA"
  ],
  "RPL3": [
    "RPL3 CNV",
    "RPL3 RNA",
    "RPL3 Proteo"
  ],
  "BCLAF1": [
    "BCLAF1 CNV",
    "BCLAF1 RNA",
    "BCLAF1 Proteo"
  ],
  "PRDX3P2": [
    "PRDX3P2 CNV",
    "PRDX3P2 RNA"
  ],
  "MRPL22": [
    "MRPL22 CNV",
    "MRPL22 RNA",
    "MRPL22 Proteo"
  ],
  "NR1D1": [
    "NR1D1 CNV",
    "NR1D1 RNA"
  ],
  "IFI27L1": [
    "IFI27L1 CNV",
    "IFI27L1 RNA"
  ],
  "FKBP8": [
    "FKBP8 CNV",
    "FKBP8 RNA",
    "FKBP8 Proteo"
  ],
  "RNA5SP358": [
    "RNA5SP358 CNV",
    "RNA5SP358 RNA"
  ],
  "SDC2": [
    "SDC2 CNV",
    "SDC2 RNA",
    "SDC2 Proteo"
  ],
  "RNA5SP41": [
    "RNA5SP41 CNV",
    "RNA5SP41 RNA"
  ],
  "OR7C2": [
    "OR7C2 CNV",
    "OR7C2 RNA"
  ],
  "ISX": [
    "ISX CNV",
    "ISX RNA"
  ],
  "RNF152": [
    "RNF152 CNV",
    "RNF152 RNA"
  ],
  "MTND6P21": [
    "MTND6P21 CNV",
    "MTND6P21 RNA"
  ],
  "HDAC8": [
    "HDAC8 CNV",
    "HDAC8 RNA",
    "HDAC8 Proteo"
  ],
  "RPL7AP81": [
    "RPL7AP81 CNV",
    "RPL7AP81 RNA"
  ],
  "ERCC6L": [
    "ERCC6L CNV",
    "ERCC6L RNA",
    "ERCC6L Proteo"
  ],
  "FAM86C2P": [
    "FAM86C2P CNV",
    "FAM86C2P RNA"
  ],
  "PPIAP83": [
    "PPIAP83 CNV",
    "PPIAP83 RNA"
  ],
  "KCNH2": [
    "KCNH2 CNV",
    "KCNH2 RNA"
  ],
  "PRAG1": [
    "PRAG1 CNV",
    "PRAG1 RNA",
    "PRAG1 Proteo"
  ],
  "TP53TG3": [
    "TP53TG3 CNV",
    "TP53TG3 RNA"
  ],
  "ADPRS": [
    "ADPRS CNV",
    "ADPRS RNA",
    "ADPRS Proteo"
  ],
  "NPM1P24": [
    "NPM1P24 CNV",
    "NPM1P24 RNA"
  ],
  "GAPDHP19": [
    "GAPDHP19 CNV",
    "GAPDHP19 RNA"
  ],
  "HSD17B7P2": [
    "HSD17B7P2 CNV",
    "HSD17B7P2 RNA"
  ],
  "WDR20": [
    "WDR20 CNV",
    "WDR20 RNA",
    "WDR20 Proteo"
  ],
  "PAICSP1": [
    "PAICSP1 CNV",
    "PAICSP1 RNA"
  ],
  "DGKI": [
    "DGKI CNV",
    "DGKI RNA"
  ],
  "TBX18": [
    "TBX18 CNV",
    "TBX18 RNA"
  ],
  "CYBC1": [
    "CYBC1 CNV",
    "CYBC1 RNA",
    "CYBC1 Proteo"
  ],
  "TDRD7": [
    "TDRD7 CNV",
    "TDRD7 RNA",
    "TDRD7 Proteo"
  ],
  "UNC93B8": [
    "UNC93B8 CNV",
    "UNC93B8 RNA"
  ],
  "ADRA2C": [
    "ADRA2C CNV",
    "ADRA2C RNA"
  ],
  "PIM2": [
    "PIM2 CNV",
    "PIM2 RNA",
    "PIM2 Proteo"
  ],
  "STK16": [
    "STK16 CNV",
    "STK16 RNA",
    "STK16 Proteo"
  ],
  "JDP2": [
    "JDP2 CNV",
    "JDP2 RNA"
  ],
  "ZCCHC2": [
    "ZCCHC2 CNV",
    "ZCCHC2 RNA",
    "ZCCHC2 Proteo"
  ],
  "GPC3": [
    "GPC3 CNV",
    "GPC3 RNA"
  ],
  "PKD1L2": [
    "PKD1L2 CNV",
    "PKD1L2 RNA"
  ],
  "RNA5SP227": [
    "RNA5SP227 CNV",
    "RNA5SP227 RNA"
  ],
  "DSC3": [
    "DSC3 CNV",
    "DSC3 RNA",
    "DSC3 Proteo"
  ],
  "CTRB2": [
    "CTRB2 CNV",
    "CTRB2 RNA",
    "CTRB2 Proteo"
  ],
  "RNA5SP138": [
    "RNA5SP138 CNV",
    "RNA5SP138 RNA"
  ],
  "DLG4": [
    "DLG4 CNV",
    "DLG4 RNA",
    "DLG4 Proteo"
  ],
  "RIMS2": [
    "RIMS2 CNV",
    "RIMS2 RNA",
    "RIMS2 Proteo"
  ],
  "ANKRD45": [
    "ANKRD45 CNV",
    "ANKRD45 RNA"
  ],
  "CAMK2G": [
    "CAMK2G CNV",
    "CAMK2G RNA",
    "CAMK2G Proteo"
  ],
  "RIMKLA": [
    "RIMKLA CNV",
    "RIMKLA RNA",
    "RIMKLA Proteo"
  ],
  "CIROP": [
    "CIROP CNV",
    "CIROP RNA"
  ],
  "TRAPPC14": [
    "TRAPPC14 CNV",
    "TRAPPC14 RNA",
    "TRAPPC14 Proteo"
  ],
  "SNAP47": [
    "SNAP47 CNV",
    "SNAP47 RNA",
    "SNAP47 Proteo"
  ],
  "CZIB": [
    "CZIB CNV",
    "CZIB RNA",
    "CZIB Proteo"
  ],
  "EIF4EBP1P1": [
    "EIF4EBP1P1 CNV",
    "EIF4EBP1P1 RNA"
  ],
  "VPS11": [
    "VPS11 CNV",
    "VPS11 RNA",
    "VPS11 Proteo"
  ],
  "RWDD2A": [
    "RWDD2A CNV",
    "RWDD2A RNA",
    "RWDD2A Proteo"
  ],
  "GRM4": [
    "GRM4 CNV",
    "GRM4 RNA"
  ],
  "RGS9": [
    "RGS9 CNV",
    "RGS9 RNA"
  ],
  "DEFT1P": [
    "DEFT1P CNV",
    "DEFT1P RNA"
  ],
  "PPIA": [
    "PPIA CNV",
    "PPIA RNA",
    "PPIA Proteo"
  ],
  "MT-CO2": [
    "MT-CO2 RNA",
    "MT-CO2 Proteo"
  ],
  "C10orf95": [
    "C10orf95 CNV",
    "C10orf95 RNA"
  ],
  "MTND4P10": [
    "MTND4P10 CNV",
    "MTND4P10 RNA"
  ],
  "EXO1": [
    "EXO1 CNV",
    "EXO1 RNA",
    "EXO1 Proteo"
  ],
  "UGT2B15": [
    "UGT2B15 CNV",
    "UGT2B15 RNA"
  ],
  "CCDC174": [
    "CCDC174 CNV",
    "CCDC174 RNA",
    "CCDC174 Proteo"
  ],
  "RNA5SP79": [
    "RNA5SP79 CNV",
    "RNA5SP79 RNA"
  ],
  "CEACAM7": [
    "CEACAM7 CNV",
    "CEACAM7 RNA"
  ],
  "VWA3A": [
    "VWA3A CNV",
    "VWA3A RNA"
  ],
  "SPTBN2": [
    "SPTBN2 CNV",
    "SPTBN2 RNA",
    "SPTBN2 Proteo"
  ],
  "SRPX": [
    "SRPX CNV",
    "SRPX RNA",
    "SRPX Proteo"
  ],
  "ETDB": [
    "ETDB CNV",
    "ETDB RNA"
  ],
  "PPIAP5": [
    "PPIAP5 CNV",
    "PPIAP5 RNA"
  ],
  "NRROS": [
    "NRROS CNV",
    "NRROS RNA",
    "NRROS Proteo"
  ],
  "GPAA1P2": [
    "GPAA1P2 CNV",
    "GPAA1P2 RNA"
  ],
  "C1orf43": [
    "C1orf43 CNV",
    "C1orf43 RNA",
    "C1orf43 Proteo"
  ],
  "ZNF736P12Y": [
    "ZNF736P12Y CNV",
    "ZNF736P12Y RNA"
  ],
  "LDLRAD3": [
    "LDLRAD3 CNV",
    "LDLRAD3 RNA",
    "LDLRAD3 Proteo"
  ],
  "SMOC2": [
    "SMOC2 CNV",
    "SMOC2 RNA",
    "SMOC2 Proteo"
  ],
  "C1orf127": [
    "C1orf127 CNV",
    "C1orf127 RNA"
  ],
  "SBF1": [
    "SBF1 CNV",
    "SBF1 RNA",
    "SBF1 Proteo"
  ],
  "FLAD1": [
    "FLAD1 CNV",
    "FLAD1 RNA",
    "FLAD1 Proteo"
  ],
  "SYNGR4": [
    "SYNGR4 CNV",
    "SYNGR4 RNA"
  ],
  "CCDC7": [
    "CCDC7 CNV",
    "CCDC7 RNA"
  ],
  "H3P19": [
    "H3P19 CNV",
    "H3P19 RNA"
  ],
  "FGFR1": [
    "FGFR1 CNV",
    "FGFR1 RNA",
    "FGFR1 Proteo"
  ],
  "RASEF": [
    "RASEF CNV",
    "RASEF RNA",
    "RASEF Proteo"
  ],
  "USH1C": [
    "USH1C CNV",
    "USH1C RNA",
    "USH1C Proteo"
  ],
  "CLSPN": [
    "CLSPN CNV",
    "CLSPN RNA",
    "CLSPN Proteo"
  ],
  "TRHR": [
    "TRHR CNV",
    "TRHR RNA"
  ],
  "NR2C2AP": [
    "NR2C2AP CNV",
    "NR2C2AP RNA",
    "NR2C2AP Proteo"
  ],
  "HSD3B7": [
    "HSD3B7 CNV",
    "HSD3B7 RNA",
    "HSD3B7 Proteo"
  ],
  "THEM7P": [
    "THEM7P CNV",
    "THEM7P RNA"
  ],
  "C5orf58": [
    "C5orf58 CNV",
    "C5orf58 RNA"
  ],
  "PLEKHH1": [
    "PLEKHH1 CNV",
    "PLEKHH1 RNA",
    "PLEKHH1 Proteo"
  ],
  "SLC6A15": [
    "SLC6A15 CNV",
    "SLC6A15 RNA",
    "SLC6A15 Proteo"
  ],
  "GOPC": [
    "GOPC CNV",
    "GOPC RNA",
    "GOPC Proteo"
  ],
  "LRRC71": [
    "LRRC71 CNV",
    "LRRC71 RNA"
  ],
  "VAX1": [
    "VAX1 CNV",
    "VAX1 RNA"
  ],
  "RUVBL1": [
    "RUVBL1 CNV",
    "RUVBL1 RNA",
    "RUVBL1 Proteo"
  ],
  "PCDH11X": [
    "PCDH11X CNV",
    "PCDH11X RNA"
  ],
  "BOLA2P2": [
    "BOLA2P2 CNV",
    "BOLA2P2 RNA"
  ],
  "PSMA6P1": [
    "PSMA6P1 CNV",
    "PSMA6P1 RNA"
  ],
  "GSTA8P": [
    "GSTA8P CNV",
    "GSTA8P RNA"
  ],
  "KLF13": [
    "KLF13 CNV",
    "KLF13 RNA",
    "KLF13 Proteo"
  ],
  "TAFA5": [
    "TAFA5 CNV",
    "TAFA5 RNA"
  ],
  "FGFR4": [
    "FGFR4 CNV",
    "FGFR4 RNA"
  ],
  "MRPL55": [
    "MRPL55 CNV",
    "MRPL55 RNA",
    "MRPL55 Proteo"
  ],
  "SNX6": [
    "SNX6 CNV",
    "SNX6 RNA",
    "SNX6 Proteo"
  ],
  "CLDN1": [
    "CLDN1 CNV",
    "CLDN1 RNA",
    "CLDN1 Proteo"
  ],
  "ZSWIM5P2": [
    "ZSWIM5P2 CNV",
    "ZSWIM5P2 RNA"
  ],
  "LTBP3": [
    "LTBP3 CNV",
    "LTBP3 RNA",
    "LTBP3 Proteo"
  ],
  "RPP30": [
    "RPP30 CNV",
    "RPP30 RNA",
    "RPP30 Proteo"
  ],
  "SLC25A3P3": [
    "SLC25A3P3 CNV",
    "SLC25A3P3 RNA"
  ],
  "GTF2IP23": [
    "GTF2IP23 CNV",
    "GTF2IP23 RNA"
  ],
  "TRPV6": [
    "TRPV6 CNV",
    "TRPV6 RNA"
  ],
  "ACTE1P": [
    "ACTE1P CNV",
    "ACTE1P RNA"
  ],
  "CC2D1B": [
    "CC2D1B CNV",
    "CC2D1B RNA",
    "CC2D1B Proteo"
  ],
  "RPSAP68": [
    "RPSAP68 CNV",
    "RPSAP68 RNA"
  ],
  "SUMO2P3": [
    "SUMO2P3 CNV",
    "SUMO2P3 RNA"
  ],
  "GTPBP10": [
    "GTPBP10 CNV",
    "GTPBP10 RNA",
    "GTPBP10 Proteo"
  ],
  "NUDT3": [
    "NUDT3 CNV",
    "NUDT3 RNA",
    "NUDT3 Proteo"
  ],
  "PHF21A": [
    "PHF21A CNV",
    "PHF21A RNA",
    "PHF21A Proteo"
  ],
  "HEPN1": [
    "HEPN1 CNV",
    "HEPN1 RNA"
  ],
  "ADRA1D": [
    "ADRA1D CNV",
    "ADRA1D RNA"
  ],
  "RPL6P7": [
    "RPL6P7 CNV",
    "RPL6P7 RNA"
  ],
  "TUBA1B": [
    "TUBA1B CNV",
    "TUBA1B RNA"
  ],
  "STUB1": [
    "STUB1 CNV",
    "STUB1 RNA",
    "STUB1 Proteo"
  ],
  "NYAP1": [
    "NYAP1 CNV",
    "NYAP1 RNA",
    "NYAP1 Proteo"
  ],
  "RAX2": [
    "RAX2 CNV",
    "RAX2 RNA"
  ],
  "FAM120C": [
    "FAM120C CNV",
    "FAM120C RNA",
    "FAM120C Proteo"
  ],
  "LPP": [
    "LPP CNV",
    "LPP RNA",
    "LPP Proteo"
  ],
  "FAM107B": [
    "FAM107B CNV",
    "FAM107B RNA",
    "FAM107B Proteo"
  ],
  "SRSF2P1": [
    "SRSF2P1 CNV",
    "SRSF2P1 RNA"
  ],
  "FAM185BP": [
    "FAM185BP CNV",
    "FAM185BP RNA"
  ],
  "TBL1X": [
    "TBL1X CNV",
    "TBL1X RNA",
    "TBL1X Proteo"
  ],
  "ACER2": [
    "ACER2 CNV",
    "ACER2 RNA"
  ],
  "PTS": [
    "PTS CNV",
    "PTS RNA",
    "PTS Proteo"
  ],
  "LRTM2": [
    "LRTM2 CNV",
    "LRTM2 RNA"
  ],
  "PRSS47P": [
    "PRSS47P CNV",
    "PRSS47P RNA"
  ],
  "PSPHP1": [
    "PSPHP1 CNV",
    "PSPHP1 RNA"
  ],
  "LRRC59": [
    "LRRC59 CNV",
    "LRRC59 RNA",
    "LRRC59 Proteo"
  ],
  "PCDHAC2": [
    "PCDHAC2 CNV",
    "PCDHAC2 RNA"
  ],
  "HMGB3P7": [
    "HMGB3P7 CNV",
    "HMGB3P7 RNA"
  ],
  "FAM91A3P": [
    "FAM91A3P CNV",
    "FAM91A3P RNA"
  ],
  "MED28P3": [
    "MED28P3 CNV",
    "MED28P3 RNA"
  ],
  "UTP3": [
    "UTP3 CNV",
    "UTP3 RNA",
    "UTP3 Proteo"
  ],
  "DDX3P1": [
    "DDX3P1 CNV",
    "DDX3P1 RNA"
  ],
  "HNRNPA1P67": [
    "HNRNPA1P67 CNV",
    "HNRNPA1P67 RNA"
  ],
  "ZDHHC1": [
    "ZDHHC1 CNV",
    "ZDHHC1 RNA"
  ],
  "CBLIF": [
    "CBLIF CNV",
    "CBLIF RNA"
  ],
  "KRT18P21": [
    "KRT18P21 CNV",
    "KRT18P21 RNA"
  ],
  "LRRC8C": [
    "LRRC8C CNV",
    "LRRC8C RNA",
    "LRRC8C Proteo"
  ],
  "KLHL4": [
    "KLHL4 CNV",
    "KLHL4 RNA"
  ],
  "ABI1P1": [
    "ABI1P1 CNV",
    "ABI1P1 RNA"
  ],
  "RPS29P17": [
    "RPS29P17 CNV",
    "RPS29P17 RNA"
  ],
  "SUCLA2P2": [
    "SUCLA2P2 CNV",
    "SUCLA2P2 RNA"
  ],
  "C20orf144": [
    "C20orf144 CNV",
    "C20orf144 RNA"
  ],
  "RPL5P27": [
    "RPL5P27 CNV",
    "RPL5P27 RNA"
  ],
  "YARS1": [
    "YARS1 CNV",
    "YARS1 RNA",
    "YARS1 Proteo"
  ],
  "ZNF443": [
    "ZNF443 CNV",
    "ZNF443 RNA"
  ],
  "NPIPA2": [
    "NPIPA2 CNV",
    "NPIPA2 RNA"
  ],
  "PGBD4P8": [
    "PGBD4P8 CNV",
    "PGBD4P8 RNA"
  ],
  "TRAPPC2P7": [
    "TRAPPC2P7 CNV",
    "TRAPPC2P7 RNA"
  ],
  "HUWE1": [
    "HUWE1 CNV",
    "HUWE1 RNA",
    "HUWE1 Proteo"
  ],
  "REEP6": [
    "REEP6 CNV",
    "REEP6 RNA",
    "REEP6 Proteo"
  ],
  "GPR89A": [
    "GPR89A CNV",
    "GPR89A RNA",
    "GPR89A Proteo"
  ],
  "CTRL": [
    "CTRL CNV",
    "CTRL RNA"
  ],
  "GNG12": [
    "GNG12 CNV",
    "GNG12 RNA",
    "GNG12 Proteo"
  ],
  "USP32P3": [
    "USP32P3 CNV",
    "USP32P3 RNA"
  ],
  "MRPL49": [
    "MRPL49 CNV",
    "MRPL49 RNA",
    "MRPL49 Proteo"
  ],
  "EIF2B4": [
    "EIF2B4 CNV",
    "EIF2B4 RNA",
    "EIF2B4 Proteo"
  ],
  "EIF3H": [
    "EIF3H CNV",
    "EIF3H RNA",
    "EIF3H Proteo"
  ],
  "HMGN2P20": [
    "HMGN2P20 CNV",
    "HMGN2P20 RNA"
  ],
  "VN2R9P": [
    "VN2R9P CNV",
    "VN2R9P RNA"
  ],
  "PERM1": [
    "PERM1 CNV",
    "PERM1 RNA"
  ],
  "EVA1CP2": [
    "EVA1CP2 CNV",
    "EVA1CP2 RNA"
  ],
  "CCDC74A": [
    "CCDC74A CNV",
    "CCDC74A RNA"
  ],
  "BSDC1": [
    "BSDC1 CNV",
    "BSDC1 RNA",
    "BSDC1 Proteo"
  ],
  "IYD": [
    "IYD CNV",
    "IYD RNA"
  ],
  "PGC": [
    "PGC CNV",
    "PGC RNA",
    "PGC Proteo"
  ],
  "CNOT3": [
    "CNOT3 CNV",
    "CNOT3 RNA",
    "CNOT3 Proteo"
  ],
  "LBHD1": [
    "LBHD1 CNV",
    "LBHD1 RNA"
  ],
  "HOXA5": [
    "HOXA5 CNV",
    "HOXA5 RNA",
    "HOXA5 Proteo"
  ],
  "H2BN1": [
    "H2BN1 CNV",
    "H2BN1 RNA"
  ],
  "C1DP1": [
    "C1DP1 CNV",
    "C1DP1 RNA"
  ],
  "EEA1": [
    "EEA1 CNV",
    "EEA1 RNA",
    "EEA1 Proteo"
  ],
  "SNRPGP15": [
    "SNRPGP15 CNV",
    "SNRPGP15 RNA"
  ],
  "KPNA7": [
    "KPNA7 CNV",
    "KPNA7 RNA",
    "KPNA7 Proteo"
  ],
  "NSA2P1": [
    "NSA2P1 CNV",
    "NSA2P1 RNA"
  ],
  "MRPL2": [
    "MRPL2 CNV",
    "MRPL2 RNA",
    "MRPL2 Proteo"
  ],
  "RPL10P1": [
    "RPL10P1 CNV",
    "RPL10P1 RNA"
  ],
  "FEZF1": [
    "FEZF1 CNV",
    "FEZF1 RNA"
  ],
  "OR4A3P": [
    "OR4A3P CNV",
    "OR4A3P RNA"
  ],
  "RPL21P28": [
    "RPL21P28 CNV",
    "RPL21P28 RNA"
  ],
  "SLC6A5": [
    "SLC6A5 CNV",
    "SLC6A5 RNA"
  ],
  "FNDC3B": [
    "FNDC3B CNV",
    "FNDC3B RNA",
    "FNDC3B Proteo"
  ],
  "SH2D6": [
    "SH2D6 CNV",
    "SH2D6 RNA"
  ],
  "PHF19": [
    "PHF19 CNV",
    "PHF19 RNA",
    "PHF19 Proteo"
  ],
  "RNF217": [
    "RNF217 CNV",
    "RNF217 RNA"
  ],
  "OR6K5P": [
    "OR6K5P CNV",
    "OR6K5P RNA"
  ],
  "NELFB": [
    "NELFB CNV",
    "NELFB RNA",
    "NELFB Proteo"
  ],
  "RRBP1": [
    "RRBP1 CNV",
    "RRBP1 RNA",
    "RRBP1 Proteo"
  ],
  "TLE3": [
    "TLE3 CNV",
    "TLE3 RNA",
    "TLE3 Proteo"
  ],
  "EXOGP1": [
    "EXOGP1 CNV",
    "EXOGP1 RNA"
  ],
  "PCDH15": [
    "PCDH15 CNV",
    "PCDH15 RNA"
  ],
  "PKDCC": [
    "PKDCC CNV",
    "PKDCC RNA"
  ],
  "RNA5SP382": [
    "RNA5SP382 CNV",
    "RNA5SP382 RNA"
  ],
  "TSPAN33": [
    "TSPAN33 CNV",
    "TSPAN33 RNA"
  ],
  "CHD5": [
    "CHD5 CNV",
    "CHD5 RNA",
    "CHD5 Proteo"
  ],
  "RNA5SP202": [
    "RNA5SP202 CNV",
    "RNA5SP202 RNA"
  ],
  "RPL27AP": [
    "RPL27AP CNV",
    "RPL27AP RNA"
  ],
  "OR4A40P": [
    "OR4A40P CNV",
    "OR4A40P RNA"
  ],
  "MTND6P24": [
    "MTND6P24 CNV",
    "MTND6P24 RNA"
  ],
  "RPSAP76": [
    "RPSAP76 CNV",
    "RPSAP76 RNA"
  ],
  "RPL7AP23": [
    "RPL7AP23 CNV",
    "RPL7AP23 RNA"
  ],
  "SRF": [
    "SRF CNV",
    "SRF RNA",
    "SRF Proteo"
  ],
  "TTBK1": [
    "TTBK1 CNV",
    "TTBK1 RNA"
  ],
  "HMGN2P32": [
    "HMGN2P32 CNV",
    "HMGN2P32 RNA"
  ],
  "TNPO3": [
    "TNPO3 CNV",
    "TNPO3 RNA",
    "TNPO3 Proteo"
  ],
  "SNRPGP17": [
    "SNRPGP17 CNV",
    "SNRPGP17 RNA"
  ],
  "IGLC6": [
    "IGLC6 CNV",
    "IGLC6 RNA"
  ],
  "EXOC5": [
    "EXOC5 CNV",
    "EXOC5 RNA",
    "EXOC5 Proteo"
  ],
  "AGTR1": [
    "AGTR1 CNV",
    "AGTR1 RNA"
  ],
  "OR6X1": [
    "OR6X1 CNV",
    "OR6X1 RNA"
  ],
  "PNRC2P1": [
    "PNRC2P1 CNV",
    "PNRC2P1 RNA"
  ],
  "ZFHX4": [
    "ZFHX4 CNV",
    "ZFHX4 RNA",
    "ZFHX4 Proteo"
  ],
  "TADA2A": [
    "TADA2A CNV",
    "TADA2A RNA",
    "TADA2A Proteo"
  ],
  "IGHV3-30": [
    "IGHV3-30 Proteo"
  ],
  "JUP": [
    "JUP CNV",
    "JUP RNA",
    "JUP Proteo"
  ],
  "GORASP1": [
    "GORASP1 CNV",
    "GORASP1 RNA",
    "GORASP1 Proteo"
  ],
  "TIMM10B": [
    "TIMM10B CNV",
    "TIMM10B RNA",
    "TIMM10B Proteo"
  ],
  "RRM2": [
    "RRM2 CNV",
    "RRM2 RNA",
    "RRM2 Proteo"
  ],
  "MRPL50P1": [
    "MRPL50P1 CNV",
    "MRPL50P1 RNA"
  ],
  "DUS1L": [
    "DUS1L CNV",
    "DUS1L RNA",
    "DUS1L Proteo"
  ],
  "AKIRIN1P2": [
    "AKIRIN1P2 CNV",
    "AKIRIN1P2 RNA"
  ],
  "USP21": [
    "USP21 CNV",
    "USP21 RNA",
    "USP21 Proteo"
  ],
  "KRT8P5": [
    "KRT8P5 CNV",
    "KRT8P5 RNA"
  ],
  "C1orf74": [
    "C1orf74 CNV",
    "C1orf74 RNA"
  ],
  "CFAP299": [
    "CFAP299 CNV",
    "CFAP299 RNA"
  ],
  "USP49": [
    "USP49 CNV",
    "USP49 RNA"
  ],
  "RNA5SP133": [
    "RNA5SP133 CNV",
    "RNA5SP133 RNA"
  ],
  "RPL6P32": [
    "RPL6P32 CNV",
    "RPL6P32 RNA"
  ],
  "GPX6": [
    "GPX6 CNV",
    "GPX6 RNA"
  ],
  "RPL23AP56": [
    "RPL23AP56 CNV",
    "RPL23AP56 RNA"
  ],
  "C17orf107": [
    "C17orf107 CNV",
    "C17orf107 RNA"
  ],
  "PPP1R14D": [
    "PPP1R14D CNV",
    "PPP1R14D RNA"
  ],
  "BIRC7": [
    "BIRC7 CNV",
    "BIRC7 RNA",
    "BIRC7 Proteo"
  ],
  "RPL22P18": [
    "RPL22P18 CNV",
    "RPL22P18 RNA"
  ],
  "CMTM2": [
    "CMTM2 CNV",
    "CMTM2 RNA"
  ],
  "SASH1": [
    "SASH1 CNV",
    "SASH1 RNA",
    "SASH1 Proteo"
  ],
  "ACVR2B": [
    "ACVR2B CNV",
    "ACVR2B RNA"
  ],
  "GOLGA2P6": [
    "GOLGA2P6 CNV",
    "GOLGA2P6 RNA"
  ],
  "ZNF12": [
    "ZNF12 CNV",
    "ZNF12 RNA"
  ],
  "FBXO2": [
    "FBXO2 CNV",
    "FBXO2 RNA",
    "FBXO2 Proteo"
  ],
  "LRRC45": [
    "LRRC45 CNV",
    "LRRC45 RNA",
    "LRRC45 Proteo"
  ],
  "MESTP1": [
    "MESTP1 CNV",
    "MESTP1 RNA"
  ],
  "FAM90A7": [
    "FAM90A7 CNV",
    "FAM90A7 RNA"
  ],
  "PPP2CB": [
    "PPP2CB CNV",
    "PPP2CB RNA",
    "PPP2CB Proteo"
  ],
  "CYMP": [
    "CYMP CNV",
    "CYMP RNA"
  ],
  "RPL19P18": [
    "RPL19P18 CNV",
    "RPL19P18 RNA"
  ],
  "VN1R37P": [
    "VN1R37P CNV",
    "VN1R37P RNA"
  ],
  "RPP25": [
    "RPP25 CNV",
    "RPP25 RNA",
    "RPP25 Proteo"
  ],
  "RPL35AP3": [
    "RPL35AP3 CNV",
    "RPL35AP3 RNA"
  ],
  "DRICH1": [
    "DRICH1 CNV",
    "DRICH1 RNA"
  ],
  "TTC6": [
    "TTC6 CNV",
    "TTC6 RNA"
  ],
  "UBE2V1P14": [
    "UBE2V1P14 CNV",
    "UBE2V1P14 RNA"
  ],
  "SEPTIN6": [
    "SEPTIN6 CNV",
    "SEPTIN6 RNA",
    "SEPTIN6 Proteo"
  ],
  "MIX23": [
    "MIX23 CNV",
    "MIX23 RNA",
    "MIX23 Proteo"
  ],
  "ZDHHC21": [
    "ZDHHC21 CNV",
    "ZDHHC21 RNA",
    "ZDHHC21 Proteo"
  ],
  "TTYH3": [
    "TTYH3 CNV",
    "TTYH3 RNA",
    "TTYH3 Proteo"
  ],
  "RPL12P33": [
    "RPL12P33 CNV",
    "RPL12P33 RNA"
  ],
  "GATA6": [
    "GATA6 CNV",
    "GATA6 RNA"
  ],
  "KIF19": [
    "KIF19 CNV",
    "KIF19 RNA"
  ],
  "ZBED1P1": [
    "ZBED1P1 CNV",
    "ZBED1P1 RNA"
  ],
  "SF3A3P2": [
    "SF3A3P2 CNV",
    "SF3A3P2 RNA"
  ],
  "TMEM274P": [
    "TMEM274P CNV",
    "TMEM274P RNA"
  ],
  "EEF1A1P25": [
    "EEF1A1P25 CNV",
    "EEF1A1P25 RNA"
  ],
  "ARHGAP6": [
    "ARHGAP6 CNV",
    "ARHGAP6 RNA",
    "ARHGAP6 Proteo"
  ],
  "KPNA6": [
    "KPNA6 CNV",
    "KPNA6 RNA",
    "KPNA6 Proteo"
  ],
  "NUTM2D": [
    "NUTM2D CNV",
    "NUTM2D RNA"
  ],
  "MSANTD3": [
    "MSANTD3 CNV",
    "MSANTD3 RNA",
    "MSANTD3 Proteo"
  ],
  "INTS7": [
    "INTS7 CNV",
    "INTS7 RNA",
    "INTS7 Proteo"
  ],
  "RPL39P34": [
    "RPL39P34 CNV",
    "RPL39P34 RNA"
  ],
  "IL11": [
    "IL11 CNV",
    "IL11 RNA"
  ],
  "RHOBTB2": [
    "RHOBTB2 CNV",
    "RHOBTB2 RNA"
  ],
  "OR4F17": [
    "OR4F17 CNV",
    "OR4F17 RNA"
  ],
  "SACM1L": [
    "SACM1L CNV",
    "SACM1L RNA",
    "SACM1L Proteo"
  ],
  "NAPGP2": [
    "NAPGP2 CNV",
    "NAPGP2 RNA"
  ],
  "FTCDNL1": [
    "FTCDNL1 CNV",
    "FTCDNL1 RNA"
  ],
  "UTP15": [
    "UTP15 CNV",
    "UTP15 RNA",
    "UTP15 Proteo"
  ],
  "OCLN": [
    "OCLN CNV",
    "OCLN RNA",
    "OCLN Proteo"
  ],
  "DOCK6": [
    "DOCK6 CNV",
    "DOCK6 RNA",
    "DOCK6 Proteo"
  ],
  "GTF2H2C": [
    "GTF2H2C CNV",
    "GTF2H2C RNA"
  ],
  "KLK11": [
    "KLK11 CNV",
    "KLK11 RNA"
  ],
  "MPHOSPH10P2": [
    "MPHOSPH10P2 CNV",
    "MPHOSPH10P2 RNA"
  ],
  "OGFRL1": [
    "OGFRL1 CNV",
    "OGFRL1 RNA",
    "OGFRL1 Proteo"
  ],
  "CCND2P1": [
    "CCND2P1 CNV",
    "CCND2P1 RNA"
  ],
  "OR10G5P": [
    "OR10G5P CNV",
    "OR10G5P RNA"
  ],
  "HNRNPA3P11": [
    "HNRNPA3P11 CNV",
    "HNRNPA3P11 RNA"
  ],
  "RPS26P6": [
    "RPS26P6 CNV",
    "RPS26P6 RNA"
  ],
  "LACC1": [
    "LACC1 CNV",
    "LACC1 RNA",
    "LACC1 Proteo"
  ],
  "STARD13": [
    "STARD13 CNV",
    "STARD13 RNA",
    "STARD13 Proteo"
  ],
  "ITGA9": [
    "ITGA9 CNV",
    "ITGA9 RNA",
    "ITGA9 Proteo"
  ],
  "VRK2": [
    "VRK2 CNV",
    "VRK2 RNA",
    "VRK2 Proteo"
  ],
  "GTF3C1": [
    "GTF3C1 CNV",
    "GTF3C1 RNA",
    "GTF3C1 Proteo"
  ],
  "EFHC2": [
    "EFHC2 CNV",
    "EFHC2 RNA"
  ],
  "NDRG3": [
    "NDRG3 CNV",
    "NDRG3 RNA",
    "NDRG3 Proteo"
  ],
  "NPEPPSP1": [
    "NPEPPSP1 CNV",
    "NPEPPSP1 RNA"
  ],
  "RHOA": [
    "RHOA CNV",
    "RHOA RNA",
    "RHOA Proteo"
  ],
  "COMMD9": [
    "COMMD9 CNV",
    "COMMD9 RNA",
    "COMMD9 Proteo"
  ],
  "LIX1L": [
    "LIX1L CNV",
    "LIX1L RNA",
    "LIX1L Proteo"
  ],
  "RPL12P15": [
    "RPL12P15 CNV",
    "RPL12P15 RNA"
  ],
  "MS4A4E": [
    "MS4A4E CNV",
    "MS4A4E RNA"
  ],
  "PDZK1P1": [
    "PDZK1P1 CNV",
    "PDZK1P1 RNA"
  ],
  "DYDC1": [
    "DYDC1 CNV",
    "DYDC1 RNA"
  ],
  "TMEM271": [
    "TMEM271 CNV",
    "TMEM271 RNA"
  ],
  "SLC9A3P3": [
    "SLC9A3P3 CNV",
    "SLC9A3P3 RNA"
  ],
  "ZNF519P2": [
    "ZNF519P2 CNV",
    "ZNF519P2 RNA"
  ],
  "INSL4": [
    "INSL4 CNV",
    "INSL4 RNA"
  ],
  "JAKMIP3": [
    "JAKMIP3 CNV",
    "JAKMIP3 RNA"
  ],
  "CNTN5": [
    "CNTN5 CNV",
    "CNTN5 RNA"
  ],
  "CHRM2": [
    "CHRM2 CNV",
    "CHRM2 RNA"
  ],
  "MTND6P13": [
    "MTND6P13 CNV",
    "MTND6P13 RNA"
  ],
  "PPP6R2P1": [
    "PPP6R2P1 CNV",
    "PPP6R2P1 RNA"
  ],
  "OR52E2": [
    "OR52E2 CNV",
    "OR52E2 RNA"
  ],
  "RNF216": [
    "RNF216 CNV",
    "RNF216 RNA",
    "RNF216 Proteo"
  ],
  "MRPS21P1": [
    "MRPS21P1 CNV",
    "MRPS21P1 RNA"
  ],
  "ACSS3": [
    "ACSS3 CNV",
    "ACSS3 RNA",
    "ACSS3 Proteo"
  ],
  "TLR7": [
    "TLR7 CNV",
    "TLR7 RNA",
    "TLR7 Proteo"
  ],
  "SAXO1": [
    "SAXO1 CNV",
    "SAXO1 RNA"
  ],
  "TPRX1": [
    "TPRX1 CNV",
    "TPRX1 RNA"
  ],
  "FOXN4": [
    "FOXN4 CNV",
    "FOXN4 RNA"
  ],
  "FUCA1P1": [
    "FUCA1P1 CNV",
    "FUCA1P1 RNA"
  ],
  "WDR46": [
    "WDR46 CNV",
    "WDR46 RNA",
    "WDR46 Proteo"
  ],
  "RPL21P30": [
    "RPL21P30 CNV",
    "RPL21P30 RNA"
  ],
  "TICAM1": [
    "TICAM1 CNV",
    "TICAM1 RNA",
    "TICAM1 Proteo"
  ],
  "GCM1": [
    "GCM1 CNV",
    "GCM1 RNA"
  ],
  "RPL31P1": [
    "RPL31P1 CNV",
    "RPL31P1 RNA"
  ],
  "SLC9A3P1": [
    "SLC9A3P1 CNV",
    "SLC9A3P1 RNA"
  ],
  "OTOR": [
    "OTOR CNV",
    "OTOR RNA"
  ],
  "PPWD1": [
    "PPWD1 CNV",
    "PPWD1 RNA",
    "PPWD1 Proteo"
  ],
  "TNPO1P2": [
    "TNPO1P2 CNV",
    "TNPO1P2 RNA"
  ],
  "EIF3M": [
    "EIF3M CNV",
    "EIF3M RNA",
    "EIF3M Proteo"
  ],
  "SPDYE21": [
    "SPDYE21 CNV",
    "SPDYE21 RNA"
  ],
  "ABCB7": [
    "ABCB7 CNV",
    "ABCB7 RNA",
    "ABCB7 Proteo"
  ],
  "LYPD6B": [
    "LYPD6B CNV",
    "LYPD6B RNA"
  ],
  "IL19": [
    "IL19 CNV",
    "IL19 RNA"
  ],
  "NOS2P1": [
    "NOS2P1 CNV",
    "NOS2P1 RNA"
  ],
  "MTND5P7": [
    "MTND5P7 CNV",
    "MTND5P7 RNA"
  ],
  "DPH1": [
    "DPH1 CNV",
    "DPH1 RNA",
    "DPH1 Proteo"
  ],
  "KERA": [
    "KERA CNV",
    "KERA RNA",
    "KERA Proteo"
  ],
  "PITPNM2": [
    "PITPNM2 CNV",
    "PITPNM2 RNA",
    "PITPNM2 Proteo"
  ],
  "FOXQ1": [
    "FOXQ1 CNV",
    "FOXQ1 RNA"
  ],
  "GABRA3": [
    "GABRA3 CNV",
    "GABRA3 RNA"
  ],
  "NPIPB1P": [
    "NPIPB1P CNV",
    "NPIPB1P RNA"
  ],
  "PFN1P8": [
    "PFN1P8 CNV",
    "PFN1P8 RNA"
  ],
  "MRPL35P4": [
    "MRPL35P4 CNV",
    "MRPL35P4 RNA"
  ],
  "GART": [
    "GART CNV",
    "GART RNA",
    "GART Proteo"
  ],
  "TPTE": [
    "TPTE CNV",
    "TPTE RNA"
  ],
  "LRRN2": [
    "LRRN2 CNV",
    "LRRN2 RNA"
  ],
  "KRT18P57": [
    "KRT18P57 CNV",
    "KRT18P57 RNA"
  ],
  "RPL21P88": [
    "RPL21P88 CNV",
    "RPL21P88 RNA"
  ],
  "HTR7": [
    "HTR7 CNV",
    "HTR7 RNA"
  ],
  "AADACL2": [
    "AADACL2 CNV",
    "AADACL2 RNA"
  ],
  "SERPINA4": [
    "SERPINA4 CNV",
    "SERPINA4 RNA",
    "SERPINA4 Proteo"
  ],
  "ARPC3P5": [
    "ARPC3P5 CNV",
    "ARPC3P5 RNA"
  ],
  "OR4F5": [
    "OR4F5 CNV",
    "OR4F5 RNA"
  ],
  "OSCAR": [
    "OSCAR CNV",
    "OSCAR RNA",
    "OSCAR Proteo"
  ],
  "OR11H3P": [
    "OR11H3P CNV",
    "OR11H3P RNA"
  ],
  "KCNK10": [
    "KCNK10 CNV",
    "KCNK10 RNA"
  ],
  "PTBP2": [
    "PTBP2 CNV",
    "PTBP2 RNA",
    "PTBP2 Proteo"
  ],
  "RPSAP48": [
    "RPSAP48 CNV",
    "RPSAP48 RNA"
  ],
  "KRT223P": [
    "KRT223P CNV",
    "KRT223P RNA"
  ],
  "LINC01399": [
    "LINC01399 CNV",
    "LINC01399 RNA"
  ],
  "PPIAP16": [
    "PPIAP16 CNV",
    "PPIAP16 RNA"
  ],
  "ANAPC1P2": [
    "ANAPC1P2 CNV",
    "ANAPC1P2 RNA"
  ],
  "SLC39A10": [
    "SLC39A10 CNV",
    "SLC39A10 RNA",
    "SLC39A10 Proteo"
  ],
  "AK9": [
    "AK9 CNV",
    "AK9 RNA"
  ],
  "ZNF705CP": [
    "ZNF705CP CNV",
    "ZNF705CP RNA"
  ],
  "TRIM53BP": [
    "TRIM53BP CNV",
    "TRIM53BP RNA"
  ],
  "KRT18P59": [
    "KRT18P59 CNV",
    "KRT18P59 RNA"
  ],
  "NSA2P4": [
    "NSA2P4 CNV",
    "NSA2P4 RNA"
  ],
  "ODF3L2": [
    "ODF3L2 CNV",
    "ODF3L2 RNA"
  ],
  "SNW1": [
    "SNW1 CNV",
    "SNW1 RNA",
    "SNW1 Proteo"
  ],
  "ATP2B4": [
    "ATP2B4 CNV",
    "ATP2B4 RNA",
    "ATP2B4 Proteo"
  ],
  "ELFN1": [
    "ELFN1 CNV",
    "ELFN1 RNA",
    "ELFN1 Proteo"
  ],
  "PCBP2P1": [
    "PCBP2P1 CNV",
    "PCBP2P1 RNA"
  ],
  "PRMT8": [
    "PRMT8 CNV",
    "PRMT8 RNA",
    "PRMT8 Proteo"
  ],
  "TEX55": [
    "TEX55 CNV",
    "TEX55 RNA"
  ],
  "ZMAT1": [
    "ZMAT1 CNV",
    "ZMAT1 RNA"
  ],
  "PDE4A": [
    "PDE4A CNV",
    "PDE4A RNA",
    "PDE4A Proteo"
  ],
  "STH": [
    "STH CNV",
    "STH RNA"
  ],
  "MTND6P35": [
    "MTND6P35 CNV",
    "MTND6P35 RNA"
  ],
  "OR7H2P": [
    "OR7H2P CNV",
    "OR7H2P RNA"
  ],
  "IGKV2OR2-7D": [
    "IGKV2OR2-7D CNV",
    "IGKV2OR2-7D RNA"
  ],
  "UBTFL7": [
    "UBTFL7 CNV",
    "UBTFL7 RNA"
  ],
  "KIAA1958": [
    "KIAA1958 CNV",
    "KIAA1958 RNA",
    "KIAA1958 Proteo"
  ],
  "CT45A1": [
    "CT45A1 CNV",
    "CT45A1 RNA"
  ],
  "KIF20A": [
    "KIF20A CNV",
    "KIF20A RNA",
    "KIF20A Proteo"
  ],
  "HNRNPA1P56": [
    "HNRNPA1P56 CNV",
    "HNRNPA1P56 RNA"
  ],
  "TP53INP2": [
    "TP53INP2 CNV",
    "TP53INP2 RNA",
    "TP53INP2 Proteo"
  ],
  "WDR72": [
    "WDR72 CNV",
    "WDR72 RNA"
  ],
  "RPL29P32": [
    "RPL29P32 CNV",
    "RPL29P32 RNA"
  ],
  "PDE6A": [
    "PDE6A CNV",
    "PDE6A RNA"
  ],
  "MIX23P3": [
    "MIX23P3 CNV",
    "MIX23P3 RNA"
  ],
  "SUPT20H": [
    "SUPT20H CNV",
    "SUPT20H RNA",
    "SUPT20H Proteo"
  ],
  "FAM86GP": [
    "FAM86GP CNV",
    "FAM86GP RNA"
  ],
  "SRSF9P1": [
    "SRSF9P1 CNV",
    "SRSF9P1 RNA"
  ],
  "GPN3": [
    "GPN3 CNV",
    "GPN3 RNA",
    "GPN3 Proteo"
  ],
  "MRTFA": [
    "MRTFA CNV",
    "MRTFA RNA",
    "MRTFA Proteo"
  ],
  "ONECUT3": [
    "ONECUT3 CNV",
    "ONECUT3 RNA"
  ],
  "PRSS27": [
    "PRSS27 CNV",
    "PRSS27 RNA"
  ],
  "RETREG2": [
    "RETREG2 CNV",
    "RETREG2 RNA",
    "RETREG2 Proteo"
  ],
  "GUF1": [
    "GUF1 CNV",
    "GUF1 RNA",
    "GUF1 Proteo"
  ],
  "CDH7": [
    "CDH7 CNV",
    "CDH7 RNA"
  ],
  "AQP9": [
    "AQP9 CNV",
    "AQP9 RNA"
  ],
  "ANPEP": [
    "ANPEP CNV",
    "ANPEP RNA",
    "ANPEP Proteo"
  ],
  "TPRN": [
    "TPRN CNV",
    "TPRN RNA",
    "TPRN Proteo"
  ],
  "SUGP1": [
    "SUGP1 CNV",
    "SUGP1 RNA",
    "SUGP1 Proteo"
  ],
  "MTND5P10": [
    "MTND5P10 CNV",
    "MTND5P10 RNA"
  ],
  "C5orf24": [
    "C5orf24 CNV",
    "C5orf24 RNA",
    "C5orf24 Proteo"
  ],
  "RBPMS2P1": [
    "RBPMS2P1 CNV",
    "RBPMS2P1 RNA"
  ],
  "CXCR1": [
    "CXCR1 CNV",
    "CXCR1 RNA"
  ],
  "MST1": [
    "MST1 CNV",
    "MST1 RNA",
    "MST1 Proteo"
  ],
  "TMEM25": [
    "TMEM25 CNV",
    "TMEM25 RNA"
  ],
  "HMGB1P15": [
    "HMGB1P15 CNV",
    "HMGB1P15 RNA"
  ],
  "RPL10P15": [
    "RPL10P15 CNV",
    "RPL10P15 RNA"
  ],
  "TSPAN8": [
    "TSPAN8 CNV",
    "TSPAN8 RNA",
    "TSPAN8 Proteo"
  ],
  "RPL36AP13": [
    "RPL36AP13 CNV",
    "RPL36AP13 RNA"
  ],
  "ZNRF2P2": [
    "ZNRF2P2 CNV",
    "ZNRF2P2 RNA"
  ],
  "PSMD8P1": [
    "PSMD8P1 CNV",
    "PSMD8P1 RNA"
  ],
  "ANKS1A": [
    "ANKS1A CNV",
    "ANKS1A RNA",
    "ANKS1A Proteo"
  ],
  "RGS4": [
    "RGS4 CNV",
    "RGS4 RNA"
  ],
  "CCPG1": [
    "CCPG1 CNV",
    "CCPG1 RNA",
    "CCPG1 Proteo"
  ],
  "LAMB3": [
    "LAMB3 CNV",
    "LAMB3 RNA",
    "LAMB3 Proteo"
  ],
  "IGLV7-46": [
    "IGLV7-46 Proteo"
  ],
  "WDR61": [
    "WDR61 CNV",
    "WDR61 RNA",
    "WDR61 Proteo"
  ],
  "FBXO42": [
    "FBXO42 CNV",
    "FBXO42 RNA",
    "FBXO42 Proteo"
  ],
  "SRSF2": [
    "SRSF2 CNV",
    "SRSF2 RNA",
    "SRSF2 Proteo"
  ],
  "FRMD5": [
    "FRMD5 CNV",
    "FRMD5 RNA",
    "FRMD5 Proteo"
  ],
  "MYCLP2": [
    "MYCLP2 CNV",
    "MYCLP2 RNA"
  ],
  "OR5P4P": [
    "OR5P4P CNV",
    "OR5P4P RNA"
  ],
  "CCHCR1": [
    "CCHCR1 CNV",
    "CCHCR1 RNA",
    "CCHCR1 Proteo"
  ],
  "CAPN6": [
    "CAPN6 CNV",
    "CAPN6 RNA"
  ],
  "SERPINA10": [
    "SERPINA10 CNV",
    "SERPINA10 RNA",
    "SERPINA10 Proteo"
  ],
  "ZGRF1": [
    "ZGRF1 CNV",
    "ZGRF1 RNA",
    "ZGRF1 Proteo"
  ],
  "HSP90AA3P": [
    "HSP90AA3P CNV",
    "HSP90AA3P RNA"
  ],
  "ATP6V1G1P6": [
    "ATP6V1G1P6 CNV",
    "ATP6V1G1P6 RNA"
  ],
  "LRRC8E": [
    "LRRC8E CNV",
    "LRRC8E RNA",
    "LRRC8E Proteo"
  ],
  "OR12D3": [
    "OR12D3 CNV",
    "OR12D3 RNA"
  ],
  "ARMCX5": [
    "ARMCX5 CNV",
    "ARMCX5 RNA",
    "ARMCX5 Proteo"
  ],
  "CLDN15": [
    "CLDN15 CNV",
    "CLDN15 RNA",
    "CLDN15 Proteo"
  ],
  "NINL": [
    "NINL CNV",
    "NINL RNA"
  ],
  "FAM78A": [
    "FAM78A CNV",
    "FAM78A RNA",
    "FAM78A Proteo"
  ],
  "CYCSP45": [
    "CYCSP45 CNV",
    "CYCSP45 RNA"
  ],
  "HAUS3": [
    "HAUS3 CNV",
    "HAUS3 RNA",
    "HAUS3 Proteo"
  ],
  "NFYCP2": [
    "NFYCP2 CNV",
    "NFYCP2 RNA"
  ],
  "MDFIC2": [
    "MDFIC2 CNV",
    "MDFIC2 RNA"
  ],
  "GOLGA6L5P": [
    "GOLGA6L5P CNV",
    "GOLGA6L5P RNA"
  ],
  "IGHV3-49": [
    "IGHV3-49 Proteo"
  ],
  "RRP7A": [
    "RRP7A CNV",
    "RRP7A RNA",
    "RRP7A Proteo"
  ],
  "RBBP5": [
    "RBBP5 CNV",
    "RBBP5 RNA",
    "RBBP5 Proteo"
  ],
  "GLUL": [
    "GLUL CNV",
    "GLUL RNA",
    "GLUL Proteo"
  ],
  "PPID": [
    "PPID CNV",
    "PPID RNA",
    "PPID Proteo"
  ],
  "PFN1P10": [
    "PFN1P10 CNV",
    "PFN1P10 RNA"
  ],
  "RBMY1A3P": [
    "RBMY1A3P CNV",
    "RBMY1A3P RNA"
  ],
  "STT3A": [
    "STT3A CNV",
    "STT3A RNA",
    "STT3A Proteo"
  ],
  "RNA5SP34": [
    "RNA5SP34 CNV",
    "RNA5SP34 RNA"
  ],
  "OGN": [
    "OGN CNV",
    "OGN RNA",
    "OGN Proteo"
  ],
  "ACP2": [
    "ACP2 CNV",
    "ACP2 RNA",
    "ACP2 Proteo"
  ],
  "COLEC10": [
    "COLEC10 CNV",
    "COLEC10 RNA"
  ],
  "NT5E": [
    "NT5E CNV",
    "NT5E RNA",
    "NT5E Proteo"
  ],
  "ATP5MC1P5": [
    "ATP5MC1P5 CNV",
    "ATP5MC1P5 RNA"
  ],
  "SNF8P1": [
    "SNF8P1 CNV",
    "SNF8P1 RNA"
  ],
  "RPS7P4": [
    "RPS7P4 CNV",
    "RPS7P4 RNA"
  ],
  "ATP5MC1P7": [
    "ATP5MC1P7 CNV",
    "ATP5MC1P7 RNA"
  ],
  "DDX3P3": [
    "DDX3P3 CNV",
    "DDX3P3 RNA"
  ],
  "NCAPH": [
    "NCAPH CNV",
    "NCAPH RNA",
    "NCAPH Proteo"
  ],
  "NIPAL1": [
    "NIPAL1 CNV",
    "NIPAL1 RNA"
  ],
  "C11orf21": [
    "C11orf21 CNV",
    "C11orf21 RNA"
  ],
  "FGF4": [
    "FGF4 CNV",
    "FGF4 RNA"
  ],
  "MGAT5": [
    "MGAT5 CNV",
    "MGAT5 RNA",
    "MGAT5 Proteo"
  ],
  "NBEAP4": [
    "NBEAP4 CNV",
    "NBEAP4 RNA"
  ],
  "XPA": [
    "XPA CNV",
    "XPA RNA",
    "XPA Proteo"
  ],
  "SAP30BP": [
    "SAP30BP CNV",
    "SAP30BP RNA",
    "SAP30BP Proteo"
  ],
  "HOXA13": [
    "HOXA13 CNV",
    "HOXA13 RNA"
  ],
  "CYP4Z1": [
    "CYP4Z1 CNV",
    "CYP4Z1 RNA"
  ],
  "CASP8": [
    "CASP8 CNV",
    "CASP8 RNA",
    "CASP8 Proteo"
  ],
  "PAM16": [
    "PAM16 CNV",
    "PAM16 RNA",
    "PAM16 Proteo"
  ],
  "TTC4P1": [
    "TTC4P1 CNV",
    "TTC4P1 RNA"
  ],
  "FBXW12": [
    "FBXW12 CNV",
    "FBXW12 RNA"
  ],
  "VPS4B": [
    "VPS4B CNV",
    "VPS4B RNA",
    "VPS4B Proteo"
  ],
  "LRRC37A2": [
    "LRRC37A2 CNV",
    "LRRC37A2 RNA"
  ],
  "PAMR1": [
    "PAMR1 CNV",
    "PAMR1 RNA"
  ],
  "HOPX": [
    "HOPX CNV",
    "HOPX RNA",
    "HOPX Proteo"
  ],
  "HDHD3": [
    "HDHD3 CNV",
    "HDHD3 RNA",
    "HDHD3 Proteo"
  ],
  "HIGD2A": [
    "HIGD2A CNV",
    "HIGD2A RNA",
    "HIGD2A Proteo"
  ],
  "MMP24": [
    "MMP24 CNV",
    "MMP24 RNA"
  ],
  "PDS5A": [
    "PDS5A CNV",
    "PDS5A RNA",
    "PDS5A Proteo"
  ],
  "GUCY2C": [
    "GUCY2C CNV",
    "GUCY2C RNA"
  ],
  "OR10N1P": [
    "OR10N1P CNV",
    "OR10N1P RNA"
  ],
  "CXCL1P1": [
    "CXCL1P1 CNV",
    "CXCL1P1 RNA"
  ],
  "NKX3-2": [
    "NKX3-2 CNV",
    "NKX3-2 RNA"
  ],
  "PKMP2": [
    "PKMP2 CNV",
    "PKMP2 RNA"
  ],
  "CEBPZ": [
    "CEBPZ CNV",
    "CEBPZ RNA",
    "CEBPZ Proteo"
  ],
  "NBR1": [
    "NBR1 CNV",
    "NBR1 RNA",
    "NBR1 Proteo"
  ],
  "HBQ1": [
    "HBQ1 CNV",
    "HBQ1 RNA",
    "HBQ1 Proteo"
  ],
  "YBEY": [
    "YBEY CNV",
    "YBEY RNA",
    "YBEY Proteo"
  ],
  "EIF1P7": [
    "EIF1P7 CNV",
    "EIF1P7 RNA"
  ],
  "DPPA2": [
    "DPPA2 CNV",
    "DPPA2 RNA"
  ],
  "DHX40": [
    "DHX40 CNV",
    "DHX40 RNA",
    "DHX40 Proteo"
  ],
  "MTFR1L": [
    "MTFR1L CNV",
    "MTFR1L RNA",
    "MTFR1L Proteo"
  ],
  "OXLD1": [
    "OXLD1 CNV",
    "OXLD1 RNA",
    "OXLD1 Proteo"
  ],
  "SLC7A15P": [
    "SLC7A15P CNV",
    "SLC7A15P RNA"
  ],
  "FOXF1": [
    "FOXF1 CNV",
    "FOXF1 RNA"
  ],
  "ABCG4": [
    "ABCG4 CNV",
    "ABCG4 RNA"
  ],
  "LORICRIN": [
    "LORICRIN CNV",
    "LORICRIN RNA",
    "LORICRIN Proteo"
  ],
  "MTND4P3": [
    "MTND4P3 CNV",
    "MTND4P3 RNA"
  ],
  "RPLP1P10": [
    "RPLP1P10 CNV",
    "RPLP1P10 RNA"
  ],
  "TRPC6P3": [
    "TRPC6P3 CNV",
    "TRPC6P3 RNA"
  ],
  "TWIST2": [
    "TWIST2 CNV",
    "TWIST2 RNA"
  ],
  "TOX3": [
    "TOX3 CNV",
    "TOX3 RNA"
  ],
  "NOVA1": [
    "NOVA1 CNV",
    "NOVA1 RNA",
    "NOVA1 Proteo"
  ],
  "GLO1": [
    "GLO1 CNV",
    "GLO1 RNA",
    "GLO1 Proteo"
  ],
  "GFM1": [
    "GFM1 CNV",
    "GFM1 RNA",
    "GFM1 Proteo"
  ],
  "ZNF383": [
    "ZNF383 CNV",
    "ZNF383 RNA"
  ],
  "ERLIN2": [
    "ERLIN2 CNV",
    "ERLIN2 RNA",
    "ERLIN2 Proteo"
  ],
  "B4GAT1": [
    "B4GAT1 CNV",
    "B4GAT1 RNA",
    "B4GAT1 Proteo"
  ],
  "KRTAP3-1": [
    "KRTAP3-1 CNV",
    "KRTAP3-1 RNA"
  ],
  "RASAL2": [
    "RASAL2 CNV",
    "RASAL2 RNA",
    "RASAL2 Proteo"
  ],
  "OR2U2P": [
    "OR2U2P CNV",
    "OR2U2P RNA"
  ],
  "CDCA4": [
    "CDCA4 CNV",
    "CDCA4 RNA",
    "CDCA4 Proteo"
  ],
  "PRNP": [
    "PRNP CNV",
    "PRNP RNA",
    "PRNP Proteo"
  ],
  "B3GNT9": [
    "B3GNT9 CNV",
    "B3GNT9 RNA",
    "B3GNT9 Proteo"
  ],
  "LRRC34P1": [
    "LRRC34P1 CNV",
    "LRRC34P1 RNA"
  ],
  "ZNF804B": [
    "ZNF804B CNV",
    "ZNF804B RNA"
  ],
  "SEC22B4P": [
    "SEC22B4P CNV",
    "SEC22B4P RNA"
  ],
  "POTEJ": [
    "POTEJ CNV",
    "POTEJ RNA",
    "POTEJ Proteo"
  ],
  "HIVEP3": [
    "HIVEP3 CNV",
    "HIVEP3 RNA",
    "HIVEP3 Proteo"
  ],
  "ADGRB2": [
    "ADGRB2 CNV",
    "ADGRB2 RNA"
  ],
  "RPS7P15": [
    "RPS7P15 CNV",
    "RPS7P15 RNA"
  ],
  "OR8G5": [
    "OR8G5 CNV",
    "OR8G5 RNA"
  ],
  "SALL4P1": [
    "SALL4P1 CNV",
    "SALL4P1 RNA"
  ],
  "NPTX2": [
    "NPTX2 CNV",
    "NPTX2 RNA",
    "NPTX2 Proteo"
  ],
  "TBL1XR1": [
    "TBL1XR1 CNV",
    "TBL1XR1 RNA",
    "TBL1XR1 Proteo"
  ],
  "RTEL1": [
    "RTEL1 CNV",
    "RTEL1 RNA",
    "RTEL1 Proteo"
  ],
  "CEACAM1": [
    "CEACAM1 CNV",
    "CEACAM1 RNA",
    "CEACAM1 Proteo"
  ],
  "UBASH3B": [
    "UBASH3B CNV",
    "UBASH3B RNA",
    "UBASH3B Proteo"
  ],
  "MTATP6P15": [
    "MTATP6P15 CNV",
    "MTATP6P15 RNA"
  ],
  "APLP2": [
    "APLP2 CNV",
    "APLP2 RNA",
    "APLP2 Proteo"
  ],
  "TEX44": [
    "TEX44 CNV",
    "TEX44 RNA"
  ],
  "PXMP4": [
    "PXMP4 CNV",
    "PXMP4 RNA",
    "PXMP4 Proteo"
  ],
  "RNF224": [
    "RNF224 CNV",
    "RNF224 RNA"
  ],
  "OR5M5P": [
    "OR5M5P CNV",
    "OR5M5P RNA"
  ],
  "ZIC3": [
    "ZIC3 CNV",
    "ZIC3 RNA"
  ],
  "STIMATE": [
    "STIMATE CNV",
    "STIMATE RNA"
  ],
  "UBE2D2": [
    "UBE2D2 CNV",
    "UBE2D2 RNA",
    "UBE2D2 Proteo"
  ],
  "ERO1A": [
    "ERO1A CNV",
    "ERO1A RNA",
    "ERO1A Proteo"
  ],
  "FGD2": [
    "FGD2 CNV",
    "FGD2 RNA",
    "FGD2 Proteo"
  ],
  "OR5M13P": [
    "OR5M13P CNV",
    "OR5M13P RNA"
  ],
  "IGFL1P2": [
    "IGFL1P2 CNV",
    "IGFL1P2 RNA"
  ],
  "TCHP": [
    "TCHP CNV",
    "TCHP RNA",
    "TCHP Proteo"
  ],
  "UPF1": [
    "UPF1 CNV",
    "UPF1 RNA",
    "UPF1 Proteo"
  ],
  "ARHGDIB": [
    "ARHGDIB CNV",
    "ARHGDIB RNA",
    "ARHGDIB Proteo"
  ],
  "TARDBPP1": [
    "TARDBPP1 CNV",
    "TARDBPP1 RNA"
  ],
  "KLRC4": [
    "KLRC4 CNV",
    "KLRC4 RNA"
  ],
  "QPRT": [
    "QPRT CNV",
    "QPRT RNA",
    "QPRT Proteo"
  ],
  "MRRF": [
    "MRRF CNV",
    "MRRF RNA",
    "MRRF Proteo"
  ],
  "ERAS": [
    "ERAS CNV",
    "ERAS RNA"
  ],
  "SGCG": [
    "SGCG CNV",
    "SGCG RNA",
    "SGCG Proteo"
  ],
  "KRT14": [
    "KRT14 CNV",
    "KRT14 RNA",
    "KRT14 Proteo"
  ],
  "C1orf216": [
    "C1orf216 CNV",
    "C1orf216 RNA"
  ],
  "SECISBP2L": [
    "SECISBP2L CNV",
    "SECISBP2L RNA",
    "SECISBP2L Proteo"
  ],
  "SNAP23P1": [
    "SNAP23P1 CNV",
    "SNAP23P1 RNA"
  ],
  "ANGPT4": [
    "ANGPT4 CNV",
    "ANGPT4 RNA"
  ],
  "SNRPB": [
    "SNRPB CNV",
    "SNRPB RNA",
    "SNRPB Proteo"
  ],
  "MYL4": [
    "MYL4 CNV",
    "MYL4 RNA",
    "MYL4 Proteo"
  ],
  "ARL4AP4": [
    "ARL4AP4 CNV",
    "ARL4AP4 RNA"
  ],
  "TSPY18P": [
    "TSPY18P CNV",
    "TSPY18P RNA"
  ],
  "EIF4G1": [
    "EIF4G1 CNV",
    "EIF4G1 RNA",
    "EIF4G1 Proteo"
  ],
  "RAB9A": [
    "RAB9A CNV",
    "RAB9A RNA",
    "RAB9A Proteo"
  ],
  "OR2AG1": [
    "OR2AG1 CNV",
    "OR2AG1 RNA"
  ],
  "CLCN4": [
    "CLCN4 CNV",
    "CLCN4 RNA",
    "CLCN4 Proteo"
  ],
  "GAS7": [
    "GAS7 CNV",
    "GAS7 RNA",
    "GAS7 Proteo"
  ],
  "UNC93A": [
    "UNC93A CNV",
    "UNC93A RNA"
  ],
  "RBBP9": [
    "RBBP9 CNV",
    "RBBP9 RNA",
    "RBBP9 Proteo"
  ],
  "PTCD2P2": [
    "PTCD2P2 CNV",
    "PTCD2P2 RNA"
  ],
  "DDC": [
    "DDC CNV",
    "DDC RNA"
  ],
  "RPL31": [
    "RPL31 CNV",
    "RPL31 RNA",
    "RPL31 Proteo"
  ],
  "PDK3": [
    "PDK3 CNV",
    "PDK3 RNA",
    "PDK3 Proteo"
  ],
  "RNA5SP144": [
    "RNA5SP144 CNV",
    "RNA5SP144 RNA"
  ],
  "USP32P2": [
    "USP32P2 CNV",
    "USP32P2 RNA"
  ],
  "FXYD3": [
    "FXYD3 CNV",
    "FXYD3 RNA",
    "FXYD3 Proteo"
  ],
  "RPL31P14": [
    "RPL31P14 CNV",
    "RPL31P14 RNA"
  ],
  "NDUFB5P2": [
    "NDUFB5P2 CNV",
    "NDUFB5P2 RNA"
  ],
  "GDAP1L1": [
    "GDAP1L1 CNV",
    "GDAP1L1 RNA"
  ],
  "PTN": [
    "PTN CNV",
    "PTN RNA",
    "PTN Proteo"
  ],
  "EIF1B": [
    "EIF1B CNV",
    "EIF1B RNA",
    "EIF1B Proteo"
  ],
  "LRP2BP": [
    "LRP2BP CNV",
    "LRP2BP RNA"
  ],
  "WNK4": [
    "WNK4 CNV",
    "WNK4 RNA",
    "WNK4 Proteo"
  ],
  "CHRNA9": [
    "CHRNA9 CNV",
    "CHRNA9 RNA"
  ],
  "BUB3": [
    "BUB3 CNV",
    "BUB3 RNA",
    "BUB3 Proteo"
  ],
  "PALM": [
    "PALM CNV",
    "PALM RNA",
    "PALM Proteo"
  ],
  "MED15P5": [
    "MED15P5 CNV",
    "MED15P5 RNA"
  ],
  "LPAR2": [
    "LPAR2 CNV",
    "LPAR2 RNA",
    "LPAR2 Proteo"
  ],
  "MTND5P29": [
    "MTND5P29 CNV",
    "MTND5P29 RNA"
  ],
  "WNT8B": [
    "WNT8B CNV",
    "WNT8B RNA"
  ],
  "RBM22": [
    "RBM22 CNV",
    "RBM22 RNA",
    "RBM22 Proteo"
  ],
  "PPP1R9B": [
    "PPP1R9B CNV",
    "PPP1R9B RNA",
    "PPP1R9B Proteo"
  ],
  "COBLP1": [
    "COBLP1 CNV",
    "COBLP1 RNA"
  ],
  "CYP46A4P": [
    "CYP46A4P CNV",
    "CYP46A4P RNA"
  ],
  "CSTA": [
    "CSTA CNV",
    "CSTA RNA",
    "CSTA Proteo"
  ],
  "SLCO3A1": [
    "SLCO3A1 CNV",
    "SLCO3A1 RNA",
    "SLCO3A1 Proteo"
  ],
  "UNC119": [
    "UNC119 CNV",
    "UNC119 RNA",
    "UNC119 Proteo"
  ],
  "CDC20P1": [
    "CDC20P1 CNV",
    "CDC20P1 RNA"
  ],
  "KRTAP20-1": [
    "KRTAP20-1 CNV",
    "KRTAP20-1 RNA"
  ],
  "NGB": [
    "NGB CNV",
    "NGB RNA"
  ],
  "YAP1P1": [
    "YAP1P1 CNV",
    "YAP1P1 RNA"
  ],
  "TSPY2": [
    "TSPY2 CNV",
    "TSPY2 RNA"
  ],
  "AKR1B1P7": [
    "AKR1B1P7 CNV",
    "AKR1B1P7 RNA"
  ],
  "SYNE1": [
    "SYNE1 CNV",
    "SYNE1 RNA",
    "SYNE1 Proteo"
  ],
  "HSPA8P6": [
    "HSPA8P6 CNV",
    "HSPA8P6 RNA"
  ],
  "NUTF2P2": [
    "NUTF2P2 CNV",
    "NUTF2P2 RNA"
  ],
  "KRT18P44": [
    "KRT18P44 CNV",
    "KRT18P44 RNA"
  ],
  "OR11H5P": [
    "OR11H5P CNV",
    "OR11H5P RNA"
  ],
  "FRAT2": [
    "FRAT2 CNV",
    "FRAT2 RNA"
  ],
  "TSKU": [
    "TSKU CNV",
    "TSKU RNA",
    "TSKU Proteo"
  ],
  "TAF11L7": [
    "TAF11L7 CNV",
    "TAF11L7 RNA"
  ],
  "HNRNPA1P76": [
    "HNRNPA1P76 CNV",
    "HNRNPA1P76 RNA"
  ],
  "MFHAS1": [
    "MFHAS1 CNV",
    "MFHAS1 RNA",
    "MFHAS1 Proteo"
  ],
  "CTDSPL2P2": [
    "CTDSPL2P2 CNV",
    "CTDSPL2P2 RNA"
  ],
  "HMGCLL1": [
    "HMGCLL1 CNV",
    "HMGCLL1 RNA"
  ],
  "ALX4": [
    "ALX4 CNV",
    "ALX4 RNA"
  ],
  "AGBL3": [
    "AGBL3 CNV",
    "AGBL3 RNA"
  ],
  "MRPS6P4": [
    "MRPS6P4 CNV",
    "MRPS6P4 RNA"
  ],
  "PPDPFL": [
    "PPDPFL CNV",
    "PPDPFL RNA"
  ],
  "HRH2": [
    "HRH2 CNV",
    "HRH2 RNA"
  ],
  "EIF4A3": [
    "EIF4A3 CNV",
    "EIF4A3 RNA",
    "EIF4A3 Proteo"
  ],
  "ANKRD65": [
    "ANKRD65 CNV",
    "ANKRD65 RNA"
  ],
  "RTTN": [
    "RTTN CNV",
    "RTTN RNA",
    "RTTN Proteo"
  ],
  "RPL36AP29": [
    "RPL36AP29 CNV",
    "RPL36AP29 RNA"
  ],
  "RPL36AP21": [
    "RPL36AP21 CNV",
    "RPL36AP21 RNA"
  ],
  "HOXB2": [
    "HOXB2 CNV",
    "HOXB2 RNA"
  ],
  "TDGP1": [
    "TDGP1 CNV",
    "TDGP1 RNA"
  ],
  "INTS6P1": [
    "INTS6P1 CNV",
    "INTS6P1 RNA"
  ],
  "TRNT1": [
    "TRNT1 CNV",
    "TRNT1 RNA",
    "TRNT1 Proteo"
  ],
  "PSMF1": [
    "PSMF1 CNV",
    "PSMF1 RNA",
    "PSMF1 Proteo"
  ],
  "SELENOS": [
    "SELENOS CNV",
    "SELENOS RNA",
    "SELENOS Proteo"
  ],
  "AASS": [
    "AASS CNV",
    "AASS RNA",
    "AASS Proteo"
  ],
  "HACD1": [
    "HACD1 CNV",
    "HACD1 RNA",
    "HACD1 Proteo"
  ],
  "OR4K1": [
    "OR4K1 CNV",
    "OR4K1 RNA"
  ],
  "DPH3": [
    "DPH3 CNV",
    "DPH3 RNA",
    "DPH3 Proteo"
  ],
  "CASR": [
    "CASR CNV",
    "CASR RNA"
  ],
  "DAAM1": [
    "DAAM1 CNV",
    "DAAM1 RNA",
    "DAAM1 Proteo"
  ],
  "HCN3": [
    "HCN3 CNV",
    "HCN3 RNA"
  ],
  "PPIC": [
    "PPIC CNV",
    "PPIC RNA",
    "PPIC Proteo"
  ],
  "NDUFAB1": [
    "NDUFAB1 CNV",
    "NDUFAB1 RNA",
    "NDUFAB1 Proteo"
  ],
  "CYP2D8P": [
    "CYP2D8P CNV",
    "CYP2D8P RNA"
  ],
  "IGLV1-36": [
    "IGLV1-36 Proteo"
  ],
  "UTP4": [
    "UTP4 CNV",
    "UTP4 RNA",
    "UTP4 Proteo"
  ],
  "HCLS1": [
    "HCLS1 CNV",
    "HCLS1 RNA",
    "HCLS1 Proteo"
  ],
  "RNA5SP208": [
    "RNA5SP208 CNV",
    "RNA5SP208 RNA"
  ],
  "TFRC": [
    "TFRC CNV",
    "TFRC RNA",
    "TFRC Proteo"
  ],
  "PLEKHN1": [
    "PLEKHN1 CNV",
    "PLEKHN1 RNA"
  ],
  "ABHD4": [
    "ABHD4 CNV",
    "ABHD4 RNA",
    "ABHD4 Proteo"
  ],
  "FAM90A23": [
    "FAM90A23 CNV",
    "FAM90A23 RNA"
  ],
  "LRATD1": [
    "LRATD1 CNV",
    "LRATD1 RNA"
  ],
  "GUSBP10": [
    "GUSBP10 CNV",
    "GUSBP10 RNA"
  ],
  "MYH9": [
    "MYH9 CNV",
    "MYH9 RNA",
    "MYH9 Proteo"
  ],
  "RNA5SP267": [
    "RNA5SP267 CNV",
    "RNA5SP267 RNA"
  ],
  "SNRPCP5": [
    "SNRPCP5 CNV",
    "SNRPCP5 RNA"
  ],
  "SFTPB": [
    "SFTPB CNV",
    "SFTPB RNA",
    "SFTPB Proteo"
  ],
  "C5orf47": [
    "C5orf47 CNV",
    "C5orf47 RNA"
  ],
  "ARHGAP36": [
    "ARHGAP36 CNV",
    "ARHGAP36 RNA"
  ],
  "HNRNPA1P3": [
    "HNRNPA1P3 CNV",
    "HNRNPA1P3 RNA"
  ],
  "PRLH": [
    "PRLH CNV",
    "PRLH RNA"
  ],
  "CPA4": [
    "CPA4 CNV",
    "CPA4 RNA",
    "CPA4 Proteo"
  ],
  "SRRM4": [
    "SRRM4 CNV",
    "SRRM4 RNA"
  ],
  "RARRES1": [
    "RARRES1 CNV",
    "RARRES1 RNA",
    "RARRES1 Proteo"
  ],
  "RPS3AP9": [
    "RPS3AP9 CNV",
    "RPS3AP9 RNA"
  ],
  "PSMG4": [
    "PSMG4 CNV",
    "PSMG4 RNA",
    "PSMG4 Proteo"
  ],
  "PRPF38AP1": [
    "PRPF38AP1 CNV",
    "PRPF38AP1 RNA"
  ],
  "RNA5SP470": [
    "RNA5SP470 CNV",
    "RNA5SP470 RNA"
  ],
  "TRGVB": [
    "TRGVB CNV",
    "TRGVB RNA"
  ],
  "PRR20FP": [
    "PRR20FP CNV",
    "PRR20FP RNA"
  ],
  "RPSAP3": [
    "RPSAP3 CNV",
    "RPSAP3 RNA"
  ],
  "ZNF652": [
    "ZNF652 CNV",
    "ZNF652 RNA",
    "ZNF652 Proteo"
  ],
  "ZNF474": [
    "ZNF474 CNV",
    "ZNF474 RNA"
  ],
  "UBTFL8": [
    "UBTFL8 CNV",
    "UBTFL8 RNA"
  ],
  "TMEM164": [
    "TMEM164 CNV",
    "TMEM164 RNA",
    "TMEM164 Proteo"
  ],
  "SPAG1": [
    "SPAG1 CNV",
    "SPAG1 RNA",
    "SPAG1 Proteo"
  ],
  "PMS2P9": [
    "PMS2P9 CNV",
    "PMS2P9 RNA"
  ],
  "PRB4": [
    "PRB4 CNV",
    "PRB4 RNA"
  ],
  "C20orf204": [
    "C20orf204 CNV",
    "C20orf204 RNA"
  ],
  "KIR2DL3": [
    "KIR2DL3 CNV",
    "KIR2DL3 RNA"
  ],
  "BCL2L2": [
    "BCL2L2 CNV",
    "BCL2L2 RNA"
  ],
  "SUCO": [
    "SUCO CNV",
    "SUCO RNA",
    "SUCO Proteo"
  ],
  "COQ8A": [
    "COQ8A CNV",
    "COQ8A RNA",
    "COQ8A Proteo"
  ],
  "KRT82": [
    "KRT82 CNV",
    "KRT82 RNA",
    "KRT82 Proteo"
  ],
  "LY9": [
    "LY9 CNV",
    "LY9 RNA",
    "LY9 Proteo"
  ],
  "AGO2": [
    "AGO2 CNV",
    "AGO2 RNA",
    "AGO2 Proteo"
  ],
  "MRPL50P2": [
    "MRPL50P2 CNV",
    "MRPL50P2 RNA"
  ],
  "AIG1": [
    "AIG1 CNV",
    "AIG1 RNA",
    "AIG1 Proteo"
  ],
  "ZNF727": [
    "ZNF727 CNV",
    "ZNF727 RNA"
  ],
  "SULT1C3": [
    "SULT1C3 CNV",
    "SULT1C3 RNA"
  ],
  "NOTUM": [
    "NOTUM CNV",
    "NOTUM RNA"
  ],
  "SEC61G": [
    "SEC61G CNV",
    "SEC61G RNA",
    "SEC61G Proteo"
  ],
  "RPS29P5": [
    "RPS29P5 CNV",
    "RPS29P5 RNA"
  ],
  "FECH": [
    "FECH CNV",
    "FECH RNA",
    "FECH Proteo"
  ],
  "ETFRF1": [
    "ETFRF1 CNV",
    "ETFRF1 RNA",
    "ETFRF1 Proteo"
  ],
  "AZIN1": [
    "AZIN1 CNV",
    "AZIN1 RNA"
  ],
  "GRIN2D": [
    "GRIN2D CNV",
    "GRIN2D RNA"
  ],
  "BTBD18": [
    "BTBD18 CNV",
    "BTBD18 RNA"
  ],
  "HAS1": [
    "HAS1 CNV",
    "HAS1 RNA"
  ],
  "KRTAP4-3": [
    "KRTAP4-3 CNV",
    "KRTAP4-3 RNA"
  ],
  "ARHGAP27P2": [
    "ARHGAP27P2 CNV",
    "ARHGAP27P2 RNA"
  ],
  "PLIN4": [
    "PLIN4 CNV",
    "PLIN4 RNA",
    "PLIN4 Proteo"
  ],
  "FAM90A18": [
    "FAM90A18 CNV",
    "FAM90A18 RNA"
  ],
  "SLC25A25": [
    "SLC25A25 CNV",
    "SLC25A25 RNA",
    "SLC25A25 Proteo"
  ],
  "CAMK1": [
    "CAMK1 CNV",
    "CAMK1 RNA",
    "CAMK1 Proteo"
  ],
  "RPA3": [
    "RPA3 CNV",
    "RPA3 RNA",
    "RPA3 Proteo"
  ],
  "ZCCHC17": [
    "ZCCHC17 CNV",
    "ZCCHC17 RNA",
    "ZCCHC17 Proteo"
  ],
  "THG1L": [
    "THG1L CNV",
    "THG1L RNA",
    "THG1L Proteo"
  ],
  "SPARCL1": [
    "SPARCL1 CNV",
    "SPARCL1 RNA",
    "SPARCL1 Proteo"
  ],
  "ACTN1": [
    "ACTN1 CNV",
    "ACTN1 RNA",
    "ACTN1 Proteo"
  ],
  "CFAP298": [
    "CFAP298 CNV",
    "CFAP298 RNA",
    "CFAP298 Proteo"
  ],
  "OR10W1": [
    "OR10W1 CNV",
    "OR10W1 RNA"
  ],
  "NUTF2P7": [
    "NUTF2P7 CNV",
    "NUTF2P7 RNA"
  ],
  "MTND4LP25": [
    "MTND4LP25 CNV",
    "MTND4LP25 RNA"
  ],
  "CAMTA2": [
    "CAMTA2 CNV",
    "CAMTA2 RNA",
    "CAMTA2 Proteo"
  ],
  "ENKUR": [
    "ENKUR CNV",
    "ENKUR RNA"
  ],
  "DBIP1": [
    "DBIP1 CNV",
    "DBIP1 RNA"
  ],
  "RBMY2XP": [
    "RBMY2XP CNV",
    "RBMY2XP RNA"
  ],
  "ACP7": [
    "ACP7 CNV",
    "ACP7 RNA"
  ],
  "TRIM14": [
    "TRIM14 CNV",
    "TRIM14 RNA",
    "TRIM14 Proteo"
  ],
  "CCRL2": [
    "CCRL2 CNV",
    "CCRL2 RNA"
  ],
  "CPXCR1": [
    "CPXCR1 CNV",
    "CPXCR1 RNA"
  ],
  "NCK1": [
    "NCK1 CNV",
    "NCK1 RNA",
    "NCK1 Proteo"
  ],
  "C20orf141": [
    "C20orf141 CNV",
    "C20orf141 RNA"
  ],
  "FLNB": [
    "FLNB CNV",
    "FLNB RNA",
    "FLNB Proteo"
  ],
  "ARL2BPP7": [
    "ARL2BPP7 CNV",
    "ARL2BPP7 RNA"
  ],
  "WWP2": [
    "WWP2 CNV",
    "WWP2 RNA",
    "WWP2 Proteo"
  ],
  "OR11A1": [
    "OR11A1 CNV",
    "OR11A1 RNA"
  ],
  "TESK2": [
    "TESK2 CNV",
    "TESK2 RNA",
    "TESK2 Proteo"
  ],
  "SENP8": [
    "SENP8 CNV",
    "SENP8 RNA",
    "SENP8 Proteo"
  ],
  "ECMXP": [
    "ECMXP CNV",
    "ECMXP RNA"
  ],
  "SYCE1L": [
    "SYCE1L CNV",
    "SYCE1L RNA"
  ],
  "RPL15P4": [
    "RPL15P4 CNV",
    "RPL15P4 RNA"
  ],
  "KRTAP9-1": [
    "KRTAP9-1 CNV",
    "KRTAP9-1 RNA"
  ],
  "ARSL": [
    "ARSL CNV",
    "ARSL RNA",
    "ARSL Proteo"
  ],
  "COPS5": [
    "COPS5 CNV",
    "COPS5 RNA",
    "COPS5 Proteo"
  ],
  "TM2D3": [
    "TM2D3 CNV",
    "TM2D3 RNA",
    "TM2D3 Proteo"
  ],
  "RNF220": [
    "RNF220 CNV",
    "RNF220 RNA",
    "RNF220 Proteo"
  ],
  "ATP6V1C1": [
    "ATP6V1C1 CNV",
    "ATP6V1C1 RNA",
    "ATP6V1C1 Proteo"
  ],
  "CEACAMP3": [
    "CEACAMP3 CNV",
    "CEACAMP3 RNA"
  ],
  "TCEANC2": [
    "TCEANC2 CNV",
    "TCEANC2 RNA",
    "TCEANC2 Proteo"
  ],
  "TEX2": [
    "TEX2 CNV",
    "TEX2 RNA",
    "TEX2 Proteo"
  ],
  "DDX19B": [
    "DDX19B CNV",
    "DDX19B RNA",
    "DDX19B Proteo"
  ],
  "RPS12P17": [
    "RPS12P17 CNV",
    "RPS12P17 RNA"
  ],
  "GCOM1": [
    "GCOM1 CNV",
    "GCOM1 RNA"
  ],
  "EFNA5": [
    "EFNA5 CNV",
    "EFNA5 RNA"
  ],
  "SAP18P2": [
    "SAP18P2 CNV",
    "SAP18P2 RNA"
  ],
  "FCGR2A": [
    "FCGR2A CNV",
    "FCGR2A RNA",
    "FCGR2A Proteo"
  ],
  "OR4K11P": [
    "OR4K11P CNV",
    "OR4K11P RNA"
  ],
  "RYR1": [
    "RYR1 CNV",
    "RYR1 RNA",
    "RYR1 Proteo"
  ],
  "HMGN2P17": [
    "HMGN2P17 CNV",
    "HMGN2P17 RNA"
  ],
  "RPL12P43": [
    "RPL12P43 CNV",
    "RPL12P43 RNA"
  ],
  "DYNLT5": [
    "DYNLT5 CNV",
    "DYNLT5 RNA"
  ],
  "CLEC4E": [
    "CLEC4E CNV",
    "CLEC4E RNA"
  ],
  "MTND3P18": [
    "MTND3P18 CNV",
    "MTND3P18 RNA"
  ],
  "CABP5": [
    "CABP5 CNV",
    "CABP5 RNA"
  ],
  "SPRR2E": [
    "SPRR2E CNV",
    "SPRR2E RNA"
  ],
  "RPL23AP14": [
    "RPL23AP14 CNV",
    "RPL23AP14 RNA"
  ],
  "FOXB2": [
    "FOXB2 CNV",
    "FOXB2 RNA"
  ],
  "MEX3C": [
    "MEX3C CNV",
    "MEX3C RNA",
    "MEX3C Proteo"
  ],
  "ZNF132": [
    "ZNF132 CNV",
    "ZNF132 RNA"
  ],
  "VN1R35P": [
    "VN1R35P CNV",
    "VN1R35P RNA"
  ],
  "CYSTM1": [
    "CYSTM1 CNV",
    "CYSTM1 RNA",
    "CYSTM1 Proteo"
  ],
  "CRYGB": [
    "CRYGB CNV",
    "CRYGB RNA"
  ],
  "OR8G1": [
    "OR8G1 CNV",
    "OR8G1 RNA"
  ],
  "NKX2-6": [
    "NKX2-6 CNV",
    "NKX2-6 RNA"
  ],
  "PPIAP86": [
    "PPIAP86 CNV",
    "PPIAP86 RNA"
  ],
  "HRK": [
    "HRK CNV",
    "HRK RNA"
  ],
  "CELSR1P1": [
    "CELSR1P1 CNV",
    "CELSR1P1 RNA"
  ],
  "GALNT15": [
    "GALNT15 CNV",
    "GALNT15 RNA"
  ],
  "VGLL2": [
    "VGLL2 CNV",
    "VGLL2 RNA"
  ],
  "SLC5A1": [
    "SLC5A1 CNV",
    "SLC5A1 RNA"
  ],
  "GSDMA": [
    "GSDMA CNV",
    "GSDMA RNA",
    "GSDMA Proteo"
  ],
  "LRRC4B": [
    "LRRC4B CNV",
    "LRRC4B RNA",
    "LRRC4B Proteo"
  ],
  "FAM221A": [
    "FAM221A CNV",
    "FAM221A RNA",
    "FAM221A Proteo"
  ],
  "NCAPG2": [
    "NCAPG2 CNV",
    "NCAPG2 RNA",
    "NCAPG2 Proteo"
  ],
  "LBR": [
    "LBR CNV",
    "LBR RNA",
    "LBR Proteo"
  ],
  "TMEM132C": [
    "TMEM132C CNV",
    "TMEM132C RNA"
  ],
  "NUMA1": [
    "NUMA1 CNV",
    "NUMA1 RNA",
    "NUMA1 Proteo"
  ],
  "TMEM123": [
    "TMEM123 CNV",
    "TMEM123 RNA",
    "TMEM123 Proteo"
  ],
  "NUP37": [
    "NUP37 CNV",
    "NUP37 RNA",
    "NUP37 Proteo"
  ],
  "DPY19L4P1": [
    "DPY19L4P1 CNV",
    "DPY19L4P1 RNA"
  ],
  "TCP11X2": [
    "TCP11X2 CNV",
    "TCP11X2 RNA"
  ],
  "NAP1L4P2": [
    "NAP1L4P2 CNV",
    "NAP1L4P2 RNA"
  ],
  "CNOT6": [
    "CNOT6 CNV",
    "CNOT6 RNA",
    "CNOT6 Proteo"
  ],
  "OR5M7P": [
    "OR5M7P CNV",
    "OR5M7P RNA"
  ],
  "RAB26": [
    "RAB26 CNV",
    "RAB26 RNA"
  ],
  "EXOC8": [
    "EXOC8 CNV",
    "EXOC8 RNA",
    "EXOC8 Proteo"
  ],
  "ZPBP2": [
    "ZPBP2 CNV",
    "ZPBP2 RNA"
  ],
  "OPTN": [
    "OPTN CNV",
    "OPTN RNA",
    "OPTN Proteo"
  ],
  "CEP70": [
    "CEP70 CNV",
    "CEP70 RNA"
  ],
  "PIRT": [
    "PIRT CNV",
    "PIRT RNA"
  ],
  "NOX4": [
    "NOX4 CNV",
    "NOX4 RNA"
  ],
  "RPL22P14": [
    "RPL22P14 CNV",
    "RPL22P14 RNA"
  ],
  "IFT122": [
    "IFT122 CNV",
    "IFT122 RNA",
    "IFT122 Proteo"
  ],
  "MRPL27": [
    "MRPL27 CNV",
    "MRPL27 RNA",
    "MRPL27 Proteo"
  ],
  "TMEM212": [
    "TMEM212 CNV",
    "TMEM212 RNA"
  ],
  "HMGB1P40": [
    "HMGB1P40 CNV",
    "HMGB1P40 RNA"
  ],
  "PTF1A": [
    "PTF1A CNV",
    "PTF1A RNA"
  ],
  "NBEAL1": [
    "NBEAL1 CNV",
    "NBEAL1 RNA",
    "NBEAL1 Proteo"
  ],
  "SPEF2": [
    "SPEF2 CNV",
    "SPEF2 RNA"
  ],
  "USP17L30": [
    "USP17L30 CNV",
    "USP17L30 RNA"
  ],
  "SRD5A2P1": [
    "SRD5A2P1 CNV",
    "SRD5A2P1 RNA"
  ],
  "RPL21P75": [
    "RPL21P75 CNV",
    "RPL21P75 RNA"
  ],
  "DUS4L": [
    "DUS4L CNV",
    "DUS4L RNA"
  ],
  "NIFKP7": [
    "NIFKP7 CNV",
    "NIFKP7 RNA"
  ],
  "CBX4": [
    "CBX4 CNV",
    "CBX4 RNA",
    "CBX4 Proteo"
  ],
  "IFIT1": [
    "IFIT1 CNV",
    "IFIT1 RNA",
    "IFIT1 Proteo"
  ],
  "MEAK7": [
    "MEAK7 CNV",
    "MEAK7 RNA",
    "MEAK7 Proteo"
  ],
  "MTND4LP16": [
    "MTND4LP16 CNV",
    "MTND4LP16 RNA"
  ],
  "FTLP12": [
    "FTLP12 CNV",
    "FTLP12 RNA"
  ],
  "CCT2": [
    "CCT2 CNV",
    "CCT2 RNA",
    "CCT2 Proteo"
  ],
  "GPR89P": [
    "GPR89P CNV",
    "GPR89P RNA"
  ],
  "KLHL31": [
    "KLHL31 CNV",
    "KLHL31 RNA",
    "KLHL31 Proteo"
  ],
  "PSMA6": [
    "PSMA6 CNV",
    "PSMA6 RNA",
    "PSMA6 Proteo"
  ],
  "HSD17B8": [
    "HSD17B8 CNV",
    "HSD17B8 RNA",
    "HSD17B8 Proteo"
  ],
  "B9D2": [
    "B9D2 CNV",
    "B9D2 RNA",
    "B9D2 Proteo"
  ],
  "TRIM42": [
    "TRIM42 CNV",
    "TRIM42 RNA"
  ],
  "SETMAR": [
    "SETMAR CNV",
    "SETMAR RNA",
    "SETMAR Proteo"
  ],
  "EFNA3": [
    "EFNA3 CNV",
    "EFNA3 RNA"
  ],
  "SDHDP3": [
    "SDHDP3 CNV",
    "SDHDP3 RNA"
  ],
  "UNGP3": [
    "UNGP3 CNV",
    "UNGP3 RNA"
  ],
  "RNF146": [
    "RNF146 CNV",
    "RNF146 RNA",
    "RNF146 Proteo"
  ],
  "RPS2P48": [
    "RPS2P48 CNV",
    "RPS2P48 RNA"
  ],
  "CMPK1": [
    "CMPK1 CNV",
    "CMPK1 RNA",
    "CMPK1 Proteo"
  ],
  "RPA2": [
    "RPA2 CNV",
    "RPA2 RNA",
    "RPA2 Proteo"
  ],
  "CRIP1P3": [
    "CRIP1P3 CNV",
    "CRIP1P3 RNA"
  ],
  "ALG1L13P": [
    "ALG1L13P CNV",
    "ALG1L13P RNA"
  ],
  "DCAF12L2": [
    "DCAF12L2 CNV",
    "DCAF12L2 RNA"
  ],
  "EZHIP": [
    "EZHIP CNV",
    "EZHIP RNA"
  ],
  "SMIM6": [
    "SMIM6 CNV",
    "SMIM6 RNA"
  ],
  "AP4S1": [
    "AP4S1 CNV",
    "AP4S1 RNA",
    "AP4S1 Proteo"
  ],
  "SOWAHCP5": [
    "SOWAHCP5 CNV",
    "SOWAHCP5 RNA"
  ],
  "RSRP1": [
    "RSRP1 CNV",
    "RSRP1 RNA"
  ],
  "OSM": [
    "OSM CNV",
    "OSM RNA"
  ],
  "KBTBD7": [
    "KBTBD7 CNV",
    "KBTBD7 RNA",
    "KBTBD7 Proteo"
  ],
  "HIGD1AP3": [
    "HIGD1AP3 CNV",
    "HIGD1AP3 RNA"
  ],
  "LIMS2": [
    "LIMS2 CNV",
    "LIMS2 RNA",
    "LIMS2 Proteo"
  ],
  "OR5AR1": [
    "OR5AR1 CNV",
    "OR5AR1 RNA"
  ],
  "ARHGEF2": [
    "ARHGEF2 CNV",
    "ARHGEF2 RNA",
    "ARHGEF2 Proteo"
  ],
  "OR7E12P": [
    "OR7E12P CNV",
    "OR7E12P RNA"
  ],
  "L1CAM": [
    "L1CAM CNV",
    "L1CAM RNA",
    "L1CAM Proteo"
  ],
  "GCNA": [
    "GCNA CNV",
    "GCNA RNA"
  ],
  "CBL": [
    "CBL CNV",
    "CBL RNA",
    "CBL Proteo"
  ],
  "ELOC": [
    "ELOC CNV",
    "ELOC RNA",
    "ELOC Proteo"
  ],
  "KIF4CP": [
    "KIF4CP CNV",
    "KIF4CP RNA"
  ],
  "STC2": [
    "STC2 CNV",
    "STC2 RNA",
    "STC2 Proteo"
  ],
  "TPSB2": [
    "TPSB2 CNV",
    "TPSB2 RNA",
    "TPSB2 Proteo"
  ],
  "VN1R92P": [
    "VN1R92P CNV",
    "VN1R92P RNA"
  ],
  "TFGP1": [
    "TFGP1 CNV",
    "TFGP1 RNA"
  ],
  "LINC00869": [
    "LINC00869 CNV",
    "LINC00869 RNA"
  ],
  "LINC02210": [
    "LINC02210 CNV",
    "LINC02210 RNA"
  ],
  "ATXN2L": [
    "ATXN2L CNV",
    "ATXN2L RNA",
    "ATXN2L Proteo"
  ],
  "TRIML1": [
    "TRIML1 CNV",
    "TRIML1 RNA"
  ],
  "SLC12A3": [
    "SLC12A3 CNV",
    "SLC12A3 RNA"
  ],
  "OSBPL7": [
    "OSBPL7 CNV",
    "OSBPL7 RNA",
    "OSBPL7 Proteo"
  ],
  "SNRPGP4": [
    "SNRPGP4 CNV",
    "SNRPGP4 RNA"
  ],
  "TBXAS1": [
    "TBXAS1 CNV",
    "TBXAS1 RNA",
    "TBXAS1 Proteo"
  ],
  "MPHOSPH10P9": [
    "MPHOSPH10P9 CNV",
    "MPHOSPH10P9 RNA"
  ],
  "IGHV1-68": [
    "IGHV1-68 CNV",
    "IGHV1-68 RNA"
  ],
  "RPS17P13": [
    "RPS17P13 CNV",
    "RPS17P13 RNA"
  ],
  "ATG4D": [
    "ATG4D CNV",
    "ATG4D RNA",
    "ATG4D Proteo"
  ],
  "MPV17L2P1": [
    "MPV17L2P1 CNV",
    "MPV17L2P1 RNA"
  ],
  "ADRB3": [
    "ADRB3 CNV",
    "ADRB3 RNA"
  ],
  "UGCG": [
    "UGCG CNV",
    "UGCG RNA",
    "UGCG Proteo"
  ],
  "NOTCH3": [
    "NOTCH3 CNV",
    "NOTCH3 RNA",
    "NOTCH3 Proteo"
  ],
  "RCC2P8": [
    "RCC2P8 CNV",
    "RCC2P8 RNA"
  ],
  "RPAIN": [
    "RPAIN CNV",
    "RPAIN RNA",
    "RPAIN Proteo"
  ],
  "RPL12P40": [
    "RPL12P40 CNV",
    "RPL12P40 RNA"
  ],
  "DNAAF11": [
    "DNAAF11 CNV",
    "DNAAF11 RNA"
  ],
  "FAM90A21P": [
    "FAM90A21P CNV",
    "FAM90A21P RNA"
  ],
  "TRAPPC9": [
    "TRAPPC9 CNV",
    "TRAPPC9 RNA",
    "TRAPPC9 Proteo"
  ],
  "SH2B2": [
    "SH2B2 CNV",
    "SH2B2 RNA",
    "SH2B2 Proteo"
  ],
  "RNA5SP261": [
    "RNA5SP261 CNV",
    "RNA5SP261 RNA"
  ],
  "ADRA1A": [
    "ADRA1A CNV",
    "ADRA1A RNA"
  ],
  "EIF1AD": [
    "EIF1AD CNV",
    "EIF1AD RNA",
    "EIF1AD Proteo"
  ],
  "ARMC5": [
    "ARMC5 CNV",
    "ARMC5 RNA",
    "ARMC5 Proteo"
  ],
  "CAPZB": [
    "CAPZB CNV",
    "CAPZB RNA",
    "CAPZB Proteo"
  ],
  "SLC20A1P3": [
    "SLC20A1P3 CNV",
    "SLC20A1P3 RNA"
  ],
  "NPIPB10P": [
    "NPIPB10P CNV",
    "NPIPB10P RNA"
  ],
  "SOX2": [
    "SOX2 CNV",
    "SOX2 RNA",
    "SOX2 Proteo"
  ],
  "RPS26P48": [
    "RPS26P48 CNV",
    "RPS26P48 RNA"
  ],
  "PCDH8P1": [
    "PCDH8P1 CNV",
    "PCDH8P1 RNA"
  ],
  "RPS17P15": [
    "RPS17P15 CNV",
    "RPS17P15 RNA"
  ],
  "ELF3": [
    "ELF3 CNV",
    "ELF3 RNA",
    "ELF3 Proteo"
  ],
  "SLC35G3": [
    "SLC35G3 CNV",
    "SLC35G3 RNA"
  ],
  "PRAMEF26": [
    "PRAMEF26 CNV",
    "PRAMEF26 RNA"
  ],
  "PRRC1": [
    "PRRC1 CNV",
    "PRRC1 RNA",
    "PRRC1 Proteo"
  ],
  "RNA5SP451": [
    "RNA5SP451 CNV",
    "RNA5SP451 RNA"
  ],
  "CDV3": [
    "CDV3 CNV",
    "CDV3 RNA",
    "CDV3 Proteo"
  ],
  "GBAP1": [
    "GBAP1 CNV",
    "GBAP1 RNA"
  ],
  "DENND4B": [
    "DENND4B CNV",
    "DENND4B RNA",
    "DENND4B Proteo"
  ],
  "RPL23AP4": [
    "RPL23AP4 CNV",
    "RPL23AP4 RNA"
  ],
  "CTSG": [
    "CTSG CNV",
    "CTSG RNA",
    "CTSG Proteo"
  ],
  "C8orf33": [
    "C8orf33 CNV",
    "C8orf33 RNA",
    "C8orf33 Proteo"
  ],
  "ATP1B3P1": [
    "ATP1B3P1 CNV",
    "ATP1B3P1 RNA"
  ],
  "ACOT8": [
    "ACOT8 CNV",
    "ACOT8 RNA",
    "ACOT8 Proteo"
  ],
  "OR4F14P": [
    "OR4F14P CNV",
    "OR4F14P RNA"
  ],
  "SUCLA2": [
    "SUCLA2 CNV",
    "SUCLA2 RNA",
    "SUCLA2 Proteo"
  ],
  "IFI30": [
    "IFI30 CNV",
    "IFI30 RNA",
    "IFI30 Proteo"
  ],
  "ATP5MGL": [
    "ATP5MGL CNV",
    "ATP5MGL RNA"
  ],
  "STAM": [
    "STAM CNV",
    "STAM RNA",
    "STAM Proteo"
  ],
  "TP53TG3HP": [
    "TP53TG3HP CNV",
    "TP53TG3HP RNA"
  ],
  "HS6ST1P1": [
    "HS6ST1P1 CNV",
    "HS6ST1P1 RNA"
  ],
  "ATXN7L3B": [
    "ATXN7L3B CNV",
    "ATXN7L3B RNA",
    "ATXN7L3B Proteo"
  ],
  "DSEL": [
    "DSEL CNV",
    "DSEL RNA"
  ],
  "RHOBTB3": [
    "RHOBTB3 CNV",
    "RHOBTB3 RNA",
    "RHOBTB3 Proteo"
  ],
  "SEC24D": [
    "SEC24D CNV",
    "SEC24D RNA",
    "SEC24D Proteo"
  ],
  "RNFT1P2": [
    "RNFT1P2 CNV",
    "RNFT1P2 RNA"
  ],
  "IGFBPL1": [
    "IGFBPL1 CNV",
    "IGFBPL1 RNA"
  ],
  "RNA5SP441": [
    "RNA5SP441 CNV",
    "RNA5SP441 RNA"
  ],
  "LRRC77P": [
    "LRRC77P CNV",
    "LRRC77P RNA"
  ],
  "CD164L2": [
    "CD164L2 CNV",
    "CD164L2 RNA"
  ],
  "SFRP2": [
    "SFRP2 CNV",
    "SFRP2 RNA",
    "SFRP2 Proteo"
  ],
  "ADGRL1": [
    "ADGRL1 CNV",
    "ADGRL1 RNA",
    "ADGRL1 Proteo"
  ],
  "SMAP1": [
    "SMAP1 CNV",
    "SMAP1 RNA",
    "SMAP1 Proteo"
  ],
  "ADAM19": [
    "ADAM19 CNV",
    "ADAM19 RNA",
    "ADAM19 Proteo"
  ],
  "CELA2A": [
    "CELA2A CNV",
    "CELA2A RNA"
  ],
  "IL18R1": [
    "IL18R1 CNV",
    "IL18R1 RNA",
    "IL18R1 Proteo"
  ],
  "CENPUP1": [
    "CENPUP1 CNV",
    "CENPUP1 RNA"
  ],
  "DNAJC5G": [
    "DNAJC5G CNV",
    "DNAJC5G RNA"
  ],
  "CTSK": [
    "CTSK CNV",
    "CTSK RNA",
    "CTSK Proteo"
  ],
  "TAX1BP3": [
    "TAX1BP3 CNV",
    "TAX1BP3 RNA",
    "TAX1BP3 Proteo"
  ],
  "CSTF2": [
    "CSTF2 CNV",
    "CSTF2 RNA",
    "CSTF2 Proteo"
  ],
  "OR4U1P": [
    "OR4U1P CNV",
    "OR4U1P RNA"
  ],
  "BTBD1": [
    "BTBD1 CNV",
    "BTBD1 RNA",
    "BTBD1 Proteo"
  ],
  "SGTB": [
    "SGTB CNV",
    "SGTB RNA",
    "SGTB Proteo"
  ],
  "TEX10": [
    "TEX10 CNV",
    "TEX10 RNA",
    "TEX10 Proteo"
  ],
  "IGLV8-61": [
    "IGLV8-61 Proteo"
  ],
  "FOXA2": [
    "FOXA2 CNV",
    "FOXA2 RNA"
  ],
  "OR2AS2P": [
    "OR2AS2P CNV",
    "OR2AS2P RNA"
  ],
  "BANF1P2": [
    "BANF1P2 CNV",
    "BANF1P2 RNA"
  ],
  "GRM5": [
    "GRM5 CNV",
    "GRM5 RNA"
  ],
  "SPINK9": [
    "SPINK9 CNV",
    "SPINK9 RNA"
  ],
  "TRIM60P8Y": [
    "TRIM60P8Y CNV",
    "TRIM60P8Y RNA"
  ],
  "OR6C5P": [
    "OR6C5P CNV",
    "OR6C5P RNA"
  ],
  "KPNB1P1": [
    "KPNB1P1 CNV",
    "KPNB1P1 RNA"
  ],
  "GAPDHP75": [
    "GAPDHP75 CNV",
    "GAPDHP75 RNA"
  ],
  "MARK2P12": [
    "MARK2P12 CNV",
    "MARK2P12 RNA"
  ],
  "NME4": [
    "NME4 CNV",
    "NME4 RNA",
    "NME4 Proteo"
  ],
  "NBEAP6": [
    "NBEAP6 CNV",
    "NBEAP6 RNA"
  ],
  "SLC22A4": [
    "SLC22A4 CNV",
    "SLC22A4 RNA"
  ],
  "SPDYE20P": [
    "SPDYE20P CNV",
    "SPDYE20P RNA"
  ],
  "PPP2CA": [
    "PPP2CA CNV",
    "PPP2CA RNA"
  ],
  "RPL7AP65": [
    "RPL7AP65 CNV",
    "RPL7AP65 RNA"
  ],
  "RPL21P4": [
    "RPL21P4 CNV",
    "RPL21P4 RNA"
  ],
  "XPO1": [
    "XPO1 CNV",
    "XPO1 RNA",
    "XPO1 Proteo"
  ],
  "NUTF2P8": [
    "NUTF2P8 CNV",
    "NUTF2P8 RNA"
  ],
  "TSPAN18": [
    "TSPAN18 CNV",
    "TSPAN18 RNA",
    "TSPAN18 Proteo"
  ],
  "KRTAP10-11": [
    "KRTAP10-11 CNV",
    "KRTAP10-11 RNA"
  ],
  "BRI3P2": [
    "BRI3P2 CNV",
    "BRI3P2 RNA"
  ],
  "DAB1": [
    "DAB1 CNV",
    "DAB1 RNA"
  ],
  "GTF2A2": [
    "GTF2A2 CNV",
    "GTF2A2 RNA",
    "GTF2A2 Proteo"
  ],
  "ZFYVE1": [
    "ZFYVE1 CNV",
    "ZFYVE1 RNA",
    "ZFYVE1 Proteo"
  ],
  "NDUFA11": [
    "NDUFA11 CNV",
    "NDUFA11 RNA",
    "NDUFA11 Proteo"
  ],
  "RPL5P17": [
    "RPL5P17 CNV",
    "RPL5P17 RNA"
  ],
  "PLSCR2": [
    "PLSCR2 CNV",
    "PLSCR2 RNA"
  ],
  "GJD3": [
    "GJD3 CNV",
    "GJD3 RNA"
  ],
  "ZNF852": [
    "ZNF852 CNV",
    "ZNF852 RNA",
    "ZNF852 Proteo"
  ],
  "PTRHD1": [
    "PTRHD1 CNV",
    "PTRHD1 RNA",
    "PTRHD1 Proteo"
  ],
  "APOE": [
    "APOE CNV",
    "APOE RNA",
    "APOE Proteo"
  ],
  "ATP2B3": [
    "ATP2B3 CNV",
    "ATP2B3 RNA",
    "ATP2B3 Proteo"
  ],
  "HMOX2": [
    "HMOX2 CNV",
    "HMOX2 RNA",
    "HMOX2 Proteo"
  ],
  "NCLP2": [
    "NCLP2 CNV",
    "NCLP2 RNA"
  ],
  "ETS2": [
    "ETS2 CNV",
    "ETS2 RNA"
  ],
  "VMA21": [
    "VMA21 CNV",
    "VMA21 RNA",
    "VMA21 Proteo"
  ],
  "RAB30": [
    "RAB30 CNV",
    "RAB30 RNA",
    "RAB30 Proteo"
  ],
  "APRT": [
    "APRT CNV",
    "APRT RNA",
    "APRT Proteo"
  ],
  "FAM120A": [
    "FAM120A CNV",
    "FAM120A RNA",
    "FAM120A Proteo"
  ],
  "RAP1A": [
    "RAP1A CNV",
    "RAP1A RNA",
    "RAP1A Proteo"
  ],
  "RAMP2": [
    "RAMP2 CNV",
    "RAMP2 RNA",
    "RAMP2 Proteo"
  ],
  "TPT1": [
    "TPT1 CNV",
    "TPT1 RNA",
    "TPT1 Proteo"
  ],
  "SKA1": [
    "SKA1 CNV",
    "SKA1 RNA",
    "SKA1 Proteo"
  ],
  "EIF4EBP2P3": [
    "EIF4EBP2P3 CNV",
    "EIF4EBP2P3 RNA"
  ],
  "PRAMEF5": [
    "PRAMEF5 CNV",
    "PRAMEF5 RNA"
  ],
  "RPS20P14": [
    "RPS20P14 CNV",
    "RPS20P14 RNA"
  ],
  "HSP90AB7P": [
    "HSP90AB7P CNV",
    "HSP90AB7P RNA"
  ],
  "RNA5SP218": [
    "RNA5SP218 CNV",
    "RNA5SP218 RNA"
  ],
  "AWAT2": [
    "AWAT2 CNV",
    "AWAT2 RNA",
    "AWAT2 Proteo"
  ],
  "CLCA2": [
    "CLCA2 CNV",
    "CLCA2 RNA"
  ],
  "KLRC1": [
    "KLRC1 CNV",
    "KLRC1 RNA"
  ],
  "ZNF582": [
    "ZNF582 CNV",
    "ZNF582 RNA"
  ],
  "FAM95B1": [
    "FAM95B1 CNV",
    "FAM95B1 RNA"
  ],
  "RNF130": [
    "RNF130 CNV",
    "RNF130 RNA",
    "RNF130 Proteo"
  ],
  "PSMA3": [
    "PSMA3 CNV",
    "PSMA3 RNA",
    "PSMA3 Proteo"
  ],
  "RHBDL2": [
    "RHBDL2 CNV",
    "RHBDL2 RNA"
  ],
  "GNB3": [
    "GNB3 CNV",
    "GNB3 RNA",
    "GNB3 Proteo"
  ],
  "STMN2": [
    "STMN2 CNV",
    "STMN2 RNA"
  ],
  "CDHR1": [
    "CDHR1 CNV",
    "CDHR1 RNA"
  ],
  "ZNF123P": [
    "ZNF123P CNV",
    "ZNF123P RNA"
  ],
  "ZNF777": [
    "ZNF777 CNV",
    "ZNF777 RNA",
    "ZNF777 Proteo"
  ],
  "ARID1B": [
    "ARID1B CNV",
    "ARID1B RNA",
    "ARID1B Proteo"
  ],
  "COL9A3": [
    "COL9A3 CNV",
    "COL9A3 RNA"
  ],
  "SOX10": [
    "SOX10 CNV",
    "SOX10 RNA",
    "SOX10 Proteo"
  ],
  "PRPF40B": [
    "PRPF40B CNV",
    "PRPF40B RNA",
    "PRPF40B Proteo"
  ],
  "GDPD1": [
    "GDPD1 CNV",
    "GDPD1 RNA",
    "GDPD1 Proteo"
  ],
  "H2AC9P": [
    "H2AC9P CNV",
    "H2AC9P RNA"
  ],
  "NPM1P18": [
    "NPM1P18 CNV",
    "NPM1P18 RNA"
  ],
  "HIKESHI": [
    "HIKESHI CNV",
    "HIKESHI RNA",
    "HIKESHI Proteo"
  ],
  "CDKN2B": [
    "CDKN2B CNV",
    "CDKN2B RNA",
    "CDKN2B Proteo"
  ],
  "SPINK7": [
    "SPINK7 CNV",
    "SPINK7 RNA"
  ],
  "MAP3K7CL": [
    "MAP3K7CL CNV",
    "MAP3K7CL RNA"
  ],
  "ZNF527": [
    "ZNF527 CNV",
    "ZNF527 RNA"
  ],
  "HNRNPCP4": [
    "HNRNPCP4 CNV",
    "HNRNPCP4 RNA"
  ],
  "OR4A48P": [
    "OR4A48P CNV",
    "OR4A48P RNA"
  ],
  "OR2R1P": [
    "OR2R1P CNV",
    "OR2R1P RNA"
  ],
  "LNX1": [
    "LNX1 CNV",
    "LNX1 RNA"
  ],
  "IGLVI-63": [
    "IGLVI-63 CNV",
    "IGLVI-63 RNA"
  ],
  "UTY": [
    "UTY CNV",
    "UTY RNA",
    "UTY Proteo"
  ],
  "FAM149B1P1": [
    "FAM149B1P1 CNV",
    "FAM149B1P1 RNA"
  ],
  "YTHDF2P1": [
    "YTHDF2P1 CNV",
    "YTHDF2P1 RNA"
  ],
  "RPL7AP11": [
    "RPL7AP11 CNV",
    "RPL7AP11 RNA"
  ],
  "GREP1": [
    "GREP1 CNV",
    "GREP1 RNA"
  ],
  "MYC": [
    "MYC CNV",
    "MYC RNA"
  ],
  "H3-3A": [
    "H3-3A CNV",
    "H3-3A RNA",
    "H3-3A Proteo"
  ],
  "CHCHD3P3": [
    "CHCHD3P3 CNV",
    "CHCHD3P3 RNA"
  ],
  "ATP5PDP1": [
    "ATP5PDP1 CNV",
    "ATP5PDP1 RNA"
  ],
  "TLN2": [
    "TLN2 CNV",
    "TLN2 RNA",
    "TLN2 Proteo"
  ],
  "IQCD": [
    "IQCD CNV",
    "IQCD RNA"
  ],
  "RBMX2P4": [
    "RBMX2P4 CNV",
    "RBMX2P4 RNA"
  ],
  "PDCL3P4": [
    "PDCL3P4 CNV",
    "PDCL3P4 RNA"
  ],
  "PMF1": [
    "PMF1 CNV",
    "PMF1 RNA",
    "PMF1 Proteo"
  ],
  "LDB3": [
    "LDB3 CNV",
    "LDB3 RNA",
    "LDB3 Proteo"
  ],
  "C2orf69P2": [
    "C2orf69P2 CNV",
    "C2orf69P2 RNA"
  ],
  "AKAP10": [
    "AKAP10 CNV",
    "AKAP10 RNA",
    "AKAP10 Proteo"
  ],
  "SIGLEC31P": [
    "SIGLEC31P CNV",
    "SIGLEC31P RNA"
  ],
  "SUMO2P8": [
    "SUMO2P8 CNV",
    "SUMO2P8 RNA"
  ],
  "RUSC2": [
    "RUSC2 CNV",
    "RUSC2 RNA",
    "RUSC2 Proteo"
  ],
  "EBF2": [
    "EBF2 CNV",
    "EBF2 RNA"
  ],
  "FZD9": [
    "FZD9 CNV",
    "FZD9 RNA"
  ],
  "CTSO": [
    "CTSO CNV",
    "CTSO RNA",
    "CTSO Proteo"
  ],
  "FERMT3": [
    "FERMT3 CNV",
    "FERMT3 RNA",
    "FERMT3 Proteo"
  ],
  "UBE2E3": [
    "UBE2E3 CNV",
    "UBE2E3 RNA",
    "UBE2E3 Proteo"
  ],
  "SKP2": [
    "SKP2 CNV",
    "SKP2 RNA",
    "SKP2 Proteo"
  ],
  "CYP2A13": [
    "CYP2A13 CNV",
    "CYP2A13 RNA"
  ],
  "MAPK6": [
    "MAPK6 CNV",
    "MAPK6 RNA",
    "MAPK6 Proteo"
  ],
  "CITED2": [
    "CITED2 CNV",
    "CITED2 RNA"
  ],
  "OR10D1P": [
    "OR10D1P CNV",
    "OR10D1P RNA"
  ],
  "FARS2": [
    "FARS2 CNV",
    "FARS2 RNA",
    "FARS2 Proteo"
  ],
  "SLC38A3": [
    "SLC38A3 CNV",
    "SLC38A3 RNA"
  ],
  "SNX2": [
    "SNX2 CNV",
    "SNX2 RNA",
    "SNX2 Proteo"
  ],
  "FBXL4": [
    "FBXL4 CNV",
    "FBXL4 RNA",
    "FBXL4 Proteo"
  ],
  "SAGSIN1": [
    "SAGSIN1 CNV",
    "SAGSIN1 RNA"
  ],
  "RNA5SP413": [
    "RNA5SP413 CNV",
    "RNA5SP413 RNA"
  ],
  "MYSM1": [
    "MYSM1 CNV",
    "MYSM1 RNA",
    "MYSM1 Proteo"
  ],
  "OR5G1P": [
    "OR5G1P CNV",
    "OR5G1P RNA"
  ],
  "SLC6A14P2": [
    "SLC6A14P2 CNV",
    "SLC6A14P2 RNA"
  ],
  "DNAH3": [
    "DNAH3 CNV",
    "DNAH3 RNA",
    "DNAH3 Proteo"
  ],
  "OR2M4": [
    "OR2M4 CNV",
    "OR2M4 RNA"
  ],
  "ECM1P2": [
    "ECM1P2 CNV",
    "ECM1P2 RNA"
  ],
  "CADM3": [
    "CADM3 CNV",
    "CADM3 RNA",
    "CADM3 Proteo"
  ],
  "USP8": [
    "USP8 CNV",
    "USP8 RNA",
    "USP8 Proteo"
  ],
  "PCDHB12": [
    "PCDHB12 CNV",
    "PCDHB12 RNA"
  ],
  "DAB2": [
    "DAB2 CNV",
    "DAB2 RNA",
    "DAB2 Proteo"
  ],
  "NGEF": [
    "NGEF CNV",
    "NGEF RNA",
    "NGEF Proteo"
  ],
  "OR11G1P": [
    "OR11G1P CNV",
    "OR11G1P RNA"
  ],
  "CLEC20A": [
    "CLEC20A CNV",
    "CLEC20A RNA"
  ],
  "ZNF347": [
    "ZNF347 CNV",
    "ZNF347 RNA"
  ],
  "PCNPP4": [
    "PCNPP4 CNV",
    "PCNPP4 RNA"
  ],
  "MEFV": [
    "MEFV CNV",
    "MEFV RNA",
    "MEFV Proteo"
  ],
  "MTCO2P8": [
    "MTCO2P8 CNV",
    "MTCO2P8 RNA"
  ],
  "NT5C3B": [
    "NT5C3B CNV",
    "NT5C3B RNA",
    "NT5C3B Proteo"
  ],
  "RPL29": [
    "RPL29 CNV",
    "RPL29 RNA",
    "RPL29 Proteo"
  ],
  "NUTF2P4": [
    "NUTF2P4 CNV",
    "NUTF2P4 RNA"
  ],
  "RPL37P15": [
    "RPL37P15 CNV",
    "RPL37P15 RNA"
  ],
  "ITGB3BP": [
    "ITGB3BP CNV",
    "ITGB3BP RNA",
    "ITGB3BP Proteo"
  ],
  "SNRPCP4": [
    "SNRPCP4 CNV",
    "SNRPCP4 RNA"
  ],
  "CCSER1": [
    "CCSER1 CNV",
    "CCSER1 RNA"
  ],
  "RNA5SP461": [
    "RNA5SP461 CNV",
    "RNA5SP461 RNA"
  ],
  "GLI4": [
    "GLI4 CNV",
    "GLI4 RNA",
    "GLI4 Proteo"
  ],
  "GAREM2": [
    "GAREM2 CNV",
    "GAREM2 RNA"
  ],
  "TUBB6": [
    "TUBB6 CNV",
    "TUBB6 RNA",
    "TUBB6 Proteo"
  ],
  "IARS2": [
    "IARS2 CNV",
    "IARS2 RNA",
    "IARS2 Proteo"
  ],
  "TNFRSF11B": [
    "TNFRSF11B CNV",
    "TNFRSF11B RNA"
  ],
  "NOX5_ENSG00000290203": [
    "NOX5_ENSG00000290203 RNA"
  ],
  "ABCF3": [
    "ABCF3 CNV",
    "ABCF3 RNA",
    "ABCF3 Proteo"
  ],
  "LEMD1": [
    "LEMD1 CNV",
    "LEMD1 RNA"
  ],
  "P4HA3": [
    "P4HA3 CNV",
    "P4HA3 RNA",
    "P4HA3 Proteo"
  ],
  "RFX7": [
    "RFX7 CNV",
    "RFX7 RNA",
    "RFX7 Proteo"
  ],
  "TTC1": [
    "TTC1 CNV",
    "TTC1 RNA",
    "TTC1 Proteo"
  ],
  "MAGI1": [
    "MAGI1 CNV",
    "MAGI1 RNA",
    "MAGI1 Proteo"
  ],
  "CUPIN1P": [
    "CUPIN1P CNV",
    "CUPIN1P RNA"
  ],
  "CYP4V2": [
    "CYP4V2 CNV",
    "CYP4V2 RNA",
    "CYP4V2 Proteo"
  ],
  "GPR161": [
    "GPR161 CNV",
    "GPR161 RNA",
    "GPR161 Proteo"
  ],
  "LCEP3": [
    "LCEP3 CNV",
    "LCEP3 RNA"
  ],
  "SLCO5A1": [
    "SLCO5A1 CNV",
    "SLCO5A1 RNA"
  ],
  "MTATP6P13": [
    "MTATP6P13 CNV",
    "MTATP6P13 RNA"
  ],
  "KCTD10": [
    "KCTD10 CNV",
    "KCTD10 RNA",
    "KCTD10 Proteo"
  ],
  "CDC42EP1": [
    "CDC42EP1 CNV",
    "CDC42EP1 RNA",
    "CDC42EP1 Proteo"
  ],
  "RBMY2BP": [
    "RBMY2BP CNV",
    "RBMY2BP RNA"
  ],
  "NUMB": [
    "NUMB CNV",
    "NUMB RNA",
    "NUMB Proteo"
  ],
  "OR13C3": [
    "OR13C3 CNV",
    "OR13C3 RNA"
  ],
  "TYSND1": [
    "TYSND1 CNV",
    "TYSND1 RNA",
    "TYSND1 Proteo"
  ],
  "ZNF695": [
    "ZNF695 CNV",
    "ZNF695 RNA"
  ],
  "INHBE": [
    "INHBE CNV",
    "INHBE RNA"
  ],
  "SP110": [
    "SP110 CNV",
    "SP110 RNA",
    "SP110 Proteo"
  ],
  "OR9K1P": [
    "OR9K1P CNV",
    "OR9K1P RNA"
  ],
  "ANKRD42": [
    "ANKRD42 CNV",
    "ANKRD42 RNA"
  ],
  "CICP6": [
    "CICP6 CNV",
    "CICP6 RNA"
  ],
  "TPD52L2": [
    "TPD52L2 CNV",
    "TPD52L2 RNA",
    "TPD52L2 Proteo"
  ],
  "FAM183A": [
    "FAM183A CNV",
    "FAM183A RNA"
  ],
  "DDX55": [
    "DDX55 CNV",
    "DDX55 RNA",
    "DDX55 Proteo"
  ],
  "ITCH": [
    "ITCH CNV",
    "ITCH RNA",
    "ITCH Proteo"
  ],
  "WFDC6": [
    "WFDC6 CNV",
    "WFDC6 RNA"
  ],
  "POM121L12": [
    "POM121L12 CNV",
    "POM121L12 RNA"
  ],
  "UQCR10P1": [
    "UQCR10P1 CNV",
    "UQCR10P1 RNA"
  ],
  "NKX2-8": [
    "NKX2-8 CNV",
    "NKX2-8 RNA"
  ],
  "MRPS2": [
    "MRPS2 CNV",
    "MRPS2 RNA",
    "MRPS2 Proteo"
  ],
  "SMIM15": [
    "SMIM15 CNV",
    "SMIM15 RNA",
    "SMIM15 Proteo"
  ],
  "TATDN2P2": [
    "TATDN2P2 CNV",
    "TATDN2P2 RNA"
  ],
  "PSMD7P1": [
    "PSMD7P1 CNV",
    "PSMD7P1 RNA"
  ],
  "HADHBP1": [
    "HADHBP1 CNV",
    "HADHBP1 RNA"
  ],
  "GAPDHP37": [
    "GAPDHP37 CNV",
    "GAPDHP37 RNA"
  ],
  "SAMM50P1": [
    "SAMM50P1 CNV",
    "SAMM50P1 RNA"
  ],
  "STAT1": [
    "STAT1 CNV",
    "STAT1 RNA",
    "STAT1 Proteo"
  ],
  "RPS15AP24": [
    "RPS15AP24 CNV",
    "RPS15AP24 RNA"
  ],
  "ACTRT3": [
    "ACTRT3 CNV",
    "ACTRT3 RNA"
  ],
  "NKX6-1": [
    "NKX6-1 CNV",
    "NKX6-1 RNA"
  ],
  "CCNI2": [
    "CCNI2 CNV",
    "CCNI2 RNA"
  ],
  "PIP5K1A": [
    "PIP5K1A CNV",
    "PIP5K1A RNA",
    "PIP5K1A Proteo"
  ],
  "SNRPEP3": [
    "SNRPEP3 CNV",
    "SNRPEP3 RNA"
  ],
  "DGKD": [
    "DGKD CNV",
    "DGKD RNA",
    "DGKD Proteo"
  ],
  "RPS16P9": [
    "RPS16P9 CNV",
    "RPS16P9 RNA"
  ],
  "TBX3": [
    "TBX3 CNV",
    "TBX3 RNA",
    "TBX3 Proteo"
  ],
  "PRAMEF31P": [
    "PRAMEF31P CNV",
    "PRAMEF31P RNA"
  ],
  "CD320": [
    "CD320 CNV",
    "CD320 RNA",
    "CD320 Proteo"
  ],
  "RPL18AP17": [
    "RPL18AP17 CNV",
    "RPL18AP17 RNA"
  ],
  "VSIG2": [
    "VSIG2 CNV",
    "VSIG2 RNA"
  ],
  "GMFBP1": [
    "GMFBP1 CNV",
    "GMFBP1 RNA"
  ],
  "KRT8P22": [
    "KRT8P22 CNV",
    "KRT8P22 RNA"
  ],
  "SLC35A5": [
    "SLC35A5 CNV",
    "SLC35A5 RNA",
    "SLC35A5 Proteo"
  ],
  "UQCRFS1P2": [
    "UQCRFS1P2 CNV",
    "UQCRFS1P2 RNA"
  ],
  "KNOP1P2": [
    "KNOP1P2 CNV",
    "KNOP1P2 RNA"
  ],
  "CPED1": [
    "CPED1 CNV",
    "CPED1 RNA"
  ],
  "HK2": [
    "HK2 CNV",
    "HK2 RNA",
    "HK2 Proteo"
  ],
  "C4orf17": [
    "C4orf17 CNV",
    "C4orf17 RNA"
  ],
  "THAP12P6": [
    "THAP12P6 CNV",
    "THAP12P6 RNA"
  ],
  "OR8L1P": [
    "OR8L1P CNV",
    "OR8L1P RNA"
  ],
  "TREM1": [
    "TREM1 CNV",
    "TREM1 RNA",
    "TREM1 Proteo"
  ],
  "EIF4A1P8": [
    "EIF4A1P8 CNV",
    "EIF4A1P8 RNA"
  ],
  "TMPOP1": [
    "TMPOP1 CNV",
    "TMPOP1 RNA"
  ],
  "RPL13P": [
    "RPL13P CNV",
    "RPL13P RNA"
  ],
  "HNRNPRP2": [
    "HNRNPRP2 CNV",
    "HNRNPRP2 RNA"
  ],
  "LSP1P1": [
    "LSP1P1 CNV",
    "LSP1P1 RNA"
  ],
  "PDE2A": [
    "PDE2A CNV",
    "PDE2A RNA",
    "PDE2A Proteo"
  ],
  "SREK1IP1P2": [
    "SREK1IP1P2 CNV",
    "SREK1IP1P2 RNA"
  ],
  "SAE1": [
    "SAE1 CNV",
    "SAE1 RNA",
    "SAE1 Proteo"
  ],
  "NPIPA7": [
    "NPIPA7 CNV",
    "NPIPA7 RNA"
  ],
  "RAP2B": [
    "RAP2B CNV",
    "RAP2B RNA",
    "RAP2B Proteo"
  ],
  "B2M": [
    "B2M CNV",
    "B2M RNA",
    "B2M Proteo"
  ],
  "WNT2B": [
    "WNT2B CNV",
    "WNT2B RNA",
    "WNT2B Proteo"
  ],
  "MXD1": [
    "MXD1 CNV",
    "MXD1 RNA"
  ],
  "CSF3R": [
    "CSF3R CNV",
    "CSF3R RNA"
  ],
  "PDZK1IP1": [
    "PDZK1IP1 CNV",
    "PDZK1IP1 RNA",
    "PDZK1IP1 Proteo"
  ],
  "MORN4": [
    "MORN4 CNV",
    "MORN4 RNA"
  ],
  "RPL21P50": [
    "RPL21P50 CNV",
    "RPL21P50 RNA"
  ],
  "GMDS": [
    "GMDS CNV",
    "GMDS RNA",
    "GMDS Proteo"
  ],
  "NPFF": [
    "NPFF CNV",
    "NPFF RNA"
  ],
  "ETS1": [
    "ETS1 CNV",
    "ETS1 RNA",
    "ETS1 Proteo"
  ],
  "KIAA1586": [
    "KIAA1586 CNV",
    "KIAA1586 RNA",
    "KIAA1586 Proteo"
  ],
  "CHMP3": [
    "CHMP3 CNV",
    "CHMP3 RNA",
    "CHMP3 Proteo"
  ],
  "ACADSB": [
    "ACADSB CNV",
    "ACADSB RNA",
    "ACADSB Proteo"
  ],
  "TOM1L1": [
    "TOM1L1 CNV",
    "TOM1L1 RNA",
    "TOM1L1 Proteo"
  ],
  "EDEM3": [
    "EDEM3 CNV",
    "EDEM3 RNA",
    "EDEM3 Proteo"
  ],
  "RNF10": [
    "RNF10 CNV",
    "RNF10 RNA",
    "RNF10 Proteo"
  ],
  "AGKP2": [
    "AGKP2 CNV",
    "AGKP2 RNA"
  ],
  "SRCIN1": [
    "SRCIN1 CNV",
    "SRCIN1 RNA",
    "SRCIN1 Proteo"
  ],
  "GMPPA": [
    "GMPPA CNV",
    "GMPPA RNA",
    "GMPPA Proteo"
  ],
  "ITIH4": [
    "ITIH4 CNV",
    "ITIH4 RNA",
    "ITIH4 Proteo"
  ],
  "CNOT8": [
    "CNOT8 CNV",
    "CNOT8 RNA",
    "CNOT8 Proteo"
  ],
  "ETNK2": [
    "ETNK2 CNV",
    "ETNK2 RNA",
    "ETNK2 Proteo"
  ],
  "AASDHPPT": [
    "AASDHPPT CNV",
    "AASDHPPT RNA",
    "AASDHPPT Proteo"
  ],
  "PLGLB1": [
    "PLGLB1 CNV",
    "PLGLB1 RNA"
  ],
  "COX5BP8": [
    "COX5BP8 CNV",
    "COX5BP8 RNA"
  ],
  "FGL1": [
    "FGL1 CNV",
    "FGL1 RNA"
  ],
  "NCKAP1": [
    "NCKAP1 CNV",
    "NCKAP1 RNA",
    "NCKAP1 Proteo"
  ],
  "CDC25C": [
    "CDC25C CNV",
    "CDC25C RNA",
    "CDC25C Proteo"
  ],
  "ARL2": [
    "ARL2 CNV",
    "ARL2 RNA",
    "ARL2 Proteo"
  ],
  "RIMKLBP2": [
    "RIMKLBP2 CNV",
    "RIMKLBP2 RNA"
  ],
  "ADGRE2": [
    "ADGRE2 CNV",
    "ADGRE2 RNA",
    "ADGRE2 Proteo"
  ],
  "PABPC1L2A": [
    "PABPC1L2A CNV",
    "PABPC1L2A RNA",
    "PABPC1L2A Proteo"
  ],
  "ITM2B": [
    "ITM2B CNV",
    "ITM2B RNA",
    "ITM2B Proteo"
  ],
  "PLGRKT": [
    "PLGRKT CNV",
    "PLGRKT RNA",
    "PLGRKT Proteo"
  ],
  "BIRC6": [
    "BIRC6 CNV",
    "BIRC6 RNA",
    "BIRC6 Proteo"
  ],
  "CTSLP4": [
    "CTSLP4 CNV",
    "CTSLP4 RNA"
  ],
  "NDUFA8": [
    "NDUFA8 CNV",
    "NDUFA8 RNA",
    "NDUFA8 Proteo"
  ],
  "RPL23AP92": [
    "RPL23AP92 CNV",
    "RPL23AP92 RNA"
  ],
  "TRIM51HP": [
    "TRIM51HP CNV",
    "TRIM51HP RNA"
  ],
  "ILF2P1": [
    "ILF2P1 CNV",
    "ILF2P1 RNA"
  ],
  "CICP14": [
    "CICP14 CNV",
    "CICP14 RNA"
  ],
  "CXCL2": [
    "CXCL2 CNV",
    "CXCL2 RNA"
  ],
  "FAXC": [
    "FAXC CNV",
    "FAXC RNA",
    "FAXC Proteo"
  ],
  "SRGAP2B": [
    "SRGAP2B CNV",
    "SRGAP2B RNA"
  ],
  "MTATP6P31": [
    "MTATP6P31 CNV",
    "MTATP6P31 RNA"
  ],
  "PTP4A3": [
    "PTP4A3 CNV",
    "PTP4A3 RNA",
    "PTP4A3 Proteo"
  ],
  "MCTP1": [
    "MCTP1 CNV",
    "MCTP1 RNA",
    "MCTP1 Proteo"
  ],
  "RPS27L": [
    "RPS27L CNV",
    "RPS27L RNA",
    "RPS27L Proteo"
  ],
  "FAM90A26": [
    "FAM90A26 CNV",
    "FAM90A26 RNA"
  ],
  "IL26": [
    "IL26 CNV",
    "IL26 RNA"
  ],
  "DHX9P1": [
    "DHX9P1 CNV",
    "DHX9P1 RNA"
  ],
  "FLOT2": [
    "FLOT2 CNV",
    "FLOT2 RNA",
    "FLOT2 Proteo"
  ],
  "HYDIN": [
    "HYDIN CNV",
    "HYDIN RNA"
  ],
  "TARM1": [
    "TARM1 CNV",
    "TARM1 RNA"
  ],
  "ACTBP6": [
    "ACTBP6 CNV",
    "ACTBP6 RNA"
  ],
  "SHBG": [
    "SHBG CNV",
    "SHBG RNA",
    "SHBG Proteo"
  ],
  "DIP2B": [
    "DIP2B CNV",
    "DIP2B RNA",
    "DIP2B Proteo"
  ],
  "SCD5": [
    "SCD5 CNV",
    "SCD5 RNA",
    "SCD5 Proteo"
  ],
  "GKN2": [
    "GKN2 CNV",
    "GKN2 RNA"
  ],
  "BLOC1S4": [
    "BLOC1S4 CNV",
    "BLOC1S4 RNA",
    "BLOC1S4 Proteo"
  ],
  "HMGB3P3": [
    "HMGB3P3 CNV",
    "HMGB3P3 RNA"
  ],
  "ZFP69": [
    "ZFP69 CNV",
    "ZFP69 RNA"
  ],
  "ZNF225": [
    "ZNF225 CNV",
    "ZNF225 RNA"
  ],
  "USP9YP14": [
    "USP9YP14 CNV",
    "USP9YP14 RNA"
  ],
  "POM121L6P": [
    "POM121L6P CNV",
    "POM121L6P RNA"
  ],
  "RPS7P10": [
    "RPS7P10 CNV",
    "RPS7P10 RNA"
  ],
  "LRRC4C": [
    "LRRC4C CNV",
    "LRRC4C RNA"
  ],
  "SLC39A13": [
    "SLC39A13 CNV",
    "SLC39A13 RNA"
  ],
  "PTK7": [
    "PTK7 CNV",
    "PTK7 RNA",
    "PTK7 Proteo"
  ],
  "PGM2L1": [
    "PGM2L1 CNV",
    "PGM2L1 RNA",
    "PGM2L1 Proteo"
  ],
  "NPM1P21": [
    "NPM1P21 CNV",
    "NPM1P21 RNA"
  ],
  "PPP1R11P1": [
    "PPP1R11P1 CNV",
    "PPP1R11P1 RNA"
  ],
  "HNRNPA0": [
    "HNRNPA0 CNV",
    "HNRNPA0 RNA",
    "HNRNPA0 Proteo"
  ],
  "TAF13": [
    "TAF13 CNV",
    "TAF13 RNA",
    "TAF13 Proteo"
  ],
  "IGLV1-40": [
    "IGLV1-40 Proteo"
  ],
  "ATP6V0E2": [
    "ATP6V0E2 CNV",
    "ATP6V0E2 RNA"
  ],
  "EBNA1BP2": [
    "EBNA1BP2 CNV",
    "EBNA1BP2 RNA",
    "EBNA1BP2 Proteo"
  ],
  "CLEC12B": [
    "CLEC12B CNV",
    "CLEC12B RNA"
  ],
  "EVI5": [
    "EVI5 CNV",
    "EVI5 RNA",
    "EVI5 Proteo"
  ],
  "OOSP4B": [
    "OOSP4B CNV",
    "OOSP4B RNA"
  ],
  "OR2T4": [
    "OR2T4 CNV",
    "OR2T4 RNA"
  ],
  "ANKRD55": [
    "ANKRD55 CNV",
    "ANKRD55 RNA"
  ],
  "CCNB3": [
    "CCNB3 CNV",
    "CCNB3 RNA"
  ],
  "FAM111A": [
    "FAM111A CNV",
    "FAM111A RNA",
    "FAM111A Proteo"
  ],
  "NDUFAF7": [
    "NDUFAF7 CNV",
    "NDUFAF7 RNA",
    "NDUFAF7 Proteo"
  ],
  "ITPRIP": [
    "ITPRIP CNV",
    "ITPRIP RNA",
    "ITPRIP Proteo"
  ],
  "SLC36A3": [
    "SLC36A3 CNV",
    "SLC36A3 RNA"
  ],
  "SMARCB1": [
    "SMARCB1 CNV",
    "SMARCB1 RNA",
    "SMARCB1 Proteo"
  ],
  "DHRS1": [
    "DHRS1 CNV",
    "DHRS1 RNA",
    "DHRS1 Proteo"
  ],
  "SNX19P3": [
    "SNX19P3 CNV",
    "SNX19P3 RNA"
  ],
  "OR7A2P": [
    "OR7A2P CNV",
    "OR7A2P RNA"
  ],
  "PRPF4": [
    "PRPF4 CNV",
    "PRPF4 RNA",
    "PRPF4 Proteo"
  ],
  "CALR4P": [
    "CALR4P CNV",
    "CALR4P RNA"
  ],
  "NOXRED1": [
    "NOXRED1 CNV",
    "NOXRED1 RNA"
  ],
  "ERBIN": [
    "ERBIN CNV",
    "ERBIN RNA",
    "ERBIN Proteo"
  ],
  "RAB37": [
    "RAB37 CNV",
    "RAB37 RNA",
    "RAB37 Proteo"
  ],
  "RPL31P59": [
    "RPL31P59 CNV",
    "RPL31P59 RNA"
  ],
  "CCNG2": [
    "CCNG2 CNV",
    "CCNG2 RNA"
  ],
  "EPHA7": [
    "EPHA7 CNV",
    "EPHA7 RNA"
  ],
  "RBMY2KP": [
    "RBMY2KP CNV",
    "RBMY2KP RNA"
  ],
  "TUBB8B": [
    "TUBB8B CNV",
    "TUBB8B RNA"
  ],
  "H2AC10P": [
    "H2AC10P CNV",
    "H2AC10P RNA"
  ],
  "OLFML2A": [
    "OLFML2A CNV",
    "OLFML2A RNA",
    "OLFML2A Proteo"
  ],
  "GOLGA8K": [
    "GOLGA8K CNV",
    "GOLGA8K RNA",
    "GOLGA8K Proteo"
  ],
  "TMBIM6": [
    "TMBIM6 CNV",
    "TMBIM6 RNA",
    "TMBIM6 Proteo"
  ],
  "RAB1AP2": [
    "RAB1AP2 CNV",
    "RAB1AP2 RNA"
  ],
  "WDR17": [
    "WDR17 CNV",
    "WDR17 RNA"
  ],
  "GADD45A": [
    "GADD45A CNV",
    "GADD45A RNA"
  ],
  "CCNB1IP1P1": [
    "CCNB1IP1P1 CNV",
    "CCNB1IP1P1 RNA"
  ],
  "OR7E10P": [
    "OR7E10P CNV",
    "OR7E10P RNA"
  ],
  "OR4A2P": [
    "OR4A2P CNV",
    "OR4A2P RNA"
  ],
  "RPL7AP12": [
    "RPL7AP12 CNV",
    "RPL7AP12 RNA"
  ],
  "SYT12": [
    "SYT12 CNV",
    "SYT12 RNA"
  ],
  "WDCP": [
    "WDCP CNV",
    "WDCP RNA",
    "WDCP Proteo"
  ],
  "VIRMA": [
    "VIRMA CNV",
    "VIRMA RNA",
    "VIRMA Proteo"
  ],
  "CDRT15P13": [
    "CDRT15P13 CNV",
    "CDRT15P13 RNA"
  ],
  "ANKRD20A17P": [
    "ANKRD20A17P CNV",
    "ANKRD20A17P RNA"
  ],
  "C12orf43": [
    "C12orf43 CNV",
    "C12orf43 RNA",
    "C12orf43 Proteo"
  ],
  "GCC2": [
    "GCC2 CNV",
    "GCC2 RNA",
    "GCC2 Proteo"
  ],
  "KCTD2": [
    "KCTD2 CNV",
    "KCTD2 RNA",
    "KCTD2 Proteo"
  ],
  "LGMN": [
    "LGMN CNV",
    "LGMN RNA",
    "LGMN Proteo"
  ],
  "NOS2P2": [
    "NOS2P2 CNV",
    "NOS2P2 RNA"
  ],
  "ELOCP31": [
    "ELOCP31 CNV",
    "ELOCP31 RNA"
  ],
  "FHL1": [
    "FHL1 CNV",
    "FHL1 RNA",
    "FHL1 Proteo"
  ],
  "ISG20L2": [
    "ISG20L2 CNV",
    "ISG20L2 RNA",
    "ISG20L2 Proteo"
  ],
  "YWHAZP1": [
    "YWHAZP1 CNV",
    "YWHAZP1 RNA"
  ],
  "ELOCP15": [
    "ELOCP15 CNV",
    "ELOCP15 RNA"
  ],
  "CLSTN2": [
    "CLSTN2 CNV",
    "CLSTN2 RNA"
  ],
  "RNF20": [
    "RNF20 CNV",
    "RNF20 RNA",
    "RNF20 Proteo"
  ],
  "KRTAP5-14P": [
    "KRTAP5-14P CNV",
    "KRTAP5-14P RNA"
  ],
  "MTRF1LP2": [
    "MTRF1LP2 CNV",
    "MTRF1LP2 RNA"
  ],
  "RAB43P1": [
    "RAB43P1 CNV",
    "RAB43P1 RNA"
  ],
  "KCNA7": [
    "KCNA7 CNV",
    "KCNA7 RNA"
  ],
  "WASH3P": [
    "WASH3P CNV",
    "WASH3P RNA"
  ],
  "HLA-DRB9": [
    "HLA-DRB9 CNV",
    "HLA-DRB9 RNA"
  ],
  "CNTNAP5": [
    "CNTNAP5 CNV",
    "CNTNAP5 RNA"
  ],
  "RRP36": [
    "RRP36 CNV",
    "RRP36 RNA",
    "RRP36 Proteo"
  ],
  "MYRF": [
    "MYRF CNV",
    "MYRF RNA",
    "MYRF Proteo"
  ],
  "RREB1": [
    "RREB1 CNV",
    "RREB1 RNA",
    "RREB1 Proteo"
  ],
  "H4C4": [
    "H4C4 CNV",
    "H4C4 RNA"
  ],
  "GXYLT1": [
    "GXYLT1 CNV",
    "GXYLT1 RNA",
    "GXYLT1 Proteo"
  ],
  "TMSB4XP8": [
    "TMSB4XP8 CNV",
    "TMSB4XP8 RNA"
  ],
  "ANKRD18EP": [
    "ANKRD18EP CNV",
    "ANKRD18EP RNA"
  ],
  "OR5W1P": [
    "OR5W1P CNV",
    "OR5W1P RNA"
  ],
  "PLIN2": [
    "PLIN2 CNV",
    "PLIN2 RNA",
    "PLIN2 Proteo"
  ],
  "TRH": [
    "TRH CNV",
    "TRH RNA"
  ],
  "RHBDF1P1": [
    "RHBDF1P1 CNV",
    "RHBDF1P1 RNA"
  ],
  "PRM2": [
    "PRM2 CNV",
    "PRM2 RNA"
  ],
  "KIAA0895LP1": [
    "KIAA0895LP1 CNV",
    "KIAA0895LP1 RNA"
  ],
  "KIF3B": [
    "KIF3B CNV",
    "KIF3B RNA",
    "KIF3B Proteo"
  ],
  "CDY22P": [
    "CDY22P CNV",
    "CDY22P RNA"
  ],
  "SNAPC5": [
    "SNAPC5 CNV",
    "SNAPC5 RNA",
    "SNAPC5 Proteo"
  ],
  "MTCO1P20": [
    "MTCO1P20 CNV",
    "MTCO1P20 RNA"
  ],
  "PTPN2P1": [
    "PTPN2P1 CNV",
    "PTPN2P1 RNA"
  ],
  "TMEM63A": [
    "TMEM63A CNV",
    "TMEM63A RNA",
    "TMEM63A Proteo"
  ],
  "SSTR5": [
    "SSTR5 CNV",
    "SSTR5 RNA"
  ],
  "HNRNPA1P57": [
    "HNRNPA1P57 CNV",
    "HNRNPA1P57 RNA"
  ],
  "GGTA2P": [
    "GGTA2P CNV",
    "GGTA2P RNA"
  ],
  "ILDR2": [
    "ILDR2 CNV",
    "ILDR2 RNA"
  ],
  "KRT18P35": [
    "KRT18P35 CNV",
    "KRT18P35 RNA"
  ],
  "SNRPGP16": [
    "SNRPGP16 CNV",
    "SNRPGP16 RNA"
  ],
  "NUP35P2": [
    "NUP35P2 CNV",
    "NUP35P2 RNA"
  ],
  "MYOM1": [
    "MYOM1 CNV",
    "MYOM1 RNA",
    "MYOM1 Proteo"
  ],
  "ATG2B": [
    "ATG2B CNV",
    "ATG2B RNA",
    "ATG2B Proteo"
  ],
  "MRPS36": [
    "MRPS36 CNV",
    "MRPS36 RNA",
    "MRPS36 Proteo"
  ],
  "FKBP4P7": [
    "FKBP4P7 CNV",
    "FKBP4P7 RNA"
  ],
  "SLC25A41": [
    "SLC25A41 CNV",
    "SLC25A41 RNA"
  ],
  "MEP1AP1": [
    "MEP1AP1 CNV",
    "MEP1AP1 RNA"
  ],
  "SCNN1A": [
    "SCNN1A CNV",
    "SCNN1A RNA"
  ],
  "SLC22A25": [
    "SLC22A25 CNV",
    "SLC22A25 RNA",
    "SLC22A25 Proteo"
  ],
  "HNRNPA1P30": [
    "HNRNPA1P30 CNV",
    "HNRNPA1P30 RNA"
  ],
  "BCAN": [
    "BCAN CNV",
    "BCAN RNA",
    "BCAN Proteo"
  ],
  "WBP1LP12": [
    "WBP1LP12 CNV",
    "WBP1LP12 RNA"
  ],
  "OPA3": [
    "OPA3 CNV",
    "OPA3 RNA",
    "OPA3 Proteo"
  ],
  "HLA-W": [
    "HLA-W CNV",
    "HLA-W RNA"
  ],
  "RPL7P11": [
    "RPL7P11 CNV",
    "RPL7P11 RNA"
  ],
  "RTF2": [
    "RTF2 CNV",
    "RTF2 RNA",
    "RTF2 Proteo"
  ],
  "GRAMD1B": [
    "GRAMD1B CNV",
    "GRAMD1B RNA",
    "GRAMD1B Proteo"
  ],
  "POLR3GP2": [
    "POLR3GP2 CNV",
    "POLR3GP2 RNA"
  ],
  "HOXC13": [
    "HOXC13 CNV",
    "HOXC13 RNA"
  ],
  "NCAM2": [
    "NCAM2 CNV",
    "NCAM2 RNA",
    "NCAM2 Proteo"
  ],
  "TMUB2": [
    "TMUB2 CNV",
    "TMUB2 RNA",
    "TMUB2 Proteo"
  ],
  "GRHL3": [
    "GRHL3 CNV",
    "GRHL3 RNA"
  ],
  "PRDM8": [
    "PRDM8 CNV",
    "PRDM8 RNA"
  ],
  "MTCO2P33": [
    "MTCO2P33 CNV",
    "MTCO2P33 RNA"
  ],
  "USP17L4": [
    "USP17L4 CNV",
    "USP17L4 RNA"
  ],
  "MCFD2P1": [
    "MCFD2P1 CNV",
    "MCFD2P1 RNA"
  ],
  "MT1G": [
    "MT1G CNV",
    "MT1G RNA"
  ],
  "ETV4": [
    "ETV4 CNV",
    "ETV4 RNA",
    "ETV4 Proteo"
  ],
  "RSL24D1P4": [
    "RSL24D1P4 CNV",
    "RSL24D1P4 RNA"
  ],
  "POPDC2": [
    "POPDC2 CNV",
    "POPDC2 RNA",
    "POPDC2 Proteo"
  ],
  "NPEPL1": [
    "NPEPL1 CNV",
    "NPEPL1 RNA",
    "NPEPL1 Proteo"
  ],
  "HMGB1": [
    "HMGB1 CNV",
    "HMGB1 RNA",
    "HMGB1 Proteo"
  ],
  "B4GALNT1": [
    "B4GALNT1 CNV",
    "B4GALNT1 RNA",
    "B4GALNT1 Proteo"
  ],
  "MYT1L": [
    "MYT1L CNV",
    "MYT1L RNA",
    "MYT1L Proteo"
  ],
  "TCL1B": [
    "TCL1B CNV",
    "TCL1B RNA"
  ],
  "DDX4": [
    "DDX4 CNV",
    "DDX4 RNA"
  ],
  "DNAH7": [
    "DNAH7 CNV",
    "DNAH7 RNA",
    "DNAH7 Proteo"
  ],
  "OR2H2": [
    "OR2H2 CNV",
    "OR2H2 RNA"
  ],
  "TPTE2": [
    "TPTE2 CNV",
    "TPTE2 RNA"
  ],
  "TMEM131L": [
    "TMEM131L CNV",
    "TMEM131L RNA",
    "TMEM131L Proteo"
  ],
  "STAP2": [
    "STAP2 CNV",
    "STAP2 RNA",
    "STAP2 Proteo"
  ],
  "CDK4P1": [
    "CDK4P1 CNV",
    "CDK4P1 RNA"
  ],
  "IKZF2": [
    "IKZF2 CNV",
    "IKZF2 RNA",
    "IKZF2 Proteo"
  ],
  "ZNF574": [
    "ZNF574 CNV",
    "ZNF574 RNA",
    "ZNF574 Proteo"
  ],
  "KYNU": [
    "KYNU CNV",
    "KYNU RNA",
    "KYNU Proteo"
  ],
  "SLC19A1": [
    "SLC19A1 CNV",
    "SLC19A1 RNA",
    "SLC19A1 Proteo"
  ],
  "PDZD7": [
    "PDZD7 CNV",
    "PDZD7 RNA"
  ],
  "OR1D5": [
    "OR1D5 CNV",
    "OR1D5 RNA"
  ],
  "TM9SF5P": [
    "TM9SF5P CNV",
    "TM9SF5P RNA"
  ],
  "CYP4F29P": [
    "CYP4F29P CNV",
    "CYP4F29P RNA"
  ],
  "SWAP70": [
    "SWAP70 CNV",
    "SWAP70 RNA",
    "SWAP70 Proteo"
  ],
  "PRAMEF25": [
    "PRAMEF25 CNV",
    "PRAMEF25 RNA"
  ],
  "ADAMTS10": [
    "ADAMTS10 CNV",
    "ADAMTS10 RNA"
  ],
  "DUX4L11": [
    "DUX4L11 CNV",
    "DUX4L11 RNA"
  ],
  "GAPDHP16": [
    "GAPDHP16 CNV",
    "GAPDHP16 RNA"
  ],
  "USP9YP36": [
    "USP9YP36 CNV",
    "USP9YP36 RNA"
  ],
  "EIF1P2": [
    "EIF1P2 CNV",
    "EIF1P2 RNA"
  ],
  "MS4A18": [
    "MS4A18 CNV",
    "MS4A18 RNA"
  ],
  "NFXL1": [
    "NFXL1 CNV",
    "NFXL1 RNA",
    "NFXL1 Proteo"
  ],
  "DLL1": [
    "DLL1 CNV",
    "DLL1 RNA"
  ],
  "ST14": [
    "ST14 CNV",
    "ST14 RNA",
    "ST14 Proteo"
  ],
  "KRT77": [
    "KRT77 CNV",
    "KRT77 RNA",
    "KRT77 Proteo"
  ],
  "GAPDHP15": [
    "GAPDHP15 CNV",
    "GAPDHP15 RNA"
  ],
  "TMED7": [
    "TMED7 CNV",
    "TMED7 RNA"
  ],
  "DDX28": [
    "DDX28 CNV",
    "DDX28 RNA",
    "DDX28 Proteo"
  ],
  "DNM1P24": [
    "DNM1P24 CNV",
    "DNM1P24 RNA"
  ],
  "UBL5P2": [
    "UBL5P2 CNV",
    "UBL5P2 RNA"
  ],
  "OTUD6B": [
    "OTUD6B CNV",
    "OTUD6B RNA",
    "OTUD6B Proteo"
  ],
  "ZMYM5": [
    "ZMYM5 CNV",
    "ZMYM5 RNA",
    "ZMYM5 Proteo"
  ],
  "SERPINH1P1": [
    "SERPINH1P1 CNV",
    "SERPINH1P1 RNA"
  ],
  "SLC16A6P1": [
    "SLC16A6P1 CNV",
    "SLC16A6P1 RNA"
  ],
  "OR1F12P": [
    "OR1F12P CNV",
    "OR1F12P RNA"
  ],
  "DDX39B": [
    "DDX39B CNV",
    "DDX39B RNA",
    "DDX39B Proteo"
  ],
  "CNEP1R1": [
    "CNEP1R1 CNV",
    "CNEP1R1 RNA",
    "CNEP1R1 Proteo"
  ],
  "FETUB": [
    "FETUB CNV",
    "FETUB RNA",
    "FETUB Proteo"
  ],
  "SLC35C2P1": [
    "SLC35C2P1 CNV",
    "SLC35C2P1 RNA"
  ],
  "RAB3IP": [
    "RAB3IP CNV",
    "RAB3IP RNA",
    "RAB3IP Proteo"
  ],
  "PCDHA12": [
    "PCDHA12 CNV",
    "PCDHA12 RNA"
  ],
  "ZNF137P": [
    "ZNF137P CNV",
    "ZNF137P RNA"
  ],
  "TAC1": [
    "TAC1 CNV",
    "TAC1 RNA"
  ],
  "PSG9": [
    "PSG9 CNV",
    "PSG9 RNA"
  ],
  "RAB5IF": [
    "RAB5IF CNV",
    "RAB5IF RNA",
    "RAB5IF Proteo"
  ],
  "DUSP7": [
    "DUSP7 CNV",
    "DUSP7 RNA"
  ],
  "HTR1E": [
    "HTR1E CNV",
    "HTR1E RNA"
  ],
  "RPL12P42": [
    "RPL12P42 CNV",
    "RPL12P42 RNA"
  ],
  "TMEM239": [
    "TMEM239 CNV",
    "TMEM239 RNA"
  ],
  "ZNF322P1": [
    "ZNF322P1 CNV",
    "ZNF322P1 RNA"
  ],
  "ZNF281": [
    "ZNF281 CNV",
    "ZNF281 RNA",
    "ZNF281 Proteo"
  ],
  "LRRN3": [
    "LRRN3 CNV",
    "LRRN3 RNA"
  ],
  "EDN3": [
    "EDN3 CNV",
    "EDN3 RNA",
    "EDN3 Proteo"
  ],
  "ACTR3BP3": [
    "ACTR3BP3 CNV",
    "ACTR3BP3 RNA"
  ],
  "CTSH": [
    "CTSH CNV",
    "CTSH RNA",
    "CTSH Proteo"
  ],
  "GPRIN2": [
    "GPRIN2 CNV",
    "GPRIN2 RNA"
  ],
  "RAF1P1": [
    "RAF1P1 CNV",
    "RAF1P1 RNA"
  ],
  "DAGLB": [
    "DAGLB CNV",
    "DAGLB RNA",
    "DAGLB Proteo"
  ],
  "BMP7": [
    "BMP7 CNV",
    "BMP7 RNA",
    "BMP7 Proteo"
  ],
  "ZNF736": [
    "ZNF736 CNV",
    "ZNF736 RNA"
  ],
  "GATA4": [
    "GATA4 CNV",
    "GATA4 RNA"
  ],
  "CFAP43": [
    "CFAP43 CNV",
    "CFAP43 RNA"
  ],
  "CBWD3": [
    "CBWD3 CNV",
    "CBWD3 RNA",
    "CBWD3 Proteo"
  ],
  "TRAPPC3L": [
    "TRAPPC3L CNV",
    "TRAPPC3L RNA"
  ],
  "YWHAZP8": [
    "YWHAZP8 CNV",
    "YWHAZP8 RNA"
  ],
  "ADAMTS15": [
    "ADAMTS15 CNV",
    "ADAMTS15 RNA"
  ],
  "CBLB": [
    "CBLB CNV",
    "CBLB RNA",
    "CBLB Proteo"
  ],
  "PDZRN4": [
    "PDZRN4 CNV",
    "PDZRN4 RNA"
  ],
  "IKZF4": [
    "IKZF4 CNV",
    "IKZF4 RNA"
  ],
  "HNRNPA1P6": [
    "HNRNPA1P6 CNV",
    "HNRNPA1P6 RNA"
  ],
  "NRBP1": [
    "NRBP1 CNV",
    "NRBP1 RNA",
    "NRBP1 Proteo"
  ],
  "DNAJC21": [
    "DNAJC21 CNV",
    "DNAJC21 RNA",
    "DNAJC21 Proteo"
  ],
  "RNA5SP77": [
    "RNA5SP77 CNV",
    "RNA5SP77 RNA"
  ],
  "RNF222": [
    "RNF222 CNV",
    "RNF222 RNA"
  ],
  "KBTBD6": [
    "KBTBD6 CNV",
    "KBTBD6 RNA",
    "KBTBD6 Proteo"
  ],
  "NBPF19": [
    "NBPF19 CNV",
    "NBPF19 RNA"
  ],
  "STT3B": [
    "STT3B CNV",
    "STT3B RNA",
    "STT3B Proteo"
  ],
  "TMEM97": [
    "TMEM97 CNV",
    "TMEM97 RNA",
    "TMEM97 Proteo"
  ],
  "PPM1D": [
    "PPM1D CNV",
    "PPM1D RNA",
    "PPM1D Proteo"
  ],
  "RPL3P1": [
    "RPL3P1 CNV",
    "RPL3P1 RNA"
  ],
  "HYAL3": [
    "HYAL3 CNV",
    "HYAL3 RNA"
  ],
  "USH2A": [
    "USH2A CNV",
    "USH2A RNA"
  ],
  "FHAD1": [
    "FHAD1 CNV",
    "FHAD1 RNA",
    "FHAD1 Proteo"
  ],
  "PPP1R14BP5": [
    "PPP1R14BP5 CNV",
    "PPP1R14BP5 RNA"
  ],
  "FAM9B": [
    "FAM9B CNV",
    "FAM9B RNA"
  ],
  "RPS27AP6": [
    "RPS27AP6 CNV",
    "RPS27AP6 RNA"
  ],
  "MS4A14": [
    "MS4A14 CNV",
    "MS4A14 RNA"
  ],
  "MAN1C1": [
    "MAN1C1 CNV",
    "MAN1C1 RNA",
    "MAN1C1 Proteo"
  ],
  "LHFPL2": [
    "LHFPL2 CNV",
    "LHFPL2 RNA",
    "LHFPL2 Proteo"
  ],
  "HES6": [
    "HES6 CNV",
    "HES6 RNA"
  ],
  "PSMB5": [
    "PSMB5 CNV",
    "PSMB5 RNA",
    "PSMB5 Proteo"
  ],
  "OBI1": [
    "OBI1 CNV",
    "OBI1 RNA",
    "OBI1 Proteo"
  ],
  "XPO4": [
    "XPO4 CNV",
    "XPO4 RNA",
    "XPO4 Proteo"
  ],
  "PGAM4P2": [
    "PGAM4P2 CNV",
    "PGAM4P2 RNA"
  ],
  "SLC38A5": [
    "SLC38A5 CNV",
    "SLC38A5 RNA",
    "SLC38A5 Proteo"
  ],
  "ZNF468": [
    "ZNF468 CNV",
    "ZNF468 RNA"
  ],
  "PGAM1P5": [
    "PGAM1P5 CNV",
    "PGAM1P5 RNA"
  ],
  "PWWP2A": [
    "PWWP2A CNV",
    "PWWP2A RNA",
    "PWWP2A Proteo"
  ],
  "ZUP1": [
    "ZUP1 CNV",
    "ZUP1 RNA"
  ],
  "CYP4F35P": [
    "CYP4F35P CNV",
    "CYP4F35P RNA"
  ],
  "FAM200B": [
    "FAM200B CNV",
    "FAM200B RNA"
  ],
  "STOM": [
    "STOM CNV",
    "STOM RNA",
    "STOM Proteo"
  ],
  "FGF9": [
    "FGF9 CNV",
    "FGF9 RNA"
  ],
  "IGHVII-62-1": [
    "IGHVII-62-1 CNV",
    "IGHVII-62-1 RNA"
  ],
  "CAPRIN1": [
    "CAPRIN1 CNV",
    "CAPRIN1 RNA",
    "CAPRIN1 Proteo"
  ],
  "OR13F1": [
    "OR13F1 CNV",
    "OR13F1 RNA"
  ],
  "STRIP2": [
    "STRIP2 CNV",
    "STRIP2 RNA",
    "STRIP2 Proteo"
  ],
  "SLC25A5P3": [
    "SLC25A5P3 CNV",
    "SLC25A5P3 RNA"
  ],
  "WASHC5": [
    "WASHC5 CNV",
    "WASHC5 RNA",
    "WASHC5 Proteo"
  ],
  "ZC3H8": [
    "ZC3H8 CNV",
    "ZC3H8 RNA",
    "ZC3H8 Proteo"
  ],
  "SLF1": [
    "SLF1 CNV",
    "SLF1 RNA",
    "SLF1 Proteo"
  ],
  "GRIK2": [
    "GRIK2 CNV",
    "GRIK2 RNA"
  ],
  "IPO9": [
    "IPO9 CNV",
    "IPO9 RNA",
    "IPO9 Proteo"
  ],
  "RSL24D1P1": [
    "RSL24D1P1 CNV",
    "RSL24D1P1 RNA"
  ],
  "IFITM4P": [
    "IFITM4P CNV",
    "IFITM4P RNA"
  ],
  "CICP15": [
    "CICP15 CNV",
    "CICP15 RNA"
  ],
  "OR2G2": [
    "OR2G2 CNV",
    "OR2G2 RNA"
  ],
  "EGLN2": [
    "EGLN2 CNV",
    "EGLN2 RNA",
    "EGLN2 Proteo"
  ],
  "OCSTAMP": [
    "OCSTAMP CNV",
    "OCSTAMP RNA"
  ],
  "NDE1": [
    "NDE1 CNV",
    "NDE1 RNA",
    "NDE1 Proteo"
  ],
  "IGHVIII-76-1": [
    "IGHVIII-76-1 CNV",
    "IGHVIII-76-1 RNA"
  ],
  "OR8K4P": [
    "OR8K4P CNV",
    "OR8K4P RNA"
  ],
  "GABRA1": [
    "GABRA1 CNV",
    "GABRA1 RNA"
  ],
  "TRIM29": [
    "TRIM29 CNV",
    "TRIM29 RNA",
    "TRIM29 Proteo"
  ],
  "GRIA3": [
    "GRIA3 CNV",
    "GRIA3 RNA"
  ],
  "HSPA6": [
    "HSPA6 CNV",
    "HSPA6 RNA",
    "HSPA6 Proteo"
  ],
  "PAPSS2": [
    "PAPSS2 CNV",
    "PAPSS2 RNA",
    "PAPSS2 Proteo"
  ],
  "GOT2P5": [
    "GOT2P5 CNV",
    "GOT2P5 RNA"
  ],
  "POLR1B": [
    "POLR1B CNV",
    "POLR1B RNA",
    "POLR1B Proteo"
  ],
  "POU2AF1": [
    "POU2AF1 CNV",
    "POU2AF1 RNA",
    "POU2AF1 Proteo"
  ],
  "ZFAND6P1": [
    "ZFAND6P1 CNV",
    "ZFAND6P1 RNA"
  ],
  "C1GALT1P3": [
    "C1GALT1P3 CNV",
    "C1GALT1P3 RNA"
  ],
  "NBN": [
    "NBN CNV",
    "NBN RNA",
    "NBN Proteo"
  ],
  "FRG1KP": [
    "FRG1KP CNV",
    "FRG1KP RNA"
  ],
  "SRBD1": [
    "SRBD1 CNV",
    "SRBD1 RNA",
    "SRBD1 Proteo"
  ],
  "ISM1": [
    "ISM1 CNV",
    "ISM1 RNA"
  ],
  "GAPDHP61": [
    "GAPDHP61 CNV",
    "GAPDHP61 RNA"
  ],
  "RNA5SP93": [
    "RNA5SP93 CNV",
    "RNA5SP93 RNA"
  ],
  "DYNLT3P1": [
    "DYNLT3P1 CNV",
    "DYNLT3P1 RNA"
  ],
  "PSME2P2": [
    "PSME2P2 CNV",
    "PSME2P2 RNA"
  ],
  "NUDT19P3": [
    "NUDT19P3 CNV",
    "NUDT19P3 RNA"
  ],
  "CGB1": [
    "CGB1 CNV",
    "CGB1 RNA"
  ],
  "CCT5P1": [
    "CCT5P1 CNV",
    "CCT5P1 RNA"
  ],
  "LETM2": [
    "LETM2 CNV",
    "LETM2 RNA"
  ],
  "AIFM1P1": [
    "AIFM1P1 CNV",
    "AIFM1P1 RNA"
  ],
  "CEP68": [
    "CEP68 CNV",
    "CEP68 RNA",
    "CEP68 Proteo"
  ],
  "GMPR": [
    "GMPR CNV",
    "GMPR RNA",
    "GMPR Proteo"
  ],
  "FAM136DP": [
    "FAM136DP CNV",
    "FAM136DP RNA"
  ],
  "HNRNPCL1": [
    "HNRNPCL1 CNV",
    "HNRNPCL1 RNA",
    "HNRNPCL1 Proteo"
  ],
  "PNMA6F": [
    "PNMA6F CNV",
    "PNMA6F RNA"
  ],
  "ZNF862": [
    "ZNF862 CNV",
    "ZNF862 RNA",
    "ZNF862 Proteo"
  ],
  "ZFYVE9": [
    "ZFYVE9 CNV",
    "ZFYVE9 RNA",
    "ZFYVE9 Proteo"
  ],
  "LARGE2": [
    "LARGE2 CNV",
    "LARGE2 RNA"
  ],
  "SNX10": [
    "SNX10 CNV",
    "SNX10 RNA",
    "SNX10 Proteo"
  ],
  "YPEL5": [
    "YPEL5 CNV",
    "YPEL5 RNA",
    "YPEL5 Proteo"
  ],
  "PRR23C": [
    "PRR23C CNV",
    "PRR23C RNA"
  ],
  "FTLP10": [
    "FTLP10 CNV",
    "FTLP10 RNA"
  ],
  "PTPN14": [
    "PTPN14 CNV",
    "PTPN14 RNA",
    "PTPN14 Proteo"
  ],
  "RNASE7": [
    "RNASE7 CNV",
    "RNASE7 RNA",
    "RNASE7 Proteo"
  ],
  "DUT": [
    "DUT CNV",
    "DUT RNA",
    "DUT Proteo"
  ],
  "MTND5P41": [
    "MTND5P41 CNV",
    "MTND5P41 RNA"
  ],
  "MECOM": [
    "MECOM CNV",
    "MECOM RNA"
  ],
  "DNM1L": [
    "DNM1L CNV",
    "DNM1L RNA",
    "DNM1L Proteo"
  ],
  "IGDCC3": [
    "IGDCC3 CNV",
    "IGDCC3 RNA"
  ],
  "LRP11": [
    "LRP11 CNV",
    "LRP11 RNA",
    "LRP11 Proteo"
  ],
  "ILF3": [
    "ILF3 CNV",
    "ILF3 RNA",
    "ILF3 Proteo"
  ],
  "NRG2": [
    "NRG2 CNV",
    "NRG2 RNA"
  ],
  "SNRPGP12": [
    "SNRPGP12 CNV",
    "SNRPGP12 RNA"
  ],
  "EXOSC6": [
    "EXOSC6 CNV",
    "EXOSC6 RNA",
    "EXOSC6 Proteo"
  ],
  "RAB28P4": [
    "RAB28P4 CNV",
    "RAB28P4 RNA"
  ],
  "SYF2": [
    "SYF2 CNV",
    "SYF2 RNA",
    "SYF2 Proteo"
  ],
  "EIF3FP3": [
    "EIF3FP3 CNV",
    "EIF3FP3 RNA"
  ],
  "PTPN13": [
    "PTPN13 CNV",
    "PTPN13 RNA",
    "PTPN13 Proteo"
  ],
  "KRT8P10": [
    "KRT8P10 CNV",
    "KRT8P10 RNA"
  ],
  "SPDYE7P": [
    "SPDYE7P CNV",
    "SPDYE7P RNA"
  ],
  "RNA5SP325": [
    "RNA5SP325 CNV",
    "RNA5SP325 RNA"
  ],
  "TIRAP": [
    "TIRAP CNV",
    "TIRAP RNA",
    "TIRAP Proteo"
  ],
  "SYP": [
    "SYP CNV",
    "SYP RNA",
    "SYP Proteo"
  ],
  "BNIP3P37": [
    "BNIP3P37 CNV",
    "BNIP3P37 RNA"
  ],
  "PTPN20CP": [
    "PTPN20CP CNV",
    "PTPN20CP RNA"
  ],
  "ZNF479": [
    "ZNF479 CNV",
    "ZNF479 RNA"
  ],
  "NUFIP1": [
    "NUFIP1 CNV",
    "NUFIP1 RNA",
    "NUFIP1 Proteo"
  ],
  "PMS2P7": [
    "PMS2P7 CNV",
    "PMS2P7 RNA"
  ],
  "PRR23D3P": [
    "PRR23D3P CNV",
    "PRR23D3P RNA"
  ],
  "GDAP2": [
    "GDAP2 CNV",
    "GDAP2 RNA",
    "GDAP2 Proteo"
  ],
  "CNKSR1": [
    "CNKSR1 CNV",
    "CNKSR1 RNA",
    "CNKSR1 Proteo"
  ],
  "AGBL4": [
    "AGBL4 CNV",
    "AGBL4 RNA"
  ],
  "OR11H2": [
    "OR11H2 CNV",
    "OR11H2 RNA"
  ],
  "TOMM34": [
    "TOMM34 CNV",
    "TOMM34 RNA",
    "TOMM34 Proteo"
  ],
  "EDEM1": [
    "EDEM1 CNV",
    "EDEM1 RNA",
    "EDEM1 Proteo"
  ],
  "PMM2P2": [
    "PMM2P2 CNV",
    "PMM2P2 RNA"
  ],
  "RPL23AP42": [
    "RPL23AP42 CNV",
    "RPL23AP42 RNA"
  ],
  "MREGP1": [
    "MREGP1 CNV",
    "MREGP1 RNA"
  ],
  "HMGN1P6": [
    "HMGN1P6 CNV",
    "HMGN1P6 RNA"
  ],
  "OGDHL": [
    "OGDHL CNV",
    "OGDHL RNA",
    "OGDHL Proteo"
  ],
  "RNASEK": [
    "RNASEK CNV",
    "RNASEK RNA"
  ],
  "MAGEB16": [
    "MAGEB16 CNV",
    "MAGEB16 RNA"
  ],
  "MPPE1": [
    "MPPE1 CNV",
    "MPPE1 RNA",
    "MPPE1 Proteo"
  ],
  "TENT4A": [
    "TENT4A CNV",
    "TENT4A RNA",
    "TENT4A Proteo"
  ],
  "PCDHGA8": [
    "PCDHGA8 CNV",
    "PCDHGA8 RNA"
  ],
  "MSRB1P1": [
    "MSRB1P1 CNV",
    "MSRB1P1 RNA"
  ],
  "TEAD1": [
    "TEAD1 CNV",
    "TEAD1 RNA",
    "TEAD1 Proteo"
  ],
  "CSAD": [
    "CSAD CNV",
    "CSAD RNA",
    "CSAD Proteo"
  ],
  "NUTF2P5": [
    "NUTF2P5 CNV",
    "NUTF2P5 RNA"
  ],
  "SMIM22": [
    "SMIM22 CNV",
    "SMIM22 RNA",
    "SMIM22 Proteo"
  ],
  "HMGB1P38": [
    "HMGB1P38 CNV",
    "HMGB1P38 RNA"
  ],
  "KDM4E": [
    "KDM4E CNV",
    "KDM4E RNA"
  ],
  "LILRB3": [
    "LILRB3 CNV",
    "LILRB3 RNA",
    "LILRB3 Proteo"
  ],
  "ANKRD52": [
    "ANKRD52 CNV",
    "ANKRD52 RNA",
    "ANKRD52 Proteo"
  ],
  "BPY2": [
    "BPY2 CNV",
    "BPY2 RNA"
  ],
  "NFIX": [
    "NFIX CNV",
    "NFIX RNA",
    "NFIX Proteo"
  ],
  "ST7L": [
    "ST7L CNV",
    "ST7L RNA"
  ],
  "ZFC3H1": [
    "ZFC3H1 CNV",
    "ZFC3H1 RNA",
    "ZFC3H1 Proteo"
  ],
  "PPP1R13B": [
    "PPP1R13B CNV",
    "PPP1R13B RNA",
    "PPP1R13B Proteo"
  ],
  "CDC73": [
    "CDC73 CNV",
    "CDC73 RNA",
    "CDC73 Proteo"
  ],
  "CBLL1": [
    "CBLL1 CNV",
    "CBLL1 RNA",
    "CBLL1 Proteo"
  ],
  "NELFCD": [
    "NELFCD CNV",
    "NELFCD RNA",
    "NELFCD Proteo"
  ],
  "KCP": [
    "KCP CNV",
    "KCP RNA"
  ],
  "KLRF2": [
    "KLRF2 CNV",
    "KLRF2 RNA"
  ],
  "VDAC1P3": [
    "VDAC1P3 CNV",
    "VDAC1P3 RNA"
  ],
  "RPL23AP20": [
    "RPL23AP20 CNV",
    "RPL23AP20 RNA"
  ],
  "CTHRC1": [
    "CTHRC1 CNV",
    "CTHRC1 RNA",
    "CTHRC1 Proteo"
  ],
  "NCOA4P4": [
    "NCOA4P4 CNV",
    "NCOA4P4 RNA"
  ],
  "OR2Z1": [
    "OR2Z1 CNV",
    "OR2Z1 RNA"
  ],
  "PABPN1P2": [
    "PABPN1P2 CNV",
    "PABPN1P2 RNA"
  ],
  "AKR1C2": [
    "AKR1C2 CNV",
    "AKR1C2 RNA",
    "AKR1C2 Proteo"
  ],
  "SNAI3": [
    "SNAI3 CNV",
    "SNAI3 RNA"
  ],
  "PRELID1P4": [
    "PRELID1P4 CNV",
    "PRELID1P4 RNA"
  ],
  "KMT5AP1": [
    "KMT5AP1 CNV",
    "KMT5AP1 RNA"
  ],
  "GABRG1": [
    "GABRG1 CNV",
    "GABRG1 RNA"
  ],
  "GOLGA6B": [
    "GOLGA6B CNV",
    "GOLGA6B RNA"
  ],
  "C14orf28": [
    "C14orf28 CNV",
    "C14orf28 RNA"
  ],
  "BRMS1": [
    "BRMS1 CNV",
    "BRMS1 RNA",
    "BRMS1 Proteo"
  ],
  "ZNF217": [
    "ZNF217 CNV",
    "ZNF217 RNA",
    "ZNF217 Proteo"
  ],
  "NUP85": [
    "NUP85 CNV",
    "NUP85 RNA",
    "NUP85 Proteo"
  ],
  "ACP6": [
    "ACP6 CNV",
    "ACP6 RNA",
    "ACP6 Proteo"
  ],
  "FAM86KP": [
    "FAM86KP CNV",
    "FAM86KP RNA"
  ],
  "HDHD5": [
    "HDHD5 CNV",
    "HDHD5 RNA",
    "HDHD5 Proteo"
  ],
  "PARM1": [
    "PARM1 CNV",
    "PARM1 RNA",
    "PARM1 Proteo"
  ],
  "RNA5SP437": [
    "RNA5SP437 CNV",
    "RNA5SP437 RNA"
  ],
  "ASIC5": [
    "ASIC5 CNV",
    "ASIC5 RNA"
  ],
  "ANO7": [
    "ANO7 CNV",
    "ANO7 RNA"
  ],
  "CSH2": [
    "CSH2 CNV",
    "CSH2 RNA"
  ],
  "DCT": [
    "DCT CNV",
    "DCT RNA",
    "DCT Proteo"
  ],
  "TOE1": [
    "TOE1 CNV",
    "TOE1 RNA",
    "TOE1 Proteo"
  ],
  "KIF14": [
    "KIF14 CNV",
    "KIF14 RNA",
    "KIF14 Proteo"
  ],
  "DNAJC27": [
    "DNAJC27 CNV",
    "DNAJC27 RNA"
  ],
  "FABP5P5": [
    "FABP5P5 CNV",
    "FABP5P5 RNA"
  ],
  "SOCS2P1": [
    "SOCS2P1 CNV",
    "SOCS2P1 RNA"
  ],
  "BNIP3P19": [
    "BNIP3P19 CNV",
    "BNIP3P19 RNA"
  ],
  "OR10A7": [
    "OR10A7 CNV",
    "OR10A7 RNA"
  ],
  "KDM5A": [
    "KDM5A CNV",
    "KDM5A RNA",
    "KDM5A Proteo"
  ],
  "PTP4A2P1": [
    "PTP4A2P1 CNV",
    "PTP4A2P1 RNA"
  ],
  "GPR85": [
    "GPR85 CNV",
    "GPR85 RNA"
  ],
  "GPR20": [
    "GPR20 CNV",
    "GPR20 RNA"
  ],
  "CPLX2": [
    "CPLX2 CNV",
    "CPLX2 RNA",
    "CPLX2 Proteo"
  ],
  "C11orf68": [
    "C11orf68 CNV",
    "C11orf68 RNA",
    "C11orf68 Proteo"
  ],
  "YWHAEP4": [
    "YWHAEP4 CNV",
    "YWHAEP4 RNA"
  ],
  "TTC17": [
    "TTC17 CNV",
    "TTC17 RNA",
    "TTC17 Proteo"
  ],
  "NT5C": [
    "NT5C CNV",
    "NT5C RNA",
    "NT5C Proteo"
  ],
  "ACTR2": [
    "ACTR2 CNV",
    "ACTR2 RNA",
    "ACTR2 Proteo"
  ],
  "PON1": [
    "PON1 CNV",
    "PON1 RNA",
    "PON1 Proteo"
  ],
  "RNA5SP266": [
    "RNA5SP266 CNV",
    "RNA5SP266 RNA"
  ],
  "MFF": [
    "MFF CNV",
    "MFF RNA",
    "MFF Proteo"
  ],
  "GNAS": [
    "GNAS CNV",
    "GNAS RNA",
    "GNAS Proteo"
  ],
  "PPIAP8": [
    "PPIAP8 CNV",
    "PPIAP8 RNA"
  ],
  "IKZF5": [
    "IKZF5 CNV",
    "IKZF5 RNA",
    "IKZF5 Proteo"
  ],
  "MPHOSPH10P4": [
    "MPHOSPH10P4 CNV",
    "MPHOSPH10P4 RNA"
  ],
  "ZNF497": [
    "ZNF497 CNV",
    "ZNF497 RNA"
  ],
  "TRMT112P5": [
    "TRMT112P5 CNV",
    "TRMT112P5 RNA"
  ],
  "RNA5SP317": [
    "RNA5SP317 CNV",
    "RNA5SP317 RNA"
  ],
  "ZC2HC1A": [
    "ZC2HC1A CNV",
    "ZC2HC1A RNA",
    "ZC2HC1A Proteo"
  ],
  "RPS27P18": [
    "RPS27P18 CNV",
    "RPS27P18 RNA"
  ],
  "TMEM19": [
    "TMEM19 CNV",
    "TMEM19 RNA",
    "TMEM19 Proteo"
  ],
  "CIITA": [
    "CIITA CNV",
    "CIITA RNA",
    "CIITA Proteo"
  ],
  "OR2AE1": [
    "OR2AE1 CNV",
    "OR2AE1 RNA"
  ],
  "REN": [
    "REN CNV",
    "REN RNA"
  ],
  "INKA1": [
    "INKA1 CNV",
    "INKA1 RNA"
  ],
  "BCL9L": [
    "BCL9L CNV",
    "BCL9L RNA",
    "BCL9L Proteo"
  ],
  "OBSCN": [
    "OBSCN CNV",
    "OBSCN RNA",
    "OBSCN Proteo"
  ],
  "ZFP62": [
    "ZFP62 CNV",
    "ZFP62 RNA",
    "ZFP62 Proteo"
  ],
  "PTPRN2": [
    "PTPRN2 CNV",
    "PTPRN2 RNA"
  ],
  "DSPP": [
    "DSPP CNV",
    "DSPP RNA"
  ],
  "HMGB3P8": [
    "HMGB3P8 CNV",
    "HMGB3P8 RNA"
  ],
  "EPC1": [
    "EPC1 CNV",
    "EPC1 RNA",
    "EPC1 Proteo"
  ],
  "RPS26P41": [
    "RPS26P41 CNV",
    "RPS26P41 RNA"
  ],
  "CCDC25": [
    "CCDC25 CNV",
    "CCDC25 RNA",
    "CCDC25 Proteo"
  ],
  "NPIPA9": [
    "NPIPA9 CNV",
    "NPIPA9 RNA"
  ],
  "NAXD": [
    "NAXD CNV",
    "NAXD RNA",
    "NAXD Proteo"
  ],
  "PCGF1": [
    "PCGF1 CNV",
    "PCGF1 RNA",
    "PCGF1 Proteo"
  ],
  "CTC1": [
    "CTC1 CNV",
    "CTC1 RNA",
    "CTC1 Proteo"
  ],
  "ASB17": [
    "ASB17 CNV",
    "ASB17 RNA"
  ],
  "SETD5": [
    "SETD5 CNV",
    "SETD5 RNA",
    "SETD5 Proteo"
  ],
  "UGT2B10": [
    "UGT2B10 CNV",
    "UGT2B10 RNA"
  ],
  "SLC10A7": [
    "SLC10A7 CNV",
    "SLC10A7 RNA",
    "SLC10A7 Proteo"
  ],
  "MCTP2": [
    "MCTP2 CNV",
    "MCTP2 RNA",
    "MCTP2 Proteo"
  ],
  "NOL4": [
    "NOL4 CNV",
    "NOL4 RNA"
  ],
  "DDX12P": [
    "DDX12P CNV",
    "DDX12P RNA"
  ],
  "TICAM2": [
    "TICAM2 CNV",
    "TICAM2 RNA"
  ],
  "CRYGEP": [
    "CRYGEP CNV",
    "CRYGEP RNA"
  ],
  "VANGL1": [
    "VANGL1 CNV",
    "VANGL1 RNA",
    "VANGL1 Proteo"
  ],
  "ANKRD37": [
    "ANKRD37 CNV",
    "ANKRD37 RNA"
  ],
  "CCDC28A": [
    "CCDC28A CNV",
    "CCDC28A RNA",
    "CCDC28A Proteo"
  ],
  "NUTF2P6": [
    "NUTF2P6 CNV",
    "NUTF2P6 RNA"
  ],
  "GPAT2P1": [
    "GPAT2P1 CNV",
    "GPAT2P1 RNA"
  ],
  "DUXAP6": [
    "DUXAP6 CNV",
    "DUXAP6 RNA"
  ],
  "CRYBA4": [
    "CRYBA4 CNV",
    "CRYBA4 RNA"
  ],
  "LRRC40": [
    "LRRC40 CNV",
    "LRRC40 RNA",
    "LRRC40 Proteo"
  ],
  "SIL1": [
    "SIL1 CNV",
    "SIL1 RNA",
    "SIL1 Proteo"
  ],
  "LANCL1": [
    "LANCL1 CNV",
    "LANCL1 RNA",
    "LANCL1 Proteo"
  ],
  "MTHFD2P3": [
    "MTHFD2P3 CNV",
    "MTHFD2P3 RNA"
  ],
  "DISP2": [
    "DISP2 CNV",
    "DISP2 RNA",
    "DISP2 Proteo"
  ],
  "SUN2": [
    "SUN2 CNV",
    "SUN2 RNA",
    "SUN2 Proteo"
  ],
  "CITED1": [
    "CITED1 CNV",
    "CITED1 RNA",
    "CITED1 Proteo"
  ],
  "MRPS18CP6": [
    "MRPS18CP6 CNV",
    "MRPS18CP6 RNA"
  ],
  "TCF7": [
    "TCF7 CNV",
    "TCF7 RNA",
    "TCF7 Proteo"
  ],
  "KIF4B": [
    "KIF4B CNV",
    "KIF4B RNA"
  ],
  "VSX2": [
    "VSX2 CNV",
    "VSX2 RNA"
  ],
  "SPTSSA": [
    "SPTSSA CNV",
    "SPTSSA RNA"
  ],
  "PNMA8C": [
    "PNMA8C CNV",
    "PNMA8C RNA"
  ],
  "PLEKHA3P1": [
    "PLEKHA3P1 CNV",
    "PLEKHA3P1 RNA"
  ],
  "TMEM272": [
    "TMEM272 CNV",
    "TMEM272 RNA"
  ],
  "DTWD2": [
    "DTWD2 CNV",
    "DTWD2 RNA",
    "DTWD2 Proteo"
  ],
  "FMO11P": [
    "FMO11P CNV",
    "FMO11P RNA"
  ],
  "CCDC115": [
    "CCDC115 CNV",
    "CCDC115 RNA",
    "CCDC115 Proteo"
  ],
  "APC2": [
    "APC2 CNV",
    "APC2 RNA"
  ],
  "PCDHA1": [
    "PCDHA1 CNV",
    "PCDHA1 RNA"
  ],
  "TSPY1": [
    "TSPY1 CNV",
    "TSPY1 RNA"
  ],
  "PSME4": [
    "PSME4 CNV",
    "PSME4 RNA",
    "PSME4 Proteo"
  ],
  "AMZ2P2": [
    "AMZ2P2 CNV",
    "AMZ2P2 RNA"
  ],
  "GPR160P2": [
    "GPR160P2 CNV",
    "GPR160P2 RNA"
  ],
  "SERPINB8P1": [
    "SERPINB8P1 CNV",
    "SERPINB8P1 RNA"
  ],
  "SORL1": [
    "SORL1 CNV",
    "SORL1 RNA",
    "SORL1 Proteo"
  ],
  "GPD1L": [
    "GPD1L CNV",
    "GPD1L RNA",
    "GPD1L Proteo"
  ],
  "FCGR3A": [
    "FCGR3A CNV",
    "FCGR3A RNA",
    "FCGR3A Proteo"
  ],
  "TMEM132A": [
    "TMEM132A CNV",
    "TMEM132A RNA",
    "TMEM132A Proteo"
  ],
  "PINX1_ENSG00000258724": [
    "PINX1_ENSG00000258724 RNA"
  ],
  "MS4A6E": [
    "MS4A6E CNV",
    "MS4A6E RNA"
  ],
  "PPIAP28": [
    "PPIAP28 CNV",
    "PPIAP28 RNA"
  ],
  "B9D1": [
    "B9D1 CNV",
    "B9D1 RNA",
    "B9D1 Proteo"
  ],
  "ENTHD1": [
    "ENTHD1 CNV",
    "ENTHD1 RNA"
  ],
  "POLR3KP1": [
    "POLR3KP1 CNV",
    "POLR3KP1 RNA"
  ],
  "EMX2": [
    "EMX2 CNV",
    "EMX2 RNA"
  ],
  "MTF1": [
    "MTF1 CNV",
    "MTF1 RNA",
    "MTF1 Proteo"
  ],
  "FANCI": [
    "FANCI CNV",
    "FANCI RNA",
    "FANCI Proteo"
  ],
  "BBOF1": [
    "BBOF1 CNV",
    "BBOF1 RNA"
  ],
  "OR51A7": [
    "OR51A7 CNV",
    "OR51A7 RNA"
  ],
  "CELA3A": [
    "CELA3A CNV",
    "CELA3A RNA"
  ],
  "IL20RA": [
    "IL20RA CNV",
    "IL20RA RNA"
  ],
  "HSPD1P1": [
    "HSPD1P1 CNV",
    "HSPD1P1 RNA"
  ],
  "MTCO3P40": [
    "MTCO3P40 CNV",
    "MTCO3P40 RNA"
  ],
  "LRRK1": [
    "LRRK1 CNV",
    "LRRK1 RNA",
    "LRRK1 Proteo"
  ],
  "PTK6": [
    "PTK6 CNV",
    "PTK6 RNA",
    "PTK6 Proteo"
  ],
  "FUBP1": [
    "FUBP1 CNV",
    "FUBP1 RNA",
    "FUBP1 Proteo"
  ],
  "MOAP1": [
    "MOAP1 CNV",
    "MOAP1 RNA",
    "MOAP1 Proteo"
  ],
  "CRYM": [
    "CRYM CNV",
    "CRYM RNA",
    "CRYM Proteo"
  ],
  "EPG5": [
    "EPG5 CNV",
    "EPG5 RNA",
    "EPG5 Proteo"
  ],
  "SFR1": [
    "SFR1 CNV",
    "SFR1 RNA",
    "SFR1 Proteo"
  ],
  "ELP3": [
    "ELP3 CNV",
    "ELP3 RNA",
    "ELP3 Proteo"
  ],
  "CNTN1": [
    "CNTN1 CNV",
    "CNTN1 RNA",
    "CNTN1 Proteo"
  ],
  "T_CD4": [
    "T_CD4 Cell_type"
  ],
  "FITM1": [
    "FITM1 CNV",
    "FITM1 RNA"
  ],
  "NAPSB": [
    "NAPSB CNV",
    "NAPSB RNA"
  ],
  "PTPN18": [
    "PTPN18 CNV",
    "PTPN18 RNA",
    "PTPN18 Proteo"
  ],
  "HMBOX1": [
    "HMBOX1 CNV",
    "HMBOX1 RNA",
    "HMBOX1 Proteo"
  ],
  "SOCS5P5": [
    "SOCS5P5 CNV",
    "SOCS5P5 RNA"
  ],
  "KRTAP22-2": [
    "KRTAP22-2 CNV",
    "KRTAP22-2 RNA"
  ],
  "PTGR1": [
    "PTGR1 CNV",
    "PTGR1 RNA",
    "PTGR1 Proteo"
  ],
  "CD177": [
    "CD177 CNV",
    "CD177 RNA",
    "CD177 Proteo"
  ],
  "SLC22A16": [
    "SLC22A16 CNV",
    "SLC22A16 RNA"
  ],
  "GCG": [
    "GCG CNV",
    "GCG RNA",
    "GCG Proteo"
  ],
  "USP32": [
    "USP32 CNV",
    "USP32 RNA",
    "USP32 Proteo"
  ],
  "ELOCP26": [
    "ELOCP26 CNV",
    "ELOCP26 RNA"
  ],
  "CA5AP1": [
    "CA5AP1 CNV",
    "CA5AP1 RNA"
  ],
  "HSD11B1L": [
    "HSD11B1L CNV",
    "HSD11B1L RNA"
  ],
  "MET": [
    "MET CNV",
    "MET RNA",
    "MET Proteo"
  ],
  "RASSF6": [
    "RASSF6 CNV",
    "RASSF6 RNA"
  ],
  "ADAM24P": [
    "ADAM24P CNV",
    "ADAM24P RNA"
  ],
  "GAPDHP59": [
    "GAPDHP59 CNV",
    "GAPDHP59 RNA"
  ],
  "NDRG1": [
    "NDRG1 CNV",
    "NDRG1 RNA",
    "NDRG1 Proteo"
  ],
  "ZNF408": [
    "ZNF408 CNV",
    "ZNF408 RNA",
    "ZNF408 Proteo"
  ],
  "N4BP1": [
    "N4BP1 CNV",
    "N4BP1 RNA",
    "N4BP1 Proteo"
  ],
  "HMGN3": [
    "HMGN3 CNV",
    "HMGN3 RNA",
    "HMGN3 Proteo"
  ],
  "ARL14": [
    "ARL14 CNV",
    "ARL14 RNA"
  ],
  "PIAS3": [
    "PIAS3 CNV",
    "PIAS3 RNA",
    "PIAS3 Proteo"
  ],
  "DMBT1L1": [
    "DMBT1L1 CNV",
    "DMBT1L1 RNA"
  ],
  "CCDC182": [
    "CCDC182 CNV",
    "CCDC182 RNA"
  ],
  "CNN2P8": [
    "CNN2P8 CNV",
    "CNN2P8 RNA"
  ],
  "ZNF451": [
    "ZNF451 CNV",
    "ZNF451 RNA",
    "ZNF451 Proteo"
  ],
  "RPSAP39": [
    "RPSAP39 CNV",
    "RPSAP39 RNA"
  ],
  "VCY1B": [
    "VCY1B CNV",
    "VCY1B RNA",
    "VCY1B Proteo"
  ],
  "NOS2": [
    "NOS2 CNV",
    "NOS2 RNA"
  ],
  "AHCYP7": [
    "AHCYP7 CNV",
    "AHCYP7 RNA"
  ],
  "H3C2": [
    "H3C2 CNV",
    "H3C2 RNA"
  ],
  "PSTPIP2": [
    "PSTPIP2 CNV",
    "PSTPIP2 RNA",
    "PSTPIP2 Proteo"
  ],
  "ELOCP33": [
    "ELOCP33 CNV",
    "ELOCP33 RNA"
  ],
  "RPL24P7": [
    "RPL24P7 CNV",
    "RPL24P7 RNA"
  ],
  "NR4A3": [
    "NR4A3 CNV",
    "NR4A3 RNA",
    "NR4A3 Proteo"
  ],
  "SPATA48": [
    "SPATA48 CNV",
    "SPATA48 RNA"
  ],
  "RPL17P45": [
    "RPL17P45 CNV",
    "RPL17P45 RNA"
  ],
  "GTF2IRD1": [
    "GTF2IRD1 CNV",
    "GTF2IRD1 RNA",
    "GTF2IRD1 Proteo"
  ],
  "H2BC5": [
    "H2BC5 CNV",
    "H2BC5 RNA",
    "H2BC5 Proteo"
  ],
  "KIF5B": [
    "KIF5B CNV",
    "KIF5B RNA",
    "KIF5B Proteo"
  ],
  "PSENEN": [
    "PSENEN CNV",
    "PSENEN RNA",
    "PSENEN Proteo"
  ],
  "DPH2": [
    "DPH2 CNV",
    "DPH2 RNA",
    "DPH2 Proteo"
  ],
  "RPL21P121": [
    "RPL21P121 CNV",
    "RPL21P121 RNA"
  ],
  "AREG": [
    "AREG CNV",
    "AREG RNA"
  ],
  "YPEL4": [
    "YPEL4 CNV",
    "YPEL4 RNA"
  ],
  "DEFB104B": [
    "DEFB104B CNV",
    "DEFB104B RNA"
  ],
  "CCNG1": [
    "CCNG1 CNV",
    "CCNG1 RNA"
  ],
  "NUB1": [
    "NUB1 CNV",
    "NUB1 RNA",
    "NUB1 Proteo"
  ],
  "NAA50": [
    "NAA50 CNV",
    "NAA50 RNA",
    "NAA50 Proteo"
  ],
  "SLC30A5": [
    "SLC30A5 CNV",
    "SLC30A5 RNA",
    "SLC30A5 Proteo"
  ],
  "CENPN": [
    "CENPN CNV",
    "CENPN RNA",
    "CENPN Proteo"
  ],
  "PIWIL1": [
    "PIWIL1 CNV",
    "PIWIL1 RNA",
    "PIWIL1 Proteo"
  ],
  "NAIPP3": [
    "NAIPP3 CNV",
    "NAIPP3 RNA"
  ],
  "RRAS2": [
    "RRAS2 CNV",
    "RRAS2 RNA",
    "RRAS2 Proteo"
  ],
  "ENTPD7": [
    "ENTPD7 CNV",
    "ENTPD7 RNA",
    "ENTPD7 Proteo"
  ],
  "VN1R32P": [
    "VN1R32P CNV",
    "VN1R32P RNA"
  ],
  "DIPK2A": [
    "DIPK2A CNV",
    "DIPK2A RNA",
    "DIPK2A Proteo"
  ],
  "EZH1": [
    "EZH1 CNV",
    "EZH1 RNA",
    "EZH1 Proteo"
  ],
  "IRX1P1": [
    "IRX1P1 CNV",
    "IRX1P1 RNA"
  ],
  "C19orf67": [
    "C19orf67 CNV",
    "C19orf67 RNA"
  ],
  "MDFIC": [
    "MDFIC CNV",
    "MDFIC RNA",
    "MDFIC Proteo"
  ],
  "TIMM22": [
    "TIMM22 CNV",
    "TIMM22 RNA",
    "TIMM22 Proteo"
  ],
  "NAIPP4": [
    "NAIPP4 CNV",
    "NAIPP4 RNA"
  ],
  "GRPEL1": [
    "GRPEL1 CNV",
    "GRPEL1 RNA",
    "GRPEL1 Proteo"
  ],
  "MKX": [
    "MKX CNV",
    "MKX RNA"
  ],
  "C6orf15": [
    "C6orf15 CNV",
    "C6orf15 RNA"
  ],
  "ADGRL3": [
    "ADGRL3 CNV",
    "ADGRL3 RNA",
    "ADGRL3 Proteo"
  ],
  "IFIH1": [
    "IFIH1 CNV",
    "IFIH1 RNA",
    "IFIH1 Proteo"
  ],
  "ITGA4": [
    "ITGA4 CNV",
    "ITGA4 RNA",
    "ITGA4 Proteo"
  ],
  "REXO1L5P": [
    "REXO1L5P CNV",
    "REXO1L5P RNA"
  ],
  "HOMEZ": [
    "HOMEZ CNV",
    "HOMEZ RNA",
    "HOMEZ Proteo"
  ],
  "RGS7BP": [
    "RGS7BP CNV",
    "RGS7BP RNA"
  ],
  "EFCAB14P1": [
    "EFCAB14P1 CNV",
    "EFCAB14P1 RNA"
  ],
  "GGT2P": [
    "GGT2P CNV",
    "GGT2P RNA"
  ],
  "CNTNAP3P2": [
    "CNTNAP3P2 CNV",
    "CNTNAP3P2 RNA"
  ],
  "AP1G1": [
    "AP1G1 CNV",
    "AP1G1 RNA",
    "AP1G1 Proteo"
  ],
  "KCNV1": [
    "KCNV1 CNV",
    "KCNV1 RNA"
  ],
  "ALPG": [
    "ALPG CNV",
    "ALPG RNA"
  ],
  "CES1P2": [
    "CES1P2 CNV",
    "CES1P2 RNA"
  ],
  "IGKV1D-13": [
    "IGKV1D-13 Proteo"
  ],
  "GRAMD4P5": [
    "GRAMD4P5 CNV",
    "GRAMD4P5 RNA"
  ],
  "IP6K2": [
    "IP6K2 CNV",
    "IP6K2 RNA",
    "IP6K2 Proteo"
  ],
  "NELL1": [
    "NELL1 CNV",
    "NELL1 RNA",
    "NELL1 Proteo"
  ],
  "CCDC190": [
    "CCDC190 CNV",
    "CCDC190 RNA"
  ],
  "BSNDP4": [
    "BSNDP4 CNV",
    "BSNDP4 RNA"
  ],
  "RNASEL": [
    "RNASEL CNV",
    "RNASEL RNA",
    "RNASEL Proteo"
  ],
  "RRP1B": [
    "RRP1B CNV",
    "RRP1B RNA",
    "RRP1B Proteo"
  ],
  "C2CD4D": [
    "C2CD4D CNV",
    "C2CD4D RNA"
  ],
  "ANKRD30BP3": [
    "ANKRD30BP3 CNV",
    "ANKRD30BP3 RNA"
  ],
  "MTND5P34": [
    "MTND5P34 CNV",
    "MTND5P34 RNA"
  ],
  "MCF2L": [
    "MCF2L CNV",
    "MCF2L RNA",
    "MCF2L Proteo"
  ],
  "FAM162B": [
    "FAM162B CNV",
    "FAM162B RNA"
  ],
  "RPL5P5": [
    "RPL5P5 CNV",
    "RPL5P5 RNA"
  ],
  "BFSP2": [
    "BFSP2 CNV",
    "BFSP2 RNA"
  ],
  "FAT4": [
    "FAT4 CNV",
    "FAT4 RNA",
    "FAT4 Proteo"
  ],
  "Macrophages": [
    "Macrophages Cell_type"
  ],
  "MTND6P14": [
    "MTND6P14 CNV",
    "MTND6P14 RNA"
  ],
  "WASHC1": [
    "WASHC1 CNV",
    "WASHC1 RNA",
    "WASHC1 Proteo"
  ],
  "SLC4A10": [
    "SLC4A10 CNV",
    "SLC4A10 RNA"
  ],
  "RPSAP62": [
    "RPSAP62 CNV",
    "RPSAP62 RNA"
  ],
  "MTCO1P53": [
    "MTCO1P53 CNV",
    "MTCO1P53 RNA"
  ],
  "MARCHF11": [
    "MARCHF11 CNV",
    "MARCHF11 RNA"
  ],
  "ZNF800": [
    "ZNF800 CNV",
    "ZNF800 RNA",
    "ZNF800 Proteo"
  ],
  "NUDT9P1": [
    "NUDT9P1 CNV",
    "NUDT9P1 RNA"
  ],
  "CCDC92": [
    "CCDC92 CNV",
    "CCDC92 RNA",
    "CCDC92 Proteo"
  ],
  "DUX4L27": [
    "DUX4L27 CNV",
    "DUX4L27 RNA"
  ],
  "MTRES1P1": [
    "MTRES1P1 CNV",
    "MTRES1P1 RNA"
  ],
  "MARK2P15": [
    "MARK2P15 CNV",
    "MARK2P15 RNA"
  ],
  "DGAT2": [
    "DGAT2 CNV",
    "DGAT2 RNA",
    "DGAT2 Proteo"
  ],
  "HTR5BP": [
    "HTR5BP CNV",
    "HTR5BP RNA"
  ],
  "THBS1": [
    "THBS1 CNV",
    "THBS1 RNA",
    "THBS1 Proteo"
  ],
  "TSPY19P": [
    "TSPY19P CNV",
    "TSPY19P RNA"
  ],
  "GTSE1": [
    "GTSE1 CNV",
    "GTSE1 RNA",
    "GTSE1 Proteo"
  ],
  "GALM": [
    "GALM CNV",
    "GALM RNA",
    "GALM Proteo"
  ],
  "MME": [
    "MME CNV",
    "MME RNA",
    "MME Proteo"
  ],
  "MED19": [
    "MED19 CNV",
    "MED19 RNA",
    "MED19 Proteo"
  ],
  "CRYBA1": [
    "CRYBA1 CNV",
    "CRYBA1 RNA"
  ],
  "MRPL53": [
    "MRPL53 CNV",
    "MRPL53 RNA",
    "MRPL53 Proteo"
  ],
  "EGLN1": [
    "EGLN1 CNV",
    "EGLN1 RNA",
    "EGLN1 Proteo"
  ],
  "RAB40C": [
    "RAB40C CNV",
    "RAB40C RNA",
    "RAB40C Proteo"
  ],
  "MTND2P32": [
    "MTND2P32 CNV",
    "MTND2P32 RNA"
  ],
  "GADD45GIP1": [
    "GADD45GIP1 CNV",
    "GADD45GIP1 RNA",
    "GADD45GIP1 Proteo"
  ],
  "B4GALT1": [
    "B4GALT1 CNV",
    "B4GALT1 RNA",
    "B4GALT1 Proteo"
  ],
  "ARRDC1": [
    "ARRDC1 CNV",
    "ARRDC1 RNA",
    "ARRDC1 Proteo"
  ],
  "IGSF6": [
    "IGSF6 CNV",
    "IGSF6 RNA",
    "IGSF6 Proteo"
  ],
  "NPM1P30": [
    "NPM1P30 CNV",
    "NPM1P30 RNA"
  ],
  "CCDC177": [
    "CCDC177 CNV",
    "CCDC177 RNA"
  ],
  "PTPN2P2": [
    "PTPN2P2 CNV",
    "PTPN2P2 RNA"
  ],
  "XRCC6P3": [
    "XRCC6P3 CNV",
    "XRCC6P3 RNA"
  ],
  "IFNWP9": [
    "IFNWP9 CNV",
    "IFNWP9 RNA"
  ],
  "RBISP1": [
    "RBISP1 CNV",
    "RBISP1 RNA"
  ],
  "UGT2B27P": [
    "UGT2B27P CNV",
    "UGT2B27P RNA"
  ],
  "SNX18": [
    "SNX18 CNV",
    "SNX18 RNA",
    "SNX18 Proteo"
  ],
  "SREBF1": [
    "SREBF1 CNV",
    "SREBF1 RNA",
    "SREBF1 Proteo"
  ],
  "DNM3": [
    "DNM3 CNV",
    "DNM3 RNA",
    "DNM3 Proteo"
  ],
  "ATG7": [
    "ATG7 CNV",
    "ATG7 RNA",
    "ATG7 Proteo"
  ],
  "C1GALT1": [
    "C1GALT1 CNV",
    "C1GALT1 RNA",
    "C1GALT1 Proteo"
  ],
  "HARS2": [
    "HARS2 CNV",
    "HARS2 RNA",
    "HARS2 Proteo"
  ],
  "SLC35E1": [
    "SLC35E1 CNV",
    "SLC35E1 RNA",
    "SLC35E1 Proteo"
  ],
  "TRAPPC2P5": [
    "TRAPPC2P5 CNV",
    "TRAPPC2P5 RNA"
  ],
  "SPINK2": [
    "SPINK2 CNV",
    "SPINK2 RNA"
  ],
  "HNRNPA1P51": [
    "HNRNPA1P51 CNV",
    "HNRNPA1P51 RNA"
  ],
  "RNA5SP503": [
    "RNA5SP503 CNV",
    "RNA5SP503 RNA"
  ],
  "HNRNPA1P65": [
    "HNRNPA1P65 CNV",
    "HNRNPA1P65 RNA"
  ],
  "SDHC": [
    "SDHC CNV",
    "SDHC RNA",
    "SDHC Proteo"
  ],
  "RPS6P16": [
    "RPS6P16 CNV",
    "RPS6P16 RNA"
  ],
  "ACTR6P1": [
    "ACTR6P1 CNV",
    "ACTR6P1 RNA"
  ],
  "TSPO": [
    "TSPO CNV",
    "TSPO RNA",
    "TSPO Proteo"
  ],
  "RNA5SP66": [
    "RNA5SP66 CNV",
    "RNA5SP66 RNA"
  ],
  "CDH18": [
    "CDH18 CNV",
    "CDH18 RNA"
  ],
  "RPUSD1": [
    "RPUSD1 CNV",
    "RPUSD1 RNA",
    "RPUSD1 Proteo"
  ],
  "ELL": [
    "ELL CNV",
    "ELL RNA",
    "ELL Proteo"
  ],
  "KRT17P8": [
    "KRT17P8 CNV",
    "KRT17P8 RNA"
  ],
  "BST2": [
    "BST2 CNV",
    "BST2 RNA",
    "BST2 Proteo"
  ],
  "CYP4X1": [
    "CYP4X1 CNV",
    "CYP4X1 RNA",
    "CYP4X1 Proteo"
  ],
  "LACRT": [
    "LACRT CNV",
    "LACRT RNA"
  ],
  "CYP4A26P": [
    "CYP4A26P CNV",
    "CYP4A26P RNA"
  ],
  "MKKS": [
    "MKKS CNV",
    "MKKS RNA"
  ],
  "ZNF619": [
    "ZNF619 CNV",
    "ZNF619 RNA"
  ],
  "CYS1": [
    "CYS1 CNV",
    "CYS1 RNA",
    "CYS1 Proteo"
  ],
  "EFCAB3": [
    "EFCAB3 CNV",
    "EFCAB3 RNA"
  ],
  "DLX2": [
    "DLX2 CNV",
    "DLX2 RNA"
  ],
  "RNA5SP426": [
    "RNA5SP426 CNV",
    "RNA5SP426 RNA"
  ],
  "IGHV1OR15-1": [
    "IGHV1OR15-1 Proteo"
  ],
  "MCOLN1": [
    "MCOLN1 CNV",
    "MCOLN1 RNA",
    "MCOLN1 Proteo"
  ],
  "BCAR1": [
    "BCAR1 CNV",
    "BCAR1 RNA",
    "BCAR1 Proteo"
  ],
  "SPACA3": [
    "SPACA3 CNV",
    "SPACA3 RNA"
  ],
  "ZAR1": [
    "ZAR1 CNV",
    "ZAR1 RNA"
  ],
  "YRDCP2": [
    "YRDCP2 CNV",
    "YRDCP2 RNA"
  ],
  "IL21": [
    "IL21 CNV",
    "IL21 RNA"
  ],
  "BNIP3P38": [
    "BNIP3P38 CNV",
    "BNIP3P38 RNA"
  ],
  "CD59": [
    "CD59 CNV",
    "CD59 RNA",
    "CD59 Proteo"
  ],
  "OR10J8P": [
    "OR10J8P CNV",
    "OR10J8P RNA"
  ],
  "KLK9": [
    "KLK9 CNV",
    "KLK9 RNA"
  ],
  "RNA5SP99": [
    "RNA5SP99 CNV",
    "RNA5SP99 RNA"
  ],
  "MANSC1": [
    "MANSC1 CNV",
    "MANSC1 RNA",
    "MANSC1 Proteo"
  ],
  "MAGT1": [
    "MAGT1 CNV",
    "MAGT1 RNA",
    "MAGT1 Proteo"
  ],
  "OR52E3P": [
    "OR52E3P CNV",
    "OR52E3P RNA"
  ],
  "CRB1": [
    "CRB1 CNV",
    "CRB1 RNA"
  ],
  "FGF7P5": [
    "FGF7P5 CNV",
    "FGF7P5 RNA"
  ],
  "MRPL11": [
    "MRPL11 CNV",
    "MRPL11 RNA",
    "MRPL11 Proteo"
  ],
  "GSDMC": [
    "GSDMC CNV",
    "GSDMC RNA"
  ],
  "SH2D3C": [
    "SH2D3C CNV",
    "SH2D3C RNA",
    "SH2D3C Proteo"
  ],
  "ELOCP9": [
    "ELOCP9 CNV",
    "ELOCP9 RNA"
  ],
  "RPL6P12": [
    "RPL6P12 CNV",
    "RPL6P12 RNA"
  ],
  "POM121L2": [
    "POM121L2 CNV",
    "POM121L2 RNA"
  ],
  "UBE2I": [
    "UBE2I CNV",
    "UBE2I RNA",
    "UBE2I Proteo"
  ],
  "NPIPA8": [
    "NPIPA8 CNV",
    "NPIPA8 RNA"
  ],
  "PLA2G4C": [
    "PLA2G4C CNV",
    "PLA2G4C RNA",
    "PLA2G4C Proteo"
  ],
  "UCHL5": [
    "UCHL5 CNV",
    "UCHL5 RNA",
    "UCHL5 Proteo"
  ],
  "PSAT1P1": [
    "PSAT1P1 CNV",
    "PSAT1P1 RNA"
  ],
  "MKNK2": [
    "MKNK2 CNV",
    "MKNK2 RNA"
  ],
  "XIRP1": [
    "XIRP1 CNV",
    "XIRP1 RNA",
    "XIRP1 Proteo"
  ],
  "KRTAP10-1": [
    "KRTAP10-1 CNV",
    "KRTAP10-1 RNA"
  ],
  "H1-12P": [
    "H1-12P CNV",
    "H1-12P RNA"
  ],
  "TP53BP1": [
    "TP53BP1 CNV",
    "TP53BP1 RNA",
    "TP53BP1 Proteo"
  ],
  "PGA3": [
    "PGA3 CNV",
    "PGA3 RNA"
  ],
  "CDIPTOSP": [
    "CDIPTOSP CNV",
    "CDIPTOSP RNA"
  ],
  "PSMC1P12": [
    "PSMC1P12 CNV",
    "PSMC1P12 RNA"
  ],
  "ST8SIA5": [
    "ST8SIA5 CNV",
    "ST8SIA5 RNA"
  ],
  "SEM1P1": [
    "SEM1P1 CNV",
    "SEM1P1 RNA"
  ],
  "TBX21": [
    "TBX21 CNV",
    "TBX21 RNA"
  ],
  "H3P22": [
    "H3P22 CNV",
    "H3P22 RNA"
  ],
  "RASA3": [
    "RASA3 CNV",
    "RASA3 RNA",
    "RASA3 Proteo"
  ],
  "ERN1": [
    "ERN1 CNV",
    "ERN1 RNA",
    "ERN1 Proteo"
  ],
  "SIRT7": [
    "SIRT7 CNV",
    "SIRT7 RNA",
    "SIRT7 Proteo"
  ],
  "ZPLD2P": [
    "ZPLD2P CNV",
    "ZPLD2P RNA"
  ],
  "MXRA7": [
    "MXRA7 CNV",
    "MXRA7 RNA",
    "MXRA7 Proteo"
  ],
  "CHST14": [
    "CHST14 CNV",
    "CHST14 RNA",
    "CHST14 Proteo"
  ],
  "USP17L7": [
    "USP17L7 CNV",
    "USP17L7 RNA"
  ],
  "RFLNB": [
    "RFLNB CNV",
    "RFLNB RNA",
    "RFLNB Proteo"
  ],
  "NAMPTP3": [
    "NAMPTP3 CNV",
    "NAMPTP3 RNA"
  ],
  "PRXL2C": [
    "PRXL2C CNV",
    "PRXL2C RNA",
    "PRXL2C Proteo"
  ],
  "AREL1": [
    "AREL1 CNV",
    "AREL1 RNA",
    "AREL1 Proteo"
  ],
  "HOXB6": [
    "HOXB6 CNV",
    "HOXB6 RNA"
  ],
  "METRNL": [
    "METRNL CNV",
    "METRNL RNA",
    "METRNL Proteo"
  ],
  "WDR87BP": [
    "WDR87BP CNV",
    "WDR87BP RNA"
  ],
  "EFNB1": [
    "EFNB1 CNV",
    "EFNB1 RNA",
    "EFNB1 Proteo"
  ],
  "ASZ1": [
    "ASZ1 CNV",
    "ASZ1 RNA"
  ],
  "TMSB10P1": [
    "TMSB10P1 CNV",
    "TMSB10P1 RNA"
  ],
  "AP2A2": [
    "AP2A2 CNV",
    "AP2A2 RNA",
    "AP2A2 Proteo"
  ],
  "PDE4DIP": [
    "PDE4DIP CNV",
    "PDE4DIP RNA",
    "PDE4DIP Proteo"
  ],
  "RUBCN": [
    "RUBCN CNV",
    "RUBCN RNA",
    "RUBCN Proteo"
  ],
  "MAVS": [
    "MAVS CNV",
    "MAVS RNA",
    "MAVS Proteo"
  ],
  "ZCCHC18": [
    "ZCCHC18 CNV",
    "ZCCHC18 RNA"
  ],
  "FAM180A": [
    "FAM180A CNV",
    "FAM180A RNA"
  ],
  "MESTP3": [
    "MESTP3 CNV",
    "MESTP3 RNA"
  ],
  "SMC1A": [
    "SMC1A CNV",
    "SMC1A RNA",
    "SMC1A Proteo"
  ],
  "UHMK1": [
    "UHMK1 CNV",
    "UHMK1 RNA",
    "UHMK1 Proteo"
  ],
  "SIX1": [
    "SIX1 CNV",
    "SIX1 RNA"
  ],
  "SINHCAFP3": [
    "SINHCAFP3 CNV",
    "SINHCAFP3 RNA"
  ],
  "ALOX15B": [
    "ALOX15B CNV",
    "ALOX15B RNA",
    "ALOX15B Proteo"
  ],
  "WDR45B": [
    "WDR45B CNV",
    "WDR45B RNA",
    "WDR45B Proteo"
  ],
  "DNAJB14": [
    "DNAJB14 CNV",
    "DNAJB14 RNA",
    "DNAJB14 Proteo"
  ],
  "XGY1": [
    "XGY1 CNV",
    "XGY1 RNA"
  ],
  "CD24P4": [
    "CD24P4 CNV",
    "CD24P4 RNA"
  ],
  "LIMK1": [
    "LIMK1 CNV",
    "LIMK1 RNA",
    "LIMK1 Proteo"
  ],
  "MUC21": [
    "MUC21 CNV",
    "MUC21 RNA"
  ],
  "SLX4IP": [
    "SLX4IP CNV",
    "SLX4IP RNA",
    "SLX4IP Proteo"
  ],
  "CREG1": [
    "CREG1 CNV",
    "CREG1 RNA",
    "CREG1 Proteo"
  ],
  "PRKACB": [
    "PRKACB CNV",
    "PRKACB RNA",
    "PRKACB Proteo"
  ],
  "RNA5SP324": [
    "RNA5SP324 CNV",
    "RNA5SP324 RNA"
  ],
  "CFAP300": [
    "CFAP300 CNV",
    "CFAP300 RNA"
  ],
  "RPL36AP11": [
    "RPL36AP11 CNV",
    "RPL36AP11 RNA"
  ],
  "SSXP4": [
    "SSXP4 CNV",
    "SSXP4 RNA"
  ],
  "PFKP": [
    "PFKP CNV",
    "PFKP RNA",
    "PFKP Proteo"
  ],
  "RPL31P11": [
    "RPL31P11 CNV",
    "RPL31P11 RNA"
  ],
  "ABITRAM": [
    "ABITRAM CNV",
    "ABITRAM RNA",
    "ABITRAM Proteo"
  ],
  "GNA15": [
    "GNA15 CNV",
    "GNA15 RNA",
    "GNA15 Proteo"
  ],
  "COL18A1": [
    "COL18A1 CNV",
    "COL18A1 RNA",
    "COL18A1 Proteo"
  ],
  "PARP4": [
    "PARP4 CNV",
    "PARP4 RNA",
    "PARP4 Proteo"
  ],
  "PRSS8": [
    "PRSS8 CNV",
    "PRSS8 RNA",
    "PRSS8 Proteo"
  ],
  "POTEF": [
    "POTEF CNV",
    "POTEF RNA",
    "POTEF Proteo"
  ],
  "THEMIS2": [
    "THEMIS2 CNV",
    "THEMIS2 RNA",
    "THEMIS2 Proteo"
  ],
  "CBLC": [
    "CBLC CNV",
    "CBLC RNA"
  ],
  "YIPF2": [
    "YIPF2 CNV",
    "YIPF2 RNA",
    "YIPF2 Proteo"
  ],
  "PORCN": [
    "PORCN CNV",
    "PORCN RNA",
    "PORCN Proteo"
  ],
  "HOMER2P1": [
    "HOMER2P1 CNV",
    "HOMER2P1 RNA"
  ],
  "MFSD13A": [
    "MFSD13A CNV",
    "MFSD13A RNA"
  ],
  "AKR1B1P6": [
    "AKR1B1P6 CNV",
    "AKR1B1P6 RNA"
  ],
  "OR8B5P": [
    "OR8B5P CNV",
    "OR8B5P RNA"
  ],
  "SRP54": [
    "SRP54 CNV",
    "SRP54 RNA",
    "SRP54 Proteo"
  ],
  "JUNB": [
    "JUNB CNV",
    "JUNB RNA",
    "JUNB Proteo"
  ],
  "OR5AK2": [
    "OR5AK2 CNV",
    "OR5AK2 RNA"
  ],
  "SLC44A3-AS1": [
    "SLC44A3-AS1 CNV",
    "SLC44A3-AS1 RNA"
  ],
  "FAM237B": [
    "FAM237B CNV",
    "FAM237B RNA"
  ],
  "HOXB3": [
    "HOXB3 CNV",
    "HOXB3 RNA"
  ],
  "TOMM22P4": [
    "TOMM22P4 CNV",
    "TOMM22P4 RNA"
  ],
  "KRT18P9": [
    "KRT18P9 CNV",
    "KRT18P9 RNA"
  ],
  "TYR": [
    "TYR CNV",
    "TYR RNA",
    "TYR Proteo"
  ],
  "TGIF2LY": [
    "TGIF2LY CNV",
    "TGIF2LY RNA"
  ],
  "TTC38": [
    "TTC38 CNV",
    "TTC38 RNA",
    "TTC38 Proteo"
  ],
  "RPL13AP23": [
    "RPL13AP23 CNV",
    "RPL13AP23 RNA"
  ],
  "CGA": [
    "CGA CNV",
    "CGA RNA"
  ],
  "TMEM97P1": [
    "TMEM97P1 CNV",
    "TMEM97P1 RNA"
  ],
  "PLA2G2E": [
    "PLA2G2E CNV",
    "PLA2G2E RNA"
  ],
  "PTMA": [
    "PTMA CNV",
    "PTMA RNA",
    "PTMA Proteo"
  ],
  "OTUD6A": [
    "OTUD6A CNV",
    "OTUD6A RNA"
  ],
  "IL36G": [
    "IL36G CNV",
    "IL36G RNA",
    "IL36G Proteo"
  ],
  "ZNF705EP": [
    "ZNF705EP CNV",
    "ZNF705EP RNA"
  ],
  "F7": [
    "F7 CNV",
    "F7 RNA",
    "F7 Proteo"
  ],
  "MTRR": [
    "MTRR CNV",
    "MTRR RNA",
    "MTRR Proteo"
  ],
  "MYBL2": [
    "MYBL2 CNV",
    "MYBL2 RNA",
    "MYBL2 Proteo"
  ],
  "CETP": [
    "CETP CNV",
    "CETP RNA",
    "CETP Proteo"
  ],
  "FST": [
    "FST CNV",
    "FST RNA"
  ],
  "IGKV3D-34": [
    "IGKV3D-34 CNV",
    "IGKV3D-34 RNA"
  ],
  "RIMBP2": [
    "RIMBP2 CNV",
    "RIMBP2 RNA"
  ],
  "OR51Q1": [
    "OR51Q1 CNV",
    "OR51Q1 RNA"
  ],
  "NINJ1": [
    "NINJ1 CNV",
    "NINJ1 RNA",
    "NINJ1 Proteo"
  ],
  "BTN3A3": [
    "BTN3A3 CNV",
    "BTN3A3 RNA",
    "BTN3A3 Proteo"
  ],
  "RPSAP59": [
    "RPSAP59 CNV",
    "RPSAP59 RNA"
  ],
  "ALAD": [
    "ALAD CNV",
    "ALAD RNA",
    "ALAD Proteo"
  ],
  "SLC38A9": [
    "SLC38A9 CNV",
    "SLC38A9 RNA",
    "SLC38A9 Proteo"
  ],
  "OR2J2": [
    "OR2J2 CNV",
    "OR2J2 RNA"
  ],
  "OFD1P5Y": [
    "OFD1P5Y CNV",
    "OFD1P5Y RNA"
  ],
  "CMTM6": [
    "CMTM6 CNV",
    "CMTM6 RNA",
    "CMTM6 Proteo"
  ],
  "OR4A17P": [
    "OR4A17P CNV",
    "OR4A17P RNA"
  ],
  "SHC3": [
    "SHC3 CNV",
    "SHC3 RNA"
  ],
  "GNAI3": [
    "GNAI3 CNV",
    "GNAI3 RNA",
    "GNAI3 Proteo"
  ],
  "AK4": [
    "AK4 CNV",
    "AK4 RNA",
    "AK4 Proteo"
  ],
  "CRTAP": [
    "CRTAP CNV",
    "CRTAP RNA",
    "CRTAP Proteo"
  ],
  "DCTN3": [
    "DCTN3 CNV",
    "DCTN3 RNA",
    "DCTN3 Proteo"
  ],
  "H3Y2": [
    "H3Y2 CNV",
    "H3Y2 RNA",
    "H3Y2 Proteo"
  ],
  "KCTD17": [
    "KCTD17 CNV",
    "KCTD17 RNA",
    "KCTD17 Proteo"
  ],
  "NRSN2": [
    "NRSN2 CNV",
    "NRSN2 RNA"
  ],
  "GPR45": [
    "GPR45 CNV",
    "GPR45 RNA"
  ],
  "PGBP": [
    "PGBP CNV",
    "PGBP RNA"
  ],
  "PI4KB": [
    "PI4KB CNV",
    "PI4KB RNA",
    "PI4KB Proteo"
  ],
  "CITED4": [
    "CITED4 CNV",
    "CITED4 RNA"
  ],
  "TUBGCP4": [
    "TUBGCP4 CNV",
    "TUBGCP4 RNA",
    "TUBGCP4 Proteo"
  ],
  "DCX": [
    "DCX CNV",
    "DCX RNA",
    "DCX Proteo"
  ],
  "CD180": [
    "CD180 CNV",
    "CD180 RNA",
    "CD180 Proteo"
  ],
  "ZNF780A": [
    "ZNF780A CNV",
    "ZNF780A RNA"
  ],
  "SRRM1P3": [
    "SRRM1P3 CNV",
    "SRRM1P3 RNA"
  ],
  "AJM1": [
    "AJM1 CNV",
    "AJM1 RNA"
  ],
  "ALG13": [
    "ALG13 CNV",
    "ALG13 RNA",
    "ALG13 Proteo"
  ],
  "SLC17A5": [
    "SLC17A5 CNV",
    "SLC17A5 RNA",
    "SLC17A5 Proteo"
  ],
  "CEBPB": [
    "CEBPB CNV",
    "CEBPB RNA",
    "CEBPB Proteo"
  ],
  "CGREF1": [
    "CGREF1 CNV",
    "CGREF1 RNA",
    "CGREF1 Proteo"
  ],
  "TRIM64DP": [
    "TRIM64DP CNV",
    "TRIM64DP RNA"
  ],
  "HMGB3P18": [
    "HMGB3P18 CNV",
    "HMGB3P18 RNA"
  ],
  "OR6C2": [
    "OR6C2 CNV",
    "OR6C2 RNA"
  ],
  "HSFY1": [
    "HSFY1 CNV",
    "HSFY1 RNA"
  ],
  "OR4F4": [
    "OR4F4 CNV",
    "OR4F4 RNA"
  ],
  "ATF5": [
    "ATF5 CNV",
    "ATF5 RNA"
  ],
  "TXNP3": [
    "TXNP3 CNV",
    "TXNP3 RNA"
  ],
  "CARS1P2": [
    "CARS1P2 CNV",
    "CARS1P2 RNA"
  ],
  "PTMAP9": [
    "PTMAP9 CNV",
    "PTMAP9 RNA"
  ],
  "KRT8P26": [
    "KRT8P26 CNV",
    "KRT8P26 RNA"
  ],
  "NXF2B": [
    "NXF2B CNV",
    "NXF2B RNA"
  ],
  "MRPL52": [
    "MRPL52 CNV",
    "MRPL52 RNA",
    "MRPL52 Proteo"
  ],
  "ACKR1": [
    "ACKR1 CNV",
    "ACKR1 RNA",
    "ACKR1 Proteo"
  ],
  "POLR3GL": [
    "POLR3GL CNV",
    "POLR3GL RNA",
    "POLR3GL Proteo"
  ],
  "ATP1B2": [
    "ATP1B2 CNV",
    "ATP1B2 RNA",
    "ATP1B2 Proteo"
  ],
  "DPYSL2": [
    "DPYSL2 CNV",
    "DPYSL2 RNA",
    "DPYSL2 Proteo"
  ],
  "GTF2IP14": [
    "GTF2IP14 CNV",
    "GTF2IP14 RNA"
  ],
  "UBE2J2": [
    "UBE2J2 CNV",
    "UBE2J2 RNA",
    "UBE2J2 Proteo"
  ],
  "GJA4": [
    "GJA4 CNV",
    "GJA4 RNA"
  ],
  "ZNF83": [
    "ZNF83 CNV",
    "ZNF83 RNA"
  ],
  "ANKRD33B": [
    "ANKRD33B CNV",
    "ANKRD33B RNA"
  ],
  "DUTP6": [
    "DUTP6 CNV",
    "DUTP6 RNA"
  ],
  "KLK5": [
    "KLK5 CNV",
    "KLK5 RNA",
    "KLK5 Proteo"
  ],
  "VPREB3": [
    "VPREB3 CNV",
    "VPREB3 RNA"
  ],
  "IQCF2": [
    "IQCF2 CNV",
    "IQCF2 RNA"
  ],
  "NDUFA3P6": [
    "NDUFA3P6 CNV",
    "NDUFA3P6 RNA"
  ],
  "ANXA3": [
    "ANXA3 CNV",
    "ANXA3 RNA",
    "ANXA3 Proteo"
  ],
  "GALK1": [
    "GALK1 CNV",
    "GALK1 RNA",
    "GALK1 Proteo"
  ],
  "UQCRFS1": [
    "UQCRFS1 CNV",
    "UQCRFS1 RNA",
    "UQCRFS1 Proteo"
  ],
  "RPL7AP18": [
    "RPL7AP18 CNV",
    "RPL7AP18 RNA"
  ],
  "KRT19P3": [
    "KRT19P3 CNV",
    "KRT19P3 RNA"
  ],
  "SOCS5": [
    "SOCS5 CNV",
    "SOCS5 RNA"
  ],
  "RNA5SP512": [
    "RNA5SP512 CNV",
    "RNA5SP512 RNA"
  ],
  "ZFYVE16": [
    "ZFYVE16 CNV",
    "ZFYVE16 RNA",
    "ZFYVE16 Proteo"
  ],
  "SPATA33": [
    "SPATA33 CNV",
    "SPATA33 RNA",
    "SPATA33 Proteo"
  ],
  "RPL3P7": [
    "RPL3P7 CNV",
    "RPL3P7 RNA"
  ],
  "PRELID1P3": [
    "PRELID1P3 CNV",
    "PRELID1P3 RNA"
  ],
  "ANKHD1": [
    "ANKHD1 CNV",
    "ANKHD1 RNA",
    "ANKHD1 Proteo"
  ],
  "UGT1A4": [
    "UGT1A4 CNV",
    "UGT1A4 RNA"
  ],
  "ZNF99": [
    "ZNF99 CNV",
    "ZNF99 RNA"
  ],
  "NPM1P23": [
    "NPM1P23 CNV",
    "NPM1P23 RNA"
  ],
  "CHRM1": [
    "CHRM1 CNV",
    "CHRM1 RNA"
  ],
  "ZNF887P": [
    "ZNF887P CNV",
    "ZNF887P RNA"
  ],
  "FOLH1B": [
    "FOLH1B CNV",
    "FOLH1B RNA"
  ],
  "C1orf53": [
    "C1orf53 CNV",
    "C1orf53 RNA",
    "C1orf53 Proteo"
  ],
  "PRM3": [
    "PRM3 CNV",
    "PRM3 RNA"
  ],
  "COPS7A": [
    "COPS7A CNV",
    "COPS7A RNA",
    "COPS7A Proteo"
  ],
  "ARF3": [
    "ARF3 CNV",
    "ARF3 RNA",
    "ARF3 Proteo"
  ],
  "IGHV4-28": [
    "IGHV4-28 Proteo"
  ],
  "SEMA5B": [
    "SEMA5B CNV",
    "SEMA5B RNA"
  ],
  "IGF2BP3": [
    "IGF2BP3 CNV",
    "IGF2BP3 RNA",
    "IGF2BP3 Proteo"
  ],
  "MRPS12": [
    "MRPS12 CNV",
    "MRPS12 RNA",
    "MRPS12 Proteo"
  ],
  "HELQ": [
    "HELQ CNV",
    "HELQ RNA",
    "HELQ Proteo"
  ],
  "ENDOD1": [
    "ENDOD1 CNV",
    "ENDOD1 RNA",
    "ENDOD1 Proteo"
  ],
  "RPLP1P13": [
    "RPLP1P13 CNV",
    "RPLP1P13 RNA"
  ],
  "KRT18P66": [
    "KRT18P66 CNV",
    "KRT18P66 RNA"
  ],
  "RNA5SP190": [
    "RNA5SP190 CNV",
    "RNA5SP190 RNA"
  ],
  "LIME1": [
    "LIME1 CNV",
    "LIME1 RNA",
    "LIME1 Proteo"
  ],
  "KCNA2": [
    "KCNA2 CNV",
    "KCNA2 RNA"
  ],
  "CMKLR2": [
    "CMKLR2 CNV",
    "CMKLR2 RNA"
  ],
  "UBE2V2P3": [
    "UBE2V2P3 CNV",
    "UBE2V2P3 RNA"
  ],
  "BRAF": [
    "BRAF CNV",
    "BRAF RNA",
    "BRAF Proteo"
  ],
  "MAPK10": [
    "MAPK10 CNV",
    "MAPK10 RNA"
  ],
  "NUDT6": [
    "NUDT6 CNV",
    "NUDT6 RNA",
    "NUDT6 Proteo"
  ],
  "CCDC68": [
    "CCDC68 CNV",
    "CCDC68 RNA"
  ],
  "EIPR1": [
    "EIPR1 CNV",
    "EIPR1 RNA",
    "EIPR1 Proteo"
  ],
  "GAB3": [
    "GAB3 CNV",
    "GAB3 RNA",
    "GAB3 Proteo"
  ],
  "OR5H7P": [
    "OR5H7P CNV",
    "OR5H7P RNA"
  ],
  "ZNF131": [
    "ZNF131 CNV",
    "ZNF131 RNA",
    "ZNF131 Proteo"
  ],
  "DNM1": [
    "DNM1 CNV",
    "DNM1 RNA",
    "DNM1 Proteo"
  ],
  "PWWP3A": [
    "PWWP3A CNV",
    "PWWP3A RNA",
    "PWWP3A Proteo"
  ],
  "CEACAM3": [
    "CEACAM3 CNV",
    "CEACAM3 RNA"
  ],
  "KRT8P47": [
    "KRT8P47 CNV",
    "KRT8P47 RNA"
  ],
  "TUB": [
    "TUB CNV",
    "TUB RNA"
  ],
  "SGPP2": [
    "SGPP2 CNV",
    "SGPP2 RNA"
  ],
  "SELENOOLP": [
    "SELENOOLP CNV",
    "SELENOOLP RNA"
  ],
  "NDUFA7": [
    "NDUFA7 CNV",
    "NDUFA7 RNA",
    "NDUFA7 Proteo"
  ],
  "RUNX1": [
    "RUNX1 CNV",
    "RUNX1 RNA",
    "RUNX1 Proteo"
  ],
  "DNAAF4": [
    "DNAAF4 CNV",
    "DNAAF4 RNA"
  ],
  "FKBP9": [
    "FKBP9 CNV",
    "FKBP9 RNA",
    "FKBP9 Proteo"
  ],
  "MROH4P": [
    "MROH4P CNV",
    "MROH4P RNA"
  ],
  "DUSP21": [
    "DUSP21 CNV",
    "DUSP21 RNA"
  ],
  "SI": [
    "SI CNV",
    "SI RNA"
  ],
  "PSME3": [
    "PSME3 CNV",
    "PSME3 RNA",
    "PSME3 Proteo"
  ],
  "NHLRC2": [
    "NHLRC2 CNV",
    "NHLRC2 RNA",
    "NHLRC2 Proteo"
  ],
  "CACYBPP1": [
    "CACYBPP1 CNV",
    "CACYBPP1 RNA"
  ],
  "MTO1": [
    "MTO1 CNV",
    "MTO1 RNA",
    "MTO1 Proteo"
  ],
  "RUNX2": [
    "RUNX2 CNV",
    "RUNX2 RNA",
    "RUNX2 Proteo"
  ],
  "CSAG2": [
    "CSAG2 CNV",
    "CSAG2 RNA"
  ],
  "PTGR2": [
    "PTGR2 CNV",
    "PTGR2 RNA",
    "PTGR2 Proteo"
  ],
  "FZD6": [
    "FZD6 CNV",
    "FZD6 RNA",
    "FZD6 Proteo"
  ],
  "NIPA2P3": [
    "NIPA2P3 CNV",
    "NIPA2P3 RNA"
  ],
  "RPL39P39": [
    "RPL39P39 CNV",
    "RPL39P39 RNA"
  ],
  "CAV2": [
    "CAV2 CNV",
    "CAV2 RNA",
    "CAV2 Proteo"
  ],
  "PUDP": [
    "PUDP CNV",
    "PUDP RNA",
    "PUDP Proteo"
  ],
  "MTND4LP20": [
    "MTND4LP20 CNV",
    "MTND4LP20 RNA"
  ],
  "GIMAP7": [
    "GIMAP7 CNV",
    "GIMAP7 RNA",
    "GIMAP7 Proteo"
  ],
  "TRIM46": [
    "TRIM46 CNV",
    "TRIM46 RNA",
    "TRIM46 Proteo"
  ],
  "IGKV1-16": [
    "IGKV1-16 Proteo"
  ],
  "BEX3": [
    "BEX3 CNV",
    "BEX3 RNA"
  ],
  "GSTM2P1": [
    "GSTM2P1 CNV",
    "GSTM2P1 RNA"
  ],
  "ENTPD5": [
    "ENTPD5 CNV",
    "ENTPD5 RNA",
    "ENTPD5 Proteo"
  ],
  "PPIAP27": [
    "PPIAP27 CNV",
    "PPIAP27 RNA"
  ],
  "TRMT12": [
    "TRMT12 CNV",
    "TRMT12 RNA",
    "TRMT12 Proteo"
  ],
  "NPM1P8": [
    "NPM1P8 CNV",
    "NPM1P8 RNA"
  ],
  "PAIP1P2": [
    "PAIP1P2 CNV",
    "PAIP1P2 RNA"
  ],
  "GEMIN2P1": [
    "GEMIN2P1 CNV",
    "GEMIN2P1 RNA"
  ],
  "ATP5MGP1": [
    "ATP5MGP1 CNV",
    "ATP5MGP1 RNA"
  ],
  "BLOC1S1": [
    "BLOC1S1 CNV",
    "BLOC1S1 RNA",
    "BLOC1S1 Proteo"
  ],
  "DTX3L": [
    "DTX3L CNV",
    "DTX3L RNA",
    "DTX3L Proteo"
  ],
  "ARHGEF6": [
    "ARHGEF6 CNV",
    "ARHGEF6 RNA",
    "ARHGEF6 Proteo"
  ],
  "MTND4P35": [
    "MTND4P35 CNV",
    "MTND4P35 RNA"
  ],
  "TMEM43": [
    "TMEM43 CNV",
    "TMEM43 RNA",
    "TMEM43 Proteo"
  ],
  "SEM1": [
    "SEM1 CNV",
    "SEM1 RNA",
    "SEM1 Proteo"
  ],
  "KCMF1": [
    "KCMF1 CNV",
    "KCMF1 RNA",
    "KCMF1 Proteo"
  ],
  "PRSS58": [
    "PRSS58 CNV",
    "PRSS58 RNA"
  ],
  "SNRPCP16": [
    "SNRPCP16 CNV",
    "SNRPCP16 RNA"
  ],
  "PPP4R1L": [
    "PPP4R1L CNV",
    "PPP4R1L RNA"
  ],
  "SLC4A1APP2": [
    "SLC4A1APP2 CNV",
    "SLC4A1APP2 RNA"
  ],
  "UPK1B": [
    "UPK1B CNV",
    "UPK1B RNA",
    "UPK1B Proteo"
  ],
  "KRT19P4": [
    "KRT19P4 CNV",
    "KRT19P4 RNA"
  ],
  "FAM53A": [
    "FAM53A CNV",
    "FAM53A RNA"
  ],
  "LRRC15": [
    "LRRC15 CNV",
    "LRRC15 RNA",
    "LRRC15 Proteo"
  ],
  "PPP1R32": [
    "PPP1R32 CNV",
    "PPP1R32 RNA"
  ],
  "DEDD": [
    "DEDD CNV",
    "DEDD RNA",
    "DEDD Proteo"
  ],
  "CTAG2": [
    "CTAG2 CNV",
    "CTAG2 RNA",
    "CTAG2 Proteo"
  ],
  "ROMO1": [
    "ROMO1 CNV",
    "ROMO1 RNA",
    "ROMO1 Proteo"
  ],
  "RAD51": [
    "RAD51 CNV",
    "RAD51 RNA",
    "RAD51 Proteo"
  ],
  "FAM133DP": [
    "FAM133DP CNV",
    "FAM133DP RNA"
  ],
  "BRD3OS": [
    "BRD3OS CNV",
    "BRD3OS RNA"
  ],
  "RPL10AP3": [
    "RPL10AP3 CNV",
    "RPL10AP3 RNA"
  ],
  "SOGA3": [
    "SOGA3 CNV",
    "SOGA3 RNA",
    "SOGA3 Proteo"
  ],
  "PHYHIP": [
    "PHYHIP CNV",
    "PHYHIP RNA"
  ],
  "P2RY14": [
    "P2RY14 CNV",
    "P2RY14 RNA"
  ],
  "ZNHIT3": [
    "ZNHIT3 CNV",
    "ZNHIT3 RNA",
    "ZNHIT3 Proteo"
  ],
  "NFATC3": [
    "NFATC3 CNV",
    "NFATC3 RNA",
    "NFATC3 Proteo"
  ],
  "ANKLE2": [
    "ANKLE2 CNV",
    "ANKLE2 RNA",
    "ANKLE2 Proteo"
  ],
  "CHAT": [
    "CHAT CNV",
    "CHAT RNA"
  ],
  "FEN1P1": [
    "FEN1P1 CNV",
    "FEN1P1 RNA"
  ],
  "RAG2": [
    "RAG2 CNV",
    "RAG2 RNA"
  ],
  "RPS5P8": [
    "RPS5P8 CNV",
    "RPS5P8 RNA"
  ],
  "NOBOX": [
    "NOBOX CNV",
    "NOBOX RNA"
  ],
  "HMGCS2": [
    "HMGCS2 CNV",
    "HMGCS2 RNA",
    "HMGCS2 Proteo"
  ],
  "RMC1": [
    "RMC1 CNV",
    "RMC1 RNA",
    "RMC1 Proteo"
  ],
  "NINJ2": [
    "NINJ2 CNV",
    "NINJ2 RNA",
    "NINJ2 Proteo"
  ],
  "OR5J7P": [
    "OR5J7P CNV",
    "OR5J7P RNA"
  ],
  "SBK1": [
    "SBK1 CNV",
    "SBK1 RNA"
  ],
  "LY6G5B": [
    "LY6G5B CNV",
    "LY6G5B RNA"
  ],
  "RBM22P5": [
    "RBM22P5 CNV",
    "RBM22P5 RNA"
  ],
  "TOMM20P1": [
    "TOMM20P1 CNV",
    "TOMM20P1 RNA"
  ],
  "PIERCE2": [
    "PIERCE2 CNV",
    "PIERCE2 RNA"
  ],
  "FAM205A": [
    "FAM205A CNV",
    "FAM205A RNA"
  ],
  "PSMD12P1": [
    "PSMD12P1 CNV",
    "PSMD12P1 RNA"
  ],
  "PABPC1L": [
    "PABPC1L CNV",
    "PABPC1L RNA",
    "PABPC1L Proteo"
  ],
  "NPIPB12": [
    "NPIPB12 CNV",
    "NPIPB12 RNA"
  ],
  "LRPAP1": [
    "LRPAP1 CNV",
    "LRPAP1 RNA",
    "LRPAP1 Proteo"
  ],
  "DCUN1D4": [
    "DCUN1D4 CNV",
    "DCUN1D4 RNA",
    "DCUN1D4 Proteo"
  ],
  "MUC7": [
    "MUC7 CNV",
    "MUC7 RNA",
    "MUC7 Proteo"
  ],
  "ALG1L10P": [
    "ALG1L10P CNV",
    "ALG1L10P RNA"
  ],
  "DNMT3B": [
    "DNMT3B CNV",
    "DNMT3B RNA",
    "DNMT3B Proteo"
  ],
  "NUP210P1": [
    "NUP210P1 CNV",
    "NUP210P1 RNA"
  ],
  "APCDD1L": [
    "APCDD1L CNV",
    "APCDD1L RNA"
  ],
  "GXYLT1P6": [
    "GXYLT1P6 CNV",
    "GXYLT1P6 RNA"
  ],
  "H3P34": [
    "H3P34 CNV",
    "H3P34 RNA"
  ],
  "PRR5-ARHGAP8": [
    "PRR5-ARHGAP8 Proteo"
  ],
  "ZNF101P1": [
    "ZNF101P1 CNV",
    "ZNF101P1 RNA"
  ],
  "ZNF219": [
    "ZNF219 CNV",
    "ZNF219 RNA",
    "ZNF219 Proteo"
  ],
  "DPH5": [
    "DPH5 CNV",
    "DPH5 RNA",
    "DPH5 Proteo"
  ],
  "ANKRD62": [
    "ANKRD62 CNV",
    "ANKRD62 RNA"
  ],
  "SOX9": [
    "SOX9 CNV",
    "SOX9 RNA",
    "SOX9 Proteo"
  ],
  "CNTN2": [
    "CNTN2 CNV",
    "CNTN2 RNA"
  ],
  "MTCYBP20": [
    "MTCYBP20 CNV",
    "MTCYBP20 RNA"
  ],
  "BNIP3P41": [
    "BNIP3P41 CNV",
    "BNIP3P41 RNA"
  ],
  "OR9G3P": [
    "OR9G3P CNV",
    "OR9G3P RNA"
  ],
  "KLKP1": [
    "KLKP1 CNV",
    "KLKP1 RNA"
  ],
  "RPL39P5": [
    "RPL39P5 CNV",
    "RPL39P5 RNA"
  ],
  "SUMO1P4": [
    "SUMO1P4 CNV",
    "SUMO1P4 RNA"
  ],
  "HSD17B10": [
    "HSD17B10 CNV",
    "HSD17B10 RNA",
    "HSD17B10 Proteo"
  ],
  "CDCA4P1": [
    "CDCA4P1 CNV",
    "CDCA4P1 RNA"
  ],
  "EIF4A1P4": [
    "EIF4A1P4 CNV",
    "EIF4A1P4 RNA"
  ],
  "PRXL2CP1": [
    "PRXL2CP1 CNV",
    "PRXL2CP1 RNA"
  ],
  "RNA5SP228": [
    "RNA5SP228 CNV",
    "RNA5SP228 RNA"
  ],
  "COX14": [
    "COX14 CNV",
    "COX14 RNA",
    "COX14 Proteo"
  ],
  "ECH1": [
    "ECH1 CNV",
    "ECH1 RNA",
    "ECH1 Proteo"
  ],
  "MOG": [
    "MOG CNV",
    "MOG RNA"
  ],
  "TNXB": [
    "TNXB CNV",
    "TNXB RNA",
    "TNXB Proteo"
  ],
  "ELF2P3": [
    "ELF2P3 CNV",
    "ELF2P3 RNA"
  ],
  "TRMT10A": [
    "TRMT10A CNV",
    "TRMT10A RNA",
    "TRMT10A Proteo"
  ],
  "ITPRID1": [
    "ITPRID1 CNV",
    "ITPRID1 RNA"
  ],
  "NEK9": [
    "NEK9 CNV",
    "NEK9 RNA",
    "NEK9 Proteo"
  ],
  "NIP7": [
    "NIP7 CNV",
    "NIP7 RNA",
    "NIP7 Proteo"
  ],
  "ZNF37CP": [
    "ZNF37CP CNV",
    "ZNF37CP RNA"
  ],
  "ANAPC4": [
    "ANAPC4 CNV",
    "ANAPC4 RNA",
    "ANAPC4 Proteo"
  ],
  "ACOT7": [
    "ACOT7 CNV",
    "ACOT7 RNA",
    "ACOT7 Proteo"
  ],
  "ZNF706": [
    "ZNF706 CNV",
    "ZNF706 RNA",
    "ZNF706 Proteo"
  ],
  "RGSL1": [
    "RGSL1 CNV",
    "RGSL1 RNA"
  ],
  "EEF1B2P2": [
    "EEF1B2P2 CNV",
    "EEF1B2P2 RNA"
  ],
  "RNA5SP384": [
    "RNA5SP384 CNV",
    "RNA5SP384 RNA"
  ],
  "RPL39P14": [
    "RPL39P14 CNV",
    "RPL39P14 RNA"
  ],
  "SYPL1P2": [
    "SYPL1P2 CNV",
    "SYPL1P2 RNA"
  ],
  "MTND2P28": [
    "MTND2P28 CNV",
    "MTND2P28 RNA"
  ],
  "FAAP24": [
    "FAAP24 CNV",
    "FAAP24 RNA",
    "FAAP24 Proteo"
  ],
  "BMP8B": [
    "BMP8B CNV",
    "BMP8B RNA"
  ],
  "SOHLH1": [
    "SOHLH1 CNV",
    "SOHLH1 RNA"
  ],
  "SMIM10L2B": [
    "SMIM10L2B CNV",
    "SMIM10L2B RNA"
  ],
  "HTRA1": [
    "HTRA1 CNV",
    "HTRA1 RNA",
    "HTRA1 Proteo"
  ],
  "PHACTR2P1": [
    "PHACTR2P1 CNV",
    "PHACTR2P1 RNA"
  ],
  "OXGR1": [
    "OXGR1 CNV",
    "OXGR1 RNA"
  ],
  "MRGPRD": [
    "MRGPRD CNV",
    "MRGPRD RNA"
  ],
  "MORF4L1": [
    "MORF4L1 CNV",
    "MORF4L1 RNA",
    "MORF4L1 Proteo"
  ],
  "CD83P1": [
    "CD83P1 CNV",
    "CD83P1 RNA"
  ],
  "FGF11": [
    "FGF11 CNV",
    "FGF11 RNA"
  ],
  "DGUOK": [
    "DGUOK CNV",
    "DGUOK RNA",
    "DGUOK Proteo"
  ],
  "NFATC4": [
    "NFATC4 CNV",
    "NFATC4 RNA",
    "NFATC4 Proteo"
  ],
  "TUBAP15": [
    "TUBAP15 CNV",
    "TUBAP15 RNA"
  ],
  "NDUFAF5": [
    "NDUFAF5 CNV",
    "NDUFAF5 RNA",
    "NDUFAF5 Proteo"
  ],
  "H3P30": [
    "H3P30 CNV",
    "H3P30 RNA"
  ],
  "SNX18P12": [
    "SNX18P12 CNV",
    "SNX18P12 RNA"
  ],
  "PEX2": [
    "PEX2 CNV",
    "PEX2 RNA",
    "PEX2 Proteo"
  ],
  "CASTOR2": [
    "CASTOR2 CNV",
    "CASTOR2 RNA",
    "CASTOR2 Proteo"
  ],
  "SPSB4": [
    "SPSB4 CNV",
    "SPSB4 RNA"
  ],
  "FUBP3": [
    "FUBP3 CNV",
    "FUBP3 RNA",
    "FUBP3 Proteo"
  ],
  "GSPT2": [
    "GSPT2 CNV",
    "GSPT2 RNA",
    "GSPT2 Proteo"
  ],
  "MUC20": [
    "MUC20 CNV",
    "MUC20 RNA"
  ],
  "KIAA1755": [
    "KIAA1755 CNV",
    "KIAA1755 RNA",
    "KIAA1755 Proteo"
  ],
  "PHF13": [
    "PHF13 CNV",
    "PHF13 RNA"
  ],
  "NTRK1": [
    "NTRK1 CNV",
    "NTRK1 RNA"
  ],
  "ACVR1C": [
    "ACVR1C CNV",
    "ACVR1C RNA"
  ],
  "SOX17": [
    "SOX17 CNV",
    "SOX17 RNA"
  ],
  "CTBP2P10": [
    "CTBP2P10 CNV",
    "CTBP2P10 RNA"
  ],
  "KRT83": [
    "KRT83 CNV",
    "KRT83 RNA"
  ],
  "POLDIP2": [
    "POLDIP2 CNV",
    "POLDIP2 RNA",
    "POLDIP2 Proteo"
  ],
  "POLR2CP1": [
    "POLR2CP1 CNV",
    "POLR2CP1 RNA"
  ],
  "NUDT21": [
    "NUDT21 CNV",
    "NUDT21 RNA",
    "NUDT21 Proteo"
  ],
  "FBXO17": [
    "FBXO17 CNV",
    "FBXO17 RNA",
    "FBXO17 Proteo"
  ],
  "ACOXL": [
    "ACOXL CNV",
    "ACOXL RNA"
  ],
  "MST1R": [
    "MST1R CNV",
    "MST1R RNA",
    "MST1R Proteo"
  ]
}
